/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		27: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-settings","1":"route-register-pro","2":"route-upcoming-bookings","3":"route-sign-up","4":"route-log-in","5":"route-forgot-password","6":"route-user","7":"route-preview","8":"route-featured-service","9":"route-transactions","10":"route-language-learners","11":"route-immigration-law","12":"route-language-practice","13":"route-home","14":"route-blog","15":"route-edit-profile","16":"route-find-pro","17":"route-select-interest","18":"route-faq","19":"route-contact-us","20":"route-static-page","21":"route-login-or-signup","22":"route-errorRoute","23":"route-api","24":"route-accountActivationSuccess","25":"route-accountActivationError","26":"route-activity"}[chunkId]||chunkId) + ".chunk." + {"0":"3f55a","1":"8ba38","2":"05b8c","3":"b44ad","4":"ee544","5":"6cc57","6":"a98dc","7":"2dfa1","8":"2f098","9":"976f7","10":"6a86d","11":"3657a","12":"98c79","13":"c53d6","14":"7f7fb","15":"d5301","16":"617e3","17":"4dbf9","18":"2ec6b","19":"a860a","20":"c30f3","21":"c955f","22":"bd4a3","23":"84935","24":"de010","25":"eb046","26":"3b7bd"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+BPH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__("ZHsT");

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__("18l1");

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__("F4n3");

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__("Ke8z");

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__("hTqB");

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__("dtN7");

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__("NNyR");

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
}; /* eslint-disable */

/***/ }),

/***/ "+qlq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = callOnce;

var _warning = __webpack_require__("/sXU");

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var CALLED_ONCE = 'muiPrepared';

function callOnce() {
  if (false) {
    return function (style) {
      if (style[CALLED_ONCE]) {
        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
      }
      style[CALLED_ONCE] = true;
      return style;
    };
  }
}

/***/ }),

/***/ "+uQg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6e6d1f91d28b03434376667cc2bdaaef.png";

/***/ }),

/***/ "+vXN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getBuiltIn = __webpack_require__("qvVx");
var definePropertyModule = __webpack_require__("y7Dx");
var wellKnownSymbol = __webpack_require__("G69i");
var DESCRIPTORS = __webpack_require__("RA6A");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function get() {
        return this;
      }
    });
  }
};

/***/ }),

/***/ "+wiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRelative;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__ = __webpack_require__("ieRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_index_js__ = __webpack_require__("OZJZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__ = __webpack_require__("lcWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__ = __webpack_require__("A4qf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__("aFbL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");








/**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to format
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {String} the date in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(addDays(new Date(), -6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */
function formatRelative(dirtyDate, dirtyBaseDate, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a" /* default */])(dirtyDate);
  var baseDate = Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a" /* default */])(dirtyBaseDate);

  var _ref = dirtyOptions || {},
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__["a" /* default */] : _ref$locale,
      _ref$weekStartsOn = _ref.weekStartsOn,
      weekStartsOn = _ref$weekStartsOn === void 0 ? 0 : _ref$weekStartsOn;

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  if (!locale.formatRelative) {
    throw new RangeError('locale must contain formatRelative property');
  }

  var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__["a" /* default */])(date, baseDate);

  if (isNaN(diff)) {
    throw new RangeError('Invalid time value');
  }

  var token;

  if (diff < -6) {
    token = 'other';
  } else if (diff < -1) {
    token = 'lastWeek';
  } else if (diff < 0) {
    token = 'yesterday';
  } else if (diff < 1) {
    token = 'today';
  } else if (diff < 2) {
    token = 'tomorrow';
  } else if (diff < 7) {
    token = 'nextWeek';
  } else {
    token = 'other';
  }

  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__["a" /* default */])(date, Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(date));
  var utcBaseDate = Object(__WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__["a" /* default */])(baseDate, Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(baseDate));
  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
    locale: locale,
    weekStartsOn: weekStartsOn
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1__format_index_js__["a" /* default */])(date, formatStr, {
    locale: locale,
    weekStartsOn: weekStartsOn
  });
}

/***/ }),

/***/ "/0Qi":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
   true ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.strophe = {}));
})(this, function (exports) {
  'use strict';

  var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  /*
   * This module provides uniform
   * Shims APIs and globals that are not present in all JS environments,
   * the most common example for Strophe being browser APIs like WebSocket
   * and DOM that don't exist under nodejs.
   *
   * Usually these will be supplied in nodejs by conditionally requiring a
   * NPM module that provides a compatible implementation.
   */

  /* global global */

  /**
   * WHATWG WebSockets API
   * https://www.w3.org/TR/websockets/
   *
   * Interface to use the web socket protocol
   *
   * Used implementations:
   * - supported browsers: built-in in WebSocket global
   *   https://developer.mozilla.org/en-US/docs/Web/API/WebSocket#Browser_compatibility
   * - nodejs: use standard-compliant 'ws' module
   *   https://www.npmjs.com/package/ws
   */
  function getWebSocketImplementation() {
    var WebSocketImplementation = global$1.WebSocket;

    if (typeof WebSocketImplementation === 'undefined') {
      try {
        WebSocketImplementation = __webpack_require__("5yon");
      } catch (err) {
        throw new Error('You must install the "ws" package to use Strophe in nodejs.');
      }
    }

    return WebSocketImplementation;
  }

  var WebSocket = getWebSocketImplementation();
  /**
   * DOMParser
   * https://w3c.github.io/DOM-Parsing/#the-domparser-interface
   *
   * Interface to parse XML strings into Document objects
   *
   * Used implementations:
   * - supported browsers: built-in in DOMParser global
   *   https://developer.mozilla.org/en-US/docs/Web/API/DOMParser#Browser_compatibility
   * - nodejs: use 'xmldom' module
   *   https://www.npmjs.com/package/xmldom
   */

  function getDOMParserImplementation() {
    var DOMParserImplementation = global$1.DOMParser;

    if (typeof DOMParserImplementation === 'undefined') {
      try {
        DOMParserImplementation = __webpack_require__("6Elf").DOMParser;
      } catch (err) {
        throw new Error('You must install the "xmldom" package to use Strophe in nodejs.');
      }
    }

    return DOMParserImplementation;
  }

  var DOMParser = getDOMParserImplementation();
  /**
   *  Gets IE xml doc object. Used by getDummyXMLDocument shim.
   *
   *  Returns:
   *    A Microsoft XML DOM Object
   *  See Also:
   *    http://msdn.microsoft.com/en-us/library/ms757837%28VS.85%29.aspx
   */

  function _getIEXmlDom() {
    var docStrings = ["Msxml2.DOMDocument.6.0", "Msxml2.DOMDocument.5.0", "Msxml2.DOMDocument.4.0", "MSXML2.DOMDocument.3.0", "MSXML2.DOMDocument", "MSXML.DOMDocument", "Microsoft.XMLDOM"];

    for (var d = 0; d < docStrings.length; d++) {
      try {
        // eslint-disable-next-line no-undef
        var doc = new ActiveXObject(docStrings[d]);
        return doc;
      } catch (e) {// Try next one
      }
    }
  }
  /**
   * Creates a dummy XML DOM document to serve as an element and text node generator.
   *
   * Used implementations:
   *  - IE < 10: avoid using createDocument() due to a memory leak, use ie-specific
   *    workaround
   *  - other supported browsers: use document's createDocument
   *  - nodejs: use 'xmldom'
   */

  function getDummyXMLDOMDocument() {
    // nodejs
    if (typeof document === 'undefined') {
      try {
        var DOMImplementation = __webpack_require__("6Elf").DOMImplementation;

        return new DOMImplementation().createDocument('jabber:client', 'strophe', null);
      } catch (err) {
        throw new Error('You must install the "xmldom" package to use Strophe in nodejs.');
      }
    } // IE < 10


    if (document.implementation.createDocument === undefined || document.implementation.createDocument && document.documentMode && document.documentMode < 10) {
      var doc = _getIEXmlDom();

      doc.appendChild(doc.createElement('strophe'));
      return doc;
    } // All other supported browsers


    return document.implementation.createDocument('jabber:client', 'strophe', null);
  }

  /*
   * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
   * Digest Algorithm, as defined in RFC 1321.
   * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * Distributed under the BSD License
   * See http://pajhome.org.uk/crypt/md5 for more info.
   */

  /*
   * Everything that isn't used by Strophe has been stripped here!
   */

  /*
   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
   * to work around bugs in some JS interpreters.
   */
  var safe_add = function safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
  };
  /*
   * Bitwise rotate a 32-bit number to the left.
   */

  var bit_rol = function bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  };
  /*
   * Convert a string to an array of little-endian words
   */

  var str2binl = function str2binl(str) {
    if (typeof str !== "string") {
      throw new Error("str2binl was passed a non-string");
    }

    var bin = [];

    for (var i = 0; i < str.length * 8; i += 8) {
      bin[i >> 5] |= (str.charCodeAt(i / 8) & 255) << i % 32;
    }

    return bin;
  };
  /*
   * Convert an array of little-endian words to a string
   */

  var binl2str = function binl2str(bin) {
    var str = "";

    for (var i = 0; i < bin.length * 32; i += 8) {
      str += String.fromCharCode(bin[i >> 5] >>> i % 32 & 255);
    }

    return str;
  };
  /*
   * Convert an array of little-endian words to a hex string.
   */

  var binl2hex = function binl2hex(binarray) {
    var hex_tab = "0123456789abcdef";
    var str = "";

    for (var i = 0; i < binarray.length * 4; i++) {
      str += hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 & 0xF);
    }

    return str;
  };
  /*
   * These functions implement the four basic operations the algorithm uses.
   */

  var md5_cmn = function md5_cmn(q, a, b, x, s, t) {
    return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
  };

  var md5_ff = function md5_ff(a, b, c, d, x, s, t) {
    return md5_cmn(b & c | ~b & d, a, b, x, s, t);
  };

  var md5_gg = function md5_gg(a, b, c, d, x, s, t) {
    return md5_cmn(b & d | c & ~d, a, b, x, s, t);
  };

  var md5_hh = function md5_hh(a, b, c, d, x, s, t) {
    return md5_cmn(b ^ c ^ d, a, b, x, s, t);
  };

  var md5_ii = function md5_ii(a, b, c, d, x, s, t) {
    return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
  };
  /*
   * Calculate the MD5 of an array of little-endian words, and a bit length
   */

  var core_md5 = function core_md5(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    var olda, oldb, oldc, oldd;

    for (var i = 0; i < x.length; i += 16) {
      olda = a;
      oldb = b;
      oldc = c;
      oldd = d;
      a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
      d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
      b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
      a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
      a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
      a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
      d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
      c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
      a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
      d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
      a = safe_add(a, olda);
      b = safe_add(b, oldb);
      c = safe_add(c, oldc);
      d = safe_add(d, oldd);
    }

    return [a, b, c, d];
  };
  /*
   * These are the functions you'll usually want to call.
   * They take string arguments and return either hex or base-64 encoded
   * strings.
   */

  var MD5 = {
    hexdigest: function hexdigest(s) {
      return binl2hex(core_md5(str2binl(s), s.length * 8));
    },
    hash: function hash(s) {
      return binl2str(core_md5(str2binl(s), s.length * 8));
    }
  };

  /** Class: Strophe.SASLMechanism
   *
   *  Encapsulates an SASL authentication mechanism.
   *
   *  User code may override the priority for each mechanism or disable it completely.
   *  See <priority> for information about changing priority and <test> for informatian on
   *  how to disable a mechanism.
   *
   *  By default, all mechanisms are enabled and the priorities are
   *
   *      SCRAM-SHA-1 - 60
   *      PLAIN       - 50
   *      OAUTHBEARER - 40
   *      X-OAUTH2    - 30
   *      ANONYMOUS   - 20
   *      EXTERNAL    - 10
   *
   *  See: Strophe.Connection.addSupportedSASLMechanisms
   */
  var SASLMechanism = /*#__PURE__*/function () {
    /**
     * PrivateConstructor: Strophe.SASLMechanism
     * SASL auth mechanism abstraction.
     *
     *  Parameters:
     *    (String) name - SASL Mechanism name.
     *    (Boolean) isClientFirst - If client should send response first without challenge.
     *    (Number) priority - Priority.
     *
     *  Returns:
     *    A new Strophe.SASLMechanism object.
     */
    function SASLMechanism(name, isClientFirst, priority) {
      _classCallCheck(this, SASLMechanism);

      /** PrivateVariable: mechname
       *  Mechanism name.
       */
      this.mechname = name;
      /** PrivateVariable: isClientFirst
       *  If client sends response without initial server challenge.
       */

      this.isClientFirst = isClientFirst;
      /** Variable: priority
       *  Determines which <SASLMechanism> is chosen for authentication (Higher is better).
       *  Users may override this to prioritize mechanisms differently.
       *
       *  Example: (This will cause Strophe to choose the mechanism that the server sent first)
       *
       *  > Strophe.SASLPlain.priority = Strophe.SASLSHA1.priority;
       *
       *  See <SASL mechanisms> for a list of available mechanisms.
       *
       */

      this.priority = priority;
    }
    /**
     *  Function: test
     *  Checks if mechanism able to run.
     *  To disable a mechanism, make this return false;
     *
     *  To disable plain authentication run
     *  > Strophe.SASLPlain.test = function() {
     *  >   return false;
     *  > }
     *
     *  See <SASL mechanisms> for a list of available mechanisms.
     *
     *  Parameters:
     *    (Strophe.Connection) connection - Target Connection.
     *
     *  Returns:
     *    (Boolean) If mechanism was able to run.
     */

    _createClass(SASLMechanism, [{
      key: "test",
      value: function test() {
        // eslint-disable-line class-methods-use-this
        return true;
      }
      /** PrivateFunction: onStart
       *  Called before starting mechanism on some connection.
       *
       *  Parameters:
       *    (Strophe.Connection) connection - Target Connection.
       */

    }, {
      key: "onStart",
      value: function onStart(connection) {
        this._connection = connection;
      }
      /** PrivateFunction: onChallenge
       *  Called by protocol implementation on incoming challenge.
       *
       *  By deafult, if the client is expected to send data first (isClientFirst === true),
       *  this method is called with `challenge` as null on the first call,
       *  unless `clientChallenge` is overridden in the relevant subclass.
       *
       *  Parameters:
       *    (Strophe.Connection) connection - Target Connection.
       *    (String) challenge - current challenge to handle.
       *
       *  Returns:
       *    (String) Mechanism response.
       */

    }, {
      key: "onChallenge",
      value: function onChallenge(connection, challenge) {
        // eslint-disable-line
        throw new Error("You should implement challenge handling!");
      }
      /** PrivateFunction: clientChallenge
       *  Called by the protocol implementation if the client is expected to send
       *  data first in the authentication exchange (i.e. isClientFirst === true).
       *
       *  Parameters:
       *    (Strophe.Connection) connection - Target Connection.
       *
       *  Returns:
       *    (String) Mechanism response.
       */

    }, {
      key: "clientChallenge",
      value: function clientChallenge(connection) {
        if (!this.isClientFirst) {
          throw new Error("clientChallenge should not be called if isClientFirst is false!");
        }

        return this.onChallenge(connection);
      }
      /** PrivateFunction: onFailure
       *  Protocol informs mechanism implementation about SASL failure.
       */

    }, {
      key: "onFailure",
      value: function onFailure() {
        this._connection = null;
      }
      /** PrivateFunction: onSuccess
       *  Protocol informs mechanism implementation about SASL success.
       */

    }, {
      key: "onSuccess",
      value: function onSuccess() {
        this._connection = null;
      }
    }]);

    return SASLMechanism;
  }();

  var SASLAnonymous = /*#__PURE__*/function (_SASLMechanism) {
    _inherits(SASLAnonymous, _SASLMechanism);

    var _super = _createSuper(SASLAnonymous);

    /** PrivateConstructor: SASLAnonymous
     *  SASL ANONYMOUS authentication.
     */
    function SASLAnonymous() {
      var mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ANONYMOUS';
      var isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

      _classCallCheck(this, SASLAnonymous);

      return _super.call(this, mechname, isClientFirst, priority);
    }

    _createClass(SASLAnonymous, [{
      key: "test",
      value: function test(connection) {
        // eslint-disable-line class-methods-use-this
        return connection.authcid === null;
      }
    }]);

    return SASLAnonymous;
  }(SASLMechanism);

  var SASLExternal = /*#__PURE__*/function (_SASLMechanism) {
    _inherits(SASLExternal, _SASLMechanism);

    var _super = _createSuper(SASLExternal);

    /** PrivateConstructor: SASLExternal
     *  SASL EXTERNAL authentication.
     *
     *  The EXTERNAL mechanism allows a client to request the server to use
     *  credentials established by means external to the mechanism to
     *  authenticate the client. The external means may be, for instance,
     *  TLS services.
     */
    function SASLExternal() {
      var mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'EXTERNAL';
      var isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

      _classCallCheck(this, SASLExternal);

      return _super.call(this, mechname, isClientFirst, priority);
    }

    _createClass(SASLExternal, [{
      key: "onChallenge",
      value: function onChallenge(connection) {
        // eslint-disable-line class-methods-use-this

        /** According to XEP-178, an authzid SHOULD NOT be presented when the
         * authcid contained or implied in the client certificate is the JID (i.e.
         * authzid) with which the user wants to log in as.
         *
         * To NOT send the authzid, the user should therefore set the authcid equal
         * to the JID when instantiating a new Strophe.Connection object.
         */
        return connection.authcid === connection.authzid ? '' : connection.authzid;
      }
    }]);

    return SASLExternal;
  }(SASLMechanism);

  var utils = {
    utf16to8: function utf16to8(str) {
      var i, c;
      var out = "";
      var len = str.length;

      for (i = 0; i < len; i++) {
        c = str.charCodeAt(i);

        if (c >= 0x0000 && c <= 0x007F) {
          out += str.charAt(i);
        } else if (c > 0x07FF) {
          out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
          out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
          out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
        } else {
          out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
          out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
        }
      }

      return out;
    },
    addCookies: function addCookies(cookies) {
      /* Parameters:
       *  (Object) cookies - either a map of cookie names
       *    to string values or to maps of cookie values.
       *
       * For example:
       * { "myCookie": "1234" }
       *
       * or:
       * { "myCookie": {
       *      "value": "1234",
       *      "domain": ".example.org",
       *      "path": "/",
       *      "expires": expirationDate
       *      }
       *  }
       *
       *  These values get passed to Strophe.Connection via
       *   options.cookies
       */
      cookies = cookies || {};

      for (var cookieName in cookies) {
        if (Object.prototype.hasOwnProperty.call(cookies, cookieName)) {
          var expires = '';
          var domain = '';
          var path = '';
          var cookieObj = cookies[cookieName];
          var isObj = _typeof(cookieObj) === "object";
          var cookieValue = escape(unescape(isObj ? cookieObj.value : cookieObj));

          if (isObj) {
            expires = cookieObj.expires ? ";expires=" + cookieObj.expires : '';
            domain = cookieObj.domain ? ";domain=" + cookieObj.domain : '';
            path = cookieObj.path ? ";path=" + cookieObj.path : '';
          }

          document.cookie = cookieName + '=' + cookieValue + expires + domain + path;
        }
      }
    }
  };

  var SASLOAuthBearer = /*#__PURE__*/function (_SASLMechanism) {
    _inherits(SASLOAuthBearer, _SASLMechanism);

    var _super = _createSuper(SASLOAuthBearer);

    /** PrivateConstructor: SASLOAuthBearer
     *  SASL OAuth Bearer authentication.
     */
    function SASLOAuthBearer() {
      var mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'OAUTHBEARER';
      var isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 40;

      _classCallCheck(this, SASLOAuthBearer);

      return _super.call(this, mechname, isClientFirst, priority);
    }

    _createClass(SASLOAuthBearer, [{
      key: "test",
      value: function test(connection) {
        // eslint-disable-line class-methods-use-this
        return connection.pass !== null;
      }
    }, {
      key: "onChallenge",
      value: function onChallenge(connection) {
        // eslint-disable-line class-methods-use-this
        var auth_str = 'n,';

        if (connection.authcid !== null) {
          auth_str = auth_str + 'a=' + connection.authzid;
        }

        auth_str = auth_str + ',';
        auth_str = auth_str + "\x01";
        auth_str = auth_str + 'auth=Bearer ';
        auth_str = auth_str + connection.pass;
        auth_str = auth_str + "\x01";
        auth_str = auth_str + "\x01";
        return utils.utf16to8(auth_str);
      }
    }]);

    return SASLOAuthBearer;
  }(SASLMechanism);

  var SASLPlain = /*#__PURE__*/function (_SASLMechanism) {
    _inherits(SASLPlain, _SASLMechanism);

    var _super = _createSuper(SASLPlain);

    /** PrivateConstructor: SASLPlain
     *  SASL PLAIN authentication.
     */
    function SASLPlain() {
      var mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PLAIN';
      var isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;

      _classCallCheck(this, SASLPlain);

      return _super.call(this, mechname, isClientFirst, priority);
    }

    _createClass(SASLPlain, [{
      key: "test",
      value: function test(connection) {
        // eslint-disable-line class-methods-use-this
        return connection.authcid !== null;
      }
    }, {
      key: "onChallenge",
      value: function onChallenge(connection) {
        // eslint-disable-line class-methods-use-this
        var authcid = connection.authcid,
            authzid = connection.authzid,
            domain = connection.domain,
            pass = connection.pass;

        if (!domain) {
          throw new Error("SASLPlain onChallenge: domain is not defined!");
        } // Only include authzid if it differs from authcid.
        // See: https://tools.ietf.org/html/rfc6120#section-6.3.8


        var auth_str = authzid !== "".concat(authcid, "@").concat(domain) ? authzid : '';
        auth_str = auth_str + "\0";
        auth_str = auth_str + authcid;
        auth_str = auth_str + "\0";
        auth_str = auth_str + pass;
        return utils.utf16to8(auth_str);
      }
    }]);

    return SASLPlain;
  }(SASLMechanism);

  /*
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
   * in FIPS PUB 180-1
   * Version 2.1a Copyright Paul Johnston 2000 - 2002.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * Distributed under the BSD License
   * See http://pajhome.org.uk/crypt/md5 for details.
   */

  /* global define */

  /* Some functions and variables have been stripped for use with Strophe */

  /*
   * Calculate the SHA-1 of an array of big-endian words, and a bit length
   */
  function core_sha1(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << 24 - len % 32;
    x[(len + 64 >> 9 << 4) + 15] = len;
    var w = new Array(80);
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    var e = -1009589776;
    var i, j, t, olda, oldb, oldc, oldd, olde;

    for (i = 0; i < x.length; i += 16) {
      olda = a;
      oldb = b;
      oldc = c;
      oldd = d;
      olde = e;

      for (j = 0; j < 80; j++) {
        if (j < 16) {
          w[j] = x[i + j];
        } else {
          w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
        }

        t = safe_add$1(safe_add$1(rol(a, 5), sha1_ft(j, b, c, d)), safe_add$1(safe_add$1(e, w[j]), sha1_kt(j)));
        e = d;
        d = c;
        c = rol(b, 30);
        b = a;
        a = t;
      }

      a = safe_add$1(a, olda);
      b = safe_add$1(b, oldb);
      c = safe_add$1(c, oldc);
      d = safe_add$1(d, oldd);
      e = safe_add$1(e, olde);
    }

    return [a, b, c, d, e];
  }
  /*
   * Perform the appropriate triplet combination function for the current
   * iteration
   */

  function sha1_ft(t, b, c, d) {
    if (t < 20) {
      return b & c | ~b & d;
    }

    if (t < 40) {
      return b ^ c ^ d;
    }

    if (t < 60) {
      return b & c | b & d | c & d;
    }

    return b ^ c ^ d;
  }
  /*
   * Determine the appropriate additive constant for the current iteration
   */

  function sha1_kt(t) {
    return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
  }
  /*
   * Calculate the HMAC-SHA1 of a key and some data
   */

  function core_hmac_sha1(key, data) {
    var bkey = str2binb(key);

    if (bkey.length > 16) {
      bkey = core_sha1(bkey, key.length * 8);
    }

    var ipad = new Array(16),
        opad = new Array(16);

    for (var i = 0; i < 16; i++) {
      ipad[i] = bkey[i] ^ 0x36363636;
      opad[i] = bkey[i] ^ 0x5C5C5C5C;
    }

    var hash = core_sha1(ipad.concat(str2binb(data)), 512 + data.length * 8);
    return core_sha1(opad.concat(hash), 512 + 160);
  }
  /*
   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
   * to work around bugs in some JS interpreters.
   */

  function safe_add$1(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
  }
  /*
   * Bitwise rotate a 32-bit number to the left.
   */

  function rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  }
  /*
   * Convert an 8-bit or 16-bit string to an array of big-endian words
   * In 8-bit function, characters >255 have their hi-byte silently ignored.
   */

  function str2binb(str) {
    var bin = [];
    var mask = 255;

    for (var i = 0; i < str.length * 8; i += 8) {
      bin[i >> 5] |= (str.charCodeAt(i / 8) & mask) << 24 - i % 32;
    }

    return bin;
  }
  /*
   * Convert an array of big-endian words to a base-64 string
   */

  function binb2b64(binarray) {
    var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var str = "";
    var triplet, j;

    for (var i = 0; i < binarray.length * 4; i += 3) {
      triplet = (binarray[i >> 2] >> 8 * (3 - i % 4) & 0xFF) << 16 | (binarray[i + 1 >> 2] >> 8 * (3 - (i + 1) % 4) & 0xFF) << 8 | binarray[i + 2 >> 2] >> 8 * (3 - (i + 2) % 4) & 0xFF;

      for (j = 0; j < 4; j++) {
        if (i * 8 + j * 6 > binarray.length * 32) {
          str += "=";
        } else {
          str += tab.charAt(triplet >> 6 * (3 - j) & 0x3F);
        }
      }
    }

    return str;
  }
  /*
   * Convert an array of big-endian words to a string
   */

  function binb2str(bin) {
    var str = "";
    var mask = 255;

    for (var i = 0; i < bin.length * 32; i += 8) {
      str += String.fromCharCode(bin[i >> 5] >>> 24 - i % 32 & mask);
    }

    return str;
  }
  /*
   * These are the functions you'll usually want to call
   * They take string arguments and return either hex or base-64 encoded strings
   */

  var SHA1 = {
    b64_hmac_sha1: function b64_hmac_sha1(key, data) {
      return binb2b64(core_hmac_sha1(key, data));
    },
    b64_sha1: function b64_sha1(s) {
      return binb2b64(core_sha1(str2binb(s), s.length * 8));
    },
    binb2str: binb2str,
    core_hmac_sha1: core_hmac_sha1,
    str_hmac_sha1: function str_hmac_sha1(key, data) {
      return binb2str(core_hmac_sha1(key, data));
    },
    str_sha1: function str_sha1(s) {
      return binb2str(core_sha1(str2binb(s), s.length * 8));
    }
  };

  var SASLSHA1 = /*#__PURE__*/function (_SASLMechanism) {
    _inherits(SASLSHA1, _SASLMechanism);

    var _super = _createSuper(SASLSHA1);

    /** PrivateConstructor: SASLSHA1
     *  SASL SCRAM SHA 1 authentication.
     */
    function SASLSHA1() {
      var mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SCRAM-SHA-1';
      var isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60;

      _classCallCheck(this, SASLSHA1);

      return _super.call(this, mechname, isClientFirst, priority);
    }

    _createClass(SASLSHA1, [{
      key: "test",
      value: function test(connection) {
        // eslint-disable-line class-methods-use-this
        return connection.authcid !== null;
      }
    }, {
      key: "onChallenge",
      value: function onChallenge(connection, challenge) {
        // eslint-disable-line class-methods-use-this
        var nonce, salt, iter, Hi, U, U_old, i, k;
        var responseText = "c=biws,";
        var authMessage = "".concat(connection._sasl_data["client-first-message-bare"], ",").concat(challenge, ",");
        var cnonce = connection._sasl_data.cnonce;
        var attribMatch = /([a-z]+)=([^,]+)(,|$)/;

        while (challenge.match(attribMatch)) {
          var matches = challenge.match(attribMatch);
          challenge = challenge.replace(matches[0], "");

          switch (matches[1]) {
            case "r":
              nonce = matches[2];
              break;

            case "s":
              salt = matches[2];
              break;

            case "i":
              iter = matches[2];
              break;
          }
        }

        if (nonce.substr(0, cnonce.length) !== cnonce) {
          connection._sasl_data = {};
          return connection._sasl_failure_cb();
        }

        responseText += "r=" + nonce;
        authMessage += responseText;
        salt = atob(salt);
        salt += "\x00\x00\x00\x01";
        var pass = utils.utf16to8(connection.pass);
        Hi = U_old = SHA1.core_hmac_sha1(pass, salt);

        for (i = 1; i < iter; i++) {
          U = SHA1.core_hmac_sha1(pass, SHA1.binb2str(U_old));

          for (k = 0; k < 5; k++) {
            Hi[k] ^= U[k];
          }

          U_old = U;
        }

        Hi = SHA1.binb2str(Hi);
        var clientKey = SHA1.core_hmac_sha1(Hi, "Client Key");
        var serverKey = SHA1.str_hmac_sha1(Hi, "Server Key");
        var clientSignature = SHA1.core_hmac_sha1(SHA1.str_sha1(SHA1.binb2str(clientKey)), authMessage);
        connection._sasl_data["server-signature"] = SHA1.b64_hmac_sha1(serverKey, authMessage);

        for (k = 0; k < 5; k++) {
          clientKey[k] ^= clientSignature[k];
        }

        responseText += ",p=" + btoa(SHA1.binb2str(clientKey));
        return responseText;
      }
    }, {
      key: "clientChallenge",
      value: function clientChallenge(connection, test_cnonce) {
        // eslint-disable-line class-methods-use-this
        var cnonce = test_cnonce || MD5.hexdigest("" + Math.random() * 1234567890);
        var auth_str = "n=" + utils.utf16to8(connection.authcid);
        auth_str += ",r=";
        auth_str += cnonce;
        connection._sasl_data.cnonce = cnonce;
        connection._sasl_data["client-first-message-bare"] = auth_str;
        auth_str = "n,," + auth_str;
        return auth_str;
      }
    }]);

    return SASLSHA1;
  }(SASLMechanism);

  var SASLXOAuth2 = /*#__PURE__*/function (_SASLMechanism) {
    _inherits(SASLXOAuth2, _SASLMechanism);

    var _super = _createSuper(SASLXOAuth2);

    /** PrivateConstructor: SASLXOAuth2
     *  SASL X-OAuth2 authentication.
     */
    function SASLXOAuth2() {
      var mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'X-OAUTH2';
      var isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;

      _classCallCheck(this, SASLXOAuth2);

      return _super.call(this, mechname, isClientFirst, priority);
    }

    _createClass(SASLXOAuth2, [{
      key: "test",
      value: function test(connection) {
        // eslint-disable-line class-methods-use-this
        return connection.pass !== null;
      }
    }, {
      key: "onChallenge",
      value: function onChallenge(connection) {
        // eslint-disable-line class-methods-use-this
        var auth_str = "\0";

        if (connection.authcid !== null) {
          auth_str = auth_str + connection.authzid;
        }

        auth_str = auth_str + "\0";
        auth_str = auth_str + connection.pass;
        return utils.utf16to8(auth_str);
      }
    }]);

    return SASLXOAuth2;
  }(SASLMechanism);

  /**
   * Implementation of atob() according to the HTML and Infra specs, except that
   * instead of throwing INVALID_CHARACTER_ERR we return null.
   */

  function atob$1(data) {
    // Web IDL requires DOMStrings to just be converted using ECMAScript
    // ToString, which in our case amounts to using a template literal.
    data = "".concat(data); // "Remove all ASCII whitespace from data."

    data = data.replace(/[ \t\n\f\r]/g, ""); // "If data's length divides by 4 leaving no remainder, then: if data ends
    // with one or two U+003D (=) code points, then remove them from data."

    if (data.length % 4 === 0) {
      data = data.replace(/==?$/, "");
    } // "If data's length divides by 4 leaving a remainder of 1, then return
    // failure."
    //
    // "If data contains a code point that is not one of
    //
    // U+002B (+)
    // U+002F (/)
    // ASCII alphanumeric
    //
    // then return failure."


    if (data.length % 4 === 1 || /[^+/0-9A-Za-z]/.test(data)) {
      return null;
    } // "Let output be an empty byte sequence."


    var output = ""; // "Let buffer be an empty buffer that can have bits appended to it."
    //
    // We append bits via left-shift and or.  accumulatedBits is used to track
    // when we've gotten to 24 bits.

    var buffer = 0;
    var accumulatedBits = 0; // "Let position be a position variable for data, initially pointing at the
    // start of data."
    //
    // "While position does not point past the end of data:"

    for (var i = 0; i < data.length; i++) {
      // "Find the code point pointed to by position in the second column of
      // Table 1: The Base 64 Alphabet of RFC 4648. Let n be the number given in
      // the first cell of the same row.
      //
      // "Append to buffer the six bits corresponding to n, most significant bit
      // first."
      //
      // atobLookup() implements the table from RFC 4648.
      buffer <<= 6;
      buffer |= atobLookup(data[i]);
      accumulatedBits += 6; // "If buffer has accumulated 24 bits, interpret them as three 8-bit
      // big-endian numbers. Append three bytes with values equal to those
      // numbers to output, in the same order, and then empty buffer."

      if (accumulatedBits === 24) {
        output += String.fromCharCode((buffer & 0xff0000) >> 16);
        output += String.fromCharCode((buffer & 0xff00) >> 8);
        output += String.fromCharCode(buffer & 0xff);
        buffer = accumulatedBits = 0;
      } // "Advance position by 1."
    } // "If buffer is not empty, it contains either 12 or 18 bits. If it contains
    // 12 bits, then discard the last four and interpret the remaining eight as
    // an 8-bit big-endian number. If it contains 18 bits, then discard the last
    // two and interpret the remaining 16 as two 8-bit big-endian numbers. Append
    // the one or two bytes with values equal to those one or two numbers to
    // output, in the same order."


    if (accumulatedBits === 12) {
      buffer >>= 4;
      output += String.fromCharCode(buffer);
    } else if (accumulatedBits === 18) {
      buffer >>= 2;
      output += String.fromCharCode((buffer & 0xff00) >> 8);
      output += String.fromCharCode(buffer & 0xff);
    } // "Return output."


    return output;
  }
  /**
   * A lookup table for atob(), which converts an ASCII character to the
   * corresponding six-bit number.
   */

  function atobLookup(chr) {
    if (/[A-Z]/.test(chr)) {
      return chr.charCodeAt(0) - "A".charCodeAt(0);
    }

    if (/[a-z]/.test(chr)) {
      return chr.charCodeAt(0) - "a".charCodeAt(0) + 26;
    }

    if (/[0-9]/.test(chr)) {
      return chr.charCodeAt(0) - "0".charCodeAt(0) + 52;
    }

    if (chr === "+") {
      return 62;
    }

    if (chr === "/") {
      return 63;
    } // Throw exception; should not be hit in tests


    return undefined;
  }

  var atob_1 = atob$1;

  /**
   * btoa() as defined by the HTML and Infra specs, which mostly just references
   * RFC 4648.
   */

  function btoa$1(s) {
    var i; // String conversion as required by Web IDL.

    s = "".concat(s); // "The btoa() method must throw an "InvalidCharacterError" DOMException if
    // data contains any character whose code point is greater than U+00FF."

    for (i = 0; i < s.length; i++) {
      if (s.charCodeAt(i) > 255) {
        return null;
      }
    }

    var out = "";

    for (i = 0; i < s.length; i += 3) {
      var groupsOfSix = [undefined, undefined, undefined, undefined];
      groupsOfSix[0] = s.charCodeAt(i) >> 2;
      groupsOfSix[1] = (s.charCodeAt(i) & 0x03) << 4;

      if (s.length > i + 1) {
        groupsOfSix[1] |= s.charCodeAt(i + 1) >> 4;
        groupsOfSix[2] = (s.charCodeAt(i + 1) & 0x0f) << 2;
      }

      if (s.length > i + 2) {
        groupsOfSix[2] |= s.charCodeAt(i + 2) >> 6;
        groupsOfSix[3] = s.charCodeAt(i + 2) & 0x3f;
      }

      for (var j = 0; j < groupsOfSix.length; j++) {
        if (typeof groupsOfSix[j] === "undefined") {
          out += "=";
        } else {
          out += btoaLookup(groupsOfSix[j]);
        }
      }
    }

    return out;
  }
  /**
   * Lookup table for btoa(), which converts a six-bit number into the
   * corresponding ASCII character.
   */

  function btoaLookup(idx) {
    if (idx < 26) {
      return String.fromCharCode(idx + "A".charCodeAt(0));
    }

    if (idx < 52) {
      return String.fromCharCode(idx - 26 + "a".charCodeAt(0));
    }

    if (idx < 62) {
      return String.fromCharCode(idx - 52 + "0".charCodeAt(0));
    }

    if (idx === 62) {
      return "+";
    }

    if (idx === 63) {
      return "/";
    } // Throw INVALID_CHARACTER_ERR exception here -- won't be hit in the tests.


    return undefined;
  }

  var btoa_1 = btoa$1;

  var abab = {
    atob: atob_1,
    btoa: btoa_1
  };

  /** Function: $build
   *  Create a Strophe.Builder.
   *  This is an alias for 'new Strophe.Builder(name, attrs)'.
   *
   *  Parameters:
   *    (String) name - The root element name.
   *    (Object) attrs - The attributes for the root element in object notation.
   *
   *  Returns:
   *    A new Strophe.Builder object.
   */

  function $build(name, attrs) {
    return new Strophe.Builder(name, attrs);
  }
  /** Function: $msg
   *  Create a Strophe.Builder with a <message/> element as the root.
   *
   *  Parameters:
   *    (Object) attrs - The <message/> element attributes in object notation.
   *
   *  Returns:
   *    A new Strophe.Builder object.
   */

  function $msg(attrs) {
    return new Strophe.Builder("message", attrs);
  }
  /** Function: $iq
   *  Create a Strophe.Builder with an <iq/> element as the root.
   *
   *  Parameters:
   *    (Object) attrs - The <iq/> element attributes in object notation.
   *
   *  Returns:
   *    A new Strophe.Builder object.
   */

  function $iq(attrs) {
    return new Strophe.Builder("iq", attrs);
  }
  /** Function: $pres
   *  Create a Strophe.Builder with a <presence/> element as the root.
   *
   *  Parameters:
   *    (Object) attrs - The <presence/> element attributes in object notation.
   *
   *  Returns:
   *    A new Strophe.Builder object.
   */

  function $pres(attrs) {
    return new Strophe.Builder("presence", attrs);
  }
  /** Class: Strophe
   *  An object container for all Strophe library functions.
   *
   *  This class is just a container for all the objects and constants
   *  used in the library.  It is not meant to be instantiated, but to
   *  provide a namespace for library objects, constants, and functions.
   */

  var Strophe = {
    /** Constant: VERSION */
    VERSION: "1.4.2",

    /** Constants: XMPP Namespace Constants
     *  Common namespace constants from the XMPP RFCs and XEPs.
     *
     *  NS.HTTPBIND - HTTP BIND namespace from XEP 124.
     *  NS.BOSH - BOSH namespace from XEP 206.
     *  NS.CLIENT - Main XMPP client namespace.
     *  NS.AUTH - Legacy authentication namespace.
     *  NS.ROSTER - Roster operations namespace.
     *  NS.PROFILE - Profile namespace.
     *  NS.DISCO_INFO - Service discovery info namespace from XEP 30.
     *  NS.DISCO_ITEMS - Service discovery items namespace from XEP 30.
     *  NS.MUC - Multi-User Chat namespace from XEP 45.
     *  NS.SASL - XMPP SASL namespace from RFC 3920.
     *  NS.STREAM - XMPP Streams namespace from RFC 3920.
     *  NS.BIND - XMPP Binding namespace from RFC 3920 and RFC 6120.
     *  NS.SESSION - XMPP Session namespace from RFC 3920.
     *  NS.XHTML_IM - XHTML-IM namespace from XEP 71.
     *  NS.XHTML - XHTML body namespace from XEP 71.
     */
    NS: {
      HTTPBIND: "http://jabber.org/protocol/httpbind",
      BOSH: "urn:xmpp:xbosh",
      CLIENT: "jabber:client",
      AUTH: "jabber:iq:auth",
      ROSTER: "jabber:iq:roster",
      PROFILE: "jabber:iq:profile",
      DISCO_INFO: "http://jabber.org/protocol/disco#info",
      DISCO_ITEMS: "http://jabber.org/protocol/disco#items",
      MUC: "http://jabber.org/protocol/muc",
      SASL: "urn:ietf:params:xml:ns:xmpp-sasl",
      STREAM: "http://etherx.jabber.org/streams",
      FRAMING: "urn:ietf:params:xml:ns:xmpp-framing",
      BIND: "urn:ietf:params:xml:ns:xmpp-bind",
      SESSION: "urn:ietf:params:xml:ns:xmpp-session",
      VERSION: "jabber:iq:version",
      STANZAS: "urn:ietf:params:xml:ns:xmpp-stanzas",
      XHTML_IM: "http://jabber.org/protocol/xhtml-im",
      XHTML: "http://www.w3.org/1999/xhtml"
    },

    /** Constants: XHTML_IM Namespace
     *  contains allowed tags, tag attributes, and css properties.
     *  Used in the createHtml function to filter incoming html into the allowed XHTML-IM subset.
     *  See http://xmpp.org/extensions/xep-0071.html#profile-summary for the list of recommended
     *  allowed tags and their attributes.
     */
    XHTML: {
      tags: ['a', 'blockquote', 'br', 'cite', 'em', 'img', 'li', 'ol', 'p', 'span', 'strong', 'ul', 'body'],
      attributes: {
        'a': ['href'],
        'blockquote': ['style'],
        'br': [],
        'cite': ['style'],
        'em': [],
        'img': ['src', 'alt', 'style', 'height', 'width'],
        'li': ['style'],
        'ol': ['style'],
        'p': ['style'],
        'span': ['style'],
        'strong': [],
        'ul': ['style'],
        'body': []
      },
      css: ['background-color', 'color', 'font-family', 'font-size', 'font-style', 'font-weight', 'margin-left', 'margin-right', 'text-align', 'text-decoration'],

      /** Function: XHTML.validTag
       *
       * Utility method to determine whether a tag is allowed
       * in the XHTML_IM namespace.
       *
       * XHTML tag names are case sensitive and must be lower case.
       */
      validTag: function validTag(tag) {
        for (var i = 0; i < Strophe.XHTML.tags.length; i++) {
          if (tag === Strophe.XHTML.tags[i]) {
            return true;
          }
        }

        return false;
      },

      /** Function: XHTML.validAttribute
       *
       * Utility method to determine whether an attribute is allowed
       * as recommended per XEP-0071
       *
       * XHTML attribute names are case sensitive and must be lower case.
       */
      validAttribute: function validAttribute(tag, attribute) {
        if (typeof Strophe.XHTML.attributes[tag] !== 'undefined' && Strophe.XHTML.attributes[tag].length > 0) {
          for (var i = 0; i < Strophe.XHTML.attributes[tag].length; i++) {
            if (attribute === Strophe.XHTML.attributes[tag][i]) {
              return true;
            }
          }
        }

        return false;
      },
      validCSS: function validCSS(style) {
        for (var i = 0; i < Strophe.XHTML.css.length; i++) {
          if (style === Strophe.XHTML.css[i]) {
            return true;
          }
        }

        return false;
      }
    },

    /** Constants: Connection Status Constants
     *  Connection status constants for use by the connection handler
     *  callback.
     *
     *  Status.ERROR - An error has occurred
     *  Status.CONNECTING - The connection is currently being made
     *  Status.CONNFAIL - The connection attempt failed
     *  Status.AUTHENTICATING - The connection is authenticating
     *  Status.AUTHFAIL - The authentication attempt failed
     *  Status.CONNECTED - The connection has succeeded
     *  Status.DISCONNECTED - The connection has been terminated
     *  Status.DISCONNECTING - The connection is currently being terminated
     *  Status.ATTACHED - The connection has been attached
     *  Status.REDIRECT - The connection has been redirected
     *  Status.CONNTIMEOUT - The connection has timed out
     */
    Status: {
      ERROR: 0,
      CONNECTING: 1,
      CONNFAIL: 2,
      AUTHENTICATING: 3,
      AUTHFAIL: 4,
      CONNECTED: 5,
      DISCONNECTED: 6,
      DISCONNECTING: 7,
      ATTACHED: 8,
      REDIRECT: 9,
      CONNTIMEOUT: 10,
      BINDREQUIRED: 11,
      ATTACHFAIL: 12
    },
    ErrorCondition: {
      BAD_FORMAT: "bad-format",
      CONFLICT: "conflict",
      MISSING_JID_NODE: "x-strophe-bad-non-anon-jid",
      NO_AUTH_MECH: "no-auth-mech",
      UNKNOWN_REASON: "unknown"
    },

    /** Constants: Log Level Constants
     *  Logging level indicators.
     *
     *  LogLevel.DEBUG - Debug output
     *  LogLevel.INFO - Informational output
     *  LogLevel.WARN - Warnings
     *  LogLevel.ERROR - Errors
     *  LogLevel.FATAL - Fatal errors
     */
    LogLevel: {
      DEBUG: 0,
      INFO: 1,
      WARN: 2,
      ERROR: 3,
      FATAL: 4
    },

    /** PrivateConstants: DOM Element Type Constants
     *  DOM element types.
     *
     *  ElementType.NORMAL - Normal element.
     *  ElementType.TEXT - Text data element.
     *  ElementType.FRAGMENT - XHTML fragment element.
     */
    ElementType: {
      NORMAL: 1,
      TEXT: 3,
      CDATA: 4,
      FRAGMENT: 11
    },

    /** PrivateConstants: Timeout Values
     *  Timeout values for error states.  These values are in seconds.
     *  These should not be changed unless you know exactly what you are
     *  doing.
     *
     *  TIMEOUT - Timeout multiplier. A waiting request will be considered
     *      failed after Math.floor(TIMEOUT * wait) seconds have elapsed.
     *      This defaults to 1.1, and with default wait, 66 seconds.
     *  SECONDARY_TIMEOUT - Secondary timeout multiplier. In cases where
     *      Strophe can detect early failure, it will consider the request
     *      failed if it doesn't return after
     *      Math.floor(SECONDARY_TIMEOUT * wait) seconds have elapsed.
     *      This defaults to 0.1, and with default wait, 6 seconds.
     */
    TIMEOUT: 1.1,
    SECONDARY_TIMEOUT: 0.1,

    /** Function: addNamespace
     *  This function is used to extend the current namespaces in
     *  Strophe.NS.  It takes a key and a value with the key being the
     *  name of the new namespace, with its actual value.
     *  For example:
     *  Strophe.addNamespace('PUBSUB', "http://jabber.org/protocol/pubsub");
     *
     *  Parameters:
     *    (String) name - The name under which the namespace will be
     *      referenced under Strophe.NS
     *    (String) value - The actual namespace.
     */
    addNamespace: function addNamespace(name, value) {
      Strophe.NS[name] = value;
    },

    /** Function: forEachChild
     *  Map a function over some or all child elements of a given element.
     *
     *  This is a small convenience function for mapping a function over
     *  some or all of the children of an element.  If elemName is null, all
     *  children will be passed to the function, otherwise only children
     *  whose tag names match elemName will be passed.
     *
     *  Parameters:
     *    (XMLElement) elem - The element to operate on.
     *    (String) elemName - The child element tag name filter.
     *    (Function) func - The function to apply to each child.  This
     *      function should take a single argument, a DOM element.
     */
    forEachChild: function forEachChild(elem, elemName, func) {
      for (var i = 0; i < elem.childNodes.length; i++) {
        var childNode = elem.childNodes[i];

        if (childNode.nodeType === Strophe.ElementType.NORMAL && (!elemName || this.isTagEqual(childNode, elemName))) {
          func(childNode);
        }
      }
    },

    /** Function: isTagEqual
     *  Compare an element's tag name with a string.
     *
     *  This function is case sensitive.
     *
     *  Parameters:
     *    (XMLElement) el - A DOM element.
     *    (String) name - The element name.
     *
     *  Returns:
     *    true if the element's tag name matches _el_, and false
     *    otherwise.
     */
    isTagEqual: function isTagEqual(el, name) {
      return el.tagName === name;
    },

    /** PrivateVariable: _xmlGenerator
     *  _Private_ variable that caches a DOM document to
     *  generate elements.
     */
    _xmlGenerator: null,

    /** Function: xmlGenerator
     *  Get the DOM document to generate elements.
     *
     *  Returns:
     *    The currently used DOM document.
     */
    xmlGenerator: function xmlGenerator() {
      if (!Strophe._xmlGenerator) {
        Strophe._xmlGenerator = getDummyXMLDOMDocument();
      }

      return Strophe._xmlGenerator;
    },

    /** Function: xmlElement
     *  Create an XML DOM element.
     *
     *  This function creates an XML DOM element correctly across all
     *  implementations. Note that these are not HTML DOM elements, which
     *  aren't appropriate for XMPP stanzas.
     *
     *  Parameters:
     *    (String) name - The name for the element.
     *    (Array|Object) attrs - An optional array or object containing
     *      key/value pairs to use as element attributes. The object should
     *      be in the format {'key': 'value'} or {key: 'value'}. The array
     *      should have the format [['key1', 'value1'], ['key2', 'value2']].
     *    (String) text - The text child data for the element.
     *
     *  Returns:
     *    A new XML DOM element.
     */
    xmlElement: function xmlElement(name) {
      if (!name) {
        return null;
      }

      var node = Strophe.xmlGenerator().createElement(name); // FIXME: this should throw errors if args are the wrong type or
      // there are more than two optional args

      for (var a = 1; a < arguments.length; a++) {
        var arg = arguments[a];

        if (!arg) {
          continue;
        }

        if (typeof arg === "string" || typeof arg === "number") {
          node.appendChild(Strophe.xmlTextNode(arg));
        } else if (_typeof(arg) === "object" && typeof arg.sort === "function") {
          for (var i = 0; i < arg.length; i++) {
            var attr = arg[i];

            if (_typeof(attr) === "object" && typeof attr.sort === "function" && attr[1] !== undefined && attr[1] !== null) {
              node.setAttribute(attr[0], attr[1]);
            }
          }
        } else if (_typeof(arg) === "object") {
          for (var k in arg) {
            if (Object.prototype.hasOwnProperty.call(arg, k) && arg[k] !== undefined && arg[k] !== null) {
              node.setAttribute(k, arg[k]);
            }
          }
        }
      }

      return node;
    },

    /*  Function: xmlescape
     *  Excapes invalid xml characters.
     *
     *  Parameters:
     *     (String) text - text to escape.
     *
     *  Returns:
     *      Escaped text.
     */
    xmlescape: function xmlescape(text) {
      text = text.replace(/\&/g, "&amp;");
      text = text.replace(/</g, "&lt;");
      text = text.replace(/>/g, "&gt;");
      text = text.replace(/'/g, "&apos;");
      text = text.replace(/"/g, "&quot;");
      return text;
    },

    /*  Function: xmlunescape
    *  Unexcapes invalid xml characters.
    *
    *  Parameters:
    *     (String) text - text to unescape.
    *
    *  Returns:
    *      Unescaped text.
    */
    xmlunescape: function xmlunescape(text) {
      text = text.replace(/\&amp;/g, "&");
      text = text.replace(/&lt;/g, "<");
      text = text.replace(/&gt;/g, ">");
      text = text.replace(/&apos;/g, "'");
      text = text.replace(/&quot;/g, "\"");
      return text;
    },

    /** Function: xmlTextNode
     *  Creates an XML DOM text node.
     *
     *  Provides a cross implementation version of document.createTextNode.
     *
     *  Parameters:
     *    (String) text - The content of the text node.
     *
     *  Returns:
     *    A new XML DOM text node.
     */
    xmlTextNode: function xmlTextNode(text) {
      return Strophe.xmlGenerator().createTextNode(text);
    },

    /** Function: xmlHtmlNode
     *  Creates an XML DOM html node.
     *
     *  Parameters:
     *    (String) html - The content of the html node.
     *
     *  Returns:
     *    A new XML DOM text node.
     */
    xmlHtmlNode: function xmlHtmlNode(html) {
      var node; //ensure text is escaped

      if (DOMParser) {
        var parser = new DOMParser();
        node = parser.parseFromString(html, "text/xml");
      } else {
        node = new ActiveXObject("Microsoft.XMLDOM");
        node.async = "false";
        node.loadXML(html);
      }

      return node;
    },

    /** Function: getText
     *  Get the concatenation of all text children of an element.
     *
     *  Parameters:
     *    (XMLElement) elem - A DOM element.
     *
     *  Returns:
     *    A String with the concatenated text of all text element children.
     */
    getText: function getText(elem) {
      if (!elem) {
        return null;
      }

      var str = "";

      if (elem.childNodes.length === 0 && elem.nodeType === Strophe.ElementType.TEXT) {
        str += elem.nodeValue;
      }

      for (var i = 0; i < elem.childNodes.length; i++) {
        if (elem.childNodes[i].nodeType === Strophe.ElementType.TEXT) {
          str += elem.childNodes[i].nodeValue;
        }
      }

      return Strophe.xmlescape(str);
    },

    /** Function: copyElement
     *  Copy an XML DOM element.
     *
     *  This function copies a DOM element and all its descendants and returns
     *  the new copy.
     *
     *  Parameters:
     *    (XMLElement) elem - A DOM element.
     *
     *  Returns:
     *    A new, copied DOM element tree.
     */
    copyElement: function copyElement(elem) {
      var el;

      if (elem.nodeType === Strophe.ElementType.NORMAL) {
        el = Strophe.xmlElement(elem.tagName);

        for (var i = 0; i < elem.attributes.length; i++) {
          el.setAttribute(elem.attributes[i].nodeName, elem.attributes[i].value);
        }

        for (var _i = 0; _i < elem.childNodes.length; _i++) {
          el.appendChild(Strophe.copyElement(elem.childNodes[_i]));
        }
      } else if (elem.nodeType === Strophe.ElementType.TEXT) {
        el = Strophe.xmlGenerator().createTextNode(elem.nodeValue);
      }

      return el;
    },

    /** Function: createHtml
     *  Copy an HTML DOM element into an XML DOM.
     *
     *  This function copies a DOM element and all its descendants and returns
     *  the new copy.
     *
     *  Parameters:
     *    (HTMLElement) elem - A DOM element.
     *
     *  Returns:
     *    A new, copied DOM element tree.
     */
    createHtml: function createHtml(elem) {
      var el;

      if (elem.nodeType === Strophe.ElementType.NORMAL) {
        var tag = elem.nodeName.toLowerCase(); // XHTML tags must be lower case.

        if (Strophe.XHTML.validTag(tag)) {
          try {
            el = Strophe.xmlElement(tag);

            for (var i = 0; i < Strophe.XHTML.attributes[tag].length; i++) {
              var attribute = Strophe.XHTML.attributes[tag][i];
              var value = elem.getAttribute(attribute);

              if (typeof value === 'undefined' || value === null || value === '' || value === false || value === 0) {
                continue;
              }

              if (attribute === 'style' && _typeof(value) === 'object' && typeof value.cssText !== 'undefined') {
                value = value.cssText; // we're dealing with IE, need to get CSS out
              } // filter out invalid css styles


              if (attribute === 'style') {
                var css = [];
                var cssAttrs = value.split(';');

                for (var j = 0; j < cssAttrs.length; j++) {
                  var attr = cssAttrs[j].split(':');
                  var cssName = attr[0].replace(/^\s*/, "").replace(/\s*$/, "").toLowerCase();

                  if (Strophe.XHTML.validCSS(cssName)) {
                    var cssValue = attr[1].replace(/^\s*/, "").replace(/\s*$/, "");
                    css.push(cssName + ': ' + cssValue);
                  }
                }

                if (css.length > 0) {
                  value = css.join('; ');
                  el.setAttribute(attribute, value);
                }
              } else {
                el.setAttribute(attribute, value);
              }
            }

            for (var _i2 = 0; _i2 < elem.childNodes.length; _i2++) {
              el.appendChild(Strophe.createHtml(elem.childNodes[_i2]));
            }
          } catch (e) {
            // invalid elements
            el = Strophe.xmlTextNode('');
          }
        } else {
          el = Strophe.xmlGenerator().createDocumentFragment();

          for (var _i3 = 0; _i3 < elem.childNodes.length; _i3++) {
            el.appendChild(Strophe.createHtml(elem.childNodes[_i3]));
          }
        }
      } else if (elem.nodeType === Strophe.ElementType.FRAGMENT) {
        el = Strophe.xmlGenerator().createDocumentFragment();

        for (var _i4 = 0; _i4 < elem.childNodes.length; _i4++) {
          el.appendChild(Strophe.createHtml(elem.childNodes[_i4]));
        }
      } else if (elem.nodeType === Strophe.ElementType.TEXT) {
        el = Strophe.xmlTextNode(elem.nodeValue);
      }

      return el;
    },

    /** Function: escapeNode
     *  Escape the node part (also called local part) of a JID.
     *
     *  Parameters:
     *    (String) node - A node (or local part).
     *
     *  Returns:
     *    An escaped node (or local part).
     */
    escapeNode: function escapeNode(node) {
      if (typeof node !== "string") {
        return node;
      }

      return node.replace(/^\s+|\s+$/g, '').replace(/\\/g, "\\5c").replace(/ /g, "\\20").replace(/\"/g, "\\22").replace(/\&/g, "\\26").replace(/\'/g, "\\27").replace(/\//g, "\\2f").replace(/:/g, "\\3a").replace(/</g, "\\3c").replace(/>/g, "\\3e").replace(/@/g, "\\40");
    },

    /** Function: unescapeNode
     *  Unescape a node part (also called local part) of a JID.
     *
     *  Parameters:
     *    (String) node - A node (or local part).
     *
     *  Returns:
     *    An unescaped node (or local part).
     */
    unescapeNode: function unescapeNode(node) {
      if (typeof node !== "string") {
        return node;
      }

      return node.replace(/\\20/g, " ").replace(/\\22/g, '"').replace(/\\26/g, "&").replace(/\\27/g, "'").replace(/\\2f/g, "/").replace(/\\3a/g, ":").replace(/\\3c/g, "<").replace(/\\3e/g, ">").replace(/\\40/g, "@").replace(/\\5c/g, "\\");
    },

    /** Function: getNodeFromJid
     *  Get the node portion of a JID String.
     *
     *  Parameters:
     *    (String) jid - A JID.
     *
     *  Returns:
     *    A String containing the node.
     */
    getNodeFromJid: function getNodeFromJid(jid) {
      if (jid.indexOf("@") < 0) {
        return null;
      }

      return jid.split("@")[0];
    },

    /** Function: getDomainFromJid
     *  Get the domain portion of a JID String.
     *
     *  Parameters:
     *    (String) jid - A JID.
     *
     *  Returns:
     *    A String containing the domain.
     */
    getDomainFromJid: function getDomainFromJid(jid) {
      var bare = Strophe.getBareJidFromJid(jid);

      if (bare.indexOf("@") < 0) {
        return bare;
      } else {
        var parts = bare.split("@");
        parts.splice(0, 1);
        return parts.join('@');
      }
    },

    /** Function: getResourceFromJid
     *  Get the resource portion of a JID String.
     *
     *  Parameters:
     *    (String) jid - A JID.
     *
     *  Returns:
     *    A String containing the resource.
     */
    getResourceFromJid: function getResourceFromJid(jid) {
      if (!jid) {
        return null;
      }

      var s = jid.split("/");

      if (s.length < 2) {
        return null;
      }

      s.splice(0, 1);
      return s.join('/');
    },

    /** Function: getBareJidFromJid
     *  Get the bare JID from a JID String.
     *
     *  Parameters:
     *    (String) jid - A JID.
     *
     *  Returns:
     *    A String containing the bare JID.
     */
    getBareJidFromJid: function getBareJidFromJid(jid) {
      return jid ? jid.split("/")[0] : null;
    },

    /** PrivateFunction: _handleError
     *  _Private_ function that properly logs an error to the console
     */
    _handleError: function _handleError(e) {
      if (typeof e.stack !== "undefined") {
        Strophe.fatal(e.stack);
      }

      if (e.sourceURL) {
        Strophe.fatal("error: " + this.handler + " " + e.sourceURL + ":" + e.line + " - " + e.name + ": " + e.message);
      } else if (e.fileName) {
        Strophe.fatal("error: " + this.handler + " " + e.fileName + ":" + e.lineNumber + " - " + e.name + ": " + e.message);
      } else {
        Strophe.fatal("error: " + e.message);
      }
    },

    /** Function: log
     *  User overrideable logging function.
     *
     *  This function is called whenever the Strophe library calls any
     *  of the logging functions.  The default implementation of this
     *  function logs only fatal errors.  If client code wishes to handle the logging
     *  messages, it should override this with
     *  > Strophe.log = function (level, msg) {
     *  >   (user code here)
     *  > };
     *
     *  Please note that data sent and received over the wire is logged
     *  via Strophe.Connection.rawInput() and Strophe.Connection.rawOutput().
     *
     *  The different levels and their meanings are
     *
     *    DEBUG - Messages useful for debugging purposes.
     *    INFO - Informational messages.  This is mostly information like
     *      'disconnect was called' or 'SASL auth succeeded'.
     *    WARN - Warnings about potential problems.  This is mostly used
     *      to report transient connection errors like request timeouts.
     *    ERROR - Some error occurred.
     *    FATAL - A non-recoverable fatal error occurred.
     *
     *  Parameters:
     *    (Integer) level - The log level of the log message.  This will
     *      be one of the values in Strophe.LogLevel.
     *    (String) msg - The log message.
     */
    log: function log(level, msg) {
      if (level === this.LogLevel.FATAL) {
        var _console;

        (_console = console) === null || _console === void 0 ? void 0 : _console.error(msg);
      }
    },

    /** Function: debug
     *  Log a message at the Strophe.LogLevel.DEBUG level.
     *
     *  Parameters:
     *    (String) msg - The log message.
     */
    debug: function debug(msg) {
      this.log(this.LogLevel.DEBUG, msg);
    },

    /** Function: info
     *  Log a message at the Strophe.LogLevel.INFO level.
     *
     *  Parameters:
     *    (String) msg - The log message.
     */
    info: function info(msg) {
      this.log(this.LogLevel.INFO, msg);
    },

    /** Function: warn
     *  Log a message at the Strophe.LogLevel.WARN level.
     *
     *  Parameters:
     *    (String) msg - The log message.
     */
    warn: function warn(msg) {
      this.log(this.LogLevel.WARN, msg);
    },

    /** Function: error
     *  Log a message at the Strophe.LogLevel.ERROR level.
     *
     *  Parameters:
     *    (String) msg - The log message.
     */
    error: function error(msg) {
      this.log(this.LogLevel.ERROR, msg);
    },

    /** Function: fatal
     *  Log a message at the Strophe.LogLevel.FATAL level.
     *
     *  Parameters:
     *    (String) msg - The log message.
     */
    fatal: function fatal(msg) {
      this.log(this.LogLevel.FATAL, msg);
    },

    /** Function: serialize
     *  Render a DOM element and all descendants to a String.
     *
     *  Parameters:
     *    (XMLElement) elem - A DOM element.
     *
     *  Returns:
     *    The serialized element tree as a String.
     */
    serialize: function serialize(elem) {
      if (!elem) {
        return null;
      }

      if (typeof elem.tree === "function") {
        elem = elem.tree();
      }

      var names = _toConsumableArray(Array(elem.attributes.length).keys()).map(function (i) {
        return elem.attributes[i].nodeName;
      });

      names.sort();
      var result = names.reduce(function (a, n) {
        return "".concat(a, " ").concat(n, "=\"").concat(Strophe.xmlescape(elem.attributes.getNamedItem(n).value), "\"");
      }, "<".concat(elem.nodeName));

      if (elem.childNodes.length > 0) {
        result += ">";

        for (var i = 0; i < elem.childNodes.length; i++) {
          var child = elem.childNodes[i];

          switch (child.nodeType) {
            case Strophe.ElementType.NORMAL:
              // normal element, so recurse
              result += Strophe.serialize(child);
              break;

            case Strophe.ElementType.TEXT:
              // text element to escape values
              result += Strophe.xmlescape(child.nodeValue);
              break;

            case Strophe.ElementType.CDATA:
              // cdata section so don't escape values
              result += "<![CDATA[" + child.nodeValue + "]]>";
          }
        }

        result += "</" + elem.nodeName + ">";
      } else {
        result += "/>";
      }

      return result;
    },

    /** PrivateVariable: _requestId
     *  _Private_ variable that keeps track of the request ids for
     *  connections.
     */
    _requestId: 0,

    /** PrivateVariable: Strophe.connectionPlugins
     *  _Private_ variable Used to store plugin names that need
     *  initialization on Strophe.Connection construction.
     */
    _connectionPlugins: {},

    /** Function: addConnectionPlugin
     *  Extends the Strophe.Connection object with the given plugin.
     *
     *  Parameters:
     *    (String) name - The name of the extension.
     *    (Object) ptype - The plugin's prototype.
     */
    addConnectionPlugin: function addConnectionPlugin(name, ptype) {
      Strophe._connectionPlugins[name] = ptype;
    }
  };
  /** Class: Strophe.Builder
   *  XML DOM builder.
   *
   *  This object provides an interface similar to JQuery but for building
   *  DOM elements easily and rapidly.  All the functions except for toString()
   *  and tree() return the object, so calls can be chained.  Here's an
   *  example using the $iq() builder helper.
   *  > $iq({to: 'you', from: 'me', type: 'get', id: '1'})
   *  >     .c('query', {xmlns: 'strophe:example'})
   *  >     .c('example')
   *  >     .toString()
   *
   *  The above generates this XML fragment
   *  > <iq to='you' from='me' type='get' id='1'>
   *  >   <query xmlns='strophe:example'>
   *  >     <example/>
   *  >   </query>
   *  > </iq>
   *  The corresponding DOM manipulations to get a similar fragment would be
   *  a lot more tedious and probably involve several helper variables.
   *
   *  Since adding children makes new operations operate on the child, up()
   *  is provided to traverse up the tree.  To add two children, do
   *  > builder.c('child1', ...).up().c('child2', ...)
   *  The next operation on the Builder will be relative to the second child.
   */

  /** Constructor: Strophe.Builder
   *  Create a Strophe.Builder object.
   *
   *  The attributes should be passed in object notation.  For example
   *  > let b = new Builder('message', {to: 'you', from: 'me'});
   *  or
   *  > let b = new Builder('messsage', {'xml:lang': 'en'});
   *
   *  Parameters:
   *    (String) name - The name of the root element.
   *    (Object) attrs - The attributes for the root element in object notation.
   *
   *  Returns:
   *    A new Strophe.Builder.
   */

  Strophe.Builder = /*#__PURE__*/function () {
    function Builder(name, attrs) {
      _classCallCheck(this, Builder);

      // Set correct namespace for jabber:client elements
      if (name === "presence" || name === "message" || name === "iq") {
        if (attrs && !attrs.xmlns) {
          attrs.xmlns = Strophe.NS.CLIENT;
        } else if (!attrs) {
          attrs = {
            xmlns: Strophe.NS.CLIENT
          };
        }
      } // Holds the tree being built.


      this.nodeTree = Strophe.xmlElement(name, attrs); // Points to the current operation node.

      this.node = this.nodeTree;
    }
    /** Function: tree
     *  Return the DOM tree.
     *
     *  This function returns the current DOM tree as an element object.  This
     *  is suitable for passing to functions like Strophe.Connection.send().
     *
     *  Returns:
     *    The DOM tree as a element object.
     */

    _createClass(Builder, [{
      key: "tree",
      value: function tree() {
        return this.nodeTree;
      }
      /** Function: toString
       *  Serialize the DOM tree to a String.
       *
       *  This function returns a string serialization of the current DOM
       *  tree.  It is often used internally to pass data to a
       *  Strophe.Request object.
       *
       *  Returns:
       *    The serialized DOM tree in a String.
       */

    }, {
      key: "toString",
      value: function toString() {
        return Strophe.serialize(this.nodeTree);
      }
      /** Function: up
       *  Make the current parent element the new current element.
       *
       *  This function is often used after c() to traverse back up the tree.
       *  For example, to add two children to the same element
       *  > builder.c('child1', {}).up().c('child2', {});
       *
       *  Returns:
       *    The Stophe.Builder object.
       */

    }, {
      key: "up",
      value: function up() {
        this.node = this.node.parentNode;
        return this;
      }
      /** Function: root
       *  Make the root element the new current element.
       *
       *  When at a deeply nested element in the tree, this function can be used
       *  to jump back to the root of the tree, instead of having to repeatedly
       *  call up().
       *
       *  Returns:
       *    The Stophe.Builder object.
       */

    }, {
      key: "root",
      value: function root() {
        this.node = this.nodeTree;
        return this;
      }
      /** Function: attrs
       *  Add or modify attributes of the current element.
       *
       *  The attributes should be passed in object notation.  This function
       *  does not move the current element pointer.
       *
       *  Parameters:
       *    (Object) moreattrs - The attributes to add/modify in object notation.
       *
       *  Returns:
       *    The Strophe.Builder object.
       */

    }, {
      key: "attrs",
      value: function attrs(moreattrs) {
        for (var k in moreattrs) {
          if (Object.prototype.hasOwnProperty.call(moreattrs, k)) {
            if (moreattrs[k] === undefined) {
              this.node.removeAttribute(k);
            } else {
              this.node.setAttribute(k, moreattrs[k]);
            }
          }
        }

        return this;
      }
      /** Function: c
       *  Add a child to the current element and make it the new current
       *  element.
       *
       *  This function moves the current element pointer to the child,
       *  unless text is provided.  If you need to add another child, it
       *  is necessary to use up() to go back to the parent in the tree.
       *
       *  Parameters:
       *    (String) name - The name of the child.
       *    (Object) attrs - The attributes of the child in object notation.
       *    (String) text - The text to add to the child.
       *
       *  Returns:
       *    The Strophe.Builder object.
       */

    }, {
      key: "c",
      value: function c(name, attrs, text) {
        var child = Strophe.xmlElement(name, attrs, text);
        this.node.appendChild(child);

        if (typeof text !== "string" && typeof text !== "number") {
          this.node = child;
        }

        return this;
      }
      /** Function: cnode
       *  Add a child to the current element and make it the new current
       *  element.
       *
       *  This function is the same as c() except that instead of using a
       *  name and an attributes object to create the child it uses an
       *  existing DOM element object.
       *
       *  Parameters:
       *    (XMLElement) elem - A DOM element.
       *
       *  Returns:
       *    The Strophe.Builder object.
       */

    }, {
      key: "cnode",
      value: function cnode(elem) {
        var impNode;
        var xmlGen = Strophe.xmlGenerator();

        try {
          impNode = xmlGen.importNode !== undefined;
        } catch (e) {
          impNode = false;
        }

        var newElem = impNode ? xmlGen.importNode(elem, true) : Strophe.copyElement(elem);
        this.node.appendChild(newElem);
        this.node = newElem;
        return this;
      }
      /** Function: t
       *  Add a child text element.
       *
       *  This *does not* make the child the new current element since there
       *  are no children of text elements.
       *
       *  Parameters:
       *    (String) text - The text data to append to the current element.
       *
       *  Returns:
       *    The Strophe.Builder object.
       */

    }, {
      key: "t",
      value: function t(text) {
        var child = Strophe.xmlTextNode(text);
        this.node.appendChild(child);
        return this;
      }
      /** Function: h
       *  Replace current element contents with the HTML passed in.
       *
       *  This *does not* make the child the new current element
       *
       *  Parameters:
       *    (String) html - The html to insert as contents of current element.
       *
       *  Returns:
       *    The Strophe.Builder object.
       */

    }, {
      key: "h",
      value: function h(html) {
        var fragment = Strophe.xmlGenerator().createElement('body'); // force the browser to try and fix any invalid HTML tags

        fragment.innerHTML = html; // copy cleaned html into an xml dom

        var xhtml = Strophe.createHtml(fragment);

        while (xhtml.childNodes.length > 0) {
          this.node.appendChild(xhtml.childNodes[0]);
        }

        return this;
      }
    }]);

    return Builder;
  }();
  /** PrivateClass: Strophe.Handler
   *  _Private_ helper class for managing stanza handlers.
   *
   *  A Strophe.Handler encapsulates a user provided callback function to be
   *  executed when matching stanzas are received by the connection.
   *  Handlers can be either one-off or persistant depending on their
   *  return value. Returning true will cause a Handler to remain active, and
   *  returning false will remove the Handler.
   *
   *  Users will not use Strophe.Handler objects directly, but instead they
   *  will use Strophe.Connection.addHandler() and
   *  Strophe.Connection.deleteHandler().
   */

  /** PrivateConstructor: Strophe.Handler
   *  Create and initialize a new Strophe.Handler.
   *
   *  Parameters:
   *    (Function) handler - A function to be executed when the handler is run.
   *    (String) ns - The namespace to match.
   *    (String) name - The element name to match.
   *    (String) type - The element type to match.
   *    (String) id - The element id attribute to match.
   *    (String) from - The element from attribute to match.
   *    (Object) options - Handler options
   *
   *  Returns:
   *    A new Strophe.Handler object.
   */

  Strophe.Handler = function (handler, ns, name, type, id, from, options) {
    this.handler = handler;
    this.ns = ns;
    this.name = name;
    this.type = type;
    this.id = id;
    this.options = options || {
      'matchBareFromJid': false,
      'ignoreNamespaceFragment': false
    }; // BBB: Maintain backward compatibility with old `matchBare` option

    if (this.options.matchBare) {
      Strophe.warn('The "matchBare" option is deprecated, use "matchBareFromJid" instead.');
      this.options.matchBareFromJid = this.options.matchBare;
      delete this.options.matchBare;
    }

    if (this.options.matchBareFromJid) {
      this.from = from ? Strophe.getBareJidFromJid(from) : null;
    } else {
      this.from = from;
    } // whether the handler is a user handler or a system handler


    this.user = true;
  };

  Strophe.Handler.prototype = {
    /** PrivateFunction: getNamespace
     *  Returns the XML namespace attribute on an element.
     *  If `ignoreNamespaceFragment` was passed in for this handler, then the
     *  URL fragment will be stripped.
     *
     *  Parameters:
     *    (XMLElement) elem - The XML element with the namespace.
     *
     *  Returns:
     *    The namespace, with optionally the fragment stripped.
     */
    getNamespace: function getNamespace(elem) {
      var elNamespace = elem.getAttribute("xmlns");

      if (elNamespace && this.options.ignoreNamespaceFragment) {
        elNamespace = elNamespace.split('#')[0];
      }

      return elNamespace;
    },

    /** PrivateFunction: namespaceMatch
     *  Tests if a stanza matches the namespace set for this Strophe.Handler.
     *
     *  Parameters:
     *    (XMLElement) elem - The XML element to test.
     *
     *  Returns:
     *    true if the stanza matches and false otherwise.
     */
    namespaceMatch: function namespaceMatch(elem) {
      var _this = this;

      var nsMatch = false;

      if (!this.ns) {
        return true;
      } else {
        Strophe.forEachChild(elem, null, function (elem) {
          if (_this.getNamespace(elem) === _this.ns) {
            nsMatch = true;
          }
        });
        return nsMatch || this.getNamespace(elem) === this.ns;
      }
    },

    /** PrivateFunction: isMatch
     *  Tests if a stanza matches the Strophe.Handler.
     *
     *  Parameters:
     *    (XMLElement) elem - The XML element to test.
     *
     *  Returns:
     *    true if the stanza matches and false otherwise.
     */
    isMatch: function isMatch(elem) {
      var from = elem.getAttribute('from');

      if (this.options.matchBareFromJid) {
        from = Strophe.getBareJidFromJid(from);
      }

      var elem_type = elem.getAttribute("type");

      if (this.namespaceMatch(elem) && (!this.name || Strophe.isTagEqual(elem, this.name)) && (!this.type || (Array.isArray(this.type) ? this.type.indexOf(elem_type) !== -1 : elem_type === this.type)) && (!this.id || elem.getAttribute("id") === this.id) && (!this.from || from === this.from)) {
        return true;
      }

      return false;
    },

    /** PrivateFunction: run
     *  Run the callback on a matching stanza.
     *
     *  Parameters:
     *    (XMLElement) elem - The DOM element that triggered the
     *      Strophe.Handler.
     *
     *  Returns:
     *    A boolean indicating if the handler should remain active.
     */
    run: function run(elem) {
      var result = null;

      try {
        result = this.handler(elem);
      } catch (e) {
        Strophe._handleError(e);

        throw e;
      }

      return result;
    },

    /** PrivateFunction: toString
     *  Get a String representation of the Strophe.Handler object.
     *
     *  Returns:
     *    A String.
     */
    toString: function toString() {
      return "{Handler: " + this.handler + "(" + this.name + "," + this.id + "," + this.ns + ")}";
    }
  };
  /** PrivateClass: Strophe.TimedHandler
   *  _Private_ helper class for managing timed handlers.
   *
   *  A Strophe.TimedHandler encapsulates a user provided callback that
   *  should be called after a certain period of time or at regular
   *  intervals.  The return value of the callback determines whether the
   *  Strophe.TimedHandler will continue to fire.
   *
   *  Users will not use Strophe.TimedHandler objects directly, but instead
   *  they will use Strophe.Connection.addTimedHandler() and
   *  Strophe.Connection.deleteTimedHandler().
   */

  Strophe.TimedHandler = /*#__PURE__*/function () {
    /** PrivateConstructor: Strophe.TimedHandler
     *  Create and initialize a new Strophe.TimedHandler object.
     *
     *  Parameters:
     *    (Integer) period - The number of milliseconds to wait before the
     *      handler is called.
     *    (Function) handler - The callback to run when the handler fires.  This
     *      function should take no arguments.
     *
     *  Returns:
     *    A new Strophe.TimedHandler object.
     */
    function TimedHandler(period, handler) {
      _classCallCheck(this, TimedHandler);

      this.period = period;
      this.handler = handler;
      this.lastCalled = new Date().getTime();
      this.user = true;
    }
    /** PrivateFunction: run
     *  Run the callback for the Strophe.TimedHandler.
     *
     *  Returns:
     *    true if the Strophe.TimedHandler should be called again, and false
     *      otherwise.
     */

    _createClass(TimedHandler, [{
      key: "run",
      value: function run() {
        this.lastCalled = new Date().getTime();
        return this.handler();
      }
      /** PrivateFunction: reset
       *  Reset the last called time for the Strophe.TimedHandler.
       */

    }, {
      key: "reset",
      value: function reset() {
        this.lastCalled = new Date().getTime();
      }
      /** PrivateFunction: toString
       *  Get a string representation of the Strophe.TimedHandler object.
       *
       *  Returns:
       *    The string representation.
       */

    }, {
      key: "toString",
      value: function toString() {
        return "{TimedHandler: " + this.handler + "(" + this.period + ")}";
      }
    }]);

    return TimedHandler;
  }();
  /** Class: Strophe.Connection
   *  XMPP Connection manager.
   *
   *  This class is the main part of Strophe.  It manages a BOSH or websocket
   *  connection to an XMPP server and dispatches events to the user callbacks
   *  as data arrives. It supports SASL PLAIN, SASL SCRAM-SHA-1
   *  and legacy authentication.
   *
   *  After creating a Strophe.Connection object, the user will typically
   *  call connect() with a user supplied callback to handle connection level
   *  events like authentication failure, disconnection, or connection
   *  complete.
   *
   *  The user will also have several event handlers defined by using
   *  addHandler() and addTimedHandler().  These will allow the user code to
   *  respond to interesting stanzas or do something periodically with the
   *  connection. These handlers will be active once authentication is
   *  finished.
   *
   *  To send data to the connection, use send().
   */

  /** Constructor: Strophe.Connection
   *  Create and initialize a Strophe.Connection object.
   *
   *  The transport-protocol for this connection will be chosen automatically
   *  based on the given service parameter. URLs starting with "ws://" or
   *  "wss://" will use WebSockets, URLs starting with "http://", "https://"
   *  or without a protocol will use BOSH.
   *
   *  To make Strophe connect to the current host you can leave out the protocol
   *  and host part and just pass the path, e.g.
   *
   *  > let conn = new Strophe.Connection("/http-bind/");
   *
   *  Options common to both Websocket and BOSH:
   *  ------------------------------------------
   *
   *  cookies:
   *
   *  The *cookies* option allows you to pass in cookies to be added to the
   *  document. These cookies will then be included in the BOSH XMLHttpRequest
   *  or in the websocket connection.
   *
   *  The passed in value must be a map of cookie names and string values.
   *
   *  > { "myCookie": {
   *  >     "value": "1234",
   *  >     "domain": ".example.org",
   *  >     "path": "/",
   *  >     "expires": expirationDate
   *  >     }
   *  > }
   *
   *  Note that cookies can't be set in this way for other domains (i.e. cross-domain).
   *  Those cookies need to be set under those domains, for example they can be
   *  set server-side by making a XHR call to that domain to ask it to set any
   *  necessary cookies.
   *
   *  mechanisms:
   *
   *  The *mechanisms* option allows you to specify the SASL mechanisms that this
   *  instance of Strophe.Connection (and therefore your XMPP client) will
   *  support.
   *
   *  The value must be an array of objects with Strophe.SASLMechanism
   *  prototypes.
   *
   *  If nothing is specified, then the following mechanisms (and their
   *  priorities) are registered:
   *
   *      SCRAM-SHA-1 - 60
   *      PLAIN       - 50
   *      OAUTHBEARER - 40
   *      X-OAUTH2    - 30
   *      ANONYMOUS   - 20
   *      EXTERNAL    - 10
   *
   *  explicitResourceBinding:
   *
   *  If `explicitResourceBinding` is set to a truthy value, then the XMPP client
   *  needs to explicitly call `Strophe.Connection.prototype.bind` once the XMPP
   *  server has advertised the "urn:ietf:params:xml:ns:xmpp-bind" feature.
   *
   *  Making this step explicit allows client authors to first finish other
   *  stream related tasks, such as setting up an XEP-0198 Stream Management
   *  session, before binding the JID resource for this session.
   *
   *  WebSocket options:
   *  ------------------
   *
   *  protocol:
   *
   *  If you want to connect to the current host with a WebSocket connection you
   *  can tell Strophe to use WebSockets through a "protocol" attribute in the
   *  optional options parameter. Valid values are "ws" for WebSocket and "wss"
   *  for Secure WebSocket.
   *  So to connect to "wss://CURRENT_HOSTNAME/xmpp-websocket" you would call
   *
   *  > let conn = new Strophe.Connection("/xmpp-websocket/", {protocol: "wss"});
   *
   *  Note that relative URLs _NOT_ starting with a "/" will also include the path
   *  of the current site.
   *
   *  Also because downgrading security is not permitted by browsers, when using
   *  relative URLs both BOSH and WebSocket connections will use their secure
   *  variants if the current connection to the site is also secure (https).
   *
   *  worker:
   *
   *  Set this option to URL from where the shared worker script should be loaded.
   *
   *  To run the websocket connection inside a shared worker.
   *  This allows you to share a single websocket-based connection between
   *  multiple Strophe.Connection instances, for example one per browser tab.
   *
   *  The script to use is the one in `src/shared-connection-worker.js`.
   *
   *  BOSH options:
   *  -------------
   *
   *  By adding "sync" to the options, you can control if requests will
   *  be made synchronously or not. The default behaviour is asynchronous.
   *  If you want to make requests synchronous, make "sync" evaluate to true.
   *  > let conn = new Strophe.Connection("/http-bind/", {sync: true});
   *
   *  You can also toggle this on an already established connection.
   *  > conn.options.sync = true;
   *
   *  The *customHeaders* option can be used to provide custom HTTP headers to be
   *  included in the XMLHttpRequests made.
   *
   *  The *keepalive* option can be used to instruct Strophe to maintain the
   *  current BOSH session across interruptions such as webpage reloads.
   *
   *  It will do this by caching the sessions tokens in sessionStorage, and when
   *  "restore" is called it will check whether there are cached tokens with
   *  which it can resume an existing session.
   *
   *  The *withCredentials* option should receive a Boolean value and is used to
   *  indicate wether cookies should be included in ajax requests (by default
   *  they're not).
   *  Set this value to true if you are connecting to a BOSH service
   *  and for some reason need to send cookies to it.
   *  In order for this to work cross-domain, the server must also enable
   *  credentials by setting the Access-Control-Allow-Credentials response header
   *  to "true". For most usecases however this setting should be false (which
   *  is the default).
   *  Additionally, when using Access-Control-Allow-Credentials, the
   *  Access-Control-Allow-Origin header can't be set to the wildcard "*", but
   *  instead must be restricted to actual domains.
   *
   *  The *contentType* option can be set to change the default Content-Type
   *  of "text/xml; charset=utf-8", which can be useful to reduce the amount of
   *  CORS preflight requests that are sent to the server.
   *
   *  Parameters:
   *    (String) service - The BOSH or WebSocket service URL.
   *    (Object) options - A hash of configuration options
   *
   *  Returns:
   *    A new Strophe.Connection object.
   */

  Strophe.Connection = /*#__PURE__*/function () {
    function Connection(service, options) {
      var _this2 = this;

      _classCallCheck(this, Connection);

      // The service URL
      this.service = service; // Configuration options

      this.options = options || {};
      this.setProtocol();
      /* The connected JID. */

      this.jid = "";
      /* the JIDs domain */

      this.domain = null;
      /* stream:features */

      this.features = null; // SASL

      this._sasl_data = {};
      this.do_bind = false;
      this.do_session = false;
      this.mechanisms = {}; // handler lists

      this.timedHandlers = [];
      this.handlers = [];
      this.removeTimeds = [];
      this.removeHandlers = [];
      this.addTimeds = [];
      this.addHandlers = [];
      this.protocolErrorHandlers = {
        'HTTP': {},
        'websocket': {}
      };
      this._idleTimeout = null;
      this._disconnectTimeout = null;
      this.authenticated = false;
      this.connected = false;
      this.disconnecting = false;
      this.do_authentication = true;
      this.paused = false;
      this.restored = false;
      this._data = [];
      this._uniqueId = 0;
      this._sasl_success_handler = null;
      this._sasl_failure_handler = null;
      this._sasl_challenge_handler = null; // Max retries before disconnecting

      this.maxRetries = 5; // Call onIdle callback every 1/10th of a second

      this._idleTimeout = setTimeout(function () {
        return _this2._onIdle();
      }, 100);
      utils.addCookies(this.options.cookies);
      this.registerSASLMechanisms(this.options.mechanisms); // initialize plugins

      for (var k in Strophe._connectionPlugins) {
        if (Object.prototype.hasOwnProperty.call(Strophe._connectionPlugins, k)) {
          var F = function F() {};

          F.prototype = Strophe._connectionPlugins[k];
          this[k] = new F();
          this[k].init(this);
        }
      }
    }
    /** Function: setProtocol
     *  Select protocal based on this.options or this.service
     */

    _createClass(Connection, [{
      key: "setProtocol",
      value: function setProtocol() {
        var proto = this.options.protocol || "";

        if (this.options.worker) {
          this._proto = new Strophe.WorkerWebsocket(this);
        } else if (this.service.indexOf("ws:") === 0 || this.service.indexOf("wss:") === 0 || proto.indexOf("ws") === 0) {
          this._proto = new Strophe.Websocket(this);
        } else {
          this._proto = new Strophe.Bosh(this);
        }
      }
      /** Function: reset
       *  Reset the connection.
       *
       *  This function should be called after a connection is disconnected
       *  before that connection is reused.
       */

    }, {
      key: "reset",
      value: function reset() {
        this._proto._reset(); // SASL


        this.do_session = false;
        this.do_bind = false; // handler lists

        this.timedHandlers = [];
        this.handlers = [];
        this.removeTimeds = [];
        this.removeHandlers = [];
        this.addTimeds = [];
        this.addHandlers = [];
        this.authenticated = false;
        this.connected = false;
        this.disconnecting = false;
        this.restored = false;
        this._data = [];
        this._requests = [];
        this._uniqueId = 0;
      }
      /** Function: pause
       *  Pause the request manager.
       *
       *  This will prevent Strophe from sending any more requests to the
       *  server.  This is very useful for temporarily pausing
       *  BOSH-Connections while a lot of send() calls are happening quickly.
       *  This causes Strophe to send the data in a single request, saving
       *  many request trips.
       */

    }, {
      key: "pause",
      value: function pause() {
        this.paused = true;
      }
      /** Function: resume
       *  Resume the request manager.
       *
       *  This resumes after pause() has been called.
       */

    }, {
      key: "resume",
      value: function resume() {
        this.paused = false;
      }
      /** Function: getUniqueId
       *  Generate a unique ID for use in <iq/> elements.
       *
       *  All <iq/> stanzas are required to have unique id attributes.  This
       *  function makes creating these easy.  Each connection instance has
       *  a counter which starts from zero, and the value of this counter
       *  plus a colon followed by the suffix becomes the unique id. If no
       *  suffix is supplied, the counter is used as the unique id.
       *
       *  Suffixes are used to make debugging easier when reading the stream
       *  data, and their use is recommended.  The counter resets to 0 for
       *  every new connection for the same reason.  For connections to the
       *  same server that authenticate the same way, all the ids should be
       *  the same, which makes it easy to see changes.  This is useful for
       *  automated testing as well.
       *
       *  Parameters:
       *    (String) suffix - A optional suffix to append to the id.
       *
       *  Returns:
       *    A unique string to be used for the id attribute.
       */

    }, {
      key: "getUniqueId",
      value: function getUniqueId(suffix) {
        // eslint-disable-line class-methods-use-this
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
              v = c === 'x' ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });

        if (typeof suffix === "string" || typeof suffix === "number") {
          return uuid + ":" + suffix;
        } else {
          return uuid + "";
        }
      }
      /** Function: addProtocolErrorHandler
       *  Register a handler function for when a protocol (websocker or HTTP)
       *  error occurs.
       *
       *  NOTE: Currently only HTTP errors for BOSH requests are handled.
       *  Patches that handle websocket errors would be very welcome.
       *
       *  Parameters:
       *    (String) protocol - 'HTTP' or 'websocket'
       *    (Integer) status_code - Error status code (e.g 500, 400 or 404)
       *    (Function) callback - Function that will fire on Http error
       *
       *  Example:
       *  function onError(err_code){
       *    //do stuff
       *  }
       *
       *  let conn = Strophe.connect('http://example.com/http-bind');
       *  conn.addProtocolErrorHandler('HTTP', 500, onError);
       *  // Triggers HTTP 500 error and onError handler will be called
       *  conn.connect('user_jid@incorrect_jabber_host', 'secret', onConnect);
       */

    }, {
      key: "addProtocolErrorHandler",
      value: function addProtocolErrorHandler(protocol, status_code, callback) {
        this.protocolErrorHandlers[protocol][status_code] = callback;
      }
      /** Function: connect
       *  Starts the connection process.
       *
       *  As the connection process proceeds, the user supplied callback will
       *  be triggered multiple times with status updates.  The callback
       *  should take two arguments - the status code and the error condition.
       *
       *  The status code will be one of the values in the Strophe.Status
       *  constants.  The error condition will be one of the conditions
       *  defined in RFC 3920 or the condition 'strophe-parsererror'.
       *
       *  The Parameters _wait_, _hold_ and _route_ are optional and only relevant
       *  for BOSH connections. Please see XEP 124 for a more detailed explanation
       *  of the optional parameters.
       *
       *  Parameters:
       *    (String) jid - The user's JID.  This may be a bare JID,
       *      or a full JID.  If a node is not supplied, SASL OAUTHBEARER or
       *      SASL ANONYMOUS authentication will be attempted (OAUTHBEARER will
       *      process the provided password value as an access token).
       *    (String) pass - The user's password.
       *    (Function) callback - The connect callback function.
       *    (Integer) wait - The optional HTTPBIND wait value.  This is the
       *      time the server will wait before returning an empty result for
       *      a request.  The default setting of 60 seconds is recommended.
       *    (Integer) hold - The optional HTTPBIND hold value.  This is the
       *      number of connections the server will hold at one time.  This
       *      should almost always be set to 1 (the default).
       *    (String) route - The optional route value.
       *    (String) authcid - The optional alternative authentication identity
       *      (username) if intending to impersonate another user.
       *      When using the SASL-EXTERNAL authentication mechanism, for example
       *      with client certificates, then the authcid value is used to
       *      determine whether an authorization JID (authzid) should be sent to
       *      the server. The authzid should NOT be sent to the server if the
       *      authzid and authcid are the same. So to prevent it from being sent
       *      (for example when the JID is already contained in the client
       *      certificate), set authcid to that same JID. See XEP-178 for more
       *      details.
       */

    }, {
      key: "connect",
      value: function connect(jid, pass, callback, wait, hold, route, authcid) {
        this.jid = jid;
        /** Variable: authzid
         *  Authorization identity.
         */

        this.authzid = Strophe.getBareJidFromJid(this.jid);
        /** Variable: authcid
         *  Authentication identity (User name).
         */

        this.authcid = authcid || Strophe.getNodeFromJid(this.jid);
        /** Variable: pass
         *  Authentication identity (User password).
         */

        this.pass = pass;
        this.connect_callback = callback;
        this.disconnecting = false;
        this.connected = false;
        this.authenticated = false;
        this.restored = false; // parse jid for domain

        this.domain = Strophe.getDomainFromJid(this.jid);

        this._changeConnectStatus(Strophe.Status.CONNECTING, null);

        this._proto._connect(wait, hold, route);
      }
      /** Function: attach
       *  Attach to an already created and authenticated BOSH session.
       *
       *  This function is provided to allow Strophe to attach to BOSH
       *  sessions which have been created externally, perhaps by a Web
       *  application.  This is often used to support auto-login type features
       *  without putting user credentials into the page.
       *
       *  Parameters:
       *    (String) jid - The full JID that is bound by the session.
       *    (String) sid - The SID of the BOSH session.
       *    (String) rid - The current RID of the BOSH session.  This RID
       *      will be used by the next request.
       *    (Function) callback The connect callback function.
       *    (Integer) wait - The optional HTTPBIND wait value.  This is the
       *      time the server will wait before returning an empty result for
       *      a request.  The default setting of 60 seconds is recommended.
       *      Other settings will require tweaks to the Strophe.TIMEOUT value.
       *    (Integer) hold - The optional HTTPBIND hold value.  This is the
       *      number of connections the server will hold at one time.  This
       *      should almost always be set to 1 (the default).
       *    (Integer) wind - The optional HTTBIND window value.  This is the
       *      allowed range of request ids that are valid.  The default is 5.
       */

    }, {
      key: "attach",
      value: function attach(jid, sid, rid, callback, wait, hold, wind) {
        if (this._proto._attach) {
          return this._proto._attach(jid, sid, rid, callback, wait, hold, wind);
        } else {
          var error = new Error('The "attach" method is not available for your connection protocol');
          error.name = 'StropheSessionError';
          throw error;
        }
      }
      /** Function: restore
       *  Attempt to restore a cached BOSH session.
       *
       *  This function is only useful in conjunction with providing the
       *  "keepalive":true option when instantiating a new Strophe.Connection.
       *
       *  When "keepalive" is set to true, Strophe will cache the BOSH tokens
       *  RID (Request ID) and SID (Session ID) and then when this function is
       *  called, it will attempt to restore the session from those cached
       *  tokens.
       *
       *  This function must therefore be called instead of connect or attach.
       *
       *  For an example on how to use it, please see examples/restore.js
       *
       *  Parameters:
       *    (String) jid - The user's JID.  This may be a bare JID or a full JID.
       *    (Function) callback - The connect callback function.
       *    (Integer) wait - The optional HTTPBIND wait value.  This is the
       *      time the server will wait before returning an empty result for
       *      a request.  The default setting of 60 seconds is recommended.
       *    (Integer) hold - The optional HTTPBIND hold value.  This is the
       *      number of connections the server will hold at one time.  This
       *      should almost always be set to 1 (the default).
       *    (Integer) wind - The optional HTTBIND window value.  This is the
       *      allowed range of request ids that are valid.  The default is 5.
       */

    }, {
      key: "restore",
      value: function restore(jid, callback, wait, hold, wind) {
        if (this._sessionCachingSupported()) {
          this._proto._restore(jid, callback, wait, hold, wind);
        } else {
          var error = new Error('The "restore" method can only be used with a BOSH connection.');
          error.name = 'StropheSessionError';
          throw error;
        }
      }
      /** PrivateFunction: _sessionCachingSupported
       * Checks whether sessionStorage and JSON are supported and whether we're
       * using BOSH.
       */

    }, {
      key: "_sessionCachingSupported",
      value: function _sessionCachingSupported() {
        if (this._proto instanceof Strophe.Bosh) {
          if (!JSON) {
            return false;
          }

          try {
            sessionStorage.setItem('_strophe_', '_strophe_');
            sessionStorage.removeItem('_strophe_');
          } catch (e) {
            return false;
          }

          return true;
        }

        return false;
      }
      /** Function: xmlInput
       *  User overrideable function that receives XML data coming into the
       *  connection.
       *
       *  The default function does nothing.  User code can override this with
       *  > Strophe.Connection.xmlInput = function (elem) {
       *  >   (user code)
       *  > };
       *
       *  Due to limitations of current Browsers' XML-Parsers the opening and closing
       *  <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
       *
       *  BOSH-Connections will have all stanzas wrapped in a <body> tag. See
       *  <Strophe.Bosh.strip> if you want to strip this tag.
       *
       *  Parameters:
       *    (XMLElement) elem - The XML data received by the connection.
       */

    }, {
      key: "xmlInput",
      value: function xmlInput(elem) {
        // eslint-disable-line
        return;
      }
      /** Function: xmlOutput
       *  User overrideable function that receives XML data sent to the
       *  connection.
       *
       *  The default function does nothing.  User code can override this with
       *  > Strophe.Connection.xmlOutput = function (elem) {
       *  >   (user code)
       *  > };
       *
       *  Due to limitations of current Browsers' XML-Parsers the opening and closing
       *  <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
       *
       *  BOSH-Connections will have all stanzas wrapped in a <body> tag. See
       *  <Strophe.Bosh.strip> if you want to strip this tag.
       *
       *  Parameters:
       *    (XMLElement) elem - The XMLdata sent by the connection.
       */

    }, {
      key: "xmlOutput",
      value: function xmlOutput(elem) {
        // eslint-disable-line
        return;
      }
      /** Function: rawInput
       *  User overrideable function that receives raw data coming into the
       *  connection.
       *
       *  The default function does nothing.  User code can override this with
       *  > Strophe.Connection.rawInput = function (data) {
       *  >   (user code)
       *  > };
       *
       *  Parameters:
       *    (String) data - The data received by the connection.
       */

    }, {
      key: "rawInput",
      value: function rawInput(data) {
        // eslint-disable-line
        return;
      }
      /** Function: rawOutput
       *  User overrideable function that receives raw data sent to the
       *  connection.
       *
       *  The default function does nothing.  User code can override this with
       *  > Strophe.Connection.rawOutput = function (data) {
       *  >   (user code)
       *  > };
       *
       *  Parameters:
       *    (String) data - The data sent by the connection.
       */

    }, {
      key: "rawOutput",
      value: function rawOutput(data) {
        // eslint-disable-line
        return;
      }
      /** Function: nextValidRid
       *  User overrideable function that receives the new valid rid.
       *
       *  The default function does nothing. User code can override this with
       *  > Strophe.Connection.nextValidRid = function (rid) {
       *  >    (user code)
       *  > };
       *
       *  Parameters:
       *    (Number) rid - The next valid rid
       */

    }, {
      key: "nextValidRid",
      value: function nextValidRid(rid) {
        // eslint-disable-line
        return;
      }
      /** Function: send
       *  Send a stanza.
       *
       *  This function is called to push data onto the send queue to
       *  go out over the wire.  Whenever a request is sent to the BOSH
       *  server, all pending data is sent and the queue is flushed.
       *
       *  Parameters:
       *    (XMLElement |
       *     [XMLElement] |
       *     Strophe.Builder) elem - The stanza to send.
       */

    }, {
      key: "send",
      value: function send(elem) {
        if (elem === null) {
          return;
        }

        if (typeof elem.sort === "function") {
          for (var i = 0; i < elem.length; i++) {
            this._queueData(elem[i]);
          }
        } else if (typeof elem.tree === "function") {
          this._queueData(elem.tree());
        } else {
          this._queueData(elem);
        }

        this._proto._send();
      }
      /** Function: flush
       *  Immediately send any pending outgoing data.
       *
       *  Normally send() queues outgoing data until the next idle period
       *  (100ms), which optimizes network use in the common cases when
       *  several send()s are called in succession. flush() can be used to
       *  immediately send all pending data.
       */

    }, {
      key: "flush",
      value: function flush() {
        // cancel the pending idle period and run the idle function
        // immediately
        clearTimeout(this._idleTimeout);

        this._onIdle();
      }
      /** Function: sendPresence
       *  Helper function to send presence stanzas. The main benefit is for
       *  sending presence stanzas for which you expect a responding presence
       *  stanza with the same id (for example when leaving a chat room).
       *
       *  Parameters:
       *    (XMLElement) elem - The stanza to send.
       *    (Function) callback - The callback function for a successful request.
       *    (Function) errback - The callback function for a failed or timed
       *      out request.  On timeout, the stanza will be null.
       *    (Integer) timeout - The time specified in milliseconds for a
       *      timeout to occur.
       *
       *  Returns:
       *    The id used to send the presence.
       */

    }, {
      key: "sendPresence",
      value: function sendPresence(elem, callback, errback, timeout) {
        var _this3 = this;

        var timeoutHandler = null;

        if (typeof elem.tree === "function") {
          elem = elem.tree();
        }

        var id = elem.getAttribute('id');

        if (!id) {
          // inject id if not found
          id = this.getUniqueId("sendPresence");
          elem.setAttribute("id", id);
        }

        if (typeof callback === "function" || typeof errback === "function") {
          var handler = this.addHandler(function (stanza) {
            // remove timeout handler if there is one
            if (timeoutHandler) {
              _this3.deleteTimedHandler(timeoutHandler);
            }

            if (stanza.getAttribute('type') === 'error') {
              if (errback) {
                errback(stanza);
              }
            } else if (callback) {
              callback(stanza);
            }
          }, null, 'presence', null, id); // if timeout specified, set up a timeout handler.

          if (timeout) {
            timeoutHandler = this.addTimedHandler(timeout, function () {
              // get rid of normal handler
              _this3.deleteHandler(handler); // call errback on timeout with null stanza


              if (errback) {
                errback(null);
              }

              return false;
            });
          }
        }

        this.send(elem);
        return id;
      }
      /** Function: sendIQ
       *  Helper function to send IQ stanzas.
       *
       *  Parameters:
       *    (XMLElement) elem - The stanza to send.
       *    (Function) callback - The callback function for a successful request.
       *    (Function) errback - The callback function for a failed or timed
       *      out request.  On timeout, the stanza will be null.
       *    (Integer) timeout - The time specified in milliseconds for a
       *      timeout to occur.
       *
       *  Returns:
       *    The id used to send the IQ.
      */

    }, {
      key: "sendIQ",
      value: function sendIQ(elem, callback, errback, timeout) {
        var _this4 = this;

        var timeoutHandler = null;

        if (typeof elem.tree === "function") {
          elem = elem.tree();
        }

        var id = elem.getAttribute('id');

        if (!id) {
          // inject id if not found
          id = this.getUniqueId("sendIQ");
          elem.setAttribute("id", id);
        }

        if (typeof callback === "function" || typeof errback === "function") {
          var handler = this.addHandler(function (stanza) {
            // remove timeout handler if there is one
            if (timeoutHandler) {
              _this4.deleteTimedHandler(timeoutHandler);
            }

            var iqtype = stanza.getAttribute('type');

            if (iqtype === 'result') {
              if (callback) {
                callback(stanza);
              }
            } else if (iqtype === 'error') {
              if (errback) {
                errback(stanza);
              }
            } else {
              var error = new Error("Got bad IQ type of ".concat(iqtype));
              error.name = "StropheError";
              throw error;
            }
          }, null, 'iq', ['error', 'result'], id); // if timeout specified, set up a timeout handler.

          if (timeout) {
            timeoutHandler = this.addTimedHandler(timeout, function () {
              // get rid of normal handler
              _this4.deleteHandler(handler); // call errback on timeout with null stanza


              if (errback) {
                errback(null);
              }

              return false;
            });
          }
        }

        this.send(elem);
        return id;
      }
      /** PrivateFunction: _queueData
       *  Queue outgoing data for later sending.  Also ensures that the data
       *  is a DOMElement.
       */

    }, {
      key: "_queueData",
      value: function _queueData(element) {
        if (element === null || !element.tagName || !element.childNodes) {
          var error = new Error("Cannot queue non-DOMElement.");
          error.name = "StropheError";
          throw error;
        }

        this._data.push(element);
      }
      /** PrivateFunction: _sendRestart
       *  Send an xmpp:restart stanza.
       */

    }, {
      key: "_sendRestart",
      value: function _sendRestart() {
        var _this5 = this;

        this._data.push("restart");

        this._proto._sendRestart();

        this._idleTimeout = setTimeout(function () {
          return _this5._onIdle();
        }, 100);
      }
      /** Function: addTimedHandler
       *  Add a timed handler to the connection.
       *
       *  This function adds a timed handler.  The provided handler will
       *  be called every period milliseconds until it returns false,
       *  the connection is terminated, or the handler is removed.  Handlers
       *  that wish to continue being invoked should return true.
       *
       *  Because of method binding it is necessary to save the result of
       *  this function if you wish to remove a handler with
       *  deleteTimedHandler().
       *
       *  Note that user handlers are not active until authentication is
       *  successful.
       *
       *  Parameters:
       *    (Integer) period - The period of the handler.
       *    (Function) handler - The callback function.
       *
       *  Returns:
       *    A reference to the handler that can be used to remove it.
       */

    }, {
      key: "addTimedHandler",
      value: function addTimedHandler(period, handler) {
        var thand = new Strophe.TimedHandler(period, handler);
        this.addTimeds.push(thand);
        return thand;
      }
      /** Function: deleteTimedHandler
       *  Delete a timed handler for a connection.
       *
       *  This function removes a timed handler from the connection.  The
       *  handRef parameter is *not* the function passed to addTimedHandler(),
       *  but is the reference returned from addTimedHandler().
       *
       *  Parameters:
       *    (Strophe.TimedHandler) handRef - The handler reference.
       */

    }, {
      key: "deleteTimedHandler",
      value: function deleteTimedHandler(handRef) {
        // this must be done in the Idle loop so that we don't change
        // the handlers during iteration
        this.removeTimeds.push(handRef);
      }
      /** Function: addHandler
       *  Add a stanza handler for the connection.
       *
       *  This function adds a stanza handler to the connection.  The
       *  handler callback will be called for any stanza that matches
       *  the parameters.  Note that if multiple parameters are supplied,
       *  they must all match for the handler to be invoked.
       *
       *  The handler will receive the stanza that triggered it as its argument.
       *  *The handler should return true if it is to be invoked again;
       *  returning false will remove the handler after it returns.*
       *
       *  As a convenience, the ns parameters applies to the top level element
       *  and also any of its immediate children.  This is primarily to make
       *  matching /iq/query elements easy.
       *
       *  Options
       *  ~~~~~~~
       *  With the options argument, you can specify boolean flags that affect how
       *  matches are being done.
       *
       *  Currently two flags exist:
       *
       *  - matchBareFromJid:
       *      When set to true, the from parameter and the
       *      from attribute on the stanza will be matched as bare JIDs instead
       *      of full JIDs. To use this, pass {matchBareFromJid: true} as the
       *      value of options. The default value for matchBareFromJid is false.
       *
       *  - ignoreNamespaceFragment:
       *      When set to true, a fragment specified on the stanza's namespace
       *      URL will be ignored when it's matched with the one configured for
       *      the handler.
       *
       *      This means that if you register like this:
       *      >   connection.addHandler(
       *      >       handler,
       *      >       'http://jabber.org/protocol/muc',
       *      >       null, null, null, null,
       *      >       {'ignoreNamespaceFragment': true}
       *      >   );
       *
       *      Then a stanza with XML namespace of
       *      'http://jabber.org/protocol/muc#user' will also be matched. If
       *      'ignoreNamespaceFragment' is false, then only stanzas with
       *      'http://jabber.org/protocol/muc' will be matched.
       *
       *  Deleting the handler
       *  ~~~~~~~~~~~~~~~~~~~~
       *  The return value should be saved if you wish to remove the handler
       *  with deleteHandler().
       *
       *  Parameters:
       *    (Function) handler - The user callback.
       *    (String) ns - The namespace to match.
       *    (String) name - The stanza name to match.
       *    (String|Array) type - The stanza type (or types if an array) to match.
       *    (String) id - The stanza id attribute to match.
       *    (String) from - The stanza from attribute to match.
       *    (String) options - The handler options
       *
       *  Returns:
       *    A reference to the handler that can be used to remove it.
       */

    }, {
      key: "addHandler",
      value: function addHandler(handler, ns, name, type, id, from, options) {
        var hand = new Strophe.Handler(handler, ns, name, type, id, from, options);
        this.addHandlers.push(hand);
        return hand;
      }
      /** Function: deleteHandler
       *  Delete a stanza handler for a connection.
       *
       *  This function removes a stanza handler from the connection.  The
       *  handRef parameter is *not* the function passed to addHandler(),
       *  but is the reference returned from addHandler().
       *
       *  Parameters:
       *    (Strophe.Handler) handRef - The handler reference.
       */

    }, {
      key: "deleteHandler",
      value: function deleteHandler(handRef) {
        // this must be done in the Idle loop so that we don't change
        // the handlers during iteration
        this.removeHandlers.push(handRef); // If a handler is being deleted while it is being added,
        // prevent it from getting added

        var i = this.addHandlers.indexOf(handRef);

        if (i >= 0) {
          this.addHandlers.splice(i, 1);
        }
      }
      /** Function: registerSASLMechanisms
       *
       * Register the SASL mechanisms which will be supported by this instance of
       * Strophe.Connection (i.e. which this XMPP client will support).
       *
       *  Parameters:
       *    (Array) mechanisms - Array of objects with Strophe.SASLMechanism prototypes
       *
       */

    }, {
      key: "registerSASLMechanisms",
      value: function registerSASLMechanisms(mechanisms) {
        var _this6 = this;

        this.mechanisms = {};
        mechanisms = mechanisms || [Strophe.SASLAnonymous, Strophe.SASLExternal, Strophe.SASLOAuthBearer, Strophe.SASLXOAuth2, Strophe.SASLPlain, Strophe.SASLSHA1];
        mechanisms.forEach(function (m) {
          return _this6.registerSASLMechanism(m);
        });
      }
      /** Function: registerSASLMechanism
       *
       * Register a single SASL mechanism, to be supported by this client.
       *
       *  Parameters:
       *    (Object) mechanism - Object with a Strophe.SASLMechanism prototype
       *
       */

    }, {
      key: "registerSASLMechanism",
      value: function registerSASLMechanism(Mechanism) {
        var mechanism = new Mechanism();
        this.mechanisms[mechanism.mechname] = mechanism;
      }
      /** Function: disconnect
       *  Start the graceful disconnection process.
       *
       *  This function starts the disconnection process.  This process starts
       *  by sending unavailable presence and sending BOSH body of type
       *  terminate.  A timeout handler makes sure that disconnection happens
       *  even if the BOSH server does not respond.
       *  If the Connection object isn't connected, at least tries to abort all pending requests
       *  so the connection object won't generate successful requests (which were already opened).
       *
       *  The user supplied connection callback will be notified of the
       *  progress as this process happens.
       *
       *  Parameters:
       *    (String) reason - The reason the disconnect is occuring.
       */

    }, {
      key: "disconnect",
      value: function disconnect(reason) {
        this._changeConnectStatus(Strophe.Status.DISCONNECTING, reason);

        if (reason) {
          Strophe.warn("Disconnect was called because: " + reason);
        } else {
          Strophe.info("Disconnect was called");
        }

        if (this.connected) {
          var pres = false;
          this.disconnecting = true;

          if (this.authenticated) {
            pres = $pres({
              'xmlns': Strophe.NS.CLIENT,
              'type': 'unavailable'
            });
          } // setup timeout handler


          this._disconnectTimeout = this._addSysTimedHandler(3000, this._onDisconnectTimeout.bind(this));

          this._proto._disconnect(pres);
        } else {
          Strophe.warn("Disconnect was called before Strophe connected to the server");

          this._proto._abortAllRequests();

          this._doDisconnect();
        }
      }
      /** PrivateFunction: _changeConnectStatus
       *  _Private_ helper function that makes sure plugins and the user's
       *  callback are notified of connection status changes.
       *
       *  Parameters:
       *    (Integer) status - the new connection status, one of the values
       *      in Strophe.Status
       *    (String) condition - the error condition or null
       *    (XMLElement) elem - The triggering stanza.
       */

    }, {
      key: "_changeConnectStatus",
      value: function _changeConnectStatus(status, condition, elem) {
        // notify all plugins listening for status changes
        for (var k in Strophe._connectionPlugins) {
          if (Object.prototype.hasOwnProperty.call(Strophe._connectionPlugins, k)) {
            var plugin = this[k];

            if (plugin.statusChanged) {
              try {
                plugin.statusChanged(status, condition);
              } catch (err) {
                Strophe.error("".concat(k, " plugin caused an exception changing status: ").concat(err));
              }
            }
          }
        } // notify the user's callback


        if (this.connect_callback) {
          try {
            this.connect_callback(status, condition, elem);
          } catch (e) {
            Strophe._handleError(e);

            Strophe.error("User connection callback caused an exception: ".concat(e));
          }
        }
      }
      /** PrivateFunction: _doDisconnect
       *  _Private_ function to disconnect.
       *
       *  This is the last piece of the disconnection logic.  This resets the
       *  connection and alerts the user's connection callback.
       */

    }, {
      key: "_doDisconnect",
      value: function _doDisconnect(condition) {
        if (typeof this._idleTimeout === "number") {
          clearTimeout(this._idleTimeout);
        } // Cancel Disconnect Timeout


        if (this._disconnectTimeout !== null) {
          this.deleteTimedHandler(this._disconnectTimeout);
          this._disconnectTimeout = null;
        }

        Strophe.debug("_doDisconnect was called");

        this._proto._doDisconnect();

        this.authenticated = false;
        this.disconnecting = false;
        this.restored = false; // delete handlers

        this.handlers = [];
        this.timedHandlers = [];
        this.removeTimeds = [];
        this.removeHandlers = [];
        this.addTimeds = [];
        this.addHandlers = []; // tell the parent we disconnected

        this._changeConnectStatus(Strophe.Status.DISCONNECTED, condition);

        this.connected = false;
      }
      /** PrivateFunction: _dataRecv
       *  _Private_ handler to processes incoming data from the the connection.
       *
       *  Except for _connect_cb handling the initial connection request,
       *  this function handles the incoming data for all requests.  This
       *  function also fires stanza handlers that match each incoming
       *  stanza.
       *
       *  Parameters:
       *    (Strophe.Request) req - The request that has data ready.
       *    (string) req - The stanza a raw string (optiona).
       */

    }, {
      key: "_dataRecv",
      value: function _dataRecv(req, raw) {
        var _this7 = this;

        var elem = this._proto._reqToData(req);

        if (elem === null) {
          return;
        }

        if (this.xmlInput !== Strophe.Connection.prototype.xmlInput) {
          if (elem.nodeName === this._proto.strip && elem.childNodes.length) {
            this.xmlInput(elem.childNodes[0]);
          } else {
            this.xmlInput(elem);
          }
        }

        if (this.rawInput !== Strophe.Connection.prototype.rawInput) {
          if (raw) {
            this.rawInput(raw);
          } else {
            this.rawInput(Strophe.serialize(elem));
          }
        } // remove handlers scheduled for deletion


        while (this.removeHandlers.length > 0) {
          var hand = this.removeHandlers.pop();
          var i = this.handlers.indexOf(hand);

          if (i >= 0) {
            this.handlers.splice(i, 1);
          }
        } // add handlers scheduled for addition


        while (this.addHandlers.length > 0) {
          this.handlers.push(this.addHandlers.pop());
        } // handle graceful disconnect


        if (this.disconnecting && this._proto._emptyQueue()) {
          this._doDisconnect();

          return;
        }

        var type = elem.getAttribute("type");

        if (type !== null && type === "terminate") {
          // Don't process stanzas that come in after disconnect
          if (this.disconnecting) {
            return;
          } // an error occurred


          var cond = elem.getAttribute("condition");
          var conflict = elem.getElementsByTagName("conflict");

          if (cond !== null) {
            if (cond === "remote-stream-error" && conflict.length > 0) {
              cond = "conflict";
            }

            this._changeConnectStatus(Strophe.Status.CONNFAIL, cond);
          } else {
            this._changeConnectStatus(Strophe.Status.CONNFAIL, Strophe.ErrorCondition.UNKOWN_REASON);
          }

          this._doDisconnect(cond);

          return;
        } // send each incoming stanza through the handler chain


        Strophe.forEachChild(elem, null, function (child) {
          // process handlers
          var newList = _this7.handlers;
          _this7.handlers = [];

          for (var _i5 = 0; _i5 < newList.length; _i5++) {
            var _hand = newList[_i5]; // encapsulate 'handler.run' not to lose the whole handler list if
            // one of the handlers throws an exception

            try {
              if (_hand.isMatch(child) && (_this7.authenticated || !_hand.user)) {
                if (_hand.run(child)) {
                  _this7.handlers.push(_hand);
                }
              } else {
                _this7.handlers.push(_hand);
              }
            } catch (e) {
              // if the handler throws an exception, we consider it as false
              Strophe.warn('Removing Strophe handlers due to uncaught exception: ' + e.message);
            }
          }
        });
      }
      /** PrivateFunction: _connect_cb
       *  _Private_ handler for initial connection request.
       *
       *  This handler is used to process the initial connection request
       *  response from the BOSH server. It is used to set up authentication
       *  handlers and start the authentication process.
       *
       *  SASL authentication will be attempted if available, otherwise
       *  the code will fall back to legacy authentication.
       *
       *  Parameters:
       *    (Strophe.Request) req - The current request.
       *    (Function) _callback - low level (xmpp) connect callback function.
       *      Useful for plugins with their own xmpp connect callback (when they
       *      want to do something special).
       */

    }, {
      key: "_connect_cb",
      value: function _connect_cb(req, _callback, raw) {
        var _this8 = this;

        Strophe.debug("_connect_cb was called");
        this.connected = true;
        var bodyWrap;

        try {
          bodyWrap = this._proto._reqToData(req);
        } catch (e) {
          if (e.name !== Strophe.ErrorCondition.BAD_FORMAT) {
            throw e;
          }

          this._changeConnectStatus(Strophe.Status.CONNFAIL, Strophe.ErrorCondition.BAD_FORMAT);

          this._doDisconnect(Strophe.ErrorCondition.BAD_FORMAT);
        }

        if (!bodyWrap) {
          return;
        }

        if (this.xmlInput !== Strophe.Connection.prototype.xmlInput) {
          if (bodyWrap.nodeName === this._proto.strip && bodyWrap.childNodes.length) {
            this.xmlInput(bodyWrap.childNodes[0]);
          } else {
            this.xmlInput(bodyWrap);
          }
        }

        if (this.rawInput !== Strophe.Connection.prototype.rawInput) {
          if (raw) {
            this.rawInput(raw);
          } else {
            this.rawInput(Strophe.serialize(bodyWrap));
          }
        }

        var conncheck = this._proto._connect_cb(bodyWrap);

        if (conncheck === Strophe.Status.CONNFAIL) {
          return;
        } // Check for the stream:features tag


        var hasFeatures;

        if (bodyWrap.getElementsByTagNameNS) {
          hasFeatures = bodyWrap.getElementsByTagNameNS(Strophe.NS.STREAM, "features").length > 0;
        } else {
          hasFeatures = bodyWrap.getElementsByTagName("stream:features").length > 0 || bodyWrap.getElementsByTagName("features").length > 0;
        }

        if (!hasFeatures) {
          this._proto._no_auth_received(_callback);

          return;
        }

        var matched = Array.from(bodyWrap.getElementsByTagName("mechanism")).map(function (m) {
          return _this8.mechanisms[m.textContent];
        }).filter(function (m) {
          return m;
        });

        if (matched.length === 0) {
          if (bodyWrap.getElementsByTagName("auth").length === 0) {
            // There are no matching SASL mechanisms and also no legacy
            // auth available.
            this._proto._no_auth_received(_callback);

            return;
          }
        }

        if (this.do_authentication !== false) {
          this.authenticate(matched);
        }
      }
      /** Function: sortMechanismsByPriority
       *
       *  Sorts an array of objects with prototype SASLMechanism according to
       *  their priorities.
       *
       *  Parameters:
       *    (Array) mechanisms - Array of SASL mechanisms.
       *
       */

    }, {
      key: "sortMechanismsByPriority",
      value: function sortMechanismsByPriority(mechanisms) {
        // eslint-disable-line class-methods-use-this
        // Sorting mechanisms according to priority.
        for (var i = 0; i < mechanisms.length - 1; ++i) {
          var higher = i;

          for (var j = i + 1; j < mechanisms.length; ++j) {
            if (mechanisms[j].priority > mechanisms[higher].priority) {
              higher = j;
            }
          }

          if (higher !== i) {
            var swap = mechanisms[i];
            mechanisms[i] = mechanisms[higher];
            mechanisms[higher] = swap;
          }
        }

        return mechanisms;
      }
      /** Function: authenticate
       * Set up authentication
       *
       *  Continues the initial connection request by setting up authentication
       *  handlers and starting the authentication process.
       *
       *  SASL authentication will be attempted if available, otherwise
       *  the code will fall back to legacy authentication.
       *
       *  Parameters:
       *    (Array) matched - Array of SASL mechanisms supported.
       *
       */

    }, {
      key: "authenticate",
      value: function authenticate(matched) {
        if (!this._attemptSASLAuth(matched)) {
          this._attemptLegacyAuth();
        }
      }
      /** PrivateFunction: _attemptSASLAuth
       *
       *  Iterate through an array of SASL mechanisms and attempt authentication
       *  with the highest priority (enabled) mechanism.
       *
       *  Parameters:
       *    (Array) mechanisms - Array of SASL mechanisms.
       *
       *  Returns:
       *    (Boolean) mechanism_found - true or false, depending on whether a
       *          valid SASL mechanism was found with which authentication could be
       *          started.
       */

    }, {
      key: "_attemptSASLAuth",
      value: function _attemptSASLAuth(mechanisms) {
        mechanisms = this.sortMechanismsByPriority(mechanisms || []);
        var mechanism_found = false;

        for (var i = 0; i < mechanisms.length; ++i) {
          if (!mechanisms[i].test(this)) {
            continue;
          }

          this._sasl_success_handler = this._addSysHandler(this._sasl_success_cb.bind(this), null, "success", null, null);
          this._sasl_failure_handler = this._addSysHandler(this._sasl_failure_cb.bind(this), null, "failure", null, null);
          this._sasl_challenge_handler = this._addSysHandler(this._sasl_challenge_cb.bind(this), null, "challenge", null, null);
          this._sasl_mechanism = mechanisms[i];

          this._sasl_mechanism.onStart(this);

          var request_auth_exchange = $build("auth", {
            'xmlns': Strophe.NS.SASL,
            'mechanism': this._sasl_mechanism.mechname
          });

          if (this._sasl_mechanism.isClientFirst) {
            var response = this._sasl_mechanism.clientChallenge(this);

            request_auth_exchange.t(abab.btoa(response));
          }

          this.send(request_auth_exchange.tree());
          mechanism_found = true;
          break;
        }

        return mechanism_found;
      }
      /** PrivateFunction: _sasl_challenge_cb
       *  _Private_ handler for the SASL challenge
       *
       */

    }, {
      key: "_sasl_challenge_cb",
      value: function _sasl_challenge_cb(elem) {
        var challenge = abab.atob(Strophe.getText(elem));

        var response = this._sasl_mechanism.onChallenge(this, challenge);

        var stanza = $build('response', {
          'xmlns': Strophe.NS.SASL
        });

        if (response !== "") {
          stanza.t(abab.btoa(response));
        }

        this.send(stanza.tree());
        return true;
      }
      /** PrivateFunction: _attemptLegacyAuth
       *
       *  Attempt legacy (i.e. non-SASL) authentication.
       */

    }, {
      key: "_attemptLegacyAuth",
      value: function _attemptLegacyAuth() {
        if (Strophe.getNodeFromJid(this.jid) === null) {
          // we don't have a node, which is required for non-anonymous
          // client connections
          this._changeConnectStatus(Strophe.Status.CONNFAIL, Strophe.ErrorCondition.MISSING_JID_NODE);

          this.disconnect(Strophe.ErrorCondition.MISSING_JID_NODE);
        } else {
          // Fall back to legacy authentication
          this._changeConnectStatus(Strophe.Status.AUTHENTICATING, null);

          this._addSysHandler(this._onLegacyAuthIQResult.bind(this), null, null, null, "_auth_1");

          this.send($iq({
            'type': "get",
            'to': this.domain,
            'id': "_auth_1"
          }).c("query", {
            xmlns: Strophe.NS.AUTH
          }).c("username", {}).t(Strophe.getNodeFromJid(this.jid)).tree());
        }
      }
      /** PrivateFunction: _onLegacyAuthIQResult
       *  _Private_ handler for legacy authentication.
       *
       *  This handler is called in response to the initial <iq type='get'/>
       *  for legacy authentication.  It builds an authentication <iq/> and
       *  sends it, creating a handler (calling back to _auth2_cb()) to
       *  handle the result
       *
       *  Parameters:
       *    (XMLElement) elem - The stanza that triggered the callback.
       *
       *  Returns:
       *    false to remove the handler.
       */

    }, {
      key: "_onLegacyAuthIQResult",
      value: function _onLegacyAuthIQResult(elem) {
        // eslint-disable-line no-unused-vars
        // build plaintext auth iq
        var iq = $iq({
          type: "set",
          id: "_auth_2"
        }).c('query', {
          xmlns: Strophe.NS.AUTH
        }).c('username', {}).t(Strophe.getNodeFromJid(this.jid)).up().c('password').t(this.pass);

        if (!Strophe.getResourceFromJid(this.jid)) {
          // since the user has not supplied a resource, we pick
          // a default one here.  unlike other auth methods, the server
          // cannot do this for us.
          this.jid = Strophe.getBareJidFromJid(this.jid) + '/strophe';
        }

        iq.up().c('resource', {}).t(Strophe.getResourceFromJid(this.jid));

        this._addSysHandler(this._auth2_cb.bind(this), null, null, null, "_auth_2");

        this.send(iq.tree());
        return false;
      }
      /** PrivateFunction: _sasl_success_cb
       *  _Private_ handler for succesful SASL authentication.
       *
       *  Parameters:
       *    (XMLElement) elem - The matching stanza.
       *
       *  Returns:
       *    false to remove the handler.
       */

    }, {
      key: "_sasl_success_cb",
      value: function _sasl_success_cb(elem) {
        var _this9 = this;

        if (this._sasl_data["server-signature"]) {
          var serverSignature;
          var success = abab.atob(Strophe.getText(elem));
          var attribMatch = /([a-z]+)=([^,]+)(,|$)/;
          var matches = success.match(attribMatch);

          if (matches[1] === "v") {
            serverSignature = matches[2];
          }

          if (serverSignature !== this._sasl_data["server-signature"]) {
            // remove old handlers
            this.deleteHandler(this._sasl_failure_handler);
            this._sasl_failure_handler = null;

            if (this._sasl_challenge_handler) {
              this.deleteHandler(this._sasl_challenge_handler);
              this._sasl_challenge_handler = null;
            }

            this._sasl_data = {};
            return this._sasl_failure_cb(null);
          }
        }

        Strophe.info("SASL authentication succeeded.");

        if (this._sasl_mechanism) {
          this._sasl_mechanism.onSuccess();
        } // remove old handlers


        this.deleteHandler(this._sasl_failure_handler);
        this._sasl_failure_handler = null;

        if (this._sasl_challenge_handler) {
          this.deleteHandler(this._sasl_challenge_handler);
          this._sasl_challenge_handler = null;
        }

        var streamfeature_handlers = [];

        var wrapper = function wrapper(handlers, elem) {
          while (handlers.length) {
            _this9.deleteHandler(handlers.pop());
          }

          _this9._onStreamFeaturesAfterSASL(elem);

          return false;
        };

        streamfeature_handlers.push(this._addSysHandler(function (elem) {
          return wrapper(streamfeature_handlers, elem);
        }, null, "stream:features", null, null));
        streamfeature_handlers.push(this._addSysHandler(function (elem) {
          return wrapper(streamfeature_handlers, elem);
        }, Strophe.NS.STREAM, "features", null, null)); // we must send an xmpp:restart now

        this._sendRestart();

        return false;
      }
      /** PrivateFunction: _onStreamFeaturesAfterSASL
       *  Parameters:
       *    (XMLElement) elem - The matching stanza.
       *
       *  Returns:
       *    false to remove the handler.
       */

    }, {
      key: "_onStreamFeaturesAfterSASL",
      value: function _onStreamFeaturesAfterSASL(elem) {
        // save stream:features for future usage
        this.features = elem;

        for (var i = 0; i < elem.childNodes.length; i++) {
          var child = elem.childNodes[i];

          if (child.nodeName === 'bind') {
            this.do_bind = true;
          }

          if (child.nodeName === 'session') {
            this.do_session = true;
          }
        }

        if (!this.do_bind) {
          this._changeConnectStatus(Strophe.Status.AUTHFAIL, null);

          return false;
        } else if (!this.options.explicitResourceBinding) {
          this.bind();
        } else {
          this._changeConnectStatus(Strophe.Status.BINDREQUIRED, null);
        }

        return false;
      }
      /** Function: bind
       *
       *  Sends an IQ to the XMPP server to bind a JID resource for this session.
       *
       *  https://tools.ietf.org/html/rfc6120#section-7.5
       *
       *  If `explicitResourceBinding` was set to a truthy value in the options
       *  passed to the Strophe.Connection constructor, then this function needs
       *  to be called explicitly by the client author.
       *
       *  Otherwise it'll be called automatically as soon as the XMPP server
       *  advertises the "urn:ietf:params:xml:ns:xmpp-bind" stream feature.
       */

    }, {
      key: "bind",
      value: function bind() {
        if (!this.do_bind) {
          Strophe.log(Strophe.LogLevel.INFO, "Strophe.Connection.prototype.bind called but \"do_bind\" is false");
          return;
        }

        this._addSysHandler(this._onResourceBindResultIQ.bind(this), null, null, null, "_bind_auth_2");

        var resource = Strophe.getResourceFromJid(this.jid);

        if (resource) {
          this.send($iq({
            type: "set",
            id: "_bind_auth_2"
          }).c('bind', {
            xmlns: Strophe.NS.BIND
          }).c('resource', {}).t(resource).tree());
        } else {
          this.send($iq({
            type: "set",
            id: "_bind_auth_2"
          }).c('bind', {
            xmlns: Strophe.NS.BIND
          }).tree());
        }
      }
      /** PrivateFunction: _onResourceBindIQ
       *  _Private_ handler for binding result and session start.
       *
       *  Parameters:
       *    (XMLElement) elem - The matching stanza.
       *
       *  Returns:
       *    false to remove the handler.
       */

    }, {
      key: "_onResourceBindResultIQ",
      value: function _onResourceBindResultIQ(elem) {
        if (elem.getAttribute("type") === "error") {
          Strophe.warn("Resource binding failed.");
          var conflict = elem.getElementsByTagName("conflict");
          var condition;

          if (conflict.length > 0) {
            condition = Strophe.ErrorCondition.CONFLICT;
          }

          this._changeConnectStatus(Strophe.Status.AUTHFAIL, condition, elem);

          return false;
        } // TODO - need to grab errors


        var bind = elem.getElementsByTagName("bind");

        if (bind.length > 0) {
          var jidNode = bind[0].getElementsByTagName("jid");

          if (jidNode.length > 0) {
            this.authenticated = true;
            this.jid = Strophe.getText(jidNode[0]);

            if (this.do_session) {
              this._establishSession();
            } else {
              this._changeConnectStatus(Strophe.Status.CONNECTED, null);
            }
          }
        } else {
          Strophe.warn("Resource binding failed.");

          this._changeConnectStatus(Strophe.Status.AUTHFAIL, null, elem);

          return false;
        }
      }
      /** PrivateFunction: _establishSession
       *  Send IQ request to establish a session with the XMPP server.
       *
       *  See https://xmpp.org/rfcs/rfc3921.html#session
       *
       *  Note: The protocol for session establishment has been determined as
       *  unnecessary and removed in RFC-6121.
       */

    }, {
      key: "_establishSession",
      value: function _establishSession() {
        if (!this.do_session) {
          throw new Error("Strophe.Connection.prototype._establishSession " + "called but apparently ".concat(Strophe.NS.SESSION, " wasn't advertised by the server"));
        }

        this._addSysHandler(this._onSessionResultIQ.bind(this), null, null, null, "_session_auth_2");

        this.send($iq({
          type: "set",
          id: "_session_auth_2"
        }).c('session', {
          xmlns: Strophe.NS.SESSION
        }).tree());
      }
      /** PrivateFunction: _onSessionResultIQ
       *  _Private_ handler for the server's IQ response to a client's session
       *  request.
       *
       *  This sets Connection.authenticated to true on success, which
       *  starts the processing of user handlers.
       *
       *  See https://xmpp.org/rfcs/rfc3921.html#session
       *
       *  Note: The protocol for session establishment has been determined as
       *  unnecessary and removed in RFC-6121.
       *
       *  Parameters:
       *    (XMLElement) elem - The matching stanza.
       *
       *  Returns:
       *    false to remove the handler.
       */

    }, {
      key: "_onSessionResultIQ",
      value: function _onSessionResultIQ(elem) {
        if (elem.getAttribute("type") === "result") {
          this.authenticated = true;

          this._changeConnectStatus(Strophe.Status.CONNECTED, null);
        } else if (elem.getAttribute("type") === "error") {
          this.authenticated = false;
          Strophe.warn("Session creation failed.");

          this._changeConnectStatus(Strophe.Status.AUTHFAIL, null, elem);

          return false;
        }

        return false;
      }
      /** PrivateFunction: _sasl_failure_cb
       *  _Private_ handler for SASL authentication failure.
       *
       *  Parameters:
       *    (XMLElement) elem - The matching stanza.
       *
       *  Returns:
       *    false to remove the handler.
       */

    }, {
      key: "_sasl_failure_cb",
      value: function _sasl_failure_cb(elem) {
        // delete unneeded handlers
        if (this._sasl_success_handler) {
          this.deleteHandler(this._sasl_success_handler);
          this._sasl_success_handler = null;
        }

        if (this._sasl_challenge_handler) {
          this.deleteHandler(this._sasl_challenge_handler);
          this._sasl_challenge_handler = null;
        }

        if (this._sasl_mechanism) this._sasl_mechanism.onFailure();

        this._changeConnectStatus(Strophe.Status.AUTHFAIL, null, elem);

        return false;
      }
      /** PrivateFunction: _auth2_cb
       *  _Private_ handler to finish legacy authentication.
       *
       *  This handler is called when the result from the jabber:iq:auth
       *  <iq/> stanza is returned.
       *
       *  Parameters:
       *    (XMLElement) elem - The stanza that triggered the callback.
       *
       *  Returns:
       *    false to remove the handler.
       */

    }, {
      key: "_auth2_cb",
      value: function _auth2_cb(elem) {
        if (elem.getAttribute("type") === "result") {
          this.authenticated = true;

          this._changeConnectStatus(Strophe.Status.CONNECTED, null);
        } else if (elem.getAttribute("type") === "error") {
          this._changeConnectStatus(Strophe.Status.AUTHFAIL, null, elem);

          this.disconnect('authentication failed');
        }

        return false;
      }
      /** PrivateFunction: _addSysTimedHandler
       *  _Private_ function to add a system level timed handler.
       *
       *  This function is used to add a Strophe.TimedHandler for the
       *  library code.  System timed handlers are allowed to run before
       *  authentication is complete.
       *
       *  Parameters:
       *    (Integer) period - The period of the handler.
       *    (Function) handler - The callback function.
       */

    }, {
      key: "_addSysTimedHandler",
      value: function _addSysTimedHandler(period, handler) {
        var thand = new Strophe.TimedHandler(period, handler);
        thand.user = false;
        this.addTimeds.push(thand);
        return thand;
      }
      /** PrivateFunction: _addSysHandler
       *  _Private_ function to add a system level stanza handler.
       *
       *  This function is used to add a Strophe.Handler for the
       *  library code.  System stanza handlers are allowed to run before
       *  authentication is complete.
       *
       *  Parameters:
       *    (Function) handler - The callback function.
       *    (String) ns - The namespace to match.
       *    (String) name - The stanza name to match.
       *    (String) type - The stanza type attribute to match.
       *    (String) id - The stanza id attribute to match.
       */

    }, {
      key: "_addSysHandler",
      value: function _addSysHandler(handler, ns, name, type, id) {
        var hand = new Strophe.Handler(handler, ns, name, type, id);
        hand.user = false;
        this.addHandlers.push(hand);
        return hand;
      }
      /** PrivateFunction: _onDisconnectTimeout
       *  _Private_ timeout handler for handling non-graceful disconnection.
       *
       *  If the graceful disconnect process does not complete within the
       *  time allotted, this handler finishes the disconnect anyway.
       *
       *  Returns:
       *    false to remove the handler.
       */

    }, {
      key: "_onDisconnectTimeout",
      value: function _onDisconnectTimeout() {
        Strophe.debug("_onDisconnectTimeout was called");

        this._changeConnectStatus(Strophe.Status.CONNTIMEOUT, null);

        this._proto._onDisconnectTimeout(); // actually disconnect


        this._doDisconnect();

        return false;
      }
      /** PrivateFunction: _onIdle
       *  _Private_ handler to process events during idle cycle.
       *
       *  This handler is called every 100ms to fire timed handlers that
       *  are ready and keep poll requests going.
       */

    }, {
      key: "_onIdle",
      value: function _onIdle() {
        var _this10 = this;

        // add timed handlers scheduled for addition
        // NOTE: we add before remove in the case a timed handler is
        // added and then deleted before the next _onIdle() call.
        while (this.addTimeds.length > 0) {
          this.timedHandlers.push(this.addTimeds.pop());
        } // remove timed handlers that have been scheduled for deletion


        while (this.removeTimeds.length > 0) {
          var thand = this.removeTimeds.pop();
          var i = this.timedHandlers.indexOf(thand);

          if (i >= 0) {
            this.timedHandlers.splice(i, 1);
          }
        } // call ready timed handlers


        var now = new Date().getTime();
        var newList = [];

        for (var _i6 = 0; _i6 < this.timedHandlers.length; _i6++) {
          var _thand = this.timedHandlers[_i6];

          if (this.authenticated || !_thand.user) {
            var since = _thand.lastCalled + _thand.period;

            if (since - now <= 0) {
              if (_thand.run()) {
                newList.push(_thand);
              }
            } else {
              newList.push(_thand);
            }
          }
        }

        this.timedHandlers = newList;
        clearTimeout(this._idleTimeout);

        this._proto._onIdle(); // reactivate the timer only if connected


        if (this.connected) {
          this._idleTimeout = setTimeout(function () {
            return _this10._onIdle();
          }, 100);
        }
      }
    }]);

    return Connection;
  }();

  Strophe.SASLMechanism = SASLMechanism;
  /** Constants: SASL mechanisms
   *  Available authentication mechanisms
   *
   *  Strophe.SASLAnonymous   - SASL ANONYMOUS authentication.
   *  Strophe.SASLPlain       - SASL PLAIN authentication.
   *  Strophe.SASLSHA1        - SASL SCRAM-SHA-1 authentication
   *  Strophe.SASLOAuthBearer - SASL OAuth Bearer authentication
   *  Strophe.SASLExternal    - SASL EXTERNAL authentication
   *  Strophe.SASLXOAuth2     - SASL X-OAuth2 authentication
   */

  Strophe.SASLAnonymous = SASLAnonymous;
  Strophe.SASLPlain = SASLPlain;
  Strophe.SASLSHA1 = SASLSHA1;
  Strophe.SASLOAuthBearer = SASLOAuthBearer;
  Strophe.SASLExternal = SASLExternal;
  Strophe.SASLXOAuth2 = SASLXOAuth2;
  var core = {
    'Strophe': Strophe,
    '$build': $build,
    '$iq': $iq,
    '$msg': $msg,
    '$pres': $pres,
    'SHA1': SHA1,
    'MD5': MD5,
    'b64_hmac_sha1': SHA1.b64_hmac_sha1,
    'b64_sha1': SHA1.b64_sha1,
    'str_hmac_sha1': SHA1.str_hmac_sha1,
    'str_sha1': SHA1.str_sha1
  };

  /** PrivateClass: Strophe.Request
   *  _Private_ helper class that provides a cross implementation abstraction
   *  for a BOSH related XMLHttpRequest.
   *
   *  The Strophe.Request class is used internally to encapsulate BOSH request
   *  information.  It is not meant to be used from user's code.
   */

  Strophe.Request = /*#__PURE__*/function () {
    /** PrivateConstructor: Strophe.Request
     *  Create and initialize a new Strophe.Request object.
     *
     *  Parameters:
     *    (XMLElement) elem - The XML data to be sent in the request.
     *    (Function) func - The function that will be called when the
     *      XMLHttpRequest readyState changes.
     *    (Integer) rid - The BOSH rid attribute associated with this request.
     *    (Integer) sends - The number of times this same request has been sent.
     */
    function Request(elem, func, rid, sends) {
      _classCallCheck(this, Request);

      this.id = ++Strophe._requestId;
      this.xmlData = elem;
      this.data = Strophe.serialize(elem); // save original function in case we need to make a new request
      // from this one.

      this.origFunc = func;
      this.func = func;
      this.rid = rid;
      this.date = NaN;
      this.sends = sends || 0;
      this.abort = false;
      this.dead = null;

      this.age = function () {
        if (!this.date) {
          return 0;
        }

        var now = new Date();
        return (now - this.date) / 1000;
      };

      this.timeDead = function () {
        if (!this.dead) {
          return 0;
        }

        var now = new Date();
        return (now - this.dead) / 1000;
      };

      this.xhr = this._newXHR();
    }
    /** PrivateFunction: getResponse
     *  Get a response from the underlying XMLHttpRequest.
     *
     *  This function attempts to get a response from the request and checks
     *  for errors.
     *
     *  Throws:
     *    "parsererror" - A parser error occured.
     *    "bad-format" - The entity has sent XML that cannot be processed.
     *
     *  Returns:
     *    The DOM element tree of the response.
     */

    _createClass(Request, [{
      key: "getResponse",
      value: function getResponse() {
        var node = null;

        if (this.xhr.responseXML && this.xhr.responseXML.documentElement) {
          node = this.xhr.responseXML.documentElement;

          if (node.tagName === "parsererror") {
            Strophe.error("invalid response received");
            Strophe.error("responseText: " + this.xhr.responseText);
            Strophe.error("responseXML: " + Strophe.serialize(this.xhr.responseXML));
            throw new Error("parsererror");
          }
        } else if (this.xhr.responseText) {
          // In React Native, we may get responseText but no responseXML.  We can try to parse it manually.
          Strophe.debug("Got responseText but no responseXML; attempting to parse it with DOMParser...");
          node = new DOMParser().parseFromString(this.xhr.responseText, 'application/xml').documentElement;

          if (!node) {
            throw new Error('Parsing produced null node');
          } else if (node.querySelector('parsererror')) {
            Strophe.error("invalid response received: " + node.querySelector('parsererror').textContent);
            Strophe.error("responseText: " + this.xhr.responseText);
            var error = new Error();
            error.name = Strophe.ErrorCondition.BAD_FORMAT;
            throw error;
          }
        }

        return node;
      }
      /** PrivateFunction: _newXHR
       *  _Private_ helper function to create XMLHttpRequests.
       *
       *  This function creates XMLHttpRequests across all implementations.
       *
       *  Returns:
       *    A new XMLHttpRequest.
       */

    }, {
      key: "_newXHR",
      value: function _newXHR() {
        var xhr = null;

        if (window.XMLHttpRequest) {
          xhr = new XMLHttpRequest();

          if (xhr.overrideMimeType) {
            xhr.overrideMimeType("text/xml; charset=utf-8");
          }
        } else if (window.ActiveXObject) {
          xhr = new ActiveXObject("Microsoft.XMLHTTP");
        } // use Function.bind() to prepend ourselves as an argument


        xhr.onreadystatechange = this.func.bind(null, this);
        return xhr;
      }
    }]);

    return Request;
  }();
  /** Class: Strophe.Bosh
   *  _Private_ helper class that handles BOSH Connections
   *
   *  The Strophe.Bosh class is used internally by Strophe.Connection
   *  to encapsulate BOSH sessions. It is not meant to be used from user's code.
   */

  /** File: bosh.js
   *  A JavaScript library to enable BOSH in Strophejs.
   *
   *  this library uses Bidirectional-streams Over Synchronous HTTP (BOSH)
   *  to emulate a persistent, stateful, two-way connection to an XMPP server.
   *  More information on BOSH can be found in XEP 124.
   */

  /** PrivateConstructor: Strophe.Bosh
   *  Create and initialize a Strophe.Bosh object.
   *
   *  Parameters:
   *    (Strophe.Connection) connection - The Strophe.Connection that will use BOSH.
   *
   *  Returns:
   *    A new Strophe.Bosh object.
   */

  Strophe.Bosh = /*#__PURE__*/function () {
    function Bosh(connection) {
      _classCallCheck(this, Bosh);

      this._conn = connection;
      /* request id for body tags */

      this.rid = Math.floor(Math.random() * 4294967295);
      /* The current session ID. */

      this.sid = null; // default BOSH values

      this.hold = 1;
      this.wait = 60;
      this.window = 5;
      this.errors = 0;
      this.inactivity = null;
      this.lastResponseHeaders = null;
      this._requests = [];
    }
    /** PrivateFunction: _buildBody
     *  _Private_ helper function to generate the <body/> wrapper for BOSH.
     *
     *  Returns:
     *    A Strophe.Builder with a <body/> element.
     */

    _createClass(Bosh, [{
      key: "_buildBody",
      value: function _buildBody() {
        var bodyWrap = $build('body', {
          'rid': this.rid++,
          'xmlns': Strophe.NS.HTTPBIND
        });

        if (this.sid !== null) {
          bodyWrap.attrs({
            'sid': this.sid
          });
        }

        if (this._conn.options.keepalive && this._conn._sessionCachingSupported()) {
          this._cacheSession();
        }

        return bodyWrap;
      }
      /** PrivateFunction: _reset
       *  Reset the connection.
       *
       *  This function is called by the reset function of the Strophe Connection
       */

    }, {
      key: "_reset",
      value: function _reset() {
        this.rid = Math.floor(Math.random() * 4294967295);
        this.sid = null;
        this.errors = 0;

        if (this._conn._sessionCachingSupported()) {
          window.sessionStorage.removeItem('strophe-bosh-session');
        }

        this._conn.nextValidRid(this.rid);
      }
      /** PrivateFunction: _connect
       *  _Private_ function that initializes the BOSH connection.
       *
       *  Creates and sends the Request that initializes the BOSH connection.
       */

    }, {
      key: "_connect",
      value: function _connect(wait, hold, route) {
        this.wait = wait || this.wait;
        this.hold = hold || this.hold;
        this.errors = 0;

        var body = this._buildBody().attrs({
          "to": this._conn.domain,
          "xml:lang": "en",
          "wait": this.wait,
          "hold": this.hold,
          "content": "text/xml; charset=utf-8",
          "ver": "1.6",
          "xmpp:version": "1.0",
          "xmlns:xmpp": Strophe.NS.BOSH
        });

        if (route) {
          body.attrs({
            'route': route
          });
        }

        var _connect_cb = this._conn._connect_cb;

        this._requests.push(new Strophe.Request(body.tree(), this._onRequestStateChange.bind(this, _connect_cb.bind(this._conn)), body.tree().getAttribute("rid")));

        this._throttledRequestHandler();
      }
      /** PrivateFunction: _attach
       *  Attach to an already created and authenticated BOSH session.
       *
       *  This function is provided to allow Strophe to attach to BOSH
       *  sessions which have been created externally, perhaps by a Web
       *  application.  This is often used to support auto-login type features
       *  without putting user credentials into the page.
       *
       *  Parameters:
       *    (String) jid - The full JID that is bound by the session.
       *    (String) sid - The SID of the BOSH session.
       *    (String) rid - The current RID of the BOSH session.  This RID
       *      will be used by the next request.
       *    (Function) callback The connect callback function.
       *    (Integer) wait - The optional HTTPBIND wait value.  This is the
       *      time the server will wait before returning an empty result for
       *      a request.  The default setting of 60 seconds is recommended.
       *      Other settings will require tweaks to the Strophe.TIMEOUT value.
       *    (Integer) hold - The optional HTTPBIND hold value.  This is the
       *      number of connections the server will hold at one time.  This
       *      should almost always be set to 1 (the default).
       *    (Integer) wind - The optional HTTBIND window value.  This is the
       *      allowed range of request ids that are valid.  The default is 5.
       */

    }, {
      key: "_attach",
      value: function _attach(jid, sid, rid, callback, wait, hold, wind) {
        this._conn.jid = jid;
        this.sid = sid;
        this.rid = rid;
        this._conn.connect_callback = callback;
        this._conn.domain = Strophe.getDomainFromJid(this._conn.jid);
        this._conn.authenticated = true;
        this._conn.connected = true;
        this.wait = wait || this.wait;
        this.hold = hold || this.hold;
        this.window = wind || this.window;

        this._conn._changeConnectStatus(Strophe.Status.ATTACHED, null);
      }
      /** PrivateFunction: _restore
       *  Attempt to restore a cached BOSH session
       *
       *  Parameters:
       *    (String) jid - The full JID that is bound by the session.
       *      This parameter is optional but recommended, specifically in cases
       *      where prebinded BOSH sessions are used where it's important to know
       *      that the right session is being restored.
       *    (Function) callback The connect callback function.
       *    (Integer) wait - The optional HTTPBIND wait value.  This is the
       *      time the server will wait before returning an empty result for
       *      a request.  The default setting of 60 seconds is recommended.
       *      Other settings will require tweaks to the Strophe.TIMEOUT value.
       *    (Integer) hold - The optional HTTPBIND hold value.  This is the
       *      number of connections the server will hold at one time.  This
       *      should almost always be set to 1 (the default).
       *    (Integer) wind - The optional HTTBIND window value.  This is the
       *      allowed range of request ids that are valid.  The default is 5.
       */

    }, {
      key: "_restore",
      value: function _restore(jid, callback, wait, hold, wind) {
        var session = JSON.parse(window.sessionStorage.getItem('strophe-bosh-session'));

        if (typeof session !== "undefined" && session !== null && session.rid && session.sid && session.jid && (typeof jid === "undefined" || jid === null || Strophe.getBareJidFromJid(session.jid) === Strophe.getBareJidFromJid(jid) || // If authcid is null, then it's an anonymous login, so
        // we compare only the domains:
        Strophe.getNodeFromJid(jid) === null && Strophe.getDomainFromJid(session.jid) === jid)) {
          this._conn.restored = true;

          this._attach(session.jid, session.sid, session.rid, callback, wait, hold, wind);
        } else {
          var error = new Error("_restore: no restoreable session.");
          error.name = "StropheSessionError";
          throw error;
        }
      }
      /** PrivateFunction: _cacheSession
       *  _Private_ handler for the beforeunload event.
       *
       *  This handler is used to process the Bosh-part of the initial request.
       *  Parameters:
       *    (Strophe.Request) bodyWrap - The received stanza.
       */

    }, {
      key: "_cacheSession",
      value: function _cacheSession() {
        if (this._conn.authenticated) {
          if (this._conn.jid && this.rid && this.sid) {
            window.sessionStorage.setItem('strophe-bosh-session', JSON.stringify({
              'jid': this._conn.jid,
              'rid': this.rid,
              'sid': this.sid
            }));
          }
        } else {
          window.sessionStorage.removeItem('strophe-bosh-session');
        }
      }
      /** PrivateFunction: _connect_cb
       *  _Private_ handler for initial connection request.
       *
       *  This handler is used to process the Bosh-part of the initial request.
       *  Parameters:
       *    (Strophe.Request) bodyWrap - The received stanza.
       */

    }, {
      key: "_connect_cb",
      value: function _connect_cb(bodyWrap) {
        var typ = bodyWrap.getAttribute("type");

        if (typ !== null && typ === "terminate") {
          // an error occurred
          var cond = bodyWrap.getAttribute("condition");
          Strophe.error("BOSH-Connection failed: " + cond);
          var conflict = bodyWrap.getElementsByTagName("conflict");

          if (cond !== null) {
            if (cond === "remote-stream-error" && conflict.length > 0) {
              cond = "conflict";
            }

            this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, cond);
          } else {
            this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "unknown");
          }

          this._conn._doDisconnect(cond);

          return Strophe.Status.CONNFAIL;
        } // check to make sure we don't overwrite these if _connect_cb is
        // called multiple times in the case of missing stream:features


        if (!this.sid) {
          this.sid = bodyWrap.getAttribute("sid");
        }

        var wind = bodyWrap.getAttribute('requests');

        if (wind) {
          this.window = parseInt(wind, 10);
        }

        var hold = bodyWrap.getAttribute('hold');

        if (hold) {
          this.hold = parseInt(hold, 10);
        }

        var wait = bodyWrap.getAttribute('wait');

        if (wait) {
          this.wait = parseInt(wait, 10);
        }

        var inactivity = bodyWrap.getAttribute('inactivity');

        if (inactivity) {
          this.inactivity = parseInt(inactivity, 10);
        }
      }
      /** PrivateFunction: _disconnect
       *  _Private_ part of Connection.disconnect for Bosh
       *
       *  Parameters:
       *    (Request) pres - This stanza will be sent before disconnecting.
       */

    }, {
      key: "_disconnect",
      value: function _disconnect(pres) {
        this._sendTerminate(pres);
      }
      /** PrivateFunction: _doDisconnect
       *  _Private_ function to disconnect.
       *
       *  Resets the SID and RID.
       */

    }, {
      key: "_doDisconnect",
      value: function _doDisconnect() {
        this.sid = null;
        this.rid = Math.floor(Math.random() * 4294967295);

        if (this._conn._sessionCachingSupported()) {
          window.sessionStorage.removeItem('strophe-bosh-session');
        }

        this._conn.nextValidRid(this.rid);
      }
      /** PrivateFunction: _emptyQueue
       * _Private_ function to check if the Request queue is empty.
       *
       *  Returns:
       *    True, if there are no Requests queued, False otherwise.
       */

    }, {
      key: "_emptyQueue",
      value: function _emptyQueue() {
        return this._requests.length === 0;
      }
      /** PrivateFunction: _callProtocolErrorHandlers
       *  _Private_ function to call error handlers registered for HTTP errors.
       *
       *  Parameters:
       *    (Strophe.Request) req - The request that is changing readyState.
       */

    }, {
      key: "_callProtocolErrorHandlers",
      value: function _callProtocolErrorHandlers(req) {
        var reqStatus = Bosh._getRequestStatus(req);

        var err_callback = this._conn.protocolErrorHandlers.HTTP[reqStatus];

        if (err_callback) {
          err_callback.call(this, reqStatus);
        }
      }
      /** PrivateFunction: _hitError
       *  _Private_ function to handle the error count.
       *
       *  Requests are resent automatically until their error count reaches
       *  5.  Each time an error is encountered, this function is called to
       *  increment the count and disconnect if the count is too high.
       *
       *  Parameters:
       *    (Integer) reqStatus - The request status.
       */

    }, {
      key: "_hitError",
      value: function _hitError(reqStatus) {
        this.errors++;
        Strophe.warn("request errored, status: " + reqStatus + ", number of errors: " + this.errors);

        if (this.errors > 4) {
          this._conn._onDisconnectTimeout();
        }
      }
      /** PrivateFunction: _no_auth_received
       *
       * Called on stream start/restart when no stream:features
       * has been received and sends a blank poll request.
       */

    }, {
      key: "_no_auth_received",
      value: function _no_auth_received(callback) {
        Strophe.warn("Server did not yet offer a supported authentication " + "mechanism. Sending a blank poll request.");

        if (callback) {
          callback = callback.bind(this._conn);
        } else {
          callback = this._conn._connect_cb.bind(this._conn);
        }

        var body = this._buildBody();

        this._requests.push(new Strophe.Request(body.tree(), this._onRequestStateChange.bind(this, callback), body.tree().getAttribute("rid")));

        this._throttledRequestHandler();
      }
      /** PrivateFunction: _onDisconnectTimeout
       *  _Private_ timeout handler for handling non-graceful disconnection.
       *
       *  Cancels all remaining Requests and clears the queue.
       */

    }, {
      key: "_onDisconnectTimeout",
      value: function _onDisconnectTimeout() {
        this._abortAllRequests();
      }
      /** PrivateFunction: _abortAllRequests
       *  _Private_ helper function that makes sure all pending requests are aborted.
       */

    }, {
      key: "_abortAllRequests",
      value: function _abortAllRequests() {
        while (this._requests.length > 0) {
          var req = this._requests.pop();

          req.abort = true;
          req.xhr.abort();

          req.xhr.onreadystatechange = function () {};
        }
      }
      /** PrivateFunction: _onIdle
       *  _Private_ handler called by Strophe.Connection._onIdle
       *
       *  Sends all queued Requests or polls with empty Request if there are none.
       */

    }, {
      key: "_onIdle",
      value: function _onIdle() {
        var data = this._conn._data; // if no requests are in progress, poll

        if (this._conn.authenticated && this._requests.length === 0 && data.length === 0 && !this._conn.disconnecting) {
          Strophe.debug("no requests during idle cycle, sending blank request");
          data.push(null);
        }

        if (this._conn.paused) {
          return;
        }

        if (this._requests.length < 2 && data.length > 0) {
          var body = this._buildBody();

          for (var i = 0; i < data.length; i++) {
            if (data[i] !== null) {
              if (data[i] === "restart") {
                body.attrs({
                  "to": this._conn.domain,
                  "xml:lang": "en",
                  "xmpp:restart": "true",
                  "xmlns:xmpp": Strophe.NS.BOSH
                });
              } else {
                body.cnode(data[i]).up();
              }
            }
          }

          delete this._conn._data;
          this._conn._data = [];

          this._requests.push(new Strophe.Request(body.tree(), this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)), body.tree().getAttribute("rid")));

          this._throttledRequestHandler();
        }

        if (this._requests.length > 0) {
          var time_elapsed = this._requests[0].age();

          if (this._requests[0].dead !== null) {
            if (this._requests[0].timeDead() > Math.floor(Strophe.SECONDARY_TIMEOUT * this.wait)) {
              this._throttledRequestHandler();
            }
          }

          if (time_elapsed > Math.floor(Strophe.TIMEOUT * this.wait)) {
            Strophe.warn("Request " + this._requests[0].id + " timed out, over " + Math.floor(Strophe.TIMEOUT * this.wait) + " seconds since last activity");

            this._throttledRequestHandler();
          }
        }
      }
      /** PrivateFunction: _getRequestStatus
       *
       *  Returns the HTTP status code from a Strophe.Request
       *
       *  Parameters:
       *    (Strophe.Request) req - The Strophe.Request instance.
       *    (Integer) def - The default value that should be returned if no
       *          status value was found.
       */

    }, {
      key: "_onRequestStateChange",

      /** PrivateFunction: _onRequestStateChange
       *  _Private_ handler for Strophe.Request state changes.
       *
       *  This function is called when the XMLHttpRequest readyState changes.
       *  It contains a lot of error handling logic for the many ways that
       *  requests can fail, and calls the request callback when requests
       *  succeed.
       *
       *  Parameters:
       *    (Function) func - The handler for the request.
       *    (Strophe.Request) req - The request that is changing readyState.
       */
      value: function _onRequestStateChange(func, req) {
        Strophe.debug("request id " + req.id + "." + req.sends + " state changed to " + req.xhr.readyState);

        if (req.abort) {
          req.abort = false;
          return;
        }

        if (req.xhr.readyState !== 4) {
          // The request is not yet complete
          return;
        }

        var reqStatus = Bosh._getRequestStatus(req);

        this.lastResponseHeaders = req.xhr.getAllResponseHeaders();

        if (this._conn.disconnecting && reqStatus >= 400) {
          this._hitError(reqStatus);

          this._callProtocolErrorHandlers(req);

          return;
        }

        var valid_request = reqStatus > 0 && reqStatus < 500;
        var too_many_retries = req.sends > this._conn.maxRetries;

        if (valid_request || too_many_retries) {
          // remove from internal queue
          this._removeRequest(req);

          Strophe.debug("request id " + req.id + " should now be removed");
        }

        if (reqStatus === 200) {
          // request succeeded
          var reqIs0 = this._requests[0] === req;
          var reqIs1 = this._requests[1] === req; // if request 1 finished, or request 0 finished and request
          // 1 is over Strophe.SECONDARY_TIMEOUT seconds old, we need to
          // restart the other - both will be in the first spot, as the
          // completed request has been removed from the queue already

          if (reqIs1 || reqIs0 && this._requests.length > 0 && this._requests[0].age() > Math.floor(Strophe.SECONDARY_TIMEOUT * this.wait)) {
            this._restartRequest(0);
          }

          this._conn.nextValidRid(Number(req.rid) + 1);

          Strophe.debug("request id " + req.id + "." + req.sends + " got 200");
          func(req); // call handler

          this.errors = 0;
        } else if (reqStatus === 0 || reqStatus >= 400 && reqStatus < 600 || reqStatus >= 12000) {
          // request failed
          Strophe.error("request id " + req.id + "." + req.sends + " error " + reqStatus + " happened");

          this._hitError(reqStatus);

          this._callProtocolErrorHandlers(req);

          if (reqStatus >= 400 && reqStatus < 500) {
            this._conn._changeConnectStatus(Strophe.Status.DISCONNECTING, null);

            this._conn._doDisconnect();
          }
        } else {
          Strophe.error("request id " + req.id + "." + req.sends + " error " + reqStatus + " happened");
        }

        if (!valid_request && !too_many_retries) {
          this._throttledRequestHandler();
        } else if (too_many_retries && !this._conn.connected) {
          this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "giving-up");
        }
      }
      /** PrivateFunction: _processRequest
       *  _Private_ function to process a request in the queue.
       *
       *  This function takes requests off the queue and sends them and
       *  restarts dead requests.
       *
       *  Parameters:
       *    (Integer) i - The index of the request in the queue.
       */

    }, {
      key: "_processRequest",
      value: function _processRequest(i) {
        var _this = this;

        var req = this._requests[i];

        var reqStatus = Bosh._getRequestStatus(req, -1); // make sure we limit the number of retries


        if (req.sends > this._conn.maxRetries) {
          this._conn._onDisconnectTimeout();

          return;
        }

        var time_elapsed = req.age();
        var primary_timeout = !isNaN(time_elapsed) && time_elapsed > Math.floor(Strophe.TIMEOUT * this.wait);
        var secondary_timeout = req.dead !== null && req.timeDead() > Math.floor(Strophe.SECONDARY_TIMEOUT * this.wait);
        var server_error = req.xhr.readyState === 4 && (reqStatus < 1 || reqStatus >= 500);

        if (primary_timeout || secondary_timeout || server_error) {
          if (secondary_timeout) {
            Strophe.error("Request ".concat(this._requests[i].id, " timed out (secondary), restarting"));
          }

          req.abort = true;
          req.xhr.abort(); // setting to null fails on IE6, so set to empty function

          req.xhr.onreadystatechange = function () {};

          this._requests[i] = new Strophe.Request(req.xmlData, req.origFunc, req.rid, req.sends);
          req = this._requests[i];
        }

        if (req.xhr.readyState === 0) {
          Strophe.debug("request id " + req.id + "." + req.sends + " posting");

          try {
            var content_type = this._conn.options.contentType || "text/xml; charset=utf-8";
            req.xhr.open("POST", this._conn.service, this._conn.options.sync ? false : true);

            if (typeof req.xhr.setRequestHeader !== 'undefined') {
              // IE9 doesn't have setRequestHeader
              req.xhr.setRequestHeader("Content-Type", content_type);
            }

            if (this._conn.options.withCredentials) {
              req.xhr.withCredentials = true;
            }
          } catch (e2) {
            Strophe.error("XHR open failed: " + e2.toString());

            if (!this._conn.connected) {
              this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "bad-service");
            }

            this._conn.disconnect();

            return;
          } // Fires the XHR request -- may be invoked immediately
          // or on a gradually expanding retry window for reconnects


          var sendFunc = function sendFunc() {
            req.date = new Date();

            if (_this._conn.options.customHeaders) {
              var headers = _this._conn.options.customHeaders;

              for (var header in headers) {
                if (Object.prototype.hasOwnProperty.call(headers, header)) {
                  req.xhr.setRequestHeader(header, headers[header]);
                }
              }
            }

            req.xhr.send(req.data);
          }; // Implement progressive backoff for reconnects --
          // First retry (send === 1) should also be instantaneous


          if (req.sends > 1) {
            // Using a cube of the retry number creates a nicely
            // expanding retry window
            var backoff = Math.min(Math.floor(Strophe.TIMEOUT * this.wait), Math.pow(req.sends, 3)) * 1000;
            setTimeout(function () {
              // XXX: setTimeout should be called only with function expressions (23974bc1)
              sendFunc();
            }, backoff);
          } else {
            sendFunc();
          }

          req.sends++;

          if (this._conn.xmlOutput !== Strophe.Connection.prototype.xmlOutput) {
            if (req.xmlData.nodeName === this.strip && req.xmlData.childNodes.length) {
              this._conn.xmlOutput(req.xmlData.childNodes[0]);
            } else {
              this._conn.xmlOutput(req.xmlData);
            }
          }

          if (this._conn.rawOutput !== Strophe.Connection.prototype.rawOutput) {
            this._conn.rawOutput(req.data);
          }
        } else {
          Strophe.debug("_processRequest: " + (i === 0 ? "first" : "second") + " request has readyState of " + req.xhr.readyState);
        }
      }
      /** PrivateFunction: _removeRequest
       *  _Private_ function to remove a request from the queue.
       *
       *  Parameters:
       *    (Strophe.Request) req - The request to remove.
       */

    }, {
      key: "_removeRequest",
      value: function _removeRequest(req) {
        Strophe.debug("removing request");

        for (var i = this._requests.length - 1; i >= 0; i--) {
          if (req === this._requests[i]) {
            this._requests.splice(i, 1);
          }
        } // IE6 fails on setting to null, so set to empty function


        req.xhr.onreadystatechange = function () {};

        this._throttledRequestHandler();
      }
      /** PrivateFunction: _restartRequest
       *  _Private_ function to restart a request that is presumed dead.
       *
       *  Parameters:
       *    (Integer) i - The index of the request in the queue.
       */

    }, {
      key: "_restartRequest",
      value: function _restartRequest(i) {
        var req = this._requests[i];

        if (req.dead === null) {
          req.dead = new Date();
        }

        this._processRequest(i);
      }
      /** PrivateFunction: _reqToData
       * _Private_ function to get a stanza out of a request.
       *
       * Tries to extract a stanza out of a Request Object.
       * When this fails the current connection will be disconnected.
       *
       *  Parameters:
       *    (Object) req - The Request.
       *
       *  Returns:
       *    The stanza that was passed.
       */

    }, {
      key: "_reqToData",
      value: function _reqToData(req) {
        try {
          return req.getResponse();
        } catch (e) {
          if (e.message !== "parsererror") {
            throw e;
          }

          this._conn.disconnect("strophe-parsererror");
        }
      }
      /** PrivateFunction: _sendTerminate
       *  _Private_ function to send initial disconnect sequence.
       *
       *  This is the first step in a graceful disconnect.  It sends
       *  the BOSH server a terminate body and includes an unavailable
       *  presence if authentication has completed.
       */

    }, {
      key: "_sendTerminate",
      value: function _sendTerminate(pres) {
        Strophe.debug("_sendTerminate was called");

        var body = this._buildBody().attrs({
          type: "terminate"
        });

        if (pres) {
          body.cnode(pres.tree());
        }

        var req = new Strophe.Request(body.tree(), this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)), body.tree().getAttribute("rid"));

        this._requests.push(req);

        this._throttledRequestHandler();
      }
      /** PrivateFunction: _send
       *  _Private_ part of the Connection.send function for BOSH
       *
       * Just triggers the RequestHandler to send the messages that are in the queue
       */

    }, {
      key: "_send",
      value: function _send() {
        var _this2 = this;

        clearTimeout(this._conn._idleTimeout);

        this._throttledRequestHandler();

        this._conn._idleTimeout = setTimeout(function () {
          return _this2._conn._onIdle();
        }, 100);
      }
      /** PrivateFunction: _sendRestart
       *
       *  Send an xmpp:restart stanza.
       */

    }, {
      key: "_sendRestart",
      value: function _sendRestart() {
        this._throttledRequestHandler();

        clearTimeout(this._conn._idleTimeout);
      }
      /** PrivateFunction: _throttledRequestHandler
       *  _Private_ function to throttle requests to the connection window.
       *
       *  This function makes sure we don't send requests so fast that the
       *  request ids overflow the connection window in the case that one
       *  request died.
       */

    }, {
      key: "_throttledRequestHandler",
      value: function _throttledRequestHandler() {
        if (!this._requests) {
          Strophe.debug("_throttledRequestHandler called with " + "undefined requests");
        } else {
          Strophe.debug("_throttledRequestHandler called with " + this._requests.length + " requests");
        }

        if (!this._requests || this._requests.length === 0) {
          return;
        }

        if (this._requests.length > 0) {
          this._processRequest(0);
        }

        if (this._requests.length > 1 && Math.abs(this._requests[0].rid - this._requests[1].rid) < this.window) {
          this._processRequest(1);
        }
      }
    }], [{
      key: "_getRequestStatus",
      value: function _getRequestStatus(req, def) {
        var reqStatus;

        if (req.xhr.readyState === 4) {
          try {
            reqStatus = req.xhr.status;
          } catch (e) {
            // ignore errors from undefined status attribute. Works
            // around a browser bug
            Strophe.error("Caught an error while retrieving a request's status, " + "reqStatus: " + reqStatus);
          }
        }

        if (typeof reqStatus === "undefined") {
          reqStatus = typeof def === 'number' ? def : 0;
        }

        return reqStatus;
      }
    }]);

    return Bosh;
  }();
  /** Variable: strip
   *
   *  BOSH-Connections will have all stanzas wrapped in a <body> tag when
   *  passed to <Strophe.Connection.xmlInput> or <Strophe.Connection.xmlOutput>.
   *  To strip this tag, User code can set <Strophe.Bosh.strip> to "body":
   *
   *  > Strophe.Bosh.prototype.strip = "body";
   *
   *  This will enable stripping of the body tag in both
   *  <Strophe.Connection.xmlInput> and <Strophe.Connection.xmlOutput>.
   */

  Strophe.Bosh.prototype.strip = null;

  /** Class: Strophe.WebSocket
   *  _Private_ helper class that handles WebSocket Connections
   *
   *  The Strophe.WebSocket class is used internally by Strophe.Connection
   *  to encapsulate WebSocket sessions. It is not meant to be used from user's code.
   */

  /** File: websocket.js
   *  A JavaScript library to enable XMPP over Websocket in Strophejs.
   *
   *  This file implements XMPP over WebSockets for Strophejs.
   *  If a Connection is established with a Websocket url (ws://...)
   *  Strophe will use WebSockets.
   *  For more information on XMPP-over-WebSocket see RFC 7395:
   *  http://tools.ietf.org/html/rfc7395
   *
   *  WebSocket support implemented by Andreas Guth (andreas.guth@rwth-aachen.de)
   */

  Strophe.Websocket = /*#__PURE__*/function () {
    /** PrivateConstructor: Strophe.Websocket
     *  Create and initialize a Strophe.WebSocket object.
     *  Currently only sets the connection Object.
     *
     *  Parameters:
     *    (Strophe.Connection) connection - The Strophe.Connection that will use WebSockets.
     *
     *  Returns:
     *    A new Strophe.WebSocket object.
     */
    function Websocket(connection) {
      _classCallCheck(this, Websocket);

      this._conn = connection;
      this.strip = "wrapper";
      var service = connection.service;

      if (service.indexOf("ws:") !== 0 && service.indexOf("wss:") !== 0) {
        // If the service is not an absolute URL, assume it is a path and put the absolute
        // URL together from options, current URL and the path.
        var new_service = "";

        if (connection.options.protocol === "ws" && window.location.protocol !== "https:") {
          new_service += "ws";
        } else {
          new_service += "wss";
        }

        new_service += "://" + window.location.host;

        if (service.indexOf("/") !== 0) {
          new_service += window.location.pathname + service;
        } else {
          new_service += service;
        }

        connection.service = new_service;
      }
    }
    /** PrivateFunction: _buildStream
     *  _Private_ helper function to generate the <stream> start tag for WebSockets
     *
     *  Returns:
     *    A Strophe.Builder with a <stream> element.
     */

    _createClass(Websocket, [{
      key: "_buildStream",
      value: function _buildStream() {
        return $build("open", {
          "xmlns": Strophe.NS.FRAMING,
          "to": this._conn.domain,
          "version": '1.0'
        });
      }
      /** PrivateFunction: _checkStreamError
       * _Private_ checks a message for stream:error
       *
       *  Parameters:
       *    (Strophe.Request) bodyWrap - The received stanza.
       *    connectstatus - The ConnectStatus that will be set on error.
       *  Returns:
       *     true if there was a streamerror, false otherwise.
       */

    }, {
      key: "_checkStreamError",
      value: function _checkStreamError(bodyWrap, connectstatus) {
        var errors;

        if (bodyWrap.getElementsByTagNameNS) {
          errors = bodyWrap.getElementsByTagNameNS(Strophe.NS.STREAM, "error");
        } else {
          errors = bodyWrap.getElementsByTagName("stream:error");
        }

        if (errors.length === 0) {
          return false;
        }

        var error = errors[0];
        var condition = "";
        var text = "";
        var ns = "urn:ietf:params:xml:ns:xmpp-streams";

        for (var i = 0; i < error.childNodes.length; i++) {
          var e = error.childNodes[i];

          if (e.getAttribute("xmlns") !== ns) {
            break;
          }

          if (e.nodeName === "text") {
            text = e.textContent;
          } else {
            condition = e.nodeName;
          }
        }

        var errorString = "WebSocket stream error: ";

        if (condition) {
          errorString += condition;
        } else {
          errorString += "unknown";
        }

        if (text) {
          errorString += " - " + text;
        }

        Strophe.error(errorString); // close the connection on stream_error

        this._conn._changeConnectStatus(connectstatus, condition);

        this._conn._doDisconnect();

        return true;
      }
      /** PrivateFunction: _reset
       *  Reset the connection.
       *
       *  This function is called by the reset function of the Strophe Connection.
       *  Is not needed by WebSockets.
       */

    }, {
      key: "_reset",
      value: function _reset() {
        // eslint-disable-line class-methods-use-this
        return;
      }
      /** PrivateFunction: _connect
       *  _Private_ function called by Strophe.Connection.connect
       *
       *  Creates a WebSocket for a connection and assigns Callbacks to it.
       *  Does nothing if there already is a WebSocket.
       */

    }, {
      key: "_connect",
      value: function _connect() {
        var _this = this;

        // Ensure that there is no open WebSocket from a previous Connection.
        this._closeSocket();

        this.socket = new WebSocket(this._conn.service, "xmpp");

        this.socket.onopen = function () {
          return _this._onOpen();
        };

        this.socket.onerror = function (e) {
          return _this._onError(e);
        };

        this.socket.onclose = function (e) {
          return _this._onClose(e);
        }; // Gets replaced with this._onMessage once _onInitialMessage is called


        this.socket.onmessage = function (message) {
          return _this._onInitialMessage(message);
        };
      }
      /** PrivateFunction: _connect_cb
       *  _Private_ function called by Strophe.Connection._connect_cb
       *
       * checks for stream:error
       *
       *  Parameters:
       *    (Strophe.Request) bodyWrap - The received stanza.
       */

    }, {
      key: "_connect_cb",
      value: function _connect_cb(bodyWrap) {
        var error = this._checkStreamError(bodyWrap, Strophe.Status.CONNFAIL);

        if (error) {
          return Strophe.Status.CONNFAIL;
        }
      }
      /** PrivateFunction: _handleStreamStart
       * _Private_ function that checks the opening <open /> tag for errors.
       *
       * Disconnects if there is an error and returns false, true otherwise.
       *
       *  Parameters:
       *    (Node) message - Stanza containing the <open /> tag.
       */

    }, {
      key: "_handleStreamStart",
      value: function _handleStreamStart(message) {
        var error = false; // Check for errors in the <open /> tag

        var ns = message.getAttribute("xmlns");

        if (typeof ns !== "string") {
          error = "Missing xmlns in <open />";
        } else if (ns !== Strophe.NS.FRAMING) {
          error = "Wrong xmlns in <open />: " + ns;
        }

        var ver = message.getAttribute("version");

        if (typeof ver !== "string") {
          error = "Missing version in <open />";
        } else if (ver !== "1.0") {
          error = "Wrong version in <open />: " + ver;
        }

        if (error) {
          this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, error);

          this._conn._doDisconnect();

          return false;
        }

        return true;
      }
      /** PrivateFunction: _onInitialMessage
       * _Private_ function that handles the first connection messages.
       *
       * On receiving an opening stream tag this callback replaces itself with the real
       * message handler. On receiving a stream error the connection is terminated.
       */

    }, {
      key: "_onInitialMessage",
      value: function _onInitialMessage(message) {
        if (message.data.indexOf("<open ") === 0 || message.data.indexOf("<?xml") === 0) {
          // Strip the XML Declaration, if there is one
          var data = message.data.replace(/^(<\?.*?\?>\s*)*/, "");
          if (data === '') return;
          var streamStart = new DOMParser().parseFromString(data, "text/xml").documentElement;

          this._conn.xmlInput(streamStart);

          this._conn.rawInput(message.data); //_handleStreamSteart will check for XML errors and disconnect on error


          if (this._handleStreamStart(streamStart)) {
            //_connect_cb will check for stream:error and disconnect on error
            this._connect_cb(streamStart);
          }
        } else if (message.data.indexOf("<close ") === 0) {
          // <close xmlns="urn:ietf:params:xml:ns:xmpp-framing />
          // Parse the raw string to an XML element
          var parsedMessage = new DOMParser().parseFromString(message.data, "text/xml").documentElement; // Report this input to the raw and xml handlers

          this._conn.xmlInput(parsedMessage);

          this._conn.rawInput(message.data);

          var see_uri = parsedMessage.getAttribute("see-other-uri");

          if (see_uri) {
            var service = this._conn.service; // Valid scenarios: WSS->WSS, WS->ANY

            var isSecureRedirect = service.indexOf("wss:") >= 0 && see_uri.indexOf("wss:") >= 0 || service.indexOf("ws:") >= 0;

            if (isSecureRedirect) {
              this._conn._changeConnectStatus(Strophe.Status.REDIRECT, "Received see-other-uri, resetting connection");

              this._conn.reset();

              this._conn.service = see_uri;

              this._connect();
            }
          } else {
            this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "Received closing stream");

            this._conn._doDisconnect();
          }
        } else {
          this._replaceMessageHandler();

          var string = this._streamWrap(message.data);

          var elem = new DOMParser().parseFromString(string, "text/xml").documentElement;

          this._conn._connect_cb(elem, null, message.data);
        }
      }
      /** PrivateFunction: _replaceMessageHandler
       *
       * Called by _onInitialMessage in order to replace itself with the general message handler.
       * This method is overridden by Strophe.WorkerWebsocket, which manages a
       * websocket connection via a service worker and doesn't have direct access
       * to the socket.
       */

    }, {
      key: "_replaceMessageHandler",
      value: function _replaceMessageHandler() {
        var _this2 = this;

        this.socket.onmessage = function (m) {
          return _this2._onMessage(m);
        };
      }
      /** PrivateFunction: _disconnect
       *  _Private_ function called by Strophe.Connection.disconnect
       *
       *  Disconnects and sends a last stanza if one is given
       *
       *  Parameters:
       *    (Request) pres - This stanza will be sent before disconnecting.
       */

    }, {
      key: "_disconnect",
      value: function _disconnect(pres) {
        var _this3 = this;

        if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
          if (pres) {
            this._conn.send(pres);
          }

          var close = $build("close", {
            "xmlns": Strophe.NS.FRAMING
          });

          this._conn.xmlOutput(close.tree());

          var closeString = Strophe.serialize(close);

          this._conn.rawOutput(closeString);

          try {
            this.socket.send(closeString);
          } catch (e) {
            Strophe.warn("Couldn't send <close /> tag.");
          }
        }

        setTimeout(function () {
          return _this3._conn._doDisconnect;
        }, 0);
      }
      /** PrivateFunction: _doDisconnect
       *  _Private_ function to disconnect.
       *
       *  Just closes the Socket for WebSockets
       */

    }, {
      key: "_doDisconnect",
      value: function _doDisconnect() {
        Strophe.debug("WebSockets _doDisconnect was called");

        this._closeSocket();
      }
      /** PrivateFunction _streamWrap
       *  _Private_ helper function to wrap a stanza in a <stream> tag.
       *  This is used so Strophe can process stanzas from WebSockets like BOSH
       */

    }, {
      key: "_streamWrap",
      value: function _streamWrap(stanza) {
        // eslint-disable-line class-methods-use-this
        return "<wrapper>" + stanza + '</wrapper>';
      }
      /** PrivateFunction: _closeSocket
       *  _Private_ function to close the WebSocket.
       *
       *  Closes the socket if it is still open and deletes it
       */

    }, {
      key: "_closeSocket",
      value: function _closeSocket() {
        if (this.socket) {
          try {
            this.socket.onclose = null;
            this.socket.onerror = null;
            this.socket.onmessage = null;
            this.socket.close();
          } catch (e) {
            Strophe.debug(e.message);
          }
        }

        this.socket = null;
      }
      /** PrivateFunction: _emptyQueue
       * _Private_ function to check if the message queue is empty.
       *
       *  Returns:
       *    True, because WebSocket messages are send immediately after queueing.
       */

    }, {
      key: "_emptyQueue",
      value: function _emptyQueue() {
        // eslint-disable-line class-methods-use-this
        return true;
      }
      /** PrivateFunction: _onClose
       * _Private_ function to handle websockets closing.
       */

    }, {
      key: "_onClose",
      value: function _onClose(e) {
        if (this._conn.connected && !this._conn.disconnecting) {
          Strophe.error("Websocket closed unexpectedly");

          this._conn._doDisconnect();
        } else if (e && e.code === 1006 && !this._conn.connected && this.socket) {
          // in case the onError callback was not called (Safari 10 does not
          // call onerror when the initial connection fails) we need to
          // dispatch a CONNFAIL status update to be consistent with the
          // behavior on other browsers.
          Strophe.error("Websocket closed unexcectedly");

          this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "The WebSocket connection could not be established or was disconnected.");

          this._conn._doDisconnect();
        } else {
          Strophe.debug("Websocket closed");
        }
      }
      /** PrivateFunction: _no_auth_received
       *
       * Called on stream start/restart when no stream:features
       * has been received.
       */

    }, {
      key: "_no_auth_received",
      value: function _no_auth_received(callback) {
        Strophe.error("Server did not offer a supported authentication mechanism");

        this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, Strophe.ErrorCondition.NO_AUTH_MECH);

        if (callback) {
          callback.call(this._conn);
        }

        this._conn._doDisconnect();
      }
      /** PrivateFunction: _onDisconnectTimeout
       *  _Private_ timeout handler for handling non-graceful disconnection.
       *
       *  This does nothing for WebSockets
       */

    }, {
      key: "_onDisconnectTimeout",
      value: function _onDisconnectTimeout() {} // eslint-disable-line class-methods-use-this

      /** PrivateFunction: _abortAllRequests
       *  _Private_ helper function that makes sure all pending requests are aborted.
       */

    }, {
      key: "_abortAllRequests",
      value: function _abortAllRequests() {} // eslint-disable-line class-methods-use-this

      /** PrivateFunction: _onError
       * _Private_ function to handle websockets errors.
       *
       * Parameters:
       * (Object) error - The websocket error.
       */

    }, {
      key: "_onError",
      value: function _onError(error) {
        Strophe.error("Websocket error " + error);

        this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "The WebSocket connection could not be established or was disconnected.");

        this._disconnect();
      }
      /** PrivateFunction: _onIdle
       *  _Private_ function called by Strophe.Connection._onIdle
       *
       *  sends all queued stanzas
       */

    }, {
      key: "_onIdle",
      value: function _onIdle() {
        var data = this._conn._data;

        if (data.length > 0 && !this._conn.paused) {
          for (var i = 0; i < data.length; i++) {
            if (data[i] !== null) {
              var stanza = void 0;

              if (data[i] === "restart") {
                stanza = this._buildStream().tree();
              } else {
                stanza = data[i];
              }

              var rawStanza = Strophe.serialize(stanza);

              this._conn.xmlOutput(stanza);

              this._conn.rawOutput(rawStanza);

              this.socket.send(rawStanza);
            }
          }

          this._conn._data = [];
        }
      }
      /** PrivateFunction: _onMessage
       * _Private_ function to handle websockets messages.
       *
       * This function parses each of the messages as if they are full documents.
       * [TODO : We may actually want to use a SAX Push parser].
       *
       * Since all XMPP traffic starts with
       *  <stream:stream version='1.0'
       *                 xml:lang='en'
       *                 xmlns='jabber:client'
       *                 xmlns:stream='http://etherx.jabber.org/streams'
       *                 id='3697395463'
       *                 from='SERVER'>
       *
       * The first stanza will always fail to be parsed.
       *
       * Additionally, the seconds stanza will always be <stream:features> with
       * the stream NS defined in the previous stanza, so we need to 'force'
       * the inclusion of the NS in this stanza.
       *
       * Parameters:
       * (string) message - The websocket message.
       */

    }, {
      key: "_onMessage",
      value: function _onMessage(message) {
        var elem; // check for closing stream

        var close = '<close xmlns="urn:ietf:params:xml:ns:xmpp-framing" />';

        if (message.data === close) {
          this._conn.rawInput(close);

          this._conn.xmlInput(message);

          if (!this._conn.disconnecting) {
            this._conn._doDisconnect();
          }

          return;
        } else if (message.data.search("<open ") === 0) {
          // This handles stream restarts
          elem = new DOMParser().parseFromString(message.data, "text/xml").documentElement;

          if (!this._handleStreamStart(elem)) {
            return;
          }
        } else {
          var data = this._streamWrap(message.data);

          elem = new DOMParser().parseFromString(data, "text/xml").documentElement;
        }

        if (this._checkStreamError(elem, Strophe.Status.ERROR)) {
          return;
        } //handle unavailable presence stanza before disconnecting


        if (this._conn.disconnecting && elem.firstChild.nodeName === "presence" && elem.firstChild.getAttribute("type") === "unavailable") {
          this._conn.xmlInput(elem);

          this._conn.rawInput(Strophe.serialize(elem)); // if we are already disconnecting we will ignore the unavailable stanza and
          // wait for the </stream:stream> tag before we close the connection


          return;
        }

        this._conn._dataRecv(elem, message.data);
      }
      /** PrivateFunction: _onOpen
       * _Private_ function to handle websockets connection setup.
       *
       * The opening stream tag is sent here.
       */

    }, {
      key: "_onOpen",
      value: function _onOpen() {
        Strophe.debug("Websocket open");

        var start = this._buildStream();

        this._conn.xmlOutput(start.tree());

        var startString = Strophe.serialize(start);

        this._conn.rawOutput(startString);

        this.socket.send(startString);
      }
      /** PrivateFunction: _reqToData
       * _Private_ function to get a stanza out of a request.
       *
       * WebSockets don't use requests, so the passed argument is just returned.
       *
       *  Parameters:
       *    (Object) stanza - The stanza.
       *
       *  Returns:
       *    The stanza that was passed.
       */

    }, {
      key: "_reqToData",
      value: function _reqToData(stanza) {
        // eslint-disable-line class-methods-use-this
        return stanza;
      }
      /** PrivateFunction: _send
       *  _Private_ part of the Connection.send function for WebSocket
       *
       * Just flushes the messages that are in the queue
       */

    }, {
      key: "_send",
      value: function _send() {
        this._conn.flush();
      }
      /** PrivateFunction: _sendRestart
       *
       *  Send an xmpp:restart stanza.
       */

    }, {
      key: "_sendRestart",
      value: function _sendRestart() {
        clearTimeout(this._conn._idleTimeout);

        this._conn._onIdle.bind(this._conn)();
      }
    }]);

    return Websocket;
  }();

  var lmap = {};
  lmap['debug'] = Strophe.LogLevel.DEBUG;
  lmap['info'] = Strophe.LogLevel.INFO;
  lmap['warn'] = Strophe.LogLevel.WARN;
  lmap['error'] = Strophe.LogLevel.ERROR;
  lmap['fatal'] = Strophe.LogLevel.FATAL;
  /** Class: Strophe.WorkerWebsocket
   *  _Private_ helper class that handles a websocket connection inside a shared worker.
   */

  Strophe.WorkerWebsocket = /*#__PURE__*/function (_Strophe$Websocket) {
    _inherits(WorkerWebsocket, _Strophe$Websocket);

    var _super = _createSuper(WorkerWebsocket);

    /** PrivateConstructor: Strophe.WorkerWebsocket
     *  Create and initialize a Strophe.WorkerWebsocket object.
     *
     *  Parameters:
     *    (Strophe.Connection) connection - The Strophe.Connection
     *
     *  Returns:
     *    A new Strophe.WorkerWebsocket object.
     */
    function WorkerWebsocket(connection) {
      var _this;

      _classCallCheck(this, WorkerWebsocket);

      _this = _super.call(this, connection);
      _this._conn = connection;
      _this.worker = new SharedWorker(_this._conn.options.worker, 'Strophe XMPP Connection');

      _this.worker.onerror = function (e) {
        var _console;

        (_console = console) === null || _console === void 0 ? void 0 : _console.error(e);
        Strophe.log(Strophe.LogLevel.ERROR, "Shared Worker Error: ".concat(e));
      };

      return _this;
    }

    _createClass(WorkerWebsocket, [{
      key: "_connect",
      value: function _connect() {
        var _this2 = this;

        this._messageHandler = function (m) {
          return _this2._onInitialMessage(m);
        };

        this.worker.port.start();

        this.worker.port.onmessage = function (ev) {
          return _this2._onWorkerMessage(ev);
        };

        this.worker.port.postMessage(['_connect', this._conn.service, this._conn.jid]);
      }
    }, {
      key: "_attach",
      value: function _attach(callback) {
        var _this3 = this;

        this._messageHandler = function (m) {
          return _this3._onMessage(m);
        };

        this._conn.connect_callback = callback;
        this.worker.port.start();

        this.worker.port.onmessage = function (ev) {
          return _this3._onWorkerMessage(ev);
        };

        this.worker.port.postMessage(['_attach', this._conn.service]);
      }
    }, {
      key: "_attachCallback",
      value: function _attachCallback(status, jid) {
        if (status === Strophe.Status.ATTACHED) {
          this._conn.jid = jid;
          this._conn.authenticated = true;
          this._conn.connected = true;
          this._conn.restored = true;

          this._conn._changeConnectStatus(Strophe.Status.ATTACHED);
        } else if (status === Strophe.Status.ATTACHFAIL) {
          this._conn.authenticated = false;
          this._conn.connected = false;
          this._conn.restored = false;

          this._conn._changeConnectStatus(Strophe.Status.ATTACHFAIL);
        }
      }
    }, {
      key: "_disconnect",
      value: function _disconnect(readyState, pres) {
        pres && this._conn.send(pres);
        var close = $build("close", {
          "xmlns": Strophe.NS.FRAMING
        });

        this._conn.xmlOutput(close.tree());

        var closeString = Strophe.serialize(close);

        this._conn.rawOutput(closeString);

        this.worker.port.postMessage(['send', closeString]);

        this._conn._doDisconnect();
      }
    }, {
      key: "_onClose",
      value: function _onClose(e) {
        if (this._conn.connected && !this._conn.disconnecting) {
          Strophe.error("Websocket closed unexpectedly");

          this._conn._doDisconnect();
        } else if (e && e.code === 1006 && !this._conn.connected) {
          // in case the onError callback was not called (Safari 10 does not
          // call onerror when the initial connection fails) we need to
          // dispatch a CONNFAIL status update to be consistent with the
          // behavior on other browsers.
          Strophe.error("Websocket closed unexcectedly");

          this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "The WebSocket connection could not be established or was disconnected.");

          this._conn._doDisconnect();
        } else {
          Strophe.debug("Websocket closed");
        }
      }
    }, {
      key: "_closeSocket",
      value: function _closeSocket() {
        this.worker.port.postMessage(['_closeSocket']);
      }
      /** PrivateFunction: _replaceMessageHandler
       *
       * Called by _onInitialMessage in order to replace itself with the general message handler.
       * This method is overridden by Strophe.WorkerWebsocket, which manages a
       * websocket connection via a service worker and doesn't have direct access
       * to the socket.
       */

    }, {
      key: "_replaceMessageHandler",
      value: function _replaceMessageHandler() {
        var _this4 = this;

        this._messageHandler = function (m) {
          return _this4._onMessage(m);
        };
      }
      /** PrivateFunction: _onWorkerMessage
       * _Private_ function that handles messages received from the service worker
       */

    }, {
      key: "_onWorkerMessage",
      value: function _onWorkerMessage(ev) {
        var data = ev.data;
        var method_name = data[0];

        if (method_name === '_onMessage') {
          this._messageHandler(data[1]);
        } else if (method_name in this) {
          try {
            this[method_name].apply(this, ev.data.slice(1));
          } catch (e) {
            Strophe.log(Strophe.LogLevel.ERROR, e);
          }
        } else if (method_name === 'log') {
          var level = data[1];
          var msg = data[2];
          Strophe.log(lmap[level], msg);
        } else {
          Strophe.log(Strophe.LogLevel.ERROR, "Found unhandled service worker message: ".concat(data));
        }
      }
    }, {
      key: "socket",
      get: function get() {
        var _this5 = this;

        return {
          'send': function send(str) {
            return _this5.worker.port.postMessage(['send', str]);
          }
        };
      }
    }]);

    return WorkerWebsocket;
  }(Strophe.Websocket);

  global$1.$build = core.$build;
  global$1.$iq = core.$iq;
  global$1.$msg = core.$msg;
  global$1.$pres = core.$pres;
  global$1.Strophe = core.Strophe;
  var b64_sha1 = SHA1.b64_sha1;

  exports.$build = $build;
  exports.$iq = $iq;
  exports.$msg = $msg;
  exports.$pres = $pres;
  exports.Strophe = Strophe;
  exports.b64_sha1 = b64_sha1;

  Object.defineProperty(exports, '__esModule', { value: true });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "/44e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "704e74295cc6e59e881d3ddfad5aaa62.png";

/***/ }),

/***/ "/B6s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _isPrefixedValue = __webpack_require__("QXNG");

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "/C1n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export apiHost */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return webSocketHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiRoot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiUrls; });
var apiHost = "https://app.telmie.com/api/";
var bookingApiRoot = "https://app.telmie.com/calendar/api/";
var webSocketHost = "app.telmie.com";

var apiRoot = apiHost;

/**
 * @callback ProAvailabilityV4UrlBuilder
 * @param {number} proId
 * @param {string} timeZone
 * @returns {string}
*/

/**
 * @typedef {Object} apiUrls
 * @property {ProAvailabilityV4UrlBuilder} PRO_AVAILABILITY_V4
 */
var apiUrls = {
  AUTH: apiRoot + 'v3/auth',
  CATEGORIES: apiRoot + 'v3/categories',
  COUNTRIES: apiRoot + 'v3/countries',
  REGISTER: apiRoot + 'v3/users',
  EDIT_DETAILS: apiRoot + 'users',
  SEARCH_USERS: apiRoot + 'users/pro/find?q=',
  GET_USER_DETAILS: apiRoot + 'users/',
  GET_V3_USER_DETAILS: function GET_V3_USER_DETAILS(proId) {
    return apiRoot + 'v3/users/' + proId;
  },
  GET_V3_CURRENT_USER_DETAILS: apiRoot + 'v3/users',
  GET_CLIENT_USER_DETAILS: function GET_CLIENT_USER_DETAILS(proId) {
    return apiRoot + 'v3/users/' + proId;
  },
  GET_USER_DETAILS_REF: function GET_USER_DETAILS_REF(proId) {
    return apiRoot + 'users/ref/' + proId;
  },
  LOG_IN: apiRoot + 'auth',
  GET_PRO_CALLS: apiRoot + 'users/activity?isPro=true',
  GET_PERSONAL_CALLS: apiRoot + 'users/activity?isPro=false',
  GET_TRANSACTIONS: apiRoot + 'wallet',
  VERIFY_USER: apiRoot + 'users/signup',
  ADD_TO_SHORTLIST: function ADD_TO_SHORTLIST(id) {
    return apiRoot + 'shortlist/' + id;
  },
  RESET_PASSWORD: apiRoot + 'security/reset',
  UPLOAD_PHOTO: apiRoot + 'image',
  SEND_CODE: apiRoot + 'code',
  REGISTER_PRO: function REGISTER_PRO(id) {
    return apiRoot + 'users/' + id + '/pro';
  },
  REGISTER_PRO_USER: apiRoot + 'users/pro',
  GET_CATEGORIES: apiRoot + 'categories',
  SEND_CONTACT_DATA: apiRoot + 'help/contact',
  EMAIL_NOTIFICATIONS: apiRoot + 'users/emailNotifications',
  WORKING_PRO: apiRoot + 'users/pro/work',
  CALLS: apiRoot + 'calls',
  CALLS_V3: apiRoot + 'v3/calls',
  CALL_HISTORY: function CALL_HISTORY(id) {
    return apiRoot + 'calls/user/' + id;
  },
  GET_COMPANY_TAX_ID: function GET_COMPANY_TAX_ID(id) {
    return apiRoot + 'companies/' + id;
  },
  GET_CARDS: apiRoot + 'wallet/payment-method',
  GET_BANK_ACC: apiRoot + 'wallet/bank',
  GET_STRIPE_KEY: apiRoot + 'wallet/token',
  TOP_UP: apiRoot + 'wallet/top-up',
  WITHDRAW: apiRoot + 'wallet/withdraw',
  PAYOUT_V3: apiRoot + 'v3/wallet/payout',
  VERIFICATION_ID: apiRoot + 'wallet/documentid',
  OAUTH2: function OAUTH2(id, partner) {
    return apiRoot + 'oauth2/' + id + partner;
  },
  SET_STATE: function SET_STATE(key) {
    return apiRoot + 'users/state/' + key;
  },
  REMOVE_STATE: function REMOVE_STATE(key) {
    return apiRoot + 'users/state/' + key;
  },
  AVAILABILITY: apiRoot + 'users/pro/availability',
  FEATURED: function FEATURED(cid, fcid) {
    return apiRoot + 'calls/featured?' + (cid ? 'cid=' + cid + '&' : '') + 'fcid=' + fcid;
  },
  FEATURED_ALL: apiRoot + 'calls/featured/all',
  FEATURED_AGREEMENT: apiRoot + 'users/pro/featured-agreement',
  GET_SECTORS: apiRoot + 'categories',
  USER_SETTINGS: apiRoot + 'users/settings',
  SEND_NOTIFICATION_FROM_SUPPORT: function SEND_NOTIFICATION_FROM_SUPPORT(delay) {
    return apiRoot + 'chats/' + delay;
  },
  DEEP_LINK: apiRoot + 'v3/branch',
  UPLOAD_FILE: apiRoot + 'file',
  GET_FILE: function GET_FILE(id) {
    return apiRoot + 'file/' + id;
  },
  DELETE_FILE: function DELETE_FILE(id) {
    return apiRoot + 'file/' + id;
  },
  BADGE: function BADGE(id) {
    return apiRoot + 'badge' + (id ? '/' + id : '');
  },
  DEVICE: function DEVICE(id) {
    return apiRoot + 'devices' + (id ? '/' + id : '');
  },
  VERSION: function VERSION(type, version) {
    return apiRoot + 'devices/version?type=' + type + '&v=' + version;
  },
  SHARE: function SHARE(query) {
    return apiRoot + 'v3/users/pro/share?q=' + query;
  },
  PRO_AVAILABILITY_V4: function PRO_AVAILABILITY_V4(proId, timeZone) {
    return apiRoot + 'v4/users/' + proId + '/pro/availability?timezone=' + encodeURIComponent(timeZone);
  },

  REFRESH: apiRoot + 'v3/refresh-token',

  SECURITY_RESET: apiRoot + 'v3/security/reset',

  TOKEN: apiRoot + 'v3/token',

  USERS_PRO_FIND: apiRoot + 'v3/users/pro/find',

  USERS_PRO_SHARE: function USERS_PRO_SHARE(query) {
    return apiRoot + 'v3/users/pro/share?q=' + query;
  },

  INFO_LAUNCH: apiRoot + 'v3/info/launch',

  USER_BOOKINGS: function USER_BOOKINGS(userId) {
    return bookingApiRoot + 'v3/bookings?userId=' + userId;
  },

  CANCEL_BOOKING: function CANCEL_BOOKING(id) {
    return bookingApiRoot + 'v3/bookings/' + id;
  },

  BOOKING_DETAILS: function BOOKING_DETAILS(id) {
    return bookingApiRoot + 'v3/bookings/' + id;
  }
};

/***/ }),

/***/ "/G36":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;

  return {
    root: {
      position: 'relative',
      paddingLeft: baseTheme.spacing.desktopGutterLess,
      paddingRight: baseTheme.spacing.desktopGutterLess,
      verticalAlign: 'middle'
    }
  };
}

var FlatButtonLabel = function (_Component) {
  (0, _inherits3.default)(FlatButtonLabel, _Component);

  function FlatButtonLabel() {
    (0, _classCallCheck3.default)(this, FlatButtonLabel);
    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlatButtonLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          style = _props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement('span', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, label);
    }
  }]);
  return FlatButtonLabel;
}(_react.Component);

FlatButtonLabel.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButtonLabel.propTypes =  false ? {
  label: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};
exports.default = FlatButtonLabel;

/***/ }),

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "/V2d":
/***/ (function(module, exports, __webpack_require__) {

/* Copyright @ 2015 Atlassian Pty Ltd
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var transform = __webpack_require__("ka43");

exports.write = function (session, opts) {

  if (typeof session !== 'undefined' && typeof session.media !== 'undefined' && Array.isArray(session.media)) {

    session.media.forEach(function (mLine) {
      // expand sources to ssrcs
      if (typeof mLine.sources !== 'undefined' && Object.keys(mLine.sources).length !== 0) {
        mLine.ssrcs = [];
        Object.keys(mLine.sources).forEach(function (ssrc) {
          var source = mLine.sources[ssrc];
          Object.keys(source).forEach(function (attribute) {
            mLine.ssrcs.push({
              id: ssrc,
              attribute: attribute,
              value: source[attribute]
            });
          });
        });
        delete mLine.sources;
      }

      // join ssrcs in ssrc groups
      if (typeof mLine.ssrcGroups !== 'undefined' && Array.isArray(mLine.ssrcGroups)) {
        mLine.ssrcGroups.forEach(function (ssrcGroup) {
          if (typeof ssrcGroup.ssrcs !== 'undefined' && Array.isArray(ssrcGroup.ssrcs)) {
            ssrcGroup.ssrcs = ssrcGroup.ssrcs.join(' ');
          }
        });
      }
    });
  }

  // join group mids
  if (typeof session !== 'undefined' && typeof session.groups !== 'undefined' && Array.isArray(session.groups)) {

    session.groups.forEach(function (g) {
      if (typeof g.mids !== 'undefined' && Array.isArray(g.mids)) {
        g.mids = g.mids.join(' ');
      }
    });
  }

  return transform.write(session, opts);
};

exports.parse = function (sdp) {
  var session = transform.parse(sdp);

  if (typeof session !== 'undefined' && typeof session.media !== 'undefined' && Array.isArray(session.media)) {

    session.media.forEach(function (mLine) {
      // group sources attributes by ssrc
      if (typeof mLine.ssrcs !== 'undefined' && Array.isArray(mLine.ssrcs)) {
        mLine.sources = {};
        mLine.ssrcs.forEach(function (ssrc) {
          if (!mLine.sources[ssrc.id]) mLine.sources[ssrc.id] = {};
          mLine.sources[ssrc.id][ssrc.attribute] = ssrc.value;
        });

        delete mLine.ssrcs;
      }

      // split ssrcs in ssrc groups
      if (typeof mLine.ssrcGroups !== 'undefined' && Array.isArray(mLine.ssrcGroups)) {
        mLine.ssrcGroups.forEach(function (ssrcGroup) {
          if (typeof ssrcGroup.ssrcs === 'string') {
            ssrcGroup.ssrcs = ssrcGroup.ssrcs.split(' ');
          }
        });
      }
    });
  }
  // split group mids
  if (typeof session !== 'undefined' && typeof session.groups !== 'undefined' && Array.isArray(session.groups)) {

    session.groups.forEach(function (g) {
      if (typeof g.mids === 'string') {
        g.mids = g.mids.split(' ');
      }
    });
  }

  return session;
};

/***/ }),

/***/ "/eMc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),

/***/ "/jMQ":
/***/ (function(module, exports) {

/* Copyright @ 2015 Atlassian Pty Ltd
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = function arrayEquals(array) {
    // if the other array is a falsy value, return
    if (!array) return false;

    // compare lengths - can save a lot of time
    if (this.length != array.length) return false;

    for (var i = 0, l = this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!arrayEquals.apply(this[i], [array[i]])) return false;
        } else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal:
            // {x:20} != {x:20}
            return false;
        }
    }
    return true;
};

/***/ }),

/***/ "/sXU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function warning() {};

if (false) {
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),

/***/ "/wuY":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("NB7d")('keys');
var uid = __webpack_require__("X6va");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "/z8I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _EventBaseObject = __webpack_require__("M4O7");

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__("J4Nk");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),

/***/ "/zpV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _colors = __webpack_require__("e1OT");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Typography = function Typography() {
  (0, _classCallCheck3.default)(this, Typography);

  // text colors
  this.textFullBlack = _colors.fullBlack;
  this.textDarkBlack = _colors.darkBlack;
  this.textLightBlack = _colors.lightBlack;
  this.textMinBlack = _colors.minBlack;
  this.textFullWhite = _colors.fullWhite;
  this.textDarkWhite = _colors.darkWhite;
  this.textLightWhite = _colors.lightWhite;

  // font weight
  this.fontWeightLight = 300;
  this.fontWeightNormal = 400;
  this.fontWeightMedium = 500;

  this.fontStyleButtonFontSize = 14;
};

exports.default = new Typography();

/***/ }),

/***/ "0/Oh":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("rtOw");
var isCallable = __webpack_require__("yeFe");

var replacement = /#|\.prototype\./;

var isForced = function isForced(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;

/***/ }),

/***/ "0421":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("b9XL")["default"];

var assertThisInitialized = __webpack_require__("E7HD");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "0Ucg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright @ 2015 Atlassian Pty Ltd
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* global RTCSessionDescription */
/* global RTCIceCandidate */
/* jshint -W097 */


var transform = __webpack_require__("/V2d");
var arrayEquals = __webpack_require__("/jMQ");

function Interop() {

    /**
     * This map holds the most recent Unified Plan offer/answer SDP that was
     * converted to Plan B, with the SDP type ('offer' or 'answer') as keys and
     * the SDP string as values.
     *
     * @type {{}}
     */
    this.cache = {
        mlB2UMap: {},
        mlU2BMap: {}
    };
}

module.exports = Interop;

/**
 * Changes the candidate args to match with the related Unified Plan
 */
Interop.prototype.candidateToUnifiedPlan = function (candidate) {
    var cand = new RTCIceCandidate(candidate);

    cand.sdpMLineIndex = this.cache.mlB2UMap[cand.sdpMLineIndex];
    /* TODO: change sdpMid to (audio|video)-SSRC */

    return cand;
};

/**
 * Changes the candidate args to match with the related Plan B
 */
Interop.prototype.candidateToPlanB = function (candidate) {
    var cand = new RTCIceCandidate(candidate);

    if (cand.sdpMid.indexOf('audio') === 0) {
        cand.sdpMid = 'audio';
    } else if (cand.sdpMid.indexOf('video') === 0) {
        cand.sdpMid = 'video';
    } else {
        throw new Error('candidate with ' + cand.sdpMid + ' not allowed');
    }

    cand.sdpMLineIndex = this.cache.mlU2BMap[cand.sdpMLineIndex];

    return cand;
};

/**
 * Returns the index of the first m-line with the given media type and with a
 * direction which allows sending, in the last Unified Plan description with
 * type "answer" converted to Plan B. Returns {null} if there is no saved
 * answer, or if none of its m-lines with the given type allow sending.
 * @param type the media type ("audio" or "video").
 * @returns {*}
 */
Interop.prototype.getFirstSendingIndexFromAnswer = function (type) {
    if (!this.cache.answer) {
        return null;
    }

    var session = transform.parse(this.cache.answer);
    if (session && session.media && Array.isArray(session.media)) {
        for (var i = 0; i < session.media.length; i++) {
            if (session.media[i].type == type && (!session.media[i].direction /* default to sendrecv */ || session.media[i].direction === 'sendrecv' || session.media[i].direction === 'sendonly')) {
                return i;
            }
        }
    }

    return null;
};

/**
 * This method transforms a Unified Plan SDP to an equivalent Plan B SDP. A
 * PeerConnection wrapper transforms the SDP to Plan B before passing it to the
 * application.
 *
 * @param desc
 * @returns {*}
 */
Interop.prototype.toPlanB = function (desc) {
    var self = this;
    //#region Preliminary input validation.

    if (typeof desc !== 'object' || desc === null || typeof desc.sdp !== 'string') {
        console.warn('An empty description was passed as an argument.');
        return desc;
    }

    // Objectify the SDP for easier manipulation.
    var session = transform.parse(desc.sdp);

    // If the SDP contains no media, there's nothing to transform.
    if (typeof session.media === 'undefined' || !Array.isArray(session.media) || session.media.length === 0) {
        console.warn('The description has no media.');
        return desc;
    }

    // Try some heuristics to "make sure" this is a Unified Plan SDP. Plan B
    // SDP has a video, an audio and a data "channel" at most.
    if (session.media.length <= 3 && session.media.every(function (m) {
        return ['video', 'audio', 'data'].indexOf(m.mid) !== -1;
    })) {
        console.warn('This description does not look like Unified Plan.');
        return desc;
    }

    //#endregion

    // HACK https://bugzilla.mozilla.org/show_bug.cgi?id=1113443
    var sdp = desc.sdp;
    var rewrite = false;
    for (var i = 0; i < session.media.length; i++) {
        var uLine = session.media[i];
        uLine.rtp.forEach(function (rtp) {
            if (rtp.codec === 'NULL') {
                rewrite = true;
                var offer = transform.parse(self.cache.offer);
                rtp.codec = offer.media[i].rtp[0].codec;
            }
        });
    }
    if (rewrite) {
        sdp = transform.write(session);
    }

    // Unified Plan SDP is our "precious". Cache it for later use in the Plan B
    // -> Unified Plan transformation.
    this.cache[desc.type] = sdp;

    //#region Convert from Unified Plan to Plan B.

    // We rebuild the session.media array.
    var media = session.media;
    session.media = [];

    // Associative array that maps channel types to channel objects for fast
    // access to channel objects by their type, e.g. type2bl['audio']->channel
    // obj.
    var type2bl = {};

    // Used to build the group:BUNDLE value after the channels construction
    // loop.
    var types = [];

    media.forEach(function (uLine) {
        // rtcp-mux is required in the Plan B SDP.
        if ((typeof uLine.rtcpMux !== 'string' || uLine.rtcpMux !== 'rtcp-mux') && uLine.direction !== 'inactive') {
            throw new Error('Cannot convert to Plan B because m-lines ' + 'without the rtcp-mux attribute were found.');
        }

        // If we don't have a channel for this uLine.type OR the selected is
        // inactive, then select this uLine as the channel basis.
        if (typeof type2bl[uLine.type] === 'undefined' || type2bl[uLine.type].direction === 'inactive') {
            type2bl[uLine.type] = uLine;
        }

        if (uLine.protocol != type2bl[uLine.type].protocol) {
            throw new Error('Cannot convert to Plan B because m-lines ' + 'have different protocols and this library does not have ' + 'support for that');
        }

        if (uLine.payloads != type2bl[uLine.type].payloads) {
            throw new Error('Cannot convert to Plan B because m-lines ' + 'have different payloads and this library does not have ' + 'support for that');
        }
    });

    // Implode the Unified Plan m-lines/tracks into Plan B channels.
    media.forEach(function (uLine) {
        if (uLine.type === 'application') {
            session.media.push(uLine);
            types.push(uLine.mid);
            return;
        }

        // Add sources to the channel and handle a=msid.
        if (typeof uLine.sources === 'object') {
            Object.keys(uLine.sources).forEach(function (ssrc) {
                if (typeof type2bl[uLine.type].sources !== 'object') type2bl[uLine.type].sources = {};

                // Assign the sources to the channel.
                type2bl[uLine.type].sources[ssrc] = uLine.sources[ssrc];

                if (typeof uLine.msid !== 'undefined') {
                    // In Plan B the msid is an SSRC attribute. Also, we don't
                    // care about the obsolete label and mslabel attributes.
                    //
                    // Note that it is not guaranteed that the uLine will
                    // have an msid. recvonly channels in particular don't have
                    // one.
                    type2bl[uLine.type].sources[ssrc].msid = uLine.msid;
                }
                // NOTE ssrcs in ssrc groups will share msids, as
                // draft-uberti-rtcweb-plan-00 mandates.
            });
        }

        // Add ssrc groups to the channel.
        if (typeof uLine.ssrcGroups !== 'undefined' && Array.isArray(uLine.ssrcGroups)) {

            // Create the ssrcGroups array, if it's not defined.
            if (typeof type2bl[uLine.type].ssrcGroups === 'undefined' || !Array.isArray(type2bl[uLine.type].ssrcGroups)) {
                type2bl[uLine.type].ssrcGroups = [];
            }

            type2bl[uLine.type].ssrcGroups = type2bl[uLine.type].ssrcGroups.concat(uLine.ssrcGroups);
        }

        if (type2bl[uLine.type] === uLine) {
            // Plan B mids are in ['audio', 'video', 'data']
            uLine.mid = uLine.type;

            // Plan B doesn't support/need the bundle-only attribute.
            delete uLine.bundleOnly;

            // In Plan B the msid is an SSRC attribute.
            delete uLine.msid;

            if (uLine.type == media[0].type) {
                types.unshift(uLine.type);
                // Add the channel to the new media array.
                session.media.unshift(uLine);
            } else {
                types.push(uLine.type);
                // Add the channel to the new media array.
                session.media.push(uLine);
            }
        }
    });

    if (typeof session.groups !== 'undefined') {
        // We regenerate the BUNDLE group with the new mids.
        session.groups.some(function (group) {
            if (group.type === 'BUNDLE') {
                group.mids = types.join(' ');
                return true;
            }
        });
    }

    // msid semantic
    session.msidSemantic = {
        semantic: 'WMS',
        token: '*'
    };

    var resStr = transform.write(session);

    return new RTCSessionDescription({
        type: desc.type,
        sdp: resStr
    });

    //#endregion
};

/* follow rules defined in RFC4145 */
function addSetupAttr(uLine) {
    if (typeof uLine.setup === 'undefined') {
        return;
    }

    if (uLine.setup === "active") {
        uLine.setup = "passive";
    } else if (uLine.setup === "passive") {
        uLine.setup = "active";
    }
}

/**
 * This method transforms a Plan B SDP to an equivalent Unified Plan SDP. A
 * PeerConnection wrapper transforms the SDP to Unified Plan before passing it
 * to FF.
 *
 * @param desc
 * @returns {*}
 */
Interop.prototype.toUnifiedPlan = function (desc) {
    var self = this;
    //#region Preliminary input validation.

    if (typeof desc !== 'object' || desc === null || typeof desc.sdp !== 'string') {
        console.warn('An empty description was passed as an argument.');
        return desc;
    }

    var session = transform.parse(desc.sdp);

    // If the SDP contains no media, there's nothing to transform.
    if (typeof session.media === 'undefined' || !Array.isArray(session.media) || session.media.length === 0) {
        console.warn('The description has no media.');
        return desc;
    }

    // Try some heuristics to "make sure" this is a Plan B SDP. Plan B SDP has
    // a video, an audio and a data "channel" at most.
    if (session.media.length > 3 || !session.media.every(function (m) {
        return ['video', 'audio', 'data'].indexOf(m.mid) !== -1;
    })) {
        console.warn('This description does not look like Plan B.');
        return desc;
    }

    // Make sure this Plan B SDP can be converted to a Unified Plan SDP.
    var mids = [];
    session.media.forEach(function (m) {
        mids.push(m.mid);
    });

    var hasBundle = false;
    if (typeof session.groups !== 'undefined' && Array.isArray(session.groups)) {
        hasBundle = session.groups.every(function (g) {
            return g.type !== 'BUNDLE' || arrayEquals.apply(g.mids.sort(), [mids.sort()]);
        });
    }

    if (!hasBundle) {
        var mustBeBundle = false;

        session.media.forEach(function (m) {
            if (m.direction !== 'inactive') {
                mustBeBundle = true;
            }
        });

        if (mustBeBundle) {
            throw new Error("Cannot convert to Unified Plan because m-lines that" + " are not bundled were found.");
        }
    }

    //#endregion


    //#region Convert from Plan B to Unified Plan.

    // Unfortunately, a Plan B offer/answer doesn't have enough information to
    // rebuild an equivalent Unified Plan offer/answer.
    //
    // For example, if this is a local answer (in Unified Plan style) that we
    // convert to Plan B prior to handing it over to the application (the
    // PeerConnection wrapper called us, for instance, after a successful
    // createAnswer), we want to remember the m-line at which we've seen the
    // (local) SSRC. That's because when the application wants to do call the
    // SLD method, forcing us to do the inverse transformation (from Plan B to
    // Unified Plan), we need to know to which m-line to assign the (local)
    // SSRC. We also need to know all the other m-lines that the original
    // answer had and include them in the transformed answer as well.
    //
    // Another example is if this is a remote offer that we convert to Plan B
    // prior to giving it to the application, we want to remember the mid at
    // which we've seen the (remote) SSRC.
    //
    // In the iteration that follows, we use the cached Unified Plan (if it
    // exists) to assign mids to ssrcs.

    var type;
    if (desc.type === 'answer') {
        type = 'offer';
    } else if (desc.type === 'offer') {
        type = 'answer';
    } else {
        throw new Error("Type '" + desc.type + "' not supported.");
    }

    var cached;
    if (typeof this.cache[type] !== 'undefined') {
        cached = transform.parse(this.cache[type]);
    }

    var recvonlySsrcs = {
        audio: {},
        video: {}
    };

    // A helper map that sends mids to m-line objects. We use it later to
    // rebuild the Unified Plan style session.media array.
    var mid2ul = {};
    var bIdx = 0;
    var uIdx = 0;

    var sources2ul = {};

    var candidates;
    var iceUfrag;
    var icePwd;
    var fingerprint;
    var payloads = {};
    var rtcpFb = {};
    var rtp = {};

    session.media.forEach(function (bLine) {
        if ((typeof bLine.rtcpMux !== 'string' || bLine.rtcpMux !== 'rtcp-mux') && bLine.direction !== 'inactive') {
            throw new Error("Cannot convert to Unified Plan because m-lines " + "without the rtcp-mux attribute were found.");
        }

        if (bLine.type === 'application') {
            mid2ul[bLine.mid] = bLine;
            return;
        }

        // With rtcp-mux and bundle all the channels should have the same ICE
        // stuff.
        var sources = bLine.sources;
        var ssrcGroups = bLine.ssrcGroups;
        var port = bLine.port;

        /* Chrome adds different candidates even using bundle, so we concat the candidates list */
        if (typeof bLine.candidates != 'undefined') {
            if (typeof candidates != 'undefined') {
                candidates = candidates.concat(bLine.candidates);
            } else {
                candidates = bLine.candidates;
            }
        }

        if (typeof iceUfrag != 'undefined' && typeof bLine.iceUfrag != 'undefined' && iceUfrag != bLine.iceUfrag) {
            throw new Error("Only BUNDLE supported, iceUfrag must be the same for all m-lines.\n" + "\tLast iceUfrag: " + iceUfrag + "\n" + "\tNew iceUfrag: " + bLine.iceUfrag);
        }

        if (typeof bLine.iceUfrag != 'undefined') {
            iceUfrag = bLine.iceUfrag;
        }

        if (typeof icePwd != 'undefined' && typeof bLine.icePwd != 'undefined' && icePwd != bLine.icePwd) {
            throw new Error("Only BUNDLE supported, icePwd must be the same for all m-lines.\n" + "\tLast icePwd: " + icePwd + "\n" + "\tNew icePwd: " + bLine.icePwd);
        }

        if (typeof bLine.icePwd != 'undefined') {
            icePwd = bLine.icePwd;
        }

        if (typeof fingerprint != 'undefined' && typeof bLine.fingerprint != 'undefined' && (fingerprint.type != bLine.fingerprint.type || fingerprint.hash != bLine.fingerprint.hash)) {
            throw new Error("Only BUNDLE supported, fingerprint must be the same for all m-lines.\n" + "\tLast fingerprint: " + JSON.stringify(fingerprint) + "\n" + "\tNew fingerprint: " + JSON.stringify(bLine.fingerprint));
        }

        if (typeof bLine.fingerprint != 'undefined') {
            fingerprint = bLine.fingerprint;
        }

        payloads[bLine.type] = bLine.payloads;
        rtcpFb[bLine.type] = bLine.rtcpFb;
        rtp[bLine.type] = bLine.rtp;

        // inverted ssrc group map
        var ssrc2group = {};
        if (typeof ssrcGroups !== 'undefined' && Array.isArray(ssrcGroups)) {
            ssrcGroups.forEach(function (ssrcGroup) {
                // XXX This might brake if an SSRC is in more than one group
                // for some reason.
                if (typeof ssrcGroup.ssrcs !== 'undefined' && Array.isArray(ssrcGroup.ssrcs)) {
                    ssrcGroup.ssrcs.forEach(function (ssrc) {
                        if (typeof ssrc2group[ssrc] === 'undefined') {
                            ssrc2group[ssrc] = [];
                        }

                        ssrc2group[ssrc].push(ssrcGroup);
                    });
                }
            });
        }

        // ssrc to m-line index.
        var ssrc2ml = {};

        if (typeof sources === 'object') {

            // We'll use the "bLine" object as a prototype for each new "mLine"
            // that we create, but first we need to clean it up a bit.
            delete bLine.sources;
            delete bLine.ssrcGroups;
            delete bLine.candidates;
            delete bLine.iceUfrag;
            delete bLine.icePwd;
            delete bLine.fingerprint;
            delete bLine.port;
            delete bLine.mid;

            // Explode the Plan B channel sources with one m-line per source.
            Object.keys(sources).forEach(function (ssrc) {

                // The (unified) m-line for this SSRC. We either create it from
                // scratch or, if it's a grouped SSRC, we re-use a related
                // mline. In other words, if the source is grouped with another
                // source, put the two together in the same m-line.
                var uLine;

                // We assume here that we are the answerer in the O/A, so any
                // offers which we translate come from the remote side, while
                // answers are local. So the check below is to make that we
                // handle receive-only SSRCs in a special way only if they come
                // from the remote side.
                if (desc.type === 'offer') {
                    // We want to detect SSRCs which are used by a remote peer
                    // in an m-line with direction=recvonly (i.e. they are
                    // being used for RTCP only).
                    // This information would have gotten lost if the remote
                    // peer used Unified Plan and their local description was
                    // translated to Plan B. So we use the lack of an MSID
                    // attribute to deduce a "receive only" SSRC.
                    if (!sources[ssrc].msid) {
                        recvonlySsrcs[bLine.type][ssrc] = sources[ssrc];
                        // Receive-only SSRCs must not create new m-lines. We
                        // will assign them to an existing m-line later.
                        return;
                    }
                }

                if (typeof ssrc2group[ssrc] !== 'undefined' && Array.isArray(ssrc2group[ssrc])) {
                    ssrc2group[ssrc].some(function (ssrcGroup) {
                        // ssrcGroup.ssrcs *is* an Array, no need to check
                        // again here.
                        return ssrcGroup.ssrcs.some(function (related) {
                            if (typeof ssrc2ml[related] === 'object') {
                                uLine = ssrc2ml[related];
                                return true;
                            }
                        });
                    });
                }

                if (typeof uLine === 'object') {
                    // the m-line already exists. Just add the source.
                    uLine.sources[ssrc] = sources[ssrc];
                    delete sources[ssrc].msid;
                } else {
                    // Use the "bLine" as a prototype for the "uLine".
                    uLine = Object.create(bLine);
                    ssrc2ml[ssrc] = uLine;

                    if (typeof sources[ssrc].msid !== 'undefined') {
                        // Assign the msid of the source to the m-line. Note
                        // that it is not guaranteed that the source will have
                        // msid. In particular "recvonly" sources don't have an
                        // msid. Note that "recvonly" is a term only defined
                        // for m-lines.
                        uLine.msid = sources[ssrc].msid;
                        delete sources[ssrc].msid;
                    }

                    // We assign one SSRC per media line.
                    uLine.sources = {};
                    uLine.sources[ssrc] = sources[ssrc];
                    uLine.ssrcGroups = ssrc2group[ssrc];

                    // Use the cached Unified Plan SDP (if it exists) to assign
                    // SSRCs to mids.
                    if (typeof cached !== 'undefined' && typeof cached.media !== 'undefined' && Array.isArray(cached.media)) {

                        cached.media.forEach(function (m) {
                            if (typeof m.sources === 'object') {
                                Object.keys(m.sources).forEach(function (s) {
                                    if (s === ssrc) {
                                        uLine.mid = m.mid;
                                    }
                                });
                            }
                        });
                    }

                    if (typeof uLine.mid === 'undefined') {

                        // If this is an SSRC that we see for the first time
                        // assign it a new mid. This is typically the case when
                        // this method is called to transform a remote
                        // description for the first time or when there is a
                        // new SSRC in the remote description because a new
                        // peer has joined the conference. Local SSRCs should
                        // have already been added to the map in the toPlanB
                        // method.
                        //
                        // Because FF generates answers in Unified Plan style,
                        // we MUST already have a cached answer with all the
                        // local SSRCs mapped to some m-line/mid.

                        uLine.mid = [bLine.type, '-', ssrc].join('');
                    }

                    // Include the candidates in the 1st media line.
                    uLine.candidates = candidates;
                    uLine.iceUfrag = iceUfrag;
                    uLine.icePwd = icePwd;
                    uLine.fingerprint = fingerprint;
                    uLine.port = port;

                    mid2ul[uLine.mid] = uLine;
                    sources2ul[uIdx] = uLine.sources;

                    self.cache.mlU2BMap[uIdx] = bIdx;
                    if (typeof self.cache.mlB2UMap[bIdx] === 'undefined') {
                        self.cache.mlB2UMap[bIdx] = uIdx;
                    }
                    uIdx++;
                }
            });
        } else {
            var uLine = bLine;

            uLine.candidates = candidates;
            uLine.iceUfrag = iceUfrag;
            uLine.icePwd = icePwd;
            uLine.fingerprint = fingerprint;
            uLine.port = port;

            mid2ul[uLine.mid] = uLine;

            self.cache.mlU2BMap[uIdx] = bIdx;
            if (typeof self.cache.mlB2UMap[bIdx] === 'undefined') {
                self.cache.mlB2UMap[bIdx] = uIdx;
            }
        }

        bIdx++;
    });

    // Rebuild the media array in the right order and add the missing mLines
    // (missing from the Plan B SDP).
    session.media = [];
    mids = []; // reuse

    if (desc.type === 'answer') {

        // The media lines in the answer must match the media lines in the
        // offer. The order is important too. Here we assume that Firefox is
        // the answerer, so we merely have to use the reconstructed (unified)
        // answer to update the cached (unified) answer accordingly.
        //
        // In the general case, one would have to use the cached (unified)
        // offer to find the m-lines that are missing from the reconstructed
        // answer, potentially grabbing them from the cached (unified) answer.
        // One has to be careful with this approach because inactive m-lines do
        // not always have an mid, making it tricky (impossible?) to find where
        // exactly and which m-lines are missing from the reconstructed answer.

        for (var i = 0; i < cached.media.length; i++) {
            var uLine = cached.media[i];

            delete uLine.msid;
            delete uLine.sources;
            delete uLine.ssrcGroups;

            if (typeof sources2ul[i] === 'undefined') {
                if (!uLine.direction || uLine.direction === 'sendrecv') uLine.direction = 'recvonly';else if (uLine.direction === 'sendonly') uLine.direction = 'inactive';
            } else {
                if (!uLine.direction || uLine.direction === 'sendrecv') uLine.direction = 'sendrecv';else if (uLine.direction === 'recvonly') uLine.direction = 'sendonly';
            }

            uLine.sources = sources2ul[i];
            uLine.candidates = candidates;
            uLine.iceUfrag = iceUfrag;
            uLine.icePwd = icePwd;
            uLine.fingerprint = fingerprint;

            uLine.rtp = rtp[uLine.type];
            uLine.payloads = payloads[uLine.type];
            uLine.rtcpFb = rtcpFb[uLine.type];

            session.media.push(uLine);

            if (typeof uLine.mid === 'string') {
                // inactive lines don't/may not have an mid.
                mids.push(uLine.mid);
            }
        }
    } else {

        // SDP offer/answer (and the JSEP spec) forbids removing an m-section
        // under any circumstances. If we are no longer interested in sending a
        // track, we just remove the msid and ssrc attributes and set it to
        // either a=recvonly (as the reofferer, we must use recvonly if the
        // other side was previously sending on the m-section, but we can also
        // leave the possibility open if it wasn't previously in use), or
        // a=inactive.

        if (typeof cached !== 'undefined' && typeof cached.media !== 'undefined' && Array.isArray(cached.media)) {
            cached.media.forEach(function (uLine) {
                mids.push(uLine.mid);
                if (typeof mid2ul[uLine.mid] !== 'undefined') {
                    session.media.push(mid2ul[uLine.mid]);
                } else {
                    delete uLine.msid;
                    delete uLine.sources;
                    delete uLine.ssrcGroups;

                    if (!uLine.direction || uLine.direction === 'sendrecv') {
                        uLine.direction = 'sendonly';
                    }
                    if (!uLine.direction || uLine.direction === 'recvonly') {
                        uLine.direction = 'inactive';
                    }

                    addSetupAttr(uLine);
                    session.media.push(uLine);
                }
            });
        }

        // Add all the remaining (new) m-lines of the transformed SDP.
        Object.keys(mid2ul).forEach(function (mid) {
            if (mids.indexOf(mid) === -1) {
                mids.push(mid);
                if (mid2ul[mid].direction === 'recvonly') {
                    // This is a remote recvonly channel. Add its SSRC to the
                    // appropriate sendrecv or sendonly channel.
                    // TODO(gp) what if we don't have sendrecv/sendonly
                    // channel?

                    var done = false;

                    session.media.some(function (uLine) {
                        if ((uLine.direction === 'sendrecv' || uLine.direction === 'sendonly') && uLine.type === mid2ul[mid].type) {
                            // mid2ul[mid] shouldn't have any ssrc-groups
                            Object.keys(mid2ul[mid].sources).forEach(function (ssrc) {
                                uLine.sources[ssrc] = mid2ul[mid].sources[ssrc];
                            });

                            done = true;
                            return true;
                        }
                    });

                    if (!done) {
                        session.media.push(mid2ul[mid]);
                    }
                } else {
                    session.media.push(mid2ul[mid]);
                }
            }
        });
    }

    // After we have constructed the Plan Unified m-lines we can figure out
    // where (in which m-line) to place the 'recvonly SSRCs'.
    // Note: we assume here that we are the answerer in the O/A, so any offers
    // which we translate come from the remote side, while answers are local
    // (and so our last local description is cached as an 'answer').
    ["audio", "video"].forEach(function (type) {
        if (!session || !session.media || !Array.isArray(session.media)) return;

        var idx = null;
        if (Object.keys(recvonlySsrcs[type]).length > 0) {
            idx = self.getFirstSendingIndexFromAnswer(type);
            if (idx === null) {
                // If this is the first offer we receive, we don't have a
                // cached answer. Assume that we will be sending media using
                // the first m-line for each media type.

                for (var i = 0; i < session.media.length; i++) {
                    if (session.media[i].type === type) {
                        idx = i;
                        break;
                    }
                }
            }
        }

        if (idx && session.media.length > idx) {
            var mLine = session.media[idx];
            Object.keys(recvonlySsrcs[type]).forEach(function (ssrc) {
                if (mLine.sources && mLine.sources[ssrc]) {
                    console.warn("Replacing an existing SSRC.");
                }
                if (!mLine.sources) {
                    mLine.sources = {};
                }

                mLine.sources[ssrc] = recvonlySsrcs[type][ssrc];
            });
        }
    });

    if (typeof session.groups !== 'undefined') {
        // We regenerate the BUNDLE group (since we regenerated the mids)
        session.groups.some(function (group) {
            if (group.type === 'BUNDLE') {
                group.mids = mids.join(' ');
                return true;
            }
        });
    }

    // msid semantic
    session.msidSemantic = {
        semantic: 'WMS',
        token: '*'
    };

    var resStr = transform.write(session);

    // Cache the transformed SDP (Unified Plan) for later re-use in this
    // function.
    this.cache[desc.type] = resStr;

    return new RTCSessionDescription({
        type: desc.type,
        sdp: resStr
    });

    //#endregion
};

/***/ }),

/***/ "0WCH":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "0fcM":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "0guB":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var TO_STRING_TAG_SUPPORT = __webpack_require__("5VJ8");
var isCallable = __webpack_require__("yeFe");
var classofRaw = __webpack_require__("UNYT");
var wellKnownSymbol = __webpack_require__("G69i");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (error) {/* empty */}
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
  // builtinTag case
  : CORRECT_ARGUMENTS ? classofRaw(O)
  // ES3 arguments fallback
  : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

/***/ }),

/***/ "11Ut":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("Gfzd").f;
var has = __webpack_require__("yS17");
var TAG = __webpack_require__("Ug9I")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),

/***/ "15a7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
// CONCATENATED MODULE: ../node_modules/reselect/es/index.js
/* unused harmony export createSelectorCreator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSelector; });
/* unused harmony export createStructuredSelector */
/* unused concated harmony import defaultMemoize */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultMemoize; });
/* unused concated harmony import defaultEqualityCheck */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultEqualityCheck; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function () {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    _extends(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};

/***/ }),

/***/ "18l1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__("rQKw");

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var values = {
  flex: true,
  'inline-flex': true
};
function flex(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "1Hmk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

/***/ }),

/***/ "1PPX":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");
var aCallable = __webpack_require__("oOss");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind ? bind(fn, that) : function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "1QDr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__("Ku7I");

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),

/***/ "1UNZ":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

/***/ }),

/***/ "1kal":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var isObject = __webpack_require__("FS7x");

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};

/***/ }),

/***/ "1kq3":
/***/ (function(module, exports) {

module.exports = true;

/***/ }),

/***/ "2+7m":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("2112");
var uid = __webpack_require__("MCkq");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

/***/ }),

/***/ "2112":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("oj7W");
var store = __webpack_require__("kERb");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.19.3',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "25e4":
/***/ (function(module, exports) {

module.exports = {};

/***/ }),

/***/ "2JJl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty,
    prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once),
      evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = [],
      events,
      name;

  if (this._eventsCount === 0) return names;

  for (name in events = this._events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event,
      handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event,
      listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1:
        return listeners.fn.call(listeners.context), true;
      case 2:
        return listeners.fn.call(listeners.context, a1), true;
      case 3:
        return listeners.fn.call(listeners.context, a1, a2), true;
      case 4:
        return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len - 1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length,
        j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1:
          listeners[i].fn.call(listeners[i].context);break;
        case 2:
          listeners[i].fn.call(listeners[i].context, a1);break;
        case 3:
          listeners[i].fn.call(listeners[i].context, a1, a2);break;
        case 4:
          listeners[i].fn.call(listeners[i].context, a1, a2, a3);break;
        default:
          if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}

/***/ }),

/***/ "2gTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "2kK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requiredArgs;
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ "2mwf":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c2zY")('observable');

/***/ }),

/***/ "2pTr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__("VxKF");
var callBind = __webpack_require__("y9YS");

var implementation = __webpack_require__("4md/");
var getPolyfill = __webpack_require__("TyWm");
var shim = __webpack_require__("Fi9R");

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;

/***/ }),

/***/ "2tBI":
/***/ (function(module, exports, __webpack_require__) {

var grammar = __webpack_require__("F2TU");

// customized util.format - discards excess arguments and can void middle ones
var formatRegExp = /%[sdv%]/g;
var format = function format(formatStr) {
  var i = 1;
  var args = arguments;
  var len = args.length;
  return formatStr.replace(formatRegExp, function (x) {
    if (i >= len) {
      return x; // missing argument
    }
    var arg = args[i];
    i += 1;
    switch (x) {
      case '%%':
        return '%';
      case '%s':
        return String(arg);
      case '%d':
        return Number(arg);
      case '%v':
        return '';
    }
  });
  // NB: we discard excess arguments - they are typically undefined from makeLine
};

var makeLine = function makeLine(type, obj, location) {
  var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;

  var args = [type + '=' + str];
  if (obj.names) {
    for (var i = 0; i < obj.names.length; i += 1) {
      var n = obj.names[i];
      if (obj.name) {
        args.push(location[obj.name][n]);
      } else {
        // for mLine and push attributes
        args.push(location[obj.names[i]]);
      }
    }
  } else {
    args.push(location[obj.name]);
  }
  return format.apply(null, args);
};

// RFC specified order
// TODO: extend this with all the rest
var defaultOuterOrder = ['v', 'o', 's', 'i', 'u', 'e', 'p', 'c', 'b', 't', 'r', 'z', 'a'];
var defaultInnerOrder = ['i', 'c', 'b', 'a'];

module.exports = function (session, opts) {
  opts = opts || {};
  // ensure certain properties exist
  if (session.version == null) {
    session.version = 0; // "v=0" must be there (only defined version atm)
  }
  if (session.name == null) {
    session.name = " "; // "s= " must be there if no meaningful name set
  }
  session.media.forEach(function (mLine) {
    if (mLine.payloads == null) {
      mLine.payloads = "";
    }
  });

  var outerOrder = opts.outerOrder || defaultOuterOrder;
  var innerOrder = opts.innerOrder || defaultInnerOrder;
  var sdp = [];

  // loop through outerOrder for matching properties on session
  outerOrder.forEach(function (type) {
    grammar[type].forEach(function (obj) {
      if (obj.name in session && session[obj.name] != null) {
        sdp.push(makeLine(type, obj, session));
      } else if (obj.push in session && session[obj.push] != null) {
        session[obj.push].forEach(function (el) {
          sdp.push(makeLine(type, obj, el));
        });
      }
    });
  });

  // then for each media line, follow the innerOrder
  session.media.forEach(function (mLine) {
    sdp.push(makeLine('m', grammar.m[0], mLine));

    innerOrder.forEach(function (type) {
      grammar[type].forEach(function (obj) {
        if (obj.name in mLine && mLine[obj.name] != null) {
          sdp.push(makeLine(type, obj, mLine));
        } else if (obj.push in mLine && mLine[obj.push] != null) {
          mLine[obj.push].forEach(function (el) {
            sdp.push(makeLine(type, obj, el));
          });
        }
      });
    });
  });

  return sdp.join('\r\n') + '\r\n';
};

/***/ }),

/***/ "31EJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("o9aU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_langPack__ = __webpack_require__("9dRJ");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import { changeLocale, changeLocaleLangs } from '../../../actions/user';



var SearchInput = function (_Component) {
  _inherits(SearchInput, _Component);

  function SearchInput() {
    var _temp, _this, _ret;

    _classCallCheck(this, SearchInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.performSearch = function () {
      _this.props.onSearch();
      firebase.analytics().logEvent('Tap_on_the_Search_bar');
    }, _this.changeHandler = function (e) {
      if (_this.props.value !== e.target.value) {
        _this.props.onChange(e.target.value);
      }
    }, _this.keyHandler = function (e) {
      if (e.keyCode === 13) {
        _this.props.onSearch();
        firebase.analytics().logEvent('Tap_on_the_Search_bar');
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SearchInput.prototype.render = function render(_ref) {
    var value = _ref.value,
        placeholder = _ref.placeholder,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: className + ' ' + __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.searchContainer },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
        placeholder: placeholder || __WEBPACK_IMPORTED_MODULE_2__utils_langPack__["a" /* langPack */][this.props.locale].SEARCH.ENTER_KEYWORDS,
        className: __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.serchInput,
        value: value,
        onKeyUp: this.changeHandler,
        onKeyDown: this.keyHandler
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', {
        'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.searchIcon,
        onClick: this.performSearch
      })
    );
  };

  return SearchInput;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SearchInput);

/***/ }),

/***/ "3Dq6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("1QDr");

/***/ }),

/***/ "3Lw+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  drawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};

/***/ }),

/***/ "3dLy":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "3dqK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"callAreaBackground":"callAreaBackground__hyvUt","callArea":"callArea__RQGPc","closeBtn":"closeBtn__2zG_9"};

/***/ }),

/***/ "3v7p":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("htFH");
var $Object = __webpack_require__("zKeE").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

/***/ }),

/***/ "3yko":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _classCallCheck = _interopDefault(__webpack_require__("0fcM"));
var _createClass = _interopDefault(__webpack_require__("P8NW"));
var _possibleConstructorReturn = _interopDefault(__webpack_require__("0421"));
var _getPrototypeOf = _interopDefault(__webpack_require__("UJE0"));
var _inherits = _interopDefault(__webpack_require__("d4H2"));
var _typeof = _interopDefault(__webpack_require__("b9XL"));
var _objectWithoutProperties = _interopDefault(__webpack_require__("U8F3"));
var _extends = _interopDefault(__webpack_require__("3dLy"));
var React = _interopDefault(__webpack_require__("eW0v"));
var PropTypes = _interopDefault(__webpack_require__("5D9O"));
var warning = _interopDefault(__webpack_require__("zI/n"));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;

/***/ }),

/***/ "3zRh":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("g31e");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "45fX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _utils = __webpack_require__("yd8v");

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__("kD/w");

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__("cX2q");

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),

/***/ "49hf":
/***/ (function(module, exports) {

function copy(src, dest) {
	for (var p in src) {
		dest[p] = src[p];
	}
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */
function _extends(Class, Super) {
	var pt = Class.prototype;
	if (!(pt instanceof Super)) {
		var t = function t() {};

		;
		t.prototype = Super.prototype;
		t = new t();
		copy(pt, t);
		Class.prototype = pt = t;
	}
	if (pt.constructor != Class) {
		if (typeof Class != 'function') {
			console.error("unknow Class:" + Class);
		}
		pt.constructor = Class;
	}
}
var htmlns = 'http://www.w3.org/1999/xhtml';
// Node Types
var NodeType = {};
var ELEMENT_NODE = NodeType.ELEMENT_NODE = 1;
var ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2;
var TEXT_NODE = NodeType.TEXT_NODE = 3;
var CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4;
var ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5;
var ENTITY_NODE = NodeType.ENTITY_NODE = 6;
var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var COMMENT_NODE = NodeType.COMMENT_NODE = 8;
var DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9;
var DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10;
var DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var NOTATION_NODE = NodeType.NOTATION_NODE = 12;

// ExceptionCode
var ExceptionCode = {};
var ExceptionMessage = {};
var INDEX_SIZE_ERR = ExceptionCode.INDEX_SIZE_ERR = (ExceptionMessage[1] = "Index size error", 1);
var DOMSTRING_SIZE_ERR = ExceptionCode.DOMSTRING_SIZE_ERR = (ExceptionMessage[2] = "DOMString size error", 2);
var HIERARCHY_REQUEST_ERR = ExceptionCode.HIERARCHY_REQUEST_ERR = (ExceptionMessage[3] = "Hierarchy request error", 3);
var WRONG_DOCUMENT_ERR = ExceptionCode.WRONG_DOCUMENT_ERR = (ExceptionMessage[4] = "Wrong document", 4);
var INVALID_CHARACTER_ERR = ExceptionCode.INVALID_CHARACTER_ERR = (ExceptionMessage[5] = "Invalid character", 5);
var NO_DATA_ALLOWED_ERR = ExceptionCode.NO_DATA_ALLOWED_ERR = (ExceptionMessage[6] = "No data allowed", 6);
var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = (ExceptionMessage[7] = "No modification allowed", 7);
var NOT_FOUND_ERR = ExceptionCode.NOT_FOUND_ERR = (ExceptionMessage[8] = "Not found", 8);
var NOT_SUPPORTED_ERR = ExceptionCode.NOT_SUPPORTED_ERR = (ExceptionMessage[9] = "Not supported", 9);
var INUSE_ATTRIBUTE_ERR = ExceptionCode.INUSE_ATTRIBUTE_ERR = (ExceptionMessage[10] = "Attribute in use", 10);
//level2
var INVALID_STATE_ERR = ExceptionCode.INVALID_STATE_ERR = (ExceptionMessage[11] = "Invalid state", 11);
var SYNTAX_ERR = ExceptionCode.SYNTAX_ERR = (ExceptionMessage[12] = "Syntax error", 12);
var INVALID_MODIFICATION_ERR = ExceptionCode.INVALID_MODIFICATION_ERR = (ExceptionMessage[13] = "Invalid modification", 13);
var NAMESPACE_ERR = ExceptionCode.NAMESPACE_ERR = (ExceptionMessage[14] = "Invalid namespace", 14);
var INVALID_ACCESS_ERR = ExceptionCode.INVALID_ACCESS_ERR = (ExceptionMessage[15] = "Invalid access", 15);

/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */
function DOMException(code, message) {
	if (message instanceof Error) {
		var error = message;
	} else {
		error = this;
		Error.call(this, ExceptionMessage[code]);
		this.message = ExceptionMessage[code];
		if (Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
	}
	error.code = code;
	if (message) this.message = this.message + ": " + message;
	return error;
};
DOMException.prototype = Error.prototype;
copy(ExceptionCode, DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */
function NodeList() {};
NodeList.prototype = {
	/**
  * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
  * @standard level1
  */
	length: 0,
	/**
  * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
  * @standard level1
  * @param index  unsigned long 
  *   Index into the collection.
  * @return Node
  * 	The node at the indexth position in the NodeList, or null if that is not a valid index. 
  */
	item: function item(index) {
		return this[index] || null;
	},
	toString: function toString(isHTML, nodeFilter) {
		for (var buf = [], i = 0; i < this.length; i++) {
			serializeToString(this[i], buf, isHTML, nodeFilter);
		}
		return buf.join('');
	}
};
function LiveNodeList(node, refresh) {
	this._node = node;
	this._refresh = refresh;
	_updateLiveList(this);
}
function _updateLiveList(list) {
	var inc = list._node._inc || list._node.ownerDocument._inc;
	if (list._inc != inc) {
		var ls = list._refresh(list._node);
		//console.log(ls.length)
		__set__(list, 'length', ls.length);
		copy(ls, list);
		list._inc = inc;
	}
}
LiveNodeList.prototype.item = function (i) {
	_updateLiveList(this);
	return this[i];
};

_extends(LiveNodeList, NodeList);
/**
 * 
 * Objects implementing the NamedNodeMap interface are used to represent collections of nodes that can be accessed by name. Note that NamedNodeMap does not inherit from NodeList; NamedNodeMaps are not maintained in any particular order. Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index, but this is simply to allow convenient enumeration of the contents of a NamedNodeMap, and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities 
 */
function NamedNodeMap() {};

function _findNodeIndex(list, node) {
	var i = list.length;
	while (i--) {
		if (list[i] === node) {
			return i;
		}
	}
}

function _addNamedNode(el, list, newAttr, oldAttr) {
	if (oldAttr) {
		list[_findNodeIndex(list, oldAttr)] = newAttr;
	} else {
		list[list.length++] = newAttr;
	}
	if (el) {
		newAttr.ownerElement = el;
		var doc = el.ownerDocument;
		if (doc) {
			oldAttr && _onRemoveAttribute(doc, el, oldAttr);
			_onAddAttribute(doc, el, newAttr);
		}
	}
}
function _removeNamedNode(el, list, attr) {
	//console.log('remove attr:'+attr)
	var i = _findNodeIndex(list, attr);
	if (i >= 0) {
		var lastIndex = list.length - 1;
		while (i < lastIndex) {
			list[i] = list[++i];
		}
		list.length = lastIndex;
		if (el) {
			var doc = el.ownerDocument;
			if (doc) {
				_onRemoveAttribute(doc, el, attr);
				attr.ownerElement = null;
			}
		}
	} else {
		throw DOMException(NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
	}
}
NamedNodeMap.prototype = {
	length: 0,
	item: NodeList.prototype.item,
	getNamedItem: function getNamedItem(key) {
		//		if(key.indexOf(':')>0 || key == 'xmlns'){
		//			return null;
		//		}
		//console.log()
		var i = this.length;
		while (i--) {
			var attr = this[i];
			//console.log(attr.nodeName,key)
			if (attr.nodeName == key) {
				return attr;
			}
		}
	},
	setNamedItem: function setNamedItem(attr) {
		var el = attr.ownerElement;
		if (el && el != this._ownerElement) {
			throw new DOMException(INUSE_ATTRIBUTE_ERR);
		}
		var oldAttr = this.getNamedItem(attr.nodeName);
		_addNamedNode(this._ownerElement, this, attr, oldAttr);
		return oldAttr;
	},
	/* returns Node */
	setNamedItemNS: function setNamedItemNS(attr) {
		// raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
		var el = attr.ownerElement,
		    oldAttr;
		if (el && el != this._ownerElement) {
			throw new DOMException(INUSE_ATTRIBUTE_ERR);
		}
		oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
		_addNamedNode(this._ownerElement, this, attr, oldAttr);
		return oldAttr;
	},

	/* returns Node */
	removeNamedItem: function removeNamedItem(key) {
		var attr = this.getNamedItem(key);
		_removeNamedNode(this._ownerElement, this, attr);
		return attr;
	}, // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR

	//for level2
	removeNamedItemNS: function removeNamedItemNS(namespaceURI, localName) {
		var attr = this.getNamedItemNS(namespaceURI, localName);
		_removeNamedNode(this._ownerElement, this, attr);
		return attr;
	},
	getNamedItemNS: function getNamedItemNS(namespaceURI, localName) {
		var i = this.length;
		while (i--) {
			var node = this[i];
			if (node.localName == localName && node.namespaceURI == namespaceURI) {
				return node;
			}
		}
		return null;
	}
};
/**
 * @see http://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490
 */
function DOMImplementation( /* Object */features) {
	this._features = {};
	if (features) {
		for (var feature in features) {
			this._features = features[feature];
		}
	}
};

DOMImplementation.prototype = {
	hasFeature: function hasFeature( /* string */feature, /* string */version) {
		var versions = this._features[feature.toLowerCase()];
		if (versions && (!version || version in versions)) {
			return true;
		} else {
			return false;
		}
	},
	// Introduced in DOM Level 2:
	createDocument: function createDocument(namespaceURI, qualifiedName, doctype) {
		// raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR,WRONG_DOCUMENT_ERR
		var doc = new Document();
		doc.implementation = this;
		doc.childNodes = new NodeList();
		doc.doctype = doctype;
		if (doctype) {
			doc.appendChild(doctype);
		}
		if (qualifiedName) {
			var root = doc.createElementNS(namespaceURI, qualifiedName);
			doc.appendChild(root);
		}
		return doc;
	},
	// Introduced in DOM Level 2:
	createDocumentType: function createDocumentType(qualifiedName, publicId, systemId) {
		// raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR
		var node = new DocumentType();
		node.name = qualifiedName;
		node.nodeName = qualifiedName;
		node.publicId = publicId;
		node.systemId = systemId;
		// Introduced in DOM Level 2:
		//readonly attribute DOMString        internalSubset;

		//TODO:..
		//  readonly attribute NamedNodeMap     entities;
		//  readonly attribute NamedNodeMap     notations;
		return node;
	}
};

/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */

function Node() {};

Node.prototype = {
	firstChild: null,
	lastChild: null,
	previousSibling: null,
	nextSibling: null,
	attributes: null,
	parentNode: null,
	childNodes: null,
	ownerDocument: null,
	nodeValue: null,
	namespaceURI: null,
	prefix: null,
	localName: null,
	// Modified in DOM Level 2:
	insertBefore: function insertBefore(newChild, refChild) {
		//raises 
		return _insertBefore(this, newChild, refChild);
	},
	replaceChild: function replaceChild(newChild, oldChild) {
		//raises 
		this.insertBefore(newChild, oldChild);
		if (oldChild) {
			this.removeChild(oldChild);
		}
	},
	removeChild: function removeChild(oldChild) {
		return _removeChild(this, oldChild);
	},
	appendChild: function appendChild(newChild) {
		return this.insertBefore(newChild, null);
	},
	hasChildNodes: function hasChildNodes() {
		return this.firstChild != null;
	},
	cloneNode: function cloneNode(deep) {
		return _cloneNode(this.ownerDocument || this, this, deep);
	},
	// Modified in DOM Level 2:
	normalize: function normalize() {
		var child = this.firstChild;
		while (child) {
			var next = child.nextSibling;
			if (next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE) {
				this.removeChild(next);
				child.appendData(next.data);
			} else {
				child.normalize();
				child = next;
			}
		}
	},
	// Introduced in DOM Level 2:
	isSupported: function isSupported(feature, version) {
		return this.ownerDocument.implementation.hasFeature(feature, version);
	},
	// Introduced in DOM Level 2:
	hasAttributes: function hasAttributes() {
		return this.attributes.length > 0;
	},
	lookupPrefix: function lookupPrefix(namespaceURI) {
		var el = this;
		while (el) {
			var map = el._nsMap;
			//console.dir(map)
			if (map) {
				for (var n in map) {
					if (map[n] == namespaceURI) {
						return n;
					}
				}
			}
			el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
		}
		return null;
	},
	// Introduced in DOM Level 3:
	lookupNamespaceURI: function lookupNamespaceURI(prefix) {
		var el = this;
		while (el) {
			var map = el._nsMap;
			//console.dir(map)
			if (map) {
				if (prefix in map) {
					return map[prefix];
				}
			}
			el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
		}
		return null;
	},
	// Introduced in DOM Level 3:
	isDefaultNamespace: function isDefaultNamespace(namespaceURI) {
		var prefix = this.lookupPrefix(namespaceURI);
		return prefix == null;
	}
};

function _xmlEncoder(c) {
	return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}

copy(NodeType, Node);
copy(NodeType, Node.prototype);

/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */
function _visitNode(node, callback) {
	if (callback(node)) {
		return true;
	}
	if (node = node.firstChild) {
		do {
			if (_visitNode(node, callback)) {
				return true;
			}
		} while (node = node.nextSibling);
	}
}

function Document() {}
function _onAddAttribute(doc, el, newAttr) {
	doc && doc._inc++;
	var ns = newAttr.namespaceURI;
	if (ns == 'http://www.w3.org/2000/xmlns/') {
		//update namespace
		el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
	}
}
function _onRemoveAttribute(doc, el, newAttr, remove) {
	doc && doc._inc++;
	var ns = newAttr.namespaceURI;
	if (ns == 'http://www.w3.org/2000/xmlns/') {
		//update namespace
		delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
	}
}
function _onUpdateChild(doc, el, newChild) {
	if (doc && doc._inc) {
		doc._inc++;
		//update childNodes
		var cs = el.childNodes;
		if (newChild) {
			cs[cs.length++] = newChild;
		} else {
			//console.log(1)
			var child = el.firstChild;
			var i = 0;
			while (child) {
				cs[i++] = child;
				child = child.nextSibling;
			}
			cs.length = i;
		}
	}
}

/**
 * attributes;
 * children;
 * 
 * writeable properties:
 * nodeValue,Attr:value,CharacterData:data
 * prefix
 */
function _removeChild(parentNode, child) {
	var previous = child.previousSibling;
	var next = child.nextSibling;
	if (previous) {
		previous.nextSibling = next;
	} else {
		parentNode.firstChild = next;
	}
	if (next) {
		next.previousSibling = previous;
	} else {
		parentNode.lastChild = previous;
	}
	_onUpdateChild(parentNode.ownerDocument, parentNode);
	return child;
}
/**
 * preformance key(refChild == null)
 */
function _insertBefore(parentNode, newChild, nextChild) {
	var cp = newChild.parentNode;
	if (cp) {
		cp.removeChild(newChild); //remove and update
	}
	if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
		var newFirst = newChild.firstChild;
		if (newFirst == null) {
			return newChild;
		}
		var newLast = newChild.lastChild;
	} else {
		newFirst = newLast = newChild;
	}
	var pre = nextChild ? nextChild.previousSibling : parentNode.lastChild;

	newFirst.previousSibling = pre;
	newLast.nextSibling = nextChild;

	if (pre) {
		pre.nextSibling = newFirst;
	} else {
		parentNode.firstChild = newFirst;
	}
	if (nextChild == null) {
		parentNode.lastChild = newLast;
	} else {
		nextChild.previousSibling = newLast;
	}
	do {
		newFirst.parentNode = parentNode;
	} while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
	_onUpdateChild(parentNode.ownerDocument || parentNode, parentNode);
	//console.log(parentNode.lastChild.nextSibling == null)
	if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
		newChild.firstChild = newChild.lastChild = null;
	}
	return newChild;
}
function _appendSingleChild(parentNode, newChild) {
	var cp = newChild.parentNode;
	if (cp) {
		var pre = parentNode.lastChild;
		cp.removeChild(newChild); //remove and update
		var pre = parentNode.lastChild;
	}
	var pre = parentNode.lastChild;
	newChild.parentNode = parentNode;
	newChild.previousSibling = pre;
	newChild.nextSibling = null;
	if (pre) {
		pre.nextSibling = newChild;
	} else {
		parentNode.firstChild = newChild;
	}
	parentNode.lastChild = newChild;
	_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
	return newChild;
	//console.log("__aa",parentNode.lastChild.nextSibling == null)
}
Document.prototype = {
	//implementation : null,
	nodeName: '#document',
	nodeType: DOCUMENT_NODE,
	doctype: null,
	documentElement: null,
	_inc: 1,

	insertBefore: function insertBefore(newChild, refChild) {
		//raises 
		if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
			var child = newChild.firstChild;
			while (child) {
				var next = child.nextSibling;
				this.insertBefore(child, refChild);
				child = next;
			}
			return newChild;
		}
		if (this.documentElement == null && newChild.nodeType == ELEMENT_NODE) {
			this.documentElement = newChild;
		}

		return _insertBefore(this, newChild, refChild), newChild.ownerDocument = this, newChild;
	},
	removeChild: function removeChild(oldChild) {
		if (this.documentElement == oldChild) {
			this.documentElement = null;
		}
		return _removeChild(this, oldChild);
	},
	// Introduced in DOM Level 2:
	importNode: function importNode(importedNode, deep) {
		return _importNode(this, importedNode, deep);
	},
	// Introduced in DOM Level 2:
	getElementById: function getElementById(id) {
		var rtv = null;
		_visitNode(this.documentElement, function (node) {
			if (node.nodeType == ELEMENT_NODE) {
				if (node.getAttribute('id') == id) {
					rtv = node;
					return true;
				}
			}
		});
		return rtv;
	},

	getElementsByClassName: function getElementsByClassName(className) {
		var pattern = new RegExp("(^|\\s)" + className + "(\\s|$)");
		return new LiveNodeList(this, function (base) {
			var ls = [];
			_visitNode(base.documentElement, function (node) {
				if (node !== base && node.nodeType == ELEMENT_NODE) {
					if (pattern.test(node.getAttribute('class'))) {
						ls.push(node);
					}
				}
			});
			return ls;
		});
	},

	//document factory method:
	createElement: function createElement(tagName) {
		var node = new Element();
		node.ownerDocument = this;
		node.nodeName = tagName;
		node.tagName = tagName;
		node.childNodes = new NodeList();
		var attrs = node.attributes = new NamedNodeMap();
		attrs._ownerElement = node;
		return node;
	},
	createDocumentFragment: function createDocumentFragment() {
		var node = new DocumentFragment();
		node.ownerDocument = this;
		node.childNodes = new NodeList();
		return node;
	},
	createTextNode: function createTextNode(data) {
		var node = new Text();
		node.ownerDocument = this;
		node.appendData(data);
		return node;
	},
	createComment: function createComment(data) {
		var node = new Comment();
		node.ownerDocument = this;
		node.appendData(data);
		return node;
	},
	createCDATASection: function createCDATASection(data) {
		var node = new CDATASection();
		node.ownerDocument = this;
		node.appendData(data);
		return node;
	},
	createProcessingInstruction: function createProcessingInstruction(target, data) {
		var node = new ProcessingInstruction();
		node.ownerDocument = this;
		node.tagName = node.target = target;
		node.nodeValue = node.data = data;
		return node;
	},
	createAttribute: function createAttribute(name) {
		var node = new Attr();
		node.ownerDocument = this;
		node.name = name;
		node.nodeName = name;
		node.localName = name;
		node.specified = true;
		return node;
	},
	createEntityReference: function createEntityReference(name) {
		var node = new EntityReference();
		node.ownerDocument = this;
		node.nodeName = name;
		return node;
	},
	// Introduced in DOM Level 2:
	createElementNS: function createElementNS(namespaceURI, qualifiedName) {
		var node = new Element();
		var pl = qualifiedName.split(':');
		var attrs = node.attributes = new NamedNodeMap();
		node.childNodes = new NodeList();
		node.ownerDocument = this;
		node.nodeName = qualifiedName;
		node.tagName = qualifiedName;
		node.namespaceURI = namespaceURI;
		if (pl.length == 2) {
			node.prefix = pl[0];
			node.localName = pl[1];
		} else {
			//el.prefix = null;
			node.localName = qualifiedName;
		}
		attrs._ownerElement = node;
		return node;
	},
	// Introduced in DOM Level 2:
	createAttributeNS: function createAttributeNS(namespaceURI, qualifiedName) {
		var node = new Attr();
		var pl = qualifiedName.split(':');
		node.ownerDocument = this;
		node.nodeName = qualifiedName;
		node.name = qualifiedName;
		node.namespaceURI = namespaceURI;
		node.specified = true;
		if (pl.length == 2) {
			node.prefix = pl[0];
			node.localName = pl[1];
		} else {
			//el.prefix = null;
			node.localName = qualifiedName;
		}
		return node;
	}
};
_extends(Document, Node);

function Element() {
	this._nsMap = {};
};
Element.prototype = {
	nodeType: ELEMENT_NODE,
	hasAttribute: function hasAttribute(name) {
		return this.getAttributeNode(name) != null;
	},
	getAttribute: function getAttribute(name) {
		var attr = this.getAttributeNode(name);
		return attr && attr.value || '';
	},
	getAttributeNode: function getAttributeNode(name) {
		return this.attributes.getNamedItem(name);
	},
	setAttribute: function setAttribute(name, value) {
		var attr = this.ownerDocument.createAttribute(name);
		attr.value = attr.nodeValue = "" + value;
		this.setAttributeNode(attr);
	},
	removeAttribute: function removeAttribute(name) {
		var attr = this.getAttributeNode(name);
		attr && this.removeAttributeNode(attr);
	},

	//four real opeartion method
	appendChild: function appendChild(newChild) {
		if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
			return this.insertBefore(newChild, null);
		} else {
			return _appendSingleChild(this, newChild);
		}
	},
	setAttributeNode: function setAttributeNode(newAttr) {
		return this.attributes.setNamedItem(newAttr);
	},
	setAttributeNodeNS: function setAttributeNodeNS(newAttr) {
		return this.attributes.setNamedItemNS(newAttr);
	},
	removeAttributeNode: function removeAttributeNode(oldAttr) {
		//console.log(this == oldAttr.ownerElement)
		return this.attributes.removeNamedItem(oldAttr.nodeName);
	},
	//get real attribute name,and remove it by removeAttributeNode
	removeAttributeNS: function removeAttributeNS(namespaceURI, localName) {
		var old = this.getAttributeNodeNS(namespaceURI, localName);
		old && this.removeAttributeNode(old);
	},

	hasAttributeNS: function hasAttributeNS(namespaceURI, localName) {
		return this.getAttributeNodeNS(namespaceURI, localName) != null;
	},
	getAttributeNS: function getAttributeNS(namespaceURI, localName) {
		var attr = this.getAttributeNodeNS(namespaceURI, localName);
		return attr && attr.value || '';
	},
	setAttributeNS: function setAttributeNS(namespaceURI, qualifiedName, value) {
		var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
		attr.value = attr.nodeValue = "" + value;
		this.setAttributeNode(attr);
	},
	getAttributeNodeNS: function getAttributeNodeNS(namespaceURI, localName) {
		return this.attributes.getNamedItemNS(namespaceURI, localName);
	},

	getElementsByTagName: function getElementsByTagName(tagName) {
		return new LiveNodeList(this, function (base) {
			var ls = [];
			_visitNode(base, function (node) {
				if (node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) {
					ls.push(node);
				}
			});
			return ls;
		});
	},
	getElementsByTagNameNS: function getElementsByTagNameNS(namespaceURI, localName) {
		return new LiveNodeList(this, function (base) {
			var ls = [];
			_visitNode(base, function (node) {
				if (node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) {
					ls.push(node);
				}
			});
			return ls;
		});
	}
};
Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;

_extends(Element, Node);
function Attr() {};
Attr.prototype.nodeType = ATTRIBUTE_NODE;
_extends(Attr, Node);

function CharacterData() {};
CharacterData.prototype = {
	data: '',
	substringData: function substringData(offset, count) {
		return this.data.substring(offset, offset + count);
	},
	appendData: function appendData(text) {
		text = this.data + text;
		this.nodeValue = this.data = text;
		this.length = text.length;
	},
	insertData: function insertData(offset, text) {
		this.replaceData(offset, 0, text);
	},
	appendChild: function appendChild(newChild) {
		throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR]);
	},
	deleteData: function deleteData(offset, count) {
		this.replaceData(offset, count, "");
	},
	replaceData: function replaceData(offset, count, text) {
		var start = this.data.substring(0, offset);
		var end = this.data.substring(offset + count);
		text = start + text + end;
		this.nodeValue = this.data = text;
		this.length = text.length;
	}
};
_extends(CharacterData, Node);
function Text() {};
Text.prototype = {
	nodeName: "#text",
	nodeType: TEXT_NODE,
	splitText: function splitText(offset) {
		var text = this.data;
		var newText = text.substring(offset);
		text = text.substring(0, offset);
		this.data = this.nodeValue = text;
		this.length = text.length;
		var newNode = this.ownerDocument.createTextNode(newText);
		if (this.parentNode) {
			this.parentNode.insertBefore(newNode, this.nextSibling);
		}
		return newNode;
	}
};
_extends(Text, CharacterData);
function Comment() {};
Comment.prototype = {
	nodeName: "#comment",
	nodeType: COMMENT_NODE
};
_extends(Comment, CharacterData);

function CDATASection() {};
CDATASection.prototype = {
	nodeName: "#cdata-section",
	nodeType: CDATA_SECTION_NODE
};
_extends(CDATASection, CharacterData);

function DocumentType() {};
DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
_extends(DocumentType, Node);

function Notation() {};
Notation.prototype.nodeType = NOTATION_NODE;
_extends(Notation, Node);

function Entity() {};
Entity.prototype.nodeType = ENTITY_NODE;
_extends(Entity, Node);

function EntityReference() {};
EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
_extends(EntityReference, Node);

function DocumentFragment() {};
DocumentFragment.prototype.nodeName = "#document-fragment";
DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
_extends(DocumentFragment, Node);

function ProcessingInstruction() {}
ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
_extends(ProcessingInstruction, Node);
function XMLSerializer() {}
XMLSerializer.prototype.serializeToString = function (node, isHtml, nodeFilter) {
	return nodeSerializeToString.call(node, isHtml, nodeFilter);
};
Node.prototype.toString = nodeSerializeToString;
function nodeSerializeToString(isHtml, nodeFilter) {
	var buf = [];
	var refNode = this.nodeType == 9 && this.documentElement || this;
	var prefix = refNode.prefix;
	var uri = refNode.namespaceURI;

	if (uri && prefix == null) {
		//console.log(prefix)
		var prefix = refNode.lookupPrefix(uri);
		if (prefix == null) {
			//isHTML = true;
			var visibleNamespaces = [{ namespace: uri, prefix: null
				//{namespace:uri,prefix:''}
			}];
		}
	}
	serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
	//console.log('###',this.nodeType,uri,prefix,buf.join(''))
	return buf.join('');
}
function needNamespaceDefine(node, isHTML, visibleNamespaces) {
	var prefix = node.prefix || '';
	var uri = node.namespaceURI;
	if (!prefix && !uri) {
		return false;
	}
	if (prefix === "xml" && uri === "http://www.w3.org/XML/1998/namespace" || uri == 'http://www.w3.org/2000/xmlns/') {
		return false;
	}

	var i = visibleNamespaces.length;
	//console.log('@@@@',node.tagName,prefix,uri,visibleNamespaces)
	while (i--) {
		var ns = visibleNamespaces[i];
		// get namespace prefix
		//console.log(node.nodeType,node.tagName,ns.prefix,prefix)
		if (ns.prefix == prefix) {
			return ns.namespace != uri;
		}
	}
	//console.log(isHTML,uri,prefix=='')
	//if(isHTML && prefix ==null && uri == 'http://www.w3.org/1999/xhtml'){
	//	return false;
	//}
	//node.flag = '11111'
	//console.error(3,true,node.flag,node.prefix,node.namespaceURI)
	return true;
}
function serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
	if (nodeFilter) {
		node = nodeFilter(node);
		if (node) {
			if (typeof node == 'string') {
				buf.push(node);
				return;
			}
		} else {
			return;
		}
		//buf.sort.apply(attrs, attributeSorter);
	}
	switch (node.nodeType) {
		case ELEMENT_NODE:
			if (!visibleNamespaces) visibleNamespaces = [];
			var startVisibleNamespaces = visibleNamespaces.length;
			var attrs = node.attributes;
			var len = attrs.length;
			var child = node.firstChild;
			var nodeName = node.tagName;

			isHTML = htmlns === node.namespaceURI || isHTML;
			buf.push('<', nodeName);

			for (var i = 0; i < len; i++) {
				// add namespaces for attributes
				var attr = attrs.item(i);
				if (attr.prefix == 'xmlns') {
					visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
				} else if (attr.nodeName == 'xmlns') {
					visibleNamespaces.push({ prefix: '', namespace: attr.value });
				}
			}
			for (var i = 0; i < len; i++) {
				var attr = attrs.item(i);
				if (needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
					var prefix = attr.prefix || '';
					var uri = attr.namespaceURI;
					var ns = prefix ? ' xmlns:' + prefix : " xmlns";
					buf.push(ns, '="', uri, '"');
					visibleNamespaces.push({ prefix: prefix, namespace: uri });
				}
				serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
			}
			// add namespace for current node		
			if (needNamespaceDefine(node, isHTML, visibleNamespaces)) {
				var prefix = node.prefix || '';
				var uri = node.namespaceURI;
				var ns = prefix ? ' xmlns:' + prefix : " xmlns";
				buf.push(ns, '="', uri, '"');
				visibleNamespaces.push({ prefix: prefix, namespace: uri });
			}

			if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
				buf.push('>');
				//if is cdata child node
				if (isHTML && /^script$/i.test(nodeName)) {
					while (child) {
						if (child.data) {
							buf.push(child.data);
						} else {
							serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces);
						}
						child = child.nextSibling;
					}
				} else {
					while (child) {
						serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces);
						child = child.nextSibling;
					}
				}
				buf.push('</', nodeName, '>');
			} else {
				buf.push('/>');
			}
			// remove added visible namespaces
			//visibleNamespaces.length = startVisibleNamespaces;
			return;
		case DOCUMENT_NODE:
		case DOCUMENT_FRAGMENT_NODE:
			var child = node.firstChild;
			while (child) {
				serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces);
				child = child.nextSibling;
			}
			return;
		case ATTRIBUTE_NODE:
			return buf.push(' ', node.name, '="', node.value.replace(/[&"]/g, _xmlEncoder), '"');
		case TEXT_NODE:
			/**
    * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
    * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
    * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
    * `&amp;` and `&lt;` respectively.
    * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
    * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
    * when that string is not marking the end of a CDATA section.
    *
    * In the content of elements, character data is any string of characters
    * which does not contain the start-delimiter of any markup
    * and does not include the CDATA-section-close delimiter, `]]>`.
    *
    * @see https://www.w3.org/TR/xml/#NT-CharData
    */
			return buf.push(node.data.replace(/[<&]/g, _xmlEncoder).replace(/]]>/g, ']]&gt;'));
		case CDATA_SECTION_NODE:
			return buf.push('<![CDATA[', node.data, ']]>');
		case COMMENT_NODE:
			return buf.push("<!--", node.data, "-->");
		case DOCUMENT_TYPE_NODE:
			var pubid = node.publicId;
			var sysid = node.systemId;
			buf.push('<!DOCTYPE ', node.name);
			if (pubid) {
				buf.push(' PUBLIC ', pubid);
				if (sysid && sysid != '.') {
					buf.push(' ', sysid);
				}
				buf.push('>');
			} else if (sysid && sysid != '.') {
				buf.push(' SYSTEM ', sysid, '>');
			} else {
				var sub = node.internalSubset;
				if (sub) {
					buf.push(" [", sub, "]");
				}
				buf.push(">");
			}
			return;
		case PROCESSING_INSTRUCTION_NODE:
			return buf.push("<?", node.target, " ", node.data, "?>");
		case ENTITY_REFERENCE_NODE:
			return buf.push('&', node.nodeName, ';');
		//case ENTITY_NODE:
		//case NOTATION_NODE:
		default:
			buf.push('??', node.nodeName);
	}
}
function _importNode(doc, node, deep) {
	var node2;
	switch (node.nodeType) {
		case ELEMENT_NODE:
			node2 = node.cloneNode(false);
			node2.ownerDocument = doc;
		//var attrs = node2.attributes;
		//var len = attrs.length;
		//for(var i=0;i<len;i++){
		//node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
		//}
		case DOCUMENT_FRAGMENT_NODE:
			break;
		case ATTRIBUTE_NODE:
			deep = true;
			break;
		//case ENTITY_REFERENCE_NODE:
		//case PROCESSING_INSTRUCTION_NODE:
		////case TEXT_NODE:
		//case CDATA_SECTION_NODE:
		//case COMMENT_NODE:
		//	deep = false;
		//	break;
		//case DOCUMENT_NODE:
		//case DOCUMENT_TYPE_NODE:
		//cannot be imported.
		//case ENTITY_NODE:
		//case NOTATION_NODE：
		//can not hit in level3
		//default:throw e;
	}
	if (!node2) {
		node2 = node.cloneNode(false); //false
	}
	node2.ownerDocument = doc;
	node2.parentNode = null;
	if (deep) {
		var child = node.firstChild;
		while (child) {
			node2.appendChild(_importNode(doc, child, deep));
			child = child.nextSibling;
		}
	}
	return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function _cloneNode(doc, node, deep) {
	var node2 = new node.constructor();
	for (var n in node) {
		var v = node[n];
		if (typeof v != 'object') {
			if (v != node2[n]) {
				node2[n] = v;
			}
		}
	}
	if (node.childNodes) {
		node2.childNodes = new NodeList();
	}
	node2.ownerDocument = doc;
	switch (node2.nodeType) {
		case ELEMENT_NODE:
			var attrs = node.attributes;
			var attrs2 = node2.attributes = new NamedNodeMap();
			var len = attrs.length;
			attrs2._ownerElement = node2;
			for (var i = 0; i < len; i++) {
				node2.setAttributeNode(_cloneNode(doc, attrs.item(i), true));
			}
			break;;
		case ATTRIBUTE_NODE:
			deep = true;
	}
	if (deep) {
		var child = node.firstChild;
		while (child) {
			node2.appendChild(_cloneNode(doc, child, deep));
			child = child.nextSibling;
		}
	}
	return node2;
}

function __set__(object, key, value) {
	object[key] = value;
}
//do dynamic
try {
	if (Object.defineProperty) {
		var getTextContent = function getTextContent(node) {
			switch (node.nodeType) {
				case ELEMENT_NODE:
				case DOCUMENT_FRAGMENT_NODE:
					var buf = [];
					node = node.firstChild;
					while (node) {
						if (node.nodeType !== 7 && node.nodeType !== 8) {
							buf.push(getTextContent(node));
						}
						node = node.nextSibling;
					}
					return buf.join('');
				default:
					return node.nodeValue;
			}
		};

		Object.defineProperty(LiveNodeList.prototype, 'length', {
			get: function get() {
				_updateLiveList(this);
				return this.$$length;
			}
		});
		Object.defineProperty(Node.prototype, 'textContent', {
			get: function get() {
				return getTextContent(this);
			},
			set: function set(data) {
				switch (this.nodeType) {
					case ELEMENT_NODE:
					case DOCUMENT_FRAGMENT_NODE:
						while (this.firstChild) {
							this.removeChild(this.firstChild);
						}
						if (data || String(data)) {
							this.appendChild(this.ownerDocument.createTextNode(data));
						}
						break;
					default:
						//TODO:
						this.data = data;
						this.value = data;
						this.nodeValue = data;
				}
			}
		});

		__set__ = function __set__(object, key, value) {
			//console.log(value)
			object['$$' + key] = value;
		};
	}
} catch (e) {} //ie8


//if(typeof require == 'function'){
exports.Node = Node;
exports.DOMException = DOMException;
exports.DOMImplementation = DOMImplementation;
exports.XMLSerializer = XMLSerializer;
//}

/***/ }),

/***/ "4Bm0":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function TempCtor() {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
  };
}

/***/ }),

/***/ "4Etx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTON_THEMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("9qb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_compat__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_scss__ = __webpack_require__("j65U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_scss__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */






var BUTTON_THEMES = {
  CALL: 'CALL'
};

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      var onClick = _this.props.onClick;


      onClick(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Button.prototype.render = function render() {
    var _cn;

    var _props = this.props,
        theme = _props.theme,
        type = _props.type,
        children = _props.children;


    return (
      // eslint-disable-next-line react/button-has-type
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'button',
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.button, (_cn = {}, _cn[__WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.themeCall] = theme === BUTTON_THEMES.CALL, _cn)),
          type: type,
          onClick: this.handleClick
        },
        children
      )
    );
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

Button.defaultProps = {
  theme: '',
  type: 'button',
  children: null
};

/* harmony default export */ __webpack_exports__["b"] = (Button);

/***/ }),

/***/ "4J90":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("OkVp");
var global = __webpack_require__("IJ/8");
var uncurryThis = __webpack_require__("PoOm");
var isObject = __webpack_require__("FS7x");
var createNonEnumerableProperty = __webpack_require__("yNEm");
var hasOwn = __webpack_require__("J3pj");
var shared = __webpack_require__("kERb");
var sharedKey = __webpack_require__("2+7m");
var hiddenKeys = __webpack_require__("Psxq");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function enforce(it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function getterFor(TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    }return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function set(it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function get(it) {
    return wmget(store, it) || {};
  };
  has = function has(it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function set(it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function get(it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function has(it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

/***/ }),

/***/ "4PH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/uuid/index.js
var uuid = __webpack_require__("qQO4");
var uuid_default = /*#__PURE__*/__webpack_require__.n(uuid);

// EXTERNAL MODULE: ./assets/app-store-badge.svg
var app_store_badge = __webpack_require__("eTnC");
var app_store_badge_default = /*#__PURE__*/__webpack_require__.n(app_store_badge);

// EXTERNAL MODULE: ./assets/google-play-badge.png
var google_play_badge = __webpack_require__("RDCy");
var google_play_badge_default = /*#__PURE__*/__webpack_require__.n(google_play_badge);

// CONCATENATED MODULE: ../lib/version.js
// generated by genversion
var version = '2.4.7';
// CONCATENATED MODULE: ./utils/consts.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return OS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LOCAL_STORAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return IT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return langs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return labelsGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return activityTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return chatBtns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return timeouts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return statuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ENVIRONMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return appVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return USER_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return REFRESH_TOKEN; });
/* unused harmony export ACTIVATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BRANCH_IO_REF_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TOKEN_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISCONNECT_TIMEOUT_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RECONNECT_TIMEOUT_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return VIDEO_PLAYING_TIMEOUT_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APPS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MAX_LAST_VISIT_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FULL_DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TIME_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TIME_FORMAT_COLON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EVENT_BUS_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return USERS_ERROR_CODES; });
var _langs;




// This module is generated by the genversion tool as a part of the build process
// eslint-disable-next-line import/extensions
 // eslint-disable-line import/no-unresolved

var consts = {
  PAGE_SIZE: 10,
  MES_HISTORY_SIZE: 10,
  CHAT: 'CHAT',
  CALL: 'CALL',

  USER_INFO_TAB: 'User Info',
  CALL_TAB: 'Call with user',
  CALL_HISTORY_TAB: 'Call history',

  THREAD: {
    IS_CLIENT: 0,
    IS_PRO: 1
  }
};

var OS = {
  ANDROID: 'Android OS',
  IOS: 'iOS'
};

var LOCAL_STORAGE = {
  ACTIVATION: 'ACTIVATION',
  PATH_NAME: 'pathName',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  USER_AUTH: 'USER_AUTH',
  USER_DATA: 'USER_DATA',
  UUID: 'uuid'
};

var EN = 'en-us';
var RU = 'ru';
var IT = 'it-it';
var ES = 'es-es';
var PL = 'pl';
var AE = 'ar-ae';
var PT = 'pt-br';
var DE = 'de-de';
var FR = 'fr-fr';

var langs = (_langs = {}, _langs[EN] = {
  code: 'en',
  lang: EN,
  name: 'eng',
  emoji: '🇬🇧'
}, _langs[RU] = {
  code: 'ru',
  lang: RU,
  name: 'рус',
  emoji: '🇷🇺'
}, _langs[IT] = {
  code: 'it',
  lang: IT,
  name: 'ita',
  emoji: '🇮🇹'
}, _langs[ES] = {
  code: 'es',
  lang: ES,
  name: 'esp',
  emoji: '🇪🇸'
}, _langs[PL] = {
  code: 'pl',
  lang: PL,
  name: 'pol',
  emoji: '🇵🇱'
}, _langs[AE] = {
  code: 'ar',
  lang: AE,
  name: 'ar',
  emoji: '🇦🇪'
}, _langs[PT] = {
  code: 'pt',
  lang: PT,
  name: 'pt',
  emoji: '🇧🇷'
}, _langs[DE] = {
  code: 'de',
  lang: DE,
  name: 'de',
  emoji: '🇩🇪'
}, _langs[FR] = {
  code: 'fr',
  lang: FR,
  name: 'fr',
  emoji: '🇫🇷'
}, _langs);

var labelsGA = {
  downloadAppClick: 'Clicked Download App'
};

var activityTypes = {
  call: 'Call on',
  callMissed: 'Missed call on',
  callFailed: 'Failed call on',
  im: 'Message on',
  uim: 'New message on',
  om: 'Outgoing message on',
  shortlisted: 'Shortlisted on',
  callDeclined: 'Call declined on ',
  callWithdrawn: 'Call withdrawn on ',
  callProBusy: 'Call pro busy on',
  callDisconnected: 'Call disconnected on',
  callNoAnswer: 'Call no answer on',
  callActive: 'Call active on',
  callTerminated: 'Call terminated on',
  chatError: 'Message error on'
};

var chatBtns = {
  decline: 'Decline',
  pickUp: 'Pick up',
  textMe: 'Text me',
  cancel: 'Cancel',
  cancelCall: 'Cancel call',
  finish: 'Hang up',
  next: 'Next pro',
  control: {
    speaker: 'speaker',
    video: 'video',
    mute: 'mute',
    fullScreen: 'full-screen',
    screenSharing: 'screen-sharing'
  }
};

var timeouts = {
  autoRejectTimeout: 25000,
  autoFinishCallTimeout: 60000,
  finishOnXMPPConnectionLostTimeout: 50000
};

var statuses = {
  SENT: 'Sent',
  DELIVERED: 'Delivered',
  READ: 'Read',
  FAILED: 'Failed'
};

/* export const branchIoKeys = {
  dev: 'key_test_fmIi9IeSnXeHJsULJk5Xebldqsjhpw6T',
  prod: 'key_live_hcHm1UgQh2mQQALMLl3aMojlrrjmoA5w',
}; */

var ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production'
};

var appVersion = version;

var USER_AUTH = 'USER_AUTH';
var REFRESH_TOKEN = 'REFRESH_TOKEN';
var ACTIVATION = 'ACTIVATION';

var BRANCH_IO_REF_TYPES = {
  RESET_PASSWORD: 'RESET_PASSWORD'
};

var TOKEN_TYPES = {
  RESET_PASSWORD: 'RESET_PASSWORD'
};

/**
 * @desc Timeout to disconnection in ms
 *
 * @type {number}
 */
var DISCONNECT_TIMEOUT_MS = 20 * 1000;

/**
 * @desc Timeout to reconnection in ms
 *
 * @type {number}
 */
var RECONNECT_TIMEOUT_MS = 2 * 1000;

/**
 * @desc Timeout to video connection in ms
 *
 * @type {number}
 */
var VIDEO_PLAYING_TIMEOUT_MS = 1000;

/**
 *
 * @desc Mobile applications list
 *
 * @type {{os: string, link: string, id: string, imgSrc: string}[]}
 */
var APPS_LIST = [{
  id: Object(uuid["v4"])(),
  imgSrc: app_store_badge_default.a,
  link: 'https://apps.apple.com/us/app/telmie/id1345950689',
  os: OS.IOS
}, {
  id: Object(uuid["v4"])(),
  imgSrc: google_play_badge_default.a,
  link: 'https://play.google.com/store/apps/details?id=com.starcloud.telmie&hl=en',
  os: OS.ANDROID
}];

/**
 * @desc Up to this duration user status is displaying with formatted time since last visit'
 *
 * @type {number}
 */
var MAX_LAST_VISIT_HOURS = 24;

var FULL_DATE_FORMAT = 'yyyy/LL/dd';

var DATE_FORMAT = 'dd.LL';

var TIME_FORMAT = 'HH.mm';

var TIME_FORMAT_COLON = 'HH:mm';

var EVENT_BUS_EVENTS = {
  PRESENCE_CHANGED_TO_ONLINE: 'presenceChangedToOnline',
  PRESENCE_CHANGED_TO_AWAY: 'presenceChangedToAway'
};

var USERS_ERROR_CODES = {
  PRO_IS_NOT_AVAILABLE: 116
};

/***/ }),

/***/ "4RHR":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  }return value;
};

/***/ }),

/***/ "4md/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function numberIsNaN(value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};

/***/ }),

/***/ "4zcZ":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("G69i");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function next() {
      return { done: !!called++ };
    },
    'return': function _return() {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {/* empty */}

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function next() {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) {/* empty */}
  return ITERATION_SUPPORT;
};

/***/ }),

/***/ "50ot":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

 true ? module.exports = __webpack_require__("sqxo") : module.exports = require("./js/react-notifications.dev.js");

/***/ }),

/***/ "51Pw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compareUrlLocale;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPage;
/* harmony export (immutable) */ __webpack_exports__["m"] = processPostThumbnailData;
/* harmony export (immutable) */ __webpack_exports__["n"] = processRecentPosts;
/* harmony export (immutable) */ __webpack_exports__["l"] = processPostText;
/* harmony export (immutable) */ __webpack_exports__["j"] = processPostImage;
/* harmony export (immutable) */ __webpack_exports__["k"] = processPostQuote;
/* harmony export (immutable) */ __webpack_exports__["c"] = processAuthorInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = processBlogBtn;
/* harmony export (immutable) */ __webpack_exports__["e"] = processBlogBtnGroup;
/* harmony export (immutable) */ __webpack_exports__["i"] = processPostData;
/* harmony export (immutable) */ __webpack_exports__["h"] = processHomepageData;
/* harmony export (immutable) */ __webpack_exports__["p"] = processTextPageData;
/* harmony export (immutable) */ __webpack_exports__["o"] = processReviewsData;
/* harmony export (immutable) */ __webpack_exports__["f"] = processFAQPageData;
/* harmony export (immutable) */ __webpack_exports__["g"] = processGlobalMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismic_javascript__ = __webpack_require__("wv0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismic_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__("4PH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app__ = __webpack_require__("qLaj");






function compareUrlLocale(props) {
    var locale = props.locale || __WEBPACK_IMPORTED_MODULE_3__consts__["g" /* EN */];
    var urlLocale = props.path.toString().split('/')[1];
    var _lang = '';

    return __WEBPACK_IMPORTED_MODULE_3__consts__["G" /* langs */][locale].code === urlLocale ? props.locale : Object.keys(__WEBPACK_IMPORTED_MODULE_3__consts__["G" /* langs */]).some(function (el) {
        return __WEBPACK_IMPORTED_MODULE_3__consts__["G" /* langs */][el].code === urlLocale ? (_lang = el, true) : false;
    }) ? (props.changeLocale(_lang), _lang) : (props.changeLocale(__WEBPACK_IMPORTED_MODULE_3__consts__["g" /* EN */]), __WEBPACK_IMPORTED_MODULE_3__consts__["g" /* EN */]);
}
function getPage() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var urlEng = arguments[1];

    var conditions = props.tag ? [__WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default.a.Predicates.at('document.type', props.type), __WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default.a.Predicates.at('document.tags', [props.tag])] : __WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default.a.Predicates.at('document.type', props.type);

    var lang = compareUrlLocale(props);

    return props.prismicCtx && props.prismicCtx.api.query(conditions, { lang: lang }).then(function (response, err) {
        if (response.results_size > 0) {
            var page = response.results[0];
            props.changeLocaleLangs(page.alternate_languages);
            return page;
        } else {
            props.changeLocale();
            Object(__WEBPACK_IMPORTED_MODULE_2_preact_router__["route"])(urlEng ? urlEng : '/' + /\/(.+)/.exec(props.path.substring(1))[1], true);
            return null;
        }
    }).catch(function (e) {
        console.log(e);
        Object(__WEBPACK_IMPORTED_MODULE_2_preact_router__["route"])(__WEBPACK_IMPORTED_MODULE_4__components_app__["routes"].HOME, true);
        return null;
    });
}

function processPostThumbnailData() {
    var rawPost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _rawPost$data = rawPost.data,
        data = _rawPost$data === undefined ? {} : _rawPost$data;

    var newPostData = {};
    try {
        newPostData = {
            id: rawPost.uid,
            title: data.title[0].text,
            date: data.date,
            link: '/blog/' + rawPost.uid,
            img: data.thumbnail.url
        };
    } catch (e) {
        console.log(e);
        newPostData = null;
    }
    if (typeof rawPost.tags != 'undefined' && rawPost.tags[0] && rawPost.tags[0] == 'featured') {
        newPostData.isFeatured = true;
    }
    return newPostData;
}

function processRecentPosts(rawPosts) {
    return rawPosts.map(function (rawPost) {
        return processPostThumbnailData(rawPost);
    });
}

function compliteTextWithTags(tags, text, type, withoutTags) {
    var nodes = [];
    tags && tags.length && tags.forEach(function (el) {
        switch (el.type) {
            case "hyperlink":
                nodes.push(text.substring(0, el.start));
                nodes.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'a',
                    { href: el.data.url, target: '_blank' },
                    text.substring(el.start, el.end)
                ));
                nodes.push(text.substring(el.end));
                break;
            case 'strong':
                nodes.push(text.substring(0, el.start));
                nodes.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'strong',
                    null,
                    text.substring(el.start, el.end)
                ));
                nodes.push(text.substring(el.end));
                break;
            default:
                nodes.push(text);
        }
    });
    var result = nodes.length ? nodes : text;
    return withoutTags ? result : type === 'list-item' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'li',
        null,
        result
    ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        null,
        result
    );
}

function processContent(content, tags) {
    return compliteTextWithTags(tags, content);
}
function processTagsInText(postData) {
    var withoutTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return compliteTextWithTags(postData.spans, postData.text, postData.type, withoutTags);
}

function processPostText(postData) {
    var prevType = null,
        tmpContent = [],
        _content = null,
        isForClear = false;

    var textLen = postData.primary.text.length;

    var serialiseText = function serialiseText(type, content, tags, i) {
        isForClear && (tmpContent = [], _content = null, isForClear = false);
        isForClear = prevType == 'o-list-item' && type != 'o-list-item';
        isForClear && (_content = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'ol',
            null,
            [].concat(tmpContent)
        ));
        prevType = type;

        switch (type) {
            case 'list-item':
                return [_content, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'li',
                    null,
                    content
                )];
            case 'o-list-item':
                return i + 1 === textLen ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'ol',
                    null,
                    [].concat(tmpContent, [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'li',
                        { key: i },
                        content
                    )])
                ) : (tmpContent.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'li',
                    { key: i },
                    content
                )), null);
            case 'heading2':
                return [_content, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'h2',
                    null,
                    content
                )];
            case 'heading3':
                return [_content, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'h3',
                    null,
                    content
                )];
            default:
                return [_content, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'p',
                    null,
                    processContent(content, tags)
                )];
        }
    };

    return postData.primary.text.map(function (text, i) {
        return serialiseText(text.type, text.text, text.spans, i);
    });
}

function processPostImage() {
    var postData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var imageData = {
        url: postData.primary.image.url
    };
    if (postData.primary.caption.length > 0) {
        imageData.title = postData.primary.caption[0].text;
    }
    return imageData;
}

function processPostQuote(postData) {
    try {
        return {
            text: postData.primary.quote[0].text,
            author: postData.primary.author[0] ? postData.primary.author[0].text : ''
        };
    } catch (e) {
        console.log(e);
        return {
            text: '',
            author: ''
        };
    }
}
function processAuthorInfo(postData) {
    try {
        return {
            title: postData.primary.section_title[0].text,
            aName: postData.primary.author_name[0].text,
            aDescription: postData.primary.author_description[0].text,
            aAvatar: postData.primary.author_avatar.url
        };
    } catch (e) {
        console.log(e);
        return null;
    }
}

function processBlogBtn(postData) {
    try {
        var link = postData.primary.button_link;
        return {
            text: postData.primary.button_text[0].text,
            link: link,
            isExternal: link.indexOf('http://') === 0 || link.indexOf('https://') === 0
        };
    } catch (e) {
        console.log(e);
        return {};
    }
}
function processBlogBtnGroup(postData) {
    try {
        return postData.items.map(function (item) {
            return {
                link: item.link,
                text: item.button_text[0].text,
                isExternal: item.link.indexOf('http://') === 0 || item.link.indexOf('https://') === 0
            };
        });
    } catch (e) {
        console.log(e);
        return {};
    }
}

var processDate = function processDate(date) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-us";

    var dateObj = new Date(date);

    return dateObj.toLocaleString(locale, { month: "long", day: 'numeric', year: "numeric" });
};
function processPostData() {
    var rawData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var locale = arguments[1];

    try {
        return {
            title: rawData.title[0].text,
            date: processDate(rawData.date, locale),
            body: rawData.body
        };
    } catch (e) {
        console.log(e);
        return {
            title: '',
            date: null,
            body: []
        };
    }
}
var getExperts = function getExperts(data) {
    var side1 = [],
        side2 = [];
    try {
        data.featured_experts.forEach(function (expert, index) {
            var expertData = {
                id: parseInt(expert.id[0].text),
                name: expert.name[0].text,
                img: expert.photo.url,
                serviceName: expert.proffesion[0].text,
                price: expert.price[0].text,
                time: 'min'
            };
            if (expert.photo.dimensions.height < 600) {
                expertData.isSmall = true;
            }
            if (index <= 1) {
                side1.push(expertData);
            } else {
                side2.push(expertData);
            }
        });

        side2.splice(1, 0, {
            id: 4,
            isSmall: true,
            isStat: true,
            minutes: data.amount_of_minutes
        });
        side2 = [[side2[0], side2[1]], [side2[2], side2[3]]];
        return {
            side1: side1, side2: side2
        };
    } catch (e) {
        console.log(e);
        return { side1: [], side2: [] };
    }
};

var getServices = function getServices(data) {
    try {
        return data.services.map(function (service) {
            return {
                link: service.link[0] ? service.link[0].text : '',
                earnBtnText: service.earning_btn_text,
                linkLearn: service.link_learning[0] ? service.link_learning[0].text : '',
                learnBtnText: service.learning_btn_text,
                background: service.image.url,
                serviceName: service.title1[0].text,
                description: service.description[0] && service.description[0].text
            };
        });
    } catch (e) {
        console.log(e);
        return [];
    }
};

var getFAQs = function getFAQs(faqData) {
    var allFaqs = {},
        getFAQ = function getFAQ(name) {
        try {
            return faqData[name].map(function (faq) {
                return {
                    question: faq.question[0].text,
                    answer: faq.answer.map(function (answer) {
                        return processTagsInText(answer);
                    })
                };
            });
        } catch (e) {
            console.log(e);
            return [];
        }
    };

    allFaqs.generalQuestions = getFAQ('general_faqs');
    allFaqs.customersQuestions = getFAQ('customer_faqs');
    allFaqs.expertsQuestions = getFAQ('experts_faqs');
    allFaqs.paymentsQuestions = getFAQ('payments_faqs');

    return allFaqs.generalQuestions.length === 0 && allFaqs.customersQuestions.length === 0 && allFaqs.expertsQuestions.length === 0 && allFaqs.paymentsQuestions.length === 0 ? null : allFaqs;
};

function processHomepageData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var processedData = {};

    try {
        processedData.mainSection = {
            title: data.title[0].text,
            subTitle: data.sub_title[0].text,
            typedWords: data.typed_words[0].text,
            btnText: data.buttom_title[0] && data.buttom_title[0].text,
            btnLink: data.button_link.url
        };
    } catch (e) {
        console.log(e);
        processedData.mainSection = null;
    }

    processedData.experts = getExperts(data);

    try {
        processedData.howItWorks = {
            title: data.how_it_works_title[0].text,
            text: data.how_it_works[0].text,
            videoID: data.how_it_works_video.video_id,
            btnText: data.buttom_title[0] && data.buttom_title[0].text,
            btnLink: data.button_link.url
        };
    } catch (e) {
        console.log(e);
        processedData.howItWorks = null;
    }

    try {
        processedData.servicesTitle = data.featured_services_title[0].text;
    } catch (e) {
        console.log(e);
        processedData.servicesTitle = '';
    }

    processedData.services = getServices(data);

    try {
        processedData.app = {
            title: data.app_title[0].text,
            text: data.app_text[0] ? data.app_text[0].text : '',
            img: data.app_image.url,
            btnLink: data.button_link.url
        };
    } catch (e) {
        console.log(e);
        processedData.app = null;
    }

    processedData.faqs = getFAQs(data);

    try {
        processedData.becomePro = {
            title: data.earn_more_title[0].text,
            text: data.earn_more_text[0].text,
            btnText: data.buttom_title[0] && data.buttom_title[0].text,
            btnLink: data.button_link.url
        };
    } catch (e) {
        console.log(e);
        processedData.becomePro = null;
    }

    return processedData;
}

var getSteps = function getSteps(data) {
    try {
        return data.work_steps.map(function (step) {
            return {
                id: step.id[0].text,
                title: step.step_title[0].text,
                text: step.step_text[0].text,
                icon: step.step_icon.url
            };
        });
    } catch (e) {
        console.log(e);
        return [];
    }
};

var getReasons = function getReasons(data) {
    try {
        return data.reasons.map(function (reason) {
            return {
                icon: reason.reason_icon.url,
                title: reason.reason_title[0].text,
                text: reason.reason_text[0].text
            };
        });
    } catch (e) {
        console.log(e);
        return [];
    }
};

var getReviews = function getReviews(data) {
    try {
        return data.reviews.map(function (review) {
            return {
                avatar: review.avatar.url,
                name: review.name[0].text,
                title: review.review_title[0].text,
                text: review.review_text[0].text
            };
        });
    } catch (e) {
        console.log(e);
        return [];
    }
};

var getInfo = function getInfo(data) {
    try {
        return data.info_section.map(function (infotext) {
            return {
                id: infotext.section_id,
                img: infotext.section_image.url,
                img_height: infotext.section_image.dimensions.height,
                img_width: infotext.section_image.dimensions.width,
                title: infotext.section_title[0].text,
                text: infotext.section_text[0].text,
                right: infotext.is_right_position,
                animated: infotext.is_animated
            };
        });
    } catch (e) {
        console.log(e);
        return [];
    }
};

function processTextPageData(data) {
    var processedData = {};
    var btnLink = void 0,
        btnText = void 0;

    try {
        btnLink = data.button_link.url;
        btnText = data.button_title[0] && data.button_title[0].text;
    } catch (e) {
        console.log(e);
        btnLink = '';
        btnTetxt = '';
    }
    //processedData = { ...data };
    processedData.downloadBtn = {
        btnLink: btnLink,
        btnText: btnText
    };

    try {
        processedData.becomePro = {
            img: data.earn_money_image.url,
            title: data.earn_money_title[0].text,
            emphasized: data.emphasize_title_part[0].text,
            text: data.earn_money_text[0].text
        };
    } catch (e) {
        console.log(e);
        processedData.becomePro = {
            img: '',
            title: '',
            emphasized: '',
            text: ''
        };
    }

    processedData.info = getInfo(data);
    processedData.steps = getSteps(data);
    processedData.reasons = getReasons(data);
    //processedData.reviews = getReviews(data);

    try {
        processedData.titles = {
            how_works_title: data.how_works_title[0].text,
            choose_us_title: data.choose_us_title[0].text
        };
    } catch (e) {
        console.log(e);
        processedData.titles = {
            how_works_title: '',
            choose_us_title: ''
        };
    }

    try {
        processedData.app = {
            title: data.app_title[0] ? data.app_title[0].text : '',
            text: data.app_text[0] ? data.app_text[0].text : '',
            img: data.app_image.url,
            btnLink: btnLink
        };
    } catch (e) {
        console.log(e);
        processedData.app = {
            title: '',
            text: '',
            img: ''
        };
    }

    console.log(processedData);

    return processedData;
}
function processReviewsData(data) {
    return getReviews(data);
}

function processFAQPageData(data) {
    var processedData = {};

    processedData.faqs = getFAQs(data);

    try {
        processedData.mainQuestion = {
            question: data.telmie_question[0].text,
            answer: data.telmie_answer.map(function (answer) {
                return processTagsInText(answer);
            })
        };
    } catch (e) {
        console.log(e);
    }

    return processedData;
}

function processGlobalMessage(data) {
    var mes = '';
    try {
        mes = processTagsInText(data.message[0], true);
    } catch (e) {
        console.log(e);
        return '';
    }
    return mes;
}

/***/ }),

/***/ "58Ti":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("B6/o");

module.exports = Function.prototype.bind || implementation;

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "5VJ8":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("G69i");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';

/***/ }),

/***/ "5dKy":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("UNYT");
var global = __webpack_require__("IJ/8");

module.exports = classof(global.process) == 'process';

/***/ }),

/***/ "5x0G":
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__("l2iA");

/**
 * Export.
 */

module.exports = toSpaceCase;

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : '';
  }).trim();
}

/***/ }),

/***/ "5yon":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  throw new Error('ws does not work in the browser. Browser clients must use the native ' + 'WebSocket object');
};

/***/ }),

/***/ "650N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header__1fovO","mobileNav":"mobileNav__3rj_a","logoWrapper":"logoWrapper__27U0l","leftNavWrapper":"leftNavWrapper__3AWcj","navbarRight":"navbarRight__2zScE","navbarLeft":"navbarLeft__1KIjk","title":"title__2eCzC","localeSelect":"localeSelect__jaeH7","flagContainer":"flagContainer__NBhAq","subHeader":"subHeader__mGwec","notificationDanger":"notificationDanger__3tB6H","content":"content__3PrKh","smallHeader":"smallHeader__KeMEg","logo":"logo__XXPs0","mobileNavHeader":"mobileNavHeader__328Z-","expandMobileMenu":"expandMobileMenu__2_tb2","signUp":"signUp__TA_fx","loggedInContainer":"loggedInContainer__10R-Q","dropdown":"dropdown__11PLr","chats":"chats__UyvdA","avatar":"avatar__1G5c_","newChats":"newChats__NBNAb","mobileShadow":"mobileShadow__YYEpG","opened":"opened__2lxlq","leftNav":"leftNav__2EsTM","activeLink":"activeLink__3XRDA","searchPros":"searchPros__3DHmV","searchInput":"searchInput__1s1Gf","sideBar":"sideBar__2LM0k"};

/***/ }),

/***/ "69EM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return safeDisableMultimediaKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return safeEnableMulimediaKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return safeSetMediaPlaybackState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createInvisibleAudioElementFromMedia; });
var safeDisableMultimediaKeys = function safeDisableMultimediaKeys() {
  if (navigator.mediaSession && typeof navigator.mediaSession.setActionHandler === 'function') {
    navigator.mediaSession.setActionHandler('play', function () {});
    navigator.mediaSession.setActionHandler('pause', function () {});
    navigator.mediaSession.setActionHandler('stop', function () {});
    navigator.mediaSession.setActionHandler('seekbackward', function () {});
    navigator.mediaSession.setActionHandler('seekforward', function () {});
    navigator.mediaSession.setActionHandler('seekto', function () {});
    navigator.mediaSession.setActionHandler('previoustrack', function () {});
    navigator.mediaSession.setActionHandler('nexttrack', function () {});
  }
};

var safeEnableMulimediaKeys = function safeEnableMulimediaKeys() {
  if (navigator.mediaSession && typeof navigator.mediaSession.setActionHandler === 'function') {
    navigator.mediaSession.setActionHandler('play', null);
    navigator.mediaSession.setActionHandler('pause', null);
    navigator.mediaSession.setActionHandler('stop', null);
    navigator.mediaSession.setActionHandler('seekbackward', null);
    navigator.mediaSession.setActionHandler('seekforward', null);
    navigator.mediaSession.setActionHandler('seekto', null);
    navigator.mediaSession.setActionHandler('previoustrack', null);
    navigator.mediaSession.setActionHandler('nexttrack', null);
  }
};

var safeSetMediaPlaybackState = function safeSetMediaPlaybackState(state) {
  var _navigator = navigator,
      mediaSession = _navigator.mediaSession;


  if (mediaSession) {
    if (state === 'none') {
      mediaSession.metadata = null;
    }
    mediaSession.playbackState = state;
  }
};

var createInvisibleAudioElementFromMedia = function createInvisibleAudioElementFromMedia(mediaSrc, id) {
  var audio = new Audio(mediaSrc);

  audio.id = id;
  audio.controls = false;

  return audio;
};

/***/ }),

/***/ "6BI7":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("HiG7");
var anObject = __webpack_require__("1kal");
var getMethod = __webpack_require__("YeOI");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

/***/ }),

/***/ "6Elf":
/***/ (function(module, exports, __webpack_require__) {

function DOMParser(options) {
	this.options = options || { locator: {} };
}

DOMParser.prototype.parseFromString = function (source, mimeType) {
	var options = this.options;
	var sax = new XMLReader();
	var domBuilder = options.domBuilder || new DOMHandler(); //contentHandler and LexicalHandler
	var errorHandler = options.errorHandler;
	var locator = options.locator;
	var defaultNSMap = options.xmlns || {};
	var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
	var entityMap = isHTML ? htmlEntity.entityMap : { 'lt': '<', 'gt': '>', 'amp': '&', 'quot': '"', 'apos': "'" };
	if (locator) {
		domBuilder.setDocumentLocator(locator);
	}

	sax.errorHandler = buildErrorHandler(errorHandler, domBuilder, locator);
	sax.domBuilder = options.domBuilder || domBuilder;
	if (isHTML) {
		defaultNSMap[''] = 'http://www.w3.org/1999/xhtml';
	}
	defaultNSMap.xml = defaultNSMap.xml || 'http://www.w3.org/XML/1998/namespace';
	if (source && typeof source === 'string') {
		sax.parse(source, defaultNSMap, entityMap);
	} else {
		sax.errorHandler.error("invalid doc source");
	}
	return domBuilder.doc;
};
function buildErrorHandler(errorImpl, domBuilder, locator) {
	if (!errorImpl) {
		if (domBuilder instanceof DOMHandler) {
			return domBuilder;
		}
		errorImpl = domBuilder;
	}
	var errorHandler = {};
	var isCallback = errorImpl instanceof Function;
	locator = locator || {};
	function build(key) {
		var fn = errorImpl[key];
		if (!fn && isCallback) {
			fn = errorImpl.length == 2 ? function (msg) {
				errorImpl(key, msg);
			} : errorImpl;
		}
		errorHandler[key] = fn && function (msg) {
			fn('[xmldom ' + key + ']\t' + msg + _locator(locator));
		} || function () {};
	}
	build('warning');
	build('error');
	build('fatalError');
	return errorHandler;
}

//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */
function DOMHandler() {
	this.cdata = false;
}
function position(locator, node) {
	node.lineNumber = locator.lineNumber;
	node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */
DOMHandler.prototype = {
	startDocument: function startDocument() {
		this.doc = new DOMImplementation().createDocument(null, null, null);
		if (this.locator) {
			this.doc.documentURI = this.locator.systemId;
		}
	},
	startElement: function startElement(namespaceURI, localName, qName, attrs) {
		var doc = this.doc;
		var el = doc.createElementNS(namespaceURI, qName || localName);
		var len = attrs.length;
		appendElement(this, el);
		this.currentElement = el;

		this.locator && position(this.locator, el);
		for (var i = 0; i < len; i++) {
			var namespaceURI = attrs.getURI(i);
			var value = attrs.getValue(i);
			var qName = attrs.getQName(i);
			var attr = doc.createAttributeNS(namespaceURI, qName);
			this.locator && position(attrs.getLocator(i), attr);
			attr.value = attr.nodeValue = value;
			el.setAttributeNode(attr);
		}
	},
	endElement: function endElement(namespaceURI, localName, qName) {
		var current = this.currentElement;
		var tagName = current.tagName;
		this.currentElement = current.parentNode;
	},
	startPrefixMapping: function startPrefixMapping(prefix, uri) {},
	endPrefixMapping: function endPrefixMapping(prefix) {},
	processingInstruction: function processingInstruction(target, data) {
		var ins = this.doc.createProcessingInstruction(target, data);
		this.locator && position(this.locator, ins);
		appendElement(this, ins);
	},
	ignorableWhitespace: function ignorableWhitespace(ch, start, length) {},
	characters: function characters(chars, start, length) {
		chars = _toString.apply(this, arguments);
		//console.log(chars)
		if (chars) {
			if (this.cdata) {
				var charNode = this.doc.createCDATASection(chars);
			} else {
				var charNode = this.doc.createTextNode(chars);
			}
			if (this.currentElement) {
				this.currentElement.appendChild(charNode);
			} else if (/^\s*$/.test(chars)) {
				this.doc.appendChild(charNode);
				//process xml
			}
			this.locator && position(this.locator, charNode);
		}
	},
	skippedEntity: function skippedEntity(name) {},
	endDocument: function endDocument() {
		this.doc.normalize();
	},
	setDocumentLocator: function setDocumentLocator(locator) {
		if (this.locator = locator) {
			// && !('lineNumber' in locator)){
			locator.lineNumber = 0;
		}
	},
	//LexicalHandler
	comment: function comment(chars, start, length) {
		chars = _toString.apply(this, arguments);
		var comm = this.doc.createComment(chars);
		this.locator && position(this.locator, comm);
		appendElement(this, comm);
	},

	startCDATA: function startCDATA() {
		//used in characters() methods
		this.cdata = true;
	},
	endCDATA: function endCDATA() {
		this.cdata = false;
	},

	startDTD: function startDTD(name, publicId, systemId) {
		var impl = this.doc.implementation;
		if (impl && impl.createDocumentType) {
			var dt = impl.createDocumentType(name, publicId, systemId);
			this.locator && position(this.locator, dt);
			appendElement(this, dt);
		}
	},
	/**
  * @see org.xml.sax.ErrorHandler
  * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
  */
	warning: function warning(error) {
		console.warn('[xmldom warning]\t' + error, _locator(this.locator));
	},
	error: function error(_error) {
		console.error('[xmldom error]\t' + _error, _locator(this.locator));
	},
	fatalError: function fatalError(error) {
		throw new ParseError(error, this.locator);
	}
};
function _locator(l) {
	if (l) {
		return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
	}
}
function _toString(chars, start, length) {
	if (typeof chars == 'string') {
		return chars.substr(start, length);
	} else {
		//java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
		if (chars.length >= start + length || start) {
			return new java.lang.String(chars, start, length) + '';
		}
		return chars;
	}
}

/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function (key) {
	DOMHandler.prototype[key] = function () {
		return null;
	};
});

/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
function appendElement(hander, node) {
	if (!hander.currentElement) {
		hander.doc.appendChild(node);
	} else {
		hander.currentElement.appendChild(node);
	}
} //appendChild and setAttributeNS are preformance key

//if(typeof require == 'function'){
var htmlEntity = __webpack_require__("MxlY");
var sax = __webpack_require__("a5Ub");
var XMLReader = sax.XMLReader;
var ParseError = sax.ParseError;
var DOMImplementation = exports.DOMImplementation = __webpack_require__("49hf").DOMImplementation;
exports.XMLSerializer = __webpack_require__("49hf").XMLSerializer;
exports.DOMParser = DOMParser;
exports.__DOMHandler = DOMHandler;
//}

/***/ }),

/***/ "6MLN":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("wLcK")(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "6k8n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ "6nxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toggle_switch__ = __webpack_require__("kcvk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toggle_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_toggle_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_scss__ = __webpack_require__("Xl3w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_langPack__ = __webpack_require__("9dRJ");
var _class, _temp2;



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */







var RadioButtons = (_temp2 = _class = function (_Component) {
  _inherits(RadioButtons, _Component);

  function RadioButtons() {
    var _temp, _this, _ret;

    _classCallCheck(this, RadioButtons);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.generateId = function (el) {
      var _this$props = _this.props,
          valueField = _this$props.valueField,
          name = _this$props.name;

      return el[valueField] + '_' + name;
    }, _this.getItem = function (el) {
      var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var valueField = _this.props.valueField;

      if (el.type === 'radio' || !el.type) {
        if (el[valueField] !== 'pro') {
          var value = parent ? parent + '.' + el[valueField] : el[valueField];
          var checked = value === _this.props.value.radio;

          // Show submenu
          var showChildren = el.childs && el.childs.length && !parent && (checked || _this.props.value.radio.indexOf(value) === 0);

          return el[valueField] !== 'payment' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
              type: 'radio',
              id: _this.generateId(el),
              disabled: el.disabled,
              name: el.name,
              value: value,
              checked: checked
            }),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'label',
              {
                htmlFor: _this.generateId(el)
              },
              el.name
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.children,
                style: {
                  height: showChildren ? 28 * el.childs.length + 'px' : 0,
                  width: !showChildren ? 0 : 'auto'
                }
              },
              el.childs ? el.childs.map(function (item) {
                return _this.getItem(item, value);
              }) : null
            )
          ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
              type: 'radio',
              id: _this.generateId(el),
              disabled: el.disabled,
              name: el.name,
              value: value,
              checked: checked
            }),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'label',
              {
                htmlFor: _this.generateId(el),
                onClick: function onClick() {
                  return firebase.analytics().logEvent('Tap_Payment_settings');
                }
              },
              el.name
            )
          );
        }
        return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
          type: 'radio',
          id: _this.generateId(el),
          disabled: el.disabled,
          name: el.name,
          value: el[valueField],
          checked: el[valueField] === _this.props.value.radio
        }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.wrapProDeatils },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'label',
            { htmlFor: _this.generateId(el), onClick: function onClick() {
                return firebase.analytics().logEvent('Pro_details');
              } },
            el.name
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.proDetailsApproved },
            '\u2714\xA0Approved'
          )
        )];
      }
      if (el.type === 'link') {
        return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
          type: 'radio',
          id: _this.generateId(el),
          disabled: el.disabled,
          name: el.name,
          value: el[valueField],
          checked: el[valueField] === _this.props.value.radio
        }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.wrapProDeatils },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_2_preact_router__["Link"],
            { href: el.href },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'label',
              { htmlFor: _this.generateId(el) },
              el.name
            )
          )
        )];
      }
      if (el.type === 'switch') {
        if (el[valueField] === 'proWork') {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.switch + ' ' + (_this.props.isPro && el[valueField] === 'proWork' && !_this.props.value.switch[el[valueField]] ? __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.redSwitch : '') },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              null,
              el.name
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_react_toggle_switch___default.a, {
              onClick: function onClick() {
                _this.props.onSwitch(el[valueField]);
                firebase.analytics().logEvent('Work_as_Pro');
              },
              on: _this.props.value.switch[el[valueField]],
              className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.switchcell
            })
          );
        }if (el[valueField] === 'emailNotification') {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { className: '' + __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.switch },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              null,
              el.name
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_react_toggle_switch___default.a, {
              onClick: function onClick() {
                _this.props.onSwitch(el[valueField]);
                firebase.analytics().logEvent('Switch_Important_via_Email');
              },
              on: _this.props.value.switch[el[valueField]],
              className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.switchcell
            })
          );
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: '' + __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.switch },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            null,
            el.name
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_react_toggle_switch___default.a, { onClick: function onClick() {
              return _this.props.onSwitch(el[valueField]);
            }, on: _this.props.value.switch[el[valueField]], className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.switchcell })
        );
      }

      if (el.type === 'text') {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.text },
          el.name
        );
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // eslint-disable-next-line react/static-property-placement


  // eslint-disable-next-line consistent-return


  RadioButtons.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        data = _props.data,
        _onChange = _props.onChange,
        footer = _props.footer,
        className = _props.className;


    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.leftSideBar },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'form',
          {
            className: className,
            onChange: function onChange(e) {
              return _onChange(e.target.value, e.target.name);
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.options },
            data.name === 'SECTORS' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.sideBarInWrapper },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'span',
                { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.sideBarTitle },
                __WEBPACK_IMPORTED_MODULE_4__utils_langPack__["a" /* langPack */][this.props.locale].RADIO_BUTTONS.SECTORS
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.sideBarInWrapper },
                data.map(function (el) {
                  return el !== 'name' && _this2.getItem(el);
                })
              )
            ) : data.map(function (el) {
              return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'span',
                { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.sideBarTitle },
                el.name
              ), el.links.map(function (item) {
                return _this2.getItem(item);
              })];
            })
          )
        )
      ),
      footer ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.footer },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          { onClick: function onClick() {
              footer.onClick();
              firebase.analytics().logEvent('Sign_out');
            }
          },
          footer.text
        )
      ) : null
    );
  };

  return RadioButtons;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
  valueField: 'value',
  value: {
    radio: ''
  }
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (RadioButtons);

/***/ }),

/***/ "6ord":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__("KpHW")();
var callBound = __webpack_require__("tAi/");

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && $toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = function () {
	return isStandardArguments(arguments);
}();

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

/***/ }),

/***/ "6t7t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("nFDa"), __esModule: true };

/***/ }),

/***/ "71YK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("eW0v");

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("eW0v");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__("slh1");

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var isDescendant = function isDescendant(el, target) {
  if (target !== null) {
    return el === target || isDescendant(el, target.parentNode);
  }
  return false;
};

var clickAwayEvents = ['mouseup', 'touchend'];
var bind = function bind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.on(document, event, callback);
  });
};
var unbind = function unbind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.off(document, event, callback);
  });
};

var ClickAwayListener = function (_Component) {
  (0, _inherits3.default)(ClickAwayListener, _Component);

  function ClickAwayListener() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      // IE11 support, which trigger the handleClickAway even after the unbind
      if (_this.isCurrentlyMounted) {
        var el = _reactDom2.default.findDOMNode(_this);

        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
          _this.props.onClickAway(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClickAwayListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isCurrentlyMounted = true;
      if (this.props.onClickAway) {
        bind(this.handleClickAway);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.onClickAway !== this.props.onClickAway) {
        unbind(this.handleClickAway);
        if (this.props.onClickAway) {
          bind(this.handleClickAway);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isCurrentlyMounted = false;
      unbind(this.handleClickAway);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return ClickAwayListener;
}(_react.Component);

ClickAwayListener.propTypes =  false ? {
  children: _propTypes2.default.element,
  onClickAway: _propTypes2.default.func
} : {};
exports.default = ClickAwayListener;

/***/ }),

/***/ "7AqT":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("ZHvQ");
var ITERATOR = __webpack_require__("Ug9I")('iterator');
var Iterators = __webpack_require__("dhak");
module.exports = __webpack_require__("zKeE").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),

/***/ "7CVk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toIndexedObject = __webpack_require__("M0Be");
var addToUnscopables = __webpack_require__("aXzn");
var Iterators = __webpack_require__("25e4");
var InternalStateModule = __webpack_require__("4J90");
var defineIterator = __webpack_require__("PFhi");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0, // next index
    kind: kind // kind
  });
  // `%ArrayIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),

/***/ "7CnU":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "7NjO":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var call = __webpack_require__("HiG7");
var aCallable = __webpack_require__("oOss");
var anObject = __webpack_require__("1kal");
var tryToString = __webpack_require__("HXaG");
var getIteratorMethod = __webpack_require__("x6RK");

var TypeError = global.TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw TypeError(tryToString(argument) + ' is not iterable');
};

/***/ }),

/***/ "7U15":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var userAgent = __webpack_require__("WMuu");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;

/***/ }),

/***/ "7qbT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__("JAZJ");

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__("45fX");

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__("T9hV");

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool,
  spyThrottle: _propTypes2.default.number
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),

/***/ "87tL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleName; });
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectSignInProcessed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectSignInProcessing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectSignInError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("vyGZ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var moduleName = 'signIn';

// Reducer (down)

var initialState = {
  processed: false,
  processing: false,
  error: ''
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var type = action.type,
      error = action.error;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_IN_FETCH_USER_DATA_REQUEST:
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_IN_LOGIN_REQUEST:
      return _extends({}, state, {
        processing: true,
        error: initialState.error
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_IN_FETCH_USER_DATA_SUCCESS:
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_IN_LOGIN_SUCCESS:
      return _extends({}, state, {
        processed: true,
        processing: false
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_IN_FETCH_USER_DATA_FAILURE:
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_IN_LOGIN_FAILURE:
      return _extends({}, state, {
        processed: true,
        processing: false,
        // TODO Add more informative error message
        error: error || 'Unknown error'
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_IN_SET_PROCESSED:
      return _extends({}, state, {
        processed: true
      });

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

var stateSelector = function stateSelector(state) {
  return state[moduleName];
};

var selectSignInProcessed = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (signIn) {
  return signIn.processed;
});

var selectSignInProcessing = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (signIn) {
  return signIn.processing;
});

var selectSignInError = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (signIn) {
  return signIn.error;
});

// Selectors (up

/***/ }),

/***/ "8FtN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("eOjq"), __esModule: true };

/***/ }),

/***/ "8TP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleName; });
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectForgotPasswordIsProcessing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectForgotPasswordError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectForgotPasswordSuccessMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectForgotPasswordResettingParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectForgotPasswordIsResettingMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectForgotPasswordCurrentEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("vyGZ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// Constants (down)

var moduleName = 'forgotPassword';

// Constants (up)

// Reducer (down)

/**
 *
 * @type {{
 * processing: boolean,
 * error: string,
 * successMessage: string,
 * resettingParams: null | { email: string, token: string },
 * }}
 */
var initialState = {
  processing: false,
  error: '',
  successMessage: '',
  resettingParams: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var error = action.error,
      type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_POST_REQUEST:
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_RESET_REQUEST:
      {
        return _extends({}, state, {
          processing: true,
          error: initialState.error,
          successMessage: initialState.successMessage
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_POST_SUCCESS:
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_RESET_SUCCESS:
      {
        var successMessage = payload.successMessage;


        return _extends({}, state, {
          processing: false,
          error: initialState.error,
          successMessage: successMessage || 'Ready!'
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_POST_FAILURE:
      {
        return _extends({}, state, {
          error: error || 'Cannot request password resetting!',
          processing: false,
          successMessage: initialState.successMessage
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_RESET_FAILURE:
      {
        return _extends({}, state, {
          error: error || 'Cannot change your password. Please, try again later!',
          processing: false,
          successMessage: initialState.successMessage
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_SET_RESETTING_MODE:
      {
        var resettingParams = payload.resettingParams;


        return _extends({}, state, {
          resettingParams: resettingParams,
          processing: false,
          error: initialState.error,
          successMessage: initialState.successMessage
        });
      }

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

var stateSelector = function stateSelector(state) {
  return state[moduleName];
};

var selectForgotPasswordIsProcessing = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (forgotPassword) {
  return forgotPassword.processing;
});

var selectForgotPasswordError = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (forgotPassword) {
  return forgotPassword.error;
});

var selectForgotPasswordSuccessMessage = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (forgotPassword) {
  return forgotPassword.successMessage;
});

var selectForgotPasswordResettingParams = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (forgotPassword) {
  return forgotPassword.resettingParams;
});

var selectForgotPasswordIsResettingMode = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectForgotPasswordResettingParams, function (resettingParams) {
  return !!resettingParams;
});

var selectForgotPasswordCurrentEmail = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectForgotPasswordResettingParams, function (resettingParams) {
  return resettingParams && resettingParams.email || '';
});

// Selectors (up)

/***/ }),

/***/ "91gb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var core_namespaceObject = {};
__webpack_require__.d(core_namespaceObject, "initialize", function() { return initialize; });
__webpack_require__.d(core_namespaceObject, "ga", function() { return ga; });
__webpack_require__.d(core_namespaceObject, "set", function() { return set; });
__webpack_require__.d(core_namespaceObject, "send", function() { return send; });
__webpack_require__.d(core_namespaceObject, "pageview", function() { return pageview; });
__webpack_require__.d(core_namespaceObject, "modalview", function() { return modalview; });
__webpack_require__.d(core_namespaceObject, "timing", function() { return timing; });
__webpack_require__.d(core_namespaceObject, "event", function() { return core_event; });
__webpack_require__.d(core_namespaceObject, "exception", function() { return exception; });
__webpack_require__.d(core_namespaceObject, "plugin", function() { return core_plugin; });
__webpack_require__.d(core_namespaceObject, "outboundLink", function() { return outboundLink; });
__webpack_require__.d(core_namespaceObject, "testModeAPI", function() { return core_testModeAPI; });
__webpack_require__.d(core_namespaceObject, "default", function() { return core; });

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/console/warn.js
function warn(s) {
  console.warn('[react-ga]', s);
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/components/OutboundLink.js
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink_OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return preact_compat_es["default"].createElement('a', props);
    }
  }]);

  return OutboundLink;
}(preact_compat_es["Component"]);

_defineProperty(OutboundLink_OutboundLink, "trackLink", function () {
  warn('ga tracking not enabled');
});

_defineProperty(OutboundLink_OutboundLink, "propTypes", {
  eventLabel: prop_types_default.a.string.isRequired,
  target: prop_types_default.a.string,
  to: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  trackerNames: prop_types_default.a.arrayOf(prop_types_default.a.string)
});

_defineProperty(OutboundLink_OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});


// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/mightBeEmail.js
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/trim.js
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/toTitleCase.js
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return trim(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/format.js



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (mightBeEmail(s)) {
    warn('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return toTitleCase(s);
  }

  return s;
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/removeLeadingSlash.js
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/loadGA.js
/* harmony default export */ var loadGA = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */

  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */
});
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/console/log.js
function log(s) {
  console.info('[react-ga]', s);
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/testModeAPI.js
var gaCalls = [];
/* harmony default export */ var testModeAPI = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/core.js
function core__objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = core__objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function core__objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function core_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function core__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      core_ownKeys(source, true).forEach(function (key) {
        core__defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      core_ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function core__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function core__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    core__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    core__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return core__typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  }
}

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var core_internalGa = function internalGa() {
  var _window;

  if (_testMode) return testModeAPI.ga.apply(testModeAPI, arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return warn('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return format(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof core_internalGa === 'function') {
    if (typeof command !== 'string') {
      warn('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) core_internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        core_internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    warn('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    core_internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    core_internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) loadGA(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (core__typeof(config) !== 'object') {
        warn('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    core_internalGa.apply(void 0, args);

    if (_debug) {
      log('called ga(\'arguments\');');
      log("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    warn('`fieldsObject` is required in .set()');
    return;
  }

  if (core__typeof(fieldsObject) !== 'object') {
    warn('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    warn('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    log('called ga(\'set\', fieldsObject);');
    log("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    log('called ga(\'send\', fieldObject);');
    log("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    log("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    warn('path is required in .pageview()');
    return;
  }

  var path = trim(rawPath);

  if (path === '') {
    warn('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', core__objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      log('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      log("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    warn('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = removeLeadingSlash(trim(rawModalName));

  if (modalName === '') {
    warn('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      log('called ga(\'send\', \'pageview\', path);');
      log("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      warn('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function core_event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = core__objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      warn('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        warn('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        warn('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        warn('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          warn('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        warn('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var core_plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        warn('`name` is required in .require()');
        return;
      }

      var name = trim(rawName);

      if (name === '') {
        warn('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (core__typeof(options) !== 'object') {
          warn('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          warn('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          log("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          log("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        warn('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        warn('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            log("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    warn('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      warn('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var core_testModeAPI = testModeAPI;
/* harmony default export */ var core = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: core_event,
  exception: exception,
  plugin: core_plugin,
  outboundLink: outboundLink,
  testModeAPI: testModeAPI
});
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/index.js
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
function esm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function esm__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      esm_ownKeys(source, true).forEach(function (key) {
        esm__defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      esm_ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function esm__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}



var esm_initialize = initialize;
var esm_ga = ga;
var esm_set = set;
var esm_send = send;
var esm_pageview = pageview;
var esm_modalview = modalview;
var esm_timing = timing;
var esm_event = core_event;
var esm_exception = exception;
var esm_plugin = core_plugin;
var esm_outboundLink = outboundLink;
var esm_testModeAPI = core_testModeAPI;
OutboundLink_OutboundLink.origTrackLink = OutboundLink_OutboundLink.trackLink;
OutboundLink_OutboundLink.trackLink = outboundLink;
var esm_OutboundLink = OutboundLink_OutboundLink;
/* harmony default export */ var esm = __webpack_exports__["a"] = (esm__objectSpread({}, core_namespaceObject, {
  OutboundLink: esm_OutboundLink
}));

/***/ }),

/***/ "9I8e":
/***/ (function(module, exports) {

/**
  # normalice

  Normalize an ice server configuration object (or plain old string) into a format
  that is usable in all browsers supporting WebRTC.  Primarily this module is designed
  to help with the transition of the `url` attribute of the configuration object to
  the `urls` attribute.

  ## Example Usage

  <<< examples/simple.js

**/

var protocols = ['stun:', 'turn:'];

module.exports = function (input) {
  var url = (input || {}).url || input;
  var protocol;
  var parts;
  var output = {};

  // if we don't have a string url, then allow the input to passthrough
  if (typeof url != 'string' && !(url instanceof String)) {
    return input;
  }

  // trim the url string, and convert to an array
  url = url.trim();

  // if the protocol is not known, then passthrough
  protocol = protocols[protocols.indexOf(url.slice(0, 5))];
  if (!protocol) {
    return input;
  }

  // now let's attack the remaining url parts
  url = url.slice(5);
  parts = url.split('@');

  output.username = input.username;
  output.credential = input.credential;
  // if we have an authentication part, then set the credentials
  if (parts.length > 1) {
    url = parts[1];
    parts = parts[0].split(':');

    // add the output credential and username
    output.username = parts[0];
    output.credential = (input || {}).credential || parts[1] || '';
  }

  output.url = protocol + url;
  output.urls = [output.url];

  return output;
};

/***/ }),

/***/ "9TS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("svpX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__("CtKb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("UKR9");




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);

/***/ }),

/***/ "9UzH":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var call = __webpack_require__("HiG7");
var isObject = __webpack_require__("FS7x");
var isSymbol = __webpack_require__("trvQ");
var getMethod = __webpack_require__("YeOI");
var ordinaryToPrimitive = __webpack_require__("GhPB");
var wellKnownSymbol = __webpack_require__("G69i");

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

/***/ }),

/***/ "9dRJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return langPack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__("4PH9");
var _langPack;


/* eslint import/prefer-default-export: 0, react/no-unescaped-entities: 0 */


var langPack = (_langPack = {}, _langPack[__WEBPACK_IMPORTED_MODULE_1__consts__["g" /* EN */]] = {
  DOWNLOAD_APP_BTN: 'Download app',
  HOMEPAGE_FAQ_TITLE: 'Most popular questions',
  GENERAL_QUESTIONS: 'General Questions',
  CUSTOMERS_QUESTIONS: 'Customers',
  EXPERTS_QUESTIONS: 'Experts',
  PAYMENTS_QUESTIONS: 'Payments',
  BLOG_TITLE: 'Blog',
  FULL_STORY_BTN: 'Full story',
  OTHER_POSTS: 'Other posts',
  MISC: {
    DELETE: 'Delete',
    UPDATE_NOW: 'Update now',
    CONNECTING: 'Connecting',
    CONNECTING_TO_SERVER: 'Connecting to server',
    CALLING_PRO: 'Calling Pro',
    CREDIT_CARD: 'Credit card',
    ADD_A_CARD: 'Add a card',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    SAVE: 'Save',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
    PLEASE_ENTER_LAST_NAME: 'Please enter last name',
    YOU_WILL_PAY: 'You will pay',
    PER_MINUTE_FOR_CALL: 'per minute for this call',
    MINUTES_SHORT: 'min',
    BECOME_PRO: 'Become a Pro',
    BLOG: 'Blog',
    FIND_A_PRO: 'Find a Pro',
    MY_CLIENTS: 'My Clients',
    MY_PROS: 'My Pros',
    MY_APPOINTMENTS: 'My Appointments',
    SIGN_UP: 'Sign Up',
    LOG_OUT: 'Log out',
    REGISTER_AS_PRO: 'Register as Pro',
    REGISTER: 'Register',
    LOG_IN: 'Log in',
    FORGOT_PASSWORD: 'Forgot password',
    PASSWORD: 'Password',
    DATE: 'Date',
    DATE_AND_TIME: 'Date and time',
    DURATION: 'Duration',
    TYPE: 'Type',
    EDIT: 'Edit',
    NAME: 'Name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    MOBILE: 'Mobile',
    CITY: 'City',
    BUSINESS_NAME: 'Business name',
    COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
    COUNTRY: 'Country',
    RATE: 'Rate',
    YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
    CODE_VERIFIED: 'Code verified',
    IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
    CODE_EXPIRES_IN: 'Code expires in',
    CODE: 'Code',
    VERIFY_CODE: 'Verify code',
    PLEASE_ENTER_EMAIL: 'Please enter email',
    RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
    SEND_VERIFICATION_CODE: 'Send verification code',
    LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully'
  },
  BLOG: {
    COMMENTS: 'Comments',
    REPLY: 'Reply',
    ADD_COMMENT: 'Add Comment',
    POST_COMMENT: 'Post comment'
  },
  BOOKING: {
    CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
    CANCELLATION_POLICY: 'Cancellation Policy',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
    YES_CANCEL: 'Yes, cancel',
    NO_KEEP: 'No, keep it'
  },
  COMMUNICATION: {
    ON_CALL_WITH: 'On call with',
    CONNECTING_WITH: 'Connecting with',
    INCOMING_CALL: 'Incoming Call',
    YOUR_CLIENT: 'Your client',
    TYPE_YOUR_MESSAGE: 'Type your message',
    MIN: 'min',
    CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.'
  },
  CREDIT_CARD: {
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder',
    EXPIRY_DATE: 'Expiry date',
    CVV: 'CVV',
    CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
    SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
    SAVE_PAYMENT_METHOD: 'Save payment method',
    X2_BONUS: 'x2 BONUS',
    YOU_WILL_GET: 'You will get',
    TELMIE_CREDIT: 'Telmie credit',
    IN_TOTAL: 'in total',
    CONFIRM_AND_PAY: 'Confirm & Pay',
    CANNOT_WITHDRAW: 'Cannot withdraw',
    FEE: 'fee',
    FREE: 'Free',
    YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
    AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
    AVALIABLE: 'Available',
    AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
    WITHDRAW: 'Withdraw',
    FREE_APPLIES: 'Fee applies: ',
    YOU_RECEIVE: 'You receive: ',
    WITHDRAWAL_RULES: 'Withdrawal rules',
    WITHDRAWAL_AMOUNT: 'Withdrawal amount',
    HIDE: 'Hide',
    SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules'
  },
  EDIT_PROFILE: {
    SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
    CANT_BE_CHANGED: 'Can\'t be changed',
    UPLOAD_PICTURE: 'Upload picture',
    NAME_ISNT_VALID: 'The name isn\'t valid.'
  },
  FEATURED_SERVICE: {
    CALL_NOW: 'Call now',
    CANCEL_CALL: 'Cancel call',
    NEXT_PRO: 'Next pro',
    NEXT_PRO_CAPS: 'NEXT PRO',
    THEN_CAPS: 'THEN'
  },
  HEADER: {
    HOW_IT_WORKS: 'How it works',
    FAQ: 'FAQ',
    CONTACT: 'Contact us',
    MONEY: 'Money',
    SETTINGS: 'Settings',
    LOGIN: 'Log in',
    EDIT_PROFILE: 'Edit Profile',
    NEW_CHATS: 'New Chats',
    WELL_DONE: 'Well done',
    SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
    EDIT_PRO_DETAILS: 'Edit Pro details'
  },
  HOMEPAGE: {
    FEATURED_PROS: 'Featured Pros',
    FEATURED_SERVICES: 'Featured services',
    DOWNLOAD_TELMIE_APP: 'Download Telmie app'
  },
  LANGUAGE_PRACTICE: {
    HAPPY_PROS: 'Happy Pros',
    HAPPY_USERS: 'Happy Users'
  },
  LOG_IN: {
    LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
    NEW_TO_TELMIE: 'New to Telmie',
    DOWNLOAD_THE_APP: 'Download the app'
  },
  NEW_LANDING: {
    MINUTES: 'minutes',
    COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
    BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
    PLEASE_ENTER_SUBJECT: 'Please enter subject',
    PLEASE_ENTER_MESSAGE: 'Please enter message'
  },
  PRO: {
    PRO: 'Pro',
    AMOUNT: 'Amount',
    NO_RECENT_CALLS: 'No recent calls',
    MESSAGES: 'Messages',
    START_CALL: 'Start Call',
    SHORTLISTED: 'Shortlisted',
    REMOVE: 'Remove',
    SHORTLIST: 'Shortlist',
    LOADING: 'Loading',
    TELMIE_CLIENT: 'Telmie Client',
    ON_CALL: 'On call',
    RECONNECTING: 'Reconnecting...',
    TELMIE_USER_IS_CALLING: 'Telmie user is calling',
    SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
    HOURS_FIRST_LETTER: 'h',
    MINUTES_FIRST_LETTER: 'm',
    CALENDAR_TITLE: 'My availability',
    CALENDAR_SUB_TITLE: 'I am not available right now',
    CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
    AVAILABLE_NOW: 'Available now',
    AVAILABLE_LATTER: 'Available later',
    WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
    PRO_IS_BUSY: 'Pro is busy'
  },
  PROFILE: {
    VIEW_ALL: 'View all',
    CONTACT: 'Contact',
    COUNT: 'Count',
    NO_RECENT_ACTIVITY: 'No recent activity',
    YOUR_DETAILS: 'Your details',
    LOCATION: 'Location',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NO_RECENT_PROS: 'No recent PROS',
    WITHDRAW_EARNINGS: 'Withdraw earnings',
    TOP_UP: 'Top Up',
    ATTACH_CARD: 'Attach card',
    SERVICE: 'Service',
    APPOINTMENT_WITH: 'Appointment with',
    COST: 'Cost',
    BALANCE: 'Balance',
    NO_RECENT_TRANSACTIONS: 'No recent transactions',
    NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
    CLIENT: 'Client'
  },
  RADIO_BUTTONS: {
    APPROVED: 'Approved',
    SECTORS: 'SECTORS'
  },
  SEARCH: {
    FILTERS: 'Filters',
    SESSIONS: 'sessions',
    ARRANGE_BY: 'Arrange by',
    ENTER_KEYWORDS: 'Enter keywords',
    RESET_FILTERS: 'Clear all'
  },
  SELECT: {
    EVERY: 'Every'
  },
  SETTINGS: {
    IMPORTANT_VIA_EMAIL: 'Important via email',
    WORKING_AS_PRO: 'Working as Pro',
    PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
    ADD_NEW_PERIOD: 'Add new period',
    CHANGE_BANK_ACCOUNT: 'Change bank account',
    ADD_BANK_ACCOUNT: 'Add bank account',
    ENTITY: 'Entity',
    ADDRESS: 'Address',
    YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
    WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
    SORT_CODE: 'Sort code',
    DIGITS_VALUE: 'digits value',
    ACCOUNT_NUMBER: 'Account number',
    BAD_REQUEST_DATA: 'Bad Request data',
    PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
    CONFIRM: 'Confirm',
    UPLOAD_ANOTHER_IMAGE: 'Upload another image',
    UPLOAD: 'Upload',
    YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
    YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
    PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
    POST_CODE: 'Post Code',
    LOADING_CARDS: 'Loading cards',
    NO_CARDS: 'No cards.',
    COMPANY_ADDRESS: 'Company address',
    PERSONAL_ADDRESS: 'Personal address',
    SERVICE_NAME: 'Service name',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_SUB_CATEGORY: 'Service sub-category',
    SERVICE_DESCRIPTION: 'Service description',
    PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
    LOADING_ACCOUNTS: 'Loading accounts',
    ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
    PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
    THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
    DAYS_REQUIRED: 'Please select days',
    FROM: 'From',
    TO: 'To',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
    PROFILE_DETAILS: 'Profile details',
    PRO_SETTINGS: 'PRO SETTINGS',
    WORK_AS_PRO: 'Work as Pro',
    PRO_DETAILS: 'Pro details',
    PAYOUT_BANK_DETAILS: 'Payout bank details',
    PREVIEW_MY_PROFILE: 'Preview my profile',
    MY_AVAILABILITY: 'My availability',
    HIDE_PROFILE: 'Hide profile',
    GENERAL_SETTINGS: 'GENERAL SETTINGS',
    PAYMENT_SETTINGS: 'Payment settings',
    EMAIL_NOTIFICATION: 'Email notification',
    BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
    BANK_ACCOUNT: 'Bank account',
    ID_VERIFICATION: 'ID Verification',
    I_WANT_TO_TAKE_PART: 'I want to take part'
  },
  SIGN_UP: {
    CONFIRM_EMAIL: 'Now confirm your email address',
    RESEND: 'Resend',
    CONFIRM_EMAIL_MESSAGE: function CONFIRM_EMAIL_MESSAGE(email) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        'We\'ve sent an email to ',
        email,
        ', please check your inbox and click the link "Activate" to confirm and earn!'
      );
    },
    USE_ANOTHER_EMAIL: 'Use another email',
    SECTOR: 'Sector',
    CATEGORY: 'Category',
    PLEASE_SELECT_CATEGORY: 'Please select category',
    PROFESSION: 'Profession',
    DESCRIPTION: 'Description',
    FREE: 'Free',
    PER_MINUTE: 'per minute',
    BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
    TERMS_OF_USE: 'Terms of use',
    AND_THE: 'and the',
    PRIVACY_POLICY: 'Privacy Policy',
    THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
    CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
    ACCOUNT_TYPE: 'Account type',
    APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
    CANCEL_CHANGES: 'Cancel changes',
    PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
    ERROR: 'Error',
    PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
    UNITED_KINGDOM: 'United Kingdom',
    ONLY_UK_NOW: 'Only UK for now',
    I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
    ALREADY_HAVE_ACCOUNT: 'Already have an account',
    CODE_HAVE_BEEN_SENT: 'Code has been sent to',
    EDUCATION: {
      EDUCATION: 'Education',
      LANGUAGE_TUTOR: 'Language tutor',
      LANGUAGE_PRACTICE: 'Language practice',
      EXAMS_PREPARATION: 'Exams preparation',
      SCIENCE: 'Science',
      BUSINESS_STUDIES: 'Business studies',
      SOCIAL_SCIENCE: 'Social science',
      DRAWING: 'Drawing',
      MUSIC: 'Music',
      DANCE: 'Dance'
    },
    SERVICES: {
      SERVICES: 'Services',
      INTERPRETER: 'Interpreter',
      NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
      THERAPIST: 'Therapist',
      LISTENER: 'Listener',
      SPEECH_THERAPIST: 'Speech therapist',
      FORTUN_TELLER: 'Fortun teller',
      ASTROLOGIST: 'Astrologist',
      PERSONAL_ASSISTANT: 'Personal assistant',
      CAREER_COACH: 'Career coach'
    },
    CONSULTANCY: {
      CONSULTANCY: 'Consultancy',
      LEGAL: 'Legal',
      MEDICAL: 'Medical',
      BUSINESS: 'Business',
      FAMILY: 'Family',
      INVESTMENT: 'Investment',
      TECH_SUPPORT: 'Tech support',
      BEAUTICIAN: 'Beautician'
    },
    HEALTH_LIFESTYLE: {
      HEALTH_LIFESTYLE: 'Health&Lifestyle',
      PERSONAL_TRAINER: 'Personal trainer',
      YOGA_INSTRUCTOR: 'Yuga instructor',
      MEDITATION_INSTRUCTOR: 'Meditation instructor',
      DIETOLOGIST: 'Dietologist',
      SPORT_COACH: 'Sport coach',
      FITNESS_PROFESSIONAL: 'Fitness professional',
      SPIRITUAL_COACH: 'Spiritual coach'
    },
    PLEASE_SELECT_SECTOR: 'Please select sector',
    PLEASE_ENTER_PROFESSION: 'Please enter profession',
    PLEASE_ENTER_DESCRIPTION: 'Please enter description',
    PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
    PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
    YOU_ARE_UNDER_18: 'You are under 18',
    DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
    YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
    PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
    CITY_IN_THE_UK: 'City in the UK',
    CITY_INCORRECT: 'City incorrect',
    POSTCODE: 'Postcode',
    PLEASE_ENTER_POSTCODE: 'Please enter postcode',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    ONLY_UK_ADDRESS: 'Only UK address',
    ADDRESS_INCORRECT: 'Address incorrect',
    ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
    BIRTHDAY_INCORRECT: 'Birthday incorrect',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    WE_WONT_SHARE_IT: 'We won\'t share it with others.',
    MOBILE_INCORRECT: 'Mobile incorrect',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    EG_IO: 'e.g. i0ONOZLgCIM',
    SERVICE_INCORRECT: 'Service incorrect',
    SERVICE_LABEL: 'Service (20 characters)',
    IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
    SERVICE_NAME_INCORRECT: 'Service name incorrect',
    SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
    SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
    SERVICE_DESCRIPTION: 'Service description (500-10000 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
    PRICE_PER_MINUTE: 'Price per minute',
    DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
    YES: 'Yes.',
    NO: 'No.',
    DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
    YES_SAVE: 'Yes, save.',
    DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
    ENTER_TAX_ID: 'Enter tax ID to check',
    CHECK: 'Check.',
    PLEASE_ENTER_PASSWORD: 'Please enter password',
    FIRST_NAME: 'First name'
  },
  SOCIAL_NETWORK: {
    CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
    CONTINUE_WITH_GOOGLE: 'Continue with Google'
  },
  ROUTES: {
    ERROR_404: 'Error 404',
    PAGE_NOT_FOUND: 'Page not found',
    THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
    GO_HOME: 'Go Home',
    FEATURED_SERVICE: 'FEATURED SERVICE',
    WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
    GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
    FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
    CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
    NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
    YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
    RESET: 'Reset',
    BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
    TELMIE_T_C: 'Telmie T&C',
    TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
    AND: 'and',
    STRIPE_T_C: 'Stripe T&C.',
    SORRY: 'Sorry',
    IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
    OR: 'or',
    IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
    BACK_TO_SETTINGS: 'Back to Settings',
    PROFILE_PREVIEW: 'Profile preview',
    PRO_DETAILS: 'Pro details',
    PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
    RESULTS_FOR: 'Results for',
    SORRY_NO_PROS: 'Sorry, no pros found for',
    SELECT_YOUR_INTEREST: 'Select your interest',
    TELMIE_MY_CLIENTS: 'Telmie | My Clients',
    FIND_YOUR_CLIENT: 'Find your Client',
    TELMIE_MY_PROS: 'Telmie | My Pros',
    FIND_YOUR_PRO: 'Find your Pro',
    PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
    TELMIE_PREVIEW: 'Telmie | Preview',
    LOWEST_RATE_FIRST: 'Lowest rate first',
    HIGHEST_RATE_FIRST: 'Highest rate first',
    EXPERIENCE: 'Experience',
    RATING: 'Rating',
    ACTIVITY: 'Activity',
    LANGUAGES: 'Languages',
    COACHING: 'Coaching',
    IMMIGRATION: 'Immigration',
    OTHER: 'Other',
    ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
    ERROR_WITH_STRIPE: 'Error with Stripe.',
    TELMIE_PRO: 'Telmie | Pro'
  },
  FOOTER: {
    HOME: 'Home',
    CONTACT: 'Contact',
    SUPPORT: 'Support',
    POLICY: 'Privacy Policy',
    CANCELLATION: 'Booking Cancellation Policy',
    TERMS: 'Terms',
    FAQ: 'FAQ',
    COPYRIGHT: 'Copyright',
    COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom'
  },
  CONTACT_US: {
    title: 'Contact us',
    subTitle: 'Any questions? Drop us a line.',
    name: 'Your name',
    email: 'Your email',
    company: 'Company',
    subject: 'Subject',
    message: 'Your message',
    success: 'Your message has been sent. Thank you!',
    submitBtn: 'Submit'
  },
  SERVICES: {
    LANGUAGE_PRACTICE: 'Language practice',
    IMMIGRATION_CONSULTANT: 'Immigration Pro',
    IMMIGRATION_ADVICE: 'Immigration advice',
    LANGUAGE_LEARNERS: 'Language learning'
  },
  FAQ: 'FAQ',
  MORE_FAQ: 'More FAQ',
  API: {
    NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content'
  },
  NOTIFICATIONS: {
    DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
    EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
    MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
    SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
    UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!'
  },
  REGISTER_PRO: {
    FIRST_NAME: 'First name',
    FIRST_NAME_ERROR: 'First name field is required',
    LAST_NAME: 'Last name',
    LAST_NAME_ERROR: 'Last name field is required',
    COUNTRY: 'Country',
    COUNTRY_PLACEHOLDER: 'Select country',
    COUNTRY_ERROR: 'Country field is required',
    CITY: 'City',
    POSTCODE: 'Postcode',
    POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
    DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
    DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    MOBILE_HINT: 'We won\'t share it with others.',
    MOBILE_ERROR: 'Must contain only numbers',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
    SERVICES: 'Services',
    SERVICES_PLACEHOLDER: 'Select service',
    SERVICES_ERROR: 'Services field is required',
    SERVICE: 'Service (20 characters)',
    SERVICE_HINT: 'i.e. English practice, Immigration advice',
    SERVICE_ERROR: 'Service name may not be greater than 20 characters',
    SECTOR: 'Sector',
    SECTOR_PLACEHOLDER: 'Select sector',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
    SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
    SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
    SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
    SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
    COST_PER_MINUTE_ERROR: 'Please enter price',
    COST_PER_MINUTE_MAX: 'Maximum allowed for this service'
  }
}, _langPack[__WEBPACK_IMPORTED_MODULE_1__consts__["u" /* RU */]] = {
  DOWNLOAD_APP_BTN: 'Скачать приложение',
  HOMEPAGE_FAQ_TITLE: 'Популярные вопросы',
  GENERAL_QUESTIONS: 'Общие вопросы',
  CUSTOMERS_QUESTIONS: 'Клиенты',
  EXPERTS_QUESTIONS: 'Эксперты',
  PAYMENTS_QUESTIONS: 'Оплата',
  BLOG_TITLE: 'Блог',
  FULL_STORY_BTN: 'Подробнее',
  OTHER_POSTS: 'Другие статьи',
  MISC: {
    DELETE: 'Delete',
    UPDATE_NOW: 'Update now',
    CONNECTING: 'Connecting',
    CONNECTING_TO_SERVER: 'Connecting to server',
    CALLING_PRO: 'Calling Pro',
    CREDIT_CARD: 'Credit card',
    ADD_A_CARD: 'Add a card',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    SAVE: 'Save',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
    PLEASE_ENTER_LAST_NAME: 'Please enter last name',
    YOU_WILL_PAY: 'You will pay',
    PER_MINUTE_FOR_CALL: 'per minute for this call',
    MINUTES_SHORT: 'min',
    BECOME_PRO: 'Become a Pro',
    BLOG: 'Блог',
    FIND_A_PRO: 'Find a Pro',
    MY_APPOINTMENTS: 'My Appointments',
    MY_CLIENTS: 'My Clients',
    MY_PROS: 'My Pros',
    SIGN_UP: 'Sign Up',
    LOG_OUT: 'Log out',
    REGISTER_AS_PRO: 'Register as Pro',
    REGISTER: 'Register',
    LOG_IN: 'Log in',
    FORGOT_PASSWORD: 'Forgot password',
    PASSWORD: 'Password',
    DATE: 'Date',
    DATE_AND_TIME: 'Date and time',
    DURATION: 'Duration',
    TYPE: 'Type',
    EDIT: 'Edit',
    NAME: 'Name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    MOBILE: 'Mobile',
    CITY: 'City',
    BUSINESS_NAME: 'Business name',
    COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
    COUNTRY: 'Country',
    RATE: 'Rate',
    YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
    CODE_VERIFIED: 'Code verified',
    IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
    CODE_EXPIRES_IN: 'Code expires in',
    CODE: 'Code',
    VERIFY_CODE: 'Verify code',
    PLEASE_ENTER_EMAIL: 'Please enter email',
    RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
    SEND_VERIFICATION_CODE: 'Send verification code',
    LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully'
  },
  BLOG: {
    COMMENTS: 'Comments',
    REPLY: 'Reply',
    ADD_COMMENT: 'Add Comment',
    POST_COMMENT: 'Post comment',
    YES_CANCEL: 'Yes, cancel',
    NO_KEEP: 'No, keep it'
  },
  BOOKING: {
    CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
    CANCELLATION_POLICY: 'Cancellation Policy',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?'
  },
  COMMUNICATION: {
    ON_CALL_WITH: 'On call with',
    CONNECTING_WITH: 'Connecting with',
    INCOMING_CALL: 'Incoming Call',
    YOUR_CLIENT: 'Your client',
    TYPE_YOUR_MESSAGE: 'Type your message',
    MIN: 'min',
    CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.'
  },
  CREDIT_CARD: {
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder',
    EXPIRY_DATE: 'Expiry date',
    CVV: 'CVV',
    CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
    SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
    SAVE_PAYMENT_METHOD: 'Save payment method',
    X2_BONUS: 'x2 BONUS',
    YOU_WILL_GET: 'You will get',
    TELMIE_CREDIT: 'Telmie credit',
    IN_TOTAL: 'in total',
    CONFIRM_AND_PAY: 'Confirm & Pay',
    CANNOT_WITHDRAW: 'Cannot withdraw',
    FEE: 'fee',
    FREE: 'Free',
    YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
    AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
    AVALIABLE: 'Available',
    AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
    WITHDRAW: 'Withdraw',
    FREE_APPLIES: 'Fee applies: ',
    YOU_RECEIVE: 'You receive: ',
    WITHDRAWAL_RULES: 'Withdrawal rules',
    WITHDRAWAL_AMOUNT: 'Withdrawal amount',
    HIDE: 'Hide',
    SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules'
  },
  EDIT_PROFILE: {
    SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
    CANT_BE_CHANGED: 'Can\'t be changed',
    UPLOAD_PICTURE: 'Upload picture',
    NAME_ISNT_VALID: 'The name isn\'t valid.'
  },
  FEATURED_SERVICE: {
    CALL_NOW: 'Call now',
    CANCEL_CALL: 'Cancel call',
    NEXT_PRO: 'Next pro',
    NEXT_PRO_CAPS: 'NEXT PRO',
    THEN_CAPS: 'THEN'
  },
  HEADER: {
    HOW_IT_WORKS: 'O нас',
    FAQ: 'Часто задаваемые вопросы',
    CONTACT: 'Связь с нами',
    MONEY: 'Money',
    SETTINGS: 'Settings',
    LOGIN: 'Log in',
    EDIT_PROFILE: 'Edit Profile',
    NEW_CHATS: 'New Chats',
    WELL_DONE: 'Well done',
    SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
    EDIT_PRO_DETAILS: 'Edit Pro details'
  },
  HOMEPAGE: {
    FEATURED_PROS: 'Featured Pros',
    FEATURED_SERVICES: 'Featured services',
    DOWNLOAD_TELMIE_APP: 'Download Telmie app'
  },
  LANGUAGE_PRACTICE: {
    HAPPY_PROS: 'Happy Pros',
    HAPPY_USERS: 'Happy Users'
  },
  LOG_IN: {
    LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
    NEW_TO_TELMIE: 'New to Telmie',
    DOWNLOAD_THE_APP: 'Download the app'
  },
  NEW_LANDING: {
    MINUTES: 'minutes',
    COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
    BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
    PLEASE_ENTER_SUBJECT: 'Please enter subject',
    PLEASE_ENTER_MESSAGE: 'Please enter message'
  },
  PRO: {
    PRO: 'Pro',
    AMOUNT: 'Amount',
    NO_RECENT_CALLS: 'No recent calls',
    MESSAGES: 'Messages',
    START_CALL: 'Start Call',
    SHORTLISTED: 'Shortlisted',
    REMOVE: 'Remove',
    SHORTLIST: 'Shortlist',
    LOADING: 'Loading',
    TELMIE_CLIENT: 'Telmie Client',
    ON_CALL: 'On call',
    RECONNECTING: 'Reconnecting...',
    TELMIE_USER_IS_CALLING: 'Telmie user is calling',
    SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
    HOURS_FIRST_LETTER: 'h',
    MINUTES_FIRST_LETTER: 'm',
    CALENDAR_TITLE: 'My availability',
    CALENDAR_SUB_TITLE: 'I am not available right now',
    CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
    AVAILABLE_NOW: 'Available now',
    AVAILABLE_LATTER: 'Available later',
    WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
    PRO_IS_BUSY: 'Pro is busy'
  },
  PROFILE: {
    VIEW_ALL: 'View all',
    CONTACT: 'Contact',
    COUNT: 'Count',
    NO_RECENT_ACTIVITY: 'No recent activity',
    YOUR_DETAILS: 'Your details',
    LOCATION: 'Location',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NO_RECENT_PROS: 'No recent PROS',
    WITHDRAW_EARNINGS: 'Withdraw earnings',
    TOP_UP: 'Top Up',
    ATTACH_CARD: 'Attach card',
    SERVICE: 'Service',
    APPOINTMENT_WITH: 'Appointment with',
    COST: 'Cost',
    BALANCE: 'Balance',
    NO_RECENT_TRANSACTIONS: 'No recent transactions',
    NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
    CLIENT: 'Client'
  },
  RADIO_BUTTONS: {
    APPROVED: 'Approved',
    SECTORS: 'SECTORS'
  },
  SEARCH: {
    FILTERS: 'Фильтры',
    SESSIONS: 'sessions',
    ARRANGE_BY: 'Arrange by',
    ENTER_KEYWORDS: 'Enter keywords',
    RESET_FILTERS: 'Сбросить фильтры'
  },
  SELECT: {
    EVERY: 'Every'
  },
  SETTINGS: {
    IMPORTANT_VIA_EMAIL: 'Important via email',
    WORKING_AS_PRO: 'Working as Pro',
    PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
    ADD_NEW_PERIOD: 'Add new period',
    CHANGE_BANK_ACCOUNT: 'Change bank account',
    ADD_BANK_ACCOUNT: 'Add bank account',
    ENTITY: 'Entity',
    ADDRESS: 'Address',
    YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
    WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
    SORT_CODE: 'Sort code',
    DIGITS_VALUE: 'digits value',
    ACCOUNT_NUMBER: 'Account number',
    BAD_REQUEST_DATA: 'Bad Request data',
    PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
    CONFIRM: 'Confirm',
    UPLOAD_ANOTHER_IMAGE: 'Upload another image',
    UPLOAD: 'Upload',
    YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
    YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
    PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
    POST_CODE: 'Post Code',
    LOADING_CARDS: 'Loading cards',
    NO_CARDS: 'No cards.',
    COMPANY_ADDRESS: 'Company address',
    PERSONAL_ADDRESS: 'Personal address',
    SERVICE_NAME: 'Service name',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_SUB_CATEGORY: 'Service sub-category',
    SERVICE_DESCRIPTION: 'Service description',
    PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
    LOADING_ACCOUNTS: 'Loading accounts',
    ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
    PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
    THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
    DAYS_REQUIRED: 'Please select days',
    FROM: 'From',
    TO: 'To',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
    PROFILE_DETAILS: 'Profile details',
    PRO_SETTINGS: 'PRO SETTINGS',
    WORK_AS_PRO: 'Work as Pro',
    PRO_DETAILS: 'Pro details',
    PAYOUT_BANK_DETAILS: 'Payout bank details',
    PREVIEW_MY_PROFILE: 'Preview my profile',
    MY_AVAILABILITY: 'My availability',
    HIDE_PROFILE: 'Hide profile',
    GENERAL_SETTINGS: 'GENERAL SETTINGS',
    PAYMENT_SETTINGS: 'Payment settings',
    EMAIL_NOTIFICATION: 'Email notification',
    BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
    BANK_ACCOUNT: 'Bank account',
    ID_VERIFICATION: 'ID Verification',
    I_WANT_TO_TAKE_PART: 'I want to take part'
  },
  SIGN_UP: {
    CONFIRM_EMAIL: 'Now confirm your email address',
    RESEND: 'Resend',
    CONFIRM_EMAIL_MESSAGE: function CONFIRM_EMAIL_MESSAGE(email) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        'We\'ve sent an email to ',
        email,
        ', please check your inbox and click the link \'Activate\' to confirm and earn!'
      );
    },
    USE_ANOTHER_EMAIL: 'Use another email',
    SECTOR: 'Sector',
    CATEGORY: 'Category',
    PLEASE_SELECT_CATEGORY: 'Please select category',
    PROFESSION: 'Profession',
    DESCRIPTION: 'Description',
    FREE: 'Free',
    PER_MINUTE: 'per minute',
    BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
    TERMS_OF_USE: 'Terms of use',
    AND_THE: 'and the',
    PRIVACY_POLICY: 'Privacy Policy',
    THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
    CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
    ACCOUNT_TYPE: 'Account type',
    APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
    CANCEL_CHANGES: 'Cancel changes',
    PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
    ERROR: 'Error',
    PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
    UNITED_KINGDOM: 'United Kingdom',
    ONLY_UK_NOW: 'Only UK for now',
    I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
    ALREADY_HAVE_ACCOUNT: 'Already have an account',
    CODE_HAVE_BEEN_SENT: 'Code has been sent to',
    EDUCATION: {
      EDUCATION: 'Education',
      LANGUAGE_TUTOR: 'Language tutor',
      LANGUAGE_PRACTICE: 'Language practice',
      EXAMS_PREPARATION: 'Exams preparation',
      SCIENCE: 'Science',
      BUSINESS_STUDIES: 'Business studies',
      SOCIAL_SCIENCE: 'Social science',
      DRAWING: 'Drawing',
      MUSIC: 'Music',
      DANCE: 'Dance'
    },
    SERVICES: {
      SERVICES: 'Services',
      INTERPRETER: 'Interpreter',
      NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
      THERAPIST: 'Therapist',
      LISTENER: 'Listener',
      SPEECH_THERAPIST: 'Speech therapist',
      FORTUN_TELLER: 'Fortun teller',
      ASTROLOGIST: 'Astrologist',
      PERSONAL_ASSISTANT: 'Personal assistant',
      CAREER_COACH: 'Career coach'
    },
    CONSULTANCY: {
      CONSULTANCY: 'Consultancy',
      LEGAL: 'Legal',
      MEDICAL: 'Medical',
      BUSINESS: 'Business',
      FAMILY: 'Family',
      INVESTMENT: 'Investment',
      TECH_SUPPORT: 'Tech support',
      BEAUTICIAN: 'Beautician'
    },
    HEALTH_LIFESTYLE: {
      HEALTH_LIFESTYLE: 'Health&Lifestyle',
      PERSONAL_TRAINER: 'Personal trainer',
      YOGA_INSTRUCTOR: 'Yuga instructor',
      MEDITATION_INSTRUCTOR: 'Meditation instructor',
      DIETOLOGIST: 'Dietologist',
      SPORT_COACH: 'Sport coach',
      FITNESS_PROFESSIONAL: 'Fitness professional',
      SPIRITUAL_COACH: 'Spiritual coach'
    },
    PLEASE_SELECT_SECTOR: 'Please select sector',
    PLEASE_ENTER_PROFESSION: 'Please enter profession',
    PLEASE_ENTER_DESCRIPTION: 'Please enter description',
    PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
    PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
    YOU_ARE_UNDER_18: 'You are under 18',
    DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
    YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
    PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
    CITY_IN_THE_UK: 'City in the UK',
    CITY_INCORRECT: 'City incorrect',
    POSTCODE: 'Postcode',
    PLEASE_ENTER_POSTCODE: 'Please enter postcode',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    ONLY_UK_ADDRESS: 'Only UK address',
    ADDRESS_INCORRECT: 'Address incorrect',
    ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
    BIRTHDAY_INCORRECT: 'Birthday incorrect',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    WE_WONT_SHARE_IT: 'We won\'t share it with others.',
    MOBILE_INCORRECT: 'Mobile incorrect',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    EG_IO: 'e.g. i0ONOZLgCIM',
    SERVICE_INCORRECT: 'Service incorrect',
    SERVICE_LABEL: 'Service (20 characters)',
    IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
    SERVICE_NAME_INCORRECT: 'Service name incorrect',
    SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
    SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
    SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
    PRICE_PER_MINUTE: 'Price per minute',
    DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
    YES: 'Yes.',
    NO: 'No.',
    DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
    YES_SAVE: 'Yes, save.',
    DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
    ENTER_TAX_ID: 'Enter tax ID to check',
    CHECK: 'Check.',
    PLEASE_ENTER_PASSWORD: 'Please enter password',
    FIRST_NAME: 'First name'
  },
  SOCIAL_NETWORK: {
    CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
    CONTINUE_WITH_GOOGLE: 'Continue with Google'
  },
  ROUTES: {
    ERROR_404: 'Error 404',
    PAGE_NOT_FOUND: 'Page not found',
    THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
    GO_HOME: 'Go Home',
    FEATURED_SERVICE: 'FEATURED SERVICE',
    WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
    GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
    FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
    CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
    NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
    YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
    RESET: 'Reset',
    BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
    TELMIE_T_C: 'Telmie T&C',
    TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
    AND: 'and',
    STRIPE_T_C: 'Stripe T&C.',
    SORRY: 'Sorry',
    IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
    OR: 'or',
    IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
    BACK_TO_SETTINGS: 'Back to Settings',
    PROFILE_PREVIEW: 'Profile preview',
    PRO_DETAILS: 'Pro details',
    PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
    RESULTS_FOR: 'Results for',
    SORRY_NO_PROS: 'Sorry, no pros found for',
    SELECT_YOUR_INTEREST: 'Select your interest',
    TELMIE_MY_CLIENTS: 'Telmie | My Clients',
    FIND_YOUR_CLIENT: 'Find your Client',
    TELMIE_MY_PROS: 'Telmie | My Pros',
    FIND_YOUR_PRO: 'Find your Pro',
    PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
    TELMIE_PREVIEW: 'Telmie | Preview',
    LOWEST_RATE_FIRST: 'Lowest rate first',
    HIGHEST_RATE_FIRST: 'Highest rate first',
    EXPERIENCE: 'Experience',
    RATING: 'Rating',
    ACTIVITY: 'Activity',
    LANGUAGES: 'Languages',
    COACHING: 'Coaching',
    IMMIGRATION: 'Immigration',
    OTHER: 'Other',
    ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
    ERROR_WITH_STRIPE: 'Error with Stripe.',
    TELMIE_PRO: 'Telmie | Pro'
  },
  FOOTER: {
    HOME: 'Главная',
    CONTACT: 'Контакт',
    SUPPORT: 'Поддержка',
    POLICY: 'Политика приватности',
    TERMS: 'Условия',
    FAQ: 'ЧаВо',
    COPYRIGHT: 'Copyright',
    COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom'
  },
  CONTACT_US: {
    title: 'Как с нами связаться?',
    subTitle: 'Есть вопросы? Напишите нам.',
    name: 'Ваше имя',
    email: 'Ваш имейл',
    company: 'Название компании',
    subject: 'Тема',
    message: 'Ваше сообщение',
    success: 'Ваше сообщение было отправлено. Спасибо!',
    submitBtn: 'Отправить'
  },
  SERVICES: {
    LANGUAGE_PRACTICE: 'Практика английского',
    IMMIGRATION_ADVICE: 'Иммиграционные консультации',
    IMMIGRATION_CONSULTANT: 'Иммиграционная помощь',
    LANGUAGE_LEARNERS: 'Изучение языка'
  },
  FAQ: 'Часто задаваемые вопросы',
  MORE_FAQ: 'Больше вопросов',
  API: {
    NOTIFICATION_MESSAGE: 'Пожалуйста, нажмите на данное сообщение, чтобы перезагрузить эту страницу'
  },
  NOTIFICATIONS: {
    DOWNLOAD_TO_USE_ON_MOBILE: 'Загрузите приложение Telmie, чтобы использовать Telmie на своем мобильном устройстве.',
    EMAIL_VALIDATED_SUCCESSFULLY: 'Ваш e-mail адрес был успешно подтвержден. Вы можете продолжить регистрацию на своем мобильном устройстве или войти в систему, используя данные своей учетной записи на этой странице.',
    MAX_ATTACHED_FILES_AMOUNT: 'Максимальное количество вложенных файлов',
    SUPPORTED_FILE_TYPES: 'Этот формат файла еще не поддерживается. Пожалуйста, отправляйте файлы в следующих форматах:',
    UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!'
  },
  REGISTER_PRO: {
    FIRST_NAME: 'First name',
    FIRST_NAME_ERROR: 'First name field is required',
    LAST_NAME: 'Last name',
    LAST_NAME_ERROR: 'Last name field is required',
    COUNTRY: 'Country',
    COUNTRY_PLACEHOLDER: 'Select country',
    COUNTRY_ERROR: 'Country field is required',
    CITY: 'City',
    POSTCODE: 'Postcode',
    POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
    DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
    DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    MOBILE_HINT: 'We won\'t share it with others.',
    MOBILE_ERROR: 'Must contain only numbers',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
    SERVICES: 'Services',
    SERVICES_PLACEHOLDER: 'Select service',
    SERVICES_ERROR: 'Services field is required',
    SERVICE: 'Service (20 characters)',
    SERVICE_HINT: 'i.e. English practice, Immigration advice',
    SERVICE_ERROR: 'Service name may not be greater than 20 characters',
    SECTOR: 'Sector',
    SECTOR_PLACEHOLDER: 'Select sector',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
    SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
    SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
    SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
    SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
    COST_PER_MINUTE_ERROR: 'Please enter price',
    COST_PER_MINUTE_MAX: 'Maximum allowed for this service'
  }
}, _langPack[__WEBPACK_IMPORTED_MODULE_1__consts__["m" /* IT */]] = {
  DOWNLOAD_APP_BTN: 'Scarica la App',
  HOMEPAGE_FAQ_TITLE: 'Domande più popolari',
  GENERAL_QUESTIONS: 'Domande frequenti',
  CUSTOMERS_QUESTIONS: 'Clienti',
  EXPERTS_QUESTIONS: 'Domande frequenti per specialisti',
  PAYMENTS_QUESTIONS: 'Domande frequenti sui pagamenti',
  BLOG_TITLE: 'Blog',
  FULL_STORY_BTN: 'La storia completa',
  OTHER_POSTS: 'Altri post',
  MISC: {
    DELETE: 'Delete',
    UPDATE_NOW: 'Update now',
    CONNECTING: 'Connecting',
    CONNECTING_TO_SERVER: 'Connecting to server',
    CALLING_PRO: 'Calling Pro',
    CREDIT_CARD: 'Credit card',
    ADD_A_CARD: 'Add a card',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    SAVE: 'Save',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
    PLEASE_ENTER_LAST_NAME: 'Please enter last name',
    YOU_WILL_PAY: 'You will pay',
    PER_MINUTE_FOR_CALL: 'per minute for this call',
    MINUTES_SHORT: 'min',
    BECOME_PRO: 'Become a Pro',
    BLOG: 'Blog',
    FIND_A_PRO: 'Find a Pro',
    MY_CLIENTS: 'My Clients',
    MY_PROS: 'My Pros',
    MY_APPOINTMENTS: 'My Appointments',
    SIGN_UP: 'Sign Up',
    LOG_OUT: 'Log out',
    REGISTER_AS_PRO: 'Register as Pro',
    REGISTER: 'Register',
    LOG_IN: 'Log in',
    FORGOT_PASSWORD: 'Forgot password',
    PASSWORD: 'Password',
    DATE: 'Date',
    DATE_AND_TIME: 'Date and time',
    DURATION: 'Duration',
    TYPE: 'Type',
    EDIT: 'Edit',
    NAME: 'Name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    MOBILE: 'Mobile',
    CITY: 'City',
    BUSINESS_NAME: 'Business name',
    COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
    COUNTRY: 'Country',
    RATE: 'Rate',
    YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
    CODE_VERIFIED: 'Code verified',
    IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
    CODE_EXPIRES_IN: 'Code expires in',
    CODE: 'Code',
    VERIFY_CODE: 'Verify code',
    PLEASE_ENTER_EMAIL: 'Please enter email',
    RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
    SEND_VERIFICATION_CODE: 'Send verification code',
    LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully'
  },
  BLOG: {
    COMMENTS: 'Comments',
    REPLY: 'Reply',
    ADD_COMMENT: 'Add Comment',
    POST_COMMENT: 'Post comment'
  },
  BOOKING: {
    CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
    CANCELLATION_POLICY: 'Cancellation Policy',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
    YES_CANCEL: 'Yes, cancel',
    NO_KEEP: 'No, keep it'
  },
  COMMUNICATION: {
    ON_CALL_WITH: 'On call with',
    CONNECTING_WITH: 'Connecting with',
    INCOMING_CALL: 'Incoming Call',
    YOUR_CLIENT: 'Your client',
    TYPE_YOUR_MESSAGE: 'Type your message',
    MIN: 'min',
    CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.'
  },
  CREDIT_CARD: {
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder',
    EXPIRY_DATE: 'Expiry date',
    CVV: 'CVV',
    CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
    SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
    SAVE_PAYMENT_METHOD: 'Save payment method',
    X2_BONUS: 'x2 BONUS',
    YOU_WILL_GET: 'You will get',
    TELMIE_CREDIT: 'Telmie credit',
    IN_TOTAL: 'in total',
    CONFIRM_AND_PAY: 'Confirm & Pay',
    CANNOT_WITHDRAW: 'Cannot withdraw',
    FEE: 'fee',
    FREE: 'Free',
    YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
    AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
    AVALIABLE: 'Available',
    AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
    WITHDRAW: 'Withdraw',
    FREE_APPLIES: 'Fee applies: ',
    YOU_RECEIVE: 'You receive: ',
    WITHDRAWAL_RULES: 'Withdrawal rules',
    WITHDRAWAL_AMOUNT: 'Withdrawal amount',
    HIDE: 'Hide',
    SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules'
  },
  EDIT_PROFILE: {
    SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
    CANT_BE_CHANGED: 'Can\'t be changed',
    UPLOAD_PICTURE: 'Upload picture',
    NAME_ISNT_VALID: 'The name isn\'t valid.'
  },
  FEATURED_SERVICE: {
    CALL_NOW: 'Call now',
    CANCEL_CALL: 'Cancel call',
    NEXT_PRO: 'Next pro',
    NEXT_PRO_CAPS: 'NEXT PRO',
    THEN_CAPS: 'THEN'
  },
  HEADER: {
    HOW_IT_WORKS: 'Come funziona',
    FAQ: 'Domande frequenti',
    CONTACT: 'Contatti',
    MONEY: 'Money',
    SETTINGS: 'Settings',
    LOGIN: 'Log in',
    EDIT_PROFILE: 'Edit Profile',
    NEW_CHATS: 'New Chats',
    WELL_DONE: 'Well done',
    SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
    EDIT_PRO_DETAILS: 'Edit Pro details'
  },
  HOMEPAGE: {
    FEATURED_PROS: 'Featured Pros',
    FEATURED_SERVICES: 'Featured services',
    DOWNLOAD_TELMIE_APP: 'Download Telmie app'
  },
  LANGUAGE_PRACTICE: {
    HAPPY_PROS: 'Happy Pros',
    HAPPY_USERS: 'Happy Users'
  },
  LOG_IN: {
    LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
    NEW_TO_TELMIE: 'New to Telmie',
    DOWNLOAD_THE_APP: 'Download the app'
  },
  NEW_LANDING: {
    MINUTES: 'minutes',
    COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
    BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
    PLEASE_ENTER_SUBJECT: 'Please enter subject',
    PLEASE_ENTER_MESSAGE: 'Please enter message'
  },
  PRO: {
    PRO: 'Pro',
    AMOUNT: 'Amount',
    NO_RECENT_CALLS: 'No recent calls',
    MESSAGES: 'Messages',
    START_CALL: 'Start Call',
    SHORTLISTED: 'Shortlisted',
    REMOVE: 'Remove',
    SHORTLIST: 'Shortlist',
    LOADING: 'Loading',
    TELMIE_CLIENT: 'Telmie Client',
    ON_CALL: 'On call',
    RECONNECTING: 'Reconnecting...',
    TELMIE_USER_IS_CALLING: 'Telmie user is calling',
    SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
    HOURS_FIRST_LETTER: 'h',
    MINUTES_FIRST_LETTER: 'm',
    CALENDAR_TITLE: 'My availability',
    CALENDAR_SUB_TITLE: 'I am not available right now',
    CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
    AVAILABLE_NOW: 'Available now',
    AVAILABLE_LATTER: 'Available later',
    WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
    PRO_IS_BUSY: 'Pro is busy'
  },
  PROFILE: {
    VIEW_ALL: 'View all',
    CONTACT: 'Contact',
    COUNT: 'Count',
    NO_RECENT_ACTIVITY: 'No recent activity',
    YOUR_DETAILS: 'Your details',
    LOCATION: 'Location',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NO_RECENT_PROS: 'No recent PROS',
    WITHDRAW_EARNINGS: 'Withdraw earnings',
    TOP_UP: 'Top Up',
    ATTACH_CARD: 'Attach card',
    SERVICE: 'Service',
    APPOINTMENT_WITH: 'Appointment with',
    COST: 'Cost',
    BALANCE: 'Balance',
    NO_RECENT_TRANSACTIONS: 'No recent transactions',
    NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
    CLIENT: 'Client'
  },
  RADIO_BUTTONS: {
    APPROVED: 'Approved',
    SECTORS: 'SECTORS'
  },
  SEARCH: {
    FILTERS: 'Filters',
    SESSIONS: 'sessions',
    ARRANGE_BY: 'Arrange by',
    ENTER_KEYWORDS: 'Enter keywords',
    RESET_FILTERS: 'Clear all'
  },
  SELECT: {
    EVERY: 'Every'
  },
  SETTINGS: {
    IMPORTANT_VIA_EMAIL: 'Important via email',
    WORKING_AS_PRO: 'Working as Pro',
    PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
    ADD_NEW_PERIOD: 'Add new period',
    CHANGE_BANK_ACCOUNT: 'Change bank account',
    ADD_BANK_ACCOUNT: 'Add bank account',
    ENTITY: 'Entity',
    ADDRESS: 'Address',
    YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
    WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
    SORT_CODE: 'Sort code',
    DIGITS_VALUE: 'digits value',
    ACCOUNT_NUMBER: 'Account number',
    BAD_REQUEST_DATA: 'Bad Request data',
    PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
    CONFIRM: 'Confirm',
    UPLOAD_ANOTHER_IMAGE: 'Upload another image',
    UPLOAD: 'Upload',
    YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
    YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
    PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
    POST_CODE: 'Post Code',
    LOADING_CARDS: 'Loading cards',
    NO_CARDS: 'No cards.',
    COMPANY_ADDRESS: 'Company address',
    PERSONAL_ADDRESS: 'Personal address',
    SERVICE_NAME: 'Service name',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_SUB_CATEGORY: 'Service sub-category',
    SERVICE_DESCRIPTION: 'Service description',
    PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
    LOADING_ACCOUNTS: 'Loading accounts',
    ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
    PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
    THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
    DAYS_REQUIRED: 'Please select days',
    FROM: 'From',
    TO: 'To',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
    PROFILE_DETAILS: 'Profile details',
    PRO_SETTINGS: 'PRO SETTINGS',
    WORK_AS_PRO: 'Work as Pro',
    PRO_DETAILS: 'Pro details',
    PAYOUT_BANK_DETAILS: 'Payout bank details',
    PREVIEW_MY_PROFILE: 'Preview my profile',
    MY_AVAILABILITY: 'My availability',
    HIDE_PROFILE: 'Hide profile',
    GENERAL_SETTINGS: 'GENERAL SETTINGS',
    PAYMENT_SETTINGS: 'Payment settings',
    EMAIL_NOTIFICATION: 'Email notification',
    BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
    BANK_ACCOUNT: 'Bank account',
    ID_VERIFICATION: 'ID Verification',
    I_WANT_TO_TAKE_PART: 'I want to take part'
  },
  SIGN_UP: {
    CONFIRM_EMAIL: 'Now confirm your email address',
    RESEND: 'Resend',
    CONFIRM_EMAIL_MESSAGE: function CONFIRM_EMAIL_MESSAGE(email) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        'We\'ve sent an email to ',
        email,
        ', please check your inbox and click the link \'Activate\' to confirm and earn!'
      );
    },
    USE_ANOTHER_EMAIL: 'Use another email',
    SECTOR: 'Sector',
    CATEGORY: 'Category',
    PLEASE_SELECT_CATEGORY: 'Please select category',
    PROFESSION: 'Profession',
    DESCRIPTION: 'Description',
    FREE: 'Free',
    PER_MINUTE: 'per minute',
    BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
    TERMS_OF_USE: 'Terms of use',
    AND_THE: 'and the',
    PRIVACY_POLICY: 'Privacy Policy',
    THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
    CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
    ACCOUNT_TYPE: 'Account type',
    APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
    CANCEL_CHANGES: 'Cancel changes',
    PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
    ERROR: 'Error',
    PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
    UNITED_KINGDOM: 'United Kingdom',
    ONLY_UK_NOW: 'Only UK for now',
    I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
    ALREADY_HAVE_ACCOUNT: 'Already have an account',
    CODE_HAVE_BEEN_SENT: 'Code has been sent to',
    EDUCATION: {
      EDUCATION: 'Education',
      LANGUAGE_TUTOR: 'Language tutor',
      LANGUAGE_PRACTICE: 'Language practice',
      EXAMS_PREPARATION: 'Exams preparation',
      SCIENCE: 'Science',
      BUSINESS_STUDIES: 'Business studies',
      SOCIAL_SCIENCE: 'Social science',
      DRAWING: 'Drawing',
      MUSIC: 'Music',
      DANCE: 'Dance'
    },
    SERVICES: {
      SERVICES: 'Services',
      INTERPRETER: 'Interpreter',
      NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
      THERAPIST: 'Therapist',
      LISTENER: 'Listener',
      SPEECH_THERAPIST: 'Speech therapist',
      FORTUN_TELLER: 'Fortun teller',
      ASTROLOGIST: 'Astrologist',
      PERSONAL_ASSISTANT: 'Personal assistant',
      CAREER_COACH: 'Career coach'
    },
    CONSULTANCY: {
      CONSULTANCY: 'Consultancy',
      LEGAL: 'Legal',
      MEDICAL: 'Medical',
      BUSINESS: 'Business',
      FAMILY: 'Family',
      INVESTMENT: 'Investment',
      TECH_SUPPORT: 'Tech support',
      BEAUTICIAN: 'Beautician'
    },
    HEALTH_LIFESTYLE: {
      HEALTH_LIFESTYLE: 'Health&Lifestyle',
      PERSONAL_TRAINER: 'Personal trainer',
      YOGA_INSTRUCTOR: 'Yuga instructor',
      MEDITATION_INSTRUCTOR: 'Meditation instructor',
      DIETOLOGIST: 'Dietologist',
      SPORT_COACH: 'Sport coach',
      FITNESS_PROFESSIONAL: 'Fitness professional',
      SPIRITUAL_COACH: 'Spiritual coach'
    },
    PLEASE_SELECT_SECTOR: 'Please select sector',
    PLEASE_ENTER_PROFESSION: 'Please enter profession',
    PLEASE_ENTER_DESCRIPTION: 'Please enter description',
    PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
    PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
    YOU_ARE_UNDER_18: 'You are under 18',
    DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
    YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
    PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
    CITY_IN_THE_UK: 'City in the UK',
    CITY_INCORRECT: 'City incorrect',
    POSTCODE: 'Postcode',
    PLEASE_ENTER_POSTCODE: 'Please enter postcode',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    ONLY_UK_ADDRESS: 'Only UK address',
    ADDRESS_INCORRECT: 'Address incorrect',
    ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
    BIRTHDAY_INCORRECT: 'Birthday incorrect',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    WE_WONT_SHARE_IT: 'We won\'t share it with others.',
    MOBILE_INCORRECT: 'Mobile incorrect',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    EG_IO: 'e.g. i0ONOZLgCIM',
    SERVICE_INCORRECT: 'Service incorrect',
    SERVICE_LABEL: 'Service (20 characters)',
    IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
    SERVICE_NAME_INCORRECT: 'Service name incorrect',
    SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
    SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
    SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
    PRICE_PER_MINUTE: 'Price per minute',
    DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
    YES: 'Yes.',
    NO: 'No.',
    DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
    YES_SAVE: 'Yes, save.',
    DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
    ENTER_TAX_ID: 'Enter tax ID to check',
    CHECK: 'Check.',
    PLEASE_ENTER_PASSWORD: 'Please enter password',
    FIRST_NAME: 'First name'
  },
  SOCIAL_NETWORK: {
    CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
    CONTINUE_WITH_GOOGLE: 'Continue with Google'
  },
  ROUTES: {
    ERROR_404: 'Error 404',
    PAGE_NOT_FOUND: 'Page not found',
    THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
    GO_HOME: 'Go Home',
    FEATURED_SERVICE: 'FEATURED SERVICE',
    WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
    GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
    FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
    CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
    NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
    YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
    RESET: 'Reset',
    BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
    TELMIE_T_C: 'Telmie T&C',
    TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
    AND: 'and',
    STRIPE_T_C: 'Stripe T&C.',
    SORRY: 'Sorry',
    IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
    OR: 'or',
    IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
    BACK_TO_SETTINGS: 'Back to Settings',
    PROFILE_PREVIEW: 'Profile preview',
    PRO_DETAILS: 'Pro details',
    PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
    RESULTS_FOR: 'Results for',
    SORRY_NO_PROS: 'Sorry, no pros found for',
    SELECT_YOUR_INTEREST: 'Select your interest',
    TELMIE_MY_CLIENTS: 'Telmie | My Clients',
    FIND_YOUR_CLIENT: 'Find your Client',
    TELMIE_MY_PROS: 'Telmie | My Pros',
    FIND_YOUR_PRO: 'Find your Pro',
    PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
    TELMIE_PREVIEW: 'Telmie | Preview',
    LOWEST_RATE_FIRST: 'Lowest rate first',
    HIGHEST_RATE_FIRST: 'Highest rate first',
    EXPERIENCE: 'Experience',
    RATING: 'Rating',
    ACTIVITY: 'Activity',
    LANGUAGES: 'Languages',
    COACHING: 'Coaching',
    IMMIGRATION: 'Immigration',
    OTHER: 'Other',
    ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
    ERROR_WITH_STRIPE: 'Error with Stripe.',
    TELMIE_PRO: 'Telmie | Pro'
  },
  FOOTER: {
    HOME: 'Home',
    CONTACT: 'Contatti',
    SUPPORT: 'Support',
    POLICY: 'Privacy Policy',
    TERMS: 'Termini e condizioni',
    FAQ: 'Domande frequenti',
    COPYRIGHT: 'Copyright',
    COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom'
  },
  CONTACT_US: {
    title: 'Contatti',
    subTitle: 'Hai qualche domanda? ',
    name: 'Nome',
    email: 'E-mail',
    company: 'Azienda',
    subject: 'Oggetto',
    message: 'Scrivi qui il tuo messaggio',
    success: 'Grazie per averci contattato ',
    submitBtn: 'Invia'
  },
  SERVICES: {
    LANGUAGE_PRACTICE: 'Esercizio delle lingue straniere',
    IMMIGRATION_ADVICE: 'Consulenza immigrazione',
    IMMIGRATION_CONSULTANT: 'Consulente in immigrazione',
    LANGUAGE_LEARNERS: 'Impara la lingua'
  },
  FAQ: 'Domande frequenti',
  MORE_FAQ: 'Altre domande',
  API: {
    NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content'
  },
  NOTIFICATIONS: {
    DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
    EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
    MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
    SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
    UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!'
  },
  REGISTER_PRO: {
    FIRST_NAME: 'First name',
    FIRST_NAME_ERROR: 'First name field is required',
    LAST_NAME: 'Last name',
    LAST_NAME_ERROR: 'Last name field is required',
    COUNTRY: 'Country',
    COUNTRY_PLACEHOLDER: 'Select country',
    COUNTRY_ERROR: 'Country field is required',
    CITY: 'City',
    POSTCODE: 'Postcode',
    POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
    DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
    DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    MOBILE_HINT: 'We won\'t share it with others.',
    MOBILE_ERROR: 'Must contain only numbers',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
    SERVICES: 'Services',
    SERVICES_PLACEHOLDER: 'Select service',
    SERVICES_ERROR: 'Services field is required',
    SERVICE: 'Service (20 characters)',
    SERVICE_HINT: 'i.e. English practice, Immigration advice',
    SERVICE_ERROR: 'Service name may not be greater than 20 characters',
    SECTOR: 'Sector',
    SECTOR_PLACEHOLDER: 'Select sector',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
    SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
    SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
    SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
    SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
    COST_PER_MINUTE_ERROR: 'Please enter price',
    COST_PER_MINUTE_MAX: 'Maximum allowed for this service'
  }
}, _langPack[__WEBPACK_IMPORTED_MODULE_1__consts__["i" /* ES */]] = {
  DOWNLOAD_APP_BTN: 'Descarga nuestra app',
  HOMEPAGE_FAQ_TITLE: 'Preguntas más populares',
  GENERAL_QUESTIONS: 'Preguntas Frecuentes',
  CUSTOMERS_QUESTIONS: 'Clientes',
  EXPERTS_QUESTIONS: 'Preguntas Frecuentes sobre Expertos',
  PAYMENTS_QUESTIONS: 'Preguntas sobre Pagos',
  BLOG_TITLE: 'Blog',
  FULL_STORY_BTN: 'Leer Más',
  OTHER_POSTS: 'Otros articulos',
  MISC: {
    DELETE: 'Delete',
    UPDATE_NOW: 'Update now',
    CONNECTING: 'Connecting',
    CONNECTING_TO_SERVER: 'Connecting to server',
    CALLING_PRO: 'Calling Pro',
    CREDIT_CARD: 'Credit card',
    ADD_A_CARD: 'Add a card',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    SAVE: 'Save',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
    PLEASE_ENTER_LAST_NAME: 'Please enter last name',
    YOU_WILL_PAY: 'You will pay',
    PER_MINUTE_FOR_CALL: 'per minute for this call',
    MINUTES_SHORT: 'min',
    BECOME_PRO: 'Conviértete en Pro',
    BLOG: 'Blog',
    FIND_A_PRO: 'Find a Pro',
    MY_CLIENTS: 'My Clients',
    MY_PROS: 'My Pros',
    MY_APPOINTMENTS: 'My Appointments',
    SIGN_UP: 'Sign Up',
    LOG_OUT: 'Log out',
    REGISTER_AS_PRO: 'Register as Pro',
    REGISTER: 'Register',
    LOG_IN: 'Log in',
    FORGOT_PASSWORD: 'Forgot password',
    PASSWORD: 'Password',
    DATE: 'Date',
    DATE_AND_TIME: 'Date and time',
    DURATION: 'Duration',
    TYPE: 'Type',
    EDIT: 'Edit',
    NAME: 'Name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    MOBILE: 'Mobile',
    CITY: 'City',
    BUSINESS_NAME: 'Business name',
    COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
    COUNTRY: 'Country',
    RATE: 'Rate',
    YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
    CODE_VERIFIED: 'Code verified',
    IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
    CODE_EXPIRES_IN: 'Code expires in',
    CODE: 'Code',
    VERIFY_CODE: 'Verify code',
    PLEASE_ENTER_EMAIL: 'Please enter email',
    RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
    SEND_VERIFICATION_CODE: 'Send verification code',
    LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully'
  },
  BLOG: {
    COMMENTS: 'Comments',
    REPLY: 'Reply',
    ADD_COMMENT: 'Add Comment',
    POST_COMMENT: 'Post comment'
  },
  BOOKING: {
    CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
    CANCELLATION_POLICY: 'Cancellation Policy',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
    YES_CANCEL: 'Yes, cancel',
    NO_KEEP: 'No, keep it'
  },
  COMMUNICATION: {
    ON_CALL_WITH: 'On call with',
    CONNECTING_WITH: 'Connecting with',
    INCOMING_CALL: 'Incoming Call',
    YOUR_CLIENT: 'Your client',
    TYPE_YOUR_MESSAGE: 'Type your message',
    MIN: 'min',
    CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.'
  },
  CREDIT_CARD: {
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder',
    EXPIRY_DATE: 'Expiry date',
    CVV: 'CVV',
    CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
    SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
    SAVE_PAYMENT_METHOD: 'Save payment method',
    X2_BONUS: 'x2 BONUS',
    YOU_WILL_GET: 'You will get',
    TELMIE_CREDIT: 'Telmie credit',
    IN_TOTAL: 'in total',
    CONFIRM_AND_PAY: 'Confirm & Pay',
    CANNOT_WITHDRAW: 'Cannot withdraw',
    FEE: 'fee',
    FREE: 'Free',
    YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
    AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
    AVALIABLE: 'Available',
    AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
    WITHDRAW: 'Withdraw',
    FREE_APPLIES: 'Fee applies: ',
    YOU_RECEIVE: 'You receive: ',
    WITHDRAWAL_RULES: 'Withdrawal rules',
    WITHDRAWAL_AMOUNT: 'Withdrawal amount',
    HIDE: 'Hide',
    SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules'
  },
  EDIT_PROFILE: {
    SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
    CANT_BE_CHANGED: 'Can\'t be changed',
    UPLOAD_PICTURE: 'Upload picture',
    NAME_ISNT_VALID: 'The name isn\'t valid.'
  },
  FEATURED_SERVICE: {
    CALL_NOW: 'Call now',
    CANCEL_CALL: 'Cancel call',
    NEXT_PRO: 'Next pro',
    NEXT_PRO_CAPS: 'NEXT PRO',
    THEN_CAPS: 'THEN'
  },
  HEADER: {
    HOW_IT_WORKS: 'Cómo funciona',
    FAQ: 'FAQs',
    CONTACT: 'Contacto',
    MONEY: 'Money',
    SETTINGS: 'Settings',
    LOGIN: 'Log in',
    EDIT_PROFILE: 'Edit Profile',
    NEW_CHATS: 'New Chats',
    WELL_DONE: 'Well done',
    SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
    EDIT_PRO_DETAILS: 'Edit Pro details'
  },
  HOMEPAGE: {
    FEATURED_PROS: 'Featured Pros',
    FEATURED_SERVICES: 'Featured services',
    DOWNLOAD_TELMIE_APP: 'Download Telmie app'
  },
  LANGUAGE_PRACTICE: {
    HAPPY_PROS: 'Happy Pros',
    HAPPY_USERS: 'Happy Users'
  },
  LOG_IN: {
    LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
    NEW_TO_TELMIE: 'New to Telmie',
    DOWNLOAD_THE_APP: 'Download the app'
  },
  NEW_LANDING: {
    MINUTES: 'minutes',
    COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
    BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
    PLEASE_ENTER_SUBJECT: 'Please enter subject',
    PLEASE_ENTER_MESSAGE: 'Please enter message'
  },
  PRO: {
    PRO: 'Pro',
    AMOUNT: 'Amount',
    NO_RECENT_CALLS: 'No recent calls',
    MESSAGES: 'Messages',
    START_CALL: 'Start Call',
    SHORTLISTED: 'Shortlisted',
    REMOVE: 'Remove',
    SHORTLIST: 'Shortlist',
    LOADING: 'Loading',
    TELMIE_CLIENT: 'Telmie Client',
    ON_CALL: 'On call',
    RECONNECTING: 'Reconnecting...',
    TELMIE_USER_IS_CALLING: 'Telmie user is calling',
    SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
    HOURS_FIRST_LETTER: 'h',
    MINUTES_FIRST_LETTER: 'm',
    CALENDAR_TITLE: 'My availability',
    CALENDAR_SUB_TITLE: 'I am not available right now',
    CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
    AVAILABLE_NOW: 'Available now',
    AVAILABLE_LATTER: 'Available later',
    WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
    PRO_IS_BUSY: 'Pro is busy'
  },
  PROFILE: {
    VIEW_ALL: 'View all',
    CONTACT: 'Contact',
    COUNT: 'Count',
    NO_RECENT_ACTIVITY: 'No recent activity',
    YOUR_DETAILS: 'Your details',
    LOCATION: 'Location',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NO_RECENT_PROS: 'No recent PROS',
    WITHDRAW_EARNINGS: 'Withdraw earnings',
    TOP_UP: 'Top Up',
    ATTACH_CARD: 'Attach card',
    SERVICE: 'Service',
    APPOINTMENT_WITH: 'Appointment with',
    COST: 'Cost',
    BALANCE: 'Balance',
    NO_RECENT_TRANSACTIONS: 'No recent transactions',
    NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
    CLIENT: 'Client'
  },
  RADIO_BUTTONS: {
    APPROVED: 'Approved',
    SECTORS: 'SECTORS'
  },
  SEARCH: {
    FILTERS: 'Filters',
    SESSIONS: 'sessions',
    ARRANGE_BY: 'Arrange by',
    ENTER_KEYWORDS: 'Enter keywords',
    RESET_FILTERS: 'Clear all'
  },
  SELECT: {
    EVERY: 'Every'
  },
  SETTINGS: {
    IMPORTANT_VIA_EMAIL: 'Important via email',
    WORKING_AS_PRO: 'Working as Pro',
    PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
    ADD_NEW_PERIOD: 'Add new period',
    CHANGE_BANK_ACCOUNT: 'Change bank account',
    ADD_BANK_ACCOUNT: 'Add bank account',
    ENTITY: 'Entity',
    ADDRESS: 'Address',
    YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
    WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
    SORT_CODE: 'Sort code',
    DIGITS_VALUE: 'digits value',
    ACCOUNT_NUMBER: 'Account number',
    BAD_REQUEST_DATA: 'Bad Request data',
    PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
    CONFIRM: 'Confirm',
    UPLOAD_ANOTHER_IMAGE: 'Upload another image',
    UPLOAD: 'Upload',
    YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
    YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
    PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
    POST_CODE: 'Post Code',
    LOADING_CARDS: 'Loading cards',
    NO_CARDS: 'No cards.',
    COMPANY_ADDRESS: 'Company address',
    PERSONAL_ADDRESS: 'Personal address',
    SERVICE_NAME: 'Service name',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_SUB_CATEGORY: 'Service sub-category',
    SERVICE_DESCRIPTION: 'Service description',
    PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
    LOADING_ACCOUNTS: 'Loading accounts',
    ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
    PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
    THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
    DAYS_REQUIRED: 'Please select days',
    FROM: 'From',
    TO: 'To',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
    PROFILE_DETAILS: 'Profile details',
    PRO_SETTINGS: 'PRO SETTINGS',
    WORK_AS_PRO: 'Work as Pro',
    PRO_DETAILS: 'Pro details',
    PAYOUT_BANK_DETAILS: 'Payout bank details',
    PREVIEW_MY_PROFILE: 'Preview my profile',
    MY_AVAILABILITY: 'My availability',
    HIDE_PROFILE: 'Hide profile',
    GENERAL_SETTINGS: 'GENERAL SETTINGS',
    PAYMENT_SETTINGS: 'Payment settings',
    EMAIL_NOTIFICATION: 'Email notification',
    BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
    BANK_ACCOUNT: 'Bank account',
    ID_VERIFICATION: 'ID Verification',
    I_WANT_TO_TAKE_PART: 'I want to take part'
  },
  SIGN_UP: {
    CONFIRM_EMAIL: 'Now confirm your email address',
    RESEND: 'Resend',
    CONFIRM_EMAIL_MESSAGE: function CONFIRM_EMAIL_MESSAGE(email) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        'We\'ve sent an email to ',
        email,
        ', please check your inbox and click the link \'Activate\' to confirm and earn!'
      );
    },
    USE_ANOTHER_EMAIL: 'Use another email',
    SECTOR: 'Sector',
    CATEGORY: 'Category',
    PLEASE_SELECT_CATEGORY: 'Please select category',
    PROFESSION: 'Profession',
    DESCRIPTION: 'Description',
    FREE: 'Free',
    PER_MINUTE: 'per minute',
    BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
    TERMS_OF_USE: 'Terms of use',
    AND_THE: 'and the',
    PRIVACY_POLICY: 'Privacy Policy',
    THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
    CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
    ACCOUNT_TYPE: 'Account type',
    APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
    CANCEL_CHANGES: 'Cancel changes',
    PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
    ERROR: 'Error',
    PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
    UNITED_KINGDOM: 'United Kingdom',
    ONLY_UK_NOW: 'Only UK for now',
    I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
    ALREADY_HAVE_ACCOUNT: 'Already have an account',
    CODE_HAVE_BEEN_SENT: 'Code has been sent to',
    EDUCATION: {
      EDUCATION: 'Education',
      LANGUAGE_TUTOR: 'Language tutor',
      LANGUAGE_PRACTICE: 'Language practice',
      EXAMS_PREPARATION: 'Exams preparation',
      SCIENCE: 'Science',
      BUSINESS_STUDIES: 'Business studies',
      SOCIAL_SCIENCE: 'Social science',
      DRAWING: 'Drawing',
      MUSIC: 'Music',
      DANCE: 'Dance'
    },
    SERVICES: {
      SERVICES: 'Services',
      INTERPRETER: 'Interpreter',
      NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
      THERAPIST: 'Therapist',
      LISTENER: 'Listener',
      SPEECH_THERAPIST: 'Speech therapist',
      FORTUN_TELLER: 'Fortun teller',
      ASTROLOGIST: 'Astrologist',
      PERSONAL_ASSISTANT: 'Personal assistant',
      CAREER_COACH: 'Career coach'
    },
    CONSULTANCY: {
      CONSULTANCY: 'Consultancy',
      LEGAL: 'Legal',
      MEDICAL: 'Medical',
      BUSINESS: 'Business',
      FAMILY: 'Family',
      INVESTMENT: 'Investment',
      TECH_SUPPORT: 'Tech support',
      BEAUTICIAN: 'Beautician'
    },
    HEALTH_LIFESTYLE: {
      HEALTH_LIFESTYLE: 'Health&Lifestyle',
      PERSONAL_TRAINER: 'Personal trainer',
      YOGA_INSTRUCTOR: 'Yuga instructor',
      MEDITATION_INSTRUCTOR: 'Meditation instructor',
      DIETOLOGIST: 'Dietologist',
      SPORT_COACH: 'Sport coach',
      FITNESS_PROFESSIONAL: 'Fitness professional',
      SPIRITUAL_COACH: 'Spiritual coach'
    },
    PLEASE_SELECT_SECTOR: 'Please select sector',
    PLEASE_ENTER_PROFESSION: 'Please enter profession',
    PLEASE_ENTER_DESCRIPTION: 'Please enter description',
    PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
    PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
    YOU_ARE_UNDER_18: 'You are under 18',
    DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
    YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
    PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
    CITY_IN_THE_UK: 'City in the UK',
    CITY_INCORRECT: 'City incorrect',
    POSTCODE: 'Postcode',
    PLEASE_ENTER_POSTCODE: 'Please enter postcode',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    ONLY_UK_ADDRESS: 'Only UK address',
    ADDRESS_INCORRECT: 'Address incorrect',
    ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
    BIRTHDAY_INCORRECT: 'Birthday incorrect',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    WE_WONT_SHARE_IT: 'We won\'t share it with others.',
    MOBILE_INCORRECT: 'Mobile incorrect',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    EG_IO: 'e.g. i0ONOZLgCIM',
    SERVICE_INCORRECT: 'Service incorrect',
    SERVICE_LABEL: 'Service (20 characters)',
    IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
    SERVICE_NAME_INCORRECT: 'Service name incorrect',
    SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
    SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
    SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
    PRICE_PER_MINUTE: 'Price per minute',
    DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
    YES: 'Yes.',
    NO: 'No.',
    DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
    YES_SAVE: 'Yes, save.',
    DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
    ENTER_TAX_ID: 'Enter tax ID to check',
    CHECK: 'Check.',
    PLEASE_ENTER_PASSWORD: 'Please enter password',
    FIRST_NAME: 'First name'
  },
  SOCIAL_NETWORK: {
    CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
    CONTINUE_WITH_GOOGLE: 'Continue with Google'
  },
  ROUTES: {
    ERROR_404: 'Error 404',
    PAGE_NOT_FOUND: 'Page not found',
    THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
    GO_HOME: 'Go Home',
    FEATURED_SERVICE: 'FEATURED SERVICE',
    WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
    GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
    FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
    CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
    NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
    YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
    RESET: 'Reset',
    BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
    TELMIE_T_C: 'Telmie T&C',
    TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
    AND: 'and',
    STRIPE_T_C: 'Stripe T&C.',
    SORRY: 'Sorry',
    IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
    OR: 'or',
    IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
    BACK_TO_SETTINGS: 'Back to Settings',
    PROFILE_PREVIEW: 'Profile preview',
    PRO_DETAILS: 'Pro details',
    PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
    RESULTS_FOR: 'Results for',
    SORRY_NO_PROS: 'Sorry, no pros found for',
    SELECT_YOUR_INTEREST: 'Select your interest',
    TELMIE_MY_CLIENTS: 'Telmie | My Clients',
    FIND_YOUR_CLIENT: 'Find your Client',
    TELMIE_MY_PROS: 'Telmie | My Pros',
    FIND_YOUR_PRO: 'Find your Pro',
    PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
    TELMIE_PREVIEW: 'Telmie | Preview',
    LOWEST_RATE_FIRST: 'Lowest rate first',
    HIGHEST_RATE_FIRST: 'Highest rate first',
    EXPERIENCE: 'Experience',
    RATING: 'Rating',
    ACTIVITY: 'Activity',
    LANGUAGES: 'Languages',
    COACHING: 'Coaching',
    IMMIGRATION: 'Immigration',
    OTHER: 'Other',
    ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
    ERROR_WITH_STRIPE: 'Error with Stripe.',
    TELMIE_PRO: 'Telmie | Pro'
  },
  FOOTER: {
    HOME: 'Inicio',
    CONTACT: 'Contacto',
    POLICY: 'Política de Privacidad',
    SUPPORT: 'Support',
    TERMS: 'Términos de Uso',
    FAQ: 'FAQs',
    COPYRIGHT: 'Copyright',
    COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom'
  },
  CONTACT_US: {
    title: 'Contacto',
    subTitle: '¿Tienes dudas? Escríbenos',
    name: 'Nombre',
    email: 'Correo electrónico',
    company: 'Empresa',
    subject: 'Asunto',
    message: 'Escribe tu mensaje',
    success: 'Gracias por contactarnos',
    submitBtn: 'Enviar'
  },
  SERVICES: {
    LANGUAGE_PRACTICE: 'Practicar Idiomas',
    IMMIGRATION_ADVICE: 'Trámites de Inmigración',
    IMMIGRATION_CONSULTANT: 'Trámites de Inmigración',
    LANGUAGE_LEARNERS: 'Aprender idiomas'
  },
  FAQ: 'FAQs',
  MORE_FAQ: 'Más Preguntas Frecuentes'
}, _langPack[__WEBPACK_IMPORTED_MODULE_1__consts__["q" /* PL */]] = {
  DOWNLOAD_APP_BTN: 'Ściągnij aplikację',
  HOMEPAGE_FAQ_TITLE: 'Najpopularniejsze pytania',
  GENERAL_QUESTIONS: 'Ogólne pytania',
  CUSTOMERS_QUESTIONS: 'Klienci',
  EXPERTS_QUESTIONS: 'Ekspert',
  PAYMENTS_QUESTIONS: 'Płatności',
  BLOG_TITLE: 'Blog',
  FULL_STORY_BTN: 'Pełna historia',
  OTHER_POSTS: 'Inne',
  MISC: {
    DELETE: 'Delete',
    UPDATE_NOW: 'Update now',
    CONNECTING: 'Connecting',
    CONNECTING_TO_SERVER: 'Connecting to server',
    CALLING_PRO: 'Calling Pro',
    CREDIT_CARD: 'Credit card',
    ADD_A_CARD: 'Add a card',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    SAVE: 'Save',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
    PLEASE_ENTER_LAST_NAME: 'Please enter last name',
    YOU_WILL_PAY: 'You will pay',
    PER_MINUTE_FOR_CALL: 'per minute for this call',
    MINUTES_SHORT: 'min',
    BECOME_PRO: 'Zostań ekspertem',
    BLOG: 'Blog',
    FIND_A_PRO: 'Find a Pro',
    MY_CLIENTS: 'My Clients',
    MY_PROS: 'My Pros',
    MY_APPOINTMENTS: 'My Appointments',
    SIGN_UP: 'Sign Up',
    LOG_OUT: 'Log out',
    REGISTER_AS_PRO: 'Register as Pro',
    REGISTER: 'Register',
    LOG_IN: 'Log in',
    FORGOT_PASSWORD: 'Forgot password',
    PASSWORD: 'Password',
    DATE: 'Date',
    DATE_AND_TIME: 'Date and time',
    DURATION: 'Duration',
    TYPE: 'Type',
    EDIT: 'Edit',
    NAME: 'Name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    MOBILE: 'Mobile',
    CITY: 'City',
    BUSINESS_NAME: 'Business name',
    COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
    COUNTRY: 'Country',
    RATE: 'Rate',
    YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
    CODE_VERIFIED: 'Code verified',
    IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
    CODE_EXPIRES_IN: 'Code expires in',
    CODE: 'Code',
    VERIFY_CODE: 'Verify code',
    PLEASE_ENTER_EMAIL: 'Please enter email',
    RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
    SEND_VERIFICATION_CODE: 'Send verification code',
    LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully'
  },
  BLOG: {
    COMMENTS: 'Comments',
    REPLY: 'Reply',
    ADD_COMMENT: 'Add Comment',
    POST_COMMENT: 'Post comment'
  },
  BOOKING: {
    CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
    CANCELLATION_POLICY: 'Cancellation Policy',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
    YES_CANCEL: 'Yes, cancel',
    NO_KEEP: 'No, keep it'
  },
  COMMUNICATION: {
    ON_CALL_WITH: 'On call with',
    CONNECTING_WITH: 'Connecting with',
    INCOMING_CALL: 'Incoming Call',
    YOUR_CLIENT: 'Your client',
    TYPE_YOUR_MESSAGE: 'Type your message',
    MIN: 'min',
    CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.'
  },
  CREDIT_CARD: {
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder',
    EXPIRY_DATE: 'Expiry date',
    CVV: 'CVV',
    CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
    SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
    SAVE_PAYMENT_METHOD: 'Save payment method',
    X2_BONUS: 'x2 BONUS',
    YOU_WILL_GET: 'You will get',
    TELMIE_CREDIT: 'Telmie credit',
    IN_TOTAL: 'in total',
    CONFIRM_AND_PAY: 'Confirm & Pay',
    CANNOT_WITHDRAW: 'Cannot withdraw',
    FEE: 'fee',
    FREE: 'Free',
    YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
    AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
    AVALIABLE: 'Available',
    AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
    WITHDRAW: 'Withdraw',
    FREE_APPLIES: 'Fee applies: ',
    YOU_RECEIVE: 'You receive: ',
    WITHDRAWAL_RULES: 'Withdrawal rules',
    WITHDRAWAL_AMOUNT: 'Withdrawal amount',
    HIDE: 'Hide',
    SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules'
  },
  EDIT_PROFILE: {
    SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
    CANT_BE_CHANGED: 'Can\'t be changed',
    UPLOAD_PICTURE: 'Upload picture',
    NAME_ISNT_VALID: 'The name isn\'t valid.'
  },
  FEATURED_SERVICE: {
    CALL_NOW: 'Call now',
    CANCEL_CALL: 'Cancel call',
    NEXT_PRO: 'Next pro',
    NEXT_PRO_CAPS: 'NEXT PRO',
    THEN_CAPS: 'THEN'
  },
  HEADER: {
    HOW_IT_WORKS: 'Jak to działa',
    FAQ: 'FAQ',
    CONTACT: 'Kontakt',
    MONEY: 'Money',
    SETTINGS: 'Settings',
    LOGIN: 'Log in',
    EDIT_PROFILE: 'Edit Profile',
    NEW_CHATS: 'New Chats',
    WELL_DONE: 'Well done',
    SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
    EDIT_PRO_DETAILS: 'Edit Pro details'
  },
  HOMEPAGE: {
    FEATURED_PROS: 'Featured Pros',
    FEATURED_SERVICES: 'Featured services',
    DOWNLOAD_TELMIE_APP: 'Download Telmie app'
  },
  LANGUAGE_PRACTICE: {
    HAPPY_PROS: 'Happy Pros',
    HAPPY_USERS: 'Happy Users'
  },
  LOG_IN: {
    LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
    NEW_TO_TELMIE: 'New to Telmie',
    DOWNLOAD_THE_APP: 'Download the app'
  },
  NEW_LANDING: {
    MINUTES: 'minutes',
    COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
    BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
    PLEASE_ENTER_SUBJECT: 'Please enter subject',
    PLEASE_ENTER_MESSAGE: 'Please enter message'
  },
  PRO: {
    PRO: 'Pro',
    AMOUNT: 'Amount',
    NO_RECENT_CALLS: 'No recent calls',
    MESSAGES: 'Messages',
    START_CALL: 'Start Call',
    SHORTLISTED: 'Shortlisted',
    REMOVE: 'Remove',
    SHORTLIST: 'Shortlist',
    LOADING: 'Loading',
    TELMIE_CLIENT: 'Telmie Client',
    ON_CALL: 'On call',
    RECONNECTING: 'Reconnecting...',
    TELMIE_USER_IS_CALLING: 'Telmie user is calling',
    SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
    HOURS_FIRST_LETTER: 'h',
    MINUTES_FIRST_LETTER: 'm',
    CALENDAR_TITLE: 'My availability',
    CALENDAR_SUB_TITLE: 'I am not available right now',
    CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
    AVAILABLE_NOW: 'Available now',
    AVAILABLE_LATTER: 'Available later',
    WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
    PRO_IS_BUSY: 'Pro is busy'
  },
  PROFILE: {
    VIEW_ALL: 'View all',
    CONTACT: 'Contact',
    COUNT: 'Count',
    NO_RECENT_ACTIVITY: 'No recent activity',
    YOUR_DETAILS: 'Your details',
    LOCATION: 'Location',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NO_RECENT_PROS: 'No recent PROS',
    WITHDRAW_EARNINGS: 'Withdraw earnings',
    TOP_UP: 'Top Up',
    ATTACH_CARD: 'Attach card',
    SERVICE: 'Service',
    APPOINTMENT_WITH: 'Appointment with',
    COST: 'Cost',
    BALANCE: 'Balance',
    NO_RECENT_TRANSACTIONS: 'No recent transactions',
    NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
    CLIENT: 'Client'
  },
  RADIO_BUTTONS: {
    APPROVED: 'Approved',
    SECTORS: 'SECTORS'
  },
  SEARCH: {
    FILTERS: 'Filters',
    SESSIONS: 'sessions',
    ARRANGE_BY: 'Arrange by',
    ENTER_KEYWORDS: 'Enter keywords',
    RESET_FILTERS: 'Clear all'
  },
  SELECT: {
    EVERY: 'Every'
  },
  SETTINGS: {
    IMPORTANT_VIA_EMAIL: 'Important via email',
    WORKING_AS_PRO: 'Working as Pro',
    PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
    ADD_NEW_PERIOD: 'Add new period',
    CHANGE_BANK_ACCOUNT: 'Change bank account',
    ADD_BANK_ACCOUNT: 'Add bank account',
    ENTITY: 'Entity',
    ADDRESS: 'Address',
    YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
    WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
    SORT_CODE: 'Sort code',
    DIGITS_VALUE: 'digits value',
    ACCOUNT_NUMBER: 'Account number',
    BAD_REQUEST_DATA: 'Bad Request data',
    PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
    CONFIRM: 'Confirm',
    UPLOAD_ANOTHER_IMAGE: 'Upload another image',
    UPLOAD: 'Upload',
    YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
    YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
    PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
    POST_CODE: 'Post Code',
    LOADING_CARDS: 'Loading cards',
    NO_CARDS: 'No cards.',
    COMPANY_ADDRESS: 'Company address',
    PERSONAL_ADDRESS: 'Personal address',
    SERVICE_NAME: 'Service name',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_SUB_CATEGORY: 'Service sub-category',
    SERVICE_DESCRIPTION: 'Service description',
    PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
    LOADING_ACCOUNTS: 'Loading accounts',
    ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
    PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
    THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
    DAYS_REQUIRED: 'Please select days',
    FROM: 'From',
    TO: 'To',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
    PROFILE_DETAILS: 'Profile details',
    PRO_SETTINGS: 'PRO SETTINGS',
    WORK_AS_PRO: 'Work as Pro',
    PRO_DETAILS: 'Pro details',
    PAYOUT_BANK_DETAILS: 'Payout bank details',
    PREVIEW_MY_PROFILE: 'Preview my profile',
    MY_AVAILABILITY: 'My availability',
    HIDE_PROFILE: 'Hide profile',
    GENERAL_SETTINGS: 'GENERAL SETTINGS',
    PAYMENT_SETTINGS: 'Payment settings',
    EMAIL_NOTIFICATION: 'Email notification',
    BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
    BANK_ACCOUNT: 'Bank account',
    ID_VERIFICATION: 'ID Verification',
    I_WANT_TO_TAKE_PART: 'I want to take part'
  },
  SIGN_UP: {
    CONFIRM_EMAIL: 'Now confirm your email address',
    RESEND: 'Resend',
    CONFIRM_EMAIL_MESSAGE: function CONFIRM_EMAIL_MESSAGE(email) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        'We\'ve sent an email to ',
        email,
        ', please check your inbox and click the link \'Activate\' to confirm and earn!'
      );
    },
    USE_ANOTHER_EMAIL: 'Use another email',
    SECTOR: 'Sector',
    CATEGORY: 'Category',
    PLEASE_SELECT_CATEGORY: 'Please select category',
    PROFESSION: 'Profession',
    DESCRIPTION: 'Description',
    FREE: 'Free',
    PER_MINUTE: 'per minute',
    BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
    TERMS_OF_USE: 'Terms of use',
    AND_THE: 'and the',
    PRIVACY_POLICY: 'Privacy Policy',
    THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
    CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
    ACCOUNT_TYPE: 'Account type',
    APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
    CANCEL_CHANGES: 'Cancel changes',
    PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
    ERROR: 'Error',
    PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
    UNITED_KINGDOM: 'United Kingdom',
    ONLY_UK_NOW: 'Only UK for now',
    I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
    ALREADY_HAVE_ACCOUNT: 'Already have an account',
    CODE_HAVE_BEEN_SENT: 'Code has been sent to',
    EDUCATION: {
      EDUCATION: 'Education',
      LANGUAGE_TUTOR: 'Language tutor',
      LANGUAGE_PRACTICE: 'Language practice',
      EXAMS_PREPARATION: 'Exams preparation',
      SCIENCE: 'Science',
      BUSINESS_STUDIES: 'Business studies',
      SOCIAL_SCIENCE: 'Social science',
      DRAWING: 'Drawing',
      MUSIC: 'Music',
      DANCE: 'Dance'
    },
    SERVICES: {
      SERVICES: 'Services',
      INTERPRETER: 'Interpreter',
      NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
      THERAPIST: 'Therapist',
      LISTENER: 'Listener',
      SPEECH_THERAPIST: 'Speech therapist',
      FORTUN_TELLER: 'Fortun teller',
      ASTROLOGIST: 'Astrologist',
      PERSONAL_ASSISTANT: 'Personal assistant',
      CAREER_COACH: 'Career coach'
    },
    CONSULTANCY: {
      CONSULTANCY: 'Consultancy',
      LEGAL: 'Legal',
      MEDICAL: 'Medical',
      BUSINESS: 'Business',
      FAMILY: 'Family',
      INVESTMENT: 'Investment',
      TECH_SUPPORT: 'Tech support',
      BEAUTICIAN: 'Beautician'
    },
    HEALTH_LIFESTYLE: {
      HEALTH_LIFESTYLE: 'Health&Lifestyle',
      PERSONAL_TRAINER: 'Personal trainer',
      YOGA_INSTRUCTOR: 'Yuga instructor',
      MEDITATION_INSTRUCTOR: 'Meditation instructor',
      DIETOLOGIST: 'Dietologist',
      SPORT_COACH: 'Sport coach',
      FITNESS_PROFESSIONAL: 'Fitness professional',
      SPIRITUAL_COACH: 'Spiritual coach'
    },
    PLEASE_SELECT_SECTOR: 'Please select sector',
    PLEASE_ENTER_PROFESSION: 'Please enter profession',
    PLEASE_ENTER_DESCRIPTION: 'Please enter description',
    PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
    PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
    YOU_ARE_UNDER_18: 'You are under 18',
    DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
    YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
    PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
    CITY_IN_THE_UK: 'City in the UK',
    CITY_INCORRECT: 'City incorrect',
    POSTCODE: 'Postcode',
    PLEASE_ENTER_POSTCODE: 'Please enter postcode',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    ONLY_UK_ADDRESS: 'Only UK address',
    ADDRESS_INCORRECT: 'Address incorrect',
    ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
    BIRTHDAY_INCORRECT: 'Birthday incorrect',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    WE_WONT_SHARE_IT: 'We won\'t share it with others.',
    MOBILE_INCORRECT: 'Mobile incorrect',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    EG_IO: 'e.g. i0ONOZLgCIM',
    SERVICE_INCORRECT: 'Service incorrect',
    SERVICE_LABEL: 'Service (20 characters)',
    IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
    SERVICE_NAME_INCORRECT: 'Service name incorrect',
    SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
    SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
    SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
    PRICE_PER_MINUTE: 'Price per minute',
    DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
    YES: 'Yes.',
    NO: 'No.',
    DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
    YES_SAVE: 'Yes, save.',
    DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
    ENTER_TAX_ID: 'Enter tax ID to check',
    CHECK: 'Check.',
    PLEASE_ENTER_PASSWORD: 'Please enter password',
    FIRST_NAME: 'First name'
  },
  SOCIAL_NETWORK: {
    CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
    CONTINUE_WITH_GOOGLE: 'Continue with Google'
  },
  ROUTES: {
    ERROR_404: 'Error 404',
    PAGE_NOT_FOUND: 'Page not found',
    THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
    GO_HOME: 'Go Home',
    FEATURED_SERVICE: 'FEATURED SERVICE',
    WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
    GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
    FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
    CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
    NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
    YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
    RESET: 'Reset',
    BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
    TELMIE_T_C: 'Telmie T&C',
    TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
    AND: 'and',
    STRIPE_T_C: 'Stripe T&C.',
    SORRY: 'Sorry',
    IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
    OR: 'or',
    IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
    BACK_TO_SETTINGS: 'Back to Settings',
    PROFILE_PREVIEW: 'Profile preview',
    PRO_DETAILS: 'Pro details',
    PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
    RESULTS_FOR: 'Results for',
    SORRY_NO_PROS: 'Sorry, no pros found for',
    SELECT_YOUR_INTEREST: 'Select your interest',
    TELMIE_MY_CLIENTS: 'Telmie | My Clients',
    FIND_YOUR_CLIENT: 'Find your Client',
    TELMIE_MY_PROS: 'Telmie | My Pros',
    FIND_YOUR_PRO: 'Find your Pro',
    PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
    TELMIE_PREVIEW: 'Telmie | Preview',
    LOWEST_RATE_FIRST: 'Lowest rate first',
    HIGHEST_RATE_FIRST: 'Highest rate first',
    EXPERIENCE: 'Experience',
    RATING: 'Rating',
    ACTIVITY: 'Activity',
    LANGUAGES: 'Languages',
    COACHING: 'Coaching',
    IMMIGRATION: 'Immigration',
    OTHER: 'Other',
    ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
    ERROR_WITH_STRIPE: 'Error with Stripe.',
    TELMIE_PRO: 'Telmie | Pro'
  },
  FOOTER: {
    HOME: 'Strona domowa',
    CONTACT: 'Kontakt',
    SUPPORT: 'Support',
    POLICY: 'Polityka prywatności',
    TERMS: 'Warunki',
    FAQ: 'FAQ',
    COPYRIGHT: 'Copyright',
    COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom'
  },
  CONTACT_US: {
    title: 'Kontakt',
    subTitle: 'Masz pytania? Napisz do nas',
    name: 'Imię',
    email: 'E-mail',
    company: 'Firma',
    subject: 'Temat',
    message: 'Wpisz swoją wiadomość',
    success: 'Dziękujemy za Twoją wiadomość',
    submitBtn: 'Wyślij'
  },
  SERVICES: {
    LANGUAGE_PRACTICE: 'Ćwiczenie umiejętności językowych',
    IMMIGRATION_ADVICE: 'Porady dotyczące imigracji',
    IMMIGRATION_CONSULTANT: 'Doradca do spraw imigracji',
    LANGUAGE_LEARNERS: 'Nauka języków'
  },
  FAQ: 'FAQ',
  MORE_FAQ: 'Więcej pytania',
  API: {
    NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content'
  },
  NOTIFICATIONS: {
    DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
    EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
    MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
    SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
    UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!'
  },
  REGISTER_PRO: {
    FIRST_NAME: 'First name',
    FIRST_NAME_ERROR: 'First name field is required',
    LAST_NAME: 'Last name',
    LAST_NAME_ERROR: 'Last name field is required',
    COUNTRY: 'Country',
    COUNTRY_PLACEHOLDER: 'Select country',
    COUNTRY_ERROR: 'Country field is required',
    CITY: 'City',
    POSTCODE: 'Postcode',
    POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
    DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
    DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    MOBILE_HINT: 'We won\'t share it with others.',
    MOBILE_ERROR: 'Must contain only numbers',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
    SERVICES: 'Services',
    SERVICES_PLACEHOLDER: 'Select service',
    SERVICES_ERROR: 'Services field is required',
    SERVICE: 'Service (20 characters)',
    SERVICE_HINT: 'i.e. English practice, Immigration advice',
    SERVICE_ERROR: 'Service name may not be greater than 20 characters',
    SECTOR: 'Sector',
    SECTOR_PLACEHOLDER: 'Select sector',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
    SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
    SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
    SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
    SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
    COST_PER_MINUTE_ERROR: 'Please enter price',
    COST_PER_MINUTE_MAX: 'Maximum allowed for this service'
  }
}, _langPack[__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* AE */]] = {
  DOWNLOAD_APP_BTN: 'تحميل التطبيق',
  HOMEPAGE_FAQ_TITLE: 'الأسئلة الأكثر شيوعًا',
  GENERAL_QUESTIONS: 'شائع',
  CUSTOMERS_QUESTIONS: 'العملاء',
  EXPERTS_QUESTIONS: 'خبير',
  PAYMENTS_QUESTIONS: 'المدفوعات',
  BLOG_TITLE: 'مدونة',
  FULL_STORY_BTN: 'قصه كامله',
  OTHER_POSTS: 'وظيفة أخرى',
  MISC: {
    DELETE: 'Delete',
    UPDATE_NOW: 'Update now',
    CONNECTING: 'Connecting',
    CONNECTING_TO_SERVER: 'Connecting to server',
    CALLING_PRO: 'Calling Pro',
    CREDIT_CARD: 'Credit card',
    ADD_A_CARD: 'Add a card',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    SAVE: 'Save',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
    PLEASE_ENTER_LAST_NAME: 'Please enter last name',
    YOU_WILL_PAY: 'You will pay',
    PER_MINUTE_FOR_CALL: 'per minute for this call',
    MINUTES_SHORT: 'min',
    BECOME_PRO: 'إحترف',
    BLOG: 'مدونة',
    FIND_A_PRO: 'Find a Pro',
    MY_CLIENTS: 'My Clients',
    MY_PROS: 'My Pros',
    MY_APPOINTMENTS: 'My Appointments',
    SIGN_UP: 'Sign Up',
    LOG_OUT: 'Log out',
    REGISTER_AS_PRO: 'Register as Pro',
    REGISTER: 'Register',
    LOG_IN: 'Log in',
    FORGOT_PASSWORD: 'Forgot password',
    PASSWORD: 'Password',
    DATE: 'Date',
    DATE_AND_TIME: 'Date and time',
    DURATION: 'Duration',
    TYPE: 'Type',
    EDIT: 'Edit',
    NAME: 'Name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    MOBILE: 'Mobile',
    CITY: 'City',
    BUSINESS_NAME: 'Business name',
    COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
    COUNTRY: 'Country',
    RATE: 'Rate',
    YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
    CODE_VERIFIED: 'Code verified',
    IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
    CODE_EXPIRES_IN: 'Code expires in',
    CODE: 'Code',
    VERIFY_CODE: 'Verify code',
    PLEASE_ENTER_EMAIL: 'Please enter email',
    RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
    SEND_VERIFICATION_CODE: 'Send verification code',
    LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully'
  },
  BLOG: {
    COMMENTS: 'Comments',
    REPLY: 'Reply',
    ADD_COMMENT: 'Add Comment',
    POST_COMMENT: 'Post comment'
  },
  BOOKING: {
    CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
    CANCELLATION_POLICY: 'Cancellation Policy',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
    YES_CANCEL: 'Yes, cancel',
    NO_KEEP: 'No, keep it'
  },
  COMMUNICATION: {
    ON_CALL_WITH: 'On call with',
    CONNECTING_WITH: 'Connecting with',
    INCOMING_CALL: 'Incoming Call',
    YOUR_CLIENT: 'Your client',
    TYPE_YOUR_MESSAGE: 'Type your message',
    MIN: 'min',
    CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.'
  },
  CREDIT_CARD: {
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder',
    EXPIRY_DATE: 'Expiry date',
    CVV: 'CVV',
    CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
    SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
    SAVE_PAYMENT_METHOD: 'Save payment method',
    X2_BONUS: 'x2 BONUS',
    YOU_WILL_GET: 'You will get',
    TELMIE_CREDIT: 'Telmie credit',
    IN_TOTAL: 'in total',
    CONFIRM_AND_PAY: 'Confirm & Pay',
    CANNOT_WITHDRAW: 'Cannot withdraw',
    FEE: 'fee',
    FREE: 'Free',
    YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
    AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
    AVALIABLE: 'Available',
    AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
    WITHDRAW: 'Withdraw',
    FREE_APPLIES: 'Fee applies: ',
    YOU_RECEIVE: 'You receive: ',
    WITHDRAWAL_RULES: 'Withdrawal rules',
    WITHDRAWAL_AMOUNT: 'Withdrawal amount',
    HIDE: 'Hide',
    SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules'
  },
  EDIT_PROFILE: {
    SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
    CANT_BE_CHANGED: 'Can\'t be changed',
    UPLOAD_PICTURE: 'Upload picture',
    NAME_ISNT_VALID: 'The name isn\'t valid.'
  },
  FEATURED_SERVICE: {
    CALL_NOW: 'Call now',
    CANCEL_CALL: 'Cancel call',
    NEXT_PRO: 'Next pro',
    NEXT_PRO_CAPS: 'NEXT PRO',
    THEN_CAPS: 'THEN'
  },
  HEADER: {
    HOW_IT_WORKS: 'كيف يعمل',
    FAQ: 'الأسئلة الشائعة',
    CONTACT: 'إتصل بنا',
    MONEY: 'Money',
    SETTINGS: 'Settings',
    LOGIN: 'Log in',
    EDIT_PROFILE: 'Edit Profile',
    NEW_CHATS: 'New Chats',
    WELL_DONE: 'Well done',
    SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
    EDIT_PRO_DETAILS: 'Edit Pro details'
  },
  HOMEPAGE: {
    FEATURED_PROS: 'Featured Pros',
    FEATURED_SERVICES: 'Featured services',
    DOWNLOAD_TELMIE_APP: 'Download Telmie app'
  },
  LANGUAGE_PRACTICE: {
    HAPPY_PROS: 'Happy Pros',
    HAPPY_USERS: 'Happy Users'
  },
  LOG_IN: {
    LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
    NEW_TO_TELMIE: 'New to Telmie',
    DOWNLOAD_THE_APP: 'Download the app'
  },
  NEW_LANDING: {
    MINUTES: 'minutes',
    COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
    BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
    PLEASE_ENTER_SUBJECT: 'Please enter subject',
    PLEASE_ENTER_MESSAGE: 'Please enter message'
  },
  PRO: {
    PRO: 'Pro',
    AMOUNT: 'Amount',
    NO_RECENT_CALLS: 'No recent calls',
    MESSAGES: 'Messages',
    START_CALL: 'Start Call',
    SHORTLISTED: 'Shortlisted',
    REMOVE: 'Remove',
    SHORTLIST: 'Shortlist',
    LOADING: 'Loading',
    TELMIE_CLIENT: 'Telmie Client',
    ON_CALL: 'On call',
    RECONNECTING: 'Reconnecting...',
    TELMIE_USER_IS_CALLING: 'Telmie user is calling',
    SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
    HOURS_FIRST_LETTER: 'h',
    MINUTES_FIRST_LETTER: 'm',
    CALENDAR_TITLE: 'My availability',
    CALENDAR_SUB_TITLE: 'I am not available right now',
    CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
    AVAILABLE_NOW: 'Available now',
    AVAILABLE_LATTER: 'Available later',
    WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
    PRO_IS_BUSY: 'Pro is busy'
  },
  PROFILE: {
    VIEW_ALL: 'View all',
    CONTACT: 'Contact',
    COUNT: 'Count',
    NO_RECENT_ACTIVITY: 'No recent activity',
    YOUR_DETAILS: 'Your details',
    LOCATION: 'Location',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NO_RECENT_PROS: 'No recent PROS',
    WITHDRAW_EARNINGS: 'Withdraw earnings',
    TOP_UP: 'Top Up',
    ATTACH_CARD: 'Attach card',
    SERVICE: 'Service',
    APPOINTMENT_WITH: 'Appointment with',
    COST: 'Cost',
    BALANCE: 'Balance',
    NO_RECENT_TRANSACTIONS: 'No recent transactions',
    NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
    CLIENT: 'Client'
  },
  RADIO_BUTTONS: {
    APPROVED: 'Approved',
    SECTORS: 'SECTORS'
  },
  SEARCH: {
    FILTERS: 'Filters',
    SESSIONS: 'sessions',
    ARRANGE_BY: 'Arrange by',
    ENTER_KEYWORDS: 'Enter keywords',
    RESET_FILTERS: 'Clear all'
  },
  SELECT: {
    EVERY: 'Every'
  },
  SETTINGS: {
    IMPORTANT_VIA_EMAIL: 'Important via email',
    WORKING_AS_PRO: 'Working as Pro',
    PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
    ADD_NEW_PERIOD: 'Add new period',
    CHANGE_BANK_ACCOUNT: 'Change bank account',
    ADD_BANK_ACCOUNT: 'Add bank account',
    ENTITY: 'Entity',
    ADDRESS: 'Address',
    YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
    WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
    SORT_CODE: 'Sort code',
    DIGITS_VALUE: 'digits value',
    ACCOUNT_NUMBER: 'Account number',
    BAD_REQUEST_DATA: 'Bad Request data',
    PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
    CONFIRM: 'Confirm',
    UPLOAD_ANOTHER_IMAGE: 'Upload another image',
    UPLOAD: 'Upload',
    YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
    YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
    PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
    POST_CODE: 'Post Code',
    LOADING_CARDS: 'Loading cards',
    NO_CARDS: 'No cards.',
    COMPANY_ADDRESS: 'Company address',
    PERSONAL_ADDRESS: 'Personal address',
    SERVICE_NAME: 'Service name',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_SUB_CATEGORY: 'Service sub-category',
    SERVICE_DESCRIPTION: 'Service description',
    PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
    LOADING_ACCOUNTS: 'Loading accounts',
    ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
    PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
    THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
    DAYS_REQUIRED: 'Please select days',
    FROM: 'From',
    TO: 'To',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
    PROFILE_DETAILS: 'Profile details',
    PRO_SETTINGS: 'PRO SETTINGS',
    WORK_AS_PRO: 'Work as Pro',
    PRO_DETAILS: 'Pro details',
    PAYOUT_BANK_DETAILS: 'Payout bank details',
    PREVIEW_MY_PROFILE: 'Preview my profile',
    MY_AVAILABILITY: 'My availability',
    HIDE_PROFILE: 'Hide profile',
    GENERAL_SETTINGS: 'GENERAL SETTINGS',
    PAYMENT_SETTINGS: 'Payment settings',
    EMAIL_NOTIFICATION: 'Email notification',
    BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
    BANK_ACCOUNT: 'Bank account',
    ID_VERIFICATION: 'ID Verification',
    I_WANT_TO_TAKE_PART: 'I want to take part'
  },
  SIGN_UP: {
    CONFIRM_EMAIL: 'Now confirm your email address',
    RESEND: 'Resend',
    CONFIRM_EMAIL_MESSAGE: function CONFIRM_EMAIL_MESSAGE(email) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        'We\'ve sent an email to ',
        email,
        ', please check your inbox and click the link \'Activate\' to confirm and earn!'
      );
    },
    USE_ANOTHER_EMAIL: 'Use another email',
    SECTOR: 'Sector',
    CATEGORY: 'Category',
    PLEASE_SELECT_CATEGORY: 'Please select category',
    PROFESSION: 'Profession',
    DESCRIPTION: 'Description',
    FREE: 'Free',
    PER_MINUTE: 'per minute',
    BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
    TERMS_OF_USE: 'Terms of use',
    AND_THE: 'and the',
    PRIVACY_POLICY: 'Privacy Policy',
    THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
    CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
    ACCOUNT_TYPE: 'Account type',
    APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
    CANCEL_CHANGES: 'Cancel changes',
    PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
    ERROR: 'Error',
    PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
    UNITED_KINGDOM: 'United Kingdom',
    ONLY_UK_NOW: 'Only UK for now',
    I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
    ALREADY_HAVE_ACCOUNT: 'Already have an account',
    CODE_HAVE_BEEN_SENT: 'Code has been sent to',
    EDUCATION: {
      EDUCATION: 'Education',
      LANGUAGE_TUTOR: 'Language tutor',
      LANGUAGE_PRACTICE: 'Language practice',
      EXAMS_PREPARATION: 'Exams preparation',
      SCIENCE: 'Science',
      BUSINESS_STUDIES: 'Business studies',
      SOCIAL_SCIENCE: 'Social science',
      DRAWING: 'Drawing',
      MUSIC: 'Music',
      DANCE: 'Dance'
    },
    SERVICES: {
      SERVICES: 'Services',
      INTERPRETER: 'Interpreter',
      NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
      THERAPIST: 'Therapist',
      LISTENER: 'Listener',
      SPEECH_THERAPIST: 'Speech therapist',
      FORTUN_TELLER: 'Fortun teller',
      ASTROLOGIST: 'Astrologist',
      PERSONAL_ASSISTANT: 'Personal assistant',
      CAREER_COACH: 'Career coach'
    },
    CONSULTANCY: {
      CONSULTANCY: 'Consultancy',
      LEGAL: 'Legal',
      MEDICAL: 'Medical',
      BUSINESS: 'Business',
      FAMILY: 'Family',
      INVESTMENT: 'Investment',
      TECH_SUPPORT: 'Tech support',
      BEAUTICIAN: 'Beautician'
    },
    HEALTH_LIFESTYLE: {
      HEALTH_LIFESTYLE: 'Health&Lifestyle',
      PERSONAL_TRAINER: 'Personal trainer',
      YOGA_INSTRUCTOR: 'Yuga instructor',
      MEDITATION_INSTRUCTOR: 'Meditation instructor',
      DIETOLOGIST: 'Dietologist',
      SPORT_COACH: 'Sport coach',
      FITNESS_PROFESSIONAL: 'Fitness professional',
      SPIRITUAL_COACH: 'Spiritual coach'
    },
    PLEASE_SELECT_SECTOR: 'Please select sector',
    PLEASE_ENTER_PROFESSION: 'Please enter profession',
    PLEASE_ENTER_DESCRIPTION: 'Please enter description',
    PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
    PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
    YOU_ARE_UNDER_18: 'You are under 18',
    DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
    YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
    PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
    CITY_IN_THE_UK: 'City in the UK',
    CITY_INCORRECT: 'City incorrect',
    POSTCODE: 'Postcode',
    PLEASE_ENTER_POSTCODE: 'Please enter postcode',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    ONLY_UK_ADDRESS: 'Only UK address',
    ADDRESS_INCORRECT: 'Address incorrect',
    ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
    BIRTHDAY_INCORRECT: 'Birthday incorrect',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    WE_WONT_SHARE_IT: 'We won\'t share it with others.',
    MOBILE_INCORRECT: 'Mobile incorrect',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    EG_IO: 'e.g. i0ONOZLgCIM',
    SERVICE_INCORRECT: 'Service incorrect',
    SERVICE_LABEL: 'Service (20 characters)',
    IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
    SERVICE_NAME_INCORRECT: 'Service name incorrect',
    SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
    SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
    SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
    PRICE_PER_MINUTE: 'Price per minute',
    DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
    YES: 'Yes.',
    NO: 'No.',
    DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
    YES_SAVE: 'Yes, save.',
    DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
    ENTER_TAX_ID: 'Enter tax ID to check',
    CHECK: 'Check.',
    PLEASE_ENTER_PASSWORD: 'Please enter password',
    FIRST_NAME: 'First name'
  },
  SOCIAL_NETWORK: {
    CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
    CONTINUE_WITH_GOOGLE: 'Continue with Google'
  },
  ROUTES: {
    ERROR_404: 'Error 404',
    PAGE_NOT_FOUND: 'Page not found',
    THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
    GO_HOME: 'Go Home',
    FEATURED_SERVICE: 'FEATURED SERVICE',
    WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
    GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
    FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
    CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
    NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
    YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
    RESET: 'Reset',
    BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
    TELMIE_T_C: 'Telmie T&C',
    TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
    AND: 'and',
    STRIPE_T_C: 'Stripe T&C.',
    SORRY: 'Sorry',
    IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
    OR: 'or',
    IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
    BACK_TO_SETTINGS: 'Back to Settings',
    PROFILE_PREVIEW: 'Profile preview',
    PRO_DETAILS: 'Pro details',
    PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
    RESULTS_FOR: 'Results for',
    SORRY_NO_PROS: 'Sorry, no pros found for',
    SELECT_YOUR_INTEREST: 'Select your interest',
    TELMIE_MY_CLIENTS: 'Telmie | My Clients',
    FIND_YOUR_CLIENT: 'Find your Client',
    TELMIE_MY_PROS: 'Telmie | My Pros',
    FIND_YOUR_PRO: 'Find your Pro',
    PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
    TELMIE_PREVIEW: 'Telmie | Preview',
    LOWEST_RATE_FIRST: 'Lowest rate first',
    HIGHEST_RATE_FIRST: 'Highest rate first',
    EXPERIENCE: 'Experience',
    RATING: 'Rating',
    ACTIVITY: 'Activity',
    LANGUAGES: 'Languages',
    COACHING: 'Coaching',
    IMMIGRATION: 'Immigration',
    OTHER: 'Other',
    ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
    ERROR_WITH_STRIPE: 'Error with Stripe.',
    TELMIE_PRO: 'Telmie | Pro'
  },
  FOOTER: {
    HOME: 'الرئيسية',
    CONTACT: 'إتصل بنا',
    SUPPORT: 'Support',
    POLICY: 'سياسة الخصوصية',
    TERMS: 'البنود',
    FAQ: 'الأسئلة الشائعة',
    COPYRIGHT: 'Copyright',
    COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom'
  },
  CONTACT_US: {
    title: 'إتصل بنا',
    subTitle: 'أى أسئلة ؟ إكتب لنا ',
    name: 'إسم',
    email: 'بريد إلكترونى ',
    company: 'شركة',
    subject: 'الموضوع',
    message: 'إكتب رسالتك',
    success: 'نشكرك على إتصالك بنا',
    submitBtn: 'أرسل'
  },
  SERVICES: {
    LANGUAGE_PRACTICE: 'تدريب اللغة',
    IMMIGRATION_ADVICE: 'إستشارات الهجرة',
    IMMIGRATION_CONSULTANT: 'مستشار هجرة',
    LANGUAGE_LEARNERS: 'تعلم اللغة'
  },
  FAQ: 'الأسئلة الشائعة',
  MORE_FAQ: 'المزيد من الأسئلة',
  API: {
    NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content'
  },
  NOTIFICATIONS: {
    DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
    EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
    MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
    SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
    UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!'
  },
  REGISTER_PRO: {
    FIRST_NAME: 'First name',
    FIRST_NAME_ERROR: 'First name field is required',
    LAST_NAME: 'Last name',
    LAST_NAME_ERROR: 'Last name field is required',
    COUNTRY: 'Country',
    COUNTRY_PLACEHOLDER: 'Select country',
    COUNTRY_ERROR: 'Country field is required',
    CITY: 'City',
    POSTCODE: 'Postcode',
    POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
    DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
    DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    MOBILE_HINT: 'We won\'t share it with others.',
    MOBILE_ERROR: 'Must contain only numbers',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
    SERVICES: 'Services',
    SERVICES_PLACEHOLDER: 'Select service',
    SERVICES_ERROR: 'Services field is required',
    SERVICE: 'Service (20 characters)',
    SERVICE_HINT: 'i.e. English practice, Immigration advice',
    SERVICE_ERROR: 'Service name may not be greater than 20 characters',
    SECTOR: 'Sector',
    SECTOR_PLACEHOLDER: 'Select sector',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
    SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
    SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
    SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
    SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
    COST_PER_MINUTE_ERROR: 'Please enter price',
    COST_PER_MINUTE_MAX: 'Maximum allowed for this service'
  }
}, _langPack[__WEBPACK_IMPORTED_MODULE_1__consts__["r" /* PT */]] = {
  DOWNLOAD_APP_BTN: 'Baixar o App',
  HOMEPAGE_FAQ_TITLE: 'Perguntas mais populares',
  GENERAL_QUESTIONS: 'Questões Gerais',
  CUSTOMERS_QUESTIONS: 'Clientes',
  EXPERTS_QUESTIONS: 'Especialista',
  PAYMENTS_QUESTIONS: 'Pagamentos',
  BLOG_TITLE: 'Blog',
  FULL_STORY_BTN: 'História completa',
  OTHER_POSTS: 'Outros posts',
  MISC: {
    DELETE: 'Delete',
    UPDATE_NOW: 'Update now',
    CONNECTING: 'Connecting',
    CONNECTING_TO_SERVER: 'Connecting to server',
    CALLING_PRO: 'Calling Pro',
    CREDIT_CARD: 'Credit card',
    ADD_A_CARD: 'Add a card',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    SAVE: 'Save',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
    PLEASE_ENTER_LAST_NAME: 'Please enter last name',
    YOU_WILL_PAY: 'You will pay',
    PER_MINUTE_FOR_CALL: 'per minute for this call',
    MINUTES_SHORT: 'min',
    BECOME_PRO: 'Torne-se um pro',
    BLOG: 'Blog',
    FIND_A_PRO: 'Find a Pro',
    MY_CLIENTS: 'My Clients',
    MY_PROS: 'My Pros',
    MY_APPOINTMENTS: 'My Appointments',
    SIGN_UP: 'Sign Up',
    LOG_OUT: 'Log out',
    REGISTER_AS_PRO: 'Register as Pro',
    REGISTER: 'Register',
    LOG_IN: 'Log in',
    FORGOT_PASSWORD: 'Forgot password',
    PASSWORD: 'Password',
    DATE: 'Date',
    DATE_AND_TIME: 'Date and time',
    DURATION: 'Duration',
    TYPE: 'Type',
    EDIT: 'Edit',
    NAME: 'Name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    MOBILE: 'Mobile',
    CITY: 'City',
    BUSINESS_NAME: 'Business name',
    COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
    COUNTRY: 'Country',
    RATE: 'Rate',
    YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
    CODE_VERIFIED: 'Code verified',
    IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
    CODE_EXPIRES_IN: 'Code expires in',
    CODE: 'Code',
    VERIFY_CODE: 'Verify code',
    PLEASE_ENTER_EMAIL: 'Please enter email',
    RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
    SEND_VERIFICATION_CODE: 'Send verification code',
    LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully'
  },
  BLOG: {
    COMMENTS: 'Comments',
    REPLY: 'Reply',
    ADD_COMMENT: 'Add Comment',
    POST_COMMENT: 'Post comment'
  },
  BOOKING: {
    CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
    CANCELLATION_POLICY: 'Cancellation Policy',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
    YES_CANCEL: 'Yes, cancel',
    NO_KEEP: 'No, keep it'
  },
  COMMUNICATION: {
    ON_CALL_WITH: 'On call with',
    CONNECTING_WITH: 'Connecting with',
    INCOMING_CALL: 'Incoming Call',
    YOUR_CLIENT: 'Your client',
    TYPE_YOUR_MESSAGE: 'Type your message',
    MIN: 'min',
    CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.'
  },
  CREDIT_CARD: {
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder',
    EXPIRY_DATE: 'Expiry date',
    CVV: 'CVV',
    CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
    SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
    SAVE_PAYMENT_METHOD: 'Save payment method',
    X2_BONUS: 'x2 BONUS',
    YOU_WILL_GET: 'You will get',
    TELMIE_CREDIT: 'Telmie credit',
    IN_TOTAL: 'in total',
    CONFIRM_AND_PAY: 'Confirm & Pay',
    CANNOT_WITHDRAW: 'Cannot withdraw',
    FEE: 'fee',
    FREE: 'Free',
    YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
    AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
    AVALIABLE: 'Available',
    AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
    WITHDRAW: 'Withdraw',
    FREE_APPLIES: 'Fee applies: ',
    YOU_RECEIVE: 'You receive: ',
    WITHDRAWAL_RULES: 'Withdrawal rules',
    WITHDRAWAL_AMOUNT: 'Withdrawal amount',
    HIDE: 'Hide',
    SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules'
  },
  EDIT_PROFILE: {
    SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
    CANT_BE_CHANGED: 'Can\'t be changed',
    UPLOAD_PICTURE: 'Upload picture',
    NAME_ISNT_VALID: 'The name isn\'t valid.'
  },
  FEATURED_SERVICE: {
    CALL_NOW: 'Call now',
    CANCEL_CALL: 'Cancel call',
    NEXT_PRO: 'Next pro',
    NEXT_PRO_CAPS: 'NEXT PRO',
    THEN_CAPS: 'THEN'
  },
  HEADER: {
    HOW_IT_WORKS: 'Como funciona',
    FAQ: 'Perguntas frequentes',
    CONTACT: 'Fale conosco',
    MONEY: 'Money',
    SETTINGS: 'Settings',
    LOGIN: 'Log in',
    EDIT_PROFILE: 'Edit Profile',
    NEW_CHATS: 'New Chats',
    WELL_DONE: 'Well done',
    SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
    EDIT_PRO_DETAILS: 'Edit Pro details'
  },
  HOMEPAGE: {
    FEATURED_PROS: 'Featured Pros',
    FEATURED_SERVICES: 'Featured services',
    DOWNLOAD_TELMIE_APP: 'Download Telmie app'
  },
  LANGUAGE_PRACTICE: {
    HAPPY_PROS: 'Happy Pros',
    HAPPY_USERS: 'Happy Users'
  },
  LOG_IN: {
    LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
    NEW_TO_TELMIE: 'New to Telmie',
    DOWNLOAD_THE_APP: 'Download the app'
  },
  NEW_LANDING: {
    MINUTES: 'minutes',
    COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
    BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
    PLEASE_ENTER_SUBJECT: 'Please enter subject',
    PLEASE_ENTER_MESSAGE: 'Please enter message'
  },
  PRO: {
    PRO: 'Pro',
    AMOUNT: 'Amount',
    NO_RECENT_CALLS: 'No recent calls',
    MESSAGES: 'Messages',
    START_CALL: 'Start Call',
    SHORTLISTED: 'Shortlisted',
    REMOVE: 'Remove',
    SHORTLIST: 'Shortlist',
    LOADING: 'Loading',
    TELMIE_CLIENT: 'Telmie Client',
    ON_CALL: 'On call',
    RECONNECTING: 'Reconnecting...',
    TELMIE_USER_IS_CALLING: 'Telmie user is calling',
    SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
    HOURS_FIRST_LETTER: 'h',
    MINUTES_FIRST_LETTER: 'm',
    CALENDAR_TITLE: 'My availability',
    CALENDAR_SUB_TITLE: 'I am not available right now',
    CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
    AVAILABLE_NOW: 'Available now',
    AVAILABLE_LATTER: 'Available later',
    WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
    PRO_IS_BUSY: 'Pro is busy'
  },
  PROFILE: {
    VIEW_ALL: 'View all',
    CONTACT: 'Contact',
    COUNT: 'Count',
    NO_RECENT_ACTIVITY: 'No recent activity',
    YOUR_DETAILS: 'Your details',
    LOCATION: 'Location',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NO_RECENT_PROS: 'No recent PROS',
    WITHDRAW_EARNINGS: 'Withdraw earnings',
    TOP_UP: 'Top Up',
    ATTACH_CARD: 'Attach card',
    SERVICE: 'Service',
    APPOINTMENT_WITH: 'Appointment with',
    COST: 'Cost',
    BALANCE: 'Balance',
    NO_RECENT_TRANSACTIONS: 'No recent transactions',
    NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
    CLIENT: 'Client'
  },
  RADIO_BUTTONS: {
    APPROVED: 'Approved',
    SECTORS: 'SECTORS'
  },
  SEARCH: {
    FILTERS: 'Filters',
    SESSIONS: 'sessions',
    ARRANGE_BY: 'Arrange by',
    ENTER_KEYWORDS: 'Enter keywords',
    RESET_FILTERS: 'Clear all'
  },
  SELECT: {
    EVERY: 'Every'
  },
  SETTINGS: {
    IMPORTANT_VIA_EMAIL: 'Important via email',
    WORKING_AS_PRO: 'Working as Pro',
    PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
    ADD_NEW_PERIOD: 'Add new period',
    CHANGE_BANK_ACCOUNT: 'Change bank account',
    ADD_BANK_ACCOUNT: 'Add bank account',
    ENTITY: 'Entity',
    ADDRESS: 'Address',
    YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
    WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
    SORT_CODE: 'Sort code',
    DIGITS_VALUE: 'digits value',
    ACCOUNT_NUMBER: 'Account number',
    BAD_REQUEST_DATA: 'Bad Request data',
    PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
    CONFIRM: 'Confirm',
    UPLOAD_ANOTHER_IMAGE: 'Upload another image',
    UPLOAD: 'Upload',
    YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
    YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
    PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
    POST_CODE: 'Post Code',
    LOADING_CARDS: 'Loading cards',
    NO_CARDS: 'No cards.',
    COMPANY_ADDRESS: 'Company address',
    PERSONAL_ADDRESS: 'Personal address',
    SERVICE_NAME: 'Service name',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_SUB_CATEGORY: 'Service sub-category',
    SERVICE_DESCRIPTION: 'Service description',
    PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
    LOADING_ACCOUNTS: 'Loading accounts',
    ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
    PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
    THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
    DAYS_REQUIRED: 'Please select days',
    FROM: 'From',
    TO: 'To',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
    PROFILE_DETAILS: 'Profile details',
    PRO_SETTINGS: 'PRO SETTINGS',
    WORK_AS_PRO: 'Work as Pro',
    PRO_DETAILS: 'Pro details',
    PAYOUT_BANK_DETAILS: 'Payout bank details',
    PREVIEW_MY_PROFILE: 'Preview my profile',
    MY_AVAILABILITY: 'My availability',
    HIDE_PROFILE: 'Hide profile',
    GENERAL_SETTINGS: 'GENERAL SETTINGS',
    PAYMENT_SETTINGS: 'Payment settings',
    EMAIL_NOTIFICATION: 'Email notification',
    BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
    BANK_ACCOUNT: 'Bank account',
    ID_VERIFICATION: 'ID Verification',
    I_WANT_TO_TAKE_PART: 'I want to take part'
  },
  SIGN_UP: {
    CONFIRM_EMAIL: 'Now confirm your email address',
    RESEND: 'Resend',
    CONFIRM_EMAIL_MESSAGE: function CONFIRM_EMAIL_MESSAGE(email) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        'We\'ve sent an email to ',
        email,
        ', please check your inbox and click the link \'Activate\' to confirm and earn!'
      );
    },
    USE_ANOTHER_EMAIL: 'Use another email',
    SECTOR: 'Sector',
    CATEGORY: 'Category',
    PLEASE_SELECT_CATEGORY: 'Please select category',
    PROFESSION: 'Profession',
    DESCRIPTION: 'Description',
    FREE: 'Free',
    PER_MINUTE: 'per minute',
    BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
    TERMS_OF_USE: 'Terms of use',
    AND_THE: 'and the',
    PRIVACY_POLICY: 'Privacy Policy',
    THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
    CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
    ACCOUNT_TYPE: 'Account type',
    APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
    CANCEL_CHANGES: 'Cancel changes',
    PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
    ERROR: 'Error',
    PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
    UNITED_KINGDOM: 'United Kingdom',
    ONLY_UK_NOW: 'Only UK for now',
    I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
    ALREADY_HAVE_ACCOUNT: 'Already have an account',
    CODE_HAVE_BEEN_SENT: 'Code has been sent to',
    EDUCATION: {
      EDUCATION: 'Education',
      LANGUAGE_TUTOR: 'Language tutor',
      LANGUAGE_PRACTICE: 'Language practice',
      EXAMS_PREPARATION: 'Exams preparation',
      SCIENCE: 'Science',
      BUSINESS_STUDIES: 'Business studies',
      SOCIAL_SCIENCE: 'Social science',
      DRAWING: 'Drawing',
      MUSIC: 'Music',
      DANCE: 'Dance'
    },
    SERVICES: {
      SERVICES: 'Services',
      INTERPRETER: 'Interpreter',
      NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
      THERAPIST: 'Therapist',
      LISTENER: 'Listener',
      SPEECH_THERAPIST: 'Speech therapist',
      FORTUN_TELLER: 'Fortun teller',
      ASTROLOGIST: 'Astrologist',
      PERSONAL_ASSISTANT: 'Personal assistant',
      CAREER_COACH: 'Career coach'
    },
    CONSULTANCY: {
      CONSULTANCY: 'Consultancy',
      LEGAL: 'Legal',
      MEDICAL: 'Medical',
      BUSINESS: 'Business',
      FAMILY: 'Family',
      INVESTMENT: 'Investment',
      TECH_SUPPORT: 'Tech support',
      BEAUTICIAN: 'Beautician'
    },
    HEALTH_LIFESTYLE: {
      HEALTH_LIFESTYLE: 'Health&Lifestyle',
      PERSONAL_TRAINER: 'Personal trainer',
      YOGA_INSTRUCTOR: 'Yuga instructor',
      MEDITATION_INSTRUCTOR: 'Meditation instructor',
      DIETOLOGIST: 'Dietologist',
      SPORT_COACH: 'Sport coach',
      FITNESS_PROFESSIONAL: 'Fitness professional',
      SPIRITUAL_COACH: 'Spiritual coach'
    },
    PLEASE_SELECT_SECTOR: 'Please select sector',
    PLEASE_ENTER_PROFESSION: 'Please enter profession',
    PLEASE_ENTER_DESCRIPTION: 'Please enter description',
    PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
    PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
    YOU_ARE_UNDER_18: 'You are under 18',
    DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
    YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
    PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
    CITY_IN_THE_UK: 'City in the UK',
    CITY_INCORRECT: 'City incorrect',
    POSTCODE: 'Postcode',
    PLEASE_ENTER_POSTCODE: 'Please enter postcode',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    ONLY_UK_ADDRESS: 'Only UK address',
    ADDRESS_INCORRECT: 'Address incorrect',
    ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
    BIRTHDAY_INCORRECT: 'Birthday incorrect',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    WE_WONT_SHARE_IT: 'We won\'t share it with others.',
    MOBILE_INCORRECT: 'Mobile incorrect',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    EG_IO: 'e.g. i0ONOZLgCIM',
    SERVICE_INCORRECT: 'Service incorrect',
    SERVICE_LABEL: 'Service (20 characters)',
    IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
    SERVICE_NAME_INCORRECT: 'Service name incorrect',
    SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
    SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
    SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
    PRICE_PER_MINUTE: 'Price per minute',
    DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
    YES: 'Yes.',
    NO: 'No.',
    DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
    YES_SAVE: 'Yes, save.',
    DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
    ENTER_TAX_ID: 'Enter tax ID to check',
    CHECK: 'Check.',
    PLEASE_ENTER_PASSWORD: 'Please enter password',
    FIRST_NAME: 'First name'
  },
  SOCIAL_NETWORK: {
    CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
    CONTINUE_WITH_GOOGLE: 'Continue with Google'
  },
  ROUTES: {
    ERROR_404: 'Error 404',
    PAGE_NOT_FOUND: 'Page not found',
    THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
    GO_HOME: 'Go Home',
    FEATURED_SERVICE: 'FEATURED SERVICE',
    WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
    GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
    FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
    CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
    NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
    YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
    RESET: 'Reset',
    BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
    TELMIE_T_C: 'Telmie T&C',
    TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
    AND: 'and',
    STRIPE_T_C: 'Stripe T&C.',
    SORRY: 'Sorry',
    IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
    OR: 'or',
    IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
    BACK_TO_SETTINGS: 'Back to Settings',
    PROFILE_PREVIEW: 'Profile preview',
    PRO_DETAILS: 'Pro details',
    PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
    RESULTS_FOR: 'Results for',
    SORRY_NO_PROS: 'Sorry, no pros found for',
    SELECT_YOUR_INTEREST: 'Select your interest',
    TELMIE_MY_CLIENTS: 'Telmie | My Clients',
    FIND_YOUR_CLIENT: 'Find your Client',
    TELMIE_MY_PROS: 'Telmie | My Pros',
    FIND_YOUR_PRO: 'Find your Pro',
    PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
    TELMIE_PREVIEW: 'Telmie | Preview',
    LOWEST_RATE_FIRST: 'Lowest rate first',
    HIGHEST_RATE_FIRST: 'Highest rate first',
    EXPERIENCE: 'Experience',
    RATING: 'Rating',
    ACTIVITY: 'Activity',
    LANGUAGES: 'Languages',
    COACHING: 'Coaching',
    IMMIGRATION: 'Immigration',
    OTHER: 'Other',
    ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
    ERROR_WITH_STRIPE: 'Error with Stripe.',
    TELMIE_PRO: 'Telmie | Pro'
  },
  FOOTER: {
    HOME: 'Página inicial',
    CONTACT: 'Fale conosco',
    SUPPORT: 'Support',
    POLICY: 'Política de Privacidade',
    TERMS: 'Termos',
    FAQ: 'FAQ',
    COPYRIGHT: 'Copyright',
    COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom'
  },
  CONTACT_US: {
    title: 'Fale conosco',
    subTitle: 'Alguma pergunta? Manda uma mensagem.',
    name: 'Nome',
    email: 'Email',
    company: 'Empresa',
    subject: 'Assunto',
    message: 'Digite sua mensagem',
    success: 'Obrigado por nos contatar',
    submitBtn: 'Enviar'
  },
  SERVICES: {
    LANGUAGE_PRACTICE: 'Prática de idiomas',
    IMMIGRATION_CONSULTANT: 'Assessor de imigração',
    IMMIGRATION_ADVICE: 'Aconselhamento sobre imigração',
    LANGUAGE_LEARNERS: 'Aprendizado de idiomas'
  },
  FAQ: 'Perguntas frequentes',
  MORE_FAQ: 'Mais Perguntas Frequentes',
  API: {
    NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content'
  },
  NOTIFICATIONS: {
    DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
    EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
    MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
    SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
    UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!'
  },
  REGISTER_PRO: {
    FIRST_NAME: 'First name',
    FIRST_NAME_ERROR: 'First name field is required',
    LAST_NAME: 'Last name',
    LAST_NAME_ERROR: 'Last name field is required',
    COUNTRY: 'Country',
    COUNTRY_PLACEHOLDER: 'Select country',
    COUNTRY_ERROR: 'Country field is required',
    CITY: 'City',
    POSTCODE: 'Postcode',
    POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
    DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
    DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    MOBILE_HINT: 'We won\'t share it with others.',
    MOBILE_ERROR: 'Must contain only numbers',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
    SERVICES: 'Services',
    SERVICES_PLACEHOLDER: 'Select service',
    SERVICES_ERROR: 'Services field is required',
    SERVICE: 'Service (20 characters)',
    SERVICE_HINT: 'i.e. English practice, Immigration advice',
    SERVICE_ERROR: 'Service name may not be greater than 20 characters',
    SECTOR: 'Sector',
    SECTOR_PLACEHOLDER: 'Select sector',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
    SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
    SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
    SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
    SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
    COST_PER_MINUTE_ERROR: 'Please enter price',
    COST_PER_MINUTE_MAX: 'Maximum allowed for this service'
  }
}, _langPack[__WEBPACK_IMPORTED_MODULE_1__consts__["e" /* DE */]] = {
  DOWNLOAD_APP_BTN: 'App herunterladen',
  HOMEPAGE_FAQ_TITLE: 'Häufig gestellte Fragen',
  GENERAL_QUESTIONS: 'Allgemeine Fragen',
  CUSTOMERS_QUESTIONS: 'Kunden',
  EXPERTS_QUESTIONS: 'Experten',
  PAYMENTS_QUESTIONS: 'Zahlungen',
  BLOG_TITLE: 'Blog',
  FULL_STORY_BTN: 'Unsere Geschichte',
  OTHER_POSTS: 'Mehr Beiträge',
  MISC: {
    DELETE: 'Delete',
    UPDATE_NOW: 'Update now',
    CONNECTING: 'Connecting',
    CONNECTING_TO_SERVER: 'Connecting to server',
    CALLING_PRO: 'Calling Pro',
    CREDIT_CARD: 'Credit card',
    ADD_A_CARD: 'Add a card',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    SAVE: 'Save',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
    PLEASE_ENTER_LAST_NAME: 'Please enter last name',
    YOU_WILL_PAY: 'You will pay',
    PER_MINUTE_FOR_CALL: 'per minute for this call',
    MINUTES_SHORT: 'min',
    BECOME_PRO: 'Werde ein profi',
    BLOG: 'Blog',
    FIND_A_PRO: 'Find a Pro',
    MY_CLIENTS: 'My Clients',
    MY_PROS: 'My Pros',
    MY_APPOINTMENTS: 'My Appointments',
    SIGN_UP: 'Sign Up',
    LOG_OUT: 'Log out',
    REGISTER_AS_PRO: 'Register as Pro',
    REGISTER: 'Register',
    LOG_IN: 'Log in',
    FORGOT_PASSWORD: 'Forgot password',
    PASSWORD: 'Password',
    DATE: 'Date',
    DATE_AND_TIME: 'Date and time',
    DURATION: 'Duration',
    TYPE: 'Type',
    EDIT: 'Edit',
    NAME: 'Name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    MOBILE: 'Mobile',
    CITY: 'City',
    BUSINESS_NAME: 'Business name',
    COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
    COUNTRY: 'Country',
    RATE: 'Rate',
    YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
    CODE_VERIFIED: 'Code verified',
    IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
    CODE_EXPIRES_IN: 'Code expires in',
    CODE: 'Code',
    VERIFY_CODE: 'Verify code',
    PLEASE_ENTER_EMAIL: 'Please enter email',
    RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
    SEND_VERIFICATION_CODE: 'Send verification code',
    LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully'
  },
  BLOG: {
    COMMENTS: 'Comments',
    REPLY: 'Reply',
    ADD_COMMENT: 'Add Comment',
    POST_COMMENT: 'Post comment'
  },
  BOOKING: {
    CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
    CANCELLATION_POLICY: 'Cancellation Policy',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
    YES_CANCEL: 'Yes, cancel',
    NO_KEEP: 'No, keep it'
  },
  COMMUNICATION: {
    ON_CALL_WITH: 'On call with',
    CONNECTING_WITH: 'Connecting with',
    INCOMING_CALL: 'Incoming Call',
    YOUR_CLIENT: 'Your client',
    TYPE_YOUR_MESSAGE: 'Type your message',
    MIN: 'min',
    CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.'
  },
  CREDIT_CARD: {
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder',
    EXPIRY_DATE: 'Expiry date',
    CVV: 'CVV',
    CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
    SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
    SAVE_PAYMENT_METHOD: 'Save payment method',
    X2_BONUS: 'x2 BONUS',
    YOU_WILL_GET: 'You will get',
    TELMIE_CREDIT: 'Telmie credit',
    IN_TOTAL: 'in total',
    CONFIRM_AND_PAY: 'Confirm & Pay',
    CANNOT_WITHDRAW: 'Cannot withdraw',
    FEE: 'fee',
    FREE: 'Free',
    YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
    AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
    AVALIABLE: 'Available',
    AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
    WITHDRAW: 'Withdraw',
    FREE_APPLIES: 'Fee applies: ',
    YOU_RECEIVE: 'You receive: ',
    WITHDRAWAL_RULES: 'Withdrawal rules',
    WITHDRAWAL_AMOUNT: 'Withdrawal amount',
    HIDE: 'Hide',
    SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules'
  },
  EDIT_PROFILE: {
    SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
    CANT_BE_CHANGED: 'Can\'t be changed',
    UPLOAD_PICTURE: 'Upload picture',
    NAME_ISNT_VALID: 'The name isn\'t valid.'
  },
  FEATURED_SERVICE: {
    CALL_NOW: 'Call now',
    CANCEL_CALL: 'Cancel call',
    NEXT_PRO: 'Next pro',
    NEXT_PRO_CAPS: 'NEXT PRO',
    THEN_CAPS: 'THEN'
  },
  HEADER: {
    HOW_IT_WORKS: 'So funktioniert es',
    FAQ: 'FAQ',
    CONTACT: 'Kontaktieren sie uns',
    MONEY: 'Money',
    SETTINGS: 'Settings',
    LOGIN: 'Log in',
    EDIT_PROFILE: 'Edit Profile',
    NEW_CHATS: 'New Chats',
    WELL_DONE: 'Well done',
    SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
    EDIT_PRO_DETAILS: 'Edit Pro details'
  },
  HOMEPAGE: {
    FEATURED_PROS: 'Featured Pros',
    FEATURED_SERVICES: 'Featured services',
    DOWNLOAD_TELMIE_APP: 'Download Telmie app'
  },
  LANGUAGE_PRACTICE: {
    HAPPY_PROS: 'Happy Pros',
    HAPPY_USERS: 'Happy Users'
  },
  LOG_IN: {
    LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
    NEW_TO_TELMIE: 'New to Telmie',
    DOWNLOAD_THE_APP: 'Download the app'
  },
  NEW_LANDING: {
    MINUTES: 'minutes',
    COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
    BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
    PLEASE_ENTER_SUBJECT: 'Please enter subject',
    PLEASE_ENTER_MESSAGE: 'Please enter message'
  },
  PRO: {
    PRO: 'Pro',
    AMOUNT: 'Amount',
    NO_RECENT_CALLS: 'No recent calls',
    MESSAGES: 'Messages',
    START_CALL: 'Start Call',
    SHORTLISTED: 'Shortlisted',
    REMOVE: 'Remove',
    SHORTLIST: 'Shortlist',
    LOADING: 'Loading',
    TELMIE_CLIENT: 'Telmie Client',
    ON_CALL: 'On call',
    RECONNECTING: 'Reconnecting...',
    TELMIE_USER_IS_CALLING: 'Telmie user is calling',
    SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
    HOURS_FIRST_LETTER: 'h',
    MINUTES_FIRST_LETTER: 'm',
    CALENDAR_TITLE: 'My availability',
    CALENDAR_SUB_TITLE: 'I am not available right now',
    CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
    AVAILABLE_NOW: 'Available now',
    AVAILABLE_LATTER: 'Available later',
    WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
    PRO_IS_BUSY: 'Pro is busy'
  },
  PROFILE: {
    VIEW_ALL: 'View all',
    CONTACT: 'Contact',
    COUNT: 'Count',
    NO_RECENT_ACTIVITY: 'No recent activity',
    YOUR_DETAILS: 'Your details',
    LOCATION: 'Location',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NO_RECENT_PROS: 'No recent PROS',
    WITHDRAW_EARNINGS: 'Withdraw earnings',
    TOP_UP: 'Top Up',
    ATTACH_CARD: 'Attach card',
    SERVICE: 'Service',
    APPOINTMENT_WITH: 'Appointment with',
    COST: 'Cost',
    BALANCE: 'Balance',
    NO_RECENT_TRANSACTIONS: 'No recent transactions',
    NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
    CLIENT: 'Client'
  },
  RADIO_BUTTONS: {
    APPROVED: 'Approved',
    SECTORS: 'SECTORS'
  },
  SEARCH: {
    FILTERS: 'Filters',
    SESSIONS: 'sessions',
    ARRANGE_BY: 'Arrange by',
    ENTER_KEYWORDS: 'Enter keywords',
    RESET_FILTERS: 'Clear all'
  },
  SELECT: {
    EVERY: 'Every'
  },
  SETTINGS: {
    IMPORTANT_VIA_EMAIL: 'Important via email',
    WORKING_AS_PRO: 'Working as Pro',
    PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
    ADD_NEW_PERIOD: 'Add new period',
    CHANGE_BANK_ACCOUNT: 'Change bank account',
    ADD_BANK_ACCOUNT: 'Add bank account',
    ENTITY: 'Entity',
    ADDRESS: 'Address',
    YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
    WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
    SORT_CODE: 'Sort code',
    DIGITS_VALUE: 'digits value',
    ACCOUNT_NUMBER: 'Account number',
    BAD_REQUEST_DATA: 'Bad Request data',
    PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
    CONFIRM: 'Confirm',
    UPLOAD_ANOTHER_IMAGE: 'Upload another image',
    UPLOAD: 'Upload',
    YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
    YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
    PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
    POST_CODE: 'Post Code',
    LOADING_CARDS: 'Loading cards',
    NO_CARDS: 'No cards.',
    COMPANY_ADDRESS: 'Company address',
    PERSONAL_ADDRESS: 'Personal address',
    SERVICE_NAME: 'Service name',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_SUB_CATEGORY: 'Service sub-category',
    SERVICE_DESCRIPTION: 'Service description',
    PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
    LOADING_ACCOUNTS: 'Loading accounts',
    ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
    PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
    THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
    DAYS_REQUIRED: 'Please select days',
    FROM: 'From',
    TO: 'To',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
    PROFILE_DETAILS: 'Profile details',
    PRO_SETTINGS: 'PRO SETTINGS',
    WORK_AS_PRO: 'Work as Pro',
    PRO_DETAILS: 'Pro details',
    PAYOUT_BANK_DETAILS: 'Payout bank details',
    PREVIEW_MY_PROFILE: 'Preview my profile',
    MY_AVAILABILITY: 'My availability',
    HIDE_PROFILE: 'Hide profile',
    GENERAL_SETTINGS: 'GENERAL SETTINGS',
    PAYMENT_SETTINGS: 'Payment settings',
    EMAIL_NOTIFICATION: 'Email notification',
    BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
    BANK_ACCOUNT: 'Bank account',
    ID_VERIFICATION: 'ID Verification',
    I_WANT_TO_TAKE_PART: 'I want to take part'
  },
  SIGN_UP: {
    CONFIRM_EMAIL: 'Now confirm your email address',
    RESEND: 'Resend',
    CONFIRM_EMAIL_MESSAGE: function CONFIRM_EMAIL_MESSAGE(email) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        'We\'ve sent an email to ',
        email,
        ', please check your inbox and click the link \'Activate\' to confirm and earn!'
      );
    },
    USE_ANOTHER_EMAIL: 'Use another email',
    SECTOR: 'Sector',
    CATEGORY: 'Category',
    PLEASE_SELECT_CATEGORY: 'Please select category',
    PROFESSION: 'Profession',
    DESCRIPTION: 'Description',
    FREE: 'Free',
    PER_MINUTE: 'per minute',
    BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
    TERMS_OF_USE: 'Terms of use',
    AND_THE: 'and the',
    PRIVACY_POLICY: 'Privacy Policy',
    THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
    CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
    ACCOUNT_TYPE: 'Account type',
    APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
    CANCEL_CHANGES: 'Cancel changes',
    PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
    ERROR: 'Error',
    PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
    UNITED_KINGDOM: 'United Kingdom',
    ONLY_UK_NOW: 'Only UK for now',
    I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
    ALREADY_HAVE_ACCOUNT: 'Already have an account',
    CODE_HAVE_BEEN_SENT: 'Code has been sent to',
    EDUCATION: {
      EDUCATION: 'Education',
      LANGUAGE_TUTOR: 'Language tutor',
      LANGUAGE_PRACTICE: 'Language practice',
      EXAMS_PREPARATION: 'Exams preparation',
      SCIENCE: 'Science',
      BUSINESS_STUDIES: 'Business studies',
      SOCIAL_SCIENCE: 'Social science',
      DRAWING: 'Drawing',
      MUSIC: 'Music',
      DANCE: 'Dance'
    },
    SERVICES: {
      SERVICES: 'Services',
      INTERPRETER: 'Interpreter',
      NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
      THERAPIST: 'Therapist',
      LISTENER: 'Listener',
      SPEECH_THERAPIST: 'Speech therapist',
      FORTUN_TELLER: 'Fortun teller',
      ASTROLOGIST: 'Astrologist',
      PERSONAL_ASSISTANT: 'Personal assistant',
      CAREER_COACH: 'Career coach'
    },
    CONSULTANCY: {
      CONSULTANCY: 'Consultancy',
      LEGAL: 'Legal',
      MEDICAL: 'Medical',
      BUSINESS: 'Business',
      FAMILY: 'Family',
      INVESTMENT: 'Investment',
      TECH_SUPPORT: 'Tech support',
      BEAUTICIAN: 'Beautician'
    },
    HEALTH_LIFESTYLE: {
      HEALTH_LIFESTYLE: 'Health&Lifestyle',
      PERSONAL_TRAINER: 'Personal trainer',
      YOGA_INSTRUCTOR: 'Yuga instructor',
      MEDITATION_INSTRUCTOR: 'Meditation instructor',
      DIETOLOGIST: 'Dietologist',
      SPORT_COACH: 'Sport coach',
      FITNESS_PROFESSIONAL: 'Fitness professional',
      SPIRITUAL_COACH: 'Spiritual coach'
    },
    PLEASE_SELECT_SECTOR: 'Please select sector',
    PLEASE_ENTER_PROFESSION: 'Please enter profession',
    PLEASE_ENTER_DESCRIPTION: 'Please enter description',
    PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
    PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
    YOU_ARE_UNDER_18: 'You are under 18',
    DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
    YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
    PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
    CITY_IN_THE_UK: 'City in the UK',
    CITY_INCORRECT: 'City incorrect',
    POSTCODE: 'Postcode',
    PLEASE_ENTER_POSTCODE: 'Please enter postcode',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    ONLY_UK_ADDRESS: 'Only UK address',
    ADDRESS_INCORRECT: 'Address incorrect',
    ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
    BIRTHDAY_INCORRECT: 'Birthday incorrect',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    WE_WONT_SHARE_IT: 'We won\'t share it with others.',
    MOBILE_INCORRECT: 'Mobile incorrect',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    EG_IO: 'e.g. i0ONOZLgCIM',
    SERVICE_INCORRECT: 'Service incorrect',
    SERVICE_LABEL: 'Service (20 characters)',
    IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
    SERVICE_NAME_INCORRECT: 'Service name incorrect',
    SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
    SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
    SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
    PRICE_PER_MINUTE: 'Price per minute',
    DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
    YES: 'Yes.',
    NO: 'No.',
    DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
    YES_SAVE: 'Yes, save.',
    DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
    ENTER_TAX_ID: 'Enter tax ID to check',
    CHECK: 'Check.',
    PLEASE_ENTER_PASSWORD: 'Please enter password',
    FIRST_NAME: 'First name'
  },
  SOCIAL_NETWORK: {
    CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
    CONTINUE_WITH_GOOGLE: 'Continue with Google'
  },
  ROUTES: {
    ERROR_404: 'Error 404',
    PAGE_NOT_FOUND: 'Page not found',
    THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
    GO_HOME: 'Go Home',
    FEATURED_SERVICE: 'FEATURED SERVICE',
    WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
    GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
    FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
    CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
    NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
    YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
    RESET: 'Reset',
    BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
    TELMIE_T_C: 'Telmie T&C',
    TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
    AND: 'and',
    STRIPE_T_C: 'Stripe T&C.',
    SORRY: 'Sorry',
    IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
    OR: 'or',
    IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
    BACK_TO_SETTINGS: 'Back to Settings',
    PROFILE_PREVIEW: 'Profile preview',
    PRO_DETAILS: 'Pro details',
    PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
    RESULTS_FOR: 'Results for',
    SORRY_NO_PROS: 'Sorry, no pros found for',
    SELECT_YOUR_INTEREST: 'Select your interest',
    TELMIE_MY_CLIENTS: 'Telmie | My Clients',
    FIND_YOUR_CLIENT: 'Find your Client',
    TELMIE_MY_PROS: 'Telmie | My Pros',
    FIND_YOUR_PRO: 'Find your Pro',
    PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
    TELMIE_PREVIEW: 'Telmie | Preview',
    LOWEST_RATE_FIRST: 'Lowest rate first',
    HIGHEST_RATE_FIRST: 'Highest rate first',
    EXPERIENCE: 'Experience',
    RATING: 'Rating',
    ACTIVITY: 'Activity',
    LANGUAGES: 'Languages',
    COACHING: 'Coaching',
    IMMIGRATION: 'Immigration',
    OTHER: 'Other',
    ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
    ERROR_WITH_STRIPE: 'Error with Stripe.',
    TELMIE_PRO: 'Telmie | Pro'
  },
  FOOTER: {
    HOME: 'Startseite',
    CONTACT: 'Kontaktieren sie uns',
    SUPPORT: 'Support',
    POLICY: 'Datenschutzerklärung',
    TERMS: 'Nutzungsbedingungen',
    FAQ: 'FAQ',
    COPYRIGHT: 'Copyright',
    COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom'

  },
  CONTACT_US: {
    title: 'Kontaktieren sie uns',
    subTitle: 'Haben Sie Fragen? Schicken Sie uns eine Nachricht.',
    name: 'Name',
    email: 'E-mail',
    company: 'Unternehmen',
    subject: 'Betreff',
    message: 'Nachricht eingeben',
    success: 'Vielen Dank für Ihre Anfrage.',
    submitBtn: 'Abschicken'
  },
  SERVICES: {
    LANGUAGE_PRACTICE: 'Sprachtraining',
    IMMIGRATION_CONSULTANT: 'Einwanderungsberater',
    IMMIGRATION_ADVICE: 'Einwanderungsberatung',
    LANGUAGE_LEARNERS: 'Sprachenlernen'
  },
  FAQ: 'FAQ',
  MORE_FAQ: 'Mehr FAQ',
  API: {
    NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content'
  },
  NOTIFICATIONS: {
    DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
    EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
    MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
    SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
    UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!'
  },
  REGISTER_PRO: {
    FIRST_NAME: 'First name',
    FIRST_NAME_ERROR: 'First name field is required',
    LAST_NAME: 'Last name',
    LAST_NAME_ERROR: 'Last name field is required',
    COUNTRY: 'Country',
    COUNTRY_PLACEHOLDER: 'Select country',
    COUNTRY_ERROR: 'Country field is required',
    CITY: 'City',
    POSTCODE: 'Postcode',
    POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
    DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
    DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    MOBILE_HINT: 'We won\'t share it with others.',
    MOBILE_ERROR: 'Must contain only numbers',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
    SERVICES: 'Services',
    SERVICES_PLACEHOLDER: 'Select service',
    SERVICES_ERROR: 'Services field is required',
    SERVICE: 'Service (20 characters)',
    SERVICE_HINT: 'i.e. English practice, Immigration advice',
    SERVICE_ERROR: 'Service name may not be greater than 20 characters',
    SECTOR: 'Sector',
    SECTOR_PLACEHOLDER: 'Select sector',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
    SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
    SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
    SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
    SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
    COST_PER_MINUTE_ERROR: 'Please enter price',
    COST_PER_MINUTE_MAX: 'Maximum allowed for this service'
  }
}, _langPack[__WEBPACK_IMPORTED_MODULE_1__consts__["k" /* FR */]] = {
  DOWNLOAD_APP_BTN: 'Télécharger l\'appli',
  HOMEPAGE_FAQ_TITLE: 'Questions les plus populaires',
  GENERAL_QUESTIONS: 'Questions Générales',
  CUSTOMERS_QUESTIONS: 'Clients',
  EXPERTS_QUESTIONS: 'Experts',
  PAYMENTS_QUESTIONS: 'Paiements',
  BLOG_TITLE: 'Blog',
  FULL_STORY_BTN: 'Histoire complète',
  OTHER_POSTS: 'Autres Posts',
  MISC: {
    DELETE: 'Delete',
    UPDATE_NOW: 'Update now',
    CONNECTING: 'Connecting',
    CONNECTING_TO_SERVER: 'Connecting to server',
    CALLING_PRO: 'Calling Pro',
    CREDIT_CARD: 'Credit card',
    ADD_A_CARD: 'Add a card',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    SAVE: 'Save',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
    PLEASE_ENTER_LAST_NAME: 'Please enter last name',
    YOU_WILL_PAY: 'You will pay',
    PER_MINUTE_FOR_CALL: 'per minute for this call',
    MINUTES_SHORT: 'min',
    BECOME_PRO: 'Devenir un pro',
    BLOG: 'Blog',
    FIND_A_PRO: 'Find a Pro',
    MY_CLIENTS: 'My Clients',
    MY_PROS: 'My Pros',
    MY_APPOINTMENTS: 'My Appointments',
    SIGN_UP: 'Sign Up',
    LOG_OUT: 'Log out',
    REGISTER_AS_PRO: 'Register as Pro',
    REGISTER: 'Register',
    LOG_IN: 'Log in',
    FORGOT_PASSWORD: 'Forgot password',
    PASSWORD: 'Password',
    DATE: 'Date',
    DATE_AND_TIME: 'Date and time',
    DURATION: 'Duration',
    TYPE: 'Type',
    EDIT: 'Edit',
    NAME: 'Name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    MOBILE: 'Mobile',
    CITY: 'City',
    BUSINESS_NAME: 'Business name',
    COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
    COUNTRY: 'Country',
    RATE: 'Rate',
    YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
    CODE_VERIFIED: 'Code verified',
    IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
    CODE_EXPIRES_IN: 'Code expires in',
    CODE: 'Code',
    VERIFY_CODE: 'Verify code',
    PLEASE_ENTER_EMAIL: 'Please enter email',
    RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
    SEND_VERIFICATION_CODE: 'Send verification code',
    LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully'
  },
  BLOG: {
    COMMENTS: 'Comments',
    REPLY: 'Reply',
    ADD_COMMENT: 'Add Comment',
    POST_COMMENT: 'Post comment'
  },
  BOOKING: {
    CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
    CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
    CANCELLATION_POLICY: 'Cancellation Policy',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
    YES_CANCEL: 'Yes, cancel',
    NO_KEEP: 'No, keep it'
  },
  COMMUNICATION: {
    ON_CALL_WITH: 'On call with',
    CONNECTING_WITH: 'Connecting with',
    INCOMING_CALL: 'Incoming Call',
    YOUR_CLIENT: 'Your client',
    TYPE_YOUR_MESSAGE: 'Type your message',
    MIN: 'min',
    CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.'
  },
  CREDIT_CARD: {
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder',
    EXPIRY_DATE: 'Expiry date',
    CVV: 'CVV',
    CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
    SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
    SAVE_PAYMENT_METHOD: 'Save payment method',
    X2_BONUS: 'x2 BONUS',
    YOU_WILL_GET: 'You will get',
    TELMIE_CREDIT: 'Telmie credit',
    IN_TOTAL: 'in total',
    CONFIRM_AND_PAY: 'Confirm & Pay',
    CANNOT_WITHDRAW: 'Cannot withdraw',
    FEE: 'fee',
    FREE: 'Free',
    YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
    AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
    AVALIABLE: 'Available',
    AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
    WITHDRAW: 'Withdraw',
    FREE_APPLIES: 'Fee applies: ',
    YOU_RECEIVE: 'You receive: ',
    WITHDRAWAL_RULES: 'Withdrawal rules',
    WITHDRAWAL_AMOUNT: 'Withdrawal amount',
    HIDE: 'Hide'
  },
  EDIT_PROFILE: {
    SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
    CANT_BE_CHANGED: 'Can\'t be changed',
    UPLOAD_PICTURE: 'Upload picture',
    NAME_ISNT_VALID: 'The name isn\'t valid.'
  },
  FEATURED_SERVICE: {
    CALL_NOW: 'Call now',
    CANCEL_CALL: 'Cancel call',
    NEXT_PRO: 'Next pro',
    NEXT_PRO_CAPS: 'NEXT PRO',
    THEN_CAPS: 'THEN'
  },
  HEADER: {
    HOW_IT_WORKS: 'Comment ça marche',
    FAQ: 'FAQ',
    CONTACT: 'Nous contacter',
    MONEY: 'Money',
    SETTINGS: 'Settings',
    LOGIN: 'Log in',
    EDIT_PROFILE: 'Edit Profile',
    NEW_CHATS: 'New Chats',
    WELL_DONE: 'Well done',
    SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
    EDIT_PRO_DETAILS: 'Edit Pro details'
  },
  HOMEPAGE: {
    FEATURED_PROS: 'Featured Pros',
    FEATURED_SERVICES: 'Featured services',
    DOWNLOAD_TELMIE_APP: 'Download Telmie app'
  },
  LANGUAGE_PRACTICE: {
    HAPPY_PROS: 'Happy Pros',
    HAPPY_USERS: 'Happy Users'
  },
  LOG_IN: {
    LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
    NEW_TO_TELMIE: 'New to Telmie',
    DOWNLOAD_THE_APP: 'Download the app'
  },
  NEW_LANDING: {
    MINUTES: 'minutes',
    COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
    BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
    PLEASE_ENTER_SUBJECT: 'Please enter subject',
    PLEASE_ENTER_MESSAGE: 'Please enter message'
  },
  PRO: {
    PRO: 'Pro',
    AMOUNT: 'Amount',
    NO_RECENT_CALLS: 'No recent calls',
    MESSAGES: 'Messages',
    START_CALL: 'Start Call',
    SHORTLISTED: 'Shortlisted',
    REMOVE: 'Remove',
    SHORTLIST: 'Shortlist',
    LOADING: 'Loading',
    TELMIE_CLIENT: 'Telmie Client',
    ON_CALL: 'On call',
    RECONNECTING: 'Reconnecting...',
    TELMIE_USER_IS_CALLING: 'Telmie user is calling',
    SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
    HOURS_FIRST_LETTER: 'h',
    MINUTES_FIRST_LETTER: 'm',
    CALENDAR_TITLE: 'My availability',
    CALENDAR_SUB_TITLE: 'I am not available right now',
    CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
    AVAILABLE_NOW: 'Available now',
    AVAILABLE_LATTER: 'Available later',
    WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
    PRO_IS_BUSY: 'Pro is busy'
  },
  PROFILE: {
    VIEW_ALL: 'View all',
    CONTACT: 'Contact',
    COUNT: 'Count',
    NO_RECENT_ACTIVITY: 'No recent activity',
    YOUR_DETAILS: 'Your details',
    LOCATION: 'Location',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NO_RECENT_PROS: 'No recent PROS',
    WITHDRAW_EARNINGS: 'Withdraw earnings',
    TOP_UP: 'Top Up',
    ATTACH_CARD: 'Attach card',
    SERVICE: 'Service',
    APPOINTMENT_WITH: 'Appointment with',
    COST: 'Cost',
    BALANCE: 'Balance',
    NO_RECENT_TRANSACTIONS: 'No recent transactions',
    NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
    CLIENT: 'Client'
  },
  RADIO_BUTTONS: {
    APPROVED: 'Approved',
    SECTORS: 'SECTORS'
  },
  SEARCH: {
    FILTERS: 'Filters',
    SESSIONS: 'sessions',
    ARRANGE_BY: 'Arrange by',
    ENTER_KEYWORDS: 'Enter keywords',
    RESET_FILTERS: 'Clear all'
  },
  SELECT: {
    EVERY: 'Every'
  },
  SETTINGS: {
    IMPORTANT_VIA_EMAIL: 'Important via email',
    WORKING_AS_PRO: 'Working as Pro',
    PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
    ADD_NEW_PERIOD: 'Add new period',
    CHANGE_BANK_ACCOUNT: 'Change bank account',
    ADD_BANK_ACCOUNT: 'Add bank account',
    ENTITY: 'Entity',
    ADDRESS: 'Address',
    YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
    WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
    SORT_CODE: 'Sort code',
    DIGITS_VALUE: 'digits value',
    ACCOUNT_NUMBER: 'Account number',
    BAD_REQUEST_DATA: 'Bad Request data',
    PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
    CONFIRM: 'Confirm',
    UPLOAD_ANOTHER_IMAGE: 'Upload another image',
    UPLOAD: 'Upload',
    YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
    YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
    PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
    POST_CODE: 'Post Code',
    LOADING_CARDS: 'Loading cards',
    NO_CARDS: 'No cards.',
    COMPANY_ADDRESS: 'Company address',
    PERSONAL_ADDRESS: 'Personal address',
    SERVICE_NAME: 'Service name',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_SUB_CATEGORY: 'Service sub-category',
    SERVICE_DESCRIPTION: 'Service description',
    PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
    LOADING_ACCOUNTS: 'Loading accounts',
    ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
    PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
    THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
    DAYS_REQUIRED: 'Please select days',
    FROM: 'From',
    TO: 'To',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
    PROFILE_DETAILS: 'Profile details',
    PRO_SETTINGS: 'PRO SETTINGS',
    WORK_AS_PRO: 'Work as Pro',
    PRO_DETAILS: 'Pro details',
    PAYOUT_BANK_DETAILS: 'Payout bank details',
    PREVIEW_MY_PROFILE: 'Preview my profile',
    MY_AVAILABILITY: 'My availability',
    HIDE_PROFILE: 'Hide profile',
    GENERAL_SETTINGS: 'GENERAL SETTINGS',
    PAYMENT_SETTINGS: 'Payment settings',
    EMAIL_NOTIFICATION: 'Email notification',
    BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
    BANK_ACCOUNT: 'Bank account',
    ID_VERIFICATION: 'ID Verification',
    I_WANT_TO_TAKE_PART: 'I want to take part'
  },
  SIGN_UP: {
    CONFIRM_EMAIL: 'Now confirm your email address',
    RESEND: 'Resend',
    CONFIRM_EMAIL_MESSAGE: function CONFIRM_EMAIL_MESSAGE(email) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        'We\'ve sent an email to ',
        email,
        ', please check your inbox and click the link \'Activate\' to confirm and earn!'
      );
    },
    USE_ANOTHER_EMAIL: 'Use another email',
    SECTOR: 'Sector',
    CATEGORY: 'Category',
    PLEASE_SELECT_CATEGORY: 'Please select category',
    PROFESSION: 'Profession',
    DESCRIPTION: 'Description',
    FREE: 'Free',
    PER_MINUTE: 'per minute',
    BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
    TERMS_OF_USE: 'Terms of use',
    AND_THE: 'and the',
    PRIVACY_POLICY: 'Privacy Policy',
    THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
    CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
    ACCOUNT_TYPE: 'Account type',
    APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
    CANCEL_CHANGES: 'Cancel changes',
    PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
    ERROR: 'Error',
    PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
    UNITED_KINGDOM: 'United Kingdom',
    ONLY_UK_NOW: 'Only UK for now',
    I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
    ALREADY_HAVE_ACCOUNT: 'Already have an account',
    CODE_HAVE_BEEN_SENT: 'Code has been sent to',
    EDUCATION: {
      EDUCATION: 'Education',
      LANGUAGE_TUTOR: 'Language tutor',
      LANGUAGE_PRACTICE: 'Language practice',
      EXAMS_PREPARATION: 'Exams preparation',
      SCIENCE: 'Science',
      BUSINESS_STUDIES: 'Business studies',
      SOCIAL_SCIENCE: 'Social science',
      DRAWING: 'Drawing',
      MUSIC: 'Music',
      DANCE: 'Dance'
    },
    SERVICES: {
      SERVICES: 'Services',
      INTERPRETER: 'Interpreter',
      NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
      THERAPIST: 'Therapist',
      LISTENER: 'Listener',
      SPEECH_THERAPIST: 'Speech therapist',
      FORTUN_TELLER: 'Fortun teller',
      ASTROLOGIST: 'Astrologist',
      PERSONAL_ASSISTANT: 'Personal assistant',
      CAREER_COACH: 'Career coach'
    },
    CONSULTANCY: {
      CONSULTANCY: 'Consultancy',
      LEGAL: 'Legal',
      MEDICAL: 'Medical',
      BUSINESS: 'Business',
      FAMILY: 'Family',
      INVESTMENT: 'Investment',
      TECH_SUPPORT: 'Tech support',
      BEAUTICIAN: 'Beautician'
    },
    HEALTH_LIFESTYLE: {
      HEALTH_LIFESTYLE: 'Health&Lifestyle',
      PERSONAL_TRAINER: 'Personal trainer',
      YOGA_INSTRUCTOR: 'Yuga instructor',
      MEDITATION_INSTRUCTOR: 'Meditation instructor',
      DIETOLOGIST: 'Dietologist',
      SPORT_COACH: 'Sport coach',
      FITNESS_PROFESSIONAL: 'Fitness professional',
      SPIRITUAL_COACH: 'Spiritual coach'
    },
    PLEASE_SELECT_SECTOR: 'Please select sector',
    PLEASE_ENTER_PROFESSION: 'Please enter profession',
    PLEASE_ENTER_DESCRIPTION: 'Please enter description',
    PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
    PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
    YOU_ARE_UNDER_18: 'You are under 18',
    DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
    YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
    PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
    CITY_IN_THE_UK: 'City in the UK',
    CITY_INCORRECT: 'City incorrect',
    POSTCODE: 'Postcode',
    PLEASE_ENTER_POSTCODE: 'Please enter postcode',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    ONLY_UK_ADDRESS: 'Only UK address',
    ADDRESS_INCORRECT: 'Address incorrect',
    ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
    BIRTHDAY_INCORRECT: 'Birthday incorrect',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    WE_WONT_SHARE_IT: 'We won\'t share it with others.',
    MOBILE_INCORRECT: 'Mobile incorrect',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    EG_IO: 'e.g. i0ONOZLgCIM',
    SERVICE_INCORRECT: 'Service incorrect',
    SERVICE_LABEL: 'Service (20 characters)',
    IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
    SERVICE_NAME_INCORRECT: 'Service name incorrect',
    SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
    SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
    SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
    PRICE_PER_MINUTE: 'Price per minute',
    DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
    YES: 'Yes.',
    NO: 'No.',
    DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
    YES_SAVE: 'Yes, save.',
    DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
    ENTER_TAX_ID: 'Enter tax ID to check',
    CHECK: 'Check.',
    PLEASE_ENTER_PASSWORD: 'Please enter password',
    FIRST_NAME: 'First name'
  },
  SOCIAL_NETWORK: {
    CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
    CONTINUE_WITH_GOOGLE: 'Continue with Google'
  },
  ROUTES: {
    ERROR_404: 'Error 404',
    PAGE_NOT_FOUND: 'Page not found',
    THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
    GO_HOME: 'Go Home',
    FEATURED_SERVICE: 'FEATURED SERVICE',
    WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
    GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
    FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
    CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
    NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
    YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
    RESET: 'Reset',
    BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
    TELMIE_T_C: 'Telmie T&C',
    TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
    AND: 'and',
    STRIPE_T_C: 'Stripe T&C.',
    SORRY: 'Sorry',
    IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
    OR: 'or',
    IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
    BACK_TO_SETTINGS: 'Back to Settings',
    PROFILE_PREVIEW: 'Profile preview',
    PRO_DETAILS: 'Pro details',
    PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
    RESULTS_FOR: 'Results for',
    SORRY_NO_PROS: 'Sorry, no pros found for',
    SELECT_YOUR_INTEREST: 'Select your interest',
    TELMIE_MY_CLIENTS: 'Telmie | My Clients',
    FIND_YOUR_CLIENT: 'Find your Client',
    TELMIE_MY_PROS: 'Telmie | My Pros',
    FIND_YOUR_PRO: 'Find your Pro',
    PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
    TELMIE_PREVIEW: 'Telmie | Preview',
    LOWEST_RATE_FIRST: 'Lowest rate first',
    HIGHEST_RATE_FIRST: 'Highest rate first',
    EXPERIENCE: 'Experience',
    RATING: 'Rating',
    ACTIVITY: 'Activity',
    LANGUAGES: 'Languages',
    COACHING: 'Coaching',
    IMMIGRATION: 'Immigration',
    OTHER: 'Other',
    ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
    ERROR_WITH_STRIPE: 'Error with Stripe.',
    TELMIE_PRO: 'Telmie | Pro'
  },
  FOOTER: {
    HOME: 'Accueil',
    CONTACT: 'Nous contacter',
    SUPPORT: 'Support',
    POLICY: 'Politique de Confidentialité',
    TERMS: 'Modalités',
    FAQ: 'FAQ',
    COPYRIGHT: 'Copyright',
    COPYRIGHT_TEXT: '© 2018-2022 / TELMIE UK LTD. / London, United Kingdom'
  },
  CONTACT_US: {
    title: 'Nous contacter',
    subTitle: 'Une question ? Écrivez-nous.',
    name: 'Nom',
    email: 'E-mail',
    company: 'Société',
    subject: 'Sujet',
    message: 'Saisissez votre message',
    success: 'Merci de nous avoir contacté',
    submitBtn: 'Soumettre'
  },
  SERVICES: {
    LANGUAGE_PRACTICE: 'Pratique d\'une langue',
    IMMIGRATION_CONSULTANT: 'Expert en Immigration',
    IMMIGRATION_ADVICE: 'Conseils en immigration',
    LANGUAGE_LEARNERS: 'Apprentissage de langue'
  },
  FAQ: 'FAQ',
  MORE_FAQ: 'Plus de FAQ',
  API: {
    NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content'
  },
  NOTIFICATIONS: {
    DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
    EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
    MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
    SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
    UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!'
  },
  REGISTER_PRO: {
    FIRST_NAME: 'First name',
    FIRST_NAME_ERROR: 'First name field is required',
    LAST_NAME: 'Last name',
    LAST_NAME_ERROR: 'Last name field is required',
    COUNTRY: 'Country',
    COUNTRY_PLACEHOLDER: 'Select country',
    COUNTRY_ERROR: 'Country field is required',
    CITY: 'City',
    POSTCODE: 'Postcode',
    POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
    DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
    DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
    PERSONAL_ADDRESS_LINE: 'Personal address line',
    MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
    MOBILE_HINT: 'We won\'t share it with others.',
    MOBILE_ERROR: 'Must contain only numbers',
    YOUTUBE_ID: 'YouTube ID (11 characters)',
    YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
    SERVICES: 'Services',
    SERVICES_PLACEHOLDER: 'Select service',
    SERVICES_ERROR: 'Services field is required',
    SERVICE: 'Service (20 characters)',
    SERVICE_HINT: 'i.e. English practice, Immigration advice',
    SERVICE_ERROR: 'Service name may not be greater than 20 characters',
    SECTOR: 'Sector',
    SECTOR_PLACEHOLDER: 'Select sector',
    SERVICE_CATEGORY: 'Service category',
    SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
    SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
    SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
    SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
    SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
    COST_PER_MINUTE_ERROR: 'Please enter price',
    COST_PER_MINUTE_MAX: 'Maximum allowed for this service'
  }
}, _langPack);

/***/ }),

/***/ "9km1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__("7qbT");

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('input', this.props, this.props.children);
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),

/***/ "9kxq":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("BxvP");
var document = __webpack_require__("i1Q6").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "9qb7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "9ueN":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function (srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac"), __webpack_require__("l262")(module)))

/***/ }),

/***/ "A3Hj":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("xC+t");
var enumBugKeys = __webpack_require__("lzt6");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

/***/ }),

/***/ "A4qf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__("VYL5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__("umce");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),

/***/ "AI6T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AVA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("dACh");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("jx4H");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("VOrx");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("ZKjc");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/dom-align/dist-web/index.js
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */

function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */

function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points; // 重置对应部分的翻转逻辑

      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }

      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }

      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* harmony default export */ var dist_web = (alignElement);

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../node_modules/rc-util/es/Dom/addEventListener.js
var addEventListener = __webpack_require__("v9LT");

// EXTERNAL MODULE: ../node_modules/rc-util/es/Dom/contains.js
var contains = __webpack_require__("asZT");

// CONCATENATED MODULE: ../node_modules/rc-align/es/util.js


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function util_isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(contains["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}
// CONCATENATED MODULE: ../node_modules/rc-align/es/Align.js












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align_Align = function (_Component) {
  inherits_default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = preact_compat_es["default"].findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = alignElement(source, element, align);
        } else if (point) {
          result = alignPoint(source, point, align);
        }

        restoreFocus(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = preact_compat_es["default"].findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (util_isWindow(lastElement) && util_isWindow(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !isSamePoint(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!isSimilarValue(preRect.width, sourceRect.width) || !isSimilarValue(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(addEventListener["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = preact_compat_es["default"].Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return preact_compat_es["default"].cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(preact_compat_es["Component"]);

Align_Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};

/* harmony default export */ var es_Align = (Align_Align);
// CONCATENATED MODULE: ../node_modules/rc-align/es/index.js
// export this package's api


/* harmony default export */ var es = __webpack_exports__["a"] = (es_Align);

/***/ }),

/***/ "Aa2f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var global = __webpack_require__("i1Q6");
var has = __webpack_require__("yS17");
var DESCRIPTORS = __webpack_require__("6MLN");
var $export = __webpack_require__("vSO4");
var redefine = __webpack_require__("gojl");
var META = __webpack_require__("e8vu").KEY;
var $fails = __webpack_require__("wLcK");
var shared = __webpack_require__("NB7d");
var setToStringTag = __webpack_require__("11Ut");
var uid = __webpack_require__("X6va");
var wks = __webpack_require__("Ug9I");
var wksExt = __webpack_require__("ZxII");
var wksDefine = __webpack_require__("c2zY");
var enumKeys = __webpack_require__("ycyv");
var isArray = __webpack_require__("ayXv");
var anObject = __webpack_require__("zotD");
var isObject = __webpack_require__("BxvP");
var toObject = __webpack_require__("mbLO");
var toIObject = __webpack_require__("Wyka");
var toPrimitive = __webpack_require__("EKwp");
var createDesc = __webpack_require__("0WCH");
var _create = __webpack_require__("TNJq");
var gOPNExt = __webpack_require__("rMkZ");
var $GOPD = __webpack_require__("sxPs");
var $GOPS = __webpack_require__("Ocr3");
var $DP = __webpack_require__("Gfzd");
var $keys = __webpack_require__("knrM");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("Ni5N").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("z7R8").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("1kq3")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () {
  $GOPS.f(1);
});

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }$replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("akPY")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),

/***/ "AkAO":
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "AkN1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("rtOw");
var isCallable = __webpack_require__("yeFe");
var create = __webpack_require__("jqpc");
var getPrototypeOf = __webpack_require__("BJWe");
var redefine = __webpack_require__("GZef");
var wellKnownSymbol = __webpack_require__("G69i");
var IS_PURE = __webpack_require__("oj7W");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

/***/ }),

/***/ "AoWs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkUserAndGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isCurrentUserRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setMessageHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearUserChat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return processServerMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return processChatMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return redactChatMessageBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return processCallMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCallRequestMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return encodeXMPPmessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPeerConnection; });
/* unused harmony export sendInCallOfferData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return sendAnswerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sendInCallAnswerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return onIceCandidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMediaConstraints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return trackStop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kurento_utils__ = __webpack_require__("zCZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kurento_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kurento_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__ = __webpack_require__("FFyX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("cxRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_session__ = __webpack_require__("69EM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_pros__ = __webpack_require__("iMz2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index__ = __webpack_require__("DHvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app__ = __webpack_require__("qLaj");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */






// eslint-disable-next-line import/no-cycle

// eslint-disable-next-line import/no-cycle


var __FILE__ = 'connection.js';

var users = {};

var REDACT_CHAT_MSG_BODY_REGEXP = /<body>[^<]+<\/body>/g;
var REDACT_CHAT_MSG_BODY_REPLACE_STRING = '...';

var checkUserAndGet = function checkUserAndGet(id, _userAuth) {
  return new Promise(function ($return, $error) {
    var usr;

    usr = void 0;
    if (users[id]) {
      usr = users[id];
      return $If_1.call(this);
    } else {
      return Promise.resolve(Object(__WEBPACK_IMPORTED_MODULE_5__api_pros__["f" /* getUserDetails */])(id, _userAuth)).then(function ($await_4) {
        try {
          usr = $await_4 || {};
          users[id] = usr;
          return $If_1.call(this);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    }

    function $If_1() {
      return $return(usr);
    }
  });
};

var isCurrentUserRoute = function isCurrentUserRoute(url, userId) {
  var currentUserId = url.split('/').pop().split('#')[0];
  return currentUserId === '' + userId;
};

var mergeIncomingMessageWithHistory = function mergeIncomingMessageWithHistory(history, incomingMsg) {
  var acc = {
    mergedHistory: [],
    incomingMsgWasInHistory: false
  };

  var checkedHistory = history.reduce(function (prev, current) {
    if (current.id === incomingMsg.id) {
      prev.mergedHistory.push(_extends({}, incomingMsg, current));
      prev.incomingMsgWasInHistory = true;
    } else {
      prev.mergedHistory.push(current);
    }

    return prev;
  }, acc);

  return checkedHistory.incomingMsgWasInHistory ? checkedHistory.mergedHistory : [].concat(history, [incomingMsg]);
};

var setMessages = function setMessages(id, msg, isMy, prevState) {
  var _extends2;

  var _id = id.split('/')[0];
  var currentChat = prevState.chats[_id];
  var chat = currentChat ? currentChat.chat ? mergeIncomingMessageWithHistory(currentChat.chat, _extends({}, msg, { isMy: isMy })) : [_extends({}, msg, { isMy: isMy })] : [_extends({}, msg, { isMy: isMy })];
  chat.sort(function (a, b) {
    return a.timestamp - b.timestamp;
  });
  return {
    chats: _extends({}, prevState.chats, (_extends2 = {}, _extends2[_id] = {
      chat: chat,
      isDisplayed: isMy,
      mesId: isMy ? '' : msg.id,
      thread: isMy ? '' : msg.thread,
      lastMessage: isMy ? msg.id : chat.lastMessage
    }, _extends2))
  };
};

var mergeMessageHistory = function mergeMessageHistory(storedHistory, receivedHistory) {
  var receivedMessageIds = receivedHistory.reduce(function (acc, current) {
    acc.add(current.id);
    return acc;
  }, new Set());

  return [].concat(storedHistory.filter(function (msg) {
    return !receivedMessageIds.has(msg.id);
  }), receivedHistory).sort(function (a, b) {
    return a.timestamp - b.timestamp;
  });
};

var setMessageHistory = function setMessageHistory(id, msgArr, count, prevState) {
  var _extends3;

  var _id = id.split('/')[0];
  var chat = prevState.chats[_id] ? prevState.chats[_id].chat ? mergeMessageHistory(prevState.chats[_id].chat, msgArr) : [].concat(msgArr) : [].concat(msgArr);
  return {
    chats: _extends({}, prevState.chats, (_extends3 = {}, _extends3[_id] = {
      chat: chat,
      isDisplayed: true,
      lastMessage: msgArr[msgArr.length - 1].id
    }, _extends3)),
    received: count
  };
};
var setUser = function setUser(user, prevState) {
  var _extends4;

  return {
    users: _extends({}, prevState.users, (_extends4 = {}, _extends4[user.id] = _extends({}, user), _extends4))
  };
};
var clearUserChat = function clearUserChat(userId, prevState) {
  var userJID = Object(__WEBPACK_IMPORTED_MODULE_6__index__["d" /* generateJID */])(userId, true);
  var chats = _extends({}, prevState.chats);
  delete chats[userJID];
  return { chats: _extends({}, chats), received: -1 };
};

var processServerMsg = function processServerMsg(msg) {
  var __METHOD__ = 'con-helpers::processServerMsg';

  var outerMessageRecipient = msg.getAttribute('to');
  var from = msg.getAttribute('from');
  var outerMessageType = msg.getAttribute('type');
  var isChatMessage = !!(outerMessageType && outerMessageType.toLowerCase() === 'chat');
  var isCarbonCopy = outerMessageRecipient.indexOf(from) === 0;

  var message = isChatMessage && isCarbonCopy ? msg.getElementsByTagName('message')[0] : msg;
  if (!message) {
    var msgContents = msg.tree && typeof msg.tree === 'function' ? msg.tree().outerHTML : '<unavailable>';
    var errMsg = 'Received an XMPP message that looks like a carbon copy but does not contain an inner message: ' + msgContents;

    __WEBPACK_IMPORTED_MODULE_3__logger__["l" /* logXMPPReceive */](__FILE__, __METHOD__, errMsg, __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Error, msg);
    throw new Error(errMsg);
  }

  var to = isChatMessage && isCarbonCopy ? message.getAttribute('to') : outerMessageRecipient;
  var type = message.getAttribute('type');
  var timestamp = message.getAttribute('timestamp');
  var id = message.getAttribute('id');
  var inCall = message.getAttribute('inCall');
  var elems = message.getElementsByTagName('body');
  var thread = message.getElementsByTagName('thread');
  var vcxepElems = message.getElementsByTagName('vcxep');
  return {
    to: to, from: from, type: type, id: id, elems: elems, thread: thread, vcxepElems: vcxepElems, inCall: inCall, timestamp: timestamp, isMe: isCarbonCopy
  };
};

var processChatMsg = function processChatMsg(from, _userId, _userAuth, changeUnreadNum, message, createNotification, audio, calleeId, isMe) {
  return new Promise(function ($return, $error) {
    var _from$split, fromId, _usr;

    _from$split = from.split('@'), fromId = _from$split[0];


    // Show notification
    if (!document.hasFocus() && !isMe) {
      createNotification('New message from ' + message.senderName, message.text, 10000, function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_preact_router__["route"])(__WEBPACK_IMPORTED_MODULE_7__components_app__["routes"].USER_FOR_COMP + fromId + '#chat');
      });
    }
    _usr = { id: fromId };
    if (!isMe && '' + calleeId !== '' + fromId) {
      // get user info for unread messages
      if (users[fromId]) {
        _usr = users[fromId];
        return $If_3.call(this);
      } else {
        return Promise.resolve(Object(__WEBPACK_IMPORTED_MODULE_5__api_pros__["f" /* getUserDetails */])(fromId, _userAuth)).then(function ($await_5) {
          try {
            _usr = $await_5 || {};
            users[fromId] = _usr;
            return $If_3.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }

      function $If_3() {
        return $If_2.call(this);
      }
    }

    function $If_2() {
      if (!isMe) {
        if (audio) {
          audio.play();
          Object(__WEBPACK_IMPORTED_MODULE_4__media_session__["d" /* safeSetMediaPlaybackState */])('none');
        }
      }
      return $return(_usr);
    }

    return $If_2.call(this);
  });
};

var redactChatMessageBody = function redactChatMessageBody(message) {
  var type = message.getAttribute('type');
  var elems = message.getElementsByTagName('body');
  var stanzaType = message.localName.toLowerCase();

  if (stanzaType === 'message' && (type === 'chat' || type === 'error') && elems.length > 0) {
    return message.outerHTML.replace(REDACT_CHAT_MSG_BODY_REGEXP, REDACT_CHAT_MSG_BODY_REPLACE_STRING);
  }

  return message.outerHTML;
};

var processCallMsg = function processCallMsg(body) {
  var type = body.getAttribute('type');
  var callId = body.getAttribute('callid');
  var avtime = body.getAttribute('avtime');
  var bodyInner = body.innerHTML;
  return {
    type: type, callId: callId, avtime: avtime, bodyInner: bodyInner
  };
};

var isCallRequestMsg = function isCallRequestMsg(stanza) {
  if (!stanza.tree || typeof stanza.tree !== 'function') {
    return [false, null];
  }

  var msg = stanza.tree();

  if (msg.getAttribute('type') !== 'vcxep') {
    return [false, null];
  }

  var vcxepElems = msg.getElementsByTagName('vcxep');
  if (!(vcxepElems instanceof HTMLCollection) || vcxepElems.length === 0) {
    return [false, null];
  }

  var body = vcxepElems[0];
  if (body.getAttribute('type') === 'request') {
    return [true, body.getAttribute('callid')];
  }

  return [false, null];
};

var encodeXMPPmessage = function encodeXMPPmessage(msg) {
  var text = msg.replace(/&quot;/g, '"');
  text = text.replace(/&amp;/g, '&');
  text = text.replace(/&apos;/g, "'");
  var message = JSON.parse(text);
  return message;
};

var connectAudioStreamToAudioPlayback = function connectAudioStreamToAudioPlayback(options, playableAudioStream) {
  var __METHOD__ = 'con-helpers::connectAudioStreamToAudioPlayback';

  if (options.remoteAudio) {
    if (options.remoteAudio.srcObject && options.remoteAudio.srcObject === playableAudioStream) {
      __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming audio stream is now live but appears to have already been connected to audio playback. So, nothing to do');
      return;
    }

    __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming audio stream is now live - connecting to audio playback');

    options.remoteAudio.srcObject = playableAudioStream;
    options.remoteAudio.load();
    options.remoteAudio.play().catch(function (e) {
      Object(__WEBPACK_IMPORTED_MODULE_4__media_session__["d" /* safeSetMediaPlaybackState */])('none');

      __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to play the incoming audio stream. An error occurred: ' + (e.name || 'unknown error') + ' with message \'' + e.message + '\'', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Warning);
    });
    Object(__WEBPACK_IMPORTED_MODULE_4__media_session__["d" /* safeSetMediaPlaybackState */])('none');
  } else {
    __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming audio stream appeared but no HTML audio element available to connect the stream to', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Warning);
  }
};

var connectVideoStreamToVideoPlayback = function connectVideoStreamToVideoPlayback(options, playableVideoStream) {
  var __METHOD__ = 'con-helpers::connectVideoStreamToVideoPlayback';

  if (!(playableVideoStream instanceof MediaStream)) {
    __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'The supplied stream is not a valid MediaStream', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Error, playableVideoStream);
    return;
  }

  if (options.remoteVideo) {
    if (options.remoteVideo.srcObject && options.remoteVideo.srcObject === playableVideoStream) {
      __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming video stream is now live but appears to have already been connected to video playback. So, nothing to do');
      return;
    }

    __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming video stream is now live - connecting to video playback');

    if (options.remoteVideo.srcObject) {
      options.remoteVideo.pause();
    }
    options.remoteVideo.srcObject = playableVideoStream;
    options.remoteVideo.muted = true;
    options.remoteVideo.volume = 0;
    options.remoteVideo.load();
    options.remoteVideo.play().catch(function (e) {
      if (e instanceof DOMException && e.name === 'AbortError') {
        __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'A new incoming video stream replaced an existing video stream', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Warning);
      } else {
        __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to play the incoming video stream. An error occurred: ' + (e.name || 'unknown error') + ' with message \'' + e.message + '\'', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Warning);
      }
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming video stream appeared but no HTML video element available to connect the stream to', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Warning);
  }
};

// eslint-disable-next-line no-unused-vars
var createPeerConnection = function createPeerConnection(from, to) {
  var msgGenSend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cInfo = arguments[4];
  var callback = arguments[5];
  var canPlayAudioTrack = arguments[6];
  var shallMuteOutgoingAudio = arguments[7];
  var canPlayIncomingVideo = arguments[8];

  var __METHOD__ = 'con-helpers::createPeerConnection';

  var webRtcPeer = void 0;

  var peerConnectionCreatedCallback = function peerConnectionCreatedCallback(err) {
    var __CALLBACK_METHOD__ = 'createPeerConnection::peerConnectionCreatedCallback';
    var __CALLBACK_METHOD_ON_TRACK__ = 'createPeerConnection::peerConnectionCreatedCallback::ontrackCallback';
    var __CALLBACK_METHOD_ON_ADD_TRACK__ = 'createPeerConnection::peerConnectionCreatedCallback::ontrack::onaddtrackCallback';
    var __CALLBACK_METHOD_ON_REMOVE_TRACK__ = 'createPeerConnection::peerConnectionCreatedCallback::ontrack::onremovetrackCallback';
    var __CALLBACK_METHOD_ON_MUTE__ = 'createPeerConnection::peerConnectionCreatedCallback::onmuteCallback';
    var __CALLBACK_METHOD_ON_UNMUTE__ = 'createPeerConnection::peerConnectionCreatedCallback::onunmuteCallback';

    if (err) {
      __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD__, 'Failed to create a peer connection', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Warning, err); // & setCallState(NO_CALL);

      callback && callback(err);

      return;
    }

    webRtcPeer.peerConnection.ontrack = function (_ref) {
      var transceiver = _ref.transceiver,
          streams = _ref.streams,
          track = _ref.track;

      __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_TRACK__, 'A track has been added to peer connection. Tranceiver mid: ' + transceiver.mid + ', id: ' + track.id + ', kind: ' + track.kind + ', muted: ' + track.muted + ', enabled: ' + track.enabled);

      var stream = [streams];

      if (stream) {
        stream.onaddtrack = function () {
          __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_ADD_TRACK__, 'New track has been added to the stream', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Info, stream);
        };
        stream.onremovetrack = function () {
          __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_REMOVE_TRACK__, 'A track has been removed from the stream', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Info, stream);
        };
      }
      transceiver.receiver.track.onmute = function () {
        __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_MUTE__, 'A track of kind \'' + transceiver.receiver.track.kind + '\' labeled \'' + transceiver.receiver.track.label + '\' has stopped sending data');
      };
      transceiver.receiver.track.onunmute = function () {
        __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_UNMUTE__, 'A track of kind \'' + transceiver.receiver.track.kind + '\' labeled \'' + transceiver.receiver.track.label + '\' has started sending data');

        if (transceiver.receiver.track.kind === 'video') {
          if (canPlayIncomingVideo && typeof canPlayIncomingVideo === 'function') {
            if (canPlayIncomingVideo()) {
              var playableVideoStream = streams.find(function (trackStream) {
                return trackStream.getVideoTracks().length && trackStream.active;
              });

              if (playableVideoStream) {
                connectVideoStreamToVideoPlayback(options, playableVideoStream);
              }
            }
          }
        } else if (transceiver.receiver.track.kind === 'audio') {
          if (canPlayAudioTrack && typeof canPlayAudioTrack === 'function') {
            if (canPlayAudioTrack(to)) {
              var playableAudioStream = streams.find(function (trackStream) {
                return !trackStream.getVideoTracks().length && trackStream.active;
              });

              if (playableAudioStream) {
                connectAudioStreamToAudioPlayback(options, playableAudioStream);
              }
            }
          }
        }
      };
    };
    if (shallMuteOutgoingAudio && typeof shallMuteOutgoingAudio === 'function' && shallMuteOutgoingAudio()) {
      webRtcPeer.peerConnection.getSenders().forEach(function (element) {
        element.track && element.track.kind === 'audio' && (element.track.enabled = false);
      });
    }
  };

  __WEBPACK_IMPORTED_MODULE_3__logger__["j" /* logWithTag */](__FILE__, __METHOD__, __WEBPACK_IMPORTED_MODULE_3__logger__["e" /* TAG_WEBRTC */], 'Creating a peer connection with media constraints: ', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Info, options.mediaConstraints);

  webRtcPeer = __WEBPACK_IMPORTED_MODULE_1_kurento_utils___default.a.WebRtcPeer.WebRtcPeerSendrecv(options, peerConnectionCreatedCallback);
  return webRtcPeer;
};

var sendInCallOfferData = function sendInCallOfferData(from, to, webRtcPeer) {
  var msgGenSend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var cInfo = arguments[4];

  var __METHOD__ = 'sendInCallOfferData';

  __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Send incall offer data at ' + new Date().toISOString());

  webRtcPeer.generateOffer(function (err, offerSdp) {
    err && console.log(err); // & setCallState(NO_CALL);
    !err && msgGenSend(from, to, 'vcxep', 'vcxep', { type: 'offerData', callid: cInfo.callId }, offerSdp, true);
  });
  return webRtcPeer;
};

var sendAnswerData = function sendAnswerData(from, to, sdpOffer) {
  var msgGenSend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var cInfo = arguments[5];
  var callback = arguments[6];
  var canPlayAudioTrack = arguments[7];
  var shallMuteOutgoingAudio = arguments[8];
  var canPlayIncomingVideo = arguments[9];

  var __METHOD__ = 'sendAnswerData';

  var webRtcPeer = void 0;

  var onPeerConnectionCreated = function onPeerConnectionCreated(err) {
    var __CALLBACK_METHOD__ = 'sendAnswerData::onPeerConnectionCreated';
    var __CALLBACK_METHOD_ON_TRACK__ = 'sendAnswerData::onPeerConnectionCreated::ontrackCallback';
    var __CALLBACK_METHOD_ON_ADD_TRACK__ = 'sendAnswerData::onPeerConnectionCreated::ontrack::onaddtrackCallback';
    var __CALLBACK_METHOD_ON_REMOVE_TRACK__ = 'sendAnswerData::onPeerConnectionCreated::ontrack::onremovetrackCallback';
    var __CALLBACK_METHOD_ON_MUTE__ = 'sendAnswerData::onPeerConnectionCreated::onmuteCallback';
    var __CALLBACK_METHOD_ON_UNMUTE__ = 'sendAnswerData::onPeerConnectionCreated::onunmuteCallback';
    var __CALLBACK_METHOD_PROCESS_OFFER__ = 'sendAnswerData::onPeerConnectionCreated::processOfferCallback';

    if (err) {
      __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD__, 'Failed to create a peer connection', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Error, err); // & setCallState(NO_CALL);

      callback(err);

      return;
    }

    webRtcPeer.peerConnection.ontrack = function (_ref2) {
      var transceiver = _ref2.transceiver,
          streams = _ref2.streams,
          track = _ref2.track;

      __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_TRACK__, 'A track has been added to peer connection. Tranceiver mid: ' + transceiver.mid + ', id: ' + track.id + ', kind: ' + track.kind + ', muted: ' + track.muted + ', enabled: ' + track.enabled);

      var stream = streams[0];


      if (stream) {
        stream.onaddtrack = function () {
          __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_ADD_TRACK__, 'New track has been added to the stream', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Info, stream);
        };
        stream.onremovetrack = function () {
          __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_REMOVE_TRACK__, 'A track has been removed from the stream', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Info, stream);
        };
      }
      transceiver.receiver.track.onmute = function () {
        __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_MUTE__, 'A track of kind \'' + transceiver.receiver.track.kind + '\' labeled \'' + transceiver.receiver.track.label + '\' has stopped sending data');
      };
      transceiver.receiver.track.onunmute = function () {
        __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_UNMUTE__, 'A track of kind \'' + transceiver.receiver.track.kind + '\' labeled \'' + transceiver.receiver.track.label + '\' has started sending data');

        if (transceiver.receiver.track.kind === 'video') {
          if (canPlayIncomingVideo && typeof canPlayIncomingVideo === 'function') {
            if (canPlayIncomingVideo()) {
              var playableVideoStream = streams.find(function (trackStream) {
                return trackStream.getVideoTracks().length && trackStream.active;
              });

              if (playableVideoStream) {
                connectVideoStreamToVideoPlayback(options, playableVideoStream);
              }
            }
          }
        } else if (transceiver.receiver.track.kind === 'audio') {
          if (canPlayAudioTrack && typeof canPlayAudioTrack === 'function') {
            if (canPlayAudioTrack()) {
              var playableAudioStream = streams.find(function (trackStream) {
                return !trackStream.getVideoTracks().length && trackStream.active;
              });

              if (playableAudioStream) {
                connectAudioStreamToAudioPlayback(options, playableAudioStream);
              }
            }
          }
        }
      };
    };

    webRtcPeer.processOffer(sdpOffer, function (offerProcessingErr, sdpAnswer) {
      if (!offerProcessingErr) {
        msgGenSend(from, to, 'vcxep', 'vcxep', { type: 'answerData', callid: cInfo.callId }, sdpAnswer, true);
        if (shallMuteOutgoingAudio && typeof shallMuteOutgoingAudio === 'function' && shallMuteOutgoingAudio()) {
          webRtcPeer.peerConnection.getSenders().forEach(function (element) {
            element.track && element.track.kind === 'audio' && (element.track.enabled = false);
          });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_PROCESS_OFFER__, 'Failed to process the SDP offer', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Error, offerProcessingErr);
      }

      callback();
    });
  };

  __WEBPACK_IMPORTED_MODULE_3__logger__["j" /* logWithTag */](__FILE__, __METHOD__, __WEBPACK_IMPORTED_MODULE_3__logger__["e" /* TAG_WEBRTC */], 'Creating a peer connection with media constraints: ', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Info, options.mediaConstraints);

  webRtcPeer = __WEBPACK_IMPORTED_MODULE_1_kurento_utils___default.a.WebRtcPeer.WebRtcPeerSendrecv(options, onPeerConnectionCreated);
  return webRtcPeer;
};

var sendInCallAnswerData = function sendInCallAnswerData(from, to, webRtcPeer, sdpOffer) {
  var msgGenSend = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var cInfo = arguments[5];
  var callback = arguments[6];

  var __METHOD__ = 'sendInCallAnswerData';
  var __CALLBACK_METHOD_PROCESS_OFFER__ = 'sendInCallAnswerData::processOfferCallback';

  __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'Send incall answer data at ' + new Date().toISOString() + ' for the received SDP offer', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Info, sdpOffer);

  webRtcPeer.processOffer(sdpOffer, function (err, sdpAnswer) {
    err && __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_PROCESS_OFFER__, 'Failed to process the SDP offer', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Error, err); // & setCallState(NO_CALL);
    !err && msgGenSend(from, to, 'vcxep', 'vcxep', { type: 'answerData', callid: cInfo.callId }, sdpAnswer, true);

    if (!err && callback && typeof callback === 'function') {
      callback(webRtcPeer);
    }
  });
  return webRtcPeer;
};

var onIceCandidate = function onIceCandidate(from, to, callId) {
  var msgGenSend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  return function (candidate) {
    return candidateData(from, to, callId, candidate, msgGenSend);
  };
};
function candidateData(from, to, callId, candidate, msgGenSend) {
  var __METHOD__ = 'candidateData';

  var data = {
    sdp: candidate.candidate,
    sdpMid: candidate.sdpMid,
    sdpMLineIndex: candidate.sdpMLineIndex
  };
  __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'sending a local ICE candidate', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Info, data);

  msgGenSend(from, to, 'vcxep', 'vcxep', { type: 'candidateData', callid: callId }, JSON.stringify([data]), true);
}

// export const videoCapture = (isDisabled, msgGenSend = () => {}, props) => {
//   const { callInfo = {} } = props.comModal;
//   const address = prepareFromTo(props);
//   const type = isDisabled ? 'dis_video' : 'en_video';
//   msgGenSend(address, 'vcxep', 'vcxep', { type, callid: callInfo.callId });
// };

var getMediaConstraints = function getMediaConstraints() {
  return navigator.mediaDevices.enumerateDevices().then(function (deviceInfos) {
    // const audio = deviceInfos.some((d) => d.kind === 'audioinput');
    var __METHOD__ = 'con-helpers::getMediaConstraints';

    var inputDevices = deviceInfos.filter(function (d) {
      return d.kind === 'audioinput';
    });

    __WEBPACK_IMPORTED_MODULE_3__logger__["j" /* logWithTag */](__FILE__, __METHOD__, __WEBPACK_IMPORTED_MODULE_3__logger__["e" /* TAG_WEBRTC */], 'Detected audio devices: ', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Debug, inputDevices, true);

    if (inputDevices && inputDevices.length > 0) {
      var preferredDeviceId = inputDevices.reduce(function (prevValue, currentValue, currentIndex, devicesArray) {
        if ((!prevValue || prevValue !== 'communications') && currentValue.deviceId === 'communications') {
          // Default communications device found - override any previuosly detected preferred devices.
          return currentValue.deviceId;
        }

        if (!prevValue && currentValue.deviceId === 'default') {
          // Default audio input device found - assume it as the preferred device so far.
          return currentValue.deviceId;
        }

        if (!prevValue && currentIndex === devicesArray.length - 1) {
          // We've iterated over all the available device and did not find a preferred one -
          // use the first available as a sensible default.
          return devicesArray[0].deviceId;
        }

        return prevValue;
      }, null);

      __WEBPACK_IMPORTED_MODULE_3__logger__["j" /* logWithTag */](__FILE__, __METHOD__, __WEBPACK_IMPORTED_MODULE_3__logger__["e" /* TAG_WEBRTC */], 'Requesting an audio input device with ID: ' + preferredDeviceId, __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Info, undefined, false);

      if (preferredDeviceId !== '') {
        return {
          audio: {
            echoCancellation: true,
            deviceId: preferredDeviceId
          },
          video: false
        };
      }

      return {
        audio: {
          echoCancellation: true
        },
        video: false
      };
    }

    __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __METHOD__, 'No audio input devices found; calls functionality will not be available until an audio input device is plugged', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Warning, undefined);

    return { audio: false, video: false };
  }).catch(function (err) {
    var __CALLBACK_METHOD_ENUMERATE_DEVICES__ = 'getMediaConstraints::enumerateDevicesCallback';

    __WEBPACK_IMPORTED_MODULE_3__logger__["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ENUMERATE_DEVICES__, 'Failed to enumarate media devices', __WEBPACK_IMPORTED_MODULE_2__bugfender_sdk__["LogLevel"].Error, err);
    return { audio: true, video: false };
  });
};

var trackStop = function trackStop(track) {
  track.enabled = false;
  track.stop();
};

/***/ }),

/***/ "Aq8W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("dXs8"), __esModule: true };

/***/ }),

/***/ "AsRs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__("mYpx");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = getMuiTheme;

var _lodash = __webpack_require__("9ueN");

var _lodash2 = _interopRequireDefault(_lodash);

var _colorManipulator = __webpack_require__("NySk");

var _lightBaseTheme = __webpack_require__("O4VS");

var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);

var _zIndex = __webpack_require__("3Lw+");

var _zIndex2 = _interopRequireDefault(_zIndex);

var _autoprefixer = __webpack_require__("JBx7");

var _autoprefixer2 = _interopRequireDefault(_autoprefixer);

var _callOnce = __webpack_require__("+qlq");

var _callOnce2 = _interopRequireDefault(_callOnce);

var _rtl = __webpack_require__("znAs");

var _rtl2 = _interopRequireDefault(_rtl);

var _compose = __webpack_require__("tfSr");

var _compose2 = _interopRequireDefault(_compose);

var _typography = __webpack_require__("/zpV");

var _typography2 = _interopRequireDefault(_typography);

var _colors = __webpack_require__("e1OT");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Get the MUI theme corresponding to a base theme.
 * It's possible to override the computed theme values
 * by providing a second argument. The calculated
 * theme will be deeply merged with the second argument.
 */
function getMuiTheme(muiTheme) {
  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  muiTheme = _lodash2.default.apply(undefined, [{
    zIndex: _zIndex2.default,
    isRtl: false,
    userAgent: undefined
  }, _lightBaseTheme2.default, muiTheme].concat(more));

  var _muiTheme = muiTheme,
      spacing = _muiTheme.spacing,
      fontFamily = _muiTheme.fontFamily,
      palette = _muiTheme.palette;

  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };

  muiTheme = (0, _lodash2.default)({
    appBar: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      height: spacing.desktopKeylineIncrement,
      titleFontWeight: _typography2.default.fontWeightNormal,
      padding: spacing.desktopGutter
    },
    avatar: {
      color: palette.canvasColor,
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
    },
    badge: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      fontWeight: _typography2.default.fontWeightMedium
    },
    bottomNavigation: {
      backgroundColor: palette.canvasColor,
      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      selectedColor: palette.primary1Color,
      height: 56,
      unselectedFontSize: 12,
      selectedFontSize: 14
    },
    button: {
      height: 36,
      minWidth: 88,
      iconButtonSize: spacing.iconSize * 2
    },
    card: {
      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    cardMedia: {
      color: _colors.darkWhite,
      overlayContentBackground: _colors.lightBlack,
      titleColor: _colors.darkWhite,
      subtitleColor: _colors.lightWhite
    },
    cardText: {
      textColor: palette.textColor
    },
    checkbox: {
      boxColor: palette.textColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    chip: {
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      fontSize: 14,
      fontWeight: _typography2.default.fontWeightNormal,
      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
    },
    datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: palette.canvasColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color
    },
    dialog: {
      titleFontSize: 22,
      bodyFontSize: 16,
      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
    },
    dropDownMenu: {
      accentColor: palette.borderColor
    },
    enhancedButton: {
      tapHighlightColor: _colors.transparent
    },
    flatButton: {
      color: _colors.transparent,
      buttonFilterColor: '#999999',
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      textColor: palette.textColor,
      primaryTextColor: palette.primary1Color,
      secondaryTextColor: palette.accent1Color,
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    floatingActionButton: {
      buttonSize: 56,
      miniSize: 40,
      color: palette.primary1Color,
      iconColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryIconColor: palette.alternateTextColor,
      disabledTextColor: palette.disabledColor,
      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
    },
    gridTile: {
      textColor: _colors.white
    },
    icon: {
      color: palette.canvasColor,
      backgroundColor: palette.primary1Color
    },
    inkBar: {
      backgroundColor: palette.accent1Color
    },
    drawer: {
      width: spacing.desktopKeylineIncrement * 4,
      color: palette.canvasColor
    },
    listItem: {
      nestedLevelDepth: 18,
      secondaryTextColor: palette.secondaryTextColor,
      leftIconColor: _colors.grey600,
      rightIconColor: _colors.grey600
    },
    menu: {
      backgroundColor: palette.canvasColor,
      containerBackgroundColor: palette.canvasColor
    },
    menuItem: {
      dataHeight: 32,
      height: 48,
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
      padding: spacing.desktopGutter,
      selectedTextColor: palette.accent1Color,
      rightIconDesktopFill: _colors.grey600
    },
    menuSubheader: {
      padding: spacing.desktopGutter,
      borderColor: palette.borderColor,
      textColor: palette.primary1Color
    },
    overlay: {
      backgroundColor: _colors.lightBlack
    },
    paper: {
      color: palette.textColor,
      backgroundColor: palette.canvasColor,
      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
      })
    },
    radioButton: {
      borderColor: palette.textColor,
      backgroundColor: palette.alternateTextColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      size: 24,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    refreshIndicator: {
      strokeColor: palette.borderColor,
      loadingStrokeColor: palette.primary1Color
    },
    ripple: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
    },
    slider: {
      trackSize: 2,
      trackColor: palette.primary3Color,
      trackColorSelected: palette.accent3Color,
      handleSize: 12,
      handleSizeDisabled: 8,
      handleSizeActive: 18,
      handleColorZero: palette.primary3Color,
      handleFillColor: palette.alternateTextColor,
      selectionColor: palette.primary1Color,
      rippleColor: palette.primary1Color
    },
    snackbar: {
      textColor: palette.alternateTextColor,
      backgroundColor: palette.textColor,
      actionColor: palette.accent1Color
    },
    subheader: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    stepper: {
      backgroundColor: 'transparent',
      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
      iconColor: palette.primary1Color,
      hoveredIconColor: _colors.grey700,
      inactiveIconColor: _colors.grey500,
      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
      connectorLineColor: _colors.grey400
    },
    svgIcon: {
      color: palette.textColor
    },
    table: {
      backgroundColor: palette.canvasColor
    },
    tableFooter: {
      borderColor: palette.borderColor,
      textColor: palette.accent3Color
    },
    tableHeader: {
      borderColor: palette.borderColor
    },
    tableHeaderColumn: {
      textColor: palette.accent3Color,
      height: 56,
      spacing: 24
    },
    tableRow: {
      hoverColor: palette.accent2Color,
      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
      selectedColor: palette.borderColor,
      textColor: palette.textColor,
      borderColor: palette.borderColor,
      height: 48
    },
    tableRowColumn: {
      height: 48,
      spacing: 24
    },
    tabs: {
      backgroundColor: palette.primary1Color,
      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
      selectedTextColor: palette.alternateTextColor
    },
    textField: {
      textColor: palette.textColor,
      hintColor: palette.disabledColor,
      floatingLabelColor: palette.disabledColor,
      disabledTextColor: palette.disabledColor,
      errorColor: _colors.red500,
      focusColor: palette.primary1Color,
      backgroundColor: 'transparent',
      borderColor: palette.borderColor
    },
    timePicker: {
      color: palette.alternateTextColor,
      textColor: palette.alternateTextColor,
      accentColor: palette.primary1Color,
      clockColor: palette.textColor,
      clockCircleColor: palette.clockCircleColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor
    },
    toggle: {
      thumbOnColor: palette.primary1Color,
      thumbOffColor: palette.accent2Color,
      thumbDisabledColor: palette.borderColor,
      thumbRequiredColor: palette.primary1Color,
      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
      trackOffColor: palette.primary3Color,
      trackDisabledColor: palette.primary3Color,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor,
      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
    },
    toolbar: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
      height: 56,
      titleFontSize: 20,
      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
    },
    tooltip: {
      color: _colors.white,
      rippleBackgroundColor: _colors.grey700,
      opacity: 0.9
    }
  }, muiTheme, {
    baseTheme: baseTheme, // To provide backward compatibility.
    rawTheme: baseTheme // To provide backward compatibility.
  });

  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
    return t(muiTheme);
  }).filter(function (t) {
    return t;
  });

  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));

  return muiTheme;
}

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "Ayp7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("VuZO");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),

/***/ "B6/o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(that, args.concat(slice.call(arguments)));
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

/***/ }),

/***/ "B9Lq":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("yS17");
var toIObject = __webpack_require__("Wyka");
var arrayIndexOf = __webpack_require__("LNnS")(false);
var IE_PROTO = __webpack_require__("/wuY")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "BJWe":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var hasOwn = __webpack_require__("J3pj");
var isCallable = __webpack_require__("yeFe");
var toObject = __webpack_require__("Nvz5");
var sharedKey = __webpack_require__("2+7m");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("ZfyC");

var IE_PROTO = sharedKey('IE_PROTO');
var Object = global.Object;
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }return object instanceof Object ? ObjectPrototype : null;
};

/***/ }),

/***/ "BLQp":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * @license
 *
 * Push v1.0.9
 * =========
 * A compact, cross-browser solution for the JavaScript Notifications API
 *
 * Credits
 * -------
 * Tsvetan Tsvetkov (ttsvetko)
 * Alex Gibson (alexgibson)
 *
 * License
 * -------
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015-2017 Tyler Nickerson
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
!function (i, t) {
   true ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (i = i || self).Push = t();
}(this, function () {
  "use strict";
  var i = { errors: { incompatible: "".concat("PushError:", " Push.js is incompatible with browser."), invalid_plugin: "".concat("PushError:", " plugin class missing from plugin manifest (invalid plugin). Please check the documentation."), invalid_title: "".concat("PushError:", " title of notification must be a string"), permission_denied: "".concat("PushError:", " permission request declined"), sw_notification_error: "".concat("PushError:", " could not show a ServiceWorker notification due to the following reason: "), sw_registration_error: "".concat("PushError:", " could not register the ServiceWorker due to the following reason: "), unknown_interface: "".concat("PushError:", " unable to create notification: unknown interface") } };function t(i) {
    return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (i) {
      return typeof i;
    } : function (i) {
      return i && "function" == typeof Symbol && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
    })(i);
  }function n(i, t) {
    if (!(i instanceof t)) throw new TypeError("Cannot call a class as a function");
  }function e(i, t) {
    for (var n = 0; n < t.length; n++) {
      var e = t[n];e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(i, e.key, e);
    }
  }function o(i, t, n) {
    return t && e(i.prototype, t), n && e(i, n), i;
  }function r(i, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");i.prototype = Object.create(t && t.prototype, { constructor: { value: i, writable: !0, configurable: !0 } }), t && c(i, t);
  }function s(i) {
    return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (i) {
      return i.__proto__ || Object.getPrototypeOf(i);
    })(i);
  }function c(i, t) {
    return (c = Object.setPrototypeOf || function (i, t) {
      return i.__proto__ = t, i;
    })(i, t);
  }function a(i, t) {
    return !t || "object" != typeof t && "function" != typeof t ? function (i) {
      if (void 0 === i) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return i;
    }(i) : t;
  }var u = function () {
    function i(t) {
      n(this, i), this._win = t, this.GRANTED = "granted", this.DEFAULT = "default", this.DENIED = "denied", this._permissions = [this.GRANTED, this.DEFAULT, this.DENIED];
    }return o(i, [{ key: "request", value: function value(i, t) {
        return arguments.length > 0 ? this._requestWithCallback.apply(this, arguments) : this._requestAsPromise();
      } }, { key: "_requestWithCallback", value: function value(i, t) {
        var n,
            e = this,
            o = this.get(),
            r = !1,
            s = function s() {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e._win.Notification.permission;r || (r = !0, void 0 === n && e._win.webkitNotifications && (n = e._win.webkitNotifications.checkPermission()), n === e.GRANTED || 0 === n ? i && i() : t && t());
        };o !== this.DEFAULT ? s(o) : this._win.webkitNotifications && this._win.webkitNotifications.checkPermission ? this._win.webkitNotifications.requestPermission(s) : this._win.Notification && this._win.Notification.requestPermission ? (n = this._win.Notification.requestPermission(s)) && n.then && n.then(s).catch(function () {
          t && t();
        }) : i && i();
      } }, { key: "_requestAsPromise", value: function value() {
        var i = this,
            t = this.get(),
            n = t !== this.DEFAULT,
            e = this._win.Notification && this._win.Notification.requestPermission,
            o = this._win.webkitNotifications && this._win.webkitNotifications.checkPermission;return new Promise(function (r, s) {
          var c,
              a = !1,
              u = function u(t) {
            a || (a = !0, !function (t) {
              return t === i.GRANTED || 0 === t;
            }(t) ? s() : r());
          };n ? u(t) : o ? i._win.webkitNotifications.requestPermission(function (i) {
            u(i);
          }) : e ? (c = i._win.Notification.requestPermission(u)) && c.then && c.then(u).catch(s) : r();
        });
      } }, { key: "has", value: function value() {
        return this.get() === this.GRANTED;
      } }, { key: "get", value: function value() {
        return this._win.Notification && this._win.Notification.permission ? this._win.Notification.permission : this._win.webkitNotifications && this._win.webkitNotifications.checkPermission ? this._permissions[this._win.webkitNotifications.checkPermission()] : navigator.mozNotification ? this.GRANTED : this._win.external && this._win.external.msIsSiteMode ? this._win.external.msIsSiteMode() ? this.GRANTED : this.DEFAULT : this.GRANTED;
      } }]), i;
  }(),
      f = function () {
    function i() {
      n(this, i);
    }return o(i, null, [{ key: "isUndefined", value: function value(i) {
        return void 0 === i;
      } }, { key: "isNull", value: function value(i) {
        return null === obj;
      } }, { key: "isString", value: function value(i) {
        return "string" == typeof i;
      } }, { key: "isFunction", value: function value(i) {
        return i && "[object Function]" === {}.toString.call(i);
      } }, { key: "isObject", value: function value(i) {
        return "object" === t(i);
      } }, { key: "objectMerge", value: function value(i, t) {
        for (var n in t) {
          i.hasOwnProperty(n) && this.isObject(i[n]) && this.isObject(t[n]) ? this.objectMerge(i[n], t[n]) : i[n] = t[n];
        }
      } }]), i;
  }(),
      l = function i(t) {
    n(this, i), this._win = t;
  },
      h = function (i) {
    function t() {
      return n(this, t), a(this, s(t).apply(this, arguments));
    }return r(t, l), o(t, [{ key: "isSupported", value: function value() {
        return void 0 !== this._win.Notification;
      } }, { key: "create", value: function value(i, t) {
        return new this._win.Notification(i, { icon: f.isString(t.icon) || f.isUndefined(t.icon) || f.isNull(t.icon) ? t.icon : t.icon.x32, body: t.body, tag: t.tag, requireInteraction: t.requireInteraction });
      } }, { key: "close", value: function value(i) {
        i.close();
      } }]), t;
  }(),
      _ = function (t) {
    function e() {
      return n(this, e), a(this, s(e).apply(this, arguments));
    }return r(e, l), o(e, [{ key: "isSupported", value: function value() {
        return void 0 !== this._win.navigator && void 0 !== this._win.navigator.serviceWorker;
      } }, { key: "getFunctionBody", value: function value(i) {
        var t = i.toString().match(/function[^{]+{([\s\S]*)}$/);return null != t && t.length > 1 ? t[1] : null;
      } }, { key: "create", value: function value(t, n, e, o, r) {
        var s = this;this._win.navigator.serviceWorker.register(o), this._win.navigator.serviceWorker.ready.then(function (o) {
          var c = { id: t, link: e.link, origin: document.location.href, onClick: f.isFunction(e.onClick) ? s.getFunctionBody(e.onClick) : "", onClose: f.isFunction(e.onClose) ? s.getFunctionBody(e.onClose) : "" };void 0 !== e.data && null !== e.data && (c = _extends(c, e.data)), o.showNotification(n, { icon: e.icon, body: e.body, vibrate: e.vibrate, tag: e.tag, data: c, requireInteraction: e.requireInteraction, silent: e.silent }).then(function () {
            o.getNotifications().then(function (i) {
              o.active.postMessage(""), r(i);
            });
          }).catch(function (t) {
            throw new Error(i.errors.sw_notification_error + t.message);
          });
        }).catch(function (t) {
          throw new Error(i.errors.sw_registration_error + t.message);
        });
      } }, { key: "close", value: function value() {} }]), e;
  }(),
      v = function (i) {
    function t() {
      return n(this, t), a(this, s(t).apply(this, arguments));
    }return r(t, l), o(t, [{ key: "isSupported", value: function value() {
        return void 0 !== this._win.navigator.mozNotification;
      } }, { key: "create", value: function value(i, t) {
        var n = this._win.navigator.mozNotification.createNotification(i, t.body, t.icon);return n.show(), n;
      } }]), t;
  }(),
      d = function (i) {
    function t() {
      return n(this, t), a(this, s(t).apply(this, arguments));
    }return r(t, l), o(t, [{ key: "isSupported", value: function value() {
        return void 0 !== this._win.external && void 0 !== this._win.external.msIsSiteMode;
      } }, { key: "create", value: function value(i, t) {
        return this._win.external.msSiteModeClearIconOverlay(), this._win.external.msSiteModeSetIconOverlay(f.isString(t.icon) || f.isUndefined(t.icon) ? t.icon : t.icon.x16, i), this._win.external.msSiteModeActivate(), null;
      } }, { key: "close", value: function value() {
        this._win.external.msSiteModeClearIconOverlay();
      } }]), t;
  }(),
      w = function (i) {
    function t() {
      return n(this, t), a(this, s(t).apply(this, arguments));
    }return r(t, l), o(t, [{ key: "isSupported", value: function value() {
        return void 0 !== this._win.webkitNotifications;
      } }, { key: "create", value: function value(i, t) {
        var n = this._win.webkitNotifications.createNotification(t.icon, i, t.body);return n.show(), n;
      } }, { key: "close", value: function value(i) {
        i.cancel();
      } }]), t;
  }();return new (function () {
    function t(i) {
      n(this, t), this._currentId = 0, this._notifications = {}, this._win = i, this.Permission = new u(i), this._agents = { desktop: new h(i), chrome: new _(i), firefox: new v(i), ms: new d(i), webkit: new w(i) }, this._configuration = { serviceWorker: "/serviceWorker.min.js", fallback: function fallback(i) {} };
    }return o(t, [{ key: "_closeNotification", value: function value(t) {
        var n = !0,
            e = this._notifications[t];if (void 0 !== e) {
          if (n = this._removeNotification(t), this._agents.desktop.isSupported()) this._agents.desktop.close(e);else if (this._agents.webkit.isSupported()) this._agents.webkit.close(e);else {
            if (!this._agents.ms.isSupported()) throw n = !1, new Error(i.errors.unknown_interface);this._agents.ms.close();
          }return n;
        }return !1;
      } }, { key: "_addNotification", value: function value(i) {
        var t = this._currentId;return this._notifications[t] = i, this._currentId++, t;
      } }, { key: "_removeNotification", value: function value(i) {
        var t = !1;return this._notifications.hasOwnProperty(i) && (delete this._notifications[i], t = !0), t;
      } }, { key: "_prepareNotification", value: function value(i, t) {
        var n,
            e = this;return n = { get: function get() {
            return e._notifications[i];
          }, close: function close() {
            e._closeNotification(i);
          } }, t.timeout && setTimeout(function () {
          n.close();
        }, t.timeout), n;
      } }, { key: "_serviceWorkerCallback", value: function value(i, t, n) {
        var e = this,
            o = this._addNotification(i[i.length - 1]);navigator && navigator.serviceWorker && (navigator.serviceWorker.addEventListener("message", function (i) {
          var t = JSON.parse(i.data);"close" === t.action && Number.isInteger(t.id) && e._removeNotification(t.id);
        }), n(this._prepareNotification(o, t))), n(null);
      } }, { key: "_createCallback", value: function value(i, t, n) {
        var e,
            o = this,
            r = null;if (t = t || {}, e = function e(i) {
          o._removeNotification(i), f.isFunction(t.onClose) && t.onClose.call(o, r);
        }, this._agents.desktop.isSupported()) try {
          r = this._agents.desktop.create(i, t);
        } catch (e) {
          var s = this._currentId,
              c = this.config().serviceWorker;this._agents.chrome.isSupported() && this._agents.chrome.create(s, i, t, c, function (i) {
            return o._serviceWorkerCallback(i, t, n);
          });
        } else this._agents.webkit.isSupported() ? r = this._agents.webkit.create(i, t) : this._agents.firefox.isSupported() ? this._agents.firefox.create(i, t) : this._agents.ms.isSupported() ? r = this._agents.ms.create(i, t) : (t.title = i, this.config().fallback(t));if (null !== r) {
          var a = this._addNotification(r),
              u = this._prepareNotification(a, t);f.isFunction(t.onShow) && r.addEventListener("show", t.onShow), f.isFunction(t.onError) && r.addEventListener("error", t.onError), f.isFunction(t.onClick) && r.addEventListener("click", t.onClick), r.addEventListener("close", function () {
            e(a);
          }), r.addEventListener("cancel", function () {
            e(a);
          }), n(u);
        }n(null);
      } }, { key: "create", value: function value(t, n) {
        var e,
            o = this;if (!f.isString(t)) throw new Error(i.errors.invalid_title);return e = this.Permission.has() ? function (i, e) {
          try {
            o._createCallback(t, n, i);
          } catch (i) {
            e(i);
          }
        } : function (e, r) {
          o.Permission.request().then(function () {
            o._createCallback(t, n, e);
          }).catch(function () {
            r(i.errors.permission_denied);
          });
        }, new Promise(e);
      } }, { key: "count", value: function value() {
        var i,
            t = 0;for (i in this._notifications) {
          this._notifications.hasOwnProperty(i) && t++;
        }return t;
      } }, { key: "close", value: function value(i) {
        var t;for (t in this._notifications) {
          if (this._notifications.hasOwnProperty(t) && this._notifications[t].tag === i) return this._closeNotification(t);
        }
      } }, { key: "clear", value: function value() {
        var i,
            t = !0;for (i in this._notifications) {
          this._notifications.hasOwnProperty(i) && (t = t && this._closeNotification(i));
        }return t;
      } }, { key: "supported", value: function value() {
        var i = !1;for (var t in this._agents) {
          this._agents.hasOwnProperty(t) && (i = i || this._agents[t].isSupported());
        }return i;
      } }, { key: "config", value: function value(i) {
        return (void 0 !== i || null !== i && f.isObject(i)) && f.objectMerge(this._configuration, i), this._configuration;
      } }, { key: "extend", value: function value(t) {
        var n,
            e = {}.hasOwnProperty;if (!e.call(t, "plugin")) throw new Error(i.errors.invalid_plugin);for (var o in e.call(t, "config") && f.isObject(t.config) && null !== t.config && this.config(t.config), n = new (0, t.plugin)(this.config())) {
          e.call(n, o) && f.isFunction(n[o]) && (this[o] = n[o]);
        }
      } }]), t;
  }())("undefined" != typeof window ? window : global);
});
//# sourceMappingURL=push.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "BX4+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("ky2m"), __esModule: true };

/***/ }),

/***/ "BtHH":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("mbLO");
var $getPrototypeOf = __webpack_require__("HHE0");

__webpack_require__("cOHw")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),

/***/ "BxvP":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "C4qV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return (/** @class */function () {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function get() {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * @param {*} key
             * @returns {*}
             */
            class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
             * @param {*} key
             * @param {*} value
             * @returns {void}
             */
            class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) {
                    this.__entries__[index][1] = value;
                } else {
                    this.__entries__.push([key, value]);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) {
                    entries.splice(index, 1);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
             * @returns {void}
             */
            class_1.prototype.clear = function () {
                this.__entries__.splice(0);
            };
            /**
             * @param {Function} callback
             * @param {*} [ctx=null]
             * @returns {void}
             */
            class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) {
                    ctx = null;
                }
                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }()
    );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName,
            propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth,
        clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();

var ResizeObserverEntry = /** @class */function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}();

var ResizeObserverSPI = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
}();

/* harmony default export */ __webpack_exports__["a"] = (index);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "COf8":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("OYXR");
var global = __webpack_require__("i1Q6");
var hide = __webpack_require__("akPY");
var Iterators = __webpack_require__("dhak");
var TO_STRING_TAG = __webpack_require__("Ug9I")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),

/***/ "CQH0":
/***/ (function(module, exports) {

(function (self) {

  if (self.fetch) {
    return;
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && function () {
      try {
        new Blob();
        return true;
      } catch (e) {
        return false;
      }
    }(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  if (support.arrayBuffer) {
    var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

    var isDataView = function isDataView(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj);
    };

    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function next() {
        var value = items.shift();
        return { done: value === undefined, value: value };
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function (name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ',' + value : value;
  };

  Headers.prototype['delete'] = function (name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items = [];
    this.forEach(function (value) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'));
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function (resolve, reject) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('');
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function (body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        throw new Error('unsupported BodyInit type');
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      this.arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    this.text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      this.formData = function () {
        return this.text().then(decode);
      };
    }

    this.json = function () {
      return this.text().then(JSON.parse);
    };

    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read');
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'omit';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function (bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
    return form;
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    });
  };

  Response.error = function () {
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    return new Response(null, { status: status, headers: { location: url } });
  };

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.fetch = function (input, init) {
    return new Promise(function (resolve, reject) {
      var request = new Request(input, init);
      var xhr = new XMLHttpRequest();

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  };
  self.fetch.polyfill = true;
})(typeof self !== 'undefined' ? self : this);

/***/ }),

/***/ "CQhq":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var toAbsoluteIndex = __webpack_require__("Rk1v");
var lengthOfArrayLike = __webpack_require__("SYGT");
var createProperty = __webpack_require__("hp6J");

var Array = global.Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) {
    createProperty(result, n, O[k]);
  }result.length = n;
  return result;
};

/***/ }),

/***/ "CWTV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"subHeader":"subHeader__1WTvT","subHeaderFlexed":"subHeaderFlexed__2h0D9"};

/***/ }),

/***/ "CZEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(15).then((function (require) {
				cb( __webpack_require__("vTma") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "CtKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__("u9EY");


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);

/***/ }),

/***/ "D1wH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("SNRl");
var IS_PURE = __webpack_require__("oj7W");
var NativePromise = __webpack_require__("qLzV");
var fails = __webpack_require__("rtOw");
var getBuiltIn = __webpack_require__("qvVx");
var isCallable = __webpack_require__("yeFe");
var speciesConstructor = __webpack_require__("wT1l");
var promiseResolve = __webpack_require__("Y5Pa");
var redefine = __webpack_require__("GZef");

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function then() {/* empty */} }, function () {/* empty */});
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromise)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromise.prototype['finally'] !== method) {
    redefine(NativePromise.prototype, 'finally', method, { unsafe: true });
  }
}

/***/ }),

/***/ "D38D":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("9UzH");
var isSymbol = __webpack_require__("trvQ");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

/***/ }),

/***/ "DHvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/date-fns/esm/format/index.js + 2 modules
var format = __webpack_require__("OZJZ");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/differenceInHours/index.js
var differenceInHours = __webpack_require__("ZVcj");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/differenceInMinutes/index.js
var differenceInMinutes = __webpack_require__("oGJj");

// EXTERNAL MODULE: ../node_modules/uuid/v4.js
var v4 = __webpack_require__("hYHi");
var v4_default = /*#__PURE__*/__webpack_require__.n(v4);

// EXTERNAL MODULE: ../node_modules/react-easy-emoji/index.js
var react_easy_emoji = __webpack_require__("IyTP");
var react_easy_emoji_default = /*#__PURE__*/__webpack_require__.n(react_easy_emoji);

// CONCATENATED MODULE: ./utils/ascii-helper.js
var isAscii = function isAscii(string) {
  return Array.from(string).every(function (char) {
    return char.codePointAt(0) < 256;
  });
};

var toBinary = function toBinary(string) {
  var codeUnits = new Uint16Array(string.length);
  for (var i = 0; i < codeUnits.length; i += 1) {
    codeUnits[i] = string.charCodeAt(i);
  }
  return String.fromCharCode.apply(String, new Uint8Array(codeUnits.buffer));
};
// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// EXTERNAL MODULE: ./components/app.js + 53 modules
var components_app = __webpack_require__("qLaj");

// CONCATENATED MODULE: ./utils/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utils_generateJID; });
/* unused harmony export generateProfessionsArray */
/* harmony export (immutable) */ __webpack_exports__["c"] = checkIfLoggedIn;
/* unused harmony export convertDate */
/* unused harmony export isSafari */
/* unused harmony export mobileDevice */
/* unused harmony export convertTime */
/* unused harmony export convertTimeSafari */
/* unused harmony export changeDateISOFormat */
/* unused harmony export convertDuration */
/* harmony export (immutable) */ __webpack_exports__["p"] = setEmphasizedText;
/* unused harmony export getCookie */
/* unused harmony export bytesToSize */
/* harmony export (immutable) */ __webpack_exports__["o"] = secToMS;
/* harmony export (immutable) */ __webpack_exports__["l"] = getTotalPrice;
/* unused harmony export getIntervalStep */
/* harmony export (immutable) */ __webpack_exports__["m"] = queryToParams;
/* harmony export (immutable) */ __webpack_exports__["a"] = addIfNotExists;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utils_getEncodedCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return utils_getMobileAppLink; });
/* harmony export (immutable) */ __webpack_exports__["n"] = resolveAuthorisedEntryPoint;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return utils_getFormattedLastVisit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getMBytesFromBytes; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getFormattedDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = cancelEventBubbling;
/* harmony export (immutable) */ __webpack_exports__["h"] = getFormattedTime;
/* harmony export (immutable) */ __webpack_exports__["k"] = getTimezoneName;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/** @jsx h */









// eslint-disable-next-line import/no-cycle


var XMPP_DOMAIN = "telmie.com";

var TIME_FORMAT = Intl.DateTimeFormat(undefined, {
  hour: 'numeric',
  minute: 'numeric',
  timeZoneName: 'short'
});
var TIME_FORMAT_OPTIONS = TIME_FORMAT.resolvedOptions();
var TIME_SHOULD_USE_AM_PM = Boolean(TIME_FORMAT_OPTIONS.hour12);
var SHORT_TIME_ZONE = function () {
  var timeZonePart = TIME_FORMAT.formatToParts(Date.now()).find(function (part) {
    return part.type === 'timeZoneName';
  });
  return timeZonePart ? timeZonePart.value : TIME_FORMAT_OPTIONS.timeZone;
}();

var utils_generateJID = function generateJID(id, isMain, uuid) {
  var deviceId = localStorage.getItem('uuid');
  if (!deviceId) {
    deviceId = v4_default()();
    localStorage.setItem('uuid', deviceId);
  }
  return isMain ? id + '@' + XMPP_DOMAIN : id + '@' + XMPP_DOMAIN + '/' + deviceId + '_' + uuid;
};

function generateProfessionsArray(professions) {
  var Services = [];

  professions.forEach(function (profession) {
    var Service = {
      name: profession.professions[0].text,
      categories: profession.professions[1].text.split(',')
    };
    Services.push(Service);
  });
  return Services;
}

function checkIfLoggedIn() {
  return !!localStorage && localStorage.getItem(consts["z" /* USER_AUTH */]);
}

function convertDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var oldDate = new Date(date.split('.')[0]);

  return (oldDate.getMonth() + 1).toString().padStart(2, '0') + '/' + oldDate.getDate().toString().padStart(2, '0') + '/' + oldDate.getFullYear() + ' ' + oldDate.getHours().toString().padStart(2, '0') + ':' + oldDate.getMinutes().toString().padStart(2, '0');
}

var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
var mobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);

var convertTime = function convertTime(date) {
  var d = typeof date === 'string' || date instanceof String ? new Date(Date.parse(date)) : new Date(date);
  // eslint-disable-next-line no-restricted-globals
  return isNaN(d.getTime()) || !date ? '-' : d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
};

var convertTimeSafari = function convertTimeSafari(date) {
  var b = date.split(/\D/);
  var d = new Date(Date.UTC(b[0], b[1] - 1, b[2], b[3], b[4], b[5]));
  return Number.isNaN(d.getTime()) || !date ? '-' : d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
};

function changeDateISOFormat(date) {
  var d = new Date(date);
  return d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');
}

function convertDuration(totalSeconds) {
  var minutes = parseInt((totalSeconds / 60).toString(), 10);
  var seconds = totalSeconds - minutes * 60;

  if (minutes.toString().length === 1) minutes = '0' + minutes;
  if (seconds.toString().length === 1) seconds = '0' + seconds;

  return minutes + ':' + seconds;
}

function setEmphasizedText(content, elClass) {
  var emphasizedPosition = content.title.indexOf(content.emphasized);
  var emphasizedLen = content.emphasized.length;

  return emphasizedPosition + 1 ? Object(preact_min["h"])(
    'h1',
    { className: elClass },
    react_easy_emoji_default()(content.title.substring(0, emphasizedPosition)),
    Object(preact_min["h"])(
      'span',
      null,
      react_easy_emoji_default()(content.emphasized)
    ),
    react_easy_emoji_default()(content.title.substring(emphasizedPosition + emphasizedLen))
  ) : Object(preact_min["h"])(
    'h1',
    { className: elClass },
    react_easy_emoji_default()(content.title)
  );
}

var getCookie = function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i += 1) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
};

function bytesToSize(bytes) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';

  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);

  return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
}

function secToMS() {
  var sec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var s = sec % 60;
  var m = (sec - s) / 60;

  return { m: m.toString().padStart(2, '0'), s: s.toString().padStart(2, '0') };
}
function getTotalPrice(timeObj, cpm) {
  return timeObj.s > 0 ? cpm * timeObj.m + cpm : cpm * timeObj.m;
}

function getIntervalStep(val) {
  if (val <= 1) {
    return 0.01;
  }

  if (val <= 2) {
    return 0.05;
  }

  if (val <= 5) {
    return 0.1;
  }

  return 0.2;
}

function queryToParams(query) {
  var q = query.replace(/^\??\//, '');
  return q.split('&').reduce(function (values, param) {
    var _extends2;

    var _param$split = param.split('='),
        key = _param$split[0],
        value = _param$split[1];

    return _extends({}, values, (_extends2 = {}, _extends2[key] = value, _extends2));
  }, {});
}

/**
 *
 * @desc Returns haystack based array without needle if it wasn't included before and with needle otherwise
 *
 * @param {[*]} haystack
 * @param {*} needle
 *
 * @return {[*]}
 */
function addIfNotExists(haystack, needle) {
  if (haystack.includes(needle)) {
    return haystack.filter(function (item) {
      return item !== needle;
    });
  }

  return [].concat(haystack, [needle]);
}

var utils_getEncodedCredentials = function getEncodedCredentials(_ref) {
  var email = _ref.email,
      password = _ref.password;

  var emailAsBinaryString = isAscii(email) ? email : toBinary(email);
  var passwordAsBinaryString = isAscii(password) ? password : toBinary(password);

  return 'Basic ' + window.btoa(emailAsBinaryString + ':' + passwordAsBinaryString);
};

/**
 *
 * @desc Returns platform depended mobile app link
 *
 * @param {string} os
 *
 * @return {string}
 */
var utils_getMobileAppLink = function getMobileAppLink(os) {
  return consts["b" /* APPS_LIST */].find(function (app) {
    return app.os === os;
  }) || consts["b" /* APPS_LIST */].find(function (app) {
    return app.os === consts["p" /* OS */].IOS;
  }).link;
};

/**
 *
 * @param {boolean} isPro
 * @param {number | null} [refId]
 * @param {number | null} [userId]
 * @return {string}
 */
function resolveAuthorisedEntryPoint(isPro) {
  var refId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var userId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var pathName = localStorage.getItem(consts["n" /* LOCAL_STORAGE */].PATH_NAME);
  localStorage.removeItem(consts["n" /* LOCAL_STORAGE */].PATH_NAME);

  if (refId) {
    return '' + components_app["routes"].USER_FOR_COMP + userId;
  }

  if (pathName && Object.values(components_app["routes"]).includes(pathName)) {
    return pathName;
  }

  if (isPro) {
    return components_app["routes"].MY_CLIENTS;
  }

  return components_app["routes"].MY_PROS;
}

/**
 * @desc Returns formatted last visit for pro card or false if formatted last visit time isn't available
 *
 * @param {number} lastVisitTS
 * @param {number} minLastVisitMinutes
 * @return {string | boolean}
 */
var utils_getFormattedLastVisit = function getFormattedLastVisit(lastVisitTS, minLastVisitMinutes) {
  var lastVisitDate = new Date(lastVisitTS);
  var currentDate = new Date();

  var hours = Math.floor(Object(differenceInHours["a" /* default */])(currentDate, lastVisitDate));
  var minutes = Math.floor(Object(differenceInMinutes["a" /* default */])(currentDate, lastVisitDate));

  if (hours) {
    return hours < consts["o" /* MAX_LAST_VISIT_HOURS */] && hours + 'h';
  }

  if (minutes >= minLastVisitMinutes) {
    return minutes + 'm';
  }

  return '';
};

/**
 *
 * @desc Converts bytes to mega bytes (MiB if more accurate)
 *
 * @param {number} bytes
 *
 * @return {number}
 */
var getMBytesFromBytes = function getMBytesFromBytes(bytes) {
  return bytes / Math.pow(1024, 2);
};

/**
 *
 * @param {number} timeStamp
 * @param {string} pattern
 * @return {string}
 */
function getFormattedDate(timeStamp, pattern) {
  return Object(format["a" /* default */])(new Date(timeStamp), pattern);
}

function cancelEventBubbling(e) {
  e && typeof e.stopPropagation === 'function' && e.stopPropagation();
}

/**
 *
 * @param {number} hours
 * @param {number} minutes
 */
function getFormattedTime(hours, minutes) {
  if (TIME_SHOULD_USE_AM_PM) {
    var ampmSuffix = hours >= 12 ? 'PM' : 'AM';
    var h12cycleHours = hours % 12 || 12;

    return String(h12cycleHours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ' ' + ampmSuffix;
  }
  return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
}

function getTimezoneName() {
  return SHORT_TIME_ZONE;
}

/***/ }),

/***/ "DPS1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var isPrototypeOf = __webpack_require__("VN+O");

var TypeError = global.TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw TypeError('Incorrect invocation');
};

/***/ }),

/***/ "DSHT":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("RA6A");
var fails = __webpack_require__("rtOw");
var createElement = __webpack_require__("mGt/");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

/***/ }),

/***/ "DbQ/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__("VxKF");
var callBind = __webpack_require__("y9YS");

var implementation = __webpack_require__("1Hmk");
var getPolyfill = __webpack_require__("YWiL");
var shim = __webpack_require__("Kszl");

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;

/***/ }),

/***/ "DgmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ "DhUb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__("tAi/");
var hasToStringTag = __webpack_require__("KpHW")();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function throwRegexMarker() {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
// eslint-disable-next-line consistent-return
? function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	try {
		$exec(value, badStringifier);
	} catch (e) {
		return e === isRegexMarker;
	}
} : function isRegex(value) {
	// In older browsers, typeof regex incorrectly returns 'function'
	if (!value || typeof value !== 'object' && typeof value !== 'function') {
		return false;
	}

	return $toString(value) === regexClass;
};

/***/ }),

/***/ "DsHd":
/***/ (function(module, exports, __webpack_require__) {

var rules = __webpack_require__("ZHoC");
var webviewRegExp = new RegExp('(' + rules.join('|') + ')', 'ig');

module.exports = function isWebview(ua) {
  return !!ua.match(webviewRegExp);
};

/***/ }),

/***/ "E/bI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* unused harmony export ReactReduxContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connect; });
/* unused harmony export connectAdvanced */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_context__ = __webpack_require__("ZShz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("fpuT");




function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function invariant() {}

var React = {
  createContext: __WEBPACK_IMPORTED_MODULE_1_preact_context__["createContext"],
  forwardRef: invariant,
  createElement: __WEBPACK_IMPORTED_MODULE_0_preact__["h"]
};

var ReactReduxContext = React.createContext(null);

var Provider = function (_Component) {
  _inheritsLoose(Provider, _Component);
  function Provider(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    var store = props.store;
    _this.state = {
      storeState: store.getState(),
      store: store
    };
    return _this;
  }
  var _proto = Provider.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.subscribe();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    this._isMounted = false;
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.store !== prevProps.store) {
      if (this.unsubscribe) this.unsubscribe();
      this.subscribe();
    }
  };
  _proto.subscribe = function subscribe() {
    var _this2 = this;
    var store = this.props.store;
    this.unsubscribe = store.subscribe(function () {
      var newStoreState = store.getState();
      if (!_this2._isMounted) {
        return;
      }
      _this2.setState(function (providerState) {
        if (providerState.storeState === newStoreState) {
          return null;
        }
        return {
          storeState: newStoreState
        };
      });
    });
    var postMountStoreState = store.getState();
    if (postMountStoreState !== this.state.storeState) {
      this.setState({
        storeState: postMountStoreState
      });
    }
  };
  _proto.render = function render() {
    var Context = this.props.context || ReactReduxContext;
    return React.createElement(Context.Provider, {
      value: this.state
    }, this.props.children);
  };
  return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var c = 60103,
      d = 60106,
      e = 60107,
      f = 60108,
      g = 60114,
      h = 60109,
      k = 60110,
      l = 60111,
      m = 60111,
      n = 60112,
      p = 60113,
      q = 60115,
      r = 60116;
  function t(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case r:
        case q:
        case d:
          return u;
      }
    }
  }
  function v(a) {
    return t(a) === m;
  }
  exports.typeOf = t;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = r;
  exports.Memo = q;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;
  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
  };
  exports.isAsyncMode = function (a) {
    return v(a) || t(a) === l;
  };
  exports.isConcurrentMode = v;
  exports.isContextConsumer = function (a) {
    return t(a) === k;
  };
  exports.isContextProvider = function (a) {
    return t(a) === h;
  };
  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  exports.isForwardRef = function (a) {
    return t(a) === n;
  };
  exports.isFragment = function (a) {
    return t(a) === e;
  };
  exports.isLazy = function (a) {
    return t(a) === r;
  };
  exports.isMemo = function (a) {
    return t(a) === q;
  };
  exports.isPortal = function (a) {
    return t(a) === d;
  };
  exports.isProfiler = function (a) {
    return t(a) === g;
  };
  exports.isStrictMode = function (a) {
    return t(a) === f;
  };
  exports.isSuspense = function (a) {
    return t(a) === p;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;

var reactIs = createCommonjsModule(function (module) {
  {
    module.exports = reactIs_production_min;
  }
});
var reactIs_1 = reactIs.isValidElementType;
var reactIs_2 = reactIs.isContextConsumer;

var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
    return targetComponent;
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;

function connectAdvanced(selectorFactory, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === void 0 ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === void 0 ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === void 0 ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === void 0 ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      _ref$forwardRef = _ref.forwardRef,
      forwardRef = _ref$forwardRef === void 0 ? false : _ref$forwardRef,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? ReactReduxContext : _ref$context,
      connectOptions = _objectWithoutPropertiesLoose(_ref, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
  var customStoreWarningMessage = 'To use a custom Redux store for specific components,  create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);
    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });
    var pure = connectOptions.pure;
    var OuterBaseComponent = __WEBPACK_IMPORTED_MODULE_0_preact__["Component"];
    if (pure) {
      OuterBaseComponent = __WEBPACK_IMPORTED_MODULE_0_preact__["Component"];
    }
    function makeDerivedPropsSelector() {
      var lastProps;
      var lastState;
      var lastDerivedProps;
      var lastStore;
      var lastSelectorFactoryOptions;
      var sourceSelector;
      return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
        if (pure && lastProps === props && lastState === state) {
          return lastDerivedProps;
        }
        if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
          lastStore = store;
          lastSelectorFactoryOptions = selectorFactoryOptions;
          sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
        }
        lastProps = props;
        lastState = state;
        var nextProps = sourceSelector(state, props);
        lastDerivedProps = nextProps;
        return lastDerivedProps;
      };
    }
    function makeChildElementSelector() {
      var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
      return function selectChildElement(WrappedComponent, childProps, forwardRef) {
        if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
          lastChildProps = childProps;
          lastForwardRef = forwardRef;
          lastComponent = WrappedComponent;
          lastChildElement = React.createElement(WrappedComponent, _extends({}, childProps, {
            ref: forwardRef
          }));
        }
        return lastChildElement;
      };
    }
    var Connect = function (_OuterBaseComponent) {
      _inheritsLoose(Connect, _OuterBaseComponent);
      function Connect(props) {
        var _this;
        _this = _OuterBaseComponent.call(this, props) || this;
        invariant(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
        _this.selectDerivedProps = makeDerivedPropsSelector();
        _this.selectChildElement = makeChildElementSelector();
        _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind(_assertThisInitialized(_this));
        return _this;
      }
      var _proto = Connect.prototype;
      _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
        return this.renderWrappedComponent(value);
      };
      _proto.renderWrappedComponent = function renderWrappedComponent(value) {
        var storeState = value.storeState,
            store = value.store;
        var wrapperProps = this.props;
        var forwardedRef;
        if (forwardRef) {
          wrapperProps = this.props.wrapperProps;
          forwardedRef = this.props.forwardedRef;
        }
        var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
        return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
      };
      _proto.render = function render() {
        var ContextToUse = this.props.context && this.props.context.Consumer && reactIs_2(React.createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
        return React.createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
      };
      return Connect;
    }(OuterBaseComponent);
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    if (forwardRef) {
      var forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        return React.createElement(Connect, {
          wrapperProps: props,
          forwardedRef: ref
        });
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }
    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}

var hasOwn = Object.prototype.hasOwnProperty;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;
  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);
    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;
    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };
    proxy.dependsOnOwnProps = true;
    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);
      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }
      return props;
    };
    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
      }
      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;
  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }
  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }
  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);
  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }
  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}
function strictEqual(a, b) {
  return a === b;
}
function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;
  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === void 0 ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === void 0 ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === void 0 ? shallowEqual : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === void 0 ? shallowEqual : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === void 0 ? shallowEqual : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref2, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      methodName: 'connect',
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      shouldHandleStateChanges: Boolean(mapStateToProps),
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
var connect = createConnect();

var index = {
  Provider: Provider,
  connect: connect,
  connectAdvanced: connectAdvanced,
  ReactReduxContext: ReactReduxContext
};

/* unused harmony default export */ var _unused_webpack_default_export = (index);

//# sourceMappingURL=preact-redux.esm.js.map

/***/ }),

/***/ "E2GX":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");
var fails = __webpack_require__("rtOw");
var isCallable = __webpack_require__("yeFe");
var classof = __webpack_require__("0guB");
var getBuiltIn = __webpack_require__("qvVx");
var inspectSource = __webpack_require__("yPWo");

var noop = function noop() {/* empty */};
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructorModern(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructorLegacy(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction':
      return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  }return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
    called = true;
  }) || called;
}) ? isConstructorLegacy : isConstructorModern;

/***/ }),

/***/ "E5Ce":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("ShN9");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "E7HD":
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "EBZy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBrowserInformation;

var _bowser = __webpack_require__("nmn5");

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var prefixByBrowser = {
  chrome: 'Webkit',
  safari: 'Webkit',
  ios: 'Webkit',
  android: 'Webkit',
  phantom: 'Webkit',
  opera: 'Webkit',
  webos: 'Webkit',
  blackberry: 'Webkit',
  bada: 'Webkit',
  tizen: 'Webkit',
  chromium: 'Webkit',
  vivaldi: 'Webkit',
  firefox: 'Moz',
  seamoney: 'Moz',
  sailfish: 'Moz',
  msie: 'ms',
  msedge: 'ms'
};

var browserByCanIuseAlias = {
  chrome: 'chrome',
  chromium: 'chrome',
  safari: 'safari',
  firfox: 'firefox',
  msedge: 'edge',
  opera: 'opera',
  vivaldi: 'opera',
  msie: 'ie'
};

function getBrowserName(browserInfo) {
  if (browserInfo.firefox) {
    return 'firefox';
  }

  if (browserInfo.mobile || browserInfo.tablet) {
    if (browserInfo.ios) {
      return 'ios_saf';
    } else if (browserInfo.android) {
      return 'android';
    } else if (browserInfo.opera) {
      return 'op_mini';
    }
  }

  for (var browser in browserByCanIuseAlias) {
    if (browserInfo.hasOwnProperty(browser)) {
      return browserByCanIuseAlias[browser];
    }
  }
}

/**
 * Uses bowser to get default browser browserInformation such as version and name
 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
 * @param {string} userAgent - userAgent that gets evaluated
 */
function getBrowserInformation(userAgent) {
  var browserInfo = _bowser2.default._detect(userAgent);

  if (browserInfo.yandexbrowser) {
    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
  }

  for (var browser in prefixByBrowser) {
    if (browserInfo.hasOwnProperty(browser)) {
      var prefix = prefixByBrowser[browser];

      browserInfo.jsPrefix = prefix;
      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
      break;
    }
  }

  browserInfo.browserName = getBrowserName(browserInfo);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  if (browserInfo.version) {
    browserInfo.browserVersion = parseFloat(browserInfo.version);
  } else {
    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
  }

  browserInfo.osVersion = parseFloat(browserInfo.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
    browserInfo.browserName = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // Samsung browser are basically build on Chrome > 44
  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
    browserInfo.browserName = 'and_chr';
    browserInfo.browserVersion = 44;
  }

  return browserInfo;
}
module.exports = exports['default'];

/***/ }),

/***/ "EKwp":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("BxvP");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "Ewv8":
/***/ (function(module, exports, __webpack_require__) {

var replaceStringToArray = __webpack_require__("WL61");

// This is based off of https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js
//
// Ideally we'd use twemoji instead of replicating its logic.
// The reason we can't is that we need to run our own replace.
//
// We could use it for most things (by essentially running twemoji.parse for each
// regex match, and reading the code from the callback), but the one thing we'd always need
// to copy and paste into this file is the regex since we need it to run the replace.
//
// Another option is to fork twemoji and expose a method in it that could help us, then
// ask them to pull it in.
//

// RegExp based on emoji's official Unicode standards
// http://www.unicode.org/Public/UNIDATA/EmojiSources.txt
var re = /(?:\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83e\uddd1\u200d\ud83e\udd1d\u200d\ud83e\uddd1|\ud83d\udc6b\ud83c[\udffb-\udfff]|\ud83d\udc6c\ud83c[\udffb-\udfff]|\ud83d\udc6d\ud83c[\udffb-\udfff]|\ud83d\udc8f\ud83c[\udffb-\udfff]|\ud83d\udc91\ud83c[\udffb-\udfff]|\ud83d[\udc6b-\udc6d\udc8f\udc91])|(?:\ud83d[\udc68\udc69]|\ud83e\uddd1)(?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf7c\udf84\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92]|\ud83e[\uddaf-\uddb3\uddbc\uddbd])|(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75]|\u26f9)((?:\ud83c[\udffb-\udfff]|\ufe0f)\u200d[\u2640\u2642]\ufe0f)|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc70\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd35\udd37-\udd39\udd3d\udd3e\uddb8\uddb9\uddcd-\uddcf\uddd4\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f|(?:\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\u26a7\ufe0f|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83d\ude36\u200d\ud83c\udf2b\ufe0f|\u2764\ufe0f\u200d\ud83d\udd25|\u2764\ufe0f\u200d\ud83e\ude79|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc15\u200d\ud83e\uddba|\ud83d\udc3b\u200d\u2744\ufe0f|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83d\ude2e\u200d\ud83d\udca8|\ud83d\ude35\u200d\ud83d\udcab|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f|\ud83d\udc08\u200d\u2b1b)|[#*0-9]\ufe0f?\u20e3|(?:[©®\u2122\u265f]\ufe0f)|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u203c\u2049\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2697\u2699\u269b\u269c\u26a0\u26a1\u26a7\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|(?:\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0\udecc]|\ud83e[\udd0c\udd0f\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\udd77\uddb5\uddb6\uddb8\uddb9\uddbb\uddcd-\uddcf\uddd1-\udddd]|[\u270a\u270b]))(?:\ud83c[\udffb-\udfff])?|(?:\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udc8e\udc90\udc92-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\uded5-\uded7\udeeb\udeec\udef4-\udefc\udfe0-\udfeb]|\ud83e[\udd0d\udd0e\udd10-\udd17\udd1d\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd3f-\udd45\udd47-\udd76\udd78\udd7a-\uddb4\uddb7\uddba\uddbc-\uddcb\uddd0\uddde-\uddff\ude70-\ude74\ude78-\ude7a\ude80-\ude86\ude90-\udea8\udeb0-\udeb6\udec0-\udec2\uded0-\uded6]|[\u23e9-\u23ec\u23f0\u23f3\u267e\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a])|\ufe0f/g;

function toCodePoint(unicodeSurrogates, sep) {
	var r = [],
	    c = 0,
	    p = 0,
	    i = 0;

	while (i < unicodeSurrogates.length) {
		c = unicodeSurrogates.charCodeAt(i++);
		if (p) {
			r.push((0x10000 + (p - 0xD800 << 10) + (c - 0xDC00)).toString(16));
			p = 0;
		} else if (0xD800 <= c && c <= 0xDBFF) {
			p = c;
		} else {
			r.push(c.toString(16));
		}
	}
	return r.join(sep || '-');
}

// avoid runtime RegExp creation for not so smart,
// not JIT based, and old browsers / engines
var UFE0Fg = /\uFE0F/g;

// avoid using a string literal like '\u200D' here because minifiers expand it inline
var U200D = String.fromCharCode(0x200D);

/**
* Used to both remove the possible variant
*  and to convert utf16 into code points.
*  If there is a zero-width-joiner (U+200D), leave the variants in.
* @param   string    the raw text of the emoji match
*/
function grabTheRightIcon(rawText) {
	// if variant is present as \uFE0F
	return toCodePoint(rawText.indexOf(U200D) < 0 ? rawText.replace(UFE0Fg, '') : rawText);
}

module.exports = function replaceEmoji(string, render) {
	// Note: the latest regex added an empty matching group, so we ignore it.
	return replaceStringToArray(string, re, function emojiReplacer(match, _, offset) {
		var icon = grabTheRightIcon(match);
		return render(icon, match, offset);
	});
};

/***/ }),

/***/ "F2TU":
/***/ (function(module, exports) {

var grammar = module.exports = {
  v: [{
    name: 'version',
    reg: /^(\d*)$/
  }],
  o: [{ //o=- 20518 0 IN IP4 203.0.113.1
    // NB: sessionId will be a String in most cases because it is huge
    name: 'origin',
    reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
    names: ['username', 'sessionId', 'sessionVersion', 'netType', 'ipVer', 'address'],
    format: "%s %s %d %s IP%d %s"
  }],
  // default parsing of these only (though some of these feel outdated)
  s: [{ name: 'name' }],
  i: [{ name: 'description' }],
  u: [{ name: 'uri' }],
  e: [{ name: 'email' }],
  p: [{ name: 'phone' }],
  z: [{ name: 'timezones' }], // TODO: this one can actually be parsed properly..
  r: [{ name: 'repeats' }], // TODO: this one can also be parsed properly
  //k: [{}], // outdated thing ignored
  t: [{ //t=0 0
    name: 'timing',
    reg: /^(\d*) (\d*)/,
    names: ['start', 'stop'],
    format: "%d %d"
  }],
  c: [{ //c=IN IP4 10.47.197.26
    name: 'connection',
    reg: /^IN IP(\d) (\S*)/,
    names: ['version', 'ip'],
    format: "IN IP%d %s"
  }],
  b: [{ //b=AS:4000
    push: 'bandwidth',
    reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
    names: ['type', 'limit'],
    format: "%s:%s"
  }],
  m: [{ //m=video 51744 RTP/AVP 126 97 98 34 31
    // NB: special - pushes to session
    // TODO: rtp/fmtp should be filtered by the payloads found here?
    reg: /^(\w*) (\d*) ([\w\/]*)(?: (.*))?/,
    names: ['type', 'port', 'protocol', 'payloads'],
    format: "%s %d %s %s"
  }],
  a: [{ //a=rtpmap:110 opus/48000/2
    push: 'rtp',
    reg: /^rtpmap:(\d*) ([\w\-]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
    names: ['payload', 'codec', 'rate', 'encoding'],
    format: function format(o) {
      return o.encoding ? "rtpmap:%d %s/%s/%s" : o.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
    }
  }, {
    //a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
    //a=fmtp:111 minptime=10; useinbandfec=1
    push: 'fmtp',
    reg: /^fmtp:(\d*) ([\S| ]*)/,
    names: ['payload', 'config'],
    format: "fmtp:%d %s"
  }, { //a=control:streamid=0
    name: 'control',
    reg: /^control:(.*)/,
    format: "control:%s"
  }, { //a=rtcp:65179 IN IP4 193.84.77.194
    name: 'rtcp',
    reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
    names: ['port', 'netType', 'ipVer', 'address'],
    format: function format(o) {
      return o.address != null ? "rtcp:%d %s IP%d %s" : "rtcp:%d";
    }
  }, { //a=rtcp-fb:98 trr-int 100
    push: 'rtcpFbTrrInt',
    reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
    names: ['payload', 'value'],
    format: "rtcp-fb:%d trr-int %d"
  }, { //a=rtcp-fb:98 nack rpsi
    push: 'rtcpFb',
    reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
    names: ['payload', 'type', 'subtype'],
    format: function format(o) {
      return o.subtype != null ? "rtcp-fb:%s %s %s" : "rtcp-fb:%s %s";
    }
  }, { //a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
    //a=extmap:1/recvonly URI-gps-string
    push: 'ext',
    reg: /^extmap:([\w_\/]*) (\S*)(?: (\S*))?/,
    names: ['value', 'uri', 'config'], // value may include "/direction" suffix
    format: function format(o) {
      return o.config != null ? "extmap:%s %s %s" : "extmap:%s %s";
    }
  }, {
    //a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
    push: 'crypto',
    reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
    names: ['id', 'suite', 'config', 'sessionConfig'],
    format: function format(o) {
      return o.sessionConfig != null ? "crypto:%d %s %s %s" : "crypto:%d %s %s";
    }
  }, { //a=setup:actpass
    name: 'setup',
    reg: /^setup:(\w*)/,
    format: "setup:%s"
  }, { //a=mid:1
    name: 'mid',
    reg: /^mid:([^\s]*)/,
    format: "mid:%s"
  }, { //a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
    name: 'msid',
    reg: /^msid:(.*)/,
    format: "msid:%s"
  }, { //a=ptime:20
    name: 'ptime',
    reg: /^ptime:(\d*)/,
    format: "ptime:%d"
  }, { //a=maxptime:60
    name: 'maxptime',
    reg: /^maxptime:(\d*)/,
    format: "maxptime:%d"
  }, { //a=sendrecv
    name: 'direction',
    reg: /^(sendrecv|recvonly|sendonly|inactive)/
  }, { //a=ice-lite
    name: 'icelite',
    reg: /^(ice-lite)/
  }, { //a=ice-ufrag:F7gI
    name: 'iceUfrag',
    reg: /^ice-ufrag:(\S*)/,
    format: "ice-ufrag:%s"
  }, { //a=ice-pwd:x9cml/YzichV2+XlhiMu8g
    name: 'icePwd',
    reg: /^ice-pwd:(\S*)/,
    format: "ice-pwd:%s"
  }, { //a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
    name: 'fingerprint',
    reg: /^fingerprint:(\S*) (\S*)/,
    names: ['type', 'hash'],
    format: "fingerprint:%s %s"
  }, {
    //a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
    //a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0
    //a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0
    //a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0
    //a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0
    push: 'candidates',
    reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?/,
    names: ['foundation', 'component', 'transport', 'priority', 'ip', 'port', 'type', 'raddr', 'rport', 'tcptype', 'generation'],
    format: function format(o) {
      var str = "candidate:%s %d %s %d %s %d typ %s";

      str += o.raddr != null ? " raddr %s rport %d" : "%v%v";

      // NB: candidate has three optional chunks, so %void middles one if it's missing
      str += o.tcptype != null ? " tcptype %s" : "%v";

      if (o.generation != null) {
        str += " generation %d";
      }
      return str;
    }
  }, { //a=end-of-candidates (keep after the candidates line for readability)
    name: 'endOfCandidates',
    reg: /^(end-of-candidates)/
  }, { //a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
    name: 'remoteCandidates',
    reg: /^remote-candidates:(.*)/,
    format: "remote-candidates:%s"
  }, { //a=ice-options:google-ice
    name: 'iceOptions',
    reg: /^ice-options:(\S*)/,
    format: "ice-options:%s"
  }, { //a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
    push: "ssrcs",
    reg: /^ssrc:(\d*) ([\w_]*):(.*)/,
    names: ['id', 'attribute', 'value'],
    format: "ssrc:%d %s:%s"
  }, { //a=ssrc-group:FEC 1 2
    push: "ssrcGroups",
    reg: /^ssrc-group:(\w*) (.*)/,
    names: ['semantics', 'ssrcs'],
    format: "ssrc-group:%s %s"
  }, { //a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
    name: "msidSemantic",
    reg: /^msid-semantic:\s?(\w*) (\S*)/,
    names: ['semantic', 'token'],
    format: "msid-semantic: %s %s" // space after ":" is not accidental
  }, { //a=group:BUNDLE audio video
    push: 'groups',
    reg: /^group:(\w*) (.*)/,
    names: ['type', 'mids'],
    format: "group:%s %s"
  }, { //a=rtcp-mux
    name: 'rtcpMux',
    reg: /^(rtcp-mux)/
  }, { //a=rtcp-rsize
    name: 'rtcpRsize',
    reg: /^(rtcp-rsize)/
  }, { // any a= that we don't understand is kepts verbatim on media.invalid
    push: 'invalid',
    names: ["value"]
  }]
};

// set sensible defaults to avoid polluting the grammar with boring details
Object.keys(grammar).forEach(function (key) {
  var objs = grammar[key];
  objs.forEach(function (obj) {
    if (!obj.reg) {
      obj.reg = /(.*)/;
    }
    if (!obj.format) {
      obj.format = "%s";
    }
  });
});

/***/ }),

/***/ "F4n3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__("rQKw");

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};

var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "FAW1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification-custom-icon-wrap":"notification-custom-icon-wrap__s0d6d","notification-custom-icon":"notification-custom-icon__2XXyN","notification-custom-content":"notification-custom-content__6waPj","notification-custom-message":"notification-custom-message__MpWEN","notification-custom-message-small":"notification-custom-message-small__3d1IZ","notification-custom-success":"notification-custom-success__19Rfo","notification-custom-default":"notification-custom-default__2XWB5","notification-custom-danger":"notification-custom-danger__28oWY","notification-custom-info":"notification-custom-info__11QmK","notification-custom-warning":"notification-custom-warning__HcPmD"};

/***/ }),

/***/ "FD18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/redux-actions/es/index.js + 30 modules
var es = __webpack_require__("bKsd");

// EXTERNAL MODULE: ./api/index.js
var api = __webpack_require__("/C1n");

// EXTERNAL MODULE: ./api/fetch-wrapper.js
var fetch_wrapper = __webpack_require__("ds2O");

// CONCATENATED MODULE: ./api/sectors.js
/* eslint-disable import/prefer-default-export */




function sectors_fetchSectors(authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].GET_SECTORS, { method: 'GET', headers: headers });
}
// EXTERNAL MODULE: ./actions/index.js
var actions = __webpack_require__("vyGZ");

// EXTERNAL MODULE: ./actions/api-notifications.js
var api_notifications = __webpack_require__("kKXN");

// CONCATENATED MODULE: ./actions/sectors.js
/* unused harmony export sectorsRequest */
/* unused harmony export sectorsSuccess */
/* unused harmony export sectorsError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions_sectors_fetchSectors; });





var sectorsRequest = Object(es["a" /* createAction */])(actions["a" /* actionTypes */].GET_SECTORS_REQUSET);
var sectorsSuccess = Object(es["a" /* createAction */])(actions["a" /* actionTypes */].GET_SECTORS_SUCCESS);
var sectorsError = Object(es["a" /* createAction */])(actions["a" /* actionTypes */].GET_SECTORS_FAILURE);

var actions_sectors_fetchSectors = function fetchSectors() {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState, userAuth, response;

      _getState = getState(), userAuth = _getState.loggedInUser.userAuth;

      dispatch(sectorsRequest());
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (err) {
        try {
          dispatch(Object(api_notifications["a" /* addNotification */])(err));
          dispatch(sectorsError({
            sectors: [],
            loading: false,
            error: true
          }));
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        return Promise.resolve(sectors_fetchSectors(userAuth)).then(function ($await_2) {
          try {
            response = $await_2;
            dispatch(sectorsSuccess({
              sectors: response,
              loadnig: false,
              error: false
            }));
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (err) {
        $Try_1_Catch(err)
      }
    });
  };
};

/***/ }),

/***/ "FFZn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("3v7p"), __esModule: true };

/***/ }),

/***/ "FFyX":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! bugfender-web/20210212 (v1.5.0-33f931b-lib) */
!function (e, t) {
   true ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@bugfender/sdk"] = t() : e["@bugfender/sdk"] = t();
}(window, function () {
  return function (e) {
    var t = {};function n(r) {
      if (t[r]) return t[r].exports;var i = t[r] = { i: r, l: !1, exports: {} };return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;if (4 & t && "object" == typeof e && e && e.__esModule) return e;var r = Object.create(null);if (n.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 47);
  }([function (e, t, n) {
    "use strict";
    (function (e) {
      function r(e) {
        return !(!e || "function" != typeof e.then);
      }function i(e) {
        return e || (e = 0), new Promise(function (t) {
          return setTimeout(t, e);
        });
      }function o(e, t) {
        return Math.floor(Math.random() * (t - e + 1) + e);
      }function s() {
        return Math.random().toString(36).substring(2);
      }n.d(t, "b", function () {
        return r;
      }), n.d(t, "f", function () {
        return i;
      }), n.d(t, "d", function () {
        return o;
      }), n.d(t, "e", function () {
        return s;
      }), n.d(t, "c", function () {
        return c;
      }), n.d(t, "a", function () {
        return l;
      });var a = 0,
          u = 0;function c() {
        var e = new Date().getTime();return e === a ? 1e3 * e + ++u : (a = e, u = 0, 1e3 * e);
      }var l = "[object process]" === Object.prototype.toString.call(void 0 !== e ? e : 0);
    }).call(this, n(2));
  }, function (e, t, n) {
    "use strict";
    var r;Object.defineProperty(t, "__esModule", { value: !0 }), t.LOG_LEVELS = t.LogLevel = void 0, function (e) {
      e[e.Debug = 0] = "Debug", e[e.Warning = 1] = "Warning", e[e.Error = 2] = "Error", e[e.Trace = 3] = "Trace", e[e.Info = 4] = "Info", e[e.Fatal = 5] = "Fatal";
    }(r = t.LogLevel || (t.LogLevel = {})), t.LOG_LEVELS = [r.Debug, r.Warning, r.Error, r.Trace, r.Info, r.Fatal];
  }, function (e, t) {
    var n,
        r,
        i = e.exports = {};function o() {
      throw new Error("setTimeout has not been defined");
    }function s() {
      throw new Error("clearTimeout has not been defined");
    }function a(e) {
      if (n === setTimeout) return setTimeout(e, 0);if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }!function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        n = o;
      }try {
        r = "function" == typeof clearTimeout ? clearTimeout : s;
      } catch (e) {
        r = s;
      }
    }();var u,
        c = [],
        l = !1,
        f = -1;function h() {
      l && u && (l = !1, u.length ? c = u.concat(c) : f = -1, c.length && d());
    }function d() {
      if (!l) {
        var e = a(h);l = !0;for (var t = c.length; t;) {
          for (u = c, c = []; ++f < t;) {
            u && u[f].run();
          }f = -1, t = c.length;
        }u = null, l = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);if ((r === s || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }function p(e, t) {
      this.fun = e, this.array = t;
    }function y() {}i.nextTick = function (e) {
      var t = new Array(arguments.length - 1);if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }c.push(new p(e, t)), 1 !== c.length || l || a(d);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = y, i.addListener = y, i.once = y, i.off = y, i.removeListener = y, i.removeAllListeners = y, i.emit = y, i.prependListener = y, i.prependOnceListener = y, i.listeners = function (e) {
      return [];
    }, i.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    (function (e) {
      var r = Object.getOwnPropertyDescriptors || function (e) {
        for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
          n[t[r]] = Object.getOwnPropertyDescriptor(e, t[r]);
        }return n;
      },
          i = /%[sdj%]/g;t.format = function (e) {
        if (!g(e)) {
          for (var t = [], n = 0; n < arguments.length; n++) {
            t.push(a(arguments[n]));
          }return t.join(" ");
        }n = 1;for (var r = arguments, o = r.length, s = String(e).replace(i, function (e) {
          if ("%%" === e) return "%";if (n >= o) return e;switch (e) {case "%s":
              return String(r[n++]);case "%d":
              return Number(r[n++]);case "%j":
              try {
                return JSON.stringify(r[n++]);
              } catch (e) {
                return "[Circular]";
              }default:
              return e;}
        }), u = r[n]; n < o; u = r[++n]) {
          y(u) || !w(u) ? s += " " + u : s += " " + a(u);
        }return s;
      }, t.deprecate = function (n, r) {
        if (void 0 !== e && !0 === e.noDeprecation) return n;if (void 0 === e) return function () {
          return t.deprecate(n, r).apply(this, arguments);
        };var i = !1;return function () {
          if (!i) {
            if (e.throwDeprecation) throw new Error(r);e.traceDeprecation ? console.trace(r) : console.error(r), i = !0;
          }return n.apply(this, arguments);
        };
      };var o,
          s = {};function a(e, n) {
        var r = { seen: [], stylize: c };return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), p(n) ? r.showHidden = n : n && t._extend(r, n), m(r.showHidden) && (r.showHidden = !1), m(r.depth) && (r.depth = 2), m(r.colors) && (r.colors = !1), m(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = u), l(r, e, r.depth);
      }function u(e, t) {
        var n = a.styles[t];return n ? "[" + a.colors[n][0] + "m" + e + "[" + a.colors[n][1] + "m" : e;
      }function c(e, t) {
        return e;
      }function l(e, n, r) {
        if (e.customInspect && n && S(n.inspect) && n.inspect !== t.inspect && (!n.constructor || n.constructor.prototype !== n)) {
          var i = n.inspect(r, e);return g(i) || (i = l(e, i, r)), i;
        }var o = function (e, t) {
          if (m(t)) return e.stylize("undefined", "undefined");if (g(t)) {
            var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";return e.stylize(n, "string");
          }if (v(t)) return e.stylize("" + t, "number");if (p(t)) return e.stylize("" + t, "boolean");if (y(t)) return e.stylize("null", "null");
        }(e, n);if (o) return o;var s = Object.keys(n),
            a = function (e) {
          var t = {};return e.forEach(function (e, n) {
            t[e] = !0;
          }), t;
        }(s);if (e.showHidden && (s = Object.getOwnPropertyNames(n)), E(n) && (s.indexOf("message") >= 0 || s.indexOf("description") >= 0)) return f(n);if (0 === s.length) {
          if (S(n)) {
            var u = n.name ? ": " + n.name : "";return e.stylize("[Function" + u + "]", "special");
          }if (b(n)) return e.stylize(RegExp.prototype.toString.call(n), "regexp");if (_(n)) return e.stylize(Date.prototype.toString.call(n), "date");if (E(n)) return f(n);
        }var c,
            w = "",
            k = !1,
            x = ["{", "}"];(d(n) && (k = !0, x = ["[", "]"]), S(n)) && (w = " [Function" + (n.name ? ": " + n.name : "") + "]");return b(n) && (w = " " + RegExp.prototype.toString.call(n)), _(n) && (w = " " + Date.prototype.toUTCString.call(n)), E(n) && (w = " " + f(n)), 0 !== s.length || k && 0 != n.length ? r < 0 ? b(n) ? e.stylize(RegExp.prototype.toString.call(n), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(n), c = k ? function (e, t, n, r, i) {
          for (var o = [], s = 0, a = t.length; s < a; ++s) {
            P(t, String(s)) ? o.push(h(e, t, n, r, String(s), !0)) : o.push("");
          }return i.forEach(function (i) {
            i.match(/^\d+$/) || o.push(h(e, t, n, r, i, !0));
          }), o;
        }(e, n, r, a, s) : s.map(function (t) {
          return h(e, n, r, a, t, k);
        }), e.seen.pop(), function (e, t, n) {
          if (e.reduce(function (e, t) {
            return t.indexOf("\n") >= 0 && 0, e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
          }, 0) > 60) return n[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + n[1];return n[0] + t + " " + e.join(", ") + " " + n[1];
        }(c, w, x)) : x[0] + w + x[1];
      }function f(e) {
        return "[" + Error.prototype.toString.call(e) + "]";
      }function h(e, t, n, r, i, o) {
        var s, a, u;if ((u = Object.getOwnPropertyDescriptor(t, i) || { value: t[i] }).get ? a = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (a = e.stylize("[Setter]", "special")), P(r, i) || (s = "[" + i + "]"), a || (e.seen.indexOf(u.value) < 0 ? (a = y(n) ? l(e, u.value, null) : l(e, u.value, n - 1)).indexOf("\n") > -1 && (a = o ? a.split("\n").map(function (e) {
          return "  " + e;
        }).join("\n").substr(2) : "\n" + a.split("\n").map(function (e) {
          return "   " + e;
        }).join("\n")) : a = e.stylize("[Circular]", "special")), m(s)) {
          if (o && i.match(/^\d+$/)) return a;(s = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = e.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = e.stylize(s, "string"));
        }return s + ": " + a;
      }function d(e) {
        return Array.isArray(e);
      }function p(e) {
        return "boolean" == typeof e;
      }function y(e) {
        return null === e;
      }function v(e) {
        return "number" == typeof e;
      }function g(e) {
        return "string" == typeof e;
      }function m(e) {
        return void 0 === e;
      }function b(e) {
        return w(e) && "[object RegExp]" === k(e);
      }function w(e) {
        return "object" == typeof e && null !== e;
      }function _(e) {
        return w(e) && "[object Date]" === k(e);
      }function E(e) {
        return w(e) && ("[object Error]" === k(e) || e instanceof Error);
      }function S(e) {
        return "function" == typeof e;
      }function k(e) {
        return Object.prototype.toString.call(e);
      }function x(e) {
        return e < 10 ? "0" + e.toString(10) : e.toString(10);
      }t.debuglog = function (n) {
        if (m(o) && (o = e.env.NODE_DEBUG || ""), n = n.toUpperCase(), !s[n]) if (new RegExp("\\b" + n + "\\b", "i").test(o)) {
          var r = e.pid;s[n] = function () {
            var e = t.format.apply(t, arguments);console.error("%s %d: %s", n, r, e);
          };
        } else s[n] = function () {};return s[n];
      }, t.inspect = a, a.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, a.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" }, t.isArray = d, t.isBoolean = p, t.isNull = y, t.isNullOrUndefined = function (e) {
        return null == e;
      }, t.isNumber = v, t.isString = g, t.isSymbol = function (e) {
        return "symbol" == typeof e;
      }, t.isUndefined = m, t.isRegExp = b, t.isObject = w, t.isDate = _, t.isError = E, t.isFunction = S, t.isPrimitive = function (e) {
        return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
      }, t.isBuffer = n(8);var O = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];function A() {
        var e = new Date(),
            t = [x(e.getHours()), x(e.getMinutes()), x(e.getSeconds())].join(":");return [e.getDate(), O[e.getMonth()], t].join(" ");
      }function P(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }t.log = function () {
        console.log("%s - %s", A(), t.format.apply(t, arguments));
      }, t.inherits = n(9), t._extend = function (e, t) {
        if (!t || !w(t)) return e;for (var n = Object.keys(t), r = n.length; r--;) {
          e[n[r]] = t[n[r]];
        }return e;
      };var T = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;function M(e, t) {
        if (!e) {
          var n = new Error("Promise was rejected with a falsy value");n.reason = e, e = n;
        }return t(e);
      }t.promisify = function (e) {
        if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');if (T && e[T]) {
          var t;if ("function" != typeof (t = e[T])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');return Object.defineProperty(t, T, { value: t, enumerable: !1, writable: !1, configurable: !0 }), t;
        }function t() {
          for (var t, n, r = new Promise(function (e, r) {
            t = e, n = r;
          }), i = [], o = 0; o < arguments.length; o++) {
            i.push(arguments[o]);
          }i.push(function (e, r) {
            e ? n(e) : t(r);
          });try {
            e.apply(this, i);
          } catch (e) {
            n(e);
          }return r;
        }return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), T && Object.defineProperty(t, T, { value: t, enumerable: !1, writable: !1, configurable: !0 }), Object.defineProperties(t, r(e));
      }, t.promisify.custom = T, t.callbackify = function (t) {
        if ("function" != typeof t) throw new TypeError('The "original" argument must be of type Function');function n() {
          for (var n = [], r = 0; r < arguments.length; r++) {
            n.push(arguments[r]);
          }var i = n.pop();if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");var o = this,
              s = function s() {
            return i.apply(o, arguments);
          };t.apply(this, n).then(function (t) {
            e.nextTick(s, null, t);
          }, function (t) {
            e.nextTick(M, t, s);
          });
        }return Object.setPrototypeOf(n, Object.getPrototypeOf(t)), Object.defineProperties(n, r(t)), n;
      };
    }).call(this, n(2));
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.IssueType = void 0, function (e) {
      e.Issue = "issue", e.Crash = "crash", e.Feedback = "user-feedback";
    }(t.IssueType || (t.IssueType = {}));
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.HttpClient = void 0;var r = function () {
      function e(e, t, n) {
        this.apiURL = e, this.appKey = t, this.sdkUserAgent = n;
      }return e.prototype.post = function (e, t) {
        var n = new XMLHttpRequest();return n.open("POST", this.apiURL + e), n.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), n.setRequestHeader("X-User-Agent", this.sdkUserAgent), n.setRequestHeader("X-App-Token", this.appKey), new Promise(function (e, r) {
          n.onreadystatechange = function () {
            4 === n.readyState && (200 !== n.status && 304 !== n.status ? r() : e(JSON.parse(n.responseText)));
          }, n.send(JSON.stringify(t));
        });
      }, e;
    }();t.HttpClient = r;
  }, function (e, t, n) {
    var r, i, o;!function (n, s) {
      "use strict";
      i = [], void 0 === (o = "function" == typeof (r = function r() {
        function e(e) {
          return e.charAt(0).toUpperCase() + e.substring(1);
        }function t(e) {
          return function () {
            return this[e];
          };
        }var n = ["isConstructor", "isEval", "isNative", "isToplevel"],
            r = ["columnNumber", "lineNumber"],
            i = ["fileName", "functionName", "source"],
            o = n.concat(r, i, ["args"]);function s(t) {
          if (t) for (var n = 0; n < o.length; n++) {
            void 0 !== t[o[n]] && this["set" + e(o[n])](t[o[n]]);
          }
        }s.prototype = { getArgs: function getArgs() {
            return this.args;
          }, setArgs: function setArgs(e) {
            if ("[object Array]" !== Object.prototype.toString.call(e)) throw new TypeError("Args must be an Array");this.args = e;
          }, getEvalOrigin: function getEvalOrigin() {
            return this.evalOrigin;
          }, setEvalOrigin: function setEvalOrigin(e) {
            if (e instanceof s) this.evalOrigin = e;else {
              if (!(e instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");this.evalOrigin = new s(e);
            }
          }, toString: function toString() {
            var e = this.getFileName() || "",
                t = this.getLineNumber() || "",
                n = this.getColumnNumber() || "",
                r = this.getFunctionName() || "";return this.getIsEval() ? e ? "[eval] (" + e + ":" + t + ":" + n + ")" : "[eval]:" + t + ":" + n : r ? r + " (" + e + ":" + t + ":" + n + ")" : e + ":" + t + ":" + n;
          } }, s.fromString = function (e) {
          var t = e.indexOf("("),
              n = e.lastIndexOf(")"),
              r = e.substring(0, t),
              i = e.substring(t + 1, n).split(","),
              o = e.substring(n + 1);if (0 === o.indexOf("@")) var a = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(o, ""),
              u = a[1],
              c = a[2],
              l = a[3];return new s({ functionName: r, args: i || void 0, fileName: u, lineNumber: c || void 0, columnNumber: l || void 0 });
        };for (var a = 0; a < n.length; a++) {
          s.prototype["get" + e(n[a])] = t(n[a]), s.prototype["set" + e(n[a])] = function (e) {
            return function (t) {
              this[e] = Boolean(t);
            };
          }(n[a]);
        }for (var u = 0; u < r.length; u++) {
          s.prototype["get" + e(r[u])] = t(r[u]), s.prototype["set" + e(r[u])] = function (e) {
            return function (t) {
              if (n = t, isNaN(parseFloat(n)) || !isFinite(n)) throw new TypeError(e + " must be a Number");var n;this[e] = Number(t);
            };
          }(r[u]);
        }for (var c = 0; c < i.length; c++) {
          s.prototype["get" + e(i[c])] = t(i[c]), s.prototype["set" + e(i[c])] = function (e) {
            return function (t) {
              this[e] = String(t);
            };
          }(i[c]);
        }return s;
      }) ? r.apply(t, i) : r) || (e.exports = o);
    }();
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.StorageWriterSanitizer = void 0;var r = n(1),
        i = function () {
      function e() {}return e.prototype.toString = function (e) {
        if (["string", "symbol", "bigint", "function"].includes(typeof e) || e instanceof Error) try {
          return String(e);
        } catch (t) {
          return JSON.stringify(e);
        } else try {
          return JSON.stringify(e);
        } catch (t) {
          return String(e);
        }
      }, e.prototype.toNumber = function (e) {
        if (e = Number(e), isNaN(e)) throw new Error("Can't be casted to number");return e;
      }, e.prototype.sanitize = function (e) {
        var t = this;switch (e.type) {case "device-key":
            var n = ["boolean", "number", "string"].includes(typeof e.data.value);e.data.key = this.toString(e.data.key), n || (e.data.value = this.toString(e.data.value));break;case "issue":
            e.data.title = this.toString(e.data.title), e.data.markdown = this.toString(e.data.markdown);break;case "log-entry":
            var i = "line" in e.data.log && void 0 !== e.data.log.line,
                o = i && "number" == typeof e.data.log.line,
                s = "level" in e.data.log && void 0 !== e.data.log.level,
                a = s && r.LOG_LEVELS.includes(e.data.log.level);if (["tag", "method", "file", "text", "url"].forEach(function (n) {
              if (n in e.data.log && void 0 !== e.data.log[n]) try {
                e.data.log[n] = t.toString(e.data.log[n]);
              } catch (t) {
                delete e.data.log[n];
              }
            }), i && !o) try {
              e.data.log.line = this.toNumber(e.data.log.line);
            } catch (t) {
              delete e.data.log.line;
            }if (s && !a) try {
              e.data.log.level = this.toNumber(e.data.log.level), r.LOG_LEVELS.includes(e.data.log.level) || delete e.data.log.level;
            } catch (t) {
              delete e.data.log.level;
            }}return e;
      }, e;
    }();t.StorageWriterSanitizer = i;
  }, function (e, t) {
    e.exports = function (e) {
      return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
    };
  }, function (e, t) {
    "function" == typeof Object.create ? e.exports = function (e, t) {
      e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } });
    } : e.exports = function (e, t) {
      e.super_ = t;var n = function n() {};n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
    };
  }, function (e, t) {
    var n;n = function () {
      return this;
    }();try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }e.exports = n;
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.createDeferred = void 0, t.createDeferred = function () {
      var e = { isFulfilled: !1, promise: void 0, resolve: void 0, reject: void 0 };return e.promise = new Promise(function (t, n) {
        e.resolve = function (n) {
          e.isFulfilled = !0, t(n);
        }, e.reject = function (t) {
          e.isFulfilled = !0, n(t);
        };
      }), e;
    };
  }, function (e, t) {
    e.exports = !1;
  }, function (e, t) {}, function (e, t, n) {
    "use strict";
    var r = window.URL || window.webkitURL;e.exports = function (e, t, n, i) {
      try {
        try {
          var o;try {
            o = new window.Blob([e]);
          } catch (t) {
            (o = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder)()).append(e), o = o.getBlob();
          }var s = r.createObjectURL(o),
              a = new window[t](s, n);return r.revokeObjectURL(s), a;
        } catch (r) {
          return new window[t]("data:application/javascript,".concat(encodeURIComponent(e)), n);
        }
      } catch (e) {
        if (!i) throw Error("Inline worker is not supported");return new window[t](i, n);
      }
    };
  }, function (e, t, n) {
    "use strict";
    e.exports = function (e) {
      var t = [];return t.toString = function () {
        return this.map(function (t) {
          var n = e(t);return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
        }).join("");
      }, t.i = function (e, n, r) {
        "string" == typeof e && (e = [[null, e, ""]]);var i = {};if (r) for (var o = 0; o < this.length; o++) {
          var s = this[o][0];null != s && (i[s] = !0);
        }for (var a = 0; a < e.length; a++) {
          var u = [].concat(e[a]);r && i[u[0]] || (n && (u[2] ? u[2] = "".concat(n, " and ").concat(u[2]) : u[2] = n), t.push(u));
        }
      }, t;
    };
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ApiClient = void 0;var r = function () {
      function e() {}return e.prototype.init = function (e, t) {
        this.appKey = e, this.http = t;
      }, e.prototype.getDeviceStatus = function (e) {
        var t = { app_token: this.appKey, device: e };return this.http.post("/app/device-status", t).then(function (e) {
          var t = void 0 !== e.error,
              n = !t || t && -1004 !== e.error.code;return { isDeviceEnabled: void 0 !== e.logger_enabled && e.logger_enabled, isAppValid: n };
        });
      }, e.prototype.sendSession = function (e) {
        return this.http.post("/session", e);
      }, e.prototype.sendLogs = function (e, t) {
        return this.http.post("/log/batch", { session_id: e, logs: t });
      }, e.prototype.sendIssue = function (e, t, n, r, i, o) {
        var s = { uid: e, title: n, text: r, app: { key: this.appKey }, type: i, session_id: o };return this.http.post("/issue", s).then(function () {
          return { uuid: e, issueURL: t };
        });
      }, e.prototype.setDeviceKey = function (e, t, n) {
        return this.http.post("/device/keyvalue", { app_key: this.appKey, device_id: e, key: t, value: n });
      }, e;
    }();t.ApiClient = r;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }function u(e) {
          var t;e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(s, a);
        }u((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          o,
          s = { label: 0, sent: function sent() {
          if (1 & i[0]) throw i[1];return i[1];
        }, trys: [], ops: [] };return o = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;function a(o) {
        return function (a) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");for (; s;) {
              try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {case 0:case 1:
                    i = o;break;case 4:
                    return s.label++, { value: o[1], done: !1 };case 5:
                    s.label++, r = o[1], o = [0];continue;case 7:
                    o = s.ops.pop(), s.trys.pop();continue;default:
                    if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      s = 0;continue;
                    }if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      s.label = o[1];break;
                    }if (6 === o[0] && s.label < i[1]) {
                      s.label = i[1], i = o;break;
                    }if (i && s.label < i[2]) {
                      s.label = i[2], s.ops.push(o);break;
                    }i[2] && s.ops.pop(), s.trys.pop();continue;}o = t.call(e, s);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }if (5 & o[0]) throw o[1];return { value: o[0] ? o[1] : void 0, done: !0 };
          }([o, a]);
        };
      }
    },
        o = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }var r = Array(e),
          i = 0;for (t = 0; t < n; t++) {
        for (var o = arguments[t], s = 0, a = o.length; s < a; s++, i++) {
          r[i] = o[s];
        }
      }return r;
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.Bugfender = void 0;var s = n(1),
        a = n(4),
        u = n(5),
        c = function () {
      function e(e, t, n, r, i, o, a, u, c, l, f, h, d) {
        this.apiClient = e, this.device = t, this.overrideConsoleMethods = n, this.printToConsole = r, this.registerBrowserEventsHandler = i, this.registerErrorHandler = o, this.registerUIEventsHandler = a, this.processor = u, this.sdkOptions = c, this.sdkUserAgent = l, this.session = f, this.storage = h, this.userFeedback = d, this.LogLevel = s.LogLevel;
      }return e.prototype.init = function (e) {
        return r(this, void 0, void 0, function () {
          var t,
              n,
              r = this;return i(this, function (i) {
            return this.options = this.sdkOptions.init(e), t = new u.HttpClient(this.options.apiURL, this.options.appKey, this.sdkUserAgent), this.apiClient.init(this.options.appKey, t), this.processor.init(this.options), this.storage.init(this.options), n = this.device.getBrowserInfo(), this.storage.addDeviceKey("$browser", n.getBrowserName()), this.options.logBrowserEvents && this.registerBrowserEventsHandler.init(), this.options.logUIEvents && this.registerUIEventsHandler.init(), this.options.registerErrorHandler && this.registerErrorHandler.init(this), this.options.overrideConsoleMethods && this.overrideConsoleMethods.init(), this.printToConsole.init(this.options.printToConsole), window.addEventListener("beforeunload", function () {
              r.processor.run();
            }), [2];
          });
        });
      }, e.prototype.getDeviceURL = function () {
        return this.options.baseURL + "/intent/" + this.options.appID + "/device/" + this.device.getUDID();
      }, e.prototype.getSessionURL = function () {
        return this.options.baseURL + "/intent/" + this.options.appID + "/session/" + this.session.getUUID();
      }, e.prototype.getUserFeedback = function (e) {
        return r(this, void 0, void 0, function () {
          return i(this, function (t) {
            return [2, this.userFeedback.show(e)];
          });
        });
      }, e.prototype.log = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.storage.addLogMessage(s.LogLevel.Debug, o(t)), (e = this.printToConsole).log.apply(e, t);
      }, e.prototype.warn = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.storage.addLogMessage(s.LogLevel.Warning, o(t)), (e = this.printToConsole).warn.apply(e, t);
      }, e.prototype.error = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.storage.addLogMessage(s.LogLevel.Error, o(t)), (e = this.printToConsole).error.apply(e, t);
      }, e.prototype.trace = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.storage.addLogMessage(s.LogLevel.Trace, o(t)), (e = this.printToConsole).trace.apply(e, t);
      }, e.prototype.info = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.storage.addLogMessage(s.LogLevel.Info, o(t)), (e = this.printToConsole).info.apply(e, t);
      }, e.prototype.fatal = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.storage.addLogMessage(s.LogLevel.Fatal, o(t)), (e = this.printToConsole).error.apply(e, t);
      }, e.prototype.removeDeviceKey = function (e) {
        this.storage.addDeviceKey(e, null), this.printToConsole.info('Device key "' + e + '" removed');
      }, e.prototype.sendLog = function (e) {
        e.url = e.url || window ? window.location.toString() : "", this.storage.addLogEntry(e), this.printToConsole.printLog(e);
      }, e.prototype.sendIssueMarkdown = function (e, t) {
        return this.printToConsole.warn("Issue: " + e + ".\n" + t), this.storage.addIssue(a.IssueType.Issue, e, t);
      }, e.prototype.sendIssue = function (e, t) {
        this.printToConsole.warn("Issue: " + e + ".\n" + t);var n = "```\n" + t + "\n```";return this.storage.addIssue(a.IssueType.Issue, e, n);
      }, e.prototype.sendCrash = function (e, t) {
        this.printToConsole.error("Crash: " + e + ".\n" + t);var n = "```\n" + t + "\n```";return this.storage.addIssue(a.IssueType.Crash, e, n);
      }, e.prototype.sendUserFeedback = function (e, t) {
        return this.printToConsole.info("User Feedback: " + e + ".\n" + t), this.storage.addIssue(a.IssueType.Feedback, e, t);
      }, e.prototype.setDeviceKey = function (e, t) {
        this.printToConsole.info('Device key "' + e + '" set to "' + t + '"'), this.storage.addDeviceKey(e, t);
      }, e;
    }();t.Bugfender = c;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, { enumerable: !0, get: function get() {
          return t[n];
        } });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", { enumerable: !0, value: t });
    } : function (e, t) {
      e.default = t;
    }),
        o = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;var t = {};if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && r(t, e, n);
      }return i(t, e), t;
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.CallInfoFactory = void 0;var s = o(n(19)),
        a = o(n(20)),
        u = function () {
      function e() {}return e.prototype.create = function () {
        try {
          throw new Error();
        } catch (e) {
          return this.getCallInfo(e);
        }
      }, e.prototype.getCallInfo = function (e) {
        try {
          var t = this.getStackTraceSync(e),
              n = t[t.length - 1];return { file: "/" + n.fileName.substring(n.fileName.lastIndexOf("/") + 1), line: n.lineNumber, method: n.functionName };
        } catch (e) {
          return { file: void 0, line: void 0, method: void 0 };
        }
      }, e.prototype.getStackTraceSync = function (e) {
        return e.stack || e["opera#sourceloc"] ? s.parse(e) : a.backtrace();
      }, e;
    }();t.CallInfoFactory = u;
  }, function (e, t, n) {
    var r, i, o;!function (s, a) {
      "use strict";
      i = [n(6)], void 0 === (o = "function" == typeof (r = function r(e) {
        var t = /(^|@)\S+:\d+/,
            n = /^\s*at .*(\S+:\d+|\(native\))/m,
            r = /^(eval@)?(\[native code])?$/;return { parse: function parse(e) {
            if (void 0 !== e.stacktrace || void 0 !== e["opera#sourceloc"]) return this.parseOpera(e);if (e.stack && e.stack.match(n)) return this.parseV8OrIE(e);if (e.stack) return this.parseFFOrSafari(e);throw new Error("Cannot parse given Error object");
          }, extractLocation: function extractLocation(e) {
            if (-1 === e.indexOf(":")) return [e];var t = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e.replace(/[()]/g, ""));return [t[1], t[2] || void 0, t[3] || void 0];
          }, parseV8OrIE: function parseV8OrIE(t) {
            return t.stack.split("\n").filter(function (e) {
              return !!e.match(n);
            }, this).map(function (t) {
              t.indexOf("(eval ") > -1 && (t = t.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));var n = t.replace(/^\s+/, "").replace(/\(eval code/g, "("),
                  r = n.match(/ (\((.+):(\d+):(\d+)\)$)/),
                  i = (n = r ? n.replace(r[0], "") : n).split(/\s+/).slice(1),
                  o = this.extractLocation(r ? r[1] : i.pop()),
                  s = i.join(" ") || void 0,
                  a = ["eval", "<anonymous>"].indexOf(o[0]) > -1 ? void 0 : o[0];return new e({ functionName: s, fileName: a, lineNumber: o[1], columnNumber: o[2], source: t });
            }, this);
          }, parseFFOrSafari: function parseFFOrSafari(t) {
            return t.stack.split("\n").filter(function (e) {
              return !e.match(r);
            }, this).map(function (t) {
              if (t.indexOf(" > eval") > -1 && (t = t.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === t.indexOf("@") && -1 === t.indexOf(":")) return new e({ functionName: t });var n = /((.*".+"[^@]*)?[^@]*)(?:@)/,
                  r = t.match(n),
                  i = r && r[1] ? r[1] : void 0,
                  o = this.extractLocation(t.replace(n, ""));return new e({ functionName: i, fileName: o[0], lineNumber: o[1], columnNumber: o[2], source: t });
            }, this);
          }, parseOpera: function parseOpera(e) {
            return !e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length ? this.parseOpera9(e) : e.stack ? this.parseOpera11(e) : this.parseOpera10(e);
          }, parseOpera9: function parseOpera9(t) {
            for (var n = /Line (\d+).*script (?:in )?(\S+)/i, r = t.message.split("\n"), i = [], o = 2, s = r.length; o < s; o += 2) {
              var a = n.exec(r[o]);a && i.push(new e({ fileName: a[2], lineNumber: a[1], source: r[o] }));
            }return i;
          }, parseOpera10: function parseOpera10(t) {
            for (var n = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, r = t.stacktrace.split("\n"), i = [], o = 0, s = r.length; o < s; o += 2) {
              var a = n.exec(r[o]);a && i.push(new e({ functionName: a[3] || void 0, fileName: a[2], lineNumber: a[1], source: r[o] }));
            }return i;
          }, parseOpera11: function parseOpera11(n) {
            return n.stack.split("\n").filter(function (e) {
              return !!e.match(t) && !e.match(/^Error created at/);
            }, this).map(function (t) {
              var n,
                  r = t.split("@"),
                  i = this.extractLocation(r.pop()),
                  o = r.shift() || "",
                  s = o.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;o.match(/\(([^)]*)\)/) && (n = o.replace(/^[^(]+\(([^)]*)\)$/, "$1"));var a = void 0 === n || "[arguments not available]" === n ? void 0 : n.split(",");return new e({ functionName: s, args: a, fileName: i[0], lineNumber: i[1], columnNumber: i[2], source: t });
            }, this);
          } };
      }) ? r.apply(t, i) : r) || (e.exports = o);
    }();
  }, function (e, t, n) {
    var r, i, o;!function (s, a) {
      "use strict";
      i = [n(6)], void 0 === (o = "function" == typeof (r = function r(e) {
        return { backtrace: function backtrace(t) {
            var n = [],
                r = 10;"object" == typeof t && "number" == typeof t.maxStackSize && (r = t.maxStackSize);for (var i = arguments.callee; i && n.length < r && i.arguments;) {
              for (var o = new Array(i.arguments.length), s = 0; s < o.length; ++s) {
                o[s] = i.arguments[s];
              }/function(?:\s+([\w$]+))+\s*\(/.test(i.toString()) ? n.push(new e({ functionName: RegExp.$1 || void 0, args: o })) : n.push(new e({ args: o }));try {
                i = i.caller;
              } catch (e) {
                break;
              }
            }return n;
          } };
      }) ? r.apply(t, i) : r) || (e.exports = o);
    }();
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }function u(e) {
          var t;e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(s, a);
        }u((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          o,
          s = { label: 0, sent: function sent() {
          if (1 & i[0]) throw i[1];return i[1];
        }, trys: [], ops: [] };return o = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;function a(o) {
        return function (a) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");for (; s;) {
              try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {case 0:case 1:
                    i = o;break;case 4:
                    return s.label++, { value: o[1], done: !1 };case 5:
                    s.label++, r = o[1], o = [0];continue;case 7:
                    o = s.ops.pop(), s.trys.pop();continue;default:
                    if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      s = 0;continue;
                    }if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      s.label = o[1];break;
                    }if (6 === o[0] && s.label < i[1]) {
                      s.label = i[1], i = o;break;
                    }if (i && s.label < i[2]) {
                      s.label = i[2], s.ops.push(o);break;
                    }i[2] && s.ops.pop(), s.trys.pop();continue;}o = t.call(e, s);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }if (5 & o[0]) throw o[1];return { value: o[0] ? o[1] : void 0, done: !0 };
          }([o, a]);
        };
      }
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.Channel = t.createBroadcastChannel = t.MessageType = void 0;var o,
        s = n(45);!function (e) {
      e.ForceSend = "force-send", e.Ping = "ping", e.Pong = "pong";
    }(o = t.MessageType || (t.MessageType = {})), t.createBroadcastChannel = function () {
      return new s.BroadcastChannel("bf-sdk");
    };var a = function () {
      function e(e, t, n) {
        var r = this;this.channel = e, this.console = t, this.session = n, this.leader = !1, this.onForceSendCb = function () {}, this.sessionsStatus = {}, this.channel.onmessage = function (e) {
          return r.handleMessage(e);
        }, this.elector = s.createLeaderElection(this.channel, { fallbackInterval: 2e3, responseTime: 1e3 }), this.leaderPromise = this.elector.awaitLeadership(), this.leaderPromise.then(function () {
          r.leader = !0;
        });
      }return e.prototype.handleMessage = function (e) {
        switch (e.type) {case o.ForceSend:
            this.leader && this.onForceSendCb();break;case o.Ping:
            e.toSessionUUID === this.session.getUUID() && this.channel.postMessage({ type: o.Pong, fromSessionUUID: e.toSessionUUID, toSessionUUID: e.fromSessionUUID });break;case o.Pong:
            e.toSessionUUID === this.session.getUUID() && (this.sessionsStatus[e.fromSessionUUID] = !0);}
      }, e.prototype.isLeader = function () {
        return this.leader;
      }, e.prototype.notifyForceSend = function () {
        this.leader ? this.onForceSendCb() : this.channel.postMessage({ type: o.ForceSend });
      }, e.prototype.onForceSend = function (e) {
        this.onForceSendCb = e;
      }, e.prototype.onHasBecomeLeader = function () {
        return this.leaderPromise;
      }, e.prototype.isSessionActive = function (e) {
        return r(this, void 0, void 0, function () {
          var t = this;return i(this, function (n) {
            return this.session.getUUID() === e ? [2, !0] : [2, new Promise(function (n) {
              t.sessionsStatus[e] = !1, t.channel.postMessage({ type: o.Ping, fromSessionUUID: t.session.getUUID(), toSessionUUID: e }), setTimeout(function () {
                return n(t.sessionsStatus[e]);
              }, 250);
            })];
          });
        });
      }, e;
    }();t.Channel = a;
  }, function (e, t) {}, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Connection = void 0;var r = function () {
      function e(e) {
        this.navigator = e;
      }return e.prototype.isOnline = function () {
        return this.navigator.onLine;
      }, e;
    }();t.Connection = r;
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.CurrentSession = void 0;var r = function () {
      function e(e, t, n, r) {
        (this.device = e, this.sessionStorage = t, this.sessionsTable = n, this.uuidFactory = r, this.UUID_KEY = "bf_session_uuid", this.UDID_KEY = "bf_session_udid", this.uuid = this.sessionStorage.getItem(this.UUID_KEY), null === this.uuid) ? this.initSession() : this.sessionStorage.getItem(this.UDID_KEY) !== this.device.getUDID() && this.initSession();
      }return e.prototype.getUUID = function () {
        return this.uuid;
      }, e.prototype.initSession = function () {
        var e = this.device.getUDID();this.uuid = this.uuidFactory.create(), this.sessionStorage.setItem(this.UUID_KEY, this.uuid), this.sessionStorage.setItem(this.UDID_KEY, e), this.sessionsTable.add({ uuid: this.uuid, udid: e });
      }, e;
    }();t.CurrentSession = r;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
      void 0 === r && (r = n), Object.defineProperty(e, r, { enumerable: !0, get: function get() {
          return t[n];
        } });
    } : function (e, t, n, r) {
      void 0 === r && (r = n), e[r] = t[n];
    }),
        i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", { enumerable: !0, value: t });
    } : function (e, t) {
      e.default = t;
    }),
        o = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;var t = {};if (null != e) for (var n in e) {
        "default" !== n && Object.hasOwnProperty.call(e, n) && r(t, e, n);
      }return i(t, e), t;
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.Device = void 0;var s = o(n(26)),
        a = function () {
      function e(e, t, n) {
        this.localStorage = e, this.sdkVersion = t, this.uuidFactory = n, this.UDID_KEY = "bf_device_udid", this.DATA_KEY = "bf_device_data";
      }return e.prototype.getBrowserInfo = function () {
        return s.getParser(window.navigator.userAgent);
      }, e.prototype.getDeviceData = function () {
        var e = this.localStorage.getItem(this.DATA_KEY);return null === e && (e = "{}"), JSON.parse(e);
      }, e.prototype.getInfo = function (e) {
        var t = this.getBrowserInfo();return { udid: this.getUDID(), name: t.getBrowserName() + " " + t.getBrowserVersion() + " on " + t.getOSName() + " " + t.getOSVersion(), device_type: "", firebase_test_lab: !1, key_values: this.getDeviceData(), language: navigator.language || navigator.userLanguage, os_version: t.getOSVersion(), sdk_type: "web", sdk_version: this.sdkVersion.toString(), build: e.build, version: e.version };
      }, e.prototype.getUDID = function () {
        var e = this.localStorage.getItem(this.UDID_KEY);return null === e && (e = this.uuidFactory.create(), this.localStorage.setItem(this.UDID_KEY, e)), e;
      }, e.prototype.setDeviceKey = function (e, t) {
        var n = this.getDeviceData();null === t ? delete n[e] : n[e] = t, this.localStorage.setItem(this.DATA_KEY, JSON.stringify(n));
      }, e;
    }();t.Device = a;
  }, function (e, t, n) {
    e.exports = function (e) {
      var t = {};function n(r) {
        if (t[r]) return t[r].exports;var i = t[r] = { i: r, l: !1, exports: {} };return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
      }return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;if (4 & t && "object" == typeof e && e && e.__esModule) return e;var r = Object.create(null);if (n.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var i in e) {
          n.d(r, i, function (t) {
            return e[t];
          }.bind(null, i));
        }return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 90);
    }({ 17: function _(e, t, n) {
        "use strict";
        t.__esModule = !0, t.default = void 0;var r = n(18),
            i = function () {
          function e() {}return e.getFirstMatch = function (e, t) {
            var n = t.match(e);return n && n.length > 0 && n[1] || "";
          }, e.getSecondMatch = function (e, t) {
            var n = t.match(e);return n && n.length > 1 && n[2] || "";
          }, e.matchAndReturnConst = function (e, t, n) {
            if (e.test(t)) return n;
          }, e.getWindowsVersionName = function (e) {
            switch (e) {case "NT":
                return "NT";case "XP":
                return "XP";case "NT 5.0":
                return "2000";case "NT 5.1":
                return "XP";case "NT 5.2":
                return "2003";case "NT 6.0":
                return "Vista";case "NT 6.1":
                return "7";case "NT 6.2":
                return "8";case "NT 6.3":
                return "8.1";case "NT 10.0":
                return "10";default:
                return;}
          }, e.getMacOSVersionName = function (e) {
            var t = e.split(".").splice(0, 2).map(function (e) {
              return parseInt(e, 10) || 0;
            });if (t.push(0), 10 === t[0]) switch (t[1]) {case 5:
                return "Leopard";case 6:
                return "Snow Leopard";case 7:
                return "Lion";case 8:
                return "Mountain Lion";case 9:
                return "Mavericks";case 10:
                return "Yosemite";case 11:
                return "El Capitan";case 12:
                return "Sierra";case 13:
                return "High Sierra";case 14:
                return "Mojave";case 15:
                return "Catalina";default:
                return;}
          }, e.getAndroidVersionName = function (e) {
            var t = e.split(".").splice(0, 2).map(function (e) {
              return parseInt(e, 10) || 0;
            });if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
          }, e.getVersionPrecision = function (e) {
            return e.split(".").length;
          }, e.compareVersions = function (t, n, r) {
            void 0 === r && (r = !1);var i = e.getVersionPrecision(t),
                o = e.getVersionPrecision(n),
                s = Math.max(i, o),
                a = 0,
                u = e.map([t, n], function (t) {
              var n = s - e.getVersionPrecision(t),
                  r = t + new Array(n + 1).join(".0");return e.map(r.split("."), function (e) {
                return new Array(20 - e.length).join("0") + e;
              }).reverse();
            });for (r && (a = s - Math.min(i, o)), s -= 1; s >= a;) {
              if (u[0][s] > u[1][s]) return 1;if (u[0][s] === u[1][s]) {
                if (s === a) return 0;s -= 1;
              } else if (u[0][s] < u[1][s]) return -1;
            }
          }, e.map = function (e, t) {
            var n,
                r = [];if (Array.prototype.map) return Array.prototype.map.call(e, t);for (n = 0; n < e.length; n += 1) {
              r.push(t(e[n]));
            }return r;
          }, e.find = function (e, t) {
            var n, r;if (Array.prototype.find) return Array.prototype.find.call(e, t);for (n = 0, r = e.length; n < r; n += 1) {
              var i = e[n];if (t(i, n)) return i;
            }
          }, e.assign = function (e) {
            for (var t, n, r = e, i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++) {
              o[s - 1] = arguments[s];
            }if (Object.assign) return Object.assign.apply(Object, [e].concat(o));var a = function a() {
              var e = o[t];"object" == typeof e && null !== e && Object.keys(e).forEach(function (t) {
                r[t] = e[t];
              });
            };for (t = 0, n = o.length; t < n; t += 1) {
              a();
            }return e;
          }, e.getBrowserAlias = function (e) {
            return r.BROWSER_ALIASES_MAP[e];
          }, e.getBrowserTypeByAlias = function (e) {
            return r.BROWSER_MAP[e] || "";
          }, e;
        }();t.default = i, e.exports = t.default;
      }, 18: function _(e, t, n) {
        "use strict";
        t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = { "Amazon Silk": "amazon_silk", "Android Browser": "android", Bada: "bada", BlackBerry: "blackberry", Chrome: "chrome", Chromium: "chromium", Electron: "electron", Epiphany: "epiphany", Firefox: "firefox", Focus: "focus", Generic: "generic", "Google Search": "google_search", Googlebot: "googlebot", "Internet Explorer": "ie", "K-Meleon": "k_meleon", Maxthon: "maxthon", "Microsoft Edge": "edge", "MZ Browser": "mz", "NAVER Whale Browser": "naver", Opera: "opera", "Opera Coast": "opera_coast", PhantomJS: "phantomjs", Puffin: "puffin", QupZilla: "qupzilla", QQ: "qq", QQLite: "qqlite", Safari: "safari", Sailfish: "sailfish", "Samsung Internet for Android": "samsung_internet", SeaMonkey: "seamonkey", Sleipnir: "sleipnir", Swing: "swing", Tizen: "tizen", "UC Browser": "uc", Vivaldi: "vivaldi", "WebOS Browser": "webos", WeChat: "wechat", "Yandex Browser": "yandex", Roku: "roku" }, t.BROWSER_MAP = { amazon_silk: "Amazon Silk", android: "Android Browser", bada: "Bada", blackberry: "BlackBerry", chrome: "Chrome", chromium: "Chromium", electron: "Electron", epiphany: "Epiphany", firefox: "Firefox", focus: "Focus", generic: "Generic", googlebot: "Googlebot", google_search: "Google Search", ie: "Internet Explorer", k_meleon: "K-Meleon", maxthon: "Maxthon", edge: "Microsoft Edge", mz: "MZ Browser", naver: "NAVER Whale Browser", opera: "Opera", opera_coast: "Opera Coast", phantomjs: "PhantomJS", puffin: "Puffin", qupzilla: "QupZilla", qq: "QQ Browser", qqlite: "QQ Browser Lite", safari: "Safari", sailfish: "Sailfish", samsung_internet: "Samsung Internet for Android", seamonkey: "SeaMonkey", sleipnir: "Sleipnir", swing: "Swing", tizen: "Tizen", uc: "UC Browser", vivaldi: "Vivaldi", webos: "WebOS Browser", wechat: "WeChat", yandex: "Yandex Browser" }, t.PLATFORMS_MAP = { tablet: "tablet", mobile: "mobile", desktop: "desktop", tv: "tv" }, t.OS_MAP = { WindowsPhone: "Windows Phone", Windows: "Windows", MacOS: "macOS", iOS: "iOS", Android: "Android", WebOS: "WebOS", BlackBerry: "BlackBerry", Bada: "Bada", Tizen: "Tizen", Linux: "Linux", ChromeOS: "Chrome OS", PlayStation4: "PlayStation 4", Roku: "Roku" }, t.ENGINE_MAP = { EdgeHTML: "EdgeHTML", Blink: "Blink", Trident: "Trident", Presto: "Presto", Gecko: "Gecko", WebKit: "WebKit" };
      }, 90: function _(e, t, n) {
        "use strict";
        t.__esModule = !0, t.default = void 0;var r,
            i = (r = n(91)) && r.__esModule ? r : { default: r },
            o = n(18);function s(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }var a = function () {
          function e() {}var t, n;return e.getParser = function (e, t) {
            if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");return new i.default(e, t);
          }, e.parse = function (e) {
            return new i.default(e).getResult();
          }, t = e, (n = [{ key: "BROWSER_MAP", get: function get() {
              return o.BROWSER_MAP;
            } }, { key: "ENGINE_MAP", get: function get() {
              return o.ENGINE_MAP;
            } }, { key: "OS_MAP", get: function get() {
              return o.OS_MAP;
            } }, { key: "PLATFORMS_MAP", get: function get() {
              return o.PLATFORMS_MAP;
            } }]) && s(t, n), e;
        }();t.default = a, e.exports = t.default;
      }, 91: function _(e, t, n) {
        "use strict";
        t.__esModule = !0, t.default = void 0;var r = u(n(92)),
            i = u(n(93)),
            o = u(n(94)),
            s = u(n(95)),
            a = u(n(17));function u(e) {
          return e && e.__esModule ? e : { default: e };
        }var c = function () {
          function e(e, t) {
            if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
          }var t = e.prototype;return t.getUA = function () {
            return this._ua;
          }, t.test = function (e) {
            return e.test(this._ua);
          }, t.parseBrowser = function () {
            var e = this;this.parsedResult.browser = {};var t = a.default.find(r.default, function (t) {
              if ("function" == typeof t.test) return t.test(e);if (t.test instanceof Array) return t.test.some(function (t) {
                return e.test(t);
              });throw new Error("Browser's test function is not valid");
            });return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
          }, t.getBrowser = function () {
            return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
          }, t.getBrowserName = function (e) {
            return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
          }, t.getBrowserVersion = function () {
            return this.getBrowser().version;
          }, t.getOS = function () {
            return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
          }, t.parseOS = function () {
            var e = this;this.parsedResult.os = {};var t = a.default.find(i.default, function (t) {
              if ("function" == typeof t.test) return t.test(e);if (t.test instanceof Array) return t.test.some(function (t) {
                return e.test(t);
              });throw new Error("Browser's test function is not valid");
            });return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
          }, t.getOSName = function (e) {
            var t = this.getOS().name;return e ? String(t).toLowerCase() || "" : t || "";
          }, t.getOSVersion = function () {
            return this.getOS().version;
          }, t.getPlatform = function () {
            return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
          }, t.getPlatformType = function (e) {
            void 0 === e && (e = !1);var t = this.getPlatform().type;return e ? String(t).toLowerCase() || "" : t || "";
          }, t.parsePlatform = function () {
            var e = this;this.parsedResult.platform = {};var t = a.default.find(o.default, function (t) {
              if ("function" == typeof t.test) return t.test(e);if (t.test instanceof Array) return t.test.some(function (t) {
                return e.test(t);
              });throw new Error("Browser's test function is not valid");
            });return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
          }, t.getEngine = function () {
            return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
          }, t.getEngineName = function (e) {
            return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
          }, t.parseEngine = function () {
            var e = this;this.parsedResult.engine = {};var t = a.default.find(s.default, function (t) {
              if ("function" == typeof t.test) return t.test(e);if (t.test instanceof Array) return t.test.some(function (t) {
                return e.test(t);
              });throw new Error("Browser's test function is not valid");
            });return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
          }, t.parse = function () {
            return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
          }, t.getResult = function () {
            return a.default.assign({}, this.parsedResult);
          }, t.satisfies = function (e) {
            var t = this,
                n = {},
                r = 0,
                i = {},
                o = 0;if (Object.keys(e).forEach(function (t) {
              var s = e[t];"string" == typeof s ? (i[t] = s, o += 1) : "object" == typeof s && (n[t] = s, r += 1);
            }), r > 0) {
              var s = Object.keys(n),
                  u = a.default.find(s, function (e) {
                return t.isOS(e);
              });if (u) {
                var c = this.satisfies(n[u]);if (void 0 !== c) return c;
              }var l = a.default.find(s, function (e) {
                return t.isPlatform(e);
              });if (l) {
                var f = this.satisfies(n[l]);if (void 0 !== f) return f;
              }
            }if (o > 0) {
              var h = Object.keys(i),
                  d = a.default.find(h, function (e) {
                return t.isBrowser(e, !0);
              });if (void 0 !== d) return this.compareVersion(i[d]);
            }
          }, t.isBrowser = function (e, t) {
            void 0 === t && (t = !1);var n = this.getBrowserName().toLowerCase(),
                r = e.toLowerCase(),
                i = a.default.getBrowserTypeByAlias(r);return t && i && (r = i.toLowerCase()), r === n;
          }, t.compareVersion = function (e) {
            var t = [0],
                n = e,
                r = !1,
                i = this.getBrowserVersion();if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (n = e.substr(1), "=" === e[1] ? (r = !0, n = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? n = e.substr(1) : "~" === e[0] && (r = !0, n = e.substr(1)), t.indexOf(a.default.compareVersions(i, n, r)) > -1;
          }, t.isOS = function (e) {
            return this.getOSName(!0) === String(e).toLowerCase();
          }, t.isPlatform = function (e) {
            return this.getPlatformType(!0) === String(e).toLowerCase();
          }, t.isEngine = function (e) {
            return this.getEngineName(!0) === String(e).toLowerCase();
          }, t.is = function (e) {
            return this.isBrowser(e) || this.isOS(e) || this.isPlatform(e);
          }, t.some = function (e) {
            var t = this;return void 0 === e && (e = []), e.some(function (e) {
              return t.is(e);
            });
          }, e;
        }();t.default = c, e.exports = t.default;
      }, 92: function _(e, t, n) {
        "use strict";
        t.__esModule = !0, t.default = void 0;var r,
            i = (r = n(17)) && r.__esModule ? r : { default: r },
            o = /version\/(\d+(\.?_?\d+)+)/i,
            s = [{ test: [/googlebot/i], describe: function describe(e) {
            var t = { name: "Googlebot" },
                n = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/opera/i], describe: function describe(e) {
            var t = { name: "Opera" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/opr\/|opios/i], describe: function describe(e) {
            var t = { name: "Opera" },
                n = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/SamsungBrowser/i], describe: function describe(e) {
            var t = { name: "Samsung Internet for Android" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/Whale/i], describe: function describe(e) {
            var t = { name: "NAVER Whale Browser" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/MZBrowser/i], describe: function describe(e) {
            var t = { name: "MZ Browser" },
                n = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/focus/i], describe: function describe(e) {
            var t = { name: "Focus" },
                n = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/swing/i], describe: function describe(e) {
            var t = { name: "Swing" },
                n = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/coast/i], describe: function describe(e) {
            var t = { name: "Opera Coast" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/yabrowser/i], describe: function describe(e) {
            var t = { name: "Yandex Browser" },
                n = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/ucbrowser/i], describe: function describe(e) {
            var t = { name: "UC Browser" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/Maxthon|mxios/i], describe: function describe(e) {
            var t = { name: "Maxthon" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/epiphany/i], describe: function describe(e) {
            var t = { name: "Epiphany" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/puffin/i], describe: function describe(e) {
            var t = { name: "Puffin" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/sleipnir/i], describe: function describe(e) {
            var t = { name: "Sleipnir" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/k-meleon/i], describe: function describe(e) {
            var t = { name: "K-Meleon" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/micromessenger/i], describe: function describe(e) {
            var t = { name: "WeChat" },
                n = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/qqbrowser/i], describe: function describe(e) {
            var t = { name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser" },
                n = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/msie|trident/i], describe: function describe(e) {
            var t = { name: "Internet Explorer" },
                n = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/\sedg\//i], describe: function describe(e) {
            var t = { name: "Microsoft Edge" },
                n = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/edg([ea]|ios)/i], describe: function describe(e) {
            var t = { name: "Microsoft Edge" },
                n = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/vivaldi/i], describe: function describe(e) {
            var t = { name: "Vivaldi" },
                n = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/seamonkey/i], describe: function describe(e) {
            var t = { name: "SeaMonkey" },
                n = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/sailfish/i], describe: function describe(e) {
            var t = { name: "Sailfish" },
                n = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);return n && (t.version = n), t;
          } }, { test: [/silk/i], describe: function describe(e) {
            var t = { name: "Amazon Silk" },
                n = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/phantom/i], describe: function describe(e) {
            var t = { name: "PhantomJS" },
                n = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/slimerjs/i], describe: function describe(e) {
            var t = { name: "SlimerJS" },
                n = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe: function describe(e) {
            var t = { name: "BlackBerry" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/(web|hpw)[o0]s/i], describe: function describe(e) {
            var t = { name: "WebOS Browser" },
                n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/bada/i], describe: function describe(e) {
            var t = { name: "Bada" },
                n = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/tizen/i], describe: function describe(e) {
            var t = { name: "Tizen" },
                n = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/qupzilla/i], describe: function describe(e) {
            var t = { name: "QupZilla" },
                n = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/firefox|iceweasel|fxios/i], describe: function describe(e) {
            var t = { name: "Firefox" },
                n = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/electron/i], describe: function describe(e) {
            var t = { name: "Electron" },
                n = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/chromium/i], describe: function describe(e) {
            var t = { name: "Chromium" },
                n = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/chrome|crios|crmo/i], describe: function describe(e) {
            var t = { name: "Chrome" },
                n = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/GSA/i], describe: function describe(e) {
            var t = { name: "Google Search" },
                n = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: function test(e) {
            var t = !e.test(/like android/i),
                n = e.test(/android/i);return t && n;
          }, describe: function describe(e) {
            var t = { name: "Android Browser" },
                n = i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/playstation 4/i], describe: function describe(e) {
            var t = { name: "PlayStation 4" },
                n = i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/safari|applewebkit/i], describe: function describe(e) {
            var t = { name: "Safari" },
                n = i.default.getFirstMatch(o, e);return n && (t.version = n), t;
          } }, { test: [/.*/i], describe: function describe(e) {
            var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;return { name: i.default.getFirstMatch(t, e), version: i.default.getSecondMatch(t, e) };
          } }];t.default = s, e.exports = t.default;
      }, 93: function _(e, t, n) {
        "use strict";
        t.__esModule = !0, t.default = void 0;var r,
            i = (r = n(17)) && r.__esModule ? r : { default: r },
            o = n(18),
            s = [{ test: [/Roku\/DVP/], describe: function describe(e) {
            var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);return { name: o.OS_MAP.Roku, version: t };
          } }, { test: [/windows phone/i], describe: function describe(e) {
            var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);return { name: o.OS_MAP.WindowsPhone, version: t };
          } }, { test: [/windows /i], describe: function describe(e) {
            var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e),
                n = i.default.getWindowsVersionName(t);return { name: o.OS_MAP.Windows, version: t, versionName: n };
          } }, { test: [/Macintosh(.*?) FxiOS(.*?) Version\//], describe: function describe(e) {
            var t = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);return { name: o.OS_MAP.iOS, version: t };
          } }, { test: [/macintosh/i], describe: function describe(e) {
            var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."),
                n = i.default.getMacOSVersionName(t),
                r = { name: o.OS_MAP.MacOS, version: t };return n && (r.versionName = n), r;
          } }, { test: [/(ipod|iphone|ipad)/i], describe: function describe(e) {
            var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");return { name: o.OS_MAP.iOS, version: t };
          } }, { test: function test(e) {
            var t = !e.test(/like android/i),
                n = e.test(/android/i);return t && n;
          }, describe: function describe(e) {
            var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e),
                n = i.default.getAndroidVersionName(t),
                r = { name: o.OS_MAP.Android, version: t };return n && (r.versionName = n), r;
          } }, { test: [/(web|hpw)[o0]s/i], describe: function describe(e) {
            var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e),
                n = { name: o.OS_MAP.WebOS };return t && t.length && (n.version = t), n;
          } }, { test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe: function describe(e) {
            var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);return { name: o.OS_MAP.BlackBerry, version: t };
          } }, { test: [/bada/i], describe: function describe(e) {
            var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);return { name: o.OS_MAP.Bada, version: t };
          } }, { test: [/tizen/i], describe: function describe(e) {
            var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);return { name: o.OS_MAP.Tizen, version: t };
          } }, { test: [/linux/i], describe: function describe() {
            return { name: o.OS_MAP.Linux };
          } }, { test: [/CrOS/], describe: function describe() {
            return { name: o.OS_MAP.ChromeOS };
          } }, { test: [/PlayStation 4/], describe: function describe(e) {
            var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);return { name: o.OS_MAP.PlayStation4, version: t };
          } }];t.default = s, e.exports = t.default;
      }, 94: function _(e, t, n) {
        "use strict";
        t.__esModule = !0, t.default = void 0;var r,
            i = (r = n(17)) && r.__esModule ? r : { default: r },
            o = n(18),
            s = [{ test: [/googlebot/i], describe: function describe() {
            return { type: "bot", vendor: "Google" };
          } }, { test: [/huawei/i], describe: function describe(e) {
            var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova",
                n = { type: o.PLATFORMS_MAP.mobile, vendor: "Huawei" };return t && (n.model = t), n;
          } }, { test: [/nexus\s*(?:7|8|9|10).*/i], describe: function describe() {
            return { type: o.PLATFORMS_MAP.tablet, vendor: "Nexus" };
          } }, { test: [/ipad/i], describe: function describe() {
            return { type: o.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad" };
          } }, { test: [/Macintosh(.*?) FxiOS(.*?) Version\//], describe: function describe() {
            return { type: o.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad" };
          } }, { test: [/kftt build/i], describe: function describe() {
            return { type: o.PLATFORMS_MAP.tablet, vendor: "Amazon", model: "Kindle Fire HD 7" };
          } }, { test: [/silk/i], describe: function describe() {
            return { type: o.PLATFORMS_MAP.tablet, vendor: "Amazon" };
          } }, { test: [/tablet(?! pc)/i], describe: function describe() {
            return { type: o.PLATFORMS_MAP.tablet };
          } }, { test: function test(e) {
            var t = e.test(/ipod|iphone/i),
                n = e.test(/like (ipod|iphone)/i);return t && !n;
          }, describe: function describe(e) {
            var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);return { type: o.PLATFORMS_MAP.mobile, vendor: "Apple", model: t };
          } }, { test: [/nexus\s*[0-6].*/i, /galaxy nexus/i], describe: function describe() {
            return { type: o.PLATFORMS_MAP.mobile, vendor: "Nexus" };
          } }, { test: [/[^-]mobi/i], describe: function describe() {
            return { type: o.PLATFORMS_MAP.mobile };
          } }, { test: function test(e) {
            return "blackberry" === e.getBrowserName(!0);
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.mobile, vendor: "BlackBerry" };
          } }, { test: function test(e) {
            return "bada" === e.getBrowserName(!0);
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.mobile };
          } }, { test: function test(e) {
            return "windows phone" === e.getBrowserName();
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.mobile, vendor: "Microsoft" };
          } }, { test: function test(e) {
            var t = Number(String(e.getOSVersion()).split(".")[0]);return "android" === e.getOSName(!0) && t >= 3;
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.tablet };
          } }, { test: function test(e) {
            return "android" === e.getOSName(!0);
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.mobile };
          } }, { test: function test(e) {
            return "macos" === e.getOSName(!0);
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.desktop, vendor: "Apple" };
          } }, { test: function test(e) {
            return "windows" === e.getOSName(!0);
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.desktop };
          } }, { test: function test(e) {
            return "linux" === e.getOSName(!0);
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.desktop };
          } }, { test: function test(e) {
            return "playstation 4" === e.getOSName(!0);
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.tv };
          } }, { test: function test(e) {
            return "roku" === e.getOSName(!0);
          }, describe: function describe() {
            return { type: o.PLATFORMS_MAP.tv };
          } }];t.default = s, e.exports = t.default;
      }, 95: function _(e, t, n) {
        "use strict";
        t.__esModule = !0, t.default = void 0;var r,
            i = (r = n(17)) && r.__esModule ? r : { default: r },
            o = n(18),
            s = [{ test: function test(e) {
            return "microsoft edge" === e.getBrowserName(!0);
          }, describe: function describe(e) {
            if (/\sedg\//i.test(e)) return { name: o.ENGINE_MAP.Blink };var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);return { name: o.ENGINE_MAP.EdgeHTML, version: t };
          } }, { test: [/trident/i], describe: function describe(e) {
            var t = { name: o.ENGINE_MAP.Trident },
                n = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: function test(e) {
            return e.test(/presto/i);
          }, describe: function describe(e) {
            var t = { name: o.ENGINE_MAP.Presto },
                n = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: function test(e) {
            var t = e.test(/gecko/i),
                n = e.test(/like gecko/i);return t && !n;
          }, describe: function describe(e) {
            var t = { name: o.ENGINE_MAP.Gecko },
                n = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }, { test: [/(apple)?webkit\/537\.36/i], describe: function describe() {
            return { name: o.ENGINE_MAP.Blink };
          } }, { test: [/(apple)?webkit/i], describe: function describe(e) {
            var t = { name: o.ENGINE_MAP.WebKit },
                n = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);return n && (t.version = n), t;
          } }];t.default = s, e.exports = t.default;
      } });
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }function u(e) {
          var t;e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(s, a);
        }u((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          o,
          s = { label: 0, sent: function sent() {
          if (1 & i[0]) throw i[1];return i[1];
        }, trys: [], ops: [] };return o = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;function a(o) {
        return function (a) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");for (; s;) {
              try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {case 0:case 1:
                    i = o;break;case 4:
                    return s.label++, { value: o[1], done: !1 };case 5:
                    s.label++, r = o[1], o = [0];continue;case 7:
                    o = s.ops.pop(), s.trys.pop();continue;default:
                    if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      s = 0;continue;
                    }if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      s.label = o[1];break;
                    }if (6 === o[0] && s.label < i[1]) {
                      s.label = i[1], i = o;break;
                    }if (i && s.label < i[2]) {
                      s.label = i[2], s.ops.push(o);break;
                    }i[2] && s.ops.pop(), s.trys.pop();continue;}o = t.call(e, s);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }if (5 & o[0]) throw o[1];return { value: o[0] ? o[1] : void 0, done: !0 };
          }([o, a]);
        };
      }
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.StorageProcessor = void 0;var o = function () {
      function e(e, t, n, r, i, o, s, a, u, c) {
        this.api = e, this.channel = t, this.connection = n, this.console = r, this.device = i, this.deviceKeysTable = o, this.issuesTable = s, this.logsTable = a, this.sessionFactory = u, this.sessionsTable = c, this.BATCH_SIZE = 500, this.checkIsDeviceEnabledIntervalMs = 3e5, this.runIntervalMs = 15e3, this.forceSend = !1, this.isAppValid = !0, this.isDeviceEnabled = !1, this.isRunning = !1;
      }return e.prototype.init = function (e) {
        var t = this;this.options = e, this.checkIsDeviceEnabled(), setInterval(this.run.bind(this), this.runIntervalMs), setInterval(this.checkIsDeviceEnabled.bind(this), this.checkIsDeviceEnabledIntervalMs), this.channel.onHasBecomeLeader().then(function () {
          t.run();
        }), this.channel.onForceSend(function () {
          t.forceSend = !0;
        });
      }, e.prototype.checkIsDeviceEnabled = function () {
        var e = this,
            t = this.device.getInfo(this.options);return this.api.getDeviceStatus(t).then(function (t) {
          e.isAppValid = t.isAppValid, e.isDeviceEnabled = t.isDeviceEnabled;
        }, function () {});
      }, e.prototype.cleanupSessions = function (e) {
        return r(this, void 0, void 0, function () {
          var t, n, r, o, s;return i(this, function (i) {
            switch (i.label) {case 0:
                t = 0, n = e, i.label = 1;case 1:
                return t < n.length ? (r = n[t], [4, this.channel.isSessionActive(r.uuid)]) : [3, 8];case 2:
                return o = i.sent(), [4, this.hasData(r)];case 3:
                if (s = i.sent(), !(!o && !s)) return [3, 7];i.label = 4;case 4:
                return i.trys.push([4, 6,, 7]), [4, this.sessionsTable.delete(r.uuid)];case 5:
                return i.sent(), [3, 7];case 6:
                return i.sent(), [3, 7];case 7:
                return t++, [3, 1];case 8:
                return [2];}
          });
        });
      }, e.prototype.hasData = function (e) {
        return r(this, void 0, void 0, function () {
          var t, n, r, o;return i(this, function (i) {
            switch (i.label) {case 0:
                return i.trys.push([0, 2,, 3]), [4, Promise.all([this.logsTable.count(e.uuid), this.issuesTable.count(e.uuid), this.deviceKeysTable.count(e.uuid)])];case 1:
                return t = i.sent(), n = t[0], r = t[1], o = t[2], [2, n > 0 || r > 0 || o > 0];case 2:
                return i.sent(), [2, !0];case 3:
                return [2];}
          });
        });
      }, e.prototype.registerSession = function (e) {
        return r(this, void 0, void 0, function () {
          var t, n;return i(this, function (r) {
            switch (r.label) {case 0:
                return e.id ? [3, 2] : (t = this.sessionFactory.create(e.uuid, this.options), [4, this.api.sendSession(t)]);case 1:
                n = r.sent().id, e.id = n, this.sessionsTable.update(e.uuid, { id: n }), r.label = 2;case 2:
                return [2, e];}
          });
        });
      }, e.prototype.canRun = function () {
        return this.connection.isOnline() && this.channel.isLeader() && this.isAppValid && (this.isDeviceEnabled || this.forceSend) && !this.isRunning;
      }, e.prototype.run = function () {
        return r(this, void 0, void 0, function () {
          var e, t, n, r;return i(this, function (i) {
            switch (i.label) {case 0:
                return this.canRun() ? (this.isRunning = !0, [4, this.sessionsTable.getAll()]) : [2];case 1:
                e = i.sent(), t = 0, n = e, i.label = 2;case 2:
                return t < n.length ? (r = n[t], [4, this.registerSession(r)]) : [3, 7];case 3:
                return r = i.sent(), [4, this.sendLogs(r)];case 4:
                return i.sent(), [4, this.sendIssues(r)];case 5:
                i.sent(), i.label = 6;case 6:
                return t++, [3, 2];case 7:
                return [4, this.sendDeviceData()];case 8:
                return i.sent(), [4, this.cleanupSessions(e)];case 9:
                return i.sent(), this.forceSend = !1, this.isRunning = !1, [2];}
          });
        });
      }, e.prototype.sendDeviceData = function () {
        return r(this, void 0, void 0, function () {
          var e,
              t,
              n = this;return i(this, function (r) {
            switch (r.label) {case 0:
                return r.trys.push([0, 5,, 6]), e = {}, [4, this.deviceKeysTable.getAll()];case 1:
                return (t = r.sent()).forEach(function (t) {
                  e[t.data.key] = t.data.value;
                }), t.length ? [4, Promise.all(Object.entries(e).map(function (e) {
                  var t = e[0],
                      r = e[1];return n.api.setDeviceKey(n.device.getUDID(), t, r);
                }))] : [3, 4];case 2:
                return r.sent(), [4, this.deviceKeysTable.deleteBatch(t.length)];case 3:
                r.sent(), r.label = 4;case 4:
                return [3, 6];case 5:
                return r.sent(), [3, 6];case 6:
                return [2];}
          });
        });
      }, e.prototype.sendIssues = function (e) {
        return r(this, void 0, void 0, function () {
          var t, n, r, o, s, a;return i(this, function (i) {
            switch (i.label) {case 0:
                return i.trys.push([0, 7,, 8]), [4, this.issuesTable.getBatch(e.uuid, this.BATCH_SIZE)];case 1:
                t = i.sent(), n = 0, r = t, i.label = 2;case 2:
                return n < r.length ? (o = r[n], s = o.data, a = this.options.baseURL + "/intent/" + this.options.appID + "/issue/" + s.uuid, [4, this.api.sendIssue(s.uuid, a, s.title, s.markdown, s.type, e.id)]) : [3, 6];case 3:
                return i.sent(), [4, this.issuesTable.deleteById(o.id)];case 4:
                i.sent(), i.label = 5;case 5:
                return n++, [3, 2];case 6:
                return [3, 8];case 7:
                return i.sent(), [3, 8];case 8:
                return [2];}
          });
        });
      }, e.prototype.sendLogs = function (e) {
        return r(this, void 0, void 0, function () {
          var t, n;return i(this, function (r) {
            switch (r.label) {case 0:
                return r.trys.push([0, 5,, 6]), [4, this.logsTable.getBatch(e.uuid, this.BATCH_SIZE)];case 1:
                return t = r.sent(), (n = t.map(function (e) {
                  return e.data;
                })).length ? [4, this.api.sendLogs(e.id, n)] : [3, 4];case 2:
                return r.sent(), [4, this.logsTable.deleteBatch(e.uuid, n.length)];case 3:
                r.sent(), r.label = 4;case 4:
                return [3, 6];case 5:
                return r.sent(), [3, 6];case 6:
                return [2];}
          });
        });
      }, e;
    }();t.StorageProcessor = o;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }var r = Array(e),
          i = 0;for (t = 0; t < n; t++) {
        for (var o = arguments[t], s = 0, a = o.length; s < a; s++, i++) {
          r[i] = o[s];
        }
      }return r;
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.StorageWriterHub = void 0;var i = n(7),
        o = n(3),
        s = function () {
      function e(e, t, n, r, o, s, a) {
        this.callInfoFactory = e, this.channel = t, this.device = n, this.worker = r, this.session = o, this.uuidFactory = s, this.window = a, this.sanitizer = new i.StorageWriterSanitizer();
      }return e.prototype.init = function (e) {
        var t = this.session.getUUID();this.options = e, this.postMessage({ type: "init", data: { options: e, sessionUUID: t } });
      }, e.prototype.postMessage = function (e) {
        try {
          this.worker.postMessage(this.sanitizer.sanitize(e));
        } catch (e) {}
      }, e.prototype.addDeviceKey = function (e, t) {
        if ("string" != typeof e) throw new Error("The device-key 'key' must be a string.");this.device.setDeviceKey(e, t), this.postMessage({ type: "device-key", data: { key: e, value: t, callInfo: this.callInfoFactory.create() } });
      }, e.prototype.addLogEntry = function (e) {
        this.postMessage({ type: "log-entry", data: { log: e, callInfo: this.callInfoFactory.create() } });
      }, e.prototype.addLogMessage = function (e, t) {
        var n,
            i = {},
            s = t[0],
            a = t.slice(1);try {
          s = this.sanitizer.toString(s);
        } catch (e) {
          s = o.format(s);
        }n = a.length > 0 ? o.format.apply(void 0, r([s], a)) : s, i.level = e, i.text = n, i.url = this.window ? this.window.location.toString() : null, this.addLogEntry(i);
      }, e.prototype.addIssue = function (e, t, n) {
        if ("string" != typeof t) throw new Error("The crash/issue/feedback 'title' must be a string.");var r = this.uuidFactory.create();return this.postMessage({ type: "issue", data: { type: e, title: t, markdown: n, uuid: r, callInfo: this.callInfoFactory.create() } }), this.channel.notifyForceSend(), this.options.baseURL + "/intent/" + this.options.appID + "/issue/" + r;
      }, e;
    }();t.StorageWriterHub = s;
  }, function (e, t, n) {
    "use strict";
    n.r(t);var r = n(14),
        i = n.n(r);t.default = function () {
      return i()("/*! bugfender-web/20210212 (v1.5.0-33f931b-lib) */!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:\"Module\"}),Object.defineProperty(e,\"__esModule\",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&\"object\"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,\"default\",{enumerable:!0,value:e}),2&t&&\"string\"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,\"a\",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p=\"\",n(n.s=0)}([function(e,t,n){\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0});var r=n(1),o=n(2),i=n(4),u=n(10),a=n(11),s=n(12),c=new o.Database,l=new i.LogFactory,f=new u.DeviceKeysTable(c.devicekeys),h=new a.IssuesTable(c.issues),p=new s.LogsTable(c.logs,new i.LogFactory);new r.StorageWriter(f,h,l,p,self),t.default=null},function(e,t,n){\"use strict\";var r=this&&this.__awaiter||function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function u(e){try{s(r.next(e))}catch(e){i(e)}}function a(e){try{s(r.throw(e))}catch(e){i(e)}}function s(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(u,a)}s((r=r.apply(e,t||[])).next())}))},o=this&&this.__generator||function(e,t){var n,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},\"function\"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError(\"Generator is already executing.\");for(;u;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=t.call(e,u)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}};Object.defineProperty(t,\"__esModule\",{value:!0}),t.StorageWriter=void 0;var i=function(){function e(e,t,n,r,o){var i=this;this.deviceKeysTable=e,this.issuesTable=t,this.logFactory=n,this.logsTable=r,this.scope=o,this.isClearingSpace=!1,this.logsQueue=[],o.addEventListener(\"message\",(function(e){i.handleMessage(e.data)}))}return e.prototype.handleMessage=function(e){switch(e.type){case\"device-key\":return this.addDeviceKey(e.data.key,e.data.value,e.data.callInfo);case\"init\":this.options=e.data.options,this.sessionUUID=e.data.sessionUUID;break;case\"issue\":return this.addIssue(e.data.type,e.data.title,e.data.markdown,e.data.uuid,e.data.callInfo);case\"log-entry\":return this.addLogEntry(e.data.log,e.data.callInfo)}},e.prototype.addDeviceKey=function(e,t,n){this.deviceKeysTable.add({sessionUUID:this.sessionUUID,data:{key:e,value:t}}),this.addLog(this.logFactory.createFromDeviceKey(e,t,n))},e.prototype.addLog=function(e){return r(this,void 0,void 0,(function(){var t,n;return o(this,(function(r){switch(r.label){case 0:return t={sessionUUID:this.sessionUUID,data:e},this.isClearingSpace?(this.logsQueue.push(t),[3,7]):[3,1];case 1:return r.trys.push([1,3,,7]),[4,this.logsTable.add(t)];case 2:return r.sent(),[3,7];case 3:return n=r.sent(),this.isQuotaExceededError(n)?(this.logsQueue.push(t),this.isClearingSpace=!0,[4,this.logsTable.deleteOldLogs(this.sessionUUID)]):[3,6];case 4:return r.sent(),[4,this.processLogsQueue()];case 5:r.sent(),this.isClearingSpace=!1,r.label=6;case 6:return[3,7];case 7:return[2]}}))}))},e.prototype.addLogEntry=function(e,t){this.addLog(this.logFactory.createFromEntry(e,t))},e.prototype.addIssue=function(e,t,n,r,o){this.issuesTable.add({sessionUUID:this.sessionUUID,data:{markdown:n,title:t,type:e,uuid:r}}),this.addLog(this.logFactory.createFromIssue(r,o))},e.prototype.generateQuotaExceededError=function(){if(Math.random()>.9){var e=new Error;throw e.name=\"QuotaExceededError\",e}},e.prototype.isQuotaExceededError=function(e){return\"QuotaExceededError\"===e.name||e.inner&&\"QuotaExceededError\"===e.inner.name},e.prototype.processLogsQueue=function(){return r(this,void 0,void 0,(function(){var e,t;return o(this,(function(n){switch(n.label){case 0:if(!(this.logsQueue.length>0))return[3,7];e=this.logsQueue[0],n.label=1;case 1:return n.trys.push([1,3,,6]),[4,this.logsTable.add(e)];case 2:return n.sent(),this.logsQueue.shift(),[3,6];case 3:return t=n.sent(),this.isQuotaExceededError(t)?[4,this.logsTable.deleteOldLogs(this.sessionUUID)]:[3,5];case 4:n.sent(),n.label=5;case 5:return[3,6];case 6:return[3,0];case 7:return[2]}}))}))},e}();t.StorageWriter=i},function(e,t,n){\"use strict\";var r,o=this&&this.__extends||(r=function(e,t){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)},function(e,t){function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}),i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,\"__esModule\",{value:!0}),t.Database=void 0;var u=function(e){function t(){var t=e.call(this,\"bf_sdk\")||this;return t.version(1).stores({devicekeys:\"++id, sessionUUID\",issues:\"++id, sessionUUID\",logs:\"++id, sessionUUID\",sessions:\"uuid\"}),t.devicekeys=t.table(\"devicekeys\"),t.issues=t.table(\"issues\"),t.logs=t.table(\"logs\"),t.sessions=t.table(\"sessions\"),t}return o(t,e),t}(i(n(3)).default);t.Database=u},function(e,t,n){\"use strict\";n.r(t);var r=function(){return(r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function o(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var r=Array(e),o=0;for(t=0;t<n;t++)for(var i=arguments[t],u=0,a=i.length;u<a;u++,o++)r[o]=i[u];return r}var i=Object.keys,u=Array.isArray,a=\"undefined\"!=typeof self?self:\"undefined\"!=typeof window?window:global;function s(e,t){return\"object\"!=typeof t||i(t).forEach((function(n){e[n]=t[n]})),e}\"undefined\"==typeof Promise||a.Promise||(a.Promise=Promise);var c=Object.getPrototypeOf,l={}.hasOwnProperty;function f(e,t){return l.call(e,t)}function h(e,t){\"function\"==typeof t&&(t=t(c(e))),i(t).forEach((function(n){d(e,n,t[n])}))}var p=Object.defineProperty;function d(e,t,n,r){p(e,t,s(n&&f(n,\"get\")&&\"function\"==typeof n.get?{get:n.get,set:n.set,configurable:!0}:{value:n,configurable:!0,writable:!0},r))}function y(e){return{from:function(t){return e.prototype=Object.create(t.prototype),d(e.prototype,\"constructor\",e),{extend:h.bind(null,e.prototype)}}}}var v=Object.getOwnPropertyDescriptor;var m=[].slice;function g(e,t,n){return m.call(e,t,n)}function b(e,t){return t(e)}function w(e){if(!e)throw new Error(\"Assertion Failed\")}function _(e){a.setImmediate?setImmediate(e):setTimeout(e,0)}function x(e,t){return e.reduce((function(e,n,r){var o=t(n,r);return o&&(e[o[0]]=o[1]),e}),{})}function k(e,t){if(f(e,t))return e[t];if(!t)return e;if(\"string\"!=typeof t){for(var n=[],r=0,o=t.length;r<o;++r){var i=k(e,t[r]);n.push(i)}return n}var u=t.indexOf(\".\");if(-1!==u){var a=e[t.substr(0,u)];return void 0===a?void 0:k(a,t.substr(u+1))}}function O(e,t,n){if(e&&void 0!==t&&!(\"isFrozen\"in Object&&Object.isFrozen(e)))if(\"string\"!=typeof t&&\"length\"in t){w(\"string\"!=typeof n&&\"length\"in n);for(var r=0,o=t.length;r<o;++r)O(e,t[r],n[r])}else{var i=t.indexOf(\".\");if(-1!==i){var a=t.substr(0,i),s=t.substr(i+1);if(\"\"===s)void 0===n?u(e)&&!isNaN(parseInt(a))?e.splice(a,1):delete e[a]:e[a]=n;else{var c=e[a];c||(c=e[a]={}),O(c,s,n)}}else void 0===n?u(e)&&!isNaN(parseInt(t))?e.splice(t,1):delete e[t]:e[t]=n}}function E(e){var t={};for(var n in e)f(e,n)&&(t[n]=e[n]);return t}var j=[].concat;function P(e){return j.apply([],e)}var S=\"Boolean,String,Date,RegExp,Blob,File,FileList,ArrayBuffer,DataView,Uint8ClampedArray,ImageData,Map,Set\".split(\",\").concat(P([8,16,32,64].map((function(e){return[\"Int\",\"Uint\",\"Float\"].map((function(t){return t+e+\"Array\"}))})))).filter((function(e){return a[e]})),T=S.map((function(e){return a[e]})),D=x(S,(function(e){return[e,!0]}));function A(e){if(!e||\"object\"!=typeof e)return e;var t;if(u(e)){t=[];for(var n=0,r=e.length;n<r;++n)t.push(A(e[n]))}else if(T.indexOf(e.constructor)>=0)t=e;else for(var o in t=e.constructor?Object.create(e.constructor.prototype):{},e)f(e,o)&&(t[o]=A(e[o]));return t}var I={}.toString;function K(e){return I.call(e).slice(8,-1)}var C=function(e,t){return\"Array\"===t?\"\"+e.map((function(e){return C(e,K(e))})):\"ArrayBuffer\"===t?\"\"+new Uint8Array(e):\"Date\"===t?e.getTime():ArrayBuffer.isView(e)?\"\"+new Uint8Array(e.buffer):e};function F(e,t,n,r){return n=n||{},r=r||\"\",i(e).forEach((function(o){if(f(t,o)){var i=e[o],u=t[o];if(\"object\"==typeof i&&\"object\"==typeof u&&i&&u){var a=K(i),s=K(u);a===s?D[a]?C(i,a)!==C(u,s)&&(n[r+o]=t[o]):F(i,u,n,r+o+\".\"):n[r+o]=t[o]}else i!==u&&(n[r+o]=t[o])}else n[r+o]=void 0})),i(t).forEach((function(o){f(e,o)||(n[r+o]=t[o])})),n}var B=\"undefined\"!=typeof Symbol&&Symbol.iterator,R=B?function(e){var t;return null!=e&&(t=e[B])&&t.apply(e)}:function(){return null},M={};function U(e){var t,n,r,o;if(1===arguments.length){if(u(e))return e.slice();if(this===M&&\"string\"==typeof e)return[e];if(o=R(e)){for(n=[];!(r=o.next()).done;)n.push(r.value);return n}if(null==e)return[e];if(\"number\"==typeof(t=e.length)){for(n=new Array(t);t--;)n[t]=e[t];return n}return[e]}for(t=arguments.length,n=new Array(t);t--;)n[t]=arguments[t];return n}var N=\"undefined\"!=typeof Symbol?function(e){return\"AsyncFunction\"===e[Symbol.toStringTag]}:function(){return!1},L=\"undefined\"!=typeof location&&/^(http|https):\\/\\/(localhost|127\\.0\\.0\\.1)/.test(location.href);function q(e,t){L=e,z=t}var z=function(){return!0},Q=!new Error(\"\").stack;function G(){if(Q)try{throw new Error}catch(e){return e}return new Error}function V(e,t){var n=e.stack;return n?(t=t||0,0===n.indexOf(e.name)&&(t+=(e.name+e.message).split(\"\\n\").length),n.split(\"\\n\").slice(t).filter(z).map((function(e){return\"\\n\"+e})).join(\"\")):\"\"}var W=[\"Unknown\",\"Constraint\",\"Data\",\"TransactionInactive\",\"ReadOnly\",\"Version\",\"NotFound\",\"InvalidState\",\"InvalidAccess\",\"Abort\",\"Timeout\",\"QuotaExceeded\",\"Syntax\",\"DataClone\"],H=[\"Modify\",\"Bulk\",\"OpenFailed\",\"VersionChange\",\"Schema\",\"Upgrade\",\"InvalidTable\",\"MissingAPI\",\"NoSuchDatabase\",\"InvalidArgument\",\"SubTransaction\",\"Unsupported\",\"Internal\",\"DatabaseClosed\",\"PrematureCommit\",\"ForeignAwait\"].concat(W),Y={VersionChanged:\"Database version changed by other database connection\",DatabaseClosed:\"Database has been closed\",Abort:\"Transaction aborted\",TransactionInactive:\"Transaction has already completed or failed\"};function J(e,t){this._e=G(),this.name=e,this.message=t}function X(e,t){return e+\". Errors: \"+Object.keys(t).map((function(e){return t[e].toString()})).filter((function(e,t,n){return n.indexOf(e)===t})).join(\"\\n\")}function $(e,t,n,r){this._e=G(),this.failures=t,this.failedKeys=r,this.successCount=n,this.message=X(e,t)}function Z(e,t){this._e=G(),this.name=\"BulkError\",this.failures=t,this.message=X(e,t)}y(J).from(Error).extend({stack:{get:function(){return this._stack||(this._stack=this.name+\": \"+this.message+V(this._e,2))}},toString:function(){return this.name+\": \"+this.message}}),y($).from(J),y(Z).from(J);var ee=H.reduce((function(e,t){return e[t]=t+\"Error\",e}),{}),te=J,ne=H.reduce((function(e,t){var n=t+\"Error\";function r(e,r){this._e=G(),this.name=n,e?\"string\"==typeof e?(this.message=e+(r?\"\\n \"+r:\"\"),this.inner=r||null):\"object\"==typeof e&&(this.message=e.name+\" \"+e.message,this.inner=e):(this.message=Y[t]||n,this.inner=null)}return y(r).from(te),e[t]=r,e}),{});ne.Syntax=SyntaxError,ne.Type=TypeError,ne.Range=RangeError;var re=W.reduce((function(e,t){return e[t+\"Error\"]=ne[t],e}),{});var oe=H.reduce((function(e,t){return-1===[\"Syntax\",\"Type\",\"Range\"].indexOf(t)&&(e[t+\"Error\"]=ne[t]),e}),{});function ie(){}function ue(e){return e}function ae(e,t){return null==e||e===ue?t:function(n){return t(e(n))}}function se(e,t){return function(){e.apply(this,arguments),t.apply(this,arguments)}}function ce(e,t){return e===ie?t:function(){var n=e.apply(this,arguments);void 0!==n&&(arguments[0]=n);var r=this.onsuccess,o=this.onerror;this.onsuccess=null,this.onerror=null;var i=t.apply(this,arguments);return r&&(this.onsuccess=this.onsuccess?se(r,this.onsuccess):r),o&&(this.onerror=this.onerror?se(o,this.onerror):o),void 0!==i?i:n}}function le(e,t){return e===ie?t:function(){e.apply(this,arguments);var n=this.onsuccess,r=this.onerror;this.onsuccess=this.onerror=null,t.apply(this,arguments),n&&(this.onsuccess=this.onsuccess?se(n,this.onsuccess):n),r&&(this.onerror=this.onerror?se(r,this.onerror):r)}}function fe(e,t){return e===ie?t:function(n){var r=e.apply(this,arguments);s(n,r);var o=this.onsuccess,i=this.onerror;this.onsuccess=null,this.onerror=null;var u=t.apply(this,arguments);return o&&(this.onsuccess=this.onsuccess?se(o,this.onsuccess):o),i&&(this.onerror=this.onerror?se(i,this.onerror):i),void 0===r?void 0===u?void 0:u:s(r,u)}}function he(e,t){return e===ie?t:function(){return!1!==t.apply(this,arguments)&&e.apply(this,arguments)}}function pe(e,t){return e===ie?t:function(){var n=e.apply(this,arguments);if(n&&\"function\"==typeof n.then){for(var r=this,o=arguments.length,i=new Array(o);o--;)i[o]=arguments[o];return n.then((function(){return t.apply(r,i)}))}return t.apply(this,arguments)}}oe.ModifyError=$,oe.DexieError=J,oe.BulkError=Z;var de={},ye=\"undefined\"==typeof Promise?[]:function(){var e=Promise.resolve();if(\"undefined\"==typeof crypto||!crypto.subtle)return[e,e.__proto__,e];var t=crypto.subtle.digest(\"SHA-512\",new Uint8Array([0]));return[t,t.__proto__,e]}(),ve=ye[0],me=ye[1],ge=ye[2],be=me&&me.then,we=ve&&ve.constructor,_e=!!ge,xe=!1,ke=ge?function(){ge.then(Ge)}:a.setImmediate?setImmediate.bind(null,Ge):a.MutationObserver?function(){var e=document.createElement(\"div\");new MutationObserver((function(){Ge(),e=null})).observe(e,{attributes:!0}),e.setAttribute(\"i\",\"1\")}:function(){setTimeout(Ge,0)},Oe=function(e,t){Ke.push([e,t]),je&&(ke(),je=!1)},Ee=!0,je=!0,Pe=[],Se=[],Te=null,De=ue,Ae={id:\"global\",global:!0,ref:0,unhandleds:[],onunhandled:dt,pgp:!1,env:{},finalize:function(){this.unhandleds.forEach((function(e){try{dt(e[0],e[1])}catch(e){}}))}},Ie=Ae,Ke=[],Ce=0,Fe=[];function Be(e){if(\"object\"!=typeof this)throw new TypeError(\"Promises must be constructed via new\");this._listeners=[],this.onuncatched=ie,this._lib=!1;var t=this._PSD=Ie;if(L&&(this._stackHolder=G(),this._prev=null,this._numPrev=0),\"function\"!=typeof e){if(e!==de)throw new TypeError(\"Not a function\");return this._state=arguments[1],this._value=arguments[2],void(!1===this._state&&Ne(this,this._value))}this._state=null,this._value=null,++t.ref,Ue(this,e)}var Re={get:function(){var e=Ie,t=tt;function n(n,r){var o=this,i=!e.global&&(e!==Ie||t!==tt);i&&it();var u=new Be((function(t,u){qe(o,new Me(ht(n,e,i),ht(r,e,i),t,u,e))}));return L&&Qe(u,this),u}return n.prototype=de,n},set:function(e){d(this,\"then\",e&&e.prototype===de?Re:{get:function(){return e},set:Re.set})}};function Me(e,t,n,r,o){this.onFulfilled=\"function\"==typeof e?e:null,this.onRejected=\"function\"==typeof t?t:null,this.resolve=n,this.reject=r,this.psd=o}function Ue(e,t){try{t((function(t){if(null===e._state){if(t===e)throw new TypeError(\"A promise cannot be resolved with itself.\");var n=e._lib&&Ve();t&&\"function\"==typeof t.then?Ue(e,(function(e,n){t instanceof Be?t._then(e,n):t.then(e,n)})):(e._state=!0,e._value=t,Le(e)),n&&We()}}),Ne.bind(null,e))}catch(t){Ne(e,t)}}function Ne(e,t){if(Se.push(t),null===e._state){var n=e._lib&&Ve();t=De(t),e._state=!1,e._value=t,L&&null!==t&&\"object\"==typeof t&&!t._promise&&function(e,t,n){try{e.apply(null,n)}catch(e){t&&t(e)}}((function(){var n=function e(t,n){var r;return v(t,n)||(r=c(t))&&e(r,n)}(t,\"stack\");t._promise=e,d(t,\"stack\",{get:function(){return xe?n&&(n.get?n.get.apply(t):n.value):e.stack}})})),function(e){Pe.some((function(t){return t._value===e._value}))||Pe.push(e)}(e),Le(e),n&&We()}}function Le(e){var t=e._listeners;e._listeners=[];for(var n=0,r=t.length;n<r;++n)qe(e,t[n]);var o=e._PSD;--o.ref||o.finalize(),0===Ce&&(++Ce,Oe((function(){0==--Ce&&He()}),[]))}function qe(e,t){if(null!==e._state){var n=e._state?t.onFulfilled:t.onRejected;if(null===n)return(e._state?t.resolve:t.reject)(e._value);++t.psd.ref,++Ce,Oe(ze,[n,e,t])}else e._listeners.push(t)}function ze(e,t,n){try{Te=t;var r,o=t._value;t._state?r=e(o):(Se.length&&(Se=[]),r=e(o),-1===Se.indexOf(o)&&function(e){var t=Pe.length;for(;t;)if(Pe[--t]._value===e._value)return void Pe.splice(t,1)}(t)),n.resolve(r)}catch(e){n.reject(e)}finally{Te=null,0==--Ce&&He(),--n.psd.ref||n.psd.finalize()}}function Qe(e,t){var n=t?t._numPrev+1:0;n<100&&(e._prev=t,e._numPrev=n)}function Ge(){Ve()&&We()}function Ve(){var e=Ee;return Ee=!1,je=!1,e}function We(){var e,t,n;do{for(;Ke.length>0;)for(e=Ke,Ke=[],n=e.length,t=0;t<n;++t){var r=e[t];r[0].apply(null,r[1])}}while(Ke.length>0);Ee=!0,je=!0}function He(){var e=Pe;Pe=[],e.forEach((function(e){e._PSD.onunhandled.call(null,e._value,e)}));for(var t=Fe.slice(0),n=t.length;n;)t[--n]()}function Ye(e){return new Be(de,!1,e)}function Je(e,t){var n=Ie;return function(){var r=Ve(),o=Ie;try{return ct(n,!0),e.apply(this,arguments)}catch(e){t&&t(e)}finally{ct(o,!1),r&&We()}}}h(Be.prototype,{then:Re,_then:function(e,t){qe(this,new Me(null,null,e,t,Ie))},catch:function(e){if(1===arguments.length)return this.then(null,e);var t=arguments[0],n=arguments[1];return\"function\"==typeof t?this.then(null,(function(e){return e instanceof t?n(e):Ye(e)})):this.then(null,(function(e){return e&&e.name===t?n(e):Ye(e)}))},finally:function(e){return this.then((function(t){return e(),t}),(function(t){return e(),Ye(t)}))},stack:{get:function(){if(this._stack)return this._stack;try{xe=!0;var e=function e(t,n,r){if(n.length===r)return n;var o=\"\";if(!1===t._state){var i,u,a=t._value;null!=a?(i=a.name||\"Error\",u=a.message||a,o=V(a,0)):(i=a,u=\"\"),n.push(i+(u?\": \"+u:\"\")+o)}L&&((o=V(t._stackHolder,2))&&-1===n.indexOf(o)&&n.push(o),t._prev&&e(t._prev,n,r));return n}(this,[],20).join(\"\\nFrom previous: \");return null!==this._state&&(this._stack=e),e}finally{xe=!1}}},timeout:function(e,t){var n=this;return e<1/0?new Be((function(r,o){var i=setTimeout((function(){return o(new ne.Timeout(t))}),e);n.then(r,o).finally(clearTimeout.bind(null,i))})):this}}),\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&d(Be.prototype,Symbol.toStringTag,\"Dexie.Promise\"),Ae.env=lt(),h(Be,{all:function(){var e=U.apply(null,arguments).map(ut);return new Be((function(t,n){0===e.length&&t([]);var r=e.length;e.forEach((function(o,i){return Be.resolve(o).then((function(n){e[i]=n,--r||t(e)}),n)}))}))},resolve:function(e){if(e instanceof Be)return e;if(e&&\"function\"==typeof e.then)return new Be((function(t,n){e.then(t,n)}));var t=new Be(de,!0,e);return Qe(t,Te),t},reject:Ye,race:function(){var e=U.apply(null,arguments).map(ut);return new Be((function(t,n){e.map((function(e){return Be.resolve(e).then(t,n)}))}))},PSD:{get:function(){return Ie},set:function(e){return Ie=e}},newPSD:rt,usePSD:ft,scheduler:{get:function(){return Oe},set:function(e){Oe=e}},rejectionMapper:{get:function(){return De},set:function(e){De=e}},follow:function(e,t){return new Be((function(n,r){return rt((function(t,n){var r=Ie;r.unhandleds=[],r.onunhandled=n,r.finalize=se((function(){var e=this;!function(e){Fe.push((function t(){e(),Fe.splice(Fe.indexOf(t),1)})),++Ce,Oe((function(){0==--Ce&&He()}),[])}((function(){0===e.unhandleds.length?t():n(e.unhandleds[0])}))}),r.finalize),e()}),t,n,r)}))}}),we&&(we.allSettled&&d(Be,\"allSettled\",(function(){var e=U.apply(null,arguments).map(ut);return new Be((function(t){0===e.length&&t([]);var n=e.length,r=new Array(n);e.forEach((function(e,o){return Be.resolve(e).then((function(e){return r[o]={status:\"fulfilled\",value:e}}),(function(e){return r[o]={status:\"rejected\",reason:e}})).then((function(){return--n||t(r)}))}))}))})),we.any&&\"undefined\"!=typeof AggregateError&&d(Be,\"any\",(function(){var e=U.apply(null,arguments).map(ut);return new Be((function(t,n){0===e.length&&n(new AggregateError([]));var r=e.length,o=new Array(r);e.forEach((function(e,i){return Be.resolve(e).then((function(e){return t(e)}),(function(e){o[i]=e,--r||n(new AggregateError(o))}))}))}))})));var Xe={awaits:0,echoes:0,id:0},$e=0,Ze=[],et=0,tt=0,nt=0;function rt(e,t,n,r){var o=Ie,i=Object.create(o);i.parent=o,i.ref=0,i.global=!1,i.id=++nt;var u=Ae.env;i.env=_e?{Promise:Be,PromiseProp:{value:Be,configurable:!0,writable:!0},all:Be.all,race:Be.race,allSettled:Be.allSettled,any:Be.any,resolve:Be.resolve,reject:Be.reject,nthen:pt(u.nthen,i),gthen:pt(u.gthen,i)}:{},t&&s(i,t),++o.ref,i.finalize=function(){--this.parent.ref||this.parent.finalize()};var a=ft(i,e,n,r);return 0===i.ref&&i.finalize(),a}function ot(){return Xe.id||(Xe.id=++$e),++Xe.awaits,Xe.echoes+=100,Xe.id}function it(e){!Xe.awaits||e&&e!==Xe.id||(0==--Xe.awaits&&(Xe.id=0),Xe.echoes=100*Xe.awaits)}function ut(e){return Xe.echoes&&e&&e.constructor===we?(ot(),e.then((function(e){return it(),e}),(function(e){return it(),yt(e)}))):e}function at(e){++tt,Xe.echoes&&0!=--Xe.echoes||(Xe.echoes=Xe.id=0),Ze.push(Ie),ct(e,!0)}function st(){var e=Ze[Ze.length-1];Ze.pop(),ct(e,!1)}function ct(e,t){var n,r=Ie;if((t?!Xe.echoes||et++&&e===Ie:!et||--et&&e===Ie)||(n=t?at.bind(null,e):st,be.call(ve,n)),e!==Ie&&(Ie=e,r===Ae&&(Ae.env=lt()),_e)){var o=Ae.env.Promise,i=e.env;me.then=i.nthen,o.prototype.then=i.gthen,(r.global||e.global)&&(Object.defineProperty(a,\"Promise\",i.PromiseProp),o.all=i.all,o.race=i.race,o.resolve=i.resolve,o.reject=i.reject,i.allSettled&&(o.allSettled=i.allSettled),i.any&&(o.any=i.any))}}function lt(){var e=a.Promise;return _e?{Promise:e,PromiseProp:Object.getOwnPropertyDescriptor(a,\"Promise\"),all:e.all,race:e.race,allSettled:e.allSettled,any:e.any,resolve:e.resolve,reject:e.reject,nthen:me.then,gthen:e.prototype.then}:{}}function ft(e,t,n,r,o){var i=Ie;try{return ct(e,!0),t(n,r,o)}finally{ct(i,!1)}}function ht(e,t,n){return\"function\"!=typeof e?e:function(){var r=Ie;n&&ot(),ct(t,!0);try{return e.apply(this,arguments)}finally{ct(r,!1)}}}function pt(e,t){return function(n,r){return e.call(this,ht(n,t,!1),ht(r,t,!1))}}-1===(\"\"+be).indexOf(\"[native code]\")&&(ot=it=ie);function dt(e,t){var n;try{n=t.onuncatched(e)}catch(e){}if(!1!==n)try{var r,o={promise:t,reason:e};if(a.document&&document.createEvent?((r=document.createEvent(\"Event\")).initEvent(\"unhandledrejection\",!0,!0),s(r,o)):a.CustomEvent&&s(r=new CustomEvent(\"unhandledrejection\",{detail:o}),o),r&&a.dispatchEvent&&(dispatchEvent(r),!a.PromiseRejectionEvent&&a.onunhandledrejection))try{a.onunhandledrejection(r)}catch(e){}L&&r&&!r.defaultPrevented&&console.warn(\"Unhandled rejection: \"+(e.stack||e))}catch(e){}}var yt=Be.reject;var vt=String.fromCharCode(65535),mt=\"Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.\",gt=[],bt=\"undefined\"!=typeof navigator&&/(MSIE|Trident|Edge)/.test(navigator.userAgent),wt=bt,_t=bt,xt=function(e){return!/(dexie\\.js|dexie\\.min\\.js)/.test(e)};function kt(e,t){return e?t?function(){return e.apply(this,arguments)&&t.apply(this,arguments)}:e:t}var Ot={type:3,lower:-1/0,lowerOpen:!1,upper:[[]],upperOpen:!1},Et=function(){function e(){}return e.prototype._trans=function(e,t,n){var r=this._tx||Ie.trans,o=this.name;function i(e,n,r){if(!r.schema[o])throw new ne.NotFound(\"Table \"+o+\" not part of transaction\");return t(r.idbtrans,r)}var u=Ve();try{return r&&r.db===this.db?r===Ie.trans?r._promise(e,i,n):rt((function(){return r._promise(e,i,n)}),{trans:r,transless:Ie.transless||Ie}):function e(t,n,r,o){if(t._state.openComplete||Ie.letThrough){var i=t._createTransaction(n,r,t._dbSchema);try{i.create()}catch(e){return yt(e)}return i._promise(n,(function(e,t){return rt((function(){return Ie.trans=i,o(e,t,i)}))})).then((function(e){return i._completion.then((function(){return e}))}))}if(!t._state.isBeingOpened){if(!t._options.autoOpen)return yt(new ne.DatabaseClosed);t.open().catch(ie)}return t._state.dbReadyPromise.then((function(){return e(t,n,r,o)}))}(this.db,e,[this.name],i)}finally{u&&We()}},e.prototype.get=function(e,t){var n=this;return e&&e.constructor===Object?this.where(e).first(t):this._trans(\"readonly\",(function(t){return n.core.get({trans:t,key:e}).then((function(e){return n.hook.reading.fire(e)}))})).then(t)},e.prototype.where=function(e){if(\"string\"==typeof e)return new this.db.WhereClause(this,e);if(u(e))return new this.db.WhereClause(this,\"[\"+e.join(\"+\")+\"]\");var t=i(e);if(1===t.length)return this.where(t[0]).equals(e[t[0]]);var n=this.schema.indexes.concat(this.schema.primKey).filter((function(e){return e.compound&&t.every((function(t){return e.keyPath.indexOf(t)>=0}))&&e.keyPath.every((function(e){return t.indexOf(e)>=0}))}))[0];if(n&&this.db._maxKey!==vt)return this.where(n.name).equals(n.keyPath.map((function(t){return e[t]})));!n&&L&&console.warn(\"The query \"+JSON.stringify(e)+\" on \"+this.name+\" would benefit of a compound index [\"+t.join(\"+\")+\"]\");var r=this.schema.idxByName,o=this.db._deps.indexedDB;function a(e,t){try{return 0===o.cmp(e,t)}catch(e){return!1}}var s=t.reduce((function(t,n){var o=t[0],i=t[1],s=r[n],c=e[n];return[o||s,o||!s?kt(i,s&&s.multi?function(e){var t=k(e,n);return u(t)&&t.some((function(e){return a(c,e)}))}:function(e){return a(c,k(e,n))}):i]}),[null,null]),c=s[0],l=s[1];return c?this.where(c.name).equals(e[c.keyPath]).filter(l):n?this.filter(l):this.where(t).equals(\"\")},e.prototype.filter=function(e){return this.toCollection().and(e)},e.prototype.count=function(e){return this.toCollection().count(e)},e.prototype.offset=function(e){return this.toCollection().offset(e)},e.prototype.limit=function(e){return this.toCollection().limit(e)},e.prototype.each=function(e){return this.toCollection().each(e)},e.prototype.toArray=function(e){return this.toCollection().toArray(e)},e.prototype.toCollection=function(){return new this.db.Collection(new this.db.WhereClause(this))},e.prototype.orderBy=function(e){return new this.db.Collection(new this.db.WhereClause(this,u(e)?\"[\"+e.join(\"+\")+\"]\":e))},e.prototype.reverse=function(){return this.toCollection().reverse()},e.prototype.mapToClass=function(e){this.schema.mappedClass=e;var t=function(t){if(!t)return t;var n=Object.create(e.prototype);for(var r in t)if(f(t,r))try{n[r]=t[r]}catch(e){}return n};return this.schema.readHook&&this.hook.reading.unsubscribe(this.schema.readHook),this.schema.readHook=t,this.hook(\"reading\",t),e},e.prototype.defineClass=function(){return this.mapToClass((function(e){s(this,e)}))},e.prototype.add=function(e,t){var n=this;return this._trans(\"readwrite\",(function(r){return n.core.mutate({trans:r,type:\"add\",keys:null!=t?[t]:null,values:[e]})})).then((function(e){return e.numFailures?Be.reject(e.failures[0]):e.lastResult})).then((function(t){if(!n.core.schema.primaryKey.outbound)try{O(e,n.core.schema.primaryKey.keyPath,t)}catch(e){}return t}))},e.prototype.update=function(e,t){if(\"object\"!=typeof t||u(t))throw new ne.InvalidArgument(\"Modifications must be an object.\");if(\"object\"!=typeof e||u(e))return this.where(\":id\").equals(e).modify(t);i(t).forEach((function(n){O(e,n,t[n])}));var n=k(e,this.schema.primKey.keyPath);return void 0===n?yt(new ne.InvalidArgument(\"Given object does not contain its primary key\")):this.where(\":id\").equals(n).modify(t)},e.prototype.put=function(e,t){var n=this;return this._trans(\"readwrite\",(function(r){return n.core.mutate({trans:r,type:\"put\",values:[e],keys:null!=t?[t]:null})})).then((function(e){return e.numFailures?Be.reject(e.failures[0]):e.lastResult})).then((function(t){if(!n.core.schema.primaryKey.outbound)try{O(e,n.core.schema.primaryKey.keyPath,t)}catch(e){}return t}))},e.prototype.delete=function(e){var t=this;return this._trans(\"readwrite\",(function(n){return t.core.mutate({trans:n,type:\"delete\",keys:[e]})})).then((function(e){return e.numFailures?Be.reject(e.failures[0]):void 0}))},e.prototype.clear=function(){var e=this;return this._trans(\"readwrite\",(function(t){return e.core.mutate({trans:t,type:\"deleteRange\",range:Ot})})).then((function(e){return e.numFailures?Be.reject(e.failures[0]):void 0}))},e.prototype.bulkGet=function(e){var t=this;return this._trans(\"readonly\",(function(n){return t.core.getMany({keys:e,trans:n})}))},e.prototype.bulkAdd=function(e,t,n){var r=this,o=Array.isArray(t)?t:void 0,i=(n=n||(o?void 0:t))?n.allKeys:void 0;return this._trans(\"readwrite\",(function(t){if(!r.core.schema.primaryKey.outbound&&o)throw new ne.InvalidArgument(\"bulkAdd(): keys argument invalid on tables with inbound keys\");if(o&&o.length!==e.length)throw new ne.InvalidArgument(\"Arguments objects and keys must have the same length\");var n=e.length;return r.core.mutate({trans:t,type:\"add\",keys:o,values:e,wantResults:i}).then((function(e){var t=e.numFailures,o=e.results,u=e.lastResult,a=e.failures;if(0===t)return i?o:u;throw new Z(r.name+\".bulkAdd(): \"+t+\" of \"+n+\" operations failed\",Object.keys(a).map((function(e){return a[e]})))}))}))},e.prototype.bulkPut=function(e,t,n){var r=this,o=Array.isArray(t)?t:void 0,i=(n=n||(o?void 0:t))?n.allKeys:void 0;return this._trans(\"readwrite\",(function(t){if(!r.core.schema.primaryKey.outbound&&o)throw new ne.InvalidArgument(\"bulkPut(): keys argument invalid on tables with inbound keys\");if(o&&o.length!==e.length)throw new ne.InvalidArgument(\"Arguments objects and keys must have the same length\");var n=e.length;return r.core.mutate({trans:t,type:\"put\",keys:o,values:e,wantResults:i}).then((function(e){var t=e.numFailures,o=e.results,u=e.lastResult,a=e.failures;if(0===t)return i?o:u;throw new Z(r.name+\".bulkPut(): \"+t+\" of \"+n+\" operations failed\",Object.keys(a).map((function(e){return a[e]})))}))}))},e.prototype.bulkDelete=function(e){var t=this,n=e.length;return this._trans(\"readwrite\",(function(n){return t.core.mutate({trans:n,type:\"delete\",keys:e})})).then((function(e){var r=e.numFailures,o=e.lastResult,i=e.failures;if(0===r)return o;throw new Z(t.name+\".bulkDelete(): \"+r+\" of \"+n+\" operations failed\",i)}))},e}();function jt(e){var t={},n=function(n,r){if(r){for(var o=arguments.length,i=new Array(o-1);--o;)i[o-1]=arguments[o];return t[n].subscribe.apply(null,i),e}if(\"string\"==typeof n)return t[n]};n.addEventType=a;for(var r=1,o=arguments.length;r<o;++r)a(arguments[r]);return n;function a(e,r,o){if(\"object\"==typeof e)return s(e);r||(r=he),o||(o=ie);var i={subscribers:[],fire:o,subscribe:function(e){-1===i.subscribers.indexOf(e)&&(i.subscribers.push(e),i.fire=r(i.fire,e))},unsubscribe:function(e){i.subscribers=i.subscribers.filter((function(t){return t!==e})),i.fire=i.subscribers.reduce(r,o)}};return t[e]=n[e]=i,i}function s(e){i(e).forEach((function(t){var n=e[t];if(u(n))a(t,e[t][0],e[t][1]);else{if(\"asap\"!==n)throw new ne.InvalidArgument(\"Invalid event config\");var r=a(t,ue,(function(){for(var e=arguments.length,t=new Array(e);e--;)t[e]=arguments[e];r.subscribers.forEach((function(e){_((function(){e.apply(null,t)}))}))}))}}))}}function Pt(e,t){return y(t).from({prototype:e}),t}function St(e,t){return!(e.filter||e.algorithm||e.or)&&(t?e.justLimit:!e.replayFilter)}function Tt(e,t){e.filter=kt(e.filter,t)}function Dt(e,t,n){var r=e.replayFilter;e.replayFilter=r?function(){return kt(r(),t())}:t,e.justLimit=n&&!r}function At(e,t){if(e.isPrimKey)return t.primaryKey;var n=t.getIndexByKeyPath(e.index);if(!n)throw new ne.Schema(\"KeyPath \"+e.index+\" on object store \"+t.name+\" is not indexed\");return n}function It(e,t,n){var r=At(e,t.schema);return t.openCursor({trans:n,values:!e.keysOnly,reverse:\"prev\"===e.dir,unique:!!e.unique,query:{index:r,range:e.range}})}function Kt(e,t,n,r){var o=e.replayFilter?kt(e.filter,e.replayFilter()):e.filter;if(e.or){var i={},u=function(e,n,r){if(!o||o(n,r,(function(e){return n.stop(e)}),(function(e){return n.fail(e)}))){var u=n.primaryKey,a=\"\"+u;\"[object ArrayBuffer]\"===a&&(a=\"\"+new Uint8Array(u)),f(i,a)||(i[a]=!0,t(e,n,r))}};return Promise.all([e.or._iterate(u,n),Ct(It(e,r,n),e.algorithm,u,!e.keysOnly&&e.valueMapper)])}return Ct(It(e,r,n),kt(e.algorithm,o),t,!e.keysOnly&&e.valueMapper)}function Ct(e,t,n,r){var o=Je(r?function(e,t,o){return n(r(e),t,o)}:n);return e.then((function(e){if(e)return e.start((function(){var n=function(){return e.continue()};t&&!t(e,(function(e){return n=e}),(function(t){e.stop(t),n=ie}),(function(t){e.fail(t),n=ie}))||o(e.value,e,(function(e){return n=e})),n()}))}))}var Ft=function(){function e(){}return e.prototype._read=function(e,t){var n=this._ctx;return n.error?n.table._trans(null,yt.bind(null,n.error)):n.table._trans(\"readonly\",e).then(t)},e.prototype._write=function(e){var t=this._ctx;return t.error?t.table._trans(null,yt.bind(null,t.error)):t.table._trans(\"readwrite\",e,\"locked\")},e.prototype._addAlgorithm=function(e){var t=this._ctx;t.algorithm=kt(t.algorithm,e)},e.prototype._iterate=function(e,t){return Kt(this._ctx,e,t,this._ctx.table.core)},e.prototype.clone=function(e){var t=Object.create(this.constructor.prototype),n=Object.create(this._ctx);return e&&s(n,e),t._ctx=n,t},e.prototype.raw=function(){return this._ctx.valueMapper=null,this},e.prototype.each=function(e){var t=this._ctx;return this._read((function(n){return Kt(t,e,n,t.table.core)}))},e.prototype.count=function(e){var t=this;return this._read((function(e){var n=t._ctx,r=n.table.core;if(St(n,!0))return r.count({trans:e,query:{index:At(n,r.schema),range:n.range}}).then((function(e){return Math.min(e,n.limit)}));var o=0;return Kt(n,(function(){return++o,!1}),e,r).then((function(){return o}))})).then(e)},e.prototype.sortBy=function(e,t){var n=e.split(\".\").reverse(),r=n[0],o=n.length-1;function i(e,t){return t?i(e[n[t]],t-1):e[r]}var u=\"next\"===this._ctx.dir?1:-1;function a(e,t){var n=i(e,o),r=i(t,o);return n<r?-u:n>r?u:0}return this.toArray((function(e){return e.sort(a)})).then(t)},e.prototype.toArray=function(e){var t=this;return this._read((function(e){var n=t._ctx;if(\"next\"===n.dir&&St(n,!0)&&n.limit>0){var r=n.valueMapper,o=At(n,n.table.core.schema);return n.table.core.query({trans:e,limit:n.limit,values:!0,query:{index:o,range:n.range}}).then((function(e){var t=e.result;return r?t.map(r):t}))}var i=[];return Kt(n,(function(e){return i.push(e)}),e,n.table.core).then((function(){return i}))}),e)},e.prototype.offset=function(e){var t=this._ctx;return e<=0||(t.offset+=e,St(t)?Dt(t,(function(){var t=e;return function(e,n){return 0===t||(1===t?(--t,!1):(n((function(){e.advance(t),t=0})),!1))}})):Dt(t,(function(){var t=e;return function(){return--t<0}}))),this},e.prototype.limit=function(e){return this._ctx.limit=Math.min(this._ctx.limit,e),Dt(this._ctx,(function(){var t=e;return function(e,n,r){return--t<=0&&n(r),t>=0}}),!0),this},e.prototype.until=function(e,t){return Tt(this._ctx,(function(n,r,o){return!e(n.value)||(r(o),t)})),this},e.prototype.first=function(e){return this.limit(1).toArray((function(e){return e[0]})).then(e)},e.prototype.last=function(e){return this.reverse().first(e)},e.prototype.filter=function(e){var t,n;return Tt(this._ctx,(function(t){return e(t.value)})),t=this._ctx,n=e,t.isMatch=kt(t.isMatch,n),this},e.prototype.and=function(e){return this.filter(e)},e.prototype.or=function(e){return new this.db.WhereClause(this._ctx.table,e,this)},e.prototype.reverse=function(){return this._ctx.dir=\"prev\"===this._ctx.dir?\"next\":\"prev\",this._ondirectionchange&&this._ondirectionchange(this._ctx.dir),this},e.prototype.desc=function(){return this.reverse()},e.prototype.eachKey=function(e){var t=this._ctx;return t.keysOnly=!t.isMatch,this.each((function(t,n){e(n.key,n)}))},e.prototype.eachUniqueKey=function(e){return this._ctx.unique=\"unique\",this.eachKey(e)},e.prototype.eachPrimaryKey=function(e){var t=this._ctx;return t.keysOnly=!t.isMatch,this.each((function(t,n){e(n.primaryKey,n)}))},e.prototype.keys=function(e){var t=this._ctx;t.keysOnly=!t.isMatch;var n=[];return this.each((function(e,t){n.push(t.key)})).then((function(){return n})).then(e)},e.prototype.primaryKeys=function(e){var t=this._ctx;if(\"next\"===t.dir&&St(t,!0)&&t.limit>0)return this._read((function(e){var n=At(t,t.table.core.schema);return t.table.core.query({trans:e,values:!1,limit:t.limit,query:{index:n,range:t.range}})})).then((function(e){return e.result})).then(e);t.keysOnly=!t.isMatch;var n=[];return this.each((function(e,t){n.push(t.primaryKey)})).then((function(){return n})).then(e)},e.prototype.uniqueKeys=function(e){return this._ctx.unique=\"unique\",this.keys(e)},e.prototype.firstKey=function(e){return this.limit(1).keys((function(e){return e[0]})).then(e)},e.prototype.lastKey=function(e){return this.reverse().firstKey(e)},e.prototype.distinct=function(){var e=this._ctx,t=e.index&&e.table.schema.idxByName[e.index];if(!t||!t.multi)return this;var n={};return Tt(this._ctx,(function(e){var t=e.primaryKey.toString(),r=f(n,t);return n[t]=!0,!r})),this},e.prototype.modify=function(e){var t=this,n=this._ctx;return this._write((function(r){var o;if(\"function\"==typeof e)o=e;else{var u=i(e),a=u.length;o=function(t){for(var n=!1,r=0;r<a;++r){var o=u[r],i=e[o];k(t,o)!==i&&(O(t,o,i),n=!0)}return n}}var s=n.table.core,c=s.schema.primaryKey,l=c.outbound,f=c.extractKey,h=\"testmode\"in jn?1:2e3,p=t.db.core.cmp,d=[],y=0,v=[],m=function(e,t){var n=t.failures,r=t.numFailures;y+=e-r;for(var o=0,u=i(n);o<u.length;o++){var a=u[o];d.push(n[a])}};return t.clone().primaryKeys().then((function(e){var t=function(n){var i=Math.min(h,e.length-n);return s.getMany({trans:r,keys:e.slice(n,n+i)}).then((function(u){for(var a=[],c=[],d=l?[]:null,y=[],v=0;v<i;++v){var g=u[v],b={value:A(g),primKey:e[n+v]};!1!==o.call(b,b.value,b)&&(null==b.value?y.push(e[n+v]):l||0===p(f(g),f(b.value))?(c.push(b.value),l&&d.push(e[n+v])):(y.push(e[n+v]),a.push(b.value)))}return Promise.resolve(a.length>0&&s.mutate({trans:r,type:\"add\",values:a}).then((function(e){for(var t in e.failures)y.splice(parseInt(t),1);m(a.length,e)}))).then((function(e){return c.length>0&&s.mutate({trans:r,type:\"put\",keys:d,values:c}).then((function(e){return m(c.length,e)}))})).then((function(){return y.length>0&&s.mutate({trans:r,type:\"delete\",keys:y}).then((function(e){return m(y.length,e)}))})).then((function(){return e.length>n+i&&t(n+h)}))}))};return t(0).then((function(){if(d.length>0)throw new $(\"Error modifying one or more objects\",d,y,v);return e.length}))}))}))},e.prototype.delete=function(){var e=this._ctx,t=e.range;return St(e)&&(e.isPrimKey&&!_t||3===t.type)?this._write((function(n){var r=e.table.core.schema.primaryKey,o=t;return e.table.core.count({trans:n,query:{index:r,range:o}}).then((function(t){return e.table.core.mutate({trans:n,type:\"deleteRange\",range:o}).then((function(e){var n=e.failures,r=(e.lastResult,e.results,e.numFailures);if(r)throw new $(\"Could not delete some values\",Object.keys(n).map((function(e){return n[e]})),t-r);return t-r}))}))})):this.modify((function(e,t){return t.value=null}))},e}();function Bt(e,t){return e<t?-1:e===t?0:1}function Rt(e,t){return e>t?-1:e===t?0:1}function Mt(e,t,n){var r=e instanceof Qt?new e.Collection(e):e;return r._ctx.error=n?new n(t):new TypeError(t),r}function Ut(e){return new e.Collection(e,(function(){return zt(\"\")})).limit(0)}function Nt(e,t,n,r,o,i){for(var u=Math.min(e.length,r.length),a=-1,s=0;s<u;++s){var c=t[s];if(c!==r[s])return o(e[s],n[s])<0?e.substr(0,s)+n[s]+n.substr(s+1):o(e[s],r[s])<0?e.substr(0,s)+r[s]+n.substr(s+1):a>=0?e.substr(0,a)+t[a]+n.substr(a+1):null;o(e[s],c)<0&&(a=s)}return u<r.length&&\"next\"===i?e+n.substr(e.length):u<e.length&&\"prev\"===i?e.substr(0,n.length):a<0?null:e.substr(0,a)+r[a]+n.substr(a+1)}function Lt(e,t,n,r){var o,i,u,a,s,c,l,f=n.length;if(!n.every((function(e){return\"string\"==typeof e})))return Mt(e,\"String expected.\");function h(e){o=function(e){return\"next\"===e?function(e){return e.toUpperCase()}:function(e){return e.toLowerCase()}}(e),i=function(e){return\"next\"===e?function(e){return e.toLowerCase()}:function(e){return e.toUpperCase()}}(e),u=\"next\"===e?Bt:Rt;var t=n.map((function(e){return{lower:i(e),upper:o(e)}})).sort((function(e,t){return u(e.lower,t.lower)}));a=t.map((function(e){return e.upper})),s=t.map((function(e){return e.lower})),c=e,l=\"next\"===e?\"\":r}h(\"next\");var p=new e.Collection(e,(function(){return qt(a[0],s[f-1]+r)}));p._ondirectionchange=function(e){h(e)};var d=0;return p._addAlgorithm((function(e,n,r){var o=e.key;if(\"string\"!=typeof o)return!1;var h=i(o);if(t(h,s,d))return!0;for(var p=null,y=d;y<f;++y){var v=Nt(o,h,a[y],s[y],u,c);null===v&&null===p?d=y+1:(null===p||u(p,v)>0)&&(p=v)}return n(null!==p?function(){e.continue(p+l)}:r),!1})),p}function qt(e,t,n,r){return{type:2,lower:e,upper:t,lowerOpen:n,upperOpen:r}}function zt(e){return{type:1,lower:e,upper:e}}var Qt=function(){function e(){}return Object.defineProperty(e.prototype,\"Collection\",{get:function(){return this._ctx.table.db.Collection},enumerable:!0,configurable:!0}),e.prototype.between=function(e,t,n,r){n=!1!==n,r=!0===r;try{return this._cmp(e,t)>0||0===this._cmp(e,t)&&(n||r)&&(!n||!r)?Ut(this):new this.Collection(this,(function(){return qt(e,t,!n,!r)}))}catch(e){return Mt(this,mt)}},e.prototype.equals=function(e){return new this.Collection(this,(function(){return zt(e)}))},e.prototype.above=function(e){return null==e?Mt(this,mt):new this.Collection(this,(function(){return qt(e,void 0,!0)}))},e.prototype.aboveOrEqual=function(e){return null==e?Mt(this,mt):new this.Collection(this,(function(){return qt(e,void 0,!1)}))},e.prototype.below=function(e){return null==e?Mt(this,mt):new this.Collection(this,(function(){return qt(void 0,e,!1,!0)}))},e.prototype.belowOrEqual=function(e){return null==e?Mt(this,mt):new this.Collection(this,(function(){return qt(void 0,e)}))},e.prototype.startsWith=function(e){return\"string\"!=typeof e?Mt(this,\"String expected.\"):this.between(e,e+vt,!0,!0)},e.prototype.startsWithIgnoreCase=function(e){return\"\"===e?this.startsWith(e):Lt(this,(function(e,t){return 0===e.indexOf(t[0])}),[e],vt)},e.prototype.equalsIgnoreCase=function(e){return Lt(this,(function(e,t){return e===t[0]}),[e],\"\")},e.prototype.anyOfIgnoreCase=function(){var e=U.apply(M,arguments);return 0===e.length?Ut(this):Lt(this,(function(e,t){return-1!==t.indexOf(e)}),e,\"\")},e.prototype.startsWithAnyOfIgnoreCase=function(){var e=U.apply(M,arguments);return 0===e.length?Ut(this):Lt(this,(function(e,t){return t.some((function(t){return 0===e.indexOf(t)}))}),e,vt)},e.prototype.anyOf=function(){var e=this,t=U.apply(M,arguments),n=this._cmp;try{t.sort(n)}catch(e){return Mt(this,mt)}if(0===t.length)return Ut(this);var r=new this.Collection(this,(function(){return qt(t[0],t[t.length-1])}));r._ondirectionchange=function(r){n=\"next\"===r?e._ascending:e._descending,t.sort(n)};var o=0;return r._addAlgorithm((function(e,r,i){for(var u=e.key;n(u,t[o])>0;)if(++o===t.length)return r(i),!1;return 0===n(u,t[o])||(r((function(){e.continue(t[o])})),!1)})),r},e.prototype.notEqual=function(e){return this.inAnyRange([[-1/0,e],[e,this.db._maxKey]],{includeLowers:!1,includeUppers:!1})},e.prototype.noneOf=function(){var e=U.apply(M,arguments);if(0===e.length)return new this.Collection(this);try{e.sort(this._ascending)}catch(e){return Mt(this,mt)}var t=e.reduce((function(e,t){return e?e.concat([[e[e.length-1][1],t]]):[[-1/0,t]]}),null);return t.push([e[e.length-1],this.db._maxKey]),this.inAnyRange(t,{includeLowers:!1,includeUppers:!1})},e.prototype.inAnyRange=function(e,t){var n=this,r=this._cmp,o=this._ascending,i=this._descending,u=this._min,a=this._max;if(0===e.length)return Ut(this);if(!e.every((function(e){return void 0!==e[0]&&void 0!==e[1]&&o(e[0],e[1])<=0})))return Mt(this,\"First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower\",ne.InvalidArgument);var s=!t||!1!==t.includeLowers,c=t&&!0===t.includeUppers;var l,f=o;function h(e,t){return f(e[0],t[0])}try{(l=e.reduce((function(e,t){for(var n=0,o=e.length;n<o;++n){var i=e[n];if(r(t[0],i[1])<0&&r(t[1],i[0])>0){i[0]=u(i[0],t[0]),i[1]=a(i[1],t[1]);break}}return n===o&&e.push(t),e}),[])).sort(h)}catch(e){return Mt(this,mt)}var p=0,d=c?function(e){return o(e,l[p][1])>0}:function(e){return o(e,l[p][1])>=0},y=s?function(e){return i(e,l[p][0])>0}:function(e){return i(e,l[p][0])>=0};var v=d,m=new this.Collection(this,(function(){return qt(l[0][0],l[l.length-1][1],!s,!c)}));return m._ondirectionchange=function(e){\"next\"===e?(v=d,f=o):(v=y,f=i),l.sort(h)},m._addAlgorithm((function(e,t,r){for(var i=e.key;v(i);)if(++p===l.length)return t(r),!1;return!!function(e){return!d(e)&&!y(e)}(i)||(0===n._cmp(i,l[p][1])||0===n._cmp(i,l[p][0])||t((function(){f===o?e.continue(l[p][0]):e.continue(l[p][1])})),!1)})),m},e.prototype.startsWithAnyOf=function(){var e=U.apply(M,arguments);return e.every((function(e){return\"string\"==typeof e}))?0===e.length?Ut(this):this.inAnyRange(e.map((function(e){return[e,e+vt]}))):Mt(this,\"startsWithAnyOf() only works with strings\")},e}();function Gt(e){return 1===e.length?e[0]:e}function Vt(e){try{return e.only([[]]),[[]]}catch(e){return vt}}function Wt(e){return Je((function(t){return Ht(t),e(t.target.error),!1}))}function Ht(e){e.stopPropagation&&e.stopPropagation(),e.preventDefault&&e.preventDefault()}var Yt=function(){function e(){}return e.prototype._lock=function(){return w(!Ie.global),++this._reculock,1!==this._reculock||Ie.global||(Ie.lockOwnerFor=this),this},e.prototype._unlock=function(){if(w(!Ie.global),0==--this._reculock)for(Ie.global||(Ie.lockOwnerFor=null);this._blockedFuncs.length>0&&!this._locked();){var e=this._blockedFuncs.shift();try{ft(e[1],e[0])}catch(e){}}return this},e.prototype._locked=function(){return this._reculock&&Ie.lockOwnerFor!==this},e.prototype.create=function(e){var t=this;if(!this.mode)return this;var n=this.db.idbdb,r=this.db._state.dbOpenError;if(w(!this.idbtrans),!e&&!n)switch(r&&r.name){case\"DatabaseClosedError\":throw new ne.DatabaseClosed(r);case\"MissingAPIError\":throw new ne.MissingAPI(r.message,r);default:throw new ne.OpenFailed(r)}if(!this.active)throw new ne.TransactionInactive;return w(null===this._completion._state),(e=this.idbtrans=e||n.transaction(Gt(this.storeNames),this.mode)).onerror=Je((function(n){Ht(n),t._reject(e.error)})),e.onabort=Je((function(n){Ht(n),t.active&&t._reject(new ne.Abort(e.error)),t.active=!1,t.on(\"abort\").fire(n)})),e.oncomplete=Je((function(){t.active=!1,t._resolve()})),this},e.prototype._promise=function(e,t,n){var r=this;if(\"readwrite\"===e&&\"readwrite\"!==this.mode)return yt(new ne.ReadOnly(\"Transaction is readonly\"));if(!this.active)return yt(new ne.TransactionInactive);if(this._locked())return new Be((function(o,i){r._blockedFuncs.push([function(){r._promise(e,t,n).then(o,i)},Ie])}));if(n)return rt((function(){var e=new Be((function(e,n){r._lock();var o=t(e,n,r);o&&o.then&&o.then(e,n)}));return e.finally((function(){return r._unlock()})),e._lib=!0,e}));var o=new Be((function(e,n){var o=t(e,n,r);o&&o.then&&o.then(e,n)}));return o._lib=!0,o},e.prototype._root=function(){return this.parent?this.parent._root():this},e.prototype.waitFor=function(e){var t=this._root(),n=Be.resolve(e);if(t._waitingFor)t._waitingFor=t._waitingFor.then((function(){return n}));else{t._waitingFor=n,t._waitingQueue=[];var r=t.idbtrans.objectStore(t.storeNames[0]);!function e(){for(++t._spinCount;t._waitingQueue.length;)t._waitingQueue.shift()();t._waitingFor&&(r.get(-1/0).onsuccess=e)}()}var o=t._waitingFor;return new Be((function(e,r){n.then((function(n){return t._waitingQueue.push(Je(e.bind(null,n)))}),(function(e){return t._waitingQueue.push(Je(r.bind(null,e)))})).finally((function(){t._waitingFor===o&&(t._waitingFor=null)}))}))},e.prototype.abort=function(){this.active&&this._reject(new ne.Abort),this.active=!1},e.prototype.table=function(e){var t=this._memoizedTables||(this._memoizedTables={});if(f(t,e))return t[e];var n=this.schema[e];if(!n)throw new ne.NotFound(\"Table \"+e+\" not part of transaction\");var r=new this.db.Table(e,n,this);return r.core=this.db.core.table(e),t[e]=r,r},e}();function Jt(e,t,n,r,o,i,u){return{name:e,keyPath:t,unique:n,multi:r,auto:o,compound:i,src:(n&&!u?\"&\":\"\")+(r?\"*\":\"\")+(o?\"++\":\"\")+Xt(t)}}function Xt(e){return\"string\"==typeof e?e:e?\"[\"+[].join.call(e,\"+\")+\"]\":\"\"}function $t(e,t,n){return{name:e,primKey:t,indexes:n,mappedClass:null,idxByName:x(n,(function(e){return[e.name,e]}))}}function Zt(e){return null==e?function(){}:\"string\"==typeof e?function(e){return 1===e.split(\".\").length?function(t){return t[e]}:function(t){return k(t,e)}}(e):function(t){return k(t,e)}}function en(e,t){return\"delete\"===t.type?t.keys:t.keys||t.values.map(e.extractKey)}function tn(e){return[].slice.call(e)}var nn=0;function rn(e){return null==e?\":id\":\"string\"==typeof e?e:\"[\"+e.join(\"+\")+\"]\"}function on(e,t,n,r){var i=t.cmp.bind(t);function a(e){if(3===e.type)return null;if(4===e.type)throw new Error(\"Cannot convert never type to IDBKeyRange\");var t=e.lower,r=e.upper,o=e.lowerOpen,i=e.upperOpen;return void 0===t?void 0===r?null:n.upperBound(r,!!i):void 0===r?n.lowerBound(t,!!o):n.bound(t,r,!!o,!!i)}var s=function(e,t){var n=tn(e.objectStoreNames);return{schema:{name:e.name,tables:n.map((function(e){return t.objectStore(e)})).map((function(e){var t=e.keyPath,n=e.autoIncrement,r=u(t),o=null==t,i={},a={name:e.name,primaryKey:{name:null,isPrimaryKey:!0,outbound:o,compound:r,keyPath:t,autoIncrement:n,unique:!0,extractKey:Zt(t)},indexes:tn(e.indexNames).map((function(t){return e.index(t)})).map((function(e){var t=e.name,n=e.unique,r=e.multiEntry,o=e.keyPath,a={name:t,compound:u(o),keyPath:o,unique:n,multiEntry:r,extractKey:Zt(o)};return i[rn(o)]=a,a})),getIndexByKeyPath:function(e){return i[rn(e)]}};return i[\":id\"]=a.primaryKey,null!=t&&(i[rn(t)]=a.primaryKey),a}))},hasGetAll:n.length>0&&\"getAll\"in t.objectStore(n[0])&&!(\"undefined\"!=typeof navigator&&/Safari/.test(navigator.userAgent)&&!/(Chrome\\/|Edge\\/)/.test(navigator.userAgent)&&[].concat(navigator.userAgent.match(/Safari\\/(\\d*)/))[1]<604)}}(e,r),c=s.schema,l=s.hasGetAll,f=c.tables.map((function(e){return function(e){var t=e.name;return{name:t,schema:e,mutate:function(n){var r=n.trans,i=n.type,u=n.keys,s=n.values,c=n.range,l=n.wantResults;return new Promise((function(n,f){n=Je(n);var h=r.objectStore(t),p=null==h.keyPath,d=\"put\"===i||\"add\"===i;if(!d&&\"delete\"!==i&&\"deleteRange\"!==i)throw new Error(\"Invalid operation type: \"+i);var y=(u||s||{length:1}).length;if(u&&s&&u.length!==s.length)throw new Error(\"Given keys array must have same length as given values array.\");if(0===y)return n({numFailures:0,failures:{},results:[],lastResult:void 0});var v,m=l&&o(u||en(e.primaryKey,{type:i,keys:u,values:s})),g=[],b=0,w=function(e){++b,Ht(e),m&&(m[e.target._reqno]=void 0),g[e.target._reqno]=e.target.error},_=function(e){var t=e.target;m[t._reqno]=t.result};if(\"deleteRange\"===i){if(4===c.type)return n({numFailures:b,failures:g,results:m,lastResult:void 0});v=3===c.type?h.clear():h.delete(a(c))}else{var x=d?p?[s,u]:[s,null]:[u,null],k=x[0],O=x[1];if(d)for(var E=0;E<y;++E)(v=O&&void 0!==O[E]?h[i](k[E],O[E]):h[i](k[E]))._reqno=E,m&&void 0===m[E]&&(v.onsuccess=_),v.onerror=w;else for(E=0;E<y;++E)(v=h[i](k[E]))._reqno=E,v.onerror=w}var j=function(e){var t=e.target.result;m&&(m[y-1]=t),n({numFailures:b,failures:g,results:m,lastResult:t})};v.onerror=function(e){w(e),j(e)},v.onsuccess=j}))},getMany:function(e){var n=e.trans,r=e.keys;return new Promise((function(e,o){e=Je(e);for(var i,u=n.objectStore(t),a=r.length,s=new Array(a),c=0,l=0,f=function(t){var n=t.target;null!=(s[n._pos]=n.result)&&0,++l===c&&e(s)},h=Wt(o),p=0;p<a;++p){null!=r[p]&&((i=u.get(r[p]))._pos=p,i.onsuccess=f,i.onerror=h,++c)}0===c&&e(s)}))},get:function(e){var n=e.trans,r=e.key;return new Promise((function(e,o){e=Je(e);var i=n.objectStore(t).get(r);i.onsuccess=function(t){return e(t.target.result)},i.onerror=Wt(o)}))},query:function(e){return function(n){return new Promise((function(r,o){r=Je(r);var i=n.trans,u=n.values,s=n.limit,c=n.query,l=s===1/0?void 0:s,f=c.index,h=c.range,p=i.objectStore(t),d=f.isPrimaryKey?p:p.index(f.name),y=a(h);if(0===s)return r({result:[]});if(e){var v=u?d.getAll(y,l):d.getAllKeys(y,l);v.onsuccess=function(e){return r({result:e.target.result})},v.onerror=Wt(o)}else{var m=0,g=!u&&\"openKeyCursor\"in d?d.openKeyCursor(y):d.openCursor(y),b=[];g.onsuccess=function(e){var t=g.result;return t?(b.push(u?t.value:t.primaryKey),++m===s?r({result:b}):void t.continue()):r({result:b})},g.onerror=Wt(o)}}))}}(l),openCursor:function(e){var n=e.trans,r=e.values,o=e.query,i=e.reverse,u=e.unique;return new Promise((function(e,s){e=Je(e);var c=o.index,l=o.range,f=n.objectStore(t),h=c.isPrimaryKey?f:f.index(c.name),p=i?u?\"prevunique\":\"prev\":u?\"nextunique\":\"next\",d=!r&&\"openKeyCursor\"in h?h.openKeyCursor(a(l),p):h.openCursor(a(l),p);d.onerror=Wt(s),d.onsuccess=Je((function(t){var r=d.result;if(r){r.___id=++nn,r.done=!1;var o=r.continue.bind(r),i=r.continuePrimaryKey;i&&(i=i.bind(r));var u=r.advance.bind(r),a=function(){throw new Error(\"Cursor not stopped\")};r.trans=n,r.stop=r.continue=r.continuePrimaryKey=r.advance=function(){throw new Error(\"Cursor not started\")},r.fail=Je(s),r.next=function(){var e=this,t=1;return this.start((function(){return t--?e.continue():e.stop()})).then((function(){return e}))},r.start=function(e){var t=new Promise((function(e,t){e=Je(e),d.onerror=Wt(t),r.fail=t,r.stop=function(t){r.stop=r.continue=r.continuePrimaryKey=r.advance=a,e(t)}})),n=function(){if(d.result)try{e()}catch(e){r.fail(e)}else r.done=!0,r.start=function(){throw new Error(\"Cursor behind last entry\")},r.stop()};return d.onsuccess=Je((function(e){d.onsuccess=n,n()})),r.continue=o,r.continuePrimaryKey=i,r.advance=u,n(),t},e(r)}else e(null)}),s)}))},count:function(e){var n=e.query,r=e.trans,o=n.index,i=n.range;return new Promise((function(e,n){var u=r.objectStore(t),s=o.isPrimaryKey?u:u.index(o.name),c=a(i),l=c?s.count(c):s.count();l.onsuccess=Je((function(t){return e(t.target.result)})),l.onerror=Wt(n)}))}}}(e)})),h={};return f.forEach((function(e){return h[e.name]=e})),{stack:\"dbcore\",transaction:e.transaction.bind(e),table:function(e){if(!h[e])throw new Error(\"Table '\"+e+\"' not found\");return h[e]},cmp:i,MIN_KEY:-1/0,MAX_KEY:Vt(n),schema:c}}function un(e,t,n,o){var i=n.IDBKeyRange;return{dbcore:function(e,t){return t.reduce((function(e,t){var n=t.create;return r(r({},e),n(e))}),e)}(on(t,n.indexedDB,i,o),e.dbcore)}}function an(e,t){var n=t.db,r=un(e._middlewares,n,e._deps,t);e.core=r.dbcore,e.tables.forEach((function(t){var n=t.name;e.core.schema.tables.some((function(e){return e.name===n}))&&(t.core=e.core.table(n),e[n]instanceof e.Table&&(e[n].core=t.core))}))}function sn(e,t,n,r){n.forEach((function(n){var o=r[n];t.forEach((function(t){n in t||(t===e.Transaction.prototype||t instanceof e.Transaction?d(t,n,{get:function(){return this.table(n)},set:function(e){p(this,n,{value:e,writable:!0,configurable:!0,enumerable:!0})}}):t[n]=new e.Table(n,o))}))}))}function cn(e,t){t.forEach((function(t){for(var n in t)t[n]instanceof e.Table&&delete t[n]}))}function ln(e,t){return e._cfg.version-t._cfg.version}function fn(e,t,n,r){var o=e._dbSchema,u=e._createTransaction(\"readwrite\",e._storeNames,o);u.create(n),u._completion.catch(r);var a=u._reject.bind(u),s=Ie.transless||Ie;rt((function(){Ie.trans=u,Ie.transless=s,0===t?(i(o).forEach((function(e){hn(n,e,o[e].primKey,o[e].indexes)})),an(e,n),Be.follow((function(){return e.on.populate.fire(u)})).catch(a)):function(e,t,n,r){var o=[],u=e._versions,a=e._dbSchema=dn(e,e.idbdb,r),s=!1;function c(){return o.length?Be.resolve(o.shift()(n.idbtrans)).then(c):Be.resolve()}return u.filter((function(e){return e._cfg.version>=t})).forEach((function(u){o.push((function(){var o=a,c=u._cfg.dbschema;yn(e,o,r),yn(e,c,r),a=e._dbSchema=c;var l=function(e,t){var n,r={del:[],add:[],change:[]};for(n in e)t[n]||r.del.push(n);for(n in t){var o=e[n],i=t[n];if(o){var u={name:n,def:i,recreate:!1,del:[],add:[],change:[]};if(o.primKey.src===i.primKey.src||bt){var a=o.idxByName,s=i.idxByName,c=void 0;for(c in a)s[c]||u.del.push(c);for(c in s){var l=a[c],f=s[c];l?l.src!==f.src&&u.change.push(f):u.add.push(f)}(u.del.length>0||u.add.length>0||u.change.length>0)&&r.change.push(u)}else u.recreate=!0,r.change.push(u)}else r.add.push([n,i])}return r}(o,c);l.add.forEach((function(e){hn(r,e[0],e[1].primKey,e[1].indexes)})),l.change.forEach((function(e){if(e.recreate)throw new ne.Upgrade(\"Not yet support for changing primary key\");var t=r.objectStore(e.name);e.add.forEach((function(e){return pn(t,e)})),e.change.forEach((function(e){t.deleteIndex(e.name),pn(t,e)})),e.del.forEach((function(e){return t.deleteIndex(e)}))}));var f=u._cfg.contentUpgrade;if(f&&u._cfg.version>t){an(e,r),s=!0;var h=E(c);l.del.forEach((function(e){h[e]=o[e]})),cn(e,[e.Transaction.prototype]),sn(e,[e.Transaction.prototype],i(h),h),n.schema=h;var p,d=N(f);d&&ot();var y=Be.follow((function(){if((p=f(n))&&d){var e=it.bind(null,null);p.then(e,e)}}));return p&&\"function\"==typeof p.then?Be.resolve(p):y.then((function(){return p}))}})),o.push((function(t){s&&wt||function(e,t){for(var n=0;n<t.db.objectStoreNames.length;++n){var r=t.db.objectStoreNames[n];null==e[r]&&t.db.deleteObjectStore(r)}}(u._cfg.dbschema,t);cn(e,[e.Transaction.prototype]),sn(e,[e.Transaction.prototype],e._storeNames,e._dbSchema),n.schema=e._dbSchema}))})),c().then((function(){var e,t;t=r,i(e=a).forEach((function(n){t.db.objectStoreNames.contains(n)||hn(t,n,e[n].primKey,e[n].indexes)}))}))}(e,t,u,n).catch(a)}))}function hn(e,t,n,r){var o=e.db.createObjectStore(t,n.keyPath?{keyPath:n.keyPath,autoIncrement:n.auto}:{autoIncrement:n.auto});return r.forEach((function(e){return pn(o,e)})),o}function pn(e,t){e.createIndex(t.name,t.keyPath,{unique:t.unique,multiEntry:t.multi})}function dn(e,t,n){var r={};return g(t.objectStoreNames,0).forEach((function(e){for(var t=n.objectStore(e),o=t.keyPath,i=Jt(Xt(o),o||\"\",!1,!1,!!t.autoIncrement,o&&\"string\"!=typeof o,!0),u=[],a=0;a<t.indexNames.length;++a){var s=t.index(t.indexNames[a]);o=s.keyPath;var c=Jt(s.name,o,!!s.unique,!!s.multiEntry,!1,o&&\"string\"!=typeof o,!1);u.push(c)}r[e]=$t(e,i,u)})),r}function yn(e,t,n){for(var r=n.db.objectStoreNames,o=0;o<r.length;++o){var i=r[o],u=n.objectStore(i);e._hasGetAll=\"getAll\"in u;for(var s=0;s<u.indexNames.length;++s){var c=u.indexNames[s],l=u.index(c).keyPath,f=\"string\"==typeof l?l:\"[\"+g(l).join(\"+\")+\"]\";if(t[i]){var h=t[i].idxByName[f];h&&(h.name=c,delete t[i].idxByName[f],t[i].idxByName[c]=h)}}}\"undefined\"!=typeof navigator&&/Safari/.test(navigator.userAgent)&&!/(Chrome\\/|Edge\\/)/.test(navigator.userAgent)&&a.WorkerGlobalScope&&a instanceof a.WorkerGlobalScope&&[].concat(navigator.userAgent.match(/Safari\\/(\\d*)/))[1]<604&&(e._hasGetAll=!1)}var vn,mn=function(){function e(){}return e.prototype._parseStoresSpec=function(e,t){i(e).forEach((function(n){if(null!==e[n]){var r=e[n].split(\",\").map((function(e,t){var n=(e=e.trim()).replace(/([&*]|\\+\\+)/g,\"\"),r=/^\\[/.test(n)?n.match(/^\\[(.*)\\]$/)[1].split(\"+\"):n;return Jt(n,r||null,/\\&/.test(e),/\\*/.test(e),/\\+\\+/.test(e),u(r),0===t)})),o=r.shift();if(o.multi)throw new ne.Schema(\"Primary key cannot be multi-valued\");r.forEach((function(e){if(e.auto)throw new ne.Schema(\"Only primary key can be marked as autoIncrement (++)\");if(!e.keyPath)throw new ne.Schema(\"Index must have a name and cannot be an empty string\")})),t[n]=$t(n,o,r)}}))},e.prototype.stores=function(e){var t=this.db;this._cfg.storesSource=this._cfg.storesSource?s(this._cfg.storesSource,e):e;var n=t._versions,r={},o={};return n.forEach((function(e){s(r,e._cfg.storesSource),o=e._cfg.dbschema={},e._parseStoresSpec(r,o)})),t._dbSchema=o,cn(t,[t._allTables,t,t.Transaction.prototype]),sn(t,[t._allTables,t,t.Transaction.prototype,this._cfg.tables],i(o),o),t._storeNames=i(o),this},e.prototype.upgrade=function(e){return this._cfg.contentUpgrade=e,this},e}();function gn(e){return rt((function(){return Ie.letThrough=!0,e()}))}function bn(e){var t=e._state,n=e._deps.indexedDB;if(t.isBeingOpened||e.idbdb)return t.dbReadyPromise.then((function(){return t.dbOpenError?yt(t.dbOpenError):e}));L&&(t.openCanceller._stackHolder=G()),t.isBeingOpened=!0,t.dbOpenError=null,t.openComplete=!1;var r=t.dbReadyResolve,o=null;return Be.race([t.openCanceller,new Be((function(r,u){if(!n)throw new ne.MissingAPI(\"indexedDB API not found. If using IE10+, make sure to run your code on a server URL (not locally). If using old Safari versions, make sure to include indexedDB polyfill.\");var a=e.name,s=t.autoSchema?n.open(a):n.open(a,Math.round(10*e.verno));if(!s)throw new ne.MissingAPI(\"IndexedDB API not available\");s.onerror=Wt(u),s.onblocked=Je(e._fireOnBlocked),s.onupgradeneeded=Je((function(r){if(o=s.transaction,t.autoSchema&&!e._options.allowEmptyDB){s.onerror=Ht,o.abort(),s.result.close();var i=n.deleteDatabase(a);i.onsuccess=i.onerror=Je((function(){u(new ne.NoSuchDatabase(\"Database \"+a+\" doesnt exist\"))}))}else{o.onerror=Wt(u);var c=r.oldVersion>Math.pow(2,62)?0:r.oldVersion;e.idbdb=s.result,fn(e,c/10,o,u)}}),u),s.onsuccess=Je((function(){o=null;var n=e.idbdb=s.result,u=g(n.objectStoreNames);if(u.length>0)try{var c=n.transaction(Gt(u),\"readonly\");t.autoSchema?function(e,t,n){e.verno=t.version/10;var r=e._dbSchema=dn(0,t,n);e._storeNames=g(t.objectStoreNames,0),sn(e,[e._allTables],i(r),r)}(e,n,c):yn(e,e._dbSchema,c),an(e,c)}catch(e){}gt.push(e),n.onversionchange=Je((function(n){t.vcFired=!0,e.on(\"versionchange\").fire(n)})),vn.add(a),r()}),u)}))]).then((function(){return t.onReadyBeingFired=[],Be.resolve(gn(e.on.ready.fire)).then((function e(){if(t.onReadyBeingFired.length>0){var n=t.onReadyBeingFired.reduce(pe,ie);return t.onReadyBeingFired=[],Be.resolve(gn(n)).then(e)}}))})).finally((function(){t.onReadyBeingFired=null})).then((function(){return t.isBeingOpened=!1,e})).catch((function(n){try{o&&o.abort()}catch(e){}return t.isBeingOpened=!1,e.close(),t.dbOpenError=n,yt(t.dbOpenError)})).finally((function(){t.openComplete=!0,r()}))}function wn(e){var t=function(t){return e.next(t)},n=o(t),r=o((function(t){return e.throw(t)}));function o(e){return function(t){var o=e(t),i=o.value;return o.done?i:i&&\"function\"==typeof i.then?i.then(n,r):u(i)?Promise.all(i).then(n,r):n(i)}}return o(t)()}function _n(e,t,n){var r=arguments.length;if(r<2)throw new ne.InvalidArgument(\"Too few arguments\");for(var o=new Array(r-1);--r;)o[r-1]=arguments[r];n=o.pop();var i=P(o);return[e,i,n]}function xn(e,t,n,r,o){return Be.resolve().then((function(){var i=Ie.transless||Ie,u=e._createTransaction(t,n,e._dbSchema,r),a={trans:u,transless:i};r?u.idbtrans=r.idbtrans:u.create();var s,c=N(o);c&&ot();var l=Be.follow((function(){if(s=o.call(u,u))if(c){var e=it.bind(null,null);s.then(e,e)}else\"function\"==typeof s.next&&\"function\"==typeof s.throw&&(s=wn(s))}),a);return(s&&\"function\"==typeof s.then?Be.resolve(s).then((function(e){return u.active?e:yt(new ne.PrematureCommit(\"Transaction committed too early. See http://bit.ly/2kdckMn\"))})):l.then((function(){return s}))).then((function(e){return r&&u._resolve(),u._completion.then((function(){return e}))})).catch((function(e){return u._reject(e),yt(e)}))}))}function kn(e,t,n){for(var r=u(e)?e.slice():[e],o=0;o<n;++o)r.push(t);return r}var On={stack:\"dbcore\",name:\"VirtualIndexMiddleware\",level:1,create:function(e){return r(r({},e),{table:function(t){var n=e.table(t),o=n.schema,i={},u=[];function a(e,t,n){var o=rn(e),s=i[o]=i[o]||[],c=null==e?0:\"string\"==typeof e?1:e.length,l=t>0,f=r(r({},n),{isVirtual:l,isPrimaryKey:!l&&n.isPrimaryKey,keyTail:t,keyLength:c,extractKey:Zt(e),unique:!l&&n.unique});(s.push(f),f.isPrimaryKey||u.push(f),c>1)&&a(2===c?e[0]:e.slice(0,c-1),t+1,n);return s.sort((function(e,t){return e.keyTail-t.keyTail})),f}var s=a(o.primaryKey.keyPath,0,o.primaryKey);i[\":id\"]=[s];for(var c=0,l=o.indexes;c<l.length;c++){var f=l[c];a(f.keyPath,0,f)}function h(t){var n,o,i=t.query.index;return i.isVirtual?r(r({},t),{query:{index:i,range:(n=t.query.range,o=i.keyTail,{type:1===n.type?2:n.type,lower:kn(n.lower,n.lowerOpen?e.MAX_KEY:e.MIN_KEY,o),lowerOpen:!0,upper:kn(n.upper,n.upperOpen?e.MIN_KEY:e.MAX_KEY,o),upperOpen:!0})}}):t}return r(r({},n),{schema:r(r({},o),{primaryKey:s,indexes:u,getIndexByKeyPath:function(e){var t=i[rn(e)];return t&&t[0]}}),count:function(e){return n.count(h(e))},query:function(e){return n.query(h(e))},openCursor:function(t){var r=t.query.index,o=r.keyTail,i=r.isVirtual,u=r.keyLength;if(!i)return n.openCursor(t);return n.openCursor(h(t)).then((function(n){return n&&function(n){return Object.create(n,{continue:{value:function(r){null!=r?n.continue(kn(r,t.reverse?e.MAX_KEY:e.MIN_KEY,o)):t.unique?n.continue(kn(n.key,t.reverse?e.MIN_KEY:e.MAX_KEY,o)):n.continue()}},continuePrimaryKey:{value:function(t,r){n.continuePrimaryKey(kn(t,e.MAX_KEY,o),r)}},key:{get:function(){var e=n.key;return 1===u?e[0]:e.slice(0,u)}},value:{get:function(){return n.value}}})}(n)}))}})}})}},En={stack:\"dbcore\",name:\"HooksMiddleware\",level:2,create:function(e){return r(r({},e),{table:function(t){var n=e.table(t),i=n.schema.primaryKey;return r(r({},n),{mutate:function(e){var u=Ie.trans,a=u.table(t).hook,s=a.deleting,c=a.creating,l=a.updating;switch(e.type){case\"add\":if(c.fire===ie)break;return u._promise(\"readwrite\",(function(){return f(e)}),!0);case\"put\":if(c.fire===ie&&l.fire===ie)break;return u._promise(\"readwrite\",(function(){return f(e)}),!0);case\"delete\":if(s.fire===ie)break;return u._promise(\"readwrite\",(function(){return f(e)}),!0);case\"deleteRange\":if(s.fire===ie)break;return u._promise(\"readwrite\",(function(){return function(e){return function e(t,o,u){return n.query({trans:t,values:!1,query:{index:i,range:o},limit:u}).then((function(n){var i=n.result;return f({type:\"delete\",keys:i,trans:t}).then((function(n){return n.numFailures>0?Promise.reject(n.failures[0]):i.length<u?{failures:[],numFailures:0,lastResult:void 0}:e(t,r(r({},o),{lower:i[i.length-1],lowerOpen:!0}),u)}))}))}(e.trans,e.range,1e4)}(e)}),!0)}return n.mutate(e);function f(e){var t=Ie.trans,u=e.keys||en(i,e);if(!u)throw new Error(\"Keys missing\");return\"delete\"!==(e=\"add\"===e.type||\"put\"===e.type?r(r({},e),{keys:u,wantResults:!0}):r({},e)).type&&(e.values=o(e.values)),e.keys&&(e.keys=o(e.keys)),function(e,t,n){return\"add\"===t.type?Promise.resolve(new Array(t.values.length)):e.getMany({trans:t.trans,keys:n})}(n,e,u).then((function(r){var o=u.map((function(n,o){var u=r[o],a={onerror:null,onsuccess:null};if(\"delete\"===e.type)s.fire.call(a,n,u,t);else if(\"add\"===e.type||void 0===u){var f=c.fire.call(a,n,e.values[o],t);null==n&&null!=f&&(n=f,e.keys[o]=n,i.outbound||O(e.values[o],i.keyPath,n))}else{var h=F(u,e.values[o]),p=l.fire.call(a,h,n,u,t);if(p){var d=e.values[o];Object.keys(p).forEach((function(e){O(d,e,p[e])}))}}return a}));return n.mutate(e).then((function(t){for(var n=t.failures,i=t.results,a=t.numFailures,s=t.lastResult,c=0;c<u.length;++c){var l=i?i[c]:u[c],f=o[c];null==l?f.onerror&&f.onerror(n[c]):f.onsuccess&&f.onsuccess(\"put\"===e.type&&r[c]?e.values[c]:l)}return{failures:n,results:i,numFailures:a,lastResult:s}})).catch((function(e){return o.forEach((function(t){return t.onerror&&t.onerror(e)})),Promise.reject(e)}))}))}}})}})}},jn=function(){function e(t,n){var o=this;this._middlewares={},this.verno=0;var i=e.dependencies;this._options=n=r({addons:e.addons,autoOpen:!0,indexedDB:i.indexedDB,IDBKeyRange:i.IDBKeyRange},n),this._deps={indexedDB:n.indexedDB,IDBKeyRange:n.IDBKeyRange};var u=n.addons;this._dbSchema={},this._versions=[],this._storeNames=[],this._allTables={},this.idbdb=null;var a,s={dbOpenError:null,isBeingOpened:!1,onReadyBeingFired:null,openComplete:!1,dbReadyResolve:ie,dbReadyPromise:null,cancelOpen:ie,openCanceller:null,autoSchema:!0};s.dbReadyPromise=new Be((function(e){s.dbReadyResolve=e})),s.openCanceller=new Be((function(e,t){s.cancelOpen=t})),this._state=s,this.name=t,this.on=jt(this,\"populate\",\"blocked\",\"versionchange\",{ready:[pe,ie]}),this.on.ready.subscribe=b(this.on.ready.subscribe,(function(t){return function(n,r){e.vip((function(){var e=o._state;if(e.openComplete)e.dbOpenError||Be.resolve().then(n),r&&t(n);else if(e.onReadyBeingFired)e.onReadyBeingFired.push(n),r&&t(n);else{t(n);var i=o;r||t((function e(){i.on.ready.unsubscribe(n),i.on.ready.unsubscribe(e)}))}}))}})),this.Collection=(a=this,Pt(Ft.prototype,(function(e,t){this.db=a;var n=Ot,r=null;if(t)try{n=t()}catch(e){r=e}var o=e._ctx,i=o.table,u=i.hook.reading.fire;this._ctx={table:i,index:o.index,isPrimKey:!o.index||i.schema.primKey.keyPath&&o.index===i.schema.primKey.name,range:n,keysOnly:!1,dir:\"next\",unique:\"\",algorithm:null,filter:null,replayFilter:null,justLimit:!0,isMatch:null,offset:0,limit:1/0,error:r,or:o.or,valueMapper:u!==ue?u:null}}))),this.Table=function(e){return Pt(Et.prototype,(function(t,n,r){this.db=e,this._tx=r,this.name=t,this.schema=n,this.hook=e._allTables[t]?e._allTables[t].hook:jt(null,{creating:[ce,ie],reading:[ae,ue],updating:[fe,ie],deleting:[le,ie]})}))}(this),this.Transaction=function(e){return Pt(Yt.prototype,(function(t,n,r,o){var i=this;this.db=e,this.mode=t,this.storeNames=n,this.schema=r,this.idbtrans=null,this.on=jt(this,\"complete\",\"error\",\"abort\"),this.parent=o||null,this.active=!0,this._reculock=0,this._blockedFuncs=[],this._resolve=null,this._reject=null,this._waitingFor=null,this._waitingQueue=null,this._spinCount=0,this._completion=new Be((function(e,t){i._resolve=e,i._reject=t})),this._completion.then((function(){i.active=!1,i.on.complete.fire()}),(function(e){var t=i.active;return i.active=!1,i.on.error.fire(e),i.parent?i.parent._reject(e):t&&i.idbtrans&&i.idbtrans.abort(),yt(e)}))}))}(this),this.Version=function(e){return Pt(mn.prototype,(function(t){this.db=e,this._cfg={version:t,storesSource:null,dbschema:{},tables:{},contentUpgrade:null}}))}(this),this.WhereClause=function(e){return Pt(Qt.prototype,(function(t,n,r){this.db=e,this._ctx={table:t,index:\":id\"===n?null:n,or:r};var o=e._deps.indexedDB;if(!o)throw new ne.MissingAPI(\"indexedDB API missing\");this._cmp=this._ascending=o.cmp.bind(o),this._descending=function(e,t){return o.cmp(t,e)},this._max=function(e,t){return o.cmp(e,t)>0?e:t},this._min=function(e,t){return o.cmp(e,t)<0?e:t},this._IDBKeyRange=e._deps.IDBKeyRange}))}(this),this.on(\"versionchange\",(function(e){e.newVersion>0?console.warn(\"Another connection wants to upgrade database '\"+o.name+\"'. Closing db now to resume the upgrade.\"):console.warn(\"Another connection wants to delete database '\"+o.name+\"'. Closing db now to resume the delete request.\"),o.close()})),this.on(\"blocked\",(function(e){!e.newVersion||e.newVersion<e.oldVersion?console.warn(\"Dexie.delete('\"+o.name+\"') was blocked\"):console.warn(\"Upgrade '\"+o.name+\"' blocked by other connection holding version \"+e.oldVersion/10)})),this._maxKey=Vt(n.IDBKeyRange),this._createTransaction=function(e,t,n,r){return new o.Transaction(e,t,n,r)},this._fireOnBlocked=function(e){o.on(\"blocked\").fire(e),gt.filter((function(e){return e.name===o.name&&e!==o&&!e._state.vcFired})).map((function(t){return t.on(\"versionchange\").fire(e)}))},this.use(On),this.use(En),u.forEach((function(e){return e(o)}))}return e.prototype.version=function(e){if(isNaN(e)||e<.1)throw new ne.Type(\"Given version is not a positive number\");if(e=Math.round(10*e)/10,this.idbdb||this._state.isBeingOpened)throw new ne.Schema(\"Cannot add version when database is open\");this.verno=Math.max(this.verno,e);var t=this._versions,n=t.filter((function(t){return t._cfg.version===e}))[0];return n||(n=new this.Version(e),t.push(n),t.sort(ln),n.stores({}),this._state.autoSchema=!1,n)},e.prototype._whenReady=function(e){var t=this;return this._state.openComplete||Ie.letThrough?e():new Be((function(e,n){if(!t._state.isBeingOpened){if(!t._options.autoOpen)return void n(new ne.DatabaseClosed);t.open().catch(ie)}t._state.dbReadyPromise.then(e,n)})).then(e)},e.prototype.use=function(e){var t=e.stack,n=e.create,r=e.level,o=e.name;o&&this.unuse({stack:t,name:o});var i=this._middlewares[t]||(this._middlewares[t]=[]);return i.push({stack:t,create:n,level:null==r?10:r,name:o}),i.sort((function(e,t){return e.level-t.level})),this},e.prototype.unuse=function(e){var t=e.stack,n=e.name,r=e.create;return t&&this._middlewares[t]&&(this._middlewares[t]=this._middlewares[t].filter((function(e){return r?e.create!==r:!!n&&e.name!==n}))),this},e.prototype.open=function(){return bn(this)},e.prototype.close=function(){var e=gt.indexOf(this),t=this._state;if(e>=0&&gt.splice(e,1),this.idbdb){try{this.idbdb.close()}catch(e){}this.idbdb=null}this._options.autoOpen=!1,t.dbOpenError=new ne.DatabaseClosed,t.isBeingOpened&&t.cancelOpen(t.dbOpenError),t.dbReadyPromise=new Be((function(e){t.dbReadyResolve=e})),t.openCanceller=new Be((function(e,n){t.cancelOpen=n}))},e.prototype.delete=function(){var e=this,t=arguments.length>0,n=this._state;return new Be((function(r,o){var i=function(){e.close();var t=e._deps.indexedDB.deleteDatabase(e.name);t.onsuccess=Je((function(){vn.remove(e.name),r()})),t.onerror=Wt(o),t.onblocked=e._fireOnBlocked};if(t)throw new ne.InvalidArgument(\"Arguments not allowed in db.delete()\");n.isBeingOpened?n.dbReadyPromise.then(i):i()}))},e.prototype.backendDB=function(){return this.idbdb},e.prototype.isOpen=function(){return null!==this.idbdb},e.prototype.hasBeenClosed=function(){var e=this._state.dbOpenError;return e&&\"DatabaseClosed\"===e.name},e.prototype.hasFailed=function(){return null!==this._state.dbOpenError},e.prototype.dynamicallyOpened=function(){return this._state.autoSchema},Object.defineProperty(e.prototype,\"tables\",{get:function(){var e=this;return i(this._allTables).map((function(t){return e._allTables[t]}))},enumerable:!0,configurable:!0}),e.prototype.transaction=function(){var e=_n.apply(this,arguments);return this._transaction.apply(this,e)},e.prototype._transaction=function(e,t,n){var r=this,o=Ie.trans;o&&o.db===this&&-1===e.indexOf(\"!\")||(o=null);var i,u,a=-1!==e.indexOf(\"?\");e=e.replace(\"!\",\"\").replace(\"?\",\"\");try{if(u=t.map((function(e){var t=e instanceof r.Table?e.name:e;if(\"string\"!=typeof t)throw new TypeError(\"Invalid table argument to Dexie.transaction(). Only Table or String are allowed\");return t})),\"r\"==e||\"readonly\"===e)i=\"readonly\";else{if(\"rw\"!=e&&\"readwrite\"!=e)throw new ne.InvalidArgument(\"Invalid transaction mode: \"+e);i=\"readwrite\"}if(o){if(\"readonly\"===o.mode&&\"readwrite\"===i){if(!a)throw new ne.SubTransaction(\"Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY\");o=null}o&&u.forEach((function(e){if(o&&-1===o.storeNames.indexOf(e)){if(!a)throw new ne.SubTransaction(\"Table \"+e+\" not included in parent transaction.\");o=null}})),a&&o&&!o.active&&(o=null)}}catch(e){return o?o._promise(null,(function(t,n){n(e)})):yt(e)}var s=xn.bind(null,this,i,u,o,n);return o?o._promise(i,s,\"lock\"):Ie.trans?ft(Ie.transless,(function(){return r._whenReady(s)})):this._whenReady(s)},e.prototype.table=function(e){if(!f(this._allTables,e))throw new ne.InvalidTable(\"Table \"+e+\" does not exist\");return this._allTables[e]},e}(),Pn=jn;h(Pn,r(r({},oe),{delete:function(e){return new Pn(e).delete()},exists:function(e){return new Pn(e,{addons:[]}).open().then((function(e){return e.close(),!0})).catch(\"NoSuchDatabaseError\",(function(){return!1}))},getDatabaseNames:function(e){return vn?vn.getDatabaseNames().then(e):Be.resolve([])},defineClass:function(){return function(e){s(this,e)}},ignoreTransaction:function(e){return Ie.trans?ft(Ie.transless,e):e()},vip:gn,async:function(e){return function(){try{var t=wn(e.apply(this,arguments));return t&&\"function\"==typeof t.then?t:Be.resolve(t)}catch(e){return yt(e)}}},spawn:function(e,t,n){try{var r=wn(e.apply(n,t||[]));return r&&\"function\"==typeof r.then?r:Be.resolve(r)}catch(e){return yt(e)}},currentTransaction:{get:function(){return Ie.trans||null}},waitFor:function(e,t){var n=Be.resolve(\"function\"==typeof e?Pn.ignoreTransaction(e):e).timeout(t||6e4);return Ie.trans?Ie.trans.waitFor(n):n},Promise:Be,debug:{get:function(){return L},set:function(e){q(e,\"dexie\"===e?function(){return!0}:xt)}},derive:y,extend:s,props:h,override:b,Events:jt,getByKeyPath:k,setByKeyPath:O,delByKeyPath:function(e,t){\"string\"==typeof t?O(e,t,void 0):\"length\"in t&&[].map.call(t,(function(t){O(e,t,void 0)}))},shallowClone:E,deepClone:A,getObjectDiff:F,asap:_,minKey:-1/0,addons:[],connections:gt,errnames:ee,dependencies:function(){try{return{indexedDB:a.indexedDB||a.mozIndexedDB||a.webkitIndexedDB||a.msIndexedDB,IDBKeyRange:a.IDBKeyRange||a.webkitIDBKeyRange}}catch(e){return{indexedDB:null,IDBKeyRange:null}}}(),semVer:\"3.0.1\",version:\"3.0.1\".split(\".\").map((function(e){return parseInt(e)})).reduce((function(e,t,n){return e+t/Math.pow(10,2*n)})),default:Pn,Dexie:Pn})),Pn.maxKey=Vt(Pn.dependencies.IDBKeyRange),function(e){try{vn=function(e){var t,n=e&&\"function\"==typeof e.databases;if(!n){var r=new jn(\"__dbnames\",{addons:[]});r.version(1).stores({dbnames:\"name\"}),t=r.table(\"dbnames\")}return{getDatabaseNames:function(){return n?Be.resolve(e.databases()).then((function(e){return e.map((function(e){return e.name})).filter((function(e){return\"__dbnames\"!==e}))})):t.toCollection().primaryKeys()},add:function(e){return!n&&\"__dbnames\"!==e&&t.put({name:e}).catch(ie)},remove:function(e){return!n&&\"__dbnames\"!==e&&t.delete(e).catch(ie)}}}(e)}catch(e){}}(jn.dependencies.indexedDB),Be.rejectionMapper=function(e,t){if(!e||e instanceof J||e instanceof TypeError||e instanceof SyntaxError||!e.name||!re[e.name])return e;var n=new re[e.name](t||e.message,e);return\"stack\"in e&&d(n,\"stack\",{get:function(){return this.inner.stack}}),n},q(L,xt),t.default=jn},function(e,t,n){\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0}),t.LogFactory=void 0;var r=n(5),o=n(9),i=function(){function e(e,t){void 0===e&&(e=function(){return new Date}),void 0===t&&(t=32e3),this.getNow=e,this.maxLogLength=t,this.lastAbsoluteTime=0}return e.prototype.createFromDeviceKey=function(e,t,n){return this.createFromEntry({tag:\"bf_key_value\",text:'Set device data \"'+e+'\"=\"'+t+'\"'},n)},e.prototype.createFromEntry=function(e,t){var n=this.getNow(),i=n.getTime();i<=this.lastAbsoluteTime&&(i=this.lastAbsoluteTime+1),this.lastAbsoluteTime=i;var u=r.format(e.text||\"\");return u.length>=this.maxLogLength&&(u=u.substring(0,this.maxLogLength)+\"\u2026\"),{x:n.toISOString(),t:u,m:e.method||t.method||\"\",at:i,tg:e.tag||\"\",f:e.file||t.file||\"\",l:e.line||t.line||0,ll:e.level||o.LogLevel.Debug,u:e.url||\"\"}},e.prototype.createFromIssue=function(e,t){return this.createFromEntry({level:o.LogLevel.Error,tag:\"bf_issue\",text:e},t)},e.prototype.createGapLog=function(e){var t=JSON.stringify({bf_start_date:e[0].at,bf_end_date:e[e.length-1].at});return{x:e[0].x,t:t,m:\"\",at:e[0].at,tg:\"bf_gap_log\",f:\"\",l:0,ll:0,u:e[0].u}},e}();t.LogFactory=i},function(e,t,n){(function(e){var r=Object.getOwnPropertyDescriptors||function(e){for(var t=Object.keys(e),n={},r=0;r<t.length;r++)n[t[r]]=Object.getOwnPropertyDescriptor(e,t[r]);return n},o=/%[sdj%]/g;t.format=function(e){if(!m(e)){for(var t=[],n=0;n<arguments.length;n++)t.push(a(arguments[n]));return t.join(\" \")}n=1;for(var r=arguments,i=r.length,u=String(e).replace(o,(function(e){if(\"%%\"===e)return\"%\";if(n>=i)return e;switch(e){case\"%s\":return String(r[n++]);case\"%d\":return Number(r[n++]);case\"%j\":try{return JSON.stringify(r[n++])}catch(e){return\"[Circular]\"}default:return e}})),s=r[n];n<i;s=r[++n])y(s)||!w(s)?u+=\" \"+s:u+=\" \"+a(s);return u},t.deprecate=function(n,r){if(void 0!==e&&!0===e.noDeprecation)return n;if(void 0===e)return function(){return t.deprecate(n,r).apply(this,arguments)};var o=!1;return function(){if(!o){if(e.throwDeprecation)throw new Error(r);e.traceDeprecation?console.trace(r):console.error(r),o=!0}return n.apply(this,arguments)}};var i,u={};function a(e,n){var r={seen:[],stylize:c};return arguments.length>=3&&(r.depth=arguments[2]),arguments.length>=4&&(r.colors=arguments[3]),d(n)?r.showHidden=n:n&&t._extend(r,n),g(r.showHidden)&&(r.showHidden=!1),g(r.depth)&&(r.depth=2),g(r.colors)&&(r.colors=!1),g(r.customInspect)&&(r.customInspect=!0),r.colors&&(r.stylize=s),l(r,e,r.depth)}function s(e,t){var n=a.styles[t];return n?\"\x1B[\"+a.colors[n][0]+\"m\"+e+\"\x1B[\"+a.colors[n][1]+\"m\":e}function c(e,t){return e}function l(e,n,r){if(e.customInspect&&n&&k(n.inspect)&&n.inspect!==t.inspect&&(!n.constructor||n.constructor.prototype!==n)){var o=n.inspect(r,e);return m(o)||(o=l(e,o,r)),o}var i=function(e,t){if(g(t))return e.stylize(\"undefined\",\"undefined\");if(m(t)){var n=\"'\"+JSON.stringify(t).replace(/^\"|\"$/g,\"\").replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"')+\"'\";return e.stylize(n,\"string\")}if(v(t))return e.stylize(\"\"+t,\"number\");if(d(t))return e.stylize(\"\"+t,\"boolean\");if(y(t))return e.stylize(\"null\",\"null\")}(e,n);if(i)return i;var u=Object.keys(n),a=function(e){var t={};return e.forEach((function(e,n){t[e]=!0})),t}(u);if(e.showHidden&&(u=Object.getOwnPropertyNames(n)),x(n)&&(u.indexOf(\"message\")>=0||u.indexOf(\"description\")>=0))return f(n);if(0===u.length){if(k(n)){var s=n.name?\": \"+n.name:\"\";return e.stylize(\"[Function\"+s+\"]\",\"special\")}if(b(n))return e.stylize(RegExp.prototype.toString.call(n),\"regexp\");if(_(n))return e.stylize(Date.prototype.toString.call(n),\"date\");if(x(n))return f(n)}var c,w=\"\",O=!1,E=[\"{\",\"}\"];(p(n)&&(O=!0,E=[\"[\",\"]\"]),k(n))&&(w=\" [Function\"+(n.name?\": \"+n.name:\"\")+\"]\");return b(n)&&(w=\" \"+RegExp.prototype.toString.call(n)),_(n)&&(w=\" \"+Date.prototype.toUTCString.call(n)),x(n)&&(w=\" \"+f(n)),0!==u.length||O&&0!=n.length?r<0?b(n)?e.stylize(RegExp.prototype.toString.call(n),\"regexp\"):e.stylize(\"[Object]\",\"special\"):(e.seen.push(n),c=O?function(e,t,n,r,o){for(var i=[],u=0,a=t.length;u<a;++u)S(t,String(u))?i.push(h(e,t,n,r,String(u),!0)):i.push(\"\");return o.forEach((function(o){o.match(/^\\d+$/)||i.push(h(e,t,n,r,o,!0))})),i}(e,n,r,a,u):u.map((function(t){return h(e,n,r,a,t,O)})),e.seen.pop(),function(e,t,n){if(e.reduce((function(e,t){return t.indexOf(\"\\n\")>=0&&0,e+t.replace(/\\u001b\\[\\d\\d?m/g,\"\").length+1}),0)>60)return n[0]+(\"\"===t?\"\":t+\"\\n \")+\" \"+e.join(\",\\n  \")+\" \"+n[1];return n[0]+t+\" \"+e.join(\", \")+\" \"+n[1]}(c,w,E)):E[0]+w+E[1]}function f(e){return\"[\"+Error.prototype.toString.call(e)+\"]\"}function h(e,t,n,r,o,i){var u,a,s;if((s=Object.getOwnPropertyDescriptor(t,o)||{value:t[o]}).get?a=s.set?e.stylize(\"[Getter/Setter]\",\"special\"):e.stylize(\"[Getter]\",\"special\"):s.set&&(a=e.stylize(\"[Setter]\",\"special\")),S(r,o)||(u=\"[\"+o+\"]\"),a||(e.seen.indexOf(s.value)<0?(a=y(n)?l(e,s.value,null):l(e,s.value,n-1)).indexOf(\"\\n\")>-1&&(a=i?a.split(\"\\n\").map((function(e){return\"  \"+e})).join(\"\\n\").substr(2):\"\\n\"+a.split(\"\\n\").map((function(e){return\"   \"+e})).join(\"\\n\")):a=e.stylize(\"[Circular]\",\"special\")),g(u)){if(i&&o.match(/^\\d+$/))return a;(u=JSON.stringify(\"\"+o)).match(/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?(u=u.substr(1,u.length-2),u=e.stylize(u,\"name\")):(u=u.replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"').replace(/(^\"|\"$)/g,\"'\"),u=e.stylize(u,\"string\"))}return u+\": \"+a}function p(e){return Array.isArray(e)}function d(e){return\"boolean\"==typeof e}function y(e){return null===e}function v(e){return\"number\"==typeof e}function m(e){return\"string\"==typeof e}function g(e){return void 0===e}function b(e){return w(e)&&\"[object RegExp]\"===O(e)}function w(e){return\"object\"==typeof e&&null!==e}function _(e){return w(e)&&\"[object Date]\"===O(e)}function x(e){return w(e)&&(\"[object Error]\"===O(e)||e instanceof Error)}function k(e){return\"function\"==typeof e}function O(e){return Object.prototype.toString.call(e)}function E(e){return e<10?\"0\"+e.toString(10):e.toString(10)}t.debuglog=function(n){if(g(i)&&(i=e.env.NODE_DEBUG||\"\"),n=n.toUpperCase(),!u[n])if(new RegExp(\"\\\\b\"+n+\"\\\\b\",\"i\").test(i)){var r=e.pid;u[n]=function(){var e=t.format.apply(t,arguments);console.error(\"%s %d: %s\",n,r,e)}}else u[n]=function(){};return u[n]},t.inspect=a,a.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},a.styles={special:\"cyan\",number:\"yellow\",boolean:\"yellow\",undefined:\"grey\",null:\"bold\",string:\"green\",date:\"magenta\",regexp:\"red\"},t.isArray=p,t.isBoolean=d,t.isNull=y,t.isNullOrUndefined=function(e){return null==e},t.isNumber=v,t.isString=m,t.isSymbol=function(e){return\"symbol\"==typeof e},t.isUndefined=g,t.isRegExp=b,t.isObject=w,t.isDate=_,t.isError=x,t.isFunction=k,t.isPrimitive=function(e){return null===e||\"boolean\"==typeof e||\"number\"==typeof e||\"string\"==typeof e||\"symbol\"==typeof e||void 0===e},t.isBuffer=n(7);var j=[\"Jan\",\"Feb\",\"Mar\",\"Apr\",\"May\",\"Jun\",\"Jul\",\"Aug\",\"Sep\",\"Oct\",\"Nov\",\"Dec\"];function P(){var e=new Date,t=[E(e.getHours()),E(e.getMinutes()),E(e.getSeconds())].join(\":\");return[e.getDate(),j[e.getMonth()],t].join(\" \")}function S(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.log=function(){console.log(\"%s - %s\",P(),t.format.apply(t,arguments))},t.inherits=n(8),t._extend=function(e,t){if(!t||!w(t))return e;for(var n=Object.keys(t),r=n.length;r--;)e[n[r]]=t[n[r]];return e};var T=\"undefined\"!=typeof Symbol?Symbol(\"util.promisify.custom\"):void 0;function D(e,t){if(!e){var n=new Error(\"Promise was rejected with a falsy value\");n.reason=e,e=n}return t(e)}t.promisify=function(e){if(\"function\"!=typeof e)throw new TypeError('The \"original\" argument must be of type Function');if(T&&e[T]){var t;if(\"function\"!=typeof(t=e[T]))throw new TypeError('The \"util.promisify.custom\" argument must be of type Function');return Object.defineProperty(t,T,{value:t,enumerable:!1,writable:!1,configurable:!0}),t}function t(){for(var t,n,r=new Promise((function(e,r){t=e,n=r})),o=[],i=0;i<arguments.length;i++)o.push(arguments[i]);o.push((function(e,r){e?n(e):t(r)}));try{e.apply(this,o)}catch(e){n(e)}return r}return Object.setPrototypeOf(t,Object.getPrototypeOf(e)),T&&Object.defineProperty(t,T,{value:t,enumerable:!1,writable:!1,configurable:!0}),Object.defineProperties(t,r(e))},t.promisify.custom=T,t.callbackify=function(t){if(\"function\"!=typeof t)throw new TypeError('The \"original\" argument must be of type Function');function n(){for(var n=[],r=0;r<arguments.length;r++)n.push(arguments[r]);var o=n.pop();if(\"function\"!=typeof o)throw new TypeError(\"The last argument must be of type Function\");var i=this,u=function(){return o.apply(i,arguments)};t.apply(this,n).then((function(t){e.nextTick(u,null,t)}),(function(t){e.nextTick(D,t,u)}))}return Object.setPrototypeOf(n,Object.getPrototypeOf(t)),Object.defineProperties(n,r(t)),n}}).call(this,n(6))},function(e,t){var n,r,o=e.exports={};function i(){throw new Error(\"setTimeout has not been defined\")}function u(){throw new Error(\"clearTimeout has not been defined\")}function a(e){if(n===setTimeout)return setTimeout(e,0);if((n===i||!n)&&setTimeout)return n=setTimeout,setTimeout(e,0);try{return n(e,0)}catch(t){try{return n.call(null,e,0)}catch(t){return n.call(this,e,0)}}}!function(){try{n=\"function\"==typeof setTimeout?setTimeout:i}catch(e){n=i}try{r=\"function\"==typeof clearTimeout?clearTimeout:u}catch(e){r=u}}();var s,c=[],l=!1,f=-1;function h(){l&&s&&(l=!1,s.length?c=s.concat(c):f=-1,c.length&&p())}function p(){if(!l){var e=a(h);l=!0;for(var t=c.length;t;){for(s=c,c=[];++f<t;)s&&s[f].run();f=-1,t=c.length}s=null,l=!1,function(e){if(r===clearTimeout)return clearTimeout(e);if((r===u||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(e);try{r(e)}catch(t){try{return r.call(null,e)}catch(t){return r.call(this,e)}}}(e)}}function d(e,t){this.fun=e,this.array=t}function y(){}o.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];c.push(new d(e,t)),1!==c.length||l||a(p)},d.prototype.run=function(){this.fun.apply(null,this.array)},o.title=\"browser\",o.browser=!0,o.env={},o.argv=[],o.version=\"\",o.versions={},o.on=y,o.addListener=y,o.once=y,o.off=y,o.removeListener=y,o.removeAllListeners=y,o.emit=y,o.prependListener=y,o.prependOnceListener=y,o.listeners=function(e){return[]},o.binding=function(e){throw new Error(\"process.binding is not supported\")},o.cwd=function(){return\"/\"},o.chdir=function(e){throw new Error(\"process.chdir is not supported\")},o.umask=function(){return 0}},function(e,t){e.exports=function(e){return e&&\"object\"==typeof e&&\"function\"==typeof e.copy&&\"function\"==typeof e.fill&&\"function\"==typeof e.readUInt8}},function(e,t){\"function\"==typeof Object.create?e.exports=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}:e.exports=function(e,t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e}},function(e,t,n){\"use strict\";var r;Object.defineProperty(t,\"__esModule\",{value:!0}),t.LOG_LEVELS=t.LogLevel=void 0,function(e){e[e.Debug=0]=\"Debug\",e[e.Warning=1]=\"Warning\",e[e.Error=2]=\"Error\",e[e.Trace=3]=\"Trace\",e[e.Info=4]=\"Info\",e[e.Fatal=5]=\"Fatal\"}(r=t.LogLevel||(t.LogLevel={})),t.LOG_LEVELS=[r.Debug,r.Warning,r.Error,r.Trace,r.Info,r.Fatal]},function(e,t,n){\"use strict\";var r=this&&this.__awaiter||function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function u(e){try{s(r.next(e))}catch(e){i(e)}}function a(e){try{s(r.throw(e))}catch(e){i(e)}}function s(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(u,a)}s((r=r.apply(e,t||[])).next())}))},o=this&&this.__generator||function(e,t){var n,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},\"function\"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError(\"Generator is already executing.\");for(;u;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=t.call(e,u)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}};Object.defineProperty(t,\"__esModule\",{value:!0}),t.DeviceKeysTable=void 0;var i=function(){function e(e){this.devicekeys=e}return e.prototype.add=function(e){return r(this,void 0,void 0,(function(){return o(this,(function(t){switch(t.label){case 0:return[4,this.devicekeys.add(e)];case 1:return t.sent(),[2]}}))}))},e.prototype.count=function(e){return this.devicekeys.where({sessionUUID:e}).count()},e.prototype.deleteBatch=function(e){return r(this,void 0,void 0,(function(){return o(this,(function(t){switch(t.label){case 0:return[4,this.devicekeys.limit(e).delete()];case 1:return t.sent(),[2]}}))}))},e.prototype.getAll=function(){return this.devicekeys.toArray()},e}();t.DeviceKeysTable=i},function(e,t,n){\"use strict\";var r=this&&this.__awaiter||function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function u(e){try{s(r.next(e))}catch(e){i(e)}}function a(e){try{s(r.throw(e))}catch(e){i(e)}}function s(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(u,a)}s((r=r.apply(e,t||[])).next())}))},o=this&&this.__generator||function(e,t){var n,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},\"function\"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError(\"Generator is already executing.\");for(;u;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=t.call(e,u)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}};Object.defineProperty(t,\"__esModule\",{value:!0}),t.IssuesTable=void 0;var i=function(){function e(e){this.issues=e}return e.prototype.add=function(e){return r(this,void 0,void 0,(function(){return o(this,(function(t){switch(t.label){case 0:return[4,this.issues.add(e)];case 1:return t.sent(),[2]}}))}))},e.prototype.count=function(e){return this.issues.where({sessionUUID:e}).count()},e.prototype.deleteById=function(e){return r(this,void 0,void 0,(function(){return o(this,(function(t){switch(t.label){case 0:return[4,this.issues.delete(e)];case 1:return t.sent(),[2]}}))}))},e.prototype.getBatch=function(e,t){return this.issues.where({sessionUUID:e}).limit(t).toArray()},e}();t.IssuesTable=i},function(e,t,n){\"use strict\";var r=this&&this.__awaiter||function(e,t,n,r){return new(n||(n=Promise))((function(o,i){function u(e){try{s(r.next(e))}catch(e){i(e)}}function a(e){try{s(r.throw(e))}catch(e){i(e)}}function s(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(u,a)}s((r=r.apply(e,t||[])).next())}))},o=this&&this.__generator||function(e,t){var n,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},\"function\"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError(\"Generator is already executing.\");for(;u;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=(o=u.trys).length>0&&o[o.length-1])&&(6===i[0]||2===i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=t.call(e,u)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,a])}}};Object.defineProperty(t,\"__esModule\",{value:!0}),t.LogsTable=void 0;var i=function(){function e(e,t){this.logs=e,this.logFactory=t}return e.prototype.add=function(e){return r(this,void 0,void 0,(function(){return o(this,(function(t){switch(t.label){case 0:return[4,this.logs.add(e)];case 1:return t.sent(),[2]}}))}))},e.prototype.count=function(e){return this.logs.where({sessionUUID:e}).count()},e.prototype.deleteBatch=function(e,t){return r(this,void 0,void 0,(function(){return o(this,(function(n){switch(n.label){case 0:return[4,this.logs.where({sessionUUID:e}).limit(t).delete()];case 1:return n.sent(),[2]}}))}))},e.prototype.deleteOldLogs=function(e){return r(this,void 0,void 0,(function(){var t=this;return o(this,(function(n){return[2,this.logs.db.transaction(\"rw\",this.logs,(function(){return r(t,void 0,void 0,(function(){var t,n,r;return o(this,(function(o){switch(o.label){case 0:return[4,this.logs.where({sessionUUID:e}).limit(1).primaryKeys()];case 1:return t=o.sent()[0],[4,this.logs.where({sessionUUID:e}).limit(10).toArray()];case 2:return(n=o.sent()).length<=1?[2]:(r={sessionUUID:e,data:this.logFactory.createGapLog(n.map((function(e){return e.data})))},[4,this.logs.update(t,r)]);case 3:return o.sent(),[4,this.logs.where({sessionUUID:e}).offset(1).limit(9).delete()];case 4:return o.sent(),[2]}}))}))}))]}))}))},e.prototype.getBatch=function(e,t){return this.logs.where({sessionUUID:e}).limit(t).toArray()},e}();t.LogsTable=i}]);\n", "Worker", void 0, void 0);
    };
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SessionFactory = void 0;var r = function () {
      function e(e, t) {
        this.device = e, this.sdkVersion = t;
      }return e.prototype.create = function (e, t) {
        return { device: this.device.getInfo(t), orientation: 0, batteryLevel: -1, ram_total: 0, ram_free: 0, ram_used: 0, language: window.navigator.language, time: new Date().toISOString(), sdk_type: "web", sdk_version: this.sdkVersion, session_uid: e, app_version: { app: { key: t.appKey }, version: t.version, build: t.build } };
      }, e;
    }();t.SessionFactory = r;
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.LogFactory = void 0;var r = n(3),
        i = n(1),
        o = function () {
      function e(e, t) {
        void 0 === e && (e = function e() {
          return new Date();
        }), void 0 === t && (t = 32e3), this.getNow = e, this.maxLogLength = t, this.lastAbsoluteTime = 0;
      }return e.prototype.createFromDeviceKey = function (e, t, n) {
        return this.createFromEntry({ tag: "bf_key_value", text: 'Set device data "' + e + '"="' + t + '"' }, n);
      }, e.prototype.createFromEntry = function (e, t) {
        var n = this.getNow(),
            o = n.getTime();o <= this.lastAbsoluteTime && (o = this.lastAbsoluteTime + 1), this.lastAbsoluteTime = o;var s = r.format(e.text || "");return s.length >= this.maxLogLength && (s = s.substring(0, this.maxLogLength) + "…"), { x: n.toISOString(), t: s, m: e.method || t.method || "", at: o, tg: e.tag || "", f: e.file || t.file || "", l: e.line || t.line || 0, ll: e.level || i.LogLevel.Debug, u: e.url || "" };
      }, e.prototype.createFromIssue = function (e, t) {
        return this.createFromEntry({ level: i.LogLevel.Error, tag: "bf_issue", text: e }, t);
      }, e.prototype.createGapLog = function (e) {
        var t = JSON.stringify({ bf_start_date: e[0].at, bf_end_date: e[e.length - 1].at });return { x: e[0].x, t: t, m: "", at: e[0].at, tg: "bf_gap_log", f: "", l: 0, ll: 0, u: e[0].u };
      }, e;
    }();t.LogFactory = o;
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.UUIDFactory = void 0;var r = function () {
      function e() {}return e.prototype.create = function () {
        var e = function e() {
          return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
        };return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
      }, e;
    }();t.UUIDFactory = r;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var i in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }return e;
      }).apply(this, arguments);
    },
        i = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : { default: e };
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.SDKOptions = void 0;var o = i(n(34)),
        s = n(40),
        a = function () {
      function e() {
        this.rules = { appKey: ["required", "string"], apiURL: ["string", "url"], build: ["string"], baseURL: ["string", "url"], overrideConsoleMethods: ["boolean"], printToConsole: ["boolean"], logBrowserEvents: ["boolean"], logUIEvents: ["boolean"], registerErrorHandler: ["boolean"], version: ["string"] };
      }return e.prototype.init = function (e) {
        return this.validate(e), r({ appID: o.default.encode(s.sha256.array(e.appKey)).substring(0, 10), apiURL: "https://api.bugfender.com", baseURL: "https://dashboard.bugfender.com", overrideConsoleMethods: !0, printToConsole: !0, logBrowserEvents: !0, logUIEvents: !0, registerErrorHandler: !0, version: "0.0.0", build: "0" }, e);
      }, e.prototype.validate = function (e) {
        var t = new RegExp(/^http(s)?:\/\//i);Object.entries(this.rules).forEach(function (n) {
          var r = n[0],
              i = n[1],
              o = e[r];i.forEach(function (e) {
            if ("required" === e) {
              if (void 0 === o) throw new Error("Bugfender requires '" + r + "' option to initialize.");
            } else if ("string" === e) {
              if (!["string", "undefined"].includes(typeof o)) throw new Error("'" + r + "' option must be a string.");
            } else if ("url" === e) {
              if (void 0 !== o && !t.test(o)) throw new Error("'" + r + "' option must be a valid URL.");
            } else if ("boolean" === e && !["boolean", "undefined"].includes(typeof o)) throw new Error("'" + r + "' option must be a boolean.");
          });
        });
      }, e;
    }();t.SDKOptions = a;
  }, function (e, t, n) {
    (function (e, t) {
      (function () {
        var n, r, i, o;for (i = (null !== e ? e.exports : void 0) || (window.Base58 = {}), n = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", r = {}, o = 0; o < n.length;) {
          r[n.charAt(o)] = o, o++;
        }i.encode = function (e) {
          var t, r, i;if (0 === e.length) return "";for (o = void 0, i = void 0, r = [0], o = 0; o < e.length;) {
            for (i = 0; i < r.length;) {
              r[i] <<= 8, i++;
            }for (r[0] += e[o], t = 0, i = 0; i < r.length;) {
              r[i] += t, t = r[i] / 58 | 0, r[i] %= 58, ++i;
            }for (; t;) {
              r.push(t % 58), t = t / 58 | 0;
            }o++;
          }for (o = 0; 0 === e[o] && o < e.length - 1;) {
            r.push(0), o++;
          }return r.reverse().map(function (e) {
            return n[e];
          }).join("");
        }, i.decode = function (e) {
          var n, i, s, a;if (0 === e.length) return new ("undefined" != typeof Uint8Array && null !== Uint8Array ? Uint8Array : t)(0);for (o = void 0, a = void 0, n = [0], o = 0; o < e.length;) {
            if (!((i = e[o]) in r)) throw "Base58.decode received unacceptable input. Character '" + i + "' is not in the Base58 alphabet.";for (a = 0; a < n.length;) {
              n[a] *= 58, a++;
            }for (n[0] += r[i], s = 0, a = 0; a < n.length;) {
              n[a] += s, s = n[a] >> 8, n[a] &= 255, ++a;
            }for (; s;) {
              n.push(255 & s), s >>= 8;
            }o++;
          }for (o = 0; "1" === e[o] && o < e.length - 1;) {
            n.push(0), o++;
          }return new ("undefined" != typeof Uint8Array && null !== Uint8Array ? Uint8Array : t)(n.reverse());
        };
      }).call(this);
    }).call(this, n(35)(e), n(36).Buffer);
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", { enumerable: !0, get: function get() {
          return e.l;
        } }), Object.defineProperty(e, "id", { enumerable: !0, get: function get() {
          return e.i;
        } }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {
    "use strict";
    (function (e) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var r = n(37),
          i = n(38),
          o = n(39);function s() {
        return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }function a(e, t) {
        if (s() < t) throw new RangeError("Invalid typed array length");return u.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = u.prototype : (null === e && (e = new u(t)), e.length = t), e;
      }function u(e, t, n) {
        if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(e, t, n);if ("number" == typeof e) {
          if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");return f(this, e);
        }return c(this, e, t, n);
      }function c(e, t, n, r) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
          if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r);u.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = u.prototype : e = h(e, t);return e;
        }(e, t, n, r) : "string" == typeof t ? function (e, t, n) {
          "string" == typeof n && "" !== n || (n = "utf8");if (!u.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');var r = 0 | p(t, n),
              i = (e = a(e, r)).write(t, n);i !== r && (e = e.slice(0, i));return e;
        }(e, t, n) : function (e, t) {
          if (u.isBuffer(t)) {
            var n = 0 | d(t.length);return 0 === (e = a(e, n)).length || t.copy(e, 0, 0, n), e;
          }if (t) {
            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? a(e, 0) : h(e, t);if ("Buffer" === t.type && o(t.data)) return h(e, t.data);
          }var r;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(e, t);
      }function l(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');if (e < 0) throw new RangeError('"size" argument must not be negative');
      }function f(e, t) {
        if (l(t), e = a(e, t < 0 ? 0 : 0 | d(t)), !u.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) {
          e[n] = 0;
        }return e;
      }function h(e, t) {
        var n = t.length < 0 ? 0 : 0 | d(t.length);e = a(e, n);for (var r = 0; r < n; r += 1) {
          e[r] = 255 & t[r];
        }return e;
      }function d(e) {
        if (e >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");return 0 | e;
      }function p(e, t) {
        if (u.isBuffer(e)) return e.length;if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;"string" != typeof e && (e = "" + e);var n = e.length;if (0 === n) return 0;for (var r = !1;;) {
          switch (t) {case "ascii":case "latin1":case "binary":
              return n;case "utf8":case "utf-8":case void 0:
              return N(e).length;case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":
              return 2 * n;case "hex":
              return n >>> 1;case "base64":
              return K(e).length;default:
              if (r) return N(e).length;t = ("" + t).toLowerCase(), r = !0;}
        }
      }function y(e, t, n) {
        var r = !1;if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";if ((n >>>= 0) <= (t >>>= 0)) return "";for (e || (e = "utf8");;) {
          switch (e) {case "hex":
              return T(this, t, n);case "utf8":case "utf-8":
              return O(this, t, n);case "ascii":
              return A(this, t, n);case "latin1":case "binary":
              return P(this, t, n);case "base64":
              return x(this, t, n);case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":
              return M(this, t, n);default:
              if (r) throw new TypeError("Unknown encoding: " + e);e = (e + "").toLowerCase(), r = !0;}
        }
      }function v(e, t, n) {
        var r = e[t];e[t] = e[n], e[n] = r;
      }function g(e, t, n, r, i) {
        if (0 === e.length) return -1;if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
          if (i) return -1;n = e.length - 1;
        } else if (n < 0) {
          if (!i) return -1;n = 0;
        }if ("string" == typeof t && (t = u.from(t, r)), u.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, n, r, i);if ("number" == typeof t) return t &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : m(e, [t], n, r, i);throw new TypeError("val must be string, number or Buffer");
      }function m(e, t, n, r, i) {
        var o,
            s = 1,
            a = e.length,
            u = t.length;if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
          if (e.length < 2 || t.length < 2) return -1;s = 2, a /= 2, u /= 2, n /= 2;
        }function c(e, t) {
          return 1 === s ? e[t] : e.readUInt16BE(t * s);
        }if (i) {
          var l = -1;for (o = n; o < a; o++) {
            if (c(e, o) === c(t, -1 === l ? 0 : o - l)) {
              if (-1 === l && (l = o), o - l + 1 === u) return l * s;
            } else -1 !== l && (o -= o - l), l = -1;
          }
        } else for (n + u > a && (n = a - u), o = n; o >= 0; o--) {
          for (var f = !0, h = 0; h < u; h++) {
            if (c(e, o + h) !== c(t, h)) {
              f = !1;break;
            }
          }if (f) return o;
        }return -1;
      }function b(e, t, n, r) {
        n = Number(n) || 0;var i = e.length - n;r ? (r = Number(r)) > i && (r = i) : r = i;var o = t.length;if (o % 2 != 0) throw new TypeError("Invalid hex string");r > o / 2 && (r = o / 2);for (var s = 0; s < r; ++s) {
          var a = parseInt(t.substr(2 * s, 2), 16);if (isNaN(a)) return s;e[n + s] = a;
        }return s;
      }function w(e, t, n, r) {
        return H(N(t, e.length - n), e, n, r);
      }function _(e, t, n, r) {
        return H(function (e) {
          for (var t = [], n = 0; n < e.length; ++n) {
            t.push(255 & e.charCodeAt(n));
          }return t;
        }(t), e, n, r);
      }function E(e, t, n, r) {
        return _(e, t, n, r);
      }function S(e, t, n, r) {
        return H(K(t), e, n, r);
      }function k(e, t, n, r) {
        return H(function (e, t) {
          for (var n, r, i, o = [], s = 0; s < e.length && !((t -= 2) < 0); ++s) {
            n = e.charCodeAt(s), r = n >> 8, i = n % 256, o.push(i), o.push(r);
          }return o;
        }(t, e.length - n), e, n, r);
      }function x(e, t, n) {
        return 0 === t && n === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(t, n));
      }function O(e, t, n) {
        n = Math.min(e.length, n);for (var r = [], i = t; i < n;) {
          var o,
              s,
              a,
              u,
              c = e[i],
              l = null,
              f = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;if (i + f <= n) switch (f) {case 1:
              c < 128 && (l = c);break;case 2:
              128 == (192 & (o = e[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (l = u);break;case 3:
              o = e[i + 1], s = e[i + 2], 128 == (192 & o) && 128 == (192 & s) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (u < 55296 || u > 57343) && (l = u);break;case 4:
              o = e[i + 1], s = e[i + 2], a = e[i + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && u < 1114112 && (l = u);}null === l ? (l = 65533, f = 1) : l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r.push(l), i += f;
        }return function (e) {
          var t = e.length;if (t <= 4096) return String.fromCharCode.apply(String, e);var n = "",
              r = 0;for (; r < t;) {
            n += String.fromCharCode.apply(String, e.slice(r, r += 4096));
          }return n;
        }(r);
      }t.Buffer = u, t.SlowBuffer = function (e) {
        +e != e && (e = 0);return u.alloc(+e);
      }, t.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
        try {
          var e = new Uint8Array(1);return e.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
              return 42;
            } }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
        } catch (e) {
          return !1;
        }
      }(), t.kMaxLength = s(), u.poolSize = 8192, u._augment = function (e) {
        return e.__proto__ = u.prototype, e;
      }, u.from = function (e, t, n) {
        return c(null, e, t, n);
      }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, { value: null, configurable: !0 })), u.alloc = function (e, t, n) {
        return function (e, t, n, r) {
          return l(t), t <= 0 ? a(e, t) : void 0 !== n ? "string" == typeof r ? a(e, t).fill(n, r) : a(e, t).fill(n) : a(e, t);
        }(null, e, t, n);
      }, u.allocUnsafe = function (e) {
        return f(null, e);
      }, u.allocUnsafeSlow = function (e) {
        return f(null, e);
      }, u.isBuffer = function (e) {
        return !(null == e || !e._isBuffer);
      }, u.compare = function (e, t) {
        if (!u.isBuffer(e) || !u.isBuffer(t)) throw new TypeError("Arguments must be Buffers");if (e === t) return 0;for (var n = e.length, r = t.length, i = 0, o = Math.min(n, r); i < o; ++i) {
          if (e[i] !== t[i]) {
            n = e[i], r = t[i];break;
          }
        }return n < r ? -1 : r < n ? 1 : 0;
      }, u.isEncoding = function (e) {
        switch (String(e).toLowerCase()) {case "hex":case "utf8":case "utf-8":case "ascii":case "latin1":case "binary":case "base64":case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":
            return !0;default:
            return !1;}
      }, u.concat = function (e, t) {
        if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');if (0 === e.length) return u.alloc(0);var n;if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) {
          t += e[n].length;
        }var r = u.allocUnsafe(t),
            i = 0;for (n = 0; n < e.length; ++n) {
          var s = e[n];if (!u.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');s.copy(r, i), i += s.length;
        }return r;
      }, u.byteLength = p, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
        var e = this.length;if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");for (var t = 0; t < e; t += 2) {
          v(this, t, t + 1);
        }return this;
      }, u.prototype.swap32 = function () {
        var e = this.length;if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");for (var t = 0; t < e; t += 4) {
          v(this, t, t + 3), v(this, t + 1, t + 2);
        }return this;
      }, u.prototype.swap64 = function () {
        var e = this.length;if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");for (var t = 0; t < e; t += 8) {
          v(this, t, t + 7), v(this, t + 1, t + 6), v(this, t + 2, t + 5), v(this, t + 3, t + 4);
        }return this;
      }, u.prototype.toString = function () {
        var e = 0 | this.length;return 0 === e ? "" : 0 === arguments.length ? O(this, 0, e) : y.apply(this, arguments);
      }, u.prototype.equals = function (e) {
        if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");return this === e || 0 === u.compare(this, e);
      }, u.prototype.inspect = function () {
        var e = "",
            n = t.INSPECT_MAX_BYTES;return this.length > 0 && (e = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (e += " ... ")), "<Buffer " + e + ">";
      }, u.prototype.compare = function (e, t, n, r, i) {
        if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw new RangeError("out of range index");if (r >= i && t >= n) return 0;if (r >= i) return -1;if (t >= n) return 1;if (this === e) return 0;for (var o = (i >>>= 0) - (r >>>= 0), s = (n >>>= 0) - (t >>>= 0), a = Math.min(o, s), c = this.slice(r, i), l = e.slice(t, n), f = 0; f < a; ++f) {
          if (c[f] !== l[f]) {
            o = c[f], s = l[f];break;
          }
        }return o < s ? -1 : s < o ? 1 : 0;
      }, u.prototype.includes = function (e, t, n) {
        return -1 !== this.indexOf(e, t, n);
      }, u.prototype.indexOf = function (e, t, n) {
        return g(this, e, t, n, !0);
      }, u.prototype.lastIndexOf = function (e, t, n) {
        return g(this, e, t, n, !1);
      }, u.prototype.write = function (e, t, n, r) {
        if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
          if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
        }var i = this.length - t;if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");r || (r = "utf8");for (var o = !1;;) {
          switch (r) {case "hex":
              return b(this, e, t, n);case "utf8":case "utf-8":
              return w(this, e, t, n);case "ascii":
              return _(this, e, t, n);case "latin1":case "binary":
              return E(this, e, t, n);case "base64":
              return S(this, e, t, n);case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":
              return k(this, e, t, n);default:
              if (o) throw new TypeError("Unknown encoding: " + r);r = ("" + r).toLowerCase(), o = !0;}
        }
      }, u.prototype.toJSON = function () {
        return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
      };function A(e, t, n) {
        var r = "";n = Math.min(e.length, n);for (var i = t; i < n; ++i) {
          r += String.fromCharCode(127 & e[i]);
        }return r;
      }function P(e, t, n) {
        var r = "";n = Math.min(e.length, n);for (var i = t; i < n; ++i) {
          r += String.fromCharCode(e[i]);
        }return r;
      }function T(e, t, n) {
        var r = e.length;(!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);for (var i = "", o = t; o < n; ++o) {
          i += U(e[o]);
        }return i;
      }function M(e, t, n) {
        for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2) {
          i += String.fromCharCode(r[o] + 256 * r[o + 1]);
        }return i;
      }function I(e, t, n) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
      }function B(e, t, n, r, i, o) {
        if (!u.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');if (n + r > e.length) throw new RangeError("Index out of range");
      }function R(e, t, n, r) {
        t < 0 && (t = 65535 + t + 1);for (var i = 0, o = Math.min(e.length - n, 2); i < o; ++i) {
          e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
        }
      }function C(e, t, n, r) {
        t < 0 && (t = 4294967295 + t + 1);for (var i = 0, o = Math.min(e.length - n, 4); i < o; ++i) {
          e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
        }
      }function j(e, t, n, r, i, o) {
        if (n + r > e.length) throw new RangeError("Index out of range");if (n < 0) throw new RangeError("Index out of range");
      }function D(e, t, n, r, o) {
        return o || j(e, 0, n, 4), i.write(e, t, n, r, 23, 4), n + 4;
      }function F(e, t, n, r, o) {
        return o || j(e, 0, n, 8), i.write(e, t, n, r, 52, 8), n + 8;
      }u.prototype.slice = function (e, t) {
        var n,
            r = this.length;if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), u.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = u.prototype;else {
          var i = t - e;n = new u(i, void 0);for (var o = 0; o < i; ++o) {
            n[o] = this[o + e];
          }
        }return n;
      }, u.prototype.readUIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || I(e, t, this.length);for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          r += this[e + o] * i;
        }return r;
      }, u.prototype.readUIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || I(e, t, this.length);for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) {
          r += this[e + --t] * i;
        }return r;
      }, u.prototype.readUInt8 = function (e, t) {
        return t || I(e, 1, this.length), this[e];
      }, u.prototype.readUInt16LE = function (e, t) {
        return t || I(e, 2, this.length), this[e] | this[e + 1] << 8;
      }, u.prototype.readUInt16BE = function (e, t) {
        return t || I(e, 2, this.length), this[e] << 8 | this[e + 1];
      }, u.prototype.readUInt32LE = function (e, t) {
        return t || I(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
      }, u.prototype.readUInt32BE = function (e, t) {
        return t || I(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
      }, u.prototype.readIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || I(e, t, this.length);for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          r += this[e + o] * i;
        }return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
      }, u.prototype.readIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || I(e, t, this.length);for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256);) {
          o += this[e + --r] * i;
        }return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
      }, u.prototype.readInt8 = function (e, t) {
        return t || I(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
      }, u.prototype.readInt16LE = function (e, t) {
        t || I(e, 2, this.length);var n = this[e] | this[e + 1] << 8;return 32768 & n ? 4294901760 | n : n;
      }, u.prototype.readInt16BE = function (e, t) {
        t || I(e, 2, this.length);var n = this[e + 1] | this[e] << 8;return 32768 & n ? 4294901760 | n : n;
      }, u.prototype.readInt32LE = function (e, t) {
        return t || I(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
      }, u.prototype.readInt32BE = function (e, t) {
        return t || I(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
      }, u.prototype.readFloatLE = function (e, t) {
        return t || I(e, 4, this.length), i.read(this, e, !0, 23, 4);
      }, u.prototype.readFloatBE = function (e, t) {
        return t || I(e, 4, this.length), i.read(this, e, !1, 23, 4);
      }, u.prototype.readDoubleLE = function (e, t) {
        return t || I(e, 8, this.length), i.read(this, e, !0, 52, 8);
      }, u.prototype.readDoubleBE = function (e, t) {
        return t || I(e, 8, this.length), i.read(this, e, !1, 52, 8);
      }, u.prototype.writeUIntLE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || B(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);var i = 1,
            o = 0;for (this[t] = 255 & e; ++o < n && (i *= 256);) {
          this[t + o] = e / i & 255;
        }return t + n;
      }, u.prototype.writeUIntBE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || B(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);var i = n - 1,
            o = 1;for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) {
          this[t + i] = e / o & 255;
        }return t + n;
      }, u.prototype.writeUInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
      }, u.prototype.writeUInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : R(this, e, t, !0), t + 2;
      }, u.prototype.writeUInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : R(this, e, t, !1), t + 2;
      }, u.prototype.writeUInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : C(this, e, t, !0), t + 4;
      }, u.prototype.writeUInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : C(this, e, t, !1), t + 4;
      }, u.prototype.writeIntLE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);B(this, e, t, n, i - 1, -i);
        }var o = 0,
            s = 1,
            a = 0;for (this[t] = 255 & e; ++o < n && (s *= 256);) {
          e < 0 && 0 === a && 0 !== this[t + o - 1] && (a = 1), this[t + o] = (e / s >> 0) - a & 255;
        }return t + n;
      }, u.prototype.writeIntBE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);B(this, e, t, n, i - 1, -i);
        }var o = n - 1,
            s = 1,
            a = 0;for (this[t + o] = 255 & e; --o >= 0 && (s *= 256);) {
          e < 0 && 0 === a && 0 !== this[t + o + 1] && (a = 1), this[t + o] = (e / s >> 0) - a & 255;
        }return t + n;
      }, u.prototype.writeInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
      }, u.prototype.writeInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : R(this, e, t, !0), t + 2;
      }, u.prototype.writeInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : R(this, e, t, !1), t + 2;
      }, u.prototype.writeInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : C(this, e, t, !0), t + 4;
      }, u.prototype.writeInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || B(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : C(this, e, t, !1), t + 4;
      }, u.prototype.writeFloatLE = function (e, t, n) {
        return D(this, e, t, !0, n);
      }, u.prototype.writeFloatBE = function (e, t, n) {
        return D(this, e, t, !1, n);
      }, u.prototype.writeDoubleLE = function (e, t, n) {
        return F(this, e, t, !0, n);
      }, u.prototype.writeDoubleBE = function (e, t, n) {
        return F(this, e, t, !1, n);
      }, u.prototype.copy = function (e, t, n, r) {
        if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;if (0 === e.length || 0 === this.length) return 0;if (t < 0) throw new RangeError("targetStart out of bounds");if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");if (r < 0) throw new RangeError("sourceEnd out of bounds");r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);var i,
            o = r - n;if (this === e && n < t && t < r) for (i = o - 1; i >= 0; --i) {
          e[i + t] = this[i + n];
        } else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          e[i + t] = this[i + n];
        } else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);return o;
      }, u.prototype.fill = function (e, t, n, r) {
        if ("string" == typeof e) {
          if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
            var i = e.charCodeAt(0);i < 256 && (e = i);
          }if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");if ("string" == typeof r && !u.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
        } else "number" == typeof e && (e &= 255);if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");if (n <= t) return this;var o;if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < n; ++o) {
          this[o] = e;
        } else {
          var s = u.isBuffer(e) ? e : N(new u(e, r).toString()),
              a = s.length;for (o = 0; o < n - t; ++o) {
            this[o + t] = s[o % a];
          }
        }return this;
      };var L = /[^+\/0-9A-Za-z-_]/g;function U(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16);
      }function N(e, t) {
        var n;t = t || 1 / 0;for (var r = e.length, i = null, o = [], s = 0; s < r; ++s) {
          if ((n = e.charCodeAt(s)) > 55295 && n < 57344) {
            if (!i) {
              if (n > 56319) {
                (t -= 3) > -1 && o.push(239, 191, 189);continue;
              }if (s + 1 === r) {
                (t -= 3) > -1 && o.push(239, 191, 189);continue;
              }i = n;continue;
            }if (n < 56320) {
              (t -= 3) > -1 && o.push(239, 191, 189), i = n;continue;
            }n = 65536 + (i - 55296 << 10 | n - 56320);
          } else i && (t -= 3) > -1 && o.push(239, 191, 189);if (i = null, n < 128) {
            if ((t -= 1) < 0) break;o.push(n);
          } else if (n < 2048) {
            if ((t -= 2) < 0) break;o.push(n >> 6 | 192, 63 & n | 128);
          } else if (n < 65536) {
            if ((t -= 3) < 0) break;o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
          } else {
            if (!(n < 1114112)) throw new Error("Invalid code point");if ((t -= 4) < 0) break;o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
          }
        }return o;
      }function K(e) {
        return r.toByteArray(function (e) {
          if ((e = function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          }(e).replace(L, "")).length < 2) return "";for (; e.length % 4 != 0;) {
            e += "=";
          }return e;
        }(e));
      }function H(e, t, n, r) {
        for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) {
          t[i + n] = e[i];
        }return i;
      }
    }).call(this, n(10));
  }, function (e, t, n) {
    "use strict";
    t.byteLength = function (e) {
      var t = c(e),
          n = t[0],
          r = t[1];return 3 * (n + r) / 4 - r;
    }, t.toByteArray = function (e) {
      var t,
          n,
          r = c(e),
          s = r[0],
          a = r[1],
          u = new o(function (e, t, n) {
        return 3 * (t + n) / 4 - n;
      }(0, s, a)),
          l = 0,
          f = a > 0 ? s - 4 : s;for (n = 0; n < f; n += 4) {
        t = i[e.charCodeAt(n)] << 18 | i[e.charCodeAt(n + 1)] << 12 | i[e.charCodeAt(n + 2)] << 6 | i[e.charCodeAt(n + 3)], u[l++] = t >> 16 & 255, u[l++] = t >> 8 & 255, u[l++] = 255 & t;
      }2 === a && (t = i[e.charCodeAt(n)] << 2 | i[e.charCodeAt(n + 1)] >> 4, u[l++] = 255 & t);1 === a && (t = i[e.charCodeAt(n)] << 10 | i[e.charCodeAt(n + 1)] << 4 | i[e.charCodeAt(n + 2)] >> 2, u[l++] = t >> 8 & 255, u[l++] = 255 & t);return u;
    }, t.fromByteArray = function (e) {
      for (var t, n = e.length, i = n % 3, o = [], s = 0, a = n - i; s < a; s += 16383) {
        o.push(l(e, s, s + 16383 > a ? a : s + 16383));
      }1 === i ? (t = e[n - 1], o.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === i && (t = (e[n - 2] << 8) + e[n - 1], o.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "="));return o.join("");
    };for (var r = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, u = s.length; a < u; ++a) {
      r[a] = s[a], i[s.charCodeAt(a)] = a;
    }function c(e) {
      var t = e.length;if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");var n = e.indexOf("=");return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
    }function l(e, t, n) {
      for (var i, o, s = [], a = t; a < n; a += 3) {
        i = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), s.push(r[(o = i) >> 18 & 63] + r[o >> 12 & 63] + r[o >> 6 & 63] + r[63 & o]);
      }return s.join("");
    }i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (e, t) {
    t.read = function (e, t, n, r, i) {
      var o,
          s,
          a = 8 * i - r - 1,
          u = (1 << a) - 1,
          c = u >> 1,
          l = -7,
          f = n ? i - 1 : 0,
          h = n ? -1 : 1,
          d = e[t + f];for (f += h, o = d & (1 << -l) - 1, d >>= -l, l += a; l > 0; o = 256 * o + e[t + f], f += h, l -= 8) {}for (s = o & (1 << -l) - 1, o >>= -l, l += r; l > 0; s = 256 * s + e[t + f], f += h, l -= 8) {}if (0 === o) o = 1 - c;else {
        if (o === u) return s ? NaN : 1 / 0 * (d ? -1 : 1);s += Math.pow(2, r), o -= c;
      }return (d ? -1 : 1) * s * Math.pow(2, o - r);
    }, t.write = function (e, t, n, r, i, o) {
      var s,
          a,
          u,
          c = 8 * o - i - 1,
          l = (1 << c) - 1,
          f = l >> 1,
          h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          d = r ? 0 : o - 1,
          p = r ? 1 : -1,
          y = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = l) : (s = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (t += s + f >= 1 ? h / u : h * Math.pow(2, 1 - f)) * u >= 2 && (s++, u /= 2), s + f >= l ? (a = 0, s = l) : s + f >= 1 ? (a = (t * u - 1) * Math.pow(2, i), s += f) : (a = t * Math.pow(2, f - 1) * Math.pow(2, i), s = 0)); i >= 8; e[n + d] = 255 & a, d += p, a /= 256, i -= 8) {}for (s = s << i | a, c += i; c > 0; e[n + d] = 255 & s, d += p, s /= 256, c -= 8) {}e[n + d - p] |= 128 * y;
    };
  }, function (e, t) {
    var n = {}.toString;e.exports = Array.isArray || function (e) {
      return "[object Array]" == n.call(e);
    };
  }, function (module, exports, __webpack_require__) {
    (function (process, global) {
      var __WEBPACK_AMD_DEFINE_RESULT__;
      /**
       * [js-sha256]{@link https://github.com/emn178/js-sha256}
       *
       * @version 0.9.0
       * @author Chen, Yi-Cyuan [emn178@gmail.com]
       * @copyright Chen, Yi-Cyuan 2014-2017
       * @license MIT
       */!function () {
        "use strict";
        var ERROR = "input is invalid type",
            WINDOW = "object" == typeof window,
            root = WINDOW ? window : {};root.JS_SHA256_NO_WINDOW && (WINDOW = !1);var WEB_WORKER = !WINDOW && "object" == typeof self,
            NODE_JS = !root.JS_SHA256_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node;NODE_JS ? root = global : WEB_WORKER && (root = self);var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && "object" == typeof module && module.exports,
            AMD = __webpack_require__(41),
            ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
            HEX_CHARS = "0123456789abcdef".split(""),
            EXTRA = [-2147483648, 8388608, 32768, 128],
            SHIFT = [24, 16, 8, 0],
            K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
            OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"],
            blocks = [];!root.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        }), !ARRAY_BUFFER || !root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
          return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
        });var createOutputMethod = function createOutputMethod(e, t) {
          return function (n) {
            return new Sha256(t, !0).update(n)[e]();
          };
        },
            createMethod = function createMethod(e) {
          var t = createOutputMethod("hex", e);NODE_JS && (t = nodeWrap(t, e)), t.create = function () {
            return new Sha256(e);
          }, t.update = function (e) {
            return t.create().update(e);
          };for (var n = 0; n < OUTPUT_TYPES.length; ++n) {
            var r = OUTPUT_TYPES[n];t[r] = createOutputMethod(r, e);
          }return t;
        },
            nodeWrap = function nodeWrap(method, is224) {
          var crypto = eval("require('crypto')"),
              Buffer = eval("require('buffer').Buffer"),
              algorithm = is224 ? "sha224" : "sha256",
              nodeMethod = function nodeMethod(e) {
            if ("string" == typeof e) return crypto.createHash(algorithm).update(e, "utf8").digest("hex");if (null == e) throw new Error(ERROR);return e.constructor === ArrayBuffer && (e = new Uint8Array(e)), Array.isArray(e) || ArrayBuffer.isView(e) || e.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(e)).digest("hex") : method(e);
          };return nodeMethod;
        },
            createHmacOutputMethod = function createHmacOutputMethod(e, t) {
          return function (n, r) {
            return new HmacSha256(n, t, !0).update(r)[e]();
          };
        },
            createHmacMethod = function createHmacMethod(e) {
          var t = createHmacOutputMethod("hex", e);t.create = function (t) {
            return new HmacSha256(t, e);
          }, t.update = function (e, n) {
            return t.create(e).update(n);
          };for (var n = 0; n < OUTPUT_TYPES.length; ++n) {
            var r = OUTPUT_TYPES[n];t[r] = createHmacOutputMethod(r, e);
          }return t;
        };function Sha256(e, t) {
          t ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], e ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = e;
        }function HmacSha256(e, t, n) {
          var r,
              i = typeof e;if ("string" === i) {
            var o,
                s = [],
                a = e.length,
                u = 0;for (r = 0; r < a; ++r) {
              (o = e.charCodeAt(r)) < 128 ? s[u++] = o : o < 2048 ? (s[u++] = 192 | o >> 6, s[u++] = 128 | 63 & o) : o < 55296 || o >= 57344 ? (s[u++] = 224 | o >> 12, s[u++] = 128 | o >> 6 & 63, s[u++] = 128 | 63 & o) : (o = 65536 + ((1023 & o) << 10 | 1023 & e.charCodeAt(++r)), s[u++] = 240 | o >> 18, s[u++] = 128 | o >> 12 & 63, s[u++] = 128 | o >> 6 & 63, s[u++] = 128 | 63 & o);
            }e = s;
          } else {
            if ("object" !== i) throw new Error(ERROR);if (null === e) throw new Error(ERROR);if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);
          }e.length > 64 && (e = new Sha256(t, !0).update(e).array());var c = [],
              l = [];for (r = 0; r < 64; ++r) {
            var f = e[r] || 0;c[r] = 92 ^ f, l[r] = 54 ^ f;
          }Sha256.call(this, t, n), this.update(l), this.oKeyPad = c, this.inner = !0, this.sharedMemory = n;
        }Sha256.prototype.update = function (e) {
          if (!this.finalized) {
            var t,
                n = typeof e;if ("string" !== n) {
              if ("object" !== n) throw new Error(ERROR);if (null === e) throw new Error(ERROR);if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);t = !0;
            }for (var r, i, o = 0, s = e.length, a = this.blocks; o < s;) {
              if (this.hashed && (this.hashed = !1, a[0] = this.block, a[16] = a[1] = a[2] = a[3] = a[4] = a[5] = a[6] = a[7] = a[8] = a[9] = a[10] = a[11] = a[12] = a[13] = a[14] = a[15] = 0), t) for (i = this.start; o < s && i < 64; ++o) {
                a[i >> 2] |= e[o] << SHIFT[3 & i++];
              } else for (i = this.start; o < s && i < 64; ++o) {
                (r = e.charCodeAt(o)) < 128 ? a[i >> 2] |= r << SHIFT[3 & i++] : r < 2048 ? (a[i >> 2] |= (192 | r >> 6) << SHIFT[3 & i++], a[i >> 2] |= (128 | 63 & r) << SHIFT[3 & i++]) : r < 55296 || r >= 57344 ? (a[i >> 2] |= (224 | r >> 12) << SHIFT[3 & i++], a[i >> 2] |= (128 | r >> 6 & 63) << SHIFT[3 & i++], a[i >> 2] |= (128 | 63 & r) << SHIFT[3 & i++]) : (r = 65536 + ((1023 & r) << 10 | 1023 & e.charCodeAt(++o)), a[i >> 2] |= (240 | r >> 18) << SHIFT[3 & i++], a[i >> 2] |= (128 | r >> 12 & 63) << SHIFT[3 & i++], a[i >> 2] |= (128 | r >> 6 & 63) << SHIFT[3 & i++], a[i >> 2] |= (128 | 63 & r) << SHIFT[3 & i++]);
              }this.lastByteIndex = i, this.bytes += i - this.start, i >= 64 ? (this.block = a[16], this.start = i - 64, this.hash(), this.hashed = !0) : this.start = i;
            }return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
          }
        }, Sha256.prototype.finalize = function () {
          if (!this.finalized) {
            this.finalized = !0;var e = this.blocks,
                t = this.lastByteIndex;e[16] = this.block, e[t >> 2] |= EXTRA[3 & t], this.block = e[16], t >= 56 && (this.hashed || this.hash(), e[0] = this.block, e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = this.hBytes << 3 | this.bytes >>> 29, e[15] = this.bytes << 3, this.hash();
          }
        }, Sha256.prototype.hash = function () {
          var e,
              t,
              n,
              r,
              i,
              o,
              s,
              a,
              u,
              c = this.h0,
              l = this.h1,
              f = this.h2,
              h = this.h3,
              d = this.h4,
              p = this.h5,
              y = this.h6,
              v = this.h7,
              g = this.blocks;for (e = 16; e < 64; ++e) {
            t = ((i = g[e - 15]) >>> 7 | i << 25) ^ (i >>> 18 | i << 14) ^ i >>> 3, n = ((i = g[e - 2]) >>> 17 | i << 15) ^ (i >>> 19 | i << 13) ^ i >>> 10, g[e] = g[e - 16] + t + g[e - 7] + n << 0;
          }for (u = l & f, e = 0; e < 64; e += 4) {
            this.first ? (this.is224 ? (o = 300032, v = (i = g[0] - 1413257819) - 150054599 << 0, h = i + 24177077 << 0) : (o = 704751109, v = (i = g[0] - 210244248) - 1521486534 << 0, h = i + 143694565 << 0), this.first = !1) : (t = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10), r = (o = c & l) ^ c & f ^ u, v = h + (i = v + (n = (d >>> 6 | d << 26) ^ (d >>> 11 | d << 21) ^ (d >>> 25 | d << 7)) + (d & p ^ ~d & y) + K[e] + g[e]) << 0, h = i + (t + r) << 0), t = (h >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10), r = (s = h & c) ^ h & l ^ o, y = f + (i = y + (n = (v >>> 6 | v << 26) ^ (v >>> 11 | v << 21) ^ (v >>> 25 | v << 7)) + (v & d ^ ~v & p) + K[e + 1] + g[e + 1]) << 0, t = ((f = i + (t + r) << 0) >>> 2 | f << 30) ^ (f >>> 13 | f << 19) ^ (f >>> 22 | f << 10), r = (a = f & h) ^ f & c ^ s, p = l + (i = p + (n = (y >>> 6 | y << 26) ^ (y >>> 11 | y << 21) ^ (y >>> 25 | y << 7)) + (y & v ^ ~y & d) + K[e + 2] + g[e + 2]) << 0, t = ((l = i + (t + r) << 0) >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10), r = (u = l & f) ^ l & h ^ a, d = c + (i = d + (n = (p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + (p & y ^ ~p & v) + K[e + 3] + g[e + 3]) << 0, c = i + (t + r) << 0;
          }this.h0 = this.h0 + c << 0, this.h1 = this.h1 + l << 0, this.h2 = this.h2 + f << 0, this.h3 = this.h3 + h << 0, this.h4 = this.h4 + d << 0, this.h5 = this.h5 + p << 0, this.h6 = this.h6 + y << 0, this.h7 = this.h7 + v << 0;
        }, Sha256.prototype.hex = function () {
          this.finalize();var e = this.h0,
              t = this.h1,
              n = this.h2,
              r = this.h3,
              i = this.h4,
              o = this.h5,
              s = this.h6,
              a = this.h7,
              u = HEX_CHARS[e >> 28 & 15] + HEX_CHARS[e >> 24 & 15] + HEX_CHARS[e >> 20 & 15] + HEX_CHARS[e >> 16 & 15] + HEX_CHARS[e >> 12 & 15] + HEX_CHARS[e >> 8 & 15] + HEX_CHARS[e >> 4 & 15] + HEX_CHARS[15 & e] + HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 4 & 15] + HEX_CHARS[15 & t] + HEX_CHARS[n >> 28 & 15] + HEX_CHARS[n >> 24 & 15] + HEX_CHARS[n >> 20 & 15] + HEX_CHARS[n >> 16 & 15] + HEX_CHARS[n >> 12 & 15] + HEX_CHARS[n >> 8 & 15] + HEX_CHARS[n >> 4 & 15] + HEX_CHARS[15 & n] + HEX_CHARS[r >> 28 & 15] + HEX_CHARS[r >> 24 & 15] + HEX_CHARS[r >> 20 & 15] + HEX_CHARS[r >> 16 & 15] + HEX_CHARS[r >> 12 & 15] + HEX_CHARS[r >> 8 & 15] + HEX_CHARS[r >> 4 & 15] + HEX_CHARS[15 & r] + HEX_CHARS[i >> 28 & 15] + HEX_CHARS[i >> 24 & 15] + HEX_CHARS[i >> 20 & 15] + HEX_CHARS[i >> 16 & 15] + HEX_CHARS[i >> 12 & 15] + HEX_CHARS[i >> 8 & 15] + HEX_CHARS[i >> 4 & 15] + HEX_CHARS[15 & i] + HEX_CHARS[o >> 28 & 15] + HEX_CHARS[o >> 24 & 15] + HEX_CHARS[o >> 20 & 15] + HEX_CHARS[o >> 16 & 15] + HEX_CHARS[o >> 12 & 15] + HEX_CHARS[o >> 8 & 15] + HEX_CHARS[o >> 4 & 15] + HEX_CHARS[15 & o] + HEX_CHARS[s >> 28 & 15] + HEX_CHARS[s >> 24 & 15] + HEX_CHARS[s >> 20 & 15] + HEX_CHARS[s >> 16 & 15] + HEX_CHARS[s >> 12 & 15] + HEX_CHARS[s >> 8 & 15] + HEX_CHARS[s >> 4 & 15] + HEX_CHARS[15 & s];return this.is224 || (u += HEX_CHARS[a >> 28 & 15] + HEX_CHARS[a >> 24 & 15] + HEX_CHARS[a >> 20 & 15] + HEX_CHARS[a >> 16 & 15] + HEX_CHARS[a >> 12 & 15] + HEX_CHARS[a >> 8 & 15] + HEX_CHARS[a >> 4 & 15] + HEX_CHARS[15 & a]), u;
        }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function () {
          this.finalize();var e = this.h0,
              t = this.h1,
              n = this.h2,
              r = this.h3,
              i = this.h4,
              o = this.h5,
              s = this.h6,
              a = this.h7,
              u = [e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, 255 & i, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o, s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, 255 & s];return this.is224 || u.push(a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, 255 & a), u;
        }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function () {
          this.finalize();var e = new ArrayBuffer(this.is224 ? 28 : 32),
              t = new DataView(e);return t.setUint32(0, this.h0), t.setUint32(4, this.h1), t.setUint32(8, this.h2), t.setUint32(12, this.h3), t.setUint32(16, this.h4), t.setUint32(20, this.h5), t.setUint32(24, this.h6), this.is224 || t.setUint32(28, this.h7), e;
        }, HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function () {
          if (Sha256.prototype.finalize.call(this), this.inner) {
            this.inner = !1;var e = this.array();Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(e), Sha256.prototype.finalize.call(this);
          }
        };var exports = createMethod();exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224, AMD && (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return exports;
        }.call(exports, __webpack_require__, exports, module), void 0 === __WEBPACK_AMD_DEFINE_RESULT__ || (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)));
      }();
    }).call(this, __webpack_require__(2), __webpack_require__(10));
  }, function (e, t) {
    (function (t) {
      e.exports = t;
    }).call(this, {});
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var i in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }return e;
      }).apply(this, arguments);
    },
        i = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }function u(e) {
          var t;e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(s, a);
        }u((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          o,
          s = { label: 0, sent: function sent() {
          if (1 & i[0]) throw i[1];return i[1];
        }, trys: [], ops: [] };return o = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;function a(o) {
        return function (a) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");for (; s;) {
              try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {case 0:case 1:
                    i = o;break;case 4:
                    return s.label++, { value: o[1], done: !1 };case 5:
                    s.label++, r = o[1], o = [0];continue;case 7:
                    o = s.ops.pop(), s.trys.pop();continue;default:
                    if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      s = 0;continue;
                    }if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      s.label = o[1];break;
                    }if (6 === o[0] && s.label < i[1]) {
                      s.label = i[1], i = o;break;
                    }if (i && s.label < i[2]) {
                      s.label = i[2], s.ops.push(o);break;
                    }i[2] && s.ops.pop(), s.trys.pop();continue;}o = t.call(e, s);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }if (5 & o[0]) throw o[1];return { value: o[0] ? o[1] : void 0, done: !0 };
          }([o, a]);
        };
      }
    },
        s = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : { default: e };
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.UserFeedback = void 0;var a = n(11),
        u = n(4),
        c = s(n(43)),
        l = s(n(44)),
        f = function () {
      function e(e) {
        this.storage = e;
      }return e.prototype.cancel = function () {
        this.resolve({ isSent: !1, feedbackURL: void 0 }), this.close();
      }, e.prototype.close = function () {
        this.backdropEl.removeEventListener("click", this.closeCb), this.closeEl.removeEventListener("click", this.closeCb), this.formEl.removeEventListener("submit", this.submitCb), this.backdropEl = null, this.closeEl = null, this.feedbackEl = null, this.formEl = null, this.subjectEl = null, this.submitEl = null, this.titleEl = null, this.shadow.innerHTML = "", this.wrapperEl.innerHTML = "", this.wrapperEl.remove(), this.wrapperEl = null;
      }, e.prototype.injectCSS = function () {
        var e = document.createElement("style");e.textContent = c.default.toString(), this.shadow.append(e);
      }, e.prototype.resolve = function (e) {
        this.deferred.resolve(e), this.deferred = null;
      }, e.prototype.show = function (e) {
        return i(this, void 0, void 0, function () {
          return o(this, function (t) {
            return this.deferred ? [2] : (this.options = r({ title: "Feedback", subjectPlaceholder: "Subject…", feedbackPlaceholder: "Your feedback…", submitLabel: "Send" }, e || {}), this.deferred = a.createDeferred(), this.showModal(), this.injectCSS(), [2, this.deferred.promise]);
          });
        });
      }, e.prototype.showModal = function () {
        var e = this;this.wrapperEl = document.createElement("div"), this.shadow = this.wrapperEl.attachShadow({ mode: "closed" }), this.shadow.innerHTML = l.default, this.titleEl = this.shadow.querySelector("[data-bf-title]"), this.titleEl.innerText = this.options.title, this.subjectEl = this.shadow.querySelector("[data-bf-subject]"), this.subjectEl.setAttribute("placeholder", this.options.subjectPlaceholder), this.feedbackEl = this.shadow.querySelector("[data-bf-feedback]"), this.feedbackEl.setAttribute("placeholder", this.options.feedbackPlaceholder), this.submitEl = this.shadow.querySelector("[data-bf-submit]"), this.submitEl.innerText = this.options.submitLabel, this.closeCb = function () {
          return e.cancel();
        }, this.backdropEl = this.shadow.querySelector("[data-bf-backdrop]"), this.backdropEl.addEventListener("click", this.closeCb), this.closeEl = this.shadow.querySelector("[data-bf-close]"), this.closeEl.addEventListener("click", this.closeCb), this.formEl = this.shadow.querySelector("[data-bf-form]"), this.submitCb = function (t) {
          return e.submit(t);
        }, this.formEl.addEventListener("submit", this.submitCb), document.querySelector("body").appendChild(this.wrapperEl);
      }, e.prototype.submit = function (e) {
        return i(this, void 0, void 0, function () {
          var t;return o(this, function (n) {
            return e.preventDefault(), e.stopPropagation(), t = this.storage.addIssue(u.IssueType.Feedback, this.subjectEl.value, this.feedbackEl.value), this.resolve({ isSent: !0, feedbackURL: t }), this.close(), [2];
          });
        });
      }, e;
    }();t.UserFeedback = f;
  }, function (e, t, n) {
    "use strict";
    n.r(t);var r = n(15),
        i = n.n(r)()(function (e) {
      return e[1];
    });i.push([e.i, '*{box-sizing:border-box}.bf-backdrop{position:fixed;top:0;left:0;width:100%;height:100%;z-index:var(--bf-z-index, 9999);background:var(--bf-backdrop-bg, rgba(0, 0, 0, 0.5))}.bf-modal{position:fixed;left:50%;top:50%;z-index:calc(var(--bf-z-index, 9999) + 1);width:500px;max-width:calc(100% - 32px);height:400px;max-height:calc(100% - 64px);transform:translate(-50%, -50%);box-shadow:var(--bf-modal-shadow, 0px 4px 12px 0px rgba(0, 0, 0, 0.25));border-radius:var(--bf-border-radius, 4px);background:#fff}.bf-modal *{font-family:var(--bf-font, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol");outline:none;font-weight:normal;color:var(--bf-color, #222)}.bf-modal__title{margin:0 0 16px;width:calc(100% - 24px);font-weight:bold;line-height:1.3;font-family:var(--bf-font-heading, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol");font-size:18px}.bf-modal__content{position:absolute;top:0;bottom:0;left:0;right:0;overflow-y:auto;display:flex;flex-direction:column;padding:24px}.bf-modal__close{position:absolute;z-index:1;top:0px;right:0px;width:40px;height:40px;display:flex;align-items:center;justify-content:center;border:0;background:none;padding:0;font-size:20px;cursor:pointer}.bf-modal__close:active{transform:scale(0.85)}.bf-modal__subject,.bf-modal__feedback{margin-bottom:16px;font-size:16px;padding:8px;border:var(--bf-input-border, 1px solid #ccc);border-radius:var(--bf-border-radius, 4px)}.bf-modal__subject::placeholder,.bf-modal__feedback::placeholder{color:var(--bf-placeholder-color, #757575)}.bf-modal__subject{min-height:32px}.bf-modal__feedback{flex-grow:1;resize:none;min-height:64px}.bf-modal__submit{width:100%;background-color:var(--bf-submit-bg, #ff5060);box-shadow:var(--bf-submit-shadow, 0 2px 0 0 #a93e48);border:0;border-radius:var(--bf-border-radius, 4px);padding:8px 0;color:var(--bf-submit-color, #fff);font-size:18px;cursor:pointer}.bf-modal__submit:active{transform:translateY(2px);box-shadow:none}', ""]), t.default = i;
  }, function (e, t) {
    e.exports = '<div class="bf-backdrop" data-bf-backdrop></div> <div class="bf-modal"> <button class="bf-modal__close" data-bf-close>&times;</button> <form class="bf-modal__content" data-bf-form> <h3 class="bf-modal__title" data-bf-title></h3> <input class="bf-modal__subject" data-bf-subject type="text" required> <textarea class="bf-modal__feedback" data-bf-feedback required></textarea> <button class="bf-modal__submit" data-bf-submit></button> </form> </div> ';
  }, function (e, t, n) {
    "use strict";
    n.r(t);var r = n(0);var i = { create: function create(e) {
        var t = { messagesCallback: null, bc: new BroadcastChannel(e), subFns: [] };return t.bc.onmessage = function (e) {
          t.messagesCallback && t.messagesCallback(e.data);
        }, t;
      }, close: function close(e) {
        e.bc.close(), e.subFns = [];
      }, onMessage: function onMessage(e, t) {
        e.messagesCallback = t;
      }, postMessage: function postMessage(e, t) {
        e.bc.postMessage(t, !1);
      }, canBeUsed: function canBeUsed() {
        if (r.a && "undefined" == typeof window) return !1;if ("function" == typeof BroadcastChannel) {
          if (BroadcastChannel._pubkey) throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");return !0;
        }return !1;
      }, type: "native", averageResponseTime: function averageResponseTime() {
        return 150;
      }, microSeconds: r.c };function o() {
      return new Date().getTime();
    }var s = function s(e) {
      var t = new Set(),
          n = new Map();this.has = t.has.bind(t), this.add = function (r) {
        n.set(r, o()), t.add(r), function () {
          var r = o() - e,
              i = t[Symbol.iterator]();for (;;) {
            var s = i.next().value;if (!s) return;if (!(n.get(s) < r)) return;n.delete(s), t.delete(s);
          }
        }();
      }, this.clear = function () {
        t.clear(), n.clear();
      };
    };function a() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = JSON.parse(JSON.stringify(e));return void 0 === t.webWorkerSupport && (t.webWorkerSupport = !0), t.idb || (t.idb = {}), t.idb.ttl || (t.idb.ttl = 45e3), t.idb.fallbackInterval || (t.idb.fallbackInterval = 150), t.localstorage || (t.localstorage = {}), t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 6e4), e.methods && (t.methods = e.methods), t.node || (t.node = {}), t.node.ttl || (t.node.ttl = 12e4), void 0 === t.node.useFastPath && (t.node.useFastPath = !0), t;
    }var u = r.c;function c() {
      if ("undefined" != typeof indexedDB) return indexedDB;if ("undefined" != typeof window) {
        if (void 0 !== window.mozIndexedDB) return window.mozIndexedDB;if (void 0 !== window.webkitIndexedDB) return window.webkitIndexedDB;if (void 0 !== window.msIndexedDB) return window.msIndexedDB;
      }return !1;
    }function l(e, t) {
      return function (e, t) {
        var n = new Date().getTime() - t,
            r = e.transaction("messages").objectStore("messages"),
            i = [];return new Promise(function (e) {
          r.openCursor().onsuccess = function (t) {
            var r = t.target.result;if (r) {
              var o = r.value;if (!(o.time < n)) return void e(i);i.push(o), r.continue();
            } else e(i);
          };
        });
      }(e, t).then(function (t) {
        return Promise.all(t.map(function (t) {
          return function (e, t) {
            var n = e.transaction(["messages"], "readwrite").objectStore("messages").delete(t);return new Promise(function (e) {
              n.onsuccess = function () {
                return e();
              };
            });
          }(e, t.id);
        }));
      });
    }function f(e) {
      return e.closed ? Promise.resolve() : e.messagesCallback ? (t = e.db, n = e.lastCursorId, r = t.transaction("messages").objectStore("messages"), i = [], o = IDBKeyRange.bound(n + 1, 1 / 0), new Promise(function (e) {
        r.openCursor(o).onsuccess = function (t) {
          var n = t.target.result;n ? (i.push(n.value), n.continue()) : e(i);
        };
      })).then(function (t) {
        return t.filter(function (e) {
          return !!e;
        }).map(function (t) {
          return t.id > e.lastCursorId && (e.lastCursorId = t.id), t;
        }).filter(function (t) {
          return function (e, t) {
            return e.uuid !== t.uuid && !t.eMIs.has(e.id) && !(e.data.time < t.messagesCallbackTime);
          }(t, e);
        }).sort(function (e, t) {
          return e.time - t.time;
        }).forEach(function (t) {
          e.messagesCallback && (e.eMIs.add(t.id), e.messagesCallback(t.data));
        }), Promise.resolve();
      }) : Promise.resolve();var t, n, r, i, o;
    }var h = { create: function create(e, t) {
        return t = a(t), function (e) {
          var t = "pubkey.broadcast-channel-0-" + e,
              n = c().open(t, 1);return n.onupgradeneeded = function (e) {
            e.target.result.createObjectStore("messages", { keyPath: "id", autoIncrement: !0 });
          }, new Promise(function (e, t) {
            n.onerror = function (e) {
              return t(e);
            }, n.onsuccess = function () {
              e(n.result);
            };
          });
        }(e).then(function (n) {
          var i = { closed: !1, lastCursorId: 0, channelName: e, options: t, uuid: Object(r.e)(), eMIs: new s(2 * t.idb.ttl), writeBlockPromise: Promise.resolve(), messagesCallback: null, readQueuePromises: [], db: n };return function e(t) {
            if (t.closed) return;f(t).then(function () {
              return Object(r.f)(t.options.idb.fallbackInterval);
            }).then(function () {
              return e(t);
            });
          }(i), i;
        });
      }, close: function close(e) {
        e.closed = !0, e.db.close();
      }, onMessage: function onMessage(e, t, n) {
        e.messagesCallbackTime = n, e.messagesCallback = t, f(e);
      }, postMessage: function postMessage(e, t) {
        return e.writeBlockPromise = e.writeBlockPromise.then(function () {
          return function (e, t, n) {
            var r = { uuid: t, time: new Date().getTime(), data: n },
                i = e.transaction(["messages"], "readwrite");return new Promise(function (e, t) {
              i.oncomplete = function () {
                return e();
              }, i.onerror = function (e) {
                return t(e);
              }, i.objectStore("messages").add(r);
            });
          }(e.db, e.uuid, t);
        }).then(function () {
          0 === Object(r.d)(0, 10) && l(e.db, e.options.idb.ttl);
        }), e.writeBlockPromise;
      }, canBeUsed: function canBeUsed() {
        return !r.a && !!c();
      }, type: "idb", averageResponseTime: function averageResponseTime(e) {
        return 2 * e.idb.fallbackInterval;
      }, microSeconds: u },
        d = r.c;function p() {
      var e;if ("undefined" == typeof window) return null;try {
        e = window.localStorage, e = window["ie8-eventlistener/storage"] || window.localStorage;
      } catch (e) {}return e;
    }function y(e) {
      return "pubkey.broadcastChannel-" + e;
    }function v() {
      if (r.a) return !1;var e = p();if (!e) return !1;try {
        var t = "__broadcastchannel_check";e.setItem(t, "works"), e.removeItem(t);
      } catch (e) {
        return !1;
      }return !0;
    }var g = { create: function create(e, t) {
        if (t = a(t), !v()) throw new Error("BroadcastChannel: localstorage cannot be used");var n = Object(r.e)(),
            i = new s(t.localstorage.removeTimeout),
            o = { channelName: e, uuid: n, eMIs: i };return o.listener = function (e, t) {
          var n = y(e),
              r = function r(e) {
            e.key === n && t(JSON.parse(e.newValue));
          };return window.addEventListener("storage", r), r;
        }(e, function (e) {
          o.messagesCallback && e.uuid !== n && e.token && !i.has(e.token) && (e.data.time && e.data.time < o.messagesCallbackTime || (i.add(e.token), o.messagesCallback(e.data)));
        }), o;
      }, close: function close(e) {
        var t;t = e.listener, window.removeEventListener("storage", t);
      }, onMessage: function onMessage(e, t, n) {
        e.messagesCallbackTime = n, e.messagesCallback = t;
      }, postMessage: function postMessage(e, t) {
        return new Promise(function (n) {
          Object(r.f)().then(function () {
            var i = y(e.channelName),
                o = { token: Object(r.e)(), time: new Date().getTime(), data: t, uuid: e.uuid },
                s = JSON.stringify(o);p().setItem(i, s);var a = document.createEvent("Event");a.initEvent("storage", !0, !0), a.key = i, a.newValue = s, window.dispatchEvent(a), n();
          });
        });
      }, canBeUsed: v, type: "localstorage", averageResponseTime: function averageResponseTime() {
        var e = navigator.userAgent.toLowerCase();return e.includes("safari") && !e.includes("chrome") ? 240 : 120;
      }, microSeconds: d },
        m = r.c,
        b = new Set();var w = { create: function create(e) {
        var t = { name: e, messagesCallback: null };return b.add(t), t;
      }, close: function close(e) {
        b.delete(e);
      }, onMessage: function onMessage(e, t) {
        e.messagesCallback = t;
      }, postMessage: function postMessage(e, t) {
        return new Promise(function (n) {
          return setTimeout(function () {
            Array.from(b).filter(function (t) {
              return t.name === e.name;
            }).filter(function (t) {
              return t !== e;
            }).filter(function (e) {
              return !!e.messagesCallback;
            }).forEach(function (e) {
              return e.messagesCallback(t);
            }), n();
          }, 5);
        });
      }, canBeUsed: function canBeUsed() {
        return !0;
      }, type: "simulate", averageResponseTime: function averageResponseTime() {
        return 5;
      }, microSeconds: m },
        _ = [i, h, g];if (r.a) {
      var E = n(22);"function" == typeof E.canBeUsed && _.push(E);
    }function S(e) {
      var t = [].concat(e.methods, _).filter(Boolean);if (e.type) {
        if ("simulate" === e.type) return w;var n = t.find(function (t) {
          return t.type === e.type;
        });if (n) return n;throw new Error("method-type " + e.type + " not found");
      }e.webWorkerSupport || r.a || (t = t.filter(function (e) {
        return "idb" !== e.type;
      }));var i = t.find(function (e) {
        return e.canBeUsed();
      });if (i) return i;throw new Error("No useable methode found:" + JSON.stringify(_.map(function (e) {
        return e.type;
      })));
    }var k,
        x = function x(e, t) {
      var n, i;this.name = e, k && (t = k), this.options = a(t), this.method = S(this.options), this._iL = !1, this._onML = null, this._addEL = { message: [], internal: [] }, this._befC = [], this._prepP = null, i = (n = this).method.create(n.name, n.options), Object(r.b)(i) ? (n._prepP = i, i.then(function (e) {
        n._state = e;
      })) : n._state = i;
    };function O(e) {
      var t = S(e = a(e));return "node" === t.type ? t.clearNodeFolder().then(function () {
        return !0;
      }) : Promise.resolve(!1);
    }function A(e) {
      k = e;
    }function P(e, t, n) {
      var r = { time: e.method.microSeconds(), type: t, data: n };return (e._prepP ? e._prepP : Promise.resolve()).then(function () {
        return e.method.postMessage(e._state, r);
      });
    }function T(e) {
      return e._addEL.message.length > 0 || e._addEL.internal.length > 0;
    }function M(e, t, n) {
      e._addEL[t].push(n), function (e) {
        if (!e._iL && T(e)) {
          var t = function t(_t) {
            e._addEL[_t.type].forEach(function (e) {
              _t.time >= e.time && e.fn(_t.data);
            });
          },
              n = e.method.microSeconds();e._prepP ? e._prepP.then(function () {
            e._iL = !0, e.method.onMessage(e._state, t, n);
          }) : (e._iL = !0, e.method.onMessage(e._state, t, n));
        }
      }(e);
    }function I(e, t, n) {
      e._addEL[t] = e._addEL[t].filter(function (e) {
        return e !== n;
      }), function (e) {
        if (e._iL && !T(e)) {
          e._iL = !1;var t = e.method.microSeconds();e.method.onMessage(e._state, null, t);
        }
      }(e);
    }x._pubkey = !0, x.prototype = { postMessage: function postMessage(e) {
        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed");return P(this, "message", e);
      }, postInternal: function postInternal(e) {
        return P(this, "internal", e);
      }, set onmessage(e) {
        var t = { time: this.method.microSeconds(), fn: e };I(this, "message", this._onML), e && "function" == typeof e ? (this._onML = t, M(this, "message", t)) : this._onML = null;
      }, addEventListener: function addEventListener(e, t) {
        M(this, e, { time: this.method.microSeconds(), fn: t });
      }, removeEventListener: function removeEventListener(e, t) {
        I(this, e, this._addEL[e].find(function (e) {
          return e.fn === t;
        }));
      }, close: function close() {
        var e = this;if (!this.closed) {
          this.closed = !0;var t = this._prepP ? this._prepP : Promise.resolve();return this._onML = null, this._addEL.message = [], t.then(function () {
            return Promise.all(e._befC.map(function (e) {
              return e();
            }));
          }).then(function () {
            return e.method.close(e._state);
          });
        }
      }, get type() {
        return this.method.type;
      } };var B = n(12),
        R = n.n(B);var C = { add: function add(e) {
        if ("function" == typeof WorkerGlobalScope && self instanceof WorkerGlobalScope) ;else {
          if ("function" != typeof window.addEventListener) return;window.addEventListener("beforeunload", function () {
            e();
          }, !0), window.addEventListener("unload", function () {
            e();
          }, !0);
        }
      } },
        j = n(13),
        D = n.n(j),
        F = R.a ? D.a : C,
        L = new Set(),
        U = !1;function N() {
      var e = [];return L.forEach(function (t) {
        e.push(t()), L.delete(t);
      }), Promise.all(e);
    }var K = { add: function add(e) {
        if (U || (U = !0, F.add(N)), "function" != typeof e) throw new Error("Listener is no function");return L.add(e), { remove: function remove() {
            return L.delete(e);
          }, run: function run() {
            return L.delete(e), e();
          } };
      }, runAll: N, removeAll: function removeAll() {
        L.clear();
      }, getSize: function getSize() {
        return L.size;
      } },
        H = function H(e, t) {
      this._channel = e, this._options = t, this.isLeader = !1, this.isDead = !1, this.token = Object(r.e)(), this._isApl = !1, this._reApply = !1, this._unl = [], this._lstns = [], this._invs = [];
    };function q(e, t) {
      var n = { context: "leader", action: t, token: e.token };return e._channel.postInternal(n);
    }function z(e, t) {
      if (e._leaderElector) throw new Error("BroadcastChannel already has a leader-elector");t = function (e, t) {
        return e || (e = {}), (e = JSON.parse(JSON.stringify(e))).fallbackInterval || (e.fallbackInterval = 3e3), e.responseTime || (e.responseTime = t.method.averageResponseTime(t.options)), e;
      }(t, e);var n = new H(e, t);return e._befC.push(function () {
        return n.die();
      }), e._leaderElector = n, n;
    }H.prototype = { applyOnce: function applyOnce() {
        var e = this;if (this.isLeader) return Promise.resolve(!1);if (this.isDead) return Promise.resolve(!1);if (this._isApl) return this._reApply = !0, Promise.resolve(!1);this._isApl = !0;var t = !1,
            n = [],
            i = function i(r) {
          "leader" === r.context && r.token != e.token && (n.push(r), "apply" === r.action && r.token > e.token && (t = !0), "tell" === r.action && (t = !0));
        };return this._channel.addEventListener("internal", i), q(this, "apply").then(function () {
          return Object(r.f)(e._options.responseTime);
        }).then(function () {
          return t ? Promise.reject(new Error()) : q(e, "apply");
        }).then(function () {
          return Object(r.f)(e._options.responseTime);
        }).then(function () {
          return t ? Promise.reject(new Error()) : q(e);
        }).then(function () {
          return function (e) {
            e.isLeader = !0;var t = K.add(function () {
              return e.die();
            });e._unl.push(t);var n = function n(t) {
              "leader" === t.context && "apply" === t.action && q(e, "tell");
            };return e._channel.addEventListener("internal", n), e._lstns.push(n), q(e, "tell");
          }(e);
        }).then(function () {
          return !0;
        }).catch(function () {
          return !1;
        }).then(function (t) {
          return e._channel.removeEventListener("internal", i), e._isApl = !1, !t && e._reApply ? (e._reApply = !1, e.applyOnce()) : t;
        });
      }, awaitLeadership: function awaitLeadership() {
        var e;return this._aLP || (this._aLP = (e = this).isLeader ? Promise.resolve() : new Promise(function (t) {
          var n = !1,
              r = function r() {
            n || (n = !0, clearInterval(i), e._channel.removeEventListener("internal", o), t(!0));
          };e.applyOnce().then(function () {
            e.isLeader && r();
          });var i = setInterval(function () {
            e.applyOnce().then(function () {
              e.isLeader && r();
            });
          }, e._options.fallbackInterval);e._invs.push(i);var o = function o(t) {
            "leader" === t.context && "death" === t.action && e.applyOnce().then(function () {
              e.isLeader && r();
            });
          };e._channel.addEventListener("internal", o), e._lstns.push(o);
        })), this._aLP;
      }, die: function die() {
        var e = this;if (!this.isDead) return this.isDead = !0, this._lstns.forEach(function (t) {
          return e._channel.removeEventListener("internal", t);
        }), this._invs.forEach(function (e) {
          return clearInterval(e);
        }), this._unl.forEach(function (e) {
          e.remove();
        }), q(this, "death");
      } }, n.d(t, "BroadcastChannel", function () {
      return x;
    }), n.d(t, "clearNodeFolder", function () {
      return O;
    }), n.d(t, "enforceOptions", function () {
      return A;
    }), n.d(t, "createLeaderElection", function () {
      return z;
    });
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.RegisterEventsHandlerBase = void 0;var r = function () {
      function e(e) {
        this.window = e;
      }return e.prototype.getURL = function () {
        return this.window ? this.window.location.toString() : "";
      }, e.prototype.supportsPassiveEvents = function () {
        var e = !1;try {
          var t = { get passive() {
              return e = !0, !1;
            } };this.window.addEventListener("test", null, t), this.window.removeEventListener("test", null, !1);
        } catch (t) {
          e = !1;
        }return e;
      }, e;
    }();t.RegisterEventsHandlerBase = r;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : { default: e };
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.LogLevel = t.BugfenderClass = t.Bugfender = void 0;var i = n(17);Object.defineProperty(t, "BugfenderClass", { enumerable: !0, get: function get() {
        return i.Bugfender;
      } });var o = n(48),
        s = n(24),
        a = n(27),
        u = n(21),
        c = n(23),
        l = n(28),
        f = r(n(29)),
        h = n(16),
        d = n(30),
        p = n(25),
        y = n(1);Object.defineProperty(t, "LogLevel", { enumerable: !0, get: function get() {
        return y.LogLevel;
      } });var v = n(50),
        g = n(51),
        m = n(52),
        b = n(53),
        w = n(31),
        _ = n(32),
        E = n(18),
        S = n(54),
        k = n(55),
        x = n(56),
        O = n(57),
        A = n(33),
        P = n(58),
        T = n(42),
        M = new _.UUIDFactory(),
        I = new c.Connection(window.navigator),
        B = new o.Database(),
        R = new p.Device(window.localStorage, 20210212, M),
        C = new g.DeviceKeysTable(B.devicekeys),
        j = new m.IssuesTable(B.issues),
        D = new b.LogsTable(B.logs, new w.LogFactory()),
        F = new v.SessionsTable(B.sessions),
        L = new s.CurrentSession(R, window.sessionStorage, F, M),
        U = new u.Channel(u.createBroadcastChannel(), window.console, L),
        N = new h.ApiClient(),
        K = new d.SessionFactory(R, 20210212),
        H = new f.default(),
        q = new l.StorageWriterHub(new E.CallInfoFactory(), U, R, H, L, M, window),
        z = new a.StorageProcessor(N, U, I, window.console, R, C, j, D, K, F),
        W = new i.Bugfender(N, R, new S.OverrideConsoleMethods(q, window), new P.PrintToConsole(window.console), new x.RegisterBrowserEventsHandler(q, window), new k.RegisterErrorHandler(window), new O.RegisterUIEventsHandler(q, window), z, new A.SDKOptions(), "bugfender-web/20210212 (v1.5.0-33f931b-lib)", L, q, new T.UserFeedback(q));t.Bugfender = W;
  }, function (e, t, n) {
    "use strict";
    var _r,
        i = this && this.__extends || (_r = function r(e, t) {
      return (_r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }_r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : { default: e };
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.Database = void 0;var s = function (e) {
      function t() {
        var t = e.call(this, "bf_sdk") || this;return t.version(1).stores({ devicekeys: "++id, sessionUUID", issues: "++id, sessionUUID", logs: "++id, sessionUUID", sessions: "uuid" }), t.devicekeys = t.table("devicekeys"), t.issues = t.table("issues"), t.logs = t.table("logs"), t.sessions = t.table("sessions"), t;
      }return i(t, e), t;
    }(o(n(49)).default);t.Database = s;
  }, function (e, t, n) {
    "use strict";
    n.r(t);var _r2 = function r() {
      return (_r2 = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var i in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }return e;
      }).apply(this, arguments);
    };function i() {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }var r = Array(e),
          i = 0;for (t = 0; t < n; t++) {
        for (var o = arguments[t], s = 0, a = o.length; s < a; s++, i++) {
          r[i] = o[s];
        }
      }return r;
    }var o = Object.keys,
        s = Array.isArray,
        a = "undefined" != typeof self ? self : "undefined" != typeof window ? window : global;function u(e, t) {
      return "object" != typeof t || o(t).forEach(function (n) {
        e[n] = t[n];
      }), e;
    }"undefined" == typeof Promise || a.Promise || (a.Promise = Promise);var c = Object.getPrototypeOf,
        l = {}.hasOwnProperty;function f(e, t) {
      return l.call(e, t);
    }function h(e, t) {
      "function" == typeof t && (t = t(c(e))), o(t).forEach(function (n) {
        p(e, n, t[n]);
      });
    }var d = Object.defineProperty;function p(e, t, n, r) {
      d(e, t, u(n && f(n, "get") && "function" == typeof n.get ? { get: n.get, set: n.set, configurable: !0 } : { value: n, configurable: !0, writable: !0 }, r));
    }function y(e) {
      return { from: function from(t) {
          return e.prototype = Object.create(t.prototype), p(e.prototype, "constructor", e), { extend: h.bind(null, e.prototype) };
        } };
    }var v = Object.getOwnPropertyDescriptor;var g = [].slice;function m(e, t, n) {
      return g.call(e, t, n);
    }function b(e, t) {
      return t(e);
    }function w(e) {
      if (!e) throw new Error("Assertion Failed");
    }function _(e) {
      a.setImmediate ? setImmediate(e) : setTimeout(e, 0);
    }function E(e, t) {
      return e.reduce(function (e, n, r) {
        var i = t(n, r);return i && (e[i[0]] = i[1]), e;
      }, {});
    }function S(e, t) {
      if (f(e, t)) return e[t];if (!t) return e;if ("string" != typeof t) {
        for (var n = [], r = 0, i = t.length; r < i; ++r) {
          var o = S(e, t[r]);n.push(o);
        }return n;
      }var s = t.indexOf(".");if (-1 !== s) {
        var a = e[t.substr(0, s)];return void 0 === a ? void 0 : S(a, t.substr(s + 1));
      }
    }function k(e, t, n) {
      if (e && void 0 !== t && !("isFrozen" in Object && Object.isFrozen(e))) if ("string" != typeof t && "length" in t) {
        w("string" != typeof n && "length" in n);for (var r = 0, i = t.length; r < i; ++r) {
          k(e, t[r], n[r]);
        }
      } else {
        var o = t.indexOf(".");if (-1 !== o) {
          var a = t.substr(0, o),
              u = t.substr(o + 1);if ("" === u) void 0 === n ? s(e) && !isNaN(parseInt(a)) ? e.splice(a, 1) : delete e[a] : e[a] = n;else {
            var c = e[a];c || (c = e[a] = {}), k(c, u, n);
          }
        } else void 0 === n ? s(e) && !isNaN(parseInt(t)) ? e.splice(t, 1) : delete e[t] : e[t] = n;
      }
    }function x(e) {
      var t = {};for (var n in e) {
        f(e, n) && (t[n] = e[n]);
      }return t;
    }var O = [].concat;function A(e) {
      return O.apply([], e);
    }var P = "Boolean,String,Date,RegExp,Blob,File,FileList,ArrayBuffer,DataView,Uint8ClampedArray,ImageData,Map,Set".split(",").concat(A([8, 16, 32, 64].map(function (e) {
      return ["Int", "Uint", "Float"].map(function (t) {
        return t + e + "Array";
      });
    }))).filter(function (e) {
      return a[e];
    }),
        T = P.map(function (e) {
      return a[e];
    }),
        M = E(P, function (e) {
      return [e, !0];
    });function I(e) {
      if (!e || "object" != typeof e) return e;var t;if (s(e)) {
        t = [];for (var n = 0, r = e.length; n < r; ++n) {
          t.push(I(e[n]));
        }
      } else if (T.indexOf(e.constructor) >= 0) t = e;else for (var i in t = e.constructor ? Object.create(e.constructor.prototype) : {}, e) {
        f(e, i) && (t[i] = I(e[i]));
      }return t;
    }var B = {}.toString;function R(e) {
      return B.call(e).slice(8, -1);
    }var C = function C(e, t) {
      return "Array" === t ? "" + e.map(function (e) {
        return C(e, R(e));
      }) : "ArrayBuffer" === t ? "" + new Uint8Array(e) : "Date" === t ? e.getTime() : ArrayBuffer.isView(e) ? "" + new Uint8Array(e.buffer) : e;
    };function j(e, t, n, r) {
      return n = n || {}, r = r || "", o(e).forEach(function (i) {
        if (f(t, i)) {
          var o = e[i],
              s = t[i];if ("object" == typeof o && "object" == typeof s && o && s) {
            var a = R(o),
                u = R(s);a === u ? M[a] ? C(o, a) !== C(s, u) && (n[r + i] = t[i]) : j(o, s, n, r + i + ".") : n[r + i] = t[i];
          } else o !== s && (n[r + i] = t[i]);
        } else n[r + i] = void 0;
      }), o(t).forEach(function (i) {
        f(e, i) || (n[r + i] = t[i]);
      }), n;
    }var D = "undefined" != typeof Symbol && Symbol.iterator,
        F = D ? function (e) {
      var t;return null != e && (t = e[D]) && t.apply(e);
    } : function () {
      return null;
    },
        L = {};function U(e) {
      var t, n, r, i;if (1 === arguments.length) {
        if (s(e)) return e.slice();if (this === L && "string" == typeof e) return [e];if (i = F(e)) {
          for (n = []; !(r = i.next()).done;) {
            n.push(r.value);
          }return n;
        }if (null == e) return [e];if ("number" == typeof (t = e.length)) {
          for (n = new Array(t); t--;) {
            n[t] = e[t];
          }return n;
        }return [e];
      }for (t = arguments.length, n = new Array(t); t--;) {
        n[t] = arguments[t];
      }return n;
    }var N = "undefined" != typeof Symbol ? function (e) {
      return "AsyncFunction" === e[Symbol.toStringTag];
    } : function () {
      return !1;
    },
        K = "undefined" != typeof location && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);function H(e, t) {
      K = e, q = t;
    }var q = function q() {
      return !0;
    },
        z = !new Error("").stack;function W() {
      if (z) try {
        throw new Error();
      } catch (e) {
        return e;
      }return new Error();
    }function V(e, t) {
      var n = e.stack;return n ? (t = t || 0, 0 === n.indexOf(e.name) && (t += (e.name + e.message).split("\n").length), n.split("\n").slice(t).filter(q).map(function (e) {
        return "\n" + e;
      }).join("")) : "";
    }var X = ["Unknown", "Constraint", "Data", "TransactionInactive", "ReadOnly", "Version", "NotFound", "InvalidState", "InvalidAccess", "Abort", "Timeout", "QuotaExceeded", "Syntax", "DataClone"],
        Y = ["Modify", "Bulk", "OpenFailed", "VersionChange", "Schema", "Upgrade", "InvalidTable", "MissingAPI", "NoSuchDatabase", "InvalidArgument", "SubTransaction", "Unsupported", "Internal", "DatabaseClosed", "PrematureCommit", "ForeignAwait"].concat(X),
        J = { VersionChanged: "Database version changed by other database connection", DatabaseClosed: "Database has been closed", Abort: "Transaction aborted", TransactionInactive: "Transaction has already completed or failed" };function G(e, t) {
      this._e = W(), this.name = e, this.message = t;
    }function Q(e, t) {
      return e + ". Errors: " + Object.keys(t).map(function (e) {
        return t[e].toString();
      }).filter(function (e, t, n) {
        return n.indexOf(e) === t;
      }).join("\n");
    }function $(e, t, n, r) {
      this._e = W(), this.failures = t, this.failedKeys = r, this.successCount = n, this.message = Q(e, t);
    }function Z(e, t) {
      this._e = W(), this.name = "BulkError", this.failures = t, this.message = Q(e, t);
    }y(G).from(Error).extend({ stack: { get: function get() {
          return this._stack || (this._stack = this.name + ": " + this.message + V(this._e, 2));
        } }, toString: function toString() {
        return this.name + ": " + this.message;
      } }), y($).from(G), y(Z).from(G);var ee = Y.reduce(function (e, t) {
      return e[t] = t + "Error", e;
    }, {}),
        te = G,
        ne = Y.reduce(function (e, t) {
      var n = t + "Error";function r(e, r) {
        this._e = W(), this.name = n, e ? "string" == typeof e ? (this.message = e + (r ? "\n " + r : ""), this.inner = r || null) : "object" == typeof e && (this.message = e.name + " " + e.message, this.inner = e) : (this.message = J[t] || n, this.inner = null);
      }return y(r).from(te), e[t] = r, e;
    }, {});ne.Syntax = SyntaxError, ne.Type = TypeError, ne.Range = RangeError;var re = X.reduce(function (e, t) {
      return e[t + "Error"] = ne[t], e;
    }, {});var ie = Y.reduce(function (e, t) {
      return -1 === ["Syntax", "Type", "Range"].indexOf(t) && (e[t + "Error"] = ne[t]), e;
    }, {});function oe() {}function se(e) {
      return e;
    }function ae(e, t) {
      return null == e || e === se ? t : function (n) {
        return t(e(n));
      };
    }function ue(e, t) {
      return function () {
        e.apply(this, arguments), t.apply(this, arguments);
      };
    }function ce(e, t) {
      return e === oe ? t : function () {
        var n = e.apply(this, arguments);void 0 !== n && (arguments[0] = n);var r = this.onsuccess,
            i = this.onerror;this.onsuccess = null, this.onerror = null;var o = t.apply(this, arguments);return r && (this.onsuccess = this.onsuccess ? ue(r, this.onsuccess) : r), i && (this.onerror = this.onerror ? ue(i, this.onerror) : i), void 0 !== o ? o : n;
      };
    }function le(e, t) {
      return e === oe ? t : function () {
        e.apply(this, arguments);var n = this.onsuccess,
            r = this.onerror;this.onsuccess = this.onerror = null, t.apply(this, arguments), n && (this.onsuccess = this.onsuccess ? ue(n, this.onsuccess) : n), r && (this.onerror = this.onerror ? ue(r, this.onerror) : r);
      };
    }function fe(e, t) {
      return e === oe ? t : function (n) {
        var r = e.apply(this, arguments);u(n, r);var i = this.onsuccess,
            o = this.onerror;this.onsuccess = null, this.onerror = null;var s = t.apply(this, arguments);return i && (this.onsuccess = this.onsuccess ? ue(i, this.onsuccess) : i), o && (this.onerror = this.onerror ? ue(o, this.onerror) : o), void 0 === r ? void 0 === s ? void 0 : s : u(r, s);
      };
    }function he(e, t) {
      return e === oe ? t : function () {
        return !1 !== t.apply(this, arguments) && e.apply(this, arguments);
      };
    }function de(e, t) {
      return e === oe ? t : function () {
        var n = e.apply(this, arguments);if (n && "function" == typeof n.then) {
          for (var r = this, i = arguments.length, o = new Array(i); i--;) {
            o[i] = arguments[i];
          }return n.then(function () {
            return t.apply(r, o);
          });
        }return t.apply(this, arguments);
      };
    }ie.ModifyError = $, ie.DexieError = G, ie.BulkError = Z;var pe = {},
        ye = "undefined" == typeof Promise ? [] : function () {
      var e = Promise.resolve();if ("undefined" == typeof crypto || !crypto.subtle) return [e, e.__proto__, e];var t = crypto.subtle.digest("SHA-512", new Uint8Array([0]));return [t, t.__proto__, e];
    }(),
        ve = ye[0],
        ge = ye[1],
        me = ye[2],
        be = ge && ge.then,
        we = ve && ve.constructor,
        _e = !!me,
        Ee = !1,
        Se = me ? function () {
      me.then(We);
    } : a.setImmediate ? setImmediate.bind(null, We) : a.MutationObserver ? function () {
      var e = document.createElement("div");new MutationObserver(function () {
        We(), e = null;
      }).observe(e, { attributes: !0 }), e.setAttribute("i", "1");
    } : function () {
      setTimeout(We, 0);
    },
        ke = function ke(e, t) {
      Re.push([e, t]), Oe && (Se(), Oe = !1);
    },
        xe = !0,
        Oe = !0,
        Ae = [],
        Pe = [],
        Te = null,
        Me = se,
        Ie = { id: "global", global: !0, ref: 0, unhandleds: [], onunhandled: pt, pgp: !1, env: {}, finalize: function finalize() {
        this.unhandleds.forEach(function (e) {
          try {
            pt(e[0], e[1]);
          } catch (e) {}
        });
      } },
        Be = Ie,
        Re = [],
        Ce = 0,
        je = [];function De(e) {
      if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");this._listeners = [], this.onuncatched = oe, this._lib = !1;var t = this._PSD = Be;if (K && (this._stackHolder = W(), this._prev = null, this._numPrev = 0), "function" != typeof e) {
        if (e !== pe) throw new TypeError("Not a function");return this._state = arguments[1], this._value = arguments[2], void (!1 === this._state && Ne(this, this._value));
      }this._state = null, this._value = null, ++t.ref, Ue(this, e);
    }var Fe = { get: function get() {
        var e = Be,
            t = tt;function n(n, r) {
          var i = this,
              o = !e.global && (e !== Be || t !== tt);o && ot();var s = new De(function (t, s) {
            He(i, new Le(ht(n, e, o), ht(r, e, o), t, s, e));
          });return K && ze(s, this), s;
        }return n.prototype = pe, n;
      }, set: function set(e) {
        p(this, "then", e && e.prototype === pe ? Fe : { get: function get() {
            return e;
          }, set: Fe.set });
      } };function Le(e, t, n, r, i) {
      this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.resolve = n, this.reject = r, this.psd = i;
    }function Ue(e, t) {
      try {
        t(function (t) {
          if (null === e._state) {
            if (t === e) throw new TypeError("A promise cannot be resolved with itself.");var n = e._lib && Ve();t && "function" == typeof t.then ? Ue(e, function (e, n) {
              t instanceof De ? t._then(e, n) : t.then(e, n);
            }) : (e._state = !0, e._value = t, Ke(e)), n && Xe();
          }
        }, Ne.bind(null, e));
      } catch (t) {
        Ne(e, t);
      }
    }function Ne(e, t) {
      if (Pe.push(t), null === e._state) {
        var n = e._lib && Ve();t = Me(t), e._state = !1, e._value = t, K && null !== t && "object" == typeof t && !t._promise && function (e, t, n) {
          try {
            e.apply(null, n);
          } catch (e) {
            t && t(e);
          }
        }(function () {
          var n = function e(t, n) {
            var r;return v(t, n) || (r = c(t)) && e(r, n);
          }(t, "stack");t._promise = e, p(t, "stack", { get: function get() {
              return Ee ? n && (n.get ? n.get.apply(t) : n.value) : e.stack;
            } });
        }), function (e) {
          Ae.some(function (t) {
            return t._value === e._value;
          }) || Ae.push(e);
        }(e), Ke(e), n && Xe();
      }
    }function Ke(e) {
      var t = e._listeners;e._listeners = [];for (var n = 0, r = t.length; n < r; ++n) {
        He(e, t[n]);
      }var i = e._PSD;--i.ref || i.finalize(), 0 === Ce && (++Ce, ke(function () {
        0 == --Ce && Ye();
      }, []));
    }function He(e, t) {
      if (null !== e._state) {
        var n = e._state ? t.onFulfilled : t.onRejected;if (null === n) return (e._state ? t.resolve : t.reject)(e._value);++t.psd.ref, ++Ce, ke(qe, [n, e, t]);
      } else e._listeners.push(t);
    }function qe(e, t, n) {
      try {
        Te = t;var r,
            i = t._value;t._state ? r = e(i) : (Pe.length && (Pe = []), r = e(i), -1 === Pe.indexOf(i) && function (e) {
          var t = Ae.length;for (; t;) {
            if (Ae[--t]._value === e._value) return void Ae.splice(t, 1);
          }
        }(t)), n.resolve(r);
      } catch (e) {
        n.reject(e);
      } finally {
        Te = null, 0 == --Ce && Ye(), --n.psd.ref || n.psd.finalize();
      }
    }function ze(e, t) {
      var n = t ? t._numPrev + 1 : 0;n < 100 && (e._prev = t, e._numPrev = n);
    }function We() {
      Ve() && Xe();
    }function Ve() {
      var e = xe;return xe = !1, Oe = !1, e;
    }function Xe() {
      var e, t, n;do {
        for (; Re.length > 0;) {
          for (e = Re, Re = [], n = e.length, t = 0; t < n; ++t) {
            var r = e[t];r[0].apply(null, r[1]);
          }
        }
      } while (Re.length > 0);xe = !0, Oe = !0;
    }function Ye() {
      var e = Ae;Ae = [], e.forEach(function (e) {
        e._PSD.onunhandled.call(null, e._value, e);
      });for (var t = je.slice(0), n = t.length; n;) {
        t[--n]();
      }
    }function Je(e) {
      return new De(pe, !1, e);
    }function Ge(e, t) {
      var n = Be;return function () {
        var r = Ve(),
            i = Be;try {
          return ct(n, !0), e.apply(this, arguments);
        } catch (e) {
          t && t(e);
        } finally {
          ct(i, !1), r && Xe();
        }
      };
    }h(De.prototype, { then: Fe, _then: function _then(e, t) {
        He(this, new Le(null, null, e, t, Be));
      }, catch: function _catch(e) {
        if (1 === arguments.length) return this.then(null, e);var t = arguments[0],
            n = arguments[1];return "function" == typeof t ? this.then(null, function (e) {
          return e instanceof t ? n(e) : Je(e);
        }) : this.then(null, function (e) {
          return e && e.name === t ? n(e) : Je(e);
        });
      }, finally: function _finally(e) {
        return this.then(function (t) {
          return e(), t;
        }, function (t) {
          return e(), Je(t);
        });
      }, stack: { get: function get() {
          if (this._stack) return this._stack;try {
            Ee = !0;var e = function e(t, n, r) {
              if (n.length === r) return n;var i = "";if (!1 === t._state) {
                var o,
                    s,
                    a = t._value;null != a ? (o = a.name || "Error", s = a.message || a, i = V(a, 0)) : (o = a, s = ""), n.push(o + (s ? ": " + s : "") + i);
              }K && ((i = V(t._stackHolder, 2)) && -1 === n.indexOf(i) && n.push(i), t._prev && e(t._prev, n, r));return n;
            }(this, [], 20).join("\nFrom previous: ");return null !== this._state && (this._stack = e), e;
          } finally {
            Ee = !1;
          }
        } }, timeout: function timeout(e, t) {
        var n = this;return e < 1 / 0 ? new De(function (r, i) {
          var o = setTimeout(function () {
            return i(new ne.Timeout(t));
          }, e);n.then(r, i).finally(clearTimeout.bind(null, o));
        }) : this;
      } }), "undefined" != typeof Symbol && Symbol.toStringTag && p(De.prototype, Symbol.toStringTag, "Dexie.Promise"), Ie.env = lt(), h(De, { all: function all() {
        var e = U.apply(null, arguments).map(st);return new De(function (t, n) {
          0 === e.length && t([]);var r = e.length;e.forEach(function (i, o) {
            return De.resolve(i).then(function (n) {
              e[o] = n, --r || t(e);
            }, n);
          });
        });
      }, resolve: function resolve(e) {
        if (e instanceof De) return e;if (e && "function" == typeof e.then) return new De(function (t, n) {
          e.then(t, n);
        });var t = new De(pe, !0, e);return ze(t, Te), t;
      }, reject: Je, race: function race() {
        var e = U.apply(null, arguments).map(st);return new De(function (t, n) {
          e.map(function (e) {
            return De.resolve(e).then(t, n);
          });
        });
      }, PSD: { get: function get() {
          return Be;
        }, set: function set(e) {
          return Be = e;
        } }, newPSD: rt, usePSD: ft, scheduler: { get: function get() {
          return ke;
        }, set: function set(e) {
          ke = e;
        } }, rejectionMapper: { get: function get() {
          return Me;
        }, set: function set(e) {
          Me = e;
        } }, follow: function follow(e, t) {
        return new De(function (n, r) {
          return rt(function (t, n) {
            var r = Be;r.unhandleds = [], r.onunhandled = n, r.finalize = ue(function () {
              var e = this;!function (e) {
                je.push(function t() {
                  e(), je.splice(je.indexOf(t), 1);
                }), ++Ce, ke(function () {
                  0 == --Ce && Ye();
                }, []);
              }(function () {
                0 === e.unhandleds.length ? t() : n(e.unhandleds[0]);
              });
            }, r.finalize), e();
          }, t, n, r);
        });
      } }), we && (we.allSettled && p(De, "allSettled", function () {
      var e = U.apply(null, arguments).map(st);return new De(function (t) {
        0 === e.length && t([]);var n = e.length,
            r = new Array(n);e.forEach(function (e, i) {
          return De.resolve(e).then(function (e) {
            return r[i] = { status: "fulfilled", value: e };
          }, function (e) {
            return r[i] = { status: "rejected", reason: e };
          }).then(function () {
            return --n || t(r);
          });
        });
      });
    }), we.any && "undefined" != typeof AggregateError && p(De, "any", function () {
      var e = U.apply(null, arguments).map(st);return new De(function (t, n) {
        0 === e.length && n(new AggregateError([]));var r = e.length,
            i = new Array(r);e.forEach(function (e, o) {
          return De.resolve(e).then(function (e) {
            return t(e);
          }, function (e) {
            i[o] = e, --r || n(new AggregateError(i));
          });
        });
      });
    }));var Qe = { awaits: 0, echoes: 0, id: 0 },
        $e = 0,
        Ze = [],
        et = 0,
        tt = 0,
        nt = 0;function rt(e, t, n, r) {
      var i = Be,
          o = Object.create(i);o.parent = i, o.ref = 0, o.global = !1, o.id = ++nt;var s = Ie.env;o.env = _e ? { Promise: De, PromiseProp: { value: De, configurable: !0, writable: !0 }, all: De.all, race: De.race, allSettled: De.allSettled, any: De.any, resolve: De.resolve, reject: De.reject, nthen: dt(s.nthen, o), gthen: dt(s.gthen, o) } : {}, t && u(o, t), ++i.ref, o.finalize = function () {
        --this.parent.ref || this.parent.finalize();
      };var a = ft(o, e, n, r);return 0 === o.ref && o.finalize(), a;
    }function it() {
      return Qe.id || (Qe.id = ++$e), ++Qe.awaits, Qe.echoes += 100, Qe.id;
    }function ot(e) {
      !Qe.awaits || e && e !== Qe.id || (0 == --Qe.awaits && (Qe.id = 0), Qe.echoes = 100 * Qe.awaits);
    }function st(e) {
      return Qe.echoes && e && e.constructor === we ? (it(), e.then(function (e) {
        return ot(), e;
      }, function (e) {
        return ot(), yt(e);
      })) : e;
    }function at(e) {
      ++tt, Qe.echoes && 0 != --Qe.echoes || (Qe.echoes = Qe.id = 0), Ze.push(Be), ct(e, !0);
    }function ut() {
      var e = Ze[Ze.length - 1];Ze.pop(), ct(e, !1);
    }function ct(e, t) {
      var n,
          r = Be;if ((t ? !Qe.echoes || et++ && e === Be : !et || --et && e === Be) || (n = t ? at.bind(null, e) : ut, be.call(ve, n)), e !== Be && (Be = e, r === Ie && (Ie.env = lt()), _e)) {
        var i = Ie.env.Promise,
            o = e.env;ge.then = o.nthen, i.prototype.then = o.gthen, (r.global || e.global) && (Object.defineProperty(a, "Promise", o.PromiseProp), i.all = o.all, i.race = o.race, i.resolve = o.resolve, i.reject = o.reject, o.allSettled && (i.allSettled = o.allSettled), o.any && (i.any = o.any));
      }
    }function lt() {
      var e = a.Promise;return _e ? { Promise: e, PromiseProp: Object.getOwnPropertyDescriptor(a, "Promise"), all: e.all, race: e.race, allSettled: e.allSettled, any: e.any, resolve: e.resolve, reject: e.reject, nthen: ge.then, gthen: e.prototype.then } : {};
    }function ft(e, t, n, r, i) {
      var o = Be;try {
        return ct(e, !0), t(n, r, i);
      } finally {
        ct(o, !1);
      }
    }function ht(e, t, n) {
      return "function" != typeof e ? e : function () {
        var r = Be;n && it(), ct(t, !0);try {
          return e.apply(this, arguments);
        } finally {
          ct(r, !1);
        }
      };
    }function dt(e, t) {
      return function (n, r) {
        return e.call(this, ht(n, t, !1), ht(r, t, !1));
      };
    }-1 === ("" + be).indexOf("[native code]") && (it = ot = oe);function pt(e, t) {
      var n;try {
        n = t.onuncatched(e);
      } catch (e) {}if (!1 !== n) try {
        var r,
            i = { promise: t, reason: e };if (a.document && document.createEvent ? ((r = document.createEvent("Event")).initEvent("unhandledrejection", !0, !0), u(r, i)) : a.CustomEvent && u(r = new CustomEvent("unhandledrejection", { detail: i }), i), r && a.dispatchEvent && (dispatchEvent(r), !a.PromiseRejectionEvent && a.onunhandledrejection)) try {
          a.onunhandledrejection(r);
        } catch (e) {}K && r && !r.defaultPrevented && console.warn("Unhandled rejection: " + (e.stack || e));
      } catch (e) {}
    }var yt = De.reject;var vt = String.fromCharCode(65535),
        gt = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.",
        mt = [],
        bt = "undefined" != typeof navigator && /(MSIE|Trident|Edge)/.test(navigator.userAgent),
        wt = bt,
        _t = bt,
        Et = function Et(e) {
      return !/(dexie\.js|dexie\.min\.js)/.test(e);
    };function St(e, t) {
      return e ? t ? function () {
        return e.apply(this, arguments) && t.apply(this, arguments);
      } : e : t;
    }var kt = { type: 3, lower: -1 / 0, lowerOpen: !1, upper: [[]], upperOpen: !1 },
        xt = function () {
      function e() {}return e.prototype._trans = function (e, t, n) {
        var r = this._tx || Be.trans,
            i = this.name;function o(e, n, r) {
          if (!r.schema[i]) throw new ne.NotFound("Table " + i + " not part of transaction");return t(r.idbtrans, r);
        }var s = Ve();try {
          return r && r.db === this.db ? r === Be.trans ? r._promise(e, o, n) : rt(function () {
            return r._promise(e, o, n);
          }, { trans: r, transless: Be.transless || Be }) : function e(t, n, r, i) {
            if (t._state.openComplete || Be.letThrough) {
              var o = t._createTransaction(n, r, t._dbSchema);try {
                o.create();
              } catch (e) {
                return yt(e);
              }return o._promise(n, function (e, t) {
                return rt(function () {
                  return Be.trans = o, i(e, t, o);
                });
              }).then(function (e) {
                return o._completion.then(function () {
                  return e;
                });
              });
            }if (!t._state.isBeingOpened) {
              if (!t._options.autoOpen) return yt(new ne.DatabaseClosed());t.open().catch(oe);
            }return t._state.dbReadyPromise.then(function () {
              return e(t, n, r, i);
            });
          }(this.db, e, [this.name], o);
        } finally {
          s && Xe();
        }
      }, e.prototype.get = function (e, t) {
        var n = this;return e && e.constructor === Object ? this.where(e).first(t) : this._trans("readonly", function (t) {
          return n.core.get({ trans: t, key: e }).then(function (e) {
            return n.hook.reading.fire(e);
          });
        }).then(t);
      }, e.prototype.where = function (e) {
        if ("string" == typeof e) return new this.db.WhereClause(this, e);if (s(e)) return new this.db.WhereClause(this, "[" + e.join("+") + "]");var t = o(e);if (1 === t.length) return this.where(t[0]).equals(e[t[0]]);var n = this.schema.indexes.concat(this.schema.primKey).filter(function (e) {
          return e.compound && t.every(function (t) {
            return e.keyPath.indexOf(t) >= 0;
          }) && e.keyPath.every(function (e) {
            return t.indexOf(e) >= 0;
          });
        })[0];if (n && this.db._maxKey !== vt) return this.where(n.name).equals(n.keyPath.map(function (t) {
          return e[t];
        }));!n && K && console.warn("The query " + JSON.stringify(e) + " on " + this.name + " would benefit of a compound index [" + t.join("+") + "]");var r = this.schema.idxByName,
            i = this.db._deps.indexedDB;function a(e, t) {
          try {
            return 0 === i.cmp(e, t);
          } catch (e) {
            return !1;
          }
        }var u = t.reduce(function (t, n) {
          var i = t[0],
              o = t[1],
              u = r[n],
              c = e[n];return [i || u, i || !u ? St(o, u && u.multi ? function (e) {
            var t = S(e, n);return s(t) && t.some(function (e) {
              return a(c, e);
            });
          } : function (e) {
            return a(c, S(e, n));
          }) : o];
        }, [null, null]),
            c = u[0],
            l = u[1];return c ? this.where(c.name).equals(e[c.keyPath]).filter(l) : n ? this.filter(l) : this.where(t).equals("");
      }, e.prototype.filter = function (e) {
        return this.toCollection().and(e);
      }, e.prototype.count = function (e) {
        return this.toCollection().count(e);
      }, e.prototype.offset = function (e) {
        return this.toCollection().offset(e);
      }, e.prototype.limit = function (e) {
        return this.toCollection().limit(e);
      }, e.prototype.each = function (e) {
        return this.toCollection().each(e);
      }, e.prototype.toArray = function (e) {
        return this.toCollection().toArray(e);
      }, e.prototype.toCollection = function () {
        return new this.db.Collection(new this.db.WhereClause(this));
      }, e.prototype.orderBy = function (e) {
        return new this.db.Collection(new this.db.WhereClause(this, s(e) ? "[" + e.join("+") + "]" : e));
      }, e.prototype.reverse = function () {
        return this.toCollection().reverse();
      }, e.prototype.mapToClass = function (e) {
        this.schema.mappedClass = e;var t = function t(_t2) {
          if (!_t2) return _t2;var n = Object.create(e.prototype);for (var r in _t2) {
            if (f(_t2, r)) try {
              n[r] = _t2[r];
            } catch (e) {}
          }return n;
        };return this.schema.readHook && this.hook.reading.unsubscribe(this.schema.readHook), this.schema.readHook = t, this.hook("reading", t), e;
      }, e.prototype.defineClass = function () {
        return this.mapToClass(function (e) {
          u(this, e);
        });
      }, e.prototype.add = function (e, t) {
        var n = this;return this._trans("readwrite", function (r) {
          return n.core.mutate({ trans: r, type: "add", keys: null != t ? [t] : null, values: [e] });
        }).then(function (e) {
          return e.numFailures ? De.reject(e.failures[0]) : e.lastResult;
        }).then(function (t) {
          if (!n.core.schema.primaryKey.outbound) try {
            k(e, n.core.schema.primaryKey.keyPath, t);
          } catch (e) {}return t;
        });
      }, e.prototype.update = function (e, t) {
        if ("object" != typeof t || s(t)) throw new ne.InvalidArgument("Modifications must be an object.");if ("object" != typeof e || s(e)) return this.where(":id").equals(e).modify(t);o(t).forEach(function (n) {
          k(e, n, t[n]);
        });var n = S(e, this.schema.primKey.keyPath);return void 0 === n ? yt(new ne.InvalidArgument("Given object does not contain its primary key")) : this.where(":id").equals(n).modify(t);
      }, e.prototype.put = function (e, t) {
        var n = this;return this._trans("readwrite", function (r) {
          return n.core.mutate({ trans: r, type: "put", values: [e], keys: null != t ? [t] : null });
        }).then(function (e) {
          return e.numFailures ? De.reject(e.failures[0]) : e.lastResult;
        }).then(function (t) {
          if (!n.core.schema.primaryKey.outbound) try {
            k(e, n.core.schema.primaryKey.keyPath, t);
          } catch (e) {}return t;
        });
      }, e.prototype.delete = function (e) {
        var t = this;return this._trans("readwrite", function (n) {
          return t.core.mutate({ trans: n, type: "delete", keys: [e] });
        }).then(function (e) {
          return e.numFailures ? De.reject(e.failures[0]) : void 0;
        });
      }, e.prototype.clear = function () {
        var e = this;return this._trans("readwrite", function (t) {
          return e.core.mutate({ trans: t, type: "deleteRange", range: kt });
        }).then(function (e) {
          return e.numFailures ? De.reject(e.failures[0]) : void 0;
        });
      }, e.prototype.bulkGet = function (e) {
        var t = this;return this._trans("readonly", function (n) {
          return t.core.getMany({ keys: e, trans: n });
        });
      }, e.prototype.bulkAdd = function (e, t, n) {
        var r = this,
            i = Array.isArray(t) ? t : void 0,
            o = (n = n || (i ? void 0 : t)) ? n.allKeys : void 0;return this._trans("readwrite", function (t) {
          if (!r.core.schema.primaryKey.outbound && i) throw new ne.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");if (i && i.length !== e.length) throw new ne.InvalidArgument("Arguments objects and keys must have the same length");var n = e.length;return r.core.mutate({ trans: t, type: "add", keys: i, values: e, wantResults: o }).then(function (e) {
            var t = e.numFailures,
                i = e.results,
                s = e.lastResult,
                a = e.failures;if (0 === t) return o ? i : s;throw new Z(r.name + ".bulkAdd(): " + t + " of " + n + " operations failed", Object.keys(a).map(function (e) {
              return a[e];
            }));
          });
        });
      }, e.prototype.bulkPut = function (e, t, n) {
        var r = this,
            i = Array.isArray(t) ? t : void 0,
            o = (n = n || (i ? void 0 : t)) ? n.allKeys : void 0;return this._trans("readwrite", function (t) {
          if (!r.core.schema.primaryKey.outbound && i) throw new ne.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");if (i && i.length !== e.length) throw new ne.InvalidArgument("Arguments objects and keys must have the same length");var n = e.length;return r.core.mutate({ trans: t, type: "put", keys: i, values: e, wantResults: o }).then(function (e) {
            var t = e.numFailures,
                i = e.results,
                s = e.lastResult,
                a = e.failures;if (0 === t) return o ? i : s;throw new Z(r.name + ".bulkPut(): " + t + " of " + n + " operations failed", Object.keys(a).map(function (e) {
              return a[e];
            }));
          });
        });
      }, e.prototype.bulkDelete = function (e) {
        var t = this,
            n = e.length;return this._trans("readwrite", function (n) {
          return t.core.mutate({ trans: n, type: "delete", keys: e });
        }).then(function (e) {
          var r = e.numFailures,
              i = e.lastResult,
              o = e.failures;if (0 === r) return i;throw new Z(t.name + ".bulkDelete(): " + r + " of " + n + " operations failed", o);
        });
      }, e;
    }();function Ot(e) {
      var t = {},
          n = function n(_n2, r) {
        if (r) {
          for (var i = arguments.length, o = new Array(i - 1); --i;) {
            o[i - 1] = arguments[i];
          }return t[_n2].subscribe.apply(null, o), e;
        }if ("string" == typeof _n2) return t[_n2];
      };n.addEventType = a;for (var r = 1, i = arguments.length; r < i; ++r) {
        a(arguments[r]);
      }return n;function a(e, r, i) {
        if ("object" == typeof e) return u(e);r || (r = he), i || (i = oe);var o = { subscribers: [], fire: i, subscribe: function subscribe(e) {
            -1 === o.subscribers.indexOf(e) && (o.subscribers.push(e), o.fire = r(o.fire, e));
          }, unsubscribe: function unsubscribe(e) {
            o.subscribers = o.subscribers.filter(function (t) {
              return t !== e;
            }), o.fire = o.subscribers.reduce(r, i);
          } };return t[e] = n[e] = o, o;
      }function u(e) {
        o(e).forEach(function (t) {
          var n = e[t];if (s(n)) a(t, e[t][0], e[t][1]);else {
            if ("asap" !== n) throw new ne.InvalidArgument("Invalid event config");var r = a(t, se, function () {
              for (var e = arguments.length, t = new Array(e); e--;) {
                t[e] = arguments[e];
              }r.subscribers.forEach(function (e) {
                _(function () {
                  e.apply(null, t);
                });
              });
            });
          }
        });
      }
    }function At(e, t) {
      return y(t).from({ prototype: e }), t;
    }function Pt(e, t) {
      return !(e.filter || e.algorithm || e.or) && (t ? e.justLimit : !e.replayFilter);
    }function Tt(e, t) {
      e.filter = St(e.filter, t);
    }function Mt(e, t, n) {
      var r = e.replayFilter;e.replayFilter = r ? function () {
        return St(r(), t());
      } : t, e.justLimit = n && !r;
    }function It(e, t) {
      if (e.isPrimKey) return t.primaryKey;var n = t.getIndexByKeyPath(e.index);if (!n) throw new ne.Schema("KeyPath " + e.index + " on object store " + t.name + " is not indexed");return n;
    }function Bt(e, t, n) {
      var r = It(e, t.schema);return t.openCursor({ trans: n, values: !e.keysOnly, reverse: "prev" === e.dir, unique: !!e.unique, query: { index: r, range: e.range } });
    }function Rt(e, t, n, r) {
      var i = e.replayFilter ? St(e.filter, e.replayFilter()) : e.filter;if (e.or) {
        var o = {},
            s = function s(e, n, r) {
          if (!i || i(n, r, function (e) {
            return n.stop(e);
          }, function (e) {
            return n.fail(e);
          })) {
            var s = n.primaryKey,
                a = "" + s;"[object ArrayBuffer]" === a && (a = "" + new Uint8Array(s)), f(o, a) || (o[a] = !0, t(e, n, r));
          }
        };return Promise.all([e.or._iterate(s, n), Ct(Bt(e, r, n), e.algorithm, s, !e.keysOnly && e.valueMapper)]);
      }return Ct(Bt(e, r, n), St(e.algorithm, i), t, !e.keysOnly && e.valueMapper);
    }function Ct(e, t, n, r) {
      var i = Ge(r ? function (e, t, i) {
        return n(r(e), t, i);
      } : n);return e.then(function (e) {
        if (e) return e.start(function () {
          var n = function n() {
            return e.continue();
          };t && !t(e, function (e) {
            return n = e;
          }, function (t) {
            e.stop(t), n = oe;
          }, function (t) {
            e.fail(t), n = oe;
          }) || i(e.value, e, function (e) {
            return n = e;
          }), n();
        });
      });
    }var jt = function () {
      function e() {}return e.prototype._read = function (e, t) {
        var n = this._ctx;return n.error ? n.table._trans(null, yt.bind(null, n.error)) : n.table._trans("readonly", e).then(t);
      }, e.prototype._write = function (e) {
        var t = this._ctx;return t.error ? t.table._trans(null, yt.bind(null, t.error)) : t.table._trans("readwrite", e, "locked");
      }, e.prototype._addAlgorithm = function (e) {
        var t = this._ctx;t.algorithm = St(t.algorithm, e);
      }, e.prototype._iterate = function (e, t) {
        return Rt(this._ctx, e, t, this._ctx.table.core);
      }, e.prototype.clone = function (e) {
        var t = Object.create(this.constructor.prototype),
            n = Object.create(this._ctx);return e && u(n, e), t._ctx = n, t;
      }, e.prototype.raw = function () {
        return this._ctx.valueMapper = null, this;
      }, e.prototype.each = function (e) {
        var t = this._ctx;return this._read(function (n) {
          return Rt(t, e, n, t.table.core);
        });
      }, e.prototype.count = function (e) {
        var t = this;return this._read(function (e) {
          var n = t._ctx,
              r = n.table.core;if (Pt(n, !0)) return r.count({ trans: e, query: { index: It(n, r.schema), range: n.range } }).then(function (e) {
            return Math.min(e, n.limit);
          });var i = 0;return Rt(n, function () {
            return ++i, !1;
          }, e, r).then(function () {
            return i;
          });
        }).then(e);
      }, e.prototype.sortBy = function (e, t) {
        var n = e.split(".").reverse(),
            r = n[0],
            i = n.length - 1;function o(e, t) {
          return t ? o(e[n[t]], t - 1) : e[r];
        }var s = "next" === this._ctx.dir ? 1 : -1;function a(e, t) {
          var n = o(e, i),
              r = o(t, i);return n < r ? -s : n > r ? s : 0;
        }return this.toArray(function (e) {
          return e.sort(a);
        }).then(t);
      }, e.prototype.toArray = function (e) {
        var t = this;return this._read(function (e) {
          var n = t._ctx;if ("next" === n.dir && Pt(n, !0) && n.limit > 0) {
            var r = n.valueMapper,
                i = It(n, n.table.core.schema);return n.table.core.query({ trans: e, limit: n.limit, values: !0, query: { index: i, range: n.range } }).then(function (e) {
              var t = e.result;return r ? t.map(r) : t;
            });
          }var o = [];return Rt(n, function (e) {
            return o.push(e);
          }, e, n.table.core).then(function () {
            return o;
          });
        }, e);
      }, e.prototype.offset = function (e) {
        var t = this._ctx;return e <= 0 || (t.offset += e, Pt(t) ? Mt(t, function () {
          var t = e;return function (e, n) {
            return 0 === t || (1 === t ? (--t, !1) : (n(function () {
              e.advance(t), t = 0;
            }), !1));
          };
        }) : Mt(t, function () {
          var t = e;return function () {
            return --t < 0;
          };
        })), this;
      }, e.prototype.limit = function (e) {
        return this._ctx.limit = Math.min(this._ctx.limit, e), Mt(this._ctx, function () {
          var t = e;return function (e, n, r) {
            return --t <= 0 && n(r), t >= 0;
          };
        }, !0), this;
      }, e.prototype.until = function (e, t) {
        return Tt(this._ctx, function (n, r, i) {
          return !e(n.value) || (r(i), t);
        }), this;
      }, e.prototype.first = function (e) {
        return this.limit(1).toArray(function (e) {
          return e[0];
        }).then(e);
      }, e.prototype.last = function (e) {
        return this.reverse().first(e);
      }, e.prototype.filter = function (e) {
        var t, n;return Tt(this._ctx, function (t) {
          return e(t.value);
        }), t = this._ctx, n = e, t.isMatch = St(t.isMatch, n), this;
      }, e.prototype.and = function (e) {
        return this.filter(e);
      }, e.prototype.or = function (e) {
        return new this.db.WhereClause(this._ctx.table, e, this);
      }, e.prototype.reverse = function () {
        return this._ctx.dir = "prev" === this._ctx.dir ? "next" : "prev", this._ondirectionchange && this._ondirectionchange(this._ctx.dir), this;
      }, e.prototype.desc = function () {
        return this.reverse();
      }, e.prototype.eachKey = function (e) {
        var t = this._ctx;return t.keysOnly = !t.isMatch, this.each(function (t, n) {
          e(n.key, n);
        });
      }, e.prototype.eachUniqueKey = function (e) {
        return this._ctx.unique = "unique", this.eachKey(e);
      }, e.prototype.eachPrimaryKey = function (e) {
        var t = this._ctx;return t.keysOnly = !t.isMatch, this.each(function (t, n) {
          e(n.primaryKey, n);
        });
      }, e.prototype.keys = function (e) {
        var t = this._ctx;t.keysOnly = !t.isMatch;var n = [];return this.each(function (e, t) {
          n.push(t.key);
        }).then(function () {
          return n;
        }).then(e);
      }, e.prototype.primaryKeys = function (e) {
        var t = this._ctx;if ("next" === t.dir && Pt(t, !0) && t.limit > 0) return this._read(function (e) {
          var n = It(t, t.table.core.schema);return t.table.core.query({ trans: e, values: !1, limit: t.limit, query: { index: n, range: t.range } });
        }).then(function (e) {
          return e.result;
        }).then(e);t.keysOnly = !t.isMatch;var n = [];return this.each(function (e, t) {
          n.push(t.primaryKey);
        }).then(function () {
          return n;
        }).then(e);
      }, e.prototype.uniqueKeys = function (e) {
        return this._ctx.unique = "unique", this.keys(e);
      }, e.prototype.firstKey = function (e) {
        return this.limit(1).keys(function (e) {
          return e[0];
        }).then(e);
      }, e.prototype.lastKey = function (e) {
        return this.reverse().firstKey(e);
      }, e.prototype.distinct = function () {
        var e = this._ctx,
            t = e.index && e.table.schema.idxByName[e.index];if (!t || !t.multi) return this;var n = {};return Tt(this._ctx, function (e) {
          var t = e.primaryKey.toString(),
              r = f(n, t);return n[t] = !0, !r;
        }), this;
      }, e.prototype.modify = function (e) {
        var t = this,
            n = this._ctx;return this._write(function (r) {
          var i;if ("function" == typeof e) i = e;else {
            var s = o(e),
                a = s.length;i = function i(t) {
              for (var n = !1, r = 0; r < a; ++r) {
                var i = s[r],
                    o = e[i];S(t, i) !== o && (k(t, i, o), n = !0);
              }return n;
            };
          }var u = n.table.core,
              c = u.schema.primaryKey,
              l = c.outbound,
              f = c.extractKey,
              h = "testmode" in On ? 1 : 2e3,
              d = t.db.core.cmp,
              p = [],
              y = 0,
              v = [],
              g = function g(e, t) {
            var n = t.failures,
                r = t.numFailures;y += e - r;for (var i = 0, s = o(n); i < s.length; i++) {
              var a = s[i];p.push(n[a]);
            }
          };return t.clone().primaryKeys().then(function (e) {
            var t = function t(n) {
              var o = Math.min(h, e.length - n);return u.getMany({ trans: r, keys: e.slice(n, n + o) }).then(function (s) {
                for (var a = [], c = [], p = l ? [] : null, y = [], v = 0; v < o; ++v) {
                  var m = s[v],
                      b = { value: I(m), primKey: e[n + v] };!1 !== i.call(b, b.value, b) && (null == b.value ? y.push(e[n + v]) : l || 0 === d(f(m), f(b.value)) ? (c.push(b.value), l && p.push(e[n + v])) : (y.push(e[n + v]), a.push(b.value)));
                }return Promise.resolve(a.length > 0 && u.mutate({ trans: r, type: "add", values: a }).then(function (e) {
                  for (var t in e.failures) {
                    y.splice(parseInt(t), 1);
                  }g(a.length, e);
                })).then(function (e) {
                  return c.length > 0 && u.mutate({ trans: r, type: "put", keys: p, values: c }).then(function (e) {
                    return g(c.length, e);
                  });
                }).then(function () {
                  return y.length > 0 && u.mutate({ trans: r, type: "delete", keys: y }).then(function (e) {
                    return g(y.length, e);
                  });
                }).then(function () {
                  return e.length > n + o && t(n + h);
                });
              });
            };return t(0).then(function () {
              if (p.length > 0) throw new $("Error modifying one or more objects", p, y, v);return e.length;
            });
          });
        });
      }, e.prototype.delete = function () {
        var e = this._ctx,
            t = e.range;return Pt(e) && (e.isPrimKey && !_t || 3 === t.type) ? this._write(function (n) {
          var r = e.table.core.schema.primaryKey,
              i = t;return e.table.core.count({ trans: n, query: { index: r, range: i } }).then(function (t) {
            return e.table.core.mutate({ trans: n, type: "deleteRange", range: i }).then(function (e) {
              var n = e.failures,
                  r = (e.lastResult, e.results, e.numFailures);if (r) throw new $("Could not delete some values", Object.keys(n).map(function (e) {
                return n[e];
              }), t - r);return t - r;
            });
          });
        }) : this.modify(function (e, t) {
          return t.value = null;
        });
      }, e;
    }();function Dt(e, t) {
      return e < t ? -1 : e === t ? 0 : 1;
    }function Ft(e, t) {
      return e > t ? -1 : e === t ? 0 : 1;
    }function Lt(e, t, n) {
      var r = e instanceof zt ? new e.Collection(e) : e;return r._ctx.error = n ? new n(t) : new TypeError(t), r;
    }function Ut(e) {
      return new e.Collection(e, function () {
        return qt("");
      }).limit(0);
    }function Nt(e, t, n, r, i, o) {
      for (var s = Math.min(e.length, r.length), a = -1, u = 0; u < s; ++u) {
        var c = t[u];if (c !== r[u]) return i(e[u], n[u]) < 0 ? e.substr(0, u) + n[u] + n.substr(u + 1) : i(e[u], r[u]) < 0 ? e.substr(0, u) + r[u] + n.substr(u + 1) : a >= 0 ? e.substr(0, a) + t[a] + n.substr(a + 1) : null;i(e[u], c) < 0 && (a = u);
      }return s < r.length && "next" === o ? e + n.substr(e.length) : s < e.length && "prev" === o ? e.substr(0, n.length) : a < 0 ? null : e.substr(0, a) + r[a] + n.substr(a + 1);
    }function Kt(e, t, n, r) {
      var i,
          o,
          s,
          a,
          u,
          c,
          l,
          f = n.length;if (!n.every(function (e) {
        return "string" == typeof e;
      })) return Lt(e, "String expected.");function h(e) {
        i = function (e) {
          return "next" === e ? function (e) {
            return e.toUpperCase();
          } : function (e) {
            return e.toLowerCase();
          };
        }(e), o = function (e) {
          return "next" === e ? function (e) {
            return e.toLowerCase();
          } : function (e) {
            return e.toUpperCase();
          };
        }(e), s = "next" === e ? Dt : Ft;var t = n.map(function (e) {
          return { lower: o(e), upper: i(e) };
        }).sort(function (e, t) {
          return s(e.lower, t.lower);
        });a = t.map(function (e) {
          return e.upper;
        }), u = t.map(function (e) {
          return e.lower;
        }), c = e, l = "next" === e ? "" : r;
      }h("next");var d = new e.Collection(e, function () {
        return Ht(a[0], u[f - 1] + r);
      });d._ondirectionchange = function (e) {
        h(e);
      };var p = 0;return d._addAlgorithm(function (e, n, r) {
        var i = e.key;if ("string" != typeof i) return !1;var h = o(i);if (t(h, u, p)) return !0;for (var d = null, y = p; y < f; ++y) {
          var v = Nt(i, h, a[y], u[y], s, c);null === v && null === d ? p = y + 1 : (null === d || s(d, v) > 0) && (d = v);
        }return n(null !== d ? function () {
          e.continue(d + l);
        } : r), !1;
      }), d;
    }function Ht(e, t, n, r) {
      return { type: 2, lower: e, upper: t, lowerOpen: n, upperOpen: r };
    }function qt(e) {
      return { type: 1, lower: e, upper: e };
    }var zt = function () {
      function e() {}return Object.defineProperty(e.prototype, "Collection", { get: function get() {
          return this._ctx.table.db.Collection;
        }, enumerable: !0, configurable: !0 }), e.prototype.between = function (e, t, n, r) {
        n = !1 !== n, r = !0 === r;try {
          return this._cmp(e, t) > 0 || 0 === this._cmp(e, t) && (n || r) && (!n || !r) ? Ut(this) : new this.Collection(this, function () {
            return Ht(e, t, !n, !r);
          });
        } catch (e) {
          return Lt(this, gt);
        }
      }, e.prototype.equals = function (e) {
        return new this.Collection(this, function () {
          return qt(e);
        });
      }, e.prototype.above = function (e) {
        return null == e ? Lt(this, gt) : new this.Collection(this, function () {
          return Ht(e, void 0, !0);
        });
      }, e.prototype.aboveOrEqual = function (e) {
        return null == e ? Lt(this, gt) : new this.Collection(this, function () {
          return Ht(e, void 0, !1);
        });
      }, e.prototype.below = function (e) {
        return null == e ? Lt(this, gt) : new this.Collection(this, function () {
          return Ht(void 0, e, !1, !0);
        });
      }, e.prototype.belowOrEqual = function (e) {
        return null == e ? Lt(this, gt) : new this.Collection(this, function () {
          return Ht(void 0, e);
        });
      }, e.prototype.startsWith = function (e) {
        return "string" != typeof e ? Lt(this, "String expected.") : this.between(e, e + vt, !0, !0);
      }, e.prototype.startsWithIgnoreCase = function (e) {
        return "" === e ? this.startsWith(e) : Kt(this, function (e, t) {
          return 0 === e.indexOf(t[0]);
        }, [e], vt);
      }, e.prototype.equalsIgnoreCase = function (e) {
        return Kt(this, function (e, t) {
          return e === t[0];
        }, [e], "");
      }, e.prototype.anyOfIgnoreCase = function () {
        var e = U.apply(L, arguments);return 0 === e.length ? Ut(this) : Kt(this, function (e, t) {
          return -1 !== t.indexOf(e);
        }, e, "");
      }, e.prototype.startsWithAnyOfIgnoreCase = function () {
        var e = U.apply(L, arguments);return 0 === e.length ? Ut(this) : Kt(this, function (e, t) {
          return t.some(function (t) {
            return 0 === e.indexOf(t);
          });
        }, e, vt);
      }, e.prototype.anyOf = function () {
        var e = this,
            t = U.apply(L, arguments),
            n = this._cmp;try {
          t.sort(n);
        } catch (e) {
          return Lt(this, gt);
        }if (0 === t.length) return Ut(this);var r = new this.Collection(this, function () {
          return Ht(t[0], t[t.length - 1]);
        });r._ondirectionchange = function (r) {
          n = "next" === r ? e._ascending : e._descending, t.sort(n);
        };var i = 0;return r._addAlgorithm(function (e, r, o) {
          for (var s = e.key; n(s, t[i]) > 0;) {
            if (++i === t.length) return r(o), !1;
          }return 0 === n(s, t[i]) || (r(function () {
            e.continue(t[i]);
          }), !1);
        }), r;
      }, e.prototype.notEqual = function (e) {
        return this.inAnyRange([[-1 / 0, e], [e, this.db._maxKey]], { includeLowers: !1, includeUppers: !1 });
      }, e.prototype.noneOf = function () {
        var e = U.apply(L, arguments);if (0 === e.length) return new this.Collection(this);try {
          e.sort(this._ascending);
        } catch (e) {
          return Lt(this, gt);
        }var t = e.reduce(function (e, t) {
          return e ? e.concat([[e[e.length - 1][1], t]]) : [[-1 / 0, t]];
        }, null);return t.push([e[e.length - 1], this.db._maxKey]), this.inAnyRange(t, { includeLowers: !1, includeUppers: !1 });
      }, e.prototype.inAnyRange = function (e, t) {
        var n = this,
            r = this._cmp,
            i = this._ascending,
            o = this._descending,
            s = this._min,
            a = this._max;if (0 === e.length) return Ut(this);if (!e.every(function (e) {
          return void 0 !== e[0] && void 0 !== e[1] && i(e[0], e[1]) <= 0;
        })) return Lt(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", ne.InvalidArgument);var u = !t || !1 !== t.includeLowers,
            c = t && !0 === t.includeUppers;var l,
            f = i;function h(e, t) {
          return f(e[0], t[0]);
        }try {
          (l = e.reduce(function (e, t) {
            for (var n = 0, i = e.length; n < i; ++n) {
              var o = e[n];if (r(t[0], o[1]) < 0 && r(t[1], o[0]) > 0) {
                o[0] = s(o[0], t[0]), o[1] = a(o[1], t[1]);break;
              }
            }return n === i && e.push(t), e;
          }, [])).sort(h);
        } catch (e) {
          return Lt(this, gt);
        }var d = 0,
            p = c ? function (e) {
          return i(e, l[d][1]) > 0;
        } : function (e) {
          return i(e, l[d][1]) >= 0;
        },
            y = u ? function (e) {
          return o(e, l[d][0]) > 0;
        } : function (e) {
          return o(e, l[d][0]) >= 0;
        };var v = p,
            g = new this.Collection(this, function () {
          return Ht(l[0][0], l[l.length - 1][1], !u, !c);
        });return g._ondirectionchange = function (e) {
          "next" === e ? (v = p, f = i) : (v = y, f = o), l.sort(h);
        }, g._addAlgorithm(function (e, t, r) {
          for (var o = e.key; v(o);) {
            if (++d === l.length) return t(r), !1;
          }return !!function (e) {
            return !p(e) && !y(e);
          }(o) || (0 === n._cmp(o, l[d][1]) || 0 === n._cmp(o, l[d][0]) || t(function () {
            f === i ? e.continue(l[d][0]) : e.continue(l[d][1]);
          }), !1);
        }), g;
      }, e.prototype.startsWithAnyOf = function () {
        var e = U.apply(L, arguments);return e.every(function (e) {
          return "string" == typeof e;
        }) ? 0 === e.length ? Ut(this) : this.inAnyRange(e.map(function (e) {
          return [e, e + vt];
        })) : Lt(this, "startsWithAnyOf() only works with strings");
      }, e;
    }();function Wt(e) {
      return 1 === e.length ? e[0] : e;
    }function Vt(e) {
      try {
        return e.only([[]]), [[]];
      } catch (e) {
        return vt;
      }
    }function Xt(e) {
      return Ge(function (t) {
        return Yt(t), e(t.target.error), !1;
      });
    }function Yt(e) {
      e.stopPropagation && e.stopPropagation(), e.preventDefault && e.preventDefault();
    }var Jt = function () {
      function e() {}return e.prototype._lock = function () {
        return w(!Be.global), ++this._reculock, 1 !== this._reculock || Be.global || (Be.lockOwnerFor = this), this;
      }, e.prototype._unlock = function () {
        if (w(!Be.global), 0 == --this._reculock) for (Be.global || (Be.lockOwnerFor = null); this._blockedFuncs.length > 0 && !this._locked();) {
          var e = this._blockedFuncs.shift();try {
            ft(e[1], e[0]);
          } catch (e) {}
        }return this;
      }, e.prototype._locked = function () {
        return this._reculock && Be.lockOwnerFor !== this;
      }, e.prototype.create = function (e) {
        var t = this;if (!this.mode) return this;var n = this.db.idbdb,
            r = this.db._state.dbOpenError;if (w(!this.idbtrans), !e && !n) switch (r && r.name) {case "DatabaseClosedError":
            throw new ne.DatabaseClosed(r);case "MissingAPIError":
            throw new ne.MissingAPI(r.message, r);default:
            throw new ne.OpenFailed(r);}if (!this.active) throw new ne.TransactionInactive();return w(null === this._completion._state), (e = this.idbtrans = e || n.transaction(Wt(this.storeNames), this.mode)).onerror = Ge(function (n) {
          Yt(n), t._reject(e.error);
        }), e.onabort = Ge(function (n) {
          Yt(n), t.active && t._reject(new ne.Abort(e.error)), t.active = !1, t.on("abort").fire(n);
        }), e.oncomplete = Ge(function () {
          t.active = !1, t._resolve();
        }), this;
      }, e.prototype._promise = function (e, t, n) {
        var r = this;if ("readwrite" === e && "readwrite" !== this.mode) return yt(new ne.ReadOnly("Transaction is readonly"));if (!this.active) return yt(new ne.TransactionInactive());if (this._locked()) return new De(function (i, o) {
          r._blockedFuncs.push([function () {
            r._promise(e, t, n).then(i, o);
          }, Be]);
        });if (n) return rt(function () {
          var e = new De(function (e, n) {
            r._lock();var i = t(e, n, r);i && i.then && i.then(e, n);
          });return e.finally(function () {
            return r._unlock();
          }), e._lib = !0, e;
        });var i = new De(function (e, n) {
          var i = t(e, n, r);i && i.then && i.then(e, n);
        });return i._lib = !0, i;
      }, e.prototype._root = function () {
        return this.parent ? this.parent._root() : this;
      }, e.prototype.waitFor = function (e) {
        var t = this._root(),
            n = De.resolve(e);if (t._waitingFor) t._waitingFor = t._waitingFor.then(function () {
          return n;
        });else {
          t._waitingFor = n, t._waitingQueue = [];var r = t.idbtrans.objectStore(t.storeNames[0]);!function e() {
            for (++t._spinCount; t._waitingQueue.length;) {
              t._waitingQueue.shift()();
            }t._waitingFor && (r.get(-1 / 0).onsuccess = e);
          }();
        }var i = t._waitingFor;return new De(function (e, r) {
          n.then(function (n) {
            return t._waitingQueue.push(Ge(e.bind(null, n)));
          }, function (e) {
            return t._waitingQueue.push(Ge(r.bind(null, e)));
          }).finally(function () {
            t._waitingFor === i && (t._waitingFor = null);
          });
        });
      }, e.prototype.abort = function () {
        this.active && this._reject(new ne.Abort()), this.active = !1;
      }, e.prototype.table = function (e) {
        var t = this._memoizedTables || (this._memoizedTables = {});if (f(t, e)) return t[e];var n = this.schema[e];if (!n) throw new ne.NotFound("Table " + e + " not part of transaction");var r = new this.db.Table(e, n, this);return r.core = this.db.core.table(e), t[e] = r, r;
      }, e;
    }();function Gt(e, t, n, r, i, o, s) {
      return { name: e, keyPath: t, unique: n, multi: r, auto: i, compound: o, src: (n && !s ? "&" : "") + (r ? "*" : "") + (i ? "++" : "") + Qt(t) };
    }function Qt(e) {
      return "string" == typeof e ? e : e ? "[" + [].join.call(e, "+") + "]" : "";
    }function $t(e, t, n) {
      return { name: e, primKey: t, indexes: n, mappedClass: null, idxByName: E(n, function (e) {
          return [e.name, e];
        }) };
    }function Zt(e) {
      return null == e ? function () {} : "string" == typeof e ? function (e) {
        return 1 === e.split(".").length ? function (t) {
          return t[e];
        } : function (t) {
          return S(t, e);
        };
      }(e) : function (t) {
        return S(t, e);
      };
    }function en(e, t) {
      return "delete" === t.type ? t.keys : t.keys || t.values.map(e.extractKey);
    }function tn(e) {
      return [].slice.call(e);
    }var nn = 0;function rn(e) {
      return null == e ? ":id" : "string" == typeof e ? e : "[" + e.join("+") + "]";
    }function on(e, t, n, r) {
      var o = t.cmp.bind(t);function a(e) {
        if (3 === e.type) return null;if (4 === e.type) throw new Error("Cannot convert never type to IDBKeyRange");var t = e.lower,
            r = e.upper,
            i = e.lowerOpen,
            o = e.upperOpen;return void 0 === t ? void 0 === r ? null : n.upperBound(r, !!o) : void 0 === r ? n.lowerBound(t, !!i) : n.bound(t, r, !!i, !!o);
      }var u = function (e, t) {
        var n = tn(e.objectStoreNames);return { schema: { name: e.name, tables: n.map(function (e) {
              return t.objectStore(e);
            }).map(function (e) {
              var t = e.keyPath,
                  n = e.autoIncrement,
                  r = s(t),
                  i = null == t,
                  o = {},
                  a = { name: e.name, primaryKey: { name: null, isPrimaryKey: !0, outbound: i, compound: r, keyPath: t, autoIncrement: n, unique: !0, extractKey: Zt(t) }, indexes: tn(e.indexNames).map(function (t) {
                  return e.index(t);
                }).map(function (e) {
                  var t = e.name,
                      n = e.unique,
                      r = e.multiEntry,
                      i = e.keyPath,
                      a = { name: t, compound: s(i), keyPath: i, unique: n, multiEntry: r, extractKey: Zt(i) };return o[rn(i)] = a, a;
                }), getIndexByKeyPath: function getIndexByKeyPath(e) {
                  return o[rn(e)];
                } };return o[":id"] = a.primaryKey, null != t && (o[rn(t)] = a.primaryKey), a;
            }) }, hasGetAll: n.length > 0 && "getAll" in t.objectStore(n[0]) && !("undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) };
      }(e, r),
          c = u.schema,
          l = u.hasGetAll,
          f = c.tables.map(function (e) {
        return function (e) {
          var t = e.name;return { name: t, schema: e, mutate: function mutate(n) {
              var r = n.trans,
                  o = n.type,
                  s = n.keys,
                  u = n.values,
                  c = n.range,
                  l = n.wantResults;return new Promise(function (n, f) {
                n = Ge(n);var h = r.objectStore(t),
                    d = null == h.keyPath,
                    p = "put" === o || "add" === o;if (!p && "delete" !== o && "deleteRange" !== o) throw new Error("Invalid operation type: " + o);var y = (s || u || { length: 1 }).length;if (s && u && s.length !== u.length) throw new Error("Given keys array must have same length as given values array.");if (0 === y) return n({ numFailures: 0, failures: {}, results: [], lastResult: void 0 });var v,
                    g = l && i(s || en(e.primaryKey, { type: o, keys: s, values: u })),
                    m = [],
                    b = 0,
                    w = function w(e) {
                  ++b, Yt(e), g && (g[e.target._reqno] = void 0), m[e.target._reqno] = e.target.error;
                },
                    _ = function _(e) {
                  var t = e.target;g[t._reqno] = t.result;
                };if ("deleteRange" === o) {
                  if (4 === c.type) return n({ numFailures: b, failures: m, results: g, lastResult: void 0 });v = 3 === c.type ? h.clear() : h.delete(a(c));
                } else {
                  var E = p ? d ? [u, s] : [u, null] : [s, null],
                      S = E[0],
                      k = E[1];if (p) for (var x = 0; x < y; ++x) {
                    (v = k && void 0 !== k[x] ? h[o](S[x], k[x]) : h[o](S[x]))._reqno = x, g && void 0 === g[x] && (v.onsuccess = _), v.onerror = w;
                  } else for (x = 0; x < y; ++x) {
                    (v = h[o](S[x]))._reqno = x, v.onerror = w;
                  }
                }var O = function O(e) {
                  var t = e.target.result;g && (g[y - 1] = t), n({ numFailures: b, failures: m, results: g, lastResult: t });
                };v.onerror = function (e) {
                  w(e), O(e);
                }, v.onsuccess = O;
              });
            }, getMany: function getMany(e) {
              var n = e.trans,
                  r = e.keys;return new Promise(function (e, i) {
                e = Ge(e);for (var o, s = n.objectStore(t), a = r.length, u = new Array(a), c = 0, l = 0, f = function f(t) {
                  var n = t.target;null != (u[n._pos] = n.result) && 0, ++l === c && e(u);
                }, h = Xt(i), d = 0; d < a; ++d) {
                  null != r[d] && ((o = s.get(r[d]))._pos = d, o.onsuccess = f, o.onerror = h, ++c);
                }0 === c && e(u);
              });
            }, get: function get(e) {
              var n = e.trans,
                  r = e.key;return new Promise(function (e, i) {
                e = Ge(e);var o = n.objectStore(t).get(r);o.onsuccess = function (t) {
                  return e(t.target.result);
                }, o.onerror = Xt(i);
              });
            }, query: function (e) {
              return function (n) {
                return new Promise(function (r, i) {
                  r = Ge(r);var o = n.trans,
                      s = n.values,
                      u = n.limit,
                      c = n.query,
                      l = u === 1 / 0 ? void 0 : u,
                      f = c.index,
                      h = c.range,
                      d = o.objectStore(t),
                      p = f.isPrimaryKey ? d : d.index(f.name),
                      y = a(h);if (0 === u) return r({ result: [] });if (e) {
                    var v = s ? p.getAll(y, l) : p.getAllKeys(y, l);v.onsuccess = function (e) {
                      return r({ result: e.target.result });
                    }, v.onerror = Xt(i);
                  } else {
                    var g = 0,
                        m = !s && "openKeyCursor" in p ? p.openKeyCursor(y) : p.openCursor(y),
                        b = [];m.onsuccess = function (e) {
                      var t = m.result;return t ? (b.push(s ? t.value : t.primaryKey), ++g === u ? r({ result: b }) : void t.continue()) : r({ result: b });
                    }, m.onerror = Xt(i);
                  }
                });
              };
            }(l), openCursor: function openCursor(e) {
              var n = e.trans,
                  r = e.values,
                  i = e.query,
                  o = e.reverse,
                  s = e.unique;return new Promise(function (e, u) {
                e = Ge(e);var c = i.index,
                    l = i.range,
                    f = n.objectStore(t),
                    h = c.isPrimaryKey ? f : f.index(c.name),
                    d = o ? s ? "prevunique" : "prev" : s ? "nextunique" : "next",
                    p = !r && "openKeyCursor" in h ? h.openKeyCursor(a(l), d) : h.openCursor(a(l), d);p.onerror = Xt(u), p.onsuccess = Ge(function (t) {
                  var r = p.result;if (r) {
                    r.___id = ++nn, r.done = !1;var i = r.continue.bind(r),
                        o = r.continuePrimaryKey;o && (o = o.bind(r));var s = r.advance.bind(r),
                        a = function a() {
                      throw new Error("Cursor not stopped");
                    };r.trans = n, r.stop = r.continue = r.continuePrimaryKey = r.advance = function () {
                      throw new Error("Cursor not started");
                    }, r.fail = Ge(u), r.next = function () {
                      var e = this,
                          t = 1;return this.start(function () {
                        return t-- ? e.continue() : e.stop();
                      }).then(function () {
                        return e;
                      });
                    }, r.start = function (e) {
                      var t = new Promise(function (e, t) {
                        e = Ge(e), p.onerror = Xt(t), r.fail = t, r.stop = function (t) {
                          r.stop = r.continue = r.continuePrimaryKey = r.advance = a, e(t);
                        };
                      }),
                          n = function n() {
                        if (p.result) try {
                          e();
                        } catch (e) {
                          r.fail(e);
                        } else r.done = !0, r.start = function () {
                          throw new Error("Cursor behind last entry");
                        }, r.stop();
                      };return p.onsuccess = Ge(function (e) {
                        p.onsuccess = n, n();
                      }), r.continue = i, r.continuePrimaryKey = o, r.advance = s, n(), t;
                    }, e(r);
                  } else e(null);
                }, u);
              });
            }, count: function count(e) {
              var n = e.query,
                  r = e.trans,
                  i = n.index,
                  o = n.range;return new Promise(function (e, n) {
                var s = r.objectStore(t),
                    u = i.isPrimaryKey ? s : s.index(i.name),
                    c = a(o),
                    l = c ? u.count(c) : u.count();l.onsuccess = Ge(function (t) {
                  return e(t.target.result);
                }), l.onerror = Xt(n);
              });
            } };
        }(e);
      }),
          h = {};return f.forEach(function (e) {
        return h[e.name] = e;
      }), { stack: "dbcore", transaction: e.transaction.bind(e), table: function table(e) {
          if (!h[e]) throw new Error("Table '" + e + "' not found");return h[e];
        }, cmp: o, MIN_KEY: -1 / 0, MAX_KEY: Vt(n), schema: c };
    }function sn(e, t, n, i) {
      var o = n.IDBKeyRange;return { dbcore: function (e, t) {
          return t.reduce(function (e, t) {
            var n = t.create;return _r2(_r2({}, e), n(e));
          }, e);
        }(on(t, n.indexedDB, o, i), e.dbcore) };
    }function an(e, t) {
      var n = t.db,
          r = sn(e._middlewares, n, e._deps, t);e.core = r.dbcore, e.tables.forEach(function (t) {
        var n = t.name;e.core.schema.tables.some(function (e) {
          return e.name === n;
        }) && (t.core = e.core.table(n), e[n] instanceof e.Table && (e[n].core = t.core));
      });
    }function un(e, t, n, r) {
      n.forEach(function (n) {
        var i = r[n];t.forEach(function (t) {
          n in t || (t === e.Transaction.prototype || t instanceof e.Transaction ? p(t, n, { get: function get() {
              return this.table(n);
            }, set: function set(e) {
              d(this, n, { value: e, writable: !0, configurable: !0, enumerable: !0 });
            } }) : t[n] = new e.Table(n, i));
        });
      });
    }function cn(e, t) {
      t.forEach(function (t) {
        for (var n in t) {
          t[n] instanceof e.Table && delete t[n];
        }
      });
    }function ln(e, t) {
      return e._cfg.version - t._cfg.version;
    }function fn(e, t, n, r) {
      var i = e._dbSchema,
          s = e._createTransaction("readwrite", e._storeNames, i);s.create(n), s._completion.catch(r);var a = s._reject.bind(s),
          u = Be.transless || Be;rt(function () {
        Be.trans = s, Be.transless = u, 0 === t ? (o(i).forEach(function (e) {
          hn(n, e, i[e].primKey, i[e].indexes);
        }), an(e, n), De.follow(function () {
          return e.on.populate.fire(s);
        }).catch(a)) : function (e, t, n, r) {
          var i = [],
              s = e._versions,
              a = e._dbSchema = pn(e, e.idbdb, r),
              u = !1;function c() {
            return i.length ? De.resolve(i.shift()(n.idbtrans)).then(c) : De.resolve();
          }return s.filter(function (e) {
            return e._cfg.version >= t;
          }).forEach(function (s) {
            i.push(function () {
              var i = a,
                  c = s._cfg.dbschema;yn(e, i, r), yn(e, c, r), a = e._dbSchema = c;var l = function (e, t) {
                var n,
                    r = { del: [], add: [], change: [] };for (n in e) {
                  t[n] || r.del.push(n);
                }for (n in t) {
                  var i = e[n],
                      o = t[n];if (i) {
                    var s = { name: n, def: o, recreate: !1, del: [], add: [], change: [] };if (i.primKey.src === o.primKey.src || bt) {
                      var a = i.idxByName,
                          u = o.idxByName,
                          c = void 0;for (c in a) {
                        u[c] || s.del.push(c);
                      }for (c in u) {
                        var l = a[c],
                            f = u[c];l ? l.src !== f.src && s.change.push(f) : s.add.push(f);
                      }(s.del.length > 0 || s.add.length > 0 || s.change.length > 0) && r.change.push(s);
                    } else s.recreate = !0, r.change.push(s);
                  } else r.add.push([n, o]);
                }return r;
              }(i, c);l.add.forEach(function (e) {
                hn(r, e[0], e[1].primKey, e[1].indexes);
              }), l.change.forEach(function (e) {
                if (e.recreate) throw new ne.Upgrade("Not yet support for changing primary key");var t = r.objectStore(e.name);e.add.forEach(function (e) {
                  return dn(t, e);
                }), e.change.forEach(function (e) {
                  t.deleteIndex(e.name), dn(t, e);
                }), e.del.forEach(function (e) {
                  return t.deleteIndex(e);
                });
              });var f = s._cfg.contentUpgrade;if (f && s._cfg.version > t) {
                an(e, r), u = !0;var h = x(c);l.del.forEach(function (e) {
                  h[e] = i[e];
                }), cn(e, [e.Transaction.prototype]), un(e, [e.Transaction.prototype], o(h), h), n.schema = h;var d,
                    p = N(f);p && it();var y = De.follow(function () {
                  if ((d = f(n)) && p) {
                    var e = ot.bind(null, null);d.then(e, e);
                  }
                });return d && "function" == typeof d.then ? De.resolve(d) : y.then(function () {
                  return d;
                });
              }
            }), i.push(function (t) {
              u && wt || function (e, t) {
                for (var n = 0; n < t.db.objectStoreNames.length; ++n) {
                  var r = t.db.objectStoreNames[n];null == e[r] && t.db.deleteObjectStore(r);
                }
              }(s._cfg.dbschema, t);cn(e, [e.Transaction.prototype]), un(e, [e.Transaction.prototype], e._storeNames, e._dbSchema), n.schema = e._dbSchema;
            });
          }), c().then(function () {
            var e, t;t = r, o(e = a).forEach(function (n) {
              t.db.objectStoreNames.contains(n) || hn(t, n, e[n].primKey, e[n].indexes);
            });
          });
        }(e, t, s, n).catch(a);
      });
    }function hn(e, t, n, r) {
      var i = e.db.createObjectStore(t, n.keyPath ? { keyPath: n.keyPath, autoIncrement: n.auto } : { autoIncrement: n.auto });return r.forEach(function (e) {
        return dn(i, e);
      }), i;
    }function dn(e, t) {
      e.createIndex(t.name, t.keyPath, { unique: t.unique, multiEntry: t.multi });
    }function pn(e, t, n) {
      var r = {};return m(t.objectStoreNames, 0).forEach(function (e) {
        for (var t = n.objectStore(e), i = t.keyPath, o = Gt(Qt(i), i || "", !1, !1, !!t.autoIncrement, i && "string" != typeof i, !0), s = [], a = 0; a < t.indexNames.length; ++a) {
          var u = t.index(t.indexNames[a]);i = u.keyPath;var c = Gt(u.name, i, !!u.unique, !!u.multiEntry, !1, i && "string" != typeof i, !1);s.push(c);
        }r[e] = $t(e, o, s);
      }), r;
    }function yn(e, t, n) {
      for (var r = n.db.objectStoreNames, i = 0; i < r.length; ++i) {
        var o = r[i],
            s = n.objectStore(o);e._hasGetAll = "getAll" in s;for (var u = 0; u < s.indexNames.length; ++u) {
          var c = s.indexNames[u],
              l = s.index(c).keyPath,
              f = "string" == typeof l ? l : "[" + m(l).join("+") + "]";if (t[o]) {
            var h = t[o].idxByName[f];h && (h.name = c, delete t[o].idxByName[f], t[o].idxByName[c] = h);
          }
        }
      }"undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && a.WorkerGlobalScope && a instanceof a.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604 && (e._hasGetAll = !1);
    }var vn,
        gn = function () {
      function e() {}return e.prototype._parseStoresSpec = function (e, t) {
        o(e).forEach(function (n) {
          if (null !== e[n]) {
            var r = e[n].split(",").map(function (e, t) {
              var n = (e = e.trim()).replace(/([&*]|\+\+)/g, ""),
                  r = /^\[/.test(n) ? n.match(/^\[(.*)\]$/)[1].split("+") : n;return Gt(n, r || null, /\&/.test(e), /\*/.test(e), /\+\+/.test(e), s(r), 0 === t);
            }),
                i = r.shift();if (i.multi) throw new ne.Schema("Primary key cannot be multi-valued");r.forEach(function (e) {
              if (e.auto) throw new ne.Schema("Only primary key can be marked as autoIncrement (++)");if (!e.keyPath) throw new ne.Schema("Index must have a name and cannot be an empty string");
            }), t[n] = $t(n, i, r);
          }
        });
      }, e.prototype.stores = function (e) {
        var t = this.db;this._cfg.storesSource = this._cfg.storesSource ? u(this._cfg.storesSource, e) : e;var n = t._versions,
            r = {},
            i = {};return n.forEach(function (e) {
          u(r, e._cfg.storesSource), i = e._cfg.dbschema = {}, e._parseStoresSpec(r, i);
        }), t._dbSchema = i, cn(t, [t._allTables, t, t.Transaction.prototype]), un(t, [t._allTables, t, t.Transaction.prototype, this._cfg.tables], o(i), i), t._storeNames = o(i), this;
      }, e.prototype.upgrade = function (e) {
        return this._cfg.contentUpgrade = e, this;
      }, e;
    }();function mn(e) {
      return rt(function () {
        return Be.letThrough = !0, e();
      });
    }function bn(e) {
      var t = e._state,
          n = e._deps.indexedDB;if (t.isBeingOpened || e.idbdb) return t.dbReadyPromise.then(function () {
        return t.dbOpenError ? yt(t.dbOpenError) : e;
      });K && (t.openCanceller._stackHolder = W()), t.isBeingOpened = !0, t.dbOpenError = null, t.openComplete = !1;var r = t.dbReadyResolve,
          i = null;return De.race([t.openCanceller, new De(function (r, s) {
        if (!n) throw new ne.MissingAPI("indexedDB API not found. If using IE10+, make sure to run your code on a server URL (not locally). If using old Safari versions, make sure to include indexedDB polyfill.");var a = e.name,
            u = t.autoSchema ? n.open(a) : n.open(a, Math.round(10 * e.verno));if (!u) throw new ne.MissingAPI("IndexedDB API not available");u.onerror = Xt(s), u.onblocked = Ge(e._fireOnBlocked), u.onupgradeneeded = Ge(function (r) {
          if (i = u.transaction, t.autoSchema && !e._options.allowEmptyDB) {
            u.onerror = Yt, i.abort(), u.result.close();var o = n.deleteDatabase(a);o.onsuccess = o.onerror = Ge(function () {
              s(new ne.NoSuchDatabase("Database " + a + " doesnt exist"));
            });
          } else {
            i.onerror = Xt(s);var c = r.oldVersion > Math.pow(2, 62) ? 0 : r.oldVersion;e.idbdb = u.result, fn(e, c / 10, i, s);
          }
        }, s), u.onsuccess = Ge(function () {
          i = null;var n = e.idbdb = u.result,
              s = m(n.objectStoreNames);if (s.length > 0) try {
            var c = n.transaction(Wt(s), "readonly");t.autoSchema ? function (e, t, n) {
              e.verno = t.version / 10;var r = e._dbSchema = pn(0, t, n);e._storeNames = m(t.objectStoreNames, 0), un(e, [e._allTables], o(r), r);
            }(e, n, c) : yn(e, e._dbSchema, c), an(e, c);
          } catch (e) {}mt.push(e), n.onversionchange = Ge(function (n) {
            t.vcFired = !0, e.on("versionchange").fire(n);
          }), vn.add(a), r();
        }, s);
      })]).then(function () {
        return t.onReadyBeingFired = [], De.resolve(mn(e.on.ready.fire)).then(function e() {
          if (t.onReadyBeingFired.length > 0) {
            var n = t.onReadyBeingFired.reduce(de, oe);return t.onReadyBeingFired = [], De.resolve(mn(n)).then(e);
          }
        });
      }).finally(function () {
        t.onReadyBeingFired = null;
      }).then(function () {
        return t.isBeingOpened = !1, e;
      }).catch(function (n) {
        try {
          i && i.abort();
        } catch (e) {}return t.isBeingOpened = !1, e.close(), t.dbOpenError = n, yt(t.dbOpenError);
      }).finally(function () {
        t.openComplete = !0, r();
      });
    }function wn(e) {
      var t = function t(_t3) {
        return e.next(_t3);
      },
          n = i(t),
          r = i(function (t) {
        return e.throw(t);
      });function i(e) {
        return function (t) {
          var i = e(t),
              o = i.value;return i.done ? o : o && "function" == typeof o.then ? o.then(n, r) : s(o) ? Promise.all(o).then(n, r) : n(o);
        };
      }return i(t)();
    }function _n(e, t, n) {
      var r = arguments.length;if (r < 2) throw new ne.InvalidArgument("Too few arguments");for (var i = new Array(r - 1); --r;) {
        i[r - 1] = arguments[r];
      }n = i.pop();var o = A(i);return [e, o, n];
    }function En(e, t, n, r, i) {
      return De.resolve().then(function () {
        var o = Be.transless || Be,
            s = e._createTransaction(t, n, e._dbSchema, r),
            a = { trans: s, transless: o };r ? s.idbtrans = r.idbtrans : s.create();var u,
            c = N(i);c && it();var l = De.follow(function () {
          if (u = i.call(s, s)) if (c) {
            var e = ot.bind(null, null);u.then(e, e);
          } else "function" == typeof u.next && "function" == typeof u.throw && (u = wn(u));
        }, a);return (u && "function" == typeof u.then ? De.resolve(u).then(function (e) {
          return s.active ? e : yt(new ne.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : l.then(function () {
          return u;
        })).then(function (e) {
          return r && s._resolve(), s._completion.then(function () {
            return e;
          });
        }).catch(function (e) {
          return s._reject(e), yt(e);
        });
      });
    }function Sn(e, t, n) {
      for (var r = s(e) ? e.slice() : [e], i = 0; i < n; ++i) {
        r.push(t);
      }return r;
    }var kn = { stack: "dbcore", name: "VirtualIndexMiddleware", level: 1, create: function create(e) {
        return _r2(_r2({}, e), { table: function table(t) {
            var n = e.table(t),
                i = n.schema,
                o = {},
                s = [];function a(e, t, n) {
              var i = rn(e),
                  u = o[i] = o[i] || [],
                  c = null == e ? 0 : "string" == typeof e ? 1 : e.length,
                  l = t > 0,
                  f = _r2(_r2({}, n), { isVirtual: l, isPrimaryKey: !l && n.isPrimaryKey, keyTail: t, keyLength: c, extractKey: Zt(e), unique: !l && n.unique });(u.push(f), f.isPrimaryKey || s.push(f), c > 1) && a(2 === c ? e[0] : e.slice(0, c - 1), t + 1, n);return u.sort(function (e, t) {
                return e.keyTail - t.keyTail;
              }), f;
            }var u = a(i.primaryKey.keyPath, 0, i.primaryKey);o[":id"] = [u];for (var c = 0, l = i.indexes; c < l.length; c++) {
              var f = l[c];a(f.keyPath, 0, f);
            }function h(t) {
              var n,
                  i,
                  o = t.query.index;return o.isVirtual ? _r2(_r2({}, t), { query: { index: o, range: (n = t.query.range, i = o.keyTail, { type: 1 === n.type ? 2 : n.type, lower: Sn(n.lower, n.lowerOpen ? e.MAX_KEY : e.MIN_KEY, i), lowerOpen: !0, upper: Sn(n.upper, n.upperOpen ? e.MIN_KEY : e.MAX_KEY, i), upperOpen: !0 }) } }) : t;
            }return _r2(_r2({}, n), { schema: _r2(_r2({}, i), { primaryKey: u, indexes: s, getIndexByKeyPath: function getIndexByKeyPath(e) {
                  var t = o[rn(e)];return t && t[0];
                } }), count: function count(e) {
                return n.count(h(e));
              }, query: function query(e) {
                return n.query(h(e));
              }, openCursor: function openCursor(t) {
                var r = t.query.index,
                    i = r.keyTail,
                    o = r.isVirtual,
                    s = r.keyLength;if (!o) return n.openCursor(t);return n.openCursor(h(t)).then(function (n) {
                  return n && function (n) {
                    return Object.create(n, { continue: { value: function value(r) {
                          null != r ? n.continue(Sn(r, t.reverse ? e.MAX_KEY : e.MIN_KEY, i)) : t.unique ? n.continue(Sn(n.key, t.reverse ? e.MIN_KEY : e.MAX_KEY, i)) : n.continue();
                        } }, continuePrimaryKey: { value: function value(t, r) {
                          n.continuePrimaryKey(Sn(t, e.MAX_KEY, i), r);
                        } }, key: { get: function get() {
                          var e = n.key;return 1 === s ? e[0] : e.slice(0, s);
                        } }, value: { get: function get() {
                          return n.value;
                        } } });
                  }(n);
                });
              } });
          } });
      } },
        xn = { stack: "dbcore", name: "HooksMiddleware", level: 2, create: function create(e) {
        return _r2(_r2({}, e), { table: function table(t) {
            var n = e.table(t),
                o = n.schema.primaryKey;return _r2(_r2({}, n), { mutate: function mutate(e) {
                var s = Be.trans,
                    a = s.table(t).hook,
                    u = a.deleting,
                    c = a.creating,
                    l = a.updating;switch (e.type) {case "add":
                    if (c.fire === oe) break;return s._promise("readwrite", function () {
                      return f(e);
                    }, !0);case "put":
                    if (c.fire === oe && l.fire === oe) break;return s._promise("readwrite", function () {
                      return f(e);
                    }, !0);case "delete":
                    if (u.fire === oe) break;return s._promise("readwrite", function () {
                      return f(e);
                    }, !0);case "deleteRange":
                    if (u.fire === oe) break;return s._promise("readwrite", function () {
                      return function (e) {
                        return function e(t, i, s) {
                          return n.query({ trans: t, values: !1, query: { index: o, range: i }, limit: s }).then(function (n) {
                            var o = n.result;return f({ type: "delete", keys: o, trans: t }).then(function (n) {
                              return n.numFailures > 0 ? Promise.reject(n.failures[0]) : o.length < s ? { failures: [], numFailures: 0, lastResult: void 0 } : e(t, _r2(_r2({}, i), { lower: o[o.length - 1], lowerOpen: !0 }), s);
                            });
                          });
                        }(e.trans, e.range, 1e4);
                      }(e);
                    }, !0);}return n.mutate(e);function f(e) {
                  var t = Be.trans,
                      s = e.keys || en(o, e);if (!s) throw new Error("Keys missing");return "delete" !== (e = "add" === e.type || "put" === e.type ? _r2(_r2({}, e), { keys: s, wantResults: !0 }) : _r2({}, e)).type && (e.values = i(e.values)), e.keys && (e.keys = i(e.keys)), function (e, t, n) {
                    return "add" === t.type ? Promise.resolve(new Array(t.values.length)) : e.getMany({ trans: t.trans, keys: n });
                  }(n, e, s).then(function (r) {
                    var i = s.map(function (n, i) {
                      var s = r[i],
                          a = { onerror: null, onsuccess: null };if ("delete" === e.type) u.fire.call(a, n, s, t);else if ("add" === e.type || void 0 === s) {
                        var f = c.fire.call(a, n, e.values[i], t);null == n && null != f && (n = f, e.keys[i] = n, o.outbound || k(e.values[i], o.keyPath, n));
                      } else {
                        var h = j(s, e.values[i]),
                            d = l.fire.call(a, h, n, s, t);if (d) {
                          var p = e.values[i];Object.keys(d).forEach(function (e) {
                            k(p, e, d[e]);
                          });
                        }
                      }return a;
                    });return n.mutate(e).then(function (t) {
                      for (var n = t.failures, o = t.results, a = t.numFailures, u = t.lastResult, c = 0; c < s.length; ++c) {
                        var l = o ? o[c] : s[c],
                            f = i[c];null == l ? f.onerror && f.onerror(n[c]) : f.onsuccess && f.onsuccess("put" === e.type && r[c] ? e.values[c] : l);
                      }return { failures: n, results: o, numFailures: a, lastResult: u };
                    }).catch(function (e) {
                      return i.forEach(function (t) {
                        return t.onerror && t.onerror(e);
                      }), Promise.reject(e);
                    });
                  });
                }
              } });
          } });
      } },
        On = function () {
      function e(t, n) {
        var i = this;this._middlewares = {}, this.verno = 0;var o = e.dependencies;this._options = n = _r2({ addons: e.addons, autoOpen: !0, indexedDB: o.indexedDB, IDBKeyRange: o.IDBKeyRange }, n), this._deps = { indexedDB: n.indexedDB, IDBKeyRange: n.IDBKeyRange };var s = n.addons;this._dbSchema = {}, this._versions = [], this._storeNames = [], this._allTables = {}, this.idbdb = null;var a,
            u = { dbOpenError: null, isBeingOpened: !1, onReadyBeingFired: null, openComplete: !1, dbReadyResolve: oe, dbReadyPromise: null, cancelOpen: oe, openCanceller: null, autoSchema: !0 };u.dbReadyPromise = new De(function (e) {
          u.dbReadyResolve = e;
        }), u.openCanceller = new De(function (e, t) {
          u.cancelOpen = t;
        }), this._state = u, this.name = t, this.on = Ot(this, "populate", "blocked", "versionchange", { ready: [de, oe] }), this.on.ready.subscribe = b(this.on.ready.subscribe, function (t) {
          return function (n, r) {
            e.vip(function () {
              var e = i._state;if (e.openComplete) e.dbOpenError || De.resolve().then(n), r && t(n);else if (e.onReadyBeingFired) e.onReadyBeingFired.push(n), r && t(n);else {
                t(n);var o = i;r || t(function e() {
                  o.on.ready.unsubscribe(n), o.on.ready.unsubscribe(e);
                });
              }
            });
          };
        }), this.Collection = (a = this, At(jt.prototype, function (e, t) {
          this.db = a;var n = kt,
              r = null;if (t) try {
            n = t();
          } catch (e) {
            r = e;
          }var i = e._ctx,
              o = i.table,
              s = o.hook.reading.fire;this._ctx = { table: o, index: i.index, isPrimKey: !i.index || o.schema.primKey.keyPath && i.index === o.schema.primKey.name, range: n, keysOnly: !1, dir: "next", unique: "", algorithm: null, filter: null, replayFilter: null, justLimit: !0, isMatch: null, offset: 0, limit: 1 / 0, error: r, or: i.or, valueMapper: s !== se ? s : null };
        })), this.Table = function (e) {
          return At(xt.prototype, function (t, n, r) {
            this.db = e, this._tx = r, this.name = t, this.schema = n, this.hook = e._allTables[t] ? e._allTables[t].hook : Ot(null, { creating: [ce, oe], reading: [ae, se], updating: [fe, oe], deleting: [le, oe] });
          });
        }(this), this.Transaction = function (e) {
          return At(Jt.prototype, function (t, n, r, i) {
            var o = this;this.db = e, this.mode = t, this.storeNames = n, this.schema = r, this.idbtrans = null, this.on = Ot(this, "complete", "error", "abort"), this.parent = i || null, this.active = !0, this._reculock = 0, this._blockedFuncs = [], this._resolve = null, this._reject = null, this._waitingFor = null, this._waitingQueue = null, this._spinCount = 0, this._completion = new De(function (e, t) {
              o._resolve = e, o._reject = t;
            }), this._completion.then(function () {
              o.active = !1, o.on.complete.fire();
            }, function (e) {
              var t = o.active;return o.active = !1, o.on.error.fire(e), o.parent ? o.parent._reject(e) : t && o.idbtrans && o.idbtrans.abort(), yt(e);
            });
          });
        }(this), this.Version = function (e) {
          return At(gn.prototype, function (t) {
            this.db = e, this._cfg = { version: t, storesSource: null, dbschema: {}, tables: {}, contentUpgrade: null };
          });
        }(this), this.WhereClause = function (e) {
          return At(zt.prototype, function (t, n, r) {
            this.db = e, this._ctx = { table: t, index: ":id" === n ? null : n, or: r };var i = e._deps.indexedDB;if (!i) throw new ne.MissingAPI("indexedDB API missing");this._cmp = this._ascending = i.cmp.bind(i), this._descending = function (e, t) {
              return i.cmp(t, e);
            }, this._max = function (e, t) {
              return i.cmp(e, t) > 0 ? e : t;
            }, this._min = function (e, t) {
              return i.cmp(e, t) < 0 ? e : t;
            }, this._IDBKeyRange = e._deps.IDBKeyRange;
          });
        }(this), this.on("versionchange", function (e) {
          e.newVersion > 0 ? console.warn("Another connection wants to upgrade database '" + i.name + "'. Closing db now to resume the upgrade.") : console.warn("Another connection wants to delete database '" + i.name + "'. Closing db now to resume the delete request."), i.close();
        }), this.on("blocked", function (e) {
          !e.newVersion || e.newVersion < e.oldVersion ? console.warn("Dexie.delete('" + i.name + "') was blocked") : console.warn("Upgrade '" + i.name + "' blocked by other connection holding version " + e.oldVersion / 10);
        }), this._maxKey = Vt(n.IDBKeyRange), this._createTransaction = function (e, t, n, r) {
          return new i.Transaction(e, t, n, r);
        }, this._fireOnBlocked = function (e) {
          i.on("blocked").fire(e), mt.filter(function (e) {
            return e.name === i.name && e !== i && !e._state.vcFired;
          }).map(function (t) {
            return t.on("versionchange").fire(e);
          });
        }, this.use(kn), this.use(xn), s.forEach(function (e) {
          return e(i);
        });
      }return e.prototype.version = function (e) {
        if (isNaN(e) || e < .1) throw new ne.Type("Given version is not a positive number");if (e = Math.round(10 * e) / 10, this.idbdb || this._state.isBeingOpened) throw new ne.Schema("Cannot add version when database is open");this.verno = Math.max(this.verno, e);var t = this._versions,
            n = t.filter(function (t) {
          return t._cfg.version === e;
        })[0];return n || (n = new this.Version(e), t.push(n), t.sort(ln), n.stores({}), this._state.autoSchema = !1, n);
      }, e.prototype._whenReady = function (e) {
        var t = this;return this._state.openComplete || Be.letThrough ? e() : new De(function (e, n) {
          if (!t._state.isBeingOpened) {
            if (!t._options.autoOpen) return void n(new ne.DatabaseClosed());t.open().catch(oe);
          }t._state.dbReadyPromise.then(e, n);
        }).then(e);
      }, e.prototype.use = function (e) {
        var t = e.stack,
            n = e.create,
            r = e.level,
            i = e.name;i && this.unuse({ stack: t, name: i });var o = this._middlewares[t] || (this._middlewares[t] = []);return o.push({ stack: t, create: n, level: null == r ? 10 : r, name: i }), o.sort(function (e, t) {
          return e.level - t.level;
        }), this;
      }, e.prototype.unuse = function (e) {
        var t = e.stack,
            n = e.name,
            r = e.create;return t && this._middlewares[t] && (this._middlewares[t] = this._middlewares[t].filter(function (e) {
          return r ? e.create !== r : !!n && e.name !== n;
        })), this;
      }, e.prototype.open = function () {
        return bn(this);
      }, e.prototype.close = function () {
        var e = mt.indexOf(this),
            t = this._state;if (e >= 0 && mt.splice(e, 1), this.idbdb) {
          try {
            this.idbdb.close();
          } catch (e) {}this.idbdb = null;
        }this._options.autoOpen = !1, t.dbOpenError = new ne.DatabaseClosed(), t.isBeingOpened && t.cancelOpen(t.dbOpenError), t.dbReadyPromise = new De(function (e) {
          t.dbReadyResolve = e;
        }), t.openCanceller = new De(function (e, n) {
          t.cancelOpen = n;
        });
      }, e.prototype.delete = function () {
        var e = this,
            t = arguments.length > 0,
            n = this._state;return new De(function (r, i) {
          var o = function o() {
            e.close();var t = e._deps.indexedDB.deleteDatabase(e.name);t.onsuccess = Ge(function () {
              vn.remove(e.name), r();
            }), t.onerror = Xt(i), t.onblocked = e._fireOnBlocked;
          };if (t) throw new ne.InvalidArgument("Arguments not allowed in db.delete()");n.isBeingOpened ? n.dbReadyPromise.then(o) : o();
        });
      }, e.prototype.backendDB = function () {
        return this.idbdb;
      }, e.prototype.isOpen = function () {
        return null !== this.idbdb;
      }, e.prototype.hasBeenClosed = function () {
        var e = this._state.dbOpenError;return e && "DatabaseClosed" === e.name;
      }, e.prototype.hasFailed = function () {
        return null !== this._state.dbOpenError;
      }, e.prototype.dynamicallyOpened = function () {
        return this._state.autoSchema;
      }, Object.defineProperty(e.prototype, "tables", { get: function get() {
          var e = this;return o(this._allTables).map(function (t) {
            return e._allTables[t];
          });
        }, enumerable: !0, configurable: !0 }), e.prototype.transaction = function () {
        var e = _n.apply(this, arguments);return this._transaction.apply(this, e);
      }, e.prototype._transaction = function (e, t, n) {
        var r = this,
            i = Be.trans;i && i.db === this && -1 === e.indexOf("!") || (i = null);var o,
            s,
            a = -1 !== e.indexOf("?");e = e.replace("!", "").replace("?", "");try {
          if (s = t.map(function (e) {
            var t = e instanceof r.Table ? e.name : e;if ("string" != typeof t) throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");return t;
          }), "r" == e || "readonly" === e) o = "readonly";else {
            if ("rw" != e && "readwrite" != e) throw new ne.InvalidArgument("Invalid transaction mode: " + e);o = "readwrite";
          }if (i) {
            if ("readonly" === i.mode && "readwrite" === o) {
              if (!a) throw new ne.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");i = null;
            }i && s.forEach(function (e) {
              if (i && -1 === i.storeNames.indexOf(e)) {
                if (!a) throw new ne.SubTransaction("Table " + e + " not included in parent transaction.");i = null;
              }
            }), a && i && !i.active && (i = null);
          }
        } catch (e) {
          return i ? i._promise(null, function (t, n) {
            n(e);
          }) : yt(e);
        }var u = En.bind(null, this, o, s, i, n);return i ? i._promise(o, u, "lock") : Be.trans ? ft(Be.transless, function () {
          return r._whenReady(u);
        }) : this._whenReady(u);
      }, e.prototype.table = function (e) {
        if (!f(this._allTables, e)) throw new ne.InvalidTable("Table " + e + " does not exist");return this._allTables[e];
      }, e;
    }(),
        An = On;h(An, _r2(_r2({}, ie), { delete: function _delete(e) {
        return new An(e).delete();
      }, exists: function exists(e) {
        return new An(e, { addons: [] }).open().then(function (e) {
          return e.close(), !0;
        }).catch("NoSuchDatabaseError", function () {
          return !1;
        });
      }, getDatabaseNames: function getDatabaseNames(e) {
        return vn ? vn.getDatabaseNames().then(e) : De.resolve([]);
      }, defineClass: function defineClass() {
        return function (e) {
          u(this, e);
        };
      }, ignoreTransaction: function ignoreTransaction(e) {
        return Be.trans ? ft(Be.transless, e) : e();
      }, vip: mn, async: function async(e) {
        return function () {
          try {
            var t = wn(e.apply(this, arguments));return t && "function" == typeof t.then ? t : De.resolve(t);
          } catch (e) {
            return yt(e);
          }
        };
      }, spawn: function spawn(e, t, n) {
        try {
          var r = wn(e.apply(n, t || []));return r && "function" == typeof r.then ? r : De.resolve(r);
        } catch (e) {
          return yt(e);
        }
      }, currentTransaction: { get: function get() {
          return Be.trans || null;
        } }, waitFor: function waitFor(e, t) {
        var n = De.resolve("function" == typeof e ? An.ignoreTransaction(e) : e).timeout(t || 6e4);return Be.trans ? Be.trans.waitFor(n) : n;
      }, Promise: De, debug: { get: function get() {
          return K;
        }, set: function set(e) {
          H(e, "dexie" === e ? function () {
            return !0;
          } : Et);
        } }, derive: y, extend: u, props: h, override: b, Events: Ot, getByKeyPath: S, setByKeyPath: k, delByKeyPath: function delByKeyPath(e, t) {
        "string" == typeof t ? k(e, t, void 0) : "length" in t && [].map.call(t, function (t) {
          k(e, t, void 0);
        });
      }, shallowClone: x, deepClone: I, getObjectDiff: j, asap: _, minKey: -1 / 0, addons: [], connections: mt, errnames: ee, dependencies: function () {
        try {
          return { indexedDB: a.indexedDB || a.mozIndexedDB || a.webkitIndexedDB || a.msIndexedDB, IDBKeyRange: a.IDBKeyRange || a.webkitIDBKeyRange };
        } catch (e) {
          return { indexedDB: null, IDBKeyRange: null };
        }
      }(), semVer: "3.0.1", version: "3.0.1".split(".").map(function (e) {
        return parseInt(e);
      }).reduce(function (e, t, n) {
        return e + t / Math.pow(10, 2 * n);
      }), default: An, Dexie: An })), An.maxKey = Vt(An.dependencies.IDBKeyRange), function (e) {
      try {
        vn = function (e) {
          var t,
              n = e && "function" == typeof e.databases;if (!n) {
            var r = new On("__dbnames", { addons: [] });r.version(1).stores({ dbnames: "name" }), t = r.table("dbnames");
          }return { getDatabaseNames: function getDatabaseNames() {
              return n ? De.resolve(e.databases()).then(function (e) {
                return e.map(function (e) {
                  return e.name;
                }).filter(function (e) {
                  return "__dbnames" !== e;
                });
              }) : t.toCollection().primaryKeys();
            }, add: function add(e) {
              return !n && "__dbnames" !== e && t.put({ name: e }).catch(oe);
            }, remove: function remove(e) {
              return !n && "__dbnames" !== e && t.delete(e).catch(oe);
            } };
        }(e);
      } catch (e) {}
    }(On.dependencies.indexedDB), De.rejectionMapper = function (e, t) {
      if (!e || e instanceof G || e instanceof TypeError || e instanceof SyntaxError || !e.name || !re[e.name]) return e;var n = new re[e.name](t || e.message, e);return "stack" in e && p(n, "stack", { get: function get() {
          return this.inner.stack;
        } }), n;
    }, H(K, Et), t.default = On;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }function u(e) {
          var t;e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(s, a);
        }u((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          o,
          s = { label: 0, sent: function sent() {
          if (1 & i[0]) throw i[1];return i[1];
        }, trys: [], ops: [] };return o = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;function a(o) {
        return function (a) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");for (; s;) {
              try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {case 0:case 1:
                    i = o;break;case 4:
                    return s.label++, { value: o[1], done: !1 };case 5:
                    s.label++, r = o[1], o = [0];continue;case 7:
                    o = s.ops.pop(), s.trys.pop();continue;default:
                    if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      s = 0;continue;
                    }if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      s.label = o[1];break;
                    }if (6 === o[0] && s.label < i[1]) {
                      s.label = i[1], i = o;break;
                    }if (i && s.label < i[2]) {
                      s.label = i[2], s.ops.push(o);break;
                    }i[2] && s.ops.pop(), s.trys.pop();continue;}o = t.call(e, s);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }if (5 & o[0]) throw o[1];return { value: o[0] ? o[1] : void 0, done: !0 };
          }([o, a]);
        };
      }
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.SessionsTable = void 0;var o = function () {
      function e(e) {
        this.sessions = e;
      }return e.prototype.add = function (e) {
        return r(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {case 0:
                return [4, this.sessions.add(e)];case 1:
                return t.sent(), [2];}
          });
        });
      }, e.prototype.delete = function (e) {
        return this.sessions.delete(e);
      }, e.prototype.getAll = function () {
        return this.sessions.toArray();
      }, e.prototype.update = function (e, t) {
        return r(this, void 0, void 0, function () {
          return i(this, function (n) {
            switch (n.label) {case 0:
                return [4, this.sessions.update(e, t)];case 1:
                return n.sent(), [2];}
          });
        });
      }, e;
    }();t.SessionsTable = o;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }function u(e) {
          var t;e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(s, a);
        }u((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          o,
          s = { label: 0, sent: function sent() {
          if (1 & i[0]) throw i[1];return i[1];
        }, trys: [], ops: [] };return o = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;function a(o) {
        return function (a) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");for (; s;) {
              try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {case 0:case 1:
                    i = o;break;case 4:
                    return s.label++, { value: o[1], done: !1 };case 5:
                    s.label++, r = o[1], o = [0];continue;case 7:
                    o = s.ops.pop(), s.trys.pop();continue;default:
                    if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      s = 0;continue;
                    }if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      s.label = o[1];break;
                    }if (6 === o[0] && s.label < i[1]) {
                      s.label = i[1], i = o;break;
                    }if (i && s.label < i[2]) {
                      s.label = i[2], s.ops.push(o);break;
                    }i[2] && s.ops.pop(), s.trys.pop();continue;}o = t.call(e, s);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }if (5 & o[0]) throw o[1];return { value: o[0] ? o[1] : void 0, done: !0 };
          }([o, a]);
        };
      }
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.DeviceKeysTable = void 0;var o = function () {
      function e(e) {
        this.devicekeys = e;
      }return e.prototype.add = function (e) {
        return r(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {case 0:
                return [4, this.devicekeys.add(e)];case 1:
                return t.sent(), [2];}
          });
        });
      }, e.prototype.count = function (e) {
        return this.devicekeys.where({ sessionUUID: e }).count();
      }, e.prototype.deleteBatch = function (e) {
        return r(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {case 0:
                return [4, this.devicekeys.limit(e).delete()];case 1:
                return t.sent(), [2];}
          });
        });
      }, e.prototype.getAll = function () {
        return this.devicekeys.toArray();
      }, e;
    }();t.DeviceKeysTable = o;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }function u(e) {
          var t;e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(s, a);
        }u((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          o,
          s = { label: 0, sent: function sent() {
          if (1 & i[0]) throw i[1];return i[1];
        }, trys: [], ops: [] };return o = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;function a(o) {
        return function (a) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");for (; s;) {
              try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {case 0:case 1:
                    i = o;break;case 4:
                    return s.label++, { value: o[1], done: !1 };case 5:
                    s.label++, r = o[1], o = [0];continue;case 7:
                    o = s.ops.pop(), s.trys.pop();continue;default:
                    if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      s = 0;continue;
                    }if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      s.label = o[1];break;
                    }if (6 === o[0] && s.label < i[1]) {
                      s.label = i[1], i = o;break;
                    }if (i && s.label < i[2]) {
                      s.label = i[2], s.ops.push(o);break;
                    }i[2] && s.ops.pop(), s.trys.pop();continue;}o = t.call(e, s);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }if (5 & o[0]) throw o[1];return { value: o[0] ? o[1] : void 0, done: !0 };
          }([o, a]);
        };
      }
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.IssuesTable = void 0;var o = function () {
      function e(e) {
        this.issues = e;
      }return e.prototype.add = function (e) {
        return r(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {case 0:
                return [4, this.issues.add(e)];case 1:
                return t.sent(), [2];}
          });
        });
      }, e.prototype.count = function (e) {
        return this.issues.where({ sessionUUID: e }).count();
      }, e.prototype.deleteById = function (e) {
        return r(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {case 0:
                return [4, this.issues.delete(e)];case 1:
                return t.sent(), [2];}
          });
        });
      }, e.prototype.getBatch = function (e, t) {
        return this.issues.where({ sessionUUID: e }).limit(t).toArray();
      }, e;
    }();t.IssuesTable = o;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }function u(e) {
          var t;e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(s, a);
        }u((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          o,
          s = { label: 0, sent: function sent() {
          if (1 & i[0]) throw i[1];return i[1];
        }, trys: [], ops: [] };return o = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;function a(o) {
        return function (a) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");for (; s;) {
              try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {case 0:case 1:
                    i = o;break;case 4:
                    return s.label++, { value: o[1], done: !1 };case 5:
                    s.label++, r = o[1], o = [0];continue;case 7:
                    o = s.ops.pop(), s.trys.pop();continue;default:
                    if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      s = 0;continue;
                    }if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      s.label = o[1];break;
                    }if (6 === o[0] && s.label < i[1]) {
                      s.label = i[1], i = o;break;
                    }if (i && s.label < i[2]) {
                      s.label = i[2], s.ops.push(o);break;
                    }i[2] && s.ops.pop(), s.trys.pop();continue;}o = t.call(e, s);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }if (5 & o[0]) throw o[1];return { value: o[0] ? o[1] : void 0, done: !0 };
          }([o, a]);
        };
      }
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.LogsTable = void 0;var o = function () {
      function e(e, t) {
        this.logs = e, this.logFactory = t;
      }return e.prototype.add = function (e) {
        return r(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {case 0:
                return [4, this.logs.add(e)];case 1:
                return t.sent(), [2];}
          });
        });
      }, e.prototype.count = function (e) {
        return this.logs.where({ sessionUUID: e }).count();
      }, e.prototype.deleteBatch = function (e, t) {
        return r(this, void 0, void 0, function () {
          return i(this, function (n) {
            switch (n.label) {case 0:
                return [4, this.logs.where({ sessionUUID: e }).limit(t).delete()];case 1:
                return n.sent(), [2];}
          });
        });
      }, e.prototype.deleteOldLogs = function (e) {
        return r(this, void 0, void 0, function () {
          var t = this;return i(this, function (n) {
            return [2, this.logs.db.transaction("rw", this.logs, function () {
              return r(t, void 0, void 0, function () {
                var t, n, r;return i(this, function (i) {
                  switch (i.label) {case 0:
                      return [4, this.logs.where({ sessionUUID: e }).limit(1).primaryKeys()];case 1:
                      return t = i.sent()[0], [4, this.logs.where({ sessionUUID: e }).limit(10).toArray()];case 2:
                      return (n = i.sent()).length <= 1 ? [2] : (r = { sessionUUID: e, data: this.logFactory.createGapLog(n.map(function (e) {
                          return e.data;
                        })) }, [4, this.logs.update(t, r)]);case 3:
                      return i.sent(), [4, this.logs.where({ sessionUUID: e }).offset(1).limit(9).delete()];case 4:
                      return i.sent(), [2];}
                });
              });
            })];
          });
        });
      }, e.prototype.getBatch = function (e, t) {
        return this.logs.where({ sessionUUID: e }).limit(t).toArray();
      }, e;
    }();t.LogsTable = o;
  }, function (e, t, n) {
    "use strict";
    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var i in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }return e;
      }).apply(this, arguments);
    };Object.defineProperty(t, "__esModule", { value: !0 }), t.OverrideConsoleMethods = void 0;var i = n(1),
        o = function () {
      function e(e, t) {
        this.storage = e, this.window = t;
      }return e.prototype.init = function () {
        var e = this;this.window.console = function (t) {
          return r(r({}, t), { log: function log() {
              for (var n = [], r = 0; r < arguments.length; r++) {
                n[r] = arguments[r];
              }t.log.apply(t, n), e.storage.addLogMessage(i.LogLevel.Debug, n);
            }, trace: function trace() {
              for (var n = [], r = 0; r < arguments.length; r++) {
                n[r] = arguments[r];
              }t.trace.apply(t, n), e.storage.addLogMessage(i.LogLevel.Trace, n);
            }, info: function info() {
              for (var n = [], r = 0; r < arguments.length; r++) {
                n[r] = arguments[r];
              }t.info.apply(t, n), e.storage.addLogMessage(i.LogLevel.Info, n);
            }, warn: function warn() {
              for (var n = [], r = 0; r < arguments.length; r++) {
                n[r] = arguments[r];
              }t.warn.apply(t, n), e.storage.addLogMessage(i.LogLevel.Warning, n);
            }, error: function error() {
              for (var n = [], r = 0; r < arguments.length; r++) {
                n[r] = arguments[r];
              }t.error.apply(t, n), e.storage.addLogMessage(i.LogLevel.Error, n);
            } });
        }(this.window.console);
      }, e;
    }();t.OverrideConsoleMethods = o;
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.RegisterErrorHandler = void 0;var r = function () {
      function e(e) {
        this.window = e;
      }return e.prototype.init = function (e) {
        this.window.addEventListener("error", function (t) {
          var n,
              r = t.message,
              i = t.lineno,
              o = t.filename,
              s = t.error;s && s.stack && (n = s.stack), "string" == typeof r && e.sendCrash(r, ["Error: " + r, "URL: " + (o || "N/A"), "Line: " + (i || "N/A"), "Stack: " + (n || "N/A")].join("\n"));
        });
      }, e;
    }();t.RegisterErrorHandler = r;
  }, function (e, t, n) {
    "use strict";
    var _r3,
        i = this && this.__extends || (_r3 = function r(e, t) {
      return (_r3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }_r3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });Object.defineProperty(t, "__esModule", { value: !0 }), t.RegisterBrowserEventsHandler = void 0;var o = function (e) {
      function t(t, n) {
        var r = e.call(this, n) || this;return r.storage = t, r.window = n, r;
      }return i(t, e), t.prototype.init = function () {
        var e = this;if (this.window.document.addEventListener) {
          var t = !this.supportsPassiveEvents() || { passive: !0, capture: !0 };this.window.addEventListener("load", function (t) {
            e.storage.addLogEntry({ tag: "js_event", text: JSON.stringify({ event: "PageLoaded", performance: e.window.performance }), url: e.getURL() });
          }, t), this.window.addEventListener("DOMContentLoaded", function () {
            e.storage.addLogEntry({ tag: "js_event", text: JSON.stringify({ event: "DOMContentLoaded" }), url: e.getURL() });
          }, t), this.window.addEventListener("popstate", function (t) {
            e.storage.addLogEntry({ tag: "js_event", text: JSON.stringify({ event: "popstate", location: e.window.location.toString(), state: JSON.stringify(t.state) }), url: e.getURL() });
          }, t), this.window.addEventListener("hashchange", function () {
            e.storage.addLogEntry({ tag: "js_event", text: JSON.stringify({ event: "hashchange", hash: e.window.location.hash }), url: e.getURL() });
          }, t);var n = function n(t) {
            var n = e;return function () {
              for (var e = [], r = 0; r < arguments.length; r++) {
                e[r] = arguments[r];
              }var i = e.length > 2 ? e[2] : void 0;return i && n.storage.addLogEntry({ tag: "js_event", text: JSON.stringify({ event: "pushstate", to: String(i), state: e.length > 1 ? JSON.stringify(e[1]) : null }), url: n.getURL() }), t.apply(this, e);
            };
          };this.override(this.window.history, "pushState", n), this.override(this.window.history, "replaceState", n);
        }
      }, t.prototype.override = function (e, t, n) {
        if (t in e) {
          var r = n(e[t]);e[t] = r;
        }
      }, t;
    }(n(46).RegisterEventsHandlerBase);t.RegisterBrowserEventsHandler = o;
  }, function (e, t, n) {
    "use strict";
    var _r4,
        i = this && this.__extends || (_r4 = function r(e, t) {
      return (_r4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }_r4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });Object.defineProperty(t, "__esModule", { value: !0 }), t.RegisterUIEventsHandler = void 0;var o = function (e) {
      function t(t, n) {
        var r = e.call(this, n) || this;return r.storage = t, r.window = n, r;
      }return i(t, e), t.prototype.init = function () {
        var e = this;if (this.window.document.addEventListener) {
          var t = !this.supportsPassiveEvents() || { passive: !0, capture: !0 };document.addEventListener("click", function (t) {
            t.target instanceof Element && e.storage.addLogEntry({ tag: "js_event", text: JSON.stringify(e.getTargetData(t.target, "click")), url: e.getURL() });
          }, t), document.addEventListener("focusin", function (t) {
            t.target instanceof Element && e.storage.addLogEntry({ tag: "js_event", text: JSON.stringify(e.getTargetData(t.target, "focus")), url: e.getURL() });
          }, t), document.addEventListener("focusout", function (t) {
            t.target instanceof Element && e.storage.addLogEntry({ tag: "js_event", text: JSON.stringify(e.getTargetData(t.target, "blur")), url: e.getURL() });
          }, t), this.window.addEventListener("submit", function (t) {
            e.storage.addLogEntry({ tag: "js_event", text: JSON.stringify(e.getTargetData(t.target, "submit")), url: e.getURL() });
          }, t);
        }
      }, t.prototype.getPathTo = function (e) {
        if ("" !== e.id) return 'id("' + e.id + '")';if (e === document.body) return e.tagName;if ("HTML" === e.tagName) return e.tagName;for (var t = 0, n = e.parentNode.childNodes, r = 0; r < n.length; r++) {
          var i = n[r];if (i === e) return this.getPathTo(e.parentNode) + "/" + e.tagName + "[" + (t + 1) + "]";1 === i.nodeType && i.tagName === e.tagName && t++;
        }
      }, t.prototype.getTargetData = function (e, t) {
        if (e instanceof Element) {
          var n = e.childElementCount <= 1 ? e.textContent : void 0,
              r = "FORM" === e.tagName ? e : null;return { event: t, url: this.window ? this.window.location.href : "", xpath: this.getPathTo(e), tag: e.tagName, id: e.id, text: n, action: r && r.action ? r.action : "" };
        }return null;
      }, t;
    }(n(46).RegisterEventsHandlerBase);t.RegisterUIEventsHandler = o;
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.PrintToConsole = void 0;var r = n(3),
        i = n(1),
        o = function () {
      function e(e) {
        this.console = e;
      }return e.prototype.init = function (e) {
        this.printToConsole = e;
      }, e.prototype.error = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.printToConsole && (e = this.console).error.apply(e, t);
      }, e.prototype.info = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.printToConsole && (e = this.console).info.apply(e, t);
      }, e.prototype.log = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.printToConsole && (e = this.console).log.apply(e, t);
      }, e.prototype.trace = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.printToConsole && (e = this.console).trace.apply(e, t);
      }, e.prototype.warn = function () {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }this.printToConsole && (e = this.console).warn.apply(e, t);
      }, e.prototype.printLog = function (e) {
        if (this.printToConsole) {
          var t = ["log", "warn", "error", "trace", "info", "error"][e.level || i.LogLevel.Debug],
              n = e.tag ? "[" + e.tag + "] " : "",
              o = [e.file || "", e.method || "", e.line || ""].filter(function (e) {
            return "" !== e;
          }).join(":"),
              s = "" + n + r.format(e.text) + " " + o;this.console[t](s);
        }
      }, e;
    }();t.PrintToConsole = o;
  }]);
});
//# sourceMappingURL=index.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "FJnM":
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _preact = __webpack_require__("KM04");

var _preactSideEffect = __webpack_require__("xToX");

var _preactSideEffect2 = _interopRequireDefault(_preactSideEffect);

var _deepEqual = __webpack_require__("koiw");

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _objectAssign = __webpack_require__("J4Nk");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__("Qxat");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var HELMET_ATTRIBUTE = "data-preact-helmet";

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props[property]) {
            return props[property];
        }
    }
    return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, "title");
    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");

    return innermostTitle || innermostDefaultTitle || "";
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        return typeof props[tagName] !== "undefined";
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var updateTitle = function updateTitle(title, attributes) {
    document.title = title || document.title;
    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var htmlTag = document.getElementsByTagName(tagName)[0];
    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        htmlTag.setAttribute(attribute, value);

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        htmlTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
    } else {
        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector("head");
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === "innerHTML") {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === "cssText") {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
    var attributeString = generateHtmlAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + " " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + ">" + encodeSpecialCharacters(title) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === "innerHTML" || attribute === "cssText");
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + " " + attributeHtml + (isSelfClosing ? ">" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var generateTitleAsPreactComponent = function generateTitleAsPreactComponent(type, title, attributes) {
    // assigning into an array to define toString function on it
    var initProps = _defineProperty({
        key: title
    }, HELMET_ATTRIBUTE, true);
    var props = Object.keys(attributes).reduce(function (obj, key) {
        obj[key] = attributes[key];
        return obj;
    }, initProps);

    return [(0, _preact.h)(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsPreactComponent = function generateTagsAsPreactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var mappedTag = _defineProperty({
            key: i
        }, HELMET_ATTRIBUTE, true);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = attribute;

            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return (0, _preact.h)(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsPreactComponent(type, tags.title, tags.titleAttributes);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
                }
            };
        case _HelmetConstants.TAG_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return tags;
                },
                toString: function toString() {
                    return generateHtmlAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsPreactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var htmlAttributes = _ref.htmlAttributes,
        title = _ref.title,
        titleAttributes = _ref.titleAttributes,
        baseTag = _ref.baseTag,
        metaTags = _ref.metaTags,
        linkTags = _ref.linkTags,
        scriptTags = _ref.scriptTags,
        noscriptTags = _ref.noscriptTags,
        styleTags = _ref.styleTags;
    return {
        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };
};

/**
 * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
 * @param {String} title: "Title"
 * @param {String} defaultTitle: "Default Title"
 * @param {String} titleTemplate: "MySite.com - %s"
 * @param {Object} titleAttributes: {"itemprop": "name"}
 * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
 * @param {Array} meta: [{"name": "description", "content": "Test description"}]
 * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
 * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
 * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
 * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
 * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
 */
var Helmet = function Helmet(WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        _inherits(HelmetWrapper, _Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
        }

        _createClass(HelmetWrapper, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var props = _extends({}, nextProps);
                if (!props.children || !props.children.length) {
                    delete props.children;
                }
                return !(0, _deepEqual2.default)(this.props, props);
            }
        }, {
            key: "render",
            value: function render() {
                return (0, _preact.h)(WrappedComponent, this.props);
            }
        }], [{
            key: "canUseDOM",

            // WrappedComponent.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.
            set: function set(canUseDOM) {
                WrappedComponent.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_preact.Component), _class.peek = WrappedComponent.peek, _class.rewind = function () {
        var mappedState = WrappedComponent.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                htmlAttributes: {},
                title: "",
                titleAttributes: {},
                baseTag: [],
                metaTags: [],
                linkTags: [],
                scriptTags: [],
                noscriptTags: [],
                styleTags: []
            });
        }

        return mappedState;
    }, _temp;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        onChangeClientState: getOnChangeClientState(propsList)
    };
};

var handleClientStateChange = function handleClientStateChange(newState) {
    var htmlAttributes = newState.htmlAttributes,
        title = newState.title,
        titleAttributes = newState.titleAttributes,
        baseTag = newState.baseTag,
        metaTags = newState.metaTags,
        linkTags = newState.linkTags,
        scriptTags = newState.scriptTags,
        noscriptTags = newState.noscriptTags,
        styleTags = newState.styleTags,
        onChangeClientState = newState.onChangeClientState;

    updateAttributes("html", htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;

        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    onChangeClientState(newState, addedTags, removedTags);
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _preactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

exports.default = Helmet(HelmetSideEffects);
module.exports = exports["default"];

/***/ }),

/***/ "FNy/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = throttle;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "FS7x":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("yeFe");

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

/***/ }),

/***/ "FcUr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FlatButton = __webpack_require__("laFM");

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _FlatButton2.default;

/***/ }),

/***/ "FfP1":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("5VJ8");
var defineProperty = __webpack_require__("y7Dx").f;
var createNonEnumerableProperty = __webpack_require__("yNEm");
var hasOwn = __webpack_require__("J3pj");
var toString = __webpack_require__("VmVQ");
var wellKnownSymbol = __webpack_require__("G69i");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!hasOwn(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty(target, 'toString', toString);
    }
  }
};

/***/ }),

/***/ "Fg8D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"activity":"activity__3P7K0","type":"type__3ZM0u","icon":"icon__1Ep5D","typeBold":"typeBold__vIlSQ","count":"count__30owx","countRed":"countRed__3vxyG","contact":"contact__zs0xP","profession":"profession__1aKgn","date":"date__3-zRj","avatar":"avatar__2wHXS","call":"call__3LRvR","info":"info__2e8TY","relatedActivities":"relatedActivities__3aU3-","expanded":"expanded__2htpp","container":"container__1QZRz","relatedTitle":"relatedTitle__3X9cR","related":"related__2G23S","relatedDate":"relatedDate__mLnxt"};

/***/ }),

/***/ "Fi9R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__("TyWm");
var define = __webpack_require__("VxKF");

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};

/***/ }),

/***/ "G69i":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var shared = __webpack_require__("2112");
var hasOwn = __webpack_require__("J3pj");
var uid = __webpack_require__("MCkq");
var NATIVE_SYMBOL = __webpack_require__("qR+x");
var USE_SYMBOL_AS_UID = __webpack_require__("HGpA");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  }return WellKnownSymbolsStore[name];
};

/***/ }),

/***/ "G96k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__("QXNG");

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "GLIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserInfo", function() { return BrowserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NodeInfo", function() { return NodeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SearchBotDeviceInfo", function() { return SearchBotDeviceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BotInfo", function() { return BotInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactNativeInfo", function() { return ReactNativeInfo; });
/* harmony export (immutable) */ __webpack_exports__["detect"] = detect;
/* harmony export (immutable) */ __webpack_exports__["browserName"] = browserName;
/* harmony export (immutable) */ __webpack_exports__["parseUserAgent"] = parseUserAgent;
/* harmony export (immutable) */ __webpack_exports__["detectOS"] = detectOS;
/* harmony export (immutable) */ __webpack_exports__["getNodeVersion"] = getNodeVersion;
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var BrowserInfo = /** @class */function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = 'browser';
    }
    return BrowserInfo;
}();

var NodeInfo = /** @class */function () {
    function NodeInfo(version) {
        this.version = version;
        this.type = 'node';
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}();

var SearchBotDeviceInfo = /** @class */function () {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = 'bot-device';
    }
    return SearchBotDeviceInfo;
}();

var BotInfo = /** @class */function () {
    function BotInfo() {
        this.type = 'bot';
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();

var ReactNativeInfo = /** @class */function () {
    function ReactNativeInfo() {
        this.type = 'react-native';
        this.name = 'react-native';
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();

// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [['aol', /AOLShield\/([0-9\._]+)/], ['edge', /Edge\/([0-9\._]+)/], ['edge-ios', /EdgiOS\/([0-9\._]+)/], ['yandexbrowser', /YaBrowser\/([0-9\._]+)/], ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/], ['samsung', /SamsungBrowser\/([0-9\.]+)/], ['silk', /\bSilk\/([0-9._-]+)\b/], ['miui', /MiuiBrowser\/([0-9\.]+)$/], ['beaker', /BeakerBrowser\/([0-9\.]+)/], ['edge-chromium', /EdgA?\/([0-9\.]+)/], ['chromium-webview', /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/], ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/], ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/], ['fxios', /FxiOS\/([0-9\.]+)/], ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/], ['opera', /Opera\/([0-9\.]+)(?:\s|$)/], ['opera', /OPR\/([0-9\.]+)(:?\s|$)/], ['pie', /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/], ['pie', /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/], ['netfront', /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/], ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/], ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ['ie', /MSIE\s(7\.0)/], ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/], ['android', /Android\s([0-9\.]+)/], ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/], ['safari', /Version\/([0-9\._]+).*Safari/], ['facebook', /FB[AS]V\/([0-9\.]+)/], ['instagram', /Instagram\s([0-9\.]+)/], ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/], ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/], ['curl', /^curl\/([0-9\.]+)$/], ['searchbot', SEARCHBOX_UA_REGEX]];
var operatingSystemRules = [['iOS', /iP(hone|od|ad)/], ['Android OS', /Android/], ['BlackBerry OS', /BlackBerry|BB10/], ['Windows Mobile', /IEMobile/], ['Amazon OS', /Kindle/], ['Windows 3.11', /Win16/], ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/], ['Windows 98', /(Windows 98)|(Win98)/], ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/], ['Windows XP', /(Windows NT 5.1)|(Windows XP)/], ['Windows Server 2003', /(Windows NT 5.2)/], ['Windows Vista', /(Windows NT 6.0)/], ['Windows 7', /(Windows NT 6.1)/], ['Windows 8', /(Windows NT 6.2)/], ['Windows 8.1', /(Windows NT 6.3)/], ['Windows 10', /(Windows NT 10.0)/], ['Windows ME', /Windows ME/], ['Windows CE', /Windows CE|WinCE|Microsoft Pocket Internet Explorer/], ['Open BSD', /OpenBSD/], ['Sun OS', /SunOS/], ['Chrome OS', /CrOS/], ['Linux', /(Linux)|(X11)/], ['Mac OS', /(Mac_PowerPC)|(Macintosh)/], ['QNX', /QNX/], ['BeOS', /BeOS/], ['OS/2', /OS\/2/]];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof document === 'undefined' && typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
        return new ReactNativeInfo();
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
function matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== '' && userAgentRules.reduce(function (matched, _a) {
        var browser = _a[0],
            regex = _a[1];
        if (matched) {
            return matched;
        }
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [browser, uaMatch];
    }, false);
}
function browserName(ua) {
    var data = matchUserAgent(ua);
    return data ? data[0] : null;
}
function parseUserAgent(ua) {
    var matchedRule = matchUserAgent(ua);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0],
        match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = __spreadArray(__spreadArray([], versionParts, true), createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length), true);
        }
    } else {
        versionParts = [];
    }
    var version = versionParts.join('.');
    var os = detectOS(ua);
    var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) {
        return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
    }
    return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii],
            os = _a[0],
            regex = _a[1];
        var match = regex.exec(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}

/***/ }),

/***/ "GT3O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__("eW0v");

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ "GZ/G":
/***/ (function(module, exports) {

/*
WildEmitter.js is a slim little event emitter by @henrikjoreteg largely based
on @visionmedia's Emitter from UI Kit.

Why? I wanted it standalone.

I also wanted support for wildcard emitters like this:

emitter.on('*', function (eventName, other, event, payloads) {

});

emitter.on('somenamespace*', function (eventName, payloads) {

});

Please note that callbacks triggered by wildcard registered events also get
the event name as the first argument.
*/

module.exports = WildEmitter;

function WildEmitter() {}

WildEmitter.mixin = function (constructor) {
    var prototype = constructor.prototype || constructor;

    prototype.isWildEmitter = true;

    // Listen on the given `event` with `fn`. Store a group name if present.
    prototype.on = function (event, groupName, fn) {
        this.callbacks = this.callbacks || {};
        var hasGroup = arguments.length === 3,
            group = hasGroup ? arguments[1] : undefined,
            func = hasGroup ? arguments[2] : arguments[1];
        func._groupName = group;
        (this.callbacks[event] = this.callbacks[event] || []).push(func);
        return this;
    };

    // Adds an `event` listener that will be invoked a single
    // time then automatically removed.
    prototype.once = function (event, groupName, fn) {
        var self = this,
            hasGroup = arguments.length === 3,
            group = hasGroup ? arguments[1] : undefined,
            func = hasGroup ? arguments[2] : arguments[1];
        function on() {
            self.off(event, on);
            func.apply(this, arguments);
        }
        this.on(event, group, on);
        return this;
    };

    // Unbinds an entire group
    prototype.releaseGroup = function (groupName) {
        this.callbacks = this.callbacks || {};
        var item, i, len, handlers;
        for (item in this.callbacks) {
            handlers = this.callbacks[item];
            for (i = 0, len = handlers.length; i < len; i++) {
                if (handlers[i]._groupName === groupName) {
                    //console.log('removing');
                    // remove it and shorten the array we're looping through
                    handlers.splice(i, 1);
                    i--;
                    len--;
                }
            }
        }
        return this;
    };

    // Remove the given callback for `event` or all
    // registered callbacks.
    prototype.off = function (event, fn) {
        this.callbacks = this.callbacks || {};
        var callbacks = this.callbacks[event],
            i;

        if (!callbacks) return this;

        // remove all handlers
        if (arguments.length === 1) {
            delete this.callbacks[event];
            return this;
        }

        // remove specific handler
        i = callbacks.indexOf(fn);
        if (i !== -1) {
            callbacks.splice(i, 1);
            if (callbacks.length === 0) {
                delete this.callbacks[event];
            }
        }
        return this;
    };

    /// Emit `event` with the given args.
    // also calls any `*` handlers
    prototype.emit = function (event) {
        this.callbacks = this.callbacks || {};
        var args = [].slice.call(arguments, 1),
            callbacks = this.callbacks[event],
            specialCallbacks = this.getWildcardCallbacks(event),
            i,
            len,
            item,
            listeners;

        if (callbacks) {
            listeners = callbacks.slice();
            for (i = 0, len = listeners.length; i < len; ++i) {
                if (!listeners[i]) {
                    break;
                }
                listeners[i].apply(this, args);
            }
        }

        if (specialCallbacks) {
            len = specialCallbacks.length;
            listeners = specialCallbacks.slice();
            for (i = 0, len = listeners.length; i < len; ++i) {
                if (!listeners[i]) {
                    break;
                }
                listeners[i].apply(this, [event].concat(args));
            }
        }

        return this;
    };

    // Helper for for finding special wildcard event handlers that match the event
    prototype.getWildcardCallbacks = function (eventName) {
        this.callbacks = this.callbacks || {};
        var item,
            split,
            result = [];

        for (item in this.callbacks) {
            split = item.split('*');
            if (item === '*' || split.length === 2 && eventName.slice(0, split[0].length) === split[0]) {
                result = result.concat(this.callbacks[item]);
            }
        }
        return result;
    };
};

WildEmitter.mixin(WildEmitter);

/***/ }),

/***/ "GZef":
/***/ (function(module, exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__("yNEm");

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;else createNonEnumerableProperty(target, key, value);
};

/***/ }),

/***/ "Gfzd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("zotD");
var IE8_DOM_DEFINE = __webpack_require__("R6c1");
var toPrimitive = __webpack_require__("EKwp");
var dP = Object.defineProperty;

exports.f = __webpack_require__("6MLN") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "GhPB":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var call = __webpack_require__("HiG7");
var isCallable = __webpack_require__("yeFe");
var isObject = __webpack_require__("FS7x");

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "GyB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("6t7t");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("ibPW");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "H+qL":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("qvVx");
var uncurryThis = __webpack_require__("PoOm");
var getOwnPropertyNamesModule = __webpack_require__("kUlY");
var getOwnPropertySymbolsModule = __webpack_require__("SN69");
var anObject = __webpack_require__("1kal");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

/***/ }),

/***/ "H2mZ":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__("u82x");

/***/ }),

/***/ "H70G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dateLeft).getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dateRight).getTime();
}

/***/ }),

/***/ "HGpA":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("qR+x");

module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';

/***/ }),

/***/ "HHE0":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("yS17");
var toObject = __webpack_require__("mbLO");
var IE_PROTO = __webpack_require__("/wuY")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),

/***/ "HXaG":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};

/***/ }),

/***/ "HiG7":
/***/ (function(module, exports) {

var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};

/***/ }),

/***/ "HtdO":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("RA6A");
var call = __webpack_require__("HiG7");
var propertyIsEnumerableModule = __webpack_require__("vkXE");
var createPropertyDescriptor = __webpack_require__("v6/v");
var toIndexedObject = __webpack_require__("M0Be");
var toPropertyKey = __webpack_require__("D38D");
var hasOwn = __webpack_require__("J3pj");
var IE8_DOM_DEFINE = __webpack_require__("DSHT");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) {/* empty */}
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

/***/ }),

/***/ "ID6i":
/***/ (function(module, exports) {

module.exports = function () {/* empty */};

/***/ }),

/***/ "IJ/8":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function check(it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
// eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
// eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof global == 'object' && global) ||
// eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "Ihp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleName; });
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectSignUpPendingActivation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectSignUpProcessing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectSignUpError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectSignUpSaved; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("vyGZ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var moduleName = 'signUp';

// Reducer (down)

var initialState = {
  pendingActivation: false,
  processing: false,
  error: '',
  saved: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var error = action.error,
      type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_UP_REGISTER_REQUEST:
      {
        var params = payload.params;


        return _extends({}, state, {
          processing: true,
          error: initialState.error,
          pendingActivation: false,
          saved: _extends({}, params)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_UP_REGISTER_SUCCESS:
      return _extends({}, state, {
        processing: false,
        error: initialState.error,
        pendingActivation: true
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_UP_REGISTER_FAILURE:
      return _extends({}, state, {
        processing: false,
        error: error || 'Unknown error',
        pendingActivation: false
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_UP_RESET:
      return _extends({}, initialState);

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

var stateSelector = function stateSelector(state) {
  return state[moduleName];
};

var selectSignUpPendingActivation = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (signUp) {
  return signUp.pendingActivation;
});

var selectSignUpProcessing = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (signUp) {
  return signUp.processing;
});

var selectSignUpError = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (signUp) {
  return signUp.error;
});

var selectSignUpSaved = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (signUp) {
  return signUp.saved;
});

// Selectors (up)

/***/ }),

/***/ "IsmX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__("S6J3");

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__("QXNG");

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__("/eMc");

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};

var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "IuuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__("2kK6");

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ "IyTP":
/***/ (function(module, exports, __webpack_require__) {

var replaceEmoji = __webpack_require__("Ewv8"),
    makeTwemojiRenderer = __webpack_require__("U7BB");

module.exports = function reactEasyEmoji(element, optionsOrFn) {
	var render = typeof optionsOrFn === 'function' ? optionsOrFn : makeTwemojiRenderer(optionsOrFn);
	return replaceEmoji(element, render);
};

/***/ }),

/***/ "J3pj":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");
var toObject = __webpack_require__("Nvz5");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

/***/ }),

/***/ "J4Nk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(_extends({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),

/***/ "J7oX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ./actions/index.js
var actions = __webpack_require__("vyGZ");

// EXTERNAL MODULE: ./api/fetch-wrapper.js
var fetch_wrapper = __webpack_require__("ds2O");

// EXTERNAL MODULE: ./api/index.js
var api = __webpack_require__("/C1n");

// CONCATENATED MODULE: ./api/security.js



function resetPost(params) {
  var headers = new Headers();

  headers.append('Content-Type', 'application/json ');

  var requestOptions = { method: 'POST', headers: headers, body: JSON.stringify(params) };

  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].SECURITY_RESET, requestOptions);
}

function resetPut(params) {
  var headers = new Headers();

  headers.append('Content-Type', 'application/json ');

  var requestOptions = { method: 'PUT', headers: headers, body: JSON.stringify(params) };

  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].SECURITY_RESET, requestOptions);
}
// EXTERNAL MODULE: ./components/app.js + 53 modules
var app = __webpack_require__("qLaj");

// EXTERNAL MODULE: ./reducers/forgotPassword.js
var forgotPassword = __webpack_require__("8TP0");

// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// CONCATENATED MODULE: ./actions/forgotPassword.js
/* harmony export (immutable) */ __webpack_exports__["a"] = forgotPasswordPost;
/* harmony export (immutable) */ __webpack_exports__["c"] = forgotPasswordSetResettingMode;
/* harmony export (immutable) */ __webpack_exports__["b"] = forgotPasswordReset;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// eslint-disable-next-line import/no-cycle




function forgotPasswordPost(params) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var _ref, message;

      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (_ref2) {
        try {
          message = _ref2.message;

          dispatch(forgotPasswordPostFailure(message));
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({
          type: actions["a" /* actionTypes */].FORGOT_PASSWORD_POST_REQUEST,
          payload: { params: params }
        });

        return Promise.resolve(resetPost(params)).then(function ($await_3) {
          try {
            _ref = $await_3, message = _ref.message;


            dispatch(forgotPasswordPostSuccess(message));
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (_ref2) {
        $Try_1_Catch(_ref2)
      }
    });
  };
}

function forgotPasswordPostSuccess(successMessage) {
  return {
    type: actions["a" /* actionTypes */].FORGOT_PASSWORD_POST_SUCCESS,
    payload: { successMessage: successMessage }
  };
}

function forgotPasswordPostFailure(error) {
  return {
    error: error,
    type: actions["a" /* actionTypes */].FORGOT_PASSWORD_POST_FAILURE
  };
}

function forgotPasswordSetResettingMode(resettingParams) {
  return function (dispatch) {
    dispatch({
      type: actions["a" /* actionTypes */].FORGOT_PASSWORD_SET_RESETTING_MODE,
      payload: { resettingParams: resettingParams }
    });

    Object(preact_router_es["route"])(app["routes"].FORGOT_PASSWORD);
  };
}

function forgotPasswordReset(params) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var resettingParams, _ref3, message;

      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_2_Catch = function (_ref4) {
        try {
          message = _ref4.message;

          dispatch(forgotPasswordResetFailure(message));
          return $Try_2_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({
          type: actions["a" /* actionTypes */].FORGOT_PASSWORD_RESET_REQUEST,
          payload: { params: params }
        });

        resettingParams = Object(forgotPassword["g" /* selectForgotPasswordResettingParams */])(getState());

        return Promise.resolve(resetPut(_extends({}, resettingParams, params, {
          tokenType: consts["x" /* TOKEN_TYPES */].RESET_PASSWORD
        }))).then(function ($await_4) {
          try {
            _ref3 = $await_4, message = _ref3.message;


            dispatch(forgotPasswordResetSuccess(message));
            return $Try_2_Post();
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (_ref4) {
        $Try_2_Catch(_ref4)
      }
    });
  };
}

function forgotPasswordResetSuccess(successMessage) {
  return {
    type: actions["a" /* actionTypes */].FORGOT_PASSWORD_RESET_SUCCESS,
    payload: { successMessage: successMessage }
  };
}

function forgotPasswordResetFailure(error) {
  return {
    error: error,
    type: actions["a" /* actionTypes */].FORGOT_PASSWORD_RESET_FAILURE
  };
}

/***/ }),

/***/ "JAZJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("FNy/");

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__("lkHq");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },

  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),

/***/ "JBx7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (muiTheme) {
  var isClient = typeof navigator !== 'undefined';
  var userAgent = muiTheme.userAgent;

  if (userAgent === undefined && isClient) {
    userAgent = navigator.userAgent;
  }

  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;

    hasWarnedAboutUserAgent = true;
  }

  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);

  if (userAgent === false) {
    // Disabled autoprefixer
    return null;
  } else if (userAgent === 'all' || userAgent === undefined) {
    // Prefix for all user agent
    return function (style) {
      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
      var stylePrefixed = prefixAll(style);

      if (isFlex) {
        var display = stylePrefixed.display;
        if (isClient) {
          // We can't apply this join with react-dom:
          // #https://github.com/facebook/react/issues/6467
          stylePrefixed.display = display[display.length - 1];
        } else {
          stylePrefixed.display = display.join('; display: ');
        }
      }

      return stylePrefixed;
    };
  } else {
    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
    var prefixer = new Prefixer({
      userAgent: userAgent
    });

    return function (style) {
      return prefixer.prefix(style);
    };
  }
};

var _createPrefixer = __webpack_require__("UU8C");

var _createPrefixer2 = _interopRequireDefault(_createPrefixer);

var _createPrefixer3 = __webpack_require__("dYQv");

var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);

var _autoprefixerDynamic = __webpack_require__("+BPH");

var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);

var _autoprefixerStatic = __webpack_require__("uGKn");

var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);

var _warning = __webpack_require__("/sXU");

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var hasWarnedAboutUserAgent = false;

/***/ }),

/***/ "JFC8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var retry = __webpack_require__("yi9p");

var networkErrorMsgs = ['Failed to fetch', // Chrome
'NetworkError when attempting to fetch resource.', // Firefox
'The Internet connection appears to be offline.', // Safari
'Network request failed' // `cross-fetch`
];

var AbortError = function (_Error) {
	_inherits(AbortError, _Error);

	function AbortError(message) {
		_classCallCheck(this, AbortError);

		var _this = _possibleConstructorReturn(this, _Error.call(this));

		if (message instanceof Error) {
			_this.originalError = message;
			var _message = message;
			message = _message.message;
		} else {
			_this.originalError = new Error(message);
			_this.originalError.stack = _this.stack;
		}

		_this.name = 'AbortError';
		_this.message = message;
		return _this;
	}

	return AbortError;
}(Error);

var decorateErrorWithCounts = function decorateErrorWithCounts(error, attemptNumber, options) {
	// Minus 1 from attemptNumber because the first attempt does not count as a retry
	var retriesLeft = options.retries - (attemptNumber - 1);

	error.attemptNumber = attemptNumber;
	error.retriesLeft = retriesLeft;
	return error;
};

var isNetworkError = function isNetworkError(errorMessage) {
	return networkErrorMsgs.includes(errorMessage);
};

var pRetry = function pRetry(input, options) {
	return new Promise(function (resolve, reject) {
		options = _extends({
			onFailedAttempt: function onFailedAttempt() {},
			retries: 10
		}, options);

		var operation = retry.operation(options);

		operation.attempt(function (attemptNumber) {
			return new Promise(function ($return, $error) {
				var $Try_1_Post = function () {
					try {
						return $return();
					} catch ($boundEx) {
						return $error($boundEx);
					}
				};var $Try_1_Catch = function (error) {
					try {
						if (!(error instanceof Error)) {
							reject(new TypeError('Non-error was thrown: "' + error + '". You should only throw errors.'));
							return $return();
						}

						if (error instanceof AbortError) {
							operation.stop();
							reject(error.originalError);
							return $If_3.call(this);
						} else {
							if (error instanceof TypeError && !isNetworkError(error.message)) {
								operation.stop();
								reject(error);
								return $If_4.call(this);
							} else {
								decorateErrorWithCounts(error, attemptNumber, options);

								var $Try_2_Post = function () {
									try {

										if (!operation.retry(error)) {
											reject(operation.mainError());
										}
										return $If_4.call(this);
									} catch ($boundEx) {
										return $error($boundEx);
									}
								}.bind(this);var $Try_2_Catch = function (error) {
									try {
										reject(error);
										return $return();
									} catch ($boundEx) {
										return $error($boundEx);
									}
								};try {
									return Promise.resolve(options.onFailedAttempt(error)).then(function ($await_5) {
										try {
											return $Try_2_Post();
										} catch ($boundEx) {
											return $Try_2_Catch($boundEx);
										}
									}, $Try_2_Catch);
								} catch (error) {
									$Try_2_Catch(error)
								}
							}

							function $If_4() {
								return $If_3.call(this);
							}
						}
						function $If_3() {
							return $Try_1_Post();
						}
					} catch ($boundEx) {
						return $error($boundEx);
					}
				}.bind(this);
				try {
					return Promise.resolve(input(attemptNumber)).then(function ($await_6) {
						try {
							resolve($await_6);
							return $Try_1_Post();
						} catch ($boundEx) {
							return $Try_1_Catch($boundEx);
						}
					}, $Try_1_Catch);
				} catch (error) {
					$Try_1_Catch(error)
				}
			});
		});
	});
};

module.exports = pRetry;
// TODO: remove this in the next major version
module.exports.default = pRetry;

module.exports.AbortError = AbortError;

/***/ }),

/***/ "JMpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_NOTIFICATION_TYPE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_compat__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_langPack__ = __webpack_require__("9dRJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_scss__ = __webpack_require__("FAW1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_scss__);

/** @jsx h */






var API_NOTIFICATION_TYPE = {
  SUCCESS: 'success',
  DANGER: 'danger',
  INFO: 'info',
  DEFAULT: 'default',
  WARNING: 'warning'
};

var APINotifications = function APINotifications(_ref) {
  var reloadRequired = _ref.reloadRequired,
      type = _ref.type,
      iconClassName = _ref.iconClassName,
      message = _ref.message,
      locale = _ref.locale;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a['notification-custom-' + type] },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a['notification-custom-icon-wrap'] },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('i', { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a['notification-custom-icon'] + ' ' + iconClassName })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a['notification-custom-content'] },
      reloadRequired ? [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a['notification-custom-message'] + ' notification-message' },
        __WEBPACK_IMPORTED_MODULE_2__utils_langPack__["a" /* langPack */][locale].API.NOTIFICATION_MESSAGE
      ), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a['notification-custom-message-small'] + ' notification-message' },
        message
      )] : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a['notification-custom-message'] + ' notification-message' },
        message
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["b"] = (APINotifications);

/***/ }),

/***/ "JOB+":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};

/***/ }),

/***/ "JZ8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),

/***/ "JZvF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ec535ad1d82af9d80b116e3637d9c937.png";

/***/ }),

/***/ "JbHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__("2kK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__("sFsT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__ = __webpack_require__("VYL5");



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/core-js-pure/features/promise/index.js
var promise = __webpack_require__("uvux");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ../node_modules/material-ui/styles/MuiThemeProvider.js
var MuiThemeProvider = __webpack_require__("u8U4");
var MuiThemeProvider_default = /*#__PURE__*/__webpack_require__.n(MuiThemeProvider);

// EXTERNAL MODULE: ../node_modules/material-ui/styles/getMuiTheme.js
var getMuiTheme = __webpack_require__("AsRs");
var getMuiTheme_default = /*#__PURE__*/__webpack_require__.n(getMuiTheme);

// EXTERNAL MODULE: ../node_modules/@bugfender/sdk/lib/index.js
var lib = __webpack_require__("FFyX");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ../node_modules/uikit/dist/js/uikit.js
var uikit = __webpack_require__("k+5J");
var uikit_default = /*#__PURE__*/__webpack_require__.n(uikit);

// EXTERNAL MODULE: ../node_modules/uikit/dist/js/uikit-icons.js
var uikit_icons = __webpack_require__("dwtN");
var uikit_icons_default = /*#__PURE__*/__webpack_require__.n(uikit_icons);

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// CONCATENATED MODULE: ./components/global/supported-browser/index.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */

// eslint-disable-next-line no-unused-vars



var SupportedBrowserProvider = function (_Component) {
  _inherits(SupportedBrowserProvider, _Component);

  function SupportedBrowserProvider() {
    _classCallCheck(this, SupportedBrowserProvider);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  SupportedBrowserProvider.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        isSupportedBrowser = _props.isSupportedBrowser,
        isSupportedOS = _props.isSupportedOS;

    return { isSupportedBrowser: isSupportedBrowser, isSupportedOS: isSupportedOS };
  };

  SupportedBrowserProvider.prototype.render = function render() {
    var children = this.props.children;

    return children[0];
  };

  return SupportedBrowserProvider;
}(preact_min["Component"]);




SupportedBrowserProvider.childContextTypes = {
  isSupportedBrowser: preact_compat_es["PropTypes"].bool.isRequired,
  isSupportedOS: preact_compat_es["PropTypes"].bool.isRequired
};
// EXTERNAL MODULE: ../node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__("fpuT");

// CONCATENATED MODULE: ../node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var redux_thunk_es = (thunk);
// EXTERNAL MODULE: ../node_modules/redux-devtools-extension/index.js
var redux_devtools_extension = __webpack_require__("yP4S");
var redux_devtools_extension_default = /*#__PURE__*/__webpack_require__.n(redux_devtools_extension);

// EXTERNAL MODULE: ../node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__("XYJE");
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);

// EXTERNAL MODULE: ./reducers/user.js
var user = __webpack_require__("XZs+");

// EXTERNAL MODULE: ./actions/index.js
var actions = __webpack_require__("vyGZ");

// CONCATENATED MODULE: ./reducers/pros.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var pros_initialState = {
  pros: [],
  sortBy: 'activity',
  searchTerm: '',
  page: 1,
  loading: false,
  total: 0,
  featuredServices: []
};

/* harmony default export */ var pros = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _extends({}, pros_initialState);
  var action = arguments[1];

  switch (action.type) {
    case actions["a" /* actionTypes */].GET_PROS_SUCCESS:
      return _extends({}, state, {
        pros: action.payload.results,
        loading: false,
        total: action.payload.total,
        featuredServices: action.payload.featuredServices
      });
    case actions["a" /* actionTypes */].SIGN_IN_PUT_RESPONSE:
    case actions["a" /* actionTypes */].UPDATE_USER_SETTINGS_SUCCESS:
      {
        var _action$payload = action.payload,
            userSettings = _action$payload.settings,
            userData = _action$payload.userData;


        var settings = userData ? userData.settings : userSettings;
        var sector = settings && settings.interestSector[0];
        var category = settings && settings.interestCategory[0];

        return _extends({}, state, {
          filter: !state.filter && sector ? '' + sector + (category ? '.' + category : '') : state.filter
        });
      }

    case actions["a" /* actionTypes */].GET_PROS:
      return _extends({}, state, {
        loading: true,
        featuredServices: []
      });
    case actions["a" /* actionTypes */].RESET_PRO_SEARCH_PARAMS:
      return _extends({}, state, pros_initialState);
    case actions["a" /* actionTypes */].SET_PRO_SEARCH_PARAMS:
      {
        var _extends2;

        var type = action.payload.type;

        var resetPage = type !== 'page' && state.page !== 1;

        return _extends({}, state, (_extends2 = {
          page: resetPage ? 1 : state.page
        }, _extends2[action.payload.type] = action.payload.value, _extends2));
      }
    case actions["a" /* actionTypes */].LOGGED_OFF:
      return _extends({}, pros_initialState);
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./reducers/calls.js
var calls__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var calls_initialState = {
  activity: [],
  sortBy: 'date',
  searchTerm: '',
  page: 1,
  loading: false,
  total: 0
};

/* harmony default export */ var calls = (function () {
  var _extends2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : calls__extends({}, calls_initialState);
  var action = arguments[1];

  switch (action.type) {

    case actions["a" /* actionTypes */].GET_USER_ACTIVITY_SUCCESS:
      return calls__extends({}, state, {
        activity: action.payload.results,
        loading: false,
        total: action.payload.total
      });
    case actions["a" /* actionTypes */].GET_USER_ACTIVITY:
      return calls__extends({}, state, {
        loading: action.shouldBeReloaded
      });
    case actions["a" /* actionTypes */].RESET_ACTIVITY_SEARCH_PARAMS:
      return calls__extends({}, calls_initialState);
    case actions["a" /* actionTypes */].SET_ACTIVITY_SEARCH_PARAMS:
      var type = action.payload.type;
      var resetPage = type !== 'page' && state.page !== 1;
      return calls__extends({}, state, (_extends2 = {
        page: resetPage ? 1 : state.page
      }, _extends2[type] = action.payload.value, _extends2));
    case actions["a" /* actionTypes */].LOGGED_OFF:
      return calls__extends({}, calls_initialState);
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./reducers/userDetails.js
var userDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var userDetails_initialState = {
  user: {},
  loading: false
};

/* harmony default export */ var userDetails = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userDetails__extends({}, userDetails_initialState);
  var action = arguments[1];

  switch (action.type) {
    case actions["a" /* actionTypes */].GET_USER_DETAILS:
      return userDetails__extends({}, state, {
        loading: true
      });
    case actions["a" /* actionTypes */].GET_USER_DETAILS_SUCCESS:
      return userDetails__extends({}, state, {
        user: action.payload,
        loading: false
      });
    case actions["a" /* actionTypes */].RESET_USER_DETAILS:
      return userDetails__extends({}, userDetails_initialState);
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./reducers/url.js
var url__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var url_initialState = {
  url: ''
};

/* harmony default export */ var url = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : url__extends({}, url_initialState);
  var action = arguments[1];

  switch (action.type) {
    case actions["a" /* actionTypes */].SET_URL:
      return url__extends({}, state, {
        url: action.payload
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./reducers/chat.js
var chat = __webpack_require__("OTa1");

// CONCATENATED MODULE: ./reducers/wallet.js
var wallet__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialCreditCards = {
	cards: [],
	error: false,
	loading: false
};

var wallet_creditCards = function creditCards() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : wallet__extends({}, initialCreditCards);
	var action = arguments[1];

	switch (action.type) {

		case actions["a" /* actionTypes */].MODIFYING_CARDS:
			return wallet__extends({}, state, {
				cards: [],
				loading: true,
				error: false,
				errorMsg: ''
			});
		case actions["a" /* actionTypes */].GETING_CARDS_SUCCESS:
			return wallet__extends({}, state, {
				cards: action.cards,
				loading: false
			});
		case actions["a" /* actionTypes */].GETING_CARDS_FAILURE:
			return wallet__extends({}, state, {
				error: true,
				errorMsg: action.message,
				loading: false
			});
		case actions["a" /* actionTypes */].LOGGED_OFF:
			return wallet__extends({}, initialCreditCards);

		default:
			return state;
	}
};

var wallet_bankAccount = function bankAccount() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { banks: [], error: false, loading: false };
	var action = arguments[1];

	switch (action.type) {

		case actions["a" /* actionTypes */].MODIFYING_BANKS:
			return wallet__extends({}, state, {
				banks: [],
				loading: true,
				error: false,
				errorMsg: ''
			});
		case actions["a" /* actionTypes */].GETING_BANKS_SUCCESS:
			return wallet__extends({}, state, {
				banks: action.banks,
				loading: false
			});
		case actions["a" /* actionTypes */].GETING_BANKS_FAILURE:
			return wallet__extends({}, state, {
				error: true,
				errorMsg: action.message,
				loading: false
			});

		case actions["a" /* actionTypes */].VERIFICATION_ID_UPLOADED:
			return wallet__extends({}, state, {
				verificationIdComplete: true,
				verificationIdError: ''
			});
		case actions["a" /* actionTypes */].VERIFICATION_ID_UPLOAD_FAILURE:
			return wallet__extends({}, state, {
				verificationIdComplete: false,
				verificationIdError: action.errorMsg
			});
		case actions["a" /* actionTypes */].CHECK_VERIFICATION_ID_SUCCESS:
			return wallet__extends({}, state, {
				verificationIdComplete: true,
				verificationIdError: '',
				status: action.status
			});
		case actions["a" /* actionTypes */].CHECK_VERIFICATION_ID_FAIL:
			return wallet__extends({}, state, {
				verificationIdComplete: false,
				verificationIdError: action.errorMsg
			});
		case actions["a" /* actionTypes */].VERIFICATION_ID_STATUS_RESET:
			return wallet__extends({}, state, {
				verificationIdComplete: false,
				verificationIdError: ''
			});

		default:
			return state;
	}
};

var wallet_stripeToken = function stripeToken() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { token: '' };
	var action = arguments[1];

	switch (action.type) {

		case actions["a" /* actionTypes */].GET_STRIPE_KEY_SUCCESS:
			return wallet__extends({}, state, {
				token: action.payload
			});
		case actions["a" /* actionTypes */].GET_STRIPE_KEY_FAILURE:
			return wallet__extends({}, state, {
				token: ''
			});
		default:
			return state;
	}
};

var topUpInitial = {
	conversionRate: 0,
	firstCardAdded: true,
	telmieBalance: 0,
	topUpPackage: [],
	userCurrency: '',
	paymentMethod: [],
	loading: false
};

var wallet_topUpInfo = function topUpInfo() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : wallet__extends({}, topUpInitial);
	var action = arguments[1];

	switch (action.type) {
		case actions["a" /* actionTypes */].GET_AMOUNTS:
			return wallet__extends({}, state, {
				loading: true
			});
		case actions["a" /* actionTypes */].GET_AMOUNTS_SUCCESS:
			return wallet__extends({}, state, action.payload, {
				loading: false
			});
		case actions["a" /* actionTypes */].GETING_CARDS_SUCCESS:
			return wallet__extends({}, state, {
				paymentMethod: action.cards
			});
		default:
			return state;
	}
};

var wallet_widthdrawInfo = function widthdrawInfo() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	switch (action.type) {
		case actions["a" /* actionTypes */].SEND_WITHDRAW_START:
			return wallet__extends({}, state, {
				error: false,
				loading: true
			});
		case actions["a" /* actionTypes */].SEND_WITHDRAW_SUCCESS:
			return wallet__extends({}, state, {
				widthdrawInfo: action.payload,
				error: false,
				loading: false
			});
		case actions["a" /* actionTypes */].SEND_WITHDRAW_FAILURE:
			return wallet__extends({}, state, {
				widthdrawInfo: action.payload,
				error: true,
				loading: false
			});
		default:
			return state;
	}
};
// CONCATENATED MODULE: ./reducers/sectors.js
var sectors__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var sectors_initialState = {
  sectors: [],
  loading: false,
  error: false
};

/* harmony default export */ var sectors = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sectors__extends({}, sectors_initialState);
  var action = arguments[1];

  switch (action.type) {

    case actions["a" /* actionTypes */].GET_SECTORS_SUCCESS:
      return sectors__extends({}, state, {
        sectors: action.payload.sectors,
        loading: false,
        error: false
      });
    case actions["a" /* actionTypes */].GET_SECTORS_REQUSET:
      return sectors__extends({}, state, {
        loading: true,
        error: false
      });
    case actions["a" /* actionTypes */].GET_SECTORS_FAILURE:
      return {
        sectors: [],
        loading: false,
        error: true
      };
    case actions["a" /* actionTypes */].LOGGED_OFF:
      return sectors__extends({}, sectors_initialState);
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./reducers/featuredService.js
var featuredService__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var featuredService_initialState = {
  services: [],
  service: {},
  agreement: [],
  agreementLoading: false,
  loading: false
};

/* harmony default export */ var featuredService = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : featuredService__extends({}, featuredService_initialState);
  var action = arguments[1];

  switch (action.type) {
    case actions["a" /* actionTypes */].FEATURED_SERVICES:
      return featuredService__extends({}, state);
    case actions["a" /* actionTypes */].FEATURED_SERVICES_SUCCESS:
      return featuredService__extends({}, state, {
        services: action.payload
      });
    case actions["a" /* actionTypes */].FEATURED_SERVICES_FAILURE:
      return featuredService__extends({}, state, {
        error: action.error
      });
    case actions["a" /* actionTypes */].FEATURED_SERVICE:
      return featuredService__extends({}, state, {
        loading: true
      });
    case actions["a" /* actionTypes */].FEATURED_SERVICE_SUCCESS:
      return featuredService__extends({}, state, {
        service: action.payload,
        loading: false
      });
    case actions["a" /* actionTypes */].FEATURED_SERVICE_FAILURE:
      return featuredService__extends({}, state, {
        error: action.error,
        loading: false
      });
    case actions["a" /* actionTypes */].RESET_FEATURED_SERVICE:
      return featuredService__extends({}, state, {
        service: {},
        agreement: []
      });
    case actions["a" /* actionTypes */].FEATURED_AGREEMENT:
      return featuredService__extends({}, state, {
        agreementLoading: true
      });
    case actions["a" /* actionTypes */].FEATURED_AGREEMENT_SUCCESS:
      return featuredService__extends({}, state, {
        agreement: action.payload.results,
        agreementLoading: false
      });
    case actions["a" /* actionTypes */].FEATURED_AGREEMENT_FAILURE:
      return featuredService__extends({}, state, {
        agreementLoading: false
      });
    case actions["a" /* actionTypes */].LOGGED_OFF:
      return featuredService__extends({}, featuredService_initialState);
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./reducers/files.js
var files__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var files_uploadFiles = function uploadFiles() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	switch (action.type) {
		case actions["a" /* actionTypes */].UPLOAD_FILE_REQUSET:
			return files__extends({}, state, {
				uploadFile: null,
				error: false,
				loading: true
			});
		case actions["a" /* actionTypes */].UPLOAD_FILE_SUCCESS:
			return files__extends({}, state, {
				uploadFile: action.payload,
				error: false,
				loading: false
			});
		case actions["a" /* actionTypes */].UPLOAD_FILE_FAILURE:
			return files__extends({}, state, {
				uploadFile: action.payload,
				error: true,
				loading: false
			});
		case actions["a" /* actionTypes */].DELETE_FILE_REQUSET:
			return files__extends({}, state, {
				deleteFile: null,
				error: false,
				loading: true
			});
		case actions["a" /* actionTypes */].DELETE_FILE_SUCCESS:
			return files__extends({}, state, {
				deleteFile: action.payload,
				error: false,
				loading: false
			});
		case actions["a" /* actionTypes */].DELETE_FILE_FAILURE:
			return files__extends({}, state, {
				deleteFile: action.payload,
				error: true,
				loading: false
			});
		default:
			return state;
	}
};
// EXTERNAL MODULE: ./components/api-notifications/index.js
var api_notifications = __webpack_require__("JMpC");

// CONCATENATED MODULE: ./reducers/api-notifications.js



/* harmony default export */ var reducers_api_notifications = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case actions["a" /* actionTypes */].ADD_NOTIFICATION:
      {
        var _payload$reloadRequir = payload.reloadRequired,
            reloadRequired = _payload$reloadRequir === undefined ? true : _payload$reloadRequir,
            iconClassName = payload.iconClassName,
            id = payload.id,
            message = payload.message,
            notificationType = payload.type,
            dismissAfter = payload.dismissAfter;


        return [].concat(state, [{
          reloadRequired: !!reloadRequired,
          id: id,
          message: message,
          iconClassName: iconClassName || 'fa fa-exclamation-circle',
          type: notificationType || api_notifications["a" /* API_NOTIFICATION_TYPE */].DANGER,
          dismissAfter: dismissAfter || 3000
        }]);
      }

    case actions["a" /* actionTypes */].REMOVE_NOTIFICATION:
      {
        var notificationId = payload.notificationId;


        return state.filter(function (notification) {
          return notification.id !== notificationId;
        });
      }

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./reducers/application.js
var application = __webpack_require__("s5UR");

// EXTERNAL MODULE: ./reducers/categories.js
var categories = __webpack_require__("mbma");

// EXTERNAL MODULE: ./reducers/countries.js
var countries = __webpack_require__("ZNi8");

// EXTERNAL MODULE: ./reducers/findPro.js
var findPro = __webpack_require__("vLpE");

// EXTERNAL MODULE: ./reducers/forgotPassword.js
var forgotPassword = __webpack_require__("8TP0");

// EXTERNAL MODULE: ./reducers/message.js
var reducers_message = __webpack_require__("OHc/");

// EXTERNAL MODULE: ./reducers/sign-in.js
var sign_in = __webpack_require__("87tL");

// EXTERNAL MODULE: ./reducers/sign-up.js
var sign_up = __webpack_require__("Ihp6");

// CONCATENATED MODULE: ./reducers/tokenValidation.js
var tokenValidation__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var tokenValidation_initialState = {
  error: false,
  processing: false,
  tokenSuccessfullyVerified: false
};

/* harmony default export */ var tokenValidation = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tokenValidation_initialState;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case actions["a" /* actionTypes */].TOKEN_VALIDATE_REQUEST:
      return tokenValidation__extends({}, state, {
        error: false,
        processing: true,
        tokenSuccessfullyVerified: false
      });

    case actions["a" /* actionTypes */].TOKEN_VALIDATE_SUCCESS:
      return tokenValidation__extends({}, state, {
        error: false,
        processing: false,
        tokenSuccessfullyVerified: true
      });

    case actions["a" /* actionTypes */].TOKEN_VALIDATE_FAILURE:
      return tokenValidation__extends({}, state, {
        error: true,
        processing: false,
        tokenSuccessfullyVerified: false
      });

    case actions["a" /* actionTypes */].TOKEN_VALIDATE_RESET:
      return tokenValidation__extends({}, tokenValidation_initialState);

    default:
      return state;
  }
});
// EXTERNAL MODULE: ./reducers/bookings.js
var bookings = __webpack_require__("w8cn");

// EXTERNAL MODULE: ./reducers/callTimer.js
var callTimer = __webpack_require__("r3yy");

// CONCATENATED MODULE: ./reducers/index.js
var _combineReducers;


























var rootReducer = Object(es["combineReducers"])((_combineReducers = {}, _combineReducers[application["b" /* moduleName */]] = application["a" /* default */], _combineReducers[categories["d" /* moduleName */]] = categories["b" /* default */], _combineReducers[countries["b" /* moduleName */]] = countries["a" /* default */], _combineReducers.findPro = findPro["b" /* default */], _combineReducers[forgotPassword["b" /* moduleName */]] = forgotPassword["a" /* default */], _combineReducers[reducers_message["b" /* moduleName */]] = reducers_message["a" /* default */], _combineReducers.loggedInUser = user["j" /* loggedInUser */], _combineReducers.logInFailure = user["i" /* logInError */], _combineReducers.availability = user["b" /* availability */], _combineReducers.loggedInUserActivity = user["a" /* activity */], _combineReducers.loggedInUserTransactions = user["z" /* transactions */], _combineReducers.registerSuccess = user["n" /* registerSuccess */], _combineReducers.registerFailureMessage = user["m" /* registerFailureMessage */], _combineReducers.verifySuccess = user["D" /* verifySuccess */], _combineReducers.verifyFailure = user["C" /* verifyFailure */], _combineReducers.resetSuccess = user["p" /* resetSuccess */], _combineReducers.resetFailure = user["o" /* resetFailure */], _combineReducers.pendingActivation = user["k" /* pendingActivation */], _combineReducers.sendCodeSuccess = user["x" /* sendCodeSuccess */], _combineReducers.sendCodeFailureMessage = user["w" /* sendCodeFailureMessage */], _combineReducers.verifyCodeSuccess = user["B" /* verifyCodeSuccess */], _combineReducers.verifyCodeFailureMessage = user["A" /* verifyCodeFailureMessage */], _combineReducers.dataFromServer = user["e" /* dataFromServer */], _combineReducers.sendContactMessage = user["y" /* sendContactMessage */], _combineReducers.locale = user["g" /* locale */], _combineReducers.branchIo = user["d" /* branchIo */], _combineReducers[chat["b" /* moduleName */]] = chat["a" /* default */], _combineReducers.creditCards = wallet_creditCards, _combineReducers.bankAccounts = wallet_bankAccount, _combineReducers.stripeToken = wallet_stripeToken, _combineReducers.topUpInfo = wallet_topUpInfo, _combineReducers.widthdrawInfo = wallet_widthdrawInfo, _combineReducers.pros = pros, _combineReducers.calls = calls, _combineReducers.userDetails = userDetails, _combineReducers.url = url, _combineReducers.sectors = sectors, _combineReducers.globalMessage = user["f" /* globalMessage */], _combineReducers.badges = user["c" /* badges */], _combineReducers.featuredService = featuredService, _combineReducers.files = files_uploadFiles, _combineReducers.redirect = user["l" /* redirect */], _combineReducers.notifications = reducers_api_notifications, _combineReducers[sign_in["b" /* moduleName */]] = sign_in["a" /* default */], _combineReducers[sign_up["b" /* moduleName */]] = sign_up["a" /* default */], _combineReducers.tokenValidation = tokenValidation, _combineReducers[bookings["b" /* moduleName */]] = bookings["a" /* default */], _combineReducers[callTimer["b" /* moduleName */]] = callTimer["a" /* default */], _combineReducers));

/* harmony default export */ var reducers = (rootReducer);
// CONCATENATED MODULE: ./store/configure-store.js


// eslint-disable-next-line import/no-extraneous-dependencies





var loggerMiddleware = Object(redux_logger["createLogger"])();
var middlewares = [redux_thunk_es];

if (false) {
  middlewares.push(loggerMiddleware);
}

var configure_store_configureStore = function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var middlewareEnhancer = es["applyMiddleware"].apply(undefined, middlewares);

  var composedEnhancer = Object(redux_devtools_extension["composeWithDevTools"])(middlewareEnhancer);

  return Object(es["createStore"])(reducers, initialState, composedEnhancer);
};

/* harmony default export */ var configure_store = (configure_store_configureStore);
// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// EXTERNAL MODULE: ./style/index.scss
var style = __webpack_require__("yY49");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./services/FireBase.js
var FireBase = __webpack_require__("Vqdy");

// CONCATENATED MODULE: ./index.js

/** @jsx h */
 // To support browsers that do not yet implement Promise.any() and AggregateError




// import * as Sentry from '@sentry/browser';

// eslint-disable-next-line no-unused-vars









FireBase["a" /* default */].initialise();

var _require = __webpack_require__("GLIM"),
    detect = _require.detect;

var browser = detect();

var supportedBrowsers = ['chrome', 'safari', 'ios', 'ios-webview'];
var supportedOperatingSystem = ['Android OS', 'iOS'];

var supported = supportedBrowsers.indexOf(browser.name) >= 0;
var supportedOS = supportedOperatingSystem.indexOf(browser.os) >= 0;

if (supported || supportedOS) /* && process.env.PREACT_APP_ENV === ENVIRONMENTS.PRODUCTION */{
    // Sentry.init({
    //   dsn: process.env.PREACT_APP_SENTRY_DSN,
    //   environment: process.env.PREACT_APP_ENV,
    //   release: `telmie2@${appVersion}`,
    // });
    lib["Bugfender"].init({
      appKey: "hAOjPEu8eRXYzbiPaWKLUYGQ0QoPnCYn",
      overrideConsoleMethods: false,
      version: 'telmie2@' + consts["C" /* appVersion */],
      logBrowserEvents: false,
      logUIEvents: false,
      printToConsole: false
    });
  }

var muiTheme = getMuiTheme_default()({
  palette: {
    primary1Color: '#5d5cf6',
    pickerHeaderColor: '#5d5cf6'
  },
  datePicker: {
    selectColor: '#5d5cf6',
    // calendarYearBackgroundColor: '#5d5cf6',
    headerColor: '#5d5cf6'
  }
});

var index_Index = function Index() {
  uikit_default.a.use(uikit_icons_default.a);
  // eslint-disable-next-line global-require
  var App = __webpack_require__("qLaj").default;

  var result = Object(preact_min["h"])(
    preact_redux_esm["a" /* Provider */],
    { store: configure_store({}) },
    Object(preact_min["h"])(
      MuiThemeProvider_default.a,
      { muiTheme: muiTheme },
      Object(preact_min["h"])(
        SupportedBrowserProvider,
        { isSupportedBrowser: supported, isSupportedOS: supportedOS },
        Object(preact_min["h"])(App, null)
      )
    )
  );
  return result;
};

/* harmony default export */ var index = __webpack_exports__["default"] = (function () {
  return index_Index();
});

/***/ }),

/***/ "JtRT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("T4f3");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("zCAL");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__("i8vT");

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _ScaleInChild = __webpack_require__("Ss7l");

var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var ScaleIn = function (_Component) {
  (0, _inherits3.default)(ScaleIn, _Component);

  function ScaleIn() {
    (0, _classCallCheck3.default)(this, ScaleIn);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleIn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          childStyle = _props.childStyle,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        height: '100%'
      }, style);

      var newChildren = _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(_ScaleInChild2.default, {
          key: child.key,
          enterDelay: enterDelay,
          maxScale: maxScale,
          minScale: minScale,
          style: childStyle
        }, child);
      });

      return _react2.default.createElement(_TransitionGroup2.default, (0, _extends3.default)({}, other, {
        style: prepareStyles(mergedRootStyles),
        component: 'div'
      }), newChildren);
    }
  }]);
  return ScaleIn;
}(_react.Component);

ScaleIn.defaultProps = {
  enterDelay: 0
};
ScaleIn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleIn.propTypes =  false ? {
  childStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ScaleIn;

/***/ }),

/***/ "JteQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var aCallable = __webpack_require__("oOss");

var PromiseCapability = function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),

/***/ "JzUE":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("WMuu");
var global = __webpack_require__("IJ/8");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;

/***/ }),

/***/ "K1uT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("vJ8O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
   'div',
   { className: 'spinner' },
   Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up outer outer-18' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down outer outer-17' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up outer outer-16' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down outer outer-15' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up outer outer-14' })
   ),
   Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up outer outer-1' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down outer outer-2' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up inner inner-6' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down inner inner-5' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up inner inner-4' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down outer outer-13' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up outer outer-12' })
   ),
   Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down outer outer-3' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up outer outer-4' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down inner inner-1' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up inner inner-2' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down inner inner-3' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up outer outer-11' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down outer outer-10' })
   ),
   Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down outer outer-5' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up outer outer-6' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down outer outer-7' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow up outer outer-8' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'arrow down outer outer-9' })
   )
);

var Spinner = function Spinner() {
   return _ref;
};

/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),

/***/ "KB9x":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("RA6A");
var hasOwn = __webpack_require__("J3pj");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KQdW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

  easeOut: function easeOut(duration, property, delay, easeFunction) {
    easeFunction = easeFunction || this.easeOutFunction;

    if (property && Object.prototype.toString.call(property) === '[object Array]') {
      var transitions = '';
      for (var i = 0; i < property.length; i++) {
        if (transitions) transitions += ',';
        transitions += this.create(duration, property[i], delay, easeFunction);
      }

      return transitions;
    } else {
      return this.create(duration, property, delay, easeFunction);
    }
  },
  create: function create(duration, property, delay, easeFunction) {
    duration = duration || '450ms';
    property = property || 'all';
    delay = delay || '0ms';
    easeFunction = easeFunction || 'linear';

    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
  }
};

/***/ }),

/***/ "KYJg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ "Kcid":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAfter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ "Ke8z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__("rQKw");

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      if (value.indexOf('column') > -1) {
        style.WebkitBoxOrient = 'vertical';
      } else {
        style.WebkitBoxOrient = 'horizontal';
      }
      if (value.indexOf('reverse') > -1) {
        style.WebkitBoxDirection = 'reverse';
      } else {
        style.WebkitBoxDirection = 'normal';
      }
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "KpHW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__("jYt2");

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};

/***/ }),

/***/ "Kszl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__("VxKF").supportsDescriptors;
var getPolyfill = __webpack_require__("YWiL");
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};

/***/ }),

/***/ "Ku7I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),

/***/ "KxjL":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),

/***/ "Ky5l":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Aa2f");
__webpack_require__("tuDi");
__webpack_require__("c6mp");
__webpack_require__("2mwf");
module.exports = __webpack_require__("zKeE").Symbol;

/***/ }),

/***/ "LKV3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "995f9654b3b9891589bab910b1c7df1e.jpg";

/***/ }),

/***/ "LLDo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57e314151a4013591c6c47dfd4a3a931.svg";

/***/ }),

/***/ "LNnS":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("Wyka");
var toLength = __webpack_require__("S7IM");
var toAbsoluteIndex = __webpack_require__("Zwq5");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "LbRA":
/***/ (function(module, exports) {

module.exports = curry;

/*
  function add(a, b, c) {
    return a + b + c;
  }
  curry(add)(1)(2)(3); // 6
  curry(add)(1)(2)(2); // 5
  curry(add)(2)(4, 3); // 9

  function add(...args) {
    return args.reduce((sum, n) => sum + n, 0)
  }
  var curryAdd4 = curry(add, 4)
  curryAdd4(1)(2, 3)(4); // 10

  function converter(ratio, input) {
    return (input*ratio).toFixed(1);
  }
  const curriedConverter = curry(converter)
  const milesToKm = curriedConverter(1.62);
  milesToKm(35); // 56.7
  milesToKm(10); // 16.2
*/

function curry(fn, arity) {
  return function curried() {
    if (arity == null) {
      arity = fn.length;
    }
    var args = [].slice.call(arguments);
    if (args.length >= arity) {
      return fn.apply(this, args);
    } else {
      return function () {
        return curried.apply(this, args.concat([].slice.call(arguments)));
      };
    }
  };
}

/***/ }),

/***/ "LiLl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function throwTypeError() {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function () {
	try {
		// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
		arguments.callee; // IE 8 does not throw here
		return throwTypeError;
	} catch (calleeThrows) {
		try {
			// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
			return $gOPD(arguments, 'callee').get;
		} catch (gOPDthrows) {
			return throwTypeError;
		}
	}
}() : throwTypeError;

var hasSymbols = __webpack_require__("NS5K")();

var getProto = Object.getPrototypeOf || function (x) {
	return x.__proto__;
}; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__("58Ti");
var hasOwn = __webpack_require__("ar57");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && i + 1 >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

/***/ }),

/***/ "LkZ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__("JZ8d");
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac"), __webpack_require__("pv+l")(module)))

/***/ }),

/***/ "Lli7":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("Ug9I")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),

/***/ "M0Be":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("dEmU");
var requireObjectCoercible = __webpack_require__("7CnU");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};

/***/ }),

/***/ "M4O7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),

/***/ "MCkq":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

/***/ }),

/***/ "MILo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),

/***/ "MJVJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router__ = __webpack_require__("/QC5");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Redirect = function (_Component) {
	_inherits(Redirect, _Component);

	function Redirect() {
		_classCallCheck(this, Redirect);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Redirect.prototype.componentWillMount = function componentWillMount() {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact_router__["route"])(this.props.to, true);
	};

	Redirect.prototype.render = function render() {
		return null;
	};

	return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "MUmM":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__("s25D");

/***/ }),

/***/ "Mmn3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  iconSize: 24,

  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopDrawerMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56
};

/***/ }),

/***/ "MpYs":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "MxlY":
/***/ (function(module, exports) {

exports.entityMap = {
       lt: '<',
       gt: '>',
       amp: '&',
       quot: '"',
       apos: "'",
       Agrave: "À",
       Aacute: "Á",
       Acirc: "Â",
       Atilde: "Ã",
       Auml: "Ä",
       Aring: "Å",
       AElig: "Æ",
       Ccedil: "Ç",
       Egrave: "È",
       Eacute: "É",
       Ecirc: "Ê",
       Euml: "Ë",
       Igrave: "Ì",
       Iacute: "Í",
       Icirc: "Î",
       Iuml: "Ï",
       ETH: "Ð",
       Ntilde: "Ñ",
       Ograve: "Ò",
       Oacute: "Ó",
       Ocirc: "Ô",
       Otilde: "Õ",
       Ouml: "Ö",
       Oslash: "Ø",
       Ugrave: "Ù",
       Uacute: "Ú",
       Ucirc: "Û",
       Uuml: "Ü",
       Yacute: "Ý",
       THORN: "Þ",
       szlig: "ß",
       agrave: "à",
       aacute: "á",
       acirc: "â",
       atilde: "ã",
       auml: "ä",
       aring: "å",
       aelig: "æ",
       ccedil: "ç",
       egrave: "è",
       eacute: "é",
       ecirc: "ê",
       euml: "ë",
       igrave: "ì",
       iacute: "í",
       icirc: "î",
       iuml: "ï",
       eth: "ð",
       ntilde: "ñ",
       ograve: "ò",
       oacute: "ó",
       ocirc: "ô",
       otilde: "õ",
       ouml: "ö",
       oslash: "ø",
       ugrave: "ù",
       uacute: "ú",
       ucirc: "û",
       uuml: "ü",
       yacute: "ý",
       thorn: "þ",
       yuml: "ÿ",
       nbsp: '\xA0',
       iexcl: "¡",
       cent: "¢",
       pound: "£",
       curren: "¤",
       yen: "¥",
       brvbar: "¦",
       sect: "§",
       uml: "¨",
       copy: "©",
       ordf: "ª",
       laquo: "«",
       not: "¬",
       shy: "­­",
       reg: "®",
       macr: "¯",
       deg: "°",
       plusmn: "±",
       sup2: "²",
       sup3: "³",
       acute: "´",
       micro: "µ",
       para: "¶",
       middot: "·",
       cedil: "¸",
       sup1: "¹",
       ordm: "º",
       raquo: "»",
       frac14: "¼",
       frac12: "½",
       frac34: "¾",
       iquest: "¿",
       times: "×",
       divide: "÷",
       forall: "∀",
       part: "∂",
       exist: "∃",
       empty: "∅",
       nabla: "∇",
       isin: "∈",
       notin: "∉",
       ni: "∋",
       prod: "∏",
       sum: "∑",
       minus: "−",
       lowast: "∗",
       radic: "√",
       prop: "∝",
       infin: "∞",
       ang: "∠",
       and: "∧",
       or: "∨",
       cap: "∩",
       cup: "∪",
       'int': "∫",
       there4: "∴",
       sim: "∼",
       cong: "≅",
       asymp: "≈",
       ne: "≠",
       equiv: "≡",
       le: "≤",
       ge: "≥",
       sub: "⊂",
       sup: "⊃",
       nsub: "⊄",
       sube: "⊆",
       supe: "⊇",
       oplus: "⊕",
       otimes: "⊗",
       perp: "⊥",
       sdot: "⋅",
       Alpha: "Α",
       Beta: "Β",
       Gamma: "Γ",
       Delta: "Δ",
       Epsilon: "Ε",
       Zeta: "Ζ",
       Eta: "Η",
       Theta: "Θ",
       Iota: "Ι",
       Kappa: "Κ",
       Lambda: "Λ",
       Mu: "Μ",
       Nu: "Ν",
       Xi: "Ξ",
       Omicron: "Ο",
       Pi: "Π",
       Rho: "Ρ",
       Sigma: "Σ",
       Tau: "Τ",
       Upsilon: "Υ",
       Phi: "Φ",
       Chi: "Χ",
       Psi: "Ψ",
       Omega: "Ω",
       alpha: "α",
       beta: "β",
       gamma: "γ",
       delta: "δ",
       epsilon: "ε",
       zeta: "ζ",
       eta: "η",
       theta: "θ",
       iota: "ι",
       kappa: "κ",
       lambda: "λ",
       mu: "μ",
       nu: "ν",
       xi: "ξ",
       omicron: "ο",
       pi: "π",
       rho: "ρ",
       sigmaf: "ς",
       sigma: "σ",
       tau: "τ",
       upsilon: "υ",
       phi: "φ",
       chi: "χ",
       psi: "ψ",
       omega: "ω",
       thetasym: "ϑ",
       upsih: "ϒ",
       piv: "ϖ",
       OElig: "Œ",
       oelig: "œ",
       Scaron: "Š",
       scaron: "š",
       Yuml: "Ÿ",
       fnof: "ƒ",
       circ: "ˆ",
       tilde: "˜",
       ensp: " ",
       emsp: " ",
       thinsp: " ",
       zwnj: "‌",
       zwj: "‍",
       lrm: "‎",
       rlm: "‏",
       ndash: "–",
       mdash: "—",
       lsquo: "‘",
       rsquo: "’",
       sbquo: "‚",
       ldquo: "“",
       rdquo: "”",
       bdquo: "„",
       dagger: "†",
       Dagger: "‡",
       bull: "•",
       hellip: "…",
       permil: "‰",
       prime: "′",
       Prime: "″",
       lsaquo: "‹",
       rsaquo: "›",
       oline: "‾",
       euro: "€",
       trade: "™",
       larr: "←",
       uarr: "↑",
       rarr: "→",
       darr: "↓",
       harr: "↔",
       crarr: "↵",
       lceil: "⌈",
       rceil: "⌉",
       lfloor: "⌊",
       rfloor: "⌋",
       loz: "◊",
       spades: "♠",
       clubs: "♣",
       hearts: "♥",
       diams: "♦"
};

/***/ }),

/***/ "N1TZ":
/***/ (function(module, exports) {

module.exports = typeof window == 'object';

/***/ }),

/***/ "N2wP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("eW0v");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__("45fX");

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),

/***/ "N484":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__("3zRh");
var $export = __webpack_require__("vSO4");
var toObject = __webpack_require__("mbLO");
var call = __webpack_require__("hEIm");
var isArrayIter = __webpack_require__("af0K");
var toLength = __webpack_require__("S7IM");
var createProperty = __webpack_require__("vUQk");
var getIterFn = __webpack_require__("7AqT");

$export($export.S + $export.F * !__webpack_require__("Lli7")(function (iter) {
  Array.from(iter);
}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

/***/ }),

/***/ "NB7d":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("zKeE");
var global = __webpack_require__("i1Q6");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("1kq3") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "NNyR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__("S6J3");

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};

var requiresPrefixDashCased = void 0;

function transition(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    // memoize the prefix array for later use
    if (!requiresPrefixDashCased) {
      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateProperty2.default)(prop);
      });
    }

    // only split multi values, not cubic beziers
    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

    requiresPrefixDashCased.forEach(function (prop) {
      multipleValues.forEach(function (val, index) {
        if (val.indexOf(prop) > -1 && prop !== 'order') {
          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
        }
      });
    });

    return multipleValues.join(',');
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "NS5K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__("jYt2");

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') {
		return false;
	}
	if (typeof Symbol !== 'function') {
		return false;
	}
	if (typeof origSymbol('foo') !== 'symbol') {
		return false;
	}
	if (typeof Symbol('bar') !== 'symbol') {
		return false;
	}

	return hasSymbolSham();
};

/***/ }),

/***/ "Ni5N":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("B9Lq");
var hiddenKeys = __webpack_require__("KxjL").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),

/***/ "Nvz5":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var requireObjectCoercible = __webpack_require__("7CnU");

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};

/***/ }),

/***/ "NySk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = __webpack_require__("/sXU");

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type,
      values = color.values;

  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values and color names.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');

   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;

  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);

  if (color.type.indexOf('rgb') > -1) {
    var rgb = color.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
  } else if (color.type.indexOf('hsl') > -1) {
    return color.values[2] / 100;
  }
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

/***/ }),

/***/ "NyUK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__("KpHW")();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

/***/ }),

/***/ "NyfM":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var classof = __webpack_require__("0guB");

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};

/***/ }),

/***/ "O35A":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("i+u+");
__webpack_require__("N484");
module.exports = __webpack_require__("zKeE").Array.from;

/***/ }),

/***/ "O4VS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__("e1OT");

var _colorManipulator = __webpack_require__("NySk");

var _spacing = __webpack_require__("Mmn3");

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
exports.default = {
  spacing: _spacing2.default,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: _colors.cyan500,
    primary2Color: _colors.cyan700,
    primary3Color: _colors.grey400,
    accent1Color: _colors.pinkA200,
    accent2Color: _colors.grey100,
    accent3Color: _colors.grey500,
    textColor: _colors.darkBlack,
    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.cyan500,
    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
    shadowColor: _colors.fullBlack
  }
}; /**
    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
    */

/***/ }),

/***/ "OHc/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mentionedProType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleName; });
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectMessageIsFetching; });
/* unused harmony export selectMessageError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectMessageText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectMessagePros; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_compat__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("vyGZ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





// Prop Types (down)

var mentionedProType = __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
  avatarUrl: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  lastName: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired
});

// Prop Types (up)

// Constants (down)

var moduleName = 'message';

// Constants (up)

// Reducer (down)

var initialState = {
  fetching: false,
  error: '',
  text: '',
  pros: [],
  personId: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var error = action.error,
      type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].MESSAGE_SET_TEXT:
      {
        var text = payload.text;


        return _extends({}, state, {
          text: text
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].MESSAGE_FETCH_PROS_AS_SUPPORT_REQUEST:
      return _extends({}, state, {
        fetching: true,
        pros: initialState.pros
      });

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].MESSAGE_FETCH_PROS_AS_SUPPORT_SUCCESS:
      {
        var pros = payload.pros;


        return _extends({}, state, {
          pros: pros,
          fetching: false,
          error: initialState.error
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].MESSAGE_FETCH_PROS_AS_SUPPORT_FAILURE:
      return _extends({}, state, {
        fetching: false,
        error: error || 'Cannot fetch referenced pros!',
        pros: initialState.pros
      });

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].MESSAGE_RESET:
      return _extends({}, initialState);

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].GET_USER_DETAILS_SUCCESS:
      return action.payload.id !== state.personId ? _extends({}, initialState, {
        personId: action.payload.id
      }) : _extends({}, state);
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].RESET_USER_DETAILS:
      return _extends({}, initialState);

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

var stateSelector = function stateSelector(state) {
  return state[moduleName];
};

var selectMessageIsFetching = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (message) {
  return message.fetching;
});

var selectMessageError = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (message) {
  return message.error;
});

var selectMessageText = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (message) {
  return message.text;
});

var selectMessagePros = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (message) {
  return message.pros;
});

// Selectors (up)

/***/ }),

/***/ "OP68":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "be8033a7947e2f4f0872a6019ff9375c.png";

/***/ }),

/***/ "ORnL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__("7qbT");

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement('a', _this.props, _this.props.children);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),

/***/ "OTa1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleName; });
/* unused harmony export selectLastCallError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectCalledProIsUnavailable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_consts__ = __webpack_require__("4PH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("vyGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("DHvs");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-case-declarations */



// eslint-disable-next-line import/no-cycle


var moduleName = 'communicateModal';

var initialState = {
  callInfo: {},
  type: null,
  unread: {},
  isBusy: false,
  isOutcoming: false,
  isIncoming: false,
  isCalling: false,
  isSpeaking: false,
  chats: {},
  isConnected: false,
  userVideoStream: false,
  offset: undefined,
  isReconnect: false,
  isChatOpened: false,
  lastCallError: null,
  calleeBrief: undefined,
  callerBrief: undefined
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _extends2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _extends({}, initialState);
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CLOSE_COMMUNICATE_MODAL:
      return _extends({}, state, {
        type: null,
        isBusy: false,
        isIncoming: false,
        callInfo: {},
        isCalling: false,
        isSpeaking: false,
        userVideoStream: false,
        isChatOpened: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CLOSE_COMMUNICATE_MODAL_CHAT:
      return _extends({}, state, {
        isChatOpened: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].OPEN_COMMUNICATE_MODAL:
      return _extends({}, state, {
        type: action.modalType,
        person: action.person,
        isOutcoming: action.isOutcoming,
        isIncoming: action.isIncoming,
        isBusy: false,
        isCalling: false,
        isSpeaking: false,
        isPickUp: false,
        lastCallError: null
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].OPEN_COMMUNICATE_MODAL_CHAT:
      return _extends({}, state, {
        isChatOpened: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].PROCESSING_CALL:
      return _extends({}, state, {
        isCalling: true,
        isBusy: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].SPEAKING:
      return _extends({}, state, {
        isSpeaking: true,
        isCalling: false,
        isBusy: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].STOP_COMMUNICATION:
      return _extends({}, state, {
        isSpeaking: false,
        isCalling: false,
        isOutcoming: false,
        isIncoming: false,
        isBusy: false,
        isPickUp: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CREATE_CALL:
      return _extends({}, state, {
        callInfo: {
          avTime: action.avTime,
          callId: action.callId,
          callerId: action.callerId,
          calleeId: action.consultant.id,
          info: '',
          error: false
        },
        isBusy: false,
        isPickUp: false,
        lastCallError: null,
        calleeBrief: action.calleeBrief,
        callerBrief: {
          id: action.callerId
        }
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CREATE_CALL_ERROR:
      return _extends({}, state, {
        callInfo: {
          info: action.info,
          error: true
        },
        lastCallError: {
          info: action.info,
          internalError: action.internalError
        }
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].GET_CALL_INFO:
      return _extends({}, state, {
        callInfo: {
          callId: action.payload.id,
          callerId: action.payload.callerId,
          calleeId: action.payload.consultant.id,
          fcid: action.payload.fcid,
          fcidCost: action.payload.fcidCost,
          consulted: action.payload.consulted,
          info: '',
          error: false,
          lastCallError: null
        },
        calleeBrief: {
          costPerMinute: action.payload.consultant.costPerMinute,
          service: action.payload.consultant.service,
          avatar: action.payload.consultant.avatar ? { id: action.payload.consultant.avatar.id } : undefined,
          imgUrl: action.payload.consultant.imgUrl,
          avatarUrl: action.payload.consultant.avatarUrl,
          nickname: action.payload.consultant.nickname,
          isPro: Boolean(action.payload.consultant.pro),
          id: action.payload.consultant.id
        },
        callerBrief: {
          id: action.payload.callerId,
          avatar: action.payload.consulted.avatar ? { id: action.payload.consulted.avatar.id } : undefined,
          imgUrl: action.payload.consulted.imgUrl,
          avatarUrl: action.payload.consulted.avatarUrl
        }
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CHOOSE_CHAT_PERSON:
      var person = action.person;

      var chats = _extends({}, state.unread);
      delete chats[Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* generateJID */])(person.id, true)];
      return _extends({}, state, {
        unread: chats,
        person: {},
        isChatOpened: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CHANGE_UNREAD_MSG:
      return _extends({}, state, {
        unread: _extends({}, state.unread, (_extends2 = {}, _extends2[action.from] = true, _extends2))
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CLEAR_CHATS:
      return _extends({}, state, {
        unread: {}
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CHANGE_CHAT:
      return _extends({}, state, {
        chats: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CHANGE_CONNECTION_STATUS:
      return _extends({}, state, {
        isConnected: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CHANGE_VIDEO_STATUS:
      return _extends({}, state, {
        userVideoStream: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CALEE_IS_BUSY:
      return _extends({}, state, {
        isBusy: true,
        callInfo: {},
        type: null,
        person: {},
        isOutcoming: false,
        isIncoming: false,
        isCalling: false,
        isSpeaking: false,
        isPickUp: false,
        lastCallError: null
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].PICK_UP_CALL:
      return _extends({}, state, {
        isPickUp: true,
        lastCallError: null
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].SET_TIME_OFFSET:
      return _extends({}, state, {
        offset: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].LOGGED_OFF:
      return _extends({}, initialState);
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CHANGE_RECONNECTION_STATUS:
      return _extends({}, state, {
        isReconnect: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CLEAR_CALL_BRIEFS:
      return _extends({}, state, {
        callerBrief: undefined,
        calleeBrief: undefined
      });
    default:
      return state;
  }
});

var stateSelector = function stateSelector(state) {
  return state[moduleName];
};

var selectLastCallError = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (communicateModal) {
  return communicateModal.lastCallError;
});

var selectCalledProIsUnavailable = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectLastCallError, function (lastCallError) {
  return !!(lastCallError && lastCallError.internalError && lastCallError.internalError === __WEBPACK_IMPORTED_MODULE_1__utils_consts__["y" /* USERS_ERROR_CODES */].PRO_IS_NOT_AVAILABLE);
});

/***/ }),

/***/ "OYXR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__("ID6i");
var step = __webpack_require__("xwD+");
var Iterators = __webpack_require__("dhak");
var toIObject = __webpack_require__("Wyka");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("uRfg")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),

/***/ "OZJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__("WNaj");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/locale/en-US/index.js + 9 modules
var en_US = __webpack_require__("lcWw");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__("A4qf");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__("KYJg");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var lightFormatters = __webpack_require__("sUXs");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__("2kK6");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__("PrDZ");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__("wuZP");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__("Z7oM");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__("JbHP");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
var addLeadingZeros = __webpack_require__("V2hq");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters["a" /* default */].y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = Object(getUTCWeekYear["a" /* default */])(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return Object(addLeadingZeros["a" /* default */])(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return Object(addLeadingZeros["a" /* default */])(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = Object(getUTCISOWeekYear["a" /* default */])(date); // Padding

    return Object(addLeadingZeros["a" /* default */])(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return Object(addLeadingZeros["a" /* default */])(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return Object(addLeadingZeros["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return Object(addLeadingZeros["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters["a" /* default */].M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return Object(addLeadingZeros["a" /* default */])(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = Object(getUTCWeek["a" /* default */])(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return Object(addLeadingZeros["a" /* default */])(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = Object(getUTCISOWeek["a" /* default */])(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return Object(addLeadingZeros["a" /* default */])(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters["a" /* default */].d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return Object(addLeadingZeros["a" /* default */])(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return Object(addLeadingZeros["a" /* default */])(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return Object(addLeadingZeros["a" /* default */])(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return Object(addLeadingZeros["a" /* default */])(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters["a" /* default */].h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters["a" /* default */].H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(addLeadingZeros["a" /* default */])(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(addLeadingZeros["a" /* default */])(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters["a" /* default */].m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters["a" /* default */].s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters["a" /* default */].S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return Object(addLeadingZeros["a" /* default */])(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return Object(addLeadingZeros["a" /* default */])(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, delimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  return sign + String(hours) + delimiter + Object(addLeadingZeros["a" /* default */])(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + Object(addLeadingZeros["a" /* default */])(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Object(addLeadingZeros["a" /* default */])(Math.floor(absOffset / 60), 2);
  var minutes = Object(addLeadingZeros["a" /* default */])(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ var format_formatters = (formatters);
// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__("W9kG");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__("aFbL");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__("VJX+");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__("VYL5");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/format/index.js
/* harmony export (immutable) */ __webpack_exports__["a"] = format;









 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || en_US["a" /* default */];
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(toInteger["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(toInteger["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(toInteger["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(toInteger["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = Object(toDate["a" /* default */])(dirtyDate);

  if (!Object(isValid["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = Object(getTimezoneOffsetInMilliseconds["a" /* default */])(originalDate);
  var utcDate = Object(subMilliseconds["a" /* default */])(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && Object(protectedTokens["b" /* isProtectedWeekYearToken */])(substring)) {
        Object(protectedTokens["c" /* throwProtectedError */])(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && Object(protectedTokens["a" /* isProtectedDayOfYearToken */])(substring)) {
        Object(protectedTokens["c" /* throwProtectedError */])(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ "Ocr3":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "Oi8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("ygki");


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);

/***/ }),

/***/ "OkVp":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var isCallable = __webpack_require__("yeFe");
var inspectSource = __webpack_require__("yPWo");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));

/***/ }),

/***/ "Ouhw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;

var _extends2 = __webpack_require__("T4f3");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withWidth;

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _reactEventListener = __webpack_require__("3yko");

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var SMALL = exports.SMALL = 1;
var MEDIUM = exports.MEDIUM = 2;
var LARGE = exports.LARGE = 3;

function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$largeWidth = options.largeWidth,
      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
      _options$mediumWidth = options.mediumWidth,
      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
      _options$resizeInterv = options.resizeInterval,
      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;

  return function (MyComponent) {
    return function (_Component) {
      (0, _inherits3.default)(WithWidth, _Component);

      function WithWidth() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WithWidth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          width: null
        }, _this.handleResize = function () {
          clearTimeout(_this.deferTimer);
          _this.deferTimer = setTimeout(function () {
            _this.updateWidth();
          }, resizeInterval);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(WithWidth, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.updateWidth();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          clearTimeout(this.deferTimer);
        }
      }, {
        key: 'updateWidth',
        value: function updateWidth() {
          var innerWidth = window.innerWidth;
          var width = void 0;

          if (innerWidth >= largeWidth) {
            width = LARGE;
          } else if (innerWidth >= mediumWidth) {
            width = MEDIUM;
          } else {
            // innerWidth < 768
            width = SMALL;
          }

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var width = this.state.width;

          /**
           * When rendering the component on the server,
           * we have no idea about the screen width.
           * In order to prevent blinks and help the reconciliation
           * we are not rendering the component.
           *
           * A better alternative would be to send client hints.
           * But the browser support of this API is low:
           * http://caniuse.com/#search=client%20hint
           */
          if (width === null) {
            return null;
          }

          return _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }, _react2.default.createElement(MyComponent, (0, _extends3.default)({
            width: width
          }, this.props)));
        }
      }]);
      return WithWidth;
    }(_react.Component);
  };
}

/***/ }),

/***/ "P2wb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCalls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeSearchParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_users__ = __webpack_require__("mecS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("vyGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_notifications__ = __webpack_require__("kKXN");




var getCalls = function getCalls(isProCalls) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var shouldBeReloaded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var shouldScrollUp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState, userAuth, _getState$calls, sortBy, searchTerm, response;

      shouldScrollUp && window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].GET_USER_ACTIVITY,
        shouldBeReloaded: shouldBeReloaded
      });
      _getState = getState(), userAuth = _getState.loggedInUser.userAuth, _getState$calls = _getState.calls, sortBy = _getState$calls.sortBy, searchTerm = _getState$calls.searchTerm;
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (error) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__api_notifications__["a" /* addNotification */])(error));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].GET_USER_ACTIVITY_FAILURE,
            error: error
          });
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__api_users__["i" /* getCalls */](userAuth, isProCalls, sortBy, searchTerm, page).catch(function (err) {
          throw err;
        })).then(function ($await_2) {
          try {
            response = $await_2;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].GET_USER_ACTIVITY_SUCCESS,
              payload: response
            });
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  };
};

var changeSearchParams = function changeSearchParams(data) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].SET_ACTIVITY_SEARCH_PARAMS,
      payload: data
    });
  };
};

var reset = function reset() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].RESET_ACTIVITY_SEARCH_PARAMS
    });
  };
};

/***/ }),

/***/ "P8NW":
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "PDcB":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("mbLO");
var $keys = __webpack_require__("knrM");

__webpack_require__("cOHw")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

/***/ }),

/***/ "PFZ8":
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__("qrqX");
__webpack_require__("yB2/");

module.exports = parent;

/***/ }),

/***/ "PFhi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("SNRl");
var call = __webpack_require__("HiG7");
var IS_PURE = __webpack_require__("oj7W");
var FunctionName = __webpack_require__("KB9x");
var isCallable = __webpack_require__("yeFe");
var createIteratorConstructor = __webpack_require__("lwyd");
var getPrototypeOf = __webpack_require__("BJWe");
var setPrototypeOf = __webpack_require__("nR03");
var setToStringTag = __webpack_require__("FfP1");
var createNonEnumerableProperty = __webpack_require__("yNEm");
var redefine = __webpack_require__("GZef");
var wellKnownSymbol = __webpack_require__("G69i");
var Iterators = __webpack_require__("25e4");
var IteratorsCore = __webpack_require__("AkN1");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function getIterationMethod(KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };
      case VALUES:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };
      case ENTRIES:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }return function () {
      return new IteratorConstructor(this);
    };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() {
        return call(nativeIterator, this);
      };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};

/***/ }),

/***/ "PTKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/date-fns/esm/getTime/index.js
var getTime = __webpack_require__("yiHt");

// EXTERNAL MODULE: ../node_modules/semver-compare/index.js
var semver_compare = __webpack_require__("qIE1");
var semver_compare_default = /*#__PURE__*/__webpack_require__.n(semver_compare);

// EXTERNAL MODULE: ../node_modules/strophe.js/dist/strophe.umd.js
var strophe_umd = __webpack_require__("/0Qi");
var strophe_umd_default = /*#__PURE__*/__webpack_require__.n(strophe_umd);

// EXTERNAL MODULE: ../node_modules/uuid/v4.js
var v4 = __webpack_require__("hYHi");
var v4_default = /*#__PURE__*/__webpack_require__.n(v4);

// EXTERNAL MODULE: ../node_modules/tab-emitter/index.js
var tab_emitter = __webpack_require__("v9s1");
var tab_emitter_default = /*#__PURE__*/__webpack_require__.n(tab_emitter);

// EXTERNAL MODULE: ../node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("2JJl");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// EXTERNAL MODULE: ../node_modules/@bugfender/sdk/lib/index.js
var lib = __webpack_require__("FFyX");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./utils/logger.js
var logger = __webpack_require__("cxRM");

// EXTERNAL MODULE: ./utils/media-session.js
var media_session = __webpack_require__("69EM");

// EXTERNAL MODULE: ./utils/index.js + 1 modules
var utils = __webpack_require__("DHvs");

// EXTERNAL MODULE: ./api/index.js
var api = __webpack_require__("/C1n");

// CONCATENATED MODULE: ./utils/enum.es6.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable max-classes-per-file */

var EnumSymbol = function () {
  function EnumSymbol(name, _ref) {
    var value = _ref.value,
        description = _ref.description;

    _classCallCheck(this, EnumSymbol);

    this.sym = Symbol.for(name);

    if (!Object.is(value, undefined)) this.value = value;
    if (description) this.description = description;

    Object.freeze(this);
  }

  EnumSymbol.prototype.toString = function toString() {
    return this.sym;
  };

  EnumSymbol.prototype.valueOf = function valueOf() {
    return this.value;
  };

  _createClass(EnumSymbol, [{
    key: 'display',
    get: function get() {
      return this.description || Symbol.keyFor(this.sym);
    }
  }]);

  return EnumSymbol;
}();

var Enum = function () {
  function Enum(enumLiterals) {
    _classCallCheck(this, Enum);

    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (var key in enumLiterals) {
      if (!enumLiterals[key]) throw new TypeError('each enum should have been initialized with atleast empty {} value');
      this[key] = new EnumSymbol(key, enumLiterals[key]);
    }
    Object.freeze(this);
  }

  Enum.prototype.symbols = function symbols() {
    var _this = this;

    // return [ for (key of Object.keys(this)) this[key] ];
    return Object.keys(this).map(function (key) {
      return _this[key];
    });
  };

  Enum.prototype.keys = function keys() {
    return Object.keys(this);
  };

  Enum.prototype.contains = function contains(sym) {
    if (!(sym instanceof EnumSymbol)) return false;
    return this[Symbol.keyFor(sym.sym)] === sym;
  };

  return Enum;
}();
// EXTERNAL MODULE: ./utils/con-helpers.js
var con_helpers = __webpack_require__("AoWs");

// EXTERNAL MODULE: ./api/pros.js
var pros = __webpack_require__("iMz2");

// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// EXTERNAL MODULE: ../node_modules/strophejs-plugin-stream-management/lib/strophe.stream-management.js
var strophe_stream_management = __webpack_require__("QM/L");
var strophe_stream_management_default = /*#__PURE__*/__webpack_require__.n(strophe_stream_management);

// CONCATENATED MODULE: ./utils/connection-quality-monitoring.js
function connection_quality_monitoring__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BITRATE_CHANGE_SENSITIVITY_DELTA_KBITS = 10;
var BITS_IN_KBIT = 1000.0;
var LOST_PACKETS_DELTA = 1;
var DISCARDED_PACKETS_DELTA = 1;
var JITTER_DELTA = 0.1;
var FRACTION_LOST_DELTA = 0.01;
var ROUNDTRIP_TIME_DELTA = 0.1;

var isValueChangeBeyondThreshold = function isValueChangeBeyondThreshold(oldValue, newValue, threshold) {
  if (oldValue === undefined && newValue !== undefined) {
    return true;
  }
  if (oldValue !== undefined && newValue === undefined) {
    return true;
  }

  if (oldValue && newValue && Math.abs(newValue - oldValue) > threshold) {
    return true;
  }

  return false;
};

var PeerConnectionQualityMonitor = function () {
  function PeerConnectionQualityMonitor(onConnectionParametersChanged) {
    connection_quality_monitoring__classCallCheck(this, PeerConnectionQualityMonitor);

    if (onConnectionParametersChanged && typeof onConnectionParametersChanged !== 'function') {
      throw Error('The \'onConnectionParametersChanged\' parameter value is not a function');
    }

    this.onConnectionParametersChanged = onConnectionParametersChanged;
    this.resetStats();
  }

  PeerConnectionQualityMonitor.prototype.resetStats = function resetStats() {
    this.localCandidateType = undefined;
    this.remoteCandidateType = undefined;
    this.localNetworkType = undefined;
    this.remoteNetworkType = undefined;
    this.localProtocol = undefined;
    this.remoteProtocol = undefined;
    this.incomingBitrate = undefined;
    this.outgoingBitrate = undefined;
    this.receivedAudioStream = {
      packetsLost: undefined,
      packetsDiscarded: undefined,
      jitter: undefined
    };
    this.receivedVideoStream = {
      packetsLost: undefined,
      packetsDiscarded: undefined,
      jitter: undefined
    };
    this.sentAudioStream = {
      packetsLost: undefined,
      packetsDiscarded: undefined,
      jitter: undefined,
      fractionLost: undefined,
      roundTripTime: undefined
    };
    this.sentVideoStream = {
      packetsLost: undefined,
      packetsDiscarded: undefined,
      jitter: undefined,
      fractionLost: undefined,
      roundTripTime: undefined
    };
  };

  PeerConnectionQualityMonitor.prototype.addStatsSample = function addStatsSample(connectionStats) {
    var qualityChanges = [];

    if (connectionStats.localCandidateType && this.localCandidateType !== connectionStats.localCandidateType) {
      qualityChanges.push('Local ICE candidate type has changed to: ' + connectionStats.localCandidateType);
      this.localCandidateType = connectionStats.localCandidateType;
    }
    if (connectionStats.remoteCandidateType && this.remoteCandidateType !== connectionStats.remoteCandidateType) {
      qualityChanges.push('Remote ICE candidate type has changed to: ' + connectionStats.remoteCandidateType);
      this.remoteCandidateType = connectionStats.remoteCandidateType;
    }

    if (connectionStats.localNetworkType && this.localNetworkType !== connectionStats.localNetworkType) {
      qualityChanges.push('Local ICE candidate network type has changed to: ' + connectionStats.localNetworkType);
      this.localNetworkType = connectionStats.localNetworkType;
    }
    if (connectionStats.remoteNetworkType && this.remoteNetworkType !== connectionStats.remoteNetworkType) {
      qualityChanges.push('Remote ICE candidate network type has changed to: ' + connectionStats.remoteNetworkType);
      this.remoteNetworkType = connectionStats.remoteNetworkType;
    }

    if (connectionStats.localProtocol && this.localProtocol !== connectionStats.localProtocol) {
      qualityChanges.push('Local ICE candidate protocol has changed to: ' + connectionStats.localProtocol);
      this.localProtocol = connectionStats.localProtocol;
    }
    if (connectionStats.remoteProtocol && this.remoteProtocol !== connectionStats.remoteProtocol) {
      qualityChanges.push('Remote ICE candidate protocol has changed to: ' + connectionStats.remoteProtocol);
      this.remoteProtocol = connectionStats.remoteProtocol;
    }

    if (connectionStats.incomingBitrate) {
      var incomingBitrateKBits = connectionStats.incomingBitrate / BITS_IN_KBIT;
      if (isValueChangeBeyondThreshold(this.incomingBitrate, incomingBitrateKBits, BITRATE_CHANGE_SENSITIVITY_DELTA_KBITS)) {
        qualityChanges.push('Incoming bitrate has changed to: ' + incomingBitrateKBits.toFixed(2));
        this.incomingBitrate = incomingBitrateKBits;
      }
    }
    if (connectionStats.outgoingBitrate) {
      var outgoingBitrateKBits = connectionStats.outgoingBitrate / BITS_IN_KBIT;
      if (isValueChangeBeyondThreshold(this.outgoingBitrate, outgoingBitrateKBits, BITRATE_CHANGE_SENSITIVITY_DELTA_KBITS)) {
        qualityChanges.push('Outgoing bitrate has changed to: ' + outgoingBitrateKBits.toFixed(2));
        this.outgoingBitrate = outgoingBitrateKBits;
      }
    }

    if (connectionStats.receivedAudio) {
      if (connectionStats.receivedAudio.packetsLost) {
        if (isValueChangeBeyondThreshold(this.receivedAudioStream.packetsLost, connectionStats.receivedAudio.packetsLost, LOST_PACKETS_DELTA)) {
          qualityChanges.push('Received audio packets lost: ' + connectionStats.receivedAudio.packetsLost);
          this.receivedAudioStream.packetsLost = connectionStats.receivedAudio.packetsLost;
        }
      }
      if (connectionStats.receivedAudio.packetsDiscarded) {
        if (isValueChangeBeyondThreshold(this.receivedAudioStream.packetsDiscarded, connectionStats.receivedAudio.packetsDiscarded, DISCARDED_PACKETS_DELTA)) {
          qualityChanges.push('Received audio packets discarded: ' + connectionStats.receivedAudio.packetsDiscarded);
          this.receivedAudioStream.packetsDiscarded = connectionStats.receivedAudio.packetsDiscarded;
        }
      }
      if (connectionStats.receivedAudio.jitter) {
        if (isValueChangeBeyondThreshold(this.receivedAudioStream.jitter, connectionStats.receivedAudio.jitter, JITTER_DELTA)) {
          qualityChanges.push('Received audio jitter has changed to: ' + connectionStats.receivedAudio.jitter);
          this.receivedAudioStream.jitter = connectionStats.receivedAudio.jitter;
        }
      }
    }

    if (connectionStats.receivedVideo) {
      if (connectionStats.receivedVideo.packetsLost) {
        if (isValueChangeBeyondThreshold(this.receivedVideoStream.packetsLost, connectionStats.receivedVideo.packetsLost, LOST_PACKETS_DELTA)) {
          qualityChanges.push('Received video packets lost: ' + connectionStats.receivedVideo.packetsLost);
          this.receivedVideoStream.packetsLost = connectionStats.receivedVideo.packetsLost;
        }
      }
      if (connectionStats.receivedVideo.packetsDiscarded) {
        if (isValueChangeBeyondThreshold(this.receivedVideoStream.packetsDiscarded, connectionStats.receivedVideo.packetsDiscarded, DISCARDED_PACKETS_DELTA)) {
          qualityChanges.push('Received video packets discarded: ' + connectionStats.receivedVideo.packetsDiscarded);
          this.receivedVideoStream.packetsDiscarded = connectionStats.receivedVideo.packetsDiscarded;
        }
      }
      if (connectionStats.receivedVideo.jitter) {
        if (isValueChangeBeyondThreshold(this.receivedVideoStream.jitter, connectionStats.receivedVideo.jitter, JITTER_DELTA)) {
          qualityChanges.push('Received video jitter has changed to: ' + connectionStats.receivedVideo.jitter);
          this.receivedVideoStream.jitter = connectionStats.receivedVideo.jitter;
        }
      }
    }

    if (connectionStats.sentAudio) {
      if (connectionStats.sentAudio.packetsLost) {
        if (isValueChangeBeyondThreshold(this.sentAudioStream.packetsLost, connectionStats.sentAudio.packetsLost, LOST_PACKETS_DELTA)) {
          qualityChanges.push('Sent audio packets lost: ' + connectionStats.sentAudio.packetsLost);
          this.sentAudioStream.packetsLost = connectionStats.sentAudio.packetsLost;
        }
      }
      if (connectionStats.sentAudio.packetsDiscarded) {
        if (isValueChangeBeyondThreshold(this.sentAudioStream.packetsDiscarded, connectionStats.sentAudio.packetsDiscarded, DISCARDED_PACKETS_DELTA)) {
          qualityChanges.push('Sent audio packets discarded: ' + connectionStats.sentAudio.packetsDiscarded);
          this.sentAudioStream.packetsDiscarded = connectionStats.sentAudio.packetsDiscarded;
        }
      }
      if (connectionStats.sentAudio.jitter) {
        if (isValueChangeBeyondThreshold(this.sentAudioStream.jitter, connectionStats.sentAudio.jitter, JITTER_DELTA)) {
          qualityChanges.push('Sent audio jitter has changed to: ' + connectionStats.sentAudio.jitter);
          this.sentAudioStream.jitter = connectionStats.sentAudio.jitter;
        }
      }
      if (connectionStats.sentAudio.fractionLost) {
        if (isValueChangeBeyondThreshold(this.sentAudioStream.fractionLost, connectionStats.sentAudio.fractionLost, FRACTION_LOST_DELTA)) {
          qualityChanges.push('Sent audio fraction lost has changed to: ' + connectionStats.sentAudio.fractionLost);
          this.sentAudioStream.fractionLost = connectionStats.sentAudio.fractionLost;
        }
      }
      if (connectionStats.sentAudio.roundTripTime) {
        if (isValueChangeBeyondThreshold(this.sentAudioStream.roundTripTime, connectionStats.sentAudio.roundTripTime, ROUNDTRIP_TIME_DELTA)) {
          qualityChanges.push('Sent audio round trip time has changed to: ' + connectionStats.sentAudio.roundTripTime);
          this.sentAudioStream.roundTripTime = connectionStats.sentAudio.roundTripTime;
        }
      }
    }

    if (connectionStats.sentVideo) {
      if (connectionStats.sentVideo.packetsLost) {
        if (isValueChangeBeyondThreshold(this.sentVideoStream.packetsLost, connectionStats.sentVideo.packetsLost, LOST_PACKETS_DELTA)) {
          qualityChanges.push('Sent video packets lost: ' + connectionStats.sentVideo.packetsLost);
          this.sentVideoStream.packetsLost = connectionStats.sentVideo.packetsLost;
        }
      }
      if (connectionStats.sentVideo.packetsDiscarded) {
        if (isValueChangeBeyondThreshold(this.sentVideoStream.packetsDiscarded, connectionStats.sentVideo.packetsDiscarded, DISCARDED_PACKETS_DELTA)) {
          qualityChanges.push('Sent video packets discarded: ' + connectionStats.sentVideo.packetsDiscarded);
          this.sentVideoStream.packetsDiscarded = connectionStats.sentVideo.packetsDiscarded;
        }
      }
      if (connectionStats.sentVideo.jitter) {
        if (isValueChangeBeyondThreshold(this.sentVideoStream.jitter, connectionStats.sentVideo.jitter, JITTER_DELTA)) {
          qualityChanges.push('Sent video jitter has changed to: ' + connectionStats.sentVideo.jitter);
          this.sentVideoStream.jitter = connectionStats.sentVideo.jitter;
        }
      }
      if (connectionStats.sentVideo.fractionLost) {
        if (isValueChangeBeyondThreshold(this.sentVideoStream.fractionLost, connectionStats.sentVideo.fractionLost, FRACTION_LOST_DELTA)) {
          qualityChanges.push('Sent video fraction lost has changed to: ' + connectionStats.sentVideo.fractionLost);
          this.sentVideoStream.fractionLost = connectionStats.sentVideo.fractionLost;
        }
      }
      if (connectionStats.sentVideo.roundTripTime) {
        if (isValueChangeBeyondThreshold(this.sentVideoStream.roundTripTime, connectionStats.sentVideo.roundTripTime, ROUNDTRIP_TIME_DELTA)) {
          qualityChanges.push('Sent video round trip time has changed to: ' + connectionStats.sentVideo.roundTripTime);
          this.sentVideoStream.roundTripTime = connectionStats.sentVideo.roundTripTime;
        }
      }
    }

    if (qualityChanges.length > 0 && this.onConnectionParametersChanged) {
      this.onConnectionParametersChanged(qualityChanges);
    }
  };

  PeerConnectionQualityMonitor.prototype.processStatsReport = function processStatsReport(stats) {
    var currentPair = void 0;
    var statsSample = {};

    stats.forEach(function (report) {
      if (report.type === 'transport') {
        currentPair = stats.get(report.selectedCandidatePairId);
      } else if (report.type === 'candidate-pair' && report.selected) {
        currentPair = report;
      } else if (report.type === 'inbound-rtp') {
        if (report.kind === 'video') {
          statsSample.receivedVideo = {
            packetsLost: report.packetsLost,
            packetsDiscarded: report.packetsDiscarded,
            jitter: report.jitter
          };
        } else if (report.kind === 'audio') {
          statsSample.receivedAudio = {
            packetsLost: report.packetsLost,
            packetsDiscarded: report.packetsDiscarded,
            jitter: report.jitter
          };
        }
      } else if (report.type === 'remote-inbound-rtp') {
        if (report.kind === 'video') {
          statsSample.sentVideo = {
            packetsLost: report.packetsLost,
            packetsDiscarded: report.packetsDiscarded,
            jitter: report.jitter,
            fractionLost: report.fractionLost,
            roundTripTime: report.roundTripTime
          };
        } else if (report.kind === 'audio') {
          statsSample.sentAudio = {
            packetsLost: report.packetsLost,
            packetsDiscarded: report.packetsDiscarded,
            jitter: report.jitter,
            fractionLost: report.fractionLost,
            roundTripTime: report.roundTripTime
          };
        }
      }
    });

    if (currentPair) {
      statsSample.incomingBitrate = currentPair.availableIncomingBitrate;
      statsSample.outgoingBitrate = currentPair.availableOutgoingBitrate;

      if (currentPair.remoteCandidateId && currentPair.localCandidateId) {
        var remoteCandidate = stats.get(currentPair.remoteCandidateId);
        var localCandidate = stats.get(currentPair.localCandidateId);

        statsSample.localCandidateType = localCandidate.candidateType;
        statsSample.localNetworkType = localCandidate.networkType;
        statsSample.localProtocol = localCandidate.protocol;

        statsSample.remoteCandidateType = remoteCandidate.candidateType;
        statsSample.remoteNetworkType = remoteCandidate.networkType;
        statsSample.remoteProtocol = remoteCandidate.protocol;
      }
    }

    this.addStatsSample(statsSample);
  };

  return PeerConnectionQualityMonitor;
}();

/* harmony default export */ var connection_quality_monitoring = (PeerConnectionQualityMonitor);
// CONCATENATED MODULE: ./utils/connection.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALL_FAILED_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INCOMING_CALL_STARTED_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INCOMING_CALL_REQUEST_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OUTGOING_CALL_STARTED_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALL_FINISHED_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_CONNECTED_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SCREEN_SHARING_PERMISSION_DENIED_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RECONNECTION_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ERR_NO_AUDIO_DEVICE; });
/* unused harmony export ERR_ACCESS_TO_MEDIA_DEVICE_DENIED */
/* unused harmony export CallState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, connection__initialiseProps;

function connection__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-cycle */
























var WEBRTC_STUN_PATH = "stun:app.telmie.com:8089";
var WEBRTC_TURN_PATH = "turn:app.telmie.com:8089";
var TURN_USERNAME = "telmieProd";
var TURN_PASSWORD = "ool0Gohwdah1Aeni";
var XMPP_DOMAIN = "telmie.com";
var XMPP_PING_INTERVAL_MS = 1000 * 20;
var XMPP_PONG_INTERVAL_MS = 1000 * 10;
var XMPP_MAX_MISSED_PONGS = 3;
var XMPP_ACK_REQUEST_DISABLED = 0;
var XMPP_MAX_UNACKNOWLEDGED_STANZAS = 5;
var XMPP_MAX_RETRANSMIT_ATTEMPTS = 2;
var WEBRTC_ICE_RESTART_DELAY_AFTER_DISCONNECTED = 10000;
var CROSS_TAB_RINGING_EVENT = 'ringing';
var CALL_FAILED_EVENT = 'callFailed';
var INCOMING_CALL_STARTED_EVENT = 'incomingCallStarted';
var INCOMING_CALL_REQUEST_EVENT = 'incomingCallRequest';
var OUTGOING_CALL_STARTED_EVENT = 'outgoingCallStarted';
var CALL_FINISHED_EVENT = 'callFinished';
var CALL_CONNECTED_EVENT = 'callConnected';
var SCREEN_SHARING_PERMISSION_DENIED_EVENT = 'screenSharingPermissionDenied';
var RECONNECTION_COMPLETE = 'reconnectionComplete';

var MAX_SUPPORTED_SIGNALING_PROTOCOL = '3.1';
var MIN_SIGNALING_PROTOCOL_SUPPORTING_CALLSATUS_REQUEST = '3.1';
var MIN_SUPPORTED_SIGNALING_PROTOCOL = '3.0';

var ERR_NO_AUDIO_DEVICE = 'Starting a call requires your system to have at least one working audio input device such as a microphone or a headset';
var ERR_ACCESS_TO_MEDIA_DEVICE_DENIED = 'Access to the microphone or camera is denied; please check your security settings';

var CallState = new Enum({
  IDLE: { value: 0, description: '' },
  INVITED: { value: 1, description: 'request' },
  ACCEPTED: { value: 2, description: 'accepted' },
  ACTIVE: { value: 3, description: 'speaking' },
  SUCCEEDED: { value: 4, description: 'finished' },
  BREAK: { value: 5, description: 'avTimeEnded | bookingEnded' },
  PRO_BUSY: { value: 6, description: 'proBusy' },
  NO_ANSWER: { value: 7, description: 'noAnswer' },
  CLIENT_DECLINE: { value: 8, description: 'clientDeclined' },
  PRO_DECLINE: { value: 9, description: 'receiverDeclined' },
  DISCONNECTED: { value: 10, description: 'rtcConnectionLost | callDisconnected' },
  FAILED: { value: 11, description: 'failed' },
  PRO_TIMEOUT: { value: 12, description: 'before sending receiverDeclined on timeout' }
});

var __FILE__ = 'connection.js';

var connection_stropheLogger = function stropheLogger(level, msg) {
  var __METHOD__ = 'Connection::stropheLogger';

  if (level >= strophe_umd["Strophe"].LogLevel.WARN) {
    logger["k" /* logXMPPClient */](__FILE__, __METHOD__, msg);
  }
};

var connection_Connection = (_temp = _class = function () {
  function Connection(props) {
    connection__classCallCheck(this, Connection);

    connection__initialiseProps.call(this);

    strophe_umd["Strophe"].addNamespace('PING', 'urn:xmpp:ping');
    strophe_umd["Strophe"].addNamespace('DELAY', 'urn:xmpp:delay');

    this._userAuth = '';
    this._curUserId = 0;
    this._curUserJID = '';

    this._calleeId = '';
    this._calleeJID = '';
    this.callInitiatorJID = null;

    this.offsetAutoGetHistory = 0;

    this.props = props;

    this.persons = {};
    this.webRtcPeers = {};
    this.candidates = [];
    this.localStream = null;
    this.mediaConstraints = { video: false, audio: false };
    this.amICallee = false;
    // UGLY HACK for iOS delayed messaging,
    // when offerData and iceCandidates comes after call rejection
    this.callWasRejected = false;
    this.callFailed = false;
    this.connected = false;

    this.initialised = false;

    this.presenceConfirmationGranted = false;
    this.callTimeBeep = consts["I" /* timeouts */].autoRejectTimeout;

    this.isScreenSharingListener = true;

    this.isAttemptingToConnect = false;
    this.pingTimer = undefined;
    this.pongTimer = undefined;
    this.pingIqId = undefined;
    this.missedPongsCount = 0;
    this.awaitPongResponseArmed = false;
    this.callState = CallState.IDLE;

    this.unacknowledgedStanzas = {};
    this.unacknowledgedStanzaRetryCounts = {};
    this.messageHistoryIQIds = {};

    this.isOutgoingScreenSharingMuted = true;
    this.isOutgoingVideoMuted = true;
    this.isOutgoingAudioMuted = true;

    var __CALLBACK_METHOD__ = 'Connection::peerConnectionQualityMonitorCallback';
    this.connectionQualityMonitor = new connection_quality_monitoring(function (qualityChanges) {
      return qualityChanges.forEach(function (change) {
        return logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD__, change);
      });
    });

    this.events = new eventemitter3_default.a();
  }

  /**
   * @param {Element} msg
   */


  // -- Timeouts start ---

  // -- Timeouts end ---

  Connection.prototype.sendPresence = function sendPresence() {
    var statusText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Available';
    var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var __METHOD__ = 'Connection::sendPresence';

    var id = this.connection.getUniqueId('presence');
    var m = Object(strophe_umd["$pres"])({ from: this._curUserJID, id: id });

    if (statusText) {
      m.c('status', {}).t(statusText);
      m.up();
    }

    if (priority) {
      m.c('priority', {}).t(priority.toString());
      m.up();
    }

    if (show) {
      m.c('show', {}).t(show);
    }

    try {
      if (this.connection.connected) {
        this.connection.send(m);
      } else {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to send presence', lib["LogLevel"].Warning);
      }
    } catch (err) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to send the presence', lib["LogLevel"].Error, err);
    }
  };

  return Connection;
}(), connection__initialiseProps = function _initialiseProps() {
  var _this = this;

  this.setCallTimeBeep = function (callTimeBeepSec) {
    _this.callTimeBeep = callTimeBeepSec * 1000;
  };

  this.initializeConnection = function (props) {
    return new Promise(function ($return, $error) {
      var __METHOD__, __CALLBACK_METHOD__, _props$userData, user, userAuth, id, oldUserId, hasNoEffectMessage;

      __METHOD__ = 'Connection::initializeConnection';
      __CALLBACK_METHOD__ = 'Connection::stropheXmlOutputCallback';

      if (!_this.isAttemptingToConnect && !_this.connected) {
        _this.isAttemptingToConnect = true;
        _props$userData = props.userData, user = _props$userData === undefined ? {} : _props$userData;

        if (Object.keys(user).length === 0) return $return();

        _this.presenceConfirmationGranted = false;

        userAuth = user.userAuth, id = user.id;

        oldUserId = _this._curUserId;
        _this._curUserId = id;
        _this._curUserJID = Object(utils["d" /* generateJID */])(_this._curUserId, false, _this.props.uuid);
        _this._userAuth = userAuth || localStorage.getItem(consts["z" /* USER_AUTH */]);
        return Promise.resolve(Object(con_helpers["e" /* getMediaConstraints */])()).then(function ($await_31) {
          try {
            _this.mediaConstraints = $await_31;

            _this.disarmPingPongMonitoring();

            if (oldUserId && oldUserId !== id) {
              _this.unacknowledgedStanzas = {};
              _this.unacknowledgedStanzaRetryCounts = {};
              _this.messageHistoryIQIds = {};
            }

            strophe_umd["Strophe"].log = connection_stropheLogger;

            if (_this.connection) {
              _this.connection.reset();
            }

            _this.connection = new strophe_umd["Strophe"].Connection('wss://' + api["c" /* webSocketHost */] + ':5281/websocket', {});

            _this.connection.streamManagement.logging = "production" === consts["h" /* ENVIRONMENTS */].DEVELOPMENT;
            _this.connection.streamManagement.addAcknowledgedStanzaListener(_this.onAcknowledgedStanza);
            _this.connection.streamManagement.requestResponseInterval = XMPP_ACK_REQUEST_DISABLED;

            _this.connection.connect(_this._curUserJID, '', _this.onConnect);

            _this.oldConnectionXmlOutputHandler = _this.connection.xmlOutput;
            _this.connection.xmlOutput = function (elem) {
              try {
                if (elem.localName.toLowerCase() === 'iq') {
                  if (elem.childElementCount === 0 && elem.hasAttribute('type') && elem.getAttribute('type').toLowerCase() === 'result') {
                    // Do not output ping replies
                    return;
                  }

                  if (elem.lastElementChild && elem.lastElementChild.localName === 'ping' && elem.lastElementChild.childElementCount === 0) {
                    // Do not output ping requests
                    return;
                  }
                }

                if (elem.localName.toLowerCase() === 'a') {
                  // Do not output stream management ACKs
                  return;
                }

                if (elem.localName.toLowerCase() === 'message' && elem.hasAttribute('type') && elem.getAttribute('type').toLowerCase() === 'chat') {
                  // Redact chat message body
                  logger["m" /* logXMPPSend */](__FILE__, __CALLBACK_METHOD__, Object(con_helpers["l" /* redactChatMessageBody */])(elem));
                } else {
                  logger["m" /* logXMPPSend */](__FILE__, __CALLBACK_METHOD__, '' + elem.outerHTML);
                }
              } finally {
                if (_this.oldConnectionXmlOutputHandler && typeof _this.oldConnectionXmlOutputHandler === 'function') {
                  _this.oldConnectionXmlOutputHandler(elem);
                }
              }
            };

            _this._crossTabEmitter && typeof _this._crossTabEmitter.removeAllListeners !== 'undefined' && _this._crossTabEmitter.removeAllListeners();
            _this._crossTabEmitter = tab_emitter_default()(_this._curUserId);
            _this._crossTabEmitter.on(CROSS_TAB_RINGING_EVENT, _this.onRinging.bind(_this));
            return $If_22.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      } else {
        hasNoEffectMessage = void 0;

        if (_this.connected) {
          hasNoEffectMessage = 'ignoring as the connection has been already established';
        } else if (_this.isAttemptingToConnect) {
          hasNoEffectMessage = 'ignoring because already trying to reconnect';
        }

        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, hasNoEffectMessage);
        return $If_22.call(this);
      }

      function $If_22() {
        return $return();
      }
    });
  };

  this.disarmPingPongMonitoring = function () {
    _this.pingIqId = undefined;
    _this.missedPongsCount = 0;
    _this.awaitPongResponseArmed = false;

    if (_this.pingTimer) {
      clearInterval(_this.pingTimer);
      _this.pingTimer = undefined;
    }
    if (_this.pongTimer) {
      clearTimeout(_this.pongTimer);
      _this.pongTimer = undefined;
    }
  };

  this._finalizeDisconnection = function () {
    _this.unacknowledgedStanzas = {};
    _this.unacknowledgedStanzaRetryCounts = {};

    _this.presenceConfirmationGranted = false;

    _this._userAuth = '';
    _this._curUserId = 0;
    _this._curUserJID = '';
    _this._calleeId = '';
    _this._calleeJID = '';
    _this.callInitiatorJID = null;

    _this._crossTabEmitter && _this._crossTabEmitter.removeAllListeners(CROSS_TAB_RINGING_EVENT);
    _this._crossTabEmitter = undefined;

    _this.connection.disconnect();
  };

  this.disconnect = function () {
    _this.disarmPingPongMonitoring();

    _this.retransmitUnacknowledgedStanzas().then(_this._finalizeDisconnection).catch(_this._finalizeDisconnection);
  };

  this.handleConnectionLoss = function () {
    _this.props.changeConnectedState(false);
    _this.connected = false;

    _this.disarmPingPongMonitoring();
  };

  this.requestAcknowledgementForSentStanzas = function () {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var __METHOD__ = 'Connection::requestAcknowledgementForSentStanzas';
    if (force || Object.keys(_this.unacknowledgedStanzas).length >= XMPP_MAX_UNACKNOWLEDGED_STANZAS) {
      try {
        if (_this.connection.connected) {
          _this.connection.streamManagement.requestAcknowledgement();
        } else {
          logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available', lib["LogLevel"].Warning);
        }
      } catch (err) {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to send an acknowledgement request', lib["LogLevel"].Error, err);
      }
    }
  };

  this.retransmitUnacknowledgedStanzas = function () {
    return new Promise(function (resolve, reject) {
      var __METHOD__ = 'Connection::retransmitUnacknowledgedStanzas';

      var retransmissions = [];
      var me = _this;

      var unacknowledgedStanzaIds = Object.keys(me.unacknowledgedStanzas);

      if (unacknowledgedStanzaIds.length === 0) {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'no unacknowledged stanzas to retransmit');
        resolve();
        return;
      }

      try {
        unacknowledgedStanzaIds.forEach(function (stanzaId) {
          var stanza = me.unacknowledgedStanzas[stanzaId];
          var retryCount = me.unacknowledgedStanzaRetryCounts[stanzaId] || 0;

          if (retryCount <= XMPP_MAX_RETRANSMIT_ATTEMPTS) {
            // We generally assume that the stored unacknowledged stanzas are
            // instances of Strophe.Builder, but still perform an additional check
            // just to be on the safe side.
            if (stanza && stanza.root && typeof stanza.root === 'function') {
              // If an outbound call is in progress and we do know that the call request message was
              // acknowledged - do not re-transmit any <request ...> stanzas to avoid unexpected
              // behavior on ejabberd side.
              if (me.callId && !me.amICallee && me.callRequestWasAcknowledged) {
                var _isCallRequestMsg = Object(con_helpers["f" /* isCallRequestMsg */])(stanza),
                    isCallRequest = _isCallRequestMsg[0];

                if (isCallRequest) {
                  delete me.unacknowledgedStanzaRetryCounts[stanzaId];
                } else {
                  retransmissions.push(stanza);
                }
              } else {
                retransmissions.push(stanza);
              }
            }
          } else {
            delete me.unacknowledgedStanzaRetryCounts[stanzaId];
          }
        });

        me.unacknowledgedStanzas = {};

        // Schedule a retransmission burst in the background.
        setTimeout(function () {
          try {
            logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Initiating a retransmission burst for ' + retransmissions.length + ' stanzas', lib["LogLevel"].Info, retransmissions.map(function (b) {
              return Object(con_helpers["l" /* redactChatMessageBody */])(b.tree());
            }));
            retransmissions.forEach(function (stanza) {
              var stanzaId = stanza.tree().getAttribute('id');
              var retryCount = me.unacknowledgedStanzaRetryCounts[stanzaId] || 0;

              me.unacknowledgedStanzas[stanzaId] = stanza;
              me.unacknowledgedStanzaRetryCounts[stanzaId] = retryCount + 1;

              try {
                if (me.connection) {
                  me.connection.send(stanza);
                } else {
                  logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'unable to re-send stanza ' + Object(con_helpers["l" /* redactChatMessageBody */])(stanza.tree()) + ': no XMPP connection is available', lib["LogLevel"].Warning);
                }
              } catch (sendErr) {
                logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'unable to re-send stanza ' + Object(con_helpers["l" /* redactChatMessageBody */])(stanza.tree()), lib["LogLevel"].Warning, sendErr);
              }
            });

            me.connection.streamManagement.requestAcknowledgement();

            logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Retransmission burst complete');

            resolve();
          } catch (err) {
            logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Retransmission burst failed', lib["LogLevel"].Error, err);

            reject(err);
          }
        }, 0);
      } catch (err) {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Preparing to retransmission failed', lib["LogLevel"].Error, err);

        reject(err);
      }
    });
  };

  this.sendPing = function () {
    var __METHOD__ = 'Connection::sendPing';
    var __CALLBACK_METHOD_PONG__ = 'Connection::sendPing::pongTimer';
    var __CALLBACK_METHOD_SENDIQ__ = 'Connection::sendPing::sendIqCallback';

    if (_this.connected && _this._curUserJID) {
      if (_this.unacknowledgedStanzas.length > 0) {
        // Request acknowledgement in lieu of a keep-alive message
        _this.requestAcknowledgementForSentStanzas(true);
      } else {
        // No unacknowledged stanzas - send a regular ping IQ as a keep-alive message
        var id = _this.connection.getUniqueId('ping');
        var iq = Object(strophe_umd["$iq"])({
          type: 'get',
          to: XMPP_DOMAIN,
          id: id
        }).c('ping', { xmlns: strophe_umd["Strophe"].NS.PING });

        try {
          if (_this.connection.connected) {
            _this.connection.sendIQ(iq, function () {
              logger["j" /* logWithTag */](__FILE__, __CALLBACK_METHOD_SENDIQ__, logger["f" /* TAG_XMPP_CLIENT */], 'Successfully sent a ping to the server', lib["LogLevel"].Info, undefined, true);
            }, function () {
              logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Sending a ping to a server failed', lib["LogLevel"].Warning);
            }, consts["s" /* RECONNECT_TIMEOUT_MS */]);
          } else {
            logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available', lib["LogLevel"].Warning);
          }
        } catch (err) {
          logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to send a ping', lib["LogLevel"].Error, err);
        }

        if (_this.pongTimer) {
          clearTimeout(_this.pongTimer);
        }

        _this.pingIqId = id;
        _this.awaitPongResponseArmed = true;
        _this.pongTimer = setTimeout(function () {
          if (_this.awaitPongResponseArmed) {
            _this.awaitPongResponseArmed = false;
            _this.missedPongsCount += 1;
            if (_this.missedPongsCount >= XMPP_MAX_MISSED_PONGS) {
              logger["k" /* logXMPPClient */](__FILE__, __CALLBACK_METHOD_PONG__, 'Exceeded the number of missed pong responses. Forcing a disconnect', lib["LogLevel"].Warning);
              setTimeout(function () {
                _this.connection.disconnect();
              }, 0);
            }
          }
        }, XMPP_PONG_INTERVAL_MS);
      }
    }
  };

  this.onConnect = function (status, condition) {
    var __METHOD__ = 'Connection::onConnect';

    if (status === strophe_umd["Strophe"].Status.CONNECTED) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Strophe is connected');

      // Enable stream management
      _this.connection.streamManagement.enable();
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Stream management enabled');

      _this.connection.addHandler(_this.onMessage.bind(_this), null, 'message', null, null, null);
      _this.connection.addHandler(_this.onIq.bind(_this), null, 'iq', null, null, null);
      _this.connection.addHandler(_this.onPresenceSubscriptionRequest.bind(_this), null, 'presence', 'subscribe', null, null, null);

      _this.sendPresence();
      _this.getServerTime();
      _this.synchronize();

      if (_this.initialised) {
        _this.undoFinishCallOnXMPPConnectionLost();

        // We send the recovered stanza either for inbound calls (unconditionally),
        // or for outbound calls when we got an acknowledgement
        if (_this.callId && (_this.amICallee || _this.callRequestWasAcknowledged)) {
          _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', {
            type: 'recovered',
            callid: _this.callId
          }, undefined, true);

          logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Sending a \'recovered\' stanza for call ID: ' + _this.callId);
        }

        // Do not initiate retransmission immediately as there is a chance we might get more acknowledgements
        // from ejabberd after the connection has been established. Instead, request acknowledgement explicitly
        // and provide an one-time handler for the incoming acknowledgement stanza that will trigger the
        // retransmission.
        _this.connection.streamManagement.onAcknowledgementComplete = function () {
          setTimeout(function () {
            _this.retransmitUnacknowledgedStanzas().then(function () {
              _this.events.emit(RECONNECTION_COMPLETE);
            });
          }, 0);

          return false;
        };
        _this.connection.streamManagement.requestAcknowledgement();

        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'RECONNECTED AGAIN');
      } else {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'FIRST TIME CONNECTED');

        _this.initialised = true;
      }

      _this.props.changeConnectedState(true);
      _this.connected = true;

      _this.isAttemptingToConnect = false;
      clearTimeout(_this.reconnectTimeout);

      _this.pingTimer = setInterval(function () {
        _this.sendPing();
      }, XMPP_PING_INTERVAL_MS);
    } else if (status === strophe_umd["Strophe"].Status.CONNECTING) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Strophe is connecting');

      // Prevent any concurrent reconnection attempts
      _this.isAttemptingToConnect = true;
    } else if (status === strophe_umd["Strophe"].Status.CONNFAIL) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Strophe failed to connect: ' + (condition || 'no reason provided'), lib["LogLevel"].Warning);

      _this.handleConnectionLoss();
      _this.attemptToReconnect();
    } else if (status === strophe_umd["Strophe"].Status.DISCONNECTING) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Strophe is disconnecting: ' + (condition || 'no reason provided'), lib["LogLevel"].Warning);
      // Report the connection as unavailable ASAP to any consumers
      _this.handleConnectionLoss();
    } else if (status === strophe_umd["Strophe"].Status.ERROR) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Strophe reported a connection error: ' + (condition || 'no details provided'), lib["LogLevel"].Warning);
      // Do nothing else as Strophe will force disconnection on its own
      // in case of a fatal error
    } else if (status === strophe_umd["Strophe"].Status.AUTHFAIL) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Strophe was unable to authenticate to ejabberd: ' + (condition || 'no details provided'), lib["LogLevel"].Error);
      // Assume the connection is unavailable if the client was unable
      // to authenticate to ejabberd
      _this.handleConnectionLoss();
    } else if (status === strophe_umd["Strophe"].Status.DISCONNECTED) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Strophe is disconnected: ' + (condition || 'no reason provided'), lib["LogLevel"].Warning);

      if (_this.callId && !_this.isFinishCallOnXMPPConnectionLostTimerArmed()) {
        _this.setFinishCallOnXMPPConnectionLost();
      }
      // Repeat reporting the no longer available connection just in case
      // there was no 'DISCONNECTING' notification from StropheJS
      _this.handleConnectionLoss();
      _this.attemptToReconnect();
    }
  };

  this.attemptToReconnect = function () {
    _this.connection.reset();

    // Allow attempts to reconnect before setting the timer
    _this.isAttemptingToConnect = false;

    if (_this._curUserJID) {
      _this.reconnectTimeout = setTimeout(function () {
        if (!_this.isAttemptingToConnect) {
          _this.props.reconnect(_this.props.uuid);
        }
      }, consts["s" /* RECONNECT_TIMEOUT_MS */]);
    }
  };

  this.onIq = function (msg) {
    var __METHOD__ = 'Connection::onIq';
    var __CALLBACK_METHOD_SENDIQ__ = 'Connection::onIq::sendIqCallback';

    if (!msg) return true;
    var type = msg.getAttribute('type');
    if (type === 'result') {
      var elems = msg.getElementsByTagName('history');
      if (elems.length > 0) {
        // Handle the message history response
        logger["g" /* logChat */](__FILE__, __METHOD__, 'Got message history from the chat server; messages received: ' + (elems[0].childNodes ? elems[0].childNodes.length : 0));

        var stanzaId = msg.getAttribute('id');

        setTimeout(function () {
          var historyRequestKey = Object.keys(_this.messageHistoryIQIds).find(function (key) {
            return _this.messageHistoryIQIds[key] === stanzaId;
          });
          if (historyRequestKey) {
            delete _this.messageHistoryIQIds[historyRequestKey];
          }

          // If we got a reply to an <iq ... > request, the request
          // has been apparently received and handled by the server.
          delete _this.unacknowledgedStanzas[stanzaId];
          delete _this.unacknowledgedStanzaRetryCounts[stanzaId];
        }, 0);

        var isDisplayed = false;
        try {
          if (!elems[0].childNodes || elems[0].childNodes.length === 0) {
            return true;
          }

          var thread = strophe_umd["Strophe"].getText(elems[0].childNodes[0].getElementsByTagName('thread')[0]);

          var participants = thread ? thread.split('-') : [];

          var fromId = stanzaId.split(':history:')[1];

          var arr = [];

          elems[0].childNodes.forEach(function (child) {
            var status = '';
            var timestamp = child.getAttribute('timestamp');
            var fromUserId = strophe_umd["Strophe"].getNodeFromJid(child.getAttribute('from'));
            var markedAsDisplayed = !!child.getElementsByTagName('displayed')[0];
            var iAmRecipient = strophe_umd["Strophe"].getNodeFromJid(child.getAttribute('to')) === _this._curUserId.toString();

            if (markedAsDisplayed) {
              status = 'Read';
            }
            if (child.getElementsByTagName('sent')[0]) {
              status = 'Sent';
            }

            if (iAmRecipient && !markedAsDisplayed) {
              // Schedule sending the "displayed" chat status marker in the background.
              setTimeout(function () {
                return _this.markChatMessage(_this._curUserJID, Object(utils["d" /* generateJID */])(fromUserId, true), child.getAttribute('id'), thread, 'displayed');
              }, 0);
              status = 'Read';
            }

            isDisplayed = isDisplayed || (
            // eslint-disable-next-line no-nested-ternary
            iAmRecipient ? markedAsDisplayed : true);

            var text = strophe_umd["Strophe"].getText(child.getElementsByTagName('body')[0]);
            var message = Object(con_helpers["d" /* encodeXMPPmessage */])(text);
            message.status = status;
            message.timestamp = +timestamp;
            message.id = child.getAttribute('id');
            message.isMy = fromUserId && fromUserId === _this._curUserId.toString();
            arr.push(message);
          });
          _this.props.setMsgHistory(Object(utils["d" /* generateJID */])(fromId, false, _this.props.uuid), arr.sort(function (a, b) {
            return a.timestamp - b.timestamp;
          }), arr.length);
          if (isDisplayed) {
            _this.offsetAutoGetHistory = 0;
          } else {
            _this.offsetAutoGetHistory += consts["E" /* consts */].MES_HISTORY_SIZE;
            _this.getChatMessages.apply(_this, participants.concat([_this.offsetAutoGetHistory]));
          }
        } catch (err) {
          logger["g" /* logChat */](__FILE__, __METHOD__, 'Unexpected error while processing the received chat history', lib["LogLevel"].Error, err);
        }
      } else if (msg.getAttribute('id').endsWith('time_1')) {
        // Handle the time offset response
        _this.offset = Object(getTime["a" /* default */])(new Date(msg.getElementsByTagName('utc')[0].innerHTML)) - Object(getTime["a" /* default */])(new Date());
        _this.props.setTimeOffset(_this.offset);
      } else if (msg.getAttribute('id') === _this.pingIqId) {
        // Handle the pong response
        _this.awaitPongResponseArmed = false;
        clearTimeout(_this.pongTimer);
      }
    } else if (type === 'get') {
      if (msg.firstElementChild && msg.firstElementChild.nodeName === 'ping' && msg.firstElementChild.namespaceURI === strophe_umd["Strophe"].NS.PING) {
        var pingFrom = msg.getAttribute('from');
        var pingId = msg.getAttribute('id');
        var pongIq = Object(strophe_umd["$iq"])({ type: 'result', to: pingFrom, id: pingId });
        try {
          if (_this.connection.connected) {
            _this.connection.sendIQ(pongIq);
            logger["j" /* logWithTag */](__FILE__, __CALLBACK_METHOD_SENDIQ__, logger["f" /* TAG_XMPP_CLIENT */], 'Successfully sent a pong to the server', lib["LogLevel"].Info, undefined, true);
          } else {
            logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to send a pong response', lib["LogLevel"].Warning);
          }
        } catch (err) {
          logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to send a pong response', lib["LogLevel"].Error, err);
        }
      }
    }
    // eslint-disable-next-line consistent-return
    return true;
  };

  this.onPresenceSubscriptionRequest = function (msg) {
    var __METHOD__ = 'Connection::onPresenceSubscriptionRequest';

    var requester = msg.getAttribute('from');
    if (!requester) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'The sender of the incoming presence subscription request is unknown - no reply will be sent', lib["LogLevel"].Warning);

      return;
    }

    var id = _this.connection.getUniqueId('presence');
    var m = Object(strophe_umd["$pres"])({ to: requester, id: id, type: 'subscribed' });

    try {
      if (_this.connection.connected) {
        _this.connection.send(m);
      } else {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to send presence subscription response', lib["LogLevel"].Warning);
      }
    } catch (err) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to send the presence subscription response', lib["LogLevel"].Error, err);
    }
  };

  this.giveReasonForNotSendingAnSDPOffer = function (signalingState) {
    if (_this.answering) {
      return 'because the callee role is not expected to generate offers';
    }
    if (signalingState === 'closed') {
      return 'because of an unsuitable signaling state';
    }

    return 'and the reason could not be determined';
  };

  this.onnegotiationneeded = function (from) {
    var __METHOD__ = 'Connection::onnegotiationneeded';

    if (_this.webRtcPeers[from]) {
      var state = _this.webRtcPeers[from].peerConnection.signalingState;
      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'About to generate an SDP offer for a single peer: ' + from + '. The peer\'s current signaling state: ' + state + '. Is answering: ' + !!_this.answering);
      var cInfo = _this.props.getCInfo() || {};
      if (state !== 'closed' && !_this.answering) {
        _this.webRtcPeers[from].generateOffer(function (err, offerSdp) {
          if (!err) {
            _this.msgGenSend(_this._curUserJID, from, 'vcxep', 'vcxep', { type: 'offerData', callid: cInfo.callId }, offerSdp, true);

            if (_this.videoSender && _this.videoSender.track) {
              _this.videoSender.replaceTrack(_this.localStream.getVideoTracks()[0]).then(function () {
                _this.videoSender.track.enabled = true;
              }).catch(function (replaceTrackErr) {
                return logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to replace an outgoing video track after sending an offer', lib["LogLevel"].Warning, replaceTrackErr);
              });
            }
          } else {
            logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to generate an SDP offer', lib["LogLevel"].Error, err);
            // & setCallState(NO_CALL);
          }
        });
      } else {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Did not generate an SDP offer for the peer: ' + from + ' ' + _this.giveReasonForNotSendingAnSDPOffer(state));
      }
    } else {
      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Generating SDP offers for all known peers');
      Object.keys(_this.webRtcPeers).forEach(function (key) {
        var state = _this.webRtcPeers[key].peerConnection.signalingState;
        var cInfo = _this.props.getCInfo() || {};

        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'About to generate an SDP offer for a peer: ' + key + '. The peer\'s current signaling state: ' + state + '. Is answering: ' + _this.answering);

        if (state !== 'closed' && !_this.answering) {
          _this.webRtcPeers[key].generateOffer(function (err, offerSdp) {
            if (!err) {
              _this.msgGenSend(_this._curUserJID, key, 'vcxep', 'vcxep', { type: 'offerData', callid: cInfo.callId }, offerSdp, true);
            } else {
              logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to generate an SDP offer', lib["LogLevel"].Error, err); // & setCallState(NO_CALL);
            }
          });
        } else {
          logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Did not generate an SDP offer for the peer: ' + key + ' ' + _this.giveReasonForNotSendingAnSDPOffer(state));
        }
      });
    }
  };

  this.onRinging = function (data) {
    // React only on events emitted for current call.
    // React only on events emitted from other tabs (as each tab has its unique user JID).
    _this.callId && _this.callId === data.callId && _this._curUserJID && _this._curUserJID !== data.currentUserJID && _this.props.changeCallRingtoneStatus(false);
  };

  this.onMessage = function (msg) {
    return new Promise(function ($return, $error) {
      var __METHOD__, __CALLBACK_METHOD_PROCESS_ANSWER__, _processServerMsg, to, from, type, messId, elems, thread, vcxepElems, timestamp, isMe, chatId, _thread, bodyText, message, userInfo, markedChatId, displayedNode, receivedNode, displayedMessageId, parentTag, receivedMessageId, data, toUser, body, _processCallMsg, callType, callId, bodyInner, cInfo, options, callerSupportsCallStatusRequest, handshakeMessage, amICallee, thePeerConnection, remoteStreams, audioStream, i, tracks, currentCall, statusResponseElementOptions, statusResponseBody, obj;

      __METHOD__ = 'Connection::onMessage';
      __CALLBACK_METHOD_PROCESS_ANSWER__ = 'Connection::onMessage::processAnswerCallback';

      _processServerMsg = Object(con_helpers["k" /* processServerMsg */])(msg), to = _processServerMsg.to, from = _processServerMsg.from, type = _processServerMsg.type, messId = _processServerMsg.id, elems = _processServerMsg.elems, thread = _processServerMsg.thread, vcxepElems = _processServerMsg.vcxepElems, timestamp = _processServerMsg.timestamp, isMe = _processServerMsg.isMe;

      chatId = strophe_umd["Strophe"].getBareJidFromJid(from);
      if (type === 'chat' && elems.length > 0) {
        logger["l" /* logXMPPReceive */](__FILE__, __METHOD__, Object(con_helpers["l" /* redactChatMessageBody */])(msg));

        _thread = strophe_umd["Strophe"].getText(thread[0]);
        bodyText = strophe_umd["Strophe"].getText(elems[0]);
        message = Object(con_helpers["d" /* encodeXMPPmessage */])(bodyText);
        return Promise.resolve(Object(con_helpers["j" /* processChatMsg */])(isMe ? to : from, _this._curUserId, _this._userAuth, _this.props.changeUnreadNum, message, _this.props.createNotification, _this.callState === CallState.INVITED || _this.callState === CallState.ACCEPTED || _this.callState === CallState.ACTIVE ? undefined : _this.props.messageAudio, _this._calleeId, isMe)).then(function ($await_32) {
          try {
            userInfo = $await_32;
            message.timestamp = timestamp;
            if (isMe) {
              message.status = consts["H" /* statuses */].SENT;
            }
            _this.props.setMsg(userInfo.id, userInfo.isUserPro, Object(utils["d" /* generateJID */])(userInfo.id, false, _this.props.uuid), _extends({}, message, { id: messId, thread: _thread }), isMe);
            if (!isMe) {
              _this.markChatMessage(_this._curUserJID, Object(utils["d" /* generateJID */])(userInfo.id, true), messId, _thread, 'received');
            }
            if (userInfo) _this.props.setUsr(userInfo);
            return $If_23.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }

      function $If_23() {
        if (type === 'chat_status') {
          logger["l" /* logXMPPReceive */](__FILE__, __METHOD__, msg.outerHTML);

          markedChatId = chatId;

          displayedNode = msg.getElementsByTagName('displayed')[0];

          receivedNode = msg.getElementsByTagName('received')[0];
          if (receivedNode && receivedNode.namespaceURI.startsWith('urn:xmpp:carbons:')) {
            // Unwrap the forwarded chat marker
            receivedNode = receivedNode.querySelector('forwarded message received');
            markedChatId = receivedNode ? strophe_umd["Strophe"].getBareJidFromJid(receivedNode.parentElement.getAttribute('from')) : markedChatId;
          }

          if (displayedNode) {
            displayedMessageId = displayedNode.id;

            parentTag = displayedNode.parentElement;
            markedChatId = parentTag && parentTag.tagName === 'message' ? strophe_umd["Strophe"].getBareJidFromJid(parentTag.getAttribute('from')) : markedChatId;

            _this.props.updateMsgStatus(markedChatId, displayedMessageId, consts["H" /* statuses */].READ);
          }

          if (receivedNode) {
            receivedMessageId = receivedNode.id;
            clearTimeout(_this['failed-' + receivedMessageId + '-timeout']);
            _this.props.updateMsgStatus(markedChatId, receivedMessageId, consts["H" /* statuses */].DELIVERED);
          }
        }
        if (type === 'error') {
          logger["l" /* logXMPPReceive */](__FILE__, __METHOD__, Object(con_helpers["l" /* redactChatMessageBody */])(msg));

          if (_this['failed-' + messId + '-timeout']) {
            _this.props.updateMsgStatus(chatId, messId, consts["H" /* statuses */].SENT);
            clearTimeout(_this['failed-' + messId + '-timeout']);
          }
        }
        if (type === 'badgeInfoUpdate') {
          data = JSON.parse(elems[0].textContent);
          return Promise.resolve(Object(con_helpers["a" /* checkUserAndGet */])(data.personInfo.personID, _this._userAuth)).then(function ($await_33) {
            try {
              toUser = $await_33;
              data.personInfo.toUser = toUser;
              _this.props.changeUnreadNum(data);
              return $If_24.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        }

        function $If_24() {
          if (type === 'vcxep' && vcxepElems.length > 0) {
            logger["l" /* logXMPPReceive */](__FILE__, __METHOD__, msg.outerHTML);

            body = vcxepElems[0];
            _processCallMsg = Object(con_helpers["i" /* processCallMsg */])(body), callType = _processCallMsg.type, callId = _processCallMsg.callId, bodyInner = _processCallMsg.bodyInner;


            cInfo = _this.props.getCInfo() || {};
            options = {
              localVideo: _this.videoOutput,
              remoteVideo: _this.videoInput,
              remoteAudio: _this.audioInput,
              onicecandidate: Object(con_helpers["h" /* onIceCandidate */])(_this._curUserJID, _this._calleeJID, cInfo.id || callId, _this.msgGenSend),
              mediaConstraints: _this.mediaConstraints,
              receiveConstraints: { video: true, audio: true },
              onnegotiationneeded: function onnegotiationneeded() {
                if (!_this.amICallee) {
                  _this.onnegotiationneeded(_this._calleeJID);
                } else {
                  _this.offerRequest();
                }
              },
              configuration: {
                iceServers: [{
                  urls: WEBRTC_STUN_PATH
                }, {
                  urls: WEBRTC_TURN_PATH,
                  username: TURN_USERNAME,
                  credential: TURN_PASSWORD
                }]
              }
            };
            logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Incoming | ' + callType + ', for call ID: ' + callId, body);
            switch (callType) {
              case 'request':
                if (cInfo.callId && cInfo.callId !== callId) {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | rejecting the incoming call with busy status. Another call with cInfo.callId=' + cInfo.callId + ' is in progress');
                  _this.callState = CallState.PRO_BUSY;
                  _this.msgGenSend(_this._curUserJID, chatId, 'vcxep', 'vcxep', { type: 'proBusy', callid: callId }, undefined, true);

                  break;
                } else if (_this.callId && _this.callId !== callId) {
                  _this.callState = CallState.PRO_BUSY;
                  _this.msgGenSend(_this._curUserJID, chatId, 'vcxep', 'vcxep', { type: 'proBusy', callid: callId }, undefined, true);
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | rejecting the incoming call with busy status. Another call with this.callId=' + _this.callId + ' is in progress');

                  break;
                } else if (_this.callId && _this.callId === callId) {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the incoming call request with this.callId=' + _this.callId + ' as this call is already in progress');
                  break;
                } else {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | Initiating the call flow for call with this.callId=' + _this.callId);
                  _this.callId = callId;
                  _this.callRequestWasAcknowledged = undefined;
                  _this.callWasRejected = false;
                  _this.callFailed = false;
                  _this.amICallee = true;
                  _this.waitData = true;
                  _this.wasAccepted = false;
                  _this.callProtocolVersion = _this.getCallProtocolVersionFromCallRequest(body);
                  _this.incomingVideoEnabled = false;
                  _this.isOutgoingScreenSharingMuted = true;
                  _this.isOutgoingVideoMuted = true;
                  _this.isOutgoingAudioMuted = true;

                  _this.webRtcPeers = {};
                  _this.candidates = [];

                  _this.callInitiatorJID = chatId;

                  _this.callState = CallState.INVITED;

                  // Arm a timer to automatically terminate the call if the call
                  // did not connect within the allowed timeout.
                  //
                  // We pass an artificially constructed cInf instance to ensure
                  // correct behavior of the rejectCall method at early stages
                  // of the call flow before the call info was retrieved from the
                  // back-end API and stored to the application-wide state.
                  _this.setProAutoDecline({
                    callerId: strophe_umd["Strophe"].getNodeFromJid(chatId),
                    // The person property here is not connected to featured calls, but is rather
                    // a hack necessary to pass the caller's JID to rejectCall if the Pro auto-rejection
                    // timer fires before a presenceConfirmationGranted signaling is received
                    // (and hence before the communicateModal.callInfo state is populated and this._calleeJID is set).
                    person: chatId
                  });
                  _this.events.emit(INCOMING_CALL_REQUEST_EVENT, callId);
                }

                callerSupportsCallStatusRequest = _this.isCallStatusRequestSupported(_this.callProtocolVersion);
                logger["h" /* logSignaling */](__FILE__, __METHOD__, callerSupportsCallStatusRequest ? 'Decision | The caller has indicated support for signaling protocol version ' + _this.callProtocolVersion + '. Initiating the "callStatusRequest" handshake' : 'Decision | The caller has not indicated a supported signaling protocol version. Assuming the legacy "presenseConfirmationRequest" handshake');

                handshakeMessage = callerSupportsCallStatusRequest ? { type: 'callStatusRequest', callid: callId } : { type: 'presenseConfirmationRequest', callid: callId };
                _this.msgGenSend(_this._curUserJID, from, 'vcxep', 'vcxep', handshakeMessage, undefined, true);

                break;
              case 'dis_video':
                _this.incomingVideoEnabled = false;
                _this.props.changeVideoStreamStatus(false);
                break;
              case 'en_video':
                _this.incomingVideoEnabled = true;
                _this.playIncomingVideoStream(from);
                _this.props.changeVideoStreamStatus(true);
                break;
              case 'receiverDeclined':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (_this.callHasBeenAcceptedOnProsDevice()) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | "receiverDeclined" signaling received ' + ' but ignored as the call has been accepted on another Pro\'s device');

                    break;
                  }

                  _this.props.caleeIsBusy();
                  _this.undoAutoReject();
                  _this.stopCommunication(false);
                  _this.callState = CallState.PRO_DECLINE;
                  _this.msgGenSend(_this._curUserJID, strophe_umd["Strophe"].getBareJidFromJid(_this._calleeJID), 'vcxep', 'vcxep', {
                    type: 'declinedElsewhere',
                    callid: cInfo.callId
                  });
                }
                break;
              case 'proBusy':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (_this.callHasBeenAcceptedOnProsDevice()) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | "proBusy" signaling received ' + 'but ignored as the call has been already accepted on another Pro\'s device');

                    break;
                  }
                  _this.props.caleeIsBusy();
                  _this.undoAutoReject();
                  _this.callState = CallState.PRO_BUSY;
                  _this.stopCommunication(false);
                }
                break;
              case 'callerDeclined':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  _this.waitData = false;
                  _this.undoProAutoDecline();
                  _this.callState = CallState.CLIENT_DECLINE;
                  _this.stopCommunication();
                }

                if (!document.hasFocus()) {
                  _this.props.createNotification('Missed call', _this.persons[from], 20000);
                }

                break;
              case 'noAnswer':
                if (!document.hasFocus()) {
                  _this.props.createNotification('Missed call', _this.persons[from], 20000);
                }

                if (_this.callId && '' + _this.callId === '' + callId) {
                  _this.undoProAutoDecline();
                  _this.callState = CallState.NO_ANSWER;
                  _this.stopCommunication();
                  if (_this.waitVideoElemsInterval) clearTimeout(_this.waitVideoElemsInterval);
                }

                break;
              case 'acceptedElsewhere':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | "acceptedElsewhere" received, current call info: ' + ('cInfo.callId=' + cInfo.callId + ', this.callId=' + _this.callId));
                  if (!_this.wasAccepted) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | "acceptedElsewhere" signaling received, but according to the app\'s internal state this device has not accepted the call. ' + ' Stopping further communication.', lib["LogLevel"].Info, {
                      callWasAccepted: _this.wasAccepted,
                      localStreamActive: _this.localStream ? _this.localStream.active : false,
                      localStreamID: _this.localStream ? _this.localStream.id : ''
                    });

                    _this.undoProAutoDecline();
                    _this.callState = CallState.IDLE;
                    _this.stopCommunication();
                  } else {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | "acceptedElsewhere" signaling received, but we are the device' + ' that picked the call. Hence, ignoring the signaling.');
                  }
                } else {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | "acceptedElsewhere" received but ignored, as the call with id: ' + (callId + ' is not current'));
                }
                break;
              case 'error':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  _this.undoProAutoDecline();
                  _this.callState = CallState.FAILED;
                  _this.stopCommunication();
                }
                break;
              case 'declinedElsewhere':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (!_this.callWasRejected) {
                    _this.undoProAutoDecline();
                    _this.callState = CallState.IDLE;
                    _this.stopCommunication();
                  } else {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the "declinedElsewhere" message as we are the device that sent it');
                  }
                }
                break;
              case 'forbidden':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | the call with call ID ' + callId + ' was forbidden, stopping communication and disarming the timers');
                  _this.stopWaitingVideoElements();
                  _this.undoAutoReject();
                  _this.undoProAutoDecline();
                  _this.props.caleeIsBusy();
                  _this.candidates = [];
                  // this.stopCommunication();
                  _this.callState = CallState.FAILED;
                  _this.events.emit(CALL_FAILED_EVENT, _this.amICallee, 'The call has forbidden');
                }
                break;
              case 'failed':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (!_this.amICallee) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | "failed" signaling received but ignored in the caller (Client) role');

                    break;
                  }

                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | the call with call ID ' + callId + ' failed on the other side', lib["LogLevel"].Warning, bodyInner);

                  amICallee = _this.amICallee;


                  _this.callState = CallState.FAILED;
                  _this.events.emit(CALL_FAILED_EVENT, amICallee, '' + (amICallee ? 'The call has finished unexpectedly on the Client side' : 'The Pro was unable to accept your call'));
                }
                break;
              case 'granted':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (_this.callHasBeenAcceptedOnProsDevice()) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the "granted" message as the call has been already accepted on another Pro\'s device');
                    return $return();
                  }

                  _this.amICallee = false;

                  if (!_this.webRtcPeers[from]) {
                    _this.props.processCall();

                    // timer ???
                    _this.rescanMediaDevices(_this.shouldForceAudioPermissionCheck()).then(function () {
                      // Need to capture "from" in a closure so that we can use the captured opponent's JID
                      // in the error handler.
                      var peerConnectionCreationFailedHandler = _this.makePeerConnectionCreationFailedHandler(from);

                      navigator.mediaDevices.getUserMedia(_this.mediaConstraints).then(function (capturedStream) {
                        if (_this.callId && '' + _this.callId === '' + callId && !_this.callWasRejected && !_this.callFailed) {
                          _this.webRtcPeers[from] = Object(con_helpers["c" /* createPeerConnection */])(_this._curUserJID, from, _this.msgGenSend, _extends({}, options, {
                            onicecandidate: Object(con_helpers["h" /* onIceCandidate */])(_this._curUserJID, from, cInfo.id || callId, _this.msgGenSend),
                            onnegotiationneeded: function onnegotiationneeded() {
                              return _this.onnegotiationneeded(from);
                            },
                            mediaConstraints: _extends({}, _this.mediaConstraints),
                            videoStream: capturedStream
                          }), cInfo, peerConnectionCreationFailedHandler, _this.canPlayCalleesAudioTrack, _this.shallMuteOutgoingAudio, _this.canPlayIncomingVideo);

                          _this.videoSender = null;

                          _this.localStream = capturedStream;

                          _this.connectionQualityMonitor.resetStats();

                          _this.setPeerStateControl(_this.webRtcPeers[from].peerConnection, from);
                        }
                      }).catch(function (err) {
                        return _this.failCall(_this.tryGetMediaCaptureErrorReason(err), false);
                      });
                    }).catch(function (err) {
                      return _this.failCall(_this.tryGetMediaCaptureErrorReason(err), false);
                    });
                  } else {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | duplicated "granted" message has been ignored, ' + ('as an RTCPeerConnection for callee\'s device \'' + from + '\' has been already created'));
                  }
                }
                break;
              case 'offerData':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (_this.callWasRejected || _this.callFailed) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | offer data received but ignored as the call ' + (_this.callFailed ? 'failed' : 'was already rejected'));
                    return $return();
                  }

                  if (_this.webRtcPeers[from] && _this.webRtcPeers[from].peerConnection.signalingState !== 'stable') {
                    logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Offer data received but ignored due to an inappropriate ' + ('RTCPeerConnection signaling state: "' + _this.webRtcPeers[from].peerConnection.signalingState + '"'));
                    return $return();
                  }

                  logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Received SDP offer data from the remote peer', lib["LogLevel"].Info, bodyInner);

                  _this.answering = !_this.webRtcPeers[from];

                  if (_this.waitVideoElemsInterval) clearTimeout(_this.waitVideoElemsInterval);
                  _this.waitVideoElemsInterval = setInterval(function () {
                    // eslint-disable-next-line no-unused-expressions
                    _this.videoInput && _this.videoOutput && _this.audioInput && _this.callId && '' + _this.callId === '' + callId && !_this.callWasRejected && !_this.callFailed && (_this.props.processCall(), function () {
                      options.localVideo = _this.videoOutput;
                      options.remoteVideo = _this.videoInput;
                      options.remoteAudio = _this.audioInput;
                    }(), clearInterval(_this.waitVideoElemsInterval), function () {
                      if (!_this.webRtcPeers[from]) _this.videoSender = null;
                    }(),
                    // eslint-disable-next-line no-return-assign
                    function () {
                      if (_this.webRtcPeers[from]) {
                        // A WebRTC connection already exists; just reply with an SDP answer.
                        Object(con_helpers["n" /* sendInCallAnswerData */])(_this._curUserJID, _this._calleeJID, _this.webRtcPeers[from], bodyInner, _this.msgGenSend, cInfo, function () {
                          if (_this.videoSender) {
                            _this.videoSender.replaceTrack(_this.localStream.getVideoTracks()[0]).then(function () {
                              _this.videoSender.track.enabled = true;
                            }).catch(function (replaceTrackErr) {
                              return logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to replace an outgoing video track after sending an offer', lib["LogLevel"].Warning, replaceTrackErr);
                            });
                          }
                        });
                      } else {
                        // A WebRTC connection has not been created yet; force peer connection creation before
                        // replying with an SDP answer.
                        _this.rescanMediaDevices(_this.shouldForceAudioPermissionCheck()).then(function () {
                          navigator.mediaDevices.getUserMedia(_this.mediaConstraints).then(function (capturedStream) {
                            if (_this.callId && '' + _this.callId === '' + callId && !_this.callWasRejected && !_this.callFailed) {
                              _this.webRtcPeers[from] = Object(con_helpers["m" /* sendAnswerData */])(_this._curUserJID, _this._calleeJID, bodyInner, _this.msgGenSend, _extends({}, options, {
                                mediaConstraints: _extends({}, _this.mediaConstraints),
                                videoStream: capturedStream
                              }), cInfo, function (err) {
                                _this.answering = false;
                                if (err) {
                                  _this.failCall(err, true);
                                }
                              }, _this.canPlayCallerAudioTrack, _this.shallMuteOutgoingAudio, _this.canPlayIncomingVideo);

                              _this.localStream = capturedStream;

                              _this.setPeerStateControl(_this.webRtcPeers[from].peerConnection, from);

                              logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Diagnostics | Local HTML elements for the audio and video streams became available. WebRTC peer connection to ' + from + ' created.');

                              _this.addAccumulatedRemoteCandidatesToPeerConnection(_this.webRtcPeers[from], from);
                            }
                          }).catch(function (err) {
                            return _this.failCall(_this.tryGetMediaCaptureErrorReason(err), true);
                          });
                        }).catch(function (err) {
                          return _this.failCall(_this.tryGetMediaCaptureErrorReason(err), true);
                        });
                      }
                    }(), _this.waitVideoElemsInterval = null);
                  }, 100);
                } else {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | Ignoring the received offer data for call ID ' + callId + ' which is not current');
                }
                break;
              case 'answerData':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (_this.callHasBeenAcceptedOnProsDevice() && from !== _this._calleeJID) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the "answerData" message from any other Pro\'s devices as the call has been already accepted on another Pro\'s device');
                    return $return();
                  }

                  if (_this.webRtcPeers[from]) {
                    if (_this.webRtcPeers[from].peerConnection.signalingState === 'stable' || _this.webRtcPeers[from].peerConnection.signalingState === 'have-remote-pranswer') {
                      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Answer data received but ignored due to an inappropriate ' + ('RTCPeerConnection signaling state: \'' + _this.webRtcPeers[from].peerConnection.signalingState + '\''));

                      return $return();
                    }

                    logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Processing the received SDP answer', lib["LogLevel"].Info, bodyInner);

                    _this.webRtcPeers[from].processAnswer(bodyInner, function (err) {
                      if (!err) {
                        logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_PROCESS_ANSWER__, 'The received SDP answer has been processed');
                      } else {
                        logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_PROCESS_ANSWER__, 'Failed to process the received SDP answer', lib["LogLevel"].Error, err);
                      }
                    });
                  }
                } else {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | Ignoring the received answer data for call ID ' + callId + ' which is not current');
                }
                break;
              case 'accept':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (_this.callHasBeenAcceptedOnProsDevice()) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | Ignoring the received "accepted" message as the call has been accepted on another Pro\'s device');
                    break;
                  }

                  _this.undoAutoReject();
                  _this.undoProAutoDecline();
                  _this._calleeJID = from;
                  _this.callState = CallState.ACCEPTED;
                  _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', {
                    type: 'speaking',
                    callid: cInfo.callId
                  });
                  _this.msgGenSend(_this._curUserJID, strophe_umd["Strophe"].getBareJidFromJid(_this._calleeJID), 'vcxep', 'vcxep', {
                    type: 'acceptedElsewhere',
                    callid: cInfo.callId
                  });
                  _this.requestAcknowledgementForSentStanzas(true);
                  Object.keys(_this.webRtcPeers).forEach(function (key) {
                    if (key !== from) {
                      if (_this.webRtcPeers[key]) {
                        try {
                          _this.webRtcPeers[key].dispose();
                          // eslint-disable-next-line no-empty
                        } catch (_disposeErr) {}
                        delete _this.webRtcPeers[key];
                      }
                    }
                  });
                }
                break;
              case 'speaking':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (_this.callHasBeenAcceptedOnProsDevice() && from !== _this._calleeJID) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | Ignoring the received "speaking" message as the call has been accepted on another Pro\'s device');
                    break;
                  }
                  _this.callState = CallState.ACTIVE;
                  _this.undoProAutoDecline();
                  _this.muteAudio(false);
                  _this.muteOpponentAudio(false);
                  _this.props.speaking();
                  _this.events.emit(CALL_CONNECTED_EVENT, _this.callId);

                  // Force audio stream from the device that accepted the call.
                  if (_this.webRtcPeers[from] && _this.audioInput) {
                    thePeerConnection = _this.webRtcPeers[from].peerConnection;

                    remoteStreams = thePeerConnection.getRemoteStreams();
                    audioStream = void 0;

                    for (i = 0; i < remoteStreams.length; i += 1) {
                      tracks = remoteStreams[i].getVideoTracks();
                      if (remoteStreams[i].active) {
                        if (!tracks.length) {
                          audioStream = remoteStreams[i];
                        }
                      }
                    }

                    if (audioStream) {
                      if (_this.audioInput.srcObject && _this.audioInput.srcObject === audioStream) {
                        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming audio stream has been already connected to audio playback - nothing to do');
                      } else {
                        _this.audioInput.srcObject = audioStream;
                        _this.audioInput.load();
                        _this.audioInput.play().catch(function (e) {
                          Object(media_session["d" /* safeSetMediaPlaybackState */])('none');

                          logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to play the incoming audio stream. An error occurred: ' + (e.name || 'unknown error') + ' with message \'' + e.message + '\'', lib["LogLevel"].Warning);
                        });
                        Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
                        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming audio stream already present - connecting to audio playback');
                      }
                    } else {
                      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming audio stream not yet present - waiting for an incoming audio track');
                    }
                  }
                }
                break;
              case 'avtimeEnded':
              case 'moneyEnded':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  _this.props.setAutoFinishNotif();
                  _this.setAutoFinish();
                }
                break;
              case 'preBooking':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  _this.props.setAutoFinishPreBookingNotif();
                  _this.setAutoFinish();
                }
                break;
              case 'bookingEnded':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  _this.props.setAutoFinishBookingEndedNotif();
                  _this.setAutoFinish();
                }
                break;
              case 'callDisconnected':
                currentCall = '' + _this.callId === '' + callId;

                logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | Received "callDisconnected"; call is ' + (currentCall ? '' : 'not') + ' current');

                if (_this.callId && '' + _this.callId === '' + callId) {
                  _this.undoProAutoDecline();
                  _this.stopCommunication();
                }
                break;
              case 'finished':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  _this.undoProAutoDecline();
                  _this.stopCommunication();
                }
                break;
              case 'offerRequest':
                _this.onnegotiationneeded(_this._calleeJID);
                break;
              case 'presenseConfirmationRequest':
                _this.msgGenSend(_this._curUserJID, from, 'vcxep', 'vcxep', { type: 'presenseConfirmationGranted', callid: cInfo.callId }, undefined, true);
                break;
              case 'callStatusRequest':
                statusResponseElementOptions = {
                  type: 'callStatusResponse',
                  callid: callId
                };
                statusResponseBody = void 0;

                _this.callProtocolVersion = MIN_SIGNALING_PROTOCOL_SUPPORTING_CALLSATUS_REQUEST;
                logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | Received a "callStatusRequest" message from the callee. Assuming support for signaling protocol version ' + MIN_SIGNALING_PROTOCOL_SUPPORTING_CALLSATUS_REQUEST + ' or higher');

                if (!_this.callId || _this.callId && '' + _this.callId !== '' + callId) {
                  // No active call, or another call in progress
                  statusResponseBody = 'outdated';
                } else if (_this.callId && '' + _this.callId === '' + callId) {
                  // The request is for current call - checking call status
                  if (_this.callState === CallState.CLIENT_DECLINE || _this.callState === CallState.NO_ANSWER || _this.callState === CallState.PRO_BUSY || _this.callState === CallState.PRO_DECLINE || _this.callStete === CallState.FAILED || _this.callState === CallState.DISCONNECTED || _this.callState === CallState.BREAK || _this.callState === CallState.IDLE || _this.callState === CallState.SUCCEEDED) {
                    // Current call is no longer active
                    statusResponseBody = 'outdated';
                  } else if (_this.callHasBeenAcceptedOnProsDevice()) {
                    statusResponseBody = 'answeredElsewhere';
                  } else {
                    statusResponseBody = 'active';
                  }
                } else {
                  statusResponseBody = 'outdated';
                }

                _this.msgGenSend(_this._curUserJID, from, 'vcxep', 'vcxep', statusResponseElementOptions, statusResponseBody, true);

                break;
              case 'presenseConfirmationGranted':
                if (_this.presenceConfirmationGranted) {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the received \'presenseConfirmationGranted\' message' + (' for call ID ' + callId + ' as presence has been already confirmed.') + (' current call info: cInfo.callId=' + cInfo.callId + ', this.callId=' + _this.callId));
                  return $return();
                }

                _this.presenceConfirmationGranted = true;

                _this.prepareForIncomingCall(callId, from, options, cInfo);

                break;
              case 'callStatusResponse':
                if (_this.presenceConfirmationGranted) {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the received \'callStatusResponse\' message' + (' for call ID ' + callId + ' as call status has been already confirmed.') + (' current call info: cInfo.callId=' + cInfo.callId + ', this.callId=' + _this.callId));
                  return $return();
                }

                if (_this.callState === CallState.PRO_TIMEOUT) {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the received \'callStatusResponse\' message' + (' for call ID ' + callId + ' as the call has timed out on the Pro\'s side.') + (' current call info: cInfo.callId=' + cInfo.callId + ', this.callId=' + _this.callId));
                  return $return();
                }

                if (_this.callId && '' + _this.callId === '' + callId) {
                  switch (bodyInner) {
                    case 'active':
                      _this.presenceConfirmationGranted = true;
                      _this.prepareForIncomingCall(callId, from, options, cInfo);

                      logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | allowing the incoming call to go through' + ' as the call status was reported as still active');

                      break;
                    case 'answeredElsewhere':
                    case 'outdated':
                      _this.undoProAutoDecline();
                      _this.callState = CallState.IDLE;
                      _this.stopCommunication();

                      logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | aborting the incoming call' + (' with call ID ' + callId + ' as the call status reported by the caller was "' + bodyInner + '"'));

                      break;
                    default:
                      break;
                  }
                } else {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the incoming "callStatusResponse" message' + (' for call ID ' + callId + ' as the call is not current'));
                }

                break;
              case 'candidateData':
                if (_this.callId && '' + _this.callId === '' + callId) {
                  if (_this.callHasBeenAcceptedOnProsDevice() && from !== _this._calleeJID) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the "candidateData" message from any other Pro\'s devices as the call has been already accepted on another Pro\'s device');
                    return $return();
                  }

                  if (_this.callWasRejected || _this.callFailed) {
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | candidate data received but discarded, ' + ('because the current call has ' + (_this.callFailed ? 'failed' : 'been rejected')));
                    return $return();
                  }

                  obj = JSON.parse(bodyInner);
                  // check for the Object instance
                  obj.forEach(function (c) {
                    var candidate = {
                      candidate: c.sdp,
                      sdpMid: c.sdpMid,
                      sdpMLineIndex: c.index,
                      receivedFrom: from
                    };
                    if (_this.webRtcPeers[from]) {
                      _this.addICECandidateToPeerConnection(_this.webRtcPeers[from], candidate);
                    } else {
                      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'No peer connection has been created yet, ' + 'remembering a received candidate', lib["LogLevel"].Info, candidate.candidate);
                      _this.candidates.push(candidate);
                    }
                  });
                } else {
                  logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | ignoring the received candidate data' + (' for call ID ' + callId + ' as the call is not current'));
                }
                break;
              case 'rtcConnectionLost':
                logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | "rtcConnectionLost" received for call id ' + callId + ', current call info: ' + ('cInfo.callId=' + cInfo.callId + ', this.callId=' + _this.callId));

                _this.props.undoAutoFinishNotif();
                _this.undoAutoFinish();
                if (_this.callId && '' + _this.callId === '' + callId) {
                  _this.undoProAutoDecline();
                  _this.callState = CallState.DISCONNECTED;
                  _this.stopCommunication();
                }
                break;
              default:
                break;
            }
          }

          // eslint-disable-next-line consistent-return
          return $return(true);
        }

        return $If_24.call(this);
      }

      return $If_23.call(this);
    });
  };

  this.onAcknowledgedStanza = function (id) {
    var __METHOD__ = 'Connection::onAcknowledgedStanza';

    if (Object.prototype.hasOwnProperty.call(_this.unacknowledgedStanzas, id)) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'acknowledged message ID: ' + id);

      if (_this.callId && !_this.amICallee) {
        var _isCallRequestMsg2 = Object(con_helpers["f" /* isCallRequestMsg */])(_this.unacknowledgedStanzas[id]),
            isRequestMsg = _isCallRequestMsg2[0],
            callId = _isCallRequestMsg2[1];

        if (isRequestMsg && '' + _this.callId === '' + callId) {
          _this.callRequestWasAcknowledged = true;
        }
      }

      delete _this.unacknowledgedStanzas[id];
      delete _this.unacknowledgedStanzaRetryCounts[id];
    }
  };

  this.setPeerStateControl = function (pc, remoteParty) {
    var __METHOD__ = 'Connection::setPeerStateControl';

    // eslint-disable-next-line no-param-reassign
    pc.oniceconnectionstatechange = function () {
      return _this.connsectionIceStateCallback(pc);
    };
    // eslint-disable-next-line no-param-reassign
    pc.onicecandidateerror = function (errEvent) {
      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Error ' + errEvent.errorCode + (' while reaching the STUN/TURN server at ' + errEvent.url + ': ' + errEvent.errorText), lib["LogLevel"].Warning, errEvent);
    };
    // eslint-disable-next-line no-param-reassign
    pc.onconnectionstatechange = function () {
      switch (pc.connectionState) {
        case 'connected':
          _this.props.changeReconnectionStatus(false);
          break;
        case 'disconnected':
        case 'failed':
          _this.props.changeReconnectionStatus(true);
          break;
        default:
          break;
      }
    };
    // eslint-disable-next-line no-param-reassign
    pc.onsignalingstatechange = function () {
      logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["e" /* TAG_WEBRTC */], 'Signaling state for the remote participant ' + remoteParty + ' changed to: ' + pc.signalingState, lib["LogLevel"].Debug, undefined, false);
    };
  };

  this.addICECandidateToPeerConnection = function (peerConnection, candidate) {
    var __METHOD__ = 'Connection:addICECandidateToPeerConnection';

    peerConnection.addIceCandidate(candidate, function (err) {
      if (err) {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to add an ICE candidate: ' + err.name, lib["LogLevel"].Warning, { err: err, candidate: candidate });
      } else {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Successfully added an ICE candidate: ' + candidate.candidate);
      }
    });
  };

  this.initiateICERestart = function (peerConnection) {
    var __METHOD__ = 'Connection::initiateICERestart';

    if (peerConnection.iceConnectionState === 'disconnected' || peerConnection.iceConnectionState === 'failed') {
      if (peerConnection.signalingState !== 'have-local-offer' && peerConnection.signalingState !== 'have-remote-pranswer') {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Attempting to restore the ICE connection from the caller side');
        peerConnection.createOffer({ iceRestart: true }).then(function (offer) {
          return _this.successRestart(offer);
        }).catch(function (reason) {
          return _this.failRestart(reason);
        });
      } else {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'ICE restore timer has fired, but the peer connection is' + (' already in progress of a negotiation. Current peer connection signaling state: ' + peerConnection.signalingState), lib["LogLevel"].Warning);
      }
    } else {
      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'ICE restore timer has fired, but the peer connection is' + (' not in a failed / disconnected state. Current peer connection state: ' + peerConnection.signalingState), lib["LogLevel"].Info);
    }
  };

  this.requestConnectionStats = function (peerConnection) {
    return new Promise(function ($return, $error) {
      var stats;
      return Promise.resolve(peerConnection.getStats()).then(function ($await_34) {
        try {
          stats = $await_34;
          _this.connectionQualityMonitor.processStatsReport(stats);
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  this.connsectionIceStateCallback = function (pc) {
    var __METHOD__ = 'Connection::connsectionIceStateCallback';

    if (pc) {
      if (pc.iceConnectionState === 'connected') {
        _this.connectionStatsTimer = setInterval(function () {
          return _this.requestConnectionStats(pc);
        }, 1000);

        if (_this.connectionLostTimeout) {
          logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'The ICE connection has been re-established');

          clearTimeout(_this.connectionLostTimeout);
          _this.connectionLostTimeout = null;

          if (_this.restoreIceInterval) {
            clearInterval(_this.restoreIceInterval);
            _this.restoreIceInterval = undefined;
          }

          _this.props.changeReconnectionStatus(false);
        }
      }
      if ((pc.iceConnectionState === 'disconnected' || pc.iceConnectionState === 'failed') && _this.callId) {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'the ICE connection has ' + ('' + (pc.iceConnectionState === 'failed' ? 'failed' : 'become disconnected')), lib["LogLevel"].Warning);

        _this.props.changeReconnectionStatus(true);

        // Cancel connection stats gathering
        if (_this.connectionStatsTimer) {
          clearInterval(_this.connectionStatsTimer);
          _this.connectionStatsTimer = undefined;
        }

        // Cancel (if needed) and restart the connection lost timer
        clearTimeout(_this.connectionLostTimeout);
        _this.connectionLostTimeout = null;
        _this.rtcConnectionLost();

        if (!_this.amICallee) {
          // If ICE is in the failed state, it makes sense to initiate an ICE restart immediately.
          // Otherwise, it makes sense to wait several seconds before making the first attempt,
          // as the 'disconnected' state is intermittent and could heal itself rather quickly
          // without our intervention.
          //
          // But even in the 'failed' state, we still set up the restore ICE timer so that
          // we make subsequent attempts to re-establish the ICE connection.

          if (pc.iceConnectionState === 'failed') {
            _this.initiateICERestart(pc);
          }

          clearInterval(_this.restoreIceInterval);
          _this.restoreIceInterval = setInterval(function () {
            _this.initiateICERestart(pc);
          }, WEBRTC_ICE_RESTART_DELAY_AFTER_DISCONNECTED);
        }
      }
    }
  };

  this.sendNewOfferToRestartee = function () {
    var __METHOD__ = 'Connection::sendNewOfferToRestartee';

    var cInfo = _this.props.getCInfo() || {};
    _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', { type: 'offerData', callid: cInfo.callId }, _this.webRtcPeers[_this._calleeJID].peerConnection.localDescription.sdp, true);
    logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'The new offer for the ICE restart has been sent');
  };

  this.failRestart = function (reason) {
    var __METHOD__ = 'Connection::failRestart';
    logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'ICE restart failed with reason', lib["LogLevel"].Error, reason);
  };

  this.successRestart = function (offer) {
    var __METHOD__ = 'Connection::successRestart';

    if (_this._calleeJID && _this.webRtcPeers[_this._calleeJID]) {
      _this.webRtcPeers[_this._calleeJID].peerConnection.setLocalDescription(offer).then(function () {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'The new offer for the ICE restart has been applied locally');
        _this.sendNewOfferToRestartee();
      }).catch(function (err) {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to apply the local description during an ICE restart', lib["LogLevel"].Error, err);
      });
    } else {
      logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | no callee JID set, or a peer connection does not exist for the callee ' + _this._calleeJID, lib["LogLevel"].Warning);
    }
  };

  this.setAutoReject = function () {
    var __METHOD__ = 'Connection::setAutoReject::timerCallback';
    _this.autoRejectTimeout = setTimeout(function () {
      logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | The Client\'s call auto-rejection timer has fired - rejecting the outgoing call', lib["LogLevel"].Warning);

      var cInfo = _this.props.getCInfo() || {};
      _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', { type: 'noAnswer', callid: cInfo.callId }, undefined, true);
      _this.callState = CallState.NO_ANSWER;
      _this.stopCommunication();
    }, _this.callTimeBeep);
  };

  this.undoAutoReject = function () {
    clearTimeout(_this.autoRejectTimeout);
    _this.autoRejectTimeout = null;
  };

  this.setAutoFinish = function () {
    _this.autoFinishTimeout = setTimeout(function () {
      return _this.finishCall(true);
    }, consts["I" /* timeouts */].autoFinishCallTimeout);
  };

  this.undoAutoFinish = function () {
    clearTimeout(_this.autoFinishTimeout);
    _this.autoFinishTimeout = null;
  };

  this.setProAutoDecline = function () {
    var cInf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var __METHOD__ = 'Connection::setProAutoDecline::timerCallback';
    _this.proAutoDeclineTimeout = setTimeout(function () {
      return new Promise(function ($return, $error) {
        logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | The Pro auto-decline timer has fired - rejecting the incoming call', lib["LogLevel"].Warning);

        _this.callState = CallState.PRO_TIMEOUT;
        // TODO: Ensure that the call has not been already answered

        _this.rejectCall(false, cInf);
        return $return();
      });
    }, _this.callTimeBeep);
  };

  this.undoProAutoDecline = function () {
    if (_this.proAutoDeclineTimeout) {
      clearTimeout(_this.proAutoDeclineTimeout);
    }

    _this.proAutoDeclineTimeout = undefined;
  };

  this.setFinishCallOnXMPPConnectionLost = function () {
    var __METHOD__ = 'Connection::setFinishCallOnXMPPConnectionLost';

    _this.finishCallOnXMPPConnectionLostTimeout = setTimeout(function () {
      logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Timer fired, terminating the call', lib["LogLevel"].Warning);

      if (_this.callId && _this._calleeJID) {
        // Sending rtcConnectionLost (even though this message does not accurately describe the situation) is unfortunately
        // our best bet as there's no other signaling message that would terminate the call with the DISCONECTED status.
        _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', { type: 'rtcConnectionLost', callid: _this.callId }, undefined, true);
      }

      _this.undoAutoReject();
      _this.undoAutoFinish();
      _this.undoProAutoDecline();

      _this.props.undoAutoFinishNotif();

      _this.callState = CallState.DISCONNECTED;

      _this.stopCommunication();
    }, consts["I" /* timeouts */].finishOnXMPPConnectionLostTimeout);
  };

  this.undoFinishCallOnXMPPConnectionLost = function () {
    if (_this.finishCallOnXMPPConnectionLostTimeout) {
      clearTimeout(_this.finishCallOnXMPPConnectionLostTimeout);
      _this.finishCallOnXMPPConnectionLostTimeout = undefined;
    }
  };

  this.isFinishCallOnXMPPConnectionLostTimerArmed = function () {
    return _this.finishCallOnXMPPConnectionLostTimeout !== undefined;
  };

  this.prepareForIncomingCall = function (callId, from, _rtcOptions, _cInfo) {
    return new Promise(function ($return, $error) {
      var __METHOD__, callInfo, _callInfo$consultant, consultant, _callInfo$consulted, consulted, callerId, person;

      __METHOD__ = 'Connection::prepareForIncomingCall';

      _this.presenceConfirmationGranted = true;

      return Promise.resolve(Object(pros["b" /* getCallDetails */])(callId, _this._userAuth)).then(function ($await_35) {
        try {
          callInfo = $await_35;
          if (_this.callId && '' + _this.callId === '' + callId) {
            if (callInfo.status && callInfo.status.toLowerCase() === 'active' && _this.waitData) {
              _this.props.getCallInfo(callInfo);
              _callInfo$consultant = callInfo.consultant, consultant = _callInfo$consultant === undefined ? {} : _callInfo$consultant, _callInfo$consulted = callInfo.consulted, consulted = _callInfo$consulted === undefined ? {} : _callInfo$consulted, callerId = callInfo.callerId;

              person = consultant.id === callerId ? _extends({}, consultant) : _extends({}, consulted);

              _this._calleeId = person.id;
              _this._calleeJID = from;
              // this._calleeJID = generateJID(person.id, true);

              _this.props.openComModal(consts["E" /* consts */].CALL, person, false, true);
              _this.props.changeCallRingtoneStatus();
              _this._crossTabEmitter && _this._crossTabEmitter.emit(CROSS_TAB_RINGING_EVENT, { callId: callId, currentUserJID: _this._curUserJID });
              _this.persons[from] = person.name + ' ' + person.lastName;
              if (!document.hasFocus()) {
                _this.props.createNotification('Incoming call', _this.persons[from], 40000);
              }
              (function () {
                if (!_this.grantedWasSent) {
                  _this.grantedWasSent = true;
                  _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', {
                    type: 'granted',
                    callid: callId
                  }, undefined, true);
                }
              })();

              _this.connectionQualityMonitor.resetStats();

              /*
               if (this.waitVideoElemsInterval) clearTimeout(this.waitVideoElemsInterval);
              this.waitVideoElemsInterval = setInterval(() => {
                // eslint-disable-next-line no-unused-expressions
                (this.videoInput && this.videoOutput && this.audioInput) && (
                  clearInterval(this.waitVideoElemsInterval),
                  (() => {
                    if (!this.webRtcPeers[from]) {
                      this.answering = true;
                      this.rescanMediaDevices().then(() => {
                        this.webRtcPeers[from] = createPeerConnection(this._curUserJID, from, this.msgGenSend,
                          {
                            ...rtcOptions,
                            mediaConstraints: { ...this.mediaConstraints },
                            localVideo: this.videoOutput,
                            remoteVideo: this.videoInput,
                            remoteAudio: this.audioInput,
                            onicecandidate: onIceCandidate(this._curUserJID, from, cInfo.id || callId, this.msgGenSend),
                            onnegotiationneeded: () => this.offerRequest(),
                          },
                          cInfo);
                         this.setPeerStateControl(this.webRtcPeers[from].peerConnection);
                         this.addAccumulatedRemoteCandidatesToPeerConnection(this.webRtcPeers[from], from);
                         Logger.logWebRTC(
                          __FILE__,
                          __METHOD__,
                          `Diagnostics | Local HTML elements for the audio and video streams became available. WebRTC peer connection to ${from} created.`,
                        );
                      }).catch((err) => this.failCall(err));
                    }
                  })(),
                  this.waitVideoElemsInterval = null
                );
              }, 100);
              */
            }
          }
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  this.rescanMediaDevices = function () {
    var $args = arguments;return new Promise(function ($return, $error) {
      var forcePermissions, mediaStream;
      forcePermissions = $args.length > 0 && $args[0] !== undefined ? $args[0] : false;

      if (forcePermissions) {
        return Promise.resolve(navigator.mediaDevices.getUserMedia({ audio: true })).then(function ($await_36) {
          try {
            mediaStream = $await_36;
            mediaStream.getTracks().forEach(function (track) {
              track.stop();
              mediaStream.removeTrack(track);
            });
            return $If_25.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }

      function $If_25() {
        return Promise.resolve(Object(con_helpers["e" /* getMediaConstraints */])()).then(function ($await_37) {
          try {
            _this.mediaConstraints = $await_37;
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      }

      return $If_25.call(this);
    });
  };

  this.msgGenSend = function (from, to, type, elemType) {
    var elemOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var body = arguments[5];
    var forceAcknowledgement = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var useStanzaId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

    var __METHOD__ = 'Connection::msgGenSend';

    var id = useStanzaId || _this.connection.getUniqueId(_this.props.uuid.toUpperCase());
    var m = body ? Object(strophe_umd["$msg"])({
      from: from, to: to, type: type, id: id
    }).c(elemType, elemOptions).t(body) : Object(strophe_umd["$msg"])({
      from: from, to: to, type: type, id: id
    }).c(elemType, elemOptions);

    _this.unacknowledgedStanzas[id] = m;
    _this.unacknowledgedStanzaRetryCounts[id] = 0;

    if (type === 'vcxep' || elemType === 'vcxep') {
      logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Outgoing | ' + elemOptions.type, lib["LogLevel"].Info, elemOptions);
    }

    try {
      if (_this.connection.connected) {
        _this.connection.send(m);
      } else {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to send the generic XMPP message', lib["LogLevel"].Warning);
      }
    } catch (err) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to send the generic XMPP message', lib["LogLevel"].Error, err);
    }

    _this.requestAcknowledgementForSentStanzas(forceAcknowledgement);
  };

  this.sendMessage = function (message, userID, isPro, senderName, thread) {
    var __METHOD__ = 'Connection::sendMessage';

    logger["g" /* logChat */](__FILE__, __METHOD__, 'Sending a chat message');

    var id = v4_default()();
    var timestamp = (Object(getTime["a" /* default */])(new Date()) + _this.offset) / 1000;
    var typeFile = '';
    var msg = null;
    if (message.attachment) {
      if (message.attachment.type === 'video/mp4') {
        typeFile = 'video';
      } else if (message.attachment.type === 'application/pdf') {
        typeFile = 'document';
      } else if (message.attachment.type === 'image/jpeg' || message.attachment.type === 'image/png' || message.attachment.type === 'image/jpg') {
        typeFile = 'image';
      } else if (message.attachment.type === 'contact') {
        typeFile = 'contact';
      }
      if (typeFile === 'contact') {
        msg = {
          text: message.text,
          senderName: senderName,
          attachment: message.attachment
        };
      } else {
        var documentType = message.attachment.type.split('/')[1];
        msg = {
          text: message.text,
          senderName: senderName,
          attachment: {
            id: message.attachment.id,
            previewId: message.attachment.id,
            type: typeFile,
            name: message.attachment.name,
            documentType: documentType
          }
        };
      }
    } else {
      msg = {
        text: message.text,
        senderName: senderName
      };
    }

    var to = Object(utils["d" /* generateJID */])(userID, true);
    _this.props.setMsg(userID, isPro, to, _extends({}, msg, {
      id: id,
      timestamp: +timestamp.toFixed(0),
      status: consts["H" /* statuses */].SENT
    }), true);
    var m = Object(strophe_umd["$msg"])({ to: to, type: 'chat', id: id }).c('body').t(JSON.stringify(msg));
    m.up().c('thread').t(thread);
    m.up().c('markable', { xmlns: 'urn:xmpp:chat-markers:0' });
    // this.connection.send(m);
    _this.unacknowledgedStanzas[id] = m;
    _this.unacknowledgedStanzaRetryCounts[id] = 0;
    try {
      if (_this.connection.connected) {
        _this.connection.send(m);
      } else {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to send the chat message', lib["LogLevel"].Warning);
      }
    } catch (err) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to send the chat message', lib["LogLevel"].Error, err);
    }
    _this['failed-' + id + '-timeout'] = setTimeout(function () {
      _this.props.updateMsgStatus(to, id, consts["H" /* statuses */].FAILED);
    }, 10000);

    _this.requestAcknowledgementForSentStanzas();
  };

  this.sentSuccessfully = function (msg) {
    var __METHOD__ = 'Connection::sentSuccessfully';
    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Successfully sent a message', lib["LogLevel"].Info, msg);
  };

  this.sentError = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var __METHOD__ = 'Connection::sentError';
    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Failed to send a message', lib["LogLevel"].Error, _extends({}, args));
  };

  this.getServerTime = function () {
    var __METHOD__ = 'Connection::getServerTime';

    var id = _this.connection.getUniqueId('time_1');

    var m = Object(strophe_umd["$iq"])({
      id: id, to: XMPP_DOMAIN, type: 'get', from: _this._curUserJID
    }).c('time', { xmlns: 'urn:xmpp:time' });

    try {
      if (_this.connection.connected) {
        _this.connection.send(m);
      } else {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to request time from the server', lib["LogLevel"].Warning);
      }
    } catch (err) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to request the time from server', lib["LogLevel"].Error, err);
    }
  };

  this.synchronize = function () {
    var __METHOD__ = 'Connection::synchronize';

    var id = _this.connection.getUniqueId('enable1');

    var m = Object(strophe_umd["$iq"])({ id: id, type: 'set', from: _this._curUserJID }).c('enable', { xmlns: 'urn:xmpp:carbons:2' });
    try {
      if (_this.connection.connected) {
        _this.connection.send(m);
      } else {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to enable message carbons', lib["LogLevel"].Warning);
      }
    } catch (err) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to enable message carbons', lib["LogLevel"].Error, err);
    }
    // this.connection.send(m1);
  };

  this.getChatMessages = function (clientId, proId) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DESC';

    var __METHOD__ = 'Connection::getChatMessages';

    var id = _this.connection.getUniqueId('history:' + clientId);
    var historyRequestKey = clientId + '-' + offset + '-' + order;

    if (historyRequestKey in _this.messageHistoryIQIds) {
      // We have a potentially unsent chat history request for the same opponent
      // with the same parameters. We discard the old request since
      // there's no point in re-sending several identical chat history
      // request.
      var prevIQStanzaId = _this.messageHistoryIQIds[historyRequestKey];
      delete _this.unacknowledgedStanzas[prevIQStanzaId];
      delete _this.unacknowledgedStanzaRetryCounts[prevIQStanzaId];
    }

    var m = Object(strophe_umd["$iq"])({ id: id, to: XMPP_DOMAIN, type: 'get' }).c('history', {
      count: consts["E" /* consts */].MES_HISTORY_SIZE, offset: offset, order: order, to: clientId
    });
    // .t(`${clientId}-${proId}`);

    _this.unacknowledgedStanzas[id] = m;
    _this.unacknowledgedStanzaRetryCounts[id] = 0;
    _this.messageHistoryIQIds[historyRequestKey] = id;

    try {
      if (_this.connection.connected) {
        _this.connection.send(m);
      } else {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to request message history', lib["LogLevel"].Warning);
      }
    } catch (err) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to request message history', lib["LogLevel"].Error, err);
    }
  };

  this.markChatMessage = function (from, to, id, thread, markType) {
    var __METHOD__ = 'Connection::markChatMessage';

    var envelopeMessageId = _this.connection.getUniqueId('chat-marker');
    var m = Object(strophe_umd["$msg"])({
      from: from, to: to, type: 'chat_status', id: envelopeMessageId
    }).c('thread').t(thread);
    m.up().c(markType, { xmlns: 'urn:xmpp:chat-markers:0', id: id });

    _this.unacknowledgedStanzas[envelopeMessageId] = m;
    _this.unacknowledgedStanzaRetryCounts[envelopeMessageId] = 0;
    try {
      if (_this.connection.connected) {
        _this.connection.send(m);
      } else {
        logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'No connection available to mark chat messages', lib["LogLevel"].Warning);
      }
    } catch (err) {
      logger["k" /* logXMPPClient */](__FILE__, __METHOD__, 'Failed to set a chat message status', lib["LogLevel"].Error, err);
    }

    _this.requestAcknowledgementForSentStanzas();
  };

  this.setVideoElements = function (videoOutput, videoInput, _audioInput, _localStream) {
    var __METHOD__ = 'Connection::setVideoElements';

    logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["e" /* TAG_WEBRTC */], 'Video elements set', lib["LogLevel"].Info, { videoOutput: videoOutput, videoInput: videoInput }, true);

    _this.videoOutput = videoOutput;
    _this.videoInput = videoInput;
    _this.audioInput = _this.props.audioInput;

    // if (localStream) this.localStream = localStream;

    if (_this.callId && _this.canPlayIncomingVideo()) {
      _this.playIncomingVideoStream(_this._calleeJID);
    }

    if (_this.callId && _this.callState === CallState.ACTIVE && _this.localStream && _this.localStream.getVideoTracks().length > 0) {
      _this.playOutgoingVideoStream();
    }
  };

  this.callRequest = function (userID, callInfo) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var __METHOD__ = 'Connection::callRequest';

    _this.callWasRejected = false;
    _this.callFailed = false;
    _this.amICallee = false;
    _this._calleeId = userID;
    _this._calleeJID = Object(utils["d" /* generateJID */])(userID, true);
    _this.callInitiatorJID = null;
    _this.setAutoReject(userID);
    callback(_this.callTimeBeep);
    _this.callId = callInfo.callId;
    _this.incomingVideoEnabled = false;
    _this.isOutgoingScreenSharingMuted = true;
    _this.isOutgoingVideoMuted = true;
    _this.isOutgoingAudioMuted = true;
    _this.callRequestWasAcknowledged = false;
    _this.webRtcPeers = {};
    _this.candidates = [];

    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | Placing a call', lib["LogLevel"].Info, JSON.stringify(callInfo));

    _this.callState = CallState.INVITED;

    _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', {
      type: 'request',
      callid: callInfo.callId,
      avtime: callInfo.avTime,
      signalingProtocol: MAX_SUPPORTED_SIGNALING_PROTOCOL
    }, undefined, true);

    _this.events.emit(OUTGOING_CALL_STARTED_EVENT, callInfo.callId);
  };

  this.rejectCall = function () {
    var isBusy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cInf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var __METHOD__ = 'Connection::rejectCall';

    _this.stopWaitingVideoElements();
    _this.callWasRejected = true;
    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | Rejecting the call; isBusy: ' + isBusy);
    _this.undoAutoReject();
    _this.undoProAutoDecline();
    var cInfo = _this.props.getCInfo() || {};
    cInfo = cInfo.callerId ? cInfo : cInf;
    var type = !cInfo.callerId || cInfo.callerId === _this._curUserId ? 'callerDeclined' : 'receiverDeclined';
    var rejectionMessageRecipientJID = _this._calleeJID || Object(utils["d" /* generateJID */])(cInfo.person, true);
    var rejectionMessageSenderJID = _this._curUserJID;
    var rejectedCallId = cInfo.callId;

    _this.callState = type === 'callerDeclined' ? CallState.CLIENT_DECLINE : CallState.PRO_DECLINE;

    _this._calleeId = '';
    _this._calleeJID = '';
    _this.callInitiatorJID = null;
    if (isBusy === true) {
      _this.props.caleeIsBusy();
    } else {
      _this.props.closeComModal();
    }
    _this.callId = undefined;
    _this.callRequestWasAcknowledged = undefined;
    _this.stopCommunication();

    var sendRejectionMessage = function sendRejectionMessage() {
      return _this.msgGenSend(rejectionMessageSenderJID, rejectionMessageRecipientJID, 'vcxep', 'vcxep', { type: type, callid: rejectedCallId }, undefined, true);
    };

    if (_this.callState === CallState.CLIENT_DECLINE) {
      sendRejectionMessage();
    } else {
      _this.checkIfCallAnsweredOnAnotherDevice(rejectionMessageRecipientJID, _this._curUserJID, cInfo.callId, _this._userAuth).then(function (isAnswered) {
        if (!isAnswered) {
          sendRejectionMessage();
        } else {
          logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | NOT sending "receiverDeclined" as the call is reported either as an active one, or has already finished', lib["LogLevel"].Info);
        }
      }).catch(function (err) {
        logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | Failed to check if the call with callId=' + rejectedCallId + ' was answered on another Pro\'s device', lib["LogLevel"].Warning, err);
      });
    }
  };

  this.failCall = function (reason, amICalleeOverride) {
    var __METHOD__ = 'Connection::failCall';

    if (_this.callState === CallState.FAILED) {
      return;
    }

    _this.stopWaitingVideoElements();
    _this.callFailed = true;

    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | Aborting the call as failed with reason: ' + reason);

    _this.undoAutoReject();
    _this.undoProAutoDecline();

    var cInfo = _this.props.getCInfo() || { callId: _this.callId };
    var amICallee = amICalleeOverride || _this.amICallee;

    _this.callState = CallState.FAILED;

    var thisParty = _this._curUserJID;
    var otherParty = _this._calleeJID;
    var failedCallId = cInfo.callId;

    var notifyTheOtherPartyOfFailedCall = function notifyTheOtherPartyOfFailedCall() {
      logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | Notifying that the call has failed with reason: ' + reason);

      _this.msgGenSend(thisParty, otherParty, 'vcxep', 'vcxep', { type: 'failed', callid: failedCallId }, reason);

      // We need to follow up the "failed" message by sending "callerDeclined"
      // in the Client (caller) role because otherwise ejabberd will keep the call
      // as an active one.
      if (!amICallee) {
        _this.msgGenSend(thisParty, Object(utils["d" /* generateJID */])(otherParty, true), 'vcxep', 'vcxep', { type: 'callerDeclined', callid: failedCallId }, undefined, true);
      }
    };

    if (cInfo.callId) {
      notifyTheOtherPartyOfFailedCall();
    }

    _this.callId = undefined;
    _this.callRequestWasAcknowledged = undefined;
    _this._calleeId = '';
    _this._calleeJID = '';
    _this.callInitiatorJID = null;

    _this.stopCommunication();
    _this.events.emit(CALL_FAILED_EVENT, amICallee, reason);
  };

  this.callHasBeenAcceptedOnProsDevice = function () {
    return !_this.amICallee && (_this.callState === CallState.ACCEPTED || _this.callState === CallState.ACTIVE);
  };

  this.reqGranted = function () {
    var __METHOD__ = 'Connection::reqGranted';

    _this.props.changeCallRingtoneStatus(false);

    // We need a rescan because the user could have plugged in an audio device
    // after the initial scan.
    _this.rescanMediaDevices(true).then(function () {
      if (!_this.wasAccepted) {
        _this.wasAccepted = true;
        var cInfo = _this.props.getCInfo() || {};

        _this.callState = CallState.ACCEPTED;
        _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', { type: 'accept', callid: cInfo.callId });

        _this.callState = CallState.ACTIVE;
        _this.muteAudio(false);
        _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', { type: 'speaking', callid: cInfo.callId });

        _this.requestAcknowledgementForSentStanzas(true);

        _this.events.emit(INCOMING_CALL_STARTED_EVENT, cInfo.callId);
      }
    }).catch(function (err) {
      _this.failCall(_this.tryGetMediaCaptureErrorReason(err), true);

      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Unable to rescan the media devices. The exact error is ' + err.name + ': ' + err.message);
    });
  };

  this.stopCommunication = function () {
    var closeModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var callId = _this.callId;


    try {
      _this.presenceConfirmationGranted = false;

      _this.props.changeReconnectionStatus(false);
      _this.waitData = false;
      clearInterval(_this.restoreIceInterval);
      clearTimeout(_this.connectionLostTimeout);
      if (_this.connectionStatsTimer) {
        clearInterval(_this.connectionStatsTimer);
        _this.connectionStatsTimer = undefined;
      }

      _this.connectionLostTimeout = null;

      if (closeModal) {
        _this.props.closeComModal();
      }
      if (_this.waitVideoElemsInterval) clearTimeout(_this.waitVideoElemsInterval);
      _this.props.changeCallRingtoneStatus(false);
      _this.amICallee = false;
      _this.disableVideo();
      _this.stopLocalStream();
      _this.candidates = [];
      _this.grantedWasSent = undefined;
      _this.wasAccepted = undefined;
      _this.videoOutput = undefined;
      _this.videoInput = undefined;
      _this.audioInput = undefined;
      _this.callId = undefined;
      _this.callInitiatorJID = null;
      _this.callRequestWasAcknowledged = undefined;
      _this.callProtocolVersion = undefined;
      _this.persons = {};

      _this.videoSender = null;
      _this.answering = false;
      _this.incomingVideoEnabled = false;
      _this.isOutgoingScreenSharingMuted = true;
      _this.isOutgoingVideoMuted = true;
      _this.isOutgoingAudioMuted = true;

      Object.keys(_this.webRtcPeers).forEach(function (key) {
        if (_this.webRtcPeers[key]) {
          try {
            _this.webRtcPeers[key].dispose();
            // eslint-disable-next-line no-empty
          } catch (_disposeErr) {}
        }
      });

      _this.webRtcPeers = {};
    } finally {
      _this.events.emit(CALL_FINISHED_EVENT, callId);
    }
  };

  this.stopLocalStream = function () {
    var __METHOD__ = 'Connection::stopLocalStream';

    logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Stop local stream');

    if (_this.audioInput && _this.audioInput.srcObject) {
      _this.audioInput.srcObject.getTracks().forEach(con_helpers["r" /* trackStop */]);
      _this.audioInput.srcObject = null;
    }

    if (_this.localStream) {
      _this.localStream.getTracks().forEach(con_helpers["r" /* trackStop */]);
      _this.localStream = null;
    }

    if (_this.webRtcPeers[_this._calleeJID]) {
      _this.webRtcPeers[_this._calleeJID].peerConnection.getLocalStreams().forEach(function (stream) {
        stream.getTracks().forEach(con_helpers["r" /* trackStop */]);
      });
    }

    if (_this.webRtcPeers[_this._calleeJID]) {
      _this.webRtcPeers[_this._calleeJID].peerConnection.getSenders().forEach(function (sender) {
        if (sender.track) {
          // eslint-disable-next-line no-param-reassign
          sender.track.enabled = false;
          sender.track.stop();
        }
      });
    }
    if (_this.webRtcPeers[_this._calleeJID]) _this.webRtcPeers[_this._calleeJID].peerConnection.close();
  };

  this.rtcConnectionLost = function () {
    var __METHOD__ = 'Connection::rtcConnectionLost';

    if (_this.connectionLostTimeout) {
      return;
    }

    _this.connectionLostTimeout = setTimeout(function () {
      _this.props.undoAutoFinishNotif();

      clearInterval(_this.restoreIceInterval);

      _this.undoAutoFinish();

      var cInfo = _this.props.getCInfo() || {};

      _this.callState = CallState.DISCONNECTED;

      try {
        _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', { type: 'rtcConnectionLost', callid: cInfo.callId }, undefined, true);
      } catch (error) {
        logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Cannot notify eJabberd about WebRTC disconnection!', lib["LogLevel"].Error, error);
      }

      _this.stopCommunication();
    }, consts["f" /* DISCONNECT_TIMEOUT_MS */]);
  };

  this.finishCall = function () {
    var forciblyFinished = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this.stopCommunication();
    _this.props.undoAutoFinishNotif();
    _this.undoAutoFinish();

    var cInfo = _this.props.getCInfo() || {};

    _this.callState = forciblyFinished ? CallState.BREAK : CallState.SUCCEEDED;

    _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', { type: 'finished', callid: cInfo.callId }, undefined, true);
  };

  this.gracefullyCloseCallOnLogout = function () {
    var __METHOD__ = 'Connection::gracefullyCloseCallOnLogout';

    if (_this.callId) {
      if (_this.callState === CallState.ACTIVE) {
        logger["h" /* logSignaling */](__FILE__, __METHOD__, 'The user has logged out while a call is in progress - finishing the call');
        _this.finishCall();
      } else if (_this.callState === CallState.INVITED || _this.callState === CallState.ACCEPTED || _this.callState === CallState.PRO_TIMEOUT) {
        var callerJID = _this.amICallee ? _this._calleeJID || _this.callInitiatorJID : _this._calleeJID;
        if (!callerJID) {
          return;
        }

        logger["h" /* logSignaling */](__FILE__, __METHOD__, 'The user has logged out while a call is being connected - rejecting the call');
        _this.rejectCall(false, { callerId: strophe_umd["Strophe"].getNodeFromJid(callerJID), person: callerJID });
      }
    }
  };

  this.muteAudio = function (isMuted) {
    var __METHOD__ = 'Connection::muteAudio';

    _this.isOutgoingAudioMuted = isMuted;

    if (_this.webRtcPeers[_this._calleeJID]) {
      var senders = _this.webRtcPeers[_this._calleeJID].peerConnection.getSenders();
      if (!senders.length) {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'A WebRTC peer connection for the remote party with JID ' + _this._calleeJID + ' does not have any senders', lib["LogLevel"].Warning);
      }

      var atLeastOneAudioTrackSenderFound = false;
      senders.forEach(function (element) {
        if (element.track && element.track.kind === 'audio') {
          // eslint-disable-next-line no-param-reassign
          element.track.enabled = !isMuted;
          atLeastOneAudioTrackSenderFound = true;
        }
      });
      if (!atLeastOneAudioTrackSenderFound) {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'A WebRTC peer connection for the remote party with JID ' + _this._calleeJID + ' does not have any senders with an audio track', lib["LogLevel"].Warning);
      }

      if (_this.localStream) {
        var atLeastOneLocalAudioTrackFound = false;

        _this.localStream.getAudioTracks().forEach(function (track) {
          // eslint-disable-next-line no-param-reassign
          track.enabled = !isMuted;
          atLeastOneLocalAudioTrackFound = true;
        });

        if (!atLeastOneLocalAudioTrackFound) {
          logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'The local stream does not contain any audio tracks', lib["LogLevel"].Warning);
        }
      } else {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'There is no local stream available', lib["LogLevel"].Warning);
      }
    } else {
      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'A WebRTC peer connection for the remote party with JID ' + _this._calleeJID + ' does not exist', lib["LogLevel"].Error);
    }
  };

  this.muteVideo = function (isMuted, screenSharingMuted, callback) {
    if (!isMuted && !screenSharingMuted) {
      _this.isScreenSharingListener = false;
      _this.disableScreenSharing(callback, false);
    }
    var cInfo = _this.props.getCInfo() || {};
    var type = isMuted ? 'dis_video' : 'en_video';
    var options = { type: type, callid: cInfo.callId };
    _this.updateVideoStatus(isMuted);

    if (JSON.stringify(_this.videoCallOptions) !== JSON.stringify(options)) {
      _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', options, undefined, true);
      _this.videoCallOptions = options;
    }
  };

  this.muteOpponentAudio = function (isMuted) {
    _this.props.audioInput.muted = isMuted;
  };

  this.isOpponentAudioMuted = function () {
    return _this.props.audioInput.muted;
  };

  this.playIncomingVideoStream = function (opponentJID) {
    var __METHOD__ = 'Connection::playIncomingVideoStream';

    if (_this.webRtcPeers[opponentJID] && _this.videoInput) {
      var remoteStreams = _this.webRtcPeers[opponentJID].peerConnection.getRemoteStreams();
      var playableVideoStream = remoteStreams.find(function (stream) {
        return stream.getVideoTracks().length && stream.active;
      });

      if (playableVideoStream) {
        _this.videoInput.srcObject = playableVideoStream;
        _this.videoInput.muted = true;
        _this.videoInput.volume = 0;
        _this.videoInput.load();
        _this.videoInput.play().catch(function (e) {
          if (e instanceof DOMException && e.name === 'AbortError') {
            logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'A new incoming video stream replaced an existing video stream', lib["LogLevel"].Warning);
          } else {
            logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Failed to play the incoming video stream. An error occurred: ' + (e.name || 'unknown error') + ' with message \'' + e.message + '\'', lib["LogLevel"].Warning);
          }
        });
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming video stream already present - connecting to video playback');
      } else {
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Incoming video stream not yet present - waiting for an incoming video track');
      }
    }
  };

  this.playOutgoingVideoStream = function () {
    if (!_this.videoOutput || !_this.localStream) {
      return;
    }

    _this.videoOutput.srcObject = null;
    _this.videoOutput.srcObject = _this.localStream;

    setTimeout(function () {
      if (_this.videoOutput.paused) {
        _this.videoOutput.play().catch(function (_err) {});
      }
    }, consts["A" /* VIDEO_PLAYING_TIMEOUT_MS */]);
  };

  this.updateVideoStatus = function (muted) {
    if (!muted) {
      _this.enableVideo();
    } else {
      _this.disableVideo();
    }
  };

  this.enableVideo = function () {
    var __METHOD__ = 'Connection::enableVideo';
    var __CALLBACK_METHOD_GET_TRACKS__ = 'Connection::enableVideo::getVideoTracksCallback';
    var __CALLBACK_METHOD_REPLACE_TRACK__ = 'Connection::enableVideo::replaceTrackCallback';
    var __CALLBACK_METHOD_GET_USER_MEDIA__ = 'Connection::enableVideo::getUserMediaCallback';

    _this.isOutgoingVideoMuted = false;

    logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Start video');
    navigator.mediaDevices.getUserMedia({ video: true }).then(function (videoStream) {
      var videoTracks = videoStream.getVideoTracks();
      if (videoTracks.length > 0) {
        logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_GET_TRACKS__, 'Using video device: ' + videoTracks[0].label);
      } else {
        logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_GET_TRACKS__, 'The captured stream does not contain any video tracks', lib["LogLevel"].Error);

        return;
      }

      _this.localStream.addTrack(videoTracks[0]);

      var remotePeer = _this.webRtcPeers[_this._calleeJID];

      if (!_this.videoSender) {
        var localStream = remotePeer.getLocalStream();
        _this.videoSender = remotePeer.peerConnection.addTrack(videoTracks[0], localStream);
        _this.videoSender.track.enabled = true;
      } else {
        _this.videoSender.replaceTrack(videoTracks[0]).catch(function (error) {
          logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_REPLACE_TRACK__, 'Failed to replace a video track', lib["LogLevel"].Error, error);
        }).then(function () {
          _this.videoSender.track.enabled = true;
        });
      }

      _this.playOutgoingVideoStream();
    }).catch(function (e) {
      logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_GET_USER_MEDIA__, 'Failed to acquire user media', lib["LogLevel"].Error, e);
    });
  };

  this.disableVideo = function () {
    var __METHOD__ = 'Connection::disableVideo';

    logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'End Video/Screen Sharing Stream');
    _this.isOutgoingVideoMuted = true;

    if (_this.videoSender && _this.videoSender.track) {
      _this.videoSender.track.enabled = false;
      _this.videoSender.track.stop();
    }
    if (_this.localStream) {
      _this.localStream.getVideoTracks().forEach(function (track) {
        Object(con_helpers["r" /* trackStop */])(track);
        _this.localStream.removeTrack(track);
        logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Stopped and removed the video track', lib["LogLevel"].Info, track);
      });
    }
  };

  this.updateScreenSharingMsg = function (isSharing) {
    var cInfo = _this.props.getCInfo() || {};
    var type = isSharing ? 'dis_video' : 'en_video';
    var options = { type: type, callid: cInfo.callId };

    if (JSON.stringify(_this.videoCallOptions) !== JSON.stringify(options)) {
      _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', options, undefined, true);
      _this.videoCallOptions = options;
    }
  };

  this.updateScreenSharingStatus = function (isSharingMuted, isVideoMuted, callback) {
    if (isSharingMuted) {
      _this.enableScreenSharing(isVideoMuted, callback);
    } else {
      _this.isScreenSharingListener = false;
      _this.disableScreenSharing(callback);
    }
  };

  this.addStreamStopListener = function (stream, callback) {
    var emptyFn = function emptyFn() {};
    var callbackFn = typeof callback === 'function' ? callback : emptyFn;
    stream.addEventListener('ended', function () {
      callbackFn();
      callbackFn = emptyFn;
    }, false);
    stream.addEventListener('inactive', function () {
      callbackFn();
      callbackFn = emptyFn;
    }, false);
    stream.getTracks().forEach(function (track) {
      track.addEventListener('ended', function () {
        callbackFn();
        callbackFn = emptyFn;
      }, false);
      track.addEventListener('inactive', function () {
        callbackFn();
        callbackFn = emptyFn;
      }, false);
    });
  };

  this.enableScreenSharing = function (isVideoMuted, callback) {
    var __METHOD__ = 'Connection::enableScreenSharing';
    var __CALLBACK_METHOD_ON_GETTING_STREAM__ = 'Connection::enableScreenSharing::onGettingStreamCallback';
    var __CALLBACK_METHOD_GET_DISPLAY_MEDIA__ = 'Connection::enableScreenSharing::onGetDisplayMediaCallback';
    var __CALLBACK_METHOD_REPLACE_TRACK__ = 'Connection::enableScreenSharing::replaceTrackCallback';

    _this.isOutgoingScreenSharingMuted = false;

    var isScreenSharingMuted = true;
    if (navigator.getDisplayMedia || navigator.mediaDevices.getDisplayMedia) {
      var onGettingSteam = function onGettingSteam(videoStream) {
        var videoTracks = videoStream.getVideoTracks();

        _this.addStreamStopListener(videoStream, function () {
          _this.isScreenSharingListener && _this.disableScreenSharing(callback);
          _this.isScreenSharingListener = true;
        });
        if (videoTracks.length > 0) {
          logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_ON_GETTING_STREAM__, 'Using Screen Sharing device: ' + videoTracks[0].label);
        }
        var localStream = _this.webRtcPeers[_this._calleeJID].getLocalStream();
        _this.localStream.addTrack(videoTracks[0]);
        if (!_this.videoSender) {
          _this.videoSender = _this.webRtcPeers[_this._calleeJID].peerConnection.addTrack(videoTracks[0], localStream);
          _this.videoSender.track.enabled = true;
        } else {
          _this.videoSender.replaceTrack(videoTracks[0]).catch(function (error) {
            logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_REPLACE_TRACK__, 'Failed to replace a screen sharing track', lib["LogLevel"].Error, error);
          }).then(function () {
            _this.videoSender.track.enabled = true;
          });
        }

        _this.playOutgoingVideoStream();
      };

      if (navigator.mediaDevices.getDisplayMedia) {
        navigator.mediaDevices.getDisplayMedia({ video: true }).then(function (stream) {
          !isVideoMuted && _this.disableVideo();
          logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_GET_DISPLAY_MEDIA__, 'Start Screen Sharing with mediaDevices.getDisplayMedia');
          isScreenSharingMuted = false;
          _this.updateScreenSharingMsg(isScreenSharingMuted);
          onGettingSteam(stream);
          if (typeof callback === 'function') {
            callback(isScreenSharingMuted);
          }
        }).catch(function (e) {
          logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_GET_DISPLAY_MEDIA__, 'Failed to acquire the display media for screen sharing with mediaDevices.getDisplayMedia', lib["LogLevel"].Error, e);

          if (e instanceof DOMException && e.name === 'NotAllowedError') {
            _this.events.emit(SCREEN_SHARING_PERMISSION_DENIED_EVENT, e.message);
          }
        });
      } else if (navigator.getDisplayMedia) {
        navigator.getDisplayMedia({ video: true }).then(function (stream) {
          !isVideoMuted && _this.disableVideo();
          logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_GET_DISPLAY_MEDIA__, 'Start Screen Sharing with getDisplayMedia');
          isScreenSharingMuted = false;
          _this.updateScreenSharingMsg(isScreenSharingMuted);
          onGettingSteam(stream);
          if (typeof callback === 'function') {
            callback(isScreenSharingMuted);
          }
        }).catch(function (e) {
          logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_GET_DISPLAY_MEDIA__, 'Failed to acquire the display media for screen sharing with getDisplayMedia', lib["LogLevel"].Error, e);

          if (e instanceof DOMException && e.name === 'NotAllowedError') {
            _this.events.emit(SCREEN_SHARING_PERMISSION_DENIED_EVENT, e.message);
          }
        });
      }
    } else if (typeof callback === 'function') {
      logger["i" /* logWebRTC */](__FILE__, __METHOD__, 'Neither navigator.getDisplayMedia nor navigator.mediaDevices.getDisplayMedia API available', lib["LogLevel"].Error);
    }
  };

  this.disableScreenSharing = function (callback) {
    var updateSteamMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _this.isOutgoingScreenSharingMuted = true;
    updateSteamMsg && _this.updateScreenSharingMsg(true);
    _this.disableVideo();
    if (typeof callback === 'function') {
      callback(true);
    }
  };

  this.replaceAudioTrack = function (audioStream, peerConnection) {
    var __CALLBACK_METHOD_REPLACE_TRACK__ = 'Connection::replaceAudioTrack::replaceTrack';

    var audioTracks = audioStream.getAudioTracks();
    var stream = peerConnection.getLocalStreams()[0];
    peerConnection.getSenders().forEach(function (sender) {
      if (sender.track && sender.track.kind === 'audio') {
        sender.track.stop();
        sender.replaceTrack(audioTracks[0], stream).then(function (a) {
          return logger["i" /* logWebRTC */](__FILE__, __CALLBACK_METHOD_REPLACE_TRACK__, 'audio replaced', lib["LogLevel"].Info, a);
        });
      }
    });
  };

  this.offerRequest = function () {
    var __METHOD__ = 'Connection::offerRequest';

    var cInfo = _this.props.getCInfo() || {};
    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | Negotiation in progress');

    if (!_this.answering) {
      logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Decision | Requesting an offer SDP from the caller');
      _this.msgGenSend(_this._curUserJID, _this._calleeJID, 'vcxep', 'vcxep', { type: 'offerRequest', callid: cInfo.callId }, undefined, true);
    } else {
      logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Diagnostics | Already have an SDP offer, no need to request a new one');
    }
  };

  this.stopWaitingVideoElements = function () {
    if (_this.waitVideoElemsInterval) {
      clearTimeout(_this.waitVideoElemsInterval);
      _this.waitVideoElemsInterval = 0;
    }
  };

  this.addAccumulatedRemoteCandidatesToPeerConnection = function (peerConnection, remotePartyJID) {
    if (_this.candidates.length > 0) {
      _this.candidates.filter(function (c) {
        return c.receivedFrom === remotePartyJID;
      }).forEach(function (candidate) {
        _this.addICECandidateToPeerConnection(peerConnection, candidate);
      });
      _this.candidates = [];
    }
  };

  this.isMediaCapturePermissionError = function (err) {
    return err instanceof DOMException && err.name === 'NotAllowedError';
  };

  this.isNoSuitableMediaDeviceFoundError = function (err) {
    return err instanceof DOMException && err.name === 'NotFoundError';
  };

  this.tryGetMediaCaptureErrorReason = function (err) {
    if (_this.isMediaCapturePermissionError(err)) {
      return ERR_ACCESS_TO_MEDIA_DEVICE_DENIED;
    }

    if (_this.isNoSuitableMediaDeviceFoundError(err)) {
      return ERR_NO_AUDIO_DEVICE;
    }

    if (err instanceof DOMException) {
      return err.name + ': ' + err.description;
    }

    return '' + err;
  };

  this.isCallStatusRequestSupported = function (callProtocolVersion) {
    return semver_compare_default()(callProtocolVersion, MIN_SIGNALING_PROTOCOL_SUPPORTING_CALLSATUS_REQUEST) >= 0;
  };

  this.getCallProtocolVersionFromCallRequest = function (callRequestBody) {
    return (callRequestBody.hasAttribute('signalingProtocol') ? callRequestBody.getAttribute('signalingProtocol') : MIN_SUPPORTED_SIGNALING_PROTOCOL) || MIN_SUPPORTED_SIGNALING_PROTOCOL;
  };

  this.getCurrentUserJID = function () {
    return _this._curUserJID;
  };

  this.getMaxSupportedSignalingProtocolVersion = function () {
    return MAX_SUPPORTED_SIGNALING_PROTOCOL;
  };

  this.shouldForceAudioPermissionCheck = function () {
    return typeof _this.mediaConstraints.audio === 'undefined' || typeof _this.mediaConstraints.audio === 'boolean' || typeof _this.mediaConstraints.audio === 'object' && !_this.mediaConstraints.audio.deviceId;
  };

  this.canPlayCalleesAudioTrack = function (from) {
    return _this.callState === CallState.ACTIVE && from === _this._calleeJID;
  };

  this.canPlayCallerAudioTrack = function () {
    return _this.callState === CallState.ACTIVE && _this.amICallee === true;
  };

  this.shallMuteOutgoingAudio = function () {
    return _this.callState !== CallState.ACTIVE;
  };

  this.canPlayIncomingVideo = function () {
    return _this.callState === CallState.ACTIVE && _this.incomingVideoEnabled;
  };

  this.makePeerConnectionCreationFailedHandler = function (opponentJID) {
    return function (err) {
      // Prevent failing a call if the error callback was invoked
      // for an already disposed peer connection.
      if (err && opponentJID in _this.webRtcPeers) {
        _this.failCall(err);
      }
    };
  };

  this.checkIfCallAnsweredOnAnotherDevice = function (callerJID, currentUserJID, checkedCallId, userAuth) {
    return new Promise(function ($return, $error) {
      var __METHOD__, WAIT_TIMEOUT, MAX_CALL_STATUS_CHECKS, EXECUTOR_API, EXECUTOR_CALL_STATUS_RESPONSE, attemptsCount, makeErrorStanzaHandler, makeCallStatusResponseStanzaHandler, callStatusRequestExecutor, apiRequestExecutor, apiCallStatus, callStatusResponse, callStatusResponsePromise, apiResponsePromise, _ref, whichExecutor, response, _ref2, _ref3, apiResponse, errMessage;

      __METHOD__ = 'ensureCallHasNotBeenAnsweredOnAnotherDevice';
      WAIT_TIMEOUT = 15000;
      MAX_CALL_STATUS_CHECKS = 3;
      EXECUTOR_API = 'api';
      EXECUTOR_CALL_STATUS_RESPONSE = 'callStatusResponse';
      attemptsCount = 0;

      makeErrorStanzaHandler = function makeErrorStanzaHandler(expectedStanzaId, isTimedOut, callback) {
        return function (msg) {
          if (isTimedOut()) {
            return false;
          }

          var _processServerMsg2 = Object(con_helpers["k" /* processServerMsg */])(msg),
              messId = _processServerMsg2.id;

          if (messId === expectedStanzaId) {
            callback();
            return false;
          }

          return true;
        };
      };

      makeCallStatusResponseStanzaHandler = function makeCallStatusResponseStanzaHandler(expectedCallId, isTimedOut, callback) {
        return function (msg) {
          if (isTimedOut()) {
            return false;
          }

          var _processServerMsg3 = Object(con_helpers["k" /* processServerMsg */])(msg),
              type = _processServerMsg3.type,
              vcxepElems = _processServerMsg3.vcxepElems;

          if (type === 'vcxep' && vcxepElems.length > 0) {
            var body = vcxepElems[0];

            var _processCallMsg2 = Object(con_helpers["i" /* processCallMsg */])(body),
                callType = _processCallMsg2.type,
                callId = _processCallMsg2.callId,
                bodyInner = _processCallMsg2.bodyInner;

            if ('' + callId === '' + expectedCallId && callType === 'callStatusResponse') {
              callback(bodyInner);
              return false;
            }
            if ('' + callId === '' + expectedCallId && (callType === 'callDisconnected' || callType === 'noAnswer' || callType === 'callerDeclined')) {
              callback('outdated');
              return false;
            }
          }

          return true;
        };
      };

      callStatusRequestExecutor = function callStatusRequestExecutor(resolve, reject) {
        // Make sure we operate on the same Strophe.Connection instance within a single attempt
        var xmppConnection = _this.connection;

        if (!xmppConnection) {
          reject(new Error('No XMPP connection instance is available'));
        }
        var callStatusRequestMessageId = xmppConnection.getUniqueId('callstatus-\u0441heck-' + attemptsCount);

        var errorStanzaHandlerRef = void 0;
        var callStatusResponseHandlerRef = void 0;

        var deleteTempStanzaHandlers = function deleteTempStanzaHandlers() {
          if (errorStanzaHandlerRef) {
            xmppConnection.deleteHandler(errorStanzaHandlerRef);
            errorStanzaHandlerRef = null;
          }
          if (callStatusResponseHandlerRef) {
            xmppConnection.deleteHandler(callStatusResponseHandlerRef);
            callStatusResponseHandlerRef = null;
          }
        };

        var timedOut = false;
        var isTimedOut = function isTimedOut() {
          return timedOut;
        };

        var watchdogTimer = setTimeout(function () {
          timedOut = true;
          deleteTempStanzaHandlers();
          reject(new Error('No response to "callStatusRequest" from the caller\'s device'));
        }, WAIT_TIMEOUT);

        var onCallStatusRequestFailed = function onCallStatusRequestFailed() {
          deleteTempStanzaHandlers();
          clearTimeout(watchdogTimer);
          reject(new Error('Failed to deliver the "callStatusRequest" message to the caller\'s device'));
        };

        var onCallStatusResponseReceived = function onCallStatusResponseReceived(reportedCallStatus) {
          deleteTempStanzaHandlers();
          clearTimeout(watchdogTimer);
          resolve([EXECUTOR_CALL_STATUS_RESPONSE, reportedCallStatus]);
        };

        errorStanzaHandlerRef = xmppConnection.addHandler(makeErrorStanzaHandler(callStatusRequestMessageId, isTimedOut, onCallStatusRequestFailed), null, 'message', 'error', callStatusRequestMessageId, callerJID);
        callStatusResponseHandlerRef = xmppConnection.addHandler(makeCallStatusResponseStanzaHandler(checkedCallId, isTimedOut, onCallStatusResponseReceived), null, 'message', 'vcxep', null, callerJID);

        if (xmppConnection.connected) {
          _this.msgGenSend(currentUserJID, callerJID, 'vcxep', 'vcxep', { type: 'callStatusRequest', callid: checkedCallId }, undefined, true, callStatusRequestMessageId);
        } else {
          clearTimeout(watchdogTimer);
          deleteTempStanzaHandlers();
          reject(new Error('The XMPP connection is no longer connected'));
        }
      };

      apiRequestExecutor = function apiRequestExecutor(resolve, reject) {
        var timedOut = false;

        var watchdogTimer = setTimeout(function () {
          timedOut = true;
          reject(new Error('No response from the back-end API'));
        }, WAIT_TIMEOUT);

        Object(pros["b" /* getCallDetails */])(checkedCallId, userAuth).then(function (callInfo) {
          if (timedOut) {
            return;
          }

          clearTimeout(watchdogTimer);
          resolve([EXECUTOR_API, callInfo]);
        }).catch(function (apiError) {
          if (timedOut) {
            return;
          }

          clearTimeout(watchdogTimer);
          reject(new Error('Back-end API returned an error: ' + apiError.message));
        });
      };

      apiCallStatus = null;
      callStatusResponse = null;

      attemptsCount = 1;
      var $Loop_26_trampoline;
      function $Loop_26_step() {
        attemptsCount += 1;
        return $Loop_26;
      }
      function $Loop_26() {
        if (attemptsCount <= MAX_CALL_STATUS_CHECKS) {
          callStatusResponsePromise = new Promise(callStatusRequestExecutor);
          apiResponsePromise = new Promise(apiRequestExecutor);

          var $Try_21_Post = function () {
            try {
              return $Loop_26_step;
            } catch ($boundEx) {
              return $error($boundEx);
            }
          };var $Try_21_Catch = function (err) {
            try {
              errMessage = err instanceof AggregateError ? err.errors.reduce(function (acc, current) {
                return acc.length === 0 ? current.message : acc + ', ' + current.message;
              }, '') : err.message;

              logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Attempt ' + attemptsCount + ' failed: ' + errMessage, lib["LogLevel"].Warning);
              return $Try_21_Post();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          };try {
            logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Checking the status of the call with call ID: ' + checkedCallId + ', attempt #' + attemptsCount);
            // eslint-disable-next-line no-await-in-loop
            return Promise.resolve(Promise.any([callStatusResponsePromise, apiResponsePromise])).then(function ($await_38) {
              try {
                _ref = $await_38, whichExecutor = _ref[0], response = _ref[1];


                switch (whichExecutor) {
                  case EXECUTOR_API:
                    apiCallStatus = response.status.toUpperCase();
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Got the call status from the API. Call ID: ' + checkedCallId + ', status: ' + apiCallStatus);
                    switch (apiCallStatus) {
                      case 'INVITED':
                        // The call didn't happen - safe to send 'receiverDeclined'
                        return $return(false);
                      case 'ACTIVE':
                        return Promise.resolve(callStatusResponsePromise).then(function ($await_39) {
                          try {
                            _ref2 = $await_39;
                            callStatusResponse = _ref2[1];

                            logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Got the call status from the client device within the same attempt. Call ID: ' + checkedCallId + ', status: ' + callStatusResponse);
                            switch (callStatusResponse) {
                              case 'active':
                                // The caller reports that the call has not been answered yet - no further checks needed;
                                return $return(false);
                              case 'answeredElsewhere':
                                // The caller reports that the call has been answered - no further checks needed;
                                return $return(true);
                              case 'outdated':
                                // The caller's client could have restarted and no longer knows about this call.
                                // Given that the API still considers the call as ACTIVE so the call could have happened, do not send 'receiverDeclined'
                                return $return(true);
                              default:
                                throw new Error('Unknown call status returned in the "callStatusResponse" message');
                            }
                            // eslint-disable-next-line no-unreachable
                            return [1];
                          } catch ($boundEx) {
                            return $Try_21_Catch($boundEx);
                          }
                        }, $Try_21_Catch);
                      default:
                        // Assume that any other call status reported by the back-end API is a "terminating" status meaning that the call is over.
                        // So, if the call is reported as having been finished for one reason or another by the back-end API,
                        // assume that the call was answered and stop further checks.
                        return $return(true);
                    }
                    // eslint-disable-next-line no-unreachable
                    return [1];
                  case EXECUTOR_CALL_STATUS_RESPONSE:
                    callStatusResponse = response;
                    logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Got the call status from the client device. Call ID: ' + checkedCallId + ', status: ' + callStatusResponse);

                    switch (callStatusResponse) {
                      case 'active':
                        // The caller reports that the call has not been answered yet - no further checks needed;
                        return $return(false);
                      case 'answeredElsewhere':
                        // The caller reports that the call has been answered - no further checks needed;
                        return $return(true);
                      case 'outdated':
                        return Promise.resolve(apiResponsePromise).then(function ($await_40) {
                          try {
                            _ref3 = $await_40, apiResponse = _ref3[1];

                            apiCallStatus = apiResponse.status.toUpperCase();
                            logger["h" /* logSignaling */](__FILE__, __METHOD__, 'Got the call status from the API within the same attempt. Call ID: ' + checkedCallId + ', status: ' + apiCallStatus);

                            switch (apiCallStatus) {
                              case 'ACTIVE':
                                // If the call is reported as ACTIVE by the back-end API, the call *might* have been answered (even if is disconnected now). Stopping further checks.
                                return $return(true);
                              case 'INVITED':
                                // The call is stuck in the INVITED state - it's safe to send 'receiverDeclined'
                                return $return(false);
                              default:
                                // Assume that any other call status reported by the back-end API is a "terminating" status meaning that the call is over.
                                // So, if the call is reported as having been finished for one reason or another by the back-end API,
                                // assume that the call was answered and stop further checks.
                                return $return(true);
                            }
                          } catch ($boundEx) {
                            return $Try_21_Catch($boundEx);
                          }
                        }, $Try_21_Catch);

                      default:
                        throw new Error('Unknown call status returned in the "callStatusResponse" message');
                    }
                    // eslint-disable-next-line no-unreachable
                    return [1];
                  default:
                    return [1];
                }
                return $Try_21_Post();
              } catch ($boundEx) {
                return $Try_21_Catch($boundEx);
              }
            }.bind(this), $Try_21_Catch);
          } catch (err) {
            $Try_21_Catch(err)
          }
        } else return [1];
      }

      return ($Loop_26_trampoline = function (q) {
        while (q) {
          if (q.then) return void q.then($Loop_26_trampoline, $error);try {
            if (q.pop) {
              if (q.length) return q.pop() ? $Loop_26_exit.call(this) : q;else q = $Loop_26_step;
            } else q = q.call(this);
          } catch (_exception) {
            return $error(_exception);
          }
        }
      }.bind(this))($Loop_26);

      function $Loop_26_exit() {

        if (!callStatusResponse && apiCallStatus === 'INVITED') {
          // The caller's device may have been disconnected, but if the call is still INVITED
          // at the API side, it's safe to send 'receiverDeclined';
          return $return(false);
        }

        return $error(new Error('Failed to reliably determine if the call was answered'));
      }
    });
  };

  this.setAudioOutputSink = function (deviceId) {
    var audioInput = _this.props.audioInput;

    audioInput.setSinkId && audioInput.setSinkId === 'function' && audioInput.setSinkId(deviceId);
  };

  this.resetToIdleState = function () {
    _this.callState = CallState.IDLE;
  };
}, _temp);


/* harmony default export */ var connection = __webpack_exports__["j"] = (connection_Connection);

/***/ }),

/***/ "PZh6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20bc45a94cf056229009317f66d1f69b.png";

/***/ }),

/***/ "PcXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./api/index.js
var api = __webpack_require__("/C1n");

// EXTERNAL MODULE: ./api/fetch-wrapper.js
var fetch_wrapper = __webpack_require__("ds2O");

// CONCATENATED MODULE: ./api/chat.js


// create call
function chat_createCall(cid) {
  var fcid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _isPro = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var authData = arguments[3];
  var callerJID = arguments[4];
  var callProtocolVersion = arguments[5];

  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  var createCallRequest = {
    objectId: typeof fcid === 'number' || typeof fcid === 'string' ? typeof fcid === 'number' ? fcid : Number.parseInt(fcid, 10) : null,
    signalingProtocol: callProtocolVersion,
    userId: cid,
    resourceId: callerJID
  };

  // const additionalQuery = isPro ? `?cid=${cid}&isPro=${isPro}${fcid !== null ? `&fcid=${fcid}` : ''}` : `?cid=${cid}${fcid !== null ? `&fcid=${fcid}` : ''}`;
  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].CALLS_V3, { method: 'POST', headers: headers, body: JSON.stringify(createCallRequest) });
}

function chat_reviewCall(id, rating, authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].CALLS + '/' + id + '/review', { method: 'POST', headers: headers, body: JSON.stringify({ rating: rating }) });
}

function getProFeatureService(authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].FEATURED, { method: 'GET', headers: headers });
}

function chat_sendNotificationFromSupport(authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');
  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].SEND_NOTIFICATION_FROM_SUPPORT(40), { method: 'POST', headers: headers });
}
// EXTERNAL MODULE: ./actions/index.js
var actions = __webpack_require__("vyGZ");

// EXTERNAL MODULE: ./actions/api-notifications.js
var api_notifications = __webpack_require__("kKXN");

// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// CONCATENATED MODULE: ./actions/chat.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_CALL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return chat_getCallInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chat_caleeIsBusy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return chat_speaking; });
/* unused harmony export stopCommunication */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return chat_closeComModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return chat_openComModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return chat_processCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return actions_chat_createCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return chat_chooseChatPerson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return chat_changeUnreadNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return chat_clearChats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return chat_pickUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return chat_changeChat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return chat_changeConnectionStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return chat_changeVideoStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return chat_setTimeOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return actions_chat_sendNotificationFromSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return actions_chat_reviewCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return chat_changeReconnectionStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return chat_clearCallBriefs; });





var CREATE_CALL_ERROR = 'Please top up your Telmie balance or link your bank card to make this call.';

var chat_createCallAction = function createCallAction(response, calleeBrief) {
  return {
    type: actions["a" /* actionTypes */].CREATE_CALL,
    avTime: response.avTime,
    callId: response.id,
    callerId: response.callerId,
    consultant: {
      id: response.consultant.id
    },
    calleeBrief: calleeBrief
  };
};
var chat_createCallErrorAction = function createCallErrorAction() {
  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: actions["a" /* actionTypes */].CREATE_CALL_ERROR,
    info: response.message || CREATE_CALL_ERROR,
    internalError: response.internalError
  };
};

var chat_getCallInfo = function getCallInfo(response) {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].GET_CALL_INFO,
      payload: response
    });
  };
};

var chat_caleeIsBusy = function caleeIsBusy() {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].CALEE_IS_BUSY
    });
  };
};

var chat_speaking = function speaking() {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].SPEAKING
    });
  };
};

var chat_stopCommunication = function stopCommunication() {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].STOP_COMMUNICATION
    });
  };
};

var chat_closeComModal = function closeComModal(type) {
  return function (dispatch) {
    if (type === consts["E" /* consts */].CHAT) {
      dispatch({
        type: actions["a" /* actionTypes */].CLOSE_COMMUNICATE_MODAL_CHAT
      });
    } else {
      dispatch({
        type: actions["a" /* actionTypes */].CLOSE_COMMUNICATE_MODAL
      });
    }
  };
};

var chat_openComModal = function openComModal(type, person) {
  var isOutcoming = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isIncoming = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch) {
    if (type === consts["E" /* consts */].CALL) {
      dispatch({
        type: actions["a" /* actionTypes */].OPEN_COMMUNICATE_MODAL,
        modalType: type,
        person: person,
        isOutcoming: isOutcoming,
        isIncoming: isIncoming
      });
    }
    if (type === consts["E" /* consts */].CHAT) {
      dispatch({
        type: actions["a" /* actionTypes */].OPEN_COMMUNICATE_MODAL_CHAT
      });
    }
  };
};

var chat_processCall = function processCall() {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].PROCESSING_CALL
    });
  };
};

var actions_chat_createCall = function createCall(cid, fcid, isPro, _auth, errCallback, callerJID, callProtocolVersion) {
  var calleeBrief = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : undefined;
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState, userAuth, response;

      _getState = getState(), userAuth = _getState.loggedInUser.userAuth;
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (err) {
        try {
          dispatch(chat_createCallErrorAction(err));

          if (errCallback) {
            errCallback();
          }
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(chat_createCall(cid, fcid, isPro, userAuth, callerJID, callProtocolVersion)).then(function ($await_3) {
          try {
            response = $await_3;

            if (response.error) {
              dispatch(chat_createCallErrorAction(response));
              if (errCallback) errCallback();
            } else {
              dispatch(chat_createCallAction(response, calleeBrief));
            }
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (err) {
        $Try_1_Catch(err)
      }
    });
  };
};

var chat_chooseChatPerson = function chooseChatPerson(person) {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].CHOOSE_CHAT_PERSON,
      person: person
    });
  };
};

var chat_changeUnreadNum = function changeUnreadNum(from) {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].CHANGE_UNREAD_MSG,
      from: from
    });
  };
};

var chat_clearChats = function clearChats() {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].CLEAR_CHATS
    });
  };
};

var chat_pickUp = function pickUp() {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].PICK_UP_CALL
    });
  };
};

var chat_changeChat = function changeChat(data) {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].CHANGE_CHAT,
      payload: data
    });
  };
};

var chat_changeConnectionStatus = function changeConnectionStatus(data) {
  return function (dispatch) {
    return dispatch({
      type: actions["a" /* actionTypes */].CHANGE_CONNECTION_STATUS,
      payload: data
    });
  };
};

var chat_changeVideoStatus = function changeVideoStatus(data) {
  return function (dispatch) {
    dispatch({
      type: actions["a" /* actionTypes */].CHANGE_VIDEO_STATUS,
      payload: data
    });
  };
};

var chat_setTimeOffset = function setTimeOffset(data) {
  return function (dispatch) {
    dispatch({
      type: actions["a" /* actionTypes */].SET_TIME_OFFSET,
      payload: data
    });
  };
};

var actions_chat_sendNotificationFromSupport = function sendNotificationFromSupport() {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState2 = getState(),
          userAuth = _getState2.loggedInUser.userAuth;

      chat_sendNotificationFromSupport(userAuth);
      return $return();
    });
  };
};

var actions_chat_reviewCall = function reviewCall(id, rating) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState3, userAuth, response;

      _getState3 = getState(), userAuth = _getState3.loggedInUser.userAuth;
      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_2_Catch = function (err) {
        try {
          dispatch(Object(api_notifications["a" /* addNotification */])(err));
          return $Try_2_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(chat_reviewCall(id, rating, userAuth)).then(function ($await_4) {
          try {
            response = $await_4;
            dispatch({
              type: actions["a" /* actionTypes */].GLOBAL_MESSAGE,
              payload: response.message
            });
            return $Try_2_Post();
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (err) {
        $Try_2_Catch(err)
      }
    });
  };
};

var chat_changeReconnectionStatus = function changeReconnectionStatus(isReconnect) {
  return {
    type: actions["a" /* actionTypes */].CHANGE_RECONNECTION_STATUS,
    payload: isReconnect
  };
};

var chat_clearCallBriefs = function clearCallBriefs() {
  return function (dispatch) {
    dispatch({
      type: actions["a" /* actionTypes */].CLEAR_CALL_BRIEFS
    });
  };
};

/***/ }),

/***/ "PkFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__("lyLi");

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _shallowEqual2.default;

/***/ }),

/***/ "PlPR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__("hDW8");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        miniStore: this.props.store
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Provider;
}(_react.Component);

Provider.propTypes = {
  store: _PropTypes.storeShape.isRequired
};
Provider.childContextTypes = {
  miniStore: _PropTypes.storeShape.isRequired
};
exports.default = Provider;

/***/ }),

/***/ "PoOm":
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var callBind = bind && bind.bind(call);

module.exports = bind ? function (fn) {
  return fn && callBind(call, fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};

/***/ }),

/***/ "PrDZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__("KYJg");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__("IuuM");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__("wuZP");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__("2kK6");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var year = Object(getUTCISOWeekYear["a" /* default */])(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = Object(startOfUTCISOWeek["a" /* default */])(fourthOfJanuary);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeek;




var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var diff = Object(startOfUTCISOWeek["a" /* default */])(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ "Psxq":
/***/ (function(module, exports) {

module.exports = {};

/***/ }),

/***/ "PvLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("Xos8");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("T4f3");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("dACh");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("jx4H");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("VOrx");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("ZKjc");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__("9qb7");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/rc-pagination/es/Pager.js





var Pager_Pager = function Pager(props) {
  var _classNames;

  var prefixCls = props.rootPrefixCls + '-item';
  var cls = classnames_default()(prefixCls, prefixCls + '-' + props.page, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-active', props.active), defineProperty_default()(_classNames, props.className, !!props.className), defineProperty_default()(_classNames, prefixCls + '-disabled', !props.page), _classNames));

  var handleClick = function handleClick() {
    props.onClick(props.page);
  };

  var handleKeyPress = function handleKeyPress(e) {
    props.onKeyPress(e, props.onClick, props.page);
  };

  return preact_compat_es["default"].createElement('li', {
    title: props.showTitle ? props.page : null,
    className: cls,
    onClick: handleClick,
    onKeyPress: handleKeyPress,
    tabIndex: '0'
  }, props.itemRender(props.page, 'page', preact_compat_es["default"].createElement('a', null, props.page)));
};

/* harmony default export */ var es_Pager = (Pager_Pager);
// CONCATENATED MODULE: ../node_modules/rc-pagination/es/KeyCode.js
/* harmony default export */ var KeyCode = ({
  ZERO: 48,
  NINE: 57,

  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,

  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,

  ARROW_UP: 38,
  ARROW_DOWN: 40
});
// CONCATENATED MODULE: ../node_modules/rc-pagination/es/Options.js








var Options_Options = function (_React$Component) {
  inherits_default()(Options, _React$Component);

  function Options() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Options);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Options.__proto__ || Object.getPrototypeOf(Options)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      goInputText: ''
    }, _this.buildOptionText = function (value) {
      return value + ' ' + _this.props.locale.items_per_page;
    }, _this.changeSize = function (value) {
      _this.props.changeSize(Number(value));
    }, _this.handleChange = function (e) {
      _this.setState({
        goInputText: e.target.value
      });
    }, _this.handleBlur = function (e) {
      var _this$props = _this.props,
          goButton = _this$props.goButton,
          quickGo = _this$props.quickGo,
          rootPrefixCls = _this$props.rootPrefixCls;

      if (goButton) {
        return;
      }
      if (e.relatedTarget && (e.relatedTarget.className.indexOf(rootPrefixCls + '-prev') >= 0 || e.relatedTarget.className.indexOf(rootPrefixCls + '-next') >= 0)) {
        return;
      }
      quickGo(_this.getValidValue());
    }, _this.go = function (e) {
      var goInputText = _this.state.goInputText;

      if (goInputText === '') {
        return;
      }
      if (e.keyCode === KeyCode.ENTER || e.type === 'click') {
        _this.setState({
          goInputText: ''
        });
        _this.props.quickGo(_this.getValidValue());
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Options, [{
    key: 'getValidValue',
    value: function getValidValue() {
      var _state = this.state,
          goInputText = _state.goInputText,
          current = _state.current;

      return !goInputText || isNaN(goInputText) ? current : Number(goInputText);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pageSize = _props.pageSize,
          pageSizeOptions = _props.pageSizeOptions,
          locale = _props.locale,
          rootPrefixCls = _props.rootPrefixCls,
          changeSize = _props.changeSize,
          quickGo = _props.quickGo,
          goButton = _props.goButton,
          selectComponentClass = _props.selectComponentClass,
          buildOptionText = _props.buildOptionText,
          selectPrefixCls = _props.selectPrefixCls,
          disabled = _props.disabled;
      var goInputText = this.state.goInputText;

      var prefixCls = rootPrefixCls + '-options';
      var Select = selectComponentClass;
      var changeSelect = null;
      var goInput = null;
      var gotoButton = null;

      if (!changeSize && !quickGo) {
        return null;
      }

      if (changeSize && Select) {
        var options = pageSizeOptions.map(function (opt, i) {
          return preact_compat_es["default"].createElement(Select.Option, { key: i, value: opt }, (buildOptionText || _this2.buildOptionText)(opt));
        });

        changeSelect = preact_compat_es["default"].createElement(Select, {
          disabled: disabled,
          prefixCls: selectPrefixCls,
          showSearch: false,
          className: prefixCls + '-size-changer',
          optionLabelProp: 'children',
          dropdownMatchSelectWidth: false,
          value: (pageSize || pageSizeOptions[0]).toString(),
          onChange: this.changeSize,
          getPopupContainer: function getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
          }
        }, options);
      }

      if (quickGo) {
        if (goButton) {
          gotoButton = typeof goButton === 'boolean' ? preact_compat_es["default"].createElement('button', {
            type: 'button',
            onClick: this.go,
            onKeyUp: this.go,
            disabled: disabled
          }, locale.jump_to_confirm) : preact_compat_es["default"].createElement('span', {
            onClick: this.go,
            onKeyUp: this.go
          }, goButton);
        }
        goInput = preact_compat_es["default"].createElement('div', { className: prefixCls + '-quick-jumper' }, locale.jump_to, preact_compat_es["default"].createElement('input', {
          disabled: disabled,
          type: 'text',
          value: goInputText,
          onChange: this.handleChange,
          onKeyUp: this.go,
          onBlur: this.handleBlur
        }), locale.page, gotoButton);
      }

      return preact_compat_es["default"].createElement('li', { className: '' + prefixCls }, changeSelect, goInput);
    }
  }]);

  return Options;
}(preact_compat_es["default"].Component);

Options_Options.defaultProps = {
  pageSizeOptions: ['10', '20', '30', '40']
};

/* harmony default export */ var es_Options = (Options_Options);
// CONCATENATED MODULE: ../node_modules/rc-pagination/es/locale/zh_CN.js
/* harmony default export */ var zh_CN = ({
  // Options.jsx
  items_per_page: '条/页',
  jump_to: '跳至',
  jump_to_confirm: '确定',
  page: '页',

  // Pagination.jsx
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页'
});
// EXTERNAL MODULE: ../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
var react_lifecycles_compat_es = __webpack_require__("nkXc");

// CONCATENATED MODULE: ../node_modules/rc-pagination/es/Pagination.js















function noop() {}

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function defaultItemRender(page, type, element) {
  return element;
}

function calculatePage(p, state, props) {
  var pageSize = p;
  if (typeof pageSize === 'undefined') {
    pageSize = state.pageSize;
  }
  return Math.floor((props.total - 1) / pageSize) + 1;
}

var Pagination_Pagination = function (_React$Component) {
  inherits_default()(Pagination, _React$Component);

  function Pagination(props) {
    classCallCheck_default()(this, Pagination);

    var _this = possibleConstructorReturn_default()(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    Pagination__initialiseProps.call(_this);

    var hasOnChange = props.onChange !== noop;
    var hasCurrent = 'current' in props;
    if (hasCurrent && !hasOnChange) {
      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
    }

    var current = props.defaultCurrent;
    if ('current' in props) {
      current = props.current;
    }

    var pageSize = props.defaultPageSize;
    if ('pageSize' in props) {
      pageSize = props.pageSize;
    }

    current = Math.min(current, calculatePage(pageSize, undefined, props));

    _this.state = {
      current: current,
      currentInputValue: current,
      pageSize: pageSize
    };
    return _this;
  }

  createClass_default()(Pagination, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // When current page change, fix focused style of prev item
      // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
      var prefixCls = this.props.prefixCls;

      if (prevState.current !== this.state.current && this.paginationNode) {
        var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);
        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
          lastCurrentNode.blur();
        }
      }
    }
  }, {
    key: 'getValidValue',
    value: function getValidValue(e) {
      var inputValue = e.target.value;
      var allPages = calculatePage(undefined, this.state, this.props);
      var currentInputValue = this.state.currentInputValue;

      var value = void 0;
      if (inputValue === '') {
        value = inputValue;
      } else if (isNaN(Number(inputValue))) {
        value = currentInputValue;
      } else if (inputValue >= allPages) {
        value = allPages;
      } else {
        value = Number(inputValue);
      }
      return value;
    }
  }, {
    key: 'renderPrev',
    value: function renderPrev(prevPage) {
      var _props = this.props,
          prevIcon = _props.prevIcon,
          itemRender = _props.itemRender;

      var prevButton = itemRender(prevPage, 'prev', this.getItemIcon(prevIcon));
      var disabled = !this.hasPrev();
      return Object(preact_compat_es["isValidElement"])(prevButton) ? Object(preact_compat_es["cloneElement"])(prevButton, { disabled: disabled }) : prevButton;
    }
  }, {
    key: 'renderNext',
    value: function renderNext(nextPage) {
      var _props2 = this.props,
          nextIcon = _props2.nextIcon,
          itemRender = _props2.itemRender;

      var nextButton = itemRender(nextPage, 'next', this.getItemIcon(nextIcon));
      var disabled = !this.hasNext();
      return Object(preact_compat_es["isValidElement"])(nextButton) ? Object(preact_compat_es["cloneElement"])(nextButton, { disabled: disabled }) : nextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          className = _props3.className,
          disabled = _props3.disabled;

      // When hideOnSinglePage is true and there is only 1 page, hide the pager

      if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
        return null;
      }

      var props = this.props;
      var locale = props.locale;

      var allPages = calculatePage(undefined, this.state, this.props);
      var pagerList = [];
      var jumpPrev = null;
      var jumpNext = null;
      var firstPager = null;
      var lastPager = null;
      var gotoButton = null;

      var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
      var pageBufferSize = props.showLessItems ? 1 : 2;
      var _state = this.state,
          current = _state.current,
          pageSize = _state.pageSize;

      var prevPage = current - 1 > 0 ? current - 1 : 0;
      var nextPage = current + 1 < allPages ? current + 1 : allPages;

      var dataOrAriaAttributeProps = Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
          prev[key] = props[key];
        }
        return prev;
      }, {});

      if (props.simple) {
        if (goButton) {
          if (typeof goButton === 'boolean') {
            gotoButton = preact_compat_es["default"].createElement('button', {
              type: 'button',
              onClick: this.handleGoTO,
              onKeyUp: this.handleGoTO
            }, locale.jump_to_confirm);
          } else {
            gotoButton = preact_compat_es["default"].createElement('span', {
              onClick: this.handleGoTO,
              onKeyUp: this.handleGoTO
            }, goButton);
          }
          gotoButton = preact_compat_es["default"].createElement('li', {
            title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
            className: prefixCls + '-simple-pager'
          }, gotoButton);
        }

        return preact_compat_es["default"].createElement('ul', extends_default()({
          className: prefixCls + ' ' + prefixCls + '-simple ' + props.className,
          style: props.style,
          ref: this.savePaginationNode
        }, dataOrAriaAttributeProps), preact_compat_es["default"].createElement('li', {
          title: props.showTitle ? locale.prev_page : null,
          onClick: this.prev,
          tabIndex: this.hasPrev() ? 0 : null,
          onKeyPress: this.runIfEnterPrev,
          className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
          'aria-disabled': !this.hasPrev()
        }, this.renderPrev(prevPage)), preact_compat_es["default"].createElement('li', {
          title: props.showTitle ? this.state.current + '/' + allPages : null,
          className: prefixCls + '-simple-pager'
        }, preact_compat_es["default"].createElement('input', {
          type: 'text',
          value: this.state.currentInputValue,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onChange: this.handleKeyUp,
          size: '3'
        }), preact_compat_es["default"].createElement('span', { className: prefixCls + '-slash' }, '/'), allPages), preact_compat_es["default"].createElement('li', {
          title: props.showTitle ? locale.next_page : null,
          onClick: this.next,
          tabIndex: this.hasPrev() ? 0 : null,
          onKeyPress: this.runIfEnterNext,
          className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
          'aria-disabled': !this.hasNext()
        }, this.renderNext(nextPage)), gotoButton);
      }

      if (allPages <= 5 + pageBufferSize * 2) {
        var pagerProps = {
          locale: locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        };
        if (!allPages) {
          pagerList.push(preact_compat_es["default"].createElement(es_Pager, extends_default()({}, pagerProps, {
            key: 'noPager',
            page: allPages,
            className: prefixCls + '-disabled'
          })));
        }
        for (var i = 1; i <= allPages; i++) {
          var active = this.state.current === i;
          pagerList.push(preact_compat_es["default"].createElement(es_Pager, extends_default()({}, pagerProps, {
            key: i,
            page: i,
            active: active
          })));
        }
      } else {
        var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
        var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
        if (props.showPrevNextJumpers) {
          var jumpPrevClassString = prefixCls + '-jump-prev';
          if (props.jumpPrevIcon) {
            jumpPrevClassString += ' ' + prefixCls + '-jump-prev-custom-icon';
          }
          jumpPrev = preact_compat_es["default"].createElement('li', {
            title: props.showTitle ? prevItemTitle : null,
            key: 'prev',
            onClick: this.jumpPrev,
            tabIndex: '0',
            onKeyPress: this.runIfEnterJumpPrev,
            className: jumpPrevClassString
          }, props.itemRender(this.getJumpPrevPage(), 'jump-prev', this.getItemIcon(props.jumpPrevIcon)));
          var jumpNextClassString = prefixCls + '-jump-next';
          if (props.jumpNextIcon) {
            jumpNextClassString += ' ' + prefixCls + '-jump-next-custom-icon';
          }
          jumpNext = preact_compat_es["default"].createElement('li', {
            title: props.showTitle ? nextItemTitle : null,
            key: 'next',
            tabIndex: '0',
            onClick: this.jumpNext,
            onKeyPress: this.runIfEnterJumpNext,
            className: jumpNextClassString
          }, props.itemRender(this.getJumpNextPage(), 'jump-next', this.getItemIcon(props.jumpNextIcon)));
        }
        lastPager = preact_compat_es["default"].createElement(es_Pager, {
          locale: props.locale,
          last: true,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: allPages,
          page: allPages,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });
        firstPager = preact_compat_es["default"].createElement(es_Pager, {
          locale: props.locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: 1,
          page: 1,
          active: false,
          showTitle: props.showTitle,
          itemRender: props.itemRender
        });

        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);

        if (current - 1 <= pageBufferSize) {
          right = 1 + pageBufferSize * 2;
        }

        if (allPages - current <= pageBufferSize) {
          left = allPages - pageBufferSize * 2;
        }

        for (var _i = left; _i <= right; _i++) {
          var _active = current === _i;
          pagerList.push(preact_compat_es["default"].createElement(es_Pager, {
            locale: props.locale,
            rootPrefixCls: prefixCls,
            onClick: this.handleChange,
            onKeyPress: this.runIfEnter,
            key: _i,
            page: _i,
            active: _active,
            showTitle: props.showTitle,
            itemRender: props.itemRender
          }));
        }

        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
          pagerList[0] = preact_compat_es["default"].cloneElement(pagerList[0], {
            className: prefixCls + '-item-after-jump-prev'
          });
          pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
          pagerList[pagerList.length - 1] = preact_compat_es["default"].cloneElement(pagerList[pagerList.length - 1], {
            className: prefixCls + '-item-before-jump-next'
          });
          pagerList.push(jumpNext);
        }

        if (left !== 1) {
          pagerList.unshift(firstPager);
        }
        if (right !== allPages) {
          pagerList.push(lastPager);
        }
      }

      var totalText = null;

      if (props.showTotal) {
        totalText = preact_compat_es["default"].createElement('li', { className: prefixCls + '-total-text' }, props.showTotal(props.total, [props.total === 0 ? 0 : (current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize]));
      }
      var prevDisabled = !this.hasPrev() || !allPages;
      var nextDisabled = !this.hasNext() || !allPages;
      return preact_compat_es["default"].createElement('ul', extends_default()({
        className: classnames_default()(prefixCls, className, defineProperty_default()({}, prefixCls + '-disabled', disabled)),
        style: props.style,
        unselectable: 'unselectable',
        ref: this.savePaginationNode
      }, dataOrAriaAttributeProps), totalText, preact_compat_es["default"].createElement('li', {
        title: props.showTitle ? locale.prev_page : null,
        onClick: this.prev,
        tabIndex: prevDisabled ? null : 0,
        onKeyPress: this.runIfEnterPrev,
        className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
        'aria-disabled': prevDisabled
      }, this.renderPrev(prevPage)), pagerList, preact_compat_es["default"].createElement('li', {
        title: props.showTitle ? locale.next_page : null,
        onClick: this.next,
        tabIndex: nextDisabled ? null : 0,
        onKeyPress: this.runIfEnterNext,
        className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
        'aria-disabled': nextDisabled
      }, this.renderNext(nextPage)), preact_compat_es["default"].createElement(es_Options, {
        disabled: disabled,
        locale: props.locale,
        rootPrefixCls: prefixCls,
        selectComponentClass: props.selectComponentClass,
        selectPrefixCls: props.selectPrefixCls,
        changeSize: this.props.showSizeChanger ? this.changePageSize : null,
        current: this.state.current,
        pageSize: this.state.pageSize,
        pageSizeOptions: this.props.pageSizeOptions,
        quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
        goButton: goButton
      }));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, prevState) {
      var newState = {};

      if ('current' in props) {
        newState.current = props.current;

        if (props.current !== prevState.current) {
          newState.currentInputValue = newState.current;
        }
      }

      if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
        var current = prevState.current;
        var newCurrent = calculatePage(props.pageSize, prevState, props);
        current = current > newCurrent ? newCurrent : current;

        if (!('current' in props)) {
          newState.current = current;
          newState.currentInputValue = current;
        }
        newState.pageSize = props.pageSize;
      }

      return newState;
    }

    /**
     * computed icon node that need to be rendered.
     * @param {React.ReactNode | React.ComponentType<PaginationProps>} icon received icon.
     * @returns {React.ReactNode}
     */

  }]);

  return Pagination;
}(preact_compat_es["default"].Component);

Pagination_Pagination.defaultProps = {
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: noop,
  className: '',
  selectPrefixCls: 'rc-select',
  prefixCls: 'rc-pagination',
  selectComponentClass: null,
  hideOnSinglePage: false,
  showPrevNextJumpers: true,
  showQuickJumper: false,
  showSizeChanger: false,
  showLessItems: false,
  showTitle: true,
  onShowSizeChange: noop,
  locale: zh_CN,
  style: {},
  itemRender: defaultItemRender
};

var Pagination__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getJumpPrevPage = function () {
    return Math.max(1, _this2.state.current - (_this2.props.showLessItems ? 3 : 5));
  };

  this.getJumpNextPage = function () {
    return Math.min(calculatePage(undefined, _this2.state, _this2.props), _this2.state.current + (_this2.props.showLessItems ? 3 : 5));
  };

  this.getItemIcon = function (icon) {
    var prefixCls = _this2.props.prefixCls;

    var iconNode = icon || preact_compat_es["default"].createElement('a', { className: prefixCls + '-item-link' });
    if (typeof icon === 'function') {
      iconNode = preact_compat_es["default"].createElement(icon, extends_default()({}, _this2.props));
    }
    return iconNode;
  };

  this.savePaginationNode = function (node) {
    _this2.paginationNode = node;
  };

  this.isValid = function (page) {
    return isInteger(page) && page !== _this2.state.current;
  };

  this.shouldDisplayQuickJumper = function () {
    var _props4 = _this2.props,
        showQuickJumper = _props4.showQuickJumper,
        pageSize = _props4.pageSize,
        total = _props4.total;

    if (total <= pageSize) {
      return false;
    }
    return showQuickJumper;
  };

  this.handleKeyDown = function (e) {
    if (e.keyCode === KeyCode.ARROW_UP || e.keyCode === KeyCode.ARROW_DOWN) {
      e.preventDefault();
    }
  };

  this.handleKeyUp = function (e) {
    var value = _this2.getValidValue(e);
    var currentInputValue = _this2.state.currentInputValue;

    if (value !== currentInputValue) {
      _this2.setState({
        currentInputValue: value
      });
    }
    if (e.keyCode === KeyCode.ENTER) {
      _this2.handleChange(value);
    } else if (e.keyCode === KeyCode.ARROW_UP) {
      _this2.handleChange(value - 1);
    } else if (e.keyCode === KeyCode.ARROW_DOWN) {
      _this2.handleChange(value + 1);
    }
  };

  this.changePageSize = function (size) {
    var current = _this2.state.current;
    var newCurrent = calculatePage(size, _this2.state, _this2.props);
    current = current > newCurrent ? newCurrent : current;
    // fix the issue:
    // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
    if (newCurrent === 0) {
      current = _this2.state.current;
    }

    if (typeof size === 'number') {
      if (!('pageSize' in _this2.props)) {
        _this2.setState({
          pageSize: size
        });
      }
      if (!('current' in _this2.props)) {
        _this2.setState({
          current: current,
          currentInputValue: current
        });
      }
    }
    _this2.props.onShowSizeChange(current, size);
  };

  this.handleChange = function (p) {
    var disabled = _this2.props.disabled;

    var page = p;
    if (_this2.isValid(page) && !disabled) {
      var currentPage = calculatePage(undefined, _this2.state, _this2.props);
      if (page > currentPage) {
        page = currentPage;
      } else if (page < 1) {
        page = 1;
      }

      if (!('current' in _this2.props)) {
        _this2.setState({
          current: page,
          currentInputValue: page
        });
      }

      var pageSize = _this2.state.pageSize;
      _this2.props.onChange(page, pageSize);

      return page;
    }

    return _this2.state.current;
  };

  this.prev = function () {
    if (_this2.hasPrev()) {
      _this2.handleChange(_this2.state.current - 1);
    }
  };

  this.next = function () {
    if (_this2.hasNext()) {
      _this2.handleChange(_this2.state.current + 1);
    }
  };

  this.jumpPrev = function () {
    _this2.handleChange(_this2.getJumpPrevPage());
  };

  this.jumpNext = function () {
    _this2.handleChange(_this2.getJumpNextPage());
  };

  this.hasPrev = function () {
    return _this2.state.current > 1;
  };

  this.hasNext = function () {
    return _this2.state.current < calculatePage(undefined, _this2.state, _this2.props);
  };

  this.runIfEnter = function (event, callback) {
    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      restParams[_key - 2] = arguments[_key];
    }

    if (event.key === 'Enter' || event.charCode === 13) {
      callback.apply(undefined, restParams);
    }
  };

  this.runIfEnterPrev = function (e) {
    _this2.runIfEnter(e, _this2.prev);
  };

  this.runIfEnterNext = function (e) {
    _this2.runIfEnter(e, _this2.next);
  };

  this.runIfEnterJumpPrev = function (e) {
    _this2.runIfEnter(e, _this2.jumpPrev);
  };

  this.runIfEnterJumpNext = function (e) {
    _this2.runIfEnter(e, _this2.jumpNext);
  };

  this.handleGoTO = function (e) {
    if (e.keyCode === KeyCode.ENTER || e.type === 'click') {
      _this2.handleChange(_this2.state.currentInputValue);
    }
  };
};

Object(react_lifecycles_compat_es["polyfill"])(Pagination_Pagination);

/* harmony default export */ var es_Pagination = (Pagination_Pagination);
// CONCATENATED MODULE: ../node_modules/rc-pagination/es/index.js

// EXTERNAL MODULE: ../node_modules/rc-pagination/assets/index.css
var assets = __webpack_require__("AI6T");
var assets_default = /*#__PURE__*/__webpack_require__.n(assets);

// EXTERNAL MODULE: ../node_modules/rc-pagination/lib/locale/en_GB.js
var en_GB = __webpack_require__("s7YI");
var en_GB_default = /*#__PURE__*/__webpack_require__.n(en_GB);

// EXTERNAL MODULE: ./components/pagination/style.scss
var style = __webpack_require__("onmi");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/pagination/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var pagination_Pagination = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Pagination.prototype.render = function render(_ref) {
    var current = _ref.current,
        total = _ref.total,
        pageSize = _ref.pageSize,
        onChange = _ref.onChange;

    return Object(preact_min["h"])(
      'div',
      { className: style_default.a.pagination },
      Object(preact_min["h"])(es_Pagination, { locale: en_GB_default.a, nextIcon: 'Next', prevIcon: 'Previous', total: total, pageSize: pageSize, current: current, onChange: onChange })
    );
  };

  return Pagination;
}(preact_min["Component"]);

/* harmony default export */ var pagination = __webpack_exports__["a"] = (pagination_Pagination);

/***/ }),

/***/ "Q373":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7b72f3d5eedd2a23861b26f2258d99fd.png";

/***/ }),

/***/ "Q38I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _EventObject = __webpack_require__("/z8I");

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    }();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),

/***/ "Q8Vk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"title__Oa_Vy","search":"search__1OI1h","offset":"offset__1GciM","content":"content__21zJN"};

/***/ }),

/***/ "QM/L":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(__webpack_require__("/0Qi")) : typeof define === 'function' && define.amd ? define(['strophe.js'], factory) : factory(global.window);
})(this, function (strophe_js) {
	'use strict';

	/**
 * StropheJS - Stream Management XEP-0198
 *
 * This plugin implements stream management ACK capabilities of the specs XEP-0198.
 * Note: Resumption is not supported in this current implementation.
 *
 * Reference: http://xmpp.org/extensions/xep-0198.html
 *
 * @class streamManagement
 */

	strophe_js.Strophe.addConnectionPlugin('streamManagement', {

		/**
  * @property {Boolean} logging: Set to true to enable logging regarding out of sync stanzas.
  */
		logging: true,

		/**
  * @property {Boolean} returnWholeStanza: Set to true to return the acknowledged stanzas, otherwise only return its ID.
  */
		returnWholeStanza: false,

		/**
  * @property {Boolean} autoSendCountOnEveryIncomingStanza: Set to true to send an 'a' response after every stanza.
  * @default false
  * @public
  */
		autoSendCountOnEveryIncomingStanza: false,

		/**
  * @property {Integer} requestResponseInterval: Set this value to send a request for counter on very interval
  * number of stanzas sent. Set to 0 to disable.
  * @default 5
  * @public
  */
		requestResponseInterval: 5,

		/**
  * @property {Handler} onAcknowledgementComplete: Stores reference to a handler that is invoked when an <a /> tag is fully processed.
  * @public
  */
		onAcknowledgementComplete: null,

		/**
  * @property {Pointer} _c: Strophe connection instance.
  * @private
  */
		_c: null,

		/**
  * @property {String} _NS XMPP Namespace.
  * @private
  */
		_NS: 'urn:xmpp:sm:3',

		/**
  * @property {Boolean} _isStreamManagementEnabled
  * @private
  */
		_isStreamManagementEnabled: false,

		/**
  * @property {Integer} _serverProcesssedStanzasCounter: Keeps count of stanzas confirmed processed by the server.
  * The server is the source of truth of this value. It is the 'h' attribute on the latest 'a' element received
  * from the server.
  * @private
  */
		_serverProcesssedStanzasCounter: null,

		/**
  * @property {Integer} _clientProcessedStanzasCounter: Counter of stanzas received by the client from the server.
  * Client is the source of truth of this value. It is the 'h' attribute in the 'a' sent from the client to
  * the server.
  * @private
  */
		_clientProcessedStanzasCounter: null,

		/**
  * @property {Integer} _clientSentStanzasCounter
  * @private
  */
		_clientSentStanzasCounter: null,

		/**
  * Stores a reference to Strophe connection xmlOutput function to wrap counting functionality.
  * @method _originalXMLOutput
  * @type {Handler}
  * @private
  */
		_originalXMLOutput: null,

		/**
  * @property {Handler} _requestHandler: Stores reference to handler that process count request from server.
  * @private
  */
		_requestHandler: null,

		/**
  * @property {Handler} _incomingHandler: Stores reference to handler that processes incoming stanzas count.
  * @private
  */
		_incomingHandler: null,

		/**
  * @property {Integer} _requestResponseIntervalCount: Counts sent stanzas since last response request.
  */
		_requestResponseIntervalCount: 0,

		/**
  * @property {Queue} _unacknowledgedStanzas: Maintains a list of packet ids for stanzas which have yet to be acknowledged.
  */
		_unacknowledgedStanzas: [],

		/**
  * @property {Array} _acknowledgedStanzaListeners: Stores callbacks for each stanza acknowledged by the server.
  * Provides the packet id of the stanza as a parameter.
  * @private
  */
		_acknowledgedStanzaListeners: [],

		addAcknowledgedStanzaListener: function addAcknowledgedStanzaListener(listener) {
			this._acknowledgedStanzaListeners.push(listener);
		},

		enable: function enable() {
			this._c.send(strophe_js.$build('enable', { xmlns: this._NS, resume: false }));
			this._c.flush();
			this._c.pause();
		},

		requestAcknowledgement: function requestAcknowledgement() {
			this._requestResponseIntervalCount = 0;
			this._c.send(strophe_js.$build('r', { xmlns: this._NS }));
		},

		getOutgoingCounter: function getOutgoingCounter() {
			return this._clientSentStanzasCounter;
		},

		getIncomingCounter: function getIncomingCounter() {
			return this._clientProcessedStanzasCounter;
		},

		init: function init(conn) {
			console.info('INIT CONN MANAGEMENT', conn);
			this._c = conn;
			strophe_js.Strophe.addNamespace('SM', this._NS);

			// Storing original xmlOutput function to use additional logic
			this._originalXMLOutput = this._c.xmlOutput;
			this._c.xmlOutput = this.xmlOutput.bind(this);
		},

		statusChanged: function statusChanged(status) {
			if (status === strophe_js.Strophe.Status.CONNECTED || status === strophe_js.Strophe.Status.DISCONNECTED) {

				this._serverProcesssedStanzasCounter = 0;
				this._clientProcessedStanzasCounter = 0;

				this._clientSentStanzasCounter = 0;

				this._isStreamManagementEnabled = false;
				this._requestResponseIntervalCount = 0;

				this._unacknowledgedStanzas = [];

				if (this._requestHandler) {
					this._c.deleteHandler(this._requestHandler);
				}

				if (this._incomingHandler) {
					this._c.deleteHandler(this._incomingHandler);
				}

				this._requestHandler = this._c.addHandler(this._handleServerRequestHandler.bind(this), this._NS, 'r');
				this._incomingHandler = this._c.addHandler(this._incomingStanzaHandler.bind(this));
			}
		},

		/**
  * This method overrides the send method implemented by Strophe.Connection
  * to count outgoing stanzas
  *
  * @method Send
  * @public
  */
		xmlOutput: function xmlOutput(elem) {
			if (strophe_js.Strophe.isTagEqual(elem, 'iq') || strophe_js.Strophe.isTagEqual(elem, 'presence') || strophe_js.Strophe.isTagEqual(elem, 'message')) {
				this._increaseSentStanzasCounter(elem);
			}

			return this._originalXMLOutput.call(this._c, elem);
		},

		_incomingStanzaHandler: function _incomingStanzaHandler(elem) {
			if (strophe_js.Strophe.isTagEqual(elem, 'enabled') && elem.getAttribute('xmlns') === this._NS) {
				this._isStreamManagementEnabled = true;
				this._c.resume();
			}

			if (strophe_js.Strophe.isTagEqual(elem, 'iq') || strophe_js.Strophe.isTagEqual(elem, 'presence') || strophe_js.Strophe.isTagEqual(elem, 'message')) {
				this._increaseReceivedStanzasCounter();

				if (this.autoSendCountOnEveryIncomingStanza) {
					this._answerProcessedStanzas();
				}
			}

			if (strophe_js.Strophe.isTagEqual(elem, 'a')) {
				var handledCount = parseInt(elem.getAttribute('h'));
				this._handleAcknowledgedStanzas(handledCount, this._serverProcesssedStanzasCounter);
				this._serverProcesssedStanzasCounter = handledCount;

				if (this.requestResponseInterval > 0) {
					this._requestResponseIntervalCount = 0;
				}

				if (typeof this.onAcknowledgementComplete === 'function') {
					if (!this.onAcknowledgementComplete()) {
						this.onAcknowledgementComplete = null;
					}
				}
			}

			return true;
		},

		_handleAcknowledgedStanzas: function _handleAcknowledgedStanzas(reportedHandledCount, lastKnownHandledCount) {
			var delta = reportedHandledCount - lastKnownHandledCount;

			if (delta < 0) {
				this._throwError('New reported stanza count lower than previous. New: ' + reportedHandledCount + ' - Previous: ' + lastKnownHandledCount);
			}

			if (delta > this._unacknowledgedStanzas.length) {
				this._throwError('Higher reported acknowledge count than unacknowledged stanzas. Reported Acknowledge Count: ' + delta + ' - Unacknowledge Stanza Count: ' + this._unacknowledgedStanzas.length + ' - New: ' + reportedHandledCount + ' - Previous: ' + lastKnownHandledCount);
			}

			for (var i = 0; i < delta; i++) {
				var stanza = this._unacknowledgedStanzas.shift();
				for (var j = 0; j < this._acknowledgedStanzaListeners.length; j++) {
					this._acknowledgedStanzaListeners[j](stanza);
				}
			}

			if (this.logging && this._unacknowledgedStanzas.length > 0) {
				console.warn('Unacknowledged stanzas', this._unacknowledgedStanzas);
			}
		},

		_handleServerRequestHandler: function _handleServerRequestHandler() {
			this._answerProcessedStanzas();
			return true;
		},

		_answerProcessedStanzas: function _answerProcessedStanzas() {
			if (this._isStreamManagementEnabled) {
				this._c.send(strophe_js.$build('a', { xmlns: this._NS, h: this._clientProcessedStanzasCounter }));
			}
		},

		_increaseSentStanzasCounter: function _increaseSentStanzasCounter(elem) {
			if (this._isStreamManagementEnabled) {
				this._unacknowledgedStanzas.push(this.returnWholeStanza ? elem : elem.getAttribute('id'));

				this._clientSentStanzasCounter++;

				if (this.requestResponseInterval > 0) {
					this._requestResponseIntervalCount++;

					if (this._requestResponseIntervalCount === this.requestResponseInterval) {
						this.requestAcknowledgement();
					}
				}
			}
		},

		_increaseReceivedStanzasCounter: function _increaseReceivedStanzasCounter() {
			if (this._isStreamManagementEnabled) {
				this._clientProcessedStanzasCounter++;
			}
		},

		_throwError: function _throwError(msg) {
			console.error(msg);
			throw new Error(msg);
		}

	});

	console.info('REGISTERED STREAM MANAGEMENT PLUGIN');
});
//# sourceMappingURL=strophe.stream-management.js.map

/***/ }),

/***/ "QXNG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),

/***/ "Qxat":
/***/ (function(module, exports) {

exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText",
    ITEM_PROP: "itemprop"
};

var PREACT_TAG_MAP = exports.PREACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "class": "className"
};

/***/ }),

/***/ "QyBi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c84ff937cd309c223ee886caa5b7894a.png";

/***/ }),

/***/ "R6c1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("6MLN") && !__webpack_require__("wLcK")(function () {
  return Object.defineProperty(__webpack_require__("9kxq")('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "RA6A":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("rtOw");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function get() {
      return 7;
    } })[1] != 7;
});

/***/ }),

/***/ "RBnT":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var isConstructor = __webpack_require__("E2GX");
var tryToString = __webpack_require__("HXaG");

var TypeError = global.TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};

/***/ }),

/***/ "RDCy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "db9b21a1c41f3dcd9731e1e7acfdbb57.png";

/***/ }),

/***/ "RGc6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__("N2wP");

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement('div', _extends({}, newProps, { ref: function ref(el) {
          _this2.props.parentBindings.domNode = el;
        } }), this.props.children);
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),

/***/ "Rk1v":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("JOB+");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

/***/ }),

/***/ "S6J3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__("jNGL");

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),

/***/ "S7IM":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("MpYs");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "SN69":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "SNRl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__("IJ/8");
var apply = __webpack_require__("dNrY");
var uncurryThis = __webpack_require__("PoOm");
var isCallable = __webpack_require__("yeFe");
var getOwnPropertyDescriptor = __webpack_require__("HtdO").f;
var isForced = __webpack_require__("0/Oh");
var path = __webpack_require__("iXvo");
var bind = __webpack_require__("1PPX");
var createNonEnumerableProperty = __webpack_require__("yNEm");
var hasOwn = __webpack_require__("J3pj");

var wrapConstructor = function wrapConstructor(NativeConstructor) {
  var Wrapper = function Wrapper(a, b, c) {
    if (this instanceof Wrapper) {
      switch (arguments.length) {
        case 0:
          return new NativeConstructor();
        case 1:
          return new NativeConstructor(a);
        case 2:
          return new NativeConstructor(a, b);
      }return new NativeConstructor(a, b, c);
    }return apply(NativeConstructor, this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : (global[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || createNonEnumerableProperty(path, TARGET, {})[TARGET];
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && hasOwn(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
      // make static versions for prototype methods
      else if (PROTO && isCallable(sourceProperty)) resultProperty = uncurryThis(sourceProperty);
        // default case
        else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    createNonEnumerableProperty(target, key, resultProperty);

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!hasOwn(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      createNonEnumerableProperty(path[VIRTUAL_PROTOTYPE], key, sourceProperty);
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};

/***/ }),

/***/ "SWjV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__("lkHq");

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),

/***/ "SYGT":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("upEt");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};

/***/ }),

/***/ "ShN9":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "SmHd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"callComponent":"callComponent__3nFPz","title":"title__2a3qB","name":"name__1mNZk","descr":"descr__ndGJF","avatar":"avatar__336Li","btnArea":"btnArea__2KEHh","btn":"btn__gazae","btnText":"btnText__1Qpxv","btnImg":"btnImg__3nxQe"};

/***/ }),

/***/ "Ss7l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("T4f3");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("zCAL");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("eW0v");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _autoPrefix = __webpack_require__("Z55K");

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__("KQdW");

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var ScaleInChild = function (_Component) {
  (0, _inherits3.default)(ScaleInChild, _Component);

  function ScaleInChild() {
    (0, _classCallCheck3.default)(this, ScaleInChild);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleInChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');

      this.leaveTimer = setTimeout(callback, 450);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '1';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');

      this.enterTimer = setTimeout(callback, this.props.enterDelay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
      }, style);

      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }), children);
    }
  }]);
  return ScaleInChild;
}(_react.Component);

ScaleInChild.defaultProps = {
  enterDelay: 0,
  maxScale: 1,
  minScale: 0
};
ScaleInChild.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleInChild.propTypes =  false ? {
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = ScaleInChild;

/***/ }),

/***/ "T2os":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};

var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function get() {
    return defaultMaxListeners;
  },
  set: function set(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function () {

  if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) {
    args.push(arguments[i]);
  }var doError = type === 'error';

  var events = this._events;
  if (events !== undefined) doError = doError && events.error === undefined;else if (!doError) return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0) er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined) return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) {
      ReflectApply(listeners[i], this, args);
    }
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0) return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;

  checkListener(listener);

  events = this._events;
  if (events === undefined) return this;

  list = events[type];
  if (list === undefined) return this;

  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0) this._events = Object.create(null);else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;

    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (position === 0) list.shift();else {
      spliceOne(list, position);
    }

    if (list.length === 1) events[type] = list[0];

    if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
  }

  return this;
};

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events, i;

  events = this._events;
  if (events === undefined) return this;

  // not listening for removeListener, no need to emit
  if (events.removeListener === undefined) {
    if (arguments.length === 0) {
      this._events = Object.create(null);
      this._eventsCount = 0;
    } else if (events[type] !== undefined) {
      if (--this._eventsCount === 0) this._events = Object.create(null);else delete events[type];
    }
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    var keys = Object.keys(events);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = Object.create(null);
    this._eventsCount = 0;
    return this;
  }

  listeners = events[type];

  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners !== undefined) {
    // LIFO order
    for (i = listeners.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners[i]);
    }
  }

  return this;
};

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined) return [];

  var evlistener = events[type];
  if (evlistener === undefined) return [];

  if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i) {
    copy[i] = arr[i];
  }return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++) {
    list[index] = list[index + 1];
  }list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

/***/ }),

/***/ "T4f3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("gc0D");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "T65i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var hoistNonReactStatic = __webpack_require__("niIn");
var React = __webpack_require__("eW0v");
var ReactDOM = __webpack_require__("eW0v");

module.exports = function enhanceWithClickOutside(WrappedComponent) {
  var componentName = WrappedComponent.displayName || WrappedComponent.name;

  var EnhancedComponent = function (_React$Component) {
    _inherits(EnhancedComponent, _React$Component);

    function EnhancedComponent(props) {
      _classCallCheck(this, EnhancedComponent);

      var _this = _possibleConstructorReturn(this, (EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).call(this, props));

      _this.handleClickOutside = _this.handleClickOutside.bind(_this);
      return _this;
    }

    _createClass(EnhancedComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: 'handleClickOutside',
      value: function handleClickOutside(e) {
        var domNode = this.__domNode;
        if ((!domNode || !domNode.contains(e.target)) && this.__wrappedInstance && typeof this.__wrappedInstance.handleClickOutside === 'function') {
          this.__wrappedInstance.handleClickOutside(e);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            wrappedRef = _props.wrappedRef,
            rest = _objectWithoutProperties(_props, ['wrappedRef']);

        return React.createElement(WrappedComponent, _extends({}, rest, {
          ref: function ref(c) {
            _this2.__wrappedInstance = c;
            _this2.__domNode = ReactDOM.findDOMNode(c);
            wrappedRef && wrappedRef(c);
          }
        }));
      }
    }]);

    return EnhancedComponent;
  }(React.Component);

  EnhancedComponent.displayName = 'clickOutside(' + componentName + ')';

  return hoistNonReactStatic(EnhancedComponent, WrappedComponent);
};

/***/ }),

/***/ "T9dW":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("J3pj");
var ownKeys = __webpack_require__("H+qL");
var getOwnPropertyDescriptorModule = __webpack_require__("HtdO");
var definePropertyModule = __webpack_require__("y7Dx");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

/***/ }),

/***/ "T9hV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__("lkHq");

var _utils = __webpack_require__("yd8v");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),

/***/ "TNJq":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("zotD");
var dPs = __webpack_require__("gjjs");
var enumBugKeys = __webpack_require__("KxjL");
var IE_PROTO = __webpack_require__("/wuY")('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("9kxq")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("ebIA").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),

/***/ "TOx8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TUng":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),

/***/ "TyWm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("4md/");

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};

/***/ }),

/***/ "U72i":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "U7BB":
/***/ (function(module, exports, __webpack_require__) {

var createElement = __webpack_require__("eW0v").createElement;

var pageProtocol = typeof location === 'undefined' ? '' : location.protocol === 'https:' ? 'https:' : 'http:';

var emojiStyle = {
	height: '1em',
	width: '1em',
	margin: '0 .05em 0 .1em',
	verticalAlign: '-0.1em'

	// Accept protocol with or without a colon
};function normalizeProtocol(protocol) {
	if (protocol && protocol.length > 0 && protocol.charAt(protocol.length - 1) !== ':') {
		return protocol + ':';
	}
	return protocol;
}

module.exports = function makeTwemojiRenderer(options) {
	options = merge({
		protocol: pageProtocol,
		baseUrl: '//twemoji.maxcdn.com/2/',
		size: '72x72',
		ext: '.png',
		props: null
	}, options);

	return function renderTwemoji(icon, match, offset) {
		var src = '';
		if (options.baseUrl.indexOf('http') !== 0) {
			src += normalizeProtocol(options.protocol);
		}

		src += options.baseUrl + options.size + '/' + icon + options.ext;

		return createElement('img', merge({
			key: offset,
			alt: match,
			draggable: false,
			src: src,
			style: emojiStyle
		}, options.props));
	};
};

function merge() {
	var out = {},
	    len = arguments.length;
	for (var i = 0; i < len; ++i) {
		var source = arguments[i];
		if (source) {
			for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					out[key] = source[key];
				}
			}
		}
	}
	return out;
}

/***/ }),

/***/ "U8F3":
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__("t2zx");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "UCHH":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");
var arraySlice = __webpack_require__("CQhq");

var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var join = uncurryThis([].join);

var TEST = function (arg) {
  return String(Error(arg).stack);
}('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
var IS_FIREFOX_OR_SAFARI_STACK = /@[^\n]*\n/.test(TEST) && !/zxcasd/.test(TEST);

module.exports = function (stack, dropEntries) {
  if (typeof stack != 'string') return stack;
  if (IS_V8_OR_CHAKRA_STACK) {
    while (dropEntries--) {
      stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
    }
  } else if (IS_FIREFOX_OR_SAFARI_STACK) {
    return join(arraySlice(split(stack, '\n'), dropEntries), '\n');
  }return stack;
};

/***/ }),

/***/ "UCMn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarBody = undefined;

var _extends2 = __webpack_require__("T4f3");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("zCAL");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__("KQdW");

var _transitions2 = _interopRequireDefault(_transitions);

var _withWidth = __webpack_require__("Ouhw");

var _withWidth2 = _interopRequireDefault(_withWidth);

var _FlatButton = __webpack_require__("FcUr");

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getStyles(props, context) {
  var open = props.open,
      width = props.width;
  var _context$muiTheme = context.muiTheme,
      _context$muiTheme$bas = _context$muiTheme.baseTheme,
      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
      desktopGutter = _context$muiTheme$bas2.desktopGutter,
      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
      fontFamily = _context$muiTheme$bas.fontFamily,
      _context$muiTheme$sna = _context$muiTheme.snackbar,
      backgroundColor = _context$muiTheme$sna.backgroundColor,
      textColor = _context$muiTheme$sna.textColor,
      actionColor = _context$muiTheme$sna.actionColor,
      borderRadius = _context$muiTheme.borderRadius;

  var isSmall = width === _withWidth.SMALL;

  var styles = {
    root: {
      fontFamily: fontFamily,
      backgroundColor: backgroundColor,
      padding: '0 ' + desktopGutter + 'px',
      height: desktopSubheaderHeight,
      lineHeight: desktopSubheaderHeight + 'px',
      borderRadius: isSmall ? 0 : borderRadius,
      maxWidth: isSmall ? 'inherit' : 568,
      minWidth: isSmall ? 'inherit' : 288,
      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
      flexGrow: isSmall ? 1 : 0
    },
    content: {
      fontSize: 14,
      color: textColor,
      opacity: open ? 1 : 0,
      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
    },
    action: {
      color: actionColor,
      float: 'right',
      marginTop: 6,
      marginRight: -16,
      marginLeft: desktopGutter,
      backgroundColor: 'transparent'
    }
  };

  return styles;
}

var SnackbarBody = function SnackbarBody(props, context) {
  var action = props.action,
      contentStyle = props.contentStyle,
      message = props.message,
      open = props.open,
      onActionClick = props.onActionClick,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionClick', 'style']);
  var prepareStyles = context.muiTheme.prepareStyles;

  var styles = getStyles(props, context);

  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
    style: styles.action,
    label: action,
    onClick: onActionClick
  });

  return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }), _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) }, _react2.default.createElement('span', null, message), actionButton));
};

exports.SnackbarBody = SnackbarBody;
SnackbarBody.propTypes =  false ? {
  /**
   * The label for the action on the snackbar.
   */
  action: _propTypes2.default.node,
  /**
   * Override the inline-styles of the content element.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _propTypes2.default.node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _propTypes2.default.func,
  /**
   * @ignore
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   * Width of the screen.
   */
  width: _propTypes2.default.number.isRequired
} : {};

SnackbarBody.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ }),

/***/ "UJE0":
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "UKR9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);

/***/ }),

/***/ "UNYT":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};

/***/ }),

/***/ "UU8C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__("ee02");

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__("TUng");

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__("Z54K");

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__("Vrbh");

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),

/***/ "Ug9I":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("NB7d")('wks');
var uid = __webpack_require__("X6va");
var Symbol = __webpack_require__("i1Q6").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ "V2hq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/***/ }),

/***/ "V9pB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = create;
function create(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _extends({}, state, partial);
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);

    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ }),

/***/ "VJX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isProtectedDayOfYearToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = isProtectedWeekYearToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

/***/ }),

/***/ "VN+O":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");

module.exports = uncurryThis({}.isPrototypeOf);

/***/ }),

/***/ "VOrx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("GyB/");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "VYL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ "VaGT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.connect = exports.Provider = undefined;

var _Provider2 = __webpack_require__("PlPR");

var _Provider3 = _interopRequireDefault(_Provider2);

var _connect2 = __webpack_require__("zKbo");

var _connect3 = _interopRequireDefault(_connect2);

var _create2 = __webpack_require__("V9pB");

var _create3 = _interopRequireDefault(_create2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.Provider = _Provider3.default;
exports.connect = _connect3.default;
exports.create = _create3.default;

/***/ }),

/***/ "VmVQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TO_STRING_TAG_SUPPORT = __webpack_require__("5VJ8");
var classof = __webpack_require__("0guB");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

/***/ }),

/***/ "Vqdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FireBase = (_temp = _class = function () {
  function FireBase() {
    _classCallCheck(this, FireBase);
  }

  FireBase.initialise = function initialise() {
    /**
     * @property {{ analytics: Function, initializeApp: Function }} firebase
     */
    firebase.initializeApp({
      apiKey: "AIzaSyDu3aPFhhnIgpXS-BSFuj1b8g28tHOJgdo",
      authDomain: "telmie-19617.firebaseapp.com",
      databaseURL: "https://telmie-19617.firebaseio.com",
      projectId: "telmie-19617",
      storageBucket: "telmie-dev-1559300782366.appspot.com",
      messagingSenderId: "624998553774",
      appId: "1:624998553774:web:e4bf28712402a74bd2753f",
      measurementId: "G-FEKCFT7MJT"
    });

    firebase.analytics();
  };

  /**
   *
   * @param {string} eventType
   * @param {Object} [eventParams]
   */


  FireBase.logEvent = function logEvent(eventType, eventParams) {
    try {
      /**
       * @property {{ analytics: Function }} firebase
       */
      window.firebase.analytics().logEvent(eventType, eventParams);
    } catch (error) {
      throw new Error('Firebase event "' + eventType + '" isn\'t processed!');
    }
  };

  FireBase.setUserId = function setUserId(id) {
    try {
      /**
       * @property {{ analytics: Function }} firebase
       */
      window.firebase.analytics().setUserId(id);
    } catch (error) {
      throw new Error('Firebase cannot set user id \'' + id + '\'');
    }
  };

  return FireBase;
}(), _class.EVENTS = {
  FIRST_LOGIN: 'First_Login',
  PURCHASE: 'Purchase',
  SUCCESS_CARD_TOP_UP: 'Success_Card_Top_Up',
  SUCCESS_SAVED_CARD_TOP_UP: 'Success_Saved_Card_Top_Up',
  TAP_ON_ANY_PRO_IN_FIND_PRO: 'Tap_on_any_Pro_in_Find_a_Pro',
  TAP_SIGN_IN: 'Tap_Sign_in'
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (FireBase);

/***/ }),

/***/ "Vrbh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),

/***/ "VuZO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("O35A"), __esModule: true };

/***/ }),

/***/ "Vwb2":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");
var toIntegerOrInfinity = __webpack_require__("JOB+");
var toString = __webpack_require__("NyfM");
var requireObjectCoercible = __webpack_require__("7CnU");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function createMethod(CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

/***/ }),

/***/ "VxKF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__("ywQn");
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function isFunction(fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) {
			// jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) {
		/* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function defineProperty(object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function defineProperties(object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;

/***/ }),

/***/ "W9kG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["a"] = (longFormatters);

/***/ }),

/***/ "WL61":
/***/ (function(module, exports) {

// Inspiration: https://github.com/facebook/react/issues/3386

function replace(string, regexpOrSubstr, newValueOrFn, globalOffset) {
	if (typeof string !== 'string') throw new Error('First param must be a string');
	if (typeof regexpOrSubstr !== 'string' && !(regexpOrSubstr instanceof RegExp)) throw new Error('Second param must be a string pattern or a regular expression');

	var fn = typeof regexpOrSubstr === 'string' ? replaceUsingString : replaceUsingRegexp;

	return fn(string, regexpOrSubstr, newValueOrFn, globalOffset);
}

function replaceUsingString(string, patternString, newValueOrFn, globalOffset) {
	var index = string.indexOf(patternString);

	if (index >= 0) {
		var arr = [];
		var endIndex = index + patternString.length;

		if (index > 0) {
			arr.push(string.substring(0, index));
		}

		arr.push(typeof newValueOrFn === 'function' ? newValueOrFn(string.substring(index, endIndex), index + globalOffset, string) : newValueOrFn);

		if (endIndex < string.length) {
			arr.push(string.substring(endIndex));
		}

		return arr;
	} else {
		return [string];
	}
}

function replaceUsingRegexp(string, regexp, newValueOrFn, globalOffset) {
	var output = [];

	var replacerIsFn = typeof newValueOrFn === 'function';

	var storedLastIndex = regexp.lastIndex;
	regexp.lastIndex = 0;

	var result;
	var lastIndex = 0;
	while (result = regexp.exec(string)) {
		var index = result.index;

		if (result[0] === '') {
			// When the regexp is an empty string
			// we still want to advance our cursor to the next item.
			// This is the behavior of String.replace.
			regexp.lastIndex++;
		}

		if (index !== lastIndex) {
			output.push(string.substring(lastIndex, index));
		}

		var match = result[0];
		lastIndex = index + match.length;

		var out = replacerIsFn ? newValueOrFn.apply(this, result.concat(index + globalOffset, result.input)) : newValueOrFn;
		output.push(out);

		if (!regexp.global) {
			break;
		}
	}

	if (lastIndex < string.length) {
		output.push(string.substring(lastIndex));
	}

	regexp.lastIndex = storedLastIndex;
	return output;
}

module.exports = function stringReplaceToArray(stringOrArray, regexpOrSubstr, newSubStrOrFn) {
	if (typeof stringOrArray === 'string') {
		return replace(stringOrArray, regexpOrSubstr, newSubStrOrFn, 0);
	} else if (!Array.isArray(stringOrArray) || !stringOrArray[0]) {
		throw new TypeError('First argument must be an array or non-empty string');
	} else {
		var len = stringOrArray.length;
		var output = [];
		var globalOffset = 0;
		for (var i = 0; i < len; ++i) {
			var arrayItem = stringOrArray[i];
			if (typeof arrayItem === 'string') {
				output.push.apply(output, replace(arrayItem, regexpOrSubstr, newSubStrOrFn, globalOffset));
				globalOffset += arrayItem.length;
			} else {
				output.push(arrayItem);
			}
		}
		return output;
	}
};

/***/ }),

/***/ "WMuu":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("qvVx");

module.exports = getBuiltIn('navigator', 'userAgent') || '';

/***/ }),

/***/ "WNaj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isDate_index_js__ = __webpack_require__("tU9A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isDate_index_js__["a" /* default */])(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ "WQDn":
/***/ (function(module, exports, __webpack_require__) {

var WildEmitter = __webpack_require__("GZ/G");

function getMaxVolume(analyser, fftBins) {
  var maxVolume = -Infinity;
  analyser.getFloatFrequencyData(fftBins);

  for (var i = 4, ii = fftBins.length; i < ii; i++) {
    if (fftBins[i] > maxVolume && fftBins[i] < 0) {
      maxVolume = fftBins[i];
    }
  };

  return maxVolume;
}

var audioContextType = window.AudioContext || window.webkitAudioContext;
// use a single audio context due to hardware limits
var audioContext = null;
module.exports = function (stream, options) {
  var harker = new WildEmitter();

  // make it not break in non-supported browsers
  if (!audioContextType) return harker;

  //Config
  var options = options || {},
      smoothing = options.smoothing || 0.1,
      interval = options.interval || 50,
      threshold = options.threshold,
      play = options.play,
      history = options.history || 10,
      running = true;

  //Setup Audio Context
  if (!audioContext) {
    audioContext = new audioContextType();
  }
  var sourceNode, fftBins, analyser;

  analyser = audioContext.createAnalyser();
  analyser.fftSize = 512;
  analyser.smoothingTimeConstant = smoothing;
  fftBins = new Float32Array(analyser.fftSize);

  if (stream.jquery) stream = stream[0];
  if (stream instanceof HTMLAudioElement || stream instanceof HTMLVideoElement) {
    //Audio Tag
    sourceNode = audioContext.createMediaElementSource(stream);
    if (typeof play === 'undefined') play = true;
    threshold = threshold || -50;
  } else {
    //WebRTC Stream
    sourceNode = audioContext.createMediaStreamSource(stream);
    threshold = threshold || -50;
  }

  sourceNode.connect(analyser);
  if (play) analyser.connect(audioContext.destination);

  harker.speaking = false;

  harker.setThreshold = function (t) {
    threshold = t;
  };

  harker.setInterval = function (i) {
    interval = i;
  };

  harker.stop = function () {
    running = false;
    harker.emit('volume_change', -100, threshold);
    if (harker.speaking) {
      harker.speaking = false;
      harker.emit('stopped_speaking');
    }
  };
  harker.speakingHistory = [];
  for (var i = 0; i < history; i++) {
    harker.speakingHistory.push(0);
  }

  // Poll the analyser node to determine if speaking
  // and emit events if changed
  var looper = function looper() {
    setTimeout(function () {

      //check if stop has been called
      if (!running) {
        return;
      }

      var currentVolume = getMaxVolume(analyser, fftBins);

      harker.emit('volume_change', currentVolume, threshold);

      var history = 0;
      if (currentVolume > threshold && !harker.speaking) {
        // trigger quickly, short history
        for (var i = harker.speakingHistory.length - 3; i < harker.speakingHistory.length; i++) {
          history += harker.speakingHistory[i];
        }
        if (history >= 2) {
          harker.speaking = true;
          harker.emit('speaking');
        }
      } else if (currentVolume < threshold && harker.speaking) {
        for (var i = 0; i < harker.speakingHistory.length; i++) {
          history += harker.speakingHistory[i];
        }
        if (history == 0) {
          harker.speaking = false;
          harker.emit('stopped_speaking');
        }
      }
      harker.speakingHistory.shift();
      harker.speakingHistory.push(0 + (currentVolume > threshold));

      looper();
    }, interval);
  };
  looper();

  return harker;
};

/***/ }),

/***/ "Wyka":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("E5Ce");
var defined = __webpack_require__("U72i");
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),

/***/ "X6va":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "XYJE":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

!function (e, t) {
   true ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(e.reduxLogger = e.reduxLogger || {});
}(this, function (e) {
  "use strict";
  function t(e, t) {
    e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } });
  }function r(e, t) {
    Object.defineProperty(this, "kind", { value: e, enumerable: !0 }), t && t.length && Object.defineProperty(this, "path", { value: t, enumerable: !0 });
  }function n(e, t, r) {
    n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", { value: t, enumerable: !0 }), Object.defineProperty(this, "rhs", { value: r, enumerable: !0 });
  }function o(e, t) {
    o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", { value: t, enumerable: !0 });
  }function i(e, t) {
    i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", { value: t, enumerable: !0 });
  }function a(e, t, r) {
    a.super_.call(this, "A", e), Object.defineProperty(this, "index", { value: t, enumerable: !0 }), Object.defineProperty(this, "item", { value: r, enumerable: !0 });
  }function f(e, t, r) {
    var n = e.slice((r || t) + 1 || e.length);return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
  }function u(e) {
    var t = "undefined" == typeof e ? "undefined" : N(e);return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
  }function l(e, t, r, c, s, d, p) {
    s = s || [], p = p || [];var g = s.slice(0);if ("undefined" != typeof d) {
      if (c) {
        if ("function" == typeof c && c(g, d)) return;if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
          if (c.prefilter && c.prefilter(g, d)) return;if (c.normalize) {
            var h = c.normalize(g, d, e, t);h && (e = h[0], t = h[1]);
          }
        }
      }g.push(d);
    }"regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());var y = "undefined" == typeof e ? "undefined" : N(e),
        v = "undefined" == typeof t ? "undefined" : N(t),
        b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d),
        m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);if (!b && m) r(new o(g, t));else if (!m && b) r(new i(g, e));else if (u(e) !== u(t)) r(new n(g, e, t));else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));else if ("object" === y && null !== e && null !== t) {
      if (p.filter(function (t) {
        return t.lhs === e;
      }).length) e !== t && r(new n(g, e, t));else {
        if (p.push({ lhs: e, rhs: t }), Array.isArray(e)) {
          var w;e.length;for (w = 0; w < e.length; w++) {
            w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
          }for (; w < t.length;) {
            r(new a(g, w, new o(void 0, t[w++])));
          }
        } else {
          var x = Object.keys(e),
              S = Object.keys(t);x.forEach(function (n, o) {
            var i = S.indexOf(n);i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
          }), S.forEach(function (e) {
            l(void 0, t[e], r, c, g, e, p);
          });
        }p.length = p.length - 1;
      }
    } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
  }function c(e, t, r, n) {
    return n = n || [], l(e, t, function (e) {
      e && n.push(e);
    }, r), n.length ? n : void 0;
  }function s(e, t, r) {
    if (r.path && r.path.length) {
      var n,
          o = e[t],
          i = r.path.length - 1;for (n = 0; n < i; n++) {
        o = o[r.path[n]];
      }switch (r.kind) {case "A":
          s(o[r.path[n]], r.index, r.item);break;case "D":
          delete o[r.path[n]];break;case "E":case "N":
          o[r.path[n]] = r.rhs;}
    } else switch (r.kind) {case "A":
        s(e[t], r.index, r.item);break;case "D":
        e = f(e, t);break;case "E":case "N":
        e[t] = r.rhs;}return e;
  }function d(e, t, r) {
    if (e && t && r && r.kind) {
      for (var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;) {
        "undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
      }switch (r.kind) {case "A":
          s(r.path ? n[r.path[o]] : n, r.index, r.item);break;case "D":
          delete n[r.path[o]];break;case "E":case "N":
          n[r.path[o]] = r.rhs;}
    }
  }function p(e, t, r) {
    if (r.path && r.path.length) {
      var n,
          o = e[t],
          i = r.path.length - 1;for (n = 0; n < i; n++) {
        o = o[r.path[n]];
      }switch (r.kind) {case "A":
          p(o[r.path[n]], r.index, r.item);break;case "D":
          o[r.path[n]] = r.lhs;break;case "E":
          o[r.path[n]] = r.lhs;break;case "N":
          delete o[r.path[n]];}
    } else switch (r.kind) {case "A":
        p(e[t], r.index, r.item);break;case "D":
        e[t] = r.lhs;break;case "E":
        e[t] = r.lhs;break;case "N":
        e = f(e, t);}return e;
  }function g(e, t, r) {
    if (e && t && r && r.kind) {
      var n,
          o,
          i = e;for (o = r.path.length - 1, n = 0; n < o; n++) {
        "undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
      }switch (r.kind) {case "A":
          p(i[r.path[n]], r.index, r.item);break;case "D":
          i[r.path[n]] = r.lhs;break;case "E":
          i[r.path[n]] = r.lhs;break;case "N":
          delete i[r.path[n]];}
    }
  }function h(e, t, r) {
    if (e && t) {
      var n = function n(_n) {
        r && !r(e, t, _n) || d(e, t, _n);
      };l(e, t, n);
    }
  }function y(e) {
    return "color: " + F[e].color + "; font-weight: bold";
  }function v(e) {
    var t = e.kind,
        r = e.path,
        n = e.lhs,
        o = e.rhs,
        i = e.index,
        a = e.item;switch (t) {case "E":
        return [r.join("."), n, "→", o];case "N":
        return [r.join("."), o];case "D":
        return [r.join(".")];case "A":
        return [r.join(".") + "[" + i + "]", a];default:
        return [];}
  }function b(e, t, r, n) {
    var o = c(e, t);try {
      n ? r.groupCollapsed("diff") : r.group("diff");
    } catch (e) {
      r.log("diff");
    }o ? o.forEach(function (e) {
      var t = e.kind,
          n = v(e);r.log.apply(r, ["%c " + F[t].text, y(t)].concat(P(n)));
    }) : r.log("—— no diff ——");try {
      r.groupEnd();
    } catch (e) {
      r.log("—— diff end —— ");
    }
  }function m(e, t, r, n) {
    switch ("undefined" == typeof e ? "undefined" : N(e)) {case "object":
        return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];case "function":
        return e(t);default:
        return e;}
  }function w(e) {
    var t = e.timestamp,
        r = e.duration;return function (e, n, o) {
      var i = ["action"];return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
    };
  }function x(e, t) {
    var r = t.logger,
        n = t.actionTransformer,
        o = t.titleFormatter,
        i = void 0 === o ? w(t) : o,
        a = t.collapsed,
        f = t.colors,
        u = t.level,
        l = t.diff,
        c = "undefined" == typeof t.titleFormatter;e.forEach(function (o, s) {
      var d = o.started,
          p = o.startedTime,
          g = o.action,
          h = o.prevState,
          y = o.error,
          v = o.took,
          w = o.nextState,
          x = e[s + 1];x && (w = x.prevState, v = x.started - d);var S = n(g),
          k = "function" == typeof a ? a(function () {
        return w;
      }, g, o) : a,
          j = D(p),
          E = f.title ? "color: " + f.title(S) + ";" : "",
          A = ["color: gray; font-weight: lighter;"];A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");var O = i(S, j, v);try {
        k ? f.title && c ? r.groupCollapsed.apply(r, ["%c " + O].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, ["%c " + O].concat(A)) : r.group(O);
      } catch (e) {
        r.log(O);
      }var N = m(u, S, [h], "prevState"),
          P = m(u, S, [S], "action"),
          C = m(u, S, [y, h], "error"),
          F = m(u, S, [w], "nextState");if (N) if (f.prevState) {
        var L = "color: " + f.prevState(h) + "; font-weight: bold";r[N]("%c prev state", L, h);
      } else r[N]("prev state", h);if (P) if (f.action) {
        var T = "color: " + f.action(S) + "; font-weight: bold";r[P]("%c action    ", T, S);
      } else r[P]("action    ", S);if (y && C) if (f.error) {
        var M = "color: " + f.error(y, h) + "; font-weight: bold;";r[C]("%c error     ", M, y);
      } else r[C]("error     ", y);if (F) if (f.nextState) {
        var _ = "color: " + f.nextState(w) + "; font-weight: bold";r[F]("%c next state", _, w);
      } else r[F]("next state", w);l && b(h, w, r, k);try {
        r.groupEnd();
      } catch (e) {
        r.log("—— log end ——");
      }
    });
  }function S() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = _extends({}, L, e),
        r = t.logger,
        n = t.stateTransformer,
        o = t.errorTransformer,
        i = t.predicate,
        a = t.logErrors,
        f = t.diffPredicate;if ("undefined" == typeof r) return function () {
      return function (e) {
        return function (t) {
          return e(t);
        };
      };
    };if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function () {
      return function (e) {
        return function (t) {
          return e(t);
        };
      };
    };var u = [];return function (e) {
      var r = e.getState;return function (e) {
        return function (l) {
          if ("function" == typeof i && !i(r, l)) return e(l);var c = {};u.push(c), c.started = O.now(), c.startedTime = new Date(), c.prevState = n(r()), c.action = l;var s = void 0;if (a) try {
            s = e(l);
          } catch (e) {
            c.error = o(e);
          } else s = e(l);c.took = O.now() - c.started, c.nextState = n(r());var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;if (x(u, _extends({}, t, { diff: d })), u.length = 0, c.error) throw c.error;return s;
        };
      };
    };
  }var k,
      j,
      E = function E(e, t) {
    return new Array(t + 1).join(e);
  },
      A = function A(e, t) {
    return E("0", t - e.toString().length) + e;
  },
      D = function D(e) {
    return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
  },
      O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date,
      N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      P = function P(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }return r;
    }return Array.from(e);
  },
      C = [];k = "object" === ("undefined" == typeof global ? "undefined" : N(global)) && global ? global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function () {
    "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
  }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, { diff: { value: c, enumerable: !0 }, observableDiff: { value: l, enumerable: !0 }, applyDiff: { value: h, enumerable: !0 }, applyChange: { value: d, enumerable: !0 }, revertChange: { value: g, enumerable: !0 }, isConflict: { value: function value() {
        return "undefined" != typeof j;
      }, enumerable: !0 }, noConflict: { value: function value() {
        return C && (C.forEach(function (e) {
          e();
        }), C = null), c;
      }, enumerable: !0 } });var F = { E: { color: "#2196F3", text: "CHANGED:" }, N: { color: "#4CAF50", text: "ADDED:" }, D: { color: "#F44336", text: "DELETED:" }, A: { color: "#2196F3", text: "ARRAY:" } },
      L = { level: "log", logger: console, logErrors: !0, collapsed: void 0, predicate: void 0, duration: !1, timestamp: !0, stateTransformer: function stateTransformer(e) {
      return e;
    }, actionTransformer: function actionTransformer(e) {
      return e;
    }, errorTransformer: function errorTransformer(e) {
      return e;
    }, colors: { title: function title() {
        return "inherit";
      }, prevState: function prevState() {
        return "#9E9E9E";
      }, action: function action() {
        return "#03A9F4";
      }, nextState: function nextState() {
        return "#4CAF50";
      }, error: function error() {
        return "#F20404";
      } }, diff: !1, diffPredicate: void 0, transformer: void 0 },
      T = function T() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.dispatch,
        r = e.getState;return "function" == typeof t || "function" == typeof r ? S()({ dispatch: t, getState: r }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
  };e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", { value: !0 });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "XZs+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loggedInUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return selectLoggedInUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return selectLoggedInUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return selectLoggedInUserAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return selectLoggedInUsersDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return selectLoggedInUserIsSupport; });
/* unused harmony export selectLoggedInUserIsPro */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return localeGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return locale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return selectLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return logInError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return registerSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return registerFailureMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return resetSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return resetFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return transactions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return verifySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return verifyFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return pendingActivation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return sendCodeFailureMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sendCodeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return verifyCodeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return verifyCodeFailureMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dataFromServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return sendContactMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return availability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return branchIo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return globalMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return badges; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("vyGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_consts__ = __webpack_require__("4PH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__application__ = __webpack_require__("s5UR");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var initialLoggedInUser = {
  loading: false,
  refreshFailed: false,
  refreshError: null
};
var loggedInUser = function loggedInUser() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _extends({}, initialLoggedInUser);
  var action = arguments[1];

  var user = void 0;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].LOG_IN_FAILURE:
      return _extends({}, state, {
        loading: false,
        refreshFailed: false,
        refreshError: null
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].LOG_IN:
      return _extends({}, state, {
        loading: true,
        refreshFailed: false,
        refreshError: null
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SIGN_IN_PUT_RESPONSE:
      {
        var _action$payload = action.payload,
            userAuth = _action$payload.userAuth,
            userData = _action$payload.userData;


        user = userData;
        user.userAuth = userAuth;

        return _extends({}, state, user, {
          loading: false,
          refreshFailed: false,
          refreshError: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].EDIT_SUCCESS:
      user = action.userData;
      user.userAuth = action.userAuth;
      return _extends({}, user);

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].EDIT_FAILURE:
      return _extends({}, state, {
        errorInUpdate: true
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].LOGGED_OFF:
      return {};

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].PHOTO_UPLOADED:
      return _extends({}, state, {
        avatar: action.photo,
        avatarUploadError: ''
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].PHOTO_UPLOAD_FAILURE:
      return _extends({}, state, {
        avatarUploadError: action.errorMsg
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].PHOTO_UPLOAD_CLEAR_STATUS:
      return _extends({}, state, {
        avatarUploadError: ''
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SET_STATE_SUCCESS:
      return _extends({}, state, {
        pro: state.pro ? _extends({}, state.pro, {
          proState: {
            proWork: action.payload.proWork,
            proHideProfile: action.payload.proHideProfile,
            proBookingAccept: action.payload.proBookingAccept
          }
        }) : null,
        state: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].UPDATE_USER_SETTINGS:
      return _extends({}, state, {
        userSettingsLoading: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].UPDATE_USER_SETTINGS_SUCCESS:
      return _extends({}, state, {
        userSettingsLoading: false
      }, action.payload);
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].UPDATE_USER_SETTINGS_FAILURE:
      return _extends({}, state, {
        userSettingsLoading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].REFRESH_LOGGED_IN_USER_DETAILS_SUCCESS:
      return _extends({}, state, action.payload, {
        refreshFailed: false,
        refreshError: null
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].REFRESH_LOGGED_IN_USER_DETAILS_FAILURE:
      return _extends({}, state, {
        refreshFailed: true,
        refreshError: action.error
      });
    default:
      return state;
  }
};

var selectLoggedInUser = function selectLoggedInUser(state) {
  return state.loggedInUser;
};

var selectLoggedInUserId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectLoggedInUser,
/**
 *
 * @param {{ id?: number }} loggedInUserState
 * @return {number || null}
 */
function (loggedInUserState) {
  return loggedInUserState.id || null;
});

var selectLoggedInUserAuth = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectLoggedInUser, function (loggedInUserState) {
  return loggedInUserState.userAuth;
});

var selectLoggedInUsersDevice = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectLoggedInUser, function (loggedInUserState) {
  return loggedInUserState.numericDeviceId;
});

var selectLoggedInUserIsSupport = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectLoggedInUserId, __WEBPACK_IMPORTED_MODULE_3__application__["l" /* selectApplicationUserSupportId */], function (loggedInUserId, userSupportId) {
  return loggedInUserId && loggedInUserId === userSupportId;
});

var selectLoggedInUserIsPro = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectLoggedInUser, function (loggedInUserState) {
  return loggedInUserState.pro !== null;
});

var localeGet = function localeGet() {
  var path = window.location.pathname.split('/')[1];
  return Object.keys(__WEBPACK_IMPORTED_MODULE_2__utils_consts__["G" /* langs */]).find(function (el) {
    return __WEBPACK_IMPORTED_MODULE_2__utils_consts__["G" /* langs */][el].code === path;
  }) || '';
};
var locale = function locale() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { locale: localeGet() || __WEBPACK_IMPORTED_MODULE_2__utils_consts__["g" /* EN */] };
  var action = arguments[1];
  var _action$lang = action.lang,
      lang = _action$lang === undefined ? __WEBPACK_IMPORTED_MODULE_2__utils_consts__["g" /* EN */] : _action$lang;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CHANGE_LOCALE:
      return _extends({}, state, {
        locale: lang
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CHANGE_LOCALE_LANGS:
      return _extends({}, state, {
        languages: action.langs
      });
    default:
      return state;
  }
};

var selectLocale = function selectLocale(state) {
  return state.locale.locale;
};

var logInError = function logInError() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].LOG_IN_FAILURE:
      return new Date().getTime();
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].LOG_IN_SUCCESS:
      return '';
    default:
      return state;
  }
};

var registerSuccess = function registerSuccess() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].REGISTER_SUCCESS:
      return true;
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].LOG_IN_SUCCESS:
      return true;
    default:
      return state;
  }
};
var registerFailureMessage = function registerFailureMessage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].REGISTER_FAILURE:
      return action.message != null ? action.message : '';

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].REGISTRATION_PENDING_ACTIVATION:
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].REGISTER_SUCCESS:
      return '';

    default:
      return state;
  }
};

var resetSuccess = function resetSuccess() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].RESET_SUCCESS:
      return true;

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_RESET:
      return false;

    default:
      return state;
  }
};
var resetFailure = function resetFailure() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].RESET_FAILURE:
      return action.message;

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_RESET:
      return '';

    default:
      return state;
  }
};

/* export const proCalls = (state = [], action) => {
  switch (action.type) {

    case actionTypes.PRO_CALLS_RECEIVED:
      return action.calls;

    default:
      return state;
  }
};
//
export const personalCalls = (state = [], action) => {
  switch (action.type) {

    case actionTypes.PERSONAL_CALLS_RECEIVED:
      return action.calls;

    default:
      return state;
  }
}; */

var activity = function activity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].PERSONAL_CALLS_RECEIVED:
      return _extends({}, state, {
        personCalls: action.calls.slice(0, 10)
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].PRO_CALLS_RECEIVED:
      return _extends({}, state, {
        proCalls: action.calls.slice(0, 10)
      });

    default:
      return state;
  }
};

var transactionsInitialState = {
  availableAmount: 0,
  transactions: [],
  total: 0,
  proBalance: 0,
  balance: 0,
  transactionId: '',
  added: 0,
  topUpLoading: false
};

var transactions = function transactions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _extends({}, transactionsInitialState);
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].TRANSACTIONS_RECEIVED:
      return _extends({}, state, {
        transactions: action.payload.results,
        total: action.payload.total,
        proBalance: action.payload.proBalance,
        balance: action.payload.balance,
        loading: false
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].WITHDRAW_RECEIVED:
      return _extends({}, state, {
        availableAmount: action.payload.availableAmount
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].RESET_TRANSACTIONS:
      return _extends({}, transactionsInitialState);
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GET_TRANSACTIONS:
      return _extends({}, state, {
        loading: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GET_TRANSACTIONS_FAILURE:
      return _extends({}, state, {
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GET_WITHDRAW_FAILURE:
      return _extends({}, state, {
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].TOP_UP_SUCCESS:
      return _extends({}, state, {
        balance: action.payload.telmieBalance,
        transactionId: action.payload.transactionId,
        added: action.payload.totalAddTelmie,
        status: action.payload.status,
        loading: false,
        topUpLoading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].TOP_UP_PENDING:
      return _extends({}, state, {
        pendingData: action.payload,
        status: action.payload.status,
        topUpLoading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].TOP_UP_FAILURE:
      return _extends({}, state, {
        topUpLoading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].TOP_UP:
      return _extends({}, state, {
        topUpLoading: true,
        status: ''
      });

    default:
      return state;
  }
};

var verifySuccess = function verifySuccess() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].VERIFY_SUCCESS:
      return true;
    default:
      return state;
  }
};
var verifyFailure = function verifyFailure() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].VERIFY_FAILURE:
      return true;

    default:
      return state;
  }
};

var pendingActivation = function pendingActivation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { pending: false };
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].REGISTRATION_PENDING_ACTIVATION:
      return _extends({}, state, {
        pending: action.payload
      });
    default:
      return state;
  }
};
var sendCodeFailureMessage = function sendCodeFailureMessage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_RESET:
      return '';

    default:
      return state;
  }
};

var sendCodeSuccess = function sendCodeSuccess() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_RESET:
      return '';

    default:
      return state;
  }
};

var verifyCodeSuccess = function verifyCodeSuccess() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_RESET:
      return false;

    default:
      return state;
  }
};

var verifyCodeFailureMessage = function verifyCodeFailureMessage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].FORGOT_PASSWORD_RESET:
      return '';

    default:
      return state;
  }
};

var dataFromServer = function dataFromServer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var newCategories = void 0;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SET_CATEGORIES:
      newCategories = action.categories.reduce(function (prevCategories, category) {
        var _extends2;

        return {
          categories: [].concat(prevCategories.categories, [category.name]),
          subCategories: _extends({}, prevCategories.subCategories, (_extends2 = {}, _extends2[category.name] = category.childs.map(function (categoryChild) {
            return categoryChild.name;
          }), _extends2))
        };
      }, { categories: [], subCategories: {} });

      return _extends({}, state, newCategories, {
        sectorsFullObject: action.categories
      });
    default:
      return state;
  }
};

var sendContactMessage = function sendContactMessage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { errorMsg: '', isSent: false };
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SEND_CONTACT_MESS:
      return _extends({}, state, {
        isSent: false,
        errorMsg: ''
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SEND_CONTACT_MESS_FAILURE:
      return _extends({}, state, {
        errorMsg: action.message != null ? action.message : ''
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SEND_CONTACT_MESS_SUCCESS:
      return _extends({}, state, {
        isSent: true,
        errorMsg: ''
      });
    default:
      return state;
  }
};

var initialAvailability = {
  loading: false
};

var availability = function availability() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _extends({}, initialAvailability);
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GET_AVAILABILITY:
      return _extends({}, state, {
        loading: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GET_AVAILABILITY_FAILURE:
      return _extends({}, state, {
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GET_AVAILABILITY_SUCCESS:
      return _extends({}, state, {
        loading: false,
        data: action.payload.results
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SET_AVAILABILITY:
      return _extends({}, state, {
        loading: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SET_AVAILABILITY_FAILURE:
      return _extends({}, state, {
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SET_AVAILABILITY_SUCCESS:
      return _extends({}, state, {
        loading: false,
        data: action.payload.results
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].UPDATE_AVAILABILITY:
      return _extends({}, state, {
        loading: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].UPDATE_AVAILABILITY_FAILURE:
      return _extends({}, state, {
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].UPDATE_AVAILABILITY_SUCCESS:
      return _extends({}, state, {
        loading: false,
        data: action.payload.results
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].DELETE_AVAILABILITY:
      return _extends({}, state, {
        loading: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].DELETE_AVAILABILITY_FAILURE:
      return _extends({}, state, {
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].DELETE_AVAILABILITY_SUCCESS:
      return _extends({}, state, {
        loading: false,
        data: action.payload.results
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].LOGGED_OFF:
      return _extends({}, initialAvailability);

    default:
      return state;
  }
};

var initialBranchIoState = {};

var branchIo = function branchIo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialBranchIoState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].BRANCH_IO_DATA:
      return _extends({}, state, {
        name: action.payload.name,
        value: action.payload.value
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GET_DEEP_LINK_SUCCESS:
      return _extends({}, state, {
        link: action.payload
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].LOGGED_OFF:
      return _extends({}, initialBranchIoState);
    default:
      return state;
  }
};

var globalMessage = function globalMessage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { message: '' };
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CREATE_CALL_ERROR:
      return {
        message: action.info
      };
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GLOBAL_MESSAGE:
      return {
        message: action.payload
      };

    default:
      return state;
  }
};

var redirect = function redirect() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { refId: '' };
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].SET_REDIRECT_LINK:
      return {
        refId: action.payload
      };
    default:
      return state;
  }
};

var badges = function badges() {
  var _extends3;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var userBadges = void 0;
  var data = void 0;
  var personInfo = void 0;
  var currentUser = void 0;
  var newTotalMissedCall = void 0;
  var newTotalMissedMessage = void 0;
  var updatedUser = void 0;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GET_BADGE_SUCCESS:
      userBadges = {};
      action.payload.badges.forEach(function (item) {
        userBadges[item.toUser.id] = item;
      });
      data = {
        totalMissedCall: action.payload.totalMissedCall,
        totalMissedMessage: action.payload.totalMissedMessage,
        badges: userBadges
      };
      return {
        data: data
      };
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CHANGE_UNREAD_MSG:
      personInfo = action.from.personInfo;
      currentUser = state.data.badges[personInfo.personID] || { missedCall: 0, missedMessage: 0 };
      newTotalMissedCall = state.data.totalMissedCall - currentUser.missedCall + personInfo.missedCallsCount;
      newTotalMissedMessage = state.data.totalMissedMessage - currentUser.missedMessage + personInfo.missedMessagesCount;
      updatedUser = {
        toID: personInfo.personID,
        missedCall: personInfo.missedCallsCount,
        missedMessage: personInfo.missedMessagesCount,
        toUser: currentUser.toUser || personInfo.toUser
      };
      return {
        data: _extends({}, state.data, {
          totalMissedCall: newTotalMissedCall,
          totalMissedMessage: newTotalMissedMessage,
          badges: _extends({}, state.data.badges, (_extends3 = {}, _extends3[updatedUser.toUser.id] = updatedUser, _extends3))
        })
      };
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].GET_BADGE_FAILURE:
      return {
        message: action.payload
      };

    default:
      return state;
  }
};

/***/ }),

/***/ "Xc0S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "237a7f3b2a5860f0fe098c80be9b0595.svg";

/***/ }),

/***/ "Xl3w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"radioGroup":"radioGroup__3eODV","leftSideBar":"leftSideBar__29AmY","wrapProDeatils":"wrapProDeatils__3BA2V","proDetailsApproved":"proDetailsApproved__lX7HZ","sideBarInWrapper":"sideBarInWrapper__2V7-3","sideBarTitle":"sideBarTitle__2Cyt-","options":"options__2iNiR","children":"children__2x_6p","switch":"switch__2QNz8","switchcell":"switchcell__1TmZL","redSwitch":"redSwitch__3NpPC","text":"text__3o6yv","footer":"footer__2a6iM"};

/***/ }),

/***/ "Xos8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("FFZn");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "Y+87":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

/***/ }),

/***/ "Y5Pa":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("1kal");
var isObject = __webpack_require__("FS7x");
var newPromiseCapability = __webpack_require__("JteQ");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),

/***/ "YD0x":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("vSO4");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("uj5A") });

/***/ }),

/***/ "YHvh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env node */


// SDP helpers.

var SDPUtils = {};

// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
SDPUtils.generateIdentifier = function () {
  return Math.random().toString(36).substr(2, 10);
};

// The RTCP CNAME used by all peerconnections from the same JS.
SDPUtils.localCName = SDPUtils.generateIdentifier();

// Splits SDP into lines, dealing with both CRLF and LF.
SDPUtils.splitLines = function (blob) {
  return blob.trim().split('\n').map(function (line) {
    return line.trim();
  });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
SDPUtils.splitSections = function (blob) {
  var parts = blob.split('\nm=');
  return parts.map(function (part, index) {
    return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
  });
};

// Returns the session description.
SDPUtils.getDescription = function (blob) {
  var sections = SDPUtils.splitSections(blob);
  return sections && sections[0];
};

// Returns the individual media sections.
SDPUtils.getMediaSections = function (blob) {
  var sections = SDPUtils.splitSections(blob);
  sections.shift();
  return sections;
};

// Returns lines that start with a certain prefix.
SDPUtils.matchPrefix = function (blob, prefix) {
  return SDPUtils.splitLines(blob).filter(function (line) {
    return line.indexOf(prefix) === 0;
  });
};

// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
// Input can be prefixed with a=.
SDPUtils.parseCandidate = function (line) {
  var parts = void 0;
  // Parse both variants.
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }

  var candidate = {
    foundation: parts[0],
    component: { 1: 'rtp', 2: 'rtcp' }[parts[1]] || parts[1],
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    address: parts[4], // address is an alias for ip.
    port: parseInt(parts[5], 10),
    // skip parts[6] == 'typ'
    type: parts[7]
  };

  for (var i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;
      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;
      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;
      case 'ufrag':
        candidate.ufrag = parts[i + 1]; // for backward compatibility.
        candidate.usernameFragment = parts[i + 1];
        break;
      default:
        // extension handling, in particular ufrag. Don't overwrite.
        if (candidate[parts[i]] === undefined) {
          candidate[parts[i]] = parts[i + 1];
        }
        break;
    }
  }
  return candidate;
};

// Translates a candidate object into SDP candidate attribute.
// This does not include the a= prefix!
SDPUtils.writeCandidate = function (candidate) {
  var sdp = [];
  sdp.push(candidate.foundation);

  var component = candidate.component;
  if (component === 'rtp') {
    sdp.push(1);
  } else if (component === 'rtcp') {
    sdp.push(2);
  } else {
    sdp.push(component);
  }
  sdp.push(candidate.protocol.toUpperCase());
  sdp.push(candidate.priority);
  sdp.push(candidate.address || candidate.ip);
  sdp.push(candidate.port);

  var type = candidate.type;
  sdp.push('typ');
  sdp.push(type);
  if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort) {
    sdp.push('raddr');
    sdp.push(candidate.relatedAddress);
    sdp.push('rport');
    sdp.push(candidate.relatedPort);
  }
  if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
    sdp.push('tcptype');
    sdp.push(candidate.tcpType);
  }
  if (candidate.usernameFragment || candidate.ufrag) {
    sdp.push('ufrag');
    sdp.push(candidate.usernameFragment || candidate.ufrag);
  }
  return 'candidate:' + sdp.join(' ');
};

// Parses an ice-options line, returns an array of option tags.
// Sample input:
// a=ice-options:foo bar
SDPUtils.parseIceOptions = function (line) {
  return line.substr(14).split(' ');
};

// Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
SDPUtils.parseRtpMap = function (line) {
  var parts = line.substr(9).split(' ');
  var parsed = {
    payloadType: parseInt(parts.shift(), 10) // was: id
  };

  parts = parts[0].split('/');

  parsed.name = parts[0];
  parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
  parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
  // legacy alias, got renamed back to channels in ORTC.
  parsed.numChannels = parsed.channels;
  return parsed;
};

// Generates a rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
SDPUtils.writeRtpMap = function (codec) {
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  var channels = codec.channels || codec.numChannels || 1;
  return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
};

// Parses a extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
SDPUtils.parseExtmap = function (line) {
  var parts = line.substr(9).split(' ');
  return {
    id: parseInt(parts[0], 10),
    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
    uri: parts[1]
  };
};

// Generates an extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
SDPUtils.writeExtmap = function (headerExtension) {
  return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + '\r\n';
};

// Parses a fmtp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
SDPUtils.parseFmtp = function (line) {
  var parsed = {};
  var kv = void 0;
  var parts = line.substr(line.indexOf(' ') + 1).split(';');
  for (var j = 0; j < parts.length; j++) {
    kv = parts[j].trim().split('=');
    parsed[kv[0].trim()] = kv[1];
  }
  return parsed;
};

// Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeFmtp = function (codec) {
  var line = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.parameters && Object.keys(codec.parameters).length) {
    var params = [];
    Object.keys(codec.parameters).forEach(function (param) {
      if (codec.parameters[param] !== undefined) {
        params.push(param + '=' + codec.parameters[param]);
      } else {
        params.push(param);
      }
    });
    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
  }
  return line;
};

// Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
SDPUtils.parseRtcpFb = function (line) {
  var parts = line.substr(line.indexOf(' ') + 1).split(' ');
  return {
    type: parts.shift(),
    parameter: parts.join(' ')
  };
};

// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeRtcpFb = function (codec) {
  var lines = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
    // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function (fb) {
      lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
    });
  }
  return lines;
};

// Parses a RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
SDPUtils.parseSsrcMedia = function (line) {
  var sp = line.indexOf(' ');
  var parts = {
    ssrc: parseInt(line.substr(7, sp - 7), 10)
  };
  var colon = line.indexOf(':', sp);
  if (colon > -1) {
    parts.attribute = line.substr(sp + 1, colon - sp - 1);
    parts.value = line.substr(colon + 1);
  } else {
    parts.attribute = line.substr(sp + 1);
  }
  return parts;
};

// Parse a ssrc-group line (see RFC 5576). Sample input:
// a=ssrc-group:semantics 12 34
SDPUtils.parseSsrcGroup = function (line) {
  var parts = line.substr(13).split(' ');
  return {
    semantics: parts.shift(),
    ssrcs: parts.map(function (ssrc) {
      return parseInt(ssrc, 10);
    })
  };
};

// Extracts the MID (RFC 5888) from a media section.
// Returns the MID or undefined if no mid line was found.
SDPUtils.getMid = function (mediaSection) {
  var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
  if (mid) {
    return mid.substr(6);
  }
};

// Parses a fingerprint line for DTLS-SRTP.
SDPUtils.parseFingerprint = function (line) {
  var parts = line.substr(14).split(' ');
  return {
    algorithm: parts[0].toLowerCase(), // algorithm is case-sensitive in Edge.
    value: parts[1].toUpperCase() // the definition is upper-case in RFC 4572.
  };
};

// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
SDPUtils.getDtlsParameters = function (mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:');
  // Note: a=setup line is ignored since we use the 'auto' role in Edge.
  return {
    role: 'auto',
    fingerprints: lines.map(SDPUtils.parseFingerprint)
  };
};

// Serializes DTLS parameters to SDP.
SDPUtils.writeDtlsParameters = function (params, setupType) {
  var sdp = 'a=setup:' + setupType + '\r\n';
  params.fingerprints.forEach(function (fp) {
    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
  });
  return sdp;
};

// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
SDPUtils.parseCryptoLine = function (line) {
  var parts = line.substr(9).split(' ');
  return {
    tag: parseInt(parts[0], 10),
    cryptoSuite: parts[1],
    keyParams: parts[2],
    sessionParams: parts.slice(3)
  };
};

SDPUtils.writeCryptoLine = function (parameters) {
  return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
};

// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
SDPUtils.parseCryptoKeyParams = function (keyParams) {
  if (keyParams.indexOf('inline:') !== 0) {
    return null;
  }
  var parts = keyParams.substr(7).split('|');
  return {
    keyMethod: 'inline',
    keySalt: parts[0],
    lifeTime: parts[1],
    mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
    mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
  };
};

SDPUtils.writeCryptoKeyParams = function (keyParams) {
  return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
};

// Extracts all SDES parameters.
SDPUtils.getCryptoParameters = function (mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
  return lines.map(SDPUtils.parseCryptoLine);
};

// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
SDPUtils.getIceParameters = function (mediaSection, sessionpart) {
  var ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
  var pwd = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];
  if (!(ufrag && pwd)) {
    return null;
  }
  return {
    usernameFragment: ufrag.substr(12),
    password: pwd.substr(10)
  };
};

// Serializes ICE parameters to SDP.
SDPUtils.writeIceParameters = function (params) {
  var sdp = 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
  if (params.iceLite) {
    sdp += 'a=ice-lite\r\n';
  }
  return sdp;
};

// Parses the SDP media section and returns RTCRtpParameters.
SDPUtils.parseRtpParameters = function (mediaSection) {
  var description = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: [],
    rtcp: []
  };
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  for (var i = 3; i < mline.length; i++) {
    // find all codecs from mline[3..]
    var pt = mline[i];
    var rtpmapline = SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];
    if (rtpmapline) {
      var codec = SDPUtils.parseRtpMap(rtpmapline);
      var fmtps = SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' ');
      // Only the first a=fmtp:<pt> is considered.
      codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
      codec.rtcpFeedback = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map(SDPUtils.parseRtcpFb);
      description.codecs.push(codec);
      // parse FEC mechanisms from rtpmap lines.
      switch (codec.name.toUpperCase()) {
        case 'RED':
        case 'ULPFEC':
          description.fecMechanisms.push(codec.name.toUpperCase());
          break;
        default:
          // only RED and ULPFEC are recognized as FEC mechanisms.
          break;
      }
    }
  }
  SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function (line) {
    description.headerExtensions.push(SDPUtils.parseExtmap(line));
  });
  // FIXME: parse rtcp.
  return description;
};

// Generates parts of the SDP media section describing the capabilities /
// parameters.
SDPUtils.writeRtpDescription = function (kind, caps) {
  var sdp = '';

  // Build the mline.
  sdp += 'm=' + kind + ' ';
  sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
  sdp += ' UDP/TLS/RTP/SAVPF ';
  sdp += caps.codecs.map(function (codec) {
    if (codec.preferredPayloadType !== undefined) {
      return codec.preferredPayloadType;
    }
    return codec.payloadType;
  }).join(' ') + '\r\n';

  sdp += 'c=IN IP4 0.0.0.0\r\n';
  sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';

  // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
  caps.codecs.forEach(function (codec) {
    sdp += SDPUtils.writeRtpMap(codec);
    sdp += SDPUtils.writeFmtp(codec);
    sdp += SDPUtils.writeRtcpFb(codec);
  });
  var maxptime = 0;
  caps.codecs.forEach(function (codec) {
    if (codec.maxptime > maxptime) {
      maxptime = codec.maxptime;
    }
  });
  if (maxptime > 0) {
    sdp += 'a=maxptime:' + maxptime + '\r\n';
  }

  if (caps.headerExtensions) {
    caps.headerExtensions.forEach(function (extension) {
      sdp += SDPUtils.writeExtmap(extension);
    });
  }
  // FIXME: write fecMechanisms.
  return sdp;
};

// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
SDPUtils.parseRtpEncodingParameters = function (mediaSection) {
  var encodingParameters = [];
  var description = SDPUtils.parseRtpParameters(mediaSection);
  var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
  var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;

  // filter a=ssrc:... cname:, ignore PlanB-msid
  var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function (line) {
    return SDPUtils.parseSsrcMedia(line);
  }).filter(function (parts) {
    return parts.attribute === 'cname';
  });
  var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
  var secondarySsrc = void 0;

  var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map(function (line) {
    var parts = line.substr(17).split(' ');
    return parts.map(function (part) {
      return parseInt(part, 10);
    });
  });
  if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
    secondarySsrc = flows[0][1];
  }

  description.codecs.forEach(function (codec) {
    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
      var encParam = {
        ssrc: primarySsrc,
        codecPayloadType: parseInt(codec.parameters.apt, 10)
      };
      if (primarySsrc && secondarySsrc) {
        encParam.rtx = { ssrc: secondarySsrc };
      }
      encodingParameters.push(encParam);
      if (hasRed) {
        encParam = JSON.parse(JSON.stringify(encParam));
        encParam.fec = {
          ssrc: primarySsrc,
          mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
        };
        encodingParameters.push(encParam);
      }
    }
  });
  if (encodingParameters.length === 0 && primarySsrc) {
    encodingParameters.push({
      ssrc: primarySsrc
    });
  }

  // we support both b=AS and b=TIAS but interpret AS as TIAS.
  var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
  if (bandwidth.length) {
    if (bandwidth[0].indexOf('b=TIAS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(7), 10);
    } else if (bandwidth[0].indexOf('b=AS:') === 0) {
      // use formula from JSEP to convert b=AS to TIAS value.
      bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95 - 50 * 40 * 8;
    } else {
      bandwidth = undefined;
    }
    encodingParameters.forEach(function (params) {
      params.maxBitrate = bandwidth;
    });
  }
  return encodingParameters;
};

// parses http://draft.ortc.org/#rtcrtcpparameters*
SDPUtils.parseRtcpParameters = function (mediaSection) {
  var rtcpParameters = {};

  // Gets the first SSRC. Note that with RTX there might be multiple
  // SSRCs.
  var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function (line) {
    return SDPUtils.parseSsrcMedia(line);
  }).filter(function (obj) {
    return obj.attribute === 'cname';
  })[0];
  if (remoteSsrc) {
    rtcpParameters.cname = remoteSsrc.value;
    rtcpParameters.ssrc = remoteSsrc.ssrc;
  }

  // Edge uses the compound attribute instead of reducedSize
  // compound is !reducedSize
  var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
  rtcpParameters.reducedSize = rsize.length > 0;
  rtcpParameters.compound = rsize.length === 0;

  // parses the rtcp-mux attrіbute.
  // Note that Edge does not support unmuxed RTCP.
  var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
  rtcpParameters.mux = mux.length > 0;

  return rtcpParameters;
};

SDPUtils.writeRtcpParameters = function (rtcpParameters) {
  var sdp = '';
  if (rtcpParameters.reducedSize) {
    sdp += 'a=rtcp-rsize\r\n';
  }
  if (rtcpParameters.mux) {
    sdp += 'a=rtcp-mux\r\n';
  }
  if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) {
    sdp += 'a=ssrc:' + rtcpParameters.ssrc + ' cname:' + rtcpParameters.cname + '\r\n';
  }
  return sdp;
};

// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
SDPUtils.parseMsid = function (mediaSection) {
  var parts = void 0;
  var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
  if (spec.length === 1) {
    parts = spec[0].substr(7).split(' ');
    return { stream: parts[0], track: parts[1] };
  }
  var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function (line) {
    return SDPUtils.parseSsrcMedia(line);
  }).filter(function (msidParts) {
    return msidParts.attribute === 'msid';
  });
  if (planB.length > 0) {
    parts = planB[0].value.split(' ');
    return { stream: parts[0], track: parts[1] };
  }
};

// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
SDPUtils.parseSctpDescription = function (mediaSection) {
  var mline = SDPUtils.parseMLine(mediaSection);
  var maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
  var maxMessageSize = void 0;
  if (maxSizeLine.length > 0) {
    maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
  }
  if (isNaN(maxMessageSize)) {
    maxMessageSize = 65536;
  }
  var sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
  if (sctpPort.length > 0) {
    return {
      port: parseInt(sctpPort[0].substr(12), 10),
      protocol: mline.fmt,
      maxMessageSize: maxMessageSize
    };
  }
  var sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
  if (sctpMapLines.length > 0) {
    var parts = sctpMapLines[0].substr(10).split(' ');
    return {
      port: parseInt(parts[0], 10),
      protocol: parts[1],
      maxMessageSize: maxMessageSize
    };
  }
};

// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
SDPUtils.writeSctpDescription = function (media, sctp) {
  var output = [];
  if (media.protocol !== 'DTLS/SCTP') {
    output = ['m=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n', 'c=IN IP4 0.0.0.0\r\n', 'a=sctp-port:' + sctp.port + '\r\n'];
  } else {
    output = ['m=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n', 'c=IN IP4 0.0.0.0\r\n', 'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'];
  }
  if (sctp.maxMessageSize !== undefined) {
    output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
  }
  return output.join('');
};

// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
SDPUtils.generateSessionId = function () {
  return Math.random().toString().substr(2, 21);
};

// Write boiler plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
SDPUtils.writeSessionBoilerplate = function (sessId, sessVer, sessUser) {
  var sessionId = void 0;
  var version = sessVer !== undefined ? sessVer : 2;
  if (sessId) {
    sessionId = sessId;
  } else {
    sessionId = SDPUtils.generateSessionId();
  }
  var user = sessUser || 'thisisadapterortc';
  // FIXME: sess-id should be an NTP timestamp.
  return 'v=0\r\n' + 'o=' + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
};

// Gets the direction from the mediaSection or the sessionpart.
SDPUtils.getDirection = function (mediaSection, sessionpart) {
  // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
  var lines = SDPUtils.splitLines(mediaSection);
  for (var i = 0; i < lines.length; i++) {
    switch (lines[i]) {
      case 'a=sendrecv':
      case 'a=sendonly':
      case 'a=recvonly':
      case 'a=inactive':
        return lines[i].substr(2);
      default:
      // FIXME: What should happen here?
    }
  }
  if (sessionpart) {
    return SDPUtils.getDirection(sessionpart);
  }
  return 'sendrecv';
};

SDPUtils.getKind = function (mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  return mline[0].substr(2);
};

SDPUtils.isRejected = function (mediaSection) {
  return mediaSection.split(' ', 2)[1] === '0';
};

SDPUtils.parseMLine = function (mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var parts = lines[0].substr(2).split(' ');
  return {
    kind: parts[0],
    port: parseInt(parts[1], 10),
    protocol: parts[2],
    fmt: parts.slice(3).join(' ')
  };
};

SDPUtils.parseOLine = function (mediaSection) {
  var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
  var parts = line.substr(2).split(' ');
  return {
    username: parts[0],
    sessionId: parts[1],
    sessionVersion: parseInt(parts[2], 10),
    netType: parts[3],
    addressType: parts[4],
    address: parts[5]
  };
};

// a very naive interpretation of a valid SDP.
SDPUtils.isValidSDP = function (blob) {
  if (typeof blob !== 'string' || blob.length === 0) {
    return false;
  }
  var lines = SDPUtils.splitLines(blob);
  for (var i = 0; i < lines.length; i++) {
    if (lines[i].length < 2 || lines[i].charAt(1) !== '=') {
      return false;
    }
    // TODO: check the modifier a bit more.
  }
  return true;
};

// Expose public methods.
if (true) {
  module.exports = SDPUtils;
}

/***/ }),

/***/ "YWiL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("1Hmk");

var supportsDescriptors = __webpack_require__("VxKF").supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if (/a/mig.flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof /a/.dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};

/***/ }),

/***/ "YdoG":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("qvVx");

module.exports = getBuiltIn('document', 'documentElement');

/***/ }),

/***/ "YeOI":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("oOss");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

/***/ }),

/***/ "Z2Ia":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("T4f3");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("zCAL");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("eW0v");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__("PkFN");

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__("Z55K");

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__("KQdW");

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var CircleRipple = function (_Component) {
  (0, _inherits3.default)(CircleRipple, _Component);

  function CircleRipple() {
    (0, _classCallCheck3.default)(this, CircleRipple);
    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
  }

  (0, _createClass3.default)(CircleRipple, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = 0;
      // If the animation is aborted, remove from the DOM immediately
      var removeAfter = this.props.aborted ? 0 : 2000;
      this.enterTimer = setTimeout(callback, removeAfter);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;
      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
      _autoPrefix2.default.set(style, 'transition', transitionValue);
      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = this.props.opacity;
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
      this.leaveTimer = setTimeout(callback, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          aborted = _props.aborted,
          color = _props.color,
          opacity = _props.opacity,
          style = _props.style,
          touchGenerated = _props.touchGenerated,
          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var mergedStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: color
      }, style);

      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
    }
  }]);
  return CircleRipple;
}(_react.Component);

CircleRipple.defaultProps = {
  opacity: 0.1,
  aborted: false
};
CircleRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CircleRipple.propTypes =  false ? {
  aborted: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object,
  touchGenerated: _propTypes2.default.bool
} : {};
exports.default = CircleRipple;

/***/ }),

/***/ "Z54K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),

/***/ "Z55K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};

/***/ }),

/***/ "Z7oM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__("KYJg");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__("sFsT");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__("JbHP");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__("2kK6");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__("VYL5");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(toInteger["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(toInteger["a" /* default */])(options.firstWeekContainsDate);
  var year = Object(getUTCWeekYear["a" /* default */])(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = Object(startOfUTCWeek["a" /* default */])(firstWeek, dirtyOptions);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/getUTCWeek/index.js
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeek;




var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var diff = Object(startOfUTCWeek["a" /* default */])(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ "ZHoC":
/***/ (function(module, exports) {

module.exports = [
// if it says it's a webview, let's go with that
'WebView',
// iOS webview will be the same as safari but missing "Safari"
'(iPhone|iPod|iPad)(?!.*Safari)',
// Android Lollipop and Above: webview will be the same as native but it will contain "wv"
// Android KitKat to lollipop webview will put {version}.0.0.0
'Android.*(wv|.0.0.0)',
// old chrome android webview agent
'Linux; U; Android'];

/***/ }),

/***/ "ZHsT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__("rQKw");

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function calc(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "ZHvQ":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("ShN9");
var TAG = __webpack_require__("Ug9I")('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),

/***/ "ZKjc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("Aq8W");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("yeEC");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("GyB/");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "ZNi8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleName; });
/* unused harmony export countryShape */
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectCountriesIsFetched; });
/* unused harmony export selectCountries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectCountriesForSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_compat__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("vyGZ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var moduleName = 'countries';

var countryShape = __WEBPACK_IMPORTED_MODULE_1_preact_compat__["PropTypes"].shape({
  code: __WEBPACK_IMPORTED_MODULE_1_preact_compat__["PropTypes"].string.isRequired,
  displayName: __WEBPACK_IMPORTED_MODULE_1_preact_compat__["PropTypes"].string.isRequired,
  localName: __WEBPACK_IMPORTED_MODULE_1_preact_compat__["PropTypes"].string.isRequired,
  searchTerms: __WEBPACK_IMPORTED_MODULE_1_preact_compat__["PropTypes"].string.isRequired
});

// Reducer (down)

var initialState = {
  fetched: false,
  error: '',
  entities: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var error = action.error,
      type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].COUNTRIES_FETCH_REQUEST:
      return _extends({}, state, {
        fetched: false,
        error: initialState,
        entities: initialState.entities
      });

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].COUNTRIES_FETCH_SUCCESS:
      {
        var countriesList = payload.countriesList;


        return _extends({}, state, {
          fetched: true,
          error: initialState.error,
          entities: countriesList
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].COUNTRIES_FETCH_FAILURE:
      return _extends({}, state, {
        error: error,
        fetched: false,
        entities: initialState.entities
      });

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

var stateSelector = function stateSelector(store) {
  return store[moduleName];
};

var selectCountriesIsFetched = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (countries) {
  return countries.fetched;
});

var selectCountries = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (countries) {
  return countries.entities;
});

var selectCountriesForSelect = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectCountries, function (countries) {
  return countries.map(function (country) {
    return _extends({}, country, {
      label: country.displayName,
      value: country.code
    });
  });
});

// Selectors (up)

/***/ }),

/***/ "ZShz":
/***/ (function(module, exports, __webpack_require__) {

!function (n, t) {
   true ? t(exports, __webpack_require__("KM04")) : "function" == typeof define && define.amd ? define(["exports", "preact"], t) : t((n = n || self).preactContext = {}, n.preact);
}(this, function (n, t) {
  "use strict";
  var _i = function i(n, t) {
    return (_i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (n, t) {
      n.__proto__ = t;
    } || function (n, t) {
      for (var i in t) {
        t.hasOwnProperty(i) && (n[i] = t[i]);
      }
    })(n, t);
  };function r(n, t) {
    function r() {
      this.constructor = n;
    }_i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  }var e = { register: function register(n) {
      console.warn("Consumer used without a Provider");
    }, unregister: function unregister(n) {}, val: function val(n) {} };function u(n) {
    var t = n.children;return { child: 1 === t.length ? t[0] : null, children: t };
  }function o(n) {
    return u(n).child || "render" in n && n.render;
  }var c = 1073741823,
      f = function f() {
    return c;
  },
      s = 0;function a(n, i) {
    var a = "_preactContextProvider-" + s++;return { Provider: function (n) {
        function e(t) {
          var r = n.call(this, t) || this;return r.t = function (n, t) {
            var i = [],
                r = n,
                e = function e(n) {
              return 0 | t(r, n);
            };return { register: function register(n) {
                i.push(n), n(r, e(r));
              }, unregister: function unregister(n) {
                i = i.filter(function (t) {
                  return t !== n;
                });
              }, val: function val(n) {
                if (void 0 === n || n == r) return r;var t = e(n);return r = n, i.forEach(function (i) {
                  return i(n, t);
                }), r;
              } };
          }(t.value, i || f), r;
        }return r(e, n), e.prototype.getChildContext = function () {
          var n;return (n = {})[a] = this.t, n;
        }, e.prototype.componentDidUpdate = function () {
          this.t.val(this.props.value);
        }, e.prototype.render = function () {
          var n = u(this.props),
              i = n.child,
              r = n.children;return i || t.h("span", null, r);
        }, e;
      }(t.Component), Consumer: function (t) {
        function i(i, r) {
          var e = t.call(this, i, r) || this;return e.i = function (n, t) {
            var i = e.props.unstable_observedBits,
                r = void 0 === i || null === i ? c : i;0 != ((r |= 0) & t) && e.setState({ value: n });
          }, e.state = { value: e.u().val() || n }, e;
        }return r(i, t), i.prototype.componentDidMount = function () {
          this.u().register(this.i);
        }, i.prototype.shouldComponentUpdate = function (n, t) {
          return this.state.value !== t.value || o(this.props) !== o(n);
        }, i.prototype.componentWillUnmount = function () {
          this.u().unregister(this.i);
        }, i.prototype.componentDidUpdate = function (n, t, i) {
          var r = i[a];r !== this.context[a] && ((r || e).unregister(this.i), this.componentDidMount());
        }, i.prototype.render = function () {
          var n = "render" in this.props && this.props.render,
              t = o(this.props);if (n && n !== t && console.warn("Both children and a render function are defined. Children will be used"), "function" == typeof t) return t(this.state.value);console.warn("Consumer is expecting a function as one and only child but didn't find any");
        }, i.prototype.u = function () {
          return this.context[a] || e;
        }, i;
      }(t.Component) };
  }var h = a;n.default = a, n.createContext = h, Object.defineProperty(n, "__esModule", { value: !0 });
});

/***/ }),

/***/ "ZVcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__("f5Sh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__ = __webpack_require__("H70G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__ = __webpack_require__("tKq7");




/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */

function differenceInHours(dateLeft, dateRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__["a" /* default */])(dateLeft, dateRight) / __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b" /* millisecondsInHour */];
  return Object(__WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),

/***/ "ZaKr":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("BxvP");
var anObject = __webpack_require__("zotD");
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__("3zRh")(Function.call, __webpack_require__("sxPs").f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),

/***/ "ZfyC":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("rtOw");

module.exports = !fails(function () {
  function F() {/* empty */}
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

/***/ }),

/***/ "Zwq5":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("MpYs");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "ZxII":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("Ug9I");

/***/ }),

/***/ "a5Ub":
/***/ (function(module, exports) {

//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/; //\u10000-\uEFFFF
var nameChar = new RegExp("[\\-\\.0-9" + nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var tagNamePattern = new RegExp('^' + nameStartChar.source + nameChar.source + '*(?:\:' + nameStartChar.source + nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')

//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var S_TAG = 0; //tag name offerring
var S_ATTR = 1; //attr name offerring 
var S_ATTR_SPACE = 2; //attr name end and space offer
var S_EQ = 3; //=space?
var S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var S_ATTR_END = 5; //attr value end and no space(quot end)
var S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var S_TAG_CLOSE = 7; //closed el<el />

/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */
function ParseError(message, locator) {
	this.message = message;
	this.locator = locator;
	if (Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
}
ParseError.prototype = new Error();
ParseError.prototype.name = ParseError.name;

function XMLReader() {}

XMLReader.prototype = {
	parse: function parse(source, defaultNSMap, entityMap) {
		var domBuilder = this.domBuilder;
		domBuilder.startDocument();
		_copy(defaultNSMap, defaultNSMap = {});
		_parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
		domBuilder.endDocument();
	}
};
function _parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
	function fixedFromCharCode(code) {
		// String.prototype.fromCharCode does not supports
		// > 2 bytes unicode chars directly
		if (code > 0xffff) {
			code -= 0x10000;
			var surrogate1 = 0xd800 + (code >> 10),
			    surrogate2 = 0xdc00 + (code & 0x3ff);

			return String.fromCharCode(surrogate1, surrogate2);
		} else {
			return String.fromCharCode(code);
		}
	}
	function entityReplacer(a) {
		var k = a.slice(1, -1);
		if (k in entityMap) {
			return entityMap[k];
		} else if (k.charAt(0) === '#') {
			return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
		} else {
			errorHandler.error('entity not found:' + a);
			return a;
		}
	}
	function appendText(end) {
		//has some bugs
		if (end > start) {
			var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
			locator && position(start);
			domBuilder.characters(xt, 0, end - start);
			start = end;
		}
	}
	function position(p, m) {
		while (p >= lineEnd && (m = linePattern.exec(source))) {
			lineStart = m.index;
			lineEnd = lineStart + m[0].length;
			locator.lineNumber++;
			//console.log('line++:',locator,startPos,endPos)
		}
		locator.columnNumber = p - lineStart + 1;
	}
	var lineStart = 0;
	var lineEnd = 0;
	var linePattern = /.*(?:\r\n?|\n)|.*$/g;
	var locator = domBuilder.locator;

	var parseStack = [{ currentNSMap: defaultNSMapCopy }];
	var closeMap = {};
	var start = 0;
	while (true) {
		try {
			var tagStart = source.indexOf('<', start);
			if (tagStart < 0) {
				if (!source.substr(start).match(/^\s*$/)) {
					var doc = domBuilder.doc;
					var text = doc.createTextNode(source.substr(start));
					doc.appendChild(text);
					domBuilder.currentElement = text;
				}
				return;
			}
			if (tagStart > start) {
				appendText(tagStart);
			}
			switch (source.charAt(tagStart + 1)) {
				case '/':
					var end = source.indexOf('>', tagStart + 3);
					var tagName = source.substring(tagStart + 2, end);
					var config = parseStack.pop();
					if (end < 0) {

						tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
						//console.error('#@@@@@@'+tagName)
						errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
						end = tagStart + 1 + tagName.length;
					} else if (tagName.match(/\s</)) {
						tagName = tagName.replace(/[\s<].*/, '');
						errorHandler.error("end tag name: " + tagName + ' maybe not complete');
						end = tagStart + 1 + tagName.length;
					}
					//console.error(parseStack.length,parseStack)
					//console.error(config);
					var localNSMap = config.localNSMap;
					var endMatch = config.tagName == tagName;
					var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
					if (endIgnoreCaseMach) {
						domBuilder.endElement(config.uri, config.localName, tagName);
						if (localNSMap) {
							for (var prefix in localNSMap) {
								domBuilder.endPrefixMapping(prefix);
							}
						}
						if (!endMatch) {
							errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName); // No known test case
						}
					} else {
						parseStack.push(config);
					}

					end++;
					break;
				// end elment
				case '?':
					// <?...?>
					locator && position(tagStart);
					end = parseInstruction(source, tagStart, domBuilder);
					break;
				case '!':
					// <!doctype,<![CDATA,<!--
					locator && position(tagStart);
					end = parseDCC(source, tagStart, domBuilder, errorHandler);
					break;
				default:
					locator && position(tagStart);
					var el = new ElementAttributes();
					var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
					//elStartEnd
					var end = parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
					var len = el.length;

					if (!el.closed && fixSelfClosed(source, end, el.tagName, closeMap)) {
						el.closed = true;
						if (!entityMap.nbsp) {
							errorHandler.warning('unclosed xml attribute');
						}
					}
					if (locator && len) {
						var locator2 = copyLocator(locator, {});
						//try{//attribute position fixed
						for (var i = 0; i < len; i++) {
							var a = el[i];
							position(a.offset);
							a.locator = copyLocator(locator, {});
						}
						//}catch(e){console.error('@@@@@'+e)}
						domBuilder.locator = locator2;
						if (appendElement(el, domBuilder, currentNSMap)) {
							parseStack.push(el);
						}
						domBuilder.locator = locator;
					} else {
						if (appendElement(el, domBuilder, currentNSMap)) {
							parseStack.push(el);
						}
					}

					if (el.uri === 'http://www.w3.org/1999/xhtml' && !el.closed) {
						end = parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
					} else {
						end++;
					}
			}
		} catch (e) {
			if (e instanceof ParseError) {
				throw e;
			}
			errorHandler.error('element parse error: ' + e);
			end = -1;
		}
		if (end > start) {
			start = end;
		} else {
			//TODO: 这里有可能sax回退，有位置错误风险
			appendText(Math.max(tagStart, start) + 1);
		}
	}
}
function copyLocator(f, t) {
	t.lineNumber = f.lineNumber;
	t.columnNumber = f.columnNumber;
	return t;
}

/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */
function parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {

	/**
  * @param {string} qname
  * @param {string} value
  * @param {number} startIndex
  */
	function addAttribute(qname, value, startIndex) {
		if (qname in el.attributeNames) errorHandler.fatalError('Attribute ' + qname + ' redefined');
		el.addValue(qname, value, startIndex);
	}
	var attrName;
	var value;
	var p = ++start;
	var s = S_TAG; //status
	while (true) {
		var c = source.charAt(p);
		switch (c) {
			case '=':
				if (s === S_ATTR) {
					//attrName
					attrName = source.slice(start, p);
					s = S_EQ;
				} else if (s === S_ATTR_SPACE) {
					s = S_EQ;
				} else {
					//fatalError: equal must after attrName or space after attrName
					throw new Error('attribute equal must after attrName'); // No known test case
				}
				break;
			case '\'':
			case '"':
				if (s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
				) {
						//equal
						if (s === S_ATTR) {
							errorHandler.warning('attribute value must after "="');
							attrName = source.slice(start, p);
						}
						start = p + 1;
						p = source.indexOf(c, start);
						if (p > 0) {
							value = source.slice(start, p).replace(/&#?\w+;/g, entityReplacer);
							addAttribute(attrName, value, start - 1);
							s = S_ATTR_END;
						} else {
							//fatalError: no end quot match
							throw new Error('attribute value no end \'' + c + '\' match');
						}
					} else if (s == S_ATTR_NOQUOT_VALUE) {
					value = source.slice(start, p).replace(/&#?\w+;/g, entityReplacer);
					//console.log(attrName,value,start,p)
					addAttribute(attrName, value, start);
					//console.dir(el)
					errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
					start = p + 1;
					s = S_ATTR_END;
				} else {
					//fatalError: no equal before
					throw new Error('attribute value must after "="'); // No known test case
				}
				break;
			case '/':
				switch (s) {
					case S_TAG:
						el.setTagName(source.slice(start, p));
					case S_ATTR_END:
					case S_TAG_SPACE:
					case S_TAG_CLOSE:
						s = S_TAG_CLOSE;
						el.closed = true;
					case S_ATTR_NOQUOT_VALUE:
					case S_ATTR:
					case S_ATTR_SPACE:
						break;
					//case S_EQ:
					default:
						throw new Error("attribute invalid close char('/')"); // No known test case
				}
				break;
			case '':
				//end document
				errorHandler.error('unexpected end of input');
				if (s == S_TAG) {
					el.setTagName(source.slice(start, p));
				}
				return p;
			case '>':
				switch (s) {
					case S_TAG:
						el.setTagName(source.slice(start, p));
					case S_ATTR_END:
					case S_TAG_SPACE:
					case S_TAG_CLOSE:
						break; //normal
					case S_ATTR_NOQUOT_VALUE: //Compatible state
					case S_ATTR:
						value = source.slice(start, p);
						if (value.slice(-1) === '/') {
							el.closed = true;
							value = value.slice(0, -1);
						}
					case S_ATTR_SPACE:
						if (s === S_ATTR_SPACE) {
							value = attrName;
						}
						if (s == S_ATTR_NOQUOT_VALUE) {
							errorHandler.warning('attribute "' + value + '" missed quot(")!');
							addAttribute(attrName, value.replace(/&#?\w+;/g, entityReplacer), start);
						} else {
							if (currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !value.match(/^(?:disabled|checked|selected)$/i)) {
								errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
							}
							addAttribute(value, value, start);
						}
						break;
					case S_EQ:
						throw new Error('attribute value missed!!');
				}
				//			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
				return p;
			/*xml space '\x20' | #x9 | #xD | #xA; */
			case "\x80":
				c = ' ';
			default:
				if (c <= ' ') {
					//space
					switch (s) {
						case S_TAG:
							el.setTagName(source.slice(start, p)); //tagName
							s = S_TAG_SPACE;
							break;
						case S_ATTR:
							attrName = source.slice(start, p);
							s = S_ATTR_SPACE;
							break;
						case S_ATTR_NOQUOT_VALUE:
							var value = source.slice(start, p).replace(/&#?\w+;/g, entityReplacer);
							errorHandler.warning('attribute "' + value + '" missed quot(")!!');
							addAttribute(attrName, value, start);
						case S_ATTR_END:
							s = S_TAG_SPACE;
							break;
						//case S_TAG_SPACE:
						//case S_EQ:
						//case S_ATTR_SPACE:
						//	void();break;
						//case S_TAG_CLOSE:
						//ignore warning
					}
				} else {
					//not space
					//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
					//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
					switch (s) {
						//case S_TAG:void();break;
						//case S_ATTR:void();break;
						//case S_ATTR_NOQUOT_VALUE:void();break;
						case S_ATTR_SPACE:
							var tagName = el.tagName;
							if (currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
								errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
							}
							addAttribute(attrName, attrName, start);
							start = p;
							s = S_ATTR;
							break;
						case S_ATTR_END:
							errorHandler.warning('attribute space is required"' + attrName + '"!!');
						case S_TAG_SPACE:
							s = S_ATTR;
							start = p;
							break;
						case S_EQ:
							s = S_ATTR_NOQUOT_VALUE;
							start = p;
							break;
						case S_TAG_CLOSE:
							throw new Error("elements closed character '/' and '>' must be connected to");
					}
				}
		} //end outer switch
		//console.log('p++',p)
		p++;
	}
}
/**
 * @return true if has new namespace define
 */
function appendElement(el, domBuilder, currentNSMap) {
	var tagName = el.tagName;
	var localNSMap = null;
	//var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
	var i = el.length;
	while (i--) {
		var a = el[i];
		var qName = a.qName;
		var value = a.value;
		var nsp = qName.indexOf(':');
		if (nsp > 0) {
			var prefix = a.prefix = qName.slice(0, nsp);
			var localName = qName.slice(nsp + 1);
			var nsPrefix = prefix === 'xmlns' && localName;
		} else {
			localName = qName;
			prefix = null;
			nsPrefix = qName === 'xmlns' && '';
		}
		//can not set prefix,because prefix !== ''
		a.localName = localName;
		//prefix == null for no ns prefix attribute 
		if (nsPrefix !== false) {
			//hack!!
			if (localNSMap == null) {
				localNSMap = {};
				//console.log(currentNSMap,0)
				_copy(currentNSMap, currentNSMap = {});
				//console.log(currentNSMap,1)
			}
			currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
			a.uri = 'http://www.w3.org/2000/xmlns/';
			domBuilder.startPrefixMapping(nsPrefix, value);
		}
	}
	var i = el.length;
	while (i--) {
		a = el[i];
		var prefix = a.prefix;
		if (prefix) {
			//no prefix attribute has no namespace
			if (prefix === 'xml') {
				a.uri = 'http://www.w3.org/XML/1998/namespace';
			}if (prefix !== 'xmlns') {
				a.uri = currentNSMap[prefix || ''];

				//{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
			}
		}
	}
	var nsp = tagName.indexOf(':');
	if (nsp > 0) {
		prefix = el.prefix = tagName.slice(0, nsp);
		localName = el.localName = tagName.slice(nsp + 1);
	} else {
		prefix = null; //important!!
		localName = el.localName = tagName;
	}
	//no prefix element has default namespace
	var ns = el.uri = currentNSMap[prefix || ''];
	domBuilder.startElement(ns, localName, tagName, el);
	//endPrefixMapping and startPrefixMapping have not any help for dom builder
	//localNSMap = null
	if (el.closed) {
		domBuilder.endElement(ns, localName, tagName);
		if (localNSMap) {
			for (prefix in localNSMap) {
				domBuilder.endPrefixMapping(prefix);
			}
		}
	} else {
		el.currentNSMap = currentNSMap;
		el.localNSMap = localNSMap;
		//parseStack.push(el);
		return true;
	}
}
function parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
	if (/^(?:script|textarea)$/i.test(tagName)) {
		var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
		var text = source.substring(elStartEnd + 1, elEndStart);
		if (/[&<]/.test(text)) {
			if (/^script$/i.test(tagName)) {
				//if(!/\]\]>/.test(text)){
				//lexHandler.startCDATA();
				domBuilder.characters(text, 0, text.length);
				//lexHandler.endCDATA();
				return elEndStart;
				//}
			} //}else{//text area
			text = text.replace(/&#?\w+;/g, entityReplacer);
			domBuilder.characters(text, 0, text.length);
			return elEndStart;
			//}
		}
	}
	return elStartEnd + 1;
}
function fixSelfClosed(source, elStartEnd, tagName, closeMap) {
	//if(tagName in closeMap){
	var pos = closeMap[tagName];
	if (pos == null) {
		//console.log(tagName)
		pos = source.lastIndexOf('</' + tagName + '>');
		if (pos < elStartEnd) {
			//忘记闭合
			pos = source.lastIndexOf('</' + tagName);
		}
		closeMap[tagName] = pos;
	}
	return pos < elStartEnd;
	//} 
}
function _copy(source, target) {
	for (var n in source) {
		target[n] = source[n];
	}
}
function parseDCC(source, start, domBuilder, errorHandler) {
	//sure start with '<!'
	var next = source.charAt(start + 2);
	switch (next) {
		case '-':
			if (source.charAt(start + 3) === '-') {
				var end = source.indexOf('-->', start + 4);
				//append comment source.substring(4,end)//<!--
				if (end > start) {
					domBuilder.comment(source, start + 4, end - start - 4);
					return end + 3;
				} else {
					errorHandler.error("Unclosed comment");
					return -1;
				}
			} else {
				//error
				return -1;
			}
		default:
			if (source.substr(start + 3, 6) == 'CDATA[') {
				var end = source.indexOf(']]>', start + 9);
				domBuilder.startCDATA();
				domBuilder.characters(source, start + 9, end - start - 9);
				domBuilder.endCDATA();
				return end + 3;
			}
			//<!DOCTYPE
			//startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId) 
			var matchs = split(source, start);
			var len = matchs.length;
			if (len > 1 && /!doctype/i.test(matchs[0][0])) {
				var name = matchs[1][0];
				var pubid = false;
				var sysid = false;
				if (len > 3) {
					if (/^public$/i.test(matchs[2][0])) {
						pubid = matchs[3][0];
						sysid = len > 4 && matchs[4][0];
					} else if (/^system$/i.test(matchs[2][0])) {
						sysid = matchs[3][0];
					}
				}
				var lastMatch = matchs[len - 1];
				domBuilder.startDTD(name, pubid, sysid);
				domBuilder.endDTD();

				return lastMatch.index + lastMatch[0].length;
			}
	}
	return -1;
}

function parseInstruction(source, start, domBuilder) {
	var end = source.indexOf('?>', start);
	if (end) {
		var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
		if (match) {
			var len = match[0].length;
			domBuilder.processingInstruction(match[1], match[2]);
			return end + 2;
		} else {
			//error
			return -1;
		}
	}
	return -1;
}

function ElementAttributes() {
	this.attributeNames = {};
}
ElementAttributes.prototype = {
	setTagName: function setTagName(tagName) {
		if (!tagNamePattern.test(tagName)) {
			throw new Error('invalid tagName:' + tagName);
		}
		this.tagName = tagName;
	},
	addValue: function addValue(qName, value, offset) {
		if (!tagNamePattern.test(qName)) {
			throw new Error('invalid attribute:' + qName);
		}
		this.attributeNames[qName] = this.length;
		this[this.length++] = { qName: qName, value: value, offset: offset };
	},
	length: 0,
	getLocalName: function getLocalName(i) {
		return this[i].localName;
	},
	getLocator: function getLocator(i) {
		return this[i].locator;
	},
	getQName: function getQName(i) {
		return this[i].qName;
	},
	getURI: function getURI(i) {
		return this[i].uri;
	},
	getValue: function getValue(i) {
		return this[i].value;
	}
	//	,getIndex:function(uri, localName)){
	//		if(localName){
	//			
	//		}else{
	//			var qName = uri
	//		}
	//	},
	//	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
	//	getType:function(uri,localName){}
	//	getType:function(i){},
};

function split(source, start) {
	var match;
	var buf = [];
	var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
	reg.lastIndex = start;
	reg.exec(source); //skip <
	while (match = reg.exec(source)) {
		buf.push(match);
		if (match[1]) return buf;
	}
}

exports.XMLReader = XMLReader;
exports.ParseError = ParseError;

/***/ }),

/***/ "aFbL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ "aXzn":
/***/ (function(module, exports) {

module.exports = function () {/* empty */};

/***/ }),

/***/ "abHJ":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var bind = __webpack_require__("1PPX");
var call = __webpack_require__("HiG7");
var anObject = __webpack_require__("1kal");
var tryToString = __webpack_require__("HXaG");
var isArrayIteratorMethod = __webpack_require__("lEU8");
var lengthOfArrayLike = __webpack_require__("SYGT");
var isPrototypeOf = __webpack_require__("VN+O");
var getIterator = __webpack_require__("7NjO");
var getIteratorMethod = __webpack_require__("x6RK");
var iteratorClose = __webpack_require__("6BI7");

var TypeError = global.TypeError;

var Result = function Result(stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function stop(condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function callFn(value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      }return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  }return new Result(false);
};

/***/ }),

/***/ "af0K":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("dhak");
var ITERATOR = __webpack_require__("Ug9I")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),

/***/ "akPY":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("Gfzd");
var createDesc = __webpack_require__("0WCH");
module.exports = __webpack_require__("6MLN") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "ar57":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("58Ti");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

/***/ }),

/***/ "asZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),

/***/ "ayXv":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("ShN9");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),

/***/ "b1tA":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("vSO4");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("ZaKr").set });

/***/ }),

/***/ "b7Q2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__("TNJq");
var descriptor = __webpack_require__("0WCH");
var setToStringTag = __webpack_require__("11Ut");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("akPY")(IteratorPrototype, __webpack_require__("Ug9I")('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),

/***/ "b9XL":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "bKsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/invariant/browser.js
var browser = __webpack_require__("2gTp");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isFunction.js
/* harmony default export */ var isFunction = (function (value) {
  return typeof value === 'function';
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isSymbol.js
/* harmony default export */ var isSymbol = (function (value) {
  return typeof value === 'symbol' || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isEmpty.js
/* harmony default export */ var isEmpty = (function (value) {
  return value.length === 0;
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/toString.js
/* harmony default export */ var utils_toString = (function (value) {
  return value.toString();
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isString.js
/* harmony default export */ var isString = (function (value) {
  return typeof value === 'string';
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/constants.js
var DEFAULT_NAMESPACE = '/';
var ACTION_TYPE_DELIMITER = '||';
// CONCATENATED MODULE: ../node_modules/redux-actions/es/combineActions.js








function isValidActionType(type) {
  return isString(type) || isFunction(type) || isSymbol(type);
}

function isValidActionTypes(types) {
  if (isEmpty(types)) {
    return false;
  }

  return types.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = new Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  browser_default()(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(utils_toString).join(ACTION_TYPE_DELIMITER);
  return {
    toString: function toString() {
      return combinedActionType;
    }
  };
}
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/identity.js
/* harmony default export */ var identity = (function (value) {
  return value;
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isNull.js
/* harmony default export */ var isNull = (function (value) {
  return value === null;
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/createAction.js




function createAction(type, payloadCreator, metaCreator) {
  if (payloadCreator === void 0) {
    payloadCreator = identity;
  }

  browser_default()(isFunction(payloadCreator) || isNull(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
  var finalPayloadCreator = isNull(payloadCreator) || payloadCreator === identity ? identity : function (head) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(void 0, [head].concat(args));
  };
  var hasMeta = isFunction(metaCreator);
  var typeString = type.toString();

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(void 0, arguments);
    var action = {
      type: type
    };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (hasMeta) {
      action.meta = metaCreator.apply(void 0, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return typeString;
  };

  return actionCreator;
}
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isPlainObject.js
/* harmony default export */ var isPlainObject = (function (value) {
  if (typeof value !== 'object' || value === null) return false;
  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isArray.js
/* harmony default export */ var isArray = (function (value) {
  return Array.isArray(value);
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isNil.js
/* harmony default export */ var isNil = (function (value) {
  return value === null || value === undefined;
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/getLastElement.js
/* harmony default export */ var getLastElement = (function (array) {
  return array[array.length - 1];
});
// EXTERNAL MODULE: ../node_modules/to-camel-case/index.js
var to_camel_case = __webpack_require__("eHdh");
var to_camel_case_default = /*#__PURE__*/__webpack_require__.n(to_camel_case);

// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/camelCase.js

var namespacer = '/';
/* harmony default export */ var camelCase = (function (type) {
  return type.indexOf(namespacer) === -1 ? to_camel_case_default()(type) : type.split(namespacer).map(to_camel_case_default.a).join(namespacer);
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/arrayToObject.js
/* harmony default export */ var arrayToObject = (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isMap.js
/* harmony default export */ var isMap = (function (value) {
  return typeof Map !== 'undefined' && value instanceof Map;
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/ownKeys.js

function ownKeys(object) {
  if (isMap(object)) {
    // We are using loose transforms in babel. Here we are trying to convert an
    // interable to an array. Loose mode expects everything to already be an
    // array. The problem is that our eslint rules encourage us to prefer
    // spread over Array.from.
    //
    // Instead of disabling loose mode we simply disable the warning.
    // eslint-disable-next-line unicorn/prefer-spread
    return Array.from(object.keys());
  }

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/get.js

function get(key, x) {
  return isMap(x) ? x.get(key) : x[key];
}
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/flattenWhenNode.js



/* harmony default export */ var flattenWhenNode = (function (predicate) {
  return function flatten(map, _temp, partialFlatMap, partialFlatActionType) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$namespace = _ref.namespace,
        namespace = _ref$namespace === void 0 ? DEFAULT_NAMESPACE : _ref$namespace,
        prefix = _ref.prefix;

    if (partialFlatMap === void 0) {
      partialFlatMap = {};
    }

    if (partialFlatActionType === void 0) {
      partialFlatActionType = '';
    }

    function connectNamespace(type) {
      var _ref2;

      if (!partialFlatActionType) return type;
      var types = type.toString().split(ACTION_TYPE_DELIMITER);
      var partials = partialFlatActionType.split(ACTION_TYPE_DELIMITER);
      return (_ref2 = []).concat.apply(_ref2, partials.map(function (p) {
        return types.map(function (t) {
          return "" + p + namespace + t;
        });
      })).join(ACTION_TYPE_DELIMITER);
    }

    function connectPrefix(type) {
      if (partialFlatActionType || !prefix || prefix && new RegExp("^" + prefix + namespace).test(type)) {
        return type;
      }

      return "" + prefix + namespace + type;
    }

    ownKeys(map).forEach(function (type) {
      var nextNamespace = connectPrefix(connectNamespace(type));
      var mapValue = get(type, map);

      if (predicate(mapValue)) {
        flatten(mapValue, {
          namespace: namespace,
          prefix: prefix
        }, partialFlatMap, nextNamespace);
      } else {
        partialFlatMap[nextNamespace] = mapValue;
      }
    });
    return partialFlatMap;
  };
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/flattenActionMap.js


/* harmony default export */ var flattenActionMap = (flattenWhenNode(isPlainObject));
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/unflattenActionCreators.js



function unflattenActionCreators(flatActionCreators, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? DEFAULT_NAMESPACE : _ref$namespace,
      prefix = _ref.prefix;

  function unflatten(flatActionType, partialNestedActionCreators, partialFlatActionTypePath) {
    var nextNamespace = camelCase(partialFlatActionTypePath.shift());

    if (isEmpty(partialFlatActionTypePath)) {
      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
    } else {
      if (!partialNestedActionCreators[nextNamespace]) {
        partialNestedActionCreators[nextNamespace] = {};
      }

      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
    }
  }

  var nestedActionCreators = {};
  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
    var unprefixedType = prefix ? type.replace("" + prefix + namespace, '') : type;
    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
  });
  return nestedActionCreators;
}
// CONCATENATED MODULE: ../node_modules/redux-actions/es/createActions.js
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}















function createActions(actionMap) {
  for (var _len = arguments.length, identityActions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  var options = isPlainObject(getLastElement(identityActions)) ? identityActions.pop() : {};
  browser_default()(identityActions.every(isString) && (isString(actionMap) || isPlainObject(actionMap)), 'Expected optional object followed by string action types');

  if (isString(actionMap)) {
    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
  }

  return _objectSpread({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
}

function actionCreatorsFromActionMap(actionMap, options) {
  var flatActionMap = flattenActionMap(actionMap, options);
  var flatActionCreators = actionMapToActionCreators(flatActionMap);
  return unflattenActionCreators(flatActionCreators, options);
}

function actionMapToActionCreators(actionMap, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      prefix = _ref.prefix,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? DEFAULT_NAMESPACE : _ref$namespace;

  function isValidActionMapValue(actionMapValue) {
    if (isFunction(actionMapValue) || isNil(actionMapValue)) {
      return true;
    }

    if (isArray(actionMapValue)) {
      var _actionMapValue$ = actionMapValue[0],
          payload = _actionMapValue$ === void 0 ? identity : _actionMapValue$,
          meta = actionMapValue[1];
      return isFunction(payload) && isFunction(meta);
    }

    return false;
  }

  return arrayToObject(Object.keys(actionMap), function (partialActionCreators, type) {
    var _objectSpread2;

    var actionMapValue = actionMap[type];
    browser_default()(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ("functions for " + type));
    var prefixedType = prefix ? "" + prefix + namespace + type : type;
    var actionCreator = isArray(actionMapValue) ? createAction.apply(void 0, [prefixedType].concat(actionMapValue)) : createAction(prefixedType, actionMapValue);
    return _objectSpread({}, partialActionCreators, (_objectSpread2 = {}, _objectSpread2[type] = actionCreator, _objectSpread2));
  });
}

function actionCreatorsFromIdentityActions(identityActions, options) {
  var actionMap = arrayToObject(identityActions, function (partialActionMap, type) {
    var _objectSpread3;

    return _objectSpread({}, partialActionMap, (_objectSpread3 = {}, _objectSpread3[type] = identity, _objectSpread3));
  });
  var actionCreators = actionMapToActionCreators(actionMap, options);
  return arrayToObject(Object.keys(actionCreators), function (partialActionCreators, type) {
    var _objectSpread4;

    return _objectSpread({}, partialActionCreators, (_objectSpread4 = {}, _objectSpread4[camelCase(type)] = actionCreators[type], _objectSpread4));
  });
}
// EXTERNAL MODULE: ../node_modules/just-curry-it/index.js
var just_curry_it = __webpack_require__("LbRA");
var just_curry_it_default = /*#__PURE__*/__webpack_require__.n(just_curry_it);

// CONCATENATED MODULE: ../node_modules/redux-actions/es/createCurriedAction.js


/* harmony default export */ var createCurriedAction = (function (type, payloadCreator) {
  return just_curry_it_default()(createAction(type, payloadCreator), payloadCreator.length);
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/isUndefined.js
/* harmony default export */ var isUndefined = (function (value) {
  return value === undefined;
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/handleAction.js








function handleAction(type, reducer, defaultState) {
  if (reducer === void 0) {
    reducer = identity;
  }

  var types = utils_toString(type).split(ACTION_TYPE_DELIMITER);
  browser_default()(!isUndefined(defaultState), "defaultState for reducer handling " + types.join(', ') + " should be defined");
  browser_default()(isFunction(reducer) || isPlainObject(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = isFunction(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return isNil(aReducer) ? identity : aReducer;
  }),
      nextReducer = _ref[0],
      throwReducer = _ref[1];

  return function (state, action) {
    if (state === void 0) {
      state = defaultState;
    }

    var actionType = action.type;

    if (!actionType || types.indexOf(utils_toString(actionType)) === -1) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}
// CONCATENATED MODULE: ../node_modules/reduce-reducers/es/index.js
/* harmony default export */ var es = (function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var initialState = typeof args[args.length - 1] !== 'function' && args.pop();
  var reducers = args;

  if (typeof initialState === 'undefined') {
    throw new TypeError('The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.');
  }

  return function (prevState, value) {
    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    var prevStateIsUndefined = typeof prevState === 'undefined';
    var valueIsUndefined = typeof value === 'undefined';

    if (prevStateIsUndefined && valueIsUndefined && initialState) {
      return initialState;
    }

    return reducers.reduce(function (newState, reducer) {
      return reducer.apply(undefined, [newState, value].concat(args));
    }, prevStateIsUndefined && !valueIsUndefined && initialState ? initialState : prevState);
  };
});
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/hasGeneratorInterface.js

function hasGeneratorInterface(handler) {
  var keys = ownKeys(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}
// CONCATENATED MODULE: ../node_modules/redux-actions/es/utils/flattenReducerMap.js




/* harmony default export */ var flattenReducerMap = (flattenWhenNode(function (node) {
  return (isPlainObject(node) || isMap(node)) && !hasGeneratorInterface(node);
}));
// CONCATENATED MODULE: ../node_modules/redux-actions/es/handleActions.js








function handleActions(handlers, defaultState, options) {
  if (options === void 0) {
    options = {};
  }

  browser_default()(isPlainObject(handlers) || isMap(handlers), 'Expected handlers to be a plain object.');
  var flattenedReducerMap = flattenReducerMap(handlers, options);
  var reducers = ownKeys(flattenedReducerMap).map(function (type) {
    return handleAction(type, get(type, flattenedReducerMap), defaultState);
  });
  var reducer = es.apply(void 0, reducers.concat([defaultState]));
  return function (state, action) {
    if (state === void 0) {
      state = defaultState;
    }

    return reducer(state, action);
  };
}
// CONCATENATED MODULE: ../node_modules/redux-actions/es/index.js
/* unused concated harmony import combineActions */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return combineActions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return createAction; });
/* unused concated harmony import createActions */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return createActions; });
/* unused concated harmony import createCurriedAction */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return createCurriedAction; });
/* unused concated harmony import handleAction */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return handleAction; });
/* unused concated harmony import handleActions */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return handleActions; });








/***/ }),

/***/ "bimv":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
  // Moderately fast, high quality
  var _rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(_rnds8);
    return _rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var _rnds = new Array(16);
  rng = function rng() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return _rnds;
  };
}

module.exports = rng;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "c2zY":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("i1Q6");
var core = __webpack_require__("zKeE");
var LIBRARY = __webpack_require__("1kq3");
var wksExt = __webpack_require__("ZxII");
var defineProperty = __webpack_require__("Gfzd").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),

/***/ "c5PF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btn":"btn__3UlhP","btnText":"btnText__3vV2T","btnImg":"btnImg__3-24n","controlBtn":"controlBtn__W7AiZ","lineThrough":"lineThrough__BZDEL","btnArea":"btnArea__3rlk-"};

/***/ }),

/***/ "c6mp":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c2zY")('asyncIterator');

/***/ }),

/***/ "cGvN":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var isCallable = __webpack_require__("yeFe");

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};

/***/ }),

/***/ "cGzZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("SNRl");
var IS_PURE = __webpack_require__("oj7W");
var global = __webpack_require__("IJ/8");
var getBuiltIn = __webpack_require__("qvVx");
var call = __webpack_require__("HiG7");
var NativePromise = __webpack_require__("qLzV");
var redefine = __webpack_require__("GZef");
var redefineAll = __webpack_require__("ufZ4");
var setPrototypeOf = __webpack_require__("nR03");
var setToStringTag = __webpack_require__("FfP1");
var setSpecies = __webpack_require__("+vXN");
var aCallable = __webpack_require__("oOss");
var isCallable = __webpack_require__("yeFe");
var isObject = __webpack_require__("FS7x");
var anInstance = __webpack_require__("DPS1");
var inspectSource = __webpack_require__("yPWo");
var iterate = __webpack_require__("abHJ");
var checkCorrectnessOfIteration = __webpack_require__("4zcZ");
var speciesConstructor = __webpack_require__("wT1l");
var task = __webpack_require__("iU4X").set;
var microtask = __webpack_require__("luft");
var promiseResolve = __webpack_require__("Y5Pa");
var hostReportErrors = __webpack_require__("vq39");
var newPromiseCapabilityModule = __webpack_require__("JteQ");
var perform = __webpack_require__("1UNZ");
var InternalStateModule = __webpack_require__("4J90");
var isForced = __webpack_require__("0/Oh");
var wellKnownSymbol = __webpack_require__("G69i");
var IS_BROWSER = __webpack_require__("N1TZ");
var IS_NODE = __webpack_require__("5dKy");
var V8_VERSION = __webpack_require__("7U15");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';

var getInternalState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromisePrototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) {
    resolve(1);
  });
  var FakePromise = function FakePromise(exec) {
    exec(function () {/* empty */}, function () {/* empty */});
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () {/* empty */}) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () {/* empty */});
});

// helpers
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var notify = function notify(state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            call(then, result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function dispatchEvent(name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function onUnhandled(state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function isUnhandled(state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function onHandleUnhandled(state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function bind(fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function internalReject(state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function internalResolve(state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reactions = state.reactions;
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable(onRejected) && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      reactions[reactions.length] = reaction;
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) {} /* empty */

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

/***/ }),

/***/ "cMrJ":
/***/ (function(module, exports) {

// mutationobserver-shim v0.3.3 (github.com/megawac/MutationObserver.js)
// Authors: Graeme Yeates (github.com/megawac) 
/*
 Shim for MutationObserver interface
 Author: Graeme Yeates (github.com/megawac)
 Repository: https://github.com/megawac/MutationObserver.js
 License: WTFPL V2, 2004 (wtfpl.net).
 Though credit and staring the repo will make me feel pretty, you can modify and redistribute as you please.
 Attempts to follow spec (https://www.w3.org/TR/dom/#mutation-observers) as closely as possible for native javascript
 See https://github.com/WebKit/webkit/blob/master/Source/WebCore/dom/MutationObserver.cpp for current webkit source c++ implementation
*/
window.MutationObserver || (window.MutationObserver = function (y) {
  function z(a) {
    this.i = [];this.m = a;
  }function K(a) {
    (function c() {
      var d = a.takeRecords();d.length && a.m(d, a);a.h = setTimeout(c, z._period);
    })();
  }function r(a) {
    var b = { type: null, target: null, addedNodes: [], removedNodes: [], previousSibling: null, nextSibling: null, attributeName: null, attributeNamespace: null, oldValue: null },
        c;for (c in a) {
      b[c] !== y && a[c] !== y && (b[c] = a[c]);
    }return b;
  }function L(a, b) {
    var c = E(a, b);return function (d) {
      var f = d.length;b.a && 3 === a.nodeType && a.nodeValue !== c.a && d.push(new r({ type: "characterData", target: a, oldValue: c.a }));b.b && c.b && C(d, a, c.b, b.f);if (b.c || b.g) var m = M(d, a, c, b);if (m || d.length !== f) c = E(a, b);
    };
  }function N(a, b) {
    return b.value;
  }function O(a, b) {
    return "style" !== b.name ? b.value : a.style.cssText;
  }function C(a, b, c, d) {
    for (var f = {}, m = b.attributes, k, g, p = m.length; p--;) {
      k = m[p], g = k.name, d && d[g] === y || (F(b, k) !== c[g] && a.push(r({ type: "attributes", target: b, attributeName: g, oldValue: c[g], attributeNamespace: k.namespaceURI })), f[g] = !0);
    }for (g in c) {
      f[g] || a.push(r({ target: b,
        type: "attributes", attributeName: g, oldValue: c[g] }));
    }
  }function M(a, b, c, d) {
    function f(g, p, t, q, x) {
      var A = g.length - 1;x = -~((A - x) / 2);for (var h, l, e; e = g.pop();) {
        h = t[e.j], l = q[e.l], d.c && x && Math.abs(e.j - e.l) >= A && (a.push(r({ type: "childList", target: p, addedNodes: [h], removedNodes: [h], nextSibling: h.nextSibling, previousSibling: h.previousSibling })), x--), d.b && l.b && C(a, h, l.b, d.f), d.a && 3 === h.nodeType && h.nodeValue !== l.a && a.push(r({ type: "characterData", target: h, oldValue: l.a })), d.g && m(h, l);
      }
    }function m(g, p) {
      for (var t = g.childNodes, q = p.c, x = t.length, A = q ? q.length : 0, h, l, e, n, v, B = 0, w = 0, u = 0; w < x || u < A;) {
        n = t[w], v = (e = q[u]) && e.node, n === v ? (d.b && e.b && C(a, n, e.b, d.f), d.a && e.a !== y && n.nodeValue !== e.a && a.push(r({ type: "characterData", target: n, oldValue: e.a })), l && f(l, g, t, q, B), d.g && (n.childNodes.length || e.c && e.c.length) && m(n, e), w++, u++) : (k = !0, h || (h = {}, l = []), n && (h[e = G(n)] || (h[e] = !0, -1 === (e = H(q, n, u, "node")) ? d.c && (a.push(r({ type: "childList", target: g, addedNodes: [n], nextSibling: n.nextSibling, previousSibling: n.previousSibling })), B++) : l.push({ j: w, l: e })), w++), v && v !== t[w] && (h[e = G(v)] || (h[e] = !0, -1 === (e = H(t, v, w)) ? d.c && (a.push(r({ type: "childList", target: p.node, removedNodes: [v], nextSibling: q[u + 1], previousSibling: q[u - 1] })), B--) : l.push({ j: e, l: u })), u++));
      }l && f(l, g, t, q, B);
    }var k;m(b, c);return k;
  }function E(a, b) {
    var c = !0;return function m(f) {
      var k = { node: f };!b.a || 3 !== f.nodeType && 8 !== f.nodeType ? (b.b && c && 1 === f.nodeType && (k.b = I(f.attributes, function (g, p) {
        if (!b.f || b.f[p.name]) g[p.name] = F(f, p);return g;
      }, {})), c && (b.c || b.a || b.b && b.g) && (k.c = P(f.childNodes, m)), c = b.g) : k.a = f.nodeValue;return k;
    }(a);
  }function G(a) {
    try {
      return a.id || (a.mo_id = a.mo_id || J++);
    } catch (b) {
      try {
        return a.nodeValue;
      } catch (c) {
        return J++;
      }
    }
  }function P(a, b) {
    for (var c = [], d = 0; d < a.length; d++) {
      c[d] = b(a[d], d, a);
    }return c;
  }function I(a, b, c) {
    for (var d = 0; d < a.length; d++) {
      c = b(c, a[d], d, a);
    }return c;
  }function H(a, b, c, d) {
    for (; c < a.length; c++) {
      if ((d ? a[c][d] : a[c]) === b) return c;
    }return -1;
  }z._period = 30;z.prototype = { observe: function observe(a, b) {
      for (var c = { b: !!(b.attributes || b.attributeFilter || b.attributeOldValue), c: !!b.childList, g: !!b.subtree,
        a: !(!b.characterData && !b.characterDataOldValue) }, d = this.i, f = 0; f < d.length; f++) {
        d[f].s === a && d.splice(f, 1);
      }b.attributeFilter && (c.f = I(b.attributeFilter, function (m, k) {
        m[k] = !0;return m;
      }, {}));d.push({ s: a, o: L(a, c) });this.h || K(this);
    }, takeRecords: function takeRecords() {
      for (var a = [], b = this.i, c = 0; c < b.length; c++) {
        b[c].o(a);
      }return a;
    }, disconnect: function disconnect() {
      this.i = [];clearTimeout(this.h);this.h = null;
    } };var D = document.createElement("i");D.style.top = 0;var F = (D = "null" != D.attributes.style.value) ? N : O,
      J = 1;return z;
}(void 0));
//# sourceMappingURL=mutationobserver.map

/***/ }),

/***/ "cOHw":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("vSO4");
var core = __webpack_require__("zKeE");
var fails = __webpack_require__("wLcK");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () {
    fn(1);
  }), 'Object', exp);
};

/***/ }),

/***/ "cX2q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),

/***/ "cjsw":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("yOG5");
var $Object = __webpack_require__("zKeE").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

/***/ }),

/***/ "cxRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TAG_XMPP_SEND */
/* unused harmony export TAG_XMPP_RECV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TAG_XMPP_CLIENT; });
/* unused harmony export TAG_SIGNALING */
/* unused harmony export TAG_CHAT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TAG_WEBRTC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TAG_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TAG_PRESENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TAG_BRANCH_IO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TAG_UI; });
/* unused harmony export log */
/* unused harmony export info */
/* unused harmony export error */
/* unused harmony export warn */
/* unused harmony export reportCrash */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return logWithTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return logXMPPSend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return logXMPPReceive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return logXMPPClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return logSignaling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return logChat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return logWebRTC; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__ = __webpack_require__("FFyX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__("4PH9");
/* eslint-disable no-console */




var TAG_XMPP_SEND = 'XMPP Send';
var TAG_XMPP_RECV = 'XMPP Recv';
var TAG_XMPP_CLIENT = 'XMPP Client';
var TAG_SIGNALING = 'Signaling';
var TAG_CHAT = 'Chat';
var TAG_WEBRTC = 'WebRTC';
var TAG_API = 'API';
var TAG_PRESENCE = 'Presence';
var TAG_BRANCH_IO = 'Branch.io';
var TAG_UI = 'UserInterface';

var log = function log() {
  try {
    if ("production" === __WEBPACK_IMPORTED_MODULE_1__consts__["h" /* ENVIRONMENTS */].DEVELOPMENT) {
      var _console;

      (_console = console).log.apply(_console, arguments);
    }
    __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"].log.apply(__WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"], arguments);
  } catch (err) {
    console.error(err);
  }
};

var info = function info() {
  try {
    if ("production" === __WEBPACK_IMPORTED_MODULE_1__consts__["h" /* ENVIRONMENTS */].DEVELOPMENT) {
      var _console2;

      (_console2 = console).info.apply(_console2, arguments);
    }
    __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"].info.apply(__WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"], arguments);
  } catch (err) {
    console.error(err);
  }
};

var error = function error() {
  try {
    if ("production" === __WEBPACK_IMPORTED_MODULE_1__consts__["h" /* ENVIRONMENTS */].DEVELOPMENT) {
      var _console3;

      (_console3 = console).error.apply(_console3, arguments);
    }
    __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"].error.apply(__WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"], arguments);
  } catch (err) {
    console.error(err);
  }
};

var warn = function warn() {
  try {
    if ("production" === __WEBPACK_IMPORTED_MODULE_1__consts__["h" /* ENVIRONMENTS */].DEVELOPMENT) {
      var _console4;

      (_console4 = console).warn.apply(_console4, arguments);
    }
    __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"].warn.apply(__WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"], arguments);
  } catch (err) {
    console.error(err);
  }
};

var reportCrash = function reportCrash(title, message) {
  __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"].sendCrash(title, message);
};

var logToConsoleBasedOnLogLevel = function logToConsoleBasedOnLogLevel(logLevel) {
  var _console5, _console6, _console7, _console8, _console9;

  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  if ("production" === __WEBPACK_IMPORTED_MODULE_1__consts__["h" /* ENVIRONMENTS */].DEVELOPMENT) {
    switch (logLevel) {
      case __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Error:
        (_console5 = console).error.apply(_console5, params);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Warning:
        (_console6 = console).warn.apply(_console6, params);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Fatal:
        (_console7 = console).error.apply(_console7, params);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Info:
        (_console8 = console).log.apply(_console8, params);
        break;
      default:
        (_console9 = console).log.apply(_console9, params);
        break;
    }
  }
};

var stringifyExtraInfo = function stringifyExtraInfo(extraInfo) {
  if (extraInfo) {
    if (typeof extraInfo === 'object') {
      return JSON.stringify(extraInfo, null, 2);
    }
    return '' + extraInfo;
  }
  return '';
};

var logWithTag = function logWithTag(file, method, tag, text) {
  var level = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Info;
  var extraInfo = arguments[5];
  var localOnly = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

  try {
    var logMessage = extraInfo ? text + ': ' + stringifyExtraInfo(extraInfo) : text;
    if (!localOnly) {
      __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"].sendLog({
        file: file,
        level: level,
        method: method,
        tag: tag,
        text: logMessage
      });
    }

    if (extraInfo) {
      logToConsoleBasedOnLogLevel(level, tag + ' | ' + method + ' | ' + text, extraInfo);
    } else {
      logToConsoleBasedOnLogLevel(level, tag + ' | ' + method + ' | ' + text);
    }
  } catch (err) {
    console.error(err);
  }
};

var logXMPPSend = function logXMPPSend(file, method, text) {
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Info;
  var extraInfo = arguments[4];

  logWithTag(file, method, TAG_XMPP_SEND, text, level, extraInfo);
};

var logXMPPReceive = function logXMPPReceive(file, method, text) {
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Info;
  var extraInfo = arguments[4];

  logWithTag(file, method, TAG_XMPP_RECV, text, level, extraInfo);
};

var logXMPPClient = function logXMPPClient(file, method, text) {
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Info;
  var extraInfo = arguments[4];

  logWithTag(file, method, TAG_XMPP_CLIENT, text, level, extraInfo);
};

var logSignaling = function logSignaling(file, method, text) {
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Info;
  var extraInfo = arguments[4];

  logWithTag(file, method, TAG_SIGNALING, text, level, extraInfo);
};

var logChat = function logChat(file, method, text) {
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Info;
  var extraInfo = arguments[4];

  logWithTag(file, method, TAG_CHAT, text, level, extraInfo);
};

var logWebRTC = function logWebRTC(file, method, text) {
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["LogLevel"].Info;
  var extraInfo = arguments[4];

  logWithTag(file, method, TAG_WEBRTC, text, level, extraInfo);
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  log: log,
  info: info,
  error: error,
  warn: warn,
  reportCrash: reportCrash,
  logXMPPSend: logXMPPSend,
  logXMPPReceive: logXMPPReceive,
  logXMPPClient: logXMPPClient,
  logSignaling: logSignaling,
  logWebRTC: logWebRTC,
  logChat: logChat,
  logWithTag: logWithTag,
  TAG_SIGNALING: TAG_SIGNALING,
  TAG_WEBRTC: TAG_WEBRTC,
  TAG_CHAT: TAG_CHAT,
  TAG_XMPP_CLIENT: TAG_XMPP_CLIENT,
  TAG_XMPP_RECV: TAG_XMPP_RECV,
  TAG_XMPP_SEND: TAG_XMPP_SEND
});

/***/ }),

/***/ "cyQs":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("M0Be");
var toAbsoluteIndex = __webpack_require__("Rk1v");
var lengthOfArrayLike = __webpack_require__("SYGT");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function createMethod(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

/***/ }),

/***/ "d4H2":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("AkAO");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "dACh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "dAjQ":
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

module.exports = bytesToUuid;

/***/ }),

/***/ "dEmU":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var uncurryThis = __webpack_require__("PoOm");
var fails = __webpack_require__("rtOw");
var classof = __webpack_require__("UNYT");

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;

/***/ }),

/***/ "dNrY":
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

/***/ }),

/***/ "dXs8":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("b1tA");
module.exports = __webpack_require__("zKeE").Object.setPrototypeOf;

/***/ }),

/***/ "dYQv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.default = createPrefixer;

var _getBrowserInformation = __webpack_require__("EBZy");

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__("g3tO");

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__("/eMc");

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _addNewValuesOnly = __webpack_require__("Z54K");

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__("Vrbh");

var _isObject2 = _interopRequireDefault(_isObject);

var _prefixValue = __webpack_require__("TUng");

var _prefixValue2 = _interopRequireDefault(_prefixValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
    return style;
  };

  return function () {
    /**
    * Instantiante a new prefixer
    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
    * @param {string} keepUnprefixed - keeps unprefixed properties and values
    */
    function Prefixer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Prefixer);

      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

      this._userAgent = options.userAgent || defaultUserAgent;
      this._keepUnprefixed = options.keepUnprefixed || false;

      if (this._userAgent) {
        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
      }

      // Checks if the userAgent was resolved correctly
      if (this._browserInfo && this._browserInfo.cssPrefix) {
        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
      } else {
        this._useFallback = true;
        return false;
      }

      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
      if (prefixData) {
        this._requiresPrefix = {};

        for (var property in prefixData) {
          if (prefixData[property] >= this._browserInfo.browserVersion) {
            this._requiresPrefix[property] = true;
          }
        }

        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
      } else {
        this._useFallback = true;
      }

      this._metaData = {
        browserVersion: this._browserInfo.browserVersion,
        browserName: this._browserInfo.browserName,
        cssPrefix: this._browserInfo.cssPrefix,
        jsPrefix: this._browserInfo.jsPrefix,
        keepUnprefixed: this._keepUnprefixed,
        requiresPrefix: this._requiresPrefix
      };
    }

    _createClass(Prefixer, [{
      key: 'prefix',
      value: function prefix(style) {
        // use static prefixer as fallback if userAgent can not be resolved
        if (this._useFallback) {
          return fallback(style);
        }

        // only add prefixes if needed
        if (!this._hasPropsRequiringPrefix) {
          return style;
        }

        return this._prefixStyle(style);
      }
    }, {
      key: '_prefixStyle',
      value: function _prefixStyle(style) {
        for (var property in style) {
          var value = style[property];

          // handle nested objects
          if ((0, _isObject2.default)(value)) {
            style[property] = this.prefix(value);
            // handle array values
          } else if (Array.isArray(value)) {
            var combinedValue = [];

            for (var i = 0, len = value.length; i < len; ++i) {
              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
            }

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (combinedValue.length > 0) {
              style[property] = combinedValue;
            }
          } else {
            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (_processedValue) {
              style[property] = _processedValue;
            }

            // add prefixes to properties
            if (this._requiresPrefix.hasOwnProperty(property)) {
              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
              if (!this._keepUnprefixed) {
                delete style[property];
              }
            }
          }
        }

        return style;
      }

      /**
      * Returns a prefixed version of the style object using all vendor prefixes
      * @param {Object} styles - Style object that gets prefixed properties added
      * @returns {Object} - Style object with prefixed properties and values
      */

    }], [{
      key: 'prefixAll',
      value: function prefixAll(styles) {
        return fallback(styles);
      }
    }]);

    return Prefixer;
  }();
}
module.exports = exports['default'];

/***/ }),

/***/ "dhak":
/***/ (function(module, exports) {

module.exports = {};

/***/ }),

/***/ "ds2O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return http; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return httpWithRetry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__("hYHi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_p_retry__ = __webpack_require__("JFC8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_p_retry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_p_retry__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable import/prefer-default-export */




var EMPTY_JSON = '{}';

var ApiError = function (_Error) {
  _inherits(ApiError, _Error);

  function ApiError(message, internalError) {
    _classCallCheck(this, ApiError);

    var _this = _possibleConstructorReturn(this, _Error.call(this, message));

    _this.internalError = internalError;
    return _this;
  }

  return ApiError;
}(Error);

var checkIfResponseError = function checkIfResponseError(response) {
  return response.status < 200 || response.status >= 300;
};

var handleResponse = function handleResponse(response) {
  var responseError = checkIfResponseError(response);

  return responseError ? response.text() : response.status !== 204 ? response.json() : EMPTY_JSON;
};

var handleResponseData = function handleResponseData(data) {
  var response = null;
  var errorMessage = 'Something went wrong';
  if (data) {
    try {
      response = JSON.parse('' + data);
    } catch (e) {
      response = data;
    }
    var responseError = checkIfResponseError(response);

    if (responseError) {
      throw new ApiError(response.message, response.internalError);
    }
  } else {
    throw errorMessage;
  }

  return response;
};

var handleError = function handleError(errorMessage) {
  if (errorMessage instanceof Error && errorMessage.internalError) {
    // eslint-disable-next-line no-throw-literal
    throw {
      id: __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()(),
      message: errorMessage.message,
      internalError: errorMessage.internalError
    };
  }

  var message = errorMessage;

  if (typeof errorMessage === 'object') {
    message = errorMessage.message;
  }

  // eslint-disable-next-line no-throw-literal
  throw {
    id: __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()(),
    message: message
  };
};

var isUnrecoverableError = function isUnrecoverableError(status) {
  return status === 401 || status === 403 || status === 404 || status === 500;
};

var http = function http(URL) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetch(URL, options).then(handleResponse).then(handleResponseData).catch(handleError);
};

var httpWithRetry = function httpWithRetry(URL) {
  var $args = arguments;return new Promise(function ($return, $error) {
    var options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
    var retryOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
    return $return(__WEBPACK_IMPORTED_MODULE_1_p_retry___default()(function () {
      return new Promise(function ($return, $error) {
        var response, content, parsedResponse;
        return Promise.resolve(fetch(URL, options)).then(function ($await_3) {
          try {
            response = $await_3;

            if (isUnrecoverableError(response.status)) {
              return $error(new __WEBPACK_IMPORTED_MODULE_1_p_retry__["AbortError"](response.statusText));
            }

            return Promise.resolve(handleResponse(response)).then(function ($await_4) {
              try {
                content = $await_4;
                parsedResponse = null;

                try {
                  parsedResponse = handleResponseData(content);
                } catch (err) {
                  handleError(err);
                }

                return $return(parsedResponse);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }, retryOptions));
  });
};

/***/ }),

/***/ "dtN7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__("rQKw");

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};

var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true

  // TODO: chrome & opera support it
};function sizing(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "dvJf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9dc396fc0bcb57f7ef062ffd76fc0c69.png";

/***/ }),

/***/ "dwtN":
/***/ (function(module, exports, __webpack_require__) {

/*! UIkit 3.9.4 | https://www.getuikit.com | (c) 2014 - 2021 YOOtheme | MIT License */

(function (global, factory) {
     true ? module.exports = factory() : typeof define === 'function' && define.amd ? define('uikiticons', factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.UIkitIcons = factory());
})(this, function () {
    'use strict';

    function plugin(UIkit) {

        if (plugin.installed) {
            return;
        }

        UIkit.icon.add({
            "500px": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.624,11.866c-0.141,0.132,0.479,0.658,0.662,0.418c0.051-0.046,0.607-0.61,0.662-0.664c0,0,0.738,0.719,0.814,0.719 c0.1,0,0.207-0.055,0.322-0.17c0.27-0.269,0.135-0.416,0.066-0.495l-0.631-0.616l0.658-0.668c0.146-0.156,0.021-0.314-0.1-0.449 c-0.182-0.18-0.359-0.226-0.471-0.125l-0.656,0.654l-0.654-0.654c-0.033-0.034-0.08-0.045-0.124-0.045 c-0.079,0-0.191,0.068-0.307,0.181c-0.202,0.202-0.247,0.351-0.133,0.462l0.665,0.665L9.624,11.866z\"/><path d=\"M11.066,2.884c-1.061,0-2.185,0.248-3.011,0.604c-0.087,0.034-0.141,0.106-0.15,0.205C7.893,3.784,7.919,3.909,7.982,4.066 c0.05,0.136,0.187,0.474,0.452,0.372c0.844-0.326,1.779-0.507,2.633-0.507c0.963,0,1.9,0.191,2.781,0.564 c0.695,0.292,1.357,0.719,2.078,1.34c0.051,0.044,0.105,0.068,0.164,0.068c0.143,0,0.273-0.137,0.389-0.271 c0.191-0.214,0.324-0.395,0.135-0.575c-0.686-0.654-1.436-1.138-2.363-1.533C13.24,3.097,12.168,2.884,11.066,2.884z\"/><path d=\"M16.43,15.747c-0.092-0.028-0.242,0.05-0.309,0.119l0,0c-0.652,0.652-1.42,1.169-2.268,1.521 c-0.877,0.371-1.814,0.551-2.779,0.551c-0.961,0-1.896-0.189-2.775-0.564c-0.848-0.36-1.612-0.879-2.268-1.53 c-0.682-0.688-1.196-1.455-1.529-2.268c-0.325-0.799-0.471-1.643-0.471-1.643c-0.045-0.24-0.258-0.249-0.567-0.203 c-0.128,0.021-0.519,0.079-0.483,0.36v0.01c0.105,0.644,0.289,1.284,0.545,1.895c0.417,0.969,1.002,1.849,1.756,2.604 c0.757,0.754,1.636,1.34,2.604,1.757C8.901,18.785,9.97,19,11.088,19c1.104,0,2.186-0.215,3.188-0.645 c1.838-0.896,2.604-1.757,2.604-1.757c0.182-0.204,0.227-0.317-0.1-0.643C16.779,15.956,16.525,15.774,16.43,15.747z\"/><path d=\"M5.633,13.287c0.293,0.71,0.723,1.341,1.262,1.882c0.54,0.54,1.172,0.971,1.882,1.264c0.731,0.303,1.509,0.461,2.298,0.461 c0.801,0,1.578-0.158,2.297-0.461c0.711-0.293,1.344-0.724,1.883-1.264c0.543-0.541,0.971-1.172,1.264-1.882 c0.314-0.721,0.463-1.5,0.463-2.298c0-0.79-0.148-1.569-0.463-2.289c-0.293-0.699-0.721-1.329-1.264-1.881 c-0.539-0.541-1.172-0.959-1.867-1.263c-0.721-0.303-1.5-0.461-2.299-0.461c-0.802,0-1.613,0.159-2.322,0.461 c-0.577,0.25-1.544,0.867-2.119,1.454v0.012V2.108h8.16C15.1,2.104,15.1,1.69,15.1,1.552C15.1,1.417,15.1,1,14.809,1H5.915 C5.676,1,5.527,1.192,5.527,1.384v6.84c0,0.214,0.273,0.372,0.529,0.428c0.5,0.105,0.614-0.056,0.737-0.224l0,0 c0.18-0.273,0.776-0.884,0.787-0.894c0.901-0.905,2.117-1.408,3.416-1.408c1.285,0,2.5,0.501,3.412,1.408 c0.914,0.914,1.408,2.122,1.408,3.405c0,1.288-0.508,2.496-1.408,3.405c-0.9,0.896-2.152,1.406-3.438,1.406 c-0.877,0-1.711-0.229-2.433-0.671v-4.158c0-0.553,0.237-1.151,0.643-1.614c0.462-0.519,1.094-0.799,1.782-0.799 c0.664,0,1.293,0.253,1.758,0.715c0.459,0.459,0.709,1.071,0.709,1.723c0,1.385-1.094,2.468-2.488,2.468 c-0.273,0-0.769-0.121-0.781-0.125c-0.281-0.087-0.405,0.306-0.438,0.436c-0.159,0.496,0.079,0.585,0.123,0.607 c0.452,0.137,0.743,0.157,1.129,0.157c1.973,0,3.572-1.6,3.572-3.57c0-1.964-1.6-3.552-3.572-3.552c-0.97,0-1.872,0.36-2.546,1.038 c-0.656,0.631-1.027,1.487-1.027,2.322v3.438v-0.011c-0.372-0.42-0.732-1.041-0.981-1.682c-0.102-0.248-0.315-0.202-0.607-0.113 c-0.135,0.035-0.519,0.157-0.44,0.439C5.372,12.799,5.577,13.164,5.633,13.287z\"/></svg>",
            "album": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"5\" y=\"2\" width=\"10\" height=\"1\"/><rect x=\"3\" y=\"4\" width=\"14\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"6.5\" width=\"17\" height=\"11\"/></svg>",
            "arrow-down": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66\"/><line fill=\"none\" stroke=\"#000\" x1=\"10.5\" y1=\"4\" x2=\"10.5\" y2=\"15\"/></svg>",
            "arrow-left": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"10 14 5 9.5 10 5\"/><line fill=\"none\" stroke=\"#000\" x1=\"16\" y1=\"9.5\" x2=\"5\" y2=\"9.52\"/></svg>",
            "arrow-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"10 5 15 9.5 10 14\"/><line fill=\"none\" stroke=\"#000\" x1=\"4\" y1=\"9.5\" x2=\"15\" y2=\"9.5\"/></svg>",
            "arrow-up": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4\"/><line fill=\"none\" stroke=\"#000\" x1=\"10.5\" y1=\"16\" x2=\"10.5\" y2=\"5\"/></svg>",
            "bag": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M7.5,7.5V4A2.48,2.48,0,0,1,10,1.5,2.54,2.54,0,0,1,12.5,4V7.5\"/><polygon fill=\"none\" stroke=\"#000\" points=\"16.5 7.5 3.5 7.5 2.5 18.5 17.5 18.5 16.5 7.5\"/></svg>",
            "ban": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"4\" y1=\"3.5\" x2=\"16\" y2=\"16.5\"/></svg>",
            "behance": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.5,10.6c-0.4-0.5-0.9-0.9-1.6-1.1c1.7-1,2.2-3.2,0.7-4.7C7.8,4,6.3,4,5.2,4C3.5,4,1.7,4,0,4v12c1.7,0,3.4,0,5.2,0 c1,0,2.1,0,3.1-0.5C10.2,14.6,10.5,12.3,9.5,10.6L9.5,10.6z M5.6,6.1c1.8,0,1.8,2.7-0.1,2.7c-1,0-2,0-2.9,0V6.1H5.6z M2.6,13.8v-3.1 c1.1,0,2.1,0,3.2,0c2.1,0,2.1,3.2,0.1,3.2L2.6,13.8z\"/><path d=\"M19.9,10.9C19.7,9.2,18.7,7.6,17,7c-4.2-1.3-7.3,3.4-5.3,7.1c0.9,1.7,2.8,2.3,4.7,2.1c1.7-0.2,2.9-1.3,3.4-2.9h-2.2 c-0.4,1.3-2.4,1.5-3.5,0.6c-0.4-0.4-0.6-1.1-0.6-1.7H20C20,11.7,19.9,10.9,19.9,10.9z M13.5,10.6c0-1.6,2.3-2.7,3.5-1.4 c0.4,0.4,0.5,0.9,0.6,1.4H13.5L13.5,10.6z\"/><rect x=\"13\" y=\"4\" width=\"5\" height=\"1.4\"/></svg>",
            "bell": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M17,15.5 L3,15.5 C2.99,14.61 3.79,13.34 4.1,12.51 C4.58,11.3 4.72,10.35 5.19,7.01 C5.54,4.53 5.89,3.2 7.28,2.16 C8.13,1.56 9.37,1.5 9.81,1.5 L9.96,1.5 C9.96,1.5 11.62,1.41 12.67,2.17 C14.08,3.2 14.42,4.54 14.77,7.02 C15.26,10.35 15.4,11.31 15.87,12.52 C16.2,13.34 17.01,14.61 17,15.5 L17,15.5 Z\"/><path fill=\"none\" stroke=\"#000\" d=\"M12.39,16 C12.39,17.37 11.35,18.43 9.91,18.43 C8.48,18.43 7.42,17.37 7.42,16\"/></svg>",
            "bold": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5,15.3 C5.66,15.3 5.9,15 5.9,14.53 L5.9,5.5 C5.9,4.92 5.56,4.7 5,4.7 L5,4 L8.95,4 C12.6,4 13.7,5.37 13.7,6.9 C13.7,7.87 13.14,9.17 10.86,9.59 L10.86,9.7 C13.25,9.86 14.29,11.28 14.3,12.54 C14.3,14.47 12.94,16 9,16 L5,16 L5,15.3 Z M9,9.3 C11.19,9.3 11.8,8.5 11.85,7 C11.85,5.65 11.3,4.8 9,4.8 L7.67,4.8 L7.67,9.3 L9,9.3 Z M9.185,15.22 C11.97,15 12.39,14 12.4,12.58 C12.4,11.15 11.39,10 9,10 L7.67,10 L7.67,15 L9.18,15 Z\"/></svg>",
            "bolt": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.74,20 L7.73,12 L3,12 L15.43,1 L12.32,9 L17.02,9 L4.74,20 L4.74,20 L4.74,20 Z M9.18,11 L7.1,16.39 L14.47,10 L10.86,10 L12.99,4.67 L5.61,11 L9.18,11 L9.18,11 L9.18,11 Z\"/></svg>",
            "bookmark": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"5.5 1.5 15.5 1.5 15.5 17.5 10.5 12.5 5.5 17.5\"/></svg>",
            "calendar": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M 2,3 2,17 18,17 18,3 2,3 Z M 17,16 3,16 3,8 17,8 17,16 Z M 17,7 3,7 3,4 17,4 17,7 Z\"/><rect width=\"1\" height=\"3\" x=\"6\" y=\"2\"/><rect width=\"1\" height=\"3\" x=\"13\" y=\"2\"/></svg>",
            "camera": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10.8\" r=\"3.8\"/><path fill=\"none\" stroke=\"#000\" d=\"M1,4.5 C0.7,4.5 0.5,4.7 0.5,5 L0.5,17 C0.5,17.3 0.7,17.5 1,17.5 L19,17.5 C19.3,17.5 19.5,17.3 19.5,17 L19.5,5 C19.5,4.7 19.3,4.5 19,4.5 L13.5,4.5 L13.5,2.9 C13.5,2.6 13.3,2.5 13,2.5 L7,2.5 C6.7,2.5 6.5,2.6 6.5,2.9 L6.5,4.5 L1,4.5 L1,4.5 Z\"/></svg>",
            "cart": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"7.3\" cy=\"17.3\" r=\"1.4\"/><circle cx=\"13.3\" cy=\"17.3\" r=\"1.4\"/><polyline fill=\"none\" stroke=\"#000\" points=\"0 2 3.2 4 5.3 12.5 16 12.5 18 6.5 8 6.5\"/></svg>",
            "check": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" points=\"4,10 8,15 17,4\"/></svg>",
            "chevron-double-left": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"10 14 6 10 10 6\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"14 14 10 10 14 6\"/></svg>",
            "chevron-double-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"10 6 14 10 10 14\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"6 6 10 10 6 14\"/></svg>",
            "chevron-down": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"16 7 10 13 4 7\"/></svg>",
            "chevron-left": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"13 16 7 10 13 4\"/></svg>",
            "chevron-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"7 4 13 10 7 16\"/></svg>",
            "chevron-up": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"4 13 10 7 16 13\"/></svg>",
            "clock": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/><rect x=\"9\" y=\"4\" width=\"1\" height=\"7\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M13.018,14.197 L9.445,10.625\"/></svg>",
            "close": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.06\" d=\"M16,16 L4,4\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.06\" d=\"M16,4 L4,16\"/></svg>",
            "cloud-download": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M6.5,14.61 L3.75,14.61 C1.96,14.61 0.5,13.17 0.5,11.39 C0.5,9.76 1.72,8.41 3.3,8.2 C3.38,5.31 5.75,3 8.68,3 C11.19,3 13.31,4.71 13.89,7.02 C14.39,6.8 14.93,6.68 15.5,6.68 C17.71,6.68 19.5,8.45 19.5,10.64 C19.5,12.83 17.71,14.6 15.5,14.6 L12.5,14.6\"/><polyline fill=\"none\" stroke=\"#000\" points=\"11.75 16 9.5 18.25 7.25 16\"/><path fill=\"none\" stroke=\"#000\" d=\"M9.5,18 L9.5,9.5\"/></svg>",
            "cloud-upload": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M6.5,14.61 L3.75,14.61 C1.96,14.61 0.5,13.17 0.5,11.39 C0.5,9.76 1.72,8.41 3.31,8.2 C3.38,5.31 5.75,3 8.68,3 C11.19,3 13.31,4.71 13.89,7.02 C14.39,6.8 14.93,6.68 15.5,6.68 C17.71,6.68 19.5,8.45 19.5,10.64 C19.5,12.83 17.71,14.6 15.5,14.6 L12.5,14.6\"/><polyline fill=\"none\" stroke=\"#000\" points=\"7.25 11.75 9.5 9.5 11.75 11.75\"/><path fill=\"none\" stroke=\"#000\" d=\"M9.5,18 L9.5,9.5\"/></svg>",
            "code": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"13,4 19,10 13,16\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"7,4 1,10 7,16\"/></svg>",
            "cog": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" cx=\"9.997\" cy=\"10\" r=\"3.31\"/><path fill=\"none\" stroke=\"#000\" d=\"M18.488,12.285 L16.205,16.237 C15.322,15.496 14.185,15.281 13.303,15.791 C12.428,16.289 12.047,17.373 12.246,18.5 L7.735,18.5 C7.938,17.374 7.553,16.299 6.684,15.791 C5.801,15.27 4.655,15.492 3.773,16.237 L1.5,12.285 C2.573,11.871 3.317,10.999 3.317,9.991 C3.305,8.98 2.573,8.121 1.5,7.716 L3.765,3.784 C4.645,4.516 5.794,4.738 6.687,4.232 C7.555,3.722 7.939,2.637 7.735,1.5 L12.263,1.5 C12.072,2.637 12.441,3.71 13.314,4.22 C14.206,4.73 15.343,4.516 16.225,3.794 L18.487,7.714 C17.404,8.117 16.661,8.988 16.67,10.009 C16.672,11.018 17.415,11.88 18.488,12.285 L18.488,12.285 Z\"/></svg>",
            "comment": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6,18.71 L6,14 L1,14 L1,1 L19,1 L19,14 L10.71,14 L6,18.71 L6,18.71 Z M2,13 L7,13 L7,16.29 L10.29,13 L18,13 L18,2 L2,2 L2,13 L2,13 Z\"/></svg>",
            "commenting": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"1.5,1.5 18.5,1.5 18.5,13.5 10.5,13.5 6.5,17.5 6.5,13.5 1.5,13.5\"/><circle cx=\"10\" cy=\"8\" r=\"1\"/><circle cx=\"6\" cy=\"8\" r=\"1\"/><circle cx=\"14\" cy=\"8\" r=\"1\"/></svg>",
            "comments": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"2 0.5 19.5 0.5 19.5 13\"/><path d=\"M5,19.71 L5,15 L0,15 L0,2 L18,2 L18,15 L9.71,15 L5,19.71 L5,19.71 L5,19.71 Z M1,14 L6,14 L6,17.29 L9.29,14 L17,14 L17,3 L1,3 L1,14 L1,14 L1,14 Z\"/></svg>",
            "copy": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"2.5\" width=\"12\" height=\"16\"/><polyline fill=\"none\" stroke=\"#000\" points=\"5 0.5 17.5 0.5 17.5 17\"/></svg>",
            "credit-card": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"4.5\" width=\"17\" height=\"12\"/><rect x=\"1\" y=\"7\" width=\"18\" height=\"3\"/></svg>",
            "database": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><ellipse fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"4.64\" rx=\"7.5\" ry=\"3.14\"/><path fill=\"none\" stroke=\"#000\" d=\"M17.5,8.11 C17.5,9.85 14.14,11.25 10,11.25 C5.86,11.25 2.5,9.84 2.5,8.11\"/><path fill=\"none\" stroke=\"#000\" d=\"M17.5,11.25 C17.5,12.99 14.14,14.39 10,14.39 C5.86,14.39 2.5,12.98 2.5,11.25\"/><path fill=\"none\" stroke=\"#000\" d=\"M17.49,4.64 L17.5,14.36 C17.5,16.1 14.14,17.5 10,17.5 C5.86,17.5 2.5,16.09 2.5,14.36 L2.5,4.64\"/></svg>",
            "desktop": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"8\" y=\"15\" width=\"1\" height=\"2\"/><rect x=\"11\" y=\"15\" width=\"1\" height=\"2\"/><rect x=\"5\" y=\"16\" width=\"10\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"3.5\" width=\"17\" height=\"11\"/></svg>",
            "discord": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M16.074,4.361a14.243,14.243,0,0,0-3.61-1.134,10.61,10.61,0,0,0-.463.96,13.219,13.219,0,0,0-4,0,10.138,10.138,0,0,0-.468-.96A14.206,14.206,0,0,0,3.919,4.364,15.146,15.146,0,0,0,1.324,14.5a14.435,14.435,0,0,0,4.428,2.269A10.982,10.982,0,0,0,6.7,15.21a9.294,9.294,0,0,1-1.494-.727c.125-.093.248-.19.366-.289a10.212,10.212,0,0,0,8.854,0c.119.1.242.2.366.289a9.274,9.274,0,0,1-1.5.728,10.8,10.8,0,0,0,.948,1.562,14.419,14.419,0,0,0,4.431-2.27A15.128,15.128,0,0,0,16.074,4.361Zm-8.981,8.1a1.7,1.7,0,0,1-1.573-1.79A1.689,1.689,0,0,1,7.093,8.881a1.679,1.679,0,0,1,1.573,1.791A1.687,1.687,0,0,1,7.093,12.462Zm5.814,0a1.7,1.7,0,0,1-1.573-1.79,1.689,1.689,0,0,1,1.573-1.791,1.679,1.679,0,0,1,1.573,1.791A1.688,1.688,0,0,1,12.907,12.462Z\"/></svg>",
            "download": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"14,10 9.5,14.5 5,10\"/><rect x=\"3\" y=\"17\" width=\"13\" height=\"1\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"13.91\" x2=\"9.5\" y2=\"3\"/></svg>",
            "dribbble": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" d=\"M1.3,8.9c0,0,5,0.1,8.6-1c1.4-0.4,2.6-0.9,4-1.9 c1.4-1.1,2.5-2.5,2.5-2.5\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" d=\"M3.9,16.6c0,0,1.7-2.8,3.5-4.2 c1.8-1.3,4-2,5.7-2.2C16,10,19,10.6,19,10.6\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" d=\"M6.9,1.6c0,0,3.3,4.6,4.2,6.8 c0.4,0.9,1.3,3.1,1.9,5.2c0.6,2,0.9,4.4,0.9,4.4\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" cx=\"10\" cy=\"10\" r=\"9\"/></svg>",
            "etsy": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M8,4.26C8,4.07,8,4,8.31,4h4.46c.79,0,1.22.67,1.53,1.91l.25,1h.76c.14-2.82.26-4,.26-4S13.65,3,12.52,3H6.81L3.75,2.92v.84l1,.2c.73.11.9.27,1,1,0,0,.06,2,.06,5.17s-.06,5.14-.06,5.14c0,.59-.23.81-1,.94l-1,.2v.84l3.06-.1h5.11c1.15,0,3.82.1,3.82.1,0-.7.45-3.88.51-4.22h-.73l-.76,1.69a2.25,2.25,0,0,1-2.45,1.47H9.4c-1,0-1.44-.4-1.44-1.24V10.44s2.16,0,2.86.06c.55,0,.85.19,1.06,1l.23,1H13L12.9,9.94,13,7.41h-.85l-.28,1.13c-.16.74-.28.84-1,1-1,.1-2.89.09-2.89.09Z\"/></svg>",
            "expand": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"13 2 18 2 18 7 17 7 17 3 13 3\"/><polygon points=\"2 13 3 13 3 17 7 17 7 18 2 18\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M11,9 L17,3\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M3,17 L9,11\"/></svg>",
            "facebook": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11,10h2.6l0.4-3H11V5.3c0-0.9,0.2-1.5,1.5-1.5H14V1.1c-0.3,0-1-0.1-2.1-0.1C9.6,1,8,2.4,8,5v2H5.5v3H8v8h3V10z\"/></svg>",
            "file-edit": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M18.65,1.68 C18.41,1.45 18.109,1.33 17.81,1.33 C17.499,1.33 17.209,1.45 16.98,1.68 L8.92,9.76 L8,12.33 L10.55,11.41 L18.651,3.34 C19.12,2.87 19.12,2.15 18.65,1.68 L18.65,1.68 L18.65,1.68 Z\"/><polyline fill=\"none\" stroke=\"#000\" points=\"16.5 8.482 16.5 18.5 3.5 18.5 3.5 1.5 14.211 1.5\"/></svg>",
            "file-pdf": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" width=\"13\" height=\"17\" x=\"3.5\" y=\"1.5\"/><path d=\"M14.65 11.67c-.48.3-1.37-.19-1.79-.37a4.65 4.65 0 0 1 1.49.06c.35.1.36.28.3.31zm-6.3.06l.43-.79a14.7 14.7 0 0 0 .75-1.64 5.48 5.48 0 0 0 1.25 1.55l.2.15a16.36 16.36 0 0 0-2.63.73zM9.5 5.32c.2 0 .32.5.32.97a1.99 1.99 0 0 1-.23 1.04 5.05 5.05 0 0 1-.17-1.3s0-.71.08-.71zm-3.9 9a4.35 4.35 0 0 1 1.21-1.46l.24-.22a4.35 4.35 0 0 1-1.46 1.68zm9.23-3.3a2.05 2.05 0 0 0-1.32-.3 11.07 11.07 0 0 0-1.58.11 4.09 4.09 0 0 1-.74-.5 5.39 5.39 0 0 1-1.32-2.06 10.37 10.37 0 0 0 .28-2.62 1.83 1.83 0 0 0-.07-.25.57.57 0 0 0-.52-.4H9.4a.59.59 0 0 0-.6.38 6.95 6.95 0 0 0 .37 3.14c-.26.63-1 2.12-1 2.12-.3.58-.57 1.08-.82 1.5l-.8.44A3.11 3.11 0 0 0 5 14.16a.39.39 0 0 0 .15.42l.24.13c1.15.56 2.28-1.74 2.66-2.42a23.1 23.1 0 0 1 3.59-.85 4.56 4.56 0 0 0 2.91.8.5.5 0 0 0 .3-.21 1.1 1.1 0 0 0 .12-.75.84.84 0 0 0-.14-.25z\"/></svg>",
            "file-text": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" width=\"13\" height=\"17\" x=\"3.5\" y=\"1.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"6\" x2=\"12\" y1=\"12.5\" y2=\"12.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"6\" x2=\"14\" y1=\"8.5\" y2=\"8.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"6\" x2=\"14\" y1=\"6.5\" y2=\"6.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"6\" x2=\"14\" y1=\"10.5\" y2=\"10.5\"/></svg>",
            "file": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"1.5\" width=\"13\" height=\"17\"/></svg>",
            "flickr": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"5.5\" cy=\"9.5\" r=\"3.5\"/><circle cx=\"14.5\" cy=\"9.5\" r=\"3.5\"/></svg>",
            "folder": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"9.5 5.5 8.5 3.5 1.5 3.5 1.5 16.5 18.5 16.5 18.5 5.5\"/></svg>",
            "forward": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.47,13.11 C4.02,10.02 6.27,7.85 9.04,6.61 C9.48,6.41 10.27,6.13 11,5.91 L11,2 L18.89,9 L11,16 L11,12.13 C9.25,12.47 7.58,13.19 6.02,14.25 C3.03,16.28 1.63,18.54 1.63,18.54 C1.63,18.54 1.38,15.28 2.47,13.11 L2.47,13.11 Z M5.3,13.53 C6.92,12.4 9.04,11.4 12,10.92 L12,13.63 L17.36,9 L12,4.25 L12,6.8 C11.71,6.86 10.86,7.02 9.67,7.49 C6.79,8.65 4.58,10.96 3.49,13.08 C3.18,13.7 2.68,14.87 2.49,16 C3.28,15.05 4.4,14.15 5.3,13.53 L5.3,13.53 Z\"/></svg>",
            "foursquare": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.23,2 C15.96,2 16.4,2.41 16.5,2.86 C16.57,3.15 16.56,3.44 16.51,3.73 C16.46,4.04 14.86,11.72 14.75,12.03 C14.56,12.56 14.16,12.82 13.61,12.83 C13.03,12.84 11.09,12.51 10.69,13 C10.38,13.38 7.79,16.39 6.81,17.53 C6.61,17.76 6.4,17.96 6.08,17.99 C5.68,18.04 5.29,17.87 5.17,17.45 C5.12,17.28 5.1,17.09 5.1,16.91 C5.1,12.4 4.86,7.81 5.11,3.31 C5.17,2.5 5.81,2.12 6.53,2 L15.23,2 L15.23,2 Z M9.76,11.42 C9.94,11.19 10.17,11.1 10.45,11.1 L12.86,11.1 C13.12,11.1 13.31,10.94 13.36,10.69 C13.37,10.64 13.62,9.41 13.74,8.83 C13.81,8.52 13.53,8.28 13.27,8.28 C12.35,8.29 11.42,8.28 10.5,8.28 C9.84,8.28 9.83,7.69 9.82,7.21 C9.8,6.85 10.13,6.55 10.5,6.55 C11.59,6.56 12.67,6.55 13.76,6.55 C14.03,6.55 14.23,6.4 14.28,6.14 C14.34,5.87 14.67,4.29 14.67,4.29 C14.67,4.29 14.82,3.74 14.19,3.74 L7.34,3.74 C7,3.75 6.84,4.02 6.84,4.33 C6.84,7.58 6.85,14.95 6.85,14.99 C6.87,15 8.89,12.51 9.76,11.42 L9.76,11.42 Z\"/></svg>",
            "future": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline points=\"19 2 18 2 18 6 14 6 14 7 19 7 19 2\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M18,6.548 C16.709,3.29 13.354,1 9.6,1 C4.6,1 0.6,5 0.6,10 C0.6,15 4.6,19 9.6,19 C14.6,19 18.6,15 18.6,10\"/><rect x=\"9\" y=\"4\" width=\"1\" height=\"7\"/><path d=\"M13.018,14.197 L9.445,10.625\" fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\"/></svg>",
            "git-branch": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"7\" cy=\"3\" r=\"2\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"14\" cy=\"6\" r=\"2\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"7\" cy=\"17\" r=\"2\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"2\" d=\"M14,8 C14,10.41 12.43,10.87 10.56,11.25 C9.09,11.54 7,12.06 7,15 L7,5\"/></svg>",
            "git-fork": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"5.79\" cy=\"2.79\" r=\"1.79\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"14.19\" cy=\"2.79\" r=\"1.79\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"10.03\" cy=\"16.79\" r=\"1.79\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"2\" d=\"M5.79,4.57 L5.79,6.56 C5.79,9.19 10.03,10.22 10.03,13.31 C10.03,14.86 10.04,14.55 10.04,14.55 C10.04,14.37 10.04,14.86 10.04,13.31 C10.04,10.22 14.2,9.19 14.2,6.56 L14.2,4.57\"/></svg>",
            "github-alt": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10,0.5 C4.75,0.5 0.5,4.76 0.5,10.01 C0.5,15.26 4.75,19.51 10,19.51 C15.24,19.51 19.5,15.26 19.5,10.01 C19.5,4.76 15.25,0.5 10,0.5 L10,0.5 Z M12.81,17.69 C12.81,17.69 12.81,17.7 12.79,17.69 C12.47,17.75 12.35,17.59 12.35,17.36 L12.35,16.17 C12.35,15.45 12.09,14.92 11.58,14.56 C12.2,14.51 12.77,14.39 13.26,14.21 C13.87,13.98 14.36,13.69 14.74,13.29 C15.42,12.59 15.76,11.55 15.76,10.17 C15.76,9.25 15.45,8.46 14.83,7.8 C15.1,7.08 15.07,6.29 14.75,5.44 L14.51,5.42 C14.34,5.4 14.06,5.46 13.67,5.61 C13.25,5.78 12.79,6.03 12.31,6.35 C11.55,6.16 10.81,6.05 10.09,6.05 C9.36,6.05 8.61,6.15 7.88,6.35 C7.28,5.96 6.75,5.68 6.26,5.54 C6.07,5.47 5.9,5.44 5.78,5.44 L5.42,5.44 C5.06,6.29 5.04,7.08 5.32,7.8 C4.7,8.46 4.4,9.25 4.4,10.17 C4.4,11.94 4.96,13.16 6.08,13.84 C6.53,14.13 7.05,14.32 7.69,14.43 C8.03,14.5 8.32,14.54 8.55,14.55 C8.07,14.89 7.82,15.42 7.82,16.16 L7.82,17.51 C7.8,17.69 7.7,17.8 7.51,17.8 C4.21,16.74 1.82,13.65 1.82,10.01 C1.82,5.5 5.49,1.83 10,1.83 C14.5,1.83 18.17,5.5 18.17,10.01 C18.18,13.53 15.94,16.54 12.81,17.69 L12.81,17.69 Z\"/></svg>",
            "github": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10,1 C5.03,1 1,5.03 1,10 C1,13.98 3.58,17.35 7.16,18.54 C7.61,18.62 7.77,18.34 7.77,18.11 C7.77,17.9 7.76,17.33 7.76,16.58 C5.26,17.12 4.73,15.37 4.73,15.37 C4.32,14.33 3.73,14.05 3.73,14.05 C2.91,13.5 3.79,13.5 3.79,13.5 C4.69,13.56 5.17,14.43 5.17,14.43 C5.97,15.8 7.28,15.41 7.79,15.18 C7.87,14.6 8.1,14.2 8.36,13.98 C6.36,13.75 4.26,12.98 4.26,9.53 C4.26,8.55 4.61,7.74 5.19,7.11 C5.1,6.88 4.79,5.97 5.28,4.73 C5.28,4.73 6.04,4.49 7.75,5.65 C8.47,5.45 9.24,5.35 10,5.35 C10.76,5.35 11.53,5.45 12.25,5.65 C13.97,4.48 14.72,4.73 14.72,4.73 C15.21,5.97 14.9,6.88 14.81,7.11 C15.39,7.74 15.73,8.54 15.73,9.53 C15.73,12.99 13.63,13.75 11.62,13.97 C11.94,14.25 12.23,14.8 12.23,15.64 C12.23,16.84 12.22,17.81 12.22,18.11 C12.22,18.35 12.38,18.63 12.84,18.54 C16.42,17.35 19,13.98 19,10 C19,5.03 14.97,1 10,1 L10,1 Z\"/></svg>",
            "gitter": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3.5\" y=\"1\" width=\"1.531\" height=\"11.471\"/><rect x=\"7.324\" y=\"4.059\" width=\"1.529\" height=\"15.294\"/><rect x=\"11.148\" y=\"4.059\" width=\"1.527\" height=\"15.294\"/><rect x=\"14.971\" y=\"4.059\" width=\"1.529\" height=\"8.412\"/></svg>",
            "google": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.86,9.09 C18.46,12.12 17.14,16.05 13.81,17.56 C9.45,19.53 4.13,17.68 2.47,12.87 C0.68,7.68 4.22,2.42 9.5,2.03 C11.57,1.88 13.42,2.37 15.05,3.65 C15.22,3.78 15.37,3.93 15.61,4.14 C14.9,4.81 14.23,5.45 13.5,6.14 C12.27,5.08 10.84,4.72 9.28,4.98 C8.12,5.17 7.16,5.76 6.37,6.63 C4.88,8.27 4.62,10.86 5.76,12.82 C6.95,14.87 9.17,15.8 11.57,15.25 C13.27,14.87 14.76,13.33 14.89,11.75 L10.51,11.75 L10.51,9.09 L17.86,9.09 L17.86,9.09 Z\"/></svg>",
            "grid": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"2\" y=\"2\" width=\"3\" height=\"3\"/><rect x=\"8\" y=\"2\" width=\"3\" height=\"3\"/><rect x=\"14\" y=\"2\" width=\"3\" height=\"3\"/><rect x=\"2\" y=\"8\" width=\"3\" height=\"3\"/><rect x=\"8\" y=\"8\" width=\"3\" height=\"3\"/><rect x=\"14\" y=\"8\" width=\"3\" height=\"3\"/><rect x=\"2\" y=\"14\" width=\"3\" height=\"3\"/><rect x=\"8\" y=\"14\" width=\"3\" height=\"3\"/><rect x=\"14\" y=\"14\" width=\"3\" height=\"3\"/></svg>",
            "happy": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"13\" cy=\"7\" r=\"1\"/><circle cx=\"7\" cy=\"7\" r=\"1\"/><circle fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"10\" r=\"8.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M14.6,11.4 C13.9,13.3 12.1,14.5 10,14.5 C7.9,14.5 6.1,13.3 5.4,11.4\"/></svg>",
            "hashtag": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.431,8 L15.661,7 L12.911,7 L13.831,3 L12.901,3 L11.98,7 L9.29,7 L10.21,3 L9.281,3 L8.361,7 L5.23,7 L5,8 L8.13,8 L7.21,12 L4.23,12 L4,13 L6.98,13 L6.061,17 L6.991,17 L7.911,13 L10.601,13 L9.681,17 L10.611,17 L11.531,13 L14.431,13 L14.661,12 L11.76,12 L12.681,8 L15.431,8 Z M10.831,12 L8.141,12 L9.061,8 L11.75,8 L10.831,12 Z\"/></svg>",
            "heart": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" d=\"M10,4 C10,4 8.1,2 5.74,2 C3.38,2 1,3.55 1,6.73 C1,8.84 2.67,10.44 2.67,10.44 L10,18 L17.33,10.44 C17.33,10.44 19,8.84 19,6.73 C19,3.55 16.62,2 14.26,2 C11.9,2 10,4 10,4 L10,4 Z\"/></svg>",
            "history": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"#000\" points=\"1 2 2 2 2 6 6 6 6 7 1 7 1 2\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M2.1,6.548 C3.391,3.29 6.746,1 10.5,1 C15.5,1 19.5,5 19.5,10 C19.5,15 15.5,19 10.5,19 C5.5,19 1.5,15 1.5,10\"/><rect x=\"9\" y=\"4\" width=\"1\" height=\"7\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M13.018,14.197 L9.445,10.625\"/></svg>",
            "home": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"18.65 11.35 10 2.71 1.35 11.35 0.65 10.65 10 1.29 19.35 10.65\"/><polygon points=\"15 4 18 4 18 7 17 7 17 5 15 5\"/><polygon points=\"3 11 4 11 4 18 7 18 7 12 12 12 12 18 16 18 16 11 17 11 17 19 11 19 11 13 8 13 8 19 3 19\"/></svg>",
            "image": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"16.1\" cy=\"6.1\" r=\"1.1\"/><rect fill=\"none\" stroke=\"#000\" x=\".5\" y=\"2.5\" width=\"19\" height=\"15\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"4,13 8,9 13,14\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"11,12 12.5,10.5 16,14\"/></svg>",
            "info": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/></svg>",
            "instagram": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.55,1H6.46C3.45,1,1,3.44,1,6.44v7.12c0,3,2.45,5.44,5.46,5.44h7.08c3.02,0,5.46-2.44,5.46-5.44V6.44 C19.01,3.44,16.56,1,13.55,1z M17.5,14c0,1.93-1.57,3.5-3.5,3.5H6c-1.93,0-3.5-1.57-3.5-3.5V6c0-1.93,1.57-3.5,3.5-3.5h8 c1.93,0,3.5,1.57,3.5,3.5V14z\"/><circle cx=\"14.87\" cy=\"5.26\" r=\"1.09\"/><path d=\"M10.03,5.45c-2.55,0-4.63,2.06-4.63,4.6c0,2.55,2.07,4.61,4.63,4.61c2.56,0,4.63-2.061,4.63-4.61 C14.65,7.51,12.58,5.45,10.03,5.45L10.03,5.45L10.03,5.45z M10.08,13c-1.66,0-3-1.34-3-2.99c0-1.65,1.34-2.99,3-2.99s3,1.34,3,2.99 C13.08,11.66,11.74,13,10.08,13L10.08,13L10.08,13z\"/></svg>",
            "italic": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.63,5.48 L10.15,14.52 C10,15.08 10.37,15.25 11.92,15.3 L11.72,16 L6,16 L6.2,15.31 C7.78,15.26 8.19,15.09 8.34,14.53 L10.82,5.49 C10.97,4.92 10.63,4.76 9.09,4.71 L9.28,4 L15,4 L14.81,4.69 C13.23,4.75 12.78,4.91 12.63,5.48 L12.63,5.48 Z\"/></svg>",
            "joomla": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.8,13.4l1.7-1.7L5.9,8c-0.6-0.5-0.6-1.5,0-2c0.6-0.6,1.4-0.6,2,0l1.7-1.7c-1-1-2.3-1.3-3.6-1C5.8,2.2,4.8,1.4,3.7,1.4 c-1.3,0-2.3,1-2.3,2.3c0,1.1,0.8,2,1.8,2.3c-0.4,1.3-0.1,2.8,1,3.8L7.8,13.4L7.8,13.4z\"/><path d=\"M10.2,4.3c1-1,2.5-1.4,3.8-1c0.2-1.1,1.1-2,2.3-2c1.3,0,2.3,1,2.3,2.3c0,1.2-0.9,2.2-2,2.3c0.4,1.3,0,2.8-1,3.8L13.9,8 c0.6-0.5,0.6-1.5,0-2c-0.5-0.6-1.5-0.6-2,0L8.2,9.7L6.5,8\"/><path d=\"M14.1,16.8c-1.3,0.4-2.8,0.1-3.8-1l1.7-1.7c0.6,0.6,1.5,0.6,2,0c0.5-0.6,0.6-1.5,0-2l-3.7-3.7L12,6.7l3.7,3.7 c1,1,1.3,2.4,1,3.6c1.1,0.2,2,1.1,2,2.3c0,1.3-1,2.3-2.3,2.3C15.2,18.6,14.3,17.8,14.1,16.8\"/><path d=\"M13.2,12.2l-3.7,3.7c-1,1-2.4,1.3-3.6,1c-0.2,1-1.2,1.8-2.2,1.8c-1.3,0-2.3-1-2.3-2.3c0-1.1,0.8-2,1.8-2.3 c-0.3-1.3,0-2.7,1-3.7l1.7,1.7c-0.6,0.6-0.6,1.5,0,2c0.6,0.6,1.4,0.6,2,0l3.7-3.7\"/></svg>",
            "laptop": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect y=\"16\" width=\"20\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\"2.5\" y=\"4.5\" width=\"15\" height=\"10\"/></svg>",
            "lifesaver": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10,0.5 C4.76,0.5 0.5,4.76 0.5,10 C0.5,15.24 4.76,19.5 10,19.5 C15.24,19.5 19.5,15.24 19.5,10 C19.5,4.76 15.24,0.5 10,0.5 L10,0.5 Z M10,1.5 C11.49,1.5 12.89,1.88 14.11,2.56 L11.85,4.82 C11.27,4.61 10.65,4.5 10,4.5 C9.21,4.5 8.47,4.67 7.79,4.96 L5.58,2.75 C6.87,1.95 8.38,1.5 10,1.5 L10,1.5 Z M4.96,7.8 C4.67,8.48 4.5,9.21 4.5,10 C4.5,10.65 4.61,11.27 4.83,11.85 L2.56,14.11 C1.88,12.89 1.5,11.49 1.5,10 C1.5,8.38 1.95,6.87 2.75,5.58 L4.96,7.79 L4.96,7.8 L4.96,7.8 Z M10,18.5 C8.25,18.5 6.62,17.97 5.27,17.06 L7.46,14.87 C8.22,15.27 9.08,15.5 10,15.5 C10.79,15.5 11.53,15.33 12.21,15.04 L14.42,17.25 C13.13,18.05 11.62,18.5 10,18.5 L10,18.5 Z M10,14.5 C7.52,14.5 5.5,12.48 5.5,10 C5.5,7.52 7.52,5.5 10,5.5 C12.48,5.5 14.5,7.52 14.5,10 C14.5,12.48 12.48,14.5 10,14.5 L10,14.5 Z M15.04,12.21 C15.33,11.53 15.5,10.79 15.5,10 C15.5,9.08 15.27,8.22 14.87,7.46 L17.06,5.27 C17.97,6.62 18.5,8.25 18.5,10 C18.5,11.62 18.05,13.13 17.25,14.42 L15.04,12.21 L15.04,12.21 Z\"/></svg>",
            "link": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M10.625,12.375 L7.525,15.475 C6.825,16.175 5.925,16.175 5.225,15.475 L4.525,14.775 C3.825,14.074 3.825,13.175 4.525,12.475 L7.625,9.375\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M9.325,7.375 L12.425,4.275 C13.125,3.575 14.025,3.575 14.724,4.275 L15.425,4.975 C16.125,5.675 16.125,6.575 15.425,7.275 L12.325,10.375\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M7.925,11.875 L11.925,7.975\"/></svg>",
            "linkedin": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.77,17.89 L5.77,7.17 L2.21,7.17 L2.21,17.89 L5.77,17.89 L5.77,17.89 Z M3.99,5.71 C5.23,5.71 6.01,4.89 6.01,3.86 C5.99,2.8 5.24,2 4.02,2 C2.8,2 2,2.8 2,3.85 C2,4.88 2.77,5.7 3.97,5.7 L3.99,5.7 L3.99,5.71 L3.99,5.71 Z\"/><path d=\"M7.75,17.89 L11.31,17.89 L11.31,11.9 C11.31,11.58 11.33,11.26 11.43,11.03 C11.69,10.39 12.27,9.73 13.26,9.73 C14.55,9.73 15.06,10.71 15.06,12.15 L15.06,17.89 L18.62,17.89 L18.62,11.74 C18.62,8.45 16.86,6.92 14.52,6.92 C12.6,6.92 11.75,7.99 11.28,8.73 L11.3,8.73 L11.3,7.17 L7.75,7.17 C7.79,8.17 7.75,17.89 7.75,17.89 L7.75,17.89 L7.75,17.89 Z\"/></svg>",
            "list": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"6\" y=\"4\" width=\"12\" height=\"1\"/><rect x=\"6\" y=\"9\" width=\"12\" height=\"1\"/><rect x=\"6\" y=\"14\" width=\"12\" height=\"1\"/><rect x=\"2\" y=\"4\" width=\"2\" height=\"1\"/><rect x=\"2\" y=\"9\" width=\"2\" height=\"1\"/><rect x=\"2\" y=\"14\" width=\"2\" height=\"1\"/></svg>",
            "location": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" d=\"M10,0.5 C6.41,0.5 3.5,3.39 3.5,6.98 C3.5,11.83 10,19 10,19 C10,19 16.5,11.83 16.5,6.98 C16.5,3.39 13.59,0.5 10,0.5 L10,0.5 Z\"/><circle fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"6.8\" r=\"2.3\"/></svg>",
            "lock": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" height=\"10\" width=\"13\" y=\"8.5\" x=\"3.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M6.5,8 L6.5,4.88 C6.5,3.01 8.07,1.5 10,1.5 C11.93,1.5 13.5,3.01 13.5,4.88 L13.5,8\"/></svg>",
            "mail": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"1.4,6.5 10,11 18.6,6.5\"/><path d=\"M 1,4 1,16 19,16 19,4 1,4 Z M 18,15 2,15 2,5 18,5 18,15 Z\"/></svg>",
            "menu": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"2\" y=\"4\" width=\"16\" height=\"1\"/><rect x=\"2\" y=\"9\" width=\"16\" height=\"1\"/><rect x=\"2\" y=\"14\" width=\"16\" height=\"1\"/></svg>",
            "microphone": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><line fill=\"none\" stroke=\"#000\" x1=\"10\" x2=\"10\" y1=\"16.44\" y2=\"18.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"7\" x2=\"13\" y1=\"18.5\" y2=\"18.5\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M13.5 4.89v5.87a3.5 3.5 0 0 1-7 0V4.89a3.5 3.5 0 0 1 7 0z\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M15.5 10.36V11a5.5 5.5 0 0 1-11 0v-.6\"/></svg>",
            "minus-circle": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9.5\" cy=\"9.5\" r=\"9\"/><line fill=\"none\" stroke=\"#000\" x1=\"5\" y1=\"9.5\" x2=\"14\" y2=\"9.5\"/></svg>",
            "minus": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect height=\"1\" width=\"18\" y=\"9\" x=\"1\"/></svg>",
            "more-vertical": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"10\" cy=\"3\" r=\"2\"/><circle cx=\"10\" cy=\"10\" r=\"2\"/><circle cx=\"10\" cy=\"17\" r=\"2\"/></svg>",
            "more": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"3\" cy=\"10\" r=\"2\"/><circle cx=\"10\" cy=\"10\" r=\"2\"/><circle cx=\"17\" cy=\"10\" r=\"2\"/></svg>",
            "move": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"4,5 1,5 1,9 2,9 2,6 4,6\"/><polygon points=\"1,16 2,16 2,18 4,18 4,19 1,19\"/><polygon points=\"14,16 14,19 11,19 11,18 13,18 13,16\"/><rect fill=\"none\" stroke=\"#000\" x=\"5.5\" y=\"1.5\" width=\"13\" height=\"13\"/><rect x=\"1\" y=\"11\" width=\"1\" height=\"3\"/><rect x=\"6\" y=\"18\" width=\"3\" height=\"1\"/></svg>",
            "nut": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"2.5,5.7 10,1.3 17.5,5.7 17.5,14.3 10,18.7 2.5,14.3\"/><circle fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"10\" r=\"3.5\"/></svg>",
            "pagekit": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"3,1 17,1 17,16 10,16 10,13 14,13 14,4 6,4 6,16 10,16 10,19 3,19\"/></svg>",
            "paint-bucket": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.21,1 L0,11.21 L8.1,19.31 L18.31,9.1 L10.21,1 L10.21,1 Z M16.89,9.1 L15,11 L1.7,11 L10.21,2.42 L16.89,9.1 Z\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M6.42,2.33 L11.7,7.61\"/><path d=\"M18.49,12 C18.49,12 20,14.06 20,15.36 C20,16.28 19.24,17 18.49,17 L18.49,17 C17.74,17 17,16.28 17,15.36 C17,14.06 18.49,12 18.49,12 L18.49,12 Z\"/></svg>",
            "pencil": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M17.25,6.01 L7.12,16.1 L3.82,17.2 L5.02,13.9 L15.12,3.88 C15.71,3.29 16.66,3.29 17.25,3.88 C17.83,4.47 17.83,5.42 17.25,6.01 L17.25,6.01 Z\"/><path fill=\"none\" stroke=\"#000\" d=\"M15.98,7.268 L13.851,5.148\"/></svg>",
            "phone-landscape": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M17,5.5 C17.8,5.5 18.5,6.2 18.5,7 L18.5,14 C18.5,14.8 17.8,15.5 17,15.5 L3,15.5 C2.2,15.5 1.5,14.8 1.5,14 L1.5,7 C1.5,6.2 2.2,5.5 3,5.5 L17,5.5 L17,5.5 L17,5.5 Z\"/><circle cx=\"3.8\" cy=\"10.5\" r=\".8\"/></svg>",
            "phone": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M15.5,17 C15.5,17.8 14.8,18.5 14,18.5 L7,18.5 C6.2,18.5 5.5,17.8 5.5,17 L5.5,3 C5.5,2.2 6.2,1.5 7,1.5 L14,1.5 C14.8,1.5 15.5,2.2 15.5,3 L15.5,17 L15.5,17 L15.5,17 Z\"/><circle cx=\"10.5\" cy=\"16.5\" r=\".8\"/></svg>",
            "pinterest": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.21,1 C5.5,1 3,4.16 3,7.61 C3,9.21 3.85,11.2 5.22,11.84 C5.43,11.94 5.54,11.89 5.58,11.69 C5.62,11.54 5.8,10.8 5.88,10.45 C5.91,10.34 5.89,10.24 5.8,10.14 C5.36,9.59 5,8.58 5,7.65 C5,5.24 6.82,2.91 9.93,2.91 C12.61,2.91 14.49,4.74 14.49,7.35 C14.49,10.3 13,12.35 11.06,12.35 C9.99,12.35 9.19,11.47 9.44,10.38 C9.75,9.08 10.35,7.68 10.35,6.75 C10.35,5.91 9.9,5.21 8.97,5.21 C7.87,5.21 6.99,6.34 6.99,7.86 C6.99,8.83 7.32,9.48 7.32,9.48 C7.32,9.48 6.24,14.06 6.04,14.91 C5.7,16.35 6.08,18.7 6.12,18.9 C6.14,19.01 6.26,19.05 6.33,18.95 C6.44,18.81 7.74,16.85 8.11,15.44 C8.24,14.93 8.79,12.84 8.79,12.84 C9.15,13.52 10.19,14.09 11.29,14.09 C14.58,14.09 16.96,11.06 16.96,7.3 C16.94,3.7 14,1 10.21,1\"/></svg>",
            "play-circle": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" points=\"8.5 7 13.5 10 8.5 13\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/></svg>",
            "play": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"6.5,5 14.5,10 6.5,15\"/></svg>",
            "plus-circle": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9.5\" cy=\"9.5\" r=\"9\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"5\" x2=\"9.5\" y2=\"14\"/><line fill=\"none\" stroke=\"#000\" x1=\"5\" y1=\"9.5\" x2=\"14\" y2=\"9.5\"/></svg>",
            "plus": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"9\" y=\"1\" width=\"1\" height=\"17\"/><rect x=\"1\" y=\"9\" width=\"17\" height=\"1\"/></svg>",
            "print": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"4.5 13.5 1.5 13.5 1.5 6.5 18.5 6.5 18.5 13.5 15.5 13.5\"/><polyline fill=\"none\" stroke=\"#000\" points=\"15.5 6.5 15.5 2.5 4.5 2.5 4.5 6.5\"/><rect fill=\"none\" stroke=\"#000\" width=\"11\" height=\"6\" x=\"4.5\" y=\"11.5\"/><rect width=\"8\" height=\"1\" x=\"6\" y=\"13\"/><rect width=\"8\" height=\"1\" x=\"6\" y=\"15\"/></svg>",
            "pull": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"6.85,8 9.5,10.6 12.15,8 12.85,8.7 9.5,12 6.15,8.7\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"11\" x2=\"9.5\" y2=\"2\"/><polyline fill=\"none\" stroke=\"#000\" points=\"6,5.5 3.5,5.5 3.5,18.5 15.5,18.5 15.5,5.5 13,5.5\"/></svg>",
            "push": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"12.15,4 9.5,1.4 6.85,4 6.15,3.3 9.5,0 12.85,3.3\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"10\" x2=\"9.5\" y2=\"1\"/><polyline fill=\"none\" stroke=\"#000\" points=\"6 5.5 3.5 5.5 3.5 18.5 15.5 18.5 15.5 5.5 13 5.5\"/></svg>",
            "question": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/><circle cx=\"10.44\" cy=\"14.42\" r=\"1.05\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" d=\"M8.17,7.79 C8.17,4.75 12.72,4.73 12.72,7.72 C12.72,8.67 11.81,9.15 11.23,9.75 C10.75,10.24 10.51,10.73 10.45,11.4 C10.44,11.53 10.43,11.64 10.43,11.75\"/></svg>",
            "quote-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.27,7.79 C17.27,9.45 16.97,10.43 15.99,12.02 C14.98,13.64 13,15.23 11.56,15.97 L11.1,15.08 C12.34,14.2 13.14,13.51 14.02,11.82 C14.27,11.34 14.41,10.92 14.49,10.54 C14.3,10.58 14.09,10.6 13.88,10.6 C12.06,10.6 10.59,9.12 10.59,7.3 C10.59,5.48 12.06,4 13.88,4 C15.39,4 16.67,5.02 17.05,6.42 C17.19,6.82 17.27,7.27 17.27,7.79 L17.27,7.79 Z\"/><path d=\"M8.68,7.79 C8.68,9.45 8.38,10.43 7.4,12.02 C6.39,13.64 4.41,15.23 2.97,15.97 L2.51,15.08 C3.75,14.2 4.55,13.51 5.43,11.82 C5.68,11.34 5.82,10.92 5.9,10.54 C5.71,10.58 5.5,10.6 5.29,10.6 C3.47,10.6 2,9.12 2,7.3 C2,5.48 3.47,4 5.29,4 C6.8,4 8.08,5.02 8.46,6.42 C8.6,6.82 8.68,7.27 8.68,7.79 L8.68,7.79 Z\"/></svg>",
            "receiver": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" d=\"M6.189,13.611C8.134,15.525 11.097,18.239 13.867,18.257C16.47,18.275 18.2,16.241 18.2,16.241L14.509,12.551L11.539,13.639L6.189,8.29L7.313,5.355L3.76,1.8C3.76,1.8 1.732,3.537 1.7,6.092C1.667,8.809 4.347,11.738 6.189,13.611\"/></svg>",
            "reddit": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 9.05a2.56 2.56 0 0 0-2.56-2.56 2.59 2.59 0 0 0-1.88.82 10.63 10.63 0 0 0-4.14-1v-.08c.58-1.62 1.58-3.89 2.7-4.1.38-.08.77.12 1.19.57a1.15 1.15 0 0 0-.06.37 1.48 1.48 0 1 0 1.51-1.45 1.43 1.43 0 0 0-.76.19A2.29 2.29 0 0 0 12.91 1c-2.11.43-3.39 4.38-3.63 5.19 0 0 0 .11-.06.11a10.65 10.65 0 0 0-3.75 1A2.56 2.56 0 0 0 1 9.05a2.42 2.42 0 0 0 .72 1.76A5.18 5.18 0 0 0 1.24 13c0 3.66 3.92 6.64 8.73 6.64s8.74-3 8.74-6.64a5.23 5.23 0 0 0-.46-2.13A2.58 2.58 0 0 0 19 9.05zm-16.88 0a1.44 1.44 0 0 1 2.27-1.19 7.68 7.68 0 0 0-2.07 1.91 1.33 1.33 0 0 1-.2-.72zM10 18.4c-4.17 0-7.55-2.4-7.55-5.4S5.83 7.53 10 7.53 17.5 10 17.5 13s-3.38 5.4-7.5 5.4zm7.69-8.61a7.62 7.62 0 0 0-2.09-1.91 1.41 1.41 0 0 1 .84-.28 1.47 1.47 0 0 1 1.44 1.45 1.34 1.34 0 0 1-.21.72z\"/><path d=\"M6.69 12.58a1.39 1.39 0 1 1 1.39-1.39 1.38 1.38 0 0 1-1.38 1.39z\"/><path d=\"M14.26 11.2a1.39 1.39 0 1 1-1.39-1.39 1.39 1.39 0 0 1 1.39 1.39z\"/><path d=\"M13.09 14.88a.54.54 0 0 1-.09.77 5.3 5.3 0 0 1-3.26 1.19 5.61 5.61 0 0 1-3.4-1.22.55.55 0 1 1 .73-.83 4.09 4.09 0 0 0 5.25 0 .56.56 0 0 1 .77.09z\"/></svg>",
            "refresh": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M17.08,11.15 C17.09,11.31 17.1,11.47 17.1,11.64 C17.1,15.53 13.94,18.69 10.05,18.69 C6.16,18.68 3,15.53 3,11.63 C3,7.74 6.16,4.58 10.05,4.58 C10.9,4.58 11.71,4.73 12.46,5\"/><polyline fill=\"none\" stroke=\"#000\" points=\"9.9 2 12.79 4.89 9.79 7.9\"/></svg>",
            "reply": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.7,13.11 C16.12,10.02 13.84,7.85 11.02,6.61 C10.57,6.41 9.75,6.13 9,5.91 L9,2 L1,9 L9,16 L9,12.13 C10.78,12.47 12.5,13.19 14.09,14.25 C17.13,16.28 18.56,18.54 18.56,18.54 C18.56,18.54 18.81,15.28 17.7,13.11 L17.7,13.11 Z M14.82,13.53 C13.17,12.4 11.01,11.4 8,10.92 L8,13.63 L2.55,9 L8,4.25 L8,6.8 C8.3,6.86 9.16,7.02 10.37,7.49 C13.3,8.65 15.54,10.96 16.65,13.08 C16.97,13.7 17.48,14.86 17.68,16 C16.87,15.05 15.73,14.15 14.82,13.53 L14.82,13.53 Z\"/></svg>",
            "rss": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"3.12\" cy=\"16.8\" r=\"1.85\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M1.5,8.2 C1.78,8.18 2.06,8.16 2.35,8.16 C7.57,8.16 11.81,12.37 11.81,17.57 C11.81,17.89 11.79,18.19 11.76,18.5\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M1.5,2.52 C1.78,2.51 2.06,2.5 2.35,2.5 C10.72,2.5 17.5,9.24 17.5,17.57 C17.5,17.89 17.49,18.19 17.47,18.5\"/></svg>",
            "search": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9\" cy=\"9\" r=\"7\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M14,14 L18,18 L14,14 Z\"/></svg>",
            "server": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"1\" height=\"2\"/><rect x=\"5\" y=\"3\" width=\"1\" height=\"2\"/><rect x=\"7\" y=\"3\" width=\"1\" height=\"2\"/><rect x=\"16\" y=\"3\" width=\"1\" height=\"1\"/><rect x=\"16\" y=\"10\" width=\"1\" height=\"1\"/><circle fill=\"none\" stroke=\"#000\" cx=\"9.9\" cy=\"17.4\" r=\"1.4\"/><rect x=\"3\" y=\"10\" width=\"1\" height=\"2\"/><rect x=\"5\" y=\"10\" width=\"1\" height=\"2\"/><rect x=\"9.5\" y=\"14\" width=\"1\" height=\"2\"/><rect x=\"3\" y=\"17\" width=\"6\" height=\"1\"/><rect x=\"11\" y=\"17\" width=\"6\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"1.5\" width=\"17\" height=\"5\"/><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"8.5\" width=\"17\" height=\"5\"/></svg>",
            "settings": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><ellipse fill=\"none\" stroke=\"#000\" cx=\"6.11\" cy=\"3.55\" rx=\"2.11\" ry=\"2.15\"/><ellipse fill=\"none\" stroke=\"#000\" cx=\"6.11\" cy=\"15.55\" rx=\"2.11\" ry=\"2.15\"/><circle fill=\"none\" stroke=\"#000\" cx=\"13.15\" cy=\"9.55\" r=\"2.15\"/><rect x=\"1\" y=\"3\" width=\"3\" height=\"1\"/><rect x=\"10\" y=\"3\" width=\"8\" height=\"1\"/><rect x=\"1\" y=\"9\" width=\"8\" height=\"1\"/><rect x=\"15\" y=\"9\" width=\"3\" height=\"1\"/><rect x=\"1\" y=\"15\" width=\"3\" height=\"1\"/><rect x=\"10\" y=\"15\" width=\"8\" height=\"1\"/></svg>",
            "shrink": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"11 4 12 4 12 8 16 8 16 9 11 9\"/><polygon points=\"4 11 9 11 9 16 8 16 8 12 4 12\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M12,8 L18,2\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M2,18 L8,12\"/></svg>",
            "sign-in": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"7 2 17 2 17 17 7 17 7 16 16 16 16 3 7 3\"/><polygon points=\"9.1 13.4 8.5 12.8 11.28 10 4 10 4 9 11.28 9 8.5 6.2 9.1 5.62 13 9.5\"/></svg>",
            "sign-out": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"13.1 13.4 12.5 12.8 15.28 10 8 10 8 9 15.28 9 12.5 6.2 13.1 5.62 17 9.5\"/><polygon points=\"13 2 3 2 3 17 13 17 13 16 4 16 4 3 13 3\"/></svg>",
            "social": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"13.4\" y1=\"14\" x2=\"6.3\" y2=\"10.7\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"13.5\" y1=\"5.5\" x2=\"6.5\" y2=\"8.8\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"15.5\" cy=\"4.6\" r=\"2.3\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"15.5\" cy=\"14.8\" r=\"2.3\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"4.5\" cy=\"9.8\" r=\"2.3\"/></svg>",
            "soundcloud": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.2,9.4c-0.4,0-0.8,0.1-1.101,0.2c-0.199-2.5-2.399-4.5-5-4.5c-0.6,0-1.2,0.1-1.7,0.3C9.2,5.5,9.1,5.6,9.1,5.6V15h8 c1.601,0,2.801-1.2,2.801-2.8C20,10.7,18.7,9.4,17.2,9.4L17.2,9.4z\"/><rect x=\"6\" y=\"6.5\" width=\"1.5\" height=\"8.5\"/><rect x=\"3\" y=\"8\" width=\"1.5\" height=\"7\"/><rect y=\"10\" width=\"1.5\" height=\"5\"/></svg>",
            "star": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"10 2 12.63 7.27 18.5 8.12 14.25 12.22 15.25 18 10 15.27 4.75 18 5.75 12.22 1.5 8.12 7.37 7.27\"/></svg>",
            "strikethrough": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6,13.02 L6.65,13.02 C7.64,15.16 8.86,16.12 10.41,16.12 C12.22,16.12 12.92,14.93 12.92,13.89 C12.92,12.55 11.99,12.03 9.74,11.23 C8.05,10.64 6.23,10.11 6.23,7.83 C6.23,5.5 8.09,4.09 10.4,4.09 C11.44,4.09 12.13,4.31 12.72,4.54 L13.33,4 L13.81,4 L13.81,7.59 L13.16,7.59 C12.55,5.88 11.52,4.89 10.07,4.89 C8.84,4.89 7.89,5.69 7.89,7.03 C7.89,8.29 8.89,8.78 10.88,9.45 C12.57,10.03 14.38,10.6 14.38,12.91 C14.38,14.75 13.27,16.93 10.18,16.93 C9.18,16.93 8.17,16.69 7.46,16.39 L6.52,17 L6,17 L6,13.02 L6,13.02 Z\"/><rect x=\"3\" y=\"10\" width=\"15\" height=\"1\"/></svg>",
            "table": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"1\" y=\"3\" width=\"18\" height=\"1\"/><rect x=\"1\" y=\"7\" width=\"18\" height=\"1\"/><rect x=\"1\" y=\"11\" width=\"18\" height=\"1\"/><rect x=\"1\" y=\"15\" width=\"18\" height=\"1\"/></svg>",
            "tablet-landscape": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M1.5,5 C1.5,4.2 2.2,3.5 3,3.5 L17,3.5 C17.8,3.5 18.5,4.2 18.5,5 L18.5,16 C18.5,16.8 17.8,17.5 17,17.5 L3,17.5 C2.2,17.5 1.5,16.8 1.5,16 L1.5,5 L1.5,5 L1.5,5 Z\"/><circle cx=\"3.7\" cy=\"10.5\" r=\".8\"/></svg>",
            "tablet": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M5,18.5 C4.2,18.5 3.5,17.8 3.5,17 L3.5,3 C3.5,2.2 4.2,1.5 5,1.5 L16,1.5 C16.8,1.5 17.5,2.2 17.5,3 L17.5,17 C17.5,17.8 16.8,18.5 16,18.5 L5,18.5 L5,18.5 L5,18.5 Z\"/><circle cx=\"10.5\" cy=\"16.3\" r=\".8\"/></svg>",
            "tag": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M17.5,3.71 L17.5,7.72 C17.5,7.96 17.4,8.2 17.21,8.39 L8.39,17.2 C7.99,17.6 7.33,17.6 6.93,17.2 L2.8,13.07 C2.4,12.67 2.4,12.01 2.8,11.61 L11.61,2.8 C11.81,2.6 12.08,2.5 12.34,2.5 L16.19,2.5 C16.52,2.5 16.86,2.63 17.11,2.88 C17.35,3.11 17.48,3.4 17.5,3.71 L17.5,3.71 Z\"/><circle cx=\"14\" cy=\"6\" r=\"1\"/></svg>",
            "thumbnails": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"3.5\" width=\"5\" height=\"5\"/><rect fill=\"none\" stroke=\"#000\" x=\"11.5\" y=\"3.5\" width=\"5\" height=\"5\"/><rect fill=\"none\" stroke=\"#000\" x=\"11.5\" y=\"11.5\" width=\"5\" height=\"5\"/><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"11.5\" width=\"5\" height=\"5\"/></svg>",
            "tiktok": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.24,6V8.82a6.79,6.79,0,0,1-4-1.28v5.81A5.26,5.26,0,1,1,8,8.1a4.36,4.36,0,0,1,.72.05v2.9A2.57,2.57,0,0,0,7.64,11a2.4,2.4,0,1,0,2.77,2.38V2h2.86a4,4,0,0,0,1.84,3.38A4,4,0,0,0,17.24,6Z\"/></svg>",
            "trash": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"6.5 3 6.5 1.5 13.5 1.5 13.5 3\"/><polyline fill=\"none\" stroke=\"#000\" points=\"4.5 4 4.5 18.5 15.5 18.5 15.5 4\"/><rect x=\"8\" y=\"7\" width=\"1\" height=\"9\"/><rect x=\"11\" y=\"7\" width=\"1\" height=\"9\"/><rect x=\"2\" y=\"3\" width=\"16\" height=\"1\"/></svg>",
            "triangle-down": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"5 7 15 7 10 12\"/></svg>",
            "triangle-left": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"12 5 7 10 12 15\"/></svg>",
            "triangle-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"8 5 13 10 8 15\"/></svg>",
            "triangle-up": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"5 13 10 8 15 13\"/></svg>",
            "tripadvisor": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.021,7.866C19.256,6.862,20,5.854,20,5.854h-3.346C14.781,4.641,12.504,4,9.98,4C7.363,4,4.999,4.651,3.135,5.876H0\tc0,0,0.738,0.987,0.976,1.988c-0.611,0.837-0.973,1.852-0.973,2.964c0,2.763,2.249,5.009,5.011,5.009\tc1.576,0,2.976-0.737,3.901-1.879l1.063,1.599l1.075-1.615c0.475,0.611,1.1,1.111,1.838,1.451c1.213,0.547,2.574,0.612,3.825,0.15\tc2.589-0.963,3.913-3.852,2.964-6.439c-0.175-0.463-0.4-0.876-0.675-1.238H19.021z M16.38,14.594\tc-1.002,0.371-2.088,0.328-3.06-0.119c-0.688-0.317-1.252-0.817-1.657-1.438c-0.164-0.25-0.313-0.52-0.417-0.811\tc-0.124-0.328-0.186-0.668-0.217-1.014c-0.063-0.689,0.037-1.396,0.339-2.043c0.448-0.971,1.251-1.71,2.25-2.079\tc2.075-0.765,4.375,0.3,5.14,2.366c0.762,2.066-0.301,4.37-2.363,5.134L16.38,14.594L16.38,14.594z M8.322,13.066\tc-0.72,1.059-1.935,1.76-3.309,1.76c-2.207,0-4.001-1.797-4.001-3.996c0-2.203,1.795-4.002,4.001-4.002\tc2.204,0,3.999,1.8,3.999,4.002c0,0.137-0.024,0.261-0.04,0.396c-0.067,0.678-0.284,1.313-0.648,1.853v-0.013H8.322z M2.472,10.775\tc0,1.367,1.112,2.479,2.476,2.479c1.363,0,2.472-1.11,2.472-2.479c0-1.359-1.11-2.468-2.472-2.468\tC3.584,8.306,2.473,9.416,2.472,10.775L2.472,10.775z M12.514,10.775c0,1.367,1.104,2.479,2.471,2.479\tc1.363,0,2.474-1.108,2.474-2.479c0-1.359-1.11-2.468-2.474-2.468c-1.364,0-2.477,1.109-2.477,2.468H12.514z M3.324,10.775\tc0-0.893,0.726-1.618,1.614-1.618c0.889,0,1.625,0.727,1.625,1.618c0,0.898-0.725,1.627-1.625,1.627\tc-0.901,0-1.625-0.729-1.625-1.627H3.324z M13.354,10.775c0-0.893,0.726-1.618,1.627-1.618c0.886,0,1.61,0.727,1.61,1.618\tc0,0.898-0.726,1.627-1.626,1.627s-1.625-0.729-1.625-1.627H13.354z M9.977,4.875c1.798,0,3.425,0.324,4.849,0.968\tc-0.535,0.015-1.061,0.108-1.586,0.3c-1.264,0.463-2.264,1.388-2.815,2.604c-0.262,0.551-0.398,1.133-0.448,1.72\tC9.79,7.905,7.677,5.873,5.076,5.82C6.501,5.208,8.153,4.875,9.94,4.875H9.977z\"/></svg>",
            "tumblr": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.885,8.598c0,0,0,3.393,0,4.996c0,0.282,0,0.66,0.094,0.942c0.377,1.509,1.131,2.545,2.545,3.11 c1.319,0.472,2.356,0.472,3.676,0c0.565-0.188,1.132-0.659,1.132-0.659l-0.849-2.263c0,0-1.036,0.378-1.603,0.283 c-0.565-0.094-1.226-0.66-1.226-1.508c0-1.603,0-4.902,0-4.902h2.828V5.771h-2.828V2H8.205c0,0-0.094,0.66-0.188,0.942 C7.828,3.791,7.262,4.733,6.603,5.394C5.848,6.147,5,6.43,5,6.43v2.168H6.885z\"/></svg>",
            "tv": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"7\" y=\"16\" width=\"6\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\".5\" y=\"3.5\" width=\"19\" height=\"11\"/></svg>",
            "twitch": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.23,1,2,4.23V15.85H5.88v3.23L9.1,15.85h2.59L17.5,10V1Zm11,8.4L13.62,12H11L8.78,14.24V12H5.88V2.29H16.21Z\"/><rect x=\"12.98\" y=\"4.55\" width=\"1.29\" height=\"3.88\"/><rect x=\"9.43\" y=\"4.55\" width=\"1.29\" height=\"3.88\"/></svg>",
            "twitter": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19,4.74 C18.339,5.029 17.626,5.229 16.881,5.32 C17.644,4.86 18.227,4.139 18.503,3.28 C17.79,3.7 17.001,4.009 16.159,4.17 C15.485,3.45 14.526,3 13.464,3 C11.423,3 9.771,4.66 9.771,6.7 C9.771,6.99 9.804,7.269 9.868,7.539 C6.795,7.38 4.076,5.919 2.254,3.679 C1.936,4.219 1.754,4.86 1.754,5.539 C1.754,6.82 2.405,7.95 3.397,8.61 C2.79,8.589 2.22,8.429 1.723,8.149 L1.723,8.189 C1.723,9.978 2.997,11.478 4.686,11.82 C4.376,11.899 4.049,11.939 3.713,11.939 C3.475,11.939 3.245,11.919 3.018,11.88 C3.49,13.349 4.852,14.419 6.469,14.449 C5.205,15.429 3.612,16.019 1.882,16.019 C1.583,16.019 1.29,16.009 1,15.969 C2.635,17.019 4.576,17.629 6.662,17.629 C13.454,17.629 17.17,12 17.17,7.129 C17.17,6.969 17.166,6.809 17.157,6.649 C17.879,6.129 18.504,5.478 19,4.74\"/></svg>",
            "uikit": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"14.4,3.1 11.3,5.1 15,7.3 15,12.9 10,15.7 5,12.9 5,8.5 2,6.8 2,14.8 9.9,19.5 18,14.8 18,5.3\"/><polygon points=\"9.8,4.2 6.7,2.4 9.8,0.4 12.9,2.3\"/></svg>",
            "unlock": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"8.5\" width=\"13\" height=\"10\"/><path fill=\"none\" stroke=\"#000\" d=\"M6.5,8.5 L6.5,4.9 C6.5,3 8.1,1.5 10,1.5 C11.9,1.5 13.5,3 13.5,4.9\"/></svg>",
            "upload": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"5 8 9.5 3.5 14 8\"/><rect x=\"3\" y=\"17\" width=\"13\" height=\"1\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"15\" x2=\"9.5\" y2=\"4\"/></svg>",
            "user": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9.9\" cy=\"6.4\" r=\"4.4\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M1.5,19 C2.3,14.5 5.8,11.2 10,11.2 C14.2,11.2 17.7,14.6 18.5,19.2\"/></svg>",
            "users": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"7.7\" cy=\"8.6\" r=\"3.5\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M1,18.1 C1.7,14.6 4.4,12.1 7.6,12.1 C10.9,12.1 13.7,14.8 14.3,18.3\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M11.4,4 C12.8,2.4 15.4,2.8 16.3,4.7 C17.2,6.6 15.7,8.9 13.6,8.9 C16.5,8.9 18.8,11.3 19.2,14.1\"/></svg>",
            "video-camera": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"17.5 6.9 17.5 13.1 13.5 10.4 13.5 14.5 2.5 14.5 2.5 5.5 13.5 5.5 13.5 9.6 17.5 6.9\"/></svg>",
            "vimeo": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.065,7.59C1.84,7.367,1.654,7.082,1.468,6.838c-0.332-0.42-0.137-0.411,0.274-0.772c1.026-0.91,2.004-1.896,3.127-2.688 c1.017-0.713,2.365-1.173,3.286-0.039c0.849,1.045,0.869,2.629,1.084,3.891c0.215,1.309,0.421,2.648,0.88,3.901 c0.127,0.352,0.37,1.018,0.81,1.074c0.567,0.078,1.145-0.917,1.408-1.289c0.684-0.987,1.611-2.317,1.494-3.587 c-0.115-1.349-1.572-1.095-2.482-0.773c0.146-1.514,1.555-3.216,2.912-3.792c1.439-0.597,3.579-0.587,4.302,1.036 c0.772,1.759,0.078,3.802-0.763,5.396c-0.918,1.731-2.1,3.333-3.363,4.829c-1.114,1.329-2.432,2.787-4.093,3.422 c-1.897,0.723-3.021-0.686-3.667-2.318c-0.705-1.777-1.056-3.771-1.565-5.621C4.898,8.726,4.644,7.836,4.136,7.191 C3.473,6.358,2.72,7.141,2.065,7.59C1.977,7.502,2.115,7.551,2.065,7.59L2.065,7.59z\"/></svg>",
            "warning": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"10\" cy=\"14\" r=\"1\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/><path d=\"M10.97,7.72 C10.85,9.54 10.56,11.29 10.56,11.29 C10.51,11.87 10.27,12 9.99,12 C9.69,12 9.49,11.87 9.43,11.29 C9.43,11.29 9.16,9.54 9.03,7.72 C8.96,6.54 9.03,6 9.03,6 C9.03,5.45 9.46,5.02 9.99,5 C10.53,5.01 10.97,5.44 10.97,6 C10.97,6 11.04,6.54 10.97,7.72 L10.97,7.72 Z\"/></svg>",
            "whatsapp": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.7,3.3c-1.8-1.8-4.1-2.8-6.7-2.8c-5.2,0-9.4,4.2-9.4,9.4c0,1.7,0.4,3.3,1.3,4.7l-1.3,4.9l5-1.3c1.4,0.8,2.9,1.2,4.5,1.2 l0,0l0,0c5.2,0,9.4-4.2,9.4-9.4C19.5,7.4,18.5,5,16.7,3.3 M10.1,17.7L10.1,17.7c-1.4,0-2.8-0.4-4-1.1l-0.3-0.2l-3,0.8l0.8-2.9 l-0.2-0.3c-0.8-1.2-1.2-2.7-1.2-4.2c0-4.3,3.5-7.8,7.8-7.8c2.1,0,4.1,0.8,5.5,2.3c1.5,1.5,2.3,3.4,2.3,5.5 C17.9,14.2,14.4,17.7,10.1,17.7 M14.4,11.9c-0.2-0.1-1.4-0.7-1.6-0.8c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.6,0.8-0.8,0.9 c-0.1,0.2-0.3,0.2-0.5,0.1c-0.2-0.1-1-0.4-1.9-1.2c-0.7-0.6-1.2-1.4-1.3-1.6c-0.1-0.2,0-0.4,0.1-0.5C8,8.8,8.1,8.7,8.2,8.5 c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0-0.3,0-0.4C8.4,7.6,7.9,6.5,7.7,6C7.5,5.5,7.3,5.6,7.2,5.6c-0.1,0-0.3,0-0.4,0 c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.2-0.8,0.8-0.8,2c0,1.2,0.8,2.3,1,2.4c0.1,0.2,1.7,2.5,4,3.5c0.6,0.2,1,0.4,1.3,0.5 c0.6,0.2,1.1,0.2,1.5,0.1c0.5-0.1,1.4-0.6,1.6-1.1c0.2-0.5,0.2-1,0.1-1.1C14.8,12.1,14.6,12,14.4,11.9\"/></svg>",
            "wordpress": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10,0.5c-5.2,0-9.5,4.3-9.5,9.5s4.3,9.5,9.5,9.5c5.2,0,9.5-4.3,9.5-9.5S15.2,0.5,10,0.5L10,0.5L10,0.5z M15.6,3.9h-0.1 c-0.8,0-1.4,0.7-1.4,1.5c0,0.7,0.4,1.3,0.8,1.9c0.3,0.6,0.7,1.3,0.7,2.3c0,0.7-0.3,1.5-0.6,2.7L14.1,15l-3-8.9 c0.5,0,0.9-0.1,0.9-0.1C12.5,6,12.5,5.3,12,5.4c0,0-1.3,0.1-2.2,0.1C9,5.5,7.7,5.4,7.7,5.4C7.2,5.3,7.2,6,7.6,6c0,0,0.4,0.1,0.9,0.1 l1.3,3.5L8,15L5,6.1C5.5,6.1,5.9,6,5.9,6C6.4,6,6.3,5.3,5.9,5.4c0,0-1.3,0.1-2.2,0.1c-0.2,0-0.3,0-0.5,0c1.5-2.2,4-3.7,6.9-3.7 C12.2,1.7,14.1,2.6,15.6,3.9L15.6,3.9L15.6,3.9z M2.5,6.6l3.9,10.8c-2.7-1.3-4.6-4.2-4.6-7.4C1.8,8.8,2,7.6,2.5,6.6L2.5,6.6L2.5,6.6 z M10.2,10.7l2.5,6.9c0,0,0,0.1,0.1,0.1C11.9,18,11,18.2,10,18.2c-0.8,0-1.6-0.1-2.3-0.3L10.2,10.7L10.2,10.7L10.2,10.7z M14.2,17.1 l2.5-7.3c0.5-1.2,0.6-2.1,0.6-2.9c0-0.3,0-0.6-0.1-0.8c0.6,1.2,1,2.5,1,4C18.3,13,16.6,15.7,14.2,17.1L14.2,17.1L14.2,17.1z\"/></svg>",
            "world": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M1,10.5 L19,10.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M2.35,15.5 L17.65,15.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M2.35,5.5 L17.523,5.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M10,19.46 L9.98,19.46 C7.31,17.33 5.61,14.141 5.61,10.58 C5.61,7.02 7.33,3.83 10,1.7 C10.01,1.7 9.99,1.7 10,1.7 L10,1.7 C12.67,3.83 14.4,7.02 14.4,10.58 C14.4,14.141 12.67,17.33 10,19.46 L10,19.46 L10,19.46 L10,19.46 Z\"/><circle fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"10.5\" r=\"9\"/></svg>",
            "xing": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.4,4.56 C4.24,4.56 4.11,4.61 4.05,4.72 C3.98,4.83 3.99,4.97 4.07,5.12 L5.82,8.16 L5.82,8.17 L3.06,13.04 C2.99,13.18 2.99,13.33 3.06,13.44 C3.12,13.55 3.24,13.62 3.4,13.62 L6,13.62 C6.39,13.62 6.57,13.36 6.71,13.12 C6.71,13.12 9.41,8.35 9.51,8.16 C9.49,8.14 7.72,5.04 7.72,5.04 C7.58,4.81 7.39,4.56 6.99,4.56 L4.4,4.56 L4.4,4.56 Z\"/><path d=\"M15.3,1 C14.91,1 14.74,1.25 14.6,1.5 C14.6,1.5 9.01,11.42 8.82,11.74 C8.83,11.76 12.51,18.51 12.51,18.51 C12.64,18.74 12.84,19 13.23,19 L15.82,19 C15.98,19 16.1,18.94 16.16,18.83 C16.23,18.72 16.23,18.57 16.16,18.43 L12.5,11.74 L12.5,11.72 L18.25,1.56 C18.32,1.42 18.32,1.27 18.25,1.16 C18.21,1.06 18.08,1 17.93,1 L15.3,1 L15.3,1 Z\"/></svg>",
            "yelp": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.175,14.971c-0.112,0.77-1.686,2.767-2.406,3.054c-0.246,0.1-0.487,0.076-0.675-0.069\tc-0.122-0.096-2.446-3.859-2.446-3.859c-0.194-0.293-0.157-0.682,0.083-0.978c0.234-0.284,0.581-0.393,0.881-0.276\tc0.016,0.01,4.21,1.394,4.332,1.482c0.178,0.148,0.263,0.379,0.225,0.646L17.175,14.971L17.175,14.971z M11.464,10.789\tc-0.203-0.307-0.199-0.666,0.009-0.916c0,0,2.625-3.574,2.745-3.657c0.203-0.135,0.452-0.141,0.69-0.025\tc0.691,0.335,2.085,2.405,2.167,3.199v0.027c0.024,0.271-0.082,0.491-0.273,0.623c-0.132,0.083-4.43,1.155-4.43,1.155\tc-0.322,0.096-0.68-0.06-0.882-0.381L11.464,10.789z M9.475,9.563C9.32,9.609,8.848,9.757,8.269,8.817c0,0-3.916-6.16-4.007-6.351\tc-0.057-0.212,0.011-0.455,0.202-0.65C5.047,1.211,8.21,0.327,9.037,0.529c0.27,0.069,0.457,0.238,0.522,0.479\tc0.047,0.266,0.433,5.982,0.488,7.264C10.098,9.368,9.629,9.517,9.475,9.563z M9.927,19.066c-0.083,0.225-0.273,0.373-0.54,0.421\tc-0.762,0.13-3.15-0.751-3.647-1.342c-0.096-0.131-0.155-0.262-0.167-0.394c-0.011-0.095,0-0.189,0.036-0.272\tc0.061-0.155,2.917-3.538,2.917-3.538c0.214-0.272,0.595-0.355,0.952-0.213c0.345,0.13,0.56,0.428,0.536,0.749\tC10.014,14.479,9.977,18.923,9.927,19.066z M3.495,13.912c-0.235-0.009-0.444-0.148-0.568-0.382c-0.089-0.17-0.151-0.453-0.19-0.794\tC2.63,11.701,2.761,10.144,3.07,9.648c0.145-0.226,0.357-0.345,0.592-0.336c0.154,0,4.255,1.667,4.255,1.667\tc0.321,0.118,0.521,0.453,0.5,0.833c-0.023,0.37-0.236,0.655-0.551,0.738L3.495,13.912z\"/></svg>",
            "youtube": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15,4.1c1,0.1,2.3,0,3,0.8c0.8,0.8,0.9,2.1,0.9,3.1C19,9.2,19,10.9,19,12c-0.1,1.1,0,2.4-0.5,3.4c-0.5,1.1-1.4,1.5-2.5,1.6 c-1.2,0.1-8.6,0.1-11,0c-1.1-0.1-2.4-0.1-3.2-1c-0.7-0.8-0.7-2-0.8-3C1,11.8,1,10.1,1,8.9c0-1.1,0-2.4,0.5-3.4C2,4.5,3,4.3,4.1,4.2 C5.3,4.1,12.6,4,15,4.1z M8,7.5v6l5.5-3L8,7.5z\"/></svg>"
        });
    }

    if (typeof window !== 'undefined' && window.UIkit) {
        window.UIkit.use(plugin);
    }

    return plugin;
});

/***/ }),

/***/ "dy/l":
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
    if (hasKeyCode) searchInput = hasKeyCode;
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput];

  // Everything else (cast to string)
  var search = String(searchInput);

  // check codes
  var foundNamedKey = codes[search.toLowerCase()];
  if (foundNamedKey) return foundNamedKey;

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()];
  if (foundNamedKey) return foundNamedKey;

  // weird character?
  if (search.length === 1) return search.charCodeAt(0);

  return undefined;
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode;
    if (keyCode === null || keyCode === undefined) {
      return false;
    }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()];
      if (foundNamedKey) {
        return foundNamedKey === keyCode;
      }

      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()];
      if (foundNamedKey) {
        return foundNamedKey === keyCode;
      }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
};

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222

  // Helper aliases

};var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91

  /*!
   * Programatically add the following
   */

  // lower case chars
};for (i = 97; i < 123; i++) {
  codes[String.fromCharCode(i)] = i - 32;
} // numbers
for (var i = 48; i < 58; i++) {
  codes[i - 48] = i;
} // function keys
for (i = 1; i < 13; i++) {
  codes['f' + i] = i + 111;
} // numpad keys
for (i = 0; i < 10; i++) {
  codes['numpad ' + i] = i + 96;
} /**
   * Get by code
   *
   *   exports.name[13] // => 'Enter'
   */

var names = exports.names = exports.title = {}; // title for backward compat

// Create reverse mapping
for (i in codes) {
  names[codes[i]] = i;
} // Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias];
}

/***/ }),

/***/ "e/vF":
/***/ (function(module, exports) {

// empty

/***/ }),

/***/ "e1OT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var red50 = exports.red50 = '#ffebee';
var red100 = exports.red100 = '#ffcdd2';
var red200 = exports.red200 = '#ef9a9a';
var red300 = exports.red300 = '#e57373';
var red400 = exports.red400 = '#ef5350';
var red500 = exports.red500 = '#f44336';
var red600 = exports.red600 = '#e53935';
var red700 = exports.red700 = '#d32f2f';
var red800 = exports.red800 = '#c62828';
var red900 = exports.red900 = '#b71c1c';
var redA100 = exports.redA100 = '#ff8a80';
var redA200 = exports.redA200 = '#ff5252';
var redA400 = exports.redA400 = '#ff1744';
var redA700 = exports.redA700 = '#d50000';

var pink50 = exports.pink50 = '#fce4ec';
var pink100 = exports.pink100 = '#f8bbd0';
var pink200 = exports.pink200 = '#f48fb1';
var pink300 = exports.pink300 = '#f06292';
var pink400 = exports.pink400 = '#ec407a';
var pink500 = exports.pink500 = '#e91e63';
var pink600 = exports.pink600 = '#d81b60';
var pink700 = exports.pink700 = '#c2185b';
var pink800 = exports.pink800 = '#ad1457';
var pink900 = exports.pink900 = '#880e4f';
var pinkA100 = exports.pinkA100 = '#ff80ab';
var pinkA200 = exports.pinkA200 = '#ff4081';
var pinkA400 = exports.pinkA400 = '#f50057';
var pinkA700 = exports.pinkA700 = '#c51162';

var purple50 = exports.purple50 = '#f3e5f5';
var purple100 = exports.purple100 = '#e1bee7';
var purple200 = exports.purple200 = '#ce93d8';
var purple300 = exports.purple300 = '#ba68c8';
var purple400 = exports.purple400 = '#ab47bc';
var purple500 = exports.purple500 = '#9c27b0';
var purple600 = exports.purple600 = '#8e24aa';
var purple700 = exports.purple700 = '#7b1fa2';
var purple800 = exports.purple800 = '#6a1b9a';
var purple900 = exports.purple900 = '#4a148c';
var purpleA100 = exports.purpleA100 = '#ea80fc';
var purpleA200 = exports.purpleA200 = '#e040fb';
var purpleA400 = exports.purpleA400 = '#d500f9';
var purpleA700 = exports.purpleA700 = '#aa00ff';

var deepPurple50 = exports.deepPurple50 = '#ede7f6';
var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
var deepPurple200 = exports.deepPurple200 = '#b39ddb';
var deepPurple300 = exports.deepPurple300 = '#9575cd';
var deepPurple400 = exports.deepPurple400 = '#7e57c2';
var deepPurple500 = exports.deepPurple500 = '#673ab7';
var deepPurple600 = exports.deepPurple600 = '#5e35b1';
var deepPurple700 = exports.deepPurple700 = '#512da8';
var deepPurple800 = exports.deepPurple800 = '#4527a0';
var deepPurple900 = exports.deepPurple900 = '#311b92';
var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';

var indigo50 = exports.indigo50 = '#e8eaf6';
var indigo100 = exports.indigo100 = '#c5cae9';
var indigo200 = exports.indigo200 = '#9fa8da';
var indigo300 = exports.indigo300 = '#7986cb';
var indigo400 = exports.indigo400 = '#5c6bc0';
var indigo500 = exports.indigo500 = '#3f51b5';
var indigo600 = exports.indigo600 = '#3949ab';
var indigo700 = exports.indigo700 = '#303f9f';
var indigo800 = exports.indigo800 = '#283593';
var indigo900 = exports.indigo900 = '#1a237e';
var indigoA100 = exports.indigoA100 = '#8c9eff';
var indigoA200 = exports.indigoA200 = '#536dfe';
var indigoA400 = exports.indigoA400 = '#3d5afe';
var indigoA700 = exports.indigoA700 = '#304ffe';

var blue50 = exports.blue50 = '#e3f2fd';
var blue100 = exports.blue100 = '#bbdefb';
var blue200 = exports.blue200 = '#90caf9';
var blue300 = exports.blue300 = '#64b5f6';
var blue400 = exports.blue400 = '#42a5f5';
var blue500 = exports.blue500 = '#2196f3';
var blue600 = exports.blue600 = '#1e88e5';
var blue700 = exports.blue700 = '#1976d2';
var blue800 = exports.blue800 = '#1565c0';
var blue900 = exports.blue900 = '#0d47a1';
var blueA100 = exports.blueA100 = '#82b1ff';
var blueA200 = exports.blueA200 = '#448aff';
var blueA400 = exports.blueA400 = '#2979ff';
var blueA700 = exports.blueA700 = '#2962ff';

var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
var lightBlue200 = exports.lightBlue200 = '#81d4fa';
var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
var lightBlue400 = exports.lightBlue400 = '#29b6f6';
var lightBlue500 = exports.lightBlue500 = '#03a9f4';
var lightBlue600 = exports.lightBlue600 = '#039be5';
var lightBlue700 = exports.lightBlue700 = '#0288d1';
var lightBlue800 = exports.lightBlue800 = '#0277bd';
var lightBlue900 = exports.lightBlue900 = '#01579b';
var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
var lightBlueA700 = exports.lightBlueA700 = '#0091ea';

var cyan50 = exports.cyan50 = '#e0f7fa';
var cyan100 = exports.cyan100 = '#b2ebf2';
var cyan200 = exports.cyan200 = '#80deea';
var cyan300 = exports.cyan300 = '#4dd0e1';
var cyan400 = exports.cyan400 = '#26c6da';
var cyan500 = exports.cyan500 = '#00bcd4';
var cyan600 = exports.cyan600 = '#00acc1';
var cyan700 = exports.cyan700 = '#0097a7';
var cyan800 = exports.cyan800 = '#00838f';
var cyan900 = exports.cyan900 = '#006064';
var cyanA100 = exports.cyanA100 = '#84ffff';
var cyanA200 = exports.cyanA200 = '#18ffff';
var cyanA400 = exports.cyanA400 = '#00e5ff';
var cyanA700 = exports.cyanA700 = '#00b8d4';

var teal50 = exports.teal50 = '#e0f2f1';
var teal100 = exports.teal100 = '#b2dfdb';
var teal200 = exports.teal200 = '#80cbc4';
var teal300 = exports.teal300 = '#4db6ac';
var teal400 = exports.teal400 = '#26a69a';
var teal500 = exports.teal500 = '#009688';
var teal600 = exports.teal600 = '#00897b';
var teal700 = exports.teal700 = '#00796b';
var teal800 = exports.teal800 = '#00695c';
var teal900 = exports.teal900 = '#004d40';
var tealA100 = exports.tealA100 = '#a7ffeb';
var tealA200 = exports.tealA200 = '#64ffda';
var tealA400 = exports.tealA400 = '#1de9b6';
var tealA700 = exports.tealA700 = '#00bfa5';

var green50 = exports.green50 = '#e8f5e9';
var green100 = exports.green100 = '#c8e6c9';
var green200 = exports.green200 = '#a5d6a7';
var green300 = exports.green300 = '#81c784';
var green400 = exports.green400 = '#66bb6a';
var green500 = exports.green500 = '#4caf50';
var green600 = exports.green600 = '#43a047';
var green700 = exports.green700 = '#388e3c';
var green800 = exports.green800 = '#2e7d32';
var green900 = exports.green900 = '#1b5e20';
var greenA100 = exports.greenA100 = '#b9f6ca';
var greenA200 = exports.greenA200 = '#69f0ae';
var greenA400 = exports.greenA400 = '#00e676';
var greenA700 = exports.greenA700 = '#00c853';

var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
var lightGreen100 = exports.lightGreen100 = '#dcedc8';
var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
var lightGreen300 = exports.lightGreen300 = '#aed581';
var lightGreen400 = exports.lightGreen400 = '#9ccc65';
var lightGreen500 = exports.lightGreen500 = '#8bc34a';
var lightGreen600 = exports.lightGreen600 = '#7cb342';
var lightGreen700 = exports.lightGreen700 = '#689f38';
var lightGreen800 = exports.lightGreen800 = '#558b2f';
var lightGreen900 = exports.lightGreen900 = '#33691e';
var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
var lightGreenA700 = exports.lightGreenA700 = '#64dd17';

var lime50 = exports.lime50 = '#f9fbe7';
var lime100 = exports.lime100 = '#f0f4c3';
var lime200 = exports.lime200 = '#e6ee9c';
var lime300 = exports.lime300 = '#dce775';
var lime400 = exports.lime400 = '#d4e157';
var lime500 = exports.lime500 = '#cddc39';
var lime600 = exports.lime600 = '#c0ca33';
var lime700 = exports.lime700 = '#afb42b';
var lime800 = exports.lime800 = '#9e9d24';
var lime900 = exports.lime900 = '#827717';
var limeA100 = exports.limeA100 = '#f4ff81';
var limeA200 = exports.limeA200 = '#eeff41';
var limeA400 = exports.limeA400 = '#c6ff00';
var limeA700 = exports.limeA700 = '#aeea00';

var yellow50 = exports.yellow50 = '#fffde7';
var yellow100 = exports.yellow100 = '#fff9c4';
var yellow200 = exports.yellow200 = '#fff59d';
var yellow300 = exports.yellow300 = '#fff176';
var yellow400 = exports.yellow400 = '#ffee58';
var yellow500 = exports.yellow500 = '#ffeb3b';
var yellow600 = exports.yellow600 = '#fdd835';
var yellow700 = exports.yellow700 = '#fbc02d';
var yellow800 = exports.yellow800 = '#f9a825';
var yellow900 = exports.yellow900 = '#f57f17';
var yellowA100 = exports.yellowA100 = '#ffff8d';
var yellowA200 = exports.yellowA200 = '#ffff00';
var yellowA400 = exports.yellowA400 = '#ffea00';
var yellowA700 = exports.yellowA700 = '#ffd600';

var amber50 = exports.amber50 = '#fff8e1';
var amber100 = exports.amber100 = '#ffecb3';
var amber200 = exports.amber200 = '#ffe082';
var amber300 = exports.amber300 = '#ffd54f';
var amber400 = exports.amber400 = '#ffca28';
var amber500 = exports.amber500 = '#ffc107';
var amber600 = exports.amber600 = '#ffb300';
var amber700 = exports.amber700 = '#ffa000';
var amber800 = exports.amber800 = '#ff8f00';
var amber900 = exports.amber900 = '#ff6f00';
var amberA100 = exports.amberA100 = '#ffe57f';
var amberA200 = exports.amberA200 = '#ffd740';
var amberA400 = exports.amberA400 = '#ffc400';
var amberA700 = exports.amberA700 = '#ffab00';

var orange50 = exports.orange50 = '#fff3e0';
var orange100 = exports.orange100 = '#ffe0b2';
var orange200 = exports.orange200 = '#ffcc80';
var orange300 = exports.orange300 = '#ffb74d';
var orange400 = exports.orange400 = '#ffa726';
var orange500 = exports.orange500 = '#ff9800';
var orange600 = exports.orange600 = '#fb8c00';
var orange700 = exports.orange700 = '#f57c00';
var orange800 = exports.orange800 = '#ef6c00';
var orange900 = exports.orange900 = '#e65100';
var orangeA100 = exports.orangeA100 = '#ffd180';
var orangeA200 = exports.orangeA200 = '#ffab40';
var orangeA400 = exports.orangeA400 = '#ff9100';
var orangeA700 = exports.orangeA700 = '#ff6d00';

var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
var deepOrange100 = exports.deepOrange100 = '#ffccbc';
var deepOrange200 = exports.deepOrange200 = '#ffab91';
var deepOrange300 = exports.deepOrange300 = '#ff8a65';
var deepOrange400 = exports.deepOrange400 = '#ff7043';
var deepOrange500 = exports.deepOrange500 = '#ff5722';
var deepOrange600 = exports.deepOrange600 = '#f4511e';
var deepOrange700 = exports.deepOrange700 = '#e64a19';
var deepOrange800 = exports.deepOrange800 = '#d84315';
var deepOrange900 = exports.deepOrange900 = '#bf360c';
var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';

var brown50 = exports.brown50 = '#efebe9';
var brown100 = exports.brown100 = '#d7ccc8';
var brown200 = exports.brown200 = '#bcaaa4';
var brown300 = exports.brown300 = '#a1887f';
var brown400 = exports.brown400 = '#8d6e63';
var brown500 = exports.brown500 = '#795548';
var brown600 = exports.brown600 = '#6d4c41';
var brown700 = exports.brown700 = '#5d4037';
var brown800 = exports.brown800 = '#4e342e';
var brown900 = exports.brown900 = '#3e2723';

var blueGrey50 = exports.blueGrey50 = '#eceff1';
var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
var blueGrey200 = exports.blueGrey200 = '#b0bec5';
var blueGrey300 = exports.blueGrey300 = '#90a4ae';
var blueGrey400 = exports.blueGrey400 = '#78909c';
var blueGrey500 = exports.blueGrey500 = '#607d8b';
var blueGrey600 = exports.blueGrey600 = '#546e7a';
var blueGrey700 = exports.blueGrey700 = '#455a64';
var blueGrey800 = exports.blueGrey800 = '#37474f';
var blueGrey900 = exports.blueGrey900 = '#263238';

var grey50 = exports.grey50 = '#fafafa';
var grey100 = exports.grey100 = '#f5f5f5';
var grey200 = exports.grey200 = '#eeeeee';
var grey300 = exports.grey300 = '#e0e0e0';
var grey400 = exports.grey400 = '#bdbdbd';
var grey500 = exports.grey500 = '#9e9e9e';
var grey600 = exports.grey600 = '#757575';
var grey700 = exports.grey700 = '#616161';
var grey800 = exports.grey800 = '#424242';
var grey900 = exports.grey900 = '#212121';

var black = exports.black = '#000000';
var white = exports.white = '#ffffff';

var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),

/***/ "e8vu":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("X6va")('meta');
var isObject = __webpack_require__("BxvP");
var has = __webpack_require__("yS17");
var setDesc = __webpack_require__("Gfzd").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("wLcK")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),

/***/ "e9SR":
/***/ (function(module, exports) {


module.exports = function chain() {
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++) {
    args[i] = arguments[i];
  }args = args.filter(function (fn) {
    return fn != null;
  });

  if (args.length === 0) return undefined;
  if (args.length === 1) return args[0];

  return args.reduce(function (current, next) {
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  });
};

/***/ }),

/***/ "eG0P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("eW0v");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__("PkFN");

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__("Z55K");

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__("KQdW");

var _transitions2 = _interopRequireDefault(_transitions);

var _ScaleIn = __webpack_require__("JtRT");

var _ScaleIn2 = _interopRequireDefault(_ScaleIn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var pulsateDuration = 750;

var FocusRipple = function (_Component) {
  (0, _inherits3.default)(FocusRipple, _Component);

  function FocusRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FocusRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
      if (!innerCircle) return;

      var startScale = 'scale(1)';
      var endScale = 'scale(0.85)';
      var currentScale = innerCircle.style.transform || startScale;
      var nextScale = currentScale === startScale ? endScale : startScale;

      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FocusRipple, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      } else {
        if (this.timeout) clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'getRippleElement',
    value: function getRippleElement(props) {
      var color = props.color,
          innerStyle = props.innerStyle,
          opacity = props.opacity;
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          ripple = _context$muiTheme.ripple;

      var innerStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        opacity: opacity ? opacity : 0.16,
        backgroundColor: color || ripple.color,
        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
      }, innerStyle);

      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
      var height = el.offsetHeight;
      var width = el.offsetWidth;
      var size = Math.max(height, width);

      var oldTop = 0;
      // For browsers that don't support endsWith()
      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
        oldTop = parseInt(el.style.top);
      }
      el.style.height = size + 'px';
      el.style.top = height / 2 - size / 2 + oldTop + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          style = _props.style;

      var mergedRootStyles = (0, _simpleAssign2.default)({
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0
      }, style);

      var ripple = show ? this.getRippleElement(this.props) : null;

      return _react2.default.createElement(_ScaleIn2.default, {
        maxScale: 0.85,
        style: mergedRootStyles
      }, ripple);
    }
  }]);
  return FocusRipple;
}(_react.Component);

FocusRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FocusRipple.propTypes =  false ? {
  color: _propTypes2.default.string,
  innerStyle: _propTypes2.default.object,
  opacity: _propTypes2.default.number,
  show: _propTypes2.default.bool,
  style: _propTypes2.default.object
} : {};
exports.default = FocusRipple;

/***/ }),

/***/ "eHdh":
/***/ (function(module, exports, __webpack_require__) {


var space = __webpack_require__("5x0G");

/**
 * Export.
 */

module.exports = toCamelCase;

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase();
  });
}

/***/ }),

/***/ "eObX":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("WMuu");

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);

/***/ }),

/***/ "eOjq":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("PDcB");
module.exports = __webpack_require__("zKeE").Object.keys;

/***/ }),

/***/ "eTnC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2928664fe1fc6aca88583a6f606d60ba.svg";

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1_preact__, "createRef")) __webpack_require__.d(__webpack_exports__, "createRef", function() { return __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context__ = __webpack_require__("ZShz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_context__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_2_preact_context__, "createContext")) __webpack_require__.d(__webpack_exports__, "createContext", function() { return __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"]; });







var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = "production" !== 'production';
} catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback, e) {
	callback(e);
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	hydrate: render$1,
	createClass: createClass,
	createContext: __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"],
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	createRef: __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"],
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);

//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "ebIA":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("i1Q6").document;
module.exports = document && document.documentElement;

/***/ }),

/***/ "ee02":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__("/eMc");

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "f+DB":
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

/***/ }),

/***/ "f+fx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__("eW0v");
var ReactDOM = __webpack_require__("eW0v");

var utils = __webpack_require__("yd8v");
var scrollSpy = __webpack_require__("JAZJ");
var defaultScroller = __webpack_require__("45fX");
var PropTypes = __webpack_require__("5D9O");
var scrollHash = __webpack_require__("T9hV");

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    return Element;
  }
};

module.exports = Helpers;

/***/ }),

/***/ "f3eR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("GyB/");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ../node_modules/css-animation/es/Event.js
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },

  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ var Event = (TransitionEvents);
// EXTERNAL MODULE: ../node_modules/component-classes/index.js
var component_classes = __webpack_require__("m+xf");
var component_classes_default = /*#__PURE__*/__webpack_require__.n(component_classes);

// CONCATENATED MODULE: ../node_modules/css-animation/es/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });




var isCssAnimationSupported = Event.endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var es_cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : typeof_default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = component_classes_default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    Event.removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  Event.addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

es_cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    Event.removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  Event.addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

es_cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

es_cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ var es = __webpack_exports__["a"] = (es_cssAnimation);

/***/ }),

/***/ "f5Sh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return daysInWeek; });
/* unused harmony export maxTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return millisecondsInMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return millisecondsInHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return millisecondsInSecond; });
/* unused harmony export minTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return minutesInHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return monthsInQuarter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return monthsInYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return quartersInYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return secondsInHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return secondsInMinute; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;

/***/ }),

/***/ "fCoI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("SNRl");
var global = __webpack_require__("IJ/8");
var isPrototypeOf = __webpack_require__("VN+O");
var getPrototypeOf = __webpack_require__("BJWe");
var setPrototypeOf = __webpack_require__("nR03");
var copyConstructorProperties = __webpack_require__("T9dW");
var create = __webpack_require__("jqpc");
var createNonEnumerableProperty = __webpack_require__("yNEm");
var createPropertyDescriptor = __webpack_require__("v6/v");
var clearErrorStack = __webpack_require__("UCHH");
var installErrorCause = __webpack_require__("vc57");
var iterate = __webpack_require__("abHJ");
var normalizeStringArgument = __webpack_require__("mQtc");
var wellKnownSymbol = __webpack_require__("G69i");
var ERROR_STACK_INSTALLABLE = __webpack_require__("hEdi");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Error = global.Error;
var push = [].push;

var $AggregateError = function AggregateError(errors, message /* , options */) {
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
  var that;
  if (setPrototypeOf) {
    that = setPrototypeOf(new Error(undefined), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : create(AggregateErrorPrototype);
    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
  }
  createNonEnumerableProperty(that, 'message', normalizeStringArgument(message, ''));
  if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(that, 'stack', clearErrorStack(that.stack, 1));
  installErrorCause(that, options);
  var errorsArray = [];
  iterate(errors, push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

if (setPrototypeOf) setPrototypeOf($AggregateError, Error);else copyConstructorProperties($AggregateError, Error);

var AggregateErrorPrototype = $AggregateError.prototype = create(Error.prototype, {
  constructor: createPropertyDescriptor(1, $AggregateError),
  message: createPropertyDescriptor(1, ''),
  name: createPropertyDescriptor(1, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true }, {
  AggregateError: $AggregateError
});

/***/ }),

/***/ "fpuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/lodash-es/isPlainObject.js
var isPlainObject = __webpack_require__("9TS5");

// EXTERNAL MODULE: ../node_modules/symbol-observable/es/index.js
var es = __webpack_require__("LkZ7");

// CONCATENATED MODULE: ../node_modules/redux/es/createStore.js



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(isPlainObject["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[es["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[es["a" /* default */]] = observable, _ref2;
}
// CONCATENATED MODULE: ../node_modules/redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning_warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ../node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(isPlainObject["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
// CONCATENATED MODULE: ../node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}
// CONCATENATED MODULE: ../node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore_createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),

/***/ "g31e":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "g3tO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedKeyframes;
function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
  var prefixedKeyframes = 'keyframes';

  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
    return cssPrefix + prefixedKeyframes;
  }
  return prefixedKeyframes;
}
module.exports = exports['default'];

/***/ }),

/***/ "g7MH":
/***/ (function(module, exports, __webpack_require__) {

//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var _rng = __webpack_require__("bimv");

// Maps for number <-> hex string conversion
var _byteToHex = [];
var _hexToByte = {};
for (var i = 0; i < 256; i++) {
  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
  _hexToByte[_byteToHex[i]] = i;
}

// **`parse()` - Parse a UUID into it's component bytes**
function parse(s, buf, offset) {
  var i = buf && offset || 0,
      ii = 0;

  buf = buf || [];
  s.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
    if (ii < 16) {
      // Don't overflow!
      buf[i + ii++] = _hexToByte[oct];
    }
  });

  // Zero out remaining bytes if string was short
  while (ii < 16) {
    buf[i + ii++] = 0;
  }

  return buf;
}

// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
function unparse(buf, offset) {
  var i = offset || 0,
      bth = _byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = _rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0,
    _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; n++) {
    b[i + n] = node[n];
  }

  return buf ? buf : unparse(b);
}

// **`v4()` - Generate random UUID**

// See https://github.com/broofa/node-uuid for API details
function v4(options, buf, offset) {
  // Deprecated - 'format' argument, as supported in v1.2
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || _rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ii++) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || unparse(rnds);
}

// Export public API
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
uuid.parse = parse;
uuid.unparse = unparse;

module.exports = uuid;

/***/ }),

/***/ "gZjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetCallTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tickCallTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCallStartTimestamp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("vyGZ");


var resetCallTimer = function resetCallTimer() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__index__["a" /* actionTypes */].CALL_TIMER_RESET
    });
  };
};

var tickCallTimer = function tickCallTimer() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__index__["a" /* actionTypes */].CALL_TIMER_TICK
    });
  };
};

var setCallStartTimestamp = function setCallStartTimestamp() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__index__["a" /* actionTypes */].CALL_TIMER_TIMESTAMP
    });
  };
};

/***/ }),

/***/ "gc0D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("vcHl"), __esModule: true };

/***/ }),

/***/ "gf6g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "gjjs":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("Gfzd");
var anObject = __webpack_require__("zotD");
var getKeys = __webpack_require__("knrM");

module.exports = __webpack_require__("6MLN") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),

/***/ "gkzq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/redux-actions/es/index.js + 30 modules
var es = __webpack_require__("bKsd");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ./api/fetch-wrapper.js
var fetch_wrapper = __webpack_require__("ds2O");

// EXTERNAL MODULE: ./api/index.js
var api = __webpack_require__("/C1n");

// CONCATENATED MODULE: ./api/tokenValidation.js
/* eslint-disable import/prefer-default-export */




var TT_MAP = {
  REGISTRATION: 'REGISTRATION',
  RESET_PASSWORD: 'RESET_PASSWORD'
};

/**
 *
 * @param {string} tokenValue
 * @param {string} tt
 * @return {Promise<*>}
 */
function tokenValidation_token(tokenValue, tt) {
  var queryParams = new URLSearchParams();

  queryParams.append('tkn', tokenValue);

  queryParams.append('tt', tt);

  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].TOKEN + '?' + queryParams.toString(), {
    method: 'GET'
  });
}
// EXTERNAL MODULE: ./actions/index.js
var actions = __webpack_require__("vyGZ");

// EXTERNAL MODULE: ./components/app.js + 53 modules
var app = __webpack_require__("qLaj");

// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// CONCATENATED MODULE: ./actions/tokenValidation.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tokenValidateReset; });
/* unused harmony export tokenValidateSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = tokenValidate;





// eslint-disable-next-line import/no-cycle



var tokenValidateRequest = Object(es["a" /* createAction */])(actions["a" /* actionTypes */].TOKEN_VALIDATE_REQUEST);
var tokenValidateFailure = Object(es["a" /* createAction */])(actions["a" /* actionTypes */].TOKEN_VALIDATE_FAILURE);

var tokenValidateReset = Object(es["a" /* createAction */])(actions["a" /* actionTypes */].TOKEN_VALIDATE_RESET);

function tokenValidateSuccess() {
  return function (dispatch) {
    dispatch({
      type: actions["a" /* actionTypes */].TOKEN_VALIDATE_SUCCESS
    });

    localStorage.setItem(consts["n" /* LOCAL_STORAGE */].ACTIVATION, 'true');

    Object(preact_router_es["route"])(app["routes"].LOG_IN);
  };
}

/**
 *
 * @param {{ token: string }} payload
 */
function tokenValidate(payload) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var token, _ref, activate;

      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (error) {
        try {
          dispatch(tokenValidateFailure(error));
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        token = payload.token;


        dispatch(tokenValidateRequest());

        return Promise.resolve(tokenValidation_token(token, TT_MAP.REGISTRATION)).then(function ($await_2) {
          try {
            _ref = $await_2, activate = _ref.activate;


            if (activate) {
              dispatch(tokenValidateSuccess());
            } else {
              // Add fallback logic if necessary
            }
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  };
}

/***/ }),

/***/ "goEr":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__("fCoI");

/***/ }),

/***/ "gojl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("akPY");

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "hDW8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeShape = undefined;

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var storeShape = exports.storeShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  setState: _propTypes2.default.func.isRequired,
  getState: _propTypes2.default.func.isRequired
});

/***/ }),

/***/ "hEIm":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("zotD");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),

/***/ "hEdi":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("rtOw");
var createPropertyDescriptor = __webpack_require__("v6/v");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});

/***/ }),

/***/ "hTqB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__("rQKw");

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
function gradient(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "hUiE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Snackbar = __webpack_require__("xqvi");

var _Snackbar2 = _interopRequireDefault(_Snackbar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _Snackbar2.default;

/***/ }),

/***/ "hVVj":
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__("f+DB");
var bytesToUuid = __webpack_require__("dAjQ");

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;

/***/ }),

/***/ "hYHi":
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__("f+DB");
var bytesToUuid = __webpack_require__("dAjQ");

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;

/***/ }),

/***/ "hp6J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toPropertyKey = __webpack_require__("D38D");
var definePropertyModule = __webpack_require__("y7Dx");
var createPropertyDescriptor = __webpack_require__("v6/v");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
};

/***/ }),

/***/ "htFH":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("vSO4");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("6MLN"), 'Object', { defineProperty: __webpack_require__("Gfzd").f });

/***/ }),

/***/ "i+u+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__("lytE")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("uRfg")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),

/***/ "i/J7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "i1Q6":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "i2r7":
/***/ (function(module, exports) {

module.exports = []

/***/ }),

/***/ "i8vT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _chainFunction = __webpack_require__("e9SR");

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__("/sXU");

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__("GT3O");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';

TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "iLhB":
/***/ (function(module, exports, __webpack_require__) {

!function (t, n) {
   true ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.IdleJs = n() : t.IdleJs = n();
}(window, function () {
  return function (t) {
    var n = {};function r(e) {
      if (n[e]) return n[e].exports;var i = n[e] = { i: e, l: !1, exports: {} };return t[e].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }return r.m = t, r.c = n, r.d = function (t, n, e) {
      r.o(t, n) || Object.defineProperty(t, n, { enumerable: !0, get: e });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
    }, r.t = function (t, n) {
      if (1 & n && (t = r(t)), 8 & n) return t;if (4 & n && "object" == typeof t && t && t.__esModule) return t;var e = Object.create(null);if (r.r(e), Object.defineProperty(e, "default", { enumerable: !0, value: t }), 2 & n && "string" != typeof t) for (var i in t) {
        r.d(e, i, function (n) {
          return t[n];
        }.bind(null, i));
      }return e;
    }, r.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };return r.d(n, "a", n), n;
    }, r.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, r.p = "", r(r.s = 115);
  }([function (t, n, r) {
    var e = r(3),
        i = r(9),
        o = r(14),
        u = r(10),
        c = r(21),
        a = function a(t, n, r) {
      var f,
          s,
          l,
          h,
          v = t & a.F,
          p = t & a.G,
          d = t & a.S,
          g = t & a.P,
          y = t & a.B,
          m = p ? e : d ? e[n] || (e[n] = {}) : (e[n] || {}).prototype,
          b = p ? i : i[n] || (i[n] = {}),
          x = b.prototype || (b.prototype = {});for (f in p && (r = n), r) {
        l = ((s = !v && m && void 0 !== m[f]) ? m : r)[f], h = y && s ? c(l, e) : g && "function" == typeof l ? c(Function.call, l) : l, m && u(m, f, l, t & a.U), b[f] != l && o(b, f, h), g && x[f] != l && (x[f] = l);
      }
    };e.core = i, a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
  }, function (t, n) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, n, r) {
    var e = r(4);t.exports = function (t) {
      if (!e(t)) throw TypeError(t + " is not an object!");return t;
    };
  }, function (t, n) {
    var r = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = r);
  }, function (t, n) {
    t.exports = function (t) {
      return "object" == typeof t ? null !== t : "function" == typeof t;
    };
  }, function (t, n, r) {
    var e = r(59)("wks"),
        i = r(29),
        o = r(3).Symbol,
        u = "function" == typeof o;(t.exports = function (t) {
      return e[t] || (e[t] = u && o[t] || (u ? o : i)("Symbol." + t));
    }).store = e;
  }, function (t, n, r) {
    var e = r(17),
        i = Math.min;t.exports = function (t) {
      return t > 0 ? i(e(t), 9007199254740991) : 0;
    };
  }, function (t, n, r) {
    var e = r(2),
        i = r(85),
        o = r(26),
        u = Object.defineProperty;n.f = r(8) ? Object.defineProperty : function (t, n, r) {
      if (e(t), n = o(n, !0), e(r), i) try {
        return u(t, n, r);
      } catch (t) {}if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");return "value" in r && (t[n] = r.value), t;
    };
  }, function (t, n, r) {
    t.exports = !r(1)(function () {
      return 7 != Object.defineProperty({}, "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, n) {
    var r = t.exports = { version: "2.6.3" };"number" == typeof __e && (__e = r);
  }, function (t, n, r) {
    var e = r(3),
        i = r(14),
        o = r(13),
        u = r(29)("src"),
        c = Function.toString,
        a = ("" + c).split("toString");r(9).inspectSource = function (t) {
      return c.call(t);
    }, (t.exports = function (t, n, r, c) {
      var f = "function" == typeof r;f && (o(r, "name") || i(r, "name", n)), t[n] !== r && (f && (o(r, u) || i(r, u, t[n] ? "" + t[n] : a.join(String(n)))), t === e ? t[n] = r : c ? t[n] ? t[n] = r : i(t, n, r) : (delete t[n], i(t, n, r)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[u] || c.call(this);
    });
  }, function (t, n, r) {
    var e = r(24);t.exports = function (t) {
      return Object(e(t));
    };
  }, function (t, n, r) {
    var e = r(0),
        i = r(1),
        o = r(24),
        u = /"/g,
        c = function c(t, n, r, e) {
      var i = String(o(t)),
          c = "<" + n;return "" !== r && (c += " " + r + '="' + String(e).replace(u, "&quot;") + '"'), c + ">" + i + "</" + n + ">";
    };t.exports = function (t, n) {
      var r = {};r[t] = n(c), e(e.P + e.F * i(function () {
        var n = ""[t]('"');return n !== n.toLowerCase() || n.split('"').length > 3;
      }), "String", r);
    };
  }, function (t, n) {
    var r = {}.hasOwnProperty;t.exports = function (t, n) {
      return r.call(t, n);
    };
  }, function (t, n, r) {
    var e = r(7),
        i = r(28);t.exports = r(8) ? function (t, n, r) {
      return e.f(t, n, i(1, r));
    } : function (t, n, r) {
      return t[n] = r, t;
    };
  }, function (t, n, r) {
    var e = r(43),
        i = r(24);t.exports = function (t) {
      return e(i(t));
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(1);t.exports = function (t, n) {
      return !!t && e(function () {
        n ? t.call(null, function () {}, 1) : t.call(null);
      });
    };
  }, function (t, n) {
    var r = Math.ceil,
        e = Math.floor;t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? e : r)(t);
    };
  }, function (t, n, r) {
    var e = r(44),
        i = r(28),
        o = r(15),
        u = r(26),
        c = r(13),
        a = r(85),
        f = Object.getOwnPropertyDescriptor;n.f = r(8) ? f : function (t, n) {
      if (t = o(t), n = u(n, !0), a) try {
        return f(t, n);
      } catch (t) {}if (c(t, n)) return i(!e.f.call(t, n), t[n]);
    };
  }, function (t, n, r) {
    var e = r(0),
        i = r(9),
        o = r(1);t.exports = function (t, n) {
      var r = (i.Object || {})[t] || Object[t],
          u = {};u[t] = n(r), e(e.S + e.F * o(function () {
        r(1);
      }), "Object", u);
    };
  }, function (t, n, r) {
    var e = r(21),
        i = r(43),
        o = r(11),
        u = r(6),
        c = r(209);t.exports = function (t, n) {
      var r = 1 == t,
          a = 2 == t,
          f = 3 == t,
          s = 4 == t,
          l = 6 == t,
          h = 5 == t || l,
          v = n || c;return function (n, c, p) {
        for (var d, g, y = o(n), m = i(y), b = e(c, p, 3), x = u(m.length), w = 0, S = r ? v(n, x) : a ? v(n, 0) : void 0; x > w; w++) {
          if ((h || w in m) && (g = b(d = m[w], w, y), t)) if (r) S[w] = g;else if (g) switch (t) {case 3:
              return !0;case 5:
              return d;case 6:
              return w;case 2:
              S.push(d);} else if (s) return !1;
        }return l ? -1 : f || s ? s : S;
      };
    };
  }, function (t, n, r) {
    var e = r(22);t.exports = function (t, n, r) {
      if (e(t), void 0 === n) return t;switch (r) {case 1:
          return function (r) {
            return t.call(n, r);
          };case 2:
          return function (r, e) {
            return t.call(n, r, e);
          };case 3:
          return function (r, e, i) {
            return t.call(n, r, e, i);
          };}return function () {
        return t.apply(n, arguments);
      };
    };
  }, function (t, n) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
    };
  }, function (t, n) {
    var r = {}.toString;t.exports = function (t) {
      return r.call(t).slice(8, -1);
    };
  }, function (t, n) {
    t.exports = function (t) {
      if (null == t) throw TypeError("Can't call method on  " + t);return t;
    };
  }, function (t, n, r) {
    "use strict";
    if (r(8)) {
      var e = r(30),
          i = r(3),
          o = r(1),
          u = r(0),
          c = r(57),
          a = r(84),
          f = r(21),
          s = r(40),
          l = r(28),
          h = r(14),
          v = r(41),
          p = r(17),
          d = r(6),
          g = r(111),
          y = r(32),
          m = r(26),
          b = r(13),
          x = r(45),
          w = r(4),
          S = r(11),
          _ = r(76),
          E = r(33),
          O = r(35),
          F = r(34).f,
          P = r(78),
          I = r(29),
          M = r(5),
          A = r(20),
          j = r(47),
          T = r(46),
          N = r(80),
          L = r(37),
          k = r(50),
          R = r(39),
          C = r(79),
          D = r(102),
          W = r(7),
          B = r(18),
          U = W.f,
          V = B.f,
          G = i.RangeError,
          H = i.TypeError,
          z = i.Uint8Array,
          Y = Array.prototype,
          K = a.ArrayBuffer,
          q = a.DataView,
          J = A(0),
          $ = A(2),
          X = A(3),
          Z = A(4),
          Q = A(5),
          tt = A(6),
          nt = j(!0),
          rt = j(!1),
          et = N.values,
          it = N.keys,
          ot = N.entries,
          ut = Y.lastIndexOf,
          ct = Y.reduce,
          at = Y.reduceRight,
          ft = Y.join,
          st = Y.sort,
          lt = Y.slice,
          ht = Y.toString,
          vt = Y.toLocaleString,
          pt = M("iterator"),
          dt = M("toStringTag"),
          gt = I("typed_constructor"),
          yt = I("def_constructor"),
          mt = c.CONSTR,
          bt = c.TYPED,
          xt = c.VIEW,
          wt = A(1, function (t, n) {
        return Ft(T(t, t[yt]), n);
      }),
          St = o(function () {
        return 1 === new z(new Uint16Array([1]).buffer)[0];
      }),
          _t = !!z && !!z.prototype.set && o(function () {
        new z(1).set({});
      }),
          Et = function Et(t, n) {
        var r = p(t);if (r < 0 || r % n) throw G("Wrong offset!");return r;
      },
          Ot = function Ot(t) {
        if (w(t) && bt in t) return t;throw H(t + " is not a typed array!");
      },
          Ft = function Ft(t, n) {
        if (!(w(t) && gt in t)) throw H("It is not a typed array constructor!");return new t(n);
      },
          Pt = function Pt(t, n) {
        return It(T(t, t[yt]), n);
      },
          It = function It(t, n) {
        for (var r = 0, e = n.length, i = Ft(t, e); e > r;) {
          i[r] = n[r++];
        }return i;
      },
          Mt = function Mt(t, n, r) {
        U(t, n, { get: function get() {
            return this._d[r];
          } });
      },
          At = function At(t) {
        var n,
            r,
            e,
            i,
            o,
            u,
            c = S(t),
            a = arguments.length,
            s = a > 1 ? arguments[1] : void 0,
            l = void 0 !== s,
            h = P(c);if (null != h && !_(h)) {
          for (u = h.call(c), e = [], n = 0; !(o = u.next()).done; n++) {
            e.push(o.value);
          }c = e;
        }for (l && a > 2 && (s = f(s, arguments[2], 2)), n = 0, r = d(c.length), i = Ft(this, r); r > n; n++) {
          i[n] = l ? s(c[n], n) : c[n];
        }return i;
      },
          jt = function jt() {
        for (var t = 0, n = arguments.length, r = Ft(this, n); n > t;) {
          r[t] = arguments[t++];
        }return r;
      },
          Tt = !!z && o(function () {
        vt.call(new z(1));
      }),
          Nt = function Nt() {
        return vt.apply(Tt ? lt.call(Ot(this)) : Ot(this), arguments);
      },
          Lt = { copyWithin: function copyWithin(t, n) {
          return D.call(Ot(this), t, n, arguments.length > 2 ? arguments[2] : void 0);
        }, every: function every(t) {
          return Z(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, fill: function fill(t) {
          return C.apply(Ot(this), arguments);
        }, filter: function filter(t) {
          return Pt(this, $(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0));
        }, find: function find(t) {
          return Q(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, findIndex: function findIndex(t) {
          return tt(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, forEach: function forEach(t) {
          J(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, indexOf: function indexOf(t) {
          return rt(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, includes: function includes(t) {
          return nt(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, join: function join(t) {
          return ft.apply(Ot(this), arguments);
        }, lastIndexOf: function lastIndexOf(t) {
          return ut.apply(Ot(this), arguments);
        }, map: function map(t) {
          return wt(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, reduce: function reduce(t) {
          return ct.apply(Ot(this), arguments);
        }, reduceRight: function reduceRight(t) {
          return at.apply(Ot(this), arguments);
        }, reverse: function reverse() {
          for (var t, n = Ot(this).length, r = Math.floor(n / 2), e = 0; e < r;) {
            t = this[e], this[e++] = this[--n], this[n] = t;
          }return this;
        }, some: function some(t) {
          return X(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, sort: function sort(t) {
          return st.call(Ot(this), t);
        }, subarray: function subarray(t, n) {
          var r = Ot(this),
              e = r.length,
              i = y(t, e);return new (T(r, r[yt]))(r.buffer, r.byteOffset + i * r.BYTES_PER_ELEMENT, d((void 0 === n ? e : y(n, e)) - i));
        } },
          kt = function kt(t, n) {
        return Pt(this, lt.call(Ot(this), t, n));
      },
          Rt = function Rt(t) {
        Ot(this);var n = Et(arguments[1], 1),
            r = this.length,
            e = S(t),
            i = d(e.length),
            o = 0;if (i + n > r) throw G("Wrong length!");for (; o < i;) {
          this[n + o] = e[o++];
        }
      },
          Ct = { entries: function entries() {
          return ot.call(Ot(this));
        }, keys: function keys() {
          return it.call(Ot(this));
        }, values: function values() {
          return et.call(Ot(this));
        } },
          Dt = function Dt(t, n) {
        return w(t) && t[bt] && "symbol" != typeof n && n in t && String(+n) == String(n);
      },
          Wt = function Wt(t, n) {
        return Dt(t, n = m(n, !0)) ? l(2, t[n]) : V(t, n);
      },
          Bt = function Bt(t, n, r) {
        return !(Dt(t, n = m(n, !0)) && w(r) && b(r, "value")) || b(r, "get") || b(r, "set") || r.configurable || b(r, "writable") && !r.writable || b(r, "enumerable") && !r.enumerable ? U(t, n, r) : (t[n] = r.value, t);
      };mt || (B.f = Wt, W.f = Bt), u(u.S + u.F * !mt, "Object", { getOwnPropertyDescriptor: Wt, defineProperty: Bt }), o(function () {
        ht.call({});
      }) && (ht = vt = function vt() {
        return ft.call(this);
      });var Ut = v({}, Lt);v(Ut, Ct), h(Ut, pt, Ct.values), v(Ut, { slice: kt, set: Rt, constructor: function constructor() {}, toString: ht, toLocaleString: Nt }), Mt(Ut, "buffer", "b"), Mt(Ut, "byteOffset", "o"), Mt(Ut, "byteLength", "l"), Mt(Ut, "length", "e"), U(Ut, dt, { get: function get() {
          return this[bt];
        } }), t.exports = function (t, n, r, a) {
        var f = t + ((a = !!a) ? "Clamped" : "") + "Array",
            l = "get" + t,
            v = "set" + t,
            p = i[f],
            y = p || {},
            m = p && O(p),
            b = !p || !c.ABV,
            S = {},
            _ = p && p.prototype,
            P = function P(t, r) {
          U(t, r, { get: function get() {
              return function (t, r) {
                var e = t._d;return e.v[l](r * n + e.o, St);
              }(this, r);
            }, set: function set(t) {
              return function (t, r, e) {
                var i = t._d;a && (e = (e = Math.round(e)) < 0 ? 0 : e > 255 ? 255 : 255 & e), i.v[v](r * n + i.o, e, St);
              }(this, r, t);
            }, enumerable: !0 });
        };b ? (p = r(function (t, r, e, i) {
          s(t, p, f, "_d");var o,
              u,
              c,
              a,
              l = 0,
              v = 0;if (w(r)) {
            if (!(r instanceof K || "ArrayBuffer" == (a = x(r)) || "SharedArrayBuffer" == a)) return bt in r ? It(p, r) : At.call(p, r);o = r, v = Et(e, n);var y = r.byteLength;if (void 0 === i) {
              if (y % n) throw G("Wrong length!");if ((u = y - v) < 0) throw G("Wrong length!");
            } else if ((u = d(i) * n) + v > y) throw G("Wrong length!");c = u / n;
          } else c = g(r), o = new K(u = c * n);for (h(t, "_d", { b: o, o: v, l: u, e: c, v: new q(o) }); l < c;) {
            P(t, l++);
          }
        }), _ = p.prototype = E(Ut), h(_, "constructor", p)) : o(function () {
          p(1);
        }) && o(function () {
          new p(-1);
        }) && k(function (t) {
          new p(), new p(null), new p(1.5), new p(t);
        }, !0) || (p = r(function (t, r, e, i) {
          var o;return s(t, p, f), w(r) ? r instanceof K || "ArrayBuffer" == (o = x(r)) || "SharedArrayBuffer" == o ? void 0 !== i ? new y(r, Et(e, n), i) : void 0 !== e ? new y(r, Et(e, n)) : new y(r) : bt in r ? It(p, r) : At.call(p, r) : new y(g(r));
        }), J(m !== Function.prototype ? F(y).concat(F(m)) : F(y), function (t) {
          t in p || h(p, t, y[t]);
        }), p.prototype = _, e || (_.constructor = p));var I = _[pt],
            M = !!I && ("values" == I.name || null == I.name),
            A = Ct.values;h(p, gt, !0), h(_, bt, f), h(_, xt, !0), h(_, yt, p), (a ? new p(1)[dt] == f : dt in _) || U(_, dt, { get: function get() {
            return f;
          } }), S[f] = p, u(u.G + u.W + u.F * (p != y), S), u(u.S, f, { BYTES_PER_ELEMENT: n }), u(u.S + u.F * o(function () {
          y.of.call(p, 1);
        }), f, { from: At, of: jt }), "BYTES_PER_ELEMENT" in _ || h(_, "BYTES_PER_ELEMENT", n), u(u.P, f, Lt), R(f), u(u.P + u.F * _t, f, { set: Rt }), u(u.P + u.F * !M, f, Ct), e || _.toString == ht || (_.toString = ht), u(u.P + u.F * o(function () {
          new p(1).slice();
        }), f, { slice: kt }), u(u.P + u.F * (o(function () {
          return [1, 2].toLocaleString() != new p([1, 2]).toLocaleString();
        }) || !o(function () {
          _.toLocaleString.call([1, 2]);
        })), f, { toLocaleString: Nt }), L[f] = M ? I : A, e || M || h(_, pt, A);
      };
    } else t.exports = function () {};
  }, function (t, n, r) {
    var e = r(4);t.exports = function (t, n) {
      if (!e(t)) return t;var r, i;if (n && "function" == typeof (r = t.toString) && !e(i = r.call(t))) return i;if ("function" == typeof (r = t.valueOf) && !e(i = r.call(t))) return i;if (!n && "function" == typeof (r = t.toString) && !e(i = r.call(t))) return i;throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, n, r) {
    var e = r(29)("meta"),
        i = r(4),
        o = r(13),
        u = r(7).f,
        c = 0,
        a = Object.isExtensible || function () {
      return !0;
    },
        f = !r(1)(function () {
      return a(Object.preventExtensions({}));
    }),
        s = function s(t) {
      u(t, e, { value: { i: "O" + ++c, w: {} } });
    },
        l = t.exports = { KEY: e, NEED: !1, fastKey: function fastKey(t, n) {
        if (!i(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;if (!o(t, e)) {
          if (!a(t)) return "F";if (!n) return "E";s(t);
        }return t[e].i;
      }, getWeak: function getWeak(t, n) {
        if (!o(t, e)) {
          if (!a(t)) return !0;if (!n) return !1;s(t);
        }return t[e].w;
      }, onFreeze: function onFreeze(t) {
        return f && l.NEED && a(t) && !o(t, e) && s(t), t;
      } };
  }, function (t, n) {
    t.exports = function (t, n) {
      return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: n };
    };
  }, function (t, n) {
    var r = 0,
        e = Math.random();t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++r + e).toString(36));
    };
  }, function (t, n) {
    t.exports = !1;
  }, function (t, n, r) {
    var e = r(87),
        i = r(62);t.exports = Object.keys || function (t) {
      return e(t, i);
    };
  }, function (t, n, r) {
    var e = r(17),
        i = Math.max,
        o = Math.min;t.exports = function (t, n) {
      return (t = e(t)) < 0 ? i(t + n, 0) : o(t, n);
    };
  }, function (t, n, r) {
    var e = r(2),
        i = r(88),
        o = r(62),
        u = r(61)("IE_PROTO"),
        c = function c() {},
        _a = function a() {
      var t,
          n = r(58)("iframe"),
          e = o.length;for (n.style.display = "none", r(64).appendChild(n), n.src = "javascript:", (t = n.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _a = t.F; e--;) {
        delete _a.prototype[o[e]];
      }return _a();
    };t.exports = Object.create || function (t, n) {
      var r;return null !== t ? (c.prototype = e(t), r = new c(), c.prototype = null, r[u] = t) : r = _a(), void 0 === n ? r : i(r, n);
    };
  }, function (t, n, r) {
    var e = r(87),
        i = r(62).concat("length", "prototype");n.f = Object.getOwnPropertyNames || function (t) {
      return e(t, i);
    };
  }, function (t, n, r) {
    var e = r(13),
        i = r(11),
        o = r(61)("IE_PROTO"),
        u = Object.prototype;t.exports = Object.getPrototypeOf || function (t) {
      return t = i(t), e(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
    };
  }, function (t, n, r) {
    var e = r(7).f,
        i = r(13),
        o = r(5)("toStringTag");t.exports = function (t, n, r) {
      t && !i(t = r ? t : t.prototype, o) && e(t, o, { configurable: !0, value: n });
    };
  }, function (t, n) {
    t.exports = {};
  }, function (t, n, r) {
    var e = r(5)("unscopables"),
        i = Array.prototype;null == i[e] && r(14)(i, e, {}), t.exports = function (t) {
      i[e][t] = !0;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(3),
        i = r(7),
        o = r(8),
        u = r(5)("species");t.exports = function (t) {
      var n = e[t];o && n && !n[u] && i.f(n, u, { configurable: !0, get: function get() {
          return this;
        } });
    };
  }, function (t, n) {
    t.exports = function (t, n, r, e) {
      if (!(t instanceof n) || void 0 !== e && e in t) throw TypeError(r + ": incorrect invocation!");return t;
    };
  }, function (t, n, r) {
    var e = r(10);t.exports = function (t, n, r) {
      for (var i in n) {
        e(t, i, n[i], r);
      }return t;
    };
  }, function (t, n, r) {
    var e = r(4);t.exports = function (t, n) {
      if (!e(t) || t._t !== n) throw TypeError("Incompatible receiver, " + n + " required!");return t;
    };
  }, function (t, n, r) {
    var e = r(23);t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == e(t) ? t.split("") : Object(t);
    };
  }, function (t, n) {
    n.f = {}.propertyIsEnumerable;
  }, function (t, n, r) {
    var e = r(23),
        i = r(5)("toStringTag"),
        o = "Arguments" == e(function () {
      return arguments;
    }());t.exports = function (t) {
      var n, r, u;return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function (t, n) {
        try {
          return t[n];
        } catch (t) {}
      }(n = Object(t), i)) ? r : o ? e(n) : "Object" == (u = e(n)) && "function" == typeof n.callee ? "Arguments" : u;
    };
  }, function (t, n, r) {
    var e = r(2),
        i = r(22),
        o = r(5)("species");t.exports = function (t, n) {
      var r,
          u = e(t).constructor;return void 0 === u || null == (r = e(u)[o]) ? n : i(r);
    };
  }, function (t, n, r) {
    var e = r(15),
        i = r(6),
        o = r(32);t.exports = function (t) {
      return function (n, r, u) {
        var c,
            a = e(n),
            f = i(a.length),
            s = o(u, f);if (t && r != r) {
          for (; f > s;) {
            if ((c = a[s++]) != c) return !0;
          }
        } else for (; f > s; s++) {
          if ((t || s in a) && a[s] === r) return t || s || 0;
        }return !t && -1;
      };
    };
  }, function (t, n) {
    n.f = Object.getOwnPropertySymbols;
  }, function (t, n, r) {
    var e = r(0),
        i = r(24),
        o = r(1),
        u = r(66),
        c = "[" + u + "]",
        a = RegExp("^" + c + c + "*"),
        f = RegExp(c + c + "*$"),
        s = function s(t, n, r) {
      var i = {},
          c = o(function () {
        return !!u[t]() || "​" != "​"[t]();
      }),
          a = i[t] = c ? n(l) : u[t];r && (i[r] = a), e(e.P + e.F * c, "String", i);
    },
        l = s.trim = function (t, n) {
      return t = String(i(t)), 1 & n && (t = t.replace(a, "")), 2 & n && (t = t.replace(f, "")), t;
    };t.exports = s;
  }, function (t, n, r) {
    var e = r(5)("iterator"),
        i = !1;try {
      var o = [7][e]();o.return = function () {
        i = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (t) {}t.exports = function (t, n) {
      if (!n && !i) return !1;var r = !1;try {
        var o = [7],
            u = o[e]();u.next = function () {
          return { done: r = !0 };
        }, o[e] = function () {
          return u;
        }, t(o);
      } catch (t) {}return r;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(2);t.exports = function () {
      var t = e(this),
          n = "";return t.global && (n += "g"), t.ignoreCase && (n += "i"), t.multiline && (n += "m"), t.unicode && (n += "u"), t.sticky && (n += "y"), n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(45),
        i = RegExp.prototype.exec;t.exports = function (t, n) {
      var r = t.exec;if ("function" == typeof r) {
        var o = r.call(t, n);if ("object" != typeof o) throw new TypeError("RegExp exec method returned something other than an Object or null");return o;
      }if ("RegExp" !== e(t)) throw new TypeError("RegExp#exec called on incompatible receiver");return i.call(t, n);
    };
  }, function (t, n, r) {
    "use strict";
    r(104);var e = r(10),
        i = r(14),
        o = r(1),
        u = r(24),
        c = r(5),
        a = r(81),
        f = c("species"),
        s = !o(function () {
      var t = /./;return t.exec = function () {
        var t = [];return t.groups = { a: "7" }, t;
      }, "7" !== "".replace(t, "$<a>");
    }),
        l = function () {
      var t = /(?:)/,
          n = t.exec;t.exec = function () {
        return n.apply(this, arguments);
      };var r = "ab".split(t);return 2 === r.length && "a" === r[0] && "b" === r[1];
    }();t.exports = function (t, n, r) {
      var h = c(t),
          v = !o(function () {
        var n = {};return n[h] = function () {
          return 7;
        }, 7 != ""[t](n);
      }),
          p = v ? !o(function () {
        var n = !1,
            r = /a/;return r.exec = function () {
          return n = !0, null;
        }, "split" === t && (r.constructor = {}, r.constructor[f] = function () {
          return r;
        }), r[h](""), !n;
      }) : void 0;if (!v || !p || "replace" === t && !s || "split" === t && !l) {
        var d = /./[h],
            g = r(u, h, ""[t], function (t, n, r, e, i) {
          return n.exec === a ? v && !i ? { done: !0, value: d.call(n, r, e) } : { done: !0, value: t.call(r, n, e) } : { done: !1 };
        }),
            y = g[0],
            m = g[1];e(String.prototype, t, y), i(RegExp.prototype, h, 2 == n ? function (t, n) {
          return m.call(t, this, n);
        } : function (t) {
          return m.call(t, this);
        });
      }
    };
  }, function (t, n, r) {
    var e = r(21),
        i = r(100),
        o = r(76),
        u = r(2),
        c = r(6),
        a = r(78),
        f = {},
        s = {};(n = t.exports = function (t, n, r, l, h) {
      var v,
          p,
          d,
          g,
          y = h ? function () {
        return t;
      } : a(t),
          m = e(r, l, n ? 2 : 1),
          b = 0;if ("function" != typeof y) throw TypeError(t + " is not iterable!");if (o(y)) {
        for (v = c(t.length); v > b; b++) {
          if ((g = n ? m(u(p = t[b])[0], p[1]) : m(t[b])) === f || g === s) return g;
        }
      } else for (d = y.call(t); !(p = d.next()).done;) {
        if ((g = i(d, m, p.value, n)) === f || g === s) return g;
      }
    }).BREAK = f, n.RETURN = s;
  }, function (t, n, r) {
    var e = r(3).navigator;t.exports = e && e.userAgent || "";
  }, function (t, n, r) {
    "use strict";
    var e = r(3),
        i = r(0),
        o = r(10),
        u = r(41),
        c = r(27),
        a = r(54),
        f = r(40),
        s = r(4),
        l = r(1),
        h = r(50),
        v = r(36),
        p = r(67);t.exports = function (t, n, r, d, g, y) {
      var m = e[t],
          b = m,
          x = g ? "set" : "add",
          w = b && b.prototype,
          S = {},
          _ = function _(t) {
        var n = w[t];o(w, t, "delete" == t ? function (t) {
          return !(y && !s(t)) && n.call(this, 0 === t ? 0 : t);
        } : "has" == t ? function (t) {
          return !(y && !s(t)) && n.call(this, 0 === t ? 0 : t);
        } : "get" == t ? function (t) {
          return y && !s(t) ? void 0 : n.call(this, 0 === t ? 0 : t);
        } : "add" == t ? function (t) {
          return n.call(this, 0 === t ? 0 : t), this;
        } : function (t, r) {
          return n.call(this, 0 === t ? 0 : t, r), this;
        });
      };if ("function" == typeof b && (y || w.forEach && !l(function () {
        new b().entries().next();
      }))) {
        var E = new b(),
            O = E[x](y ? {} : -0, 1) != E,
            F = l(function () {
          E.has(1);
        }),
            P = h(function (t) {
          new b(t);
        }),
            I = !y && l(function () {
          for (var t = new b(), n = 5; n--;) {
            t[x](n, n);
          }return !t.has(-0);
        });P || ((b = n(function (n, r) {
          f(n, b, t);var e = p(new m(), n, b);return null != r && a(r, g, e[x], e), e;
        })).prototype = w, w.constructor = b), (F || I) && (_("delete"), _("has"), g && _("get")), (I || O) && _(x), y && w.clear && delete w.clear;
      } else b = d.getConstructor(n, t, g, x), u(b.prototype, r), c.NEED = !0;return v(b, t), S[t] = b, i(i.G + i.W + i.F * (b != m), S), y || d.setStrong(b, t, g), b;
    };
  }, function (t, n, r) {
    for (var e, i = r(3), o = r(14), u = r(29), c = u("typed_array"), a = u("view"), f = !(!i.ArrayBuffer || !i.DataView), s = f, l = 0, h = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); l < 9;) {
      (e = i[h[l++]]) ? (o(e.prototype, c, !0), o(e.prototype, a, !0)) : s = !1;
    }t.exports = { ABV: f, CONSTR: s, TYPED: c, VIEW: a };
  }, function (t, n, r) {
    var e = r(4),
        i = r(3).document,
        o = e(i) && e(i.createElement);t.exports = function (t) {
      return o ? i.createElement(t) : {};
    };
  }, function (t, n, r) {
    var e = r(9),
        i = r(3),
        o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});(t.exports = function (t, n) {
      return o[t] || (o[t] = void 0 !== n ? n : {});
    })("versions", []).push({ version: e.version, mode: r(30) ? "pure" : "global", copyright: "© 2019 Denis Pushkarev (zloirock.ru)" });
  }, function (t, n, r) {
    n.f = r(5);
  }, function (t, n, r) {
    var e = r(59)("keys"),
        i = r(29);t.exports = function (t) {
      return e[t] || (e[t] = i(t));
    };
  }, function (t, n) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, n, r) {
    var e = r(23);t.exports = Array.isArray || function (t) {
      return "Array" == e(t);
    };
  }, function (t, n, r) {
    var e = r(3).document;t.exports = e && e.documentElement;
  }, function (t, n, r) {
    var e = r(4),
        i = r(2),
        o = function o(t, n) {
      if (i(t), !e(n) && null !== n) throw TypeError(n + ": can't set as prototype!");
    };t.exports = { set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, n, e) {
        try {
          (e = r(21)(Function.call, r(18).f(Object.prototype, "__proto__").set, 2))(t, []), n = !(t instanceof Array);
        } catch (t) {
          n = !0;
        }return function (t, r) {
          return o(t, r), n ? t.__proto__ = r : e(t, r), t;
        };
      }({}, !1) : void 0), check: o };
  }, function (t, n) {
    t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, function (t, n, r) {
    var e = r(4),
        i = r(65).set;t.exports = function (t, n, r) {
      var o,
          u = n.constructor;return u !== r && "function" == typeof u && (o = u.prototype) !== r.prototype && e(o) && i && i(t, o), t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(17),
        i = r(24);t.exports = function (t) {
      var n = String(i(this)),
          r = "",
          o = e(t);if (o < 0 || o == 1 / 0) throw RangeError("Count can't be negative");for (; o > 0; (o >>>= 1) && (n += n)) {
        1 & o && (r += n);
      }return r;
    };
  }, function (t, n) {
    t.exports = Math.sign || function (t) {
      return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1;
    };
  }, function (t, n) {
    var r = Math.expm1;t.exports = !r || r(10) > 22025.465794806718 || r(10) < 22025.465794806718 || -2e-17 != r(-2e-17) ? function (t) {
      return 0 == (t = +t) ? t : t > -1e-6 && t < 1e-6 ? t + t * t / 2 : Math.exp(t) - 1;
    } : r;
  }, function (t, n, r) {
    var e = r(17),
        i = r(24);t.exports = function (t) {
      return function (n, r) {
        var o,
            u,
            c = String(i(n)),
            a = e(r),
            f = c.length;return a < 0 || a >= f ? t ? "" : void 0 : (o = c.charCodeAt(a)) < 55296 || o > 56319 || a + 1 === f || (u = c.charCodeAt(a + 1)) < 56320 || u > 57343 ? t ? c.charAt(a) : o : t ? c.slice(a, a + 2) : u - 56320 + (o - 55296 << 10) + 65536;
      };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(30),
        i = r(0),
        o = r(10),
        u = r(14),
        c = r(37),
        a = r(99),
        f = r(36),
        s = r(35),
        l = r(5)("iterator"),
        h = !([].keys && "next" in [].keys()),
        v = function v() {
      return this;
    };t.exports = function (t, n, r, p, d, g, y) {
      a(r, n, p);var m,
          b,
          x,
          w = function w(t) {
        if (!h && t in O) return O[t];switch (t) {case "keys":case "values":
            return function () {
              return new r(this, t);
            };}return function () {
          return new r(this, t);
        };
      },
          S = n + " Iterator",
          _ = "values" == d,
          E = !1,
          O = t.prototype,
          F = O[l] || O["@@iterator"] || d && O[d],
          P = F || w(d),
          I = d ? _ ? w("entries") : P : void 0,
          M = "Array" == n && O.entries || F;if (M && (x = s(M.call(new t()))) !== Object.prototype && x.next && (f(x, S, !0), e || "function" == typeof x[l] || u(x, l, v)), _ && F && "values" !== F.name && (E = !0, P = function P() {
        return F.call(this);
      }), e && !y || !h && !E && O[l] || u(O, l, P), c[n] = P, c[S] = v, d) if (m = { values: _ ? P : w("values"), keys: g ? P : w("keys"), entries: I }, y) for (b in m) {
        b in O || o(O, b, m[b]);
      } else i(i.P + i.F * (h || E), n, m);return m;
    };
  }, function (t, n, r) {
    var e = r(74),
        i = r(24);t.exports = function (t, n, r) {
      if (e(n)) throw TypeError("String#" + r + " doesn't accept regex!");return String(i(t));
    };
  }, function (t, n, r) {
    var e = r(4),
        i = r(23),
        o = r(5)("match");t.exports = function (t) {
      var n;return e(t) && (void 0 !== (n = t[o]) ? !!n : "RegExp" == i(t));
    };
  }, function (t, n, r) {
    var e = r(5)("match");t.exports = function (t) {
      var n = /./;try {
        "/./"[t](n);
      } catch (r) {
        try {
          return n[e] = !1, !"/./"[t](n);
        } catch (t) {}
      }return !0;
    };
  }, function (t, n, r) {
    var e = r(37),
        i = r(5)("iterator"),
        o = Array.prototype;t.exports = function (t) {
      return void 0 !== t && (e.Array === t || o[i] === t);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(7),
        i = r(28);t.exports = function (t, n, r) {
      n in t ? e.f(t, n, i(0, r)) : t[n] = r;
    };
  }, function (t, n, r) {
    var e = r(45),
        i = r(5)("iterator"),
        o = r(37);t.exports = r(9).getIteratorMethod = function (t) {
      if (null != t) return t[i] || t["@@iterator"] || o[e(t)];
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(11),
        i = r(32),
        o = r(6);t.exports = function (t) {
      for (var n = e(this), r = o(n.length), u = arguments.length, c = i(u > 1 ? arguments[1] : void 0, r), a = u > 2 ? arguments[2] : void 0, f = void 0 === a ? r : i(a, r); f > c;) {
        n[c++] = t;
      }return n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(38),
        i = r(103),
        o = r(37),
        u = r(15);t.exports = r(72)(Array, "Array", function (t, n) {
      this._t = u(t), this._i = 0, this._k = n;
    }, function () {
      var t = this._t,
          n = this._k,
          r = this._i++;return !t || r >= t.length ? (this._t = void 0, i(1)) : i(0, "keys" == n ? r : "values" == n ? t[r] : [r, t[r]]);
    }, "values"), o.Arguments = o.Array, e("keys"), e("values"), e("entries");
  }, function (t, n, r) {
    "use strict";
    var e,
        i,
        o = r(51),
        u = RegExp.prototype.exec,
        c = String.prototype.replace,
        a = u,
        f = (e = /a/, i = /b*/g, u.call(e, "a"), u.call(i, "a"), 0 !== e.lastIndex || 0 !== i.lastIndex),
        s = void 0 !== /()??/.exec("")[1];(f || s) && (a = function a(t) {
      var n,
          r,
          e,
          i,
          a = this;return s && (r = new RegExp("^" + a.source + "$(?!\\s)", o.call(a))), f && (n = a.lastIndex), e = u.call(a, t), f && e && (a.lastIndex = a.global ? e.index + e[0].length : n), s && e && e.length > 1 && c.call(e[0], r, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          void 0 === arguments[i] && (e[i] = void 0);
        }
      }), e;
    }), t.exports = a;
  }, function (t, n, r) {
    "use strict";
    var e = r(71)(!0);t.exports = function (t, n, r) {
      return n + (r ? e(t, n).length : 1);
    };
  }, function (t, n, r) {
    var e,
        i,
        o,
        u = r(21),
        c = r(93),
        a = r(64),
        f = r(58),
        s = r(3),
        l = s.process,
        h = s.setImmediate,
        v = s.clearImmediate,
        p = s.MessageChannel,
        d = s.Dispatch,
        g = 0,
        y = {},
        m = function m() {
      var t = +this;if (y.hasOwnProperty(t)) {
        var n = y[t];delete y[t], n();
      }
    },
        b = function b(t) {
      m.call(t.data);
    };h && v || (h = function h(t) {
      for (var n = [], r = 1; arguments.length > r;) {
        n.push(arguments[r++]);
      }return y[++g] = function () {
        c("function" == typeof t ? t : Function(t), n);
      }, e(g), g;
    }, v = function v(t) {
      delete y[t];
    }, "process" == r(23)(l) ? e = function e(t) {
      l.nextTick(u(m, t, 1));
    } : d && d.now ? e = function e(t) {
      d.now(u(m, t, 1));
    } : p ? (o = (i = new p()).port2, i.port1.onmessage = b, e = u(o.postMessage, o, 1)) : s.addEventListener && "function" == typeof postMessage && !s.importScripts ? (e = function e(t) {
      s.postMessage(t + "", "*");
    }, s.addEventListener("message", b, !1)) : e = "onreadystatechange" in f("script") ? function (t) {
      a.appendChild(f("script")).onreadystatechange = function () {
        a.removeChild(this), m.call(t);
      };
    } : function (t) {
      setTimeout(u(m, t, 1), 0);
    }), t.exports = { set: h, clear: v };
  }, function (t, n, r) {
    "use strict";
    var e = r(3),
        i = r(8),
        o = r(30),
        u = r(57),
        c = r(14),
        a = r(41),
        f = r(1),
        s = r(40),
        l = r(17),
        h = r(6),
        v = r(111),
        p = r(34).f,
        d = r(7).f,
        g = r(79),
        y = r(36),
        m = "prototype",
        b = "Wrong index!",
        _x2 = e.ArrayBuffer,
        _w = e.DataView,
        S = e.Math,
        _ = e.RangeError,
        E = e.Infinity,
        O = _x2,
        F = S.abs,
        P = S.pow,
        I = S.floor,
        M = S.log,
        A = S.LN2,
        j = i ? "_b" : "buffer",
        T = i ? "_l" : "byteLength",
        N = i ? "_o" : "byteOffset";function L(t, n, r) {
      var e,
          i,
          o,
          u = new Array(r),
          c = 8 * r - n - 1,
          a = (1 << c) - 1,
          f = a >> 1,
          s = 23 === n ? P(2, -24) - P(2, -77) : 0,
          l = 0,
          h = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;for ((t = F(t)) != t || t === E ? (i = t != t ? 1 : 0, e = a) : (e = I(M(t) / A), t * (o = P(2, -e)) < 1 && (e--, o *= 2), (t += e + f >= 1 ? s / o : s * P(2, 1 - f)) * o >= 2 && (e++, o /= 2), e + f >= a ? (i = 0, e = a) : e + f >= 1 ? (i = (t * o - 1) * P(2, n), e += f) : (i = t * P(2, f - 1) * P(2, n), e = 0)); n >= 8; u[l++] = 255 & i, i /= 256, n -= 8) {}for (e = e << n | i, c += n; c > 0; u[l++] = 255 & e, e /= 256, c -= 8) {}return u[--l] |= 128 * h, u;
    }function k(t, n, r) {
      var e,
          i = 8 * r - n - 1,
          o = (1 << i) - 1,
          u = o >> 1,
          c = i - 7,
          a = r - 1,
          f = t[a--],
          s = 127 & f;for (f >>= 7; c > 0; s = 256 * s + t[a], a--, c -= 8) {}for (e = s & (1 << -c) - 1, s >>= -c, c += n; c > 0; e = 256 * e + t[a], a--, c -= 8) {}if (0 === s) s = 1 - u;else {
        if (s === o) return e ? NaN : f ? -E : E;e += P(2, n), s -= u;
      }return (f ? -1 : 1) * e * P(2, s - n);
    }function R(t) {
      return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0];
    }function C(t) {
      return [255 & t];
    }function D(t) {
      return [255 & t, t >> 8 & 255];
    }function W(t) {
      return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255];
    }function B(t) {
      return L(t, 52, 8);
    }function U(t) {
      return L(t, 23, 4);
    }function V(t, n, r) {
      d(t[m], n, { get: function get() {
          return this[r];
        } });
    }function G(t, n, r, e) {
      var i = v(+r);if (i + n > t[T]) throw _(b);var o = t[j]._b,
          u = i + t[N],
          c = o.slice(u, u + n);return e ? c : c.reverse();
    }function H(t, n, r, e, i, o) {
      var u = v(+r);if (u + n > t[T]) throw _(b);for (var c = t[j]._b, a = u + t[N], f = e(+i), s = 0; s < n; s++) {
        c[a + s] = f[o ? s : n - s - 1];
      }
    }if (u.ABV) {
      if (!f(function () {
        _x2(1);
      }) || !f(function () {
        new _x2(-1);
      }) || f(function () {
        return new _x2(), new _x2(1.5), new _x2(NaN), "ArrayBuffer" != _x2.name;
      })) {
        for (var z, Y = (_x2 = function x(t) {
          return s(this, _x2), new O(v(t));
        })[m] = O[m], K = p(O), q = 0; K.length > q;) {
          (z = K[q++]) in _x2 || c(_x2, z, O[z]);
        }o || (Y.constructor = _x2);
      }var J = new _w(new _x2(2)),
          $ = _w[m].setInt8;J.setInt8(0, 2147483648), J.setInt8(1, 2147483649), !J.getInt8(0) && J.getInt8(1) || a(_w[m], { setInt8: function setInt8(t, n) {
          $.call(this, t, n << 24 >> 24);
        }, setUint8: function setUint8(t, n) {
          $.call(this, t, n << 24 >> 24);
        } }, !0);
    } else _x2 = function _x(t) {
      s(this, _x2, "ArrayBuffer");var n = v(t);this._b = g.call(new Array(n), 0), this[T] = n;
    }, _w = function w(t, n, r) {
      s(this, _w, "DataView"), s(t, _x2, "DataView");var e = t[T],
          i = l(n);if (i < 0 || i > e) throw _("Wrong offset!");if (i + (r = void 0 === r ? e - i : h(r)) > e) throw _("Wrong length!");this[j] = t, this[N] = i, this[T] = r;
    }, i && (V(_x2, "byteLength", "_l"), V(_w, "buffer", "_b"), V(_w, "byteLength", "_l"), V(_w, "byteOffset", "_o")), a(_w[m], { getInt8: function getInt8(t) {
        return G(this, 1, t)[0] << 24 >> 24;
      }, getUint8: function getUint8(t) {
        return G(this, 1, t)[0];
      }, getInt16: function getInt16(t) {
        var n = G(this, 2, t, arguments[1]);return (n[1] << 8 | n[0]) << 16 >> 16;
      }, getUint16: function getUint16(t) {
        var n = G(this, 2, t, arguments[1]);return n[1] << 8 | n[0];
      }, getInt32: function getInt32(t) {
        return R(G(this, 4, t, arguments[1]));
      }, getUint32: function getUint32(t) {
        return R(G(this, 4, t, arguments[1])) >>> 0;
      }, getFloat32: function getFloat32(t) {
        return k(G(this, 4, t, arguments[1]), 23, 4);
      }, getFloat64: function getFloat64(t) {
        return k(G(this, 8, t, arguments[1]), 52, 8);
      }, setInt8: function setInt8(t, n) {
        H(this, 1, t, C, n);
      }, setUint8: function setUint8(t, n) {
        H(this, 1, t, C, n);
      }, setInt16: function setInt16(t, n) {
        H(this, 2, t, D, n, arguments[2]);
      }, setUint16: function setUint16(t, n) {
        H(this, 2, t, D, n, arguments[2]);
      }, setInt32: function setInt32(t, n) {
        H(this, 4, t, W, n, arguments[2]);
      }, setUint32: function setUint32(t, n) {
        H(this, 4, t, W, n, arguments[2]);
      }, setFloat32: function setFloat32(t, n) {
        H(this, 4, t, U, n, arguments[2]);
      }, setFloat64: function setFloat64(t, n) {
        H(this, 8, t, B, n, arguments[2]);
      } });y(_x2, "ArrayBuffer"), y(_w, "DataView"), c(_w[m], u.VIEW, !0), n.ArrayBuffer = _x2, n.DataView = _w;
  }, function (t, n, r) {
    t.exports = !r(8) && !r(1)(function () {
      return 7 != Object.defineProperty(r(58)("div"), "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, n, r) {
    var e = r(3),
        i = r(9),
        o = r(30),
        u = r(60),
        c = r(7).f;t.exports = function (t) {
      var n = i.Symbol || (i.Symbol = o ? {} : e.Symbol || {});"_" == t.charAt(0) || t in n || c(n, t, { value: u.f(t) });
    };
  }, function (t, n, r) {
    var e = r(13),
        i = r(15),
        o = r(47)(!1),
        u = r(61)("IE_PROTO");t.exports = function (t, n) {
      var r,
          c = i(t),
          a = 0,
          f = [];for (r in c) {
        r != u && e(c, r) && f.push(r);
      }for (; n.length > a;) {
        e(c, r = n[a++]) && (~o(f, r) || f.push(r));
      }return f;
    };
  }, function (t, n, r) {
    var e = r(7),
        i = r(2),
        o = r(31);t.exports = r(8) ? Object.defineProperties : function (t, n) {
      i(t);for (var r, u = o(n), c = u.length, a = 0; c > a;) {
        e.f(t, r = u[a++], n[r]);
      }return t;
    };
  }, function (t, n, r) {
    var e = r(15),
        i = r(34).f,
        o = {}.toString,
        u = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];t.exports.f = function (t) {
      return u && "[object Window]" == o.call(t) ? function (t) {
        try {
          return i(t);
        } catch (t) {
          return u.slice();
        }
      }(t) : i(e(t));
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(31),
        i = r(48),
        o = r(44),
        u = r(11),
        c = r(43),
        a = Object.assign;t.exports = !a || r(1)(function () {
      var t = {},
          n = {},
          r = Symbol(),
          e = "abcdefghijklmnopqrst";return t[r] = 7, e.split("").forEach(function (t) {
        n[t] = t;
      }), 7 != a({}, t)[r] || Object.keys(a({}, n)).join("") != e;
    }) ? function (t, n) {
      for (var r = u(t), a = arguments.length, f = 1, s = i.f, l = o.f; a > f;) {
        for (var h, v = c(arguments[f++]), p = s ? e(v).concat(s(v)) : e(v), d = p.length, g = 0; d > g;) {
          l.call(v, h = p[g++]) && (r[h] = v[h]);
        }
      }return r;
    } : a;
  }, function (t, n) {
    t.exports = Object.is || function (t, n) {
      return t === n ? 0 !== t || 1 / t == 1 / n : t != t && n != n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(22),
        i = r(4),
        o = r(93),
        u = [].slice,
        c = {};t.exports = Function.bind || function (t) {
      var n = e(this),
          r = u.call(arguments, 1),
          a = function a() {
        var e = r.concat(u.call(arguments));return this instanceof a ? function (t, n, r) {
          if (!(n in c)) {
            for (var e = [], i = 0; i < n; i++) {
              e[i] = "a[" + i + "]";
            }c[n] = Function("F,a", "return new F(" + e.join(",") + ")");
          }return c[n](t, r);
        }(n, e.length, e) : o(n, e, t);
      };return i(n.prototype) && (a.prototype = n.prototype), a;
    };
  }, function (t, n) {
    t.exports = function (t, n, r) {
      var e = void 0 === r;switch (n.length) {case 0:
          return e ? t() : t.call(r);case 1:
          return e ? t(n[0]) : t.call(r, n[0]);case 2:
          return e ? t(n[0], n[1]) : t.call(r, n[0], n[1]);case 3:
          return e ? t(n[0], n[1], n[2]) : t.call(r, n[0], n[1], n[2]);case 4:
          return e ? t(n[0], n[1], n[2], n[3]) : t.call(r, n[0], n[1], n[2], n[3]);}return t.apply(r, n);
    };
  }, function (t, n, r) {
    var e = r(3).parseInt,
        i = r(49).trim,
        o = r(66),
        u = /^[-+]?0[xX]/;t.exports = 8 !== e(o + "08") || 22 !== e(o + "0x16") ? function (t, n) {
      var r = i(String(t), 3);return e(r, n >>> 0 || (u.test(r) ? 16 : 10));
    } : e;
  }, function (t, n, r) {
    var e = r(3).parseFloat,
        i = r(49).trim;t.exports = 1 / e(r(66) + "-0") != -1 / 0 ? function (t) {
      var n = i(String(t), 3),
          r = e(n);return 0 === r && "-" == n.charAt(0) ? -0 : r;
    } : e;
  }, function (t, n, r) {
    var e = r(23);t.exports = function (t, n) {
      if ("number" != typeof t && "Number" != e(t)) throw TypeError(n);return +t;
    };
  }, function (t, n, r) {
    var e = r(4),
        i = Math.floor;t.exports = function (t) {
      return !e(t) && isFinite(t) && i(t) === t;
    };
  }, function (t, n) {
    t.exports = Math.log1p || function (t) {
      return (t = +t) > -1e-8 && t < 1e-8 ? t - t * t / 2 : Math.log(1 + t);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(33),
        i = r(28),
        o = r(36),
        u = {};r(14)(u, r(5)("iterator"), function () {
      return this;
    }), t.exports = function (t, n, r) {
      t.prototype = e(u, { next: i(1, r) }), o(t, n + " Iterator");
    };
  }, function (t, n, r) {
    var e = r(2);t.exports = function (t, n, r, i) {
      try {
        return i ? n(e(r)[0], r[1]) : n(r);
      } catch (n) {
        var o = t.return;throw void 0 !== o && e(o.call(t)), n;
      }
    };
  }, function (t, n, r) {
    var e = r(22),
        i = r(11),
        o = r(43),
        u = r(6);t.exports = function (t, n, r, c, a) {
      e(n);var f = i(t),
          s = o(f),
          l = u(f.length),
          h = a ? l - 1 : 0,
          v = a ? -1 : 1;if (r < 2) for (;;) {
        if (h in s) {
          c = s[h], h += v;break;
        }if (h += v, a ? h < 0 : l <= h) throw TypeError("Reduce of empty array with no initial value");
      }for (; a ? h >= 0 : l > h; h += v) {
        h in s && (c = n(c, s[h], h, f));
      }return c;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(11),
        i = r(32),
        o = r(6);t.exports = [].copyWithin || function (t, n) {
      var r = e(this),
          u = o(r.length),
          c = i(t, u),
          a = i(n, u),
          f = arguments.length > 2 ? arguments[2] : void 0,
          s = Math.min((void 0 === f ? u : i(f, u)) - a, u - c),
          l = 1;for (a < c && c < a + s && (l = -1, a += s - 1, c += s - 1); s-- > 0;) {
        a in r ? r[c] = r[a] : delete r[c], c += l, a += l;
      }return r;
    };
  }, function (t, n) {
    t.exports = function (t, n) {
      return { value: n, done: !!t };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(81);r(0)({ target: "RegExp", proto: !0, forced: e !== /./.exec }, { exec: e });
  }, function (t, n, r) {
    r(8) && "g" != /./g.flags && r(7).f(RegExp.prototype, "flags", { configurable: !0, get: r(51) });
  }, function (t, n, r) {
    "use strict";
    var e,
        i,
        o,
        u,
        c = r(30),
        a = r(3),
        f = r(21),
        s = r(45),
        l = r(0),
        h = r(4),
        v = r(22),
        p = r(40),
        d = r(54),
        g = r(46),
        y = r(83).set,
        m = r(230)(),
        b = r(107),
        x = r(231),
        w = r(55),
        S = r(108),
        _ = a.TypeError,
        E = a.process,
        O = E && E.versions,
        F = O && O.v8 || "",
        _P = a.Promise,
        I = "process" == s(E),
        M = function M() {},
        A = i = b.f,
        j = !!function () {
      try {
        var t = _P.resolve(1),
            n = (t.constructor = {})[r(5)("species")] = function (t) {
          t(M, M);
        };return (I || "function" == typeof PromiseRejectionEvent) && t.then(M) instanceof n && 0 !== F.indexOf("6.6") && -1 === w.indexOf("Chrome/66");
      } catch (t) {}
    }(),
        T = function T(t) {
      var n;return !(!h(t) || "function" != typeof (n = t.then)) && n;
    },
        N = function N(t, n) {
      if (!t._n) {
        t._n = !0;var r = t._c;m(function () {
          for (var e = t._v, i = 1 == t._s, o = 0, u = function u(n) {
            var r,
                o,
                u,
                c = i ? n.ok : n.fail,
                a = n.resolve,
                f = n.reject,
                s = n.domain;try {
              c ? (i || (2 == t._h && R(t), t._h = 1), !0 === c ? r = e : (s && s.enter(), r = c(e), s && (s.exit(), u = !0)), r === n.promise ? f(_("Promise-chain cycle")) : (o = T(r)) ? o.call(r, a, f) : a(r)) : f(e);
            } catch (t) {
              s && !u && s.exit(), f(t);
            }
          }; r.length > o;) {
            u(r[o++]);
          }t._c = [], t._n = !1, n && !t._h && L(t);
        });
      }
    },
        L = function L(t) {
      y.call(a, function () {
        var n,
            r,
            e,
            i = t._v,
            o = k(t);if (o && (n = x(function () {
          I ? E.emit("unhandledRejection", i, t) : (r = a.onunhandledrejection) ? r({ promise: t, reason: i }) : (e = a.console) && e.error && e.error("Unhandled promise rejection", i);
        }), t._h = I || k(t) ? 2 : 1), t._a = void 0, o && n.e) throw n.v;
      });
    },
        k = function k(t) {
      return 1 !== t._h && 0 === (t._a || t._c).length;
    },
        R = function R(t) {
      y.call(a, function () {
        var n;I ? E.emit("rejectionHandled", t) : (n = a.onrejectionhandled) && n({ promise: t, reason: t._v });
      });
    },
        C = function C(t) {
      var n = this;n._d || (n._d = !0, (n = n._w || n)._v = t, n._s = 2, n._a || (n._a = n._c.slice()), N(n, !0));
    },
        D = function D(t) {
      var n,
          r = this;if (!r._d) {
        r._d = !0, r = r._w || r;try {
          if (r === t) throw _("Promise can't be resolved itself");(n = T(t)) ? m(function () {
            var e = { _w: r, _d: !1 };try {
              n.call(t, f(D, e, 1), f(C, e, 1));
            } catch (t) {
              C.call(e, t);
            }
          }) : (r._v = t, r._s = 1, N(r, !1));
        } catch (t) {
          C.call({ _w: r, _d: !1 }, t);
        }
      }
    };j || (_P = function P(t) {
      p(this, _P, "Promise", "_h"), v(t), e.call(this);try {
        t(f(D, this, 1), f(C, this, 1));
      } catch (t) {
        C.call(this, t);
      }
    }, (e = function e(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }).prototype = r(41)(_P.prototype, { then: function then(t, n) {
        var r = A(g(this, _P));return r.ok = "function" != typeof t || t, r.fail = "function" == typeof n && n, r.domain = I ? E.domain : void 0, this._c.push(r), this._a && this._a.push(r), this._s && N(this, !1), r.promise;
      }, catch: function _catch(t) {
        return this.then(void 0, t);
      } }), o = function o() {
      var t = new e();this.promise = t, this.resolve = f(D, t, 1), this.reject = f(C, t, 1);
    }, b.f = A = function A(t) {
      return t === _P || t === u ? new o(t) : i(t);
    }), l(l.G + l.W + l.F * !j, { Promise: _P }), r(36)(_P, "Promise"), r(39)("Promise"), u = r(9).Promise, l(l.S + l.F * !j, "Promise", { reject: function reject(t) {
        var n = A(this);return (0, n.reject)(t), n.promise;
      } }), l(l.S + l.F * (c || !j), "Promise", { resolve: function resolve(t) {
        return S(c && this === u ? _P : this, t);
      } }), l(l.S + l.F * !(j && r(50)(function (t) {
      _P.all(t).catch(M);
    })), "Promise", { all: function all(t) {
        var n = this,
            r = A(n),
            e = r.resolve,
            i = r.reject,
            o = x(function () {
          var r = [],
              o = 0,
              u = 1;d(t, !1, function (t) {
            var c = o++,
                a = !1;r.push(void 0), u++, n.resolve(t).then(function (t) {
              a || (a = !0, r[c] = t, --u || e(r));
            }, i);
          }), --u || e(r);
        });return o.e && i(o.v), r.promise;
      }, race: function race(t) {
        var n = this,
            r = A(n),
            e = r.reject,
            i = x(function () {
          d(t, !1, function (t) {
            n.resolve(t).then(r.resolve, e);
          });
        });return i.e && e(i.v), r.promise;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(22);function i(t) {
      var n, r;this.promise = new t(function (t, e) {
        if (void 0 !== n || void 0 !== r) throw TypeError("Bad Promise constructor");n = t, r = e;
      }), this.resolve = e(n), this.reject = e(r);
    }t.exports.f = function (t) {
      return new i(t);
    };
  }, function (t, n, r) {
    var e = r(2),
        i = r(4),
        o = r(107);t.exports = function (t, n) {
      if (e(t), i(n) && n.constructor === t) return n;var r = o.f(t);return (0, r.resolve)(n), r.promise;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(7).f,
        i = r(33),
        o = r(41),
        u = r(21),
        c = r(40),
        a = r(54),
        f = r(72),
        s = r(103),
        l = r(39),
        h = r(8),
        v = r(27).fastKey,
        p = r(42),
        d = h ? "_s" : "size",
        g = function g(t, n) {
      var r,
          e = v(n);if ("F" !== e) return t._i[e];for (r = t._f; r; r = r.n) {
        if (r.k == n) return r;
      }
    };t.exports = { getConstructor: function getConstructor(t, n, r, f) {
        var s = t(function (t, e) {
          c(t, s, n, "_i"), t._t = n, t._i = i(null), t._f = void 0, t._l = void 0, t[d] = 0, null != e && a(e, r, t[f], t);
        });return o(s.prototype, { clear: function clear() {
            for (var t = p(this, n), r = t._i, e = t._f; e; e = e.n) {
              e.r = !0, e.p && (e.p = e.p.n = void 0), delete r[e.i];
            }t._f = t._l = void 0, t[d] = 0;
          }, delete: function _delete(t) {
            var r = p(this, n),
                e = g(r, t);if (e) {
              var i = e.n,
                  o = e.p;delete r._i[e.i], e.r = !0, o && (o.n = i), i && (i.p = o), r._f == e && (r._f = i), r._l == e && (r._l = o), r[d]--;
            }return !!e;
          }, forEach: function forEach(t) {
            p(this, n);for (var r, e = u(t, arguments.length > 1 ? arguments[1] : void 0, 3); r = r ? r.n : this._f;) {
              for (e(r.v, r.k, this); r && r.r;) {
                r = r.p;
              }
            }
          }, has: function has(t) {
            return !!g(p(this, n), t);
          } }), h && e(s.prototype, "size", { get: function get() {
            return p(this, n)[d];
          } }), s;
      }, def: function def(t, n, r) {
        var e,
            i,
            o = g(t, n);return o ? o.v = r : (t._l = o = { i: i = v(n, !0), k: n, v: r, p: e = t._l, n: void 0, r: !1 }, t._f || (t._f = o), e && (e.n = o), t[d]++, "F" !== i && (t._i[i] = o)), t;
      }, getEntry: g, setStrong: function setStrong(t, n, r) {
        f(t, n, function (t, r) {
          this._t = p(t, n), this._k = r, this._l = void 0;
        }, function () {
          for (var t = this._k, n = this._l; n && n.r;) {
            n = n.p;
          }return this._t && (this._l = n = n ? n.n : this._t._f) ? s(0, "keys" == t ? n.k : "values" == t ? n.v : [n.k, n.v]) : (this._t = void 0, s(1));
        }, r ? "entries" : "values", !r, !0), l(n);
      } };
  }, function (t, n, r) {
    "use strict";
    var e = r(41),
        i = r(27).getWeak,
        o = r(2),
        u = r(4),
        c = r(40),
        a = r(54),
        f = r(20),
        s = r(13),
        l = r(42),
        h = f(5),
        v = f(6),
        p = 0,
        d = function d(t) {
      return t._l || (t._l = new g());
    },
        g = function g() {
      this.a = [];
    },
        y = function y(t, n) {
      return h(t.a, function (t) {
        return t[0] === n;
      });
    };g.prototype = { get: function get(t) {
        var n = y(this, t);if (n) return n[1];
      }, has: function has(t) {
        return !!y(this, t);
      }, set: function set(t, n) {
        var r = y(this, t);r ? r[1] = n : this.a.push([t, n]);
      }, delete: function _delete(t) {
        var n = v(this.a, function (n) {
          return n[0] === t;
        });return ~n && this.a.splice(n, 1), !!~n;
      } }, t.exports = { getConstructor: function getConstructor(t, n, r, o) {
        var f = t(function (t, e) {
          c(t, f, n, "_i"), t._t = n, t._i = p++, t._l = void 0, null != e && a(e, r, t[o], t);
        });return e(f.prototype, { delete: function _delete(t) {
            if (!u(t)) return !1;var r = i(t);return !0 === r ? d(l(this, n)).delete(t) : r && s(r, this._i) && delete r[this._i];
          }, has: function has(t) {
            if (!u(t)) return !1;var r = i(t);return !0 === r ? d(l(this, n)).has(t) : r && s(r, this._i);
          } }), f;
      }, def: function def(t, n, r) {
        var e = i(o(n), !0);return !0 === e ? d(t).set(n, r) : e[t._i] = r, t;
      }, ufstore: d };
  }, function (t, n, r) {
    var e = r(17),
        i = r(6);t.exports = function (t) {
      if (void 0 === t) return 0;var n = e(t),
          r = i(n);if (n !== r) throw RangeError("Wrong length!");return r;
    };
  }, function (t, n, r) {
    var e = r(34),
        i = r(48),
        o = r(2),
        u = r(3).Reflect;t.exports = u && u.ownKeys || function (t) {
      var n = e.f(o(t)),
          r = i.f;return r ? n.concat(r(t)) : n;
    };
  }, function (t, n, r) {
    var e = r(6),
        i = r(68),
        o = r(24);t.exports = function (t, n, r, u) {
      var c = String(o(t)),
          a = c.length,
          f = void 0 === r ? " " : String(r),
          s = e(n);if (s <= a || "" == f) return c;var l = s - a,
          h = i.call(f, Math.ceil(l / f.length));return h.length > l && (h = h.slice(0, l)), u ? h + c : c + h;
    };
  }, function (t, n, r) {
    var e = r(31),
        i = r(15),
        o = r(44).f;t.exports = function (t) {
      return function (n) {
        for (var r, u = i(n), c = e(u), a = c.length, f = 0, s = []; a > f;) {
          o.call(u, r = c[f++]) && s.push(t ? [r, u[r]] : u[r]);
        }return s;
      };
    };
  }, function (t, n, r) {
    "use strict";
    function e() {
      return (e = Object.assign || function (t) {
        for (var n = 1; n < arguments.length; n++) {
          var r = arguments[n];for (var e in r) {
            Object.prototype.hasOwnProperty.call(r, e) && (t[e] = r[e]);
          }
        }return t;
      }).apply(this, arguments);
    }function i(t, n) {
      for (var r = 0; r < n.length; r++) {
        var e = n[r];e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, e.key, e);
      }
    }r(116);var o = function o(t, n, r) {
      n.forEach(function (n) {
        t.addEventListener(n, r);
      });
    },
        u = function u(t, n, r) {
      n.forEach(function (n) {
        t.removeEventListener(n, r);
      });
    },
        c = function () {
      function t(n) {
        var r = this;!function (t, n) {
          if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.defaults = { idle: 1e4, events: ["mousemove", "keydown", "mousedown", "touchstart"], onIdle: function onIdle() {}, onActive: function onActive() {}, onHide: function onHide() {}, onShow: function onShow() {}, keepTracking: !0, startAtIdle: !1, recurIdleCall: !1 }, this.throwOnBadKey(Object.keys(n), Object.keys(this.defaults)), this.settings = e({}, this.defaults, n), this.visibilityEvents = ["visibilitychange", "webkitvisibilitychange", "mozvisibilitychange", "msvisibilitychange"], this.clearTimeout = null, this.reset(), this.stopListener = function (t) {
          r.stop();
        }, this.idlenessEventsHandler = function (t) {
          r.idle && (r.idle = !1, r.settings.onActive.call()), r.resetTimeout(r.settings);
        }, this.visibilityEventsHandler = function (t) {
          document.hidden || document.webkitHidden || document.mozHidden || document.msHidden ? r.visible && (r.visible = !1, r.settings.onHide.call()) : r.visible || (r.visible = !0, r.settings.onShow.call());
        };
      }var n, r, c;return n = t, (r = [{ key: "resetTimeout", value: function value(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.settings.keepTracking;this.clearTimeout && (this.clearTimeout(), this.clearTimeout = null), n && this.timeout(this.settings);
        } }, { key: "timeout", value: function value(t) {
          var n = this.settings.recurIdleCall ? { set: setInterval.bind(window), clear: clearInterval.bind(window) } : { set: setTimeout.bind(window), clear: clearTimeout.bind(window) },
              r = n.set(function () {
            this.idle = !0, this.settings.onIdle.call();
          }.bind(this), this.settings.idle);this.clearTimeout = function () {
            return n.clear(r);
          };
        } }, { key: "start", value: function value() {
          return window.addEventListener("idle:stop", this.stopListener), this.timeout(this.settings), o(window, this.settings.events, this.idlenessEventsHandler), (this.settings.onShow || this.settings.onHide) && o(document, this.visibilityEvents, this.visibilityEventsHandler), this;
        } }, { key: "stop", value: function value() {
          return window.removeEventListener("idle:stop", this.stopListener), u(window, this.settings.events, this.idlenessEventsHandler), this.resetTimeout(this.settings, !1), (this.settings.onShow || this.settings.onHide) && u(document, this.visibilityEvents, this.visibilityEventsHandler), this;
        } }, { key: "reset", value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = t.idle,
              r = void 0 === n ? this.settings.startAtIdle : n,
              e = t.visible,
              i = void 0 === e ? !this.settings.startAtIdle : e;return this.idle = r, this.visible = i, this;
        } }, { key: "throwOnBadKey", value: function value(t, n) {
          t.forEach(function (t) {
            if (!n.includes(t)) throw "set: Unknown key ".concat(t);
          });
        } }, { key: "set", value: function value(t) {
          this.throwOnBadKey(Object.keys(t), Object.keys(this.defaults)), this.settings = e(this.settings, t);
        } }]) && i(n.prototype, r), c && i(n, c), t;
    }();t.exports = c;
  }, function (t, n, r) {
    "use strict";
    (function (t) {
      r(118), r(261), r(263), r(265), r(267), r(269), r(271), r(273), r(275), r(277), r(281), t._babelPolyfill && "undefined" != typeof console && console.warn && console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."), t._babelPolyfill = !0;
    }).call(this, r(117));
  }, function (t, n) {
    var r;r = function () {
      return this;
    }();try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (r = window);
    }t.exports = r;
  }, function (t, n, r) {
    r(119), r(121), r(122), r(123), r(124), r(125), r(126), r(127), r(128), r(129), r(130), r(131), r(132), r(133), r(134), r(135), r(136), r(137), r(138), r(139), r(140), r(141), r(142), r(143), r(144), r(145), r(146), r(147), r(148), r(149), r(150), r(151), r(152), r(153), r(154), r(155), r(156), r(157), r(158), r(159), r(160), r(161), r(162), r(164), r(165), r(166), r(167), r(168), r(169), r(170), r(171), r(172), r(173), r(174), r(175), r(176), r(177), r(178), r(179), r(180), r(181), r(182), r(183), r(184), r(185), r(186), r(187), r(188), r(189), r(190), r(191), r(192), r(193), r(194), r(195), r(196), r(197), r(199), r(200), r(202), r(203), r(204), r(205), r(206), r(207), r(208), r(211), r(212), r(213), r(214), r(215), r(216), r(217), r(218), r(219), r(220), r(221), r(222), r(223), r(80), r(224), r(104), r(225), r(105), r(226), r(227), r(228), r(229), r(106), r(232), r(233), r(234), r(235), r(236), r(237), r(238), r(239), r(240), r(241), r(242), r(243), r(244), r(245), r(246), r(247), r(248), r(249), r(250), r(251), r(252), r(253), r(254), r(255), r(256), r(257), r(258), r(259), r(260), t.exports = r(9);
  }, function (t, n, r) {
    "use strict";
    var e = r(3),
        i = r(13),
        o = r(8),
        u = r(0),
        c = r(10),
        a = r(27).KEY,
        f = r(1),
        s = r(59),
        l = r(36),
        h = r(29),
        v = r(5),
        p = r(60),
        d = r(86),
        g = r(120),
        y = r(63),
        m = r(2),
        b = r(4),
        x = r(15),
        w = r(26),
        S = r(28),
        _ = r(33),
        E = r(89),
        O = r(18),
        F = r(7),
        P = r(31),
        I = O.f,
        M = F.f,
        A = E.f,
        _j = e.Symbol,
        T = e.JSON,
        N = T && T.stringify,
        L = v("_hidden"),
        k = v("toPrimitive"),
        R = {}.propertyIsEnumerable,
        C = s("symbol-registry"),
        D = s("symbols"),
        W = s("op-symbols"),
        B = Object.prototype,
        U = "function" == typeof _j,
        V = e.QObject,
        G = !V || !V.prototype || !V.prototype.findChild,
        H = o && f(function () {
      return 7 != _(M({}, "a", { get: function get() {
          return M(this, "a", { value: 7 }).a;
        } })).a;
    }) ? function (t, n, r) {
      var e = I(B, n);e && delete B[n], M(t, n, r), e && t !== B && M(B, n, e);
    } : M,
        z = function z(t) {
      var n = D[t] = _(_j.prototype);return n._k = t, n;
    },
        Y = U && "symbol" == typeof _j.iterator ? function (t) {
      return "symbol" == typeof t;
    } : function (t) {
      return t instanceof _j;
    },
        K = function K(t, n, r) {
      return t === B && K(W, n, r), m(t), n = w(n, !0), m(r), i(D, n) ? (r.enumerable ? (i(t, L) && t[L][n] && (t[L][n] = !1), r = _(r, { enumerable: S(0, !1) })) : (i(t, L) || M(t, L, S(1, {})), t[L][n] = !0), H(t, n, r)) : M(t, n, r);
    },
        q = function q(t, n) {
      m(t);for (var r, e = g(n = x(n)), i = 0, o = e.length; o > i;) {
        K(t, r = e[i++], n[r]);
      }return t;
    },
        J = function J(t) {
      var n = R.call(this, t = w(t, !0));return !(this === B && i(D, t) && !i(W, t)) && (!(n || !i(this, t) || !i(D, t) || i(this, L) && this[L][t]) || n);
    },
        $ = function $(t, n) {
      if (t = x(t), n = w(n, !0), t !== B || !i(D, n) || i(W, n)) {
        var r = I(t, n);return !r || !i(D, n) || i(t, L) && t[L][n] || (r.enumerable = !0), r;
      }
    },
        X = function X(t) {
      for (var n, r = A(x(t)), e = [], o = 0; r.length > o;) {
        i(D, n = r[o++]) || n == L || n == a || e.push(n);
      }return e;
    },
        Z = function Z(t) {
      for (var n, r = t === B, e = A(r ? W : x(t)), o = [], u = 0; e.length > u;) {
        !i(D, n = e[u++]) || r && !i(B, n) || o.push(D[n]);
      }return o;
    };U || (c((_j = function j() {
      if (this instanceof _j) throw TypeError("Symbol is not a constructor!");var t = h(arguments.length > 0 ? arguments[0] : void 0),
          n = function n(r) {
        this === B && n.call(W, r), i(this, L) && i(this[L], t) && (this[L][t] = !1), H(this, t, S(1, r));
      };return o && G && H(B, t, { configurable: !0, set: n }), z(t);
    }).prototype, "toString", function () {
      return this._k;
    }), O.f = $, F.f = K, r(34).f = E.f = X, r(44).f = J, r(48).f = Z, o && !r(30) && c(B, "propertyIsEnumerable", J, !0), p.f = function (t) {
      return z(v(t));
    }), u(u.G + u.W + u.F * !U, { Symbol: _j });for (var Q = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), tt = 0; Q.length > tt;) {
      v(Q[tt++]);
    }for (var nt = P(v.store), rt = 0; nt.length > rt;) {
      d(nt[rt++]);
    }u(u.S + u.F * !U, "Symbol", { for: function _for(t) {
        return i(C, t += "") ? C[t] : C[t] = _j(t);
      }, keyFor: function keyFor(t) {
        if (!Y(t)) throw TypeError(t + " is not a symbol!");for (var n in C) {
          if (C[n] === t) return n;
        }
      }, useSetter: function useSetter() {
        G = !0;
      }, useSimple: function useSimple() {
        G = !1;
      } }), u(u.S + u.F * !U, "Object", { create: function create(t, n) {
        return void 0 === n ? _(t) : q(_(t), n);
      }, defineProperty: K, defineProperties: q, getOwnPropertyDescriptor: $, getOwnPropertyNames: X, getOwnPropertySymbols: Z }), T && u(u.S + u.F * (!U || f(function () {
      var t = _j();return "[null]" != N([t]) || "{}" != N({ a: t }) || "{}" != N(Object(t));
    })), "JSON", { stringify: function stringify(t) {
        for (var n, r, e = [t], i = 1; arguments.length > i;) {
          e.push(arguments[i++]);
        }if (r = n = e[1], (b(n) || void 0 !== t) && !Y(t)) return y(n) || (n = function n(t, _n) {
          if ("function" == typeof r && (_n = r.call(this, t, _n)), !Y(_n)) return _n;
        }), e[1] = n, N.apply(T, e);
      } }), _j.prototype[k] || r(14)(_j.prototype, k, _j.prototype.valueOf), l(_j, "Symbol"), l(Math, "Math", !0), l(e.JSON, "JSON", !0);
  }, function (t, n, r) {
    var e = r(31),
        i = r(48),
        o = r(44);t.exports = function (t) {
      var n = e(t),
          r = i.f;if (r) for (var u, c = r(t), a = o.f, f = 0; c.length > f;) {
        a.call(t, u = c[f++]) && n.push(u);
      }return n;
    };
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Object", { create: r(33) });
  }, function (t, n, r) {
    var e = r(0);e(e.S + e.F * !r(8), "Object", { defineProperty: r(7).f });
  }, function (t, n, r) {
    var e = r(0);e(e.S + e.F * !r(8), "Object", { defineProperties: r(88) });
  }, function (t, n, r) {
    var e = r(15),
        i = r(18).f;r(19)("getOwnPropertyDescriptor", function () {
      return function (t, n) {
        return i(e(t), n);
      };
    });
  }, function (t, n, r) {
    var e = r(11),
        i = r(35);r(19)("getPrototypeOf", function () {
      return function (t) {
        return i(e(t));
      };
    });
  }, function (t, n, r) {
    var e = r(11),
        i = r(31);r(19)("keys", function () {
      return function (t) {
        return i(e(t));
      };
    });
  }, function (t, n, r) {
    r(19)("getOwnPropertyNames", function () {
      return r(89).f;
    });
  }, function (t, n, r) {
    var e = r(4),
        i = r(27).onFreeze;r(19)("freeze", function (t) {
      return function (n) {
        return t && e(n) ? t(i(n)) : n;
      };
    });
  }, function (t, n, r) {
    var e = r(4),
        i = r(27).onFreeze;r(19)("seal", function (t) {
      return function (n) {
        return t && e(n) ? t(i(n)) : n;
      };
    });
  }, function (t, n, r) {
    var e = r(4),
        i = r(27).onFreeze;r(19)("preventExtensions", function (t) {
      return function (n) {
        return t && e(n) ? t(i(n)) : n;
      };
    });
  }, function (t, n, r) {
    var e = r(4);r(19)("isFrozen", function (t) {
      return function (n) {
        return !e(n) || !!t && t(n);
      };
    });
  }, function (t, n, r) {
    var e = r(4);r(19)("isSealed", function (t) {
      return function (n) {
        return !e(n) || !!t && t(n);
      };
    });
  }, function (t, n, r) {
    var e = r(4);r(19)("isExtensible", function (t) {
      return function (n) {
        return !!e(n) && (!t || t(n));
      };
    });
  }, function (t, n, r) {
    var e = r(0);e(e.S + e.F, "Object", { assign: r(90) });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Object", { is: r(91) });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Object", { setPrototypeOf: r(65).set });
  }, function (t, n, r) {
    "use strict";
    var e = r(45),
        i = {};i[r(5)("toStringTag")] = "z", i + "" != "[object z]" && r(10)(Object.prototype, "toString", function () {
      return "[object " + e(this) + "]";
    }, !0);
  }, function (t, n, r) {
    var e = r(0);e(e.P, "Function", { bind: r(92) });
  }, function (t, n, r) {
    var e = r(7).f,
        i = Function.prototype,
        o = /^\s*function ([^ (]*)/;"name" in i || r(8) && e(i, "name", { configurable: !0, get: function get() {
        try {
          return ("" + this).match(o)[1];
        } catch (t) {
          return "";
        }
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(35),
        o = r(5)("hasInstance"),
        u = Function.prototype;o in u || r(7).f(u, o, { value: function value(t) {
        if ("function" != typeof this || !e(t)) return !1;if (!e(this.prototype)) return t instanceof this;for (; t = i(t);) {
          if (this.prototype === t) return !0;
        }return !1;
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(94);e(e.G + e.F * (parseInt != i), { parseInt: i });
  }, function (t, n, r) {
    var e = r(0),
        i = r(95);e(e.G + e.F * (parseFloat != i), { parseFloat: i });
  }, function (t, n, r) {
    "use strict";
    var e = r(3),
        i = r(13),
        o = r(23),
        u = r(67),
        c = r(26),
        a = r(1),
        f = r(34).f,
        s = r(18).f,
        l = r(7).f,
        h = r(49).trim,
        _v = e.Number,
        p = _v,
        d = _v.prototype,
        g = "Number" == o(r(33)(d)),
        y = "trim" in String.prototype,
        m = function m(t) {
      var n = c(t, !1);if ("string" == typeof n && n.length > 2) {
        var r,
            e,
            i,
            o = (n = y ? n.trim() : h(n, 3)).charCodeAt(0);if (43 === o || 45 === o) {
          if (88 === (r = n.charCodeAt(2)) || 120 === r) return NaN;
        } else if (48 === o) {
          switch (n.charCodeAt(1)) {case 66:case 98:
              e = 2, i = 49;break;case 79:case 111:
              e = 8, i = 55;break;default:
              return +n;}for (var u, a = n.slice(2), f = 0, s = a.length; f < s; f++) {
            if ((u = a.charCodeAt(f)) < 48 || u > i) return NaN;
          }return parseInt(a, e);
        }
      }return +n;
    };if (!_v(" 0o1") || !_v("0b1") || _v("+0x1")) {
      _v = function v(t) {
        var n = arguments.length < 1 ? 0 : t,
            r = this;return r instanceof _v && (g ? a(function () {
          d.valueOf.call(r);
        }) : "Number" != o(r)) ? u(new p(m(n)), r, _v) : m(n);
      };for (var b, x = r(8) ? f(p) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), w = 0; x.length > w; w++) {
        i(p, b = x[w]) && !i(_v, b) && l(_v, b, s(p, b));
      }_v.prototype = d, d.constructor = _v, r(10)(e, "Number", _v);
    }
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(17),
        o = r(96),
        u = r(68),
        c = 1..toFixed,
        a = Math.floor,
        f = [0, 0, 0, 0, 0, 0],
        s = "Number.toFixed: incorrect invocation!",
        l = function l(t, n) {
      for (var r = -1, e = n; ++r < 6;) {
        e += t * f[r], f[r] = e % 1e7, e = a(e / 1e7);
      }
    },
        h = function h(t) {
      for (var n = 6, r = 0; --n >= 0;) {
        r += f[n], f[n] = a(r / t), r = r % t * 1e7;
      }
    },
        v = function v() {
      for (var t = 6, n = ""; --t >= 0;) {
        if ("" !== n || 0 === t || 0 !== f[t]) {
          var r = String(f[t]);n = "" === n ? r : n + u.call("0", 7 - r.length) + r;
        }
      }return n;
    },
        p = function p(t, n, r) {
      return 0 === n ? r : n % 2 == 1 ? p(t, n - 1, r * t) : p(t * t, n / 2, r);
    };e(e.P + e.F * (!!c && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !r(1)(function () {
      c.call({});
    })), "Number", { toFixed: function toFixed(t) {
        var n,
            r,
            e,
            c,
            a = o(this, s),
            f = i(t),
            d = "",
            g = "0";if (f < 0 || f > 20) throw RangeError(s);if (a != a) return "NaN";if (a <= -1e21 || a >= 1e21) return String(a);if (a < 0 && (d = "-", a = -a), a > 1e-21) if (r = (n = function (t) {
          for (var n = 0, r = t; r >= 4096;) {
            n += 12, r /= 4096;
          }for (; r >= 2;) {
            n += 1, r /= 2;
          }return n;
        }(a * p(2, 69, 1)) - 69) < 0 ? a * p(2, -n, 1) : a / p(2, n, 1), r *= 4503599627370496, (n = 52 - n) > 0) {
          for (l(0, r), e = f; e >= 7;) {
            l(1e7, 0), e -= 7;
          }for (l(p(10, e, 1), 0), e = n - 1; e >= 23;) {
            h(1 << 23), e -= 23;
          }h(1 << e), l(1, 1), h(2), g = v();
        } else l(0, r), l(1 << -n, 0), g = v() + u.call("0", f);return g = f > 0 ? d + ((c = g.length) <= f ? "0." + u.call("0", f - c) + g : g.slice(0, c - f) + "." + g.slice(c - f)) : d + g;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(1),
        o = r(96),
        u = 1..toPrecision;e(e.P + e.F * (i(function () {
      return "1" !== u.call(1, void 0);
    }) || !i(function () {
      u.call({});
    })), "Number", { toPrecision: function toPrecision(t) {
        var n = o(this, "Number#toPrecision: incorrect invocation!");return void 0 === t ? u.call(n) : u.call(n, t);
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Number", { EPSILON: Math.pow(2, -52) });
  }, function (t, n, r) {
    var e = r(0),
        i = r(3).isFinite;e(e.S, "Number", { isFinite: function isFinite(t) {
        return "number" == typeof t && i(t);
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Number", { isInteger: r(97) });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Number", { isNaN: function isNaN(t) {
        return t != t;
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(97),
        o = Math.abs;e(e.S, "Number", { isSafeInteger: function isSafeInteger(t) {
        return i(t) && o(t) <= 9007199254740991;
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 });
  }, function (t, n, r) {
    var e = r(0),
        i = r(95);e(e.S + e.F * (Number.parseFloat != i), "Number", { parseFloat: i });
  }, function (t, n, r) {
    var e = r(0),
        i = r(94);e(e.S + e.F * (Number.parseInt != i), "Number", { parseInt: i });
  }, function (t, n, r) {
    var e = r(0),
        i = r(98),
        o = Math.sqrt,
        u = Math.acosh;e(e.S + e.F * !(u && 710 == Math.floor(u(Number.MAX_VALUE)) && u(1 / 0) == 1 / 0), "Math", { acosh: function acosh(t) {
        return (t = +t) < 1 ? NaN : t > 94906265.62425156 ? Math.log(t) + Math.LN2 : i(t - 1 + o(t - 1) * o(t + 1));
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = Math.asinh;e(e.S + e.F * !(i && 1 / i(0) > 0), "Math", { asinh: function t(n) {
        return isFinite(n = +n) && 0 != n ? n < 0 ? -t(-n) : Math.log(n + Math.sqrt(n * n + 1)) : n;
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = Math.atanh;e(e.S + e.F * !(i && 1 / i(-0) < 0), "Math", { atanh: function atanh(t) {
        return 0 == (t = +t) ? t : Math.log((1 + t) / (1 - t)) / 2;
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(69);e(e.S, "Math", { cbrt: function cbrt(t) {
        return i(t = +t) * Math.pow(Math.abs(t), 1 / 3);
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Math", { clz32: function clz32(t) {
        return (t >>>= 0) ? 31 - Math.floor(Math.log(t + .5) * Math.LOG2E) : 32;
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = Math.exp;e(e.S, "Math", { cosh: function cosh(t) {
        return (i(t = +t) + i(-t)) / 2;
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(70);e(e.S + e.F * (i != Math.expm1), "Math", { expm1: i });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Math", { fround: r(163) });
  }, function (t, n, r) {
    var e = r(69),
        i = Math.pow,
        o = i(2, -52),
        u = i(2, -23),
        c = i(2, 127) * (2 - u),
        a = i(2, -126);t.exports = Math.fround || function (t) {
      var n,
          r,
          i = Math.abs(t),
          f = e(t);return i < a ? f * (i / a / u + 1 / o - 1 / o) * a * u : (r = (n = (1 + u / o) * i) - (n - i)) > c || r != r ? f * (1 / 0) : f * r;
    };
  }, function (t, n, r) {
    var e = r(0),
        i = Math.abs;e(e.S, "Math", { hypot: function hypot(t, n) {
        for (var r, e, o = 0, u = 0, c = arguments.length, a = 0; u < c;) {
          a < (r = i(arguments[u++])) ? (o = o * (e = a / r) * e + 1, a = r) : o += r > 0 ? (e = r / a) * e : r;
        }return a === 1 / 0 ? 1 / 0 : a * Math.sqrt(o);
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = Math.imul;e(e.S + e.F * r(1)(function () {
      return -5 != i(4294967295, 5) || 2 != i.length;
    }), "Math", { imul: function imul(t, n) {
        var r = +t,
            e = +n,
            i = 65535 & r,
            o = 65535 & e;return 0 | i * o + ((65535 & r >>> 16) * o + i * (65535 & e >>> 16) << 16 >>> 0);
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Math", { log10: function log10(t) {
        return Math.log(t) * Math.LOG10E;
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Math", { log1p: r(98) });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Math", { log2: function log2(t) {
        return Math.log(t) / Math.LN2;
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Math", { sign: r(69) });
  }, function (t, n, r) {
    var e = r(0),
        i = r(70),
        o = Math.exp;e(e.S + e.F * r(1)(function () {
      return -2e-17 != !Math.sinh(-2e-17);
    }), "Math", { sinh: function sinh(t) {
        return Math.abs(t = +t) < 1 ? (i(t) - i(-t)) / 2 : (o(t - 1) - o(-t - 1)) * (Math.E / 2);
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(70),
        o = Math.exp;e(e.S, "Math", { tanh: function tanh(t) {
        var n = i(t = +t),
            r = i(-t);return n == 1 / 0 ? 1 : r == 1 / 0 ? -1 : (n - r) / (o(t) + o(-t));
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Math", { trunc: function trunc(t) {
        return (t > 0 ? Math.floor : Math.ceil)(t);
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(32),
        o = String.fromCharCode,
        u = String.fromCodePoint;e(e.S + e.F * (!!u && 1 != u.length), "String", { fromCodePoint: function fromCodePoint(t) {
        for (var n, r = [], e = arguments.length, u = 0; e > u;) {
          if (n = +arguments[u++], i(n, 1114111) !== n) throw RangeError(n + " is not a valid code point");r.push(n < 65536 ? o(n) : o(55296 + ((n -= 65536) >> 10), n % 1024 + 56320));
        }return r.join("");
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(15),
        o = r(6);e(e.S, "String", { raw: function raw(t) {
        for (var n = i(t.raw), r = o(n.length), e = arguments.length, u = [], c = 0; r > c;) {
          u.push(String(n[c++])), c < e && u.push(String(arguments[c]));
        }return u.join("");
      } });
  }, function (t, n, r) {
    "use strict";
    r(49)("trim", function (t) {
      return function () {
        return t(this, 3);
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(71)(!0);r(72)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
          n = this._t,
          r = this._i;return r >= n.length ? { value: void 0, done: !0 } : (t = e(n, r), this._i += t.length, { value: t, done: !1 });
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(71)(!1);e(e.P, "String", { codePointAt: function codePointAt(t) {
        return i(this, t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(6),
        o = r(73),
        u = "".endsWith;e(e.P + e.F * r(75)("endsWith"), "String", { endsWith: function endsWith(t) {
        var n = o(this, t, "endsWith"),
            r = arguments.length > 1 ? arguments[1] : void 0,
            e = i(n.length),
            c = void 0 === r ? e : Math.min(i(r), e),
            a = String(t);return u ? u.call(n, a, c) : n.slice(c - a.length, c) === a;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(73);e(e.P + e.F * r(75)("includes"), "String", { includes: function includes(t) {
        return !!~i(this, t, "includes").indexOf(t, arguments.length > 1 ? arguments[1] : void 0);
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.P, "String", { repeat: r(68) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(6),
        o = r(73),
        u = "".startsWith;e(e.P + e.F * r(75)("startsWith"), "String", { startsWith: function startsWith(t) {
        var n = o(this, t, "startsWith"),
            r = i(Math.min(arguments.length > 1 ? arguments[1] : void 0, n.length)),
            e = String(t);return u ? u.call(n, e, r) : n.slice(r, r + e.length) === e;
      } });
  }, function (t, n, r) {
    "use strict";
    r(12)("anchor", function (t) {
      return function (n) {
        return t(this, "a", "name", n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("big", function (t) {
      return function () {
        return t(this, "big", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("blink", function (t) {
      return function () {
        return t(this, "blink", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("bold", function (t) {
      return function () {
        return t(this, "b", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("fixed", function (t) {
      return function () {
        return t(this, "tt", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("fontcolor", function (t) {
      return function (n) {
        return t(this, "font", "color", n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("fontsize", function (t) {
      return function (n) {
        return t(this, "font", "size", n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("italics", function (t) {
      return function () {
        return t(this, "i", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("link", function (t) {
      return function (n) {
        return t(this, "a", "href", n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("small", function (t) {
      return function () {
        return t(this, "small", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("strike", function (t) {
      return function () {
        return t(this, "strike", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("sub", function (t) {
      return function () {
        return t(this, "sub", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(12)("sup", function (t) {
      return function () {
        return t(this, "sup", "", "");
      };
    });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Date", { now: function now() {
        return new Date().getTime();
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(11),
        o = r(26);e(e.P + e.F * r(1)(function () {
      return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({ toISOString: function toISOString() {
          return 1;
        } });
    }), "Date", { toJSON: function toJSON(t) {
        var n = i(this),
            r = o(n);return "number" != typeof r || isFinite(r) ? n.toISOString() : null;
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(198);e(e.P + e.F * (Date.prototype.toISOString !== i), "Date", { toISOString: i });
  }, function (t, n, r) {
    "use strict";
    var e = r(1),
        i = Date.prototype.getTime,
        o = Date.prototype.toISOString,
        u = function u(t) {
      return t > 9 ? t : "0" + t;
    };t.exports = e(function () {
      return "0385-07-25T07:06:39.999Z" != o.call(new Date(-5e13 - 1));
    }) || !e(function () {
      o.call(new Date(NaN));
    }) ? function () {
      if (!isFinite(i.call(this))) throw RangeError("Invalid time value");var t = this,
          n = t.getUTCFullYear(),
          r = t.getUTCMilliseconds(),
          e = n < 0 ? "-" : n > 9999 ? "+" : "";return e + ("00000" + Math.abs(n)).slice(e ? -6 : -4) + "-" + u(t.getUTCMonth() + 1) + "-" + u(t.getUTCDate()) + "T" + u(t.getUTCHours()) + ":" + u(t.getUTCMinutes()) + ":" + u(t.getUTCSeconds()) + "." + (r > 99 ? r : "0" + u(r)) + "Z";
    } : o;
  }, function (t, n, r) {
    var e = Date.prototype,
        i = e.toString,
        o = e.getTime;new Date(NaN) + "" != "Invalid Date" && r(10)(e, "toString", function () {
      var t = o.call(this);return t == t ? i.call(this) : "Invalid Date";
    });
  }, function (t, n, r) {
    var e = r(5)("toPrimitive"),
        i = Date.prototype;e in i || r(14)(i, e, r(201));
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(26);t.exports = function (t) {
      if ("string" !== t && "number" !== t && "default" !== t) throw TypeError("Incorrect hint");return i(e(this), "number" != t);
    };
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Array", { isArray: r(63) });
  }, function (t, n, r) {
    "use strict";
    var e = r(21),
        i = r(0),
        o = r(11),
        u = r(100),
        c = r(76),
        a = r(6),
        f = r(77),
        s = r(78);i(i.S + i.F * !r(50)(function (t) {
      Array.from(t);
    }), "Array", { from: function from(t) {
        var n,
            r,
            i,
            l,
            h = o(t),
            v = "function" == typeof this ? this : Array,
            p = arguments.length,
            d = p > 1 ? arguments[1] : void 0,
            g = void 0 !== d,
            y = 0,
            m = s(h);if (g && (d = e(d, p > 2 ? arguments[2] : void 0, 2)), null == m || v == Array && c(m)) for (r = new v(n = a(h.length)); n > y; y++) {
          f(r, y, g ? d(h[y], y) : h[y]);
        } else for (l = m.call(h), r = new v(); !(i = l.next()).done; y++) {
          f(r, y, g ? u(l, d, [i.value, y], !0) : i.value);
        }return r.length = y, r;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(77);e(e.S + e.F * r(1)(function () {
      function t() {}return !(Array.of.call(t) instanceof t);
    }), "Array", { of: function of() {
        for (var t = 0, n = arguments.length, r = new ("function" == typeof this ? this : Array)(n); n > t;) {
          i(r, t, arguments[t++]);
        }return r.length = n, r;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(15),
        o = [].join;e(e.P + e.F * (r(43) != Object || !r(16)(o)), "Array", { join: function join(t) {
        return o.call(i(this), void 0 === t ? "," : t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(64),
        o = r(23),
        u = r(32),
        c = r(6),
        a = [].slice;e(e.P + e.F * r(1)(function () {
      i && a.call(i);
    }), "Array", { slice: function slice(t, n) {
        var r = c(this.length),
            e = o(this);if (n = void 0 === n ? r : n, "Array" == e) return a.call(this, t, n);for (var i = u(t, r), f = u(n, r), s = c(f - i), l = new Array(s), h = 0; h < s; h++) {
          l[h] = "String" == e ? this.charAt(i + h) : this[i + h];
        }return l;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(22),
        o = r(11),
        u = r(1),
        c = [].sort,
        a = [1, 2, 3];e(e.P + e.F * (u(function () {
      a.sort(void 0);
    }) || !u(function () {
      a.sort(null);
    }) || !r(16)(c)), "Array", { sort: function sort(t) {
        return void 0 === t ? c.call(o(this)) : c.call(o(this), i(t));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(20)(0),
        o = r(16)([].forEach, !0);e(e.P + e.F * !o, "Array", { forEach: function forEach(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    var e = r(210);t.exports = function (t, n) {
      return new (e(t))(n);
    };
  }, function (t, n, r) {
    var e = r(4),
        i = r(63),
        o = r(5)("species");t.exports = function (t) {
      var n;return i(t) && ("function" != typeof (n = t.constructor) || n !== Array && !i(n.prototype) || (n = void 0), e(n) && null === (n = n[o]) && (n = void 0)), void 0 === n ? Array : n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(20)(1);e(e.P + e.F * !r(16)([].map, !0), "Array", { map: function map(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(20)(2);e(e.P + e.F * !r(16)([].filter, !0), "Array", { filter: function filter(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(20)(3);e(e.P + e.F * !r(16)([].some, !0), "Array", { some: function some(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(20)(4);e(e.P + e.F * !r(16)([].every, !0), "Array", { every: function every(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(101);e(e.P + e.F * !r(16)([].reduce, !0), "Array", { reduce: function reduce(t) {
        return i(this, t, arguments.length, arguments[1], !1);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(101);e(e.P + e.F * !r(16)([].reduceRight, !0), "Array", { reduceRight: function reduceRight(t) {
        return i(this, t, arguments.length, arguments[1], !0);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(47)(!1),
        o = [].indexOf,
        u = !!o && 1 / [1].indexOf(1, -0) < 0;e(e.P + e.F * (u || !r(16)(o)), "Array", { indexOf: function indexOf(t) {
        return u ? o.apply(this, arguments) || 0 : i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(15),
        o = r(17),
        u = r(6),
        c = [].lastIndexOf,
        a = !!c && 1 / [1].lastIndexOf(1, -0) < 0;e(e.P + e.F * (a || !r(16)(c)), "Array", { lastIndexOf: function lastIndexOf(t) {
        if (a) return c.apply(this, arguments) || 0;var n = i(this),
            r = u(n.length),
            e = r - 1;for (arguments.length > 1 && (e = Math.min(e, o(arguments[1]))), e < 0 && (e = r + e); e >= 0; e--) {
          if (e in n && n[e] === t) return e || 0;
        }return -1;
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.P, "Array", { copyWithin: r(102) }), r(38)("copyWithin");
  }, function (t, n, r) {
    var e = r(0);e(e.P, "Array", { fill: r(79) }), r(38)("fill");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(20)(5),
        o = !0;"find" in [] && Array(1).find(function () {
      o = !1;
    }), e(e.P + e.F * o, "Array", { find: function find(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      } }), r(38)("find");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(20)(6),
        o = "findIndex",
        u = !0;o in [] && Array(1)[o](function () {
      u = !1;
    }), e(e.P + e.F * u, "Array", { findIndex: function findIndex(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      } }), r(38)(o);
  }, function (t, n, r) {
    r(39)("Array");
  }, function (t, n, r) {
    var e = r(3),
        i = r(67),
        o = r(7).f,
        u = r(34).f,
        c = r(74),
        a = r(51),
        _f = e.RegExp,
        s = _f,
        l = _f.prototype,
        h = /a/g,
        v = /a/g,
        p = new _f(h) !== h;if (r(8) && (!p || r(1)(function () {
      return v[r(5)("match")] = !1, _f(h) != h || _f(v) == v || "/a/i" != _f(h, "i");
    }))) {
      _f = function f(t, n) {
        var r = this instanceof _f,
            e = c(t),
            o = void 0 === n;return !r && e && t.constructor === _f && o ? t : i(p ? new s(e && !o ? t.source : t, n) : s((e = t instanceof _f) ? t.source : t, e && o ? a.call(t) : n), r ? this : l, _f);
      };for (var d = function d(t) {
        (t in _f) || o(_f, t, { configurable: !0, get: function get() {
            return s[t];
          }, set: function set(n) {
            s[t] = n;
          } });
      }, g = u(s), y = 0; g.length > y;) {
        d(g[y++]);
      }l.constructor = _f, _f.prototype = l, r(10)(e, "RegExp", _f);
    }r(39)("RegExp");
  }, function (t, n, r) {
    "use strict";
    r(105);var e = r(2),
        i = r(51),
        o = r(8),
        u = /./.toString,
        c = function c(t) {
      r(10)(RegExp.prototype, "toString", t, !0);
    };r(1)(function () {
      return "/a/b" != u.call({ source: "a", flags: "b" });
    }) ? c(function () {
      var t = e(this);return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? i.call(t) : void 0);
    }) : "toString" != u.name && c(function () {
      return u.call(this);
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(6),
        o = r(82),
        u = r(52);r(53)("match", 1, function (t, n, r, c) {
      return [function (r) {
        var e = t(this),
            i = null == r ? void 0 : r[n];return void 0 !== i ? i.call(r, e) : new RegExp(r)[n](String(e));
      }, function (t) {
        var n = c(r, t, this);if (n.done) return n.value;var a = e(t),
            f = String(this);if (!a.global) return u(a, f);var s = a.unicode;a.lastIndex = 0;for (var l, h = [], v = 0; null !== (l = u(a, f));) {
          var p = String(l[0]);h[v] = p, "" === p && (a.lastIndex = o(f, i(a.lastIndex), s)), v++;
        }return 0 === v ? null : h;
      }];
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(11),
        o = r(6),
        u = r(17),
        c = r(82),
        a = r(52),
        f = Math.max,
        s = Math.min,
        l = Math.floor,
        h = /\$([$&`']|\d\d?|<[^>]*>)/g,
        v = /\$([$&`']|\d\d?)/g;r(53)("replace", 2, function (t, n, r, p) {
      return [function (e, i) {
        var o = t(this),
            u = null == e ? void 0 : e[n];return void 0 !== u ? u.call(e, o, i) : r.call(String(o), e, i);
      }, function (t, n) {
        var i = p(r, t, this, n);if (i.done) return i.value;var l = e(t),
            h = String(this),
            v = "function" == typeof n;v || (n = String(n));var g = l.global;if (g) {
          var y = l.unicode;l.lastIndex = 0;
        }for (var m = [];;) {
          var b = a(l, h);if (null === b) break;if (m.push(b), !g) break;"" === String(b[0]) && (l.lastIndex = c(h, o(l.lastIndex), y));
        }for (var x, w = "", S = 0, _ = 0; _ < m.length; _++) {
          b = m[_];for (var E = String(b[0]), O = f(s(u(b.index), h.length), 0), F = [], P = 1; P < b.length; P++) {
            F.push(void 0 === (x = b[P]) ? x : String(x));
          }var I = b.groups;if (v) {
            var M = [E].concat(F, O, h);void 0 !== I && M.push(I);var A = String(n.apply(void 0, M));
          } else A = d(E, h, O, F, I, n);O >= S && (w += h.slice(S, O) + A, S = O + E.length);
        }return w + h.slice(S);
      }];function d(t, n, e, o, u, c) {
        var a = e + t.length,
            f = o.length,
            s = v;return void 0 !== u && (u = i(u), s = h), r.call(c, s, function (r, i) {
          var c;switch (i.charAt(0)) {case "$":
              return "$";case "&":
              return t;case "`":
              return n.slice(0, e);case "'":
              return n.slice(a);case "<":
              c = u[i.slice(1, -1)];break;default:
              var s = +i;if (0 === s) return r;if (s > f) {
                var h = l(s / 10);return 0 === h ? r : h <= f ? void 0 === o[h - 1] ? i.charAt(1) : o[h - 1] + i.charAt(1) : r;
              }c = o[s - 1];}return void 0 === c ? "" : c;
        });
      }
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(91),
        o = r(52);r(53)("search", 1, function (t, n, r, u) {
      return [function (r) {
        var e = t(this),
            i = null == r ? void 0 : r[n];return void 0 !== i ? i.call(r, e) : new RegExp(r)[n](String(e));
      }, function (t) {
        var n = u(r, t, this);if (n.done) return n.value;var c = e(t),
            a = String(this),
            f = c.lastIndex;i(f, 0) || (c.lastIndex = 0);var s = o(c, a);return i(c.lastIndex, f) || (c.lastIndex = f), null === s ? -1 : s.index;
      }];
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(74),
        i = r(2),
        o = r(46),
        u = r(82),
        c = r(6),
        a = r(52),
        f = r(81),
        s = r(1),
        l = Math.min,
        h = [].push,
        v = !s(function () {
      RegExp(4294967295, "y");
    });r(53)("split", 2, function (t, n, r, s) {
      var p;return p = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (t, n) {
        var i = String(this);if (void 0 === t && 0 === n) return [];if (!e(t)) return r.call(i, t, n);for (var o, u, c, a = [], s = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), l = 0, v = void 0 === n ? 4294967295 : n >>> 0, p = new RegExp(t.source, s + "g"); (o = f.call(p, i)) && !((u = p.lastIndex) > l && (a.push(i.slice(l, o.index)), o.length > 1 && o.index < i.length && h.apply(a, o.slice(1)), c = o[0].length, l = u, a.length >= v));) {
          p.lastIndex === o.index && p.lastIndex++;
        }return l === i.length ? !c && p.test("") || a.push("") : a.push(i.slice(l)), a.length > v ? a.slice(0, v) : a;
      } : "0".split(void 0, 0).length ? function (t, n) {
        return void 0 === t && 0 === n ? [] : r.call(this, t, n);
      } : r, [function (r, e) {
        var i = t(this),
            o = null == r ? void 0 : r[n];return void 0 !== o ? o.call(r, i, e) : p.call(String(i), r, e);
      }, function (t, n) {
        var e = s(p, t, this, n, p !== r);if (e.done) return e.value;var f = i(t),
            h = String(this),
            d = o(f, RegExp),
            g = f.unicode,
            y = (f.ignoreCase ? "i" : "") + (f.multiline ? "m" : "") + (f.unicode ? "u" : "") + (v ? "y" : "g"),
            m = new d(v ? f : "^(?:" + f.source + ")", y),
            b = void 0 === n ? 4294967295 : n >>> 0;if (0 === b) return [];if (0 === h.length) return null === a(m, h) ? [h] : [];for (var x = 0, w = 0, S = []; w < h.length;) {
          m.lastIndex = v ? w : 0;var _,
              E = a(m, v ? h : h.slice(w));if (null === E || (_ = l(c(m.lastIndex + (v ? 0 : w)), h.length)) === x) w = u(h, w, g);else {
            if (S.push(h.slice(x, w)), S.length === b) return S;for (var O = 1; O <= E.length - 1; O++) {
              if (S.push(E[O]), S.length === b) return S;
            }w = x = _;
          }
        }return S.push(h.slice(x)), S;
      }];
    });
  }, function (t, n, r) {
    var e = r(3),
        i = r(83).set,
        o = e.MutationObserver || e.WebKitMutationObserver,
        u = e.process,
        c = e.Promise,
        a = "process" == r(23)(u);t.exports = function () {
      var t,
          n,
          r,
          f = function f() {
        var e, i;for (a && (e = u.domain) && e.exit(); t;) {
          i = t.fn, t = t.next;try {
            i();
          } catch (e) {
            throw t ? r() : n = void 0, e;
          }
        }n = void 0, e && e.enter();
      };if (a) r = function r() {
        u.nextTick(f);
      };else if (!o || e.navigator && e.navigator.standalone) {
        if (c && c.resolve) {
          var s = c.resolve(void 0);r = function r() {
            s.then(f);
          };
        } else r = function r() {
          i.call(e, f);
        };
      } else {
        var l = !0,
            h = document.createTextNode("");new o(f).observe(h, { characterData: !0 }), r = function r() {
          h.data = l = !l;
        };
      }return function (e) {
        var i = { fn: e, next: void 0 };n && (n.next = i), t || (t = i, r()), n = i;
      };
    };
  }, function (t, n) {
    t.exports = function (t) {
      try {
        return { e: !1, v: t() };
      } catch (t) {
        return { e: !0, v: t };
      }
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(109),
        i = r(42);t.exports = r(56)("Map", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, { get: function get(t) {
        var n = e.getEntry(i(this, "Map"), t);return n && n.v;
      }, set: function set(t, n) {
        return e.def(i(this, "Map"), 0 === t ? 0 : t, n);
      } }, e, !0);
  }, function (t, n, r) {
    "use strict";
    var e = r(109),
        i = r(42);t.exports = r(56)("Set", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, { add: function add(t) {
        return e.def(i(this, "Set"), t = 0 === t ? 0 : t, t);
      } }, e);
  }, function (t, n, r) {
    "use strict";
    var e,
        i = r(20)(0),
        o = r(10),
        u = r(27),
        c = r(90),
        a = r(110),
        f = r(4),
        s = r(1),
        l = r(42),
        h = u.getWeak,
        v = Object.isExtensible,
        p = a.ufstore,
        d = {},
        g = function g(t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    },
        y = { get: function get(t) {
        if (f(t)) {
          var n = h(t);return !0 === n ? p(l(this, "WeakMap")).get(t) : n ? n[this._i] : void 0;
        }
      }, set: function set(t, n) {
        return a.def(l(this, "WeakMap"), t, n);
      } },
        m = t.exports = r(56)("WeakMap", g, y, a, !0, !0);s(function () {
      return 7 != new m().set((Object.freeze || Object)(d), 7).get(d);
    }) && (c((e = a.getConstructor(g, "WeakMap")).prototype, y), u.NEED = !0, i(["delete", "has", "get", "set"], function (t) {
      var n = m.prototype,
          r = n[t];o(n, t, function (n, i) {
        if (f(n) && !v(n)) {
          this._f || (this._f = new e());var o = this._f[t](n, i);return "set" == t ? this : o;
        }return r.call(this, n, i);
      });
    }));
  }, function (t, n, r) {
    "use strict";
    var e = r(110),
        i = r(42);r(56)("WeakSet", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, { add: function add(t) {
        return e.def(i(this, "WeakSet"), t, !0);
      } }, e, !1, !0);
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(57),
        o = r(84),
        u = r(2),
        c = r(32),
        a = r(6),
        f = r(4),
        s = r(3).ArrayBuffer,
        l = r(46),
        h = o.ArrayBuffer,
        v = o.DataView,
        p = i.ABV && s.isView,
        d = h.prototype.slice,
        g = i.VIEW;e(e.G + e.W + e.F * (s !== h), { ArrayBuffer: h }), e(e.S + e.F * !i.CONSTR, "ArrayBuffer", { isView: function isView(t) {
        return p && p(t) || f(t) && g in t;
      } }), e(e.P + e.U + e.F * r(1)(function () {
      return !new h(2).slice(1, void 0).byteLength;
    }), "ArrayBuffer", { slice: function slice(t, n) {
        if (void 0 !== d && void 0 === n) return d.call(u(this), t);for (var r = u(this).byteLength, e = c(t, r), i = c(void 0 === n ? r : n, r), o = new (l(this, h))(a(i - e)), f = new v(this), s = new v(o), p = 0; e < i;) {
          s.setUint8(p++, f.getUint8(e++));
        }return o;
      } }), r(39)("ArrayBuffer");
  }, function (t, n, r) {
    var e = r(0);e(e.G + e.W + e.F * !r(57).ABV, { DataView: r(84).DataView });
  }, function (t, n, r) {
    r(25)("Int8", 1, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    r(25)("Uint8", 1, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    r(25)("Uint8", 1, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    }, !0);
  }, function (t, n, r) {
    r(25)("Int16", 2, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    r(25)("Uint16", 2, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    r(25)("Int32", 4, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    r(25)("Uint32", 4, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    r(25)("Float32", 4, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    r(25)("Float64", 8, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    var e = r(0),
        i = r(22),
        o = r(2),
        u = (r(3).Reflect || {}).apply,
        c = Function.apply;e(e.S + e.F * !r(1)(function () {
      u(function () {});
    }), "Reflect", { apply: function apply(t, n, r) {
        var e = i(t),
            a = o(r);return u ? u(e, n, a) : c.call(e, n, a);
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(33),
        o = r(22),
        u = r(2),
        c = r(4),
        a = r(1),
        f = r(92),
        s = (r(3).Reflect || {}).construct,
        l = a(function () {
      function t() {}return !(s(function () {}, [], t) instanceof t);
    }),
        h = !a(function () {
      s(function () {});
    });e(e.S + e.F * (l || h), "Reflect", { construct: function construct(t, n) {
        o(t), u(n);var r = arguments.length < 3 ? t : o(arguments[2]);if (h && !l) return s(t, n, r);if (t == r) {
          switch (n.length) {case 0:
              return new t();case 1:
              return new t(n[0]);case 2:
              return new t(n[0], n[1]);case 3:
              return new t(n[0], n[1], n[2]);case 4:
              return new t(n[0], n[1], n[2], n[3]);}var e = [null];return e.push.apply(e, n), new (f.apply(t, e))();
        }var a = r.prototype,
            v = i(c(a) ? a : Object.prototype),
            p = Function.apply.call(t, v, n);return c(p) ? p : v;
      } });
  }, function (t, n, r) {
    var e = r(7),
        i = r(0),
        o = r(2),
        u = r(26);i(i.S + i.F * r(1)(function () {
      Reflect.defineProperty(e.f({}, 1, { value: 1 }), 1, { value: 2 });
    }), "Reflect", { defineProperty: function defineProperty(t, n, r) {
        o(t), n = u(n, !0), o(r);try {
          return e.f(t, n, r), !0;
        } catch (t) {
          return !1;
        }
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(18).f,
        o = r(2);e(e.S, "Reflect", { deleteProperty: function deleteProperty(t, n) {
        var r = i(o(t), n);return !(r && !r.configurable) && delete t[n];
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(2),
        o = function o(t) {
      this._t = i(t), this._i = 0;var n,
          r = this._k = [];for (n in t) {
        r.push(n);
      }
    };r(99)(o, "Object", function () {
      var t,
          n = this._k;do {
        if (this._i >= n.length) return { value: void 0, done: !0 };
      } while (!((t = n[this._i++]) in this._t));return { value: t, done: !1 };
    }), e(e.S, "Reflect", { enumerate: function enumerate(t) {
        return new o(t);
      } });
  }, function (t, n, r) {
    var e = r(18),
        i = r(35),
        o = r(13),
        u = r(0),
        c = r(4),
        a = r(2);u(u.S, "Reflect", { get: function t(n, r) {
        var u,
            f,
            s = arguments.length < 3 ? n : arguments[2];return a(n) === s ? n[r] : (u = e.f(n, r)) ? o(u, "value") ? u.value : void 0 !== u.get ? u.get.call(s) : void 0 : c(f = i(n)) ? t(f, r, s) : void 0;
      } });
  }, function (t, n, r) {
    var e = r(18),
        i = r(0),
        o = r(2);i(i.S, "Reflect", { getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, n) {
        return e.f(o(t), n);
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(35),
        o = r(2);e(e.S, "Reflect", { getPrototypeOf: function getPrototypeOf(t) {
        return i(o(t));
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Reflect", { has: function has(t, n) {
        return n in t;
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(2),
        o = Object.isExtensible;e(e.S, "Reflect", { isExtensible: function isExtensible(t) {
        return i(t), !o || o(t);
      } });
  }, function (t, n, r) {
    var e = r(0);e(e.S, "Reflect", { ownKeys: r(112) });
  }, function (t, n, r) {
    var e = r(0),
        i = r(2),
        o = Object.preventExtensions;e(e.S, "Reflect", { preventExtensions: function preventExtensions(t) {
        i(t);try {
          return o && o(t), !0;
        } catch (t) {
          return !1;
        }
      } });
  }, function (t, n, r) {
    var e = r(7),
        i = r(18),
        o = r(35),
        u = r(13),
        c = r(0),
        a = r(28),
        f = r(2),
        s = r(4);c(c.S, "Reflect", { set: function t(n, r, c) {
        var l,
            h,
            v = arguments.length < 4 ? n : arguments[3],
            p = i.f(f(n), r);if (!p) {
          if (s(h = o(n))) return t(h, r, c, v);p = a(0);
        }if (u(p, "value")) {
          if (!1 === p.writable || !s(v)) return !1;if (l = i.f(v, r)) {
            if (l.get || l.set || !1 === l.writable) return !1;l.value = c, e.f(v, r, l);
          } else e.f(v, r, a(0, c));return !0;
        }return void 0 !== p.set && (p.set.call(v, c), !0);
      } });
  }, function (t, n, r) {
    var e = r(0),
        i = r(65);i && e(e.S, "Reflect", { setPrototypeOf: function setPrototypeOf(t, n) {
        i.check(t, n);try {
          return i.set(t, n), !0;
        } catch (t) {
          return !1;
        }
      } });
  }, function (t, n, r) {
    r(262), t.exports = r(9).Array.includes;
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(47)(!0);e(e.P, "Array", { includes: function includes(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      } }), r(38)("includes");
  }, function (t, n, r) {
    r(264), t.exports = r(9).String.padStart;
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(113),
        o = r(55);e(e.P + e.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(o), "String", { padStart: function padStart(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !0);
      } });
  }, function (t, n, r) {
    r(266), t.exports = r(9).String.padEnd;
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(113),
        o = r(55);e(e.P + e.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(o), "String", { padEnd: function padEnd(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !1);
      } });
  }, function (t, n, r) {
    r(268), t.exports = r(60).f("asyncIterator");
  }, function (t, n, r) {
    r(86)("asyncIterator");
  }, function (t, n, r) {
    r(270), t.exports = r(9).Object.getOwnPropertyDescriptors;
  }, function (t, n, r) {
    var e = r(0),
        i = r(112),
        o = r(15),
        u = r(18),
        c = r(77);e(e.S, "Object", { getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
        for (var n, r, e = o(t), a = u.f, f = i(e), s = {}, l = 0; f.length > l;) {
          void 0 !== (r = a(e, n = f[l++])) && c(s, n, r);
        }return s;
      } });
  }, function (t, n, r) {
    r(272), t.exports = r(9).Object.values;
  }, function (t, n, r) {
    var e = r(0),
        i = r(114)(!1);e(e.S, "Object", { values: function values(t) {
        return i(t);
      } });
  }, function (t, n, r) {
    r(274), t.exports = r(9).Object.entries;
  }, function (t, n, r) {
    var e = r(0),
        i = r(114)(!0);e(e.S, "Object", { entries: function entries(t) {
        return i(t);
      } });
  }, function (t, n, r) {
    "use strict";
    r(106), r(276), t.exports = r(9).Promise.finally;
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(9),
        o = r(3),
        u = r(46),
        c = r(108);e(e.P + e.R, "Promise", { finally: function _finally(t) {
        var n = u(this, i.Promise || o.Promise),
            r = "function" == typeof t;return this.then(r ? function (r) {
          return c(n, t()).then(function () {
            return r;
          });
        } : t, r ? function (r) {
          return c(n, t()).then(function () {
            throw r;
          });
        } : t);
      } });
  }, function (t, n, r) {
    r(278), r(279), r(280), t.exports = r(9);
  }, function (t, n, r) {
    var e = r(3),
        i = r(0),
        o = r(55),
        u = [].slice,
        c = /MSIE .\./.test(o),
        a = function a(t) {
      return function (n, r) {
        var e = arguments.length > 2,
            i = !!e && u.call(arguments, 2);return t(e ? function () {
          ("function" == typeof n ? n : Function(n)).apply(this, i);
        } : n, r);
      };
    };i(i.G + i.B + i.F * c, { setTimeout: a(e.setTimeout), setInterval: a(e.setInterval) });
  }, function (t, n, r) {
    var e = r(0),
        i = r(83);e(e.G + e.B, { setImmediate: i.set, clearImmediate: i.clear });
  }, function (t, n, r) {
    for (var e = r(80), i = r(31), o = r(10), u = r(3), c = r(14), a = r(37), f = r(5), s = f("iterator"), l = f("toStringTag"), h = a.Array, v = { CSSRuleList: !0, CSSStyleDeclaration: !1, CSSValueList: !1, ClientRectList: !1, DOMRectList: !1, DOMStringList: !1, DOMTokenList: !0, DataTransferItemList: !1, FileList: !1, HTMLAllCollection: !1, HTMLCollection: !1, HTMLFormElement: !1, HTMLSelectElement: !1, MediaList: !0, MimeTypeArray: !1, NamedNodeMap: !1, NodeList: !0, PaintRequestList: !1, Plugin: !1, PluginArray: !1, SVGLengthList: !1, SVGNumberList: !1, SVGPathSegList: !1, SVGPointList: !1, SVGStringList: !1, SVGTransformList: !1, SourceBufferList: !1, StyleSheetList: !0, TextTrackCueList: !1, TextTrackList: !1, TouchList: !1 }, p = i(v), d = 0; d < p.length; d++) {
      var g,
          y = p[d],
          m = v[y],
          b = u[y],
          x = b && b.prototype;if (x && (x[s] || c(x, s, h), x[l] || c(x, l, y), a[y] = h, m)) for (g in e) {
        x[g] || o(x, g, e[g], !0);
      }
    }
  }, function (t, n) {
    !function (n) {
      "use strict";
      var r,
          e = Object.prototype,
          i = e.hasOwnProperty,
          o = "function" == typeof Symbol ? Symbol : {},
          u = o.iterator || "@@iterator",
          c = o.asyncIterator || "@@asyncIterator",
          a = o.toStringTag || "@@toStringTag",
          f = "object" == typeof t,
          s = n.regeneratorRuntime;if (s) f && (t.exports = s);else {
        (s = n.regeneratorRuntime = f ? t.exports : {}).wrap = x;var l = "suspendedStart",
            h = "suspendedYield",
            v = "executing",
            p = "completed",
            d = {},
            g = {};g[u] = function () {
          return this;
        };var y = Object.getPrototypeOf,
            m = y && y(y(j([])));m && m !== e && i.call(m, u) && (g = m);var b = E.prototype = S.prototype = Object.create(g);_.prototype = b.constructor = E, E.constructor = _, E[a] = _.displayName = "GeneratorFunction", s.isGeneratorFunction = function (t) {
          var n = "function" == typeof t && t.constructor;return !!n && (n === _ || "GeneratorFunction" === (n.displayName || n.name));
        }, s.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, E) : (t.__proto__ = E, a in t || (t[a] = "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, s.awrap = function (t) {
          return { __await: t };
        }, O(F.prototype), F.prototype[c] = function () {
          return this;
        }, s.AsyncIterator = F, s.async = function (t, n, r, e) {
          var i = new F(x(t, n, r, e));return s.isGeneratorFunction(n) ? i : i.next().then(function (t) {
            return t.done ? t.value : i.next();
          });
        }, O(b), b[a] = "Generator", b[u] = function () {
          return this;
        }, b.toString = function () {
          return "[object Generator]";
        }, s.keys = function (t) {
          var n = [];for (var r in t) {
            n.push(r);
          }return n.reverse(), function r() {
            for (; n.length;) {
              var e = n.pop();if (e in t) return r.value = e, r.done = !1, r;
            }return r.done = !0, r;
          };
        }, s.values = j, A.prototype = { constructor: A, reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(M), !t) for (var n in this) {
              "t" === n.charAt(0) && i.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = r);
            }
          }, stop: function stop() {
            this.done = !0;var t = this.tryEntries[0].completion;if ("throw" === t.type) throw t.arg;return this.rval;
          }, dispatchException: function dispatchException(t) {
            if (this.done) throw t;var n = this;function e(e, i) {
              return c.type = "throw", c.arg = t, n.next = e, i && (n.method = "next", n.arg = r), !!i;
            }for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var u = this.tryEntries[o],
                  c = u.completion;if ("root" === u.tryLoc) return e("end");if (u.tryLoc <= this.prev) {
                var a = i.call(u, "catchLoc"),
                    f = i.call(u, "finallyLoc");if (a && f) {
                  if (this.prev < u.catchLoc) return e(u.catchLoc, !0);if (this.prev < u.finallyLoc) return e(u.finallyLoc);
                } else if (a) {
                  if (this.prev < u.catchLoc) return e(u.catchLoc, !0);
                } else {
                  if (!f) throw new Error("try statement without catch or finally");if (this.prev < u.finallyLoc) return e(u.finallyLoc);
                }
              }
            }
          }, abrupt: function abrupt(t, n) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var e = this.tryEntries[r];if (e.tryLoc <= this.prev && i.call(e, "finallyLoc") && this.prev < e.finallyLoc) {
                var o = e;break;
              }
            }o && ("break" === t || "continue" === t) && o.tryLoc <= n && n <= o.finallyLoc && (o = null);var u = o ? o.completion : {};return u.type = t, u.arg = n, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(u);
          }, complete: function complete(t, n) {
            if ("throw" === t.type) throw t.arg;return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && n && (this.next = n), d;
          }, finish: function finish(t) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var r = this.tryEntries[n];if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), M(r), d;
            }
          }, catch: function _catch(t) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var r = this.tryEntries[n];if (r.tryLoc === t) {
                var e = r.completion;if ("throw" === e.type) {
                  var i = e.arg;M(r);
                }return i;
              }
            }throw new Error("illegal catch attempt");
          }, delegateYield: function delegateYield(t, n, e) {
            return this.delegate = { iterator: j(t), resultName: n, nextLoc: e }, "next" === this.method && (this.arg = r), d;
          } };
      }function x(t, n, r, e) {
        var i = n && n.prototype instanceof S ? n : S,
            o = Object.create(i.prototype),
            u = new A(e || []);return o._invoke = function (t, n, r) {
          var e = l;return function (i, o) {
            if (e === v) throw new Error("Generator is already running");if (e === p) {
              if ("throw" === i) throw o;return T();
            }for (r.method = i, r.arg = o;;) {
              var u = r.delegate;if (u) {
                var c = P(u, r);if (c) {
                  if (c === d) continue;return c;
                }
              }if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (e === l) throw e = p, r.arg;r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);e = v;var a = w(t, n, r);if ("normal" === a.type) {
                if (e = r.done ? p : h, a.arg === d) continue;return { value: a.arg, done: r.done };
              }"throw" === a.type && (e = p, r.method = "throw", r.arg = a.arg);
            }
          };
        }(t, r, u), o;
      }function w(t, n, r) {
        try {
          return { type: "normal", arg: t.call(n, r) };
        } catch (t) {
          return { type: "throw", arg: t };
        }
      }function S() {}function _() {}function E() {}function O(t) {
        ["next", "throw", "return"].forEach(function (n) {
          t[n] = function (t) {
            return this._invoke(n, t);
          };
        });
      }function F(t) {
        var n;this._invoke = function (r, e) {
          function o() {
            return new Promise(function (n, o) {
              !function n(r, e, o, u) {
                var c = w(t[r], t, e);if ("throw" !== c.type) {
                  var a = c.arg,
                      f = a.value;return f && "object" == typeof f && i.call(f, "__await") ? Promise.resolve(f.__await).then(function (t) {
                    n("next", t, o, u);
                  }, function (t) {
                    n("throw", t, o, u);
                  }) : Promise.resolve(f).then(function (t) {
                    a.value = t, o(a);
                  }, function (t) {
                    return n("throw", t, o, u);
                  });
                }u(c.arg);
              }(r, e, n, o);
            });
          }return n = n ? n.then(o, o) : o();
        };
      }function P(t, n) {
        var e = t.iterator[n.method];if (e === r) {
          if (n.delegate = null, "throw" === n.method) {
            if (t.iterator.return && (n.method = "return", n.arg = r, P(t, n), "throw" === n.method)) return d;n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }return d;
        }var i = w(e, t.iterator, n.arg);if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, d;var o = i.arg;return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = r), n.delegate = null, d) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, d);
      }function I(t) {
        var n = { tryLoc: t[0] };1 in t && (n.catchLoc = t[1]), 2 in t && (n.finallyLoc = t[2], n.afterLoc = t[3]), this.tryEntries.push(n);
      }function M(t) {
        var n = t.completion || {};n.type = "normal", delete n.arg, t.completion = n;
      }function A(t) {
        this.tryEntries = [{ tryLoc: "root" }], t.forEach(I, this), this.reset(!0);
      }function j(t) {
        if (t) {
          var n = t[u];if (n) return n.call(t);if ("function" == typeof t.next) return t;if (!isNaN(t.length)) {
            var e = -1,
                o = function n() {
              for (; ++e < t.length;) {
                if (i.call(t, e)) return n.value = t[e], n.done = !1, n;
              }return n.value = r, n.done = !0, n;
            };return o.next = o;
          }
        }return { next: T };
      }function T() {
        return { value: r, done: !0 };
      }
    }(function () {
      return this || "object" == typeof self && self;
    }() || Function("return this")());
  }]);
});
//# sourceMappingURL=Idle.js.map

/***/ }),

/***/ "iMz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getPros;
/* harmony export (immutable) */ __webpack_exports__["f"] = getUserDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = getUserByRef;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCallDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = addToShortlist;
/* harmony export (immutable) */ __webpack_exports__["c"] = getProAvailabilityForTimezone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("/C1n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_consts__ = __webpack_require__("4PH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__ = __webpack_require__("ds2O");




var getProsController = new AbortController();
var requestSend = false;
function getPros(searchTerm, sortBy, page, filter, authData) {
  if (requestSend) {
    requestSend = false;
    getProsController.abort();
    getProsController = new AbortController();
  }
  var headers = new Headers();
  headers.append('Authorization', authData);
  var currentPage = page - 1;
  requestSend = true;
  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].SEARCH_USERS + searchTerm + '&size=' + __WEBPACK_IMPORTED_MODULE_1__utils_consts__["E" /* consts */].PAGE_SIZE + '&page=' + currentPage + '&sort=' + sortBy + '&f=' + filter, { method: 'GET', headers: headers, signal: getProsController.signal }).then(function (response) {
    requestSend = false;
    return response;
  });
}

function getUserDetails(userId, authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  var url = __WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].GET_V3_USER_DETAILS(userId);
  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(url, { method: 'GET', headers: headers });
}

function getUserByRef(id) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json');
  var userAuth = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__utils_consts__["z" /* USER_AUTH */]);
  if (userAuth) {
    headers.append('Authorization', 'Bearer ' + userAuth);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].GET_USER_DETAILS_REF(id), { method: 'GET', headers: headers });
}

function getCallDetails(callId, authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].CALLS + '/' + callId, { method: 'GET', headers: headers });
}

function addToShortlist(userId, authData, isForDelete) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].ADD_TO_SHORTLIST(userId), { method: isForDelete ? 'DELETE' : 'POST', headers: headers });
}

function getProAvailabilityForTimezone(proId, timeZone, authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].PRO_AVAILABILITY_V4(proId, timeZone), { method: 'GET', headers: headers });
}

/***/ }),

/***/ "iU4X":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var apply = __webpack_require__("dNrY");
var bind = __webpack_require__("1PPX");
var isCallable = __webpack_require__("yeFe");
var hasOwn = __webpack_require__("J3pj");
var fails = __webpack_require__("rtOw");
var html = __webpack_require__("YdoG");
var arraySlice = __webpack_require__("rGMG");
var createElement = __webpack_require__("mGt/");
var IS_IOS = __webpack_require__("eObX");
var IS_NODE = __webpack_require__("5dKy");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global.location;
} catch (error) {/* empty */}

var run = function run(id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function runner(id) {
  return function () {
    run(id);
  };
};

var listener = function listener(event) {
  run(event.data);
};

var post = function post(id) {
  // old engines have not location.origin
  global.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(isCallable(fn) ? fn : Function(fn), undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function defer(id) {
      process.nextTick(runner(id));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(runner(id));
    };
    // Browsers with MessageChannel, includes WebWorkers
    // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && isCallable(global.postMessage) && !global.importScripts && location && location.protocol !== 'file:' && !fails(post)) {
    defer = post;
    global.addEventListener('message', listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function defer(id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function defer(id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};

/***/ }),

/***/ "iXvo":
/***/ (function(module, exports) {

module.exports = {};

/***/ }),

/***/ "iY6Y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "00da804c8db545d46c904fd7ca7abfb7.png";

/***/ }),

/***/ "ibPW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Ky5l"), __esModule: true };

/***/ }),

/***/ "ieRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__("aFbL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__ = __webpack_require__("DgmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");



var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var startOfDayLeft = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["a" /* default */])(dirtyDateLeft);
  var startOfDayRight = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["a" /* default */])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),

/***/ "ihXi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d60a042e2c757a0c9bb94c923e7d752b.svg";

/***/ }),

/***/ "j65U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button__10pZ6","themeCall":"themeCall__1c48f"};

/***/ }),

/***/ "jKgr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"activityList":"activityList__14vf4","activityHeader":"activityHeader__2Qllm","selected":"selected__3XueA","empty":"empty__2jJmy","header":"header__3rjiU","type":"type__3N122","contact":"contact__2Pa_l","date":"date__22KUv","count":"count__G7bbU","spinnerContainer":"spinnerContainer__1wJfu","withSorting":"withSorting__2ItYm","pagination":"pagination__2TU0m"};

/***/ }),

/***/ "jNGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase();
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name];
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return cache[name] = msPattern.test(hName) ? '-' + hName : hName;
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);

/***/ }),

/***/ "jT1X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/uuid/v4.js
var v4 = __webpack_require__("hYHi");
var v4_default = /*#__PURE__*/__webpack_require__.n(v4);

// EXTERNAL MODULE: ../node_modules/@bugfender/sdk/lib/index.js
var lib = __webpack_require__("FFyX");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./actions/index.js
var actions = __webpack_require__("vyGZ");

// EXTERNAL MODULE: ./api/users.js
var users = __webpack_require__("mecS");

// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// EXTERNAL MODULE: ./services/FireBase.js
var FireBase = __webpack_require__("Vqdy");

// EXTERNAL MODULE: ./reducers/application.js
var application = __webpack_require__("s5UR");

// EXTERNAL MODULE: ./actions/api-notifications.js
var api_notifications = __webpack_require__("kKXN");

// EXTERNAL MODULE: ./api/fetch-wrapper.js
var fetch_wrapper = __webpack_require__("ds2O");

// EXTERNAL MODULE: ./api/index.js
var api = __webpack_require__("/C1n");

// CONCATENATED MODULE: ./api/authorization.js
/* eslint-disable import/prefer-default-export */




function auth(_ref) {
  var authData = _ref.authData,
      params = _ref.params;

  var headers = new Headers();

  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  var requestOptions = {
    headers: headers,
    method: 'POST',
    body: JSON.stringify(params)
  };

  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].AUTH, requestOptions);
}
// CONCATENATED MODULE: ./actions/sign-in.js
/* harmony export (immutable) */ __webpack_exports__["a"] = signInFetchUserData;
/* harmony export (immutable) */ __webpack_exports__["b"] = signInLogin;
/* harmony export (immutable) */ __webpack_exports__["d"] = signInSocialLogin;
/* harmony export (immutable) */ __webpack_exports__["c"] = signInSetProcessed;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// import * as Sentry from '@sentry/browser';










/**
 *
 * @param {string} authData
 * @return {function(...[*]=)}
 */
function signInFetchUserData(authData) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var accessToken, refreshToken, userData, _userData;

      accessToken = localStorage.getItem(consts["n" /* LOCAL_STORAGE */].USER_AUTH);
      refreshToken = localStorage.getItem(consts["n" /* LOCAL_STORAGE */].REFRESH_TOKEN);

      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (fetchUserError) {
        try {
          var $Try_2_Post = function () {
            try {
              return $Try_1_Post();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          };var $Try_2_Catch = function (refreshTokenError) {
            try {
              dispatch(signInLoginFailure(refreshTokenError.message));

              // eslint-disable-next-line no-console
              console.error(fetchUserError);

              throw refreshTokenError;
            } catch ($boundEx) {
              return $error($boundEx);
            }
          };
          try {
            return Promise.resolve(users["u" /* refreshToken */](accessToken, refreshToken)).then(function ($await_7) {
              try {
                _userData = $await_7;

                FireBase["a" /* default */].setUserId(_userData.id.toString());

                dispatch(signInLoginSuccess(_userData));
                return $Try_2_Post();
              } catch ($boundEx) {
                return $Try_2_Catch($boundEx);
              }
            }, $Try_2_Catch);
          } catch (refreshTokenError) {
            $Try_2_Catch(refreshTokenError)
          }
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        dispatch({
          type: actions["a" /* actionTypes */].SIGN_IN_FETCH_USER_DATA_REQUEST
        });

        return Promise.resolve(users["o" /* getUserInfo */](authData)).then(function ($await_8) {
          try {
            userData = $await_8;

            FireBase["a" /* default */].setUserId(userData.id.toString());

            dispatch(signInFetchUserDataSuccess('Bearer ' + accessToken, userData));
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (fetchUserError) {
        $Try_1_Catch(fetchUserError)
      }
    });
  };
}

/**
 *
 * @param {string} error
 * @return {{error: string, type: string}}
 */
function signInFetchUserDataFailure(error) {
  return {
    error: error,
    type: actions["a" /* actionTypes */].SIGN_IN_FETCH_USER_DATA_FAILURE
  };
}

/**
 *
 * @param {string} authData
 * @param {Object} userData
 * @return {function(...[*]=)}
 */
function signInFetchUserDataSuccess(authData, userData) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var $Try_3_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_3_Catch = function (error) {
        try {
          dispatch(signInFetchUserDataFailure('Cannot fetch user data'));

          throw error;
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(dispatch(signInUpdateUser(authData, userData))).then(function ($await_9) {
          try {

            dispatch({
              type: actions["a" /* actionTypes */].SIGN_IN_FETCH_USER_DATA_SUCCESS
            });
            return $Try_3_Post();
          } catch ($boundEx) {
            return $Try_3_Catch($boundEx);
          }
        }, $Try_3_Catch);
      } catch (error) {
        $Try_3_Catch(error)
      }
    });
  };
}

/**
 *
 * @param {string} authData
 * @return {function(...[*]=)}
 */
function signInLogin(authData) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;
      var $Try_4_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_4_Catch = function (error) {
        try {
          dispatch(signInLoginFailure(error.message));
          return $Try_4_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({
          type: actions["a" /* actionTypes */].SIGN_IN_LOGIN_REQUEST
        });

        localStorage.removeItem(consts["n" /* LOCAL_STORAGE */].UUID);

        return Promise.resolve(users["q" /* logIn */](authData)).then(function ($await_10) {
          try {
            response = $await_10;

            dispatch(signInLoginSuccess(response));
            return $Try_4_Post();
          } catch ($boundEx) {
            return $Try_4_Catch($boundEx);
          }
        }, $Try_4_Catch);
      } catch (error) {
        $Try_4_Catch(error)
      }
    });
  };
}

/**
 *
 * @param {string} error
 * @return {{error: string, type: string}}
 */
function signInLoginFailure(error) {
  return {
    error: error,
    type: actions["a" /* actionTypes */].SIGN_IN_LOGIN_FAILURE
  };
}

/**
 *
 * @param {Object} response
 * @return {function(...[*]=)}
 */
function signInLoginSuccess(response) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var _response$token, accessToken, refreshToken, tokenType, userData, combinedToken;

      var $Try_5_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_5_Catch = function (error) {
        try {
          dispatch(signInLoginFailure('Cannot finish login!'));
          return $Try_5_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        _response$token = response.token, accessToken = _response$token.accessToken, refreshToken = _response$token.refreshToken, tokenType = _response$token.tokenType, userData = _objectWithoutProperties(response, ['token']);


        combinedToken = tokenType + ' ' + accessToken;

        return Promise.resolve(dispatch(signInUpdateUser(combinedToken, userData))).then(function ($await_11) {
          try {

            localStorage.setItem(consts["z" /* USER_AUTH */], '' + accessToken);
            localStorage.setItem(consts["t" /* REFRESH_TOKEN */], '' + refreshToken);

            FireBase["a" /* default */].logEvent(FireBase["a" /* default */].EVENTS.TAP_SIGN_IN);

            dispatch({
              type: actions["a" /* actionTypes */].SIGN_IN_LOGIN_SUCCESS
            });
            return $Try_5_Post();
          } catch ($boundEx) {
            return $Try_5_Catch($boundEx);
          }
        }, $Try_5_Catch);
      } catch (error) {
        $Try_5_Catch(error)
      }
    });
  };
}

/**
 *
 * @param {string} authData
 * @param {Object} input
 * @return {function(...[*]=)}
 */
function signInSocialLogin(authData, input) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var deviceID, response;
      var $Try_6_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_6_Catch = function (error) {
        try {
          dispatch(Object(api_notifications["a" /* addNotification */])(error));

          dispatch(signInLoginFailure(error.message));
          return $Try_6_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        dispatch({
          type: actions["a" /* actionTypes */].SIGN_IN_SOCIAL_LOGIN_REQUEST
        });

        deviceID = v4_default()();

        localStorage.setItem(consts["n" /* LOCAL_STORAGE */].UUID, deviceID);

        return Promise.resolve(auth({
          authData: 'Bearer ' + authData,
          params: _extends({}, input, {
            deviceID: deviceID,
            locale: navigator.languages[0]
          })
        })).then(function ($await_12) {
          try {
            response = $await_12;

            dispatch(signInLoginSuccess(response));
            return $Try_6_Post();
          } catch ($boundEx) {
            return $Try_6_Catch($boundEx);
          }
        }, $Try_6_Catch);
      } catch (error) {
        $Try_6_Catch(error)
      }
    });
  };
}

/**
 *
 * @param { string } userAuth
 * @param {Object} userData
 * @return {{payload: {userData: Object, userAuth: string}, type: string}}
 */
function signInPutResponse(userAuth, userData) {
  return {
    type: actions["a" /* actionTypes */].SIGN_IN_PUT_RESPONSE,
    payload: { userAuth: userAuth, userData: userData }
  };
}

/**
 *
 * @param {string} authData
 * @param {Object} userData
 * @return {function(...[*]=)}
 */
function signInUpdateUser(authData, userData) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var deviceId, _selectApplicationDet, name, version, registeredDevice;

      // Sentry.configureScope(((scope) => {
      //   scope.setUser({ id: userData.id });
      // }));
      lib["Bugfender"].setDeviceKey('user_email', userData.email);
      lib["Bugfender"].setDeviceKey('user_logged_in', true);

      deviceId = localStorage.getItem(consts["n" /* LOCAL_STORAGE */].UUID) || v4_default()();

      localStorage.setItem(consts["n" /* LOCAL_STORAGE */].UUID, deviceId);

      _selectApplicationDet = Object(application["g" /* selectApplicationDetected */])(getState()), name = _selectApplicationDet.name, version = _selectApplicationDet.version;
      return Promise.resolve(users["a" /* addDeviceForCurrentUser */](authData, {
        device: deviceId,
        agent: name,
        agentVersion: version,
        type: 'WEB',
        locale: navigator.languages[0],
        appVersion: consts["C" /* appVersion */]
      })).then(function ($await_13) {
        try {

          registeredDevice = $await_13;

          dispatch(signInPutResponse(authData, _extends({}, userData, { numericDeviceId: registeredDevice.id })));
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
}

function signInSetProcessed() {
  return {
    type: actions["a" /* actionTypes */].SIGN_IN_SET_PROCESSED
  };
}

/***/ }),

/***/ "jYt2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */

module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
		return false;
	}
	if (typeof Symbol.iterator === 'symbol') {
		return true;
	}

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') {
		return false;
	}

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
		return false;
	}
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
		return false;
	}

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) {
		return false;
	} // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
		return false;
	}

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
		return false;
	}

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) {
		return false;
	}

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
		return false;
	}

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) {
			return false;
		}
	}

	return true;
};

/***/ }),

/***/ "jqpc":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("1kal");
var defineProperties = __webpack_require__("u760");
var enumBugKeys = __webpack_require__("lzt6");
var hiddenKeys = __webpack_require__("Psxq");
var html = __webpack_require__("YdoG");
var documentCreateElement = __webpack_require__("mGt/");
var sharedKey = __webpack_require__("2+7m");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function EmptyConstructor() {/* empty */};

var scriptTag = function scriptTag(content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var _NullProtoObject = function NullProtoObject() {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) {/* ignore */}
  _NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) {
    delete _NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  }return _NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

/***/ }),

/***/ "jx4H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("FFZn");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "jzqA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification":"notification__lWwO4"};

/***/ }),

/***/ "k+5J":
/***/ (function(module, exports, __webpack_require__) {

/*! UIkit 3.9.4 | https://www.getuikit.com | (c) 2014 - 2021 YOOtheme | MIT License */

(function (global, factory) {
     true ? module.exports = factory() : typeof define === 'function' && define.amd ? define('uikit', factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.UIkit = factory());
})(this, function () {
    'use strict';

    var objPrototype = Object.prototype;
    var hasOwnProperty = objPrototype.hasOwnProperty;

    function hasOwn(obj, key) {
        return hasOwnProperty.call(obj, key);
    }

    var hyphenateRe = /\B([A-Z])/g;

    var hyphenate = memoize(function (str) {
        return str.replace(hyphenateRe, '-$1').toLowerCase();
    });

    var camelizeRe = /-(\w)/g;

    var camelize = memoize(function (str) {
        return str.replace(camelizeRe, toUpper);
    });

    var ucfirst = memoize(function (str) {
        return str.length ? toUpper(null, str.charAt(0)) + str.slice(1) : '';
    });

    function toUpper(_, c) {
        return c ? c.toUpperCase() : '';
    }

    var strPrototype = String.prototype;
    var startsWithFn = strPrototype.startsWith || function (search) {
        return this.lastIndexOf(search, 0) === 0;
    };

    function startsWith(str, search) {
        return startsWithFn.call(str, search);
    }

    var endsWithFn = strPrototype.endsWith || function (search) {
        return this.substr(-search.length) === search;
    };

    function endsWith(str, search) {
        return endsWithFn.call(str, search);
    }

    var arrPrototype = Array.prototype;

    var includesFn = function includesFn(search, i) {
        return !!~this.indexOf(search, i);
    };
    var includesStr = strPrototype.includes || includesFn;
    var includesArray = arrPrototype.includes || includesFn;

    function includes(obj, search) {
        return obj && (isString(obj) ? includesStr : includesArray).call(obj, search);
    }

    var findIndexFn = arrPrototype.findIndex || function (predicate) {
        var arguments$1 = arguments;

        for (var i = 0; i < this.length; i++) {
            if (predicate.call(arguments$1[1], this[i], i, this)) {
                return i;
            }
        }
        return -1;
    };

    function findIndex(array, predicate) {
        return findIndexFn.call(array, predicate);
    }

    var isArray = Array.isArray;

    function isFunction(obj) {
        return typeof obj === 'function';
    }

    function isObject(obj) {
        return obj !== null && typeof obj === 'object';
    }

    var toString = objPrototype.toString;
    function isPlainObject(obj) {
        return toString.call(obj) === '[object Object]';
    }

    function isWindow(obj) {
        return isObject(obj) && obj === obj.window;
    }

    function isDocument(obj) {
        return nodeType(obj) === 9;
    }

    function isNode(obj) {
        return nodeType(obj) >= 1;
    }

    function isElement(obj) {
        return nodeType(obj) === 1;
    }

    function nodeType(obj) {
        return !isWindow(obj) && isObject(obj) && obj.nodeType;
    }

    function isBoolean(value) {
        return typeof value === 'boolean';
    }

    function isString(value) {
        return typeof value === 'string';
    }

    function isNumber(value) {
        return typeof value === 'number';
    }

    function isNumeric(value) {
        return isNumber(value) || isString(value) && !isNaN(value - parseFloat(value));
    }

    function isEmpty(obj) {
        return !(isArray(obj) ? obj.length : isObject(obj) ? Object.keys(obj).length : false);
    }

    function isUndefined(value) {
        return value === void 0;
    }

    function toBoolean(value) {
        return isBoolean(value) ? value : value === 'true' || value === '1' || value === '' ? true : value === 'false' || value === '0' ? false : value;
    }

    function toNumber(value) {
        var number = Number(value);
        return !isNaN(number) ? number : false;
    }

    function toFloat(value) {
        return parseFloat(value) || 0;
    }

    var toArray = Array.from || function (value) {
        return arrPrototype.slice.call(value);
    };

    function toNode(element) {
        return toNodes(element)[0];
    }

    function toNodes(element) {
        return element && (isNode(element) ? [element] : toArray(element).filter(isNode)) || [];
    }

    function toWindow(element) {
        if (isWindow(element)) {
            return element;
        }

        element = toNode(element);

        return element ? (isDocument(element) ? element : element.ownerDocument).defaultView : window;
    }

    function toMs(time) {
        return !time ? 0 : endsWith(time, 'ms') ? toFloat(time) : toFloat(time) * 1000;
    }

    function isEqual(value, other) {
        return value === other || isObject(value) && isObject(other) && Object.keys(value).length === Object.keys(other).length && each(value, function (val, key) {
            return val === other[key];
        });
    }

    function swap(value, a, b) {
        return value.replace(new RegExp(a + "|" + b, 'g'), function (match) {
            return match === a ? b : a;
        });
    }

    var assign = Object.assign || function (target) {
        var args = [],
            len = arguments.length - 1;
        while (len-- > 0) {
            args[len] = arguments[len + 1];
        }target = Object(target);
        for (var i = 0; i < args.length; i++) {
            var source = args[i];
            if (source !== null) {
                for (var key in source) {
                    if (hasOwn(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };

    function last(array) {
        return array[array.length - 1];
    }

    function each(obj, cb) {
        for (var key in obj) {
            if (false === cb(obj[key], key)) {
                return false;
            }
        }
        return true;
    }

    function sortBy$1(array, prop) {
        return array.slice().sort(function (ref, ref$1) {
            var propA = ref[prop];if (propA === void 0) propA = 0;
            var propB = ref$1[prop];if (propB === void 0) propB = 0;

            return propA > propB ? 1 : propB > propA ? -1 : 0;
        });
    }

    function uniqueBy(array, prop) {
        var seen = new Set();
        return array.filter(function (ref) {
            var check = ref[prop];

            return seen.has(check) ? false : seen.add(check) || true;
        } // IE 11 does not return the Set object
        );
    }

    function clamp(number, min, max) {
        if (min === void 0) min = 0;
        if (max === void 0) max = 1;

        return Math.min(Math.max(toNumber(number) || 0, min), max);
    }

    function noop() {}

    function intersectRect() {
        var rects = [],
            len = arguments.length;
        while (len--) {
            rects[len] = arguments[len];
        }return [['bottom', 'top'], ['right', 'left']].every(function (ref) {
            var minProp = ref[0];
            var maxProp = ref[1];

            return Math.min.apply(Math, rects.map(function (ref) {
                var min = ref[minProp];

                return min;
            })) - Math.max.apply(Math, rects.map(function (ref) {
                var max = ref[maxProp];

                return max;
            })) > 0;
        });
    }

    function pointInRect(point, rect) {
        return point.x <= rect.right && point.x >= rect.left && point.y <= rect.bottom && point.y >= rect.top;
    }

    var Dimensions = {

        ratio: function ratio(dimensions, prop, value) {
            var obj;

            var aProp = prop === 'width' ? 'height' : 'width';

            return obj = {}, obj[aProp] = dimensions[prop] ? Math.round(value * dimensions[aProp] / dimensions[prop]) : dimensions[aProp], obj[prop] = value, obj;
        },

        contain: function contain(dimensions, maxDimensions) {
            var this$1$1 = this;

            dimensions = assign({}, dimensions);

            each(dimensions, function (_, prop) {
                return dimensions = dimensions[prop] > maxDimensions[prop] ? this$1$1.ratio(dimensions, prop, maxDimensions[prop]) : dimensions;
            });

            return dimensions;
        },

        cover: function cover(dimensions, maxDimensions) {
            var this$1$1 = this;

            dimensions = this.contain(dimensions, maxDimensions);

            each(dimensions, function (_, prop) {
                return dimensions = dimensions[prop] < maxDimensions[prop] ? this$1$1.ratio(dimensions, prop, maxDimensions[prop]) : dimensions;
            });

            return dimensions;
        }

    };

    function _getIndex(i, elements, current, finite) {
        if (current === void 0) current = 0;
        if (finite === void 0) finite = false;

        elements = toNodes(elements);

        var length = elements.length;

        i = isNumeric(i) ? toNumber(i) : i === 'next' ? current + 1 : i === 'previous' ? current - 1 : elements.indexOf(toNode(i));

        if (finite) {
            return clamp(i, 0, length - 1);
        }

        i %= length;

        return i < 0 ? i + length : i;
    }

    function memoize(fn) {
        var cache = Object.create(null);
        return function (key) {
            return cache[key] || (cache[key] = fn(key));
        };
    }

    function attr(element, name, value) {

        if (isObject(name)) {
            for (var key in name) {
                attr(element, key, name[key]);
            }
            return;
        }

        if (isUndefined(value)) {
            element = toNode(element);
            return element && element.getAttribute(name);
        } else {
            toNodes(element).forEach(function (element) {

                if (isFunction(value)) {
                    value = value.call(element, attr(element, name));
                }

                if (value === null) {
                    removeAttr(element, name);
                } else {
                    element.setAttribute(name, value);
                }
            });
        }
    }

    function hasAttr(element, name) {
        return toNodes(element).some(function (element) {
            return element.hasAttribute(name);
        });
    }

    function removeAttr(element, name) {
        element = toNodes(element);
        name.split(' ').forEach(function (name) {
            return element.forEach(function (element) {
                return element.hasAttribute(name) && element.removeAttribute(name);
            });
        });
    }

    function data(element, attribute) {
        for (var i = 0, attrs = [attribute, "data-" + attribute]; i < attrs.length; i++) {
            if (hasAttr(element, attrs[i])) {
                return attr(element, attrs[i]);
            }
        }
    }

    /* global DocumentTouch */

    var inBrowser = typeof window !== 'undefined';
    var isIE = inBrowser && /msie|trident/i.test(window.navigator.userAgent);
    var isRtl = inBrowser && attr(document.documentElement, 'dir') === 'rtl';

    var hasTouchEvents = inBrowser && 'ontouchstart' in window;
    var hasPointerEvents = inBrowser && window.PointerEvent;
    var hasTouch = inBrowser && (hasTouchEvents || window.DocumentTouch && document instanceof DocumentTouch || navigator.maxTouchPoints); // IE >=11

    var pointerDown = hasPointerEvents ? 'pointerdown' : hasTouchEvents ? 'touchstart' : 'mousedown';
    var pointerMove = hasPointerEvents ? 'pointermove' : hasTouchEvents ? 'touchmove' : 'mousemove';
    var pointerUp = hasPointerEvents ? 'pointerup' : hasTouchEvents ? 'touchend' : 'mouseup';
    var pointerEnter = hasPointerEvents ? 'pointerenter' : hasTouchEvents ? '' : 'mouseenter';
    var pointerLeave = hasPointerEvents ? 'pointerleave' : hasTouchEvents ? '' : 'mouseleave';
    var pointerCancel = hasPointerEvents ? 'pointercancel' : 'touchcancel';

    var voidElements = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        menuitem: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true
    };
    function isVoidElement(element) {
        return toNodes(element).some(function (element) {
            return voidElements[element.tagName.toLowerCase()];
        });
    }

    function isVisible(element) {
        return toNodes(element).some(function (element) {
            return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
        });
    }

    var selInput = 'input,select,textarea,button';
    function isInput(element) {
        return toNodes(element).some(function (element) {
            return matches(element, selInput);
        });
    }

    var selFocusable = selInput + ",a[href],[tabindex]";
    function isFocusable(element) {
        return matches(element, selFocusable);
    }

    function parent(element) {
        element = toNode(element);
        return element && isElement(element.parentNode) && element.parentNode;
    }

    function filter$1(element, selector) {
        return toNodes(element).filter(function (element) {
            return matches(element, selector);
        });
    }

    var elProto = inBrowser ? Element.prototype : {};
    var matchesFn = elProto.matches || elProto.webkitMatchesSelector || elProto.msMatchesSelector || noop;

    function matches(element, selector) {
        return toNodes(element).some(function (element) {
            return matchesFn.call(element, selector);
        });
    }

    var closestFn = elProto.closest || function (selector) {
        var ancestor = this;

        do {

            if (matches(ancestor, selector)) {
                return ancestor;
            }
        } while (ancestor = parent(ancestor));
    };

    function closest(element, selector) {

        if (startsWith(selector, '>')) {
            selector = selector.slice(1);
        }

        return isElement(element) ? closestFn.call(element, selector) : toNodes(element).map(function (element) {
            return closest(element, selector);
        }).filter(Boolean);
    }

    function within(element, selector) {
        return !isString(selector) ? element === selector || (isDocument(selector) ? selector.documentElement : toNode(selector)).contains(toNode(element)) // IE 11 document does not implement contains
        : matches(element, selector) || !!closest(element, selector);
    }

    function parents(element, selector) {
        var elements = [];

        while (element = parent(element)) {
            if (!selector || matches(element, selector)) {
                elements.push(element);
            }
        }

        return elements;
    }

    function _children(element, selector) {
        element = toNode(element);
        var children = element ? toNodes(element.children) : [];
        return selector ? filter$1(children, selector) : children;
    }

    function index(element, ref) {
        return ref ? toNodes(element).indexOf(toNode(ref)) : _children(parent(element)).indexOf(element);
    }

    function query(selector, context) {
        return find(selector, getContext(selector, context));
    }

    function queryAll(selector, context) {
        return findAll(selector, getContext(selector, context));
    }

    function getContext(selector, context) {
        if (context === void 0) context = document;

        return isString(selector) && isContextSelector(selector) || isDocument(context) ? context : context.ownerDocument;
    }

    function find(selector, context) {
        return toNode(_query(selector, context, 'querySelector'));
    }

    function findAll(selector, context) {
        return toNodes(_query(selector, context, 'querySelectorAll'));
    }

    function _query(selector, context, queryFn) {
        if (context === void 0) context = document;

        if (!selector || !isString(selector)) {
            return selector;
        }

        selector = selector.replace(contextSanitizeRe, '$1 *');

        if (isContextSelector(selector)) {

            selector = splitSelector(selector).map(function (selector) {

                var ctx = context;

                if (selector[0] === '!') {

                    var selectors = selector.substr(1).trim().split(' ');
                    ctx = closest(parent(context), selectors[0]);
                    selector = selectors.slice(1).join(' ').trim();
                }

                if (selector[0] === '-') {

                    var selectors$1 = selector.substr(1).trim().split(' ');
                    var prev = (ctx || context).previousElementSibling;
                    ctx = matches(prev, selector.substr(1)) ? prev : null;
                    selector = selectors$1.slice(1).join(' ');
                }

                if (!ctx) {
                    return null;
                }

                return domPath(ctx) + " " + selector;
            }).filter(Boolean).join(',');

            context = document;
        }

        try {

            return context[queryFn](selector);
        } catch (e) {

            return null;
        }
    }

    var contextSelectorRe = /(^|[^\\],)\s*[!>+~-]/;
    var contextSanitizeRe = /([!>+~-])(?=\s+[!>+~-]|\s*$)/g;

    var isContextSelector = memoize(function (selector) {
        return selector.match(contextSelectorRe);
    });

    var selectorRe = /.*?[^\\](?:,|$)/g;

    var splitSelector = memoize(function (selector) {
        return selector.match(selectorRe).map(function (selector) {
            return selector.replace(/,$/, '').trim();
        });
    });

    function domPath(element) {
        var names = [];
        while (element.parentNode) {
            if (element.id) {
                names.unshift("#" + escape(element.id));
                break;
            } else {
                var tagName = element.tagName;
                if (tagName !== 'HTML') {
                    tagName += ":nth-child(" + (index(element) + 1) + ")";
                }
                names.unshift(tagName);
                element = element.parentNode;
            }
        }
        return names.join(' > ');
    }

    var escapeFn = inBrowser && window.CSS && CSS.escape || function (css) {
        return css.replace(/([^\x7f-\uFFFF\w-])/g, function (match) {
            return "\\" + match;
        });
    };
    function escape(css) {
        return isString(css) ? escapeFn.call(null, css) : '';
    }

    function on() {
        var args = [],
            len = arguments.length;
        while (len--) {
            args[len] = arguments[len];
        }var ref = getArgs(args);
        var targets = ref[0];
        var type = ref[1];
        var selector = ref[2];
        var listener = ref[3];
        var useCapture = ref[4];

        targets = toEventTargets(targets);

        if (listener.length > 1) {
            listener = detail(listener);
        }

        if (useCapture && useCapture.self) {
            listener = selfFilter(listener);
        }

        if (selector) {
            listener = delegate(selector, listener);
        }

        useCapture = useCaptureFilter(useCapture);

        type.split(' ').forEach(function (type) {
            return targets.forEach(function (target) {
                return target.addEventListener(type, listener, useCapture);
            });
        });
        return function () {
            return off(targets, type, listener, useCapture);
        };
    }

    function off(targets, type, listener, useCapture) {
        if (useCapture === void 0) useCapture = false;

        useCapture = useCaptureFilter(useCapture);
        targets = toEventTargets(targets);
        type.split(' ').forEach(function (type) {
            return targets.forEach(function (target) {
                return target.removeEventListener(type, listener, useCapture);
            });
        });
    }

    function once() {
        var args = [],
            len = arguments.length;
        while (len--) {
            args[len] = arguments[len];
        }var ref = getArgs(args);
        var element = ref[0];
        var type = ref[1];
        var selector = ref[2];
        var listener = ref[3];
        var useCapture = ref[4];
        var condition = ref[5];
        var off = on(element, type, selector, function (e) {
            var result = !condition || condition(e);
            if (result) {
                off();
                listener(e, result);
            }
        }, useCapture);

        return off;
    }

    function trigger(targets, event, detail) {
        return toEventTargets(targets).reduce(function (notCanceled, target) {
            return notCanceled && target.dispatchEvent(createEvent(event, true, true, detail));
        }, true);
    }

    function createEvent(e, bubbles, cancelable, detail) {
        if (bubbles === void 0) bubbles = true;
        if (cancelable === void 0) cancelable = false;

        if (isString(e)) {
            var event = document.createEvent('CustomEvent'); // IE 11
            event.initCustomEvent(e, bubbles, cancelable, detail);
            e = event;
        }

        return e;
    }

    function getArgs(args) {
        if (isFunction(args[2])) {
            args.splice(2, 0, false);
        }
        return args;
    }

    function delegate(selector, listener) {
        var this$1$1 = this;

        return function (e) {

            var current = selector[0] === '>' ? findAll(selector, e.currentTarget).reverse().filter(function (element) {
                return within(e.target, element);
            })[0] : closest(e.target, selector);

            if (current) {
                e.current = current;
                listener.call(this$1$1, e);
            }
        };
    }

    function detail(listener) {
        return function (e) {
            return isArray(e.detail) ? listener.apply(void 0, [e].concat(e.detail)) : listener(e);
        };
    }

    function selfFilter(listener) {
        return function (e) {
            if (e.target === e.currentTarget || e.target === e.current) {
                return listener.call(null, e);
            }
        };
    }

    function useCaptureFilter(options) {
        return options && isIE && !isBoolean(options) ? !!options.capture : options;
    }

    function isEventTarget(target) {
        return target && 'addEventListener' in target;
    }

    function toEventTarget(target) {
        return isEventTarget(target) ? target : toNode(target);
    }

    function toEventTargets(target) {
        return isArray(target) ? target.map(toEventTarget).filter(Boolean) : isString(target) ? findAll(target) : isEventTarget(target) ? [target] : toNodes(target);
    }

    function isTouch(e) {
        return e.pointerType === 'touch' || !!e.touches;
    }

    function getEventPos(e) {
        var touches = e.touches;
        var changedTouches = e.changedTouches;
        var ref = touches && touches[0] || changedTouches && changedTouches[0] || e;
        var x = ref.clientX;
        var y = ref.clientY;

        return { x: x, y: y };
    }

    /* global setImmediate */

    var Promise$1 = inBrowser && window.Promise || PromiseFn;

    var Deferred = function Deferred() {
        var this$1$1 = this;

        this.promise = new Promise$1(function (resolve, reject) {
            this$1$1.reject = reject;
            this$1$1.resolve = resolve;
        });
    };

    /**
     * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
     */

    var RESOLVED = 0;
    var REJECTED = 1;
    var PENDING = 2;

    var async = inBrowser && window.setImmediate || setTimeout;

    function PromiseFn(executor) {

        this.state = PENDING;
        this.value = undefined;
        this.deferred = [];

        var promise = this;

        try {
            executor(function (x) {
                promise.resolve(x);
            }, function (r) {
                promise.reject(r);
            });
        } catch (e) {
            promise.reject(e);
        }
    }

    PromiseFn.reject = function (r) {
        return new PromiseFn(function (resolve, reject) {
            reject(r);
        });
    };

    PromiseFn.resolve = function (x) {
        return new PromiseFn(function (resolve, reject) {
            resolve(x);
        });
    };

    PromiseFn.all = function all(iterable) {
        return new PromiseFn(function (resolve, reject) {
            var result = [];
            var count = 0;

            if (iterable.length === 0) {
                resolve(result);
            }

            function resolver(i) {
                return function (x) {
                    result[i] = x;
                    count += 1;

                    if (count === iterable.length) {
                        resolve(result);
                    }
                };
            }

            for (var i = 0; i < iterable.length; i += 1) {
                PromiseFn.resolve(iterable[i]).then(resolver(i), reject);
            }
        });
    };

    PromiseFn.race = function race(iterable) {
        return new PromiseFn(function (resolve, reject) {
            for (var i = 0; i < iterable.length; i += 1) {
                PromiseFn.resolve(iterable[i]).then(resolve, reject);
            }
        });
    };

    var p = PromiseFn.prototype;

    p.resolve = function resolve(x) {
        var promise = this;

        if (promise.state === PENDING) {
            if (x === promise) {
                throw new TypeError('Promise settled with itself.');
            }

            var called = false;

            try {
                var then = x && x.then;

                if (x !== null && isObject(x) && isFunction(then)) {
                    then.call(x, function (x) {
                        if (!called) {
                            promise.resolve(x);
                        }
                        called = true;
                    }, function (r) {
                        if (!called) {
                            promise.reject(r);
                        }
                        called = true;
                    });
                    return;
                }
            } catch (e) {
                if (!called) {
                    promise.reject(e);
                }
                return;
            }

            promise.state = RESOLVED;
            promise.value = x;
            promise.notify();
        }
    };

    p.reject = function reject(reason) {
        var promise = this;

        if (promise.state === PENDING) {
            if (reason === promise) {
                throw new TypeError('Promise settled with itself.');
            }

            promise.state = REJECTED;
            promise.value = reason;
            promise.notify();
        }
    };

    p.notify = function notify() {
        var this$1$1 = this;

        async(function () {
            if (this$1$1.state !== PENDING) {
                while (this$1$1.deferred.length) {
                    var ref = this$1$1.deferred.shift();
                    var onResolved = ref[0];
                    var onRejected = ref[1];
                    var resolve = ref[2];
                    var reject = ref[3];

                    try {
                        if (this$1$1.state === RESOLVED) {
                            if (isFunction(onResolved)) {
                                resolve(onResolved.call(undefined, this$1$1.value));
                            } else {
                                resolve(this$1$1.value);
                            }
                        } else if (this$1$1.state === REJECTED) {
                            if (isFunction(onRejected)) {
                                resolve(onRejected.call(undefined, this$1$1.value));
                            } else {
                                reject(this$1$1.value);
                            }
                        }
                    } catch (e) {
                        reject(e);
                    }
                }
            }
        });
    };

    p.then = function then(onResolved, onRejected) {
        var this$1$1 = this;

        return new PromiseFn(function (resolve, reject) {
            this$1$1.deferred.push([onResolved, onRejected, resolve, reject]);
            this$1$1.notify();
        });
    };

    p.catch = function (onRejected) {
        return this.then(undefined, onRejected);
    };

    function ajax(url, options) {

        var env = assign({
            data: null,
            method: 'GET',
            headers: {},
            xhr: new XMLHttpRequest(),
            beforeSend: noop,
            responseType: ''
        }, options);

        return Promise$1.resolve().then(function () {
            return env.beforeSend(env);
        }).then(function () {
            return send(url, env);
        });
    }

    function send(url, env) {
        return new Promise$1(function (resolve, reject) {
            var xhr = env.xhr;

            for (var prop in env) {
                if (prop in xhr) {
                    try {

                        xhr[prop] = env[prop];
                    } catch (e) {}
                }
            }

            xhr.open(env.method.toUpperCase(), url);

            for (var header in env.headers) {
                xhr.setRequestHeader(header, env.headers[header]);
            }

            on(xhr, 'load', function () {

                if (xhr.status === 0 || xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {

                    // IE 11 does not support responseType 'json'
                    if (env.responseType === 'json' && isString(xhr.response)) {
                        xhr = assign(copyXhr(xhr), { response: JSON.parse(xhr.response) });
                    }

                    resolve(xhr);
                } else {
                    reject(assign(Error(xhr.statusText), {
                        xhr: xhr,
                        status: xhr.status
                    }));
                }
            });

            on(xhr, 'error', function () {
                return reject(assign(Error('Network Error'), { xhr: xhr }));
            });
            on(xhr, 'timeout', function () {
                return reject(assign(Error('Network Timeout'), { xhr: xhr }));
            });

            xhr.send(env.data);
        });
    }

    function getImage(src, srcset, sizes) {

        return new Promise$1(function (resolve, reject) {
            var img = new Image();

            img.onerror = function (e) {
                return reject(e);
            };
            img.onload = function () {
                return resolve(img);
            };

            sizes && (img.sizes = sizes);
            srcset && (img.srcset = srcset);
            img.src = src;
        });
    }

    function copyXhr(source) {
        var target = {};
        for (var key in source) {
            target[key] = source[key];
        }
        return target;
    }

    function ready(fn) {

        if (document.readyState !== 'loading') {
            fn();
            return;
        }

        var unbind = on(document, 'DOMContentLoaded', function () {
            unbind();
            fn();
        });
    }

    function empty(element) {
        element = $(element);
        element.innerHTML = '';
        return element;
    }

    function html(parent, html) {
        parent = $(parent);
        return isUndefined(html) ? parent.innerHTML : append(parent.hasChildNodes() ? empty(parent) : parent, html);
    }

    function prepend(parent, element) {

        parent = $(parent);

        if (!parent.hasChildNodes()) {
            return append(parent, element);
        } else {
            return insertNodes(element, function (element) {
                return parent.insertBefore(element, parent.firstChild);
            });
        }
    }

    function append(parent, element) {
        parent = $(parent);
        return insertNodes(element, function (element) {
            return parent.appendChild(element);
        });
    }

    function before(ref, element) {
        ref = $(ref);
        return insertNodes(element, function (element) {
            return ref.parentNode.insertBefore(element, ref);
        });
    }

    function after(ref, element) {
        ref = $(ref);
        return insertNodes(element, function (element) {
            return ref.nextSibling ? before(ref.nextSibling, element) : append(ref.parentNode, element);
        });
    }

    function insertNodes(element, fn) {
        element = isString(element) ? fragment(element) : element;
        return element ? 'length' in element ? toNodes(element).map(fn) : fn(element) : null;
    }

    function remove$1(element) {
        toNodes(element).forEach(function (element) {
            return element.parentNode && element.parentNode.removeChild(element);
        });
    }

    function wrapAll(element, structure) {

        structure = toNode(before(element, structure));

        while (structure.firstChild) {
            structure = structure.firstChild;
        }

        append(structure, element);

        return structure;
    }

    function wrapInner(element, structure) {
        return toNodes(toNodes(element).map(function (element) {
            return element.hasChildNodes ? wrapAll(toNodes(element.childNodes), structure) : append(element, structure);
        }));
    }

    function unwrap(element) {
        toNodes(element).map(parent).filter(function (value, index, self) {
            return self.indexOf(value) === index;
        }).forEach(function (parent) {
            before(parent, parent.childNodes);
            remove$1(parent);
        });
    }

    var fragmentRe = /^\s*<(\w+|!)[^>]*>/;
    var singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;

    function fragment(html) {

        var matches = singleTagRe.exec(html);
        if (matches) {
            return document.createElement(matches[1]);
        }

        var container = document.createElement('div');
        if (fragmentRe.test(html)) {
            container.insertAdjacentHTML('beforeend', html.trim());
        } else {
            container.textContent = html;
        }

        return container.childNodes.length > 1 ? toNodes(container.childNodes) : container.firstChild;
    }

    function apply$1(node, fn) {

        if (!isElement(node)) {
            return;
        }

        fn(node);
        node = node.firstElementChild;
        while (node) {
            var next = node.nextElementSibling;
            apply$1(node, fn);
            node = next;
        }
    }

    function $(selector, context) {
        return isHtml(selector) ? toNode(fragment(selector)) : find(selector, context);
    }

    function $$(selector, context) {
        return isHtml(selector) ? toNodes(fragment(selector)) : findAll(selector, context);
    }

    function isHtml(str) {
        return isString(str) && (str[0] === '<' || str.match(/^\s*</));
    }

    function addClass(element) {
        var args = [],
            len = arguments.length - 1;
        while (len-- > 0) {
            args[len] = arguments[len + 1];
        }apply(element, args, 'add');
    }

    function removeClass(element) {
        var args = [],
            len = arguments.length - 1;
        while (len-- > 0) {
            args[len] = arguments[len + 1];
        }apply(element, args, 'remove');
    }

    function removeClasses(element, cls) {
        attr(element, 'class', function (value) {
            return (value || '').replace(new RegExp("\\b" + cls + "\\b", 'g'), '');
        });
    }

    function replaceClass(element) {
        var args = [],
            len = arguments.length - 1;
        while (len-- > 0) {
            args[len] = arguments[len + 1];
        }args[0] && removeClass(element, args[0]);
        args[1] && addClass(element, args[1]);
    }

    function hasClass(element, cls) {
        var assign;

        assign = getClasses(cls), cls = assign[0];
        var nodes = toNodes(element);
        for (var n = 0; n < nodes.length; n++) {
            if (cls && nodes[n].classList.contains(cls)) {
                return true;
            }
        }
        return false;
    }

    function toggleClass(element, cls, force) {

        cls = getClasses(cls);

        var nodes = toNodes(element);
        for (var n = 0; n < nodes.length; n++) {
            var list = nodes[n].classList;
            for (var i = 0; i < cls.length; i++) {
                if (isUndefined(force)) {
                    list.toggle(cls[i]);
                } else if (supports.Force) {
                    list.toggle(cls[i], !!force);
                } else {
                    list[force ? 'add' : 'remove'](cls[i]);
                }
            }
        }
    }

    function apply(element, args, fn) {
        var ref;

        args = args.reduce(function (args, arg) {
            return args.concat(getClasses(arg));
        }, []);

        var nodes = toNodes(element);
        var loop = function loop(n) {
            if (supports.Multiple) {
                (ref = nodes[n].classList)[fn].apply(ref, args);
            } else {
                args.forEach(function (cls) {
                    return nodes[n].classList[fn](cls);
                });
            }
        };

        for (var n = 0; n < nodes.length; n++) {
            loop(n);
        }
    }

    function getClasses(str) {
        return String(str).split(/\s|,/).filter(Boolean);
    }

    // IE 11
    var supports = {

        get Multiple() {
            return this.get('Multiple');
        },

        get Force() {
            return this.get('Force');
        },

        get: function get(key) {

            var ref = document.createElement('_');
            var classList = ref.classList;
            classList.add('a', 'b');
            classList.toggle('c', false);
            supports = {
                Multiple: classList.contains('b'),
                Force: !classList.contains('c')
            };

            return supports[key];
        }

    };

    var cssNumber = {
        'animation-iteration-count': true,
        'column-count': true,
        'fill-opacity': true,
        'flex-grow': true,
        'flex-shrink': true,
        'font-weight': true,
        'line-height': true,
        'opacity': true,
        'order': true,
        'orphans': true,
        'stroke-dasharray': true,
        'stroke-dashoffset': true,
        'widows': true,
        'z-index': true,
        'zoom': true
    };

    function css(element, property, value, priority) {
        if (priority === void 0) priority = '';

        return toNodes(element).map(function (element) {

            if (isString(property)) {

                property = propName(property);

                if (isUndefined(value)) {
                    return getStyle(element, property);
                } else if (!value && !isNumber(value)) {
                    element.style.removeProperty(property);
                } else {
                    element.style.setProperty(property, isNumeric(value) && !cssNumber[property] ? value + "px" : value, priority);
                }
            } else if (isArray(property)) {

                var styles = getStyles(element);

                return property.reduce(function (props, property) {
                    props[property] = styles[propName(property)];
                    return props;
                }, {});
            } else if (isObject(property)) {
                priority = value;
                each(property, function (value, property) {
                    return css(element, property, value, priority);
                });
            }

            return element;
        })[0];
    }

    function getStyles(element, pseudoElt) {
        return toWindow(element).getComputedStyle(element, pseudoElt);
    }

    function getStyle(element, property, pseudoElt) {
        return getStyles(element, pseudoElt)[property];
    }

    var parseCssVar = memoize(function (name) {
        /* usage in css: .uk-name:before { content:"xyz" } */

        var element = append(document.documentElement, fragment('<div>'));

        addClass(element, "uk-" + name);

        var value = getStyle(element, 'content', ':before');

        remove$1(element);

        return value;
    });

    var propertyRe = /^\s*(["'])?(.*?)\1\s*$/;
    function getCssVar(name) {
        return (isIE ? parseCssVar(name) : getStyles(document.documentElement).getPropertyValue("--uk-" + name)).replace(propertyRe, '$2');
    }

    // https://drafts.csswg.org/cssom/#dom-cssstyledeclaration-setproperty
    var propName = memoize(function (name) {
        return vendorPropName(name);
    });

    var cssPrefixes = ['webkit', 'moz', 'ms'];

    function vendorPropName(name) {

        name = hyphenate(name);

        var ref = document.documentElement;
        var style = ref.style;

        if (name in style) {
            return name;
        }

        var i = cssPrefixes.length,
            prefixedName;

        while (i--) {
            prefixedName = "-" + cssPrefixes[i] + "-" + name;
            if (prefixedName in style) {
                return prefixedName;
            }
        }
    }

    function transition(element, props, duration, timing) {
        if (duration === void 0) duration = 400;
        if (timing === void 0) timing = 'linear';

        return Promise$1.all(toNodes(element).map(function (element) {
            return new Promise$1(function (resolve, reject) {

                for (var name in props) {
                    var value = css(element, name);
                    if (value === '') {
                        css(element, name, value);
                    }
                }

                var timer = setTimeout(function () {
                    return trigger(element, 'transitionend');
                }, duration);

                once(element, 'transitionend transitioncanceled', function (ref) {
                    var type = ref.type;

                    clearTimeout(timer);
                    removeClass(element, 'uk-transition');
                    css(element, {
                        transitionProperty: '',
                        transitionDuration: '',
                        transitionTimingFunction: ''
                    });
                    type === 'transitioncanceled' ? reject() : resolve(element);
                }, { self: true });

                addClass(element, 'uk-transition');
                css(element, assign({
                    transitionProperty: Object.keys(props).map(propName).join(','),
                    transitionDuration: duration + "ms",
                    transitionTimingFunction: timing
                }, props));
            });
        }));
    }

    var Transition = {

        start: transition,

        stop: function stop(element) {
            trigger(element, 'transitionend');
            return Promise$1.resolve();
        },

        cancel: function cancel(element) {
            trigger(element, 'transitioncanceled');
        },

        inProgress: function inProgress(element) {
            return hasClass(element, 'uk-transition');
        }

    };

    var animationPrefix = 'uk-animation-';

    function animate$1(element, animation, duration, origin, out) {
        if (duration === void 0) duration = 200;

        return Promise$1.all(toNodes(element).map(function (element) {
            return new Promise$1(function (resolve, reject) {

                trigger(element, 'animationcanceled');
                var timer = setTimeout(function () {
                    return trigger(element, 'animationend');
                }, duration);

                once(element, 'animationend animationcanceled', function (ref) {
                    var type = ref.type;

                    clearTimeout(timer);

                    type === 'animationcanceled' ? reject() : resolve(element);

                    css(element, 'animationDuration', '');
                    removeClasses(element, animationPrefix + "\\S*");
                }, { self: true });

                css(element, 'animationDuration', duration + "ms");
                addClass(element, animation, animationPrefix + (out ? 'leave' : 'enter'));

                if (startsWith(animation, animationPrefix)) {
                    origin && addClass(element, "uk-transform-origin-" + origin);
                    out && addClass(element, animationPrefix + "reverse");
                }
            });
        }));
    }

    var _inProgress = new RegExp(animationPrefix + "(enter|leave)");
    var Animation = {

        in: animate$1,

        out: function out(element, animation, duration, origin) {
            return animate$1(element, animation, duration, origin, true);
        },

        inProgress: function inProgress(element) {
            return _inProgress.test(attr(element, 'class'));
        },

        cancel: function cancel(element) {
            trigger(element, 'animationcanceled');
        }

    };

    var dirs$1 = {
        width: ['left', 'right'],
        height: ['top', 'bottom']
    };

    function dimensions(element) {

        var rect = isElement(element) ? toNode(element).getBoundingClientRect() : { height: height(element), width: width(element), top: 0, left: 0 };

        return {
            height: rect.height,
            width: rect.width,
            top: rect.top,
            left: rect.left,
            bottom: rect.top + rect.height,
            right: rect.left + rect.width
        };
    }

    function offset(element, coordinates) {

        var currentOffset = dimensions(element);

        if (element) {
            var ref = toWindow(element);
            var pageYOffset = ref.pageYOffset;
            var pageXOffset = ref.pageXOffset;
            var offsetBy = { height: pageYOffset, width: pageXOffset };

            for (var dir in dirs$1) {
                for (var i in dirs$1[dir]) {
                    currentOffset[dirs$1[dir][i]] += offsetBy[dir];
                }
            }
        }

        if (!coordinates) {
            return currentOffset;
        }

        var pos = css(element, 'position');

        each(css(element, ['left', 'top']), function (value, prop) {
            return css(element, prop, coordinates[prop] - currentOffset[prop] + toFloat(pos === 'absolute' && value === 'auto' ? position(element)[prop] : value));
        });
    }

    function position(element) {

        var ref = offset(element);
        var top = ref.top;
        var left = ref.left;

        var ref$1 = toNode(element);
        var ref$1_ownerDocument = ref$1.ownerDocument;
        var body = ref$1_ownerDocument.body;
        var documentElement = ref$1_ownerDocument.documentElement;
        var offsetParent = ref$1.offsetParent;
        var parent = offsetParent || documentElement;

        while (parent && (parent === body || parent === documentElement) && css(parent, 'position') === 'static') {
            parent = parent.parentNode;
        }

        if (isElement(parent)) {
            var parentOffset = offset(parent);
            top -= parentOffset.top + toFloat(css(parent, 'borderTopWidth'));
            left -= parentOffset.left + toFloat(css(parent, 'borderLeftWidth'));
        }

        return {
            top: top - toFloat(css(element, 'marginTop')),
            left: left - toFloat(css(element, 'marginLeft'))
        };
    }

    function offsetPosition(element) {
        var offset = [0, 0];

        element = toNode(element);

        do {

            offset[0] += element.offsetTop;
            offset[1] += element.offsetLeft;

            if (css(element, 'position') === 'fixed') {
                var win = toWindow(element);
                offset[0] += win.pageYOffset;
                offset[1] += win.pageXOffset;
                return offset;
            }
        } while (element = element.offsetParent);

        return offset;
    }

    var height = dimension('height');
    var width = dimension('width');

    function dimension(prop) {
        var propName = ucfirst(prop);
        return function (element, value) {

            if (isUndefined(value)) {

                if (isWindow(element)) {
                    return element["inner" + propName];
                }

                if (isDocument(element)) {
                    var doc = element.documentElement;
                    return Math.max(doc["offset" + propName], doc["scroll" + propName]);
                }

                element = toNode(element);

                value = css(element, prop);
                value = value === 'auto' ? element["offset" + propName] : toFloat(value) || 0;

                return value - boxModelAdjust(element, prop);
            } else {

                return css(element, prop, !value && value !== 0 ? '' : +value + boxModelAdjust(element, prop) + 'px');
            }
        };
    }

    function boxModelAdjust(element, prop, sizing) {
        if (sizing === void 0) sizing = 'border-box';

        return css(element, 'boxSizing') === sizing ? dirs$1[prop].map(ucfirst).reduce(function (value, prop) {
            return value + toFloat(css(element, "padding" + prop)) + toFloat(css(element, "border" + prop + "Width"));
        }, 0) : 0;
    }

    function flipPosition(pos) {
        for (var dir in dirs$1) {
            for (var i in dirs$1[dir]) {
                if (dirs$1[dir][i] === pos) {
                    return dirs$1[dir][1 - i];
                }
            }
        }
        return pos;
    }

    function toPx(value, property, element) {
        if (property === void 0) property = 'width';
        if (element === void 0) element = window;

        return isNumeric(value) ? +value : endsWith(value, 'vh') ? percent(height(toWindow(element)), value) : endsWith(value, 'vw') ? percent(width(toWindow(element)), value) : endsWith(value, '%') ? percent(dimensions(element)[property], value) : toFloat(value);
    }

    function percent(base, value) {
        return base * toFloat(value) / 100;
    }

    /*
        Based on:
        Copyright (c) 2016 Wilson Page wilsonpage@me.com
        https://github.com/wilsonpage/fastdom
    */

    var fastdom = {

        reads: [],
        writes: [],

        read: function read(task) {
            this.reads.push(task);
            scheduleFlush();
            return task;
        },

        write: function write(task) {
            this.writes.push(task);
            scheduleFlush();
            return task;
        },

        clear: function clear(task) {
            remove(this.reads, task);
            remove(this.writes, task);
        },

        flush: flush

    };

    function flush(recursion) {
        if (recursion === void 0) recursion = 1;

        runTasks(fastdom.reads);
        runTasks(fastdom.writes.splice(0));

        fastdom.scheduled = false;

        if (fastdom.reads.length || fastdom.writes.length) {
            scheduleFlush(recursion + 1);
        }
    }

    var RECURSION_LIMIT = 4;
    function scheduleFlush(recursion) {

        if (fastdom.scheduled) {
            return;
        }

        fastdom.scheduled = true;
        if (recursion && recursion < RECURSION_LIMIT) {
            Promise$1.resolve().then(function () {
                return flush(recursion);
            });
        } else {
            requestAnimationFrame(function () {
                return flush();
            });
        }
    }

    function runTasks(tasks) {
        var task;
        while (task = tasks.shift()) {
            try {
                task();
            } catch (e) {
                console.error(e);
            }
        }
    }

    function remove(array, item) {
        var index = array.indexOf(item);
        return ~index && array.splice(index, 1);
    }

    function MouseTracker() {}

    MouseTracker.prototype = {

        positions: [],

        init: function init() {
            var this$1$1 = this;

            this.positions = [];

            var position;
            this.unbind = on(document, 'mousemove', function (e) {
                return position = getEventPos(e);
            });
            this.interval = setInterval(function () {

                if (!position) {
                    return;
                }

                this$1$1.positions.push(position);

                if (this$1$1.positions.length > 5) {
                    this$1$1.positions.shift();
                }
            }, 50);
        },

        cancel: function cancel() {
            this.unbind && this.unbind();
            this.interval && clearInterval(this.interval);
        },

        movesTo: function movesTo(target) {

            if (this.positions.length < 2) {
                return false;
            }

            var p = target.getBoundingClientRect();
            var left = p.left;
            var right = p.right;
            var top = p.top;
            var bottom = p.bottom;

            var ref = this.positions;
            var prevPosition = ref[0];
            var position = last(this.positions);
            var path = [prevPosition, position];

            if (pointInRect(position, p)) {
                return false;
            }

            var diagonals = [[{ x: left, y: top }, { x: right, y: bottom }], [{ x: left, y: bottom }, { x: right, y: top }]];

            return diagonals.some(function (diagonal) {
                var intersection = intersect(path, diagonal);
                return intersection && pointInRect(intersection, p);
            });
        }

    };

    // Inspired by http://paulbourke.net/geometry/pointlineplane/
    function intersect(ref, ref$1) {
        var ref_0 = ref[0];
        var x1 = ref_0.x;
        var y1 = ref_0.y;
        var ref_1 = ref[1];
        var x2 = ref_1.x;
        var y2 = ref_1.y;
        var ref$1_0 = ref$1[0];
        var x3 = ref$1_0.x;
        var y3 = ref$1_0.y;
        var ref$1_1 = ref$1[1];
        var x4 = ref$1_1.x;
        var y4 = ref$1_1.y;

        var denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);

        // Lines are parallel
        if (denominator === 0) {
            return false;
        }

        var ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;

        if (ua < 0) {
            return false;
        }

        // Return an object with the x and y coordinates of the intersection
        return { x: x1 + ua * (x2 - x1), y: y1 + ua * (y2 - y1) };
    }

    var strats = {};

    strats.events = strats.created = strats.beforeConnect = strats.connected = strats.beforeDisconnect = strats.disconnected = strats.destroy = concatStrat;

    // args strategy
    strats.args = function (parentVal, childVal) {
        return childVal !== false && concatStrat(childVal || parentVal);
    };

    // update strategy
    strats.update = function (parentVal, childVal) {
        return sortBy$1(concatStrat(parentVal, isFunction(childVal) ? { read: childVal } : childVal), 'order');
    };

    // property strategy
    strats.props = function (parentVal, childVal) {

        if (isArray(childVal)) {
            childVal = childVal.reduce(function (value, key) {
                value[key] = String;
                return value;
            }, {});
        }

        return strats.methods(parentVal, childVal);
    };

    // extend strategy
    strats.computed = strats.methods = function (parentVal, childVal) {
        return childVal ? parentVal ? assign({}, parentVal, childVal) : childVal : parentVal;
    };

    // data strategy
    strats.data = function (parentVal, childVal, vm) {

        if (!vm) {

            if (!childVal) {
                return parentVal;
            }

            if (!parentVal) {
                return childVal;
            }

            return function (vm) {
                return mergeFnData(parentVal, childVal, vm);
            };
        }

        return mergeFnData(parentVal, childVal, vm);
    };

    function mergeFnData(parentVal, childVal, vm) {
        return strats.computed(isFunction(parentVal) ? parentVal.call(vm, vm) : parentVal, isFunction(childVal) ? childVal.call(vm, vm) : childVal);
    }

    // concat strategy
    function concatStrat(parentVal, childVal) {

        parentVal = parentVal && !isArray(parentVal) ? [parentVal] : parentVal;

        return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
    }

    // default strategy
    function defaultStrat(parentVal, childVal) {
        return isUndefined(childVal) ? parentVal : childVal;
    }

    function mergeOptions(parent, child, vm) {

        var options = {};

        if (isFunction(child)) {
            child = child.options;
        }

        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }

        if (child.mixins) {
            for (var i = 0, l = child.mixins.length; i < l; i++) {
                parent = mergeOptions(parent, child.mixins[i], vm);
            }
        }

        for (var key in parent) {
            mergeKey(key);
        }

        for (var key$1 in child) {
            if (!hasOwn(parent, key$1)) {
                mergeKey(key$1);
            }
        }

        function mergeKey(key) {
            options[key] = (strats[key] || defaultStrat)(parent[key], child[key], vm);
        }

        return options;
    }

    function parseOptions(options, args) {
        var obj;

        if (args === void 0) args = [];

        try {

            return !options ? {} : startsWith(options, '{') ? JSON.parse(options) : args.length && !includes(options, ':') ? (obj = {}, obj[args[0]] = options, obj) : options.split(';').reduce(function (options, option) {
                var ref = option.split(/:(.*)/);
                var key = ref[0];
                var value = ref[1];
                if (key && !isUndefined(value)) {
                    options[key.trim()] = value.trim();
                }
                return options;
            }, {});
        } catch (e) {
            return {};
        }
    }

    function play(el) {

        if (isIFrame(el)) {
            call(el, { func: 'playVideo', method: 'play' });
        }

        if (isHTML5(el)) {
            try {
                el.play().catch(noop);
            } catch (e) {}
        }
    }

    function pause(el) {

        if (isIFrame(el)) {
            call(el, { func: 'pauseVideo', method: 'pause' });
        }

        if (isHTML5(el)) {
            el.pause();
        }
    }

    function mute(el) {

        if (isIFrame(el)) {
            call(el, { func: 'mute', method: 'setVolume', value: 0 });
        }

        if (isHTML5(el)) {
            el.muted = true;
        }
    }

    function isVideo(el) {
        return isHTML5(el) || isIFrame(el);
    }

    function isHTML5(el) {
        return el && el.tagName === 'VIDEO';
    }

    function isIFrame(el) {
        return el && el.tagName === 'IFRAME' && (isYoutube(el) || isVimeo(el));
    }

    function isYoutube(el) {
        return !!el.src.match(/\/\/.*?youtube(-nocookie)?\.[a-z]+\/(watch\?v=[^&\s]+|embed)|youtu\.be\/.*/);
    }

    function isVimeo(el) {
        return !!el.src.match(/vimeo\.com\/video\/.*/);
    }

    function call(el, cmd) {
        enableApi(el).then(function () {
            return post(el, cmd);
        });
    }

    function post(el, cmd) {
        try {
            el.contentWindow.postMessage(JSON.stringify(assign({ event: 'command' }, cmd)), '*');
        } catch (e) {}
    }

    var stateKey$1 = '_ukPlayer';
    var counter = 0;
    function enableApi(el) {

        if (el[stateKey$1]) {
            return el[stateKey$1];
        }

        var youtube = isYoutube(el);
        var vimeo = isVimeo(el);

        var id = ++counter;
        var poller;

        return el[stateKey$1] = new Promise$1(function (resolve) {

            youtube && once(el, 'load', function () {
                var listener = function listener() {
                    return post(el, { event: 'listening', id: id });
                };
                poller = setInterval(listener, 100);
                listener();
            });

            once(window, 'message', resolve, false, function (ref) {
                var data = ref.data;

                try {
                    data = JSON.parse(data);
                    return data && (youtube && data.id === id && data.event === 'onReady' || vimeo && Number(data.player_id) === id);
                } catch (e) {}
            });

            el.src = "" + el.src + (includes(el.src, '?') ? '&' : '?') + (youtube ? 'enablejsapi=1' : "api=1&player_id=" + id);
        }).then(function () {
            return clearInterval(poller);
        });
    }

    function isInView(element, offsetTop, offsetLeft) {
        if (offsetTop === void 0) offsetTop = 0;
        if (offsetLeft === void 0) offsetLeft = 0;

        if (!isVisible(element)) {
            return false;
        }

        return intersectRect.apply(void 0, scrollParents(element).map(function (parent) {

            var ref = offset(getViewport$1(parent));
            var top = ref.top;
            var left = ref.left;
            var bottom = ref.bottom;
            var right = ref.right;

            return {
                top: top - offsetTop,
                left: left - offsetLeft,
                bottom: bottom + offsetTop,
                right: right + offsetLeft
            };
        }).concat(offset(element)));
    }

    function scrollTop(element, top) {

        if (isWindow(element) || isDocument(element)) {
            element = getScrollingElement(element);
        } else {
            element = toNode(element);
        }

        element.scrollTop = top;
    }

    function scrollIntoView(element, ref) {
        if (ref === void 0) ref = {};
        var offsetBy = ref.offset;if (offsetBy === void 0) offsetBy = 0;

        var parents = isVisible(element) ? scrollParents(element) : [];
        return parents.reduce(function (fn, scrollElement, i) {

            var scrollTop = scrollElement.scrollTop;
            var scrollHeight = scrollElement.scrollHeight;
            var offsetHeight = scrollElement.offsetHeight;
            var maxScroll = scrollHeight - getViewportClientHeight(scrollElement);
            var ref = offset(parents[i - 1] || element);
            var elHeight = ref.height;
            var elTop = ref.top;

            var top = Math.ceil(elTop - offset(getViewport$1(scrollElement)).top - offsetBy + scrollTop);

            if (offsetBy > 0 && offsetHeight < elHeight + offsetBy) {
                top += offsetBy;
            } else {
                offsetBy = 0;
            }

            if (top > maxScroll) {
                offsetBy -= top - maxScroll;
                top = maxScroll;
            } else if (top < 0) {
                offsetBy -= top;
                top = 0;
            }

            return function () {
                return scrollTo(scrollElement, top - scrollTop).then(fn);
            };
        }, function () {
            return Promise$1.resolve();
        })();

        function scrollTo(element, top) {
            return new Promise$1(function (resolve) {

                var scroll = element.scrollTop;
                var duration = getDuration(Math.abs(top));
                var start = Date.now();

                (function step() {

                    var percent = ease(clamp((Date.now() - start) / duration));

                    scrollTop(element, scroll + top * percent);

                    // scroll more if we have not reached our destination
                    if (percent !== 1) {
                        requestAnimationFrame(step);
                    } else {
                        resolve();
                    }
                })();
            });
        }

        function getDuration(dist) {
            return 40 * Math.pow(dist, .375);
        }

        function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
    }

    function scrolledOver(element, heightOffset) {
        if (heightOffset === void 0) heightOffset = 0;

        if (!isVisible(element)) {
            return 0;
        }

        var ref = scrollParents(element, /auto|scroll/, true);
        var scrollElement = ref[0];
        var scrollHeight = scrollElement.scrollHeight;
        var scrollTop = scrollElement.scrollTop;
        var clientHeight = getViewportClientHeight(scrollElement);
        var viewportTop = offsetPosition(element)[0] - scrollTop - offsetPosition(scrollElement)[0];
        var viewportDist = Math.min(clientHeight, viewportTop + scrollTop);

        var top = viewportTop - viewportDist;
        var dist = Math.min(element.offsetHeight + heightOffset + viewportDist, scrollHeight - (viewportTop + scrollTop), scrollHeight - clientHeight);

        return clamp(-1 * top / dist);
    }

    function scrollParents(element, overflowRe, scrollable) {
        if (overflowRe === void 0) overflowRe = /auto|scroll|hidden/;
        if (scrollable === void 0) scrollable = false;

        var scrollEl = getScrollingElement(element);

        var ancestors = parents(element).reverse();
        ancestors = ancestors.slice(ancestors.indexOf(scrollEl) + 1);

        var fixedIndex = findIndex(ancestors, function (el) {
            return css(el, 'position') === 'fixed';
        });
        if (~fixedIndex) {
            ancestors = ancestors.slice(fixedIndex);
        }

        return [scrollEl].concat(ancestors.filter(function (parent) {
            return overflowRe.test(css(parent, 'overflow')) && (!scrollable || parent.scrollHeight > getViewportClientHeight(parent));
        })).reverse();
    }

    function getViewport$1(scrollElement) {
        return scrollElement === getScrollingElement(scrollElement) ? window : scrollElement;
    }

    // iOS 12 returns <body> as scrollingElement
    function getViewportClientHeight(scrollElement) {
        return (scrollElement === getScrollingElement(scrollElement) ? document.documentElement : scrollElement).clientHeight;
    }

    function getScrollingElement(element) {
        var ref = toWindow(element);
        var document = ref.document;
        return document.scrollingElement || document.documentElement;
    }

    var dirs = {
        width: ['x', 'left', 'right'],
        height: ['y', 'top', 'bottom']
    };

    function _positionAt(element, target, elAttach, targetAttach, elOffset, targetOffset, flip, boundary) {

        elAttach = getPos(elAttach);
        targetAttach = getPos(targetAttach);

        var flipped = { element: elAttach, target: targetAttach };

        if (!element || !target) {
            return flipped;
        }

        var dim = offset(element);
        var targetDim = offset(target);
        var position = targetDim;

        moveTo(position, elAttach, dim, -1);
        moveTo(position, targetAttach, targetDim, 1);

        elOffset = getOffsets(elOffset, dim.width, dim.height);
        targetOffset = getOffsets(targetOffset, targetDim.width, targetDim.height);

        elOffset['x'] += targetOffset['x'];
        elOffset['y'] += targetOffset['y'];

        position.left += elOffset['x'];
        position.top += elOffset['y'];

        if (flip) {

            var boundaries = scrollParents(element).map(getViewport$1);

            if (boundary && !includes(boundaries, boundary)) {
                boundaries.unshift(boundary);
            }

            boundaries = boundaries.map(function (el) {
                return offset(el);
            });

            each(dirs, function (ref, prop) {
                var dir = ref[0];
                var align = ref[1];
                var alignFlip = ref[2];

                if (!(flip === true || includes(flip, dir))) {
                    return;
                }

                boundaries.some(function (boundary) {

                    var elemOffset = elAttach[dir] === align ? -dim[prop] : elAttach[dir] === alignFlip ? dim[prop] : 0;

                    var targetOffset = targetAttach[dir] === align ? targetDim[prop] : targetAttach[dir] === alignFlip ? -targetDim[prop] : 0;

                    if (position[align] < boundary[align] || position[align] + dim[prop] > boundary[alignFlip]) {

                        var centerOffset = dim[prop] / 2;
                        var centerTargetOffset = targetAttach[dir] === 'center' ? -targetDim[prop] / 2 : 0;

                        return elAttach[dir] === 'center' && (apply(centerOffset, centerTargetOffset) || apply(-centerOffset, -centerTargetOffset)) || apply(elemOffset, targetOffset);
                    }

                    function apply(elemOffset, targetOffset) {

                        var newVal = toFloat((position[align] + elemOffset + targetOffset - elOffset[dir] * 2).toFixed(4));

                        if (newVal >= boundary[align] && newVal + dim[prop] <= boundary[alignFlip]) {
                            position[align] = newVal;

                            ['element', 'target'].forEach(function (el) {
                                flipped[el][dir] = !elemOffset ? flipped[el][dir] : flipped[el][dir] === dirs[prop][1] ? dirs[prop][2] : dirs[prop][1];
                            });

                            return true;
                        }
                    }
                });
            });
        }

        offset(element, position);

        return flipped;
    }

    function moveTo(position, attach, dim, factor) {
        each(dirs, function (ref, prop) {
            var dir = ref[0];
            var align = ref[1];
            var alignFlip = ref[2];

            if (attach[dir] === alignFlip) {
                position[align] += dim[prop] * factor;
            } else if (attach[dir] === 'center') {
                position[align] += dim[prop] * factor / 2;
            }
        });
    }

    function getPos(pos) {

        var x = /left|center|right/;
        var y = /top|center|bottom/;

        pos = (pos || '').split(' ');

        if (pos.length === 1) {
            pos = x.test(pos[0]) ? pos.concat('center') : y.test(pos[0]) ? ['center'].concat(pos) : ['center', 'center'];
        }

        return {
            x: x.test(pos[0]) ? pos[0] : 'center',
            y: y.test(pos[1]) ? pos[1] : 'center'
        };
    }

    function getOffsets(offsets, width, height) {

        var ref = (offsets || '').split(' ');
        var x = ref[0];
        var y = ref[1];

        return {
            x: x ? toFloat(x) * (endsWith(x, '%') ? width / 100 : 1) : 0,
            y: y ? toFloat(y) * (endsWith(y, '%') ? height / 100 : 1) : 0
        };
    }

    var util = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ajax: ajax,
        getImage: getImage,
        transition: transition,
        Transition: Transition,
        animate: animate$1,
        Animation: Animation,
        attr: attr,
        hasAttr: hasAttr,
        removeAttr: removeAttr,
        data: data,
        addClass: addClass,
        removeClass: removeClass,
        removeClasses: removeClasses,
        replaceClass: replaceClass,
        hasClass: hasClass,
        toggleClass: toggleClass,
        dimensions: dimensions,
        offset: offset,
        position: position,
        offsetPosition: offsetPosition,
        height: height,
        width: width,
        boxModelAdjust: boxModelAdjust,
        flipPosition: flipPosition,
        toPx: toPx,
        ready: ready,
        empty: empty,
        html: html,
        prepend: prepend,
        append: append,
        before: before,
        after: after,
        remove: remove$1,
        wrapAll: wrapAll,
        wrapInner: wrapInner,
        unwrap: unwrap,
        fragment: fragment,
        apply: apply$1,
        $: $,
        $$: $$,
        inBrowser: inBrowser,
        isIE: isIE,
        isRtl: isRtl,
        hasTouch: hasTouch,
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        pointerEnter: pointerEnter,
        pointerLeave: pointerLeave,
        pointerCancel: pointerCancel,
        on: on,
        off: off,
        once: once,
        trigger: trigger,
        createEvent: createEvent,
        toEventTargets: toEventTargets,
        isTouch: isTouch,
        getEventPos: getEventPos,
        fastdom: fastdom,
        isVoidElement: isVoidElement,
        isVisible: isVisible,
        selInput: selInput,
        isInput: isInput,
        selFocusable: selFocusable,
        isFocusable: isFocusable,
        parent: parent,
        filter: filter$1,
        matches: matches,
        closest: closest,
        within: within,
        parents: parents,
        children: _children,
        index: index,
        hasOwn: hasOwn,
        hyphenate: hyphenate,
        camelize: camelize,
        ucfirst: ucfirst,
        startsWith: startsWith,
        endsWith: endsWith,
        includes: includes,
        findIndex: findIndex,
        isArray: isArray,
        isFunction: isFunction,
        isObject: isObject,
        isPlainObject: isPlainObject,
        isWindow: isWindow,
        isDocument: isDocument,
        isNode: isNode,
        isElement: isElement,
        isBoolean: isBoolean,
        isString: isString,
        isNumber: isNumber,
        isNumeric: isNumeric,
        isEmpty: isEmpty,
        isUndefined: isUndefined,
        toBoolean: toBoolean,
        toNumber: toNumber,
        toFloat: toFloat,
        toArray: toArray,
        toNode: toNode,
        toNodes: toNodes,
        toWindow: toWindow,
        toMs: toMs,
        isEqual: isEqual,
        swap: swap,
        assign: assign,
        last: last,
        each: each,
        sortBy: sortBy$1,
        uniqueBy: uniqueBy,
        clamp: clamp,
        noop: noop,
        intersectRect: intersectRect,
        pointInRect: pointInRect,
        Dimensions: Dimensions,
        getIndex: _getIndex,
        memoize: memoize,
        MouseTracker: MouseTracker,
        mergeOptions: mergeOptions,
        parseOptions: parseOptions,
        play: play,
        pause: pause,
        mute: mute,
        isVideo: isVideo,
        positionAt: _positionAt,
        Promise: Promise$1,
        Deferred: Deferred,
        query: query,
        queryAll: queryAll,
        find: find,
        findAll: findAll,
        escape: escape,
        css: css,
        getCssVar: getCssVar,
        propName: propName,
        isInView: isInView,
        scrollTop: scrollTop,
        scrollIntoView: scrollIntoView,
        scrolledOver: scrolledOver,
        scrollParents: scrollParents,
        getViewport: getViewport$1,
        getViewportClientHeight: getViewportClientHeight
    });

    function globalAPI(UIkit) {

        var DATA = UIkit.data;

        UIkit.use = function (plugin) {

            if (plugin.installed) {
                return;
            }

            plugin.call(null, this);
            plugin.installed = true;

            return this;
        };

        UIkit.mixin = function (mixin, component) {
            component = (isString(component) ? UIkit.component(component) : component) || this;
            component.options = mergeOptions(component.options, mixin);
        };

        UIkit.extend = function (options) {

            options = options || {};

            var Super = this;
            var Sub = function UIkitComponent(options) {
                this._init(options);
            };

            Sub.prototype = Object.create(Super.prototype);
            Sub.prototype.constructor = Sub;
            Sub.options = mergeOptions(Super.options, options);

            Sub.super = Super;
            Sub.extend = Super.extend;

            return Sub;
        };

        UIkit.update = function (element, e) {

            element = element ? toNode(element) : document.body;

            parents(element).reverse().forEach(function (element) {
                return update(element[DATA], e);
            });
            apply$1(element, function (element) {
                return update(element[DATA], e);
            });
        };

        var container;
        Object.defineProperty(UIkit, 'container', {

            get: function get() {
                return container || document.body;
            },

            set: function set(element) {
                container = $(element);
            }

        });

        function update(data, e) {

            if (!data) {
                return;
            }

            for (var name in data) {
                if (data[name]._connected) {
                    data[name]._callUpdate(e);
                }
            }
        }
    }

    function hooksAPI(UIkit) {

        UIkit.prototype._callHook = function (hook) {
            var this$1$1 = this;

            var handlers = this.$options[hook];

            if (handlers) {
                handlers.forEach(function (handler) {
                    return handler.call(this$1$1);
                });
            }
        };

        UIkit.prototype._callConnected = function () {

            if (this._connected) {
                return;
            }

            this._data = {};
            this._computeds = {};

            this._initProps();

            this._callHook('beforeConnect');
            this._connected = true;

            this._initEvents();
            this._initObservers();

            this._callHook('connected');
            this._callUpdate();
        };

        UIkit.prototype._callDisconnected = function () {

            if (!this._connected) {
                return;
            }

            this._callHook('beforeDisconnect');
            this._disconnectObservers();
            this._unbindEvents();
            this._callHook('disconnected');

            this._connected = false;
            delete this._watch;
        };

        UIkit.prototype._callUpdate = function (e) {
            var this$1$1 = this;
            if (e === void 0) e = 'update';

            if (!this._connected) {
                return;
            }

            if (e === 'update' || e === 'resize') {
                this._callWatches();
            }

            if (!this.$options.update) {
                return;
            }

            if (!this._updates) {
                this._updates = new Set();
                fastdom.read(function () {
                    if (this$1$1._connected) {
                        runUpdates.call(this$1$1, this$1$1._updates);
                    }
                    delete this$1$1._updates;
                });
            }

            this._updates.add(e.type || e);
        };

        UIkit.prototype._callWatches = function () {
            var this$1$1 = this;

            if (this._watch) {
                return;
            }

            var initial = !hasOwn(this, '_watch');

            this._watch = fastdom.read(function () {
                if (this$1$1._connected) {
                    runWatches.call(this$1$1, initial);
                }
                this$1$1._watch = null;
            });
        };

        function runUpdates(types) {
            var this$1$1 = this;

            var updates = this.$options.update;

            var loop = function loop(i) {
                var ref = updates[i];
                var read = ref.read;
                var write = ref.write;
                var events = ref.events;

                if (!types.has('update') && (!events || !events.some(function (type) {
                    return types.has(type);
                }))) {
                    return;
                }

                var result = void 0;
                if (read) {

                    result = read.call(this$1$1, this$1$1._data, types);

                    if (result && isPlainObject(result)) {
                        assign(this$1$1._data, result);
                    }
                }

                if (write && result !== false) {
                    fastdom.write(function () {
                        return write.call(this$1$1, this$1$1._data, types);
                    });
                }
            };

            for (var i = 0; i < updates.length; i++) {
                loop(i);
            }
        }

        function runWatches(initial) {

            var ref = this;
            var computed = ref.$options.computed;
            var _computeds = ref._computeds;

            for (var key in computed) {

                var hasPrev = hasOwn(_computeds, key);
                var prev = _computeds[key];

                delete _computeds[key];

                var ref$1 = computed[key];
                var watch = ref$1.watch;
                var immediate = ref$1.immediate;
                if (watch && (initial && immediate || hasPrev && !isEqual(prev, this[key]))) {
                    watch.call(this, this[key], prev);
                }
            }
        }
    }

    function stateAPI(UIkit) {

        var uid = 0;

        UIkit.prototype._init = function (options) {

            options = options || {};
            options.data = normalizeData(options, this.constructor.options);

            this.$options = mergeOptions(this.constructor.options, options, this);
            this.$el = null;
            this.$props = {};

            this._uid = uid++;
            this._initData();
            this._initMethods();
            this._initComputeds();
            this._callHook('created');

            if (options.el) {
                this.$mount(options.el);
            }
        };

        UIkit.prototype._initData = function () {

            var ref = this.$options;
            var data = ref.data;if (data === void 0) data = {};

            for (var key in data) {
                this.$props[key] = this[key] = data[key];
            }
        };

        UIkit.prototype._initMethods = function () {

            var ref = this.$options;
            var methods = ref.methods;

            if (methods) {
                for (var key in methods) {
                    this[key] = methods[key].bind(this);
                }
            }
        };

        UIkit.prototype._initComputeds = function () {

            var ref = this.$options;
            var computed = ref.computed;

            this._computeds = {};

            if (computed) {
                for (var key in computed) {
                    registerComputed(this, key, computed[key]);
                }
            }
        };

        UIkit.prototype._initProps = function (props) {

            var key;

            props = props || getProps(this.$options, this.$name);

            for (key in props) {
                if (!isUndefined(props[key])) {
                    this.$props[key] = props[key];
                }
            }

            var exclude = [this.$options.computed, this.$options.methods];
            for (key in this.$props) {
                if (key in props && notIn(exclude, key)) {
                    this[key] = this.$props[key];
                }
            }
        };

        UIkit.prototype._initEvents = function () {
            var this$1$1 = this;

            this._events = [];

            var ref = this.$options;
            var events = ref.events;

            if (events) {

                events.forEach(function (event) {

                    if (!hasOwn(event, 'handler')) {
                        for (var key in event) {
                            registerEvent(this$1$1, event[key], key);
                        }
                    } else {
                        registerEvent(this$1$1, event);
                    }
                });
            }
        };

        UIkit.prototype._unbindEvents = function () {
            this._events.forEach(function (unbind) {
                return unbind();
            });
            delete this._events;
        };

        UIkit.prototype._initObservers = function () {
            this._observers = [initChildListObserver(this), initPropsObserver(this)];
        };

        UIkit.prototype._disconnectObservers = function () {
            this._observers.forEach(function (observer) {
                return observer && observer.disconnect();
            });
        };

        function getProps(opts, name) {

            var data$1 = {};
            var args = opts.args;if (args === void 0) args = [];
            var props = opts.props;if (props === void 0) props = {};
            var el = opts.el;

            if (!props) {
                return data$1;
            }

            for (var key in props) {
                var prop = hyphenate(key);
                var value = data(el, prop);

                if (isUndefined(value)) {
                    continue;
                }

                value = props[key] === Boolean && value === '' ? true : coerce(props[key], value);

                if (prop === 'target' && (!value || startsWith(value, '_'))) {
                    continue;
                }

                data$1[key] = value;
            }

            var options = parseOptions(data(el, name), args);

            for (var key$1 in options) {
                var prop$1 = camelize(key$1);
                if (props[prop$1] !== undefined) {
                    data$1[prop$1] = coerce(props[prop$1], options[key$1]);
                }
            }

            return data$1;
        }

        function registerComputed(component, key, cb) {
            Object.defineProperty(component, key, {

                enumerable: true,

                get: function get() {

                    var _computeds = component._computeds;
                    var $props = component.$props;
                    var $el = component.$el;

                    if (!hasOwn(_computeds, key)) {
                        _computeds[key] = (cb.get || cb).call(component, $props, $el);
                    }

                    return _computeds[key];
                },

                set: function set(value) {

                    var _computeds = component._computeds;

                    _computeds[key] = cb.set ? cb.set.call(component, value) : value;

                    if (isUndefined(_computeds[key])) {
                        delete _computeds[key];
                    }
                }

            });
        }

        function registerEvent(component, event, key) {

            if (!isPlainObject(event)) {
                event = { name: key, handler: event };
            }

            var name = event.name;
            var el = event.el;
            var handler = event.handler;
            var capture = event.capture;
            var passive = event.passive;
            var delegate = event.delegate;
            var filter = event.filter;
            var self = event.self;
            el = isFunction(el) ? el.call(component) : el || component.$el;

            if (isArray(el)) {
                el.forEach(function (el) {
                    return registerEvent(component, assign({}, event, { el: el }), key);
                });
                return;
            }

            if (!el || filter && !filter.call(component)) {
                return;
            }

            component._events.push(on(el, name, !delegate ? null : isString(delegate) ? delegate : delegate.call(component), isString(handler) ? component[handler] : handler.bind(component), { passive: passive, capture: capture, self: self }));
        }

        function notIn(options, key) {
            return options.every(function (arr) {
                return !arr || !hasOwn(arr, key);
            });
        }

        function coerce(type, value) {

            if (type === Boolean) {
                return toBoolean(value);
            } else if (type === Number) {
                return toNumber(value);
            } else if (type === 'list') {
                return toList(value);
            }

            return type ? type(value) : value;
        }

        function toList(value) {
            return isArray(value) ? value : isString(value) ? value.split(/,(?![^(]*\))/).map(function (value) {
                return isNumeric(value) ? toNumber(value) : toBoolean(value.trim());
            }) : [value];
        }

        function normalizeData(ref, ref$1) {
            var data = ref.data;
            var args = ref$1.args;
            var props = ref$1.props;if (props === void 0) props = {};

            data = isArray(data) ? !isEmpty(args) ? data.slice(0, args.length).reduce(function (data, value, index) {
                if (isPlainObject(value)) {
                    assign(data, value);
                } else {
                    data[args[index]] = value;
                }
                return data;
            }, {}) : undefined : data;

            if (data) {
                for (var key in data) {
                    if (isUndefined(data[key])) {
                        delete data[key];
                    } else {
                        data[key] = props[key] ? coerce(props[key], data[key]) : data[key];
                    }
                }
            }

            return data;
        }

        function initChildListObserver(component) {
            var ref = component.$options;
            var el = ref.el;

            var observer = new MutationObserver(function () {
                return component.$emit();
            });
            observer.observe(el, {
                childList: true,
                subtree: true
            });

            return observer;
        }

        function initPropsObserver(component) {

            var $name = component.$name;
            var $options = component.$options;
            var $props = component.$props;
            var attrs = $options.attrs;
            var props = $options.props;
            var el = $options.el;

            if (!props || attrs === false) {
                return;
            }

            var attributes = isArray(attrs) ? attrs : Object.keys(props);
            var filter = attributes.map(function (key) {
                return hyphenate(key);
            }).concat($name);

            var observer = new MutationObserver(function (records) {
                var data = getProps($options, $name);
                if (records.some(function (ref) {
                    var attributeName = ref.attributeName;

                    var prop = attributeName.replace('data-', '');
                    return (prop === $name ? attributes : [camelize(prop), camelize(attributeName)]).some(function (prop) {
                        return !isUndefined(data[prop]) && data[prop] !== $props[prop];
                    });
                })) {
                    component.$reset();
                }
            });

            observer.observe(el, {
                attributes: true,
                attributeFilter: filter.concat(filter.map(function (key) {
                    return "data-" + key;
                }))
            });

            return observer;
        }
    }

    function instanceAPI(UIkit) {

        var DATA = UIkit.data;

        UIkit.prototype.$create = function (component, element, data) {
            return UIkit[component](element, data);
        };

        UIkit.prototype.$mount = function (el) {

            var ref = this.$options;
            var name = ref.name;

            if (!el[DATA]) {
                el[DATA] = {};
            }

            if (el[DATA][name]) {
                return;
            }

            el[DATA][name] = this;

            this.$el = this.$options.el = this.$options.el || el;

            if (within(el, document)) {
                this._callConnected();
            }
        };

        UIkit.prototype.$reset = function () {
            this._callDisconnected();
            this._callConnected();
        };

        UIkit.prototype.$destroy = function (removeEl) {
            if (removeEl === void 0) removeEl = false;

            var ref = this.$options;
            var el = ref.el;
            var name = ref.name;

            if (el) {
                this._callDisconnected();
            }

            this._callHook('destroy');

            if (!el || !el[DATA]) {
                return;
            }

            delete el[DATA][name];

            if (!isEmpty(el[DATA])) {
                delete el[DATA];
            }

            if (removeEl) {
                remove$1(this.$el);
            }
        };

        UIkit.prototype.$emit = function (e) {
            this._callUpdate(e);
        };

        UIkit.prototype.$update = function (element, e) {
            if (element === void 0) element = this.$el;

            UIkit.update(element, e);
        };

        UIkit.prototype.$getComponent = UIkit.getComponent;

        var componentName = memoize(function (name) {
            return UIkit.prefix + hyphenate(name);
        });
        Object.defineProperties(UIkit.prototype, {

            $container: Object.getOwnPropertyDescriptor(UIkit, 'container'),

            $name: {

                get: function get() {
                    return componentName(this.$options.name);
                }

            }

        });
    }

    function componentAPI(UIkit) {

        var DATA = UIkit.data;

        var components = {};

        UIkit.component = function (name, options) {

            var id = hyphenate(name);

            name = camelize(id);

            if (!options) {

                if (isPlainObject(components[name])) {
                    components[name] = UIkit.extend(components[name]);
                }

                return components[name];
            }

            UIkit[name] = function (element, data) {
                var i = arguments.length,
                    argsArray = Array(i);
                while (i--) {
                    argsArray[i] = arguments[i];
                }var component = UIkit.component(name);

                return component.options.functional ? new component({ data: isPlainObject(element) ? element : [].concat(argsArray) }) : !element ? init(element) : $$(element).map(init)[0];

                function init(element) {

                    var instance = UIkit.getComponent(element, name);

                    if (instance) {
                        if (!data) {
                            return instance;
                        } else {
                            instance.$destroy();
                        }
                    }

                    return new component({ el: element, data: data });
                }
            };

            var opt = isPlainObject(options) ? assign({}, options) : options.options;

            opt.name = name;

            if (opt.install) {
                opt.install(UIkit, opt, name);
            }

            if (UIkit._initialized && !opt.functional) {
                fastdom.read(function () {
                    return UIkit[name]("[uk-" + id + "],[data-uk-" + id + "]");
                });
            }

            return components[name] = isPlainObject(options) ? opt : options;
        };

        UIkit.getComponents = function (element) {
            return element && element[DATA] || {};
        };
        UIkit.getComponent = function (element, name) {
            return UIkit.getComponents(element)[name];
        };

        UIkit.connect = function (node) {

            if (node[DATA]) {
                for (var name in node[DATA]) {
                    node[DATA][name]._callConnected();
                }
            }

            for (var i = 0; i < node.attributes.length; i++) {

                var name$1 = getComponentName(node.attributes[i].name);

                if (name$1 && name$1 in components) {
                    UIkit[name$1](node);
                }
            }
        };

        UIkit.disconnect = function (node) {
            for (var name in node[DATA]) {
                node[DATA][name]._callDisconnected();
            }
        };
    }

    var getComponentName = memoize(function (attribute) {
        return startsWith(attribute, 'uk-') || startsWith(attribute, 'data-uk-') ? camelize(attribute.replace('data-uk-', '').replace('uk-', '')) : false;
    });

    var UIkit = function UIkit(options) {
        this._init(options);
    };

    UIkit.util = util;
    UIkit.data = '__uikit__';
    UIkit.prefix = 'uk-';
    UIkit.options = {};
    UIkit.version = '3.9.4';

    globalAPI(UIkit);
    hooksAPI(UIkit);
    stateAPI(UIkit);
    componentAPI(UIkit);
    instanceAPI(UIkit);

    function Core(UIkit) {

        if (!inBrowser) {
            return;
        }

        // throttle 'resize'
        var pendingResize;
        var handleResize = function handleResize() {
            if (pendingResize) {
                return;
            }
            pendingResize = true;
            fastdom.write(function () {
                return pendingResize = false;
            });
            UIkit.update(null, 'resize');
        };

        on(window, 'load resize', handleResize);
        on(document, 'loadedmetadata load', handleResize, true);

        if ('ResizeObserver' in window) {
            new ResizeObserver(handleResize).observe(document.documentElement);
        }

        // throttle `scroll` event (Safari triggers multiple `scroll` events per frame)
        var pending;
        on(window, 'scroll', function (e) {

            if (pending) {
                return;
            }
            pending = true;
            fastdom.write(function () {
                return pending = false;
            });

            UIkit.update(null, e.type);
        }, { passive: true, capture: true });

        var started = 0;
        on(document, 'animationstart', function (ref) {
            var target = ref.target;

            if ((css(target, 'animationName') || '').match(/^uk-.*(left|right)/)) {

                started++;
                css(document.documentElement, 'overflowX', 'hidden');
                setTimeout(function () {
                    if (! --started) {
                        css(document.documentElement, 'overflowX', '');
                    }
                }, toMs(css(target, 'animationDuration')) + 100);
            }
        }, true);

        on(document, pointerDown, function (e) {

            if (!isTouch(e)) {
                return;
            }

            // Handle Swipe Gesture
            var pos = getEventPos(e);
            var target = 'tagName' in e.target ? e.target : parent(e.target);
            once(document, pointerUp + " " + pointerCancel + " scroll", function (e) {

                var ref = getEventPos(e);
                var x = ref.x;
                var y = ref.y;

                // swipe
                if (e.type !== 'scroll' && target && x && Math.abs(pos.x - x) > 100 || y && Math.abs(pos.y - y) > 100) {

                    setTimeout(function () {
                        trigger(target, 'swipe');
                        trigger(target, "swipe" + swipeDirection(pos.x, pos.y, x, y));
                    });
                }
            });
        }, { passive: true });
    }

    function swipeDirection(x1, y1, x2, y2) {
        return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? x1 - x2 > 0 ? 'Left' : 'Right' : y1 - y2 > 0 ? 'Up' : 'Down';
    }

    function boot(UIkit) {

        var connect = UIkit.connect;
        var disconnect = UIkit.disconnect;

        if (!inBrowser || !window.MutationObserver) {
            return;
        }

        fastdom.read(function () {

            if (document.body) {
                apply$1(document.body, connect);
            }

            new MutationObserver(function (records) {
                return records.forEach(applyChildListMutation);
            }).observe(document, {
                childList: true,
                subtree: true
            });

            new MutationObserver(function (records) {
                return records.forEach(applyAttributeMutation);
            }).observe(document, {
                attributes: true,
                subtree: true
            });

            UIkit._initialized = true;
        });

        function applyChildListMutation(ref) {
            var addedNodes = ref.addedNodes;
            var removedNodes = ref.removedNodes;

            for (var i = 0; i < addedNodes.length; i++) {
                apply$1(addedNodes[i], connect);
            }

            for (var i$1 = 0; i$1 < removedNodes.length; i$1++) {
                apply$1(removedNodes[i$1], disconnect);
            }
        }

        function applyAttributeMutation(ref) {
            var target = ref.target;
            var attributeName = ref.attributeName;

            var name = getComponentName(attributeName);

            if (!name || !(name in UIkit)) {
                return;
            }

            if (hasAttr(target, attributeName)) {
                UIkit[name](target);
                return;
            }

            var component = UIkit.getComponent(target, name);

            if (component) {
                component.$destroy();
            }
        }
    }

    var Class = {

        connected: function connected() {
            !hasClass(this.$el, this.$name) && addClass(this.$el, this.$name);
        }

    };

    var Togglable = {

        props: {
            cls: Boolean,
            animation: 'list',
            duration: Number,
            origin: String,
            transition: String
        },

        data: {
            cls: false,
            animation: [false],
            duration: 200,
            origin: false,
            transition: 'linear',
            clsEnter: 'uk-togglabe-enter',
            clsLeave: 'uk-togglabe-leave',

            initProps: {
                overflow: '',
                height: '',
                paddingTop: '',
                paddingBottom: '',
                marginTop: '',
                marginBottom: ''
            },

            hideProps: {
                overflow: 'hidden',
                height: 0,
                paddingTop: 0,
                paddingBottom: 0,
                marginTop: 0,
                marginBottom: 0
            }

        },

        computed: {

            hasAnimation: function hasAnimation(ref) {
                var animation = ref.animation;

                return !!animation[0];
            },

            hasTransition: function hasTransition(ref) {
                var animation = ref.animation;

                return this.hasAnimation && animation[0] === true;
            }

        },

        methods: {

            toggleElement: function toggleElement(targets, toggle, animate) {
                var this$1$1 = this;

                return new Promise$1(function (resolve) {
                    return Promise$1.all(toNodes(targets).map(function (el) {

                        var show = isBoolean(toggle) ? toggle : !this$1$1.isToggled(el);

                        if (!trigger(el, "before" + (show ? 'show' : 'hide'), [this$1$1])) {
                            return Promise$1.reject();
                        }

                        var promise = (isFunction(animate) ? animate : animate === false || !this$1$1.hasAnimation ? this$1$1._toggle : this$1$1.hasTransition ? toggleHeight(this$1$1) : toggleAnimation(this$1$1))(el, show);

                        var cls = show ? this$1$1.clsEnter : this$1$1.clsLeave;

                        addClass(el, cls);

                        trigger(el, show ? 'show' : 'hide', [this$1$1]);

                        var done = function done() {
                            removeClass(el, cls);
                            trigger(el, show ? 'shown' : 'hidden', [this$1$1]);
                            this$1$1.$update(el);
                        };

                        return promise ? promise.then(done, function () {
                            removeClass(el, cls);
                            return Promise$1.reject();
                        }) : done();
                    })).then(resolve, noop);
                });
            },

            isToggled: function isToggled(el) {
                var assign;

                if (el === void 0) el = this.$el;
                assign = toNodes(el), el = assign[0];
                return hasClass(el, this.clsEnter) ? true : hasClass(el, this.clsLeave) ? false : this.cls ? hasClass(el, this.cls.split(' ')[0]) : isVisible(el);
            },

            _toggle: function _toggle(el, toggled) {

                if (!el) {
                    return;
                }

                toggled = Boolean(toggled);

                var changed;
                if (this.cls) {
                    changed = includes(this.cls, ' ') || toggled !== hasClass(el, this.cls);
                    changed && toggleClass(el, this.cls, includes(this.cls, ' ') ? undefined : toggled);
                } else {
                    changed = toggled === el.hidden;
                    changed && (el.hidden = !toggled);
                }

                $$('[autofocus]', el).some(function (el) {
                    return isVisible(el) ? el.focus() || true : el.blur();
                });

                if (changed) {
                    trigger(el, 'toggled', [toggled, this]);
                    this.$update(el);
                }
            }

        }

    };

    function toggleHeight(ref) {
        var isToggled = ref.isToggled;
        var duration = ref.duration;
        var initProps = ref.initProps;
        var hideProps = ref.hideProps;
        var transition = ref.transition;
        var _toggle = ref._toggle;

        return function (el, show) {

            var inProgress = Transition.inProgress(el);
            var inner = el.hasChildNodes ? toFloat(css(el.firstElementChild, 'marginTop')) + toFloat(css(el.lastElementChild, 'marginBottom')) : 0;
            var currentHeight = isVisible(el) ? height(el) + (inProgress ? 0 : inner) : 0;

            Transition.cancel(el);

            if (!isToggled(el)) {
                _toggle(el, true);
            }

            height(el, '');

            // Update child components first
            fastdom.flush();

            var endHeight = height(el) + (inProgress ? 0 : inner);
            height(el, currentHeight);

            return (show ? Transition.start(el, assign({}, initProps, { overflow: 'hidden', height: endHeight }), Math.round(duration * (1 - currentHeight / endHeight)), transition) : Transition.start(el, hideProps, Math.round(duration * (currentHeight / endHeight)), transition).then(function () {
                return _toggle(el, false);
            })).then(function () {
                return css(el, initProps);
            });
        };
    }

    function toggleAnimation(cmp) {
        return function (el, show) {

            Animation.cancel(el);

            var animation = cmp.animation;
            var duration = cmp.duration;
            var _toggle = cmp._toggle;

            if (show) {
                _toggle(el, true);
                return Animation.in(el, animation[0], duration, cmp.origin);
            }

            return Animation.out(el, animation[1] || animation[0], duration, cmp.origin).then(function () {
                return _toggle(el, false);
            });
        };
    }

    var Accordion = {

        mixins: [Class, Togglable],

        props: {
            targets: String,
            active: null,
            collapsible: Boolean,
            multiple: Boolean,
            toggle: String,
            content: String,
            transition: String,
            offset: Number
        },

        data: {
            targets: '> *',
            active: false,
            animation: [true],
            collapsible: true,
            multiple: false,
            clsOpen: 'uk-open',
            toggle: '> .uk-accordion-title',
            content: '> .uk-accordion-content',
            transition: 'ease',
            offset: 0
        },

        computed: {

            items: {

                get: function get(ref, $el) {
                    var targets = ref.targets;

                    return $$(targets, $el);
                },

                watch: function watch(items, prev) {
                    var this$1$1 = this;

                    items.forEach(function (el) {
                        return hide($(this$1$1.content, el), !hasClass(el, this$1$1.clsOpen));
                    });

                    if (prev || hasClass(items, this.clsOpen)) {
                        return;
                    }

                    var active = this.active !== false && items[Number(this.active)] || !this.collapsible && items[0];

                    if (active) {
                        this.toggle(active, false);
                    }
                },

                immediate: true

            },

            toggles: function toggles(ref) {
                var toggle = ref.toggle;

                return this.items.map(function (item) {
                    return $(toggle, item);
                });
            }

        },

        events: [{

            name: 'click',

            delegate: function delegate() {
                return this.targets + " " + this.$props.toggle;
            },

            handler: function handler(e) {
                e.preventDefault();
                this.toggle(index(this.toggles, e.current));
            }

        }],

        methods: {

            toggle: function toggle(item, animate) {
                var this$1$1 = this;

                var items = [this.items[_getIndex(item, this.items)]];
                var activeItems = filter$1(this.items, "." + this.clsOpen);

                if (!this.multiple && !includes(activeItems, items[0])) {
                    items = items.concat(activeItems);
                }

                if (!this.collapsible && activeItems.length < 2 && !filter$1(items, ":not(." + this.clsOpen + ")").length) {
                    return;
                }

                items.forEach(function (el) {
                    return this$1$1.toggleElement(el, !hasClass(el, this$1$1.clsOpen), function (el, show) {

                        toggleClass(el, this$1$1.clsOpen, show);
                        attr($(this$1$1.$props.toggle, el), 'aria-expanded', show);

                        var content = $("" + (el._wrapper ? '> * ' : '') + this$1$1.content, el);

                        if (animate === false || !this$1$1.hasTransition) {
                            hide(content, !show);
                            return;
                        }

                        if (!el._wrapper) {
                            el._wrapper = wrapAll(content, "<div" + (show ? ' hidden' : '') + ">");
                        }

                        hide(content, false);
                        return toggleHeight(this$1$1)(el._wrapper, show).then(function () {
                            hide(content, !show);
                            delete el._wrapper;
                            unwrap(content);

                            if (show) {
                                var toggle = $(this$1$1.$props.toggle, el);
                                if (!isInView(toggle)) {
                                    scrollIntoView(toggle, { offset: this$1$1.offset });
                                }
                            }
                        });
                    });
                });
            }

        }

    };

    function hide(el, hide) {
        el && (el.hidden = hide);
    }

    var alert = {

        mixins: [Class, Togglable],

        args: 'animation',

        props: {
            close: String
        },

        data: {
            animation: [true],
            selClose: '.uk-alert-close',
            duration: 150,
            hideProps: assign({ opacity: 0 }, Togglable.data.hideProps)
        },

        events: [{

            name: 'click',

            delegate: function delegate() {
                return this.selClose;
            },

            handler: function handler(e) {
                e.preventDefault();
                this.close();
            }

        }],

        methods: {

            close: function close() {
                var this$1$1 = this;

                this.toggleElement(this.$el).then(function () {
                    return this$1$1.$destroy(true);
                });
            }

        }

    };

    var Video = {

        args: 'autoplay',

        props: {
            automute: Boolean,
            autoplay: Boolean
        },

        data: {
            automute: false,
            autoplay: true
        },

        computed: {

            inView: function inView(ref) {
                var autoplay = ref.autoplay;

                return autoplay === 'inview';
            }

        },

        connected: function connected() {

            if (this.inView && !hasAttr(this.$el, 'preload')) {
                this.$el.preload = 'none';
            }

            if (this.automute) {
                mute(this.$el);
            }
        },

        update: {

            read: function read() {

                if (!isVideo(this.$el)) {
                    return false;
                }

                return {
                    visible: isVisible(this.$el) && css(this.$el, 'visibility') !== 'hidden',
                    inView: this.inView && isInView(this.$el)
                };
            },

            write: function write(ref) {
                var visible = ref.visible;
                var inView = ref.inView;

                if (!visible || this.inView && !inView) {
                    pause(this.$el);
                } else if (this.autoplay === true || this.inView && inView) {
                    play(this.$el);
                }
            },

            events: ['resize', 'scroll']

        }

    };

    var cover = {

        mixins: [Class, Video],

        props: {
            width: Number,
            height: Number
        },

        data: {
            automute: true
        },

        update: {

            read: function read() {

                var el = this.$el;
                var ref = getPositionedParent(el) || parent(el);
                var height = ref.offsetHeight;
                var width = ref.offsetWidth;
                var dim = Dimensions.cover({
                    width: this.width || el.naturalWidth || el.videoWidth || el.clientWidth,
                    height: this.height || el.naturalHeight || el.videoHeight || el.clientHeight
                }, {
                    width: width + (width % 2 ? 1 : 0),
                    height: height + (height % 2 ? 1 : 0)
                });

                if (!dim.width || !dim.height) {
                    return false;
                }

                return dim;
            },

            write: function write(ref) {
                var height = ref.height;
                var width = ref.width;

                css(this.$el, { height: height, width: width });
            },

            events: ['resize']

        }

    };

    function getPositionedParent(el) {
        while (el = parent(el)) {
            if (css(el, 'position') !== 'static') {
                return el;
            }
        }
    }

    var Container = {

        props: {
            container: Boolean
        },

        data: {
            container: true
        },

        computed: {

            container: function container(ref) {
                var container = ref.container;

                return container === true && this.$container || container && $(container);
            }

        }

    };

    var Position = {

        props: {
            pos: String,
            offset: null,
            flip: Boolean,
            clsPos: String
        },

        data: {
            pos: "bottom-" + (!isRtl ? 'left' : 'right'),
            flip: true,
            offset: false,
            clsPos: ''
        },

        computed: {

            pos: function pos(ref) {
                var pos = ref.pos;

                return (pos + (!includes(pos, '-') ? '-center' : '')).split('-');
            },

            dir: function dir() {
                return this.pos[0];
            },

            align: function align() {
                return this.pos[1];
            }

        },

        methods: {

            positionAt: function positionAt(element, target, boundary) {

                removeClasses(element, this.clsPos + "-(top|bottom|left|right)(-[a-z]+)?");

                var ref = this;
                var offset$1 = ref.offset;
                var axis = this.getAxis();

                if (!isNumeric(offset$1)) {
                    var node = $(offset$1);
                    offset$1 = node ? offset(node)[axis === 'x' ? 'left' : 'top'] - offset(target)[axis === 'x' ? 'right' : 'bottom'] : 0;
                }

                var ref$1 = _positionAt(element, target, axis === 'x' ? flipPosition(this.dir) + " " + this.align : this.align + " " + flipPosition(this.dir), axis === 'x' ? this.dir + " " + this.align : this.align + " " + this.dir, axis === 'x' ? "" + (this.dir === 'left' ? -offset$1 : offset$1) : " " + (this.dir === 'top' ? -offset$1 : offset$1), null, this.flip, boundary).target;
                var x = ref$1.x;
                var y = ref$1.y;

                this.dir = axis === 'x' ? x : y;
                this.align = axis === 'x' ? y : x;

                toggleClass(element, this.clsPos + "-" + this.dir + "-" + this.align, this.offset === false);
            },

            getAxis: function getAxis() {
                return this.dir === 'top' || this.dir === 'bottom' ? 'y' : 'x';
            }

        }

    };

    var active$1;

    var drop = {

        mixins: [Container, Position, Togglable],

        args: 'pos',

        props: {
            mode: 'list',
            toggle: Boolean,
            boundary: Boolean,
            boundaryAlign: Boolean,
            delayShow: Number,
            delayHide: Number,
            clsDrop: String
        },

        data: {
            mode: ['click', 'hover'],
            toggle: '- *',
            boundary: true,
            boundaryAlign: false,
            delayShow: 0,
            delayHide: 800,
            clsDrop: false,
            animation: ['uk-animation-fade'],
            cls: 'uk-open',
            container: false
        },

        computed: {

            boundary: function boundary(ref, $el) {
                var boundary = ref.boundary;

                return boundary === true ? window : query(boundary, $el);
            },

            clsDrop: function clsDrop(ref) {
                var clsDrop = ref.clsDrop;

                return clsDrop || "uk-" + this.$options.name;
            },

            clsPos: function clsPos() {
                return this.clsDrop;
            }

        },

        created: function created() {
            this.tracker = new MouseTracker();
        },

        connected: function connected() {

            addClass(this.$el, this.clsDrop);

            if (this.toggle && !this.target) {
                this.target = this.$create('toggle', query(this.toggle, this.$el), {
                    target: this.$el,
                    mode: this.mode
                });
            }
        },

        disconnected: function disconnected() {
            if (this.isActive()) {
                active$1 = null;
            }
        },

        events: [{

            name: 'click',

            delegate: function delegate() {
                return "." + this.clsDrop + "-close";
            },

            handler: function handler(e) {
                e.preventDefault();
                this.hide(false);
            }

        }, {

            name: 'click',

            delegate: function delegate() {
                return 'a[href^="#"]';
            },

            handler: function handler(ref) {
                var defaultPrevented = ref.defaultPrevented;
                var hash = ref.current.hash;

                if (!defaultPrevented && hash && !within(hash, this.$el)) {
                    this.hide(false);
                }
            }

        }, {

            name: 'beforescroll',

            handler: function handler() {
                this.hide(false);
            }

        }, {

            name: 'toggle',

            self: true,

            handler: function handler(e, toggle) {

                e.preventDefault();

                if (this.isToggled()) {
                    this.hide(false);
                } else {
                    this.show(toggle.$el, false);
                }
            }

        }, {

            name: 'toggleshow',

            self: true,

            handler: function handler(e, toggle) {
                e.preventDefault();
                this.show(toggle.$el);
            }

        }, {

            name: 'togglehide',

            self: true,

            handler: function handler(e) {
                e.preventDefault();
                if (!matches(this.$el, ':focus,:hover')) {
                    this.hide();
                }
            }

        }, {

            name: pointerEnter + " focusin",

            filter: function filter() {
                return includes(this.mode, 'hover');
            },

            handler: function handler(e) {
                if (!isTouch(e)) {
                    this.clearTimers();
                }
            }

        }, {

            name: pointerLeave + " focusout",

            filter: function filter() {
                return includes(this.mode, 'hover');
            },

            handler: function handler(e) {
                if (!isTouch(e) && e.relatedTarget) {
                    this.hide();
                }
            }

        }, {

            name: 'toggled',

            self: true,

            handler: function handler(e, toggled) {

                if (!toggled) {
                    return;
                }

                this.clearTimers();
                this.position();
            }

        }, {

            name: 'show',

            self: true,

            handler: function handler() {
                var this$1$1 = this;

                active$1 = this;

                this.tracker.init();

                once(this.$el, 'hide', on(document, pointerDown, function (ref) {
                    var target = ref.target;

                    return !within(target, this$1$1.$el) && once(document, pointerUp + " " + pointerCancel + " scroll", function (ref) {
                        var defaultPrevented = ref.defaultPrevented;
                        var type = ref.type;
                        var newTarget = ref.target;

                        if (!defaultPrevented && type === pointerUp && target === newTarget && !(this$1$1.target && within(target, this$1$1.target))) {
                            this$1$1.hide(false);
                        }
                    }, true);
                }), { self: true });

                once(this.$el, 'hide', on(document, 'keydown', function (e) {
                    if (e.keyCode === 27) {
                        this$1$1.hide(false);
                    }
                }), { self: true });
            }

        }, {

            name: 'beforehide',

            self: true,

            handler: function handler() {
                this.clearTimers();
            }

        }, {

            name: 'hide',

            handler: function handler(ref) {
                var target = ref.target;

                if (this.$el !== target) {
                    active$1 = active$1 === null && within(target, this.$el) && this.isToggled() ? this : active$1;
                    return;
                }

                active$1 = this.isActive() ? null : active$1;
                this.tracker.cancel();
            }

        }],

        update: {

            write: function write() {

                if (this.isToggled() && !hasClass(this.$el, this.clsEnter)) {
                    this.position();
                }
            },

            events: ['resize']

        },

        methods: {

            show: function show(target, delay) {
                var this$1$1 = this;
                if (target === void 0) target = this.target;
                if (delay === void 0) delay = true;

                if (this.isToggled() && target && this.target && target !== this.target) {
                    this.hide(false);
                }

                this.target = target;

                this.clearTimers();

                if (this.isActive()) {
                    return;
                }

                if (active$1) {

                    if (delay && active$1.isDelaying) {
                        this.showTimer = setTimeout(this.show, 10);
                        return;
                    }

                    var prev;
                    while (active$1 && prev !== active$1 && !within(this.$el, active$1.$el)) {
                        prev = active$1;
                        active$1.hide(false);
                    }
                }

                if (this.container && parent(this.$el) !== this.container) {
                    append(this.container, this.$el);
                }

                this.showTimer = setTimeout(function () {
                    return this$1$1.toggleElement(this$1$1.$el, true);
                }, delay && this.delayShow || 0);
            },

            hide: function hide(delay) {
                var this$1$1 = this;
                if (delay === void 0) delay = true;

                var hide = function hide() {
                    return this$1$1.toggleElement(this$1$1.$el, false, false);
                };

                this.clearTimers();

                this.isDelaying = getPositionedElements(this.$el).some(function (el) {
                    return this$1$1.tracker.movesTo(el);
                });

                if (delay && this.isDelaying) {
                    this.hideTimer = setTimeout(this.hide, 50);
                } else if (delay && this.delayHide) {
                    this.hideTimer = setTimeout(hide, this.delayHide);
                } else {
                    hide();
                }
            },

            clearTimers: function clearTimers() {
                clearTimeout(this.showTimer);
                clearTimeout(this.hideTimer);
                this.showTimer = null;
                this.hideTimer = null;
                this.isDelaying = false;
            },

            isActive: function isActive() {
                return active$1 === this;
            },

            position: function position() {

                removeClass(this.$el, this.clsDrop + "-stack");
                toggleClass(this.$el, this.clsDrop + "-boundary", this.boundaryAlign);

                var boundary = offset(this.boundary);
                var alignTo = this.boundaryAlign ? boundary : offset(this.target);

                if (this.align === 'justify') {
                    var prop = this.getAxis() === 'y' ? 'width' : 'height';
                    css(this.$el, prop, alignTo[prop]);
                } else if (this.boundary && this.$el.offsetWidth > Math.max(boundary.right - alignTo.left, alignTo.right - boundary.left)) {
                    addClass(this.$el, this.clsDrop + "-stack");
                }

                this.positionAt(this.$el, this.boundaryAlign ? this.boundary : this.target, this.boundary);
            }

        }

    };

    function getPositionedElements(el) {
        var result = [];
        apply$1(el, function (el) {
            return css(el, 'position') !== 'static' && result.push(el);
        });
        return result;
    }

    var formCustom = {

        mixins: [Class],

        args: 'target',

        props: {
            target: Boolean
        },

        data: {
            target: false
        },

        computed: {

            input: function input(_, $el) {
                return $(selInput, $el);
            },

            state: function state() {
                return this.input.nextElementSibling;
            },

            target: function target(ref, $el) {
                var target = ref.target;

                return target && (target === true && parent(this.input) === $el && this.input.nextElementSibling || query(target, $el));
            }

        },

        update: function update() {

            var ref = this;
            var target = ref.target;
            var input = ref.input;

            if (!target) {
                return;
            }

            var option;
            var prop = isInput(target) ? 'value' : 'textContent';
            var prev = target[prop];
            var value = input.files && input.files[0] ? input.files[0].name : matches(input, 'select') && (option = $$('option', input).filter(function (el) {
                return el.selected;
            })[0]) // eslint-disable-line prefer-destructuring
            ? option.textContent : input.value;

            if (prev !== value) {
                target[prop] = value;
            }
        },

        events: [{
            name: 'change',

            handler: function handler() {
                this.$update();
            }
        }, {
            name: 'reset',

            el: function el() {
                return closest(this.$el, 'form');
            },

            handler: function handler() {
                this.$update();
            }
        }]

    };

    // Deprecated
    var gif = {

        update: {

            read: function read(data) {

                var inview = isInView(this.$el);

                if (!inview || data.isInView === inview) {
                    return false;
                }

                data.isInView = inview;
            },

            write: function write() {
                this.$el.src = '' + this.$el.src; // force self-assign
            },

            events: ['scroll', 'resize']
        }

    };

    var Margin = {

        props: {
            margin: String,
            firstColumn: Boolean
        },

        data: {
            margin: 'uk-margin-small-top',
            firstColumn: 'uk-first-column'
        },

        update: {

            read: function read() {

                var rows = getRows(this.$el.children);

                return {
                    rows: rows,
                    columns: getColumns(rows)
                };
            },

            write: function write(ref) {
                var columns = ref.columns;
                var rows = ref.rows;

                for (var i = 0; i < rows.length; i++) {
                    for (var j = 0; j < rows[i].length; j++) {
                        toggleClass(rows[i][j], this.margin, i !== 0);
                        toggleClass(rows[i][j], this.firstColumn, !!~columns[0].indexOf(rows[i][j]));
                    }
                }
            },

            events: ['resize']

        }

    };

    function getRows(items) {
        return sortBy(items, 'top', 'bottom');
    }

    function getColumns(rows) {

        var columns = [];

        for (var i = 0; i < rows.length; i++) {
            var sorted = sortBy(rows[i], 'left', 'right');
            for (var j = 0; j < sorted.length; j++) {
                columns[j] = !columns[j] ? sorted[j] : columns[j].concat(sorted[j]);
            }
        }

        return isRtl ? columns.reverse() : columns;
    }

    function sortBy(items, startProp, endProp) {

        var sorted = [[]];

        for (var i = 0; i < items.length; i++) {

            var el = items[i];

            if (!isVisible(el)) {
                continue;
            }

            var dim = getOffset(el);

            for (var j = sorted.length - 1; j >= 0; j--) {

                var current = sorted[j];

                if (!current[0]) {
                    current.push(el);
                    break;
                }

                var startDim = void 0;
                if (current[0].offsetParent === el.offsetParent) {
                    startDim = getOffset(current[0]);
                } else {
                    dim = getOffset(el, true);
                    startDim = getOffset(current[0], true);
                }

                if (dim[startProp] >= startDim[endProp] - 1 && dim[startProp] !== startDim[startProp]) {
                    sorted.push([el]);
                    break;
                }

                if (dim[endProp] - 1 > startDim[startProp] || dim[startProp] === startDim[startProp]) {
                    current.push(el);
                    break;
                }

                if (j === 0) {
                    sorted.unshift([el]);
                    break;
                }
            }
        }

        return sorted;
    }

    function getOffset(element, offset) {
        var assign;

        if (offset === void 0) offset = false;

        var offsetTop = element.offsetTop;
        var offsetLeft = element.offsetLeft;
        var offsetHeight = element.offsetHeight;
        var offsetWidth = element.offsetWidth;

        if (offset) {
            assign = offsetPosition(element), offsetTop = assign[0], offsetLeft = assign[1];
        }

        return {
            top: offsetTop,
            left: offsetLeft,
            bottom: offsetTop + offsetHeight,
            right: offsetLeft + offsetWidth
        };
    }

    var grid = {

        extends: Margin,

        mixins: [Class],

        name: 'grid',

        props: {
            masonry: Boolean,
            parallax: Number
        },

        data: {
            margin: 'uk-grid-margin',
            clsStack: 'uk-grid-stack',
            masonry: false,
            parallax: 0
        },

        connected: function connected() {
            this.masonry && addClass(this.$el, 'uk-flex-top uk-flex-wrap-top');
        },

        update: [{

            write: function write(ref) {
                var columns = ref.columns;

                toggleClass(this.$el, this.clsStack, columns.length < 2);
            },

            events: ['resize']

        }, {

            read: function read(data) {

                var columns = data.columns;
                var rows = data.rows;

                // Filter component makes elements positioned absolute
                if (!columns.length || !this.masonry && !this.parallax || positionedAbsolute(this.$el)) {
                    data.translates = false;
                    return false;
                }

                var translates = false;

                var nodes = _children(this.$el);
                var columnHeights = getColumnHeights(columns);
                var margin = getMarginTop(nodes, this.margin) * (rows.length - 1);
                var elHeight = Math.max.apply(Math, columnHeights) + margin;

                if (this.masonry) {
                    columns = columns.map(function (column) {
                        return sortBy$1(column, 'offsetTop');
                    });
                    translates = getTranslates(rows, columns);
                }

                var padding = Math.abs(this.parallax);
                if (padding) {
                    padding = columnHeights.reduce(function (newPadding, hgt, i) {
                        return Math.max(newPadding, hgt + margin + (i % 2 ? padding : padding / 8) - elHeight);
                    }, 0);
                }

                return { padding: padding, columns: columns, translates: translates, height: translates ? elHeight : '' };
            },

            write: function write(ref) {
                var height = ref.height;
                var padding = ref.padding;

                css(this.$el, 'paddingBottom', padding || '');
                height !== false && css(this.$el, 'height', height);
            },

            events: ['resize']

        }, {

            read: function read(ref) {
                var height$1 = ref.height;

                if (positionedAbsolute(this.$el)) {
                    return false;
                }

                return {
                    scrolled: this.parallax ? scrolledOver(this.$el, height$1 ? height$1 - height(this.$el) : 0) * Math.abs(this.parallax) : false
                };
            },

            write: function write(ref) {
                var columns = ref.columns;
                var scrolled = ref.scrolled;
                var translates = ref.translates;

                if (scrolled === false && !translates) {
                    return;
                }

                columns.forEach(function (column, i) {
                    return column.forEach(function (el, j) {
                        return css(el, 'transform', !scrolled && !translates ? '' : "translateY(" + ((translates && -translates[i][j]) + (scrolled ? i % 2 ? scrolled : scrolled / 8 : 0)) + "px)");
                    });
                });
            },

            events: ['scroll', 'resize']

        }]

    };

    function positionedAbsolute(el) {
        return _children(el).some(function (el) {
            return css(el, 'position') === 'absolute';
        });
    }

    function getTranslates(rows, columns) {

        var rowHeights = rows.map(function (row) {
            return Math.max.apply(Math, row.map(function (el) {
                return el.offsetHeight;
            }));
        });

        return columns.map(function (elements) {
            var prev = 0;
            return elements.map(function (element, row) {
                return prev += row ? rowHeights[row - 1] - elements[row - 1].offsetHeight : 0;
            });
        });
    }

    function getMarginTop(nodes, cls) {

        var ref = nodes.filter(function (el) {
            return hasClass(el, cls);
        });
        var node = ref[0];

        return toFloat(node ? css(node, 'marginTop') : css(nodes[0], 'paddingLeft'));
    }

    function getColumnHeights(columns) {
        return columns.map(function (column) {
            return column.reduce(function (sum, el) {
                return sum + el.offsetHeight;
            }, 0);
        });
    }

    // IE 11 fix (min-height on a flex container won't apply to its flex items)
    var FlexBug = isIE ? {

        props: {
            selMinHeight: String
        },

        data: {
            selMinHeight: false,
            forceHeight: false
        },

        computed: {

            elements: function elements(ref, $el) {
                var selMinHeight = ref.selMinHeight;

                return selMinHeight ? $$(selMinHeight, $el) : [$el];
            }

        },

        update: [{

            read: function read() {
                css(this.elements, 'height', '');
            },

            order: -5,

            events: ['resize']

        }, {

            write: function write() {
                var this$1$1 = this;

                this.elements.forEach(function (el) {
                    var height = toFloat(css(el, 'minHeight'));
                    if (height && (this$1$1.forceHeight || Math.round(height + boxModelAdjust(el, 'height', 'content-box')) >= el.offsetHeight)) {
                        css(el, 'height', height);
                    }
                });
            },

            order: 5,

            events: ['resize']

        }]

    } : {};

    var heightMatch = {

        mixins: [FlexBug],

        args: 'target',

        props: {
            target: String,
            row: Boolean
        },

        data: {
            target: '> *',
            row: true,
            forceHeight: true
        },

        computed: {

            elements: function elements(ref, $el) {
                var target = ref.target;

                return $$(target, $el);
            }

        },

        update: {

            read: function read() {
                return {
                    rows: (this.row ? getRows(this.elements) : [this.elements]).map(match$1)
                };
            },

            write: function write(ref) {
                var rows = ref.rows;

                rows.forEach(function (ref) {
                    var heights = ref.heights;
                    var elements = ref.elements;

                    return elements.forEach(function (el, i) {
                        return css(el, 'minHeight', heights[i]);
                    });
                });
            },

            events: ['resize']

        }

    };

    function match$1(elements) {

        if (elements.length < 2) {
            return { heights: [''], elements: elements };
        }

        var heights = elements.map(getHeight);
        var max = Math.max.apply(Math, heights);
        var hasMinHeight = elements.some(function (el) {
            return el.style.minHeight;
        });
        var hasShrunk = elements.some(function (el, i) {
            return !el.style.minHeight && heights[i] < max;
        });

        if (hasMinHeight && hasShrunk) {
            css(elements, 'minHeight', '');
            heights = elements.map(getHeight);
            max = Math.max.apply(Math, heights);
        }

        heights = elements.map(function (el, i) {
            return heights[i] === max && toFloat(el.style.minHeight).toFixed(2) !== max.toFixed(2) ? '' : max;
        });

        return { heights: heights, elements: elements };
    }

    function getHeight(element) {

        var style = false;
        if (!isVisible(element)) {
            style = element.style.display;
            css(element, 'display', 'block', 'important');
        }

        var height = dimensions(element).height - boxModelAdjust(element, 'height', 'content-box');

        if (style !== false) {
            css(element, 'display', style);
        }

        return height;
    }

    var heightViewport = {

        mixins: [FlexBug],

        props: {
            expand: Boolean,
            offsetTop: Boolean,
            offsetBottom: Boolean,
            minHeight: Number
        },

        data: {
            expand: false,
            offsetTop: false,
            offsetBottom: false,
            minHeight: 0
        },

        update: {

            read: function read(ref) {
                var prev = ref.minHeight;

                if (!isVisible(this.$el)) {
                    return false;
                }

                var minHeight = '';
                var box = boxModelAdjust(this.$el, 'height', 'content-box');

                if (this.expand) {

                    minHeight = height(window) - (dimensions(document.documentElement).height - dimensions(this.$el).height) - box || '';
                } else {

                    // on mobile devices (iOS and Android) window.innerHeight !== 100vh
                    minHeight = 'calc(100vh';

                    if (this.offsetTop) {

                        var ref$1 = offset(this.$el);
                        var top = ref$1.top;
                        minHeight += top > 0 && top < height(window) / 2 ? " - " + top + "px" : '';
                    }

                    if (this.offsetBottom === true) {

                        minHeight += " - " + dimensions(this.$el.nextElementSibling).height + "px";
                    } else if (isNumeric(this.offsetBottom)) {

                        minHeight += " - " + this.offsetBottom + "vh";
                    } else if (this.offsetBottom && endsWith(this.offsetBottom, 'px')) {

                        minHeight += " - " + toFloat(this.offsetBottom) + "px";
                    } else if (isString(this.offsetBottom)) {

                        minHeight += " - " + dimensions(query(this.offsetBottom, this.$el)).height + "px";
                    }

                    minHeight += (box ? " - " + box + "px" : '') + ")";
                }

                return { minHeight: minHeight, prev: prev };
            },

            write: function write(ref) {
                var minHeight = ref.minHeight;
                var prev = ref.prev;

                css(this.$el, { minHeight: minHeight });

                if (minHeight !== prev) {
                    this.$update(this.$el, 'resize');
                }

                if (this.minHeight && toFloat(css(this.$el, 'minHeight')) < this.minHeight) {
                    css(this.$el, 'minHeight', this.minHeight);
                }
            },

            events: ['resize']

        }

    };

    var SVG = {

        args: 'src',

        props: {
            id: Boolean,
            icon: String,
            src: String,
            style: String,
            width: Number,
            height: Number,
            ratio: Number,
            class: String,
            strokeAnimation: Boolean,
            focusable: Boolean, // IE 11
            attributes: 'list'
        },

        data: {
            ratio: 1,
            include: ['style', 'class', 'focusable'],
            class: '',
            strokeAnimation: false
        },

        beforeConnect: function beforeConnect() {
            this.class += ' uk-svg';
        },

        connected: function connected() {
            var this$1$1 = this;
            var assign;

            if (!this.icon && includes(this.src, '#')) {
                assign = this.src.split('#'), this.src = assign[0], this.icon = assign[1];
            }

            this.svg = this.getSvg().then(function (el) {

                if (this$1$1._connected) {

                    var svg = insertSVG(el, this$1$1.$el);

                    if (this$1$1.svgEl && svg !== this$1$1.svgEl) {
                        remove$1(this$1$1.svgEl);
                    }

                    this$1$1.applyAttributes(svg, el);
                    this$1$1.$emit();
                    return this$1$1.svgEl = svg;
                }
            }, noop);
        },

        disconnected: function disconnected() {
            var this$1$1 = this;

            this.svg.then(function (svg) {
                if (!this$1$1._connected) {

                    if (isVoidElement(this$1$1.$el)) {
                        this$1$1.$el.hidden = false;
                    }

                    remove$1(svg);
                    this$1$1.svgEl = null;
                }
            });

            this.svg = null;
        },

        update: {

            read: function read() {
                return !!(this.strokeAnimation && this.svgEl && isVisible(this.svgEl));
            },

            write: function write() {
                applyAnimation(this.svgEl);
            },

            type: ['resize']

        },

        methods: {

            getSvg: function getSvg() {
                var this$1$1 = this;

                return loadSVG(this.src).then(function (svg) {
                    return parseSVG(svg, this$1$1.icon) || Promise$1.reject('SVG not found.');
                });
            },

            applyAttributes: function applyAttributes(el, ref) {
                var this$1$1 = this;

                for (var prop in this.$options.props) {
                    if (includes(this.include, prop) && prop in this) {
                        attr(el, prop, this[prop]);
                    }
                }

                for (var attribute in this.attributes) {
                    var ref$1 = this.attributes[attribute].split(':', 2);
                    var prop$1 = ref$1[0];
                    var value = ref$1[1];
                    attr(el, prop$1, value);
                }

                if (!this.id) {
                    removeAttr(el, 'id');
                }

                var props = ['width', 'height'];
                var dimensions = props.map(function (prop) {
                    return this$1$1[prop];
                });

                if (!dimensions.some(function (val) {
                    return val;
                })) {
                    dimensions = props.map(function (prop) {
                        return attr(ref, prop);
                    });
                }

                var viewBox = attr(ref, 'viewBox');
                if (viewBox && !dimensions.some(function (val) {
                    return val;
                })) {
                    dimensions = viewBox.split(' ').slice(2);
                }

                dimensions.forEach(function (val, i) {
                    return attr(el, props[i], toFloat(val) * this$1$1.ratio || null);
                });
            }

        }

    };

    var loadSVG = memoize(function (src) {
        return new Promise$1(function (resolve, reject) {

            if (!src) {
                reject();
                return;
            }

            if (startsWith(src, 'data:')) {
                resolve(decodeURIComponent(src.split(',')[1]));
            } else {

                ajax(src).then(function (xhr) {
                    return resolve(xhr.response);
                }, function () {
                    return reject('SVG not found.');
                });
            }
        });
    });

    function parseSVG(svg, icon) {

        if (icon && includes(svg, '<symbol')) {
            svg = parseSymbols(svg, icon) || svg;
        }

        svg = $(svg.substr(svg.indexOf('<svg')));
        return svg && svg.hasChildNodes() && svg;
    }

    var symbolRe = /<symbol([^]*?id=(['"])(.+?)\2[^]*?<\/)symbol>/g;
    var symbols = {};

    function parseSymbols(svg, icon) {

        if (!symbols[svg]) {

            symbols[svg] = {};

            symbolRe.lastIndex = 0;

            var match;
            while (match = symbolRe.exec(svg)) {
                symbols[svg][match[3]] = "<svg xmlns=\"http://www.w3.org/2000/svg\"" + match[1] + "svg>";
            }
        }

        return symbols[svg][icon];
    }

    function applyAnimation(el) {

        var length = getMaxPathLength(el);

        if (length) {
            el.style.setProperty('--uk-animation-stroke', length);
        }
    }

    function getMaxPathLength(el) {
        return Math.ceil(Math.max.apply(Math, [0].concat($$('[stroke]', el).map(function (stroke) {
            try {
                return stroke.getTotalLength();
            } catch (e) {
                return 0;
            }
        }))));
    }

    function insertSVG(el, root) {

        if (isVoidElement(root) || root.tagName === 'CANVAS') {

            root.hidden = true;

            var next = root.nextElementSibling;
            return equals(el, next) ? next : after(root, el);
        }

        var last = root.lastElementChild;
        return equals(el, last) ? last : append(root, el);
    }

    function equals(el, other) {
        return isSVG(el) && isSVG(other) && innerHTML(el) === innerHTML(other);
    }

    function isSVG(el) {
        return el && el.tagName === 'svg';
    }

    function innerHTML(el) {
        return (el.innerHTML || new XMLSerializer().serializeToString(el).replace(/<svg.*?>(.*?)<\/svg>/g, '$1')).replace(/\s/g, '');
    }

    var closeIcon = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"1\" y1=\"1\" x2=\"13\" y2=\"13\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"13\" y1=\"1\" x2=\"1\" y2=\"13\"/></svg>";

    var closeLarge = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" x1=\"1\" y1=\"1\" x2=\"19\" y2=\"19\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" x1=\"19\" y1=\"1\" x2=\"1\" y2=\"19\"/></svg>";

    var marker = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"9\" y=\"4\" width=\"1\" height=\"11\"/><rect x=\"4\" y=\"9\" width=\"11\" height=\"1\"/></svg>";

    var navbarToggleIcon = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect y=\"9\" width=\"20\" height=\"2\"/><rect y=\"3\" width=\"20\" height=\"2\"/><rect y=\"15\" width=\"20\" height=\"2\"/></svg>";

    var overlayIcon = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"19\" y=\"0\" width=\"1\" height=\"40\"/><rect x=\"0\" y=\"19\" width=\"40\" height=\"1\"/></svg>";

    var paginationNext = "<svg width=\"7\" height=\"12\" viewBox=\"0 0 7 12\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" points=\"1 1 6 6 1 11\"/></svg>";

    var paginationPrevious = "<svg width=\"7\" height=\"12\" viewBox=\"0 0 7 12\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" points=\"6 1 1 6 6 11\"/></svg>";

    var searchIcon = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9\" cy=\"9\" r=\"7\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M14,14 L18,18 L14,14 Z\"/></svg>";

    var searchLarge = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.8\" cx=\"17.5\" cy=\"17.5\" r=\"16.5\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.8\" x1=\"38\" y1=\"39\" x2=\"29\" y2=\"30\"/></svg>";

    var searchNavbar = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10.5\" cy=\"10.5\" r=\"9.5\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"23\" y1=\"23\" x2=\"17\" y2=\"17\"/></svg>";

    var slidenavNext = "<svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" points=\"1.225,23 12.775,12 1.225,1 \"/></svg>";

    var slidenavNextLarge = "<svg width=\"25\" height=\"40\" viewBox=\"0 0 25 40\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"2\" points=\"4.002,38.547 22.527,20.024 4,1.5 \"/></svg>";

    var slidenavPrevious = "<svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" points=\"12.775,1 1.225,12 12.775,23 \"/></svg>";

    var slidenavPreviousLarge = "<svg width=\"25\" height=\"40\" viewBox=\"0 0 25 40\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"2\" points=\"20.527,1.5 2,20.024 20.525,38.547 \"/></svg>";

    var spinner = "<svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" cx=\"15\" cy=\"15\" r=\"14\"/></svg>";

    var totop = "<svg width=\"18\" height=\"10\" viewBox=\"0 0 18 10\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" points=\"1 9 9 1 17 9 \"/></svg>";

    var icons = {
        spinner: spinner,
        totop: totop,
        marker: marker,
        'close-icon': closeIcon,
        'close-large': closeLarge,
        'navbar-toggle-icon': navbarToggleIcon,
        'overlay-icon': overlayIcon,
        'pagination-next': paginationNext,
        'pagination-previous': paginationPrevious,
        'search-icon': searchIcon,
        'search-large': searchLarge,
        'search-navbar': searchNavbar,
        'slidenav-next': slidenavNext,
        'slidenav-next-large': slidenavNextLarge,
        'slidenav-previous': slidenavPrevious,
        'slidenav-previous-large': slidenavPreviousLarge
    };

    var Icon = {

        install: install$3,

        extends: SVG,

        args: 'icon',

        props: ['icon'],

        data: {
            include: ['focusable']
        },

        isIcon: true,

        beforeConnect: function beforeConnect() {
            addClass(this.$el, 'uk-icon');
        },

        methods: {

            getSvg: function getSvg() {

                var icon = getIcon(this.icon);

                if (!icon) {
                    return Promise$1.reject('Icon not found.');
                }

                return Promise$1.resolve(icon);
            }

        }

    };

    var IconComponent = {

        args: false,

        extends: Icon,

        data: function data(vm) {
            return {
                icon: hyphenate(vm.constructor.options.name)
            };
        },

        beforeConnect: function beforeConnect() {
            addClass(this.$el, this.$name);
        }

    };

    var Slidenav = {

        extends: IconComponent,

        beforeConnect: function beforeConnect() {
            addClass(this.$el, 'uk-slidenav');
        },

        computed: {

            icon: function icon(ref, $el) {
                var icon = ref.icon;

                return hasClass($el, 'uk-slidenav-large') ? icon + "-large" : icon;
            }

        }

    };

    var Search = {

        extends: IconComponent,

        computed: {

            icon: function icon(ref, $el) {
                var icon = ref.icon;

                return hasClass($el, 'uk-search-icon') && parents($el, '.uk-search-large').length ? 'search-large' : parents($el, '.uk-search-navbar').length ? 'search-navbar' : icon;
            }

        }

    };

    var Close = {

        extends: IconComponent,

        computed: {

            icon: function icon() {
                return "close-" + (hasClass(this.$el, 'uk-close-large') ? 'large' : 'icon');
            }

        }

    };

    var Spinner = {

        extends: IconComponent,

        connected: function connected() {
            var this$1$1 = this;

            this.svg.then(function (svg) {
                return svg && this$1$1.ratio !== 1 && css($('circle', svg), 'strokeWidth', 1 / this$1$1.ratio);
            });
        }

    };

    var parsed = {};
    function install$3(UIkit) {
        UIkit.icon.add = function (name, svg) {
            var obj;

            var added = isString(name) ? (obj = {}, obj[name] = svg, obj) : name;
            each(added, function (svg, name) {
                icons[name] = svg;
                delete parsed[name];
            });

            if (UIkit._initialized) {
                apply$1(document.body, function (el) {
                    return each(UIkit.getComponents(el), function (cmp) {
                        cmp.$options.isIcon && cmp.icon in added && cmp.$reset();
                    });
                });
            }
        };
    }

    function getIcon(icon) {

        if (!icons[icon]) {
            return null;
        }

        if (!parsed[icon]) {
            parsed[icon] = $((icons[applyRtl(icon)] || icons[icon]).trim());
        }

        return parsed[icon].cloneNode(true);
    }

    function applyRtl(icon) {
        return isRtl ? swap(swap(icon, 'left', 'right'), 'previous', 'next') : icon;
    }

    var img = {

        args: 'dataSrc',

        props: {
            dataSrc: String,
            dataSrcset: Boolean,
            sizes: String,
            width: Number,
            height: Number,
            offsetTop: String,
            offsetLeft: String,
            target: String
        },

        data: {
            dataSrc: '',
            dataSrcset: false,
            sizes: false,
            width: false,
            height: false,
            offsetTop: '50vh',
            offsetLeft: '50vw',
            target: false
        },

        computed: {

            cacheKey: function cacheKey(ref) {
                var dataSrc = ref.dataSrc;

                return this.$name + "." + dataSrc;
            },

            width: function width(ref) {
                var width = ref.width;
                var dataWidth = ref.dataWidth;

                return width || dataWidth;
            },

            height: function height(ref) {
                var height = ref.height;
                var dataHeight = ref.dataHeight;

                return height || dataHeight;
            },

            sizes: function sizes(ref) {
                var sizes = ref.sizes;
                var dataSizes = ref.dataSizes;

                return sizes || dataSizes;
            },

            isImg: function isImg(_, $el) {
                return _isImg($el);
            },

            target: {

                get: function get(ref) {
                    var target = ref.target;

                    return [this.$el].concat(queryAll(target, this.$el));
                },

                watch: function watch() {
                    this.observe();
                }

            },

            offsetTop: function offsetTop(ref) {
                var offsetTop = ref.offsetTop;

                return toPx(offsetTop, 'height');
            },

            offsetLeft: function offsetLeft(ref) {
                var offsetLeft = ref.offsetLeft;

                return toPx(offsetLeft, 'width');
            }

        },

        connected: function connected() {

            if (!window.IntersectionObserver) {
                setSrcAttrs(this.$el, this.dataSrc, this.dataSrcset, this.sizes);
                return;
            }

            if (storage[this.cacheKey]) {
                setSrcAttrs(this.$el, storage[this.cacheKey], this.dataSrcset, this.sizes);
            } else if (this.isImg && this.width && this.height) {
                setSrcAttrs(this.$el, getPlaceholderImage(this.width, this.height, this.sizes));
            }

            this.observer = new IntersectionObserver(this.load, {
                rootMargin: this.offsetTop + "px " + this.offsetLeft + "px"
            });

            requestAnimationFrame(this.observe);
        },

        disconnected: function disconnected() {
            this.observer && this.observer.disconnect();
        },

        update: {

            read: function read(ref) {
                var this$1$1 = this;
                var image = ref.image;

                if (!this.observer) {
                    return false;
                }

                if (!image && document.readyState === 'complete') {
                    this.load(this.observer.takeRecords());
                }

                if (this.isImg) {
                    return false;
                }

                image && image.then(function (img) {
                    return img && img.currentSrc !== '' && setSrcAttrs(this$1$1.$el, currentSrc(img));
                });
            },

            write: function write(data) {

                if (this.dataSrcset && window.devicePixelRatio !== 1) {

                    var bgSize = css(this.$el, 'backgroundSize');
                    if (bgSize.match(/^(auto\s?)+$/) || toFloat(bgSize) === data.bgSize) {
                        data.bgSize = getSourceSize(this.dataSrcset, this.sizes);
                        css(this.$el, 'backgroundSize', data.bgSize + "px");
                    }
                }
            },

            events: ['resize']

        },

        methods: {

            load: function load(entries) {
                var this$1$1 = this;

                // Old chromium based browsers (UC Browser) did not implement `isIntersecting`
                if (!entries.some(function (entry) {
                    return isUndefined(entry.isIntersecting) || entry.isIntersecting;
                })) {
                    return;
                }

                this._data.image = getImage(this.dataSrc, this.dataSrcset, this.sizes).then(function (img) {

                    setSrcAttrs(this$1$1.$el, currentSrc(img), img.srcset, img.sizes);
                    storage[this$1$1.cacheKey] = currentSrc(img);
                    return img;
                }, function (e) {
                    return trigger(this$1$1.$el, new e.constructor(e.type, e));
                });

                this.observer.disconnect();
            },

            observe: function observe() {
                var this$1$1 = this;

                if (this._connected && !this._data.image) {
                    this.target.forEach(function (el) {
                        return this$1$1.observer.observe(el);
                    });
                }
            }

        }

    };

    function setSrcAttrs(el, src, srcset, sizes) {

        if (_isImg(el)) {
            var set = function set(prop, val) {
                return val && val !== el[prop] && (el[prop] = val);
            };
            set('sizes', sizes);
            set('srcset', srcset);
            set('src', src);
        } else if (src) {

            var change = !includes(el.style.backgroundImage, src);
            if (change) {
                css(el, 'backgroundImage', "url(" + escape(src) + ")");
                trigger(el, createEvent('load', false));
            }
        }
    }

    function getPlaceholderImage(width, height, sizes) {
        var assign;

        if (sizes) {
            assign = Dimensions.ratio({ width: width, height: height }, 'width', toPx(sizesToPixel(sizes))), width = assign.width, height = assign.height;
        }

        return "data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"" + width + "\" height=\"" + height + "\"></svg>";
    }

    var sizesRe = /\s*(.*?)\s*(\w+|calc\(.*?\))\s*(?:,|$)/g;
    function sizesToPixel(sizes) {
        var matches;

        sizesRe.lastIndex = 0;

        while (matches = sizesRe.exec(sizes)) {
            if (!matches[1] || window.matchMedia(matches[1]).matches) {
                matches = evaluateSize(matches[2]);
                break;
            }
        }

        return matches || '100vw';
    }

    var sizeRe = /\d+(?:\w+|%)/g;
    var additionRe = /[+-]?(\d+)/g;
    function evaluateSize(size) {
        return startsWith(size, 'calc') ? size.slice(5, -1).replace(sizeRe, function (size) {
            return toPx(size);
        }).replace(/ /g, '').match(additionRe).reduce(function (a, b) {
            return a + +b;
        }, 0) : size;
    }

    var srcSetRe = /\s+\d+w\s*(?:,|$)/g;
    function getSourceSize(srcset, sizes) {
        var srcSize = toPx(sizesToPixel(sizes));
        var descriptors = (srcset.match(srcSetRe) || []).map(toFloat).sort(function (a, b) {
            return a - b;
        });

        return descriptors.filter(function (size) {
            return size >= srcSize;
        })[0] || descriptors.pop() || '';
    }

    function _isImg(el) {
        return el.tagName === 'IMG';
    }

    function currentSrc(el) {
        return el.currentSrc || el.src;
    }

    var key = '__test__';
    var storage;

    // workaround for Safari's private browsing mode and accessing sessionStorage in Blink
    try {
        storage = window.sessionStorage || {};
        storage[key] = 1;
        delete storage[key];
    } catch (e) {
        storage = {};
    }

    var Media = {

        props: {
            media: Boolean
        },

        data: {
            media: false
        },

        computed: {

            matchMedia: function matchMedia() {
                var media = toMedia(this.media);
                return !media || window.matchMedia(media).matches;
            }

        }

    };

    function toMedia(value) {

        if (isString(value)) {
            if (value[0] === '@') {
                var name = "breakpoint-" + value.substr(1);
                value = toFloat(getCssVar(name));
            } else if (isNaN(value)) {
                return value;
            }
        }

        return value && !isNaN(value) ? "(min-width: " + value + "px)" : false;
    }

    var leader = {

        mixins: [Class, Media],

        props: {
            fill: String
        },

        data: {
            fill: '',
            clsWrapper: 'uk-leader-fill',
            clsHide: 'uk-leader-hide',
            attrFill: 'data-fill'
        },

        computed: {

            fill: function fill(ref) {
                var fill = ref.fill;

                return fill || getCssVar('leader-fill-content');
            }

        },

        connected: function connected() {
            var assign;

            assign = wrapInner(this.$el, "<span class=\"" + this.clsWrapper + "\">"), this.wrapper = assign[0];
        },

        disconnected: function disconnected() {
            unwrap(this.wrapper.childNodes);
        },

        update: {

            read: function read(ref) {
                var changed = ref.changed;
                var width = ref.width;

                var prev = width;

                width = Math.floor(this.$el.offsetWidth / 2);

                return {
                    width: width,
                    fill: this.fill,
                    changed: changed || prev !== width,
                    hide: !this.matchMedia
                };
            },

            write: function write(data) {

                toggleClass(this.wrapper, this.clsHide, data.hide);

                if (data.changed) {
                    data.changed = false;
                    attr(this.wrapper, this.attrFill, new Array(data.width).join(data.fill));
                }
            },

            events: ['resize']

        }

    };

    var active = [];

    var Modal = {

        mixins: [Class, Container, Togglable],

        props: {
            selPanel: String,
            selClose: String,
            escClose: Boolean,
            bgClose: Boolean,
            stack: Boolean
        },

        data: {
            cls: 'uk-open',
            escClose: true,
            bgClose: true,
            overlay: true,
            stack: false
        },

        computed: {

            panel: function panel(ref, $el) {
                var selPanel = ref.selPanel;

                return $(selPanel, $el);
            },

            transitionElement: function transitionElement() {
                return this.panel;
            },

            bgClose: function bgClose(ref) {
                var bgClose = ref.bgClose;

                return bgClose && this.panel;
            }

        },

        beforeDisconnect: function beforeDisconnect() {
            if (includes(active, this)) {
                this.toggleElement(this.$el, false, false);
            }
        },

        events: [{

            name: 'click',

            delegate: function delegate() {
                return this.selClose;
            },

            handler: function handler(e) {
                e.preventDefault();
                this.hide();
            }

        }, {

            name: 'toggle',

            self: true,

            handler: function handler(e, toggle) {

                if (e.defaultPrevented) {
                    return;
                }

                e.preventDefault();

                if (this.isToggled() === includes(active, this)) {
                    this.toggle();
                }
            }

        }, {
            name: 'beforeshow',

            self: true,

            handler: function handler(e) {

                if (includes(active, this)) {
                    return false;
                }

                if (!this.stack && active.length) {
                    Promise$1.all(active.map(function (modal) {
                        return modal.hide();
                    })).then(this.show);
                    e.preventDefault();
                } else {
                    active.push(this);
                }
            }

        }, {

            name: 'show',

            self: true,

            handler: function handler() {
                var this$1$1 = this;

                var docEl = document.documentElement;

                if (width(window) > docEl.clientWidth && this.overlay) {
                    css(document.body, 'overflowY', 'scroll');
                }

                if (this.stack) {
                    css(this.$el, 'zIndex', toFloat(css(this.$el, 'zIndex')) + active.length);
                }

                addClass(docEl, this.clsPage);

                if (this.bgClose) {
                    once(this.$el, 'hide', on(document, pointerDown, function (ref) {
                        var target = ref.target;

                        if (last(active) !== this$1$1 || this$1$1.overlay && !within(target, this$1$1.$el) || within(target, this$1$1.panel)) {
                            return;
                        }

                        once(document, pointerUp + " " + pointerCancel + " scroll", function (ref) {
                            var defaultPrevented = ref.defaultPrevented;
                            var type = ref.type;
                            var newTarget = ref.target;

                            if (!defaultPrevented && type === pointerUp && target === newTarget) {
                                this$1$1.hide();
                            }
                        }, true);
                    }), { self: true });
                }

                if (this.escClose) {
                    once(this.$el, 'hide', on(document, 'keydown', function (e) {
                        if (e.keyCode === 27 && last(active) === this$1$1) {
                            this$1$1.hide();
                        }
                    }), { self: true });
                }
            }

        }, {
            name: 'shown',

            self: true,

            handler: function handler() {
                if (!isFocusable(this.$el)) {
                    attr(this.$el, 'tabindex', '-1');
                }

                if (!$(':focus', this.$el)) {
                    this.$el.focus();
                }
            }
        }, {

            name: 'hidden',

            self: true,

            handler: function handler() {
                var this$1$1 = this;

                if (includes(active, this)) {
                    active.splice(active.indexOf(this), 1);
                }

                if (!active.length) {
                    css(document.body, 'overflowY', '');
                }

                css(this.$el, 'zIndex', '');

                if (!active.some(function (modal) {
                    return modal.clsPage === this$1$1.clsPage;
                })) {
                    removeClass(document.documentElement, this.clsPage);
                }
            }

        }],

        methods: {

            toggle: function toggle() {
                return this.isToggled() ? this.hide() : this.show();
            },

            show: function show() {
                var this$1$1 = this;

                if (this.container && parent(this.$el) !== this.container) {
                    append(this.container, this.$el);
                    return new Promise$1(function (resolve) {
                        return requestAnimationFrame(function () {
                            return this$1$1.show().then(resolve);
                        });
                    });
                }

                return this.toggleElement(this.$el, true, animate(this));
            },

            hide: function hide() {
                return this.toggleElement(this.$el, false, animate(this));
            }

        }

    };

    function animate(ref) {
        var transitionElement = ref.transitionElement;
        var _toggle = ref._toggle;

        return function (el, show) {
            return new Promise$1(function (resolve, reject) {
                return once(el, 'show hide', function () {
                    el._reject && el._reject();
                    el._reject = reject;

                    _toggle(el, show);

                    var off = once(transitionElement, 'transitionstart', function () {
                        once(transitionElement, 'transitionend transitioncancel', resolve, { self: true });
                        clearTimeout(timer);
                    }, { self: true });

                    var timer = setTimeout(function () {
                        off();
                        resolve();
                    }, toMs(css(transitionElement, 'transitionDuration')));
                });
            }).then(function () {
                return delete el._reject;
            });
        };
    }

    var modal = {

        install: install$2,

        mixins: [Modal],

        data: {
            clsPage: 'uk-modal-page',
            selPanel: '.uk-modal-dialog',
            selClose: '.uk-modal-close, .uk-modal-close-default, .uk-modal-close-outside, .uk-modal-close-full'
        },

        events: [{
            name: 'show',

            self: true,

            handler: function handler() {

                if (hasClass(this.panel, 'uk-margin-auto-vertical')) {
                    addClass(this.$el, 'uk-flex');
                } else {
                    css(this.$el, 'display', 'block');
                }

                height(this.$el); // force reflow
            }
        }, {
            name: 'hidden',

            self: true,

            handler: function handler() {

                css(this.$el, 'display', '');
                removeClass(this.$el, 'uk-flex');
            }
        }]

    };

    function install$2(ref) {
        var modal = ref.modal;

        modal.dialog = function (content, options) {

            var dialog = modal("<div class=\"uk-modal\"> <div class=\"uk-modal-dialog\">" + content + "</div> </div>", options);

            dialog.show();

            on(dialog.$el, 'hidden', function () {
                return Promise$1.resolve().then(function () {
                    return dialog.$destroy(true);
                });
            }, { self: true });

            return dialog;
        };

        modal.alert = function (message, options) {
            return openDialog(function (ref) {
                var labels = ref.labels;

                return "<div class=\"uk-modal-body\">" + (isString(message) ? message : html(message)) + "</div> <div class=\"uk-modal-footer uk-text-right\"> <button class=\"uk-button uk-button-primary uk-modal-close\" autofocus>" + labels.ok + "</button> </div>";
            }, options, function (deferred) {
                return deferred.resolve();
            });
        };

        modal.confirm = function (message, options) {
            return openDialog(function (ref) {
                var labels = ref.labels;

                return "<form> <div class=\"uk-modal-body\">" + (isString(message) ? message : html(message)) + "</div> <div class=\"uk-modal-footer uk-text-right\"> <button class=\"uk-button uk-button-default uk-modal-close\" type=\"button\">" + labels.cancel + "</button> <button class=\"uk-button uk-button-primary\" autofocus>" + labels.ok + "</button> </div> </form>";
            }, options, function (deferred) {
                return deferred.reject();
            });
        };

        modal.prompt = function (message, value, options) {
            return openDialog(function (ref) {
                var labels = ref.labels;

                return "<form class=\"uk-form-stacked\"> <div class=\"uk-modal-body\"> <label>" + (isString(message) ? message : html(message)) + "</label> <input class=\"uk-input\" value=\"" + (value || '') + "\" autofocus> </div> <div class=\"uk-modal-footer uk-text-right\"> <button class=\"uk-button uk-button-default uk-modal-close\" type=\"button\">" + labels.cancel + "</button> <button class=\"uk-button uk-button-primary\">" + labels.ok + "</button> </div> </form>";
            }, options, function (deferred) {
                return deferred.resolve(null);
            }, function (dialog) {
                return $('input', dialog.$el).value;
            });
        };

        modal.labels = {
            ok: 'Ok',
            cancel: 'Cancel'
        };

        function openDialog(tmpl, options, hideFn, submitFn) {

            options = assign({ bgClose: false, escClose: true, labels: modal.labels }, options);

            var dialog = modal.dialog(tmpl(options), options);
            var deferred = new Deferred();

            var resolved = false;

            on(dialog.$el, 'submit', 'form', function (e) {
                e.preventDefault();
                deferred.resolve(submitFn && submitFn(dialog));
                resolved = true;
                dialog.hide();
            });

            on(dialog.$el, 'hide', function () {
                return !resolved && hideFn(deferred);
            });

            deferred.promise.dialog = dialog;

            return deferred.promise;
        }
    }

    var nav = {

        extends: Accordion,

        data: {
            targets: '> .uk-parent',
            toggle: '> a',
            content: '> ul'
        }

    };

    var navItem = '.uk-navbar-nav > li > a, .uk-navbar-item, .uk-navbar-toggle';

    var navbar = {

        mixins: [Class, Container, FlexBug],

        props: {
            dropdown: String,
            mode: 'list',
            align: String,
            offset: Number,
            boundary: Boolean,
            boundaryAlign: Boolean,
            clsDrop: String,
            delayShow: Number,
            delayHide: Number,
            dropbar: Boolean,
            dropbarMode: String,
            dropbarAnchor: Boolean,
            duration: Number
        },

        data: {
            dropdown: navItem,
            align: !isRtl ? 'left' : 'right',
            clsDrop: 'uk-navbar-dropdown',
            mode: undefined,
            offset: undefined,
            delayShow: undefined,
            delayHide: undefined,
            boundaryAlign: undefined,
            flip: 'x',
            boundary: true,
            dropbar: false,
            dropbarMode: 'slide',
            dropbarAnchor: false,
            duration: 200,
            forceHeight: true,
            selMinHeight: navItem,
            container: false
        },

        computed: {

            boundary: function boundary(ref, $el) {
                var boundary = ref.boundary;
                var boundaryAlign = ref.boundaryAlign;

                return boundary === true || boundaryAlign ? $el : boundary;
            },

            dropbarAnchor: function dropbarAnchor(ref, $el) {
                var dropbarAnchor = ref.dropbarAnchor;

                return query(dropbarAnchor, $el);
            },

            pos: function pos(ref) {
                var align = ref.align;

                return "bottom-" + align;
            },

            dropbar: {

                get: function get(ref) {
                    var dropbar = ref.dropbar;

                    if (!dropbar) {
                        return null;
                    }

                    dropbar = this._dropbar || query(dropbar, this.$el) || $('+ .uk-navbar-dropbar', this.$el);

                    return dropbar ? dropbar : this._dropbar = $('<div></div>');
                },

                watch: function watch(dropbar) {
                    addClass(dropbar, 'uk-navbar-dropbar');
                },

                immediate: true

            },

            dropContainer: function dropContainer(_, $el) {
                return this.container || $el;
            },

            dropdowns: {

                get: function get(ref, $el) {
                    var this$1$1 = this;
                    var clsDrop = ref.clsDrop;

                    var dropdowns = $$("." + clsDrop, $el);

                    if (this.dropContainer !== $el) {
                        $$("." + clsDrop, this.dropContainer).forEach(function (el) {
                            var dropdown = this$1$1.getDropdown(el);
                            if (!includes(dropdowns, el) && dropdown && dropdown.target && within(dropdown.target, this$1$1.$el)) {
                                dropdowns.push(el);
                            }
                        });
                    }

                    return dropdowns;
                },

                watch: function watch(dropdowns) {
                    var this$1$1 = this;

                    this.$create('drop', dropdowns.filter(function (el) {
                        return !this$1$1.getDropdown(el);
                    }), assign({}, this.$props, { boundary: this.boundary, pos: this.pos, offset: this.dropbar || this.offset }));
                },

                immediate: true

            },

            toggles: function toggles(ref, $el) {
                var dropdown = ref.dropdown;

                return $$(dropdown, $el);
            }

        },

        disconnected: function disconnected() {
            this.dropbar && remove$1(this.dropbar);
            delete this._dropbar;
        },

        events: [{
            name: 'mouseover focusin',

            delegate: function delegate() {
                return this.dropdown;
            },

            handler: function handler(ref) {
                var current = ref.current;

                var active = this.getActive();
                if (active && includes(active.mode, 'hover') && active.target && !within(active.target, current) && !active.tracker.movesTo(active.$el)) {
                    active.hide(false);
                }
            }

        }, {
            name: 'keydown',

            delegate: function delegate() {
                return this.dropdown;
            },

            handler: function handler(e) {

                var current = e.current;
                var keyCode = e.keyCode;
                var active = this.getActive();

                if (keyCode === keyMap.DOWN && hasAttr(current, 'aria-expanded')) {

                    e.preventDefault();

                    if (!active || active.target !== current) {
                        current.click();
                        once(this.dropContainer, 'show', function (ref) {
                            var target = ref.target;

                            return focusFirstFocusableElement(target);
                        });
                    } else {
                        focusFirstFocusableElement(active.$el);
                    }
                }

                handleNavItemNavigation(e, this.toggles, active);
            }
        }, {
            name: 'keydown',

            el: function el() {
                return this.dropContainer;
            },

            delegate: function delegate() {
                return "." + this.clsDrop;
            },

            handler: function handler(e) {

                var current = e.current;
                var keyCode = e.keyCode;

                if (!includes(this.dropdowns, current)) {
                    return;
                }

                var active = this.getActive();
                var elements = $$(selFocusable, current);
                var i = findIndex(elements, function (el) {
                    return matches(el, ':focus');
                });

                if (keyCode === keyMap.UP) {
                    e.preventDefault();
                    if (i > 0) {
                        elements[i - 1].focus();
                    }
                }

                if (keyCode === keyMap.DOWN) {
                    e.preventDefault();
                    if (i < elements.length - 1) {
                        elements[i + 1].focus();
                    }
                }

                if (keyCode === keyMap.ESC) {
                    active && active.target && active.target.focus();
                }

                handleNavItemNavigation(e, this.toggles, active);
            }
        }, {
            name: 'mouseleave',

            el: function el() {
                return this.dropbar;
            },

            filter: function filter() {
                return this.dropbar;
            },

            handler: function handler() {
                var active = this.getActive();

                if (active && includes(active.mode, 'hover') && !this.dropdowns.some(function (el) {
                    return matches(el, ':hover');
                })) {
                    active.hide();
                }
            }
        }, {
            name: 'beforeshow',

            el: function el() {
                return this.dropContainer;
            },

            filter: function filter() {
                return this.dropbar;
            },

            handler: function handler() {

                if (!parent(this.dropbar)) {
                    after(this.dropbarAnchor || this.$el, this.dropbar);
                }
            }
        }, {
            name: 'show',

            el: function el() {
                return this.dropContainer;
            },

            filter: function filter() {
                return this.dropbar;
            },

            handler: function handler(_, ref) {
                var $el = ref.$el;
                var dir = ref.dir;

                if (!hasClass($el, this.clsDrop)) {
                    return;
                }

                if (this.dropbarMode === 'slide') {
                    addClass(this.dropbar, 'uk-navbar-dropbar-slide');
                }

                this.clsDrop && addClass($el, this.clsDrop + "-dropbar");

                if (dir === 'bottom') {
                    this.transitionTo($el.offsetHeight + toFloat(css($el, 'marginTop')) + toFloat(css($el, 'marginBottom')), $el);
                }
            }
        }, {
            name: 'beforehide',

            el: function el() {
                return this.dropContainer;
            },

            filter: function filter() {
                return this.dropbar;
            },

            handler: function handler(e, ref) {
                var $el = ref.$el;

                var active = this.getActive();

                if (matches(this.dropbar, ':hover') && active && active.$el === $el) {
                    e.preventDefault();
                }
            }
        }, {
            name: 'hide',

            el: function el() {
                return this.dropContainer;
            },

            filter: function filter() {
                return this.dropbar;
            },

            handler: function handler(_, ref) {
                var $el = ref.$el;

                if (!hasClass($el, this.clsDrop)) {
                    return;
                }

                var active = this.getActive();

                if (!active || active && active.$el === $el) {
                    this.transitionTo(0);
                }
            }
        }],

        methods: {

            getActive: function getActive() {
                return active$1 && within(active$1.target, this.$el) && active$1;
            },

            transitionTo: function transitionTo(newHeight, el) {
                var this$1$1 = this;

                var ref = this;
                var dropbar = ref.dropbar;
                var oldHeight = isVisible(dropbar) ? height(dropbar) : 0;

                el = oldHeight < newHeight && el;

                css(el, 'clip', "rect(0," + el.offsetWidth + "px," + oldHeight + "px,0)");

                height(dropbar, oldHeight);

                Transition.cancel([el, dropbar]);
                return Promise$1.all([Transition.start(dropbar, { height: newHeight }, this.duration), Transition.start(el, { clip: "rect(0," + el.offsetWidth + "px," + newHeight + "px,0)" }, this.duration)]).catch(noop).then(function () {
                    css(el, { clip: '' });
                    this$1$1.$update(dropbar);
                });
            },

            getDropdown: function getDropdown(el) {
                return this.$getComponent(el, 'drop') || this.$getComponent(el, 'dropdown');
            }

        }

    };

    function handleNavItemNavigation(e, toggles, active) {

        var current = e.current;
        var keyCode = e.keyCode;
        var target = active && active.target || current;
        var i = toggles.indexOf(target);

        // Left
        if (keyCode === keyMap.LEFT && i > 0) {
            active && active.hide(false);
            toggles[i - 1].focus();
        }

        // Right
        if (keyCode === keyMap.RIGHT && i < toggles.length - 1) {
            active && active.hide(false);
            toggles[i + 1].focus();
        }

        if (keyCode === keyMap.TAB) {
            target.focus();
            active && active.hide(false);
        }
    }

    function focusFirstFocusableElement(el) {
        if (!$(':focus', el)) {
            var focusEl = $(selFocusable, el);
            if (focusEl) {
                focusEl.focus();
            }
        }
    }

    var keyMap = {
        TAB: 9,
        ESC: 27,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
    };

    var offcanvas = {

        mixins: [Modal],

        args: 'mode',

        props: {
            mode: String,
            flip: Boolean,
            overlay: Boolean
        },

        data: {
            mode: 'slide',
            flip: false,
            overlay: false,
            clsPage: 'uk-offcanvas-page',
            clsContainer: 'uk-offcanvas-container',
            selPanel: '.uk-offcanvas-bar',
            clsFlip: 'uk-offcanvas-flip',
            clsContainerAnimation: 'uk-offcanvas-container-animation',
            clsSidebarAnimation: 'uk-offcanvas-bar-animation',
            clsMode: 'uk-offcanvas',
            clsOverlay: 'uk-offcanvas-overlay',
            selClose: '.uk-offcanvas-close',
            container: false
        },

        computed: {

            clsFlip: function clsFlip(ref) {
                var flip = ref.flip;
                var clsFlip = ref.clsFlip;

                return flip ? clsFlip : '';
            },

            clsOverlay: function clsOverlay(ref) {
                var overlay = ref.overlay;
                var clsOverlay = ref.clsOverlay;

                return overlay ? clsOverlay : '';
            },

            clsMode: function clsMode(ref) {
                var mode = ref.mode;
                var clsMode = ref.clsMode;

                return clsMode + "-" + mode;
            },

            clsSidebarAnimation: function clsSidebarAnimation(ref) {
                var mode = ref.mode;
                var clsSidebarAnimation = ref.clsSidebarAnimation;

                return mode === 'none' || mode === 'reveal' ? '' : clsSidebarAnimation;
            },

            clsContainerAnimation: function clsContainerAnimation(ref) {
                var mode = ref.mode;
                var clsContainerAnimation = ref.clsContainerAnimation;

                return mode !== 'push' && mode !== 'reveal' ? '' : clsContainerAnimation;
            },

            transitionElement: function transitionElement(ref) {
                var mode = ref.mode;

                return mode === 'reveal' ? parent(this.panel) : this.panel;
            }

        },

        update: {

            read: function read() {
                if (this.isToggled() && !isVisible(this.$el)) {
                    this.hide();
                }
            },

            events: ['resize']

        },

        events: [{

            name: 'click',

            delegate: function delegate() {
                return 'a[href^="#"]';
            },

            handler: function handler(ref) {
                var hash = ref.current.hash;
                var defaultPrevented = ref.defaultPrevented;

                if (!defaultPrevented && hash && $(hash, document.body)) {
                    this.hide();
                }
            }

        }, {
            name: 'touchstart',

            passive: true,

            el: function el() {
                return this.panel;
            },

            handler: function handler(ref) {
                var targetTouches = ref.targetTouches;

                if (targetTouches.length === 1) {
                    this.clientY = targetTouches[0].clientY;
                }
            }

        }, {
            name: 'touchmove',

            self: true,
            passive: false,

            filter: function filter() {
                return this.overlay;
            },

            handler: function handler(e) {
                e.cancelable && e.preventDefault();
            }

        }, {
            name: 'touchmove',

            passive: false,

            el: function el() {
                return this.panel;
            },

            handler: function handler(e) {

                if (e.targetTouches.length !== 1) {
                    return;
                }

                var clientY = e.targetTouches[0].clientY - this.clientY;
                var ref = this.panel;
                var scrollTop = ref.scrollTop;
                var scrollHeight = ref.scrollHeight;
                var clientHeight = ref.clientHeight;

                if (clientHeight >= scrollHeight || scrollTop === 0 && clientY > 0 || scrollHeight - scrollTop <= clientHeight && clientY < 0) {
                    e.cancelable && e.preventDefault();
                }
            }

        }, {
            name: 'show',

            self: true,

            handler: function handler() {

                if (this.mode === 'reveal' && !hasClass(parent(this.panel), this.clsMode)) {
                    wrapAll(this.panel, '<div>');
                    addClass(parent(this.panel), this.clsMode);
                }

                css(document.documentElement, 'overflowY', this.overlay ? 'hidden' : '');
                addClass(document.body, this.clsContainer, this.clsFlip);
                css(document.body, 'touch-action', 'pan-y pinch-zoom');
                css(this.$el, 'display', 'block');
                addClass(this.$el, this.clsOverlay);
                addClass(this.panel, this.clsSidebarAnimation, this.mode !== 'reveal' ? this.clsMode : '');

                height(document.body); // force reflow
                addClass(document.body, this.clsContainerAnimation);

                this.clsContainerAnimation && suppressUserScale();
            }
        }, {
            name: 'hide',

            self: true,

            handler: function handler() {
                removeClass(document.body, this.clsContainerAnimation);
                css(document.body, 'touch-action', '');
            }
        }, {
            name: 'hidden',

            self: true,

            handler: function handler() {

                this.clsContainerAnimation && resumeUserScale();

                if (this.mode === 'reveal') {
                    unwrap(this.panel);
                }

                removeClass(this.panel, this.clsSidebarAnimation, this.clsMode);
                removeClass(this.$el, this.clsOverlay);
                css(this.$el, 'display', '');
                removeClass(document.body, this.clsContainer, this.clsFlip);

                css(document.documentElement, 'overflowY', '');
            }
        }, {
            name: 'swipeLeft swipeRight',

            handler: function handler(e) {

                if (this.isToggled() && endsWith(e.type, 'Left') ^ this.flip) {
                    this.hide();
                }
            }
        }]

    };

    // Chrome in responsive mode zooms page upon opening offcanvas
    function suppressUserScale() {
        getViewport().content += ',user-scalable=0';
    }

    function resumeUserScale() {
        var viewport = getViewport();
        viewport.content = viewport.content.replace(/,user-scalable=0$/, '');
    }

    function getViewport() {
        return $('meta[name="viewport"]', document.head) || append(document.head, '<meta name="viewport">');
    }

    var overflowAuto = {

        mixins: [Class],

        props: {
            selContainer: String,
            selContent: String,
            minHeight: Number
        },

        data: {
            selContainer: '.uk-modal',
            selContent: '.uk-modal-dialog',
            minHeight: 150
        },

        computed: {

            container: function container(ref, $el) {
                var selContainer = ref.selContainer;

                return closest($el, selContainer);
            },

            content: function content(ref, $el) {
                var selContent = ref.selContent;

                return closest($el, selContent);
            }

        },

        connected: function connected() {
            css(this.$el, 'minHeight', this.minHeight);
        },

        update: {

            read: function read() {

                if (!this.content || !this.container || !isVisible(this.$el)) {
                    return false;
                }

                return {
                    current: toFloat(css(this.$el, 'maxHeight')),
                    max: Math.max(this.minHeight, height(this.container) - (dimensions(this.content).height - height(this.$el)))
                };
            },

            write: function write(ref) {
                var current = ref.current;
                var max = ref.max;

                css(this.$el, 'maxHeight', max);
                if (Math.round(current) !== Math.round(max)) {
                    trigger(this.$el, 'resize');
                }
            },

            events: ['resize']

        }

    };

    var responsive = {

        props: ['width', 'height'],

        connected: function connected() {
            addClass(this.$el, 'uk-responsive-width');
        },

        update: {

            read: function read() {
                return isVisible(this.$el) && this.width && this.height ? { width: width(parent(this.$el)), height: this.height } : false;
            },

            write: function write(dim) {
                height(this.$el, Dimensions.contain({
                    height: this.height,
                    width: this.width
                }, dim).height);
            },

            events: ['resize']

        }

    };

    var scroll = {

        props: {
            offset: Number
        },

        data: {
            offset: 0
        },

        methods: {

            scrollTo: function scrollTo(el) {
                var this$1$1 = this;

                el = el && $(el) || document.body;

                if (trigger(this.$el, 'beforescroll', [this, el])) {
                    scrollIntoView(el, { offset: this.offset }).then(function () {
                        return trigger(this$1$1.$el, 'scrolled', [this$1$1, el]);
                    });
                }
            }

        },

        events: {

            click: function click(e) {

                if (e.defaultPrevented) {
                    return;
                }

                e.preventDefault();
                this.scrollTo("#" + escape(decodeURIComponent((this.$el.hash || '').substr(1))));
            }

        }

    };

    var stateKey = '_ukScrollspy';
    var scrollspy = {

        args: 'cls',

        props: {
            cls: String,
            target: String,
            hidden: Boolean,
            offsetTop: Number,
            offsetLeft: Number,
            repeat: Boolean,
            delay: Number
        },

        data: function data() {
            return {
                cls: false,
                target: false,
                hidden: true,
                offsetTop: 0,
                offsetLeft: 0,
                repeat: false,
                delay: 0,
                inViewClass: 'uk-scrollspy-inview'
            };
        },

        computed: {

            elements: {

                get: function get(ref, $el) {
                    var target = ref.target;

                    return target ? $$(target, $el) : [$el];
                },

                watch: function watch(elements) {
                    if (this.hidden) {
                        css(filter$1(elements, ":not(." + this.inViewClass + ")"), 'visibility', 'hidden');
                    }
                },

                immediate: true

            }

        },

        disconnected: function disconnected() {
            var this$1$1 = this;

            this.elements.forEach(function (el) {
                removeClass(el, this$1$1.inViewClass, el[stateKey] ? el[stateKey].cls : '');
                delete el[stateKey];
            });
        },

        update: [{

            read: function read(data$1) {
                var this$1$1 = this;

                // Let child components be applied at least once first
                if (!data$1.update) {
                    Promise$1.resolve().then(function () {
                        this$1$1.$emit();
                        data$1.update = true;
                    });
                    return false;
                }

                this.elements.forEach(function (el) {

                    if (!el[stateKey]) {
                        el[stateKey] = { cls: data(el, 'uk-scrollspy-class') || this$1$1.cls };
                    }

                    el[stateKey].show = isInView(el, this$1$1.offsetTop, this$1$1.offsetLeft);
                });
            },

            write: function write(data) {
                var this$1$1 = this;

                this.elements.forEach(function (el) {

                    var state = el[stateKey];

                    if (state.show && !state.inview && !state.queued) {

                        state.queued = true;

                        data.promise = (data.promise || Promise$1.resolve()).then(function () {
                            return new Promise$1(function (resolve) {
                                return setTimeout(resolve, this$1$1.delay);
                            });
                        }).then(function () {
                            this$1$1.toggle(el, true);
                            setTimeout(function () {
                                state.queued = false;
                                this$1$1.$emit();
                            }, 300);
                        });
                    } else if (!state.show && state.inview && !state.queued && this$1$1.repeat) {

                        this$1$1.toggle(el, false);
                    }
                });
            },

            events: ['scroll', 'resize']

        }],

        methods: {

            toggle: function toggle(el, inview) {

                var state = el[stateKey];

                state.off && state.off();

                css(el, 'visibility', !inview && this.hidden ? 'hidden' : '');

                toggleClass(el, this.inViewClass, inview);
                toggleClass(el, state.cls);

                if (/\buk-animation-/.test(state.cls)) {
                    state.off = once(el, 'animationcancel animationend', function () {
                        return removeClasses(el, 'uk-animation-[\\w-]+');
                    });
                }

                trigger(el, inview ? 'inview' : 'outview');

                state.inview = inview;

                this.$update(el);
            }

        }

    };

    var scrollspyNav = {

        props: {
            cls: String,
            closest: String,
            scroll: Boolean,
            overflow: Boolean,
            offset: Number
        },

        data: {
            cls: 'uk-active',
            closest: false,
            scroll: false,
            overflow: true,
            offset: 0
        },

        computed: {

            links: {

                get: function get(_, $el) {
                    return $$('a[href^="#"]', $el).filter(function (el) {
                        return el.hash;
                    });
                },

                watch: function watch(links) {
                    if (this.scroll) {
                        this.$create('scroll', links, { offset: this.offset || 0 });
                    }
                },

                immediate: true

            },

            targets: function targets() {
                return $$(this.links.map(function (el) {
                    return escape(el.hash).substr(1);
                }).join(','));
            },

            elements: function elements(ref) {
                var selector = ref.closest;

                return closest(this.links, selector || '*');
            }

        },

        update: [{

            read: function read() {
                var this$1$1 = this;

                var ref = this.targets;
                var length = ref.length;

                if (!length || !isVisible(this.$el)) {
                    return false;
                }

                var ref$1 = scrollParents(this.targets, /auto|scroll/, true);
                var scrollElement = ref$1[0];
                var scrollTop = scrollElement.scrollTop;
                var scrollHeight = scrollElement.scrollHeight;
                var max = scrollHeight - getViewportClientHeight(scrollElement);
                var active = false;

                if (scrollTop === max) {
                    active = length - 1;
                } else {

                    this.targets.every(function (el, i) {
                        if (offset(el).top - offset(getViewport$1(scrollElement)).top - this$1$1.offset <= 0) {
                            active = i;
                            return true;
                        }
                    });

                    if (active === false && this.overflow) {
                        active = 0;
                    }
                }

                return { active: active };
            },

            write: function write(ref) {
                var active = ref.active;

                var changed = active !== false && !hasClass(this.elements[active], this.cls);

                this.links.forEach(function (el) {
                    return el.blur();
                });
                removeClass(this.elements, this.cls);
                addClass(this.elements[active], this.cls);

                if (changed) {
                    trigger(this.$el, 'active', [active, this.elements[active]]);
                }
            },

            events: ['scroll', 'resize']

        }]

    };

    var sticky = {

        mixins: [Class, Media],

        props: {
            top: null,
            bottom: Boolean,
            offset: String,
            animation: String,
            clsActive: String,
            clsInactive: String,
            clsFixed: String,
            clsBelow: String,
            selTarget: String,
            widthElement: Boolean,
            showOnUp: Boolean,
            targetOffset: Number
        },

        data: {
            top: 0,
            bottom: false,
            offset: 0,
            animation: '',
            clsActive: 'uk-active',
            clsInactive: '',
            clsFixed: 'uk-sticky-fixed',
            clsBelow: 'uk-sticky-below',
            selTarget: '',
            widthElement: false,
            showOnUp: false,
            targetOffset: false
        },

        computed: {

            offset: function offset(ref) {
                var offset = ref.offset;

                return toPx(offset);
            },

            selTarget: function selTarget(ref, $el) {
                var selTarget = ref.selTarget;

                return selTarget && $(selTarget, $el) || $el;
            },

            widthElement: function widthElement(ref, $el) {
                var widthElement = ref.widthElement;

                return query(widthElement, $el) || this.placeholder;
            },

            isActive: {

                get: function get() {
                    return hasClass(this.selTarget, this.clsActive);
                },

                set: function set(value) {
                    if (value && !this.isActive) {
                        replaceClass(this.selTarget, this.clsInactive, this.clsActive);
                        trigger(this.$el, 'active');
                    } else if (!value && !hasClass(this.selTarget, this.clsInactive)) {
                        replaceClass(this.selTarget, this.clsActive, this.clsInactive);
                        trigger(this.$el, 'inactive');
                    }
                }

            }

        },

        connected: function connected() {
            this.placeholder = $('+ .uk-sticky-placeholder', this.$el) || $('<div class="uk-sticky-placeholder"></div>');
            this.isFixed = false;
            this.isActive = false;
        },

        disconnected: function disconnected() {

            if (this.isFixed) {
                this.hide();
                removeClass(this.selTarget, this.clsInactive);
            }

            remove$1(this.placeholder);
            this.placeholder = null;
            this.widthElement = null;
        },

        events: [{

            name: 'load hashchange popstate',

            el: function el() {
                return window;
            },

            handler: function handler() {
                var this$1$1 = this;

                if (!(this.targetOffset !== false && location.hash && window.pageYOffset > 0)) {
                    return;
                }

                var target = $(location.hash);

                if (target) {
                    fastdom.read(function () {

                        var ref = offset(target);
                        var top = ref.top;
                        var elTop = offset(this$1$1.$el).top;
                        var elHeight = this$1$1.$el.offsetHeight;

                        if (this$1$1.isFixed && elTop + elHeight >= top && elTop <= top + target.offsetHeight) {
                            scrollTop(window, top - elHeight - (isNumeric(this$1$1.targetOffset) ? this$1$1.targetOffset : 0) - this$1$1.offset);
                        }
                    });
                }
            }

        }],

        update: [{

            read: function read(ref, types) {
                var height = ref.height;

                this.inactive = !this.matchMedia || !isVisible(this.$el);

                if (this.inactive) {
                    return false;
                }

                if (this.isActive && types.has('resize')) {
                    this.hide();
                    height = this.$el.offsetHeight;
                    this.show();
                }

                height = !this.isActive ? this.$el.offsetHeight : height;

                var referenceElement = this.isFixed ? this.placeholder : this.$el;
                this.topOffset = offset(referenceElement).top;
                this.bottomOffset = this.topOffset + height;
                this.offsetParentTop = offset(referenceElement.offsetParent).top;

                var bottom = parseProp('bottom', this);

                this.top = Math.max(toFloat(parseProp('top', this)), this.topOffset) - this.offset;
                this.bottom = bottom && bottom - this.$el.offsetHeight;
                this.width = dimensions(isVisible(this.widthElement) ? this.widthElement : this.$el).width;

                return {
                    height: height,
                    top: offsetPosition(this.placeholder)[0],
                    margins: css(this.$el, ['marginTop', 'marginBottom', 'marginLeft', 'marginRight'])
                };
            },

            write: function write(ref) {
                var height = ref.height;
                var margins = ref.margins;

                var ref$1 = this;
                var placeholder = ref$1.placeholder;

                css(placeholder, assign({ height: height }, margins));

                if (!within(placeholder, document)) {
                    after(this.$el, placeholder);
                    placeholder.hidden = true;
                }

                this.isActive = !!this.isActive; // force self-assign
            },

            events: ['resize']

        }, {

            read: function read(ref) {
                var scroll = ref.scroll;if (scroll === void 0) scroll = 0;

                this.scroll = window.pageYOffset;

                return {
                    dir: scroll <= this.scroll ? 'down' : 'up',
                    scroll: this.scroll
                };
            },

            write: function write(data, types) {
                var this$1$1 = this;

                var now = Date.now();
                var isScrollUpdate = types.has('scroll');
                var initTimestamp = data.initTimestamp;if (initTimestamp === void 0) initTimestamp = 0;
                var dir = data.dir;
                var lastDir = data.lastDir;
                var lastScroll = data.lastScroll;
                var scroll = data.scroll;
                var top = data.top;

                data.lastScroll = scroll;

                if (scroll < 0 || scroll === lastScroll && isScrollUpdate || this.showOnUp && !isScrollUpdate && !this.isFixed) {
                    return;
                }

                if (now - initTimestamp > 300 || dir !== lastDir) {
                    data.initScroll = scroll;
                    data.initTimestamp = now;
                }

                data.lastDir = dir;

                if (this.showOnUp && !this.isFixed && Math.abs(data.initScroll - scroll) <= 30 && Math.abs(lastScroll - scroll) <= 10) {
                    return;
                }

                if (this.inactive || scroll < this.top || this.showOnUp && (scroll <= this.top || dir === 'down' && isScrollUpdate || dir === 'up' && !this.isFixed && scroll <= this.bottomOffset)) {

                    if (!this.isFixed) {

                        if (Animation.inProgress(this.$el) && top > scroll) {
                            Animation.cancel(this.$el);
                            this.hide();
                        }

                        return;
                    }

                    this.isFixed = false;

                    if (this.animation && scroll > this.topOffset) {
                        Animation.cancel(this.$el);
                        Animation.out(this.$el, this.animation).then(function () {
                            return this$1$1.hide();
                        }, noop);
                    } else {
                        this.hide();
                    }
                } else if (this.isFixed) {

                    this.update();
                } else if (this.animation) {

                    Animation.cancel(this.$el);
                    this.show();
                    Animation.in(this.$el, this.animation).catch(noop);
                } else {
                    this.show();
                }
            },

            events: ['resize', 'scroll']

        }],

        methods: {

            show: function show() {

                this.isFixed = true;
                this.update();
                this.placeholder.hidden = false;
            },

            hide: function hide() {

                this.isActive = false;
                removeClass(this.$el, this.clsFixed, this.clsBelow);
                css(this.$el, { position: '', top: '', width: '' });
                this.placeholder.hidden = true;
            },

            update: function update() {

                var active = this.top !== 0 || this.scroll > this.top;
                var top = Math.max(0, this.offset);
                var position = 'fixed';

                if (isNumeric(this.bottom) && this.scroll > this.bottom - this.offset) {
                    top = this.bottom - this.offsetParentTop;
                    position = 'absolute';
                }

                css(this.$el, {
                    position: position,
                    top: top + "px",
                    width: this.width
                });

                this.isActive = active;
                toggleClass(this.$el, this.clsBelow, this.scroll > this.bottomOffset);
                addClass(this.$el, this.clsFixed);
            }

        }

    };

    function parseProp(prop, ref) {
        var $props = ref.$props;
        var $el = ref.$el;
        var propOffset = ref[prop + "Offset"];

        var value = $props[prop];

        if (!value) {
            return;
        }

        if (isString(value) && value.match(/^-?\d/)) {

            return propOffset + toPx(value);
        } else {

            return offset(value === true ? parent($el) : query(value, $el)).bottom;
        }
    }

    var Switcher = {

        mixins: [Togglable],

        args: 'connect',

        props: {
            connect: String,
            toggle: String,
            itemNav: String,
            active: Number,
            swiping: Boolean
        },

        data: {
            connect: '~.uk-switcher',
            toggle: '> * > :first-child',
            itemNav: false,
            active: 0,
            swiping: true,
            cls: 'uk-active',
            attrItem: 'uk-switcher-item'
        },

        computed: {

            connects: {

                get: function get(ref, $el) {
                    var connect = ref.connect;

                    return queryAll(connect, $el);
                },

                watch: function watch(connects) {
                    var this$1$1 = this;

                    if (this.swiping) {
                        css(connects, 'touch-action', 'pan-y pinch-zoom');
                    }

                    var index = this.index();
                    this.connects.forEach(function (el) {
                        return _children(el).forEach(function (child, i) {
                            return toggleClass(child, this$1$1.cls, i === index);
                        });
                    });
                },

                immediate: true

            },

            toggles: {

                get: function get(ref, $el) {
                    var toggle = ref.toggle;

                    return $$(toggle, $el).filter(function (el) {
                        return !matches(el, '.uk-disabled *, .uk-disabled, [disabled]');
                    });
                },

                watch: function watch(toggles) {
                    var active = this.index();
                    this.show(~active ? active : toggles[this.active] || toggles[0]);
                },

                immediate: true

            },

            children: function children() {
                var this$1$1 = this;

                return _children(this.$el).filter(function (child) {
                    return this$1$1.toggles.some(function (toggle) {
                        return within(toggle, child);
                    });
                });
            }

        },

        events: [{

            name: 'click',

            delegate: function delegate() {
                return this.toggle;
            },

            handler: function handler(e) {
                e.preventDefault();
                this.show(e.current);
            }

        }, {
            name: 'click',

            el: function el() {
                return this.connects.concat(this.itemNav ? queryAll(this.itemNav, this.$el) : []);
            },

            delegate: function delegate() {
                return "[" + this.attrItem + "],[data-" + this.attrItem + "]";
            },

            handler: function handler(e) {
                e.preventDefault();
                this.show(data(e.current, this.attrItem));
            }
        }, {
            name: 'swipeRight swipeLeft',

            filter: function filter() {
                return this.swiping;
            },

            el: function el() {
                return this.connects;
            },

            handler: function handler(ref) {
                var type = ref.type;

                this.show(endsWith(type, 'Left') ? 'next' : 'previous');
            }
        }],

        methods: {

            index: function index() {
                var this$1$1 = this;

                return findIndex(this.children, function (el) {
                    return hasClass(el, this$1$1.cls);
                });
            },

            show: function show(item) {
                var this$1$1 = this;

                var prev = this.index();
                var next = _getIndex(this.children[_getIndex(item, this.toggles, prev)], _children(this.$el));

                if (prev === next) {
                    return;
                }

                this.children.forEach(function (child, i) {
                    toggleClass(child, this$1$1.cls, next === i);
                    attr(this$1$1.toggles[i], 'aria-expanded', next === i);
                });

                this.connects.forEach(function (ref) {
                    var children = ref.children;

                    return this$1$1.toggleElement(toNodes(children).filter(function (child) {
                        return hasClass(child, this$1$1.cls);
                    }), false, prev >= 0).then(function () {
                        return this$1$1.toggleElement(children[next], true, prev >= 0);
                    });
                });
            }

        }

    };

    var tab = {

        mixins: [Class],

        extends: Switcher,

        props: {
            media: Boolean
        },

        data: {
            media: 960,
            attrItem: 'uk-tab-item'
        },

        connected: function connected() {

            var cls = hasClass(this.$el, 'uk-tab-left') ? 'uk-tab-left' : hasClass(this.$el, 'uk-tab-right') ? 'uk-tab-right' : false;

            if (cls) {
                this.$create('toggle', this.$el, { cls: cls, mode: 'media', media: this.media });
            }
        }

    };

    var toggle = {

        mixins: [Media, Togglable],

        args: 'target',

        props: {
            href: String,
            target: null,
            mode: 'list',
            queued: Boolean
        },

        data: {
            href: false,
            target: false,
            mode: 'click',
            queued: true
        },

        connected: function connected() {
            if (!includes(this.mode, 'media') && !isFocusable(this.$el)) {
                attr(this.$el, 'tabindex', '0');
            }
        },

        computed: {

            target: {

                get: function get(ref, $el) {
                    var href = ref.href;
                    var target = ref.target;

                    target = queryAll(target || href, $el);
                    return target.length && target || [$el];
                },

                watch: function watch() {
                    this.updateAria();
                },

                immediate: true

            }

        },

        events: [{
            name: pointerDown,

            filter: function filter() {
                return includes(this.mode, 'hover');
            },

            handler: function handler(e) {
                var this$1$1 = this;

                if (!isTouch(e) || this._showState) {
                    return;
                }

                // Clicking a button does not give it focus on all browsers and platforms
                // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#clicking_and_focus
                trigger(this.$el, 'focus');
                once(document, pointerDown, function () {
                    return trigger(this$1$1.$el, 'blur');
                }, true, function (e) {
                    return !within(e.target, this$1$1.$el);
                });

                // Prevent initial click to prevent double toggle through focus + click
                if (includes(this.mode, 'click')) {
                    this._preventClick = true;
                }
            }
        }, {

            name: pointerEnter + " " + pointerLeave + " focus blur",

            filter: function filter() {
                return includes(this.mode, 'hover');
            },

            handler: function handler(e) {
                if (isTouch(e)) {
                    return;
                }

                var show = includes([pointerEnter, 'focus'], e.type);
                var expanded = attr(this.$el, 'aria-expanded');

                // Skip hide if still hovered or focused
                if (!show && (e.type === pointerLeave && matches(this.$el, ':focus') || e.type === 'blur' && matches(this.$el, ':hover'))) {
                    return;
                }

                // Skip if state does not change e.g. hover + focus received
                if (this._showState && show === (expanded !== this._showState)) {

                    // Ensure reset if state has changed through click
                    if (!show) {
                        this._showState = null;
                    }
                    return;
                }

                this._showState = show ? expanded : null;

                this.toggle("toggle" + (show ? 'show' : 'hide'));
            }

        }, {
            name: 'keydown',

            filter: function filter() {
                return includes(this.mode, 'click');
            },

            handler: function handler(e) {
                // Space
                if (e.keyCode === 32) {
                    e.preventDefault();
                    this.$el.click();
                }
            }
        }, {

            name: 'click',

            filter: function filter() {
                return includes(this.mode, 'click');
            },

            handler: function handler(e) {

                if (this._preventClick) {
                    return this._preventClick = null;
                }

                var link;
                if (closest(e.target, 'a[href="#"], a[href=""]') || (link = closest(e.target, 'a[href]')) && (attr(this.$el, 'aria-expanded') !== 'true' || link.hash && matches(this.target, link.hash))) {
                    e.preventDefault();
                }

                this.toggle();
            }

        }, {

            name: 'toggled',

            self: true,

            el: function el() {
                return this.target;
            },

            handler: function handler(e, toggled) {
                if (e.target === this.target[0]) {
                    this.updateAria(toggled);
                }
            }
        }],

        update: {

            read: function read() {
                return includes(this.mode, 'media') && this.media ? { match: this.matchMedia } : false;
            },

            write: function write(ref) {
                var match = ref.match;

                var toggled = this.isToggled(this.target);
                if (match ? !toggled : toggled) {
                    this.toggle();
                }
            },

            events: ['resize']

        },

        methods: {

            toggle: function toggle(type) {
                var this$1$1 = this;

                if (!trigger(this.target, type || 'toggle', [this])) {
                    return;
                }

                if (!this.queued) {
                    return this.toggleElement(this.target);
                }

                var leaving = this.target.filter(function (el) {
                    return hasClass(el, this$1$1.clsLeave);
                });

                if (leaving.length) {
                    this.target.forEach(function (el) {
                        var isLeaving = includes(leaving, el);
                        this$1$1.toggleElement(el, isLeaving, isLeaving);
                    });
                    return;
                }

                var toggled = this.target.filter(this.isToggled);
                this.toggleElement(toggled, false).then(function () {
                    return this$1$1.toggleElement(this$1$1.target.filter(function (el) {
                        return !includes(toggled, el);
                    }), true);
                });
            },

            updateAria: function updateAria(toggled) {
                if (includes(this.mode, 'media')) {
                    return;
                }

                attr(this.$el, 'aria-expanded', isBoolean(toggled) ? toggled : this.isToggled(this.target));
            }

        }

    };

    var components$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        Accordion: Accordion,
        Alert: alert,
        Cover: cover,
        Drop: drop,
        Dropdown: drop,
        FormCustom: formCustom,
        Gif: gif,
        Grid: grid,
        HeightMatch: heightMatch,
        HeightViewport: heightViewport,
        Icon: Icon,
        Img: img,
        Leader: leader,
        Margin: Margin,
        Modal: modal,
        Nav: nav,
        Navbar: navbar,
        Offcanvas: offcanvas,
        OverflowAuto: overflowAuto,
        Responsive: responsive,
        Scroll: scroll,
        Scrollspy: scrollspy,
        ScrollspyNav: scrollspyNav,
        Sticky: sticky,
        Svg: SVG,
        Switcher: Switcher,
        Tab: tab,
        Toggle: toggle,
        Video: Video,
        Close: Close,
        Spinner: Spinner,
        SlidenavNext: Slidenav,
        SlidenavPrevious: Slidenav,
        SearchIcon: Search,
        Marker: IconComponent,
        NavbarToggleIcon: IconComponent,
        OverlayIcon: IconComponent,
        PaginationNext: IconComponent,
        PaginationPrevious: IconComponent,
        Totop: IconComponent
    });

    // register components
    each(components$1, function (component, name) {
        return UIkit.component(name, component);
    });

    // core functionality
    UIkit.use(Core);

    boot(UIkit);

    var countdown = {

        mixins: [Class],

        props: {
            date: String,
            clsWrapper: String
        },

        data: {
            date: '',
            clsWrapper: '.uk-countdown-%unit%'
        },

        computed: {

            date: function date(ref) {
                var date = ref.date;

                return Date.parse(date);
            },

            days: function days(ref, $el) {
                var clsWrapper = ref.clsWrapper;

                return $(clsWrapper.replace('%unit%', 'days'), $el);
            },

            hours: function hours(ref, $el) {
                var clsWrapper = ref.clsWrapper;

                return $(clsWrapper.replace('%unit%', 'hours'), $el);
            },

            minutes: function minutes(ref, $el) {
                var clsWrapper = ref.clsWrapper;

                return $(clsWrapper.replace('%unit%', 'minutes'), $el);
            },

            seconds: function seconds(ref, $el) {
                var clsWrapper = ref.clsWrapper;

                return $(clsWrapper.replace('%unit%', 'seconds'), $el);
            },

            units: function units() {
                var this$1$1 = this;

                return ['days', 'hours', 'minutes', 'seconds'].filter(function (unit) {
                    return this$1$1[unit];
                });
            }

        },

        connected: function connected() {
            this.start();
        },

        disconnected: function disconnected() {
            var this$1$1 = this;

            this.stop();
            this.units.forEach(function (unit) {
                return empty(this$1$1[unit]);
            });
        },

        events: [{

            name: 'visibilitychange',

            el: function el() {
                return document;
            },

            handler: function handler() {
                if (document.hidden) {
                    this.stop();
                } else {
                    this.start();
                }
            }

        }],

        update: {

            write: function write() {
                var this$1$1 = this;

                var timespan = getTimeSpan(this.date);

                if (timespan.total <= 0) {

                    this.stop();

                    timespan.days = timespan.hours = timespan.minutes = timespan.seconds = 0;
                }

                this.units.forEach(function (unit) {

                    var digits = String(Math.floor(timespan[unit]));

                    digits = digits.length < 2 ? "0" + digits : digits;

                    var el = this$1$1[unit];
                    if (el.textContent !== digits) {
                        digits = digits.split('');

                        if (digits.length !== el.children.length) {
                            html(el, digits.map(function () {
                                return '<span></span>';
                            }).join(''));
                        }

                        digits.forEach(function (digit, i) {
                            return el.children[i].textContent = digit;
                        });
                    }
                });
            }

        },

        methods: {

            start: function start() {

                this.stop();

                if (this.date && this.units.length) {
                    this.$update();
                    this.timer = setInterval(this.$update, 1000);
                }
            },

            stop: function stop() {

                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }

        }

    };

    function getTimeSpan(date) {

        var total = date - Date.now();

        return {
            total: total,
            seconds: total / 1000 % 60,
            minutes: total / 1000 / 60 % 60,
            hours: total / 1000 / 60 / 60 % 24,
            days: total / 1000 / 60 / 60 / 24
        };
    }

    var clsLeave = 'uk-transition-leave';
    var clsEnter = 'uk-transition-enter';

    function fade(action, target, duration, stagger) {
        if (stagger === void 0) stagger = 0;

        var index = transitionIndex(target, true);
        var propsIn = { opacity: 1 };
        var propsOut = { opacity: 0 };

        var wrapIndexFn = function wrapIndexFn(fn) {
            return function () {
                return index === transitionIndex(target) ? fn() : Promise$1.reject();
            };
        };

        var leaveFn = wrapIndexFn(function () {

            addClass(target, clsLeave);

            return Promise$1.all(getTransitionNodes(target).map(function (child, i) {
                return new Promise$1(function (resolve) {
                    return setTimeout(function () {
                        return Transition.start(child, propsOut, duration / 2, 'ease').then(resolve);
                    }, i * stagger);
                });
            })).then(function () {
                return removeClass(target, clsLeave);
            });
        });

        var enterFn = wrapIndexFn(function () {

            var oldHeight = height(target);

            addClass(target, clsEnter);
            action();

            css(_children(target), { opacity: 0 });

            // Ensure UIkit updates have propagated
            return new Promise$1(function (resolve) {
                return requestAnimationFrame(function () {

                    var nodes = _children(target);
                    var newHeight = height(target);

                    // Ensure Grid cells do not stretch when height is applied
                    css(target, 'alignContent', 'flex-start');
                    height(target, oldHeight);

                    var transitionNodes = getTransitionNodes(target);
                    css(nodes, propsOut);

                    var transitions = transitionNodes.map(function (child, i) {
                        return new Promise$1(function (resolve) {
                            return setTimeout(function () {
                                return Transition.start(child, propsIn, duration / 2, 'ease').then(resolve);
                            }, i * stagger);
                        });
                    });

                    if (oldHeight !== newHeight) {
                        transitions.push(Transition.start(target, { height: newHeight }, duration / 2 + transitionNodes.length * stagger, 'ease'));
                    }

                    Promise$1.all(transitions).then(function () {
                        removeClass(target, clsEnter);
                        if (index === transitionIndex(target)) {
                            css(target, { height: '', alignContent: '' });
                            css(nodes, { opacity: '' });
                            delete target.dataset.transition;
                        }
                        resolve();
                    });
                });
            });
        });

        return hasClass(target, clsLeave) ? waitTransitionend(target).then(enterFn) : hasClass(target, clsEnter) ? waitTransitionend(target).then(leaveFn).then(enterFn) : leaveFn().then(enterFn);
    }

    function transitionIndex(target, next) {
        if (next) {
            target.dataset.transition = 1 + transitionIndex(target);
        }

        return toNumber(target.dataset.transition) || 0;
    }

    function waitTransitionend(target) {
        return Promise$1.all(_children(target).filter(Transition.inProgress).map(function (el) {
            return new Promise$1(function (resolve) {
                return once(el, 'transitionend transitioncanceled', resolve);
            });
        }));
    }

    function getTransitionNodes(target) {
        return getRows(_children(target)).reduce(function (nodes, row) {
            return nodes.concat(sortBy$1(row.filter(function (el) {
                return isInView(el);
            }), 'offsetLeft'));
        }, []);
    }

    function slide(action, target, duration) {

        return new Promise$1(function (resolve) {
            return requestAnimationFrame(function () {

                var nodes = _children(target);

                // Get current state
                var currentProps = nodes.map(function (el) {
                    return getProps(el, true);
                });
                var targetProps = css(target, ['height', 'padding']);

                // Cancel previous animations
                Transition.cancel(target);
                nodes.forEach(Transition.cancel);
                reset(target);

                // Adding, sorting, removing nodes
                action();

                // Find new nodes
                nodes = nodes.concat(_children(target).filter(function (el) {
                    return !includes(nodes, el);
                }));

                // Wait for update to propagate
                Promise$1.resolve().then(function () {

                    // Force update
                    fastdom.flush();

                    // Get new state
                    var targetPropsTo = css(target, ['height', 'padding']);
                    var ref = getTransitionProps(target, nodes, currentProps);
                    var propsTo = ref[0];
                    var propsFrom = ref[1];

                    // Reset to previous state
                    nodes.forEach(function (el, i) {
                        return propsFrom[i] && css(el, propsFrom[i]);
                    });
                    css(target, assign({ display: 'block' }, targetProps));

                    // Start transitions on next frame
                    requestAnimationFrame(function () {

                        var transitions = nodes.map(function (el, i) {
                            return parent(el) === target && Transition.start(el, propsTo[i], duration, 'ease');
                        }).concat(Transition.start(target, targetPropsTo, duration, 'ease'));

                        Promise$1.all(transitions).then(function () {
                            nodes.forEach(function (el, i) {
                                return parent(el) === target && css(el, 'display', propsTo[i].opacity === 0 ? 'none' : '');
                            });
                            reset(target);
                        }, noop).then(resolve);
                    });
                });
            });
        });
    }

    function getProps(el, opacity) {

        var zIndex = css(el, 'zIndex');

        return isVisible(el) ? assign({
            display: '',
            opacity: opacity ? css(el, 'opacity') : '0',
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: zIndex === 'auto' ? index(el) : zIndex
        }, getPositionWithMargin(el)) : false;
    }

    function getTransitionProps(target, nodes, currentProps) {

        var propsTo = nodes.map(function (el, i) {
            return parent(el) && i in currentProps ? currentProps[i] ? isVisible(el) ? getPositionWithMargin(el) : { opacity: 0 } : { opacity: isVisible(el) ? 1 : 0 } : false;
        });

        var propsFrom = propsTo.map(function (props, i) {

            var from = parent(nodes[i]) === target && (currentProps[i] || getProps(nodes[i]));

            if (!from) {
                return false;
            }

            if (!props) {
                delete from.opacity;
            } else if (!('opacity' in props)) {
                var opacity = from.opacity;

                if (opacity % 1) {
                    props.opacity = 1;
                } else {
                    delete from.opacity;
                }
            }

            return from;
        });

        return [propsTo, propsFrom];
    }

    function reset(el) {
        css(el.children, {
            height: '',
            left: '',
            opacity: '',
            pointerEvents: '',
            position: '',
            top: '',
            marginTop: '',
            marginLeft: '',
            transform: '',
            width: '',
            zIndex: ''
        });
        css(el, { height: '', display: '', padding: '' });
    }

    function getPositionWithMargin(el) {
        var ref = offset(el);
        var height = ref.height;
        var width = ref.width;
        var ref$1 = position(el);
        var top = ref$1.top;
        var left = ref$1.left;
        var ref$2 = css(el, ['marginTop', 'marginLeft']);
        var marginLeft = ref$2.marginLeft;
        var marginTop = ref$2.marginTop;

        return { top: top, left: left, height: height, width: width, marginLeft: marginLeft, marginTop: marginTop, transform: '' };
    }

    var Animate = {

        props: {
            duration: Number,
            animation: Boolean
        },

        data: {
            duration: 150,
            animation: 'slide'
        },

        methods: {

            animate: function animate(action, target) {
                var this$1$1 = this;
                if (target === void 0) target = this.$el;

                var name = this.animation;
                var animationFn = name === 'fade' ? fade : name === 'delayed-fade' ? function () {
                    var args = [],
                        len = arguments.length;
                    while (len--) {
                        args[len] = arguments[len];
                    }return fade.apply(void 0, args.concat([40]));
                } : !name ? function () {
                    action();
                    return Promise$1.resolve();
                } : slide;

                return animationFn(action, target, this.duration).then(function () {
                    return this$1$1.$update(target, 'resize');
                }, noop);
            }

        }
    };

    var filter = {

        mixins: [Animate],

        args: 'target',

        props: {
            target: Boolean,
            selActive: Boolean
        },

        data: {
            target: null,
            selActive: false,
            attrItem: 'uk-filter-control',
            cls: 'uk-active',
            duration: 250
        },

        computed: {

            toggles: {

                get: function get(ref, $el) {
                    var attrItem = ref.attrItem;

                    return $$("[" + attrItem + "],[data-" + attrItem + "]", $el);
                },

                watch: function watch() {
                    var this$1$1 = this;

                    this.updateState();

                    if (this.selActive !== false) {
                        var actives = $$(this.selActive, this.$el);
                        this.toggles.forEach(function (el) {
                            return toggleClass(el, this$1$1.cls, includes(actives, el));
                        });
                    }
                },

                immediate: true

            },

            children: {

                get: function get(ref, $el) {
                    var target = ref.target;

                    return $$(target + " > *", $el);
                },

                watch: function watch(list, old) {
                    if (old && !isEqualList(list, old)) {
                        this.updateState();
                    }
                },

                immediate: true

            }

        },

        events: [{

            name: 'click',

            delegate: function delegate() {
                return "[" + this.attrItem + "],[data-" + this.attrItem + "]";
            },

            handler: function handler(e) {

                e.preventDefault();
                this.apply(e.current);
            }

        }],

        methods: {

            apply: function apply(el) {
                var prevState = this.getState();
                var newState = mergeState(el, this.attrItem, this.getState());

                if (!isEqualState(prevState, newState)) {
                    this.setState(newState);
                }
            },

            getState: function getState() {
                var this$1$1 = this;

                return this.toggles.filter(function (item) {
                    return hasClass(item, this$1$1.cls);
                }).reduce(function (state, el) {
                    return mergeState(el, this$1$1.attrItem, state);
                }, { filter: { '': '' }, sort: [] });
            },

            setState: function setState(state, animate) {
                var this$1$1 = this;
                if (animate === void 0) animate = true;

                state = assign({ filter: { '': '' }, sort: [] }, state);

                trigger(this.$el, 'beforeFilter', [this, state]);

                this.toggles.forEach(function (el) {
                    return toggleClass(el, this$1$1.cls, !!matchFilter(el, this$1$1.attrItem, state));
                });

                Promise$1.all($$(this.target, this.$el).map(function (target) {
                    var filterFn = function filterFn() {
                        applyState(state, target, _children(target));
                        this$1$1.$update(this$1$1.$el);
                    };
                    return animate ? this$1$1.animate(filterFn, target) : filterFn();
                })).then(function () {
                    return trigger(this$1$1.$el, 'afterFilter', [this$1$1]);
                });
            },

            updateState: function updateState() {
                var this$1$1 = this;

                fastdom.write(function () {
                    return this$1$1.setState(this$1$1.getState(), false);
                });
            }

        }

    };

    function getFilter(el, attr) {
        return parseOptions(data(el, attr), ['filter']);
    }

    function isEqualState(stateA, stateB) {
        return ['filter', 'sort'].every(function (prop) {
            return isEqual(stateA[prop], stateB[prop]);
        });
    }

    function applyState(state, target, children) {
        var selector = getSelector(state);

        children.forEach(function (el) {
            return css(el, 'display', selector && !matches(el, selector) ? 'none' : '');
        });

        var ref = state.sort;
        var sort = ref[0];
        var order = ref[1];

        if (sort) {
            var sorted = sortItems(children, sort, order);
            if (!isEqual(sorted, children)) {
                append(target, sorted);
            }
        }
    }

    function mergeState(el, attr, state) {

        var filterBy = getFilter(el, attr);
        var filter = filterBy.filter;
        var group = filterBy.group;
        var sort = filterBy.sort;
        var order = filterBy.order;if (order === void 0) order = 'asc';

        if (filter || isUndefined(sort)) {

            if (group) {

                if (filter) {
                    delete state.filter[''];
                    state.filter[group] = filter;
                } else {
                    delete state.filter[group];

                    if (isEmpty(state.filter) || '' in state.filter) {
                        state.filter = { '': filter || '' };
                    }
                }
            } else {
                state.filter = { '': filter || '' };
            }
        }

        if (!isUndefined(sort)) {
            state.sort = [sort, order];
        }

        return state;
    }

    function matchFilter(el, attr, ref) {
        var stateFilter = ref.filter;if (stateFilter === void 0) stateFilter = { '': '' };
        var ref_sort = ref.sort;
        var stateSort = ref_sort[0];
        var stateOrder = ref_sort[1];

        var ref$1 = getFilter(el, attr);
        var filter = ref$1.filter;if (filter === void 0) filter = '';
        var group = ref$1.group;if (group === void 0) group = '';
        var sort = ref$1.sort;
        var order = ref$1.order;if (order === void 0) order = 'asc';

        return isUndefined(sort) ? group in stateFilter && filter === stateFilter[group] || !filter && group && !(group in stateFilter) && !stateFilter[''] : stateSort === sort && stateOrder === order;
    }

    function isEqualList(listA, listB) {
        return listA.length === listB.length && listA.every(function (el) {
            return ~listB.indexOf(el);
        });
    }

    function getSelector(ref) {
        var filter = ref.filter;

        var selector = '';
        each(filter, function (value) {
            return selector += value || '';
        });
        return selector;
    }

    function sortItems(nodes, sort, order) {
        return assign([], nodes).sort(function (a, b) {
            return data(a, sort).localeCompare(data(b, sort), undefined, { numeric: true }) * (order === 'asc' || -1);
        });
    }

    var Animations$2 = {

        slide: {

            show: function show(dir) {
                return [{ transform: _translate(dir * -100) }, { transform: _translate() }];
            },

            percent: function percent(current) {
                return translated(current);
            },

            translate: function translate(percent, dir) {
                return [{ transform: _translate(dir * -100 * percent) }, { transform: _translate(dir * 100 * (1 - percent)) }];
            }

        }

    };

    function translated(el) {
        return Math.abs(css(el, 'transform').split(',')[4] / el.offsetWidth) || 0;
    }

    function _translate(value, unit) {
        if (value === void 0) value = 0;
        if (unit === void 0) unit = '%';

        value += value ? unit : '';
        return isIE ? "translateX(" + value + ")" : "translate3d(" + value + ", 0, 0)"; // currently not translate3d in IE, translate3d within translate3d does not work while transitioning
    }

    function scale3d(value) {
        return "scale3d(" + value + ", " + value + ", 1)";
    }

    var Animations$1 = assign({}, Animations$2, {

        fade: {

            show: function show() {
                return [{ opacity: 0 }, { opacity: 1 }];
            },

            percent: function percent(current) {
                return 1 - css(current, 'opacity');
            },

            translate: function translate(percent) {
                return [{ opacity: 1 - percent }, { opacity: percent }];
            }

        },

        scale: {

            show: function show() {
                return [{ opacity: 0, transform: scale3d(1 - .2) }, { opacity: 1, transform: scale3d(1) }];
            },

            percent: function percent(current) {
                return 1 - css(current, 'opacity');
            },

            translate: function translate(percent) {
                return [{ opacity: 1 - percent, transform: scale3d(1 - .2 * percent) }, { opacity: percent, transform: scale3d(1 - .2 + .2 * percent) }];
            }

        }

    });

    function Transitioner$1(prev, next, dir, ref) {
        var animation = ref.animation;
        var easing = ref.easing;

        var _percent = animation.percent;
        var _translate2 = animation.translate;
        var show = animation.show;if (show === void 0) show = noop;
        var props = show(dir);
        var deferred = new Deferred();

        return {

            dir: dir,

            show: function show(duration, percent, linear) {
                var this$1$1 = this;
                if (percent === void 0) percent = 0;

                var timing = linear ? 'linear' : easing;
                duration -= Math.round(duration * clamp(percent, -1, 1));

                this.translate(percent);

                triggerUpdate$1(next, 'itemin', { percent: percent, duration: duration, timing: timing, dir: dir });
                triggerUpdate$1(prev, 'itemout', { percent: 1 - percent, duration: duration, timing: timing, dir: dir });

                Promise$1.all([Transition.start(next, props[1], duration, timing), Transition.start(prev, props[0], duration, timing)]).then(function () {
                    this$1$1.reset();
                    deferred.resolve();
                }, noop);

                return deferred.promise;
            },

            cancel: function cancel() {
                Transition.cancel([next, prev]);
            },

            reset: function reset() {
                for (var prop in props[0]) {
                    css([next, prev], prop, '');
                }
            },

            forward: function forward(duration, percent) {
                if (percent === void 0) percent = this.percent();

                Transition.cancel([next, prev]);
                return this.show(duration, percent, true);
            },

            translate: function translate(percent) {

                this.reset();

                var props = _translate2(percent, dir);
                css(next, props[1]);
                css(prev, props[0]);
                triggerUpdate$1(next, 'itemtranslatein', { percent: percent, dir: dir });
                triggerUpdate$1(prev, 'itemtranslateout', { percent: 1 - percent, dir: dir });
            },

            percent: function percent() {
                return _percent(prev || next, next, dir);
            },

            getDistance: function getDistance() {
                return prev && prev.offsetWidth;
            }

        };
    }

    function triggerUpdate$1(el, type, data) {
        trigger(el, createEvent(type, false, false, data));
    }

    var SliderAutoplay = {

        props: {
            autoplay: Boolean,
            autoplayInterval: Number,
            pauseOnHover: Boolean
        },

        data: {
            autoplay: false,
            autoplayInterval: 7000,
            pauseOnHover: true
        },

        connected: function connected() {
            this.autoplay && this.startAutoplay();
        },

        disconnected: function disconnected() {
            this.stopAutoplay();
        },

        update: function update() {
            attr(this.slides, 'tabindex', '-1');
        },

        events: [{

            name: 'visibilitychange',

            el: function el() {
                return document;
            },

            filter: function filter() {
                return this.autoplay;
            },

            handler: function handler() {
                if (document.hidden) {
                    this.stopAutoplay();
                } else {
                    this.startAutoplay();
                }
            }

        }],

        methods: {

            startAutoplay: function startAutoplay() {
                var this$1$1 = this;

                this.stopAutoplay();

                this.interval = setInterval(function () {
                    return (!this$1$1.draggable || !$(':focus', this$1$1.$el)) && (!this$1$1.pauseOnHover || !matches(this$1$1.$el, ':hover')) && !this$1$1.stack.length && this$1$1.show('next');
                }, this.autoplayInterval);
            },

            stopAutoplay: function stopAutoplay() {
                this.interval && clearInterval(this.interval);
            }

        }

    };

    var SliderDrag = {

        props: {
            draggable: Boolean
        },

        data: {
            draggable: true,
            threshold: 10
        },

        created: function created() {
            var this$1$1 = this;

            ['start', 'move', 'end'].forEach(function (key) {

                var fn = this$1$1[key];
                this$1$1[key] = function (e) {

                    var pos = getEventPos(e).x * (isRtl ? -1 : 1);

                    this$1$1.prevPos = pos !== this$1$1.pos ? this$1$1.pos : this$1$1.prevPos;
                    this$1$1.pos = pos;

                    fn(e);
                };
            });
        },

        events: [{

            name: pointerDown,

            delegate: function delegate() {
                return this.selSlides;
            },

            handler: function handler(e) {

                if (!this.draggable || !isTouch(e) && hasTextNodesOnly(e.target) || closest(e.target, selInput) || e.button > 0 || this.length < 2) {
                    return;
                }

                this.start(e);
            }

        }, {
            name: 'dragstart',

            handler: function handler(e) {
                e.preventDefault();
            }
        }],

        methods: {

            start: function start() {

                this.drag = this.pos;

                if (this._transitioner) {

                    this.percent = this._transitioner.percent();
                    this.drag += this._transitioner.getDistance() * this.percent * this.dir;

                    this._transitioner.cancel();
                    this._transitioner.translate(this.percent);

                    this.dragging = true;

                    this.stack = [];
                } else {
                    this.prevIndex = this.index;
                }

                on(document, pointerMove, this.move, { passive: false });

                // 'input' event is triggered by video controls
                on(document, pointerUp + " " + pointerCancel + " input", this.end, true);

                css(this.list, 'userSelect', 'none');
            },

            move: function move(e) {
                var this$1$1 = this;

                var distance = this.pos - this.drag;

                if (distance === 0 || this.prevPos === this.pos || !this.dragging && Math.abs(distance) < this.threshold) {
                    return;
                }

                // prevent click event
                css(this.list, 'pointerEvents', 'none');

                e.cancelable && e.preventDefault();

                this.dragging = true;
                this.dir = distance < 0 ? 1 : -1;

                var ref = this;
                var slides = ref.slides;
                var ref$1 = this;
                var prevIndex = ref$1.prevIndex;
                var dis = Math.abs(distance);
                var nextIndex = this.getIndex(prevIndex + this.dir, prevIndex);
                var width = this._getDistance(prevIndex, nextIndex) || slides[prevIndex].offsetWidth;

                while (nextIndex !== prevIndex && dis > width) {

                    this.drag -= width * this.dir;

                    prevIndex = nextIndex;
                    dis -= width;
                    nextIndex = this.getIndex(prevIndex + this.dir, prevIndex);
                    width = this._getDistance(prevIndex, nextIndex) || slides[prevIndex].offsetWidth;
                }

                this.percent = dis / width;

                var prev = slides[prevIndex];
                var next = slides[nextIndex];
                var changed = this.index !== nextIndex;
                var edge = prevIndex === nextIndex;

                var itemShown;

                [this.index, this.prevIndex].filter(function (i) {
                    return !includes([nextIndex, prevIndex], i);
                }).forEach(function (i) {
                    trigger(slides[i], 'itemhidden', [this$1$1]);

                    if (edge) {
                        itemShown = true;
                        this$1$1.prevIndex = prevIndex;
                    }
                });

                if (this.index === prevIndex && this.prevIndex !== prevIndex || itemShown) {
                    trigger(slides[this.index], 'itemshown', [this]);
                }

                if (changed) {
                    this.prevIndex = prevIndex;
                    this.index = nextIndex;

                    !edge && trigger(prev, 'beforeitemhide', [this]);
                    trigger(next, 'beforeitemshow', [this]);
                }

                this._transitioner = this._translate(Math.abs(this.percent), prev, !edge && next);

                if (changed) {
                    !edge && trigger(prev, 'itemhide', [this]);
                    trigger(next, 'itemshow', [this]);
                }
            },

            end: function end() {

                off(document, pointerMove, this.move, { passive: false });
                off(document, pointerUp + " " + pointerCancel + " input", this.end, true);

                if (this.dragging) {

                    this.dragging = null;

                    if (this.index === this.prevIndex) {
                        this.percent = 1 - this.percent;
                        this.dir *= -1;
                        this._show(false, this.index, true);
                        this._transitioner = null;
                    } else {

                        var dirChange = (isRtl ? this.dir * (isRtl ? 1 : -1) : this.dir) < 0 === this.prevPos > this.pos;
                        this.index = dirChange ? this.index : this.prevIndex;

                        if (dirChange) {
                            this.percent = 1 - this.percent;
                        }

                        this.show(this.dir > 0 && !dirChange || this.dir < 0 && dirChange ? 'next' : 'previous', true);
                    }
                }

                css(this.list, { userSelect: '', pointerEvents: '' });

                this.drag = this.percent = null;
            }

        }

    };

    function hasTextNodesOnly(el) {
        return !el.children.length && el.childNodes.length;
    }

    var SliderNav = {

        data: {
            selNav: false
        },

        computed: {

            nav: function nav(ref, $el) {
                var selNav = ref.selNav;

                return $(selNav, $el);
            },

            selNavItem: function selNavItem(ref) {
                var attrItem = ref.attrItem;

                return "[" + attrItem + "],[data-" + attrItem + "]";
            },

            navItems: function navItems(_, $el) {
                return $$(this.selNavItem, $el);
            }

        },

        update: {

            write: function write() {
                var this$1$1 = this;

                if (this.nav && this.length !== this.nav.children.length) {
                    html(this.nav, this.slides.map(function (_, i) {
                        return "<li " + this$1$1.attrItem + "=\"" + i + "\"><a href></a></li>";
                    }).join(''));
                }

                this.navItems.concat(this.nav).forEach(function (el) {
                    return el && (el.hidden = !this$1$1.maxIndex);
                });

                this.updateNav();
            },

            events: ['resize']

        },

        events: [{

            name: 'click',

            delegate: function delegate() {
                return this.selNavItem;
            },

            handler: function handler(e) {
                e.preventDefault();
                this.show(data(e.current, this.attrItem));
            }

        }, {

            name: 'itemshow',
            handler: 'updateNav'

        }],

        methods: {

            updateNav: function updateNav() {
                var this$1$1 = this;

                var i = this.getValidIndex();
                this.navItems.forEach(function (el) {

                    var cmd = data(el, this$1$1.attrItem);

                    toggleClass(el, this$1$1.clsActive, toNumber(cmd) === i);
                    toggleClass(el, 'uk-invisible', this$1$1.finite && (cmd === 'previous' && i === 0 || cmd === 'next' && i >= this$1$1.maxIndex));
                });
            }

        }

    };

    var Slider = {

        mixins: [SliderAutoplay, SliderDrag, SliderNav],

        props: {
            clsActivated: Boolean,
            easing: String,
            index: Number,
            finite: Boolean,
            velocity: Number,
            selSlides: String
        },

        data: function data() {
            return {
                easing: 'ease',
                finite: false,
                velocity: 1,
                index: 0,
                prevIndex: -1,
                stack: [],
                percent: 0,
                clsActive: 'uk-active',
                clsActivated: false,
                Transitioner: false,
                transitionOptions: {}
            };
        },

        connected: function connected() {
            this.prevIndex = -1;
            this.index = this.getValidIndex(this.$props.index);
            this.stack = [];
        },

        disconnected: function disconnected() {
            removeClass(this.slides, this.clsActive);
        },

        computed: {

            duration: function duration(ref, $el) {
                var velocity = ref.velocity;

                return speedUp($el.offsetWidth / velocity);
            },

            list: function list(ref, $el) {
                var selList = ref.selList;

                return $(selList, $el);
            },

            maxIndex: function maxIndex() {
                return this.length - 1;
            },

            selSlides: function selSlides(ref) {
                var selList = ref.selList;
                var selSlides = ref.selSlides;

                return selList + " " + (selSlides || '> *');
            },

            slides: {

                get: function get() {
                    return $$(this.selSlides, this.$el);
                },

                watch: function watch() {
                    this.$reset();
                }

            },

            length: function length() {
                return this.slides.length;
            }

        },

        events: {

            itemshown: function itemshown() {
                this.$update(this.list);
            }

        },

        methods: {

            show: function show(index, force) {
                var this$1$1 = this;
                if (force === void 0) force = false;

                if (this.dragging || !this.length) {
                    return;
                }

                var ref = this;
                var stack = ref.stack;
                var queueIndex = force ? 0 : stack.length;
                var reset = function reset() {
                    stack.splice(queueIndex, 1);

                    if (stack.length) {
                        this$1$1.show(stack.shift(), true);
                    }
                };

                stack[force ? 'unshift' : 'push'](index);

                if (!force && stack.length > 1) {

                    if (stack.length === 2) {
                        this._transitioner.forward(Math.min(this.duration, 200));
                    }

                    return;
                }

                var prevIndex = this.getIndex(this.index);
                var prev = hasClass(this.slides, this.clsActive) && this.slides[prevIndex];
                var nextIndex = this.getIndex(index, this.index);
                var next = this.slides[nextIndex];

                if (prev === next) {
                    reset();
                    return;
                }

                this.dir = getDirection(index, prevIndex);
                this.prevIndex = prevIndex;
                this.index = nextIndex;

                if (prev && !trigger(prev, 'beforeitemhide', [this]) || !trigger(next, 'beforeitemshow', [this, prev])) {
                    this.index = this.prevIndex;
                    reset();
                    return;
                }

                var promise = this._show(prev, next, force).then(function () {

                    prev && trigger(prev, 'itemhidden', [this$1$1]);
                    trigger(next, 'itemshown', [this$1$1]);

                    return new Promise$1(function (resolve) {
                        fastdom.write(function () {
                            stack.shift();
                            if (stack.length) {
                                this$1$1.show(stack.shift(), true);
                            } else {
                                this$1$1._transitioner = null;
                            }
                            resolve();
                        });
                    });
                });

                prev && trigger(prev, 'itemhide', [this]);
                trigger(next, 'itemshow', [this]);

                return promise;
            },

            getIndex: function getIndex(index, prev) {
                if (index === void 0) index = this.index;
                if (prev === void 0) prev = this.index;

                return clamp(_getIndex(index, this.slides, prev, this.finite), 0, this.maxIndex);
            },

            getValidIndex: function getValidIndex(index, prevIndex) {
                if (index === void 0) index = this.index;
                if (prevIndex === void 0) prevIndex = this.prevIndex;

                return this.getIndex(index, prevIndex);
            },

            _show: function _show(prev, next, force) {

                this._transitioner = this._getTransitioner(prev, next, this.dir, assign({
                    easing: force ? next.offsetWidth < 600 ? 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' /* easeOutQuad */
                    : 'cubic-bezier(0.165, 0.84, 0.44, 1)' /* easeOutQuart */
                    : this.easing
                }, this.transitionOptions));

                if (!force && !prev) {
                    this._translate(1);
                    return Promise$1.resolve();
                }

                var ref = this.stack;
                var length = ref.length;
                return this._transitioner[length > 1 ? 'forward' : 'show'](length > 1 ? Math.min(this.duration, 75 + 75 / (length - 1)) : this.duration, this.percent);
            },

            _getDistance: function _getDistance(prev, next) {
                return this._getTransitioner(prev, prev !== next && next).getDistance();
            },

            _translate: function _translate(percent, prev, next) {
                if (prev === void 0) prev = this.prevIndex;
                if (next === void 0) next = this.index;

                var transitioner = this._getTransitioner(prev !== next ? prev : false, next);
                transitioner.translate(percent);
                return transitioner;
            },

            _getTransitioner: function _getTransitioner(prev, next, dir, options) {
                if (prev === void 0) prev = this.prevIndex;
                if (next === void 0) next = this.index;
                if (dir === void 0) dir = this.dir || 1;
                if (options === void 0) options = this.transitionOptions;

                return new this.Transitioner(isNumber(prev) ? this.slides[prev] : prev, isNumber(next) ? this.slides[next] : next, dir * (isRtl ? -1 : 1), options);
            }

        }

    };

    function getDirection(index, prevIndex) {
        return index === 'next' ? 1 : index === 'previous' ? -1 : index < prevIndex ? -1 : 1;
    }

    function speedUp(x) {
        return .5 * x + 300; // parabola through (400,500; 600,600; 1800,1200)
    }

    var Slideshow = {

        mixins: [Slider],

        props: {
            animation: String
        },

        data: {
            animation: 'slide',
            clsActivated: 'uk-transition-active',
            Animations: Animations$2,
            Transitioner: Transitioner$1
        },

        computed: {

            animation: function animation(ref) {
                var animation = ref.animation;
                var Animations = ref.Animations;

                return assign(Animations[animation] || Animations.slide, { name: animation });
            },

            transitionOptions: function transitionOptions() {
                return { animation: this.animation };
            }

        },

        events: {

            'itemshow itemhide itemshown itemhidden': function itemshowItemhideItemshownItemhidden(ref) {
                var target = ref.target;

                this.$update(target);
            },

            beforeitemshow: function beforeitemshow(ref) {
                var target = ref.target;

                addClass(target, this.clsActive);
            },

            itemshown: function itemshown(ref) {
                var target = ref.target;

                addClass(target, this.clsActivated);
            },

            itemhidden: function itemhidden(ref) {
                var target = ref.target;

                removeClass(target, this.clsActive, this.clsActivated);
            }

        }

    };

    var LightboxPanel = {

        mixins: [Container, Modal, Togglable, Slideshow],

        functional: true,

        props: {
            delayControls: Number,
            preload: Number,
            videoAutoplay: Boolean,
            template: String
        },

        data: function data() {
            return {
                preload: 1,
                videoAutoplay: false,
                delayControls: 3000,
                items: [],
                cls: 'uk-open',
                clsPage: 'uk-lightbox-page',
                selList: '.uk-lightbox-items',
                attrItem: 'uk-lightbox-item',
                selClose: '.uk-close-large',
                selCaption: '.uk-lightbox-caption',
                pauseOnHover: false,
                velocity: 2,
                Animations: Animations$1,
                template: "<div class=\"uk-lightbox uk-overflow-hidden\"> <ul class=\"uk-lightbox-items\"></ul> <div class=\"uk-lightbox-toolbar uk-position-top uk-text-right uk-transition-slide-top uk-transition-opaque\"> <button class=\"uk-lightbox-toolbar-icon uk-close-large\" type=\"button\" uk-close></button> </div> <a class=\"uk-lightbox-button uk-position-center-left uk-position-medium uk-transition-fade\" href uk-slidenav-previous uk-lightbox-item=\"previous\"></a> <a class=\"uk-lightbox-button uk-position-center-right uk-position-medium uk-transition-fade\" href uk-slidenav-next uk-lightbox-item=\"next\"></a> <div class=\"uk-lightbox-toolbar uk-lightbox-caption uk-position-bottom uk-text-center uk-transition-slide-bottom uk-transition-opaque\"></div> </div>"
            };
        },

        created: function created() {

            var $el = $(this.template);
            var list = $(this.selList, $el);
            this.items.forEach(function () {
                return append(list, '<li>');
            });

            this.$mount(append(this.container, $el));
        },

        computed: {

            caption: function caption(ref, $el) {
                var selCaption = ref.selCaption;

                return $(selCaption, $el);
            }

        },

        events: [{

            name: pointerMove + " " + pointerDown + " keydown",

            handler: 'showControls'

        }, {

            name: 'click',

            self: true,

            delegate: function delegate() {
                return this.selSlides;
            },

            handler: function handler(e) {

                if (e.defaultPrevented) {
                    return;
                }

                this.hide();
            }

        }, {

            name: 'shown',

            self: true,

            handler: function handler() {
                this.showControls();
            }

        }, {

            name: 'hide',

            self: true,

            handler: function handler() {

                this.hideControls();

                removeClass(this.slides, this.clsActive);
                Transition.stop(this.slides);
            }
        }, {

            name: 'hidden',

            self: true,

            handler: function handler() {
                this.$destroy(true);
            }

        }, {

            name: 'keyup',

            el: function el() {
                return document;
            },

            handler: function handler(e) {

                if (!this.isToggled(this.$el) || !this.draggable) {
                    return;
                }

                switch (e.keyCode) {
                    case 37:
                        this.show('previous');
                        break;
                    case 39:
                        this.show('next');
                        break;
                }
            }
        }, {

            name: 'beforeitemshow',

            handler: function handler(e) {

                if (this.isToggled()) {
                    return;
                }

                this.draggable = false;

                e.preventDefault();

                this.toggleElement(this.$el, true, false);

                this.animation = Animations$1['scale'];
                removeClass(e.target, this.clsActive);
                this.stack.splice(1, 0, this.index);
            }

        }, {

            name: 'itemshow',

            handler: function handler() {

                html(this.caption, this.getItem().caption || '');

                for (var j = -this.preload; j <= this.preload; j++) {
                    this.loadItem(this.index + j);
                }
            }

        }, {

            name: 'itemshown',

            handler: function handler() {
                this.draggable = this.$props.draggable;
            }

        }, {

            name: 'itemload',

            handler: function handler(_, item) {
                var this$1$1 = this;

                var src = item.source;
                var type = item.type;
                var alt = item.alt;if (alt === void 0) alt = '';
                var poster = item.poster;
                var attrs = item.attrs;if (attrs === void 0) attrs = {};

                this.setItem(item, '<span uk-spinner></span>');

                if (!src) {
                    return;
                }

                var matches;
                var iframeAttrs = {
                    frameborder: '0',
                    allow: 'autoplay',
                    allowfullscreen: '',
                    style: 'max-width: 100%; box-sizing: border-box;',
                    'uk-responsive': '',
                    'uk-video': "" + this.videoAutoplay
                };

                // Image
                if (type === 'image' || src.match(/\.(avif|jpe?g|a?png|gif|svg|webp)($|\?)/i)) {

                    getImage(src, attrs.srcset, attrs.size).then(function (ref) {
                        var width = ref.width;
                        var height = ref.height;

                        return this$1$1.setItem(item, createEl('img', assign({ src: src, width: width, height: height, alt: alt }, attrs)));
                    }, function () {
                        return this$1$1.setError(item);
                    });

                    // Video
                } else if (type === 'video' || src.match(/\.(mp4|webm|ogv)($|\?)/i)) {

                    var video = createEl('video', assign({
                        src: src,
                        poster: poster,
                        controls: '',
                        playsinline: '',
                        'uk-video': "" + this.videoAutoplay
                    }, attrs));

                    on(video, 'loadedmetadata', function () {
                        attr(video, { width: video.videoWidth, height: video.videoHeight });
                        this$1$1.setItem(item, video);
                    });
                    on(video, 'error', function () {
                        return this$1$1.setError(item);
                    });

                    // Iframe
                } else if (type === 'iframe' || src.match(/\.(html|php)($|\?)/i)) {

                    this.setItem(item, createEl('iframe', assign({
                        src: src,
                        frameborder: '0',
                        allowfullscreen: '',
                        class: 'uk-lightbox-iframe'
                    }, attrs)));

                    // YouTube
                } else if (matches = src.match(/\/\/(?:.*?youtube(-nocookie)?\..*?[?&]v=|youtu\.be\/)([\w-]{11})[&?]?(.*)?/)) {

                    this.setItem(item, createEl('iframe', assign({
                        src: "https://www.youtube" + (matches[1] || '') + ".com/embed/" + matches[2] + (matches[3] ? "?" + matches[3] : ''),
                        width: 1920,
                        height: 1080
                    }, iframeAttrs, attrs)));

                    // Vimeo
                } else if (matches = src.match(/\/\/.*?vimeo\.[a-z]+\/(\d+)[&?]?(.*)?/)) {

                    ajax("https://vimeo.com/api/oembed.json?maxwidth=1920&url=" + encodeURI(src), {
                        responseType: 'json',
                        withCredentials: false
                    }).then(function (ref) {
                        var ref_response = ref.response;
                        var height = ref_response.height;
                        var width = ref_response.width;

                        return this$1$1.setItem(item, createEl('iframe', assign({
                            src: "https://player.vimeo.com/video/" + matches[1] + (matches[2] ? "?" + matches[2] : ''),
                            width: width,
                            height: height
                        }, iframeAttrs, attrs)));
                    }, function () {
                        return this$1$1.setError(item);
                    });
                }
            }

        }],

        methods: {

            loadItem: function loadItem(index) {
                if (index === void 0) index = this.index;

                var item = this.getItem(index);

                if (!this.getSlide(item).childElementCount) {
                    trigger(this.$el, 'itemload', [item]);
                }
            },

            getItem: function getItem(index) {
                if (index === void 0) index = this.index;

                return this.items[_getIndex(index, this.slides)];
            },

            setItem: function setItem(item, content) {
                trigger(this.$el, 'itemloaded', [this, html(this.getSlide(item), content)]);
            },

            getSlide: function getSlide(item) {
                return this.slides[this.items.indexOf(item)];
            },

            setError: function setError(item) {
                this.setItem(item, '<span uk-icon="icon: bolt; ratio: 2"></span>');
            },

            showControls: function showControls() {

                clearTimeout(this.controlsTimer);
                this.controlsTimer = setTimeout(this.hideControls, this.delayControls);

                addClass(this.$el, 'uk-active', 'uk-transition-active');
            },

            hideControls: function hideControls() {
                removeClass(this.$el, 'uk-active', 'uk-transition-active');
            }

        }

    };

    function createEl(tag, attrs) {
        var el = fragment("<" + tag + ">");
        attr(el, attrs);
        return el;
    }

    var lightbox = {

        install: install$1,

        props: { toggle: String },

        data: { toggle: 'a' },

        computed: {

            toggles: {

                get: function get(ref, $el) {
                    var toggle = ref.toggle;

                    return $$(toggle, $el);
                },

                watch: function watch() {
                    this.hide();
                }

            }

        },

        disconnected: function disconnected() {
            this.hide();
        },

        events: [{

            name: 'click',

            delegate: function delegate() {
                return this.toggle + ":not(.uk-disabled)";
            },

            handler: function handler(e) {
                e.preventDefault();
                this.show(e.current);
            }

        }],

        methods: {

            show: function show(index) {
                var this$1$1 = this;

                var items = uniqueBy(this.toggles.map(toItem), 'source');

                if (isElement(index)) {
                    var ref = toItem(index);
                    var source = ref.source;
                    index = findIndex(items, function (ref) {
                        var src = ref.source;

                        return source === src;
                    });
                }

                this.panel = this.panel || this.$create('lightboxPanel', assign({}, this.$props, { items: items }));

                on(this.panel.$el, 'hidden', function () {
                    return this$1$1.panel = false;
                });

                return this.panel.show(index);
            },

            hide: function hide() {

                return this.panel && this.panel.hide();
            }

        }

    };

    function install$1(UIkit, Lightbox) {

        if (!UIkit.lightboxPanel) {
            UIkit.component('lightboxPanel', LightboxPanel);
        }

        assign(Lightbox.props, UIkit.component('lightboxPanel').options.props);
    }

    function toItem(el) {

        var item = {};

        ['href', 'caption', 'type', 'poster', 'alt', 'attrs'].forEach(function (attr) {
            item[attr === 'href' ? 'source' : attr] = data(el, attr);
        });

        item.attrs = parseOptions(item.attrs);

        return item;
    }

    var obj$1;

    var notification = {

        mixins: [Container],

        functional: true,

        args: ['message', 'status'],

        data: {
            message: '',
            status: '',
            timeout: 5000,
            group: null,
            pos: 'top-center',
            clsContainer: 'uk-notification',
            clsClose: 'uk-notification-close',
            clsMsg: 'uk-notification-message'
        },

        install: install,

        computed: {

            marginProp: function marginProp(ref) {
                var pos = ref.pos;

                return "margin" + (startsWith(pos, 'top') ? 'Top' : 'Bottom');
            },

            startProps: function startProps() {
                var obj;

                return obj = { opacity: 0 }, obj[this.marginProp] = -this.$el.offsetHeight, obj;
            }

        },

        created: function created() {

            var container = $("." + this.clsContainer + "-" + this.pos, this.container) || append(this.container, "<div class=\"" + this.clsContainer + " " + this.clsContainer + "-" + this.pos + "\" style=\"display: block\"></div>");

            this.$mount(append(container, "<div class=\"" + this.clsMsg + (this.status ? " " + this.clsMsg + "-" + this.status : '') + "\"> <a href class=\"" + this.clsClose + "\" data-uk-close></a> <div>" + this.message + "</div> </div>"));
        },

        connected: function connected() {
            var this$1$1 = this;
            var obj;

            var margin = toFloat(css(this.$el, this.marginProp));
            Transition.start(css(this.$el, this.startProps), (obj = { opacity: 1 }, obj[this.marginProp] = margin, obj)).then(function () {
                if (this$1$1.timeout) {
                    this$1$1.timer = setTimeout(this$1$1.close, this$1$1.timeout);
                }
            });
        },

        events: (obj$1 = {

            click: function click(e) {
                if (closest(e.target, 'a[href="#"],a[href=""]')) {
                    e.preventDefault();
                }
                this.close();
            }

        }, obj$1[pointerEnter] = function () {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }, obj$1[pointerLeave] = function () {
            if (this.timeout) {
                this.timer = setTimeout(this.close, this.timeout);
            }
        }, obj$1),

        methods: {

            close: function close(immediate) {
                var this$1$1 = this;

                var removeFn = function removeFn(el) {

                    var container = parent(el);

                    trigger(el, 'close', [this$1$1]);
                    remove$1(el);

                    if (container && !container.hasChildNodes()) {
                        remove$1(container);
                    }
                };

                if (this.timer) {
                    clearTimeout(this.timer);
                }

                if (immediate) {
                    removeFn(this.$el);
                } else {
                    Transition.start(this.$el, this.startProps).then(removeFn);
                }
            }

        }

    };

    function install(UIkit) {
        UIkit.notification.closeAll = function (group, immediate) {
            apply$1(document.body, function (el) {
                var notification = UIkit.getComponent(el, 'notification');
                if (notification && (!group || group === notification.group)) {
                    notification.close(immediate);
                }
            });
        };
    }

    var _props = ['x', 'y', 'bgx', 'bgy', 'rotate', 'scale', 'color', 'backgroundColor', 'borderColor', 'opacity', 'blur', 'hue', 'grayscale', 'invert', 'saturate', 'sepia', 'fopacity', 'stroke'];

    var Parallax = {

        mixins: [Media],

        props: _props.reduce(function (props, prop) {
            props[prop] = 'list';
            return props;
        }, {}),

        data: _props.reduce(function (data, prop) {
            data[prop] = undefined;
            return data;
        }, {}),

        computed: {

            props: function props(properties, $el) {
                var this$1$1 = this;

                return _props.reduce(function (props, prop) {

                    if (isUndefined(properties[prop])) {
                        return props;
                    }

                    var isColor = prop.match(/color/i);
                    var isCssProp = isColor || prop === 'opacity';

                    var pos, bgPos, diff;
                    var steps = properties[prop].slice();

                    if (isCssProp) {
                        css($el, prop, '');
                    }

                    if (steps.length < 2) {
                        steps.unshift((prop === 'scale' ? 1 : isCssProp ? css($el, prop) : 0) || 0);
                    }

                    var unit = getUnit(steps);

                    if (isColor) {

                        var ref = $el.style;
                        var color = ref.color;
                        steps = steps.map(function (step) {
                            return parseColor($el, step);
                        });
                        $el.style.color = color;
                    } else if (startsWith(prop, 'bg')) {

                        var attr = prop === 'bgy' ? 'height' : 'width';
                        steps = steps.map(function (step) {
                            return toPx(step, attr, this$1$1.$el);
                        });

                        css($el, "background-position-" + prop[2], '');
                        bgPos = css($el, 'backgroundPosition').split(' ')[prop[2] === 'x' ? 0 : 1]; // IE 11 can't read background-position-[x|y]

                        if (this$1$1.covers) {

                            var min = Math.min.apply(Math, steps);
                            var max = Math.max.apply(Math, steps);
                            var down = steps.indexOf(min) < steps.indexOf(max);

                            diff = max - min;

                            steps = steps.map(function (step) {
                                return step - (down ? min : max);
                            });
                            pos = (down ? -diff : 0) + "px";
                        } else {

                            pos = bgPos;
                        }
                    } else {

                        steps = steps.map(toFloat);
                    }

                    if (prop === 'stroke') {

                        if (!steps.some(function (step) {
                            return step;
                        })) {
                            return props;
                        }

                        var length = getMaxPathLength(this$1$1.$el);
                        css($el, 'strokeDasharray', length);

                        if (unit === '%') {
                            steps = steps.map(function (step) {
                                return step * length / 100;
                            });
                        }

                        steps = steps.reverse();

                        prop = 'strokeDashoffset';
                    }

                    props[prop] = { steps: steps, unit: unit, pos: pos, bgPos: bgPos, diff: diff };

                    return props;
                }, {});
            },

            bgProps: function bgProps() {
                var this$1$1 = this;

                return ['bgx', 'bgy'].filter(function (bg) {
                    return bg in this$1$1.props;
                });
            },

            covers: function covers(_, $el) {
                return _covers($el);
            }

        },

        disconnected: function disconnected() {
            delete this._image;
        },

        update: {

            read: function read(data) {
                var this$1$1 = this;

                if (!this.matchMedia) {
                    return;
                }

                if (!data.image && this.covers && this.bgProps.length) {
                    var src = css(this.$el, 'backgroundImage').replace(/^none|url\(["']?(.+?)["']?\)$/, '$1');

                    if (src) {
                        var img = new Image();
                        img.src = src;
                        data.image = img;

                        if (!img.naturalWidth) {
                            img.onload = function () {
                                return this$1$1.$update();
                            };
                        }
                    }
                }

                var image = data.image;

                if (!image || !image.naturalWidth) {
                    return;
                }

                var dimEl = {
                    width: this.$el.offsetWidth,
                    height: this.$el.offsetHeight
                };
                var dimImage = {
                    width: image.naturalWidth,
                    height: image.naturalHeight
                };

                var dim = Dimensions.cover(dimImage, dimEl);

                this.bgProps.forEach(function (prop) {

                    var ref = this$1$1.props[prop];
                    var diff = ref.diff;
                    var bgPos = ref.bgPos;
                    var steps = ref.steps;
                    var attr = prop === 'bgy' ? 'height' : 'width';
                    var span = dim[attr] - dimEl[attr];

                    if (span < diff) {
                        dimEl[attr] = dim[attr] + diff - span;
                    } else if (span > diff) {

                        var posPercentage = dimEl[attr] / toPx(bgPos, attr, this$1$1.$el);

                        if (posPercentage) {
                            this$1$1.props[prop].steps = steps.map(function (step) {
                                return step - (span - diff) / posPercentage;
                            });
                        }
                    }

                    dim = Dimensions.cover(dimImage, dimEl);
                });

                data.dim = dim;
            },

            write: function write(ref) {
                var dim = ref.dim;

                if (!this.matchMedia) {
                    css(this.$el, { backgroundSize: '', backgroundRepeat: '' });
                    return;
                }

                dim && css(this.$el, {
                    backgroundSize: dim.width + "px " + dim.height + "px",
                    backgroundRepeat: 'no-repeat'
                });
            },

            events: ['resize']

        },

        methods: {

            reset: function reset() {
                var this$1$1 = this;

                each(this.getCss(0), function (_, prop) {
                    return css(this$1$1.$el, prop, '');
                });
            },

            getCss: function getCss(percent) {

                var ref = this;
                var props = ref.props;
                return Object.keys(props).reduce(function (css, prop) {

                    var ref = props[prop];
                    var steps = ref.steps;
                    var unit = ref.unit;
                    var pos = ref.pos;
                    var value = getValue(steps, percent);

                    switch (prop) {

                        // transforms
                        case 'x':
                        case 'y':
                            {
                                unit = unit || 'px';
                                css.transform += " translate" + ucfirst(prop) + "(" + toFloat(value).toFixed(unit === 'px' ? 0 : 2) + unit + ")";
                                break;
                            }
                        case 'rotate':
                            unit = unit || 'deg';
                            css.transform += " rotate(" + (value + unit) + ")";
                            break;
                        case 'scale':
                            css.transform += " scale(" + value + ")";
                            break;

                        // bg image
                        case 'bgy':
                        case 'bgx':
                            css["background-position-" + prop[2]] = "calc(" + pos + " + " + value + "px)";
                            break;

                        // color
                        case 'color':
                        case 'backgroundColor':
                        case 'borderColor':
                            {

                                var ref$1 = getStep(steps, percent);
                                var start = ref$1[0];
                                var end = ref$1[1];
                                var p = ref$1[2];

                                css[prop] = "rgba(" + start.map(function (value, i) {
                                    value = value + p * (end[i] - value);
                                    return i === 3 ? toFloat(value) : parseInt(value, 10);
                                }).join(',') + ")";
                                break;
                            }
                        // CSS Filter
                        case 'blur':
                            unit = unit || 'px';
                            css.filter += " blur(" + (value + unit) + ")";
                            break;
                        case 'hue':
                            unit = unit || 'deg';
                            css.filter += " hue-rotate(" + (value + unit) + ")";
                            break;
                        case 'fopacity':
                            unit = unit || '%';
                            css.filter += " opacity(" + (value + unit) + ")";
                            break;
                        case 'grayscale':
                        case 'invert':
                        case 'saturate':
                        case 'sepia':
                            unit = unit || '%';
                            css.filter += " " + prop + "(" + (value + unit) + ")";
                            break;
                        default:
                            css[prop] = value;
                    }

                    return css;
                }, { transform: '', filter: '' });
            }

        }

    };

    function parseColor(el, color) {
        return css(css(el, 'color', color), 'color').split(/[(),]/g).slice(1, -1).concat(1).slice(0, 4).map(toFloat);
    }

    function getStep(steps, percent) {
        var count = steps.length - 1;
        var index = Math.min(Math.floor(count * percent), count - 1);
        var step = steps.slice(index, index + 2);

        step.push(percent === 1 ? 1 : percent % (1 / count) * count);

        return step;
    }

    function getValue(steps, percent, digits) {
        if (digits === void 0) digits = 2;

        var ref = getStep(steps, percent);
        var start = ref[0];
        var end = ref[1];
        var p = ref[2];
        return (isNumber(start) ? start + Math.abs(start - end) * p * (start < end ? 1 : -1) : +end).toFixed(digits);
    }

    function getUnit(steps) {
        return steps.reduce(function (unit, step) {
            return isString(step) && step.replace(/-|\d/g, '').trim() || unit;
        }, '');
    }

    function _covers(el) {
        var ref = el.style;
        var backgroundSize = ref.backgroundSize;
        var covers = css(css(el, 'backgroundSize', ''), 'backgroundSize') === 'cover';
        el.style.backgroundSize = backgroundSize;
        return covers;
    }

    var parallax = {

        mixins: [Parallax],

        props: {
            target: String,
            viewport: Number,
            easing: Number
        },

        data: {
            target: false,
            viewport: 1,
            easing: 1
        },

        computed: {

            target: function target(ref, $el) {
                var target = ref.target;

                return getOffsetElement(target && query(target, $el) || $el);
            }

        },

        update: {

            read: function read(ref, types) {
                var percent = ref.percent;

                if (!types.has('scroll')) {
                    percent = false;
                }

                if (!this.matchMedia) {
                    return;
                }

                var prev = percent;
                percent = ease(scrolledOver(this.target) / (this.viewport || 1), this.easing);

                return {
                    percent: percent,
                    style: prev !== percent ? this.getCss(percent) : false
                };
            },

            write: function write(ref) {
                var style = ref.style;

                if (!this.matchMedia) {
                    this.reset();
                    return;
                }

                style && css(this.$el, style);
            },

            events: ['scroll', 'resize']
        }

    };

    function ease(percent, easing) {
        return clamp(percent * (1 - (easing - easing * percent)));
    }

    // SVG elements do not inherit from HTMLElement
    function getOffsetElement(el) {
        return el ? 'offsetTop' in el ? el : getOffsetElement(parent(el)) : document.body;
    }

    var SliderReactive = {

        update: {

            write: function write() {

                if (this.stack.length || this.dragging) {
                    return;
                }

                var index = this.getValidIndex(this.index);

                if (!~this.prevIndex || this.index !== index) {
                    this.show(index);
                }
            },

            events: ['resize']

        }

    };

    function Transitioner(prev, next, dir, ref) {
        var center = ref.center;
        var easing = ref.easing;
        var list = ref.list;

        var deferred = new Deferred();

        var from = prev ? getLeft(prev, list, center) : getLeft(next, list, center) + dimensions(next).width * dir;
        var to = next ? getLeft(next, list, center) : from + dimensions(prev).width * dir * (isRtl ? -1 : 1);

        return {

            dir: dir,

            show: function show(duration, percent, linear) {
                if (percent === void 0) percent = 0;

                var timing = linear ? 'linear' : easing;
                duration -= Math.round(duration * clamp(percent, -1, 1));

                this.translate(percent);

                percent = prev ? percent : clamp(percent, 0, 1);
                triggerUpdate(this.getItemIn(), 'itemin', { percent: percent, duration: duration, timing: timing, dir: dir });
                prev && triggerUpdate(this.getItemIn(true), 'itemout', { percent: 1 - percent, duration: duration, timing: timing, dir: dir });

                Transition.start(list, { transform: _translate(-to * (isRtl ? -1 : 1), 'px') }, duration, timing).then(deferred.resolve, noop);

                return deferred.promise;
            },

            cancel: function cancel() {
                Transition.cancel(list);
            },

            reset: function reset() {
                css(list, 'transform', '');
            },

            forward: function forward(duration, percent) {
                if (percent === void 0) percent = this.percent();

                Transition.cancel(list);
                return this.show(duration, percent, true);
            },

            translate: function translate(percent) {

                var distance = this.getDistance() * dir * (isRtl ? -1 : 1);

                css(list, 'transform', _translate(clamp(-to + (distance - distance * percent), -getWidth(list), dimensions(list).width) * (isRtl ? -1 : 1), 'px'));

                var actives = this.getActives();
                var itemIn = this.getItemIn();
                var itemOut = this.getItemIn(true);

                percent = prev ? clamp(percent, -1, 1) : 0;

                _children(list).forEach(function (slide) {
                    var isActive = includes(actives, slide);
                    var isIn = slide === itemIn;
                    var isOut = slide === itemOut;
                    var translateIn = isIn || !isOut && (isActive || dir * (isRtl ? -1 : 1) === -1 ^ getElLeft(slide, list) > getElLeft(prev || next));

                    triggerUpdate(slide, "itemtranslate" + (translateIn ? 'in' : 'out'), {
                        dir: dir,
                        percent: isOut ? 1 - percent : isIn ? percent : isActive ? 1 : 0
                    });
                });
            },

            percent: function percent() {
                return Math.abs((css(list, 'transform').split(',')[4] * (isRtl ? -1 : 1) + from) / (to - from));
            },

            getDistance: function getDistance() {
                return Math.abs(to - from);
            },

            getItemIn: function getItemIn(out) {
                if (out === void 0) out = false;

                var actives = this.getActives();
                var nextActives = inView(list, getLeft(next || prev, list, center));

                if (out) {
                    var temp = actives;
                    actives = nextActives;
                    nextActives = temp;
                }

                return nextActives[findIndex(nextActives, function (el) {
                    return !includes(actives, el);
                })];
            },

            getActives: function getActives() {
                return inView(list, getLeft(prev || next, list, center));
            }

        };
    }

    function getLeft(el, list, center) {

        var left = getElLeft(el, list);

        return center ? left - centerEl(el, list) : Math.min(left, getMax(list));
    }

    function getMax(list) {
        return Math.max(0, getWidth(list) - dimensions(list).width);
    }

    function getWidth(list) {
        return _children(list).reduce(function (right, el) {
            return dimensions(el).width + right;
        }, 0);
    }

    function centerEl(el, list) {
        return dimensions(list).width / 2 - dimensions(el).width / 2;
    }

    function getElLeft(el, list) {
        return el && (position(el).left + (isRtl ? dimensions(el).width - dimensions(list).width : 0)) * (isRtl ? -1 : 1) || 0;
    }

    function inView(list, listLeft) {

        listLeft -= 1;
        var listWidth = dimensions(list).width;
        var listRight = listLeft + listWidth + 2;

        return _children(list).filter(function (slide) {
            var slideLeft = getElLeft(slide, list);
            var slideRight = slideLeft + Math.min(dimensions(slide).width, listWidth);

            return slideLeft >= listLeft && slideRight <= listRight;
        });
    }

    function triggerUpdate(el, type, data) {
        trigger(el, createEvent(type, false, false, data));
    }

    var slider = {

        mixins: [Class, Slider, SliderReactive],

        props: {
            center: Boolean,
            sets: Boolean
        },

        data: {
            center: false,
            sets: false,
            attrItem: 'uk-slider-item',
            selList: '.uk-slider-items',
            selNav: '.uk-slider-nav',
            clsContainer: 'uk-slider-container',
            Transitioner: Transitioner
        },

        computed: {

            avgWidth: function avgWidth() {
                return getWidth(this.list) / this.length;
            },

            finite: function finite(ref) {
                var finite = ref.finite;

                return finite || Math.ceil(getWidth(this.list)) < dimensions(this.list).width + getMaxElWidth(this.list) + this.center;
            },

            maxIndex: function maxIndex() {

                if (!this.finite || this.center && !this.sets) {
                    return this.length - 1;
                }

                if (this.center) {
                    return last(this.sets);
                }

                var lft = 0;
                var max = getMax(this.list);
                var index = findIndex(this.slides, function (el) {

                    if (lft >= max) {
                        return true;
                    }

                    lft += dimensions(el).width;
                });

                return ~index ? index : this.length - 1;
            },

            sets: function sets(ref) {
                var this$1$1 = this;
                var sets = ref.sets;

                if (!sets) {
                    return;
                }

                var width = dimensions(this.list).width / (this.center ? 2 : 1);

                var left = 0;
                var leftCenter = width;
                var slideLeft = 0;

                sets = sortBy$1(this.slides, 'offsetLeft').reduce(function (sets, slide, i) {

                    var slideWidth = dimensions(slide).width;
                    var slideRight = slideLeft + slideWidth;

                    if (slideRight > left) {

                        if (!this$1$1.center && i > this$1$1.maxIndex) {
                            i = this$1$1.maxIndex;
                        }

                        if (!includes(sets, i)) {

                            var cmp = this$1$1.slides[i + 1];
                            if (this$1$1.center && cmp && slideWidth < leftCenter - dimensions(cmp).width / 2) {
                                leftCenter -= slideWidth;
                            } else {
                                leftCenter = width;
                                sets.push(i);
                                left = slideLeft + width + (this$1$1.center ? slideWidth / 2 : 0);
                            }
                        }
                    }

                    slideLeft += slideWidth;

                    return sets;
                }, []);

                return !isEmpty(sets) && sets;
            },

            transitionOptions: function transitionOptions() {
                return {
                    center: this.center,
                    list: this.list
                };
            }

        },

        connected: function connected() {
            toggleClass(this.$el, this.clsContainer, !$("." + this.clsContainer, this.$el));
        },

        update: {

            write: function write() {
                var this$1$1 = this;

                this.navItems.forEach(function (el) {
                    var index = toNumber(data(el, this$1$1.attrItem));
                    if (index !== false) {
                        el.hidden = !this$1$1.maxIndex || index > this$1$1.maxIndex || this$1$1.sets && !includes(this$1$1.sets, index);
                    }
                });

                if (this.length && !this.dragging && !this.stack.length) {
                    this.reorder();
                    this._translate(1);
                }

                var actives = this._getTransitioner(this.index).getActives();
                this.slides.forEach(function (slide) {
                    return toggleClass(slide, this$1$1.clsActive, includes(actives, slide));
                });

                if (this.clsActivated && (!this.sets || includes(this.sets, toFloat(this.index)))) {
                    this.slides.forEach(function (slide) {
                        return toggleClass(slide, this$1$1.clsActivated || '', includes(actives, slide));
                    });
                }
            },

            events: ['resize']

        },

        events: {

            beforeitemshow: function beforeitemshow(e) {

                if (!this.dragging && this.sets && this.stack.length < 2 && !includes(this.sets, this.index)) {
                    this.index = this.getValidIndex();
                }

                var diff = Math.abs(this.index - this.prevIndex + (this.dir > 0 && this.index < this.prevIndex || this.dir < 0 && this.index > this.prevIndex ? (this.maxIndex + 1) * this.dir : 0));

                if (!this.dragging && diff > 1) {

                    for (var i = 0; i < diff; i++) {
                        this.stack.splice(1, 0, this.dir > 0 ? 'next' : 'previous');
                    }

                    e.preventDefault();
                    return;
                }

                var index = this.dir < 0 || !this.slides[this.prevIndex] ? this.index : this.prevIndex;
                this.duration = speedUp(this.avgWidth / this.velocity) * (dimensions(this.slides[index]).width / this.avgWidth);

                this.reorder();
            },

            itemshow: function itemshow() {
                if (~this.prevIndex) {
                    addClass(this._getTransitioner().getItemIn(), this.clsActive);
                }
            }

        },

        methods: {

            reorder: function reorder() {
                var this$1$1 = this;

                if (this.finite) {
                    css(this.slides, 'order', '');
                    return;
                }

                var index = this.dir > 0 && this.slides[this.prevIndex] ? this.prevIndex : this.index;

                this.slides.forEach(function (slide, i) {
                    return css(slide, 'order', this$1$1.dir > 0 && i < index ? 1 : this$1$1.dir < 0 && i >= this$1$1.index ? -1 : '');
                });

                if (!this.center) {
                    return;
                }

                var next = this.slides[index];
                var width = dimensions(this.list).width / 2 - dimensions(next).width / 2;
                var j = 0;

                while (width > 0) {
                    var slideIndex = this.getIndex(--j + index, index);
                    var slide = this.slides[slideIndex];

                    css(slide, 'order', slideIndex > index ? -2 : -1);
                    width -= dimensions(slide).width;
                }
            },

            getValidIndex: function getValidIndex(index, prevIndex) {
                if (index === void 0) index = this.index;
                if (prevIndex === void 0) prevIndex = this.prevIndex;

                index = this.getIndex(index, prevIndex);

                if (!this.sets) {
                    return index;
                }

                var prev;

                do {

                    if (includes(this.sets, index)) {
                        return index;
                    }

                    prev = index;
                    index = this.getIndex(index + this.dir, prevIndex);
                } while (index !== prev);

                return index;
            }

        }

    };

    function getMaxElWidth(list) {
        return Math.max.apply(Math, [0].concat(_children(list).map(function (el) {
            return dimensions(el).width;
        })));
    }

    var sliderParallax = {

        mixins: [Parallax],

        data: {
            selItem: '!li'
        },

        computed: {

            item: function item(ref, $el) {
                var selItem = ref.selItem;

                return query(selItem, $el);
            }

        },

        events: [{
            name: 'itemin itemout',

            self: true,

            el: function el() {
                return this.item;
            },

            handler: function handler(ref) {
                var this$1$1 = this;
                var type = ref.type;
                var ref_detail = ref.detail;
                var percent = ref_detail.percent;
                var duration = ref_detail.duration;
                var timing = ref_detail.timing;
                var dir = ref_detail.dir;

                fastdom.read(function () {
                    var propsFrom = this$1$1.getCss(getCurrentPercent(type, dir, percent));
                    var propsTo = this$1$1.getCss(isIn(type) ? .5 : dir > 0 ? 1 : 0);
                    fastdom.write(function () {
                        css(this$1$1.$el, propsFrom);
                        Transition.start(this$1$1.$el, propsTo, duration, timing).catch(noop);
                    });
                });
            }
        }, {
            name: 'transitioncanceled transitionend',

            self: true,

            el: function el() {
                return this.item;
            },

            handler: function handler() {
                Transition.cancel(this.$el);
            }

        }, {
            name: 'itemtranslatein itemtranslateout',

            self: true,

            el: function el() {
                return this.item;
            },

            handler: function handler(ref) {
                var this$1$1 = this;
                var type = ref.type;
                var ref_detail = ref.detail;
                var percent = ref_detail.percent;
                var dir = ref_detail.dir;

                fastdom.read(function () {
                    var props = this$1$1.getCss(getCurrentPercent(type, dir, percent));
                    fastdom.write(function () {
                        return css(this$1$1.$el, props);
                    });
                });
            }
        }]

    };

    function isIn(type) {
        return endsWith(type, 'in');
    }

    function getCurrentPercent(type, dir, percent) {

        percent /= 2;

        return !isIn(type) ? dir < 0 ? percent : 1 - percent : dir < 0 ? 1 - percent : percent;
    }

    var Animations = assign({}, Animations$2, {

        fade: {

            show: function show() {
                return [{ opacity: 0, zIndex: 0 }, { zIndex: -1 }];
            },

            percent: function percent(current) {
                return 1 - css(current, 'opacity');
            },

            translate: function translate(percent) {
                return [{ opacity: 1 - percent, zIndex: 0 }, { zIndex: -1 }];
            }

        },

        scale: {

            show: function show() {
                return [{ opacity: 0, transform: scale3d(1 + .5), zIndex: 0 }, { zIndex: -1 }];
            },

            percent: function percent(current) {
                return 1 - css(current, 'opacity');
            },

            translate: function translate(percent) {
                return [{ opacity: 1 - percent, transform: scale3d(1 + .5 * percent), zIndex: 0 }, { zIndex: -1 }];
            }

        },

        pull: {

            show: function show(dir) {
                return dir < 0 ? [{ transform: _translate(30), zIndex: -1 }, { transform: _translate(), zIndex: 0 }] : [{ transform: _translate(-100), zIndex: 0 }, { transform: _translate(), zIndex: -1 }];
            },

            percent: function percent(current, next, dir) {
                return dir < 0 ? 1 - translated(next) : translated(current);
            },

            translate: function translate(percent, dir) {
                return dir < 0 ? [{ transform: _translate(30 * percent), zIndex: -1 }, { transform: _translate(-100 * (1 - percent)), zIndex: 0 }] : [{ transform: _translate(-percent * 100), zIndex: 0 }, { transform: _translate(30 * (1 - percent)), zIndex: -1 }];
            }

        },

        push: {

            show: function show(dir) {
                return dir < 0 ? [{ transform: _translate(100), zIndex: 0 }, { transform: _translate(), zIndex: -1 }] : [{ transform: _translate(-30), zIndex: -1 }, { transform: _translate(), zIndex: 0 }];
            },

            percent: function percent(current, next, dir) {
                return dir > 0 ? 1 - translated(next) : translated(current);
            },

            translate: function translate(percent, dir) {
                return dir < 0 ? [{ transform: _translate(percent * 100), zIndex: 0 }, { transform: _translate(-30 * (1 - percent)), zIndex: -1 }] : [{ transform: _translate(-30 * percent), zIndex: -1 }, { transform: _translate(100 * (1 - percent)), zIndex: 0 }];
            }

        }

    });

    var slideshow = {

        mixins: [Class, Slideshow, SliderReactive],

        props: {
            ratio: String,
            minHeight: Number,
            maxHeight: Number
        },

        data: {
            ratio: '16:9',
            minHeight: false,
            maxHeight: false,
            selList: '.uk-slideshow-items',
            attrItem: 'uk-slideshow-item',
            selNav: '.uk-slideshow-nav',
            Animations: Animations
        },

        update: {

            read: function read() {

                var ref = this.ratio.split(':').map(Number);
                var width = ref[0];
                var height = ref[1];

                height = height * this.list.offsetWidth / width || 0;

                if (this.minHeight) {
                    height = Math.max(this.minHeight, height);
                }

                if (this.maxHeight) {
                    height = Math.min(this.maxHeight, height);
                }

                return { height: height - boxModelAdjust(this.list, 'height', 'content-box') };
            },

            write: function write(ref) {
                var height = ref.height;

                height > 0 && css(this.list, 'minHeight', height);
            },

            events: ['resize']

        }

    };

    var sortable = {

        mixins: [Class, Animate],

        props: {
            group: String,
            threshold: Number,
            clsItem: String,
            clsPlaceholder: String,
            clsDrag: String,
            clsDragState: String,
            clsBase: String,
            clsNoDrag: String,
            clsEmpty: String,
            clsCustom: String,
            handle: String
        },

        data: {
            group: false,
            threshold: 5,
            clsItem: 'uk-sortable-item',
            clsPlaceholder: 'uk-sortable-placeholder',
            clsDrag: 'uk-sortable-drag',
            clsDragState: 'uk-drag',
            clsBase: 'uk-sortable',
            clsNoDrag: 'uk-sortable-nodrag',
            clsEmpty: 'uk-sortable-empty',
            clsCustom: '',
            handle: false,
            pos: {}
        },

        created: function created() {
            var this$1$1 = this;

            ['init', 'start', 'move', 'end'].forEach(function (key) {
                var fn = this$1$1[key];
                this$1$1[key] = function (e) {
                    assign(this$1$1.pos, getEventPos(e));
                    fn(e);
                };
            });
        },

        events: {

            name: pointerDown,
            passive: false,
            handler: 'init'

        },

        computed: {

            target: function target() {
                return (this.$el.tBodies || [this.$el])[0];
            },

            items: function items() {
                return _children(this.target);
            },

            isEmpty: {

                get: function get() {
                    return isEmpty(this.items);
                },

                watch: function watch(empty) {
                    toggleClass(this.target, this.clsEmpty, empty);
                },

                immediate: true

            },

            handles: {

                get: function get(ref, el) {
                    var handle = ref.handle;

                    return handle ? $$(handle, el) : this.items;
                },

                watch: function watch(handles, prev) {
                    css(prev, { touchAction: '', userSelect: '' });
                    css(handles, { touchAction: hasTouch ? 'none' : '', userSelect: 'none' }); // touchAction set to 'none' causes a performance drop in Chrome 80
                },

                immediate: true

            }

        },

        update: {

            write: function write(data) {

                if (!this.drag || !parent(this.placeholder)) {
                    return;
                }

                var ref = this;
                var ref_pos = ref.pos;
                var x = ref_pos.x;
                var y = ref_pos.y;
                var ref_origin = ref.origin;
                var offsetTop = ref_origin.offsetTop;
                var offsetLeft = ref_origin.offsetLeft;
                var placeholder = ref.placeholder;

                css(this.drag, {
                    top: y - offsetTop,
                    left: x - offsetLeft
                });

                var sortable = this.getSortable(document.elementFromPoint(x, y));

                if (!sortable) {
                    return;
                }

                var items = sortable.items;

                if (items.some(Transition.inProgress)) {
                    return;
                }

                var target = findTarget(items, { x: x, y: y });

                if (items.length && (!target || target === placeholder)) {
                    return;
                }

                var previous = this.getSortable(placeholder);
                var insertTarget = findInsertTarget(sortable.target, target, placeholder, x, y, sortable === previous && data.moved !== target);

                if (insertTarget === false) {
                    return;
                }

                if (insertTarget && placeholder === insertTarget) {
                    return;
                }

                if (sortable !== previous) {
                    previous.remove(placeholder);
                    data.moved = target;
                } else {
                    delete data.moved;
                }

                sortable.insert(placeholder, insertTarget);

                this.touched.add(sortable);
            },

            events: ['move']

        },

        methods: {

            init: function init(e) {

                var target = e.target;
                var button = e.button;
                var defaultPrevented = e.defaultPrevented;
                var ref = this.items.filter(function (el) {
                    return within(target, el);
                });
                var placeholder = ref[0];

                if (!placeholder || defaultPrevented || button > 0 || isInput(target) || within(target, "." + this.clsNoDrag) || this.handle && !within(target, this.handle)) {
                    return;
                }

                e.preventDefault();

                this.touched = new Set([this]);
                this.placeholder = placeholder;
                this.origin = assign({ target: target, index: index(placeholder) }, this.pos);

                on(document, pointerMove, this.move);
                on(document, pointerUp, this.end);

                if (!this.threshold) {
                    this.start(e);
                }
            },

            start: function start(e) {

                this.drag = appendDrag(this.$container, this.placeholder);
                var ref = this.placeholder.getBoundingClientRect();
                var left = ref.left;
                var top = ref.top;
                assign(this.origin, { offsetLeft: this.pos.x - left, offsetTop: this.pos.y - top });

                addClass(this.drag, this.clsDrag, this.clsCustom);
                addClass(this.placeholder, this.clsPlaceholder);
                addClass(this.items, this.clsItem);
                addClass(document.documentElement, this.clsDragState);

                trigger(this.$el, 'start', [this, this.placeholder]);

                trackScroll(this.pos);

                this.move(e);
            },

            move: function move(e) {

                if (this.drag) {
                    this.$emit('move');
                } else if (Math.abs(this.pos.x - this.origin.x) > this.threshold || Math.abs(this.pos.y - this.origin.y) > this.threshold) {
                    this.start(e);
                }
            },

            end: function end() {
                var this$1$1 = this;

                off(document, pointerMove, this.move);
                off(document, pointerUp, this.end);
                off(window, 'scroll', this.scroll);

                if (!this.drag) {
                    return;
                }

                untrackScroll();

                var sortable = this.getSortable(this.placeholder);

                if (this === sortable) {
                    if (this.origin.index !== index(this.placeholder)) {
                        trigger(this.$el, 'moved', [this, this.placeholder]);
                    }
                } else {
                    trigger(sortable.$el, 'added', [sortable, this.placeholder]);
                    trigger(this.$el, 'removed', [this, this.placeholder]);
                }

                trigger(this.$el, 'stop', [this, this.placeholder]);

                remove$1(this.drag);
                this.drag = null;

                this.touched.forEach(function (ref) {
                    var clsPlaceholder = ref.clsPlaceholder;
                    var clsItem = ref.clsItem;

                    return this$1$1.touched.forEach(function (sortable) {
                        return removeClass(sortable.items, clsPlaceholder, clsItem);
                    });
                });
                this.touched = null;
                removeClass(document.documentElement, this.clsDragState);
            },

            insert: function insert(element, target) {
                var this$1$1 = this;

                addClass(this.items, this.clsItem);

                var insert = function insert() {
                    return target ? before(target, element) : append(this$1$1.target, element);
                };

                this.animate(insert);
            },

            remove: function remove(element) {

                if (!within(element, this.target)) {
                    return;
                }

                this.animate(function () {
                    return remove$1(element);
                });
            },

            getSortable: function getSortable(element) {
                do {
                    var sortable = this.$getComponent(element, 'sortable');

                    if (sortable && (sortable === this || this.group !== false && sortable.group === this.group)) {
                        return sortable;
                    }
                } while (element = parent(element));
            }

        }

    };

    var trackTimer;
    function trackScroll(pos) {

        var last = Date.now();
        trackTimer = setInterval(function () {

            var x = pos.x;
            var y = pos.y;
            y += window.pageYOffset;

            var dist = (Date.now() - last) * .3;
            last = Date.now();

            scrollParents(document.elementFromPoint(x, pos.y)).reverse().some(function (scrollEl) {

                var scroll = scrollEl.scrollTop;
                var scrollHeight = scrollEl.scrollHeight;

                var ref = offset(getViewport$1(scrollEl));
                var top = ref.top;
                var bottom = ref.bottom;
                var height = ref.height;

                if (top < y && top + 35 > y) {
                    scroll -= dist;
                } else if (bottom > y && bottom - 35 < y) {
                    scroll += dist;
                } else {
                    return;
                }

                if (scroll > 0 && scroll < scrollHeight - height) {
                    scrollTop(scrollEl, scroll);
                    return true;
                }
            });
        }, 15);
    }

    function untrackScroll() {
        clearInterval(trackTimer);
    }

    function appendDrag(container, element) {
        var clone = append(container, element.outerHTML.replace(/(^<)(?:li|tr)|(?:li|tr)(\/>$)/g, '$1div$2'));

        css(clone, 'margin', '0', 'important');
        css(clone, assign({
            boxSizing: 'border-box',
            width: element.offsetWidth,
            height: element.offsetHeight
        }, css(element, ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom'])));

        height(clone.firstElementChild, height(element.firstElementChild));

        return clone;
    }

    function findTarget(items, point) {
        return items[findIndex(items, function (item) {
            return pointInRect(point, item.getBoundingClientRect());
        })];
    }

    function findInsertTarget(list, target, placeholder, x, y, sameList) {

        if (!_children(list).length) {
            return;
        }

        var rect = target.getBoundingClientRect();
        if (!sameList) {

            if (!isHorizontal(list, placeholder)) {
                return y < rect.top + rect.height / 2 ? target : target.nextElementSibling;
            }

            return target;
        }

        var placeholderRect = placeholder.getBoundingClientRect();
        var sameRow = linesIntersect([rect.top, rect.bottom], [placeholderRect.top, placeholderRect.bottom]);

        var pointerPos = sameRow ? x : y;
        var lengthProp = sameRow ? 'width' : 'height';
        var startProp = sameRow ? 'left' : 'top';
        var endProp = sameRow ? 'right' : 'bottom';

        var diff = placeholderRect[lengthProp] < rect[lengthProp] ? rect[lengthProp] - placeholderRect[lengthProp] : 0;

        if (placeholderRect[startProp] < rect[startProp]) {

            if (diff && pointerPos < rect[startProp] + diff) {
                return false;
            }

            return target.nextElementSibling;
        }

        if (diff && pointerPos > rect[endProp] - diff) {
            return false;
        }

        return target;
    }

    function isHorizontal(list, placeholder) {

        var single = _children(list).length === 1;

        if (single) {
            append(list, placeholder);
        }

        var items = _children(list);
        var isHorizontal = items.some(function (el, i) {
            var rectA = el.getBoundingClientRect();
            return items.slice(i + 1).some(function (el) {
                var rectB = el.getBoundingClientRect();
                return !linesIntersect([rectA.left, rectA.right], [rectB.left, rectB.right]);
            });
        });

        if (single) {
            remove$1(placeholder);
        }

        return isHorizontal;
    }

    function linesIntersect(lineA, lineB) {
        return lineA[1] > lineB[0] && lineB[1] > lineA[0];
    }

    var obj;

    var tooltip = {

        mixins: [Container, Togglable, Position],

        args: 'title',

        props: {
            delay: Number,
            title: String
        },

        data: {
            pos: 'top',
            title: '',
            delay: 0,
            animation: ['uk-animation-scale-up'],
            duration: 100,
            cls: 'uk-active',
            clsPos: 'uk-tooltip'
        },

        beforeConnect: function beforeConnect() {
            this._hasTitle = hasAttr(this.$el, 'title');
            attr(this.$el, 'title', '');
            this.updateAria(false);
            makeFocusable(this.$el);
        },

        disconnected: function disconnected() {
            this.hide();
            attr(this.$el, 'title', this._hasTitle ? this.title : null);
        },

        methods: {

            show: function show() {
                var this$1$1 = this;

                if (this.isToggled(this.tooltip || null) || !this.title) {
                    return;
                }

                this._unbind = once(document, "show keydown " + pointerDown, this.hide, false, function (e) {
                    return e.type === pointerDown && !within(e.target, this$1$1.$el) || e.type === 'keydown' && e.keyCode === 27 || e.type === 'show' && e.detail[0] !== this$1$1 && e.detail[0].$name === this$1$1.$name;
                });

                clearTimeout(this.showTimer);
                this.showTimer = setTimeout(this._show, this.delay);
            },

            hide: function hide() {
                var this$1$1 = this;

                if (matches(this.$el, 'input:focus')) {
                    return;
                }

                clearTimeout(this.showTimer);

                if (!this.isToggled(this.tooltip || null)) {
                    return;
                }

                this.toggleElement(this.tooltip, false, false).then(function () {
                    this$1$1.tooltip = remove$1(this$1$1.tooltip);
                    this$1$1._unbind();
                });
            },

            _show: function _show() {
                var this$1$1 = this;

                this.tooltip = append(this.container, "<div class=\"" + this.clsPos + "\"> <div class=\"" + this.clsPos + "-inner\">" + this.title + "</div> </div>");

                on(this.tooltip, 'toggled', function (e, toggled) {

                    this$1$1.updateAria(toggled);

                    if (!toggled) {
                        return;
                    }

                    this$1$1.positionAt(this$1$1.tooltip, this$1$1.$el);

                    this$1$1.origin = this$1$1.getAxis() === 'y' ? flipPosition(this$1$1.dir) + "-" + this$1$1.align : this$1$1.align + "-" + flipPosition(this$1$1.dir);
                });

                this.toggleElement(this.tooltip, true);
            },

            updateAria: function updateAria(toggled) {
                attr(this.$el, 'aria-expanded', toggled);
            }

        },

        events: (obj = {

            focus: 'show',
            blur: 'hide'

        }, obj[pointerEnter + " " + pointerLeave] = function (e) {
            if (!isTouch(e)) {
                this[e.type === pointerEnter ? 'show' : 'hide']();
            }
        }, obj[pointerDown] = function (e) {
            if (isTouch(e)) {
                this.show();
            }
        }, obj)

    };

    function makeFocusable(el) {
        if (!isFocusable(el)) {
            attr(el, 'tabindex', '0');
        }
    }

    var upload = {

        props: {
            allow: String,
            clsDragover: String,
            concurrent: Number,
            maxSize: Number,
            method: String,
            mime: String,
            msgInvalidMime: String,
            msgInvalidName: String,
            msgInvalidSize: String,
            multiple: Boolean,
            name: String,
            params: Object,
            type: String,
            url: String
        },

        data: {
            allow: false,
            clsDragover: 'uk-dragover',
            concurrent: 1,
            maxSize: 0,
            method: 'POST',
            mime: false,
            msgInvalidMime: 'Invalid File Type: %s',
            msgInvalidName: 'Invalid File Name: %s',
            msgInvalidSize: 'Invalid File Size: %s Kilobytes Max',
            multiple: false,
            name: 'files[]',
            params: {},
            type: '',
            url: '',
            abort: noop,
            beforeAll: noop,
            beforeSend: noop,
            complete: noop,
            completeAll: noop,
            error: noop,
            fail: noop,
            load: noop,
            loadEnd: noop,
            loadStart: noop,
            progress: noop
        },

        events: {

            change: function change(e) {

                if (!matches(e.target, 'input[type="file"]')) {
                    return;
                }

                e.preventDefault();

                if (e.target.files) {
                    this.upload(e.target.files);
                }

                e.target.value = '';
            },

            drop: function drop(e) {
                stop(e);

                var transfer = e.dataTransfer;

                if (!transfer || !transfer.files) {
                    return;
                }

                removeClass(this.$el, this.clsDragover);

                this.upload(transfer.files);
            },

            dragenter: function dragenter(e) {
                stop(e);
            },

            dragover: function dragover(e) {
                stop(e);
                addClass(this.$el, this.clsDragover);
            },

            dragleave: function dragleave(e) {
                stop(e);
                removeClass(this.$el, this.clsDragover);
            }

        },

        methods: {

            upload: function upload(files) {
                var this$1$1 = this;

                if (!files.length) {
                    return;
                }

                trigger(this.$el, 'upload', [files]);

                for (var i = 0; i < files.length; i++) {

                    if (this.maxSize && this.maxSize * 1000 < files[i].size) {
                        this.fail(this.msgInvalidSize.replace('%s', this.maxSize));
                        return;
                    }

                    if (this.allow && !match(this.allow, files[i].name)) {
                        this.fail(this.msgInvalidName.replace('%s', this.allow));
                        return;
                    }

                    if (this.mime && !match(this.mime, files[i].type)) {
                        this.fail(this.msgInvalidMime.replace('%s', this.mime));
                        return;
                    }
                }

                if (!this.multiple) {
                    files = [files[0]];
                }

                this.beforeAll(this, files);

                var chunks = chunk(files, this.concurrent);
                var upload = function upload(files) {

                    var data = new FormData();

                    files.forEach(function (file) {
                        return data.append(this$1$1.name, file);
                    });

                    for (var key in this$1$1.params) {
                        data.append(key, this$1$1.params[key]);
                    }

                    ajax(this$1$1.url, {
                        data: data,
                        method: this$1$1.method,
                        responseType: this$1$1.type,
                        beforeSend: function beforeSend(env) {

                            var xhr = env.xhr;
                            xhr.upload && on(xhr.upload, 'progress', this$1$1.progress);
                            ['loadStart', 'load', 'loadEnd', 'abort'].forEach(function (type) {
                                return on(xhr, type.toLowerCase(), this$1$1[type]);
                            });

                            return this$1$1.beforeSend(env);
                        }
                    }).then(function (xhr) {

                        this$1$1.complete(xhr);

                        if (chunks.length) {
                            upload(chunks.shift());
                        } else {
                            this$1$1.completeAll(xhr);
                        }
                    }, function (e) {
                        return this$1$1.error(e);
                    });
                };

                upload(chunks.shift());
            }

        }

    };

    function match(pattern, path) {
        return path.match(new RegExp("^" + pattern.replace(/\//g, '\\/').replace(/\*\*/g, '(\\/[^\\/]+)*').replace(/\*/g, '[^\\/]+').replace(/((?!\\))\?/g, '$1.') + "$", 'i'));
    }

    function chunk(files, size) {
        var chunks = [];
        for (var i = 0; i < files.length; i += size) {
            var chunk = [];
            for (var j = 0; j < size; j++) {
                chunk.push(files[i + j]);
            }
            chunks.push(chunk);
        }
        return chunks;
    }

    function stop(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    var components = /*#__PURE__*/Object.freeze({
        __proto__: null,
        Countdown: countdown,
        Filter: filter,
        Lightbox: lightbox,
        LightboxPanel: LightboxPanel,
        Notification: notification,
        Parallax: parallax,
        Slider: slider,
        SliderParallax: sliderParallax,
        Slideshow: slideshow,
        SlideshowParallax: sliderParallax,
        Sortable: sortable,
        Tooltip: tooltip,
        Upload: upload
    });

    each(components, function (component, name) {
        return UIkit.component(name, component);
    });

    return UIkit;
});

/***/ }),

/***/ "k0hK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bca675021ce8fe09c41a2e0ba9d38a0d.png";

/***/ }),

/***/ "kD/w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _utils = __webpack_require__("yd8v");

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__("MILo");

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__("SWjV");

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__("cX2q");

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),

/***/ "kEQP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kERb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var setGlobal = __webpack_require__("4RHR");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;

/***/ }),

/***/ "kKXN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("vyGZ");


var addNotification = function addNotification(notification) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__index__["a" /* actionTypes */].ADD_NOTIFICATION,
    payload: notification
  };
};

var removeNotification = function removeNotification(notificationId) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__index__["a" /* actionTypes */].REMOVE_NOTIFICATION,
      payload: { notificationId: notificationId }
    });
  };
};

/***/ }),

/***/ "kUlY":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("xC+t");
var enumBugKeys = __webpack_require__("lzt6");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

/***/ }),

/***/ "ka1r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "ka43":
/***/ (function(module, exports, __webpack_require__) {

var parser = __webpack_require__("y+zt");
var writer = __webpack_require__("2tBI");

exports.write = writer;
exports.parse = parser.parse;
exports.parseFmtpConfig = parser.parseFmtpConfig;
exports.parsePayloads = parser.parsePayloads;
exports.parseRemoteCandidates = parser.parseRemoteCandidates;

/***/ }),

/***/ "kcvk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: !0 });var _propTypes = __webpack_require__("5D9O"),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _react = __webpack_require__("eW0v"),
    _react2 = _interopRequireDefault(_react);function _interopRequireDefault(a) {
  return a && a.__esModule ? a : { default: a };
}var propTypes = { on: _propTypes2.default.bool.isRequired, onClick: _propTypes2.default.func.isRequired, enabled: _propTypes2.default.bool, className: _propTypes2.default.string },
    defaultProps = { enabled: !0, className: '', onDisabledClick: function onDisabledClick() {} };function Switch(a) {
  var b = a.on,
      c = a.onClick,
      d = a.onDisabledClick,
      f = a.enabled,
      e = a.className,
      g = a.children,
      h = ['switch', e, b ? 'on ' : '', f ? '' : 'disabled '].join(' ');return _react2.default.createElement('div', { className: h, onClick: function onClick(a) {
      return f ? c(a) : d(a);
    } }, _react2.default.createElement('div', { className: 'switch-toggle', children: g }));
}Switch.propTypes = propTypes, Switch.defaultProps = defaultProps, exports.default = Switch;

/***/ }),

/***/ "knrM":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("B9Lq");
var enumBugKeys = __webpack_require__("KxjL");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "koiw":
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__("ywQn");
var isArguments = __webpack_require__("6ord");
var is = __webpack_require__("2pTr");
var isRegex = __webpack_require__("DhUb");
var flags = __webpack_require__("DbQ/");
var isDate = __webpack_require__("NyUK");

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) {
    return false;
  }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) {
    return false;
  }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) {
    return false;
  }

  if (isArguments(a) !== isArguments(b)) {
    return false;
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) {
    return false;
  }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) {
    return false;
  }
  if (aIsBuffer || bIsBuffer) {
    // && would work too, because both are true or both false here
    if (a.length !== b.length) {
      return false;
    }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) {
    // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) {
    return false;
  }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) {
      return false;
    }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) {
      return false;
    }
  }

  return true;
}

module.exports = deepEqual;

/***/ }),

/***/ "kvem":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("SNRl");
var newPromiseCapabilityModule = __webpack_require__("JteQ");
var perform = __webpack_require__("1UNZ");

// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$({ target: 'Promise', stat: true }, {
  'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapabilityModule.f(this);
    var result = perform(callbackfn);
    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
    return promiseCapability.promise;
  }
});

/***/ }),

/***/ "ky2m":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("BtHH");
module.exports = __webpack_require__("zKeE").Object.getPrototypeOf;

/***/ }),

/***/ "l262":
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "l2iA":
/***/ (function(module, exports) {


/**
 * Export.
 */

module.exports = toNoCase;

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/;
var hasSeparator = /(_|-|\.|:)/;
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase();
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase();
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase();
  return string.toLowerCase();
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g;

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : '';
  });
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g;

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ');
  });
}

/***/ }),

/***/ "lB5c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__("ORnL");

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__("9km1");

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__("RGc6");

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__("45fX");

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__("cX2q");

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__("JAZJ");

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__("kD/w");

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__("7qbT");

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__("N2wP");

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__("f+fx");

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),

/***/ "lEU8":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("G69i");
var Iterators = __webpack_require__("25e4");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

/***/ }),

/***/ "lH4u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b4df1b7f10a5c09cdf6bfd211f4bc615.png";

/***/ }),

/***/ "laFM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("T4f3");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("zCAL");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__("KQdW");

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__("NySk");

var _EnhancedButton = __webpack_require__("ydL9");

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FlatButtonLabel = __webpack_require__("/G36");

var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

var FlatButton = function (_Component) {
  (0, _inherits3.default)(FlatButton, _Component);

  function FlatButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FlatButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      // Cancel hover styles for touch devices
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FlatButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({
          hovered: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          children = _props.children,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          hoverColor = _props.hoverColor,
          icon = _props.icon,
          label = _props.label,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          primary = _props.primary,
          rippleColor = _props.rippleColor,
          secondary = _props.secondary,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
      var _context$muiTheme = this.context.muiTheme,
          borderRadius = _context$muiTheme.borderRadius,
          _context$muiTheme$but = _context$muiTheme.button,
          buttonHeight = _context$muiTheme$but.height,
          buttonMinWidth = _context$muiTheme$but.minWidth,
          buttonTextTransform = _context$muiTheme$but.textTransform,
          _context$muiTheme$fla = _context$muiTheme.flatButton,
          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
          buttonColor = _context$muiTheme$fla.color,
          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
          fontSize = _context$muiTheme$fla.fontSize,
          fontWeight = _context$muiTheme$fla.fontWeight,
          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
          textColor = _context$muiTheme$fla.textColor,
          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;

      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;

      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
      var defaultRippleColor = buttonFilterColor;
      var buttonHoverColor = hoverColor || defaultHoverColor;
      var buttonRippleColor = rippleColor || defaultRippleColor;
      var buttonBackgroundColor = backgroundColor || buttonColor;
      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        height: buttonHeight,
        lineHeight: buttonHeight + 'px',
        minWidth: fullWidth ? '100%' : buttonMinWidth,
        color: defaultTextColor,
        transition: _transitions2.default.easeOut(),
        borderRadius: borderRadius,
        userSelect: 'none',
        overflow: 'hidden',
        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
        padding: 0,
        margin: 0,
        textAlign: 'center'
      }, style);

      var iconCloned = void 0;
      var labelStyleIcon = {};

      if (icon) {
        var iconStyles = (0, _simpleAssign2.default)({
          verticalAlign: 'middle',
          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
          marginRight: label && labelPosition === 'before' ? 12 : 0
        }, icon.props.style);
        iconCloned = _react2.default.cloneElement(icon, {
          color: icon.props.color || mergedRootStyles.color,
          style: iconStyles,
          key: 'iconCloned'
        });

        if (labelPosition === 'before') {
          labelStyleIcon.paddingRight = 8;
        } else {
          labelStyleIcon.paddingLeft = 8;
        }
      }

      var mergedLabelStyles = (0, _simpleAssign2.default)({
        letterSpacing: 0,
        textTransform: textTransform,
        fontWeight: fontWeight,
        fontSize: fontSize
      }, labelStyleIcon, labelStyle);

      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { key: 'labelElement', label: label, style: mergedLabelStyles }) : undefined;

      // Place label before or after children.
      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];

      return _react2.default.createElement(_EnhancedButton2.default, (0, _extends3.default)({}, other, {
        disabled: disabled,
        focusRippleColor: buttonRippleColor,
        focusRippleOpacity: 0.3,
        onKeyboardFocus: this.handleKeyboardFocus,
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        onTouchStart: this.handleTouchStart,
        style: mergedRootStyles,
        touchRippleColor: buttonRippleColor,
        touchRippleOpacity: 0.3
      }), enhancedButtonChildren);
    }
  }]);
  return FlatButton;
}(_react.Component);

FlatButton.muiName = 'FlatButton';
FlatButton.defaultProps = {
  disabled: false,
  fullWidth: false,
  labelStyle: {},
  labelPosition: 'after',
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onTouchStart: function onTouchStart() {},
  primary: false,
  secondary: false
};
FlatButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButton.propTypes =  false ? {
  /**
   * Color of button when mouse is not hovering over it.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * This is what will be displayed inside the button.
   * If a label is specified, the text within the label prop will
   * be displayed. Otherwise, the component will expect children
   * which will then be displayed. (In our example,
   * we are nesting an `<input type="file" />` and a `span`
   * that acts as our label to be displayed.) This only
   * applies to flat and raised buttons.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The element to use as the container for the FlatButton. Either a string to
   * use a DOM element or a ReactElement. This is useful for wrapping the
   * FlatButton in a custom Link component. If a ReactElement is given, ensure
   * that it passes all of its given props through to the underlying DOM
   * element and renders its children prop for proper integration.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * Disables the button if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Color of button when mouse hovers over.
   */
  hoverColor: _propTypes2.default.string,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * Use this property to display an icon.
   */
  icon: _propTypes2.default.node,
  /**
   * Label for the button.
   */
  label: validateLabel,
  /**
   * Place label before or after the passed children.
   */
  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * If true, colors button according to
   * primaryTextColor from the Theme.
   */
  primary: _propTypes2.default.bool,
  /**
   * Color for the ripple after button is clicked.
   */
  rippleColor: _propTypes2.default.string,
  /**
   * If true, colors button according to secondaryTextColor from the theme.
   * The primary prop has precendent if set to true.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = FlatButton;

/***/ }),

/***/ "laPu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var charAt = __webpack_require__("Vwb2").charAt;
var toString = __webpack_require__("NyfM");
var InternalStateModule = __webpack_require__("4J90");
var defineIterator = __webpack_require__("PFhi");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
  // `%StringIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

/***/ }),

/***/ "lcWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
// CONCATENATED MODULE: ../node_modules/date-fns/esm/locale/en-US/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */

    , firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = __webpack_exports__["a"] = (locale);

/***/ }),

/***/ "lfEA":
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "lkHq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),

/***/ "luft":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var bind = __webpack_require__("1PPX");
var getOwnPropertyDescriptor = __webpack_require__("HtdO").f;
var macrotask = __webpack_require__("iU4X").set;
var IS_IOS = __webpack_require__("eObX");
var IS_IOS_PEBBLE = __webpack_require__("JzUE");
var IS_WEBOS_WEBKIT = __webpack_require__("y5eN");
var IS_NODE = __webpack_require__("5dKy");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function flush() {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();else last = undefined;
        throw error;
      }
    }last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function notify() {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function notify() {
      then(flush);
    };
    // Node.js without promises
  } else if (IS_NODE) {
    notify = function notify() {
      process.nextTick(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind(macrotask, global);
    notify = function notify() {
      macrotask(flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  }last = task;
};

/***/ }),

/***/ "lwyd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var IteratorPrototype = __webpack_require__("AkN1").IteratorPrototype;
var create = __webpack_require__("jqpc");
var createPropertyDescriptor = __webpack_require__("v6/v");
var setToStringTag = __webpack_require__("FfP1");
var Iterators = __webpack_require__("25e4");

var returnThis = function returnThis() {
  return this;
};

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

/***/ }),

/***/ "lyLi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),

/***/ "lytE":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("MpYs");
var defined = __webpack_require__("U72i");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),

/***/ "lzt6":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

/***/ }),

/***/ "m+xf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__("v5sI");
} catch (err) {
  var index = __webpack_require__("v5sI");
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function (el) {
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function (name) {
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function (name) {
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function (re) {
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function (name, force) {
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function () {
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has = ClassList.prototype.contains = function (name) {
  return this.list ? this.list.contains(name) : !!~index(this.array(), name);
};

/***/ }),

/***/ "mGt/":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var isObject = __webpack_require__("FS7x");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

/***/ }),

/***/ "mKtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("T4f3");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("Xos8");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("dACh");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("jx4H");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("VOrx");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("ZKjc");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/rc-util/es/unsafeLifecyclesPolyfill.js


var unsafeLifecyclesPolyfill_unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!preact_compat_es["default"].Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ var es_unsafeLifecyclesPolyfill = (unsafeLifecyclesPolyfill_unsafeLifecyclesPolyfill);
// CONCATENATED MODULE: ../node_modules/rc-animate/es/ChildrenUtils.js


function toArrayChildren(children) {
  var ret = [];
  preact_compat_es["default"].Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}
// EXTERNAL MODULE: ../node_modules/css-animation/es/index.js + 1 modules
var es = __webpack_require__("f3eR");

// CONCATENATED MODULE: ../node_modules/rc-animate/es/util/animate.js
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ var animate = (util);
// CONCATENATED MODULE: ../node_modules/rc-animate/es/AnimateChild.js










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild_AnimateChild = function (_React$Component) {
  inherits_default()(AnimateChild, _React$Component);

  function AnimateChild() {
    classCallCheck_default()(this, AnimateChild);

    return possibleConstructorReturn_default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  createClass_default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (animate.isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (animate.isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (animate.isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = preact_compat_es["default"].findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((es["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(es["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(preact_compat_es["default"].Component);

AnimateChild_AnimateChild.propTypes = {
  children: prop_types_default.a.any,
  animation: prop_types_default.a.any,
  transitionName: prop_types_default.a.any
};
/* harmony default export */ var es_AnimateChild = (AnimateChild_AnimateChild);
// CONCATENATED MODULE: ../node_modules/rc-animate/es/Animate.js













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (preact_compat_es["default"].isValidElement(children)) {
    if (!children.key) {
      return preact_compat_es["default"].cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate_Animate = function (_React$Component) {
  inherits_default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    classCallCheck_default()(this, Animate);

    var _this = possibleConstructorReturn_default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    Animate__initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: toArrayChildren(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  createClass_default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = toArrayChildren(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? toArrayChildren(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && findChildInChildrenByKey(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = preact_compat_es["default"].cloneElement(nextChild || currentChild, defineProperty_default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !findChildInChildrenByKey(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = mergeChildren(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && findChildInChildrenByKey(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = findShownChildInChildrenByKey(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && findChildInChildrenByKey(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = findShownChildInChildrenByKey(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return findShownChildInChildrenByKey(currentChildren, key, showProp);
      }
      return findChildInChildrenByKey(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return preact_compat_es["default"].createElement(es_AnimateChild, {
            key: child.key,
            ref: function ref(node) {
              _this4.childrenRefs[child.key] = node;
            },
            animation: props.animation,
            transitionName: props.transitionName,
            transitionEnter: props.transitionEnter,
            transitionAppear: props.transitionAppear,
            transitionLeave: props.transitionLeave
          }, child);
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = extends_default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return preact_compat_es["default"].createElement(Component, passedProps, children);
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(preact_compat_es["default"].Component);

Animate_Animate.isAnimate = true;

Animate_Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var Animate__initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = toArrayChildren(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (animate.allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (animate.allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = toArrayChildren(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (animate.allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!isSameChildren(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ var es_Animate = __webpack_exports__["a"] = (es_unsafeLifecyclesPolyfill(Animate_Animate));

/***/ }),

/***/ "mQtc":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("NyfM");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};

/***/ }),

/***/ "mYpx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("VuZO");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "mZSj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "mbLO":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("U72i");
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),

/***/ "mbma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return moduleName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CATEGORY_LEVELS; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getNextCategoryLevel;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectCategoriesFetched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectCategoriesByLevels; });
/* unused harmony export selectCategoriesServices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectCategoriesServiceTagsToNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("vyGZ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// Constants (down)

var moduleName = 'categories';

var CATEGORY_LEVELS = {
  SECTORS: 'sectors',
  CATEGORIES: 'categories',
  SERVICES: 'services'
};

/**
 *
 * @param {string} currentLevel
 *
 * @return {string|null}
 */
function getNextCategoryLevel(currentLevel) {
  var levelsAsValues = Object.values(CATEGORY_LEVELS);

  if (levelsAsValues.includes(currentLevel)) {
    var currentLevelIndex = levelsAsValues.indexOf(currentLevel);

    return levelsAsValues[currentLevelIndex + 1] || null;
  }

  return null;
}

// Constants (up)

// Reducer (down)

var initialState = {
  fetched: false,
  fetching: false,
  entities: []
};

/* harmony default export */ __webpack_exports__["b"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CATEGORIES_FETCH_REQUEST:
      return _extends({}, state, {
        fetched: false,
        fetching: true,
        entities: initialState.entities
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CATEGORIES_FETCH_SUCCESS:
      {
        var categories = payload.categories;


        return _extends({}, state, {
          fetched: true,
          fetching: false,
          entities: [].concat(categories)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CATEGORIES_FETCH_FAILURE:
      return _extends({}, state, {
        fetched: false,
        fetching: false,
        entities: []
      });

    default:
      return state;
  }
});

// Reducer (up)

// Selectors (down)

var stateSelector = function stateSelector(state) {
  return state[moduleName];
};

var selectCategoriesFetched = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (categories) {
  return categories.fetched;
});

var selectCategories = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (categories) {
  return categories.entities;
});

var selectCategoriesByLevels = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectCategories, function (entities) {
  var categoriesByLevels = Object.values(CATEGORY_LEVELS).reduce(function (result, currentLevel) {
    var _extends2;

    return _extends({}, result, (_extends2 = {}, _extends2[currentLevel] = [], _extends2));
  }, {});

  entities.forEach(function (sector) {
    categoriesByLevels[CATEGORY_LEVELS.SECTORS].push(_extends({}, sector));

    sector.childs.forEach(function (category) {
      categoriesByLevels[CATEGORY_LEVELS.CATEGORIES].push(_extends({}, category));

      category.childs.forEach(function (service) {
        categoriesByLevels[CATEGORY_LEVELS.SERVICES].push(_extends({}, service));
      });
    });
  });

  return categoriesByLevels;
});

var selectCategoriesServices = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectCategoriesByLevels, function (categoriesByLevels) {
  return categoriesByLevels[CATEGORY_LEVELS.SERVICES] || [];
});

var selectCategoriesServiceTagsToNames = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(selectCategoriesServices, function (services) {
  return services.reduce(function (result, _ref) {
    var _extends3;

    var name = _ref.name,
        tag = _ref.tag;
    return _extends({}, result, (_extends3 = {}, _extends3[tag] = name, _extends3));
  }, {});
});

// Selectors (up)

/***/ }),

/***/ "mecS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["s"] = proFind;
/* harmony export (immutable) */ __webpack_exports__["q"] = logIn;
/* harmony export (immutable) */ __webpack_exports__["r"] = logOut;
/* harmony export (immutable) */ __webpack_exports__["i"] = getCalls;
/* unused harmony export getCallHistory */
/* harmony export (immutable) */ __webpack_exports__["n"] = getTransactions;
/* harmony export (immutable) */ __webpack_exports__["p"] = getWithdraw;
/* harmony export (immutable) */ __webpack_exports__["g"] = editDetails;
/* harmony export (immutable) */ __webpack_exports__["D"] = switchData;
/* harmony export (immutable) */ __webpack_exports__["J"] = verify;
/* harmony export (immutable) */ __webpack_exports__["v"] = register;
/* harmony export (immutable) */ __webpack_exports__["o"] = getUserInfo;
/* harmony export (immutable) */ __webpack_exports__["w"] = registerPro;
/* harmony export (immutable) */ __webpack_exports__["l"] = getProRegistrationInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = cancelProPending;
/* harmony export (immutable) */ __webpack_exports__["x"] = registerProUser;
/* harmony export (immutable) */ __webpack_exports__["m"] = getProUserRegistrationInfo;
/* harmony export (immutable) */ __webpack_exports__["c"] = cancelProUserPending;
/* harmony export (immutable) */ __webpack_exports__["j"] = getCategories;
/* harmony export (immutable) */ __webpack_exports__["z"] = resetPassword;
/* harmony export (immutable) */ __webpack_exports__["I"] = uploadPhoto;
/* harmony export (immutable) */ __webpack_exports__["A"] = sendContactData;
/* harmony export (immutable) */ __webpack_exports__["e"] = checkTaxId;
/* unused harmony export authWithSocialNetwork */
/* harmony export (immutable) */ __webpack_exports__["C"] = setUserState;
/* harmony export (immutable) */ __webpack_exports__["y"] = removeUserState;
/* harmony export (immutable) */ __webpack_exports__["h"] = getAvailability;
/* harmony export (immutable) */ __webpack_exports__["f"] = deleteAvailability;
/* harmony export (immutable) */ __webpack_exports__["B"] = setAvailability;
/* harmony export (immutable) */ __webpack_exports__["F"] = updateAvailability;
/* harmony export (immutable) */ __webpack_exports__["H"] = updateUserSettings;
/* harmony export (immutable) */ __webpack_exports__["k"] = getDeepLink;
/* harmony export (immutable) */ __webpack_exports__["E"] = unreadMessagesController;
/* harmony export (immutable) */ __webpack_exports__["a"] = addDeviceForCurrentUser;
/* harmony export (immutable) */ __webpack_exports__["G"] = updateDeviceForCurrentUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = checkAppMinVersionSupport;
/* unused harmony export sharePro */
/* harmony export (immutable) */ __webpack_exports__["u"] = refreshToken;
/* harmony export (immutable) */ __webpack_exports__["t"] = proShare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("/C1n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_consts__ = __webpack_require__("4PH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__ = __webpack_require__("ds2O");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function proFind(_ref) {
  return new Promise(function ($return, $error) {
    var authData, bodyParams, headers, requestOptions, response;
    authData = _ref.authData, bodyParams = _ref.bodyParams;
    var $Try_1_Post = function () {
      try {
        return $return();
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };var $Try_1_Catch = function (error) {
      try {
        throw new Error(error.message);
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };
    try {
      headers = new Headers();

      headers.append('Authorization', authData);
      headers.append('Content-Type', 'application/json');

      requestOptions = {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(bodyParams)
      };

      return Promise.resolve(fetch(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].USERS_PRO_FIND, requestOptions)).then(function ($await_2) {
        try {
          response = $await_2;

          if (response.status === 401) {
            return $return({});
          }

          return Promise.resolve(response.json()).then($return, $Try_1_Catch);
        } catch ($boundEx) {
          return $Try_1_Catch($boundEx);
        }
      }, $Try_1_Catch);
    } catch (error) {
      $Try_1_Catch(error)
    }
  });
}

function logIn(authData) {
  var headers = new Headers();

  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].LOG_IN, { method: 'GET', headers: headers });
}

function logOut(authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Device', localStorage.getItem('uuid'));

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].LOG_IN, { method: 'DELETE', headers: headers });
}

function getCalls(authData, isProCalls) {
  var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'activity';
  var q = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  var headers = new Headers();
  headers.append('Authorization', authData);

  var query = '&sort=' + sort + '&q=' + q + '&page=' + (page - 1) + '&size=' + __WEBPACK_IMPORTED_MODULE_1__utils_consts__["E" /* consts */].PAGE_SIZE;
  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])((isProCalls ? __WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].GET_PRO_CALLS : __WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].GET_PERSONAL_CALLS) + query, { method: 'GET', headers: headers });
}

function getCallHistory(id) {
  var isPro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var page = arguments[2];
  var authData = arguments[3];

  var headers = new Headers();
  headers.append('Authorization', authData);

  var additionalQuery = '?isPro=' + isPro;

  if (page) {
    additionalQuery = additionalQuery + '&page=' + page;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].CALL_HISTORY(id) + additionalQuery, { method: 'GET', headers: headers });
}

function getTransactions(authData, num, page) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);
  var additionalQuery = num && page ? '?size=' + num + '&page=' + (page - 1) : '';

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].GET_TRANSACTIONS + additionalQuery, { method: 'POST', headers: headers });
}

function getWithdraw(authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].PAYOUT_V3, { method: 'GET', headers: headers });
}

function editDetails(data, userAuth) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', userAuth);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].EDIT_DETAILS, { method: 'PUT', headers: headers, body: JSON.stringify(data) });
}

function switchData(url, isOn, userAuth) {
  var headers = new Headers();
  headers.append('Authorization', userAuth);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(url, { method: isOn ? 'POST' : 'DELETE', headers: headers });
}

function verify(token) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].VERIFY_USER + '?token=' + token, { method: 'GET' }).then(function (response) {
    return {
      authData: window.btoa(response.email + ':' + response.password)
    };
  });
}

function register(data) {
  var headers = new Headers();

  headers.append('Content-Type', 'application/json ');

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].REGISTER, { method: 'POST', headers: headers, body: JSON.stringify(data) });
}

function getUserInfo(authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].GET_V3_CURRENT_USER_DETAILS, { method: 'GET', headers: headers });
}

function registerPro(data, authData) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].REGISTER_PRO(data.id), { method: 'POST', headers: headers, body: JSON.stringify(data) });
}

function getProRegistrationInfo(id, authData) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].REGISTER_PRO(id), { method: 'GET', headers: headers });
}

function cancelProPending(id, authData) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].REGISTER_PRO(id), { method: 'DELETE', headers: headers });
}

function registerProUser(data, authData) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);
  var body = JSON.stringify(data);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].REGISTER_PRO_USER, { method: 'POST', headers: headers, body: body });
}

function getProUserRegistrationInfo(authData) {
  var approved = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].REGISTER_PRO_USER + '?approved=' + approved, { method: 'GET', headers: headers });
}

function cancelProUserPending(authData) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].REGISTER_PRO_USER, { method: 'DELETE', headers: headers });
}

function getCategories(authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].GET_CATEGORIES, { method: 'GET', headers: headers });
}

function resetPassword(data) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json ');

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].RESET_PASSWORD, { method: 'POST', headers: headers, body: JSON.stringify(data) });
}

function uploadPhoto(authData, photo, filName) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  var body = new FormData();
  body.append('file', photo, filName);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].UPLOAD_PHOTO, { method: 'POST', headers: headers, body: body });
}

function sendContactData(data) {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json ');

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].SEND_CONTACT_DATA, { method: 'PUT', headers: headers, body: JSON.stringify(data) });
}

function checkTaxId(taxId, authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].GET_COMPANY_TAX_ID(taxId), { method: 'GET', headers: headers });
}

function authWithSocialNetwork(providerId, authData, partner) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].OAUTH2(providerId, partner), { method: 'GET', headers: headers });
}

function setUserState(key, authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].SET_STATE(key), { method: 'PUT', headers: headers });
}

function removeUserState(key, authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].REMOVE_STATE(key), { method: 'DELETE', headers: headers });
}

function getAvailability(authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].AVAILABILITY, { method: 'GET', headers: headers });
}

function deleteAvailability(authData, data) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].AVAILABILITY, {
    method: 'DELETE',
    headers: headers,
    body: JSON.stringify(_extends({}, data))
  });
}

function setAvailability(authData, _ref2) {
  var msFrom = _ref2.msFrom,
      msTo = _ref2.msTo,
      daysList = _ref2.daysList;

  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].AVAILABILITY, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      msFrom: msFrom,
      msTo: msTo,
      daysList: daysList
    })
  });
}
function updateAvailability(authData, data) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].AVAILABILITY, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({
      msFrom: data.msFrom,
      msTo: data.msTo,
      daysList: data.daysList,
      id: data.id
    })
  });
}

var userSettingController = new AbortController();
var requestSend = false;

function updateUserSettings(authData, settings) {
  if (requestSend) {
    requestSend = false;
    userSettingController.abort();
    userSettingController = new AbortController();
  }
  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');
  requestSend = true;

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].USER_SETTINGS, {
    method: 'PUT', headers: headers, body: JSON.stringify(settings), signal: userSettingController.signal
  }).then(function (response) {
    requestSend = false;
    return response;
  });
}

function getDeepLink(authData) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].DEEP_LINK, { method: 'GET', headers: headers });
}

function unreadMessagesController(authData, id) {
  var headers = new Headers();
  headers.append('Authorization', authData);

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].BADGE(id), { method: id ? 'POST' : 'GET', headers: headers });
}

function addDeviceForCurrentUser(authData, body) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].DEVICE(), { method: 'POST', headers: headers, body: JSON.stringify(body) });
}

function updateDeviceForCurrentUser(authData, deviceId, body) {
  var headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].DEVICE(deviceId), { method: 'PUT', headers: headers, body: JSON.stringify(body) });
}

function checkAppMinVersionSupport(type, version) {
  return new Promise(function ($return, $error) {
    var response, responseJson;
    return Promise.resolve(fetch(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].VERSION(type, version), { method: 'POST' })).then(function ($await_4) {
      try {
        response = $await_4;
        if (response.status === 200 || response.status === 400) return $return(response.ok);

        return Promise.resolve(response.json()).then(function ($await_5) {
          try {
            responseJson = $await_5;

            return $error(new Error(responseJson.error));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
}

var getProsController = new AbortController();
var requestGetProsSend = false;

function sharePro(authData, query) {
  return new Promise(function ($return, $error) {
    var headers;

    if (requestGetProsSend) {
      requestGetProsSend = false;
      getProsController.abort();
      getProsController = new AbortController();
    }
    headers = new Headers();
    headers.append('Authorization', authData);
    headers.append('Content-Type', 'application/json');

    // eslint-disable-next-line no-return-await
    return Promise.resolve(Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].SHARE(query), { method: 'GET', headers: headers, signal: getProsController.signal }).then(function (response) {
      requestGetProsSend = false;
      return response;
    })).then($return, $error);
  });
}

function refreshToken(accessToken, refreshTokenStr) {
  var $args = arguments;return new Promise(function ($return, $error) {
    var tokenType = $args.length > 2 && $args[2] !== undefined ? $args[2] : 'Bearer';

    var headers = new Headers();
    headers.append('Content-Type', 'application/json');

    var body = JSON.stringify({
      accessToken: accessToken,
      refreshToken: refreshTokenStr,
      tokenType: tokenType
    });

    return $return(Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].REFRESH, { method: 'POST', headers: headers, body: body }));
  });
}

function proShare(_ref3) {
  var authData = _ref3.authData,
      query = _ref3.query;

  var headers = new Headers();

  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  var options = {
    headers: headers,
    method: 'GET'
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__fetch_wrapper__["a" /* http */])(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* apiUrls */].USERS_PRO_SHARE(query), options);
}

/***/ }),

/***/ "mo7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__("VYL5");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__("KYJg");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__("2kK6");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/addDays/index.js



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/add/index.js






/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add(dirtyDate, duration) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  if (!duration || typeof duration !== 'object') return new Date(NaN);
  var years = duration.years ? Object(toInteger["a" /* default */])(duration.years) : 0;
  var months = duration.months ? Object(toInteger["a" /* default */])(duration.months) : 0;
  var weeks = duration.weeks ? Object(toInteger["a" /* default */])(duration.weeks) : 0;
  var days = duration.days ? Object(toInteger["a" /* default */])(duration.days) : 0;
  var hours = duration.hours ? Object(toInteger["a" /* default */])(duration.hours) : 0;
  var minutes = duration.minutes ? Object(toInteger["a" /* default */])(duration.minutes) : 0;
  var seconds = duration.seconds ? Object(toInteger["a" /* default */])(duration.seconds) : 0; // Add years and months

  var date = Object(toDate["a" /* default */])(dirtyDate);
  var dateWithMonths = months || years ? addMonths(date, months + years * 12) : date; // Add weeks and days

  var dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds

  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1000;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isWeekend/index.js


/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */

function isWeekend(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var day = date.getDay();
  return day === 0 || day === 6;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSunday/index.js


/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */

function isSunday(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getDay() === 0;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSaturday/index.js


/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */

function isSaturday(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getDay() === 6;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/addBusinessDays/index.js






/**
 * @name addBusinessDays
 * @category Day Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the business days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */

function addBusinessDays(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var startedOnWeekend = isWeekend(date);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  if (isNaN(amount)) return new Date(NaN);
  var hours = date.getHours();
  var sign = amount < 0 ? -1 : 1;
  var fullWeeks = Object(toInteger["a" /* default */])(amount / 5);
  date.setDate(date.getDate() + fullWeeks * 7); // Get remaining days not part of a full week

  var restDays = Math.abs(amount % 5); // Loops over remaining days

  while (restDays > 0) {
    date.setDate(date.getDate() + sign);
    if (!isWeekend(date)) restDays -= 1;
  } // If the date is a weekend day and we reduce a dividable of
  // 5 from it, we land on a weekend date.
  // To counter this, we add days accordingly to land on the next business day


  if (startedOnWeekend && isWeekend(date) && amount !== 0) {
    // If we're reducing days, we want to add days until we land on a weekday
    // If we're adding days we want to reduce days until we land on a weekday
    if (isSaturday(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
    if (isSunday(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
  } // Restore hours to avoid DST lag


  date.setHours(hours);
  return date;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/addMilliseconds/index.js
var addMilliseconds = __webpack_require__("umce");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/addHours/index.js



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return Object(addMilliseconds["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfWeek/index.js



/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(toInteger["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(toInteger["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(toDate["a" /* default */])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */

function getISOWeekYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfISOWeekYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/differenceInCalendarDays/index.js
var differenceInCalendarDays = __webpack_require__("ieRm");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/setISOWeekYear/index.js





/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `setISOYear` to `setISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */

function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var isoWeekYear = Object(toInteger["a" /* default */])(dirtyISOWeekYear);
  var diff = Object(differenceInCalendarDays["a" /* default */])(date, startOfISOWeekYear(date));
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  date = startOfISOWeekYear(fourthOfJanuary);
  date.setDate(date.getDate() + diff);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/addISOWeekYears/index.js




/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `addISOYears` to `addISOWeekYears`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the ISO week-numbering years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */

function addISOWeekYears(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return setISOWeekYear(dirtyDate, getISOWeekYear(dirtyDate) + amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/addMinutes/index.js



var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return Object(addMilliseconds["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/addQuarters/index.js



/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */

function addQuarters(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  var months = amount * 3;
  return addMonths(dirtyDate, months);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/addSeconds/index.js



/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */

function addSeconds(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return Object(addMilliseconds["a" /* default */])(dirtyDate, amount * 1000);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/addWeeks/index.js



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/addYears/index.js



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/areIntervalsOverlapping/index.js


/**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `areRangesOverlapping` to `areIntervalsOverlapping`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   areRangesOverlapping(
 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   areIntervalsOverlapping(
 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 *   )
 *   ```
 *
 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
 * @returns {Boolean} whether the time intervals are overlapping
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */

function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    inclusive: false
  };
  Object(requiredArgs["a" /* default */])(2, arguments);
  var intervalLeft = dirtyIntervalLeft || {};
  var intervalRight = dirtyIntervalRight || {};
  var leftStartTime = Object(toDate["a" /* default */])(intervalLeft.start).getTime();
  var leftEndTime = Object(toDate["a" /* default */])(intervalLeft.end).getTime();
  var rightStartTime = Object(toDate["a" /* default */])(intervalRight.start).getTime();
  var rightEndTime = Object(toDate["a" /* default */])(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError('Invalid interval');
  }

  if (options.inclusive) {
    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
  }

  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/max/index.js


/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `max` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var maxDate = max(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var maxDate = max(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max(dirtyDatesArray) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(toDate["a" /* default */])(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/min/index.js


/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `min` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   const date1 = new Date(1989, 6, 10)
 *   const date2 = new Date(1987, 1, 11)
 *   const minDate = min(date1, date2)
 *
 *   // v2.0.0 onward:
 *   const dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   const minDate = min(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min(dirtyDatesArray) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(toDate["a" /* default */])(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/clamp/index.js



/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 *
 * @param {Date | Number} date - the date to be bounded
 * @param {Interval} interval - the interval to bound to
 * @returns {Date} the date bounded by the start and the end of the interval
 * @throws {TypeError} 2 arguments required
 */

function clamp(date, _ref) {
  var start = _ref.start,
      end = _ref.end;
  Object(requiredArgs["a" /* default */])(2, arguments);
  return min([max([date, start]), end]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/closestIndexTo/index.js


/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now, `closestIndexTo` doesn't throw an exception
 *   when the second argument is not an array, and returns Invalid Date instead.
 *
 * @param {Date | Number} dateToCompare - the date to compare with
 * @param {Array<Date> | Array<number>} datesArray - the array to search
 * @returns {Number | undefined} an index of the date closest to the given date or undefined if no valid value is given
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */

function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateToCompare = Object(toDate["a" /* default */])(dirtyDateToCompare);
  if (isNaN(Number(dateToCompare))) return NaN;
  var timeToCompare = dateToCompare.getTime();
  var datesArray; // `dirtyDatesArray` is undefined or null

  if (dirtyDatesArray == null) {
    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  }

  var result;
  var minDistance;
  datesArray.forEach(function (dirtyDate, index) {
    var currentDate = Object(toDate["a" /* default */])(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = NaN;
      minDistance = NaN;
      return;
    }

    var distance = Math.abs(timeToCompare - currentDate.getTime());

    if (result == null || distance < Number(minDistance)) {
      result = index;
      minDistance = distance;
    }
  });
  return result;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/closestTo/index.js


/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now, `closestTo` doesn't throw an exception
 *   when the second argument is not an array, and returns Invalid Date instead.
 *
 * @param {Date | Number} dateToCompare - the date to compare with
 * @param {Array<Date> | Array<number>} datesArray - the array to search
 * @returns {Date | undefined} the date from the array closest to the given date or undefined if no valid value is given
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */

function closestTo(dirtyDateToCompare, dirtyDatesArray) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateToCompare = Object(toDate["a" /* default */])(dirtyDateToCompare);
  if (isNaN(Number(dateToCompare))) return new Date(NaN);
  var timeToCompare = dateToCompare.getTime();
  var datesArray; // `dirtyDatesArray` is undefined or null

  if (dirtyDatesArray == null) {
    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  }

  var result;
  var minDistance;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(toDate["a" /* default */])(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = new Date(NaN);
      minDistance = NaN;
      return;
    }

    var distance = Math.abs(timeToCompare - currentDate.getTime());

    if (result == null || distance < Number(minDistance)) {
      result = currentDate;
      minDistance = distance;
    }
  });
  return result;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/compareAsc/index.js


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/compareDesc/index.js


/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */

function compareDesc(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff > 0) {
    return -1;
  } else if (diff < 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__("f5Sh");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/daysToWeeks/index.js


/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @param {number} days - number of days to be converted
 *
 * @returns {number} the number of days converted in weeks
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */

function daysToWeeks(days) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var weeks = days / constants["a" /* daysInWeek */];
  return Math.floor(weeks);
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__("DgmM");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameDay/index.js


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeftStartOfDay = Object(startOfDay["a" /* default */])(dirtyDateLeft);
  var dateRightStartOfDay = Object(startOfDay["a" /* default */])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__("WNaj");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInBusinessDays/index.js








/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of business days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 1 November 2021 and 30 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 30)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> 22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */

function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  if (!Object(isValid["a" /* default */])(dateLeft) || !Object(isValid["a" /* default */])(dateRight)) return NaN;
  var calendarDifference = Object(differenceInCalendarDays["a" /* default */])(dateLeft, dateRight);
  var sign = calendarDifference < 0 ? -1 : 1;
  var weeks = Object(toInteger["a" /* default */])(calendarDifference / 7);
  var result = weeks * 5;
  dateRight = addDays(dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week

  while (!isSameDay(dateLeft, dateRight)) {
    // sign is used to account for both negative and positive differences
    result += isWeekend(dateRight) ? 0 : sign;
    dateRight = addDays(dateRight, sign);
  }

  return result === 0 ? 0 : result;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInCalendarISOWeekYears/index.js


/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `differenceInCalendarISOYears` to `differenceInCalendarISOWeekYears`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */

function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  return getISOWeekYear(dirtyDateLeft) - getISOWeekYear(dirtyDateRight);
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__("aFbL");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInCalendarISOWeeks/index.js



var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */

function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft);
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight);
  var timestampLeft = startOfISOWeekLeft.getTime() - Object(getTimezoneOffsetInMilliseconds["a" /* default */])(startOfISOWeekLeft);
  var timestampRight = startOfISOWeekRight.getTime() - Object(getTimezoneOffsetInMilliseconds["a" /* default */])(startOfISOWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInCalendarMonths/index.js


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getQuarter/index.js


/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInCalendarQuarters/index.js



/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */

function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight);
  return yearDiff * 4 + quarterDiff;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInCalendarWeeks/index.js



var differenceInCalendarWeeks_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions);
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions);
  var timestampLeft = startOfWeekLeft.getTime() - Object(getTimezoneOffsetInMilliseconds["a" /* default */])(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - Object(getTimezoneOffsetInMilliseconds["a" /* default */])(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / differenceInCalendarWeeks_MILLISECONDS_IN_WEEK);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInCalendarYears/index.js


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInDays/index.js


 // Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.

function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */

function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(Object(differenceInCalendarDays["a" /* default */])(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/differenceInHours/index.js
var differenceInHours = __webpack_require__("ZVcj");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/subISOWeekYears/index.js



/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `subISOYears` to `subISOWeekYears`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */

function subISOWeekYears(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addISOWeekYears(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInISOWeekYears/index.js





/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `differenceInISOYears` to `differenceInISOWeekYears`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */

function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarISOWeekYears(dateLeft, dateRight));
  dateLeft = subISOWeekYears(dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastISOWeekYearNotFull = Number(compareAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/differenceInMilliseconds/index.js
var differenceInMilliseconds = __webpack_require__("H70G");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/differenceInMinutes/index.js
var differenceInMinutes = __webpack_require__("oGJj");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfDay/index.js


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfMonth/index.js


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isLastDayOfMonth/index.js




/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */

function isLastDayOfMonth(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInMonths/index.js





/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result; // Check for the difference of less than month

  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }

    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

    if (isLastDayOfMonth(Object(toDate["a" /* default */])(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  } // Prevent negative zero


  return result === 0 ? 0 : result;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMethods = __webpack_require__("tKq7");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInQuarters/index.js



/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */

function differenceInQuarters(dateLeft, dateRight, options) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var diff = differenceInMonths(dateLeft, dateRight) / 3;
  return Object(roundingMethods["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInSeconds/index.js



/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds(dateLeft, dateRight, options) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var diff = Object(differenceInMilliseconds["a" /* default */])(dateLeft, dateRight) / 1000;
  return Object(roundingMethods["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInWeeks/index.js



/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */

function differenceInWeeks(dateLeft, dateRight, options) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var diff = differenceInDays(dateLeft, dateRight) / 7;
  return Object(roundingMethods["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/differenceInYears/index.js




/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */

function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days

  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero

  return result === 0 ? 0 : result;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachDayOfInterval/index.js


/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
 *
 *   // v2.0.0 onward
 *
 *   eachDayOfInterval(
 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
 *   )
 *   ```
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(toDate["a" /* default */])(interval.start);
  var endDate = Object(toDate["a" /* default */])(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = options && 'step' in options ? Number(options.step) : 1;
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(Object(toDate["a" /* default */])(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachHourOfInterval/index.js




/**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * var result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */
function eachHourOfInterval(dirtyInterval, options) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(toDate["a" /* default */])(interval.start);
  var endDate = Object(toDate["a" /* default */])(interval.end);
  var startTime = startDate.getTime();
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setMinutes(0, 0, 0);
  var step = options && 'step' in options ? Number(options.step) : 1;
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(Object(toDate["a" /* default */])(currentDate));
    currentDate = addHours(currentDate, step);
  }

  return dates;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfMinute/index.js


/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */

function startOfMinute(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  date.setSeconds(0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachMinuteOfInterval/index.js





/**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The starts of minutes from the hour of the interval start to the hour of the interval end
 * @throws {TypeError} 1 argument requie value should be more than 1.
 * @returns {Date[]} the array withred
 * @throws {RangeError} `options.step` must be a number equal or greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */
function eachMinuteOfInterval(interval, options) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var startDate = startOfMinute(Object(toDate["a" /* default */])(interval.start));
  var endDate = Object(toDate["a" /* default */])(interval.end);
  var startTime = startDate.getTime();
  var endTime = endDate.getTime();

  if (startTime >= endTime) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  var step = options && 'step' in options ? Number(options.step) : 1;
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number equal or greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(Object(toDate["a" /* default */])(currentDate));
    currentDate = addMinutes(currentDate, step);
  }

  return dates;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachMonthOfInterval/index.js


/**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * var result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */

function eachMonthOfInterval(dirtyInterval) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(toDate["a" /* default */])(interval.start);
  var endDate = Object(toDate["a" /* default */])(interval.end);
  var endTime = endDate.getTime();
  var dates = []; // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setDate(1);

  while (currentDate.getTime() <= endTime) {
    dates.push(Object(toDate["a" /* default */])(currentDate));
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return dates;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfQuarter/index.js


/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachQuarterOfInterval/index.js




/**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * var result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */

function eachQuarterOfInterval(dirtyInterval) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(toDate["a" /* default */])(interval.start);
  var endDate = Object(toDate["a" /* default */])(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var startDateQuarter = startOfQuarter(startDate);
  var endDateQuarter = startOfQuarter(endDate);
  endTime = endDateQuarter.getTime();
  var quarters = [];
  var currentQuarter = startDateQuarter;

  while (currentQuarter.getTime() <= endTime) {
    quarters.push(Object(toDate["a" /* default */])(currentQuarter));
    currentQuarter = addQuarters(currentQuarter, 1);
  }

  return quarters;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachWeekOfInterval/index.js




/**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * var result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */

function eachWeekOfInterval(dirtyInterval, options) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(toDate["a" /* default */])(interval.start);
  var endDate = Object(toDate["a" /* default */])(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var startDateWeek = startOfWeek(startDate, options);
  var endDateWeek = startOfWeek(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet

  startDateWeek.setHours(15);
  endDateWeek.setHours(15);
  endTime = endDateWeek.getTime();
  var weeks = [];
  var currentWeek = startDateWeek;

  while (currentWeek.getTime() <= endTime) {
    currentWeek.setHours(0);
    weeks.push(Object(toDate["a" /* default */])(currentWeek));
    currentWeek = addWeeks(currentWeek, 1);
    currentWeek.setHours(15);
  }

  return weeks;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachWeekendOfInterval/index.js




/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @param {Interval} interval - the given interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} an array containing all the Saturdays and Sundays
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */

function eachWeekendOfInterval(interval) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var dateInterval = eachDayOfInterval(interval);
  var weekends = [];
  var index = 0;

  while (index < dateInterval.length) {
    var date = dateInterval[index++];

    if (isWeekend(date)) {
      weekends.push(date);
      if (isSunday(date)) index = index + 5;
    }
  }

  return weekends;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfMonth/index.js


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachWeekendOfMonth/index.js




/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @param {Date|Number} date - the given month
 * @returns {Date[]} an array containing all the Saturdays and Sundays
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The passed date is invalid
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */

function eachWeekendOfMonth(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var startDate = startOfMonth(dirtyDate);
  if (isNaN(startDate.getTime())) throw new RangeError('The passed date is invalid');
  var endDate = endOfMonth(dirtyDate);
  return eachWeekendOfInterval({
    start: startDate,
    end: endDate
  });
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfYear/index.js


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var cleanDate = Object(toDate["a" /* default */])(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfYear/index.js


/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */

function endOfYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachWeekendOfYear/index.js




/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @param {Date|Number} date - the given year
 * @returns {Date[]} an array containing all the Saturdays and Sundays
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The passed date is invalid
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * var result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */

function eachWeekendOfYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var startDate = startOfYear(dirtyDate);
  if (isNaN(startDate)) throw new RangeError('The passed date is invalid');
  var endDate = endOfYear(dirtyDate);
  return eachWeekendOfInterval({
    start: startDate,
    end: endDate
  });
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/eachYearOfInterval/index.js


/**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */

function eachYearOfInterval(dirtyInterval) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(toDate["a" /* default */])(interval.start);
  var endDate = Object(toDate["a" /* default */])(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setMonth(0, 1);

  while (currentDate.getTime() <= endTime) {
    dates.push(Object(toDate["a" /* default */])(currentDate));
    currentDate.setFullYear(currentDate.getFullYear() + 1);
  }

  return dates;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfDecade/index.js


/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a decade
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */

function endOfDecade(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var decade = 9 + Math.floor(year / 10) * 10;
  date.setFullYear(decade, 11, 31);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfHour/index.js


/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */

function endOfHour(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  date.setMinutes(59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfWeek/index.js




/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(toInteger["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(toInteger["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(toDate["a" /* default */])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfISOWeek/index.js


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */

function endOfISOWeek(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return endOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfISOWeekYear/index.js



/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `endOfISOYear` to `endOfISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */

function endOfISOWeekYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear);
  date.setMilliseconds(date.getMilliseconds() - 1);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfMinute/index.js


/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */

function endOfMinute(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  date.setSeconds(59, 999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfQuarter/index.js


/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfQuarter(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfSecond/index.js


/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */

function endOfSecond(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  date.setMilliseconds(999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfToday/index.js

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */

function endOfToday() {
  return endOfDay(Date.now());
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfTomorrow/index.js
/**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/endOfYesterday/index.js
/**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(23, 59, 59, 999);
  return date;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/format/index.js + 2 modules
var esm_format = __webpack_require__("OZJZ");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/locale/en-US/index.js + 9 modules
var en_US = __webpack_require__("lcWw");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/cloneObject/index.js

function cloneObject(dirtyObject) {
  return assign_assign({}, dirtyObject);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatDistance/index.js








var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;
/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `distanceInWords ` to `formatDistance`
 *   to make its name consistent with `format` and `formatRelative`.
 *
 * - The order of arguments is swapped to make the function
 *   consistent with `differenceIn...` functions.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWords(
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     new Date(1986, 3, 4, 11, 32, 0),
 *     { addSuffix: true }
 *   ) //=> 'in about 1 hour'
 *
 *   // v2.0.0 onward
 *
 *   formatDistance(
 *     new Date(1986, 3, 4, 11, 32, 0),
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     { addSuffix: true }
 *   ) //=> 'in about 1 hour'
 *   ```
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(dirtyDate, dirtyBaseDate) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Object(requiredArgs["a" /* default */])(2, arguments);
  var locale = options.locale || en_US["a" /* default */];

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }

  var comparison = compareAsc(dirtyDate, dirtyBaseDate);

  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }

  var localizeOptions = cloneObject(options);
  localizeOptions.addSuffix = Boolean(options.addSuffix);
  localizeOptions.comparison = comparison;
  var dateLeft;
  var dateRight;

  if (comparison > 0) {
    dateLeft = Object(toDate["a" /* default */])(dirtyBaseDate);
    dateRight = Object(toDate["a" /* default */])(dirtyDate);
  } else {
    dateLeft = Object(toDate["a" /* default */])(dirtyDate);
    dateRight = Object(toDate["a" /* default */])(dirtyBaseDate);
  }

  var seconds = differenceInSeconds(dateRight, dateLeft);
  var offsetInSeconds = (Object(getTimezoneOffsetInMilliseconds["a" /* default */])(dateRight) - Object(getTimezoneOffsetInMilliseconds["a" /* default */])(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months; // 0 up to 2 mins

  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance('halfAMinute', null, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', minutes, localizeOptions);
      }
    } // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('aboutXMonths', months, localizeOptions);
  }

  months = differenceInMonths(dateRight, dateLeft); // 2 months up to 12 months

  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12); // N years up to 1 years 3 months

    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatDistanceStrict/index.js






var formatDistanceStrict_MILLISECONDS_IN_MINUTE = 1000 * 60;
var formatDistanceStrict_MINUTES_IN_DAY = 60 * 24;
var formatDistanceStrict_MINUTES_IN_MONTH = formatDistanceStrict_MINUTES_IN_DAY * 30;
var MINUTES_IN_YEAR = formatDistanceStrict_MINUTES_IN_DAY * 365;
/**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
 *   to make its name consistent with `format` and `formatRelative`.
 *
 * - The order of arguments is swapped to make the function
 *   consistent with `differenceIn...` functions.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWordsStrict(
 *     new Date(2015, 0, 2),
 *     new Date(2014, 6, 2)
 *   ) //=> '6 months'
 *
 *   // v2.0.0 onward
 *
 *   formatDistanceStrict(
 *     new Date(2014, 6, 2),
 *     new Date(2015, 0, 2)
 *   ) //=> '6 months'
 *   ```
 *
 * - `partialMethod` option is renamed to `roundingMethod`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWordsStrict(
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     new Date(1986, 3, 4, 10, 33, 1),
 *     { partialMethod: 'ceil' }
 *   ) //=> '2 minutes'
 *
 *   // v2.0.0 onward
 *
 *   formatDistanceStrict(
 *     new Date(1986, 3, 4, 10, 33, 1),
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     { roundingMethod: 'ceil' }
 *   ) //=> '2 minutes'
 *   ```
 *
 * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
 *
 * - `unit` option now accepts one of the strings:
 *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWordsStrict(
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     new Date(1986, 3, 4, 10, 33, 1),
 *     { unit: 'm' }
 *   )
 *
 *   // v2.0.0 onward
 *
 *   formatDistanceStrict(
 *     new Date(1986, 3, 4, 10, 33, 1),
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     { unit: 'minute' }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */

function formatDistanceStrict(dirtyDate, dirtyBaseDate) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Object(requiredArgs["a" /* default */])(2, arguments);
  var locale = options.locale || en_US["a" /* default */];

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain localize.formatDistance property');
  }

  var comparison = compareAsc(dirtyDate, dirtyBaseDate);

  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }

  var localizeOptions = cloneObject(options);
  localizeOptions.addSuffix = Boolean(options.addSuffix);
  localizeOptions.comparison = comparison;
  var dateLeft;
  var dateRight;

  if (comparison > 0) {
    dateLeft = Object(toDate["a" /* default */])(dirtyBaseDate);
    dateRight = Object(toDate["a" /* default */])(dirtyDate);
  } else {
    dateLeft = Object(toDate["a" /* default */])(dirtyDate);
    dateRight = Object(toDate["a" /* default */])(dirtyBaseDate);
  }

  var roundingMethod = options.roundingMethod == null ? 'round' : String(options.roundingMethod);
  var roundingMethodFn;

  if (roundingMethod === 'floor') {
    roundingMethodFn = Math.floor;
  } else if (roundingMethod === 'ceil') {
    roundingMethodFn = Math.ceil;
  } else if (roundingMethod === 'round') {
    roundingMethodFn = Math.round;
  } else {
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  }

  var milliseconds = dateRight.getTime() - dateLeft.getTime();
  var minutes = milliseconds / formatDistanceStrict_MILLISECONDS_IN_MINUTE;
  var timezoneOffset = Object(getTimezoneOffsetInMilliseconds["a" /* default */])(dateRight) - Object(getTimezoneOffsetInMilliseconds["a" /* default */])(dateLeft); // Use DST-normalized difference in minutes for years, months and days;
  // use regular difference in minutes for hours, minutes and seconds.

  var dstNormalizedMinutes = (milliseconds - timezoneOffset) / formatDistanceStrict_MILLISECONDS_IN_MINUTE;
  var unit;

  if (options.unit == null) {
    if (minutes < 1) {
      unit = 'second';
    } else if (minutes < 60) {
      unit = 'minute';
    } else if (minutes < formatDistanceStrict_MINUTES_IN_DAY) {
      unit = 'hour';
    } else if (dstNormalizedMinutes < formatDistanceStrict_MINUTES_IN_MONTH) {
      unit = 'day';
    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
      unit = 'month';
    } else {
      unit = 'year';
    }
  } else {
    unit = String(options.unit);
  } // 0 up to 60 seconds


  if (unit === 'second') {
    var seconds = roundingMethodFn(milliseconds / 1000);
    return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
  } else if (unit === 'minute') {
    var roundedMinutes = roundingMethodFn(minutes);
    return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions); // 1 up to 24 hours
  } else if (unit === 'hour') {
    var hours = roundingMethodFn(minutes / 60);
    return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
  } else if (unit === 'day') {
    var days = roundingMethodFn(dstNormalizedMinutes / formatDistanceStrict_MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
  } else if (unit === 'month') {
    var months = roundingMethodFn(dstNormalizedMinutes / formatDistanceStrict_MINUTES_IN_MONTH);
    return months === 12 && options.unit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
  } else if (unit === 'year') {
    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
    return locale.formatDistance('xYears', years, localizeOptions);
  }

  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatDistanceToNow/index.js


/**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `distanceInWordsToNow ` to `formatDistanceToNow`
 *   to make its name consistent with `format` and `formatRelative`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWordsToNow(new Date(2014, 6, 2), { addSuffix: true })
 *   //=> 'in 6 months'
 *
 *   // v2.0.0 onward
 *
 *   formatDistanceToNow(new Date(2014, 6, 2), { addSuffix: true })
 *   //=> 'in 6 months'
 *   ```
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */

function formatDistanceToNow(dirtyDate, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return formatDistance(dirtyDate, Date.now(), dirtyOptions);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatDistanceToNowStrict/index.js


/**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * var result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = formatDistanceToNowStrict(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */

function formatDistanceToNowStrict(dirtyDate, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return formatDistanceStrict(dirtyDate, Date.now(), dirtyOptions);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatDuration/index.js

var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];

/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @param {Duration} duration - the duration to format
 * @param {Object} [options] - an object with options.
 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
 * @param {boolean} [options.zero=false] - should zeros be included in the output?
 * @param {string} [options.delimiter=' '] - delimiter string
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {string} the formatted date string
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */
function formatDuration(duration) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }

  var format = (options === null || options === void 0 ? void 0 : options.format) || defaultFormat;
  var locale = (options === null || options === void 0 ? void 0 : options.locale) || en_US["a" /* default */];
  var zero = (options === null || options === void 0 ? void 0 : options.zero) || false;
  var delimiter = (options === null || options === void 0 ? void 0 : options.delimiter) || ' ';
  var result = format.reduce(function (acc, unit) {
    var token = "x".concat(unit.replace(/(^.)/, function (m) {
      return m.toUpperCase();
    }));
    var addChunk = typeof duration[unit] === 'number' && (zero || duration[unit]);
    return addChunk && locale.formatDistance ? acc.concat(locale.formatDistance(token, duration[unit])) : acc;
  }, []).join(delimiter);
  return result;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
var addLeadingZeros = __webpack_require__("V2hq");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatISO/index.js



/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
 * @returns {String} the formatted date string (in local time zone)
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */

function formatISO(date, options) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var originalDate = Object(toDate["a" /* default */])(date);

  if (isNaN(originalDate.getTime())) {
    throw new RangeError('Invalid time value');
  }

  var format = !(options !== null && options !== void 0 && options.format) ? 'extended' : String(options.format);
  var representation = !(options !== null && options !== void 0 && options.representation) ? 'complete' : String(options.representation);

  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }

  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }

  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

  if (representation !== 'time') {
    var day = Object(addLeadingZeros["a" /* default */])(originalDate.getDate(), 2);
    var month = Object(addLeadingZeros["a" /* default */])(originalDate.getMonth() + 1, 2);
    var year = Object(addLeadingZeros["a" /* default */])(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  } // Representation is either 'time' or 'complete'


  if (representation !== 'date') {
    // Add the timezone.
    var offset = originalDate.getTimezoneOffset();

    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = Object(addLeadingZeros["a" /* default */])(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = Object(addLeadingZeros["a" /* default */])(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }

    var hour = Object(addLeadingZeros["a" /* default */])(originalDate.getHours(), 2);
    var minute = Object(addLeadingZeros["a" /* default */])(originalDate.getMinutes(), 2);
    var second = Object(addLeadingZeros["a" /* default */])(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'

    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }

  return result;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatISO9075/index.js



/**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */

function formatISO9075(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }

  var originalDate = Object(toDate["a" /* default */])(dirtyDate);

  if (!Object(isValid["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  var options = dirtyOptions || {};
  var format = options.format == null ? 'extended' : String(options.format);
  var representation = options.representation == null ? 'complete' : String(options.representation);

  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }

  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }

  var result = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

  if (representation !== 'time') {
    var day = Object(addLeadingZeros["a" /* default */])(originalDate.getDate(), 2);
    var month = Object(addLeadingZeros["a" /* default */])(originalDate.getMonth() + 1, 2);
    var year = Object(addLeadingZeros["a" /* default */])(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  } // Representation is either 'time' or 'complete'


  if (representation !== 'date') {
    var hour = Object(addLeadingZeros["a" /* default */])(originalDate.getHours(), 2);
    var minute = Object(addLeadingZeros["a" /* default */])(originalDate.getMinutes(), 2);
    var second = Object(addLeadingZeros["a" /* default */])(originalDate.getSeconds(), 2); // If there's also date, separate it with time with a space

    var separator = result === '' ? '' : ' '; // HHmmss or HH:mm:ss.

    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
  }

  return result;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatISODuration/index.js

/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param {Duration} duration - the duration to format
 *
 * @returns {String} The ISO 8601 duration string
 * @throws {TypeError} Requires 1 argument
 * @throws {Error} Argument must be an object
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */

function formatISODuration(duration) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  if (typeof duration !== 'object') throw new Error('Duration must be an object');
  var _duration$years = duration.years,
      years = _duration$years === void 0 ? 0 : _duration$years,
      _duration$months = duration.months,
      months = _duration$months === void 0 ? 0 : _duration$months,
      _duration$days = duration.days,
      days = _duration$days === void 0 ? 0 : _duration$days,
      _duration$hours = duration.hours,
      hours = _duration$hours === void 0 ? 0 : _duration$hours,
      _duration$minutes = duration.minutes,
      minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
      _duration$seconds = duration.seconds,
      seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatRFC3339/index.js





/**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 2 digits of second fraction:
 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
 * //=> '2019-09-18T19:00:52.23Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
 * //=> '2019-09-18T19:00:52.234Z'
 */
function formatRFC3339(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  }

  var originalDate = Object(toDate["a" /* default */])(dirtyDate);

  if (!Object(isValid["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  var _ref = dirtyOptions || {},
      _ref$fractionDigits = _ref.fractionDigits,
      fractionDigits = _ref$fractionDigits === void 0 ? 0 : _ref$fractionDigits; // Test if fractionDigits is between 0 and 3 _and_ is not NaN


  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
  }

  var day = Object(addLeadingZeros["a" /* default */])(originalDate.getDate(), 2);
  var month = Object(addLeadingZeros["a" /* default */])(originalDate.getMonth() + 1, 2);
  var year = originalDate.getFullYear();
  var hour = Object(addLeadingZeros["a" /* default */])(originalDate.getHours(), 2);
  var minute = Object(addLeadingZeros["a" /* default */])(originalDate.getMinutes(), 2);
  var second = Object(addLeadingZeros["a" /* default */])(originalDate.getSeconds(), 2);
  var fractionalSecond = '';

  if (fractionDigits > 0) {
    var milliseconds = originalDate.getMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
    fractionalSecond = '.' + Object(addLeadingZeros["a" /* default */])(fractionalSeconds, fractionDigits);
  }

  var offset = '';
  var tzOffset = originalDate.getTimezoneOffset();

  if (tzOffset !== 0) {
    var absoluteOffset = Math.abs(tzOffset);
    var hourOffset = Object(addLeadingZeros["a" /* default */])(Object(toInteger["a" /* default */])(absoluteOffset / 60), 2);
    var minuteOffset = Object(addLeadingZeros["a" /* default */])(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

    var sign = tzOffset < 0 ? '+' : '-';
    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
  } else {
    offset = 'Z';
  }

  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/formatRFC7231/index.js



var formatRFC7231_days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var formatRFC7231_months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */

function formatRFC7231(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  }

  var originalDate = Object(toDate["a" /* default */])(dirtyDate);

  if (!Object(isValid["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  var dayName = formatRFC7231_days[originalDate.getUTCDay()];
  var dayOfMonth = Object(addLeadingZeros["a" /* default */])(originalDate.getUTCDate(), 2);
  var monthName = formatRFC7231_months[originalDate.getUTCMonth()];
  var year = originalDate.getUTCFullYear();
  var hour = Object(addLeadingZeros["a" /* default */])(originalDate.getUTCHours(), 2);
  var minute = Object(addLeadingZeros["a" /* default */])(originalDate.getUTCMinutes(), 2);
  var second = Object(addLeadingZeros["a" /* default */])(originalDate.getUTCSeconds(), 2); // Result variables.

  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/formatRelative/index.js
var formatRelative = __webpack_require__("+wiC");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/fromUnixTime/index.js



/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Number} unixTime - the given Unix timestamp (in seconds)
 * @returns {Date} the date
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */

function fromUnixTime(dirtyUnixTime) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var unixTime = Object(toInteger["a" /* default */])(dirtyUnixTime);
  return Object(toDate["a" /* default */])(unixTime * 1000);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getDate/index.js


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getDay/index.js


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var day = date.getDay();
  return day;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getDayOfYear/index.js




/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */

function getDayOfYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var diff = Object(differenceInCalendarDays["a" /* default */])(date, startOfYear(date));
  var dayOfYear = diff + 1;
  return dayOfYear;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isLeapYear/index.js


/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */

function isLeapYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getDaysInYear/index.js



/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */

function getDaysInYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);

  if (String(new Date(date)) === 'Invalid Date') {
    return NaN;
  }

  return isLeapYear(date) ? 366 : 365;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getDecade/index.js


/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year of decade
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */

function getDecade(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var decade = Math.floor(year / 10) * 10;
  return decade;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getHours/index.js


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var hours = date.getHours();
  return hours;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getISODay/index.js


/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */

function getISODay(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var day = date.getDay();

  if (day === 0) {
    day = 7;
  }

  return day;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getISOWeek/index.js




var getISOWeek_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getISOWeek_MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getISOWeeksInYear/index.js



var getISOWeeksInYear_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */

function getISOWeeksInYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var thisYear = startOfISOWeekYear(dirtyDate);
  var nextYear = startOfISOWeekYear(addWeeks(thisYear, 60));
  var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getISOWeeksInYear_MILLISECONDS_IN_WEEK);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getMilliseconds/index.js


/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */

function getMilliseconds(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var milliseconds = date.getMilliseconds();
  return milliseconds;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getMinutes/index.js


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getMonth/index.js


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var month = date.getMonth();
  return month;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getOverlappingDaysInIntervals/index.js


var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `getOverlappingDaysInRanges` to `getOverlappingDaysInIntervals`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   getOverlappingDaysInRanges(
 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   getOverlappingDaysInIntervals(
 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 *   )
 *   ```
 *
 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
 * @returns {Number} the number of days that overlap in two time intervals
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */

function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var intervalLeft = dirtyIntervalLeft || {};
  var intervalRight = dirtyIntervalRight || {};
  var leftStartTime = Object(toDate["a" /* default */])(intervalLeft.start).getTime();
  var leftEndTime = Object(toDate["a" /* default */])(intervalLeft.end).getTime();
  var rightStartTime = Object(toDate["a" /* default */])(intervalRight.start).getTime();
  var rightEndTime = Object(toDate["a" /* default */])(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError('Invalid interval');
  }

  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;

  if (!isOverlapping) {
    return 0;
  }

  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
  var differenceInMs = overlapEndDate - overlapStartDate;
  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getSeconds/index.js


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/getTime/index.js
var getTime = __webpack_require__("yiHt");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/getUnixTime/index.js


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */

function getUnixTime(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(Object(getTime["a" /* default */])(dirtyDate) / 1000);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getWeekYear/index.js





/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(dirtyDate, options) {
  var _options$locale, _options$locale$optio;

  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var localeFirstWeekContainsDate = options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(toInteger["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = (options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) == null ? defaultFirstWeekContainsDate : Object(toInteger["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfWeekYear/index.js





/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(dirtyDate, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(toInteger["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(toInteger["a" /* default */])(options.firstWeekContainsDate);
  var year = getWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, dirtyOptions);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getWeek/index.js




var getWeek_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var diff = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getWeek_MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getWeekOfMonth/index.js





/**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the week of month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * var result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */

function getWeekOfMonth(date, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(toInteger["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(toInteger["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var currentDayOfMonth = getDate(date);

  if (isNaN(currentDayOfMonth)) {
    return currentDayOfMonth;
  }

  var startWeekDay = getDay(startOfMonth(date));
  var lastDayOfFirstWeek = 0;

  if (startWeekDay >= weekStartsOn) {
    lastDayOfFirstWeek = weekStartsOn + 7 - startWeekDay;
  } else {
    lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  }

  var weekNumber = 1;

  if (currentDayOfMonth > lastDayOfFirstWeek) {
    var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    weekNumber = weekNumber + Math.ceil(remainingDaysAfterFirstWeek / 7);
  }

  return weekNumber;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/lastDayOfMonth/index.js


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */

function lastDayOfMonth_lastDayOfMonth(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getWeeksInMonth/index.js





/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return differenceInCalendarWeeks(lastDayOfMonth_lastDayOfMonth(date), startOfMonth(date), options) + 1;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/getYear/index.js


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getFullYear();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/hoursToMilliseconds/index.js


/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted to milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */

function hoursToMilliseconds(hours) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(hours * constants["b" /* millisecondsInHour */]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/hoursToMinutes/index.js


/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted in minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */

function hoursToMinutes(hours) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(hours * constants["e" /* minutesInHour */]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/hoursToSeconds/index.js


/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted in seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */

function hoursToSeconds(hours) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(hours * constants["i" /* secondsInHour */]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/subDays/index.js



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/subMonths/index.js



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/sub/index.js




/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */

function sub(date, duration) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  if (!duration || typeof duration !== 'object') return new Date(NaN);
  var years = duration.years ? Object(toInteger["a" /* default */])(duration.years) : 0;
  var months = duration.months ? Object(toInteger["a" /* default */])(duration.months) : 0;
  var weeks = duration.weeks ? Object(toInteger["a" /* default */])(duration.weeks) : 0;
  var days = duration.days ? Object(toInteger["a" /* default */])(duration.days) : 0;
  var hours = duration.hours ? Object(toInteger["a" /* default */])(duration.hours) : 0;
  var minutes = duration.minutes ? Object(toInteger["a" /* default */])(duration.minutes) : 0;
  var seconds = duration.seconds ? Object(toInteger["a" /* default */])(duration.seconds) : 0; // Subtract years and months

  var dateWithoutMonths = subMonths(date, months + years * 12); // Subtract weeks and days

  var dateWithoutDays = subDays(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds

  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1000;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/intervalToDuration/index.js











/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @param {Interval} interval - the interval to convert to duration
 *
 * @returns {Duration} The duration Object
 * @throws {TypeError} Requires 2 arguments
 * @throws {RangeError} `start` must not be Invalid Date
 * @throws {RangeError} `end` must not be Invalid Date
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */

function intervalToDuration(_ref) {
  var start = _ref.start,
      end = _ref.end;
  Object(requiredArgs["a" /* default */])(1, arguments);
  var dateLeft = Object(toDate["a" /* default */])(start);
  var dateRight = Object(toDate["a" /* default */])(end);

  if (!Object(isValid["a" /* default */])(dateLeft)) {
    throw new RangeError('Start Date is invalid');
  }

  if (!Object(isValid["a" /* default */])(dateRight)) {
    throw new RangeError('End Date is invalid');
  }

  var duration = {
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  var sign = compareAsc(dateLeft, dateRight);
  duration.years = Math.abs(differenceInYears(dateLeft, dateRight));
  var remainingMonths = sub(dateLeft, {
    years: sign * duration.years
  });
  duration.months = Math.abs(differenceInMonths(remainingMonths, dateRight));
  var remainingDays = sub(remainingMonths, {
    months: sign * duration.months
  });
  duration.days = Math.abs(differenceInDays(remainingDays, dateRight));
  var remainingHours = sub(remainingDays, {
    days: sign * duration.days
  });
  duration.hours = Math.abs(Object(differenceInHours["a" /* default */])(remainingHours, dateRight));
  var remainingMinutes = sub(remainingHours, {
    hours: sign * duration.hours
  });
  duration.minutes = Math.abs(Object(differenceInMinutes["a" /* default */])(remainingMinutes, dateRight));
  var remainingSeconds = sub(remainingMinutes, {
    minutes: sign * duration.minutes
  });
  duration.seconds = Math.abs(differenceInSeconds(remainingSeconds, dateRight));
  return duration;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/intlFormat/index.js


/**
 * @name intlFormat
 * @category Common Helpers
 * @summary  Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @param {Date|Number} argument - the original date.
 * @param {Object} [formatOptions] - an object with options.
 * @param {'lookup'|'best fit'} [formatOptions.localeMatcher='best fit'] - locale selection algorithm.
 * @param {'narrow'|'short'|'long'} [formatOptions.weekday] - representation the days of the week.
 * @param {'narrow'|'short'|'long'} [formatOptions.era] - representation of eras.
 * @param {'numeric'|'2-digit'} [formatOptions.year] - representation of years.
 * @param {'numeric'|'2-digit'|'narrow'|'short'|'long'} [formatOptions.month='numeric'] - representation of month.
 * @param {'numeric'|'2-digit'} [formatOptions.day='numeric'] - representation of day.
 * @param {'numeric'|'2-digit'} [formatOptions.hour='numeric'] - representation of hours.
 * @param {'numeric'|'2-digit'} [formatOptions.minute] - representation of minutes.
 * @param {'numeric'|'2-digit'} [formatOptions.second] - representation of seconds.
 * @param {'short'|'long'} [formatOptions.timeZoneName] - representation of names of time zones.
 * @param {'basic'|'best fit'} [formatOptions.formatMatcher='best fit'] - format selection algorithm.
 * @param {Boolean} [formatOptions.hour12] - determines whether to use 12-hour time format.
 * @param {String} [formatOptions.timeZone] - the time zone to use.
 * @param {Object} [localeOptions] - an object with locale.
 * @param {String|String[]} [localeOptions.locale] - the locale code
 * @returns {String} the formatted date string.
 * @throws {TypeError} 1 argument required.
 * @throws {RangeError} `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *      weekday: 'long',
 *      year: 'numeric',
 *      month: 'long',
 *      day: 'numeric',
 *    }, {
 *      locale: 'de-DE',
 *  })
 * //=> Freitag, 4. Oktober 2019
 *
 * @example
 * // Represent 10 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *      year: 'numeric',
 *      month: 'numeric',
 *      day: 'numeric',
 *      hour: 'numeric',
 *  })
 * //=> 10/4/2019, 12 PM
 *
 * @example
 * // Represent 10 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *      locale: 'ko-KR',
 *  })
 * //=> 2019. 10. 4.
 *
 * @example
 * // Represent 10 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */
function intlFormat(date, formatOrLocale, localeOptions) {
  var _localeOptions;

  Object(requiredArgs["a" /* default */])(1, arguments);
  var formatOptions;

  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }

  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
}

function isFormatOptions(opts) {
  return opts !== undefined && !('locale' in opts);
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__("Kcid");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/isBefore/index.js


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var dateToCompare = Object(toDate["a" /* default */])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/isDate/index.js
var isDate = __webpack_require__("tU9A");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/isEqual/index.js


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyLeftDate);
  var dateRight = Object(toDate["a" /* default */])(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isExists/index.js
/**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param {Number} year of the date to check
 * @param {Number} month of the date to check
 * @param {Number} day of the date to check
 * @returns {Boolean} the date exists
 * @throws {TypeError} 3 arguments required
 *
 * @example
 * // For the valid date:
 * var result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isExists(2018, 1, 31)
 * //=> false
 */
function isExists(year, month, day) {
  if (arguments.length < 3) {
    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
  }

  var date = new Date(year, month, day);
  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isFirstDayOfMonth/index.js


/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */

function isFirstDayOfMonth(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getDate() === 1;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isFriday/index.js


/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */

function isFriday(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getDay() === 5;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isFuture/index.js


/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */

function isFuture(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getTime() > Date.now();
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__("A4qf");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__("W9kG");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__("VJX+");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__("JbHP");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/setUTCDay/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(toInteger["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(toInteger["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(toDate["a" /* default */])(dirtyDate);
  var day = Object(toInteger["a" /* default */])(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/setUTCISODay/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var day = Object(toInteger["a" /* default */])(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__("PrDZ");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var isoWeek = Object(toInteger["a" /* default */])(dirtyISOWeek);
  var diff = Object(getUTCISOWeek["a" /* default */])(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__("Z7oM");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/_lib/setUTCWeek/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var week = Object(toInteger["a" /* default */])(dirtyWeek);
  var diff = Object(getUTCWeek["a" /* default */])(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__("IuuM");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__("sFsT");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/parse/_lib/parsers/index.js







var parsers_MILLISECONDS_IN_HOUR = 3600000;
var parsers_MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * parsers_MILLISECONDS_IN_HOUR + minutes * parsers_MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */

var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function set(date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function validate(_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function set(date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function validate(_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function set(date, flags, value, options) {
      var currentYear = Object(getUTCWeekYear["a" /* default */])(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return Object(startOfUTCWeek["a" /* default */])(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return Object(startOfUTCWeek["a" /* default */])(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function parse(string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function set(_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return Object(startOfUTCISOWeek["a" /* default */])(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function parse(string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function set(date, _flags, value, options) {
      return Object(startOfUTCWeek["a" /* default */])(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function set(date, _flags, value, options) {
      return Object(startOfUTCISOWeek["a" /* default */])(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function set(date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function set(date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function set(date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function set(date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function parse(string, token, _match, _options) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function parse(string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function set(date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function parse(string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function set(date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function parse(string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function set(_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function parse(string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function set(_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
/* harmony default export */ var _lib_parsers = (parsers);
// CONCATENATED MODULE: ../node_modules/date-fns/esm/parse/index.js










var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || en_US["a" /* default */];

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(toInteger["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(toInteger["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(toInteger["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(toInteger["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return Object(toDate["a" /* default */])(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && Object(protectedTokens["b" /* isProtectedWeekYearToken */])(token)) {
      Object(protectedTokens["c" /* throwProtectedError */])(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && Object(protectedTokens["a" /* isProtectedDayOfYearToken */])(token)) {
      Object(protectedTokens["c" /* throwProtectedError */])(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = _lib_parsers[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = Object(toDate["a" /* default */])(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = Object(subMilliseconds["a" /* default */])(date, Object(getTimezoneOffsetInMilliseconds["a" /* default */])(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign_assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isMatch/index.js




/**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 *
 *
 * @param {String} dateString - the date string to verify
 * @param {String} formatString - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Boolean}
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * var result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */
function isMatch(dateString, formatString, options) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  return Object(isValid["a" /* default */])(parse(dateString, formatString, new Date(), options));
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isMonday/index.js


/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */

function isMonday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(date).getDay() === 1;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isPast/index.js


/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */

function isPast(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getTime() < Date.now();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfHour/index.js


/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */

function startOfHour(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameHour/index.js


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 */

function isSameHour(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameWeek/index.js



/**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 */
function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions);
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameISOWeek/index.js


/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 */

function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {
    weekStartsOn: 1
  });
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameISOWeekYear/index.js


/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isSameISOYear` to `isSameISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */

function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeftStartOfYear = startOfISOWeekYear(dirtyDateLeft);
  var dateRightStartOfYear = startOfISOWeekYear(dirtyDateRight);
  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameMinute/index.js


/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */

function isSameMinute(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft);
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight);
  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameMonth/index.js


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameQuarter/index.js


/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfSecond/index.js


/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */

function startOfSecond(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  date.setMilliseconds(0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameSecond/index.js


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */

function isSameSecond(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft);
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight);
  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isSameYear/index.js


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var dateLeft = Object(toDate["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(toDate["a" /* default */])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isThisHour/index.js


/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */

function isThisHour(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameHour(Date.now(), dirtyDate);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isThisISOWeek/index.js


/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */

function isThisISOWeek(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameISOWeek(dirtyDate, Date.now());
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isThisMinute/index.js


/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */

function isThisMinute(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameMinute(Date.now(), dirtyDate);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isThisMonth/index.js


/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */

function isThisMonth(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameMonth(Date.now(), dirtyDate);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isThisQuarter/index.js


/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */

function isThisQuarter(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameQuarter(Date.now(), dirtyDate);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isThisSecond/index.js


/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */

function isThisSecond(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameSecond(Date.now(), dirtyDate);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isThisWeek/index.js



/**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */
function isThisWeek(dirtyDate, options) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameWeek(dirtyDate, Date.now(), options);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isThisYear/index.js


/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */

function isThisYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameYear(dirtyDate, Date.now());
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isThursday/index.js


/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */

function isThursday(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getDay() === 4;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isToday/index.js


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */

function isToday(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameDay(dirtyDate, Date.now());
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isTomorrow/index.js



/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */

function isTomorrow(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameDay(dirtyDate, addDays(Date.now(), 1));
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isTuesday/index.js


/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */

function isTuesday(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getDay() === 2;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isWednesday/index.js


/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */

function isWednesday(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Object(toDate["a" /* default */])(dirtyDate).getDay() === 3;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isWithinInterval/index.js



/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var time = Object(toDate["a" /* default */])(dirtyDate).getTime();
  var startTime = Object(toDate["a" /* default */])(interval.start).getTime();
  var endTime = Object(toDate["a" /* default */])(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/isYesterday/index.js



/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */

function isYesterday(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return isSameDay(dirtyDate, subDays(Date.now(), 1));
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/lastDayOfDecade/index.js


/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a decade
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * var result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */

function lastDayOfDecade(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var decade = 9 + Math.floor(year / 10) * 10;
  date.setFullYear(decade + 1, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/lastDayOfWeek/index.js




/**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek(dirtyDate, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(toInteger["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(toInteger["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6');
  }

  var date = Object(toDate["a" /* default */])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + diff);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/lastDayOfISOWeek/index.js


/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */

function lastDayOfISOWeek(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return lastDayOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/lastDayOfISOWeekYear/index.js



/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `lastDayOfISOYear` to `lastDayOfISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */

function lastDayOfISOWeekYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  date.setDate(date.getDate() - 1);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/lastDayOfQuarter/index.js


/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the last day of a quarter
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */

function lastDayOfQuarter(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/lastDayOfYear/index.js


/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */

function lastDayOfYear(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
// EXTERNAL MODULE: ../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var lightFormatters = __webpack_require__("sUXs");

// CONCATENATED MODULE: ../node_modules/date-fns/esm/lightFormat/index.js





 // This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var lightFormat_formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var lightFormat_escapedStringRegExp = /^'([^]*?)'?$/;
var lightFormat_doubleQuoteRegExp = /''/g;
var lightFormat_unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 0001, ..., 999               |
 * |                                 | SSSS    | ...                               |
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */

function lightFormat(dirtyDate, formatStr) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var originalDate = Object(toDate["a" /* default */])(dirtyDate);

  if (!Object(isValid["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = Object(getTimezoneOffsetInMilliseconds["a" /* default */])(originalDate);
  var utcDate = Object(subMilliseconds["a" /* default */])(originalDate, timezoneOffset);
  var tokens = formatStr.match(lightFormat_formattingTokensRegExp); // The only case when formattingTokensRegExp doesn't match the string is when it's empty

  if (!tokens) return '';
  var result = tokens.map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return lightFormat_cleanEscapedString(substring);
    }

    var formatter = lightFormatters["a" /* default */][firstCharacter];

    if (formatter) {
      return formatter(utcDate, substring);
    }

    if (firstCharacter.match(lightFormat_unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function lightFormat_cleanEscapedString(input) {
  var matches = input.match(lightFormat_escapedStringRegExp);

  if (!matches) {
    return input;
  }

  return matches[1].replace(lightFormat_doubleQuoteRegExp, "'");
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/milliseconds/index.js

// Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
// 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
var daysInYear = 365.2425;
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {number} the milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */

function milliseconds_milliseconds(_ref) {
  var years = _ref.years,
      months = _ref.months,
      weeks = _ref.weeks,
      days = _ref.days,
      hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds;
  Object(requiredArgs["a" /* default */])(1, arguments);
  var totalDays = 0;
  if (years) totalDays += years * daysInYear;
  if (months) totalDays += months * (daysInYear / 12);
  if (weeks) totalDays += weeks * 7;
  if (days) totalDays += days;
  var totalSeconds = totalDays * 24 * 60 * 60;
  if (hours) totalSeconds += hours * 60 * 60;
  if (minutes) totalSeconds += minutes * 60;
  if (seconds) totalSeconds += seconds;
  return Math.round(totalSeconds * 1000);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/millisecondsToHours/index.js


/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param {number} milliseconds - number of milliseconds to be converted
 *
 * @returns {number} the number of milliseconds converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */

function millisecondsToHours(milliseconds) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var hours = milliseconds / constants["b" /* millisecondsInHour */];
  return Math.floor(hours);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/millisecondsToMinutes/index.js


/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param {number} milliseconds - number of milliseconds to be converted.
 *
 * @returns {number} the number of milliseconds converted in minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */

function millisecondsToMinutes(milliseconds) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var minutes = milliseconds / constants["c" /* millisecondsInMinute */];
  return Math.floor(minutes);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/millisecondsToSeconds/index.js


/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param {number} milliseconds - number of milliseconds to be converted
 *
 * @returns {number} the number of milliseconds converted in seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */

function millisecondsToSeconds(milliseconds) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var seconds = milliseconds / constants["d" /* millisecondsInSecond */];
  return Math.floor(seconds);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/minutesToHours/index.js


/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param {number} minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */

function minutesToHours(minutes) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var hours = minutes / constants["e" /* minutesInHour */];
  return Math.floor(hours);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/minutesToMilliseconds/index.js


/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param {number} minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */

function minutesToMilliseconds(minutes) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(minutes * constants["c" /* millisecondsInMinute */]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/minutesToSeconds/index.js


/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param { number } minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */

function minutesToSeconds(minutes) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(minutes * constants["j" /* secondsInMinute */]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/monthsToQuarters/index.js


/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param {number} months - number of months to be converted.
 *
 * @returns {number} the number of months converted in quarters
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */

function monthsToQuarters(months) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var quarters = months / constants["f" /* monthsInQuarter */];
  return Math.floor(quarters);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/monthsToYears/index.js


/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param {number} months - number of months to be converted
 *
 * @returns {number} the number of months converted in years
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */

function monthsToYears(months) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var years = months / constants["g" /* monthsInYear */];
  return Math.floor(years);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/nextDay/index.js



/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @param {Date | number} date - the date to check
 * @param {Day} day - day of the week
 * @returns {Date} - the date is the next day of week
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */

function nextDay(date, day) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var delta = day - getDay(date);
  if (delta <= 0) delta += 7;
  return addDays(date, delta);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/nextFriday/index.js


/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */

function nextFriday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return nextDay(date, 5);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/nextMonday/index.js


/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Monday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */

function nextMonday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return nextDay(date, 1);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/nextSaturday/index.js


/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */

function nextSaturday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return nextDay(date, 6);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/nextSunday/index.js


/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */

function nextSunday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return nextDay(date, 0);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/nextThursday/index.js


/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Thursday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */

function nextThursday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return nextDay(date, 4);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/nextTuesday/index.js


/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Tuesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */

function nextTuesday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return nextDay(date, 2);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/nextWednesday/index.js


/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Wednesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */

function nextWednesday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return nextDay(date, 3);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/parseISO/index.js


var parseISO_MILLISECONDS_IN_HOUR = 3600000;
var parseISO_MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : Object(toInteger["a" /* default */])(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * parseISO_MILLISECONDS_IN_HOUR + minutes * parseISO_MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * parseISO_MILLISECONDS_IN_HOUR + minutes * parseISO_MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function parseISO_isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (parseISO_isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (parseISO_isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/parseJSON/index.js


/**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate]{@link https://date-fns.org/docs/toDate}:
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 */

function parseJSON(argument) {
  Object(requiredArgs["a" /* default */])(1, arguments);

  if (typeof argument === 'string') {
    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);

    if (parts) {
      // Group 8 matches the sign
      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
    }

    return new Date(NaN);
  }

  return Object(toDate["a" /* default */])(argument);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/previousDay/index.js




/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @param {Date | number} date - the date to check
 * @param {number} day - day of the week
 * @returns {Date} - the date is the previous day of week
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */
function previousDay(date, day) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var delta = getDay(date) - day;
  if (delta <= 0) delta += 7;
  return subDays(date, delta);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/previousFriday/index.js


/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */

function previousFriday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return previousDay(date, 5);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/previousMonday/index.js


/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Monday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */

function previousMonday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return previousDay(date, 1);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/previousSaturday/index.js


/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */

function previousSaturday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return previousDay(date, 6);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/previousSunday/index.js


/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */

function previousSunday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return previousDay(date, 0);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/previousThursday/index.js


/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Thursday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */

function previousThursday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return previousDay(date, 4);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/previousTuesday/index.js


/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Tuesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */

function previousTuesday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return previousDay(date, 2);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/previousWednesday/index.js


/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Wednesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */

function previousWednesday(date) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return previousDay(date, 3);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/quartersToMonths/index.js


/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @param {number} quarters - number of quarters to be converted
 *
 * @returns {number} the number of quarters converted in months
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */

function quartersToMonths(quarters) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(quarters * constants["f" /* monthsInQuarter */]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/quartersToYears/index.js


/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @param {number} quarters - number of quarters to be converted
 *
 * @returns {number} the number of quarters converted in years
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */

function quartersToYears(quarters) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var years = quarters / constants["h" /* quartersInYear */];
  return Math.floor(years);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/roundToNearestMinutes/index.js


/**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to round
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
 * @returns {Date} the new date rounded to the closest minute
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
 * //=> Thu Jul 10 2014 12:15:00
 */

function roundToNearestMinutes(dirtyDate, options) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only none provided present');
  }

  var nearestTo = options && 'nearestTo' in options ? Object(toInteger["a" /* default */])(options.nearestTo) : 1;

  if (nearestTo < 1 || nearestTo > 30) {
    throw new RangeError('`options.nearestTo` must be between 1 and 30');
  }

  var date = Object(toDate["a" /* default */])(dirtyDate);
  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case

  var minutes = date.getMinutes() + seconds / 60;
  var roundedMinutes = Math.floor(minutes / nearestTo) * nearestTo;
  var remainderMinutes = minutes % nearestTo;
  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/secondsToHours/index.js


/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */

function secondsToHours(seconds) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var hours = seconds / constants["i" /* secondsInHour */];
  return Math.floor(hours);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/secondsToMilliseconds/index.js


/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */

function secondsToMilliseconds(seconds) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return seconds * constants["d" /* millisecondsInSecond */];
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/secondsToMinutes/index.js


/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */

function secondsToMinutes(seconds) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var minutes = seconds / constants["j" /* secondsInMinute */];
  return Math.floor(minutes);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var month = Object(toInteger["a" /* default */])(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/set/index.js





/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */
function set_set(dirtyDate, values) {
  Object(requiredArgs["a" /* default */])(2, arguments);

  if (typeof values !== 'object' || values === null) {
    throw new RangeError('values parameter must be an object');
  }

  var date = Object(toDate["a" /* default */])(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  if (values.year != null) {
    date.setFullYear(values.year);
  }

  if (values.month != null) {
    date = setMonth(date, values.month);
  }

  if (values.date != null) {
    date.setDate(Object(toInteger["a" /* default */])(values.date));
  }

  if (values.hours != null) {
    date.setHours(Object(toInteger["a" /* default */])(values.hours));
  }

  if (values.minutes != null) {
    date.setMinutes(Object(toInteger["a" /* default */])(values.minutes));
  }

  if (values.seconds != null) {
    date.setSeconds(Object(toInteger["a" /* default */])(values.seconds));
  }

  if (values.milliseconds != null) {
    date.setMilliseconds(Object(toInteger["a" /* default */])(values.milliseconds));
  }

  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setDate/index.js



/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */

function setDate(dirtyDate, dirtyDayOfMonth) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var dayOfMonth = Object(toInteger["a" /* default */])(dirtyDayOfMonth);
  date.setDate(dayOfMonth);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setDay/index.js





/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * var result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay(dirtyDate, dirtyDay, dirtyOptions) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(toInteger["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(toInteger["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(toDate["a" /* default */])(dirtyDate);
  var day = Object(toInteger["a" /* default */])(dirtyDay);
  var currentDay = date.getDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var delta = 7 - weekStartsOn;
  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return addDays(date, diff);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setDayOfYear/index.js



/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */

function setDayOfYear(dirtyDate, dirtyDayOfYear) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var dayOfYear = Object(toInteger["a" /* default */])(dirtyDayOfYear);
  date.setMonth(0);
  date.setDate(dayOfYear);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setHours/index.js



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var hours = Object(toInteger["a" /* default */])(dirtyHours);
  date.setHours(hours);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setISODay/index.js





/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */

function setISODay(dirtyDate, dirtyDay) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var day = Object(toInteger["a" /* default */])(dirtyDay);
  var currentDay = getISODay(date);
  var diff = day - currentDay;
  return addDays(date, diff);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setISOWeek/index.js




/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */

function setISOWeek(dirtyDate, dirtyISOWeek) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var isoWeek = Object(toInteger["a" /* default */])(dirtyISOWeek);
  var diff = getISOWeek(date) - isoWeek;
  date.setDate(date.getDate() - diff * 7);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setMilliseconds/index.js



/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */

function setMilliseconds(dirtyDate, dirtyMilliseconds) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var milliseconds = Object(toInteger["a" /* default */])(dirtyMilliseconds);
  date.setMilliseconds(milliseconds);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setMinutes/index.js



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var minutes = Object(toInteger["a" /* default */])(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setQuarter/index.js




/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var quarter = Object(toInteger["a" /* default */])(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return setMonth(date, date.getMonth() + diff * 3);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setSeconds/index.js



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var seconds = Object(toInteger["a" /* default */])(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setWeek/index.js





/**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} week - the week of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the new date with the local week set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * var result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * var result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */
function setWeek(dirtyDate, dirtyWeek, options) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var week = Object(toInteger["a" /* default */])(dirtyWeek);
  var diff = getWeek(date, options) - week;
  date.setDate(date.getDate() - diff * 7);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setWeekYear/index.js






/**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} weekYear - the local week-numbering year of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the new date with the local week-numbering year set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * var result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */
function setWeekYear(dirtyDate, dirtyWeekYear) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Object(requiredArgs["a" /* default */])(2, arguments);
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(toInteger["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(toInteger["a" /* default */])(options.firstWeekContainsDate);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var weekYear = Object(toInteger["a" /* default */])(dirtyWeekYear);
  var diff = Object(differenceInCalendarDays["a" /* default */])(date, startOfWeekYear(date, options));
  var firstWeek = new Date(0);
  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  date = startOfWeekYear(firstWeek, options);
  date.setDate(date.getDate() + diff);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/setYear/index.js



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = Object(toInteger["a" /* default */])(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfDecade/index.js


/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a decade
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */

function startOfDecade(dirtyDate) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  var date = Object(toDate["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var decade = Math.floor(year / 10) * 10;
  date.setFullYear(decade, 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfToday/index.js

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */

function startOfToday() {
  return Object(startOfDay["a" /* default */])(Date.now());
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfTomorrow/index.js
/**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/startOfYesterday/index.js
/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/subBusinessDays/index.js



/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the business days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */

function subBusinessDays(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addBusinessDays(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/subHours/index.js



/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */

function subHours(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addHours(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/subMinutes/index.js



/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */

function subMinutes(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addMinutes(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/subQuarters/index.js



/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */

function subQuarters(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addQuarters(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/subSeconds/index.js



/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */

function subSeconds(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addSeconds(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/subWeeks/index.js



/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/subYears/index.js



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  Object(requiredArgs["a" /* default */])(2, arguments);
  var amount = Object(toInteger["a" /* default */])(dirtyAmount);
  return addYears(dirtyDate, -amount);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/weeksToDays/index.js


/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param {number} weeks - number of weeks to be converted
 *
 * @returns {number} the number of weeks converted in days
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */

function weeksToDays(weeks) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(weeks * constants["a" /* daysInWeek */]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/yearsToMonths/index.js


/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param {number} years - number of years to be converted
 *
 * @returns {number} the number of years converted in months
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */

function yearsToMonths(years) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(years * constants["g" /* monthsInYear */]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/yearsToQuarters/index.js


/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param {number} years - number of years to be converted
 *
 * @returns {number} the number of years converted in quarters
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */

function yearsToQuarters(years) {
  Object(requiredArgs["a" /* default */])(1, arguments);
  return Math.floor(years * constants["h" /* quartersInYear */]);
}
// CONCATENATED MODULE: ../node_modules/date-fns/esm/index.js
/* unused concated harmony import add */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return add; });
/* unused concated harmony import addBusinessDays */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addBusinessDays; });
/* unused concated harmony import addDays */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addDays; });
/* unused concated harmony import addHours */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addHours; });
/* unused concated harmony import addISOWeekYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addISOWeekYears; });
/* unused concated harmony import addMilliseconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addMilliseconds["a" /* default */]; });
/* unused concated harmony import addMinutes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addMinutes; });
/* unused concated harmony import addMonths */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addMonths; });
/* unused concated harmony import addQuarters */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addQuarters; });
/* unused concated harmony import addSeconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addSeconds; });
/* unused concated harmony import addWeeks */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addWeeks; });
/* unused concated harmony import addYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addYears; });
/* unused concated harmony import areIntervalsOverlapping */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return areIntervalsOverlapping; });
/* unused concated harmony import clamp */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return clamp; });
/* unused concated harmony import closestIndexTo */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return closestIndexTo; });
/* unused concated harmony import closestTo */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return closestTo; });
/* unused concated harmony import compareAsc */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return compareAsc; });
/* unused concated harmony import compareDesc */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return compareDesc; });
/* unused concated harmony import daysToWeeks */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return daysToWeeks; });
/* unused concated harmony import differenceInBusinessDays */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInBusinessDays; });
/* unused concated harmony import differenceInCalendarDays */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInCalendarDays["a" /* default */]; });
/* unused concated harmony import differenceInCalendarISOWeekYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInCalendarISOWeekYears; });
/* unused concated harmony import differenceInCalendarISOWeeks */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInCalendarISOWeeks; });
/* unused concated harmony import differenceInCalendarMonths */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInCalendarMonths; });
/* unused concated harmony import differenceInCalendarQuarters */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInCalendarQuarters; });
/* unused concated harmony import differenceInCalendarWeeks */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInCalendarWeeks; });
/* unused concated harmony import differenceInCalendarYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInCalendarYears; });
/* unused concated harmony import differenceInDays */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInDays; });
/* unused concated harmony import differenceInHours */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInHours["a" /* default */]; });
/* unused concated harmony import differenceInISOWeekYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInISOWeekYears; });
/* unused concated harmony import differenceInMilliseconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInMilliseconds["a" /* default */]; });
/* unused concated harmony import differenceInMinutes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInMinutes["a" /* default */]; });
/* unused concated harmony import differenceInMonths */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInMonths; });
/* unused concated harmony import differenceInQuarters */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInQuarters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return differenceInSeconds; });
/* unused concated harmony import differenceInWeeks */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInWeeks; });
/* unused concated harmony import differenceInYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return differenceInYears; });
/* unused concated harmony import eachDayOfInterval */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachDayOfInterval; });
/* unused concated harmony import eachHourOfInterval */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachHourOfInterval; });
/* unused concated harmony import eachMinuteOfInterval */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachMinuteOfInterval; });
/* unused concated harmony import eachMonthOfInterval */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachMonthOfInterval; });
/* unused concated harmony import eachQuarterOfInterval */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachQuarterOfInterval; });
/* unused concated harmony import eachWeekOfInterval */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachWeekOfInterval; });
/* unused concated harmony import eachWeekendOfInterval */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachWeekendOfInterval; });
/* unused concated harmony import eachWeekendOfMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachWeekendOfMonth; });
/* unused concated harmony import eachWeekendOfYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachWeekendOfYear; });
/* unused concated harmony import eachYearOfInterval */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return eachYearOfInterval; });
/* unused concated harmony import endOfDay */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfDay; });
/* unused concated harmony import endOfDecade */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfDecade; });
/* unused concated harmony import endOfHour */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfHour; });
/* unused concated harmony import endOfISOWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfISOWeek; });
/* unused concated harmony import endOfISOWeekYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfISOWeekYear; });
/* unused concated harmony import endOfMinute */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfMinute; });
/* unused concated harmony import endOfMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfMonth; });
/* unused concated harmony import endOfQuarter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfQuarter; });
/* unused concated harmony import endOfSecond */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfSecond; });
/* unused concated harmony import endOfToday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfToday; });
/* unused concated harmony import endOfTomorrow */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfTomorrow; });
/* unused concated harmony import endOfWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfWeek; });
/* unused concated harmony import endOfYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfYear; });
/* unused concated harmony import endOfYesterday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return endOfYesterday; });
/* unused concated harmony import format */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_format["a" /* default */]; });
/* unused concated harmony import formatDistance */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatDistance; });
/* unused concated harmony import formatDistanceStrict */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatDistanceStrict; });
/* unused concated harmony import formatDistanceToNow */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatDistanceToNow; });
/* unused concated harmony import formatDistanceToNowStrict */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatDistanceToNowStrict; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return formatDuration; });
/* unused concated harmony import formatISO */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatISO; });
/* unused concated harmony import formatISO9075 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatISO9075; });
/* unused concated harmony import formatISODuration */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatISODuration; });
/* unused concated harmony import formatRFC3339 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatRFC3339; });
/* unused concated harmony import formatRFC7231 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatRFC7231; });
/* unused concated harmony import formatRelative */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return formatRelative["a" /* default */]; });
/* unused concated harmony import fromUnixTime */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fromUnixTime; });
/* unused concated harmony import getDate */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDate; });
/* unused concated harmony import getDay */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDay; });
/* unused concated harmony import getDayOfYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDayOfYear; });
/* unused concated harmony import getDaysInMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDaysInMonth; });
/* unused concated harmony import getDaysInYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDaysInYear; });
/* unused concated harmony import getDecade */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDecade; });
/* unused concated harmony import getHours */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getHours; });
/* unused concated harmony import getISODay */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getISODay; });
/* unused concated harmony import getISOWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getISOWeek; });
/* unused concated harmony import getISOWeekYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getISOWeekYear; });
/* unused concated harmony import getISOWeeksInYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getISOWeeksInYear; });
/* unused concated harmony import getMilliseconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getMilliseconds; });
/* unused concated harmony import getMinutes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getMinutes; });
/* unused concated harmony import getMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getMonth; });
/* unused concated harmony import getOverlappingDaysInIntervals */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getOverlappingDaysInIntervals; });
/* unused concated harmony import getQuarter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getQuarter; });
/* unused concated harmony import getSeconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getSeconds; });
/* unused concated harmony import getTime */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getTime["a" /* default */]; });
/* unused concated harmony import getUnixTime */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getUnixTime; });
/* unused concated harmony import getWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getWeek; });
/* unused concated harmony import getWeekOfMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getWeekOfMonth; });
/* unused concated harmony import getWeekYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getWeekYear; });
/* unused concated harmony import getWeeksInMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getWeeksInMonth; });
/* unused concated harmony import getYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getYear; });
/* unused concated harmony import hoursToMilliseconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return hoursToMilliseconds; });
/* unused concated harmony import hoursToMinutes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return hoursToMinutes; });
/* unused concated harmony import hoursToSeconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return hoursToSeconds; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return intervalToDuration; });
/* unused concated harmony import intlFormat */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return intlFormat; });
/* unused concated harmony import isAfter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isAfter["a" /* default */]; });
/* unused concated harmony import isBefore */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isBefore; });
/* unused concated harmony import isDate */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isDate["a" /* default */]; });
/* unused concated harmony import isEqual */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isEqual; });
/* unused concated harmony import isExists */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isExists; });
/* unused concated harmony import isFirstDayOfMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isFirstDayOfMonth; });
/* unused concated harmony import isFriday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isFriday; });
/* unused concated harmony import isFuture */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isFuture; });
/* unused concated harmony import isLastDayOfMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isLastDayOfMonth; });
/* unused concated harmony import isLeapYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isLeapYear; });
/* unused concated harmony import isMatch */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isMatch; });
/* unused concated harmony import isMonday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isMonday; });
/* unused concated harmony import isPast */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isPast; });
/* unused concated harmony import isSameDay */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameDay; });
/* unused concated harmony import isSameHour */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameHour; });
/* unused concated harmony import isSameISOWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameISOWeek; });
/* unused concated harmony import isSameISOWeekYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameISOWeekYear; });
/* unused concated harmony import isSameMinute */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameMinute; });
/* unused concated harmony import isSameMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameMonth; });
/* unused concated harmony import isSameQuarter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameQuarter; });
/* unused concated harmony import isSameSecond */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameSecond; });
/* unused concated harmony import isSameWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameWeek; });
/* unused concated harmony import isSameYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSameYear; });
/* unused concated harmony import isSaturday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSaturday; });
/* unused concated harmony import isSunday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isSunday; });
/* unused concated harmony import isThisHour */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isThisHour; });
/* unused concated harmony import isThisISOWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isThisISOWeek; });
/* unused concated harmony import isThisMinute */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isThisMinute; });
/* unused concated harmony import isThisMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isThisMonth; });
/* unused concated harmony import isThisQuarter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isThisQuarter; });
/* unused concated harmony import isThisSecond */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isThisSecond; });
/* unused concated harmony import isThisWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isThisWeek; });
/* unused concated harmony import isThisYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isThisYear; });
/* unused concated harmony import isThursday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isThursday; });
/* unused concated harmony import isToday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isToday; });
/* unused concated harmony import isTomorrow */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isTomorrow; });
/* unused concated harmony import isTuesday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isTuesday; });
/* unused concated harmony import isValid */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isValid["a" /* default */]; });
/* unused concated harmony import isWednesday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isWednesday; });
/* unused concated harmony import isWeekend */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isWeekend; });
/* unused concated harmony import isWithinInterval */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isWithinInterval; });
/* unused concated harmony import isYesterday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isYesterday; });
/* unused concated harmony import lastDayOfDecade */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lastDayOfDecade; });
/* unused concated harmony import lastDayOfISOWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lastDayOfISOWeek; });
/* unused concated harmony import lastDayOfISOWeekYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lastDayOfISOWeekYear; });
/* unused concated harmony import lastDayOfMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lastDayOfMonth_lastDayOfMonth; });
/* unused concated harmony import lastDayOfQuarter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lastDayOfQuarter; });
/* unused concated harmony import lastDayOfWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lastDayOfWeek; });
/* unused concated harmony import lastDayOfYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lastDayOfYear; });
/* unused concated harmony import lightFormat */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lightFormat; });
/* unused concated harmony import max */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return max; });
/* unused concated harmony import milliseconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return milliseconds_milliseconds; });
/* unused concated harmony import millisecondsToHours */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return millisecondsToHours; });
/* unused concated harmony import millisecondsToMinutes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return millisecondsToMinutes; });
/* unused concated harmony import millisecondsToSeconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return millisecondsToSeconds; });
/* unused concated harmony import min */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return min; });
/* unused concated harmony import minutesToHours */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return minutesToHours; });
/* unused concated harmony import minutesToMilliseconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return minutesToMilliseconds; });
/* unused concated harmony import minutesToSeconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return minutesToSeconds; });
/* unused concated harmony import monthsToQuarters */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return monthsToQuarters; });
/* unused concated harmony import monthsToYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return monthsToYears; });
/* unused concated harmony import nextDay */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return nextDay; });
/* unused concated harmony import nextFriday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return nextFriday; });
/* unused concated harmony import nextMonday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return nextMonday; });
/* unused concated harmony import nextSaturday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return nextSaturday; });
/* unused concated harmony import nextSunday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return nextSunday; });
/* unused concated harmony import nextThursday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return nextThursday; });
/* unused concated harmony import nextTuesday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return nextTuesday; });
/* unused concated harmony import nextWednesday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return nextWednesday; });
/* unused concated harmony import parse */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return parse; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return parseISO; });
/* unused concated harmony import parseJSON */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return parseJSON; });
/* unused concated harmony import previousDay */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return previousDay; });
/* unused concated harmony import previousFriday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return previousFriday; });
/* unused concated harmony import previousMonday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return previousMonday; });
/* unused concated harmony import previousSaturday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return previousSaturday; });
/* unused concated harmony import previousSunday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return previousSunday; });
/* unused concated harmony import previousThursday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return previousThursday; });
/* unused concated harmony import previousTuesday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return previousTuesday; });
/* unused concated harmony import previousWednesday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return previousWednesday; });
/* unused concated harmony import quartersToMonths */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return quartersToMonths; });
/* unused concated harmony import quartersToYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return quartersToYears; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return roundToNearestMinutes; });
/* unused concated harmony import secondsToHours */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return secondsToHours; });
/* unused concated harmony import secondsToMilliseconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return secondsToMilliseconds; });
/* unused concated harmony import secondsToMinutes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return secondsToMinutes; });
/* unused concated harmony import set */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return set_set; });
/* unused concated harmony import setDate */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setDate; });
/* unused concated harmony import setDay */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setDay; });
/* unused concated harmony import setDayOfYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setDayOfYear; });
/* unused concated harmony import setHours */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setHours; });
/* unused concated harmony import setISODay */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setISODay; });
/* unused concated harmony import setISOWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setISOWeek; });
/* unused concated harmony import setISOWeekYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setISOWeekYear; });
/* unused concated harmony import setMilliseconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setMilliseconds; });
/* unused concated harmony import setMinutes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setMinutes; });
/* unused concated harmony import setMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setMonth; });
/* unused concated harmony import setQuarter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setQuarter; });
/* unused concated harmony import setSeconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setSeconds; });
/* unused concated harmony import setWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setWeek; });
/* unused concated harmony import setWeekYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setWeekYear; });
/* unused concated harmony import setYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setYear; });
/* unused concated harmony import startOfDay */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfDay["a" /* default */]; });
/* unused concated harmony import startOfDecade */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfDecade; });
/* unused concated harmony import startOfHour */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfHour; });
/* unused concated harmony import startOfISOWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfISOWeek; });
/* unused concated harmony import startOfISOWeekYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfISOWeekYear; });
/* unused concated harmony import startOfMinute */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfMinute; });
/* unused concated harmony import startOfMonth */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfMonth; });
/* unused concated harmony import startOfQuarter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfQuarter; });
/* unused concated harmony import startOfSecond */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfSecond; });
/* unused concated harmony import startOfToday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfToday; });
/* unused concated harmony import startOfTomorrow */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfTomorrow; });
/* unused concated harmony import startOfWeek */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfWeek; });
/* unused concated harmony import startOfWeekYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfWeekYear; });
/* unused concated harmony import startOfYear */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfYear; });
/* unused concated harmony import startOfYesterday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return startOfYesterday; });
/* unused concated harmony import sub */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return sub; });
/* unused concated harmony import subBusinessDays */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subBusinessDays; });
/* unused concated harmony import subDays */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subDays; });
/* unused concated harmony import subHours */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subHours; });
/* unused concated harmony import subISOWeekYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subISOWeekYears; });
/* unused concated harmony import subMilliseconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subMilliseconds["a" /* default */]; });
/* unused concated harmony import subMinutes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subMinutes; });
/* unused concated harmony import subMonths */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subMonths; });
/* unused concated harmony import subQuarters */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subQuarters; });
/* unused concated harmony import subSeconds */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subSeconds; });
/* unused concated harmony import subWeeks */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subWeeks; });
/* unused concated harmony import subYears */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return subYears; });
/* unused concated harmony import toDate */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return toDate["a" /* default */]; });
/* unused concated harmony import weeksToDays */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return weeksToDays; });
/* unused concated harmony import yearsToMonths */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return yearsToMonths; });
/* unused concated harmony import yearsToQuarters */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return yearsToQuarters; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["a" /* daysInWeek */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["c" /* millisecondsInMinute */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["b" /* millisecondsInHour */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["d" /* millisecondsInSecond */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["e" /* minutesInHour */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["f" /* monthsInQuarter */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["g" /* monthsInYear */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["h" /* quartersInYear */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["i" /* secondsInHour */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return constants["j" /* secondsInMinute */]; });
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.














































































































































































































































/***/ }),

/***/ "nFDa":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("i+u+");
__webpack_require__("COf8");
module.exports = __webpack_require__("ZxII").f('iterator');

/***/ }),

/***/ "nMzr":
/***/ (function(module, exports) {

function RetryOperation(timeouts, options) {
  // Compatibility for the old (timeouts, retryForever) signature
  if (typeof options === 'boolean') {
    options = { forever: options };
  }

  this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
  this._timeouts = timeouts;
  this._options = options || {};
  this._maxRetryTime = options && options.maxRetryTime || Infinity;
  this._fn = null;
  this._errors = [];
  this._attempts = 1;
  this._operationTimeout = null;
  this._operationTimeoutCb = null;
  this._timeout = null;
  this._operationStart = null;
  this._timer = null;

  if (this._options.forever) {
    this._cachedTimeouts = this._timeouts.slice(0);
  }
}
module.exports = RetryOperation;

RetryOperation.prototype.reset = function () {
  this._attempts = 1;
  this._timeouts = this._originalTimeouts.slice(0);
};

RetryOperation.prototype.stop = function () {
  if (this._timeout) {
    clearTimeout(this._timeout);
  }
  if (this._timer) {
    clearTimeout(this._timer);
  }

  this._timeouts = [];
  this._cachedTimeouts = null;
};

RetryOperation.prototype.retry = function (err) {
  if (this._timeout) {
    clearTimeout(this._timeout);
  }

  if (!err) {
    return false;
  }
  var currentTime = new Date().getTime();
  if (err && currentTime - this._operationStart >= this._maxRetryTime) {
    this._errors.push(err);
    this._errors.unshift(new Error('RetryOperation timeout occurred'));
    return false;
  }

  this._errors.push(err);

  var timeout = this._timeouts.shift();
  if (timeout === undefined) {
    if (this._cachedTimeouts) {
      // retry forever, only keep last error
      this._errors.splice(0, this._errors.length - 1);
      timeout = this._cachedTimeouts.slice(-1);
    } else {
      return false;
    }
  }

  var self = this;
  this._timer = setTimeout(function () {
    self._attempts++;

    if (self._operationTimeoutCb) {
      self._timeout = setTimeout(function () {
        self._operationTimeoutCb(self._attempts);
      }, self._operationTimeout);

      if (self._options.unref) {
        self._timeout.unref();
      }
    }

    self._fn(self._attempts);
  }, timeout);

  if (this._options.unref) {
    this._timer.unref();
  }

  return true;
};

RetryOperation.prototype.attempt = function (fn, timeoutOps) {
  this._fn = fn;

  if (timeoutOps) {
    if (timeoutOps.timeout) {
      this._operationTimeout = timeoutOps.timeout;
    }
    if (timeoutOps.cb) {
      this._operationTimeoutCb = timeoutOps.cb;
    }
  }

  var self = this;
  if (this._operationTimeoutCb) {
    this._timeout = setTimeout(function () {
      self._operationTimeoutCb();
    }, self._operationTimeout);
  }

  this._operationStart = new Date().getTime();

  this._fn(this._attempts);
};

RetryOperation.prototype.try = function (fn) {
  console.log('Using RetryOperation.try() is deprecated');
  this.attempt(fn);
};

RetryOperation.prototype.start = function (fn) {
  console.log('Using RetryOperation.start() is deprecated');
  this.attempt(fn);
};

RetryOperation.prototype.start = RetryOperation.prototype.try;

RetryOperation.prototype.errors = function () {
  return this._errors;
};

RetryOperation.prototype.attempts = function () {
  return this._attempts;
};

RetryOperation.prototype.mainError = function () {
  if (this._errors.length === 0) {
    return null;
  }

  var counts = {};
  var mainError = null;
  var mainErrorCount = 0;

  for (var i = 0; i < this._errors.length; i++) {
    var error = this._errors[i];
    var message = error.message;
    var count = (counts[message] || 0) + 1;

    counts[message] = count;

    if (count >= mainErrorCount) {
      mainError = error;
      mainErrorCount = count;
    }
  }

  return mainError;
};

/***/ }),

/***/ "nR03":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("PoOm");
var anObject = __webpack_require__("1kal");
var aPossiblePrototype = __webpack_require__("cGvN");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {/* empty */}
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);

/***/ }),

/***/ "nRW3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3_gnt","header":"header__3xb3k","browser":"browser__1mIPz","browserLink":"browserLink__1gdzp"};

/***/ }),

/***/ "niFk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/detect-browser/es/index.js
var es = __webpack_require__("GLIM");

// EXTERNAL MODULE: ../node_modules/is-ua-webview/index.js
var is_ua_webview = __webpack_require__("DsHd");
var is_ua_webview_default = /*#__PURE__*/__webpack_require__.n(is_ua_webview);

// EXTERNAL MODULE: ../node_modules/redux-actions/es/index.js + 30 modules
var redux_actions_es = __webpack_require__("bKsd");

// EXTERNAL MODULE: ../node_modules/uuid/index.js
var uuid = __webpack_require__("qQO4");
var uuid_default = /*#__PURE__*/__webpack_require__.n(uuid);

// EXTERNAL MODULE: ./actions/index.js
var actions = __webpack_require__("vyGZ");

// EXTERNAL MODULE: ./api/fetch-wrapper.js
var fetch_wrapper = __webpack_require__("ds2O");

// EXTERNAL MODULE: ./api/index.js
var api = __webpack_require__("/C1n");

// CONCATENATED MODULE: ./api/info.js
/* eslint-disable import/prefer-default-export */




function infoLaunch() {
  var headers = new Headers();

  headers.append('Content-Type', 'application/json ');

  return Object(fetch_wrapper["a" /* http */])(api["b" /* apiUrls */].INFO_LAUNCH, { method: 'GET', headers: headers });
}
// EXTERNAL MODULE: ./api/users.js
var users = __webpack_require__("mecS");

// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// EXTERNAL MODULE: ./actions/api-notifications.js
var api_notifications = __webpack_require__("kKXN");

// CONCATENATED MODULE: ./actions/application.js
/* harmony export (immutable) */ __webpack_exports__["a"] = applicationCheckOS;
/* harmony export (immutable) */ __webpack_exports__["b"] = applicationInitialise;
/* harmony export (immutable) */ __webpack_exports__["d"] = getInfoLaunch;
/* harmony export (immutable) */ __webpack_exports__["c"] = checkVersionSupport;
/* unused harmony export setApplicationShouldUpdateSuccess */










var applicationSetDetected = Object(redux_actions_es["a" /* createAction */])(actions["a" /* actionTypes */].APPLICATION_SET_DETECTED);

// eslint-disable-next-line import/prefer-default-export
function applicationCheckOS() {
  return function (dispatch) {
    var detected = Object(es["detect"])();

    dispatch(applicationSetDetected({
      detected: detected,
      isWebview: is_ua_webview_default()(navigator.userAgent)
    }));
  };
}

function applicationInitialise() {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      try {
        dispatch({
          type: actions["a" /* actionTypes */].APPLICATION_INITIALISE_REQUEST
        });

        dispatch(getInfoLaunch());
      } catch (error) {
        Object(api_notifications["a" /* addNotification */])({
          id: Object(uuid["v4"])(),
          message: 'Cannot initialise application data!'
        });

        dispatch(applicationInitialiseFailure(error.message));

        throw error;
      }
      return $return();
    });
  };
}

function getInfoLaunch() {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var launchData;
      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_2_Catch = function (error) {
        try {
          Object(api_notifications["a" /* addNotification */])({
            id: Object(uuid["v4"])(),
            message: 'Cannot get Launch data!'
          });

          dispatch(applicationInitialiseFailure(error.message));

          throw error;
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(infoLaunch()).then(function ($await_4) {
          try {
            launchData = $await_4;

            dispatch(applicationInitialiseSuccess(launchData));
            return $Try_2_Post();
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (error) {
        $Try_2_Catch(error)
      }
    });
  };
}

function checkVersionSupport() {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var supported, shouldUpdate;
      var $Try_3_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_3_Catch = function (error) {
        try {
          error.message !== getState().application.error && dispatch(setApplicationShouldUpdateFailure(error.message));
          return $Try_3_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(Object(users["d" /* checkAppMinVersionSupport */])('WEB', consts["C" /* appVersion */])).then(function ($await_5) {
          try {
            supported = $await_5;
            shouldUpdate = !supported;
            shouldUpdate !== getState().application.applicationShouldUpdate && dispatch(setApplicationShouldUpdateSuccess(shouldUpdate));
            return $Try_3_Post();
          } catch ($boundEx) {
            return $Try_3_Catch($boundEx);
          }
        }, $Try_3_Catch);
      } catch (error) {
        $Try_3_Catch(error)
      }
    });
  };
}

function applicationInitialiseSuccess(launchData) {
  return {
    type: actions["a" /* actionTypes */].APPLICATION_INITIALISE_SUCCESS,
    payload: { launchData: launchData }
  };
}

function applicationInitialiseFailure(error) {
  return {
    error: error,
    type: actions["a" /* actionTypes */].APPLICATION_INITIALISE_FAILURE
  };
}

function setApplicationShouldUpdateSuccess(shouldUpdate) {
  return {
    type: actions["a" /* actionTypes */].SET_APPLICATION_SHOULD_UPDATE_SUCCESS,
    payload: shouldUpdate
  };
}

function setApplicationShouldUpdateFailure(error) {
  return {
    error: error,
    type: actions["a" /* actionTypes */].SET_APPLICATION_SHOULD_UPDATE_FAILURE
  };
}

/***/ }),

/***/ "niIn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ "nkXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



/***/ }),

/***/ "nmn5":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition();else if (true) __webpack_require__("lfEA")(name, definition);else root[name] = definition();
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true;

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return match && match.length > 1 && match[1] || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return match && match.length > 1 && match[2] || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase(),
        likeAndroid = /like android/i.test(ua),
        android = !likeAndroid && /android/i.test(ua),
        nexusMobile = /nexus\s*[0-6]\s*/i.test(ua),
        nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua),
        chromeos = /CrOS/.test(ua),
        silk = /silk/i.test(ua),
        sailfish = /sailfish/i.test(ua),
        tizen = /tizen/i.test(ua),
        webos = /(web|hpw)(o|0)s/i.test(ua),
        windowsphone = /windows phone/i.test(ua),
        samsungBrowser = /SamsungBrowser/i.test(ua),
        windows = !windowsphone && /windows/i.test(ua),
        mac = !iosdevice && !silk && /macintosh/i.test(ua),
        linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua),
        edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i),
        versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i),
        tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua),
        mobile = !tablet && /[^-]mobi/i.test(ua),
        xbox = /xbox/i.test(ua),
        result;

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera',
        opera: t,
        version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      };
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera',
        opera: t,
        version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      };
    } else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android',
        samsungBrowser: t,
        version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      };
    } else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser',
        whale: t,
        version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser',
        mzbrowser: t,
        version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast',
        coast: t,
        version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      };
    } else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus',
        focus: t,
        version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser',
        yandexbrowser: t,
        version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      };
    } else if (/ucbrowser/i.test(ua)) {
      result = {
        name: 'UC Browser',
        ucbrowser: t,
        version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon',
        maxthon: t,
        version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany',
        epiphany: t,
        version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin',
        puffin: t,
        version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      };
    } else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir',
        sleipnir: t,
        version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon',
        kMeleon: t,
        version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (windowsphone) {
      result = {
        name: 'Windows Phone',
        osname: 'Windows Phone',
        windowsphone: t
      };
      if (edgeVersion) {
        result.msedge = t;
        result.version = edgeVersion;
      } else {
        result.msie = t;
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
      }
    } else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer',
        msie: t,
        version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      };
    } else if (chromeos) {
      result = {
        name: 'Chrome',
        osname: 'Chrome OS',
        chromeos: t,
        chromeBook: t,
        chrome: t,
        version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      };
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge',
        msedge: t,
        version: edgeVersion
      };
    } else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi',
        vivaldi: t,
        version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    } else if (sailfish) {
      result = {
        name: 'Sailfish',
        osname: 'Sailfish OS',
        sailfish: t,
        version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      };
    } else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey',
        seamonkey: t,
        version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      };
    } else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox',
        firefox: t,
        version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      };
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t;
        result.osname = 'Firefox OS';
      }
    } else if (silk) {
      result = {
        name: 'Amazon Silk',
        silk: t,
        version: getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      };
    } else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS',
        phantom: t,
        version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      };
    } else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS',
        slimer: t,
        version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      };
    } else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry',
        osname: 'BlackBerry OS',
        blackberry: t,
        version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      };
    } else if (webos) {
      result = {
        name: 'WebOS',
        osname: 'WebOS',
        webos: t,
        version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t);
    } else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada',
        osname: 'Bada',
        bada: t,
        version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    } else if (tizen) {
      result = {
        name: 'Tizen',
        osname: 'Tizen',
        tizen: t,
        version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    } else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla',
        qupzilla: t,
        version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      };
    } else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium',
        chromium: t,
        version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      };
    } else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome',
        chrome: t,
        version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      };
    } else if (android) {
      result = {
        name: 'Android',
        version: versionIdentifier
      };
    } else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari',
        safari: t
      };
      if (versionIdentifier) {
        result.version = versionIdentifier;
      }
    } else if (iosdevice) {
      result = {
        name: iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
        // WTF: version is not part of user agent in web apps
      };if (versionIdentifier) {
        result.version = versionIdentifier;
      }
    } else if (/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot',
        googlebot: t,
        version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      };
    } else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
      };
    }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink";
        result.blink = t;
      } else {
        result.name = result.name || "Webkit";
        result.webkit = t;
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier;
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko";
      result.gecko = t;
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t;
      result.osname = 'Android';
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t;
      result.ios = t;
      result.osname = 'iOS';
    } else if (mac) {
      result.mac = t;
      result.osname = 'macOS';
    } else if (xbox) {
      result.xbox = t;
      result.osname = 'Xbox';
    } else if (windows) {
      result.windows = t;
      result.osname = 'Windows';
    } else if (linux) {
      result.linux = t;
      result.osname = 'Linux';
    }

    function getWindowsVersion(s) {
      switch (s) {
        case 'NT':
          return 'NT';
        case 'XP':
          return 'XP';
        case 'NT 5.0':
          return '2000';
        case 'NT 5.1':
          return 'XP';
        case 'NT 5.2':
          return '2003';
        case 'NT 6.0':
          return 'Vista';
        case 'NT 6.1':
          return '7';
        case 'NT 6.2':
          return '8';
        case 'NT 6.3':
          return '8.1';
        case 'NT 10.0':
          return '10';
        default:
          return undefined;
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i));
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (tablet || nexusTablet || iosdevice == 'ipad' || android && (osMajorVersion == 3 || osMajorVersion >= 4 && !mobile) || result.silk) {
      result.tablet = t;
    } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || nexusMobile || result.blackberry || result.webos || result.bada) {
      result.mobile = t;
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge || result.msie && result.version >= 10 || result.yandexbrowser && result.version >= 15 || result.vivaldi && result.version >= 1.0 || result.chrome && result.version >= 20 || result.samsungBrowser && result.version >= 4 || result.whale && compareVersions([result.version, '1.0']) === 1 || result.mzbrowser && compareVersions([result.version, '6.0']) === 1 || result.focus && compareVersions([result.version, '1.0']) === 1 || result.firefox && result.version >= 20.0 || result.safari && result.version >= 6 || result.opera && result.version >= 10.0 || result.ios && result.osversion && result.osversion.split(".")[0] >= 6 || result.blackberry && result.version >= 10.1 || result.chromium && result.version >= 20) {
      result.a = t;
    } else if (result.msie && result.version < 10 || result.chrome && result.version < 20 || result.firefox && result.version < 20.0 || result.safari && result.version < 6 || result.opera && result.version < 10.0 || result.ios && result.osversion && result.osversion.split(".")[0] < 6 || result.chromium && result.version < 20) {
      result.c = t;
    } else result.x = t;

    return result;
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem === 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  };

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [],
        i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      } else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      } else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void 0;
    }

    if (strictMode === void 0) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser;
});

/***/ }),

/***/ "noDf":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.2
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
                  Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
                  Supports browser & node.js environment. 
                  Demo   : https://faisalman.github.io/ua-parser-js
                  Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION = '1.0.2',
        EMPTY = '',
        UNKNOWN = '?',
        FUNC_TYPE = 'function',
        UNDEF_TYPE = 'undefined',
        OBJ_TYPE = 'object',
        STR_TYPE = 'string',
        MAJOR = 'major',
        MODEL = 'model',
        NAME = 'name',
        TYPE = 'type',
        VENDOR = 'vendor',
        VERSION = 'version',
        ARCHITECTURE = 'architecture',
        CONSOLE = 'console',
        MOBILE = 'mobile',
        TABLET = 'tablet',
        SMARTTV = 'smarttv',
        WEARABLE = 'wearable',
        EMBEDDED = 'embedded',
        UA_MAX_LENGTH = 255;

    var AMAZON = 'Amazon',
        APPLE = 'Apple',
        ASUS = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME = 'Chrome',
        EDGE = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE = 'Google',
        HUAWEI = 'Huawei',
        LG = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA = 'Motorola',
        OPERA = 'Opera',
        SAMSUNG = 'Samsung',
        SONY = 'Sony',
        XIAOMI = 'Xiaomi',
        ZEBRA = 'Zebra',
        FACEBOOK = 'Facebook';

    ///////////
    // Helper
    //////////

    var extend = function extend(regexes, extensions) {
        var mergedRegexes = {};
        for (var i in regexes) {
            if (extensions[i] && extensions[i].length % 2 === 0) {
                mergedRegexes[i] = extensions[i].concat(regexes[i]);
            } else {
                mergedRegexes[i] = regexes[i];
            }
        }
        return mergedRegexes;
    },
        enumerize = function enumerize(arr) {
        var enums = {};
        for (var i = 0; i < arr.length; i++) {
            enums[arr[i].toUpperCase()] = arr[i];
        }
        return enums;
    },
        has = function has(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    },
        lowerize = function lowerize(str) {
        return str.toLowerCase();
    },
        majorize = function majorize(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    },
        trim = function trim(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function rgxMapper(ua, arrays) {

        var i = 0,
            j,
            k,
            p,
            q,
            matches,
            match;

        // loop through all regexes maps
        while (i < arrays.length && !matches) {

            var regex = arrays[i],
                // even sequence (0,2,4,..)
            props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;

            // try matching uastring with regexes
            while (j < regex.length && !matches) {

                matches = regex[j++].exec(ua);

                if (!!matches) {
                    for (p = 0; p < props.length; p++) {
                        match = matches[++k];
                        q = props[p];
                        // check if given property is actually array
                        if (typeof q === OBJ_TYPE && q.length > 0) {
                            if (q.length === 2) {
                                if (typeof q[1] == FUNC_TYPE) {
                                    // assign modified match
                                    this[q[0]] = q[1].call(this, match);
                                } else {
                                    // assign given value, ignore regex match
                                    this[q[0]] = q[1];
                                }
                            } else if (q.length === 3) {
                                // check whether function or regex
                                if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                    // call function (usually string mapper)
                                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                } else {
                                    // sanitize match using given regex
                                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                }
                            } else if (q.length === 4) {
                                this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                            }
                        } else {
                            this[q] = match ? match : undefined;
                        }
                    }
                }
            }
            i += 2;
        }
    },
        strMapper = function strMapper(str, map) {

        for (var i in map) {
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                for (var j = 0; j < map[i].length; j++) {
                    if (has(map[i][j], str)) {
                        return i === UNKNOWN ? undefined : i;
                    }
                }
            } else if (has(map[i], str)) {
                return i === UNKNOWN ? undefined : i;
            }
        }
        return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    },
        windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': ['NT 5.1', 'NT 5.2'],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': ['NT 6.4', 'NT 10.0'],
        'RT': 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
        ], [VERSION, [NAME, 'Chrome']], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
        ], [VERSION, [NAME, 'Edge']], [

        // Presto based
        /(opera mini)\/([-\w\.]+)/i, // Opera Mini
        /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, // Opera Mobi/Tablet
        /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
        ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
        ], [VERSION, [NAME, OPERA + ' Mini']], [/\bopr\/([\w\.]+)/i // Opera Webkit
        ], [VERSION, [NAME, OPERA]], [

        // Mixed
        /(kindle)\/([\w\.]+)/i, // Kindle
        /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
        // Trident based
        /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser
        /(ba?idubrowser)[\/ ]?([\w\.]+)/i, // Baidu Browser
        /(?:ms|\()(ie) ([\w\.]+)/i, // Internet Explorer

        // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
        /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
        // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
        /(weibo)__([\d\.]+)/i // Weibo
        ], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
        ], [VERSION, [NAME, 'UC' + BROWSER]], [/\bqbcore\/([\w\.]+)/i // WeChat Desktop for Windows Built-in Browser
        ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [/micromessenger\/([\w\.]+)/i // WeChat
        ], [VERSION, [NAME, 'WeChat']], [/konqueror\/([\w\.]+)/i // Konqueror
        ], [VERSION, [NAME, 'Konqueror']], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
        ], [VERSION, [NAME, 'IE']], [/yabrowser\/([\w\.]+)/i // Yandex
        ], [VERSION, [NAME, 'Yandex']], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
        ], [[NAME, /(.+)/, '$1 Secure ' + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i // Firefox Focus
        ], [VERSION, [NAME, FIREFOX + ' Focus']], [/\bopt\/([\w\.]+)/i // Opera Touch
        ], [VERSION, [NAME, OPERA + ' Touch']], [/coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
        ], [VERSION, [NAME, 'Coc Coc']], [/dolfin\/([\w\.]+)/i // Dolphin
        ], [VERSION, [NAME, 'Dolphin']], [/coast\/([\w\.]+)/i // Opera Coast
        ], [VERSION, [NAME, OPERA + ' Coast']], [/miuibrowser\/([\w\.]+)/i // MIUI Browser
        ], [VERSION, [NAME, 'MIUI ' + BROWSER]], [/fxios\/([-\w\.]+)/i // Firefox for iOS
        ], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i // 360
        ], [[NAME, '360 ' + BROWSER]], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [// Oculus/Samsung/Sailfish Browser
        /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
        ], [[NAME, /_/g, ' '], VERSION], [/(electron)\/([\w\.]+) safari/i, // Electron-based App
        /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, // Tesla
        /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
        ], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i, // SouGouBrowser
        /(lbbrowser)/i // LieBao Browser
        ], [NAME], [

        // WebView
        /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
        ], [[NAME, FACEBOOK], VERSION], [/safari (line)\/([\w\.]+)/i, // Line App for iOS
        /\b(line)\/([\w\.]+)\/iab/i, // Line App for Android
        /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
        ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
        ], [VERSION, [NAME, 'GSA']], [/headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
        ], [VERSION, [NAME, CHROME + ' Headless']], [/ wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
        ], [[NAME, CHROME + ' WebView'], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
        ], [VERSION, [NAME, 'Android ' + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
        ], [NAME, VERSION], [/version\/([\w\.]+) .*mobile\/\w+ (safari)/i // Mobile Safari
        ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
        ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
        ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [

        // Gecko based
        /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
        ], [[NAME, 'Netscape'], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
        ], [VERSION, [NAME, FIREFOX + ' Reality']], [/ekiohf.+(flow)\/([\w\.]+)/i, // Flow
        /(swiftfox)/i, // Swiftfox
        /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
        // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
        /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
        // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
        /(firefox)\/([\w\.]+)/i, // Other Firefox-based
        /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, // Mozilla

        // Other
        /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
        // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
        /(links) \(([\w\.]+)/i // Links
        ], [NAME, VERSION]],

        cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
        ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
        ], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
        ], [[ARCHITECTURE, 'ia32']], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
        ], [[ARCHITECTURE, 'arm64']], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
        ], [[ARCHITECTURE, 'armhf']], [

        // PocketPC mistakenly identified as PowerPC
        /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
        ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i // SPARC
        ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ], [[ARCHITECTURE, lowerize]]],

        device: [[

        //////////////////////////
        // MOBILES & TABLETS
        // Ordered by popularity
        /////////////////////////

        // Samsung
        /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

        // Apple
        /\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
        ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i, // iPad
        /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [

        // Huawei
        /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

        // Xiaomi
        /\b(poco[\w ]+)(?: bui|\))/i, // Xiaomi POCO
        /\b; (\w+) build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
        /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, // Xiaomi Hongmi
        /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, // Xiaomi Redmi
        /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
        ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
        ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

        // OPPO
        /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

        // Vivo
        /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

        // Realme
        /\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

        // Motorola
        /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

        // LG
        /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

        // Lenovo
        /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

        // Nokia
        /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

        // Google
        /(pixel c)\b/i // Google Pixel C
        ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
        ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

        // Sony
        /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

        // OnePlus
        / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

        // Amazon
        /(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, // Kindle Fire without Silk
        /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
        ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
        ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

        // BlackBerry
        /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
        ], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i // BlackBerry 10
        ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

        // Asus
        /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

        // HTC
        /(nexus 9)/i // HTC Nexus 9
        ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, // HTC

        // ZTE
        /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

        // Acer
        /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

        // Meizu
        /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

        // Sharp
        /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [

        // MIXED
        /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
        // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
        /(hp) ([\w ]+\w)/i, // HP iPAQ
        /(asus)-?(\w+)/i, // Asus
        /(microsoft); (lumia[\w ]+)/i, // Microsoft Lumia
        /(lenovo)[-_ ]?([-\w]+)/i, // Lenovo
        /(jolla)/i, // Jolla
        /(oppo) ?([\w ]+) bui/i // OPPO
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos) (gamepad2?)/i, // Archos
        /(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
        /(kindle)\/([\w\.]+)/i, // Kindle
        /(nook)[\w ]+build\/(\w+)/i, // Nook
        /(dell) (strea[kpr\d ]*[\dko])/i, // Dell Streak
        /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, // Le Pan Tablets
        /(trinity)[- ]*(t\d{3}) bui/i, // Trinity Tablets
        /(gigaset)[- ]+(q\w{1,9}) bui/i, // Gigaset Tablets
        /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
        ], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i // Surface Duo
        ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
        ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [/(u304aa)/i // AT&T
        ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [/\bsie-(\w*)/i // Siemens
        ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/\b(rct\w+) b/i // RCA Tablets
        ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
        ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
        ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
        ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/\b(k88) b/i // ZTE K Series Tablet
        ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i // ZTE Nubia
        ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i // Swiss ZUR Tablet
        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i // Zeki Tablets
        ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
        ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i // Insignia Tablets
        ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
        ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
        ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
        ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i // Essential PH-1
        ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
        ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
        ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/\btu_(1491) b/i // Rotor Tablets
        ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/(shield[\w ]+) b/i // Nvidia Shield Tablets
        ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [/(sprint) (\w+)/i // Sprint Phones
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
        ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
        ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

        ///////////////////
        // CONSOLES
        ///////////////////

        /(ouya)/i, // Ouya
        /(nintendo) ([wids3utch]+)/i // Nintendo
        ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i // Nvidia
        ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i // Playstation
        ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
        ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

        ///////////////////
        // SMARTTVS
        ///////////////////

        /smart-tv.+(samsung)/i // Samsung
        ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
        ], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i // Apple TV
        ], [VENDOR, [MODEL, APPLE + ' TV'], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
        ], [[MODEL, CHROME + 'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i // Fire TV
        ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
        ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, // Roku
        /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
        ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
        ], [[TYPE, SMARTTV]], [

        ///////////////////
        // WEARABLES
        ///////////////////

        /((pebble))app/i // Pebble
        ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+; (glass) \d/i // Google Glass
        ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( 2)?)/i // Oculus Quest
        ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

        ///////////////////
        // EMBEDDED
        ///////////////////

        /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
        ], [VENDOR, [TYPE, EMBEDDED]], [

        ////////////////////
        // MIXED (GENERIC)
        ///////////////////

        /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
        ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
        ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
        ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
        ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
        ], [MODEL, [VENDOR, 'Generic']]],

        engine: [[/windows.+ edge\/([\w\.]+)/i // EdgeHTML
        ], [VERSION, [NAME, EDGE + 'HTML']], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
        ], [VERSION, [NAME, 'Blink']], [/(presto)\/([\w\.]+)/i, // Presto
        /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
        /ekioh(flow)\/([\w\.]+)/i, // Flow
        /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, // KHTML/Tasman/Links
        /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
        ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
        ], [VERSION, NAME]],

        os: [[

        // Windows
        /microsoft (windows) (vista|xp)/i // Windows (iTunes)
        ], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i, // Windows RT
        /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, // Windows Phone
        /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

        // iOS/macOS
        /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, // iOS
        /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
        ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

        // Mobile OSes
        /droid ([\w\.]+)\b.+(android[- ]x86)/i // Android-x86
        ], [VERSION, NAME], [// Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
        /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, // Blackberry
        /(tizen|kaios)[\/ ]([\w\.]+)/i, // Tizen/KaiOS
        /\((series40);/i // Series 40
        ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
        ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
        ], [VERSION, [NAME, 'Symbian']], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
        ], [VERSION, [NAME, FIREFOX + ' OS']], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
        ], [VERSION, [NAME, 'webOS']], [

        // Google Chromecast
        /crkey\/([\d\.]+)/i // Google Chromecast
        ], [VERSION, [NAME, CHROME + 'cast']], [/(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
        ], [[NAME, 'Chromium OS'], VERSION], [

        // Console
        /(nintendo|playstation) ([wids345portablevuch]+)/i, // Nintendo/Playstation
        /(xbox); +xbox ([^\);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)

        // Other
        /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, // Joli/Palm
        /(mint)[\/\(\) ]?(\w*)/i, // Mint
        /(mageia|vectorlinux)[; ]/i, // Mageia/VectorLinux
        /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
        // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
        /(hurd|linux) ?([\w\.]*)/i, // Hurd/Linux
        /(gnu) ?([\w\.]*)/i, // GNU
        /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
        /(haiku) (\w+)/i // Haiku
        ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i // Solaris
        ], [[NAME, 'Solaris'], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, // Solaris
        /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, // AIX
        /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
        /(unix) ?([\w\.]*)/i // UNIX
        ], [NAME, VERSION]]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function UAParser(ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || (typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__("yNJ0")) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }
})(typeof window === 'object' ? window : this);

/***/ }),

/***/ "o9aU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchContainer":"searchContainer__1LrFo","serchInput":"serchInput__3BrY3","searchIcon":"searchIcon__2T-Ch"};

/***/ }),

/***/ "oBX1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);



var Hr = function Hr(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === undefined ? "black" : _ref$color,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 2 : _ref$height,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? "100%" : _ref$width,
        _ref$margin = _ref.margin,
        margin = _ref$margin === undefined ? 0 : _ref$margin;


    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", { style: {
            width: width,
            backgroundColor: color,
            height: height,
            margin: margin + "px auto"
        } });
};

/* harmony default export */ __webpack_exports__["a"] = (Hr);

/***/ }),

/***/ "oGJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__("f5Sh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__ = __webpack_require__("H70G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__ = __webpack_require__("tKq7");




/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */

function differenceInMinutes(dateLeft, dateRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__["a" /* default */])(dateLeft, dateRight) / __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["c" /* millisecondsInMinute */];
  return Object(__WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),

/***/ "oOss":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var isCallable = __webpack_require__("yeFe");
var tryToString = __webpack_require__("HXaG");

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};

/***/ }),

/***/ "oSON":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*!
 * @name JavaScript/NodeJS Merge v1.2.1
 * @author yeikos
 * @repository https://github.com/yeikos/js.merge

 * Copyright 2014 yeikos - MIT license
 * https://raw.github.com/yeikos/js.merge/master/LICENSE
 */

;(function (isNode) {

	/**
  * Merge one or more objects 
  * @param bool? clone
  * @param mixed,... arguments
  * @return object
  */

	var Public = function Public(clone) {

		return merge(clone === true, false, arguments);
	},
	    publicName = 'merge';

	/**
  * Merge two or more objects recursively 
  * @param bool? clone
  * @param mixed,... arguments
  * @return object
  */

	Public.recursive = function (clone) {

		return merge(clone === true, true, arguments);
	};

	/**
  * Clone the input removing any reference
  * @param mixed input
  * @return mixed
  */

	Public.clone = function (input) {

		var output = input,
		    type = typeOf(input),
		    index,
		    size;

		if (type === 'array') {

			output = [];
			size = input.length;

			for (index = 0; index < size; ++index) {

				output[index] = Public.clone(input[index]);
			}
		} else if (type === 'object') {

			output = {};

			for (index in input) {

				output[index] = Public.clone(input[index]);
			}
		}

		return output;
	};

	/**
  * Merge two objects recursively
  * @param mixed input
  * @param mixed extend
  * @return mixed
  */

	function merge_recursive(base, extend) {

		if (typeOf(base) !== 'object') return extend;

		for (var key in extend) {

			if (typeOf(base[key]) === 'object' && typeOf(extend[key]) === 'object') {

				base[key] = merge_recursive(base[key], extend[key]);
			} else {

				base[key] = extend[key];
			}
		}

		return base;
	}

	/**
  * Merge two or more objects
  * @param bool clone
  * @param bool recursive
  * @param array argv
  * @return object
  */

	function merge(clone, recursive, argv) {

		var result = argv[0],
		    size = argv.length;

		if (clone || typeOf(result) !== 'object') result = {};

		for (var index = 0; index < size; ++index) {

			var item = argv[index],
			    type = typeOf(item);

			if (type !== 'object') continue;

			for (var key in item) {

				if (key === '__proto__') continue;

				var sitem = clone ? Public.clone(item[key]) : item[key];

				if (recursive) {

					result[key] = merge_recursive(result[key], sitem);
				} else {

					result[key] = sitem;
				}
			}
		}

		return result;
	}

	/**
  * Get type of variable
  * @param mixed input
  * @return string
  *
  * @see http://jsperf.com/typeofvar
  */

	function typeOf(input) {

		return {}.toString.call(input).slice(8, -1).toLowerCase();
	}

	if (isNode) {

		module.exports = Public;
	} else {

		window[publicName] = Public;
	}
})(typeof module === 'object' && module && typeof module.exports === 'object' && module.exports);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("l262")(module)))

/***/ }),

/***/ "oXMl":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("xNmf"),
    root = typeof window === 'undefined' ? global : window,
    vendors = ['moz', 'webkit'],
    suffix = 'AnimationFrame',
    raf = root['request' + suffix],
    caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for (var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
  var last = 0,
      id = 0,
      queue = [],
      frameDuration = 1000 / 60;

  raf = function raf(callback) {
    if (queue.length === 0) {
      var _now = now(),
          next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function () {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for (var i = 0; i < cp.length; i++) {
          if (!cp[i].cancelled) {
            try {
              cp[i].callback(last);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id;
  };

  caf = function caf(handle) {
    for (var i = 0; i < queue.length; i++) {
      if (queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

module.exports = function (fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn);
};
module.exports.cancel = function () {
  caf.apply(root, arguments);
};
module.exports.polyfill = function (object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "oj7W":
/***/ (function(module, exports) {

module.exports = true;

/***/ }),

/***/ "onmi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pagination":"pagination__fAbag"};

/***/ }),

/***/ "orz+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__("uTT0"); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
	var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = function () {
		/* global window */
		if (typeof window === 'undefined') {
			return false;
		}
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}();
	var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;

/***/ }),

/***/ "pXYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/react-click-outside/dist/index.js
var dist = __webpack_require__("T65i");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/mini-store/lib/index.js
var lib = __webpack_require__("VaGT");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ../node_modules/rc-util/es/KeyCode.js
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ var es_KeyCode = (KeyCode);
// CONCATENATED MODULE: ../node_modules/rc-util/es/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}
// EXTERNAL MODULE: ../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__("pz6A");
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__("9qb7");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ../node_modules/rc-menu/es/utils/isMobile.js
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;_e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// MIT License from https://github.com/kaimallea/isMobile
var applePhone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'

var androidTablet = /Android/i;
var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i; // Match 'Windows' AND 'ARM'

var otherBlackberry = /BlackBerry/i;
var otherBlackberry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'

function match(regex, userAgent) {
  return regex.test(userAgent);
}

function isMobile(userAgent) {
  var ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : ''); // Facebook mobile app's integrated browser adds a bunch of strings that
  // match everything. Strip it out if it exists.

  var tmp = ua.split('[FBAN');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp = tmp;

    var _tmp2 = _slicedToArray(_tmp, 1);

    ua = _tmp2[0];
  } // Twitter mobile app's integrated browser on iPad adds a "Twitter for
  // iPhone" string. Same probably happens on other tablet platforms.
  // This will confuse detection so strip it out if it exists.


  tmp = ua.split('Twitter');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp3 = tmp;

    var _tmp4 = _slicedToArray(_tmp3, 1);

    ua = _tmp4[0];
  }

  var result = {
    apple: {
      phone: match(applePhone, ua) && !match(windowsPhone, ua),
      ipod: match(appleIpod, ua),
      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
    },
    amazon: {
      phone: match(amazonPhone, ua),
      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
      device: match(amazonPhone, ua) || match(amazonTablet, ua)
    },
    android: {
      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
    },
    windows: {
      phone: match(windowsPhone, ua),
      tablet: match(windowsTablet, ua),
      device: match(windowsPhone, ua) || match(windowsTablet, ua)
    },
    other: {
      blackberry: match(otherBlackberry, ua),
      blackberry10: match(otherBlackberry10, ua),
      opera: match(otherOpera, ua),
      firefox: match(otherFirefox, ua),
      chrome: match(otherChrome, ua),
      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
    },
    // Additional
    any: null,
    phone: null,
    tablet: null
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device; // excludes 'other' devices and ipods, targeting touchscreen phones

  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}

var defaultResult = _objectSpread({}, isMobile(), {
  isMobile: isMobile
});

/* harmony default export */ var utils_isMobile = (defaultResult);
// CONCATENATED MODULE: ../node_modules/rc-menu/es/util.js
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return _typeof(obj);
}



function noop() {}
function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key || "".concat(prefix, "item_").concat(index);
}
function getMenuIdFromSubMenuEventKey(eventKey) {
  return "".concat(eventKey, "-menu-");
}
function loopMenuItem(children, cb) {
  var index = -1;
  preact_compat_es["Children"].forEach(children, function (c) {
    index += 1;

    if (c && c.type && c.type.isMenuItemGroup) {
      preact_compat_es["Children"].forEach(c.props.children, function (c2) {
        index += 1;
        cb(c2, index);
      });
    } else {
      cb(c, index);
    }
  });
}
function loopMenuItemRecursively(children, keys, ret) {
  /* istanbul ignore if */
  if (!children || ret.find) {
    return;
  }

  preact_compat_es["Children"].forEach(children, function (c) {
    if (c) {
      var construct = c.type;

      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }

      if (keys.indexOf(c.key) !== -1) {
        ret.find = true;
      } else if (c.props.children) {
        loopMenuItemRecursively(c.props.children, keys, ret);
      }
    }
  });
}
var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements', 'overflowedIndicator', 'motion', // the following keys found need to be removed from test regression
'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme', 'itemIcon', 'expandIcon']; // ref: https://github.com/ant-design/ant-design/issues/14007
// ref: https://bugs.chromium.org/p/chromium/issues/detail?id=360889
// getBoundingClientRect return the full precision value, which is
// not the same behavior as on chrome. Set the precision to 6 to
// unify their behavior

var getWidth = function getWidth(elem) {
  var width = elem && typeof elem.getBoundingClientRect === 'function' && elem.getBoundingClientRect().width;

  if (width) {
    width = +width.toFixed(6);
  }

  return width || 0;
};
var setStyle = function setStyle(elem, styleProperty, value) {
  if (elem && _typeof(elem.style) === 'object') {
    elem.style[styleProperty] = value;
  }
};
var util_isMobileDevice = function isMobileDevice() {
  return utils_isMobile.any;
};
// EXTERNAL MODULE: ../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__("C4qV");

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("T4f3");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("dACh");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("VOrx");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("ZKjc");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
var react_lifecycles_compat_es = __webpack_require__("nkXc");

// EXTERNAL MODULE: ../node_modules/rc-util/es/Dom/contains.js
var contains = __webpack_require__("asZT");

// EXTERNAL MODULE: ../node_modules/rc-util/es/Dom/addEventListener.js
var addEventListener = __webpack_require__("v9LT");

// CONCATENATED MODULE: ../node_modules/rc-util/es/ContainerRender.js
function ContainerRender__typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    ContainerRender__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    ContainerRender__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return ContainerRender__typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (ContainerRender__typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}





var ContainerRender_ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        preact_compat_es["default"].unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        preact_compat_es["default"].unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(preact_compat_es["default"].Component);

ContainerRender_ContainerRender.propTypes = {
  autoMount: prop_types_default.a.bool,
  autoDestroy: prop_types_default.a.bool,
  visible: prop_types_default.a.bool,
  forceRender: prop_types_default.a.bool,
  parent: prop_types_default.a.any,
  getComponent: prop_types_default.a.func.isRequired,
  getContainer: prop_types_default.a.func.isRequired,
  children: prop_types_default.a.func.isRequired
};
ContainerRender_ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};

// CONCATENATED MODULE: ../node_modules/rc-util/es/Portal.js
function Portal__typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    Portal__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    Portal__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return Portal__typeof(obj);
}

function Portal__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Portal__defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function Portal__createClass(Constructor, protoProps, staticProps) {
  if (protoProps) Portal__defineProperties(Constructor.prototype, protoProps);if (staticProps) Portal__defineProperties(Constructor, staticProps);return Constructor;
}

function Portal__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) Portal__setPrototypeOf(subClass, superClass);
}

function Portal__setPrototypeOf(o, p) {
  Portal__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return Portal__setPrototypeOf(o, p);
}

function Portal__createSuper(Derived) {
  var hasNativeReflectConstruct = Portal__isNativeReflectConstruct();return function _createSuperInternal() {
    var Super = Portal__getPrototypeOf(Derived),
        result;if (hasNativeReflectConstruct) {
      var NewTarget = Portal__getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return Portal__possibleConstructorReturn(this, result);
  };
}

function Portal__possibleConstructorReturn(self, call) {
  if (call && (Portal__typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return Portal__assertThisInitialized(self);
}

function Portal__assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function Portal__isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function Portal__getPrototypeOf(o) {
  Portal__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return Portal__getPrototypeOf(o);
}





var Portal_Portal = /*#__PURE__*/function (_React$Component) {
  Portal__inherits(Portal, _React$Component);

  var _super = Portal__createSuper(Portal);

  function Portal() {
    Portal__classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  Portal__createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return preact_compat_es["default"].createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(preact_compat_es["default"].Component);

Portal_Portal.propTypes = {
  getContainer: prop_types_default.a.func.isRequired,
  children: prop_types_default.a.node.isRequired,
  didUpdate: prop_types_default.a.func
};

// CONCATENATED MODULE: ../node_modules/rc-trigger/es/utils.js

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return extends_default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}
// EXTERNAL MODULE: ../node_modules/rc-align/es/index.js + 3 modules
var es = __webpack_require__("AVA2");

// EXTERNAL MODULE: ../node_modules/rc-animate/es/Animate.js + 4 modules
var Animate = __webpack_require__("mKtm");

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("zCAL");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// CONCATENATED MODULE: ../node_modules/rc-trigger/es/LazyRenderBox.js







var LazyRenderBox_LazyRenderBox = function (_Component) {
  inherits_default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    classCallCheck_default()(this, LazyRenderBox);

    return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = objectWithoutProperties_default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || preact_compat_es["default"].Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return preact_compat_es["default"].createElement('div', props);
    }

    return preact_compat_es["default"].Children.only(props.children);
  };

  return LazyRenderBox;
}(preact_compat_es["Component"]);

/* harmony default export */ var es_LazyRenderBox = (LazyRenderBox_LazyRenderBox);
// CONCATENATED MODULE: ../node_modules/rc-trigger/es/PopupInner.js







var PopupInner_PopupInner = function (_Component) {
  inherits_default()(PopupInner, _Component);

  function PopupInner() {
    classCallCheck_default()(this, PopupInner);

    return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return preact_compat_es["default"].createElement('div', {
      className: className,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onMouseDown: props.onMouseDown,
      onTouchStart: props.onTouchStart,
      style: props.style
    }, preact_compat_es["default"].createElement(es_LazyRenderBox, { className: props.prefixCls + '-content', visible: props.visible }, props.children));
  };

  return PopupInner;
}(preact_compat_es["Component"]);

/* harmony default export */ var es_PopupInner = (PopupInner_PopupInner);
// CONCATENATED MODULE: ../node_modules/rc-trigger/es/Popup.js













var Popup_Popup = function (_Component) {
  inherits_default()(Popup, _Component);

  function Popup(props) {
    classCallCheck_default()(this, Popup);

    var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

    Popup__initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = saveRef.bind(_this, 'popupInstance');
    _this.saveAlignRef = saveRef.bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return preact_compat_es["default"].findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = extends_default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return preact_compat_es["default"].createElement(Animate["a" /* default */], {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName()
      }, visible ? preact_compat_es["default"].createElement(es["a" /* default */], {
        target: this.getAlignTarget(),
        key: 'popup',
        ref: this.saveAlignRef,
        monitorWindowResize: true,
        align: align,
        onAlign: this.onAlign
      }, preact_compat_es["default"].createElement(es_PopupInner, extends_default()({
        visible: true
      }, popupInnerProps), children)) : null);
    }

    return preact_compat_es["default"].createElement(Animate["a" /* default */], {
      component: '',
      exclusive: true,
      transitionAppear: true,
      transitionName: this.getTransitionName(),
      showProp: 'xVisible'
    }, preact_compat_es["default"].createElement(es["a" /* default */], {
      target: this.getAlignTarget(),
      key: 'popup',
      ref: this.saveAlignRef,
      monitorWindowResize: true,
      xVisible: visible,
      childrenProps: { visible: 'xVisible' },
      disabled: !visible,
      align: align,
      onAlign: this.onAlign
    }, preact_compat_es["default"].createElement(es_PopupInner, extends_default()({
      hiddenClassName: hiddenClassName
    }, popupInnerProps), children)));
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = preact_compat_es["default"].createElement(es_LazyRenderBox, {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = preact_compat_es["default"].createElement(Animate["a" /* default */], {
          key: 'mask',
          showProp: 'visible',
          transitionAppear: true,
          component: '',
          transitionName: maskTransition
        }, maskElement);
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return preact_compat_es["default"].createElement('div', null, this.getMaskElement(), this.getPopupElement());
  };

  return Popup;
}(preact_compat_es["Component"]);

var Popup__initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;

    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ var es_Popup = (Popup_Popup);
// CONCATENATED MODULE: ../node_modules/rc-trigger/es/index.js

















function es_noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!preact_compat_es["createPortal"];

var contextTypes = {
  rcTrigger: prop_types_default.a.shape({
    onPopupMouseDown: prop_types_default.a.func
  })
};

var es_Trigger = function (_React$Component) {
  inherits_default()(Trigger, _React$Component);

  function Trigger(props) {
    classCallCheck_default()(this, Trigger);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

    es__initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(addEventListener["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(addEventListener["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(addEventListener["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(addEventListener["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;

    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = preact_compat_es["default"].Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = classnames_default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = preact_compat_es["default"].cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return preact_compat_es["default"].createElement(ContainerRender_ContainerRender, {
        parent: this,
        visible: popupVisible,
        autoMount: false,
        forceRender: forceRender,
        getComponent: this.getComponent,
        getContainer: this.getContainer
      }, function (_ref2) {
        var renderComponent = _ref2.renderComponent;

        _this3.renderComponent = renderComponent;
        return trigger;
      });
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = preact_compat_es["default"].createElement(Portal_Portal, { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate }, this.getComponent());
    }

    return [trigger, portal];
  };

  return Trigger;
}(preact_compat_es["default"].Component);

es_Trigger.contextTypes = contextTypes;
es_Trigger.childContextTypes = contextTypes;
es_Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: es_noop,
  afterPopupVisibleChange: es_noop,
  onPopupAlign: es_noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var es__initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(contains["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(preact_compat_es["findDOMNode"])(_this4);
    if (!Object(contains["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(preact_compat_es["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;

    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return preact_compat_es["default"].createElement(es_Popup, extends_default()({
      prefixCls: prefixCls,
      destroyPopupOnHide: destroyPopupOnHide,
      visible: popupVisible,
      point: alignPoint && point,
      className: popupClassName,
      action: action,
      align: align,
      onAlign: onPopupAlign,
      animation: popupAnimation,
      getClassNameFromAlign: _this4.getPopupClassNameFromAlign
    }, mouseProps, {
      stretch: stretch,
      getRootDomNode: _this4.getRootDomNode,
      style: popupStyle,
      mask: mask,
      zIndex: zIndex,
      transitionName: popupTransitionName,
      maskAnimation: maskAnimation,
      maskTransitionName: maskTransitionName,
      ref: _this4.savePopup
    }), typeof popup === 'function' ? popup() : popup);
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(preact_compat_es["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(react_lifecycles_compat_es["polyfill"])(es_Trigger);

/* harmony default export */ var rc_trigger_es = (es_Trigger);
// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("Xos8");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("jx4H");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ../node_modules/rc-util/es/Dom/findDOMNode.js

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */

function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return preact_compat_es["default"].findDOMNode(node);
}
// EXTERNAL MODULE: ../node_modules/raf/index.js
var raf = __webpack_require__("oXMl");
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: ../node_modules/rc-animate/es/util/motion.js
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}

var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});

var motion_style = {};

if (canUseDOM) {
  motion_style = document.createElement('div').style;
}

var prefixedEventNames = {};

function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in motion_style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}

var animationEndName = getVendorPrefixedEventName('animationend');
var transitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(animationEndName && transitionEndName);

function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (typeof transitionName === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return transitionName + '-' + transitionType;
}
// CONCATENATED MODULE: ../node_modules/rc-animate/es/CSSMotion.js






/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp */








var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';

var MotionPropTypes = {
  eventProps: prop_types_default.a.object, // Internal usage. Only pass by CSSMotionList
  visible: prop_types_default.a.bool,
  children: prop_types_default.a.func,
  motionName: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]),
  motionAppear: prop_types_default.a.bool,
  motionEnter: prop_types_default.a.bool,
  motionLeave: prop_types_default.a.bool,
  motionLeaveImmediately: prop_types_default.a.bool, // Trigger leave motion immediately
  motionDeadline: prop_types_default.a.number,
  removeOnLeave: prop_types_default.a.bool,
  leavedClassName: prop_types_default.a.string,
  onAppearStart: prop_types_default.a.func,
  onAppearActive: prop_types_default.a.func,
  onAppearEnd: prop_types_default.a.func,
  onEnterStart: prop_types_default.a.func,
  onEnterActive: prop_types_default.a.func,
  onEnterEnd: prop_types_default.a.func,
  onLeaveStart: prop_types_default.a.func,
  onLeaveActive: prop_types_default.a.func,
  onLeaveEnd: prop_types_default.a.func
};

/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  var forwardRef = !!preact_compat_es["default"].forwardRef;

  if (typeof config === 'object') {
    transitionSupport = config.transitionSupport;
    forwardRef = 'forwardRef' in config ? config.forwardRef : forwardRef;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = function (_React$Component) {
    inherits_default()(CSSMotion, _React$Component);

    function CSSMotion() {
      classCallCheck_default()(this, CSSMotion);

      var _this = possibleConstructorReturn_default()(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));

      _this.onDomUpdate = function () {
        var _this$state = _this.state,
            status = _this$state.status,
            newStatus = _this$state.newStatus;
        var _this$props = _this.props,
            onAppearStart = _this$props.onAppearStart,
            onEnterStart = _this$props.onEnterStart,
            onLeaveStart = _this$props.onLeaveStart,
            onAppearActive = _this$props.onAppearActive,
            onEnterActive = _this$props.onEnterActive,
            onLeaveActive = _this$props.onLeaveActive,
            motionAppear = _this$props.motionAppear,
            motionEnter = _this$props.motionEnter,
            motionLeave = _this$props.motionLeave;

        if (!isSupportTransition(_this.props)) {
          return;
        }

        // Event injection
        var $ele = _this.getElement();
        if (_this.$cacheEle !== $ele) {
          _this.removeEventListener(_this.$cacheEle);
          _this.addEventListener($ele);
          _this.$cacheEle = $ele;
        }

        // Init status
        if (newStatus && status === STATUS_APPEAR && motionAppear) {
          _this.updateStatus(onAppearStart, null, null, function () {
            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
          });
        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
          _this.updateStatus(onEnterStart, null, null, function () {
            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
          });
        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
          _this.updateStatus(onLeaveStart, null, null, function () {
            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
          });
        }
      };

      _this.onMotionEnd = function (event) {
        var _this$state2 = _this.state,
            status = _this$state2.status,
            statusActive = _this$state2.statusActive;
        var _this$props2 = _this.props,
            onAppearEnd = _this$props2.onAppearEnd,
            onEnterEnd = _this$props2.onEnterEnd,
            onLeaveEnd = _this$props2.onLeaveEnd;

        if (status === STATUS_APPEAR && statusActive) {
          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_ENTER && statusActive) {
          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_LEAVE && statusActive) {
          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
        }
      };

      _this.setNodeRef = function (node) {
        var internalRef = _this.props.internalRef;

        _this.node = node;

        if (typeof internalRef === 'function') {
          internalRef(node);
        } else if (internalRef && 'current' in internalRef) {
          internalRef.current = node;
        }
      };

      _this.getElement = function () {
        try {
          return findDOMNode(_this.node || _this);
        } catch (e) {
          /**
           * Fallback to cache element.
           * This is only happen when `motionDeadline` trigger but element removed.
           */
          return _this.$cacheEle;
        }
      };

      _this.addEventListener = function ($ele) {
        if (!$ele) return;

        $ele.addEventListener(transitionEndName, _this.onMotionEnd);
        $ele.addEventListener(animationEndName, _this.onMotionEnd);
      };

      _this.removeEventListener = function ($ele) {
        if (!$ele) return;

        $ele.removeEventListener(transitionEndName, _this.onMotionEnd);
        $ele.removeEventListener(animationEndName, _this.onMotionEnd);
      };

      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
        var statusStyle = styleFunc ? styleFunc(_this.getElement(), event) : null;

        if (statusStyle === false || _this._destroyed) return;

        var nextStep = void 0;
        if (callback) {
          nextStep = function nextStep() {
            _this.nextFrame(callback);
          };
        }

        _this.setState(extends_default()({
          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
          newStatus: false
        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
      };

      _this.updateActiveStatus = function (styleFunc, currentStatus) {
        // `setState` use `postMessage` to trigger at the end of frame.
        // Let's use requestAnimationFrame to update new state in next frame.
        _this.nextFrame(function () {
          var status = _this.state.status;

          if (status !== currentStatus) return;

          var motionDeadline = _this.props.motionDeadline;

          _this.updateStatus(styleFunc, { statusActive: true });

          if (motionDeadline > 0) {
            setTimeout(function () {
              _this.onMotionEnd({
                deadline: true
              });
            }, motionDeadline);
          }
        });
      };

      _this.nextFrame = function (func) {
        _this.cancelNextFrame();
        _this.raf = raf_default()(func);
      };

      _this.cancelNextFrame = function () {
        if (_this.raf) {
          raf_default.a.cancel(_this.raf);
          _this.raf = null;
        }
      };

      _this.state = {
        status: STATUS_NONE,
        statusActive: false,
        newStatus: false,
        statusStyle: null
      };
      _this.$cacheEle = null;
      _this.node = null;
      _this.raf = null;
      return _this;
    }

    createClass_default()(CSSMotion, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._destroyed = true;
        this.removeEventListener(this.$cacheEle);
        this.cancelNextFrame();
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _state = this.state,
            status = _state.status,
            statusActive = _state.statusActive,
            statusStyle = _state.statusStyle;
        var _props = this.props,
            children = _props.children,
            motionName = _props.motionName,
            visible = _props.visible,
            removeOnLeave = _props.removeOnLeave,
            leavedClassName = _props.leavedClassName,
            eventProps = _props.eventProps;

        if (!children) return null;

        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
          if (visible) {
            return children(extends_default()({}, eventProps), this.setNodeRef);
          } else if (!removeOnLeave) {
            return children(extends_default()({}, eventProps, { className: leavedClassName }), this.setNodeRef);
          }

          return null;
        }

        return children(extends_default()({}, eventProps, {
          className: classnames_default()((_classNames = {}, defineProperty_default()(_classNames, getTransitionName(motionName, status), status !== STATUS_NONE), defineProperty_default()(_classNames, getTransitionName(motionName, status + '-active'), status !== STATUS_NONE && statusActive), defineProperty_default()(_classNames, motionName, typeof motionName === 'string'), _classNames)),
          style: statusStyle
        }), this.setNodeRef);
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, _ref) {
        var prevProps = _ref.prevProps,
            prevStatus = _ref.status;

        if (!isSupportTransition(props)) return {};

        var visible = props.visible,
            motionAppear = props.motionAppear,
            motionEnter = props.motionEnter,
            motionLeave = props.motionLeave,
            motionLeaveImmediately = props.motionLeaveImmediately;

        var newState = {
          prevProps: props
        };

        // Clean up status if prop set to false
        if (prevStatus === STATUS_APPEAR && !motionAppear || prevStatus === STATUS_ENTER && !motionEnter || prevStatus === STATUS_LEAVE && !motionLeave) {
          newState.status = STATUS_NONE;
          newState.statusActive = false;
          newState.newStatus = false;
        }

        // Appear
        if (!prevProps && visible && motionAppear) {
          newState.status = STATUS_APPEAR;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Enter
        if (prevProps && !prevProps.visible && visible && motionEnter) {
          newState.status = STATUS_ENTER;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Leave
        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
          newState.status = STATUS_LEAVE;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        return newState;
      }
    }]);

    return CSSMotion;
  }(preact_compat_es["default"].Component);

  CSSMotion.propTypes = extends_default()({}, MotionPropTypes, {

    internalRef: prop_types_default.a.oneOfType([prop_types_default.a.object, prop_types_default.a.func])
  });
  CSSMotion.defaultProps = {
    visible: true,
    motionEnter: true,
    motionAppear: true,
    motionLeave: true,
    removeOnLeave: true
  };

  Object(react_lifecycles_compat_es["polyfill"])(CSSMotion);

  if (!forwardRef) {
    return CSSMotion;
  }

  return preact_compat_es["default"].forwardRef(function (props, ref) {
    return preact_compat_es["default"].createElement(CSSMotion, extends_default()({ internalRef: ref }, props));
  });
}

/* harmony default export */ var es_CSSMotion = (genCSSMotion(supportTransition));
// CONCATENATED MODULE: ../node_modules/rc-menu/es/placements.js
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
/* harmony default export */ var es_placements = (placements);
// CONCATENATED MODULE: ../node_modules/rc-menu/es/SubMenu.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function SubMenu__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    SubMenu__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    SubMenu__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return SubMenu__typeof(obj);
}

function SubMenu__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function SubMenu__defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function SubMenu__createClass(Constructor, protoProps, staticProps) {
  if (protoProps) SubMenu__defineProperties(Constructor.prototype, protoProps);if (staticProps) SubMenu__defineProperties(Constructor, staticProps);return Constructor;
}

function SubMenu__possibleConstructorReturn(self, call) {
  if (call && (SubMenu__typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return SubMenu__assertThisInitialized(self);
}

function SubMenu__getPrototypeOf(o) {
  SubMenu__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return SubMenu__getPrototypeOf(o);
}

function SubMenu__assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function SubMenu__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) SubMenu__setPrototypeOf(subClass, superClass);
}

function SubMenu__setPrototypeOf(o, p) {
  SubMenu__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return SubMenu__setPrototypeOf(o, p);
}

function SubMenu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function SubMenu__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      SubMenu_ownKeys(Object(source), true).forEach(function (key) {
        SubMenu__defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      SubMenu_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function SubMenu__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}




 // import Animate from 'rc-animate';







var guid = 0;
var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};

var SubMenu_updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var menuId = getMenuIdFromSubMenuEventKey(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: SubMenu__objectSpread({}, state.defaultActiveFirst, SubMenu__defineProperty({}, menuId, defaultActiveFirst))
  });
};

var SubMenu_SubMenu =
/*#__PURE__*/
function (_React$Component) {
  SubMenu__inherits(SubMenu, _React$Component);

  function SubMenu(props) {
    var _this;

    SubMenu__classCallCheck(this, SubMenu);

    _this = SubMenu__possibleConstructorReturn(this, SubMenu__getPrototypeOf(SubMenu).call(this, props));

    _this.onDestroy = function (key) {
      _this.props.onDestroy(key);
    };
    /**
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;
      var menu = _this.menuInstance;
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          store = _this$props.store;

      if (keyCode === es_KeyCode.ENTER) {
        _this.onTitleClick(e);

        SubMenu_updateDefaultActiveFirst(store, _this.props.eventKey, true);
        return true;
      }

      if (keyCode === es_KeyCode.RIGHT) {
        if (isOpen) {
          menu.onKeyDown(e);
        } else {
          _this.triggerOpenChange(true); // need to update current menu's defaultActiveFirst value


          SubMenu_updateDefaultActiveFirst(store, _this.props.eventKey, true);
        }

        return true;
      }

      if (keyCode === es_KeyCode.LEFT) {
        var handled;

        if (isOpen) {
          handled = menu.onKeyDown(e);
        } else {
          return undefined;
        }

        if (!handled) {
          _this.triggerOpenChange(false);

          handled = true;
        }

        return handled;
      }

      if (isOpen && (keyCode === es_KeyCode.UP || keyCode === es_KeyCode.DOWN)) {
        return menu.onKeyDown(e);
      }

      return undefined;
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onPopupVisibleChange = function (visible) {
      _this.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          key = _this$props2.eventKey,
          onMouseEnter = _this$props2.onMouseEnter,
          store = _this$props2.store;
      SubMenu_updateDefaultActiveFirst(store, _this.props.eventKey, false);
      onMouseEnter({
        key: key,
        domEvent: e
      });
    };

    _this.onMouseLeave = function (e) {
      var _this$props3 = _this.props,
          parentMenu = _this$props3.parentMenu,
          eventKey = _this$props3.eventKey,
          onMouseLeave = _this$props3.onMouseLeave;
      parentMenu.subMenuInstance = SubMenu__assertThisInitialized(_this);
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleMouseEnter = function (domEvent) {
      var _this$props4 = _this.props,
          key = _this$props4.eventKey,
          onItemHover = _this$props4.onItemHover,
          onTitleMouseEnter = _this$props4.onTitleMouseEnter;
      onItemHover({
        key: key,
        hover: true
      });
      onTitleMouseEnter({
        key: key,
        domEvent: domEvent
      });
    };

    _this.onTitleMouseLeave = function (e) {
      var _this$props5 = _this.props,
          parentMenu = _this$props5.parentMenu,
          eventKey = _this$props5.eventKey,
          onItemHover = _this$props5.onItemHover,
          onTitleMouseLeave = _this$props5.onTitleMouseLeave;
      parentMenu.subMenuInstance = SubMenu__assertThisInitialized(_this);
      onItemHover({
        key: eventKey,
        hover: false
      });
      onTitleMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleClick = function (e) {
      var _assertThisInitialize = SubMenu__assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      props.onTitleClick({
        key: props.eventKey,
        domEvent: e
      });

      if (props.triggerSubMenuAction === 'hover') {
        return;
      }

      _this.triggerOpenChange(!props.isOpen, 'click');

      SubMenu_updateDefaultActiveFirst(props.store, _this.props.eventKey, false);
    };

    _this.onSubMenuClick = function (info) {
      // in the case of overflowed submenu
      // onClick is not copied over
      if (typeof _this.props.onClick === 'function') {
        _this.props.onClick(_this.addKeyPath(info));
      }
    };

    _this.onSelect = function (info) {
      _this.props.onSelect(info);
    };

    _this.onDeselect = function (info) {
      _this.props.onDeselect(info);
    };

    _this.getPrefixCls = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu");
    };

    _this.getActiveClassName = function () {
      return "".concat(_this.getPrefixCls(), "-active");
    };

    _this.getDisabledClassName = function () {
      return "".concat(_this.getPrefixCls(), "-disabled");
    };

    _this.getSelectedClassName = function () {
      return "".concat(_this.getPrefixCls(), "-selected");
    };

    _this.getOpenClassName = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu-open");
    };

    _this.saveMenuInstance = function (c) {
      // children menu instance
      _this.menuInstance = c;
    };

    _this.addKeyPath = function (info) {
      return SubMenu__objectSpread({}, info, {
        keyPath: (info.keyPath || []).concat(_this.props.eventKey)
      });
    };

    _this.triggerOpenChange = function (open, type) {
      var key = _this.props.eventKey;

      var openChange = function openChange() {
        _this.onOpenChange({
          key: key,
          item: SubMenu__assertThisInitialized(_this),
          trigger: type,
          open: open
        });
      };

      if (type === 'mouseenter') {
        // make sure mouseenter happen after other menu item's mouseleave
        _this.mouseenterTimeout = setTimeout(function () {
          openChange();
        }, 0);
      } else {
        openChange();
      }
    };

    _this.isChildrenSelected = function () {
      var ret = {
        find: false
      };
      loopMenuItemRecursively(_this.props.children, _this.props.selectedKeys, ret);
      return ret.find;
    };

    _this.isOpen = function () {
      return _this.props.openKeys.indexOf(_this.props.eventKey) !== -1;
    };

    _this.adjustWidth = function () {
      /* istanbul ignore if */
      if (!_this.subMenuTitle || !_this.menuInstance) {
        return;
      }

      var popupMenu = preact_compat_es["findDOMNode"](_this.menuInstance);

      if (popupMenu.offsetWidth >= _this.subMenuTitle.offsetWidth) {
        return;
      }
      /* istanbul ignore next */

      popupMenu.style.minWidth = "".concat(_this.subMenuTitle.offsetWidth, "px");
    };

    _this.saveSubMenuTitle = function (subMenuTitle) {
      _this.subMenuTitle = subMenuTitle;
    };

    var store = props.store,
        eventKey = props.eventKey;

    var _store$getState = store.getState(),
        defaultActiveFirst = _store$getState.defaultActiveFirst;

    _this.isRootMenu = false;
    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    SubMenu_updateDefaultActiveFirst(store, eventKey, value);
    return _this;
  }

  SubMenu__createClass(SubMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var _this$props6 = this.props,
          mode = _this$props6.mode,
          parentMenu = _this$props6.parentMenu,
          manualRef = _this$props6.manualRef; // invoke customized ref to expose component to mixin

      if (manualRef) {
        manualRef(this);
      }

      if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
        return;
      }

      this.minWidthTimeout = setTimeout(function () {
        return _this2.adjustWidth();
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props7 = this.props,
          onDestroy = _this$props7.onDestroy,
          eventKey = _this$props7.eventKey;

      if (onDestroy) {
        onDestroy(eventKey);
      }
      /* istanbul ignore if */

      if (this.minWidthTimeout) {
        clearTimeout(this.minWidthTimeout);
      }
      /* istanbul ignore if */

      if (this.mouseenterTimeout) {
        clearTimeout(this.mouseenterTimeout);
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;

      var props = this.props;
      var baseProps = {
        mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
        visible: this.props.isOpen,
        level: props.level + 1,
        inlineIndent: props.inlineIndent,
        focusable: false,
        onClick: this.onSubMenuClick,
        onSelect: this.onSelect,
        onDeselect: this.onDeselect,
        onDestroy: this.onDestroy,
        selectedKeys: props.selectedKeys,
        eventKey: "".concat(props.eventKey, "-menu-"),
        openKeys: props.openKeys,
        motion: props.motion,
        onOpenChange: this.onOpenChange,
        subMenuOpenDelay: props.subMenuOpenDelay,
        parentMenu: this,
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        triggerSubMenuAction: props.triggerSubMenuAction,
        builtinPlacements: props.builtinPlacements,
        defaultActiveFirst: props.store.getState().defaultActiveFirst[getMenuIdFromSubMenuEventKey(props.eventKey)],
        multiple: props.multiple,
        prefixCls: props.rootPrefixCls,
        id: this.internalMenuId,
        manualRef: this.saveMenuInstance,
        itemIcon: props.itemIcon,
        expandIcon: props.expandIcon
      };
      var haveRendered = this.haveRendered;
      this.haveRendered = true;
      this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender; // never rendered not planning to, don't render

      if (!this.haveOpened) {
        return preact_compat_es["createElement"]("div", null);
      } // ================== Motion ==================
      // don't show transition on first rendering (no animation for opened menu)
      // show appear transition if it's not visible (not sure why)
      // show appear transition if it's not inline mode


      var mergedMotion = SubMenu__objectSpread({}, props.motion, {
        leavedClassName: "".concat(props.rootPrefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: haveRendered || !baseProps.visible || baseProps.mode !== 'inline'
      });

      return preact_compat_es["createElement"](es_CSSMotion, _extends({
        visible: baseProps.visible
      }, mergedMotion), function (_ref) {
        var className = _ref.className,
            style = _ref.style;
        var mergedClassName = classnames_default()("".concat(baseProps.prefixCls, "-sub"), className);
        return preact_compat_es["createElement"](es_SubPopupMenu, _extends({}, baseProps, {
          id: _this3.internalMenuId,
          className: mergedClassName,
          style: style
        }), children);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var props = SubMenu__objectSpread({}, this.props);

      var isOpen = props.isOpen;
      var prefixCls = this.getPrefixCls();
      var isInlineMode = props.mode === 'inline';
      var className = classnames_default()(prefixCls, "".concat(prefixCls, "-").concat(props.mode), (_classNames = {}, SubMenu__defineProperty(_classNames, props.className, !!props.className), SubMenu__defineProperty(_classNames, this.getOpenClassName(), isOpen), SubMenu__defineProperty(_classNames, this.getActiveClassName(), props.active || isOpen && !isInlineMode), SubMenu__defineProperty(_classNames, this.getDisabledClassName(), props.disabled), SubMenu__defineProperty(_classNames, this.getSelectedClassName(), this.isChildrenSelected()), _classNames));

      if (!this.internalMenuId) {
        if (props.eventKey) {
          this.internalMenuId = "".concat(props.eventKey, "$Menu");
        } else {
          guid += 1;
          this.internalMenuId = "$__$".concat(guid, "$Menu");
        }
      }

      var mouseEvents = {};
      var titleClickEvents = {};
      var titleMouseEvents = {};

      if (!props.disabled) {
        mouseEvents = {
          onMouseLeave: this.onMouseLeave,
          onMouseEnter: this.onMouseEnter
        }; // only works in title, not outer li

        titleClickEvents = {
          onClick: this.onTitleClick
        };
        titleMouseEvents = {
          onMouseEnter: this.onTitleMouseEnter,
          onMouseLeave: this.onTitleMouseLeave
        };
      }

      var style = {};

      if (isInlineMode) {
        style.paddingLeft = props.inlineIndent * props.level;
      }

      var ariaOwns = {}; // only set aria-owns when menu is open
      // otherwise it would be an invalid aria-owns value
      // since corresponding node cannot be found

      if (this.props.isOpen) {
        ariaOwns = {
          'aria-owns': this.internalMenuId
        };
      } // expand custom icon should NOT be displayed in menu with horizontal mode.


      var icon = null;

      if (props.mode !== 'horizontal') {
        icon = this.props.expandIcon; // ReactNode

        if (typeof this.props.expandIcon === 'function') {
          icon = preact_compat_es["createElement"](this.props.expandIcon, SubMenu__objectSpread({}, this.props));
        }
      }

      var title = preact_compat_es["createElement"]("div", _extends({
        ref: this.saveSubMenuTitle,
        style: style,
        className: "".concat(prefixCls, "-title")
      }, titleMouseEvents, titleClickEvents, {
        "aria-expanded": isOpen
      }, ariaOwns, {
        "aria-haspopup": "true",
        title: typeof props.title === 'string' ? props.title : undefined
      }), props.title, icon || preact_compat_es["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow")
      }));
      var children = this.renderChildren(props.children);
      var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
        return triggerNode.parentNode;
      };
      var popupPlacement = popupPlacementMap[props.mode];
      var popupAlign = props.popupOffset ? {
        offset: props.popupOffset
      } : {};
      var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
      var disabled = props.disabled,
          triggerSubMenuAction = props.triggerSubMenuAction,
          subMenuOpenDelay = props.subMenuOpenDelay,
          forceSubMenuRender = props.forceSubMenuRender,
          subMenuCloseDelay = props.subMenuCloseDelay,
          builtinPlacements = props.builtinPlacements;
      menuAllProps.forEach(function (key) {
        return delete props[key];
      }); // Set onClick to null, to ignore propagated onClick event

      delete props.onClick;
      return preact_compat_es["createElement"]("li", _extends({}, props, mouseEvents, {
        className: className,
        role: "menuitem"
      }), isInlineMode && title, isInlineMode && children, !isInlineMode && preact_compat_es["createElement"](rc_trigger_es, {
        prefixCls: prefixCls,
        popupClassName: "".concat(prefixCls, "-popup ").concat(popupClassName),
        getPopupContainer: getPopupContainer,
        builtinPlacements: _extends({}, es_placements, builtinPlacements),
        popupPlacement: popupPlacement,
        popupVisible: isOpen,
        popupAlign: popupAlign,
        popup: children,
        action: disabled ? [] : [triggerSubMenuAction],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: this.onPopupVisibleChange,
        forceRender: forceSubMenuRender
      }, title));
    }
  }]);

  return SubMenu;
}(preact_compat_es["Component"]);
SubMenu_SubMenu.defaultProps = {
  onMouseEnter: noop,
  onMouseLeave: noop,
  onTitleMouseEnter: noop,
  onTitleMouseLeave: noop,
  onTitleClick: noop,
  manualRef: noop,
  mode: 'vertical',
  title: ''
};
var connected = Object(lib["connect"])(function (_ref2, _ref3) {
  var openKeys = _ref2.openKeys,
      activeKey = _ref2.activeKey,
      selectedKeys = _ref2.selectedKeys;
  var eventKey = _ref3.eventKey,
      subMenuKey = _ref3.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu_SubMenu);
connected.isSubMenu = true;
/* harmony default export */ var es_SubMenu = (connected);
// CONCATENATED MODULE: ../node_modules/rc-menu/es/DOMWrap.js
var DOMWrap__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function DOMWrap__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    DOMWrap__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    DOMWrap__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return DOMWrap__typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  }
}

function DOMWrap_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function DOMWrap__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      DOMWrap_ownKeys(Object(source), true).forEach(function (key) {
        DOMWrap__defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      DOMWrap_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function DOMWrap__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function DOMWrap__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function DOMWrap__defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function DOMWrap__createClass(Constructor, protoProps, staticProps) {
  if (protoProps) DOMWrap__defineProperties(Constructor.prototype, protoProps);if (staticProps) DOMWrap__defineProperties(Constructor, staticProps);return Constructor;
}

function DOMWrap__possibleConstructorReturn(self, call) {
  if (call && (DOMWrap__typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return DOMWrap__assertThisInitialized(self);
}

function DOMWrap__getPrototypeOf(o) {
  DOMWrap__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return DOMWrap__getPrototypeOf(o);
}

function DOMWrap__assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function DOMWrap__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) DOMWrap__setPrototypeOf(subClass, superClass);
}

function DOMWrap__setPrototypeOf(o, p) {
  DOMWrap__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return DOMWrap__setPrototypeOf(o, p);
}






var DOMWrap_canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var MENUITEM_OVERFLOWED_CLASSNAME = 'menuitem-overflowed';
var FLOAT_PRECISION_ADJUST = 0.5; // Fix ssr

if (DOMWrap_canUseDOM) {
  // eslint-disable-next-line global-require
  __webpack_require__("cMrJ");
}

var DOMWrap_DOMWrap =
/*#__PURE__*/
function (_React$Component) {
  DOMWrap__inherits(DOMWrap, _React$Component);

  function DOMWrap() {
    var _this;

    DOMWrap__classCallCheck(this, DOMWrap);

    _this = DOMWrap__possibleConstructorReturn(this, DOMWrap__getPrototypeOf(DOMWrap).apply(this, arguments));
    _this.resizeObserver = null;
    _this.mutationObserver = null; // original scroll size of the list

    _this.originalTotalWidth = 0; // copy of overflowed items

    _this.overflowedItems = []; // cache item of the original items (so we can track the size and order)

    _this.menuItemSizes = [];
    _this.state = {
      lastVisibleIndex: undefined
    }; // get all valid menuItem nodes

    _this.getMenuItemNodes = function () {
      var prefixCls = _this.props.prefixCls;
      var ul = preact_compat_es["findDOMNode"](DOMWrap__assertThisInitialized(_this));

      if (!ul) {
        return [];
      } // filter out all overflowed indicator placeholder


      return [].slice.call(ul.children).filter(function (node) {
        return node.className.split(' ').indexOf("".concat(prefixCls, "-overflowed-submenu")) < 0;
      });
    };

    _this.getOverflowedSubMenuItem = function (keyPrefix, overflowedItems, renderPlaceholder) {
      var _this$props = _this.props,
          overflowedIndicator = _this$props.overflowedIndicator,
          level = _this$props.level,
          mode = _this$props.mode,
          prefixCls = _this$props.prefixCls,
          theme = _this$props.theme;

      if (level !== 1 || mode !== 'horizontal') {
        return null;
      } // put all the overflowed item inside a submenu
      // with a title of overflow indicator ('...')


      var copy = _this.props.children[0];

      var _copy$props = copy.props,
          throwAway = _copy$props.children,
          title = _copy$props.title,
          propStyle = _copy$props.style,
          rest = _objectWithoutProperties(_copy$props, ["children", "title", "style"]);

      var style = DOMWrap__objectSpread({}, propStyle);

      var key = "".concat(keyPrefix, "-overflowed-indicator");
      var eventKey = "".concat(keyPrefix, "-overflowed-indicator");

      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
        style = DOMWrap__objectSpread({}, style, {
          display: 'none'
        });
      } else if (renderPlaceholder) {
        style = DOMWrap__objectSpread({}, style, {
          visibility: 'hidden',
          // prevent from taking normal dom space
          position: 'absolute'
        });
        key = "".concat(key, "-placeholder");
        eventKey = "".concat(eventKey, "-placeholder");
      }

      var popupClassName = theme ? "".concat(prefixCls, "-").concat(theme) : '';
      var props = {};
      menuAllProps.forEach(function (k) {
        if (rest[k] !== undefined) {
          props[k] = rest[k];
        }
      });
      return preact_compat_es["createElement"](es_SubMenu, DOMWrap__extends({
        title: overflowedIndicator,
        className: "".concat(prefixCls, "-overflowed-submenu"),
        popupClassName: popupClassName
      }, props, {
        key: key,
        eventKey: eventKey,
        disabled: false,
        style: style
      }), overflowedItems);
    }; // memorize rendered menuSize


    _this.setChildrenWidthAndResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = preact_compat_es["findDOMNode"](DOMWrap__assertThisInitialized(_this));

      if (!ul) {
        return;
      }

      var ulChildrenNodes = ul.children;

      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
        return;
      }

      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1]; // need last overflowed indicator for calculating length;

      setStyle(lastOverflowedIndicatorPlaceholder, 'display', 'inline-block');

      var menuItemNodes = _this.getMenuItemNodes(); // reset display attribute for all hidden elements caused by overflow to calculate updated width
      // and then reset to original state after width calculation


      var overflowedItems = menuItemNodes.filter(function (c) {
        return c.className.split(' ').indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
      });
      overflowedItems.forEach(function (c) {
        setStyle(c, 'display', 'inline-block');
      });
      _this.menuItemSizes = menuItemNodes.map(function (c) {
        return getWidth(c);
      });
      overflowedItems.forEach(function (c) {
        setStyle(c, 'display', 'none');
      });
      _this.overflowedIndicatorWidth = getWidth(ul.children[ul.children.length - 1]);
      _this.originalTotalWidth = _this.menuItemSizes.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);

      _this.handleResize(); // prevent the overflowed indicator from taking space;


      setStyle(lastOverflowedIndicatorPlaceholder, 'display', 'none');
    };

    _this.handleResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = preact_compat_es["findDOMNode"](DOMWrap__assertThisInitialized(_this));

      if (!ul) {
        return;
      }

      var width = getWidth(ul);
      _this.overflowedItems = [];
      var currentSumWidth = 0; // index for last visible child in horizontal mode

      var lastVisibleIndex; // float number comparison could be problematic
      // e.g. 0.1 + 0.2 > 0.3 =====> true
      // thus using FLOAT_PRECISION_ADJUST as buffer to help the situation

      if (_this.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
        lastVisibleIndex = -1;

        _this.menuItemSizes.forEach(function (liWidth) {
          currentSumWidth += liWidth;

          if (currentSumWidth + _this.overflowedIndicatorWidth <= width) {
            lastVisibleIndex += 1;
          }
        });
      }

      _this.setState({
        lastVisibleIndex: lastVisibleIndex
      });
    };

    return _this;
  }

  DOMWrap__createClass(DOMWrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setChildrenWidthAndResize();

      if (this.props.level === 1 && this.props.mode === 'horizontal') {
        var menuUl = preact_compat_es["findDOMNode"](this);

        if (!menuUl) {
          return;
        }

        this.resizeObserver = new ResizeObserver_es["a" /* default */](function (entries) {
          entries.forEach(_this2.setChildrenWidthAndResize);
        });
        [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
          _this2.resizeObserver.observe(el);
        });

        if (typeof MutationObserver !== 'undefined') {
          this.mutationObserver = new MutationObserver(function () {
            _this2.resizeObserver.disconnect();

            [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
              _this2.resizeObserver.observe(el);
            });

            _this2.setChildrenWidthAndResize();
          });
          this.mutationObserver.observe(menuUl, {
            attributes: false,
            childList: true,
            subTree: false
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;

      // need to take care of overflowed items in horizontal mode
      var lastVisibleIndex = this.state.lastVisibleIndex;
      return (children || []).reduce(function (acc, childNode, index) {
        var item = childNode;

        if (_this3.props.mode === 'horizontal') {
          var overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, []);

          if (lastVisibleIndex !== undefined && _this3.props.className.indexOf("".concat(_this3.props.prefixCls, "-root")) !== -1) {
            if (index > lastVisibleIndex) {
              item = preact_compat_es["cloneElement"](childNode, // 这里修改 eventKey 是为了防止隐藏状态下还会触发 openkeys 事件
              {
                style: {
                  display: 'none'
                },
                eventKey: "".concat(childNode.props.eventKey, "-hidden"),

                /**
                 * Legacy code. Here `className` never used:
                 * https://github.com/react-component/menu/commit/4cd6b49fce9d116726f4ea00dda85325d6f26500#diff-e2fa48f75c2dd2318295cde428556a76R240
                 */
                className: "".concat(MENUITEM_OVERFLOWED_CLASSNAME)
              });
            }

            if (index === lastVisibleIndex + 1) {
              _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function (c) {
                return preact_compat_es["cloneElement"](c, // children[index].key will become '.$key' in clone by default,
                // we have to overwrite with the correct key explicitly
                {
                  key: c.props.eventKey,
                  mode: 'vertical-left'
                });
              });
              overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, _this3.overflowedItems);
            }
          }

          var ret = [].concat(_toConsumableArray(acc), [overflowed, item]);

          if (index === children.length - 1) {
            // need a placeholder for calculating overflowed indicator width
            ret.push(_this3.getOverflowedSubMenuItem(childNode.props.eventKey, [], true));
          }

          return ret;
        }

        return [].concat(_toConsumableArray(acc), [item]);
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          prefixCls = _this$props2.prefixCls,
          overflowedIndicator = _this$props2.overflowedIndicator,
          mode = _this$props2.mode,
          level = _this$props2.level,
          tag = _this$props2.tag,
          children = _this$props2.children,
          theme = _this$props2.theme,
          rest = _objectWithoutProperties(_this$props2, ["visible", "prefixCls", "overflowedIndicator", "mode", "level", "tag", "children", "theme"]);

      var Tag = tag;
      return preact_compat_es["createElement"](Tag, DOMWrap__extends({}, rest), this.renderChildren(children));
    }
  }]);

  return DOMWrap;
}(preact_compat_es["Component"]);

DOMWrap_DOMWrap.defaultProps = {
  tag: 'div',
  className: ''
};
/* harmony default export */ var es_DOMWrap = (DOMWrap_DOMWrap);
// CONCATENATED MODULE: ../node_modules/rc-menu/es/SubPopupMenu.js
var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function SubPopupMenu__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    SubPopupMenu__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    SubPopupMenu__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return SubPopupMenu__typeof(obj);
}

function SubPopupMenu__extends() {
  SubPopupMenu__extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return SubPopupMenu__extends.apply(this, arguments);
}

function SubPopupMenu__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function SubPopupMenu__defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function SubPopupMenu__createClass(Constructor, protoProps, staticProps) {
  if (protoProps) SubPopupMenu__defineProperties(Constructor.prototype, protoProps);if (staticProps) SubPopupMenu__defineProperties(Constructor, staticProps);return Constructor;
}

function SubPopupMenu__possibleConstructorReturn(self, call) {
  if (call && (SubPopupMenu__typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return SubPopupMenu__assertThisInitialized(self);
}

function SubPopupMenu__getPrototypeOf(o) {
  SubPopupMenu__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return SubPopupMenu__getPrototypeOf(o);
}

function SubPopupMenu__assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function SubPopupMenu__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) SubPopupMenu__setPrototypeOf(subClass, superClass);
}

function SubPopupMenu__setPrototypeOf(o, p) {
  SubPopupMenu__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return SubPopupMenu__setPrototypeOf(o, p);
}

function SubPopupMenu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function SubPopupMenu__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      SubPopupMenu_ownKeys(Object(source), true).forEach(function (key) {
        SubPopupMenu__defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      SubPopupMenu_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function SubPopupMenu__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}










function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }

  return arr.every(function (c) {
    return !!c.props.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var state = store.getState();
  store.setState({
    activeKey: SubPopupMenu__objectSpread({}, state.activeKey, SubPopupMenu__defineProperty({}, menuId, activeKey))
  });
}

function getEventKey(props) {
  // when eventKey not available ,it's menu and return menu id '0-menu-'
  return props.eventKey || '0-menu-';
}

function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children,
      eventKey = props.eventKey;

  if (activeKey) {
    var found;
    loopMenuItem(children, function (c, i) {
      if (c && c.props && !c.props.disabled && activeKey === getKeyFromChildrenIndex(c, eventKey, i)) {
        found = true;
      }
    });

    if (found) {
      return activeKey;
    }
  }

  activeKey = null;

  if (props.defaultActiveFirst) {
    loopMenuItem(children, function (c, i) {
      if (!activeKey && c && !c.props.disabled) {
        activeKey = getKeyFromChildrenIndex(c, eventKey, i);
      }
    });
    return activeKey;
  }

  return activeKey;
}
function SubPopupMenu_saveRef(c) {
  if (c) {
    var index = this.instanceArray.indexOf(c);

    if (index !== -1) {
      // update component if it's already inside instanceArray
      this.instanceArray[index] = c;
    } else {
      // add component if it's not in instanceArray yet;
      this.instanceArray.push(c);
    }
  }
}
var SubPopupMenu_SubPopupMenu =
/*#__PURE__*/
function (_React$Component) {
  SubPopupMenu__inherits(SubPopupMenu, _React$Component);

  function SubPopupMenu(props) {
    var _this;

    SubPopupMenu__classCallCheck(this, SubPopupMenu);

    _this = SubPopupMenu__possibleConstructorReturn(this, SubPopupMenu__getPrototypeOf(SubPopupMenu).call(this, props));
    /**
     * all keyboard events callbacks run from here at first
     *
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */

    _this.onKeyDown = function (e, callback) {
      var keyCode = e.keyCode;
      var handled;

      _this.getFlatInstanceArray().forEach(function (obj) {
        if (obj && obj.props.active && obj.onKeyDown) {
          handled = obj.onKeyDown(e);
        }
      });

      if (handled) {
        return 1;
      }

      var activeItem = null;

      if (keyCode === es_KeyCode.UP || keyCode === es_KeyCode.DOWN) {
        activeItem = _this.step(keyCode === es_KeyCode.UP ? -1 : 1);
      }

      if (activeItem) {
        e.preventDefault();
        updateActiveKey(_this.props.store, getEventKey(_this.props), activeItem.props.eventKey);

        if (typeof callback === 'function') {
          callback(activeItem);
        }

        return 1;
      }

      return undefined;
    };

    _this.onItemHover = function (e) {
      var key = e.key,
          hover = e.hover;
      updateActiveKey(_this.props.store, getEventKey(_this.props), hover ? key : null);
    };

    _this.onDeselect = function (selectInfo) {
      _this.props.onDeselect(selectInfo);
    };

    _this.onSelect = function (selectInfo) {
      _this.props.onSelect(selectInfo);
    };

    _this.onClick = function (e) {
      _this.props.onClick(e);
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onDestroy = function (key) {
      /* istanbul ignore next */
      _this.props.onDestroy(key);
    };

    _this.getFlatInstanceArray = function () {
      return _this.instanceArray;
    };

    _this.step = function (direction) {
      var children = _this.getFlatInstanceArray();

      var activeKey = _this.props.store.getState().activeKey[getEventKey(_this.props)];

      var len = children.length;

      if (!len) {
        return null;
      }

      if (direction < 0) {
        children = children.concat().reverse();
      } // find current activeIndex


      var activeIndex = -1;
      children.every(function (c, ci) {
        if (c && c.props.eventKey === activeKey) {
          activeIndex = ci;
          return false;
        }

        return true;
      });

      if (!_this.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
        return undefined;
      }

      var start = (activeIndex + 1) % len;
      var i = start;

      do {
        var child = children[i];

        if (!child || child.props.disabled) {
          i = (i + 1) % len;
        } else {
          return child;
        }
      } while (i !== start);

      return null;
    };

    _this.renderCommonMenuItem = function (child, i, extraProps) {
      var state = _this.props.store.getState();

      var _assertThisInitialize = SubPopupMenu__assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var key = getKeyFromChildrenIndex(child, props.eventKey, i);
      var childProps = child.props; // https://github.com/ant-design/ant-design/issues/11517#issuecomment-477403055

      if (!childProps || typeof child.type === 'string') {
        return child;
      }

      var isActive = key === state.activeKey;

      var newChildProps = SubPopupMenu__objectSpread({
        mode: childProps.mode || props.mode,
        level: props.level,
        inlineIndent: props.inlineIndent,
        renderMenuItem: _this.renderMenuItem,
        rootPrefixCls: props.prefixCls,
        index: i,
        parentMenu: props.parentMenu,
        // customized ref function, need to be invoked manually in child's componentDidMount
        manualRef: childProps.disabled ? undefined : createChainedFunction(child.ref, SubPopupMenu_saveRef.bind(SubPopupMenu__assertThisInitialized(_this))),
        eventKey: key,
        active: !childProps.disabled && isActive,
        multiple: props.multiple,
        onClick: function onClick(e) {
          (childProps.onClick || noop)(e);

          _this.onClick(e);
        },
        onItemHover: _this.onItemHover,
        motion: props.motion,
        subMenuOpenDelay: props.subMenuOpenDelay,
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        onOpenChange: _this.onOpenChange,
        onDeselect: _this.onDeselect,
        onSelect: _this.onSelect,
        builtinPlacements: props.builtinPlacements,
        itemIcon: childProps.itemIcon || _this.props.itemIcon,
        expandIcon: childProps.expandIcon || _this.props.expandIcon
      }, extraProps); // ref: https://github.com/ant-design/ant-design/issues/13943


      if (props.mode === 'inline' || util_isMobileDevice()) {
        newChildProps.triggerSubMenuAction = 'click';
      }

      return preact_compat_es["cloneElement"](child, newChildProps);
    };

    _this.renderMenuItem = function (c, i, subMenuKey) {
      /* istanbul ignore if */
      if (!c) {
        return null;
      }

      var state = _this.props.store.getState();

      var extraProps = {
        openKeys: state.openKeys,
        selectedKeys: state.selectedKeys,
        triggerSubMenuAction: _this.props.triggerSubMenuAction,
        subMenuKey: subMenuKey
      };
      return _this.renderCommonMenuItem(c, i, extraProps);
    };

    props.store.setState({
      activeKey: SubPopupMenu__objectSpread({}, props.store.getState().activeKey, SubPopupMenu__defineProperty({}, props.eventKey, getActiveKey(props, props.activeKey)))
    });
    _this.instanceArray = [];
    return _this;
  }

  SubPopupMenu__createClass(SubPopupMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible || this.props.className !== nextProps.className || !shallowequal_default()(this.props.style, nextProps.style);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
      var activeKey = getActiveKey(props, originalActiveKey);

      if (activeKey !== originalActiveKey) {
        updateActiveKey(props.store, getEventKey(props), activeKey);
      } else if ('activeKey' in prevProps) {
        // If prev activeKey is not same as current activeKey,
        // we should set it.
        var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);

        if (activeKey !== prevActiveKey) {
          updateActiveKey(props.store, getEventKey(props), activeKey);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = SubPopupMenu__extends({}, this.props);

      this.instanceArray = [];
      var className = classnames_default()(props.prefixCls, props.className, "".concat(props.prefixCls, "-").concat(props.mode));
      var domProps = {
        className: className,
        // role could be 'select' and by default set to menu
        role: props.role || 'menu'
      };

      if (props.id) {
        domProps.id = props.id;
      }

      if (props.focusable) {
        domProps.tabIndex = 0;
        domProps.onKeyDown = this.onKeyDown;
      }

      var prefixCls = props.prefixCls,
          eventKey = props.eventKey,
          visible = props.visible,
          level = props.level,
          mode = props.mode,
          overflowedIndicator = props.overflowedIndicator,
          theme = props.theme;
      menuAllProps.forEach(function (key) {
        return delete props[key];
      }); // Otherwise, the propagated click event will trigger another onClick

      delete props.onClick;
      return preact_compat_es["createElement"](es_DOMWrap, _extends2({}, props, {
        prefixCls: prefixCls,
        mode: mode,
        tag: "ul",
        level: level,
        theme: theme,
        visible: visible,
        overflowedIndicator: overflowedIndicator
      }, domProps), preact_compat_es["Children"].map(props.children, function (c, i) {
        return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
      }));
    }
  }]);

  return SubPopupMenu;
}(preact_compat_es["Component"]);
SubPopupMenu_SubPopupMenu.defaultProps = {
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: noop
};
var SubPopupMenu_connected = Object(lib["connect"])()(SubPopupMenu_SubPopupMenu);
/* harmony default export */ var es_SubPopupMenu = (SubPopupMenu_connected);
// CONCATENATED MODULE: ../node_modules/rc-util/es/warning.js
/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (false) {
    console.error("Warning: ".concat(message));
  }
}
function note(valid, message) {
  // Support uglify
  if (false) {
    console.warn("Note: ".concat(message));
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
/* harmony default export */ var es_warning = (warningOnce);
/* eslint-enable */
// CONCATENATED MODULE: ../node_modules/rc-menu/es/utils/legacyUtil.js
function legacyUtil__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    legacyUtil__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    legacyUtil__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return legacyUtil__typeof(obj);
}


function getMotion(_ref) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      openAnimation = _ref.openAnimation,
      openTransitionName = _ref.openTransitionName;

  if (motion) {
    return motion;
  }

  if (legacyUtil__typeof(openAnimation) === 'object' && openAnimation) {
    es_warning(false, 'Object type of `openAnimation` is removed. Please use `motion` instead.');
  } else if (typeof openAnimation === 'string') {
    return {
      motionName: "".concat(prefixCls, "-open-").concat(openAnimation)
    };
  }

  if (openTransitionName) {
    return {
      motionName: openTransitionName
    };
  }

  return null;
}
// CONCATENATED MODULE: ../node_modules/rc-menu/es/Menu.js
var Menu__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Menu__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    Menu__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    Menu__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return Menu__typeof(obj);
}

function Menu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function Menu__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      Menu_ownKeys(Object(source), true).forEach(function (key) {
        Menu__defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      Menu_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function Menu__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function Menu__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Menu__defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function Menu__createClass(Constructor, protoProps, staticProps) {
  if (protoProps) Menu__defineProperties(Constructor.prototype, protoProps);if (staticProps) Menu__defineProperties(Constructor, staticProps);return Constructor;
}

function Menu__possibleConstructorReturn(self, call) {
  if (call && (Menu__typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return Menu__assertThisInitialized(self);
}

function Menu__getPrototypeOf(o) {
  Menu__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return Menu__getPrototypeOf(o);
}

function Menu__assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function Menu__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) Menu__setPrototypeOf(subClass, superClass);
}

function Menu__setPrototypeOf(o, p) {
  Menu__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return Menu__setPrototypeOf(o, p);
}







var Menu_Menu =
/*#__PURE__*/
function (_React$Component) {
  Menu__inherits(Menu, _React$Component);

  function Menu(props) {
    var _this;

    Menu__classCallCheck(this, Menu);

    _this = Menu__possibleConstructorReturn(this, Menu__getPrototypeOf(Menu).call(this, props));

    _this.onSelect = function (selectInfo) {
      var _assertThisInitialize = Menu__assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      if (props.selectable) {
        // root menu
        var _this$store$getState = _this.store.getState(),
            _selectedKeys = _this$store$getState.selectedKeys;

        var selectedKey = selectInfo.key;

        if (props.multiple) {
          _selectedKeys = _selectedKeys.concat([selectedKey]);
        } else {
          _selectedKeys = [selectedKey];
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys
          });
        }

        props.onSelect(Menu__objectSpread({}, selectInfo, {
          selectedKeys: _selectedKeys
        }));
      }
    };

    _this.onClick = function (e) {
      _this.props.onClick(e);
    }; // onKeyDown needs to be exposed as a instance method
    // e.g., in rc-select, we need to navigate menu item while
    // current active item is rc-select input box rather than the menu itself


    _this.onKeyDown = function (e, callback) {
      _this.innerMenu.getWrappedInstance().onKeyDown(e, callback);
    };

    _this.onOpenChange = function (event) {
      var _assertThisInitialize2 = Menu__assertThisInitialized(_this),
          props = _assertThisInitialize2.props;

      var openKeys = _this.store.getState().openKeys.concat();

      var changed = false;

      var processSingle = function processSingle(e) {
        var oneChanged = false;

        if (e.open) {
          oneChanged = openKeys.indexOf(e.key) === -1;

          if (oneChanged) {
            openKeys.push(e.key);
          }
        } else {
          var index = openKeys.indexOf(e.key);
          oneChanged = index !== -1;

          if (oneChanged) {
            openKeys.splice(index, 1);
          }
        }

        changed = changed || oneChanged;
      };

      if (Array.isArray(event)) {
        // batch change call
        event.forEach(processSingle);
      } else {
        processSingle(event);
      }

      if (changed) {
        if (!('openKeys' in _this.props)) {
          _this.store.setState({
            openKeys: openKeys
          });
        }

        props.onOpenChange(openKeys);
      }
    };

    _this.onDeselect = function (selectInfo) {
      var _assertThisInitialize3 = Menu__assertThisInitialized(_this),
          props = _assertThisInitialize3.props;

      if (props.selectable) {
        var _selectedKeys2 = _this.store.getState().selectedKeys.concat();

        var selectedKey = selectInfo.key;

        var index = _selectedKeys2.indexOf(selectedKey);

        if (index !== -1) {
          _selectedKeys2.splice(index, 1);
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys2
          });
        }

        props.onDeselect(Menu__objectSpread({}, selectInfo, {
          selectedKeys: _selectedKeys2
        }));
      }
    };

    _this.getOpenTransitionName = function () {
      var _assertThisInitialize4 = Menu__assertThisInitialized(_this),
          props = _assertThisInitialize4.props;

      var transitionName = props.openTransitionName;
      var animationName = props.openAnimation;

      if (!transitionName && typeof animationName === 'string') {
        transitionName = "".concat(props.prefixCls, "-open-").concat(animationName);
      }

      return transitionName;
    };

    _this.setInnerMenu = function (node) {
      _this.innerMenu = node;
    };

    _this.isRootMenu = true;
    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;

    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }

    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    _this.store = Object(lib["create"])({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: {
        '0-menu-': getActiveKey(props, props.activeKey)
      }
    });
    return _this;
  }

  Menu__createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMiniStore();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateMiniStore();
    }
  }, {
    key: "updateMiniStore",
    value: function updateMiniStore() {
      if ('selectedKeys' in this.props) {
        this.store.setState({
          selectedKeys: this.props.selectedKeys || []
        });
      }

      if ('openKeys' in this.props) {
        this.store.setState({
          openKeys: this.props.openKeys || []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = Menu__objectSpread({}, this.props);

      props.className += " ".concat(props.prefixCls, "-root");
      props = Menu__objectSpread({}, props, {
        onClick: this.onClick,
        onOpenChange: this.onOpenChange,
        onDeselect: this.onDeselect,
        onSelect: this.onSelect,
        parentMenu: this,
        motion: getMotion(this.props)
      });
      delete props.openAnimation;
      delete props.openTransitionName;
      return preact_compat_es["createElement"](lib["Provider"], {
        store: this.store
      }, preact_compat_es["createElement"](es_SubPopupMenu, Menu__extends({}, props, {
        ref: this.setInnerMenu
      }), this.props.children));
    }
  }]);

  return Menu;
}(preact_compat_es["Component"]);

Menu_Menu.defaultProps = {
  selectable: true,
  onClick: noop,
  onSelect: noop,
  onOpenChange: noop,
  onDeselect: noop,
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: 'hover',
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  style: {},
  builtinPlacements: {},
  overflowedIndicator: preact_compat_es["createElement"]("span", null, "\xB7\xB7\xB7")
};
/* harmony default export */ var es_Menu = (Menu_Menu);
// EXTERNAL MODULE: ../node_modules/dom-scroll-into-view/lib/index.js
var dom_scroll_into_view_lib = __webpack_require__("3Dq6");
var dom_scroll_into_view_lib_default = /*#__PURE__*/__webpack_require__.n(dom_scroll_into_view_lib);

// CONCATENATED MODULE: ../node_modules/rc-menu/es/MenuItem.js
var MenuItem__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function MenuItem__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    MenuItem__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    MenuItem__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return MenuItem__typeof(obj);
}

function MenuItem_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function MenuItem__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      MenuItem_ownKeys(Object(source), true).forEach(function (key) {
        MenuItem__defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      MenuItem_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function MenuItem__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function MenuItem__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function MenuItem__defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function MenuItem__createClass(Constructor, protoProps, staticProps) {
  if (protoProps) MenuItem__defineProperties(Constructor.prototype, protoProps);if (staticProps) MenuItem__defineProperties(Constructor, staticProps);return Constructor;
}

function MenuItem__possibleConstructorReturn(self, call) {
  if (call && (MenuItem__typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return MenuItem__assertThisInitialized(self);
}

function MenuItem__getPrototypeOf(o) {
  MenuItem__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return MenuItem__getPrototypeOf(o);
}

function MenuItem__assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function MenuItem__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) MenuItem__setPrototypeOf(subClass, superClass);
}

function MenuItem__setPrototypeOf(o, p) {
  MenuItem__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return MenuItem__setPrototypeOf(o, p);
}








var MenuItem_MenuItem =
/*#__PURE__*/
function (_React$Component) {
  MenuItem__inherits(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    MenuItem__classCallCheck(this, MenuItem);

    _this = MenuItem__possibleConstructorReturn(this, MenuItem__getPrototypeOf(MenuItem).apply(this, arguments));

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;

      if (keyCode === es_KeyCode.ENTER) {
        _this.onClick(e);

        return true;
      }

      return undefined;
    };

    _this.onMouseLeave = function (e) {
      var _this$props = _this.props,
          eventKey = _this$props.eventKey,
          onItemHover = _this$props.onItemHover,
          onMouseLeave = _this$props.onMouseLeave;
      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          eventKey = _this$props2.eventKey,
          onItemHover = _this$props2.onItemHover,
          onMouseEnter = _this$props2.onMouseEnter;
      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onClick = function (e) {
      var _this$props3 = _this.props,
          eventKey = _this$props3.eventKey,
          multiple = _this$props3.multiple,
          onClick = _this$props3.onClick,
          onSelect = _this$props3.onSelect,
          onDeselect = _this$props3.onDeselect,
          isSelected = _this$props3.isSelected;
      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: MenuItem__assertThisInitialized(_this),
        domEvent: e
      };
      onClick(info);

      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };

    _this.saveNode = function (node) {
      _this.node = node;
    };

    return _this;
  }

  MenuItem__createClass(MenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      this.callRef();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          active = _this$props4.active,
          parentMenu = _this$props4.parentMenu,
          eventKey = _this$props4.eventKey; // 在 parentMenu 上层保存滚动状态，避免重复的 MenuItem key 导致滚动跳动
      // https://github.com/ant-design/ant-design/issues/16181

      if (!prevProps.active && active && (!parentMenu || !parentMenu["scrolled-".concat(eventKey)])) {
        if (this.node) {
          dom_scroll_into_view_lib_default()(this.node, preact_compat_es["findDOMNode"](parentMenu), {
            onlyScrollIfNeeded: true
          });
          parentMenu["scrolled-".concat(eventKey)] = true;
        }
      } else if (parentMenu && parentMenu["scrolled-".concat(eventKey)]) {
        delete parentMenu["scrolled-".concat(eventKey)];
      }

      this.callRef();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var props = this.props;

      if (props.onDestroy) {
        props.onDestroy(props.eventKey);
      }
    }
  }, {
    key: "getPrefixCls",
    value: function getPrefixCls() {
      return "".concat(this.props.rootPrefixCls, "-item");
    }
  }, {
    key: "getActiveClassName",
    value: function getActiveClassName() {
      return "".concat(this.getPrefixCls(), "-active");
    }
  }, {
    key: "getSelectedClassName",
    value: function getSelectedClassName() {
      return "".concat(this.getPrefixCls(), "-selected");
    }
  }, {
    key: "getDisabledClassName",
    value: function getDisabledClassName() {
      return "".concat(this.getPrefixCls(), "-disabled");
    }
  }, {
    key: "callRef",
    value: function callRef() {
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var props = MenuItem__objectSpread({}, this.props);

      var className = classnames_default()(this.getPrefixCls(), props.className, (_classNames = {}, MenuItem__defineProperty(_classNames, this.getActiveClassName(), !props.disabled && props.active), MenuItem__defineProperty(_classNames, this.getSelectedClassName(), props.isSelected), MenuItem__defineProperty(_classNames, this.getDisabledClassName(), props.disabled), _classNames));

      var attrs = MenuItem__objectSpread({}, props.attribute, {
        title: props.title,
        className: className,
        // set to menuitem by default
        role: props.role || 'menuitem',
        'aria-disabled': props.disabled
      });

      if (props.role === 'option') {
        // overwrite to option
        attrs = MenuItem__objectSpread({}, attrs, {
          role: 'option',
          'aria-selected': props.isSelected
        });
      } else if (props.role === null || props.role === 'none') {
        // sometimes we want to specify role inside <li/> element
        // <li><a role='menuitem'>Link</a></li> would be a good example
        // in this case the role on <li/> should be "none" to
        // remove the implied listitem role.
        // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
        attrs.role = 'none';
      } // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner


      var mouseEvent = {
        onClick: props.disabled ? null : this.onClick,
        onMouseLeave: props.disabled ? null : this.onMouseLeave,
        onMouseEnter: props.disabled ? null : this.onMouseEnter
      };

      var style = MenuItem__objectSpread({}, props.style);

      if (props.mode === 'inline') {
        style.paddingLeft = props.inlineIndent * props.level;
      }

      menuAllProps.forEach(function (key) {
        return delete props[key];
      });
      var icon = this.props.itemIcon;

      if (typeof this.props.itemIcon === 'function') {
        // TODO: This is a bug which should fixed after TS refactor
        icon = preact_compat_es["createElement"](this.props.itemIcon, this.props);
      }

      return preact_compat_es["createElement"]("li", MenuItem__extends({}, props, attrs, mouseEvent, {
        style: style,
        ref: this.saveNode
      }), props.children, icon);
    }
  }]);

  return MenuItem;
}(preact_compat_es["Component"]);
MenuItem_MenuItem.isMenuItem = true;
MenuItem_MenuItem.defaultProps = {
  onSelect: noop,
  onMouseEnter: noop,
  onMouseLeave: noop,
  manualRef: noop
};
var MenuItem_connected = Object(lib["connect"])(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: selectedKeys.indexOf(eventKey) !== -1
  };
})(MenuItem_MenuItem);
/* harmony default export */ var es_MenuItem = (MenuItem_connected);
// CONCATENATED MODULE: ../node_modules/rc-menu/es/MenuItemGroup.js
var MenuItemGroup__extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function MenuItemGroup__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    MenuItemGroup__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    MenuItemGroup__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return MenuItemGroup__typeof(obj);
}

function MenuItemGroup__extends() {
  MenuItemGroup__extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return MenuItemGroup__extends.apply(this, arguments);
}

function MenuItemGroup__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function MenuItemGroup__defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function MenuItemGroup__createClass(Constructor, protoProps, staticProps) {
  if (protoProps) MenuItemGroup__defineProperties(Constructor.prototype, protoProps);if (staticProps) MenuItemGroup__defineProperties(Constructor, staticProps);return Constructor;
}

function MenuItemGroup__possibleConstructorReturn(self, call) {
  if (call && (MenuItemGroup__typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return MenuItemGroup__assertThisInitialized(self);
}

function MenuItemGroup__assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function MenuItemGroup__getPrototypeOf(o) {
  MenuItemGroup__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return MenuItemGroup__getPrototypeOf(o);
}

function MenuItemGroup__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) MenuItemGroup__setPrototypeOf(subClass, superClass);
}

function MenuItemGroup__setPrototypeOf(o, p) {
  MenuItemGroup__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return MenuItemGroup__setPrototypeOf(o, p);
}




var MenuItemGroup_MenuItemGroup =
/*#__PURE__*/
function (_React$Component) {
  MenuItemGroup__inherits(MenuItemGroup, _React$Component);

  function MenuItemGroup() {
    var _this;

    MenuItemGroup__classCallCheck(this, MenuItemGroup);

    _this = MenuItemGroup__possibleConstructorReturn(this, MenuItemGroup__getPrototypeOf(MenuItemGroup).apply(this, arguments));

    _this.renderInnerMenuItem = function (item) {
      var _this$props = _this.props,
          renderMenuItem = _this$props.renderMenuItem,
          index = _this$props.index;
      return renderMenuItem(item, index, _this.props.subMenuKey);
    };

    return _this;
  }

  MenuItemGroup__createClass(MenuItemGroup, [{
    key: "render",
    value: function render() {
      var props = MenuItemGroup__extends({}, this.props);

      var _props$className = props.className,
          className = _props$className === void 0 ? '' : _props$className,
          rootPrefixCls = props.rootPrefixCls;
      var titleClassName = "".concat(rootPrefixCls, "-item-group-title");
      var listClassName = "".concat(rootPrefixCls, "-item-group-list");
      var title = props.title,
          children = props.children;
      menuAllProps.forEach(function (key) {
        return delete props[key];
      }); // Set onClick to null, to ignore propagated onClick event

      delete props.onClick;
      return preact_compat_es["createElement"]("li", MenuItemGroup__extends2({}, props, {
        className: "".concat(className, " ").concat(rootPrefixCls, "-item-group")
      }), preact_compat_es["createElement"]("div", {
        className: titleClassName,
        title: typeof title === 'string' ? title : undefined
      }, title), preact_compat_es["createElement"]("ul", {
        className: listClassName
      }, preact_compat_es["Children"].map(children, this.renderInnerMenuItem)));
    }
  }]);

  return MenuItemGroup;
}(preact_compat_es["Component"]);

MenuItemGroup_MenuItemGroup.isMenuItemGroup = true;
MenuItemGroup_MenuItemGroup.defaultProps = {
  disabled: true
};
/* harmony default export */ var es_MenuItemGroup = (MenuItemGroup_MenuItemGroup);
// CONCATENATED MODULE: ../node_modules/rc-menu/es/Divider.js


var Divider_Divider = function Divider(_ref) {
  var className = _ref.className,
      rootPrefixCls = _ref.rootPrefixCls,
      style = _ref.style;
  return preact_compat_es["createElement"]("li", {
    className: "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
    style: style
  });
};

Divider_Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true,
  className: '',
  style: {}
};
/* harmony default export */ var es_Divider = (Divider_Divider);
// CONCATENATED MODULE: ../node_modules/rc-menu/es/index.js






/* harmony default export */ var rc_menu_es = (es_Menu);
// EXTERNAL MODULE: ./assets/icons/sortIcon.png
var sortIcon = __webpack_require__("rngY");
var sortIcon_default = /*#__PURE__*/__webpack_require__.n(sortIcon);

// EXTERNAL MODULE: ../node_modules/rc-menu/assets/index.css
var assets = __webpack_require__("kEQP");
var assets_default = /*#__PURE__*/__webpack_require__.n(assets);

// EXTERNAL MODULE: ./components/search/dropdown/style.scss
var dropdown_style = __webpack_require__("phh3");
var style_default = /*#__PURE__*/__webpack_require__.n(dropdown_style);

// CONCATENATED MODULE: ./components/search/dropdown/index.js
var _class, _temp, dropdown__initialiseProps;



function dropdown__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dropdown__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dropdown__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */








var _ref3 = Object(preact_min["h"])('img', { src: sortIcon_default.a, alt: '' });

var dropdown_DropDown = (_temp = _class = function (_Component) {
  dropdown__inherits(DropDown, _Component);

  function DropDown(props) {
    dropdown__classCallCheck(this, DropDown);

    var _this = dropdown__possibleConstructorReturn(this, _Component.call(this, props));

    dropdown__initialiseProps.call(_this);

    _this.state = {
      selected: _this.findSelected(props),
      showMenu: false
    };
    return _this;
  }

  DropDown.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.props.selected) {
      this.setState({
        selected: this.findSelected(nextProps)
      });
    }
  };

  DropDown.prototype.render = function render(_ref, _ref2) {
    var data = _ref.data,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$showIcon = _ref.showIcon,
        showIcon = _ref$showIcon === undefined ? true : _ref$showIcon;
    var selected = _ref2.selected,
        showMenu = _ref2.showMenu;

    return Object(preact_min["h"])(
      'div',
      { onClick: this.openMenu, className: className + ' ' + style_default.a.dropdown },
      Object(preact_min["h"])(
        'div',
        { className: (selected.value === '' ? style_default.a.placeholder : '') + ' ' + style_default.a.selected },
        showIcon && _ref3,
        selected.name || selected
      ),
      showMenu && Object(preact_min["h"])(
        'div',
        { className: style_default.a.menu },
        Object(preact_min["h"])(
          rc_menu_es,
          { onSelect: this.onSelect, activeKey: selected.value !== undefined ? selected.value : selected },
          data.map(function (item, index) {
            return index !== 0 && Object(preact_min["h"])(
              es_MenuItem,
              { key: item.value !== undefined ? item.value : item },
              item.name || item
            );
          })
        )
      )
    );
  };

  return DropDown;
}(preact_min["Component"]), dropdown__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.findSelected = function (props) {
    return props.data.find(function (item) {
      return item.value === props.selected || item === props.selected;
    }) || props.data.find(function (item) {
      return item.value === '';
    });
  };

  this.onSelect = function (e) {
    _this2.props.onChange(e.key === 'item_0' ? '' : e.key);
  };

  this.openMenu = function () {
    var showMenu = _this2.state.showMenu;

    _this2.setState({
      showMenu: !showMenu
    });
  };
}, _temp);


/* harmony default export */ var dropdown = __webpack_exports__["a"] = (dist_default()(dropdown_DropDown));

/***/ }),

/***/ "pZzd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "phh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"dropdown__1bM3c","placeholder":"placeholder__1BLp8","selected":"selected__TOFOz","menu":"menu__3Q7fm"};

/***/ }),

/***/ "piIy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A React component for the font-awesome icon library.
 *
 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
 * @param {Boolean} [border=false] Whether or not to show a border radius
 * @param {String} [className] An extra set of CSS classes to add to the component
 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
 * @param {String} [flip=false] Flip the icon's orientation.
 * @param {Boolean} [inverse=false] Inverse the icon's color
 * @param {String} [name] Name of the icon to use
 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
 * @param {Number} [rotate] The degress to rotate the icon by
 * @param {String} [size] The icon scaling size
 * @param {Boolean} [spin=false] Spin the icon
 * @param {String} [stack] Stack an icon on top of another. Arguments specify z-index such as '1x' See documentation for example http://fontawesome.io/examples/#stacked
 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
 * @module FontAwesome
 * @type {ReactClass}
 */
var FontAwesome = function (_React$Component) {
  _inherits(FontAwesome, _React$Component);

  function FontAwesome() {
    _classCallCheck(this, FontAwesome);

    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));

    _this.displayName = 'FontAwesome';
    return _this;
  }

  _createClass(FontAwesome, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          border = _props.border,
          cssModule = _props.cssModule,
          className = _props.className,
          fixedWidth = _props.fixedWidth,
          flip = _props.flip,
          inverse = _props.inverse,
          name = _props.name,
          pulse = _props.pulse,
          rotate = _props.rotate,
          size = _props.size,
          spin = _props.spin,
          stack = _props.stack,
          _props$tag = _props.tag,
          tag = _props$tag === undefined ? 'span' : _props$tag,
          ariaLabel = _props.ariaLabel,
          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);

      var ariaProps = ariaLabel ? { 'aria-label': ariaLabel } : { 'aria-hidden': true };
      var classNames = [];

      if (cssModule) {
        classNames.push(cssModule['fa']);
        classNames.push(cssModule['fa-' + name]);
        size && classNames.push(cssModule['fa-' + size]);
        spin && classNames.push(cssModule['fa-spin']);
        pulse && classNames.push(cssModule['fa-pulse']);
        border && classNames.push(cssModule['fa-border']);
        fixedWidth && classNames.push(cssModule['fa-fw']);
        inverse && classNames.push(cssModule['fa-inverse']);
        flip && classNames.push(cssModule['fa-flip-' + flip]);
        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
        stack && classNames.push(cssModule['fa-stack-' + stack]);
      } else {
        classNames.push('fa');
        classNames.push('fa-' + name);
        size && classNames.push('fa-' + size);
        spin && classNames.push('fa-spin');
        pulse && classNames.push('fa-pulse');
        border && classNames.push('fa-border');
        fixedWidth && classNames.push('fa-fw');
        inverse && classNames.push('fa-inverse');
        flip && classNames.push('fa-flip-' + flip);
        rotate && classNames.push('fa-rotate-' + rotate);
        stack && classNames.push('fa-stack-' + stack);
      }

      // Add any custom class names at the end.
      className && classNames.push(className);
      return _react2.default.createElement(tag, _extends({}, props, ariaProps, {
        className: classNames.join(' ')
      }));
    }
  }]);

  return FontAwesome;
}(_react2.default.Component);

FontAwesome.propTypes = {
  ariaLabel: _propTypes2.default.string,
  border: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  cssModule: _propTypes2.default.object,
  fixedWidth: _propTypes2.default.bool,
  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  inverse: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  pulse: _propTypes2.default.bool,
  rotate: _propTypes2.default.oneOf([90, 180, 270]),
  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
  spin: _propTypes2.default.bool,
  stack: _propTypes2.default.oneOf(['1x', '2x']),
  tag: _propTypes2.default.string
};

exports.default = FontAwesome;
module.exports = exports.default;

/***/ }),

/***/ "pv+l":
/***/ (function(module, exports) {

module.exports = function (originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "pz6A":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
};

/***/ }),

/***/ "qIE1":
/***/ (function(module, exports) {

module.exports = function cmp(a, b) {
    var pa = a.split('.');
    var pb = b.split('.');
    for (var i = 0; i < 3; i++) {
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    return 0;
};

/***/ }),

/***/ "qLaj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var chrome_shim_namespaceObject = {};
__webpack_require__.d(chrome_shim_namespaceObject, "shimGetUserMedia", function() { return shimGetUserMedia; });
__webpack_require__.d(chrome_shim_namespaceObject, "shimGetDisplayMedia", function() { return shimGetDisplayMedia; });
__webpack_require__.d(chrome_shim_namespaceObject, "shimMediaStream", function() { return shimMediaStream; });
__webpack_require__.d(chrome_shim_namespaceObject, "shimOnTrack", function() { return shimOnTrack; });
__webpack_require__.d(chrome_shim_namespaceObject, "shimGetSendersWithDtmf", function() { return shimGetSendersWithDtmf; });
__webpack_require__.d(chrome_shim_namespaceObject, "shimGetStats", function() { return shimGetStats; });
__webpack_require__.d(chrome_shim_namespaceObject, "shimSenderReceiverGetStats", function() { return shimSenderReceiverGetStats; });
__webpack_require__.d(chrome_shim_namespaceObject, "shimAddTrackRemoveTrackWithNative", function() { return shimAddTrackRemoveTrackWithNative; });
__webpack_require__.d(chrome_shim_namespaceObject, "shimAddTrackRemoveTrack", function() { return shimAddTrackRemoveTrack; });
__webpack_require__.d(chrome_shim_namespaceObject, "shimPeerConnection", function() { return shimPeerConnection; });
__webpack_require__.d(chrome_shim_namespaceObject, "fixNegotiationNeeded", function() { return fixNegotiationNeeded; });
var firefox_shim_namespaceObject = {};
__webpack_require__.d(firefox_shim_namespaceObject, "shimGetUserMedia", function() { return getusermedia_shimGetUserMedia; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimGetDisplayMedia", function() { return getdisplaymedia_shimGetDisplayMedia; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimOnTrack", function() { return firefox_shim_shimOnTrack; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimPeerConnection", function() { return firefox_shim_shimPeerConnection; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimSenderGetStats", function() { return shimSenderGetStats; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimReceiverGetStats", function() { return shimReceiverGetStats; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimRemoveStream", function() { return shimRemoveStream; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimRTCDataChannel", function() { return shimRTCDataChannel; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimAddTransceiver", function() { return shimAddTransceiver; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimGetParameters", function() { return shimGetParameters; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimCreateOffer", function() { return shimCreateOffer; });
__webpack_require__.d(firefox_shim_namespaceObject, "shimCreateAnswer", function() { return shimCreateAnswer; });
var safari_shim_namespaceObject = {};
__webpack_require__.d(safari_shim_namespaceObject, "shimLocalStreamsAPI", function() { return shimLocalStreamsAPI; });
__webpack_require__.d(safari_shim_namespaceObject, "shimRemoteStreamsAPI", function() { return shimRemoteStreamsAPI; });
__webpack_require__.d(safari_shim_namespaceObject, "shimCallbacksAPI", function() { return shimCallbacksAPI; });
__webpack_require__.d(safari_shim_namespaceObject, "shimGetUserMedia", function() { return safari_shim_shimGetUserMedia; });
__webpack_require__.d(safari_shim_namespaceObject, "shimConstraints", function() { return shimConstraints; });
__webpack_require__.d(safari_shim_namespaceObject, "shimRTCIceServerUrls", function() { return shimRTCIceServerUrls; });
__webpack_require__.d(safari_shim_namespaceObject, "shimTrackEventTransceiver", function() { return shimTrackEventTransceiver; });
__webpack_require__.d(safari_shim_namespaceObject, "shimCreateOfferLegacy", function() { return shimCreateOfferLegacy; });
__webpack_require__.d(safari_shim_namespaceObject, "shimAudioContext", function() { return shimAudioContext; });
var common_shim_namespaceObject = {};
__webpack_require__.d(common_shim_namespaceObject, "shimRTCIceCandidate", function() { return shimRTCIceCandidate; });
__webpack_require__.d(common_shim_namespaceObject, "shimMaxMessageSize", function() { return shimMaxMessageSize; });
__webpack_require__.d(common_shim_namespaceObject, "shimSendThrowTypeError", function() { return shimSendThrowTypeError; });
__webpack_require__.d(common_shim_namespaceObject, "shimConnectionState", function() { return shimConnectionState; });
__webpack_require__.d(common_shim_namespaceObject, "removeExtmapAllowMixed", function() { return removeExtmapAllowMixed; });
__webpack_require__.d(common_shim_namespaceObject, "shimAddIceCandidateNullOrEmpty", function() { return shimAddIceCandidateNullOrEmpty; });
__webpack_require__.d(common_shim_namespaceObject, "shimParameterlessSetLocalDescription", function() { return shimParameterlessSetLocalDescription; });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/uuid/v4.js
var v4 = __webpack_require__("hYHi");
var v4_default = /*#__PURE__*/__webpack_require__.n(v4);

// EXTERNAL MODULE: ../node_modules/prismic-javascript/dist/prismic-javascript.min.js
var prismic_javascript_min = __webpack_require__("wv0P");
var prismic_javascript_min_default = /*#__PURE__*/__webpack_require__.n(prismic_javascript_min);

// EXTERNAL MODULE: ../node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__("fpuT");

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ../node_modules/react-ga/dist/esm/index.js + 11 modules
var esm = __webpack_require__("91gb");

// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/utils.js
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var logDisabled_ = true;
var deprecationWarnings_ = true;

/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */
function extractVersion(uastring, expr, pos) {
  var match = uastring.match(expr);
  return match && match.length >= pos && parseInt(match[pos], 10);
}

// Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object (or false to prevent
// the event).
function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
  if (!window.RTCPeerConnection) {
    return;
  }
  var proto = window.RTCPeerConnection.prototype;
  var nativeAddEventListener = proto.addEventListener;
  proto.addEventListener = function (nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap) {
      return nativeAddEventListener.apply(this, arguments);
    }
    var wrappedCallback = function wrappedCallback(e) {
      var modifiedEvent = wrapper(e);
      if (modifiedEvent) {
        if (cb.handleEvent) {
          cb.handleEvent(modifiedEvent);
        } else {
          cb(modifiedEvent);
        }
      }
    };
    this._eventMap = this._eventMap || {};
    if (!this._eventMap[eventNameToWrap]) {
      this._eventMap[eventNameToWrap] = new Map();
    }
    this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
    return nativeAddEventListener.apply(this, [nativeEventName, wrappedCallback]);
  };

  var nativeRemoveEventListener = proto.removeEventListener;
  proto.removeEventListener = function (nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    if (!this._eventMap[eventNameToWrap].has(cb)) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    var unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
    this._eventMap[eventNameToWrap].delete(cb);
    if (this._eventMap[eventNameToWrap].size === 0) {
      delete this._eventMap[eventNameToWrap];
    }
    if (Object.keys(this._eventMap).length === 0) {
      delete this._eventMap;
    }
    return nativeRemoveEventListener.apply(this, [nativeEventName, unwrappedCb]);
  };

  Object.defineProperty(proto, 'on' + eventNameToWrap, {
    get: function get() {
      return this['_on' + eventNameToWrap];
    },
    set: function set(cb) {
      if (this['_on' + eventNameToWrap]) {
        this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
        delete this['_on' + eventNameToWrap];
      }
      if (cb) {
        this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
      }
    },

    enumerable: true,
    configurable: true
  });
}

function disableLog(bool) {
  if (typeof bool !== 'boolean') {
    return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
  }
  logDisabled_ = bool;
  return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
}

/**
 * Disable or enable deprecation warnings
 * @param {!boolean} bool set to true to disable warnings.
 */
function disableWarnings(bool) {
  if (typeof bool !== 'boolean') {
    return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
  }
  deprecationWarnings_ = !bool;
  return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
}

function log() {
  if (typeof window === 'object') {
    if (logDisabled_) {
      return;
    }
    if (typeof console !== 'undefined' && typeof console.log === 'function') {
      console.log.apply(console, arguments);
    }
  }
}

/**
 * Shows a deprecation warning suggesting the modern and spec-compatible API.
 */
function deprecated(oldMethod, newMethod) {
  if (!deprecationWarnings_) {
    return;
  }
  console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
}

/**
 * Browser detector.
 *
 * @return {object} result containing browser and version
 *     properties.
 */
function detectBrowser(window) {
  // Returned result object.
  var result = { browser: null, version: null };

  // Fail early if it's not a browser
  if (typeof window === 'undefined' || !window.navigator) {
    result.browser = 'Not a browser.';
    return result;
  }

  var navigator = window.navigator;


  if (navigator.mozGetUserMedia) {
    // Firefox.
    result.browser = 'firefox';
    result.version = extractVersion(navigator.userAgent, /Firefox\/(\d+)\./, 1);
  } else if (navigator.webkitGetUserMedia || window.isSecureContext === false && window.webkitRTCPeerConnection && !window.RTCIceGatherer) {
    // Chrome, Chromium, Webview, Opera.
    // Version matches Chrome/WebRTC version.
    // Chrome 74 removed webkitGetUserMedia on http as well so we need the
    // more complicated fallback to webkitRTCPeerConnection.
    result.browser = 'chrome';
    result.version = extractVersion(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
  } else if (window.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
    // Safari.
    result.browser = 'safari';
    result.version = extractVersion(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
    result.supportsUnifiedPlan = window.RTCRtpTransceiver && 'currentDirection' in window.RTCRtpTransceiver.prototype;
  } else {
    // Default fallthrough: not supported.
    result.browser = 'Not a supported browser.';
    return result;
  }

  return result;
}

/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */
function isObject(val) {
  return Object.prototype.toString.call(val) === '[object Object]';
}

/**
 * Remove all empty objects and undefined values
 * from a nested object -- an enhanced and vanilla version
 * of Lodash's `compact`.
 */
function compactObject(data) {
  if (!isObject(data)) {
    return data;
  }

  return Object.keys(data).reduce(function (accumulator, key) {
    var _extends2;

    var isObj = isObject(data[key]);
    var value = isObj ? compactObject(data[key]) : data[key];
    var isEmptyObject = isObj && !Object.keys(value).length;
    if (value === undefined || isEmptyObject) {
      return accumulator;
    }
    return _extends(accumulator, (_extends2 = {}, _extends2[key] = value, _extends2));
  }, {});
}

/* iterates the stats graph recursively. */
function walkStats(stats, base, resultSet) {
  if (!base || resultSet.has(base.id)) {
    return;
  }
  resultSet.set(base.id, base);
  Object.keys(base).forEach(function (name) {
    if (name.endsWith('Id')) {
      walkStats(stats, stats.get(base[name]), resultSet);
    } else if (name.endsWith('Ids')) {
      base[name].forEach(function (id) {
        walkStats(stats, stats.get(id), resultSet);
      });
    }
  });
}

/* filter getStats for a sender/receiver track. */
function filterStats(result, track, outbound) {
  var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
  var filteredResult = new Map();
  if (track === null) {
    return filteredResult;
  }
  var trackStats = [];
  result.forEach(function (value) {
    if (value.type === 'track' && value.trackIdentifier === track.id) {
      trackStats.push(value);
    }
  });
  trackStats.forEach(function (trackStat) {
    result.forEach(function (stats) {
      if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
        walkStats(result, stats, filteredResult);
      }
    });
  });
  return filteredResult;
}
// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/chrome/getusermedia.js
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */



var getusermedia_logging = log;

function shimGetUserMedia(window, browserDetails) {
  var navigator = window && window.navigator;

  if (!navigator.mediaDevices) {
    return;
  }

  var constraintsToChrome_ = function constraintsToChrome_(c) {
    if (typeof c !== 'object' || c.mandatory || c.optional) {
      return c;
    }
    var cc = {};
    Object.keys(c).forEach(function (key) {
      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
        return;
      }
      var r = typeof c[key] === 'object' ? c[key] : { ideal: c[key] };
      if (r.exact !== undefined && typeof r.exact === 'number') {
        r.min = r.max = r.exact;
      }
      var oldname_ = function oldname_(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }
        return name === 'deviceId' ? 'sourceId' : name;
      };
      if (r.ideal !== undefined) {
        cc.optional = cc.optional || [];
        var oc = {};
        if (typeof r.ideal === 'number') {
          oc[oldname_('min', key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_('max', key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_('', key)] = r.ideal;
          cc.optional.push(oc);
        }
      }
      if (r.exact !== undefined && typeof r.exact !== 'number') {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_('', key)] = r.exact;
      } else {
        ['min', 'max'].forEach(function (mix) {
          if (r[mix] !== undefined) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });
    if (c.advanced) {
      cc.optional = (cc.optional || []).concat(c.advanced);
    }
    return cc;
  };

  var shimConstraints_ = function shimConstraints_(constraints, func) {
    if (browserDetails.version >= 61) {
      return func(constraints);
    }
    constraints = JSON.parse(JSON.stringify(constraints));
    if (constraints && typeof constraints.audio === 'object') {
      var remap = function remap(obj, a, b) {
        if (a in obj && !(b in obj)) {
          obj[b] = obj[a];
          delete obj[a];
        }
      };
      constraints = JSON.parse(JSON.stringify(constraints));
      remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
      remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
      constraints.audio = constraintsToChrome_(constraints.audio);
    }
    if (constraints && typeof constraints.video === 'object') {
      // Shim facingMode for mobile & surface pro.
      var face = constraints.video.facingMode;
      face = face && (typeof face === 'object' ? face : { ideal: face });
      var getSupportedFacingModeLies = browserDetails.version < 66;

      if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
        delete constraints.video.facingMode;
        var matches = void 0;
        if (face.exact === 'environment' || face.ideal === 'environment') {
          matches = ['back', 'rear'];
        } else if (face.exact === 'user' || face.ideal === 'user') {
          matches = ['front'];
        }
        if (matches) {
          // Look for matches in label, or use last cam for back (typical).
          return navigator.mediaDevices.enumerateDevices().then(function (devices) {
            devices = devices.filter(function (d) {
              return d.kind === 'videoinput';
            });
            var dev = devices.find(function (d) {
              return matches.some(function (match) {
                return d.label.toLowerCase().includes(match);
              });
            });
            if (!dev && devices.length && matches.includes('back')) {
              dev = devices[devices.length - 1]; // more likely the back cam
            }
            if (dev) {
              constraints.video.deviceId = face.exact ? { exact: dev.deviceId } : { ideal: dev.deviceId };
            }
            constraints.video = constraintsToChrome_(constraints.video);
            getusermedia_logging('chrome: ' + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }
      constraints.video = constraintsToChrome_(constraints.video);
    }
    getusermedia_logging('chrome: ' + JSON.stringify(constraints));
    return func(constraints);
  };

  var shimError_ = function shimError_(e) {
    if (browserDetails.version >= 64) {
      return e;
    }
    return {
      name: {
        PermissionDeniedError: 'NotAllowedError',
        PermissionDismissedError: 'NotAllowedError',
        InvalidStateError: 'NotAllowedError',
        DevicesNotFoundError: 'NotFoundError',
        ConstraintNotSatisfiedError: 'OverconstrainedError',
        TrackStartError: 'NotReadableError',
        MediaDeviceFailedDueToShutdown: 'NotAllowedError',
        MediaDeviceKillSwitchOn: 'NotAllowedError',
        TabCaptureError: 'AbortError',
        ScreenCaptureError: 'AbortError',
        DeviceCaptureError: 'AbortError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint || e.constraintName,
      toString: function toString() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  var getUserMedia_ = function getUserMedia_(constraints, onSuccess, onError) {
    shimConstraints_(constraints, function (c) {
      navigator.webkitGetUserMedia(c, onSuccess, function (e) {
        if (onError) {
          onError(shimError_(e));
        }
      });
    });
  };
  navigator.getUserMedia = getUserMedia_.bind(navigator);

  // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
  // function which returns a Promise, it does not accept spec-style
  // constraints.
  if (navigator.mediaDevices.getUserMedia) {
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function (cs) {
      return shimConstraints_(cs, function (c) {
        return origGetUserMedia(c).then(function (stream) {
          if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
            stream.getTracks().forEach(function (track) {
              track.stop();
            });
            throw new DOMException('', 'NotFoundError');
          }
          return stream;
        }, function (e) {
          return Promise.reject(shimError_(e));
        });
      });
    };
  }
}
// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/chrome/getdisplaymedia.js
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */


function shimGetDisplayMedia(window, getSourceId) {
  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }
  if (!window.navigator.mediaDevices) {
    return;
  }
  // getSourceId is a function that returns a promise resolving with
  // the sourceId of the screen/window/tab to be shared.
  if (typeof getSourceId !== 'function') {
    console.error('shimGetDisplayMedia: getSourceId argument is not ' + 'a function');
    return;
  }
  window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
    return getSourceId(constraints).then(function (sourceId) {
      var widthSpecified = constraints.video && constraints.video.width;
      var heightSpecified = constraints.video && constraints.video.height;
      var frameRateSpecified = constraints.video && constraints.video.frameRate;
      constraints.video = {
        mandatory: {
          chromeMediaSource: 'desktop',
          chromeMediaSourceId: sourceId,
          maxFrameRate: frameRateSpecified || 3
        }
      };
      if (widthSpecified) {
        constraints.video.mandatory.maxWidth = widthSpecified;
      }
      if (heightSpecified) {
        constraints.video.mandatory.maxHeight = heightSpecified;
      }
      return window.navigator.mediaDevices.getUserMedia(constraints);
    });
  };
}
// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/chrome/chrome_shim.js
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */







function shimMediaStream(window) {
  window.MediaStream = window.MediaStream || window.webkitMediaStream;
}

function shimOnTrack(window) {
  if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
      get: function get() {
        return this._ontrack;
      },
      set: function set(f) {
        if (this._ontrack) {
          this.removeEventListener('track', this._ontrack);
        }
        this.addEventListener('track', this._ontrack = f);
      },

      enumerable: true,
      configurable: true
    });
    var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
      var _this = this;

      if (!this._ontrackpoly) {
        this._ontrackpoly = function (e) {
          // onaddstream does not fire when a track is added to an existing
          // stream. But stream.onaddtrack is implemented so we use that.
          e.stream.addEventListener('addtrack', function (te) {
            var receiver = void 0;
            if (window.RTCPeerConnection.prototype.getReceivers) {
              receiver = _this.getReceivers().find(function (r) {
                return r.track && r.track.id === te.track.id;
              });
            } else {
              receiver = { track: te.track };
            }

            var event = new Event('track');
            event.track = te.track;
            event.receiver = receiver;
            event.transceiver = { receiver: receiver };
            event.streams = [e.stream];
            _this.dispatchEvent(event);
          });
          e.stream.getTracks().forEach(function (track) {
            var receiver = void 0;
            if (window.RTCPeerConnection.prototype.getReceivers) {
              receiver = _this.getReceivers().find(function (r) {
                return r.track && r.track.id === track.id;
              });
            } else {
              receiver = { track: track };
            }
            var event = new Event('track');
            event.track = track;
            event.receiver = receiver;
            event.transceiver = { receiver: receiver };
            event.streams = [e.stream];
            _this.dispatchEvent(event);
          });
        };
        this.addEventListener('addstream', this._ontrackpoly);
      }
      return origSetRemoteDescription.apply(this, arguments);
    };
  } else {
    // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    wrapPeerConnectionEvent(window, 'track', function (e) {
      if (!e.transceiver) {
        Object.defineProperty(e, 'transceiver', { value: { receiver: e.receiver } });
      }
      return e;
    });
  }
}

function shimGetSendersWithDtmf(window) {
  // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
  if (typeof window === 'object' && window.RTCPeerConnection && !('getSenders' in window.RTCPeerConnection.prototype) && 'createDTMFSender' in window.RTCPeerConnection.prototype) {
    var shimSenderWithDtmf = function shimSenderWithDtmf(pc, track) {
      return {
        track: track,
        get dtmf() {
          if (this._dtmf === undefined) {
            if (track.kind === 'audio') {
              this._dtmf = pc.createDTMFSender(track);
            } else {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        },
        _pc: pc
      };
    };

    // augment addTrack when getSenders is not available.
    if (!window.RTCPeerConnection.prototype.getSenders) {
      window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        this._senders = this._senders || [];
        return this._senders.slice(); // return a copy of the internal state.
      };
      var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
      window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        var sender = origAddTrack.apply(this, arguments);
        if (!sender) {
          sender = shimSenderWithDtmf(this, track);
          this._senders.push(sender);
        }
        return sender;
      };

      var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
      window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        origRemoveTrack.apply(this, arguments);
        var idx = this._senders.indexOf(sender);
        if (idx !== -1) {
          this._senders.splice(idx, 1);
        }
      };
    }
    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
      var _this2 = this;

      this._senders = this._senders || [];
      origAddStream.apply(this, [stream]);
      stream.getTracks().forEach(function (track) {
        _this2._senders.push(shimSenderWithDtmf(_this2, track));
      });
    };

    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
      var _this3 = this;

      this._senders = this._senders || [];
      origRemoveStream.apply(this, [stream]);

      stream.getTracks().forEach(function (track) {
        var sender = _this3._senders.find(function (s) {
          return s.track === track;
        });
        if (sender) {
          // remove sender
          _this3._senders.splice(_this3._senders.indexOf(sender), 1);
        }
      });
    };
  } else if (typeof window === 'object' && window.RTCPeerConnection && 'getSenders' in window.RTCPeerConnection.prototype && 'createDTMFSender' in window.RTCPeerConnection.prototype && window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    window.RTCPeerConnection.prototype.getSenders = function getSenders() {
      var _this4 = this;

      var senders = origGetSenders.apply(this, []);
      senders.forEach(function (sender) {
        return sender._pc = _this4;
      });
      return senders;
    };

    Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
      get: function get() {
        if (this._dtmf === undefined) {
          if (this.track.kind === 'audio') {
            this._dtmf = this._pc.createDTMFSender(this.track);
          } else {
            this._dtmf = null;
          }
        }
        return this._dtmf;
      }
    });
  }
}

function shimGetStats(window) {
  if (!window.RTCPeerConnection) {
    return;
  }

  var origGetStats = window.RTCPeerConnection.prototype.getStats;
  window.RTCPeerConnection.prototype.getStats = function getStats() {
    var _this5 = this;

    var selector = arguments[0],
        onSucc = arguments[1],
        onErr = arguments[2];

    // If selector is a function then we are in the old style stats so just
    // pass back the original getStats format to avoid breaking old users.

    if (arguments.length > 0 && typeof selector === 'function') {
      return origGetStats.apply(this, arguments);
    }

    // When spec-style getStats is supported, return those when called with
    // either no arguments or the selector argument is null.
    if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== 'function')) {
      return origGetStats.apply(this, []);
    }

    var fixChromeStats_ = function fixChromeStats_(response) {
      var standardReport = {};
      var reports = response.result();
      reports.forEach(function (report) {
        var standardStats = {
          id: report.id,
          timestamp: report.timestamp,
          type: {
            localcandidate: 'local-candidate',
            remotecandidate: 'remote-candidate'
          }[report.type] || report.type
        };
        report.names().forEach(function (name) {
          standardStats[name] = report.stat(name);
        });
        standardReport[standardStats.id] = standardStats;
      });

      return standardReport;
    };

    // shim getStats with maplike support
    var makeMapStats = function makeMapStats(stats) {
      return new Map(Object.keys(stats).map(function (key) {
        return [key, stats[key]];
      }));
    };

    if (arguments.length >= 2) {
      var successCallbackWrapper_ = function successCallbackWrapper_(response) {
        onSucc(makeMapStats(fixChromeStats_(response)));
      };

      return origGetStats.apply(this, [successCallbackWrapper_, selector]);
    }

    // promise-support
    return new Promise(function (resolve, reject) {
      origGetStats.apply(_this5, [function (response) {
        resolve(makeMapStats(fixChromeStats_(response)));
      }, reject]);
    }).then(onSucc, onErr);
  };
}

function shimSenderReceiverGetStats(window) {
  if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) {
    return;
  }

  // shim sender stats.
  if (!('getStats' in window.RTCRtpSender.prototype)) {
    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) {
      window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        var _this6 = this;

        var senders = origGetSenders.apply(this, []);
        senders.forEach(function (sender) {
          return sender._pc = _this6;
        });
        return senders;
      };
    }

    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) {
      window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        var sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
      };
    }
    window.RTCRtpSender.prototype.getStats = function getStats() {
      var sender = this;
      return this._pc.getStats().then(function (result) {
        return (
          /* Note: this will include stats of all senders that
           *   send a track with the same id as sender.track as
           *   it is not possible to identify the RTCRtpSender.
           */
          filterStats(result, sender.track, true)
        );
      });
    };
  }

  // shim receiver stats.
  if (!('getStats' in window.RTCRtpReceiver.prototype)) {
    var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) {
      window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        var _this7 = this;

        var receivers = origGetReceivers.apply(this, []);
        receivers.forEach(function (receiver) {
          return receiver._pc = _this7;
        });
        return receivers;
      };
    }
    wrapPeerConnectionEvent(window, 'track', function (e) {
      e.receiver._pc = e.srcElement;
      return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
      var receiver = this;
      return this._pc.getStats().then(function (result) {
        return filterStats(result, receiver.track, false);
      });
    };
  }

  if (!('getStats' in window.RTCRtpSender.prototype && 'getStats' in window.RTCRtpReceiver.prototype)) {
    return;
  }

  // shim RTCPeerConnection.getStats(track).
  var origGetStats = window.RTCPeerConnection.prototype.getStats;
  window.RTCPeerConnection.prototype.getStats = function getStats() {
    if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
      var track = arguments[0];
      var sender = void 0;
      var receiver = void 0;
      var err = void 0;
      this.getSenders().forEach(function (s) {
        if (s.track === track) {
          if (sender) {
            err = true;
          } else {
            sender = s;
          }
        }
      });
      this.getReceivers().forEach(function (r) {
        if (r.track === track) {
          if (receiver) {
            err = true;
          } else {
            receiver = r;
          }
        }
        return r.track === track;
      });
      if (err || sender && receiver) {
        return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
      } else if (sender) {
        return sender.getStats();
      } else if (receiver) {
        return receiver.getStats();
      }
      return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
    }
    return origGetStats.apply(this, arguments);
  };
}

function shimAddTrackRemoveTrackWithNative(window) {
  // shim addTrack/removeTrack with native variants in order to make
  // the interactions with legacy getLocalStreams behave as in other browsers.
  // Keeps a mapping stream.id => [stream, rtpsenders...]
  window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
    var _this8 = this;

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    return Object.keys(this._shimmedLocalStreams).map(function (streamId) {
      return _this8._shimmedLocalStreams[streamId][0];
    });
  };

  var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
  window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
    if (!stream) {
      return origAddTrack.apply(this, arguments);
    }
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};

    var sender = origAddTrack.apply(this, arguments);
    if (!this._shimmedLocalStreams[stream.id]) {
      this._shimmedLocalStreams[stream.id] = [stream, sender];
    } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
      this._shimmedLocalStreams[stream.id].push(sender);
    }
    return sender;
  };

  var origAddStream = window.RTCPeerConnection.prototype.addStream;
  window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
    var _this9 = this;

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};

    stream.getTracks().forEach(function (track) {
      var alreadyExists = _this9.getSenders().find(function (s) {
        return s.track === track;
      });
      if (alreadyExists) {
        throw new DOMException('Track already exists.', 'InvalidAccessError');
      }
    });
    var existingSenders = this.getSenders();
    origAddStream.apply(this, arguments);
    var newSenders = this.getSenders().filter(function (newSender) {
      return existingSenders.indexOf(newSender) === -1;
    });
    this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
  };

  var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
  window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    delete this._shimmedLocalStreams[stream.id];
    return origRemoveStream.apply(this, arguments);
  };

  var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
  window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
    var _this10 = this;

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    if (sender) {
      Object.keys(this._shimmedLocalStreams).forEach(function (streamId) {
        var idx = _this10._shimmedLocalStreams[streamId].indexOf(sender);
        if (idx !== -1) {
          _this10._shimmedLocalStreams[streamId].splice(idx, 1);
        }
        if (_this10._shimmedLocalStreams[streamId].length === 1) {
          delete _this10._shimmedLocalStreams[streamId];
        }
      });
    }
    return origRemoveTrack.apply(this, arguments);
  };
}

function shimAddTrackRemoveTrack(window, browserDetails) {
  if (!window.RTCPeerConnection) {
    return;
  }
  // shim addTrack and removeTrack.
  if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) {
    return shimAddTrackRemoveTrackWithNative(window);
  }

  // also shim pc.getLocalStreams when addTrack is shimmed
  // to return the original streams.
  var origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
  window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
    var _this11 = this;

    var nativeStreams = origGetLocalStreams.apply(this);
    this._reverseStreams = this._reverseStreams || {};
    return nativeStreams.map(function (stream) {
      return _this11._reverseStreams[stream.id];
    });
  };

  var origAddStream = window.RTCPeerConnection.prototype.addStream;
  window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
    var _this12 = this;

    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};

    stream.getTracks().forEach(function (track) {
      var alreadyExists = _this12.getSenders().find(function (s) {
        return s.track === track;
      });
      if (alreadyExists) {
        throw new DOMException('Track already exists.', 'InvalidAccessError');
      }
    });
    // Add identity mapping for consistency with addTrack.
    // Unless this is being used with a stream from addTrack.
    if (!this._reverseStreams[stream.id]) {
      var newStream = new window.MediaStream(stream.getTracks());
      this._streams[stream.id] = newStream;
      this._reverseStreams[newStream.id] = stream;
      stream = newStream;
    }
    origAddStream.apply(this, [stream]);
  };

  var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
  window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};

    origRemoveStream.apply(this, [this._streams[stream.id] || stream]);
    delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
    delete this._streams[stream.id];
  };

  window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
    var _this13 = this;

    if (this.signalingState === 'closed') {
      throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
    }
    var streams = [].slice.call(arguments, 1);
    if (streams.length !== 1 || !streams[0].getTracks().find(function (t) {
      return t === track;
    })) {
      // this is not fully correct but all we can manage without
      // [[associated MediaStreams]] internal slot.
      throw new DOMException('The adapter.js addTrack polyfill only supports a single ' + ' stream which is associated with the specified track.', 'NotSupportedError');
    }

    var alreadyExists = this.getSenders().find(function (s) {
      return s.track === track;
    });
    if (alreadyExists) {
      throw new DOMException('Track already exists.', 'InvalidAccessError');
    }

    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};
    var oldStream = this._streams[stream.id];
    if (oldStream) {
      // this is using odd Chrome behaviour, use with caution:
      // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
      // Note: we rely on the high-level addTrack/dtmf shim to
      // create the sender with a dtmf sender.
      oldStream.addTrack(track);

      // Trigger ONN async.
      Promise.resolve().then(function () {
        _this13.dispatchEvent(new Event('negotiationneeded'));
      });
    } else {
      var newStream = new window.MediaStream([track]);
      this._streams[stream.id] = newStream;
      this._reverseStreams[newStream.id] = stream;
      this.addStream(newStream);
    }
    return this.getSenders().find(function (s) {
      return s.track === track;
    });
  };

  // replace the internal stream id with the external one and
  // vice versa.
  function replaceInternalStreamId(pc, description) {
    var sdp = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
      var externalStream = pc._reverseStreams[internalId];
      var internalStream = pc._streams[externalStream.id];
      sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp: sdp
    });
  }
  function replaceExternalStreamId(pc, description) {
    var sdp = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
      var externalStream = pc._reverseStreams[internalId];
      var internalStream = pc._streams[externalStream.id];
      sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp: sdp
    });
  }
  ['createOffer', 'createAnswer'].forEach(function (method) {
    var _methodObj;

    var nativeMethod = window.RTCPeerConnection.prototype[method];
    var methodObj = (_methodObj = {}, _methodObj[method] = function () {
      var _this14 = this;

      var args = arguments;
      var isLegacyCall = arguments.length && typeof arguments[0] === 'function';
      if (isLegacyCall) {
        return nativeMethod.apply(this, [function (description) {
          var desc = replaceInternalStreamId(_this14, description);
          args[0].apply(null, [desc]);
        }, function (err) {
          if (args[1]) {
            args[1].apply(null, err);
          }
        }, arguments[2]]);
      }
      return nativeMethod.apply(this, arguments).then(function (description) {
        return replaceInternalStreamId(_this14, description);
      });
    }, _methodObj);
    window.RTCPeerConnection.prototype[method] = methodObj[method];
  });

  var origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
  window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
    if (!arguments.length || !arguments[0].type) {
      return origSetLocalDescription.apply(this, arguments);
    }
    arguments[0] = replaceExternalStreamId(this, arguments[0]);
    return origSetLocalDescription.apply(this, arguments);
  };

  // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier

  var origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, 'localDescription');
  Object.defineProperty(window.RTCPeerConnection.prototype, 'localDescription', {
    get: function get() {
      var description = origLocalDescription.get.apply(this);
      if (description.type === '') {
        return description;
      }
      return replaceInternalStreamId(this, description);
    }
  });

  window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
    var _this15 = this;

    if (this.signalingState === 'closed') {
      throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
    }
    // We can not yet check for sender instanceof RTCRtpSender
    // since we shim RTPSender. So we check if sender._pc is set.
    if (!sender._pc) {
      throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' + 'does not implement interface RTCRtpSender.', 'TypeError');
    }
    var isLocal = sender._pc === this;
    if (!isLocal) {
      throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
    }

    // Search for the native stream the senders track belongs to.
    this._streams = this._streams || {};
    var stream = void 0;
    Object.keys(this._streams).forEach(function (streamid) {
      var hasTrack = _this15._streams[streamid].getTracks().find(function (track) {
        return sender.track === track;
      });
      if (hasTrack) {
        stream = _this15._streams[streamid];
      }
    });

    if (stream) {
      if (stream.getTracks().length === 1) {
        // if this is the last track of the stream, remove the stream. This
        // takes care of any shimmed _senders.
        this.removeStream(this._reverseStreams[stream.id]);
      } else {
        // relying on the same odd chrome behaviour as above.
        stream.removeTrack(sender.track);
      }
      this.dispatchEvent(new Event('negotiationneeded'));
    }
  };
}

function shimPeerConnection(window, browserDetails) {
  if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) {
    // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
  }
  if (!window.RTCPeerConnection) {
    return;
  }

  // shim implicit creation of RTCSessionDescription/RTCIceCandidate
  if (browserDetails.version < 53) {
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
      var _methodObj2;

      var nativeMethod = window.RTCPeerConnection.prototype[method];
      var methodObj = (_methodObj2 = {}, _methodObj2[method] = function () {
        arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
        return nativeMethod.apply(this, arguments);
      }, _methodObj2);
      window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
  }
}

// Attempt to fix ONN in plan-b mode.
function fixNegotiationNeeded(window, browserDetails) {
  wrapPeerConnectionEvent(window, 'negotiationneeded', function (e) {
    var pc = e.target;
    if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === 'plan-b') {
      if (pc.signalingState !== 'stable') {
        return;
      }
    }
    return e;
  });
}
// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/firefox/getusermedia.js
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */




function getusermedia_shimGetUserMedia(window, browserDetails) {
  var navigator = window && window.navigator;
  var MediaStreamTrack = window && window.MediaStreamTrack;

  navigator.getUserMedia = function (constraints, onSuccess, onError) {
    // Replace Firefox 44+'s deprecation warning with unprefixed version.
    deprecated('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };

  if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
    var remap = function remap(obj, a, b) {
      if (a in obj && !(b in obj)) {
        obj[b] = obj[a];
        delete obj[a];
      }
    };

    var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function (c) {
      if (typeof c === 'object' && typeof c.audio === 'object') {
        c = JSON.parse(JSON.stringify(c));
        remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
        remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
      }
      return nativeGetUserMedia(c);
    };

    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
      var nativeGetSettings = MediaStreamTrack.prototype.getSettings;
      MediaStreamTrack.prototype.getSettings = function () {
        var obj = nativeGetSettings.apply(this, arguments);
        remap(obj, 'mozAutoGainControl', 'autoGainControl');
        remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
        return obj;
      };
    }

    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
      var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
      MediaStreamTrack.prototype.applyConstraints = function (c) {
        if (this.kind === 'audio' && typeof c === 'object') {
          c = JSON.parse(JSON.stringify(c));
          remap(c, 'autoGainControl', 'mozAutoGainControl');
          remap(c, 'noiseSuppression', 'mozNoiseSuppression');
        }
        return nativeApplyConstraints.apply(this, [c]);
      };
    }
  }
}
// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/firefox/getdisplaymedia.js
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */


function getdisplaymedia_shimGetDisplayMedia(window, preferredMediaSource) {
  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }
  if (!window.navigator.mediaDevices) {
    return;
  }
  window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
    if (!(constraints && constraints.video)) {
      var err = new DOMException('getDisplayMedia without video ' + 'constraints is undefined');
      err.name = 'NotFoundError';
      // from https://heycam.github.io/webidl/#idl-DOMException-error-names
      err.code = 8;
      return Promise.reject(err);
    }
    if (constraints.video === true) {
      constraints.video = { mediaSource: preferredMediaSource };
    } else {
      constraints.video.mediaSource = preferredMediaSource;
    }
    return window.navigator.mediaDevices.getUserMedia(constraints);
  };
}
// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/firefox/firefox_shim.js
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */


var firefox_shim__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function firefox_shim_shimOnTrack(window) {
  if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
      get: function get() {
        return { receiver: this.receiver };
      }
    });
  }
}

function firefox_shim_shimPeerConnection(window, browserDetails) {
  if (typeof window !== 'object' || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) {
    return; // probably media.peerconnection.enabled=false in about:config
  }
  if (!window.RTCPeerConnection && window.mozRTCPeerConnection) {
    // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
  }

  if (browserDetails.version < 53) {
    // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
      var _methodObj;

      var nativeMethod = window.RTCPeerConnection.prototype[method];
      var methodObj = (_methodObj = {}, _methodObj[method] = function () {
        arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
        return nativeMethod.apply(this, arguments);
      }, _methodObj);
      window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
  }

  var modernStatsTypes = {
    inboundrtp: 'inbound-rtp',
    outboundrtp: 'outbound-rtp',
    candidatepair: 'candidate-pair',
    localcandidate: 'local-candidate',
    remotecandidate: 'remote-candidate'
  };

  var nativeGetStats = window.RTCPeerConnection.prototype.getStats;
  window.RTCPeerConnection.prototype.getStats = function getStats() {
    var selector = arguments[0],
        onSucc = arguments[1],
        onErr = arguments[2];

    return nativeGetStats.apply(this, [selector || null]).then(function (stats) {
      if (browserDetails.version < 53 && !onSucc) {
        // Shim only promise getStats with spec-hyphens in type names
        // Leave callback version alone; misc old uses of forEach before Map
        try {
          stats.forEach(function (stat) {
            stat.type = modernStatsTypes[stat.type] || stat.type;
          });
        } catch (e) {
          if (e.name !== 'TypeError') {
            throw e;
          }
          // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
          stats.forEach(function (stat, i) {
            stats.set(i, firefox_shim__extends({}, stat, {
              type: modernStatsTypes[stat.type] || stat.type
            }));
          });
        }
      }
      return stats;
    }).then(onSucc, onErr);
  };
}

function shimSenderGetStats(window) {
  if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
    return;
  }
  if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) {
    return;
  }
  var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
  if (origGetSenders) {
    window.RTCPeerConnection.prototype.getSenders = function getSenders() {
      var _this = this;

      var senders = origGetSenders.apply(this, []);
      senders.forEach(function (sender) {
        return sender._pc = _this;
      });
      return senders;
    };
  }

  var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
  if (origAddTrack) {
    window.RTCPeerConnection.prototype.addTrack = function addTrack() {
      var sender = origAddTrack.apply(this, arguments);
      sender._pc = this;
      return sender;
    };
  }
  window.RTCRtpSender.prototype.getStats = function getStats() {
    return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
  };
}

function shimReceiverGetStats(window) {
  if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
    return;
  }
  if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) {
    return;
  }
  var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
  if (origGetReceivers) {
    window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
      var _this2 = this;

      var receivers = origGetReceivers.apply(this, []);
      receivers.forEach(function (receiver) {
        return receiver._pc = _this2;
      });
      return receivers;
    };
  }
  wrapPeerConnectionEvent(window, 'track', function (e) {
    e.receiver._pc = e.srcElement;
    return e;
  });
  window.RTCRtpReceiver.prototype.getStats = function getStats() {
    return this._pc.getStats(this.track);
  };
}

function shimRemoveStream(window) {
  if (!window.RTCPeerConnection || 'removeStream' in window.RTCPeerConnection.prototype) {
    return;
  }
  window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
    var _this3 = this;

    deprecated('removeStream', 'removeTrack');
    this.getSenders().forEach(function (sender) {
      if (sender.track && stream.getTracks().includes(sender.track)) {
        _this3.removeTrack(sender);
      }
    });
  };
}

function shimRTCDataChannel(window) {
  // rename DataChannel to RTCDataChannel (native fix in FF60):
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
  if (window.DataChannel && !window.RTCDataChannel) {
    window.RTCDataChannel = window.DataChannel;
  }
}

function shimAddTransceiver(window) {
  // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
  // Firefox ignores the init sendEncodings options passed to addTransceiver
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
  if (!(typeof window === 'object' && window.RTCPeerConnection)) {
    return;
  }
  var origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
  if (origAddTransceiver) {
    window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
      this.setParametersPromises = [];
      var initParameters = arguments[1];
      var shouldPerformCheck = initParameters && 'sendEncodings' in initParameters;
      if (shouldPerformCheck) {
        // If sendEncodings params are provided, validate grammar
        initParameters.sendEncodings.forEach(function (encodingParam) {
          if ('rid' in encodingParam) {
            var ridRegex = /^[a-z0-9]{0,16}$/i;
            if (!ridRegex.test(encodingParam.rid)) {
              throw new TypeError('Invalid RID value provided.');
            }
          }
          if ('scaleResolutionDownBy' in encodingParam) {
            if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) {
              throw new RangeError('scale_resolution_down_by must be >= 1.0');
            }
          }
          if ('maxFramerate' in encodingParam) {
            if (!(parseFloat(encodingParam.maxFramerate) >= 0)) {
              throw new RangeError('max_framerate must be >= 0.0');
            }
          }
        });
      }
      var transceiver = origAddTransceiver.apply(this, arguments);
      if (shouldPerformCheck) {
        // Check if the init options were applied. If not we do this in an
        // asynchronous way and save the promise reference in a global object.
        // This is an ugly hack, but at the same time is way more robust than
        // checking the sender parameters before and after the createOffer
        // Also note that after the createoffer we are not 100% sure that
        // the params were asynchronously applied so we might miss the
        // opportunity to recreate offer.
        var sender = transceiver.sender;

        var params = sender.getParameters();
        if (!('encodings' in params) ||
        // Avoid being fooled by patched getParameters() below.
        params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
          params.encodings = initParameters.sendEncodings;
          sender.sendEncodings = initParameters.sendEncodings;
          this.setParametersPromises.push(sender.setParameters(params).then(function () {
            delete sender.sendEncodings;
          }).catch(function () {
            delete sender.sendEncodings;
          }));
        }
      }
      return transceiver;
    };
  }
}

function shimGetParameters(window) {
  if (!(typeof window === 'object' && window.RTCRtpSender)) {
    return;
  }
  var origGetParameters = window.RTCRtpSender.prototype.getParameters;
  if (origGetParameters) {
    window.RTCRtpSender.prototype.getParameters = function getParameters() {
      var params = origGetParameters.apply(this, arguments);
      if (!('encodings' in params)) {
        params.encodings = [].concat(this.sendEncodings || [{}]);
      }
      return params;
    };
  }
}

function shimCreateOffer(window) {
  // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
  // Firefox ignores the init sendEncodings options passed to addTransceiver
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
  if (!(typeof window === 'object' && window.RTCPeerConnection)) {
    return;
  }
  var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
  window.RTCPeerConnection.prototype.createOffer = function createOffer() {
    var _this4 = this,
        _arguments = arguments;

    if (this.setParametersPromises && this.setParametersPromises.length) {
      return Promise.all(this.setParametersPromises).then(function () {
        return origCreateOffer.apply(_this4, _arguments);
      }).finally(function () {
        _this4.setParametersPromises = [];
      });
    }
    return origCreateOffer.apply(this, arguments);
  };
}

function shimCreateAnswer(window) {
  // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
  // Firefox ignores the init sendEncodings options passed to addTransceiver
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
  if (!(typeof window === 'object' && window.RTCPeerConnection)) {
    return;
  }
  var origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
  window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
    var _this5 = this,
        _arguments2 = arguments;

    if (this.setParametersPromises && this.setParametersPromises.length) {
      return Promise.all(this.setParametersPromises).then(function () {
        return origCreateAnswer.apply(_this5, _arguments2);
      }).finally(function () {
        _this5.setParametersPromises = [];
      });
    }
    return origCreateAnswer.apply(this, arguments);
  };
}
// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/safari/safari_shim.js
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


var safari_shim__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function shimLocalStreamsAPI(window) {
  if (typeof window !== 'object' || !window.RTCPeerConnection) {
    return;
  }
  if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
      if (!this._localStreams) {
        this._localStreams = [];
      }
      return this._localStreams;
    };
  }
  if (!('addStream' in window.RTCPeerConnection.prototype)) {
    var _addTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
      var _this = this;

      if (!this._localStreams) {
        this._localStreams = [];
      }
      if (!this._localStreams.includes(stream)) {
        this._localStreams.push(stream);
      }
      // Try to emulate Chrome's behaviour of adding in audio-video order.
      // Safari orders by track id.
      stream.getAudioTracks().forEach(function (track) {
        return _addTrack.call(_this, track, stream);
      });
      stream.getVideoTracks().forEach(function (track) {
        return _addTrack.call(_this, track, stream);
      });
    };

    window.RTCPeerConnection.prototype.addTrack = function addTrack(track) {
      var _this2 = this;

      for (var _len = arguments.length, streams = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        streams[_key - 1] = arguments[_key];
      }

      if (streams) {
        streams.forEach(function (stream) {
          if (!_this2._localStreams) {
            _this2._localStreams = [stream];
          } else if (!_this2._localStreams.includes(stream)) {
            _this2._localStreams.push(stream);
          }
        });
      }
      return _addTrack.apply(this, arguments);
    };
  }
  if (!('removeStream' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
      var _this3 = this;

      if (!this._localStreams) {
        this._localStreams = [];
      }
      var index = this._localStreams.indexOf(stream);
      if (index === -1) {
        return;
      }
      this._localStreams.splice(index, 1);
      var tracks = stream.getTracks();
      this.getSenders().forEach(function (sender) {
        if (tracks.includes(sender.track)) {
          _this3.removeTrack(sender);
        }
      });
    };
  }
}

function shimRemoteStreamsAPI(window) {
  if (typeof window !== 'object' || !window.RTCPeerConnection) {
    return;
  }
  if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
      return this._remoteStreams ? this._remoteStreams : [];
    };
  }
  if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
      get: function get() {
        return this._onaddstream;
      },
      set: function set(f) {
        var _this4 = this;

        if (this._onaddstream) {
          this.removeEventListener('addstream', this._onaddstream);
          this.removeEventListener('track', this._onaddstreampoly);
        }
        this.addEventListener('addstream', this._onaddstream = f);
        this.addEventListener('track', this._onaddstreampoly = function (e) {
          e.streams.forEach(function (stream) {
            if (!_this4._remoteStreams) {
              _this4._remoteStreams = [];
            }
            if (_this4._remoteStreams.includes(stream)) {
              return;
            }
            _this4._remoteStreams.push(stream);
            var event = new Event('addstream');
            event.stream = stream;
            _this4.dispatchEvent(event);
          });
        });
      }
    });
    var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
      var pc = this;
      if (!this._onaddstreampoly) {
        this.addEventListener('track', this._onaddstreampoly = function (e) {
          e.streams.forEach(function (stream) {
            if (!pc._remoteStreams) {
              pc._remoteStreams = [];
            }
            if (pc._remoteStreams.indexOf(stream) >= 0) {
              return;
            }
            pc._remoteStreams.push(stream);
            var event = new Event('addstream');
            event.stream = stream;
            pc.dispatchEvent(event);
          });
        });
      }
      return origSetRemoteDescription.apply(pc, arguments);
    };
  }
}

function shimCallbacksAPI(window) {
  if (typeof window !== 'object' || !window.RTCPeerConnection) {
    return;
  }
  var prototype = window.RTCPeerConnection.prototype;
  var origCreateOffer = prototype.createOffer;
  var origCreateAnswer = prototype.createAnswer;
  var setLocalDescription = prototype.setLocalDescription;
  var setRemoteDescription = prototype.setRemoteDescription;
  var addIceCandidate = prototype.addIceCandidate;

  prototype.createOffer = function createOffer(successCallback, failureCallback) {
    var options = arguments.length >= 2 ? arguments[2] : arguments[0];
    var promise = origCreateOffer.apply(this, [options]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };

  prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
    var options = arguments.length >= 2 ? arguments[2] : arguments[0];
    var promise = origCreateAnswer.apply(this, [options]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };

  var withCallback = function withCallback(description, successCallback, failureCallback) {
    var promise = setLocalDescription.apply(this, [description]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.setLocalDescription = withCallback;

  withCallback = function withCallback(description, successCallback, failureCallback) {
    var promise = setRemoteDescription.apply(this, [description]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.setRemoteDescription = withCallback;

  withCallback = function withCallback(candidate, successCallback, failureCallback) {
    var promise = addIceCandidate.apply(this, [candidate]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.addIceCandidate = withCallback;
}

function safari_shim_shimGetUserMedia(window) {
  var navigator = window && window.navigator;

  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    // shim not needed in Safari 12.1
    var mediaDevices = navigator.mediaDevices;
    var _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
    navigator.mediaDevices.getUserMedia = function (constraints) {
      return _getUserMedia(shimConstraints(constraints));
    };
  }

  if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    navigator.getUserMedia = function getUserMedia(constraints, cb, errcb) {
      navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }.bind(navigator);
  }
}

function shimConstraints(constraints) {
  if (constraints && constraints.video !== undefined) {
    return safari_shim__extends({}, constraints, { video: compactObject(constraints.video) });
  }

  return constraints;
}

function shimRTCIceServerUrls(window) {
  if (!window.RTCPeerConnection) {
    return;
  }
  // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
  var OrigPeerConnection = window.RTCPeerConnection;
  window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
    if (pcConfig && pcConfig.iceServers) {
      var newIceServers = [];
      for (var i = 0; i < pcConfig.iceServers.length; i++) {
        var server = pcConfig.iceServers[i];
        if (!server.hasOwnProperty('urls') && server.hasOwnProperty('url')) {
          deprecated('RTCIceServer.url', 'RTCIceServer.urls');
          server = JSON.parse(JSON.stringify(server));
          server.urls = server.url;
          delete server.url;
          newIceServers.push(server);
        } else {
          newIceServers.push(pcConfig.iceServers[i]);
        }
      }
      pcConfig.iceServers = newIceServers;
    }
    return new OrigPeerConnection(pcConfig, pcConstraints);
  };
  window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
  // wrap static methods. Currently just generateCertificate.
  if ('generateCertificate' in OrigPeerConnection) {
    Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
      get: function get() {
        return OrigPeerConnection.generateCertificate;
      }
    });
  }
}

function shimTrackEventTransceiver(window) {
  // Add event.transceiver member over deprecated event.receiver
  if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
      get: function get() {
        return { receiver: this.receiver };
      }
    });
  }
}

function shimCreateOfferLegacy(window) {
  var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
  window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
    if (offerOptions) {
      if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
        // support bit values
        offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
      }
      var audioTransceiver = this.getTransceivers().find(function (transceiver) {
        return transceiver.receiver.track.kind === 'audio';
      });
      if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
        if (audioTransceiver.direction === 'sendrecv') {
          if (audioTransceiver.setDirection) {
            audioTransceiver.setDirection('sendonly');
          } else {
            audioTransceiver.direction = 'sendonly';
          }
        } else if (audioTransceiver.direction === 'recvonly') {
          if (audioTransceiver.setDirection) {
            audioTransceiver.setDirection('inactive');
          } else {
            audioTransceiver.direction = 'inactive';
          }
        }
      } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) {
        this.addTransceiver('audio', { direction: 'recvonly' });
      }

      if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
        // support bit values
        offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
      }
      var videoTransceiver = this.getTransceivers().find(function (transceiver) {
        return transceiver.receiver.track.kind === 'video';
      });
      if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
        if (videoTransceiver.direction === 'sendrecv') {
          if (videoTransceiver.setDirection) {
            videoTransceiver.setDirection('sendonly');
          } else {
            videoTransceiver.direction = 'sendonly';
          }
        } else if (videoTransceiver.direction === 'recvonly') {
          if (videoTransceiver.setDirection) {
            videoTransceiver.setDirection('inactive');
          } else {
            videoTransceiver.direction = 'inactive';
          }
        }
      } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) {
        this.addTransceiver('video', { direction: 'recvonly' });
      }
    }
    return origCreateOffer.apply(this, arguments);
  };
}

function shimAudioContext(window) {
  if (typeof window !== 'object' || window.AudioContext) {
    return;
  }
  window.AudioContext = window.webkitAudioContext;
}
// EXTERNAL MODULE: ../node_modules/sdp/sdp.js
var sdp = __webpack_require__("YHvh");
var sdp_default = /*#__PURE__*/__webpack_require__.n(sdp);

// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/common_shim.js
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */


var common_shim__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function shimRTCIceCandidate(window) {
  // foundation is arbitrarily chosen as an indicator for full support for
  // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
  if (!window.RTCIceCandidate || window.RTCIceCandidate && 'foundation' in window.RTCIceCandidate.prototype) {
    return;
  }

  var NativeRTCIceCandidate = window.RTCIceCandidate;
  window.RTCIceCandidate = function RTCIceCandidate(args) {
    // Remove the a= which shouldn't be part of the candidate string.
    if (typeof args === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
      args = JSON.parse(JSON.stringify(args));
      args.candidate = args.candidate.substr(2);
    }

    if (args.candidate && args.candidate.length) {
      // Augment the native candidate with the parsed fields.
      var nativeCandidate = new NativeRTCIceCandidate(args);
      var parsedCandidate = sdp_default.a.parseCandidate(args.candidate);
      var augmentedCandidate = common_shim__extends(nativeCandidate, parsedCandidate);

      // Add a serializer that does not serialize the extra attributes.
      augmentedCandidate.toJSON = function toJSON() {
        return {
          candidate: augmentedCandidate.candidate,
          sdpMid: augmentedCandidate.sdpMid,
          sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
          usernameFragment: augmentedCandidate.usernameFragment
        };
      };
      return augmentedCandidate;
    }
    return new NativeRTCIceCandidate(args);
  };
  window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;

  // Hook up the augmented candidate in onicecandidate and
  // addEventListener('icecandidate', ...)
  wrapPeerConnectionEvent(window, 'icecandidate', function (e) {
    if (e.candidate) {
      Object.defineProperty(e, 'candidate', {
        value: new window.RTCIceCandidate(e.candidate),
        writable: 'false'
      });
    }
    return e;
  });
}

function shimMaxMessageSize(window, browserDetails) {
  if (!window.RTCPeerConnection) {
    return;
  }

  if (!('sctp' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
      get: function get() {
        return typeof this._sctp === 'undefined' ? null : this._sctp;
      }
    });
  }

  var sctpInDescription = function sctpInDescription(description) {
    if (!description || !description.sdp) {
      return false;
    }
    var sections = sdp_default.a.splitSections(description.sdp);
    sections.shift();
    return sections.some(function (mediaSection) {
      var mLine = sdp_default.a.parseMLine(mediaSection);
      return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
    });
  };

  var getRemoteFirefoxVersion = function getRemoteFirefoxVersion(description) {
    // TODO: Is there a better solution for detecting Firefox?
    var match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
    if (match === null || match.length < 2) {
      return -1;
    }
    var version = parseInt(match[1], 10);
    // Test for NaN (yes, this is ugly)
    return version !== version ? -1 : version;
  };

  var getCanSendMaxMessageSize = function getCanSendMaxMessageSize(remoteIsFirefox) {
    // Every implementation we know can send at least 64 KiB.
    // Note: Although Chrome is technically able to send up to 256 KiB, the
    //       data does not reach the other peer reliably.
    //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
    var canSendMaxMessageSize = 65536;
    if (browserDetails.browser === 'firefox') {
      if (browserDetails.version < 57) {
        if (remoteIsFirefox === -1) {
          // FF < 57 will send in 16 KiB chunks using the deprecated PPID
          // fragmentation.
          canSendMaxMessageSize = 16384;
        } else {
          // However, other FF (and RAWRTC) can reassemble PPID-fragmented
          // messages. Thus, supporting ~2 GiB when sending.
          canSendMaxMessageSize = 2147483637;
        }
      } else if (browserDetails.version < 60) {
        // Currently, all FF >= 57 will reset the remote maximum message size
        // to the default value when a data channel is created at a later
        // stage. :(
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
        canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
      } else {
        // FF >= 60 supports sending ~2 GiB
        canSendMaxMessageSize = 2147483637;
      }
    }
    return canSendMaxMessageSize;
  };

  var getMaxMessageSize = function getMaxMessageSize(description, remoteIsFirefox) {
    // Note: 65536 bytes is the default value from the SDP spec. Also,
    //       every implementation we know supports receiving 65536 bytes.
    var maxMessageSize = 65536;

    // FF 57 has a slightly incorrect default remote max message size, so
    // we need to adjust it here to avoid a failure when sending.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
    if (browserDetails.browser === 'firefox' && browserDetails.version === 57) {
      maxMessageSize = 65535;
    }

    var match = sdp_default.a.matchPrefix(description.sdp, 'a=max-message-size:');
    if (match.length > 0) {
      maxMessageSize = parseInt(match[0].substr(19), 10);
    } else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) {
      // If the maximum message size is not present in the remote SDP and
      // both local and remote are Firefox, the remote peer can receive
      // ~2 GiB.
      maxMessageSize = 2147483637;
    }
    return maxMessageSize;
  };

  var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
  window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
    this._sctp = null;
    // Chrome decided to not expose .sctp in plan-b mode.
    // As usual, adapter.js has to do an 'ugly worakaround'
    // to cover up the mess.
    if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
      var _getConfiguration = this.getConfiguration(),
          sdpSemantics = _getConfiguration.sdpSemantics;

      if (sdpSemantics === 'plan-b') {
        Object.defineProperty(this, 'sctp', {
          get: function get() {
            return typeof this._sctp === 'undefined' ? null : this._sctp;
          },

          enumerable: true,
          configurable: true
        });
      }
    }

    if (sctpInDescription(arguments[0])) {
      // Check if the remote is FF.
      var isFirefox = getRemoteFirefoxVersion(arguments[0]);

      // Get the maximum message size the local peer is capable of sending
      var canSendMMS = getCanSendMaxMessageSize(isFirefox);

      // Get the maximum message size of the remote peer.
      var remoteMMS = getMaxMessageSize(arguments[0], isFirefox);

      // Determine final maximum message size
      var maxMessageSize = void 0;
      if (canSendMMS === 0 && remoteMMS === 0) {
        maxMessageSize = Number.POSITIVE_INFINITY;
      } else if (canSendMMS === 0 || remoteMMS === 0) {
        maxMessageSize = Math.max(canSendMMS, remoteMMS);
      } else {
        maxMessageSize = Math.min(canSendMMS, remoteMMS);
      }

      // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
      // attribute.
      var sctp = {};
      Object.defineProperty(sctp, 'maxMessageSize', {
        get: function get() {
          return maxMessageSize;
        }
      });
      this._sctp = sctp;
    }

    return origSetRemoteDescription.apply(this, arguments);
  };
}

function shimSendThrowTypeError(window) {
  if (!(window.RTCPeerConnection && 'createDataChannel' in window.RTCPeerConnection.prototype)) {
    return;
  }

  // Note: Although Firefox >= 57 has a native implementation, the maximum
  //       message size can be reset for all data channels at a later stage.
  //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831

  function wrapDcSend(dc, pc) {
    var origDataChannelSend = dc.send;
    dc.send = function send() {
      var data = arguments[0];
      var length = data.length || data.size || data.byteLength;
      if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) {
        throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
      }
      return origDataChannelSend.apply(dc, arguments);
    };
  }
  var origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
  window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
    var dataChannel = origCreateDataChannel.apply(this, arguments);
    wrapDcSend(dataChannel, this);
    return dataChannel;
  };
  wrapPeerConnectionEvent(window, 'datachannel', function (e) {
    wrapDcSend(e.channel, e.target);
    return e;
  });
}

/* shims RTCConnectionState by pretending it is the same as iceConnectionState.
 * See https://bugs.chromium.org/p/webrtc/issues/detail?id=6145#c12
 * for why this is a valid hack in Chrome. In Firefox it is slightly incorrect
 * since DTLS failures would be hidden. See
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1265827
 * for the Firefox tracking bug.
 */
function shimConnectionState(window) {
  if (!window.RTCPeerConnection || 'connectionState' in window.RTCPeerConnection.prototype) {
    return;
  }
  var proto = window.RTCPeerConnection.prototype;
  Object.defineProperty(proto, 'connectionState', {
    get: function get() {
      return {
        completed: 'connected',
        checking: 'connecting'
      }[this.iceConnectionState] || this.iceConnectionState;
    },

    enumerable: true,
    configurable: true
  });
  Object.defineProperty(proto, 'onconnectionstatechange', {
    get: function get() {
      return this._onconnectionstatechange || null;
    },
    set: function set(cb) {
      if (this._onconnectionstatechange) {
        this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
        delete this._onconnectionstatechange;
      }
      if (cb) {
        this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
      }
    },

    enumerable: true,
    configurable: true
  });

  ['setLocalDescription', 'setRemoteDescription'].forEach(function (method) {
    var origMethod = proto[method];
    proto[method] = function () {
      if (!this._connectionstatechangepoly) {
        this._connectionstatechangepoly = function (e) {
          var pc = e.target;
          if (pc._lastConnectionState !== pc.connectionState) {
            pc._lastConnectionState = pc.connectionState;
            var newEvent = new Event('connectionstatechange', e);
            pc.dispatchEvent(newEvent);
          }
          return e;
        };
        this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
      }
      return origMethod.apply(this, arguments);
    };
  });
}

function removeExtmapAllowMixed(window, browserDetails) {
  /* remove a=extmap-allow-mixed for webrtc.org < M71 */
  if (!window.RTCPeerConnection) {
    return;
  }
  if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) {
    return;
  }
  if (browserDetails.browser === 'safari' && browserDetails.version >= 605) {
    return;
  }
  var nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
  window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
    if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
      var sdp = desc.sdp.split('\n').filter(function (line) {
        return line.trim() !== 'a=extmap-allow-mixed';
      }).join('\n');
      // Safari enforces read-only-ness of RTCSessionDescription fields.
      if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) {
        arguments[0] = new window.RTCSessionDescription({
          type: desc.type,
          sdp: sdp
        });
      } else {
        desc.sdp = sdp;
      }
    }
    return nativeSRD.apply(this, arguments);
  };
}

function shimAddIceCandidateNullOrEmpty(window, browserDetails) {
  // Support for addIceCandidate(null or undefined)
  // as well as addIceCandidate({candidate: "", ...})
  // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
  // Note: must be called before other polyfills which change the signature.
  if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) {
    return;
  }
  var nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
  if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) {
    return;
  }
  window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
    if (!arguments[0]) {
      if (arguments[1]) {
        arguments[1].apply(null);
      }
      return Promise.resolve();
    }
    // Firefox 68+ emits and processes {candidate: "", ...}, ignore
    // in older versions.
    // Native support for ignoring exists for Chrome M77+.
    // Safari ignores as well, exact version unknown but works in the same
    // version that also ignores addIceCandidate(null).
    if ((browserDetails.browser === 'chrome' && browserDetails.version < 78 || browserDetails.browser === 'firefox' && browserDetails.version < 68 || browserDetails.browser === 'safari') && arguments[0] && arguments[0].candidate === '') {
      return Promise.resolve();
    }
    return nativeAddIceCandidate.apply(this, arguments);
  };
}

// Note: Make sure to call this ahead of APIs that modify
// setLocalDescription.length
function shimParameterlessSetLocalDescription(window, browserDetails) {
  if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) {
    return;
  }
  var nativeSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
  if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) {
    return;
  }
  window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
    var _this = this;

    var desc = arguments[0] || {};
    if (typeof desc !== 'object' || desc.type && desc.sdp) {
      return nativeSetLocalDescription.apply(this, arguments);
    }
    // The remaining steps should technically happen when SLD comes off the
    // RTCPeerConnection's operations chain (not ahead of going on it), but
    // this is too difficult to shim. Instead, this shim only covers the
    // common case where the operations chain is empty. This is imperfect, but
    // should cover many cases. Rationale: Even if we can't reduce the glare
    // window to zero on imperfect implementations, there's value in tapping
    // into the perfect negotiation pattern that several browsers support.
    desc = { type: desc.type, sdp: desc.sdp };
    if (!desc.type) {
      switch (this.signalingState) {
        case 'stable':
        case 'have-local-offer':
        case 'have-remote-pranswer':
          desc.type = 'offer';
          break;
        default:
          desc.type = 'answer';
          break;
      }
    }
    if (desc.sdp || desc.type !== 'offer' && desc.type !== 'answer') {
      return nativeSetLocalDescription.apply(this, [desc]);
    }
    var func = desc.type === 'offer' ? this.createOffer : this.createAnswer;
    return func.apply(this).then(function (d) {
      return nativeSetLocalDescription.apply(_this, [d]);
    });
  };
}
// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/adapter_factory.js
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


// Browser shims.






// Shimming starts here.
function adapterFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      window = _ref.window;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    shimChrome: true,
    shimFirefox: true,
    shimSafari: true
  };

  // Utils.
  var logging = log;
  var browserDetails = detectBrowser(window);

  var adapter = {
    browserDetails: browserDetails,
    commonShim: common_shim_namespaceObject,
    extractVersion: extractVersion,
    disableLog: disableLog,
    disableWarnings: disableWarnings,
    // Expose sdp as a convenience. For production apps include directly.
    sdp: sdp
  };

  // Shim browser if found.
  switch (browserDetails.browser) {
    case 'chrome':
      if (!chrome_shim_namespaceObject || !shimPeerConnection || !options.shimChrome) {
        logging('Chrome shim is not included in this adapter release.');
        return adapter;
      }
      if (browserDetails.version === null) {
        logging('Chrome shim can not determine version, not shimming.');
        return adapter;
      }
      logging('adapter.js shimming chrome.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = chrome_shim_namespaceObject;

      // Must be called before shimPeerConnection.
      shimAddIceCandidateNullOrEmpty(window, browserDetails);
      shimParameterlessSetLocalDescription(window, browserDetails);

      shimGetUserMedia(window, browserDetails);
      shimMediaStream(window, browserDetails);
      shimPeerConnection(window, browserDetails);
      shimOnTrack(window, browserDetails);
      shimAddTrackRemoveTrack(window, browserDetails);
      shimGetSendersWithDtmf(window, browserDetails);
      shimGetStats(window, browserDetails);
      shimSenderReceiverGetStats(window, browserDetails);
      fixNegotiationNeeded(window, browserDetails);

      shimRTCIceCandidate(window, browserDetails);
      shimConnectionState(window, browserDetails);
      shimMaxMessageSize(window, browserDetails);
      shimSendThrowTypeError(window, browserDetails);
      removeExtmapAllowMixed(window, browserDetails);
      break;
    case 'firefox':
      if (!firefox_shim_namespaceObject || !firefox_shim_shimPeerConnection || !options.shimFirefox) {
        logging('Firefox shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming firefox.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = firefox_shim_namespaceObject;

      // Must be called before shimPeerConnection.
      shimAddIceCandidateNullOrEmpty(window, browserDetails);
      shimParameterlessSetLocalDescription(window, browserDetails);

      getusermedia_shimGetUserMedia(window, browserDetails);
      firefox_shim_shimPeerConnection(window, browserDetails);
      firefox_shim_shimOnTrack(window, browserDetails);
      shimRemoveStream(window, browserDetails);
      shimSenderGetStats(window, browserDetails);
      shimReceiverGetStats(window, browserDetails);
      shimRTCDataChannel(window, browserDetails);
      shimAddTransceiver(window, browserDetails);
      shimGetParameters(window, browserDetails);
      shimCreateOffer(window, browserDetails);
      shimCreateAnswer(window, browserDetails);

      shimRTCIceCandidate(window, browserDetails);
      shimConnectionState(window, browserDetails);
      shimMaxMessageSize(window, browserDetails);
      shimSendThrowTypeError(window, browserDetails);
      break;
    case 'safari':
      if (!safari_shim_namespaceObject || !options.shimSafari) {
        logging('Safari shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming safari.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = safari_shim_namespaceObject;

      // Must be called before shimCallbackAPI.
      shimAddIceCandidateNullOrEmpty(window, browserDetails);
      shimParameterlessSetLocalDescription(window, browserDetails);

      shimRTCIceServerUrls(window, browserDetails);
      shimCreateOfferLegacy(window, browserDetails);
      shimCallbacksAPI(window, browserDetails);
      shimLocalStreamsAPI(window, browserDetails);
      shimRemoteStreamsAPI(window, browserDetails);
      shimTrackEventTransceiver(window, browserDetails);
      safari_shim_shimGetUserMedia(window, browserDetails);
      shimAudioContext(window, browserDetails);

      shimRTCIceCandidate(window, browserDetails);
      shimMaxMessageSize(window, browserDetails);
      shimSendThrowTypeError(window, browserDetails);
      removeExtmapAllowMixed(window, browserDetails);
      break;
    default:
      logging('Unsupported browser!');
      break;
  }

  return adapter;
}
// CONCATENATED MODULE: ../node_modules/webrtc-adapter/src/js/adapter_core.js
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */





var adapter_core_adapter = adapterFactory({ window: typeof window === 'undefined' ? undefined : window });
/* harmony default export */ var adapter_core = (adapter_core_adapter);
// EXTERNAL MODULE: ../node_modules/push.js/bin/push.min.js
var push_min = __webpack_require__("BLQp");
var push_min_default = /*#__PURE__*/__webpack_require__.n(push_min);

// EXTERNAL MODULE: ../node_modules/react-notifications-component/dist/index.js
var dist = __webpack_require__("50ot");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ../node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("2JJl");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// EXTERNAL MODULE: ../node_modules/@bugfender/sdk/lib/index.js
var lib = __webpack_require__("FFyX");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./utils/logger.js
var logger = __webpack_require__("cxRM");

// EXTERNAL MODULE: ./utils/media-session.js
var media_session = __webpack_require__("69EM");

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var preact_router_match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(preact_router_match);

// EXTERNAL MODULE: ../node_modules/react-fontawesome/lib/index.js
var react_fontawesome_lib = __webpack_require__("piIy");
var react_fontawesome_lib_default = /*#__PURE__*/__webpack_require__.n(react_fontawesome_lib);

// EXTERNAL MODULE: ../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__("lB5c");
var modules_default = /*#__PURE__*/__webpack_require__.n(modules);

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__("9qb7");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./utils/langPack.js
var langPack = __webpack_require__("9dRJ");

// EXTERNAL MODULE: ../node_modules/react-easy-emoji/index.js
var react_easy_emoji = __webpack_require__("IyTP");
var react_easy_emoji_default = /*#__PURE__*/__webpack_require__.n(react_easy_emoji);

// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// EXTERNAL MODULE: ./components/global/header/style.scss
var style = __webpack_require__("650N");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/global/header/select.js













var renderExcept = function renderExcept(elem) {
    var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return isLocale ? arr.filter(function (el) {
        return el !== elem;
    }) : arr.filter(function (el) {});
};

var select_renderServices = function renderServices(_ref) {
    var curUrl = _ref.curUrl,
        locale = _ref.locale;

    var item = '',
        listItems = '',
        urlStr = curUrl.toString();

    if (urlStr.indexOf(routes.LANGUAGE_PRACTICE) + 1) {
        item = langPack["a" /* langPack */][locale].SERVICES.LANGUAGE_PRACTICE;
        listItems = [Object(preact_min["h"])(
            'li',
            null,
            Object(preact_min["h"])(
                preact_router_match["Link"],
                { href: app_langRoutes(consts["G" /* langs */][locale].code, routes.IMMIGRATION_CONSULTANT) },
                langPack["a" /* langPack */][locale].SERVICES.IMMIGRATION_CONSULTANT
            )
        )];
    } else if (urlStr.indexOf(routes.IMMIGRATION_CONSULTANT) + 1) {
        item = langPack["a" /* langPack */][locale].SERVICES.IMMIGRATION_CONSULTANT;
        listItems = [Object(preact_min["h"])(
            'li',
            null,
            Object(preact_min["h"])(
                preact_router_match["Link"],
                { href: app_langRoutes(consts["G" /* langs */][locale].code, routes.LANGUAGE_PRACTICE) },
                langPack["a" /* langPack */][locale].SERVICES.LANGUAGE_PRACTICE
            )
        )];
    } else if (urlStr.indexOf(routes.LANGUAGE_LEARNERS) + 1) {
        item = langPack["a" /* langPack */][locale].SERVICES.LANGUAGE_LEARNERS;
        listItems = [Object(preact_min["h"])(
            'li',
            null,
            Object(preact_min["h"])(
                preact_router_match["Link"],
                { href: app_langRoutes(consts["G" /* langs */][locale].code, routes.IMMIGRATION_ADVICE) },
                langPack["a" /* langPack */][locale].SERVICES.IMMIGRATION_ADVICE
            )
        )];
    } else if (urlStr.indexOf(routes.IMMIGRATION_ADVICE) + 1) {
        item = langPack["a" /* langPack */][locale].SERVICES.IMMIGRATION_ADVICE;
        listItems = [Object(preact_min["h"])(
            'li',
            null,
            Object(preact_min["h"])(
                preact_router_match["Link"],
                { href: app_langRoutes(consts["G" /* langs */][locale].code, routes.LANGUAGE_LEARNERS) },
                langPack["a" /* langPack */][locale].SERVICES.LANGUAGE_LEARNERS
            )
        )];
    }
    return { item: item, listItems: listItems };
};

var select_renderLocale = function renderLocale(props) {
    var changeLocalization = function changeLocalization(lang) {
        return function () {
            props.changeLocale(lang);
            switch (props.locale) {
                case consts["g" /* EN */]:
                    !(window.location.pathname.toString().indexOf('/blog/') + 1) && Object(preact_router_es["route"])(app_langRoutes(consts["G" /* langs */][lang].code, window.location.pathname));
                    break;
                default:
                    var _link = '/' + window.location.pathname.split('/').slice(2).join('/');
                    !(_link.toString().indexOf('/blog/') + 1) && Object(preact_router_es["route"])(app_langRoutes(consts["G" /* langs */][lang].code, _link));
                    break;
            };
        };
    };
    var renderLocaleItem = function renderLocaleItem(el) {
        return [react_easy_emoji_default()(el.emoji, function (code) {
            return Object(preact_min["h"])('div', { 'class': style_default.a.flagContainer,
                style: { backgroundImage: 'url(https://twemoji.maxcdn.com/2/svg/' + code + '.svg)' } });
        }), el.name];
    };

    var item = '',
        listItems = [];

    item = renderLocaleItem(consts["G" /* langs */][props.locale]);

    listItems = renderExcept(props.locale, props.languages, true).map(function (el) {
        return Object(preact_min["h"])(
            'li',
            { onClick: changeLocalization(consts["G" /* langs */][el] && consts["G" /* langs */][el].lang), key: consts["G" /* langs */][el] && consts["G" /* langs */][el].code },
            consts["G" /* langs */][el] && renderLocaleItem(consts["G" /* langs */][el])
        );
    });

    return { item: item, listItems: listItems };
};

var _ref3 = Object(preact_min["h"])(react_fontawesome_lib_default.a, { name: 'angle-down' });

var select_Select = function Select(props) {
    var _ref2 = props.isLocale ? select_renderLocale(props) : select_renderServices(props),
        item = _ref2.item,
        listItems = _ref2.listItems;

    return Object(preact_min["h"])(
        'div',
        { 'class': props.isLocale ? style_default.a.title + ' ' + style_default.a.localeSelect : style_default.a.title },
        item,
        listItems.length > 0 && [_ref3, Object(preact_min["h"])(
            'ul',
            null,
            listItems
        )]
    );
};

/* harmony default export */ var header_select = (select_Select);
// EXTERNAL MODULE: ./components/hr/index.js
var hr = __webpack_require__("oBX1");

// EXTERNAL MODULE: ./api/index.js
var api_0 = __webpack_require__("/C1n");

// EXTERNAL MODULE: ./actions/user.js
var actions_user = __webpack_require__("qpDm");

// EXTERNAL MODULE: ./components/global/redirect/index.js
var redirect = __webpack_require__("MJVJ");

// EXTERNAL MODULE: ./utils/prismic-middleware.js
var prismic_middleware = __webpack_require__("51Pw");

// EXTERNAL MODULE: ./actions/pros.js
var pros = __webpack_require__("wkTU");

// EXTERNAL MODULE: ./actions/sectors.js + 1 modules
var actions_sectors = __webpack_require__("FD18");

// EXTERNAL MODULE: ./components/search/input/index.js
var input = __webpack_require__("31EJ");

// EXTERNAL MODULE: ./components/radio-buttons/leftSideBar.js
var leftSideBar = __webpack_require__("6nxu");

// CONCATENATED MODULE: ./components/global/header/searchPros.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var searchPros_SearchPros = function (_Component) {
  _inherits(SearchPros, _Component);

  function SearchPros(props) {
    _classCallCheck(this, SearchPros);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.convertSectors = function (sectors) {
      var data = [].concat(sectors);
      data.name = 'SECTORS';
      return data;
    };

    _this.state = {
      sectors: _this.convertSectors(_this.props.sectors.sectors)
    };
    return _this;
  }

  SearchPros.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        userAuth = _props.userData.userAuth,
        fetchSectors = _props.fetchSectors,
        sectors = _props.sectors.sectors;

    if (!sectors.length) {
      fetchSectors(userAuth);
    }
  };

  SearchPros.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextPros) {
    var _props2 = this.props,
        sectors = _props2.sectors.sectors,
        filter = _props2.filter;
    var newSectors = nextPros.sectors.sectors,
        newFilter = nextPros.filter,
        updateUserSettings = nextPros.updateUserSettings,
        getPros = nextPros.getPros;

    if (newFilter && filter !== newFilter) {
      getPros();
      var splitedFilter = newFilter.split('.');
      updateUserSettings({ interestSector: [splitedFilter[0]], interestCategory: splitedFilter[1] ? [splitedFilter[1]] : [] });
    }

    if (!sectors.length && newSectors.length) {
      this.setState({
        sectors: this.convertSectors(newSectors)
      });
    }
  };

  SearchPros.prototype.render = function render(_ref, _ref2) {
    var changeSearchParams = _ref.changeSearchParams,
        getPros = _ref.getPros,
        _ref$filter = _ref.filter,
        filter = _ref$filter === undefined ? '' : _ref$filter,
        searchTerm = _ref.searchTerm;
    var sectors = _ref2.sectors;

    return Object(preact_min["h"])(
      'div',
      { className: style_default.a.searchPros },
      Object(preact_min["h"])(
        'div',
        { className: style_default.a.sideBar },
        Object(preact_min["h"])(leftSideBar["a" /* default */], {
          data: sectors,
          onChange: function onChange(value) {
            return changeSearchParams({
              type: 'filter',
              value: value
            });
          },
          value: { radio: filter },
          locale: this.props.locale,
          valueField: 'tag'
        })
      ),
      Object(preact_min["h"])(
        'div',
        { className: style_default.a.searchInput },
        Object(preact_min["h"])(input["a" /* default */], {
          value: searchTerm,
          onSearch: getPros,
          onChange: function onChange(value) {
            return changeSearchParams({
              type: 'searchTerm',
              value: value
            });
          },
          locale: this.props.locale
        })
      )
    );
  };

  return SearchPros;
}(preact_min["Component"]);

var searchPros_mapStateToProps = function mapStateToProps(state) {
  return {
    filter: state.pros.filter,
    searchTerm: state.pros.searchTerm,
    sectors: state.sectors,
    userData: state.loggedInUser,
    locale: state.locale.locale
  };
};

var searchPros_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(es["bindActionCreators"])({
    getPros: pros["b" /* getPros */],
    changeSearchParams: pros["a" /* changeSearchParams */],
    fetchSectors: actions_sectors["a" /* fetchSectors */],
    updateUserSettings: actions_user["F" /* updateUserSettings */]
  }, dispatch);
};

/* harmony default export */ var searchPros = (Object(preact_redux_esm["b" /* connect */])(searchPros_mapStateToProps, searchPros_mapDispatchToProps)(searchPros_SearchPros));
// CONCATENATED MODULE: ./utils/set-class-names.js
/*
Adapted from https://github.com/vacarsu/uikit-react

Copyright 2018 Alex Lopez

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files
(the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

/* eslint-disable no-unneeded-ternary */


var classNames = classnames;

var set_class_names_setClassNames = function setClassNames(props) {
  var _classNames2;

  var isClassNameSet = props.className ? true : false;
  var isHeightSet = props.height ? true : false;
  var isWidthSet = props.width ? true : false;
  var isAlignSet = props.align ? true : false;
  var isBackgroundSet = props.background ? true : false;
  var isPositionSet = props.position ? true : false;

  return classNames((_classNames2 = {}, _classNames2['' + props.className] = isClassNameSet, _classNames2['uk-align-' + props.align] = isAlignSet, _classNames2['uk-height-' + props.height] = isHeightSet, _classNames2['uk-width-' + props.width] = isWidthSet, _classNames2['uk-background-' + props.background] = isBackgroundSet, _classNames2['uk-position-' + props.position] = isPositionSet, _classNames2));
};

/* harmony default export */ var set_class_names = (set_class_names_setClassNames);
// EXTERNAL MODULE: ./components/ui/alert/style.scss
var alert_style = __webpack_require__("CWTV");
var alert_style_default = /*#__PURE__*/__webpack_require__.n(alert_style);

// CONCATENATED MODULE: ./components/ui/alert/index.js
var alert__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function alert__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function alert__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function alert__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Adapted from https://github.com/vacarsu/uikit-react

Copyright 2018 Alex Lopez

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files
(the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */

/** @jsx h */







var alert_classNames = classnames;

var alert_Alert = function (_Component) {
  alert__inherits(Alert, _Component);

  function Alert(props) {
    alert__classCallCheck(this, Alert);

    var _this = alert__possibleConstructorReturn(this, _Component.call(this, props));

    _this.durationTimeout = undefined;
    _this.leaveTimeout = undefined;

    _this.state = {
      isOpen: true,
      isClosed: false
    };
    return _this;
  }

  Alert.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.duration) {
      this.durationTimeout = setTimeout(function () {
        _this2.handleClose();
      }, this.props.duration);
    }
  };

  Alert.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.leaveTimeout) clearTimeout(this.leaveTimeout);
    if (this.durationTimeout) clearTimeout(this.durationTimeout);
  };

  Alert.prototype.setClassNames = function setClassNames() {
    var _classNames2, _classNames3, _classNames4;

    return alert_classNames((_classNames2 = {}, _classNames2['uk-alert-' + this.props.color] = !!this.props.color, _classNames2), 'uk-alert', (_classNames3 = {}, _classNames3[set_class_names(this.props)] = true, _classNames3), (_classNames4 = {}, _classNames4[alert_style_default.a.subHeaderFlexed] = !!this.props.children, _classNames4), alert_style_default.a.subHeader);
  };

  Alert.prototype.handleClose = function handleClose() {
    var _this3 = this;

    this.setState({
      isOpen: false
    }, function () {
      if (_this3.props.onBeforeHide) _this3.props.onBeforeHide();
      _this3.leaveTimeout = setTimeout(function () {
        _this3.setState({ isClosed: true });
        if (_this3.props.onHide) _this3.props.onHide();
      }, 505);
    });
  };

  Alert.prototype.render = function render() {
    if (this.state.isClosed) return false;

    return Object(preact_min["h"])(
      'div',
      {
        id: this.props.id ? this.props.id : null,
        className: this.setClassNames(),
        style: alert__extends({
          overflow: 'hidden',
          transition: 'height 0.5s ease-in-out, opacity 0.3s ease-in-out',
          height: !this.state.isOpen ? 0 : 'auto',
          opacity: !this.state.isOpen ? 0 : 1
        }, this.props.style),
        'data-uk-alert': true
      },
      this.props.isClosable ?
      // eslint-disable-next-line jsx-a11y/control-has-associated-label
      Object(preact_min["h"])('button', { className: 'uk-alert-close', type: 'button', onClick: this.handleClose.bind(this), 'data-uk-close': true }) : null,
      Object(preact_min["h"])(
        'p',
        null,
        this.props.content
      ),
      this.props.children
    );
  };

  return Alert;
}(preact_min["Component"]);

/* harmony default export */ var ui_alert = (alert_Alert);
// EXTERNAL MODULE: ./components/ui/button/index.js
var ui_button = __webpack_require__("qNd1");

// EXTERNAL MODULE: ./actions/chat.js + 1 modules
var chat = __webpack_require__("PcXO");

// CONCATENATED MODULE: ./components/global/header/index.js
var _class, header__temp, header__initialiseProps;



function header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/** @jsx h */









// eslint-disable-next-line import/no-cycle





// eslint-disable-next-line import/no-cycle



// eslint-disable-next-line import/no-cycle










var LANDING_HOST = 'https://www.telmie.com/';

var header__ref = Object(preact_min["h"])('img', { src: '/assets/logo.png', alt: 'Telmie App' });

var header__ref2 = Object(preact_min["h"])('span', null);

var header__ref3 = Object(preact_min["h"])('span', null);

var _ref4 = Object(preact_min["h"])('span', null);

var _ref5 = Object(preact_min["h"])(react_fontawesome_lib_default.a, { name: 'caret-down' });

var header__ref6 = Object(preact_min["h"])('li', { className: 'uk-nav-divider' });

var header__ref7 = Object(preact_min["h"])('img', { src: '/assets/logo.png', alt: 'Telmie App' });

var header__ref8 = Object(preact_min["h"])('span', null);

var _ref9 = Object(preact_min["h"])('span', null);

var _ref10 = Object(preact_min["h"])('span', null);

var _ref11 = Object(preact_min["h"])(hr["a" /* default */], { color: '#5C636E', height: 1 });

var _ref12 = Object(preact_min["h"])(hr["a" /* default */], { color: '#5C636E', height: 1 });

var _ref13 = Object(preact_min["h"])(searchPros, null);

var header_Header = (header__temp = _class = function (_Component) {
  header__inherits(Header, _Component);

  function Header(props) {
    header__classCallCheck(this, Header);

    var _this = header__possibleConstructorReturn(this, _Component.call(this, props));

    header__initialiseProps.call(_this);

    _this.state = {
      loggedOff: false,
      mobileMenuOpened: false,
      isTop: true,
      globalMessage: null,
      notificationMessage: null,
      workingAsProWarningDismissed: false
    };
    return _this;
  }

  Header.prototype.componentDidMount = function componentDidMount() {
    var that = this;
    window.addEventListener('scroll', this.handleScroll);
    preact_router_es["subscribers"].push(function () {
      that.setState({
        mobileMenuOpened: false
      });
    });

    this.props.prismicCtx && this.fetchPage(this.props);
  };

  Header.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (typeof this.props.userAuth !== 'undefined' && typeof nextProps.userAuth !== 'undefined') {
      if (Object.keys(this.props.userAuth).length !== 0 && Object.keys(nextProps.userAuth).length === 0) {
        this.setState({
          loggedOff: true,
          workingAsProWarningDismissed: false
        });
      } else {
        this.setState({
          loggedOff: false
        });
      }
    }

    if (this.props.prismicCtx == null && nextProps.prismicCtx != null || this.props.uid !== nextProps.uid) {
      this.fetchPage(nextProps);
    }

    if (nextProps.transactions.transactionId !== this.props.transactions.transactionId && nextProps.transactions.added) {
      var message = langPack["a" /* langPack */][this.props.locale.locale].HEADER.WELL_DONE + '! \xA3' + nextProps.transactions.added + ' ' + langPack["a" /* langPack */][this.props.locale.locale].HEADER.SUCCESSFULLY_ADDED_BALANCE + '!';
      this.setState({
        notificationMessage: message,
        transactionId: nextProps.transactions.transactionId
      });
      if (this.hideMessageInterval) {
        clearTimeout(this.hideMessageInterval);
      }

      /*
      * Hide global message
      * */
      this.hideMessageInterval = setTimeout(function () {
        if (_this2.state.transactionId === _this2.props.transactions.transactionId || !_this2.props.transactions.transactionId) {
          _this2.setState({
            notificationMessage: ''
          });
        }
      }, 5000);
    }

    if (nextProps.message && nextProps.message !== this.state.notificationMessage) {
      this.setState({
        notificationMessage: nextProps.message
      });
      this.hideMessageInterval = setTimeout(function () {
        if (nextProps.message === _this2.state.notificationMessage) {
          _this2.setState({
            notificationMessage: ''
          });
          nextProps.sendGlobalMessage('');
        }
      }, 5000);
    }

    var userIdWas = this.props.userData ? this.props.userData.id : undefined;
    var userIdIs = nextProps.userData ? nextProps.userData.id : undefined;
    var userWasPro = !!(this.props.userData.pro && this.props.userData.pro.proState);
    var userIsPro = !!(nextProps.userData.pro && nextProps.userData.pro.proState);
    var userWasWorkingAsPro = userWasPro ? this.props.userData.pro.proState.proWork : false;
    var userIsWorkingAsPro = userIsPro ? nextProps.userData.pro.proState.proWork : false;
    var isSameUser = !!(userIdWas && userIdIs && userIdWas === userIdIs || userIdWas === undefined && userIdWas === undefined);

    if (isSameUser && userWasPro && userWasWorkingAsPro && userIsPro && !userIsWorkingAsPro || !isSameUser) {
      this.setState({
        workingAsProWarningDismissed: false
      });
    }
  };

  Header.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  };

  Header.prototype.render = function render() {
    var _this3 = this,
        _cn;

    var _props = this.props,
        _props$userData = _props.userData,
        user = _props$userData === undefined ? {} : _props$userData,
        localeObj = _props.locale,
        currentUrl = _props.currentUrl,
        badges = _props.badges,
        applicationShouldUpdate = _props.applicationShouldUpdate;
    var languages = localeObj.languages;

    var locale = localeObj.locale || consts["g" /* EN */];
    var isLogin = !!user.id;
    var isAtHome = this.props.currentUrl === routes.HOME || Object.keys(consts["G" /* langs */]).some(function (el) {
      return _this3.props.currentUrl === app_langRoutes(consts["G" /* langs */][el].code, routes.HOME);
    }) || this.props.currentUrl.toString().indexOf('/#') === 0;

    var isAtBlog = this.props.currentUrl === routes.BLOG || !!(this.props.currentUrl.indexOf('/blog') + 1);
    var isServicePage = !!(this.props.currentUrl.toString().indexOf(routes.IMMIGRATION_CONSULTANT) + 1) || !!(this.props.currentUrl.toString().indexOf(routes.IMMIGRATION_ADVICE) + 1) || !!(this.props.currentUrl.toString().indexOf(routes.LANGUAGE_PRACTICE) + 1) || !!(this.props.currentUrl.toString().indexOf(routes.LANGUAGE_LEARNERS) + 1);
    var _state = this.state,
        globalMessage = _state.globalMessage,
        notificationMessage = _state.notificationMessage;


    var newChats = badges.data ? badges.data.totalMissedCall + badges.data.totalMissedMessage || '' : '';

    var isWorkingAsPro = user.pro && user.pro.proState && user.pro.proState.proWork;
    var isWorkingAsProWarningDismissed = this.state.workingAsProWarningDismissed;

    var displayNotWorkingAsProAlert = user.pro && !isWorkingAsPro && !isWorkingAsProWarningDismissed;

    return Object(preact_min["h"])(
      'header',
      {
        className: 'uk-navbar uk-navbar-container ' + (!this.state.isTop && style_default.a.smallHeader) + ' ' + (globalMessage && 'globalMessage') + ' ' + (displayNotWorkingAsProAlert && 'proAlert'),
        style: {
          width: '100%', position: 'fixed', zIndex: 200, margin: '0 auto', top: 0, display: 'flex', flexWrap: 'wrap'
        }
      },
      Object(preact_min["h"])(
        'div',
        { style: { display: 'flex', flexDirection: 'column', width: '100%' } },
        Object(preact_min["h"])(
          'div',
          { id: style_default.a.header },
          Object(preact_min["h"])('div', {
            id: style_default.a.mobileShadow,
            className: this.state.mobileMenuOpened ? style_default.a.opened : '',
            onClick: this.toggleMobileMenu
          }),
          Object(preact_min["h"])(
            'div',
            { className: style_default.a.navbarLeft + ' uk-navbar-left' },
            this.state.loggedOff && Object(preact_min["h"])(redirect["a" /* default */], { to: routes.LOG_IN }),
            Object(preact_min["h"])(
              'div',
              { className: style_default.a.logoWrapper },
              Object(preact_min["h"])(
                'a',
                { href: LANDING_HOST, id: style_default.a.logo },
                header__ref
              ),
              isAtBlog ? Object(preact_min["h"])(
                'b',
                { className: style_default.a.title },
                langPack["a" /* langPack */][locale].BLOG_TITLE
              ) : null,
              isServicePage && Object(preact_min["h"])(header_select, { locale: locale, curUrl: this.props.currentUrl }),
              !(isServicePage || isAtBlog) ? Object(preact_min["h"])(
                'span',
                { id: style_default.a.expandMobileMenu, className: this.state.mobileMenuOpened ? style_default.a.opened : '', onClick: this.toggleMobileMenu },
                header__ref2,
                header__ref3,
                _ref4
              ) : null
            ),
            Object(preact_min["h"])(
              'div',
              { className: style_default.a.leftNavWrapper },
              Object(preact_min["h"])(
                'ul',
                { className: 'uk-navbar-nav', id: style_default.a.leftNav },
                isLogin ? [Object(preact_min["h"])(
                  'li',
                  null,
                  Object(preact_min["h"])(
                    preact_router_match["Link"],
                    {
                      className: style_default.a.headerLink,
                      activeClassName: style_default.a.activeLink,
                      href: routes.FIND_PRO,
                      'data-style': 'oldStyle',
                      onClick: function onClick() {
                        return firebase.analytics().logEvent('Tap_menu_Find_a_Pros');
                      }
                    },
                    langPack["a" /* langPack */][locale].MISC.FIND_A_PRO
                  )
                ), user.pro !== null && Object(preact_min["h"])(
                  'li',
                  null,
                  Object(preact_min["h"])(
                    preact_router_match["Link"],
                    {
                      className: style_default.a.headerLink,
                      activeClassName: style_default.a.activeLink,
                      href: routes.MY_CLIENTS,
                      'data-style': 'oldStyle'
                    },
                    langPack["a" /* langPack */][locale].MISC.MY_CLIENTS
                  )
                ), Object(preact_min["h"])(
                  'li',
                  null,
                  Object(preact_min["h"])(
                    preact_router_match["Link"],
                    {
                      className: style_default.a.headerLink,
                      activeClassName: style_default.a.activeLink,
                      href: routes.MY_PROS,
                      onClick: function onClick() {
                        return firebase.analytics().logEvent('Tap_menu_My Pros');
                      },
                      'data-style': 'oldStyle'
                    },
                    langPack["a" /* langPack */][locale].MISC.MY_PROS
                  )
                ), Object(preact_min["h"])(
                  'li',
                  null,
                  Object(preact_min["h"])(
                    preact_router_match["Link"],
                    {
                      className: style_default.a.headerLink,
                      activeClassName: style_default.a.activeLink,
                      href: routes.MY_BOOKINGS,
                      onClick: function onClick() {
                        return firebase.analytics().logEvent('Tap_menu_My Bookings');
                      },
                      'data-style': 'oldStyle'
                    },
                    langPack["a" /* langPack */][locale].MISC.MY_APPOINTMENTS
                  )
                ), Object(preact_min["h"])(
                  'li',
                  null,
                  Object(preact_min["h"])(
                    preact_router_match["Link"],
                    {
                      className: style_default.a.headerLink,
                      activeClassName: style_default.a.activeLink,
                      href: routes.TRANSACTIONS,
                      'data-style': 'oldStyle',
                      onClick: function onClick() {
                        return firebase.analytics().logEvent('Tap_menu_Money_');
                      }
                    },
                    langPack["a" /* langPack */][locale].HEADER.MONEY
                  )
                ), user.pro === null && Object(preact_min["h"])(
                  'li',
                  null,
                  Object(preact_min["h"])(
                    preact_router_match["Link"],
                    {
                      className: style_default.a.headerLink,
                      activeClassName: style_default.a.activeLink,
                      href: routes.REGISTER_PRO,
                      'data-style': 'oldStyle',
                      onClick: function onClick() {
                        return firebase.analytics().logEvent('Tap_menu_Become_Pro_');
                      }
                    },
                    langPack["a" /* langPack */][locale].MISC.BECOME_PRO
                  )
                ), Object(preact_min["h"])(
                  'li',
                  null,
                  Object(preact_min["h"])(
                    preact_router_match["Link"],
                    {
                      className: style_default.a.headerLink,
                      activeClassName: style_default.a.activeLink,
                      href: routes.SETTINGS,
                      'data-style': 'oldStyle',
                      onClick: function onClick() {
                        return firebase.analytics().logEvent('Tap_menu_Settings');
                      }
                    },
                    langPack["a" /* langPack */][locale].HEADER.SETTINGS
                  )
                )] : null
              ),
              Object(preact_min["h"])(
                'div',
                { className: style_default.a.navbarRight + ' uk-navbar-right' },
                Object(preact_min["h"])(header_select, { isLocale: true, locale: locale, changeLocale: this.props.changeLocale, languages: languages }),
                !isLogin ? Object(preact_min["h"])(
                  'nav',
                  null,
                  Object(preact_min["h"])(
                    'ul',
                    { className: 'uk-navbar-nav' },
                    Object(preact_min["h"])(
                      'li',
                      null,
                      Object(preact_min["h"])(
                        'a',
                        { onClick: function onClick() {
                            return firebase.analytics().logEvent('Tap_Register');
                          }, id: style_default.a.signUp, 'data-style': 'oldStyle', href: 'https://www.telmie.com/download-app' },
                        langPack["a" /* langPack */][locale].MISC.SIGN_UP
                      )
                    ),
                    Object(preact_min["h"])(
                      'li',
                      null,
                      Object(preact_min["h"])(
                        preact_router_match["Link"],
                        { activeClassName: style_default.a.activeLink, 'data-style': 'oldStyle', href: routes.LOG_IN },
                        langPack["a" /* langPack */][locale].HEADER.LOGIN
                      )
                    )
                  )
                ) : Object(preact_min["h"])(
                  'div',
                  { className: style_default.a.loggedInContainer },
                  Object(preact_min["h"])(
                    'div',
                    { className: style_default.a.avatar },
                    user.avatar || user.imgUrl ? Object(preact_min["h"])('img', { src: user.avatar ? api_0["a" /* apiRoot */] + 'image/' + user.avatar.id : user.imgUrl ? user.imgUrl : '', alt: user.name + ' ' + user.lastName }) : Object(preact_min["h"])('img', { src: '/assets/nouserimage.jpg', alt: user.name + ' ' + user.lastName }),
                    newChats && Object(preact_min["h"])(
                      'div',
                      { className: style_default.a.newChats },
                      newChats
                    )
                  ),
                  Object(preact_min["h"])(
                    'div',
                    { className: 'mobile-hide' },
                    user.name,
                    ' ',
                    user.lastName
                  ),
                  _ref5,
                  Object(preact_min["h"])(
                    'div',
                    { className: style_default.a.dropdown + ' uk-dropdown' },
                    Object(preact_min["h"])(
                      'ul',
                      { className: 'uk-nav uk-dropdown-nav' },
                      Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                          preact_router_match["Link"],
                          { href: routes.EDIT_PROFILE },
                          langPack["a" /* langPack */][locale].HEADER.EDIT_PROFILE
                        )
                      ),
                      Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                          preact_router_match["Link"],
                          { href: routes.REGISTER_PRO },
                          user.pro ? langPack["a" /* langPack */][locale].HEADER.EDIT_PRO_DETAILS : langPack["a" /* langPack */][locale].MISC.REGISTER_AS_PRO
                        )
                      ),
                      Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                          preact_router_match["Link"],
                          { href: routes.SETTINGS, onClick: function onClick() {
                              return firebase.analytics().logEvent('Tap_menu_Settings');
                            } },
                          langPack["a" /* langPack */][locale].HEADER.SETTINGS
                        )
                      ),
                      newChats && Object(preact_min["h"])(
                        'li',
                        { className: style_default.a.chats, onClick: this.openComModal },
                        langPack["a" /* langPack */][locale].HEADER.NEW_CHATS,
                        ': ',
                        newChats
                      ),
                      header__ref6,
                      Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                          'a',
                          { onClick: this.logOff },
                          langPack["a" /* langPack */][locale].MISC.LOG_OUT
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          Object(preact_min["h"])(
            'div',
            { id: style_default.a.mobileNav, className: this.state.mobileMenuOpened ? style_default.a.opened : '' },
            Object(preact_min["h"])(
              'div',
              { className: style_default.a.mobileNavHeader },
              Object(preact_min["h"])(
                preact_router_match["Link"],
                { href: app_langRoutes(consts["G" /* langs */][locale].code, routes.HOME), id: style_default.a.logo },
                header__ref7
              ),
              Object(preact_min["h"])(
                'span',
                { id: style_default.a.expandMobileMenu, className: this.state.mobileMenuOpened ? style_default.a.opened : '', onClick: this.toggleMobileMenu },
                header__ref8,
                _ref9,
                _ref10
              )
            ),
            isAtHome ? Object(preact_min["h"])(
              modules["Link"],
              { spy: true, smooth: true, offset: globalMessage ? -90 : -30, duration: 500, to: 'howWorksElement', onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].HEADER.HOW_IT_WORKS
            ) : Object(preact_min["h"])(
              preact_router_match["Link"],
              { className: style_default.a.headerLink, 'data-style': 'oldStyle', href: app_langRoutes(consts["G" /* langs */][locale].code, routes.HOW_WORKS_LINK), onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].HEADER.HOW_IT_WORKS
            ),
            isAtHome && langPack["a" /* langPack */][locale].MISC.BECOME_PRO ? Object(preact_min["h"])(
              modules["Link"],
              { spy: true, smooth: true, offset: globalMessage ? -130 : -70, duration: 500, to: 'becomeProElement', onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].MISC.BECOME_PRO
            ) : Object(preact_min["h"])(
              preact_router_match["Link"],
              { className: style_default.a.headerLink, 'data-style': 'oldStyle', href: app_langRoutes(consts["G" /* langs */][locale].code, routes.BECOME_PRO_LINK), onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].MISC.BECOME_PRO
            ),
            isAtHome ? Object(preact_min["h"])(
              modules["Link"],
              { spy: true, smooth: true, offset: globalMessage ? -100 : -25, duration: 500, to: 'blogElement', onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].MISC.BLOG
            ) : Object(preact_min["h"])(
              preact_router_match["Link"],
              { className: style_default.a.headerLink, 'data-style': 'oldStyle', href: app_langRoutes(consts["G" /* langs */][locale].code, routes.BLOG_LINK), onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].MISC.BLOG
            ),
            isAtHome ? Object(preact_min["h"])(
              modules["Link"],
              { spy: true, smooth: true, offset: globalMessage ? -100 : -30, duration: 500, to: 'FAQElement', onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].HEADER.FAQ
            ) : Object(preact_min["h"])(
              preact_router_match["Link"],
              { className: style_default.a.headerLink, 'data-style': 'oldStyle', href: app_langRoutes(consts["G" /* langs */][locale].code, routes.FAQ), onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].HEADER.FAQ
            ),
            isAtHome ? Object(preact_min["h"])(
              modules["Link"],
              { spy: true, smooth: true, offset: globalMessage ? -60 : 0, duration: 500, to: 'contactUsElement', onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].HEADER.CONTACT
            ) : Object(preact_min["h"])(
              preact_router_match["Link"],
              { className: style_default.a.headerLink, 'data-style': 'oldStyle', href: app_langRoutes(consts["G" /* langs */][locale].code, routes.CONTACT_US), onClick: this.toggleMobileMenu },
              langPack["a" /* langPack */][locale].HEADER.CONTACT
            ),
            !isLogin ? Object(preact_min["h"])(
              'div',
              null,
              _ref11,
              Object(preact_min["h"])(
                'a',
                { href: 'https://www.telmie.com/download-app', id: style_default.a.signUp, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].MISC.SIGN_UP
              ),
              Object(preact_min["h"])(
                preact_router_match["Link"],
                { href: routes.LOG_IN, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].HEADER.LOGIN
              )
            ) : Object(preact_min["h"])(
              'div',
              null,
              _ref12,
              Object(preact_min["h"])(
                preact_router_match["Link"],
                { activeClassName: style_default.a.activeLink, href: routes.FIND_PRO, onClick: function onClick() {
                    return firebase.analytics().logEvent('Tap_menu_Find_a_Pros');
                  }, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].MISC.FIND_A_PRO
              ),
              Object(preact_min["h"])(
                preact_router_match["Link"],
                { activeClassName: style_default.a.activeLink, href: routes.MY_PROS, onClick: function onClick() {
                    return firebase.analytics().logEvent('Tap_menu_My Pros');
                  }, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].MISC.MY_PROS
              ),
              Object(preact_min["h"])(
                preact_router_match["Link"],
                { activeClassName: style_default.a.activeLink, href: routes.MY_BOOKINGS, onClick: function onClick() {
                    return firebase.analytics().logEvent('Tap_menu_My Bookings');
                  }, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].MISC.MY_APPOINTMENTS
              ),
              user.pro !== null && Object(preact_min["h"])(
                preact_router_match["Link"],
                { activeClassName: style_default.a.activeLink, href: routes.MY_CLIENTS, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].MISC.MY_CLIENTS
              ),
              Object(preact_min["h"])(
                preact_router_match["Link"],
                { activeClassName: style_default.a.activeLink, href: routes.TRANSACTIONS, onClick: function onClick() {
                    return firebase.analytics().logEvent('Tap_menu_Money_');
                  }, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].HEADER.MONEY
              ),
              user.pro === null && Object(preact_min["h"])(
                preact_router_match["Link"],
                { activeClassName: style_default.a.activeLink, href: routes.REGISTER_PRO, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].MISC.BECOME_PRO
              ),
              Object(preact_min["h"])(
                preact_router_match["Link"],
                { activeClassName: style_default.a.activeLink, href: routes.SETTINGS, onClick: function onClick() {
                    return firebase.analytics().logEvent('Tap_menu_Settings');
                  }, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].HEADER.SETTINGS
              ),
              Object(preact_min["h"])(
                'a',
                { onClick: function onClick() {
                    return _this3.logOff();
                  }, 'data-style': 'oldStyle' },
                langPack["a" /* langPack */][locale].MISC.LOG_OUT
              )
            )
          )
        ),
        currentUrl === routes.SEARCH && isLogin && _ref13
      ),
      globalMessage && Object(preact_min["h"])(
        'div',
        { id: style_default.a.subHeader },
        Object(preact_min["h"])(
          'div',
          { className: style_default.a.content },
          ' ',
          globalMessage,
          ' '
        )
      ),
      notificationMessage &&
      // Hotfix for notificationDanger TWMA-620. Approved with QA
      Object(preact_min["h"])(
        'div',
        {
          id: style_default.a.subHeader,
          className: classnames_default()((_cn = {}, _cn[style_default.a.notificationDanger] = notificationMessage === chat["a" /* CREATE_CALL_ERROR */], _cn))
        },
        Object(preact_min["h"])(
          'div',
          { className: style_default.a.content },
          ' ',
          notificationMessage,
          ' '
        )
      ),
      displayNotWorkingAsProAlert && Object(preact_min["h"])(ui_alert, { color: 'warning', isClosable: true, content: langPack["a" /* langPack */][locale].PRO.WORKING_AS_PRO_OFF, onHide: this.dismissWorkingAsProWarning }),
      applicationShouldUpdate && Object(preact_min["h"])(
        ui_alert,
        { color: 'warning', content: langPack["a" /* langPack */][locale].NOTIFICATIONS.UPDATE_APPLICATION_VERSION },
        Object(preact_min["h"])(
          ui_button["a" /* default */],
          { onClick: this.updateApplication },
          langPack["a" /* langPack */][locale].MISC.UPDATE_NOW
        )
      )
    );
  };

  return Header;
}(preact_min["Component"]), header__initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.fetchPage = function (props) {
    var that = _this4;

    props.prismicCtx.api.getByID(props.uid).then(function (page) {
      if (page) {
        that.setState({ globalMessage: Object(prismic_middleware["g" /* processGlobalMessage */])(page.data) });
      }
    });
  };

  this.handleScroll = function () {
    var isTop = _this4.state.isTop;


    if (window.pageYOffset || document.documentElement.scrollTop) {
      if (isTop) {
        _this4.setState({ isTop: false });
      }
    } else if (!isTop) {
      _this4.setState({ isTop: true });
    }
  };

  this.logOff = function () {
    _this4.setState({
      loggedOff: true
    }, function () {
      preact_router_es["route"](routes.LOG_IN);
      if (_this4.props.onLogout && typeof _this4.props.onLogout === 'function') {
        _this4.props.onLogout();
      }
      _this4.props.logOff();
    });
  };

  this.toggleMobileMenu = function (e) {
    _this4.setState(function (prev) {
      return { mobileMenuOpened: !prev.mobileMenuOpened };
    });
    if (e.target.text === 'Become a Pro') {
      firebase.analytics().logEvent('Tap_menu_Become_Pro_');
    }
  };

  this.dismissWorkingAsProWarning = function () {
    _this4.setState({
      workingAsProWarningDismissed: true
    });
  };

  this.updateApplication = function () {
    window.location.reload();
  };

  this.openComModal = function () {
    return _this4.props.openComModal(consts["E" /* consts */].CHAT);
  };
}, header__temp);


var header_mapStateToProps = function mapStateToProps(state) {
  return {
    userData: state.loggedInUser,
    locale: state.locale,
    newChats: state.communicateModal.unread,
    currentUrl: state.url.url,
    transactions: state.loggedInUserTransactions,
    message: state.globalMessage.message,
    badges: state.badges,
    applicationShouldUpdate: state.application.applicationShouldUpdate
  };
};

var header_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(es["bindActionCreators"])({
    logOff: actions_user["q" /* logOff */],
    changeLocale: actions_user["a" /* changeLocale */],
    sendGlobalMessage: actions_user["w" /* sendGlobalMessage */]
  }, dispatch);
};

/* harmony default export */ var header = (Object(preact_redux_esm["b" /* connect */])(header_mapStateToProps, header_mapDispatchToProps)(header_Header));
// EXTERNAL MODULE: ./components/global/footer/style.scss
var footer_style = __webpack_require__("yfLs");
var footer_style_default = /*#__PURE__*/__webpack_require__.n(footer_style);

// CONCATENATED MODULE: ./components/global/footer/index.js


function footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function footer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint import/no-cycle: 0, no-undef: 0, react/forbid-prop-types: 0 */










var socialNetworksArr = ['facebook', 'linkedin', 'instagram' /* ,'medium' */];
var socialNetworks = {
  facebook: {
    icon: '/assets/icons/f-19x19.png',
    link: 'https://www.facebook.com/TelmieHQ'
  },
  linkedin: {
    icon: '/assets/icons/in-19x19.png',
    link: 'https://www.linkedin.com/company/telmie'
  },
  instagram: {
    icon: '/assets/icons/inst-20x20.png',
    link: 'https://www.instagram.com/telmiehq/'
  }
  /* medium: {
    icon: '/assets/icons/m-40×28.png',
    link: '',
  }, */
};

var footer__ref2 = Object(preact_min["h"])('img', { src: '/assets/logo.png', alt: 'Telmie App' });

var footer_Footer = function (_Component) {
  footer__inherits(Footer, _Component);

  function Footer() {
    var _temp, _this, _ret;

    footer__classCallCheck(this, Footer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = footer__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onIconClick = function (e) {
      var alt = e.target.alt;

      if (alt) {
        window.open(socialNetworks[alt].link);
      }
    }, _this.getAppVersion = function () {
      return "production" === consts["h" /* ENVIRONMENTS */].DEVELOPMENT ? consts["C" /* appVersion */] : consts["C" /* appVersion */].replace(/-rc.\d+/, '').split('.').slice(0, 3).join('.');
    }, _temp), footer__possibleConstructorReturn(_this, _ret);
  }

  Footer.prototype.render = function render(_ref) {
    var _this2 = this;

    var _currentUrl = _ref._currentUrl;
    var locale = this.props.locale;

    return Object(preact_min["h"])(
      'footer',
      { className: 'uk-navbar uk-navbar-container ' + footer_style_default.a.footer },
      Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(
          'div',
          { className: 'uk-navbar-left ' + footer_style_default.a.left },
          Object(preact_min["h"])(
            preact_router_es["Link"],
            { href: app_langRoutes(consts["G" /* langs */][locale].code, routes.HOME), className: footer_style_default.a.logo },
            footer__ref2
          ),
          Object(preact_min["h"])(
            'div',
            { className: footer_style_default.a.copyright },
            '\xA9\xA0',
            langPack["a" /* langPack */][locale].FOOTER.COPYRIGHT_TEXT,
            Object(preact_min["h"])(
              'div',
              null,
              'Version \xA0',
              this.getAppVersion()
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'uk-navbar-right ' + footer_style_default.a.right },
          Object(preact_min["h"])(
            'nav',
            { className: footer_style_default.a.footerLinks },
            Object(preact_min["h"])(
              'ul',
              { className: 'uk-navbar-nav' },
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])(
                  'a',
                  { href: 'https://www.telmie.com/' },
                  langPack["a" /* langPack */][locale].FOOTER.HOME
                )
              ),
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])(
                  'a',
                  { href: 'https://www.telmie.com/support' },
                  langPack["a" /* langPack */][locale].FOOTER.SUPPORT
                )
              ),
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])(
                  'a',
                  { href: 'https://www.telmie.com/terms-of-use' },
                  langPack["a" /* langPack */][locale].FOOTER.TERMS
                )
              ),
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])(
                  'a',
                  { href: 'https://www.telmie.com/privacy' },
                  langPack["a" /* langPack */][locale].FOOTER.POLICY
                )
              ),
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])(
                  'a',
                  { href: 'https://www.telmie.com/booking-cancellation-policy' },
                  langPack["a" /* langPack */][locale].FOOTER.CANCELLATION
                )
              ),
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])(
                  'a',
                  { href: 'https://www.telmie.com/faq' },
                  langPack["a" /* langPack */][locale].FOOTER.FAQ
                )
              )
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: footer_style_default.a.socialIcons },
            socialNetworksArr.map(function (el) {
              return Object(preact_min["h"])('img', { src: socialNetworks[el].icon, key: el, onClick: function onClick(e) {
                  return _this2.onIconClick(e);
                }, alt: el });
            })
          )
        )
      )
    );
  };

  return Footer;
}(preact_min["Component"]);

var footer_mapStateToProps = function mapStateToProps(state) {
  return {
    currentUrl: state.url.url
  };
};

/* harmony default export */ var footer = (Object(preact_redux_esm["b" /* connect */])(footer_mapStateToProps, {})(footer_Footer));
// EXTERNAL MODULE: ./components/communication/communication-component/style.scss
var communication_component_style = __webpack_require__("3dqK");
var communication_component_style_default = /*#__PURE__*/__webpack_require__.n(communication_component_style);

// EXTERNAL MODULE: ./components/communication/chat/style.scss
var chat_style = __webpack_require__("ta1H");
var chat_style_default = /*#__PURE__*/__webpack_require__.n(chat_style);

// EXTERNAL MODULE: ./assets/nouserimage.jpg
var nouserimage = __webpack_require__("LKV3");
var nouserimage_default = /*#__PURE__*/__webpack_require__.n(nouserimage);

// CONCATENATED MODULE: ./components/communication/chat/index.js

/** @jsx h */







var chat__ref2 = Object(preact_min["h"])('div', null);

var chat__ref3 = Object(preact_min["h"])('div', null);

var chat__ref4 = Object(preact_min["h"])('div', null);

var chat__ref5 = Object(preact_min["h"])('div', null);

var chat__ref6 = Object(preact_min["h"])('div', null);

var chat__ref7 = Object(preact_min["h"])('div', null);

var chat__ref8 = Object(preact_min["h"])('div', null);

var chat__ref9 = Object(preact_min["h"])('div', null);

var chat__ref10 = Object(preact_min["h"])('div', null);

var chat__ref11 = Object(preact_min["h"])('div', null);

var chat__ref12 = Object(preact_min["h"])('div', null);

var chat__ref13 = Object(preact_min["h"])('div', null);

var chat_Chat = function Chat(props) {
  var _props$users = props.users,
      users = _props$users === undefined ? {} : _props$users,
      isConnected = props.isConnected,
      locale = props.locale,
      badges = props.badges.badges;


  var onChangePerson = function onChangePerson(person) {
    return function () {
      return props.chooseChatPerson(person);
    };
  };

  var renderUnreadItem = function renderUnreadItem(el) {
    if (el.missedMessage + el.missedCall) {
      var id = el.toID;
      var user = el.toUser || users[id];

      var _ref = user || {},
          avatarUrl = _ref.avatarUrl,
          _ref$nickname = _ref.nickname,
          nickname = _ref$nickname === undefined ? '' : _ref$nickname;

      var fullName = nickname;
      return (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        Object(preact_min["h"])(
          'li',
          { key: user.id, onClick: onChangePerson(el), onKeyPress: onChangePerson(el) },
          Object(preact_min["h"])(
            'div',
            { className: chat_style_default.a.avatar },
            avatarUrl ? Object(preact_min["h"])('img', { src: avatarUrl, alt: fullName, title: fullName }) : Object(preact_min["h"])('img', { src: nouserimage_default.a, alt: fullName, title: fullName })
          ),
          Object(preact_min["h"])(
            'div',
            { className: chat_style_default.a.msgCount },
            el.missedMessage + el.missedCall
          ),
          Object(preact_min["h"])(
            'div',
            { className: chat_style_default.a.authorName },
            fullName
          )
        )
      );
    }
    return null;
  };
  return Object(preact_min["h"])(
    'div',
    { className: chat_style_default.a.chatComponent },
    !isConnected && Object(preact_min["h"])(
      'div',
      { className: chat_style_default.a.connectingDiv },
      Object(preact_min["h"])(
        'div',
        { className: chat_style_default.a.ldsDefault },
        chat__ref2,
        chat__ref3,
        chat__ref4,
        chat__ref5,
        chat__ref6,
        chat__ref7,
        chat__ref8,
        chat__ref9,
        chat__ref10,
        chat__ref11,
        chat__ref12,
        chat__ref13,
        Object(preact_min["h"])(
          'div',
          null,
          langPack["a" /* langPack */][locale].MISC.CONNECTING
        )
      )
    ),
    badges && Object(preact_min["h"])(
      'ul',
      { className: chat_style_default.a.users },
      Object.keys(badges).map(function (el) {
        return renderUnreadItem(badges[el]);
      })
    )
  );
};

/* harmony default export */ var communication_chat = (chat_Chat);
// EXTERNAL MODULE: ./components/communication/call/style.scss
var call_style = __webpack_require__("SmHd");
var call_style_default = /*#__PURE__*/__webpack_require__.n(call_style);

// EXTERNAL MODULE: ./components/communication/call-btn/index.js
var call_btn = __webpack_require__("zjJZ");

// CONCATENATED MODULE: ./components/communication/call/index.js


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










var call_Call = function Call(_ref) {
    var _ref$communicateModal = _ref.communicateModal,
        communicateModal = _ref$communicateModal === undefined ? {} : _ref$communicateModal,
        rejectCall = _ref.rejectCall,
        pickUp = _ref.pickUp,
        locale = _ref.locale,
        props = _objectWithoutProperties(_ref, ['communicateModal', 'rejectCall', 'pickUp', 'locale']);

    var _communicateModal$per = communicateModal.person,
        person = _communicateModal$per === undefined ? {} : _communicateModal$per,
        isIncoming = communicateModal.isIncoming,
        isOutcoming = communicateModal.isOutcoming,
        isBusy = communicateModal.isBusy,
        isCalling = communicateModal.isCalling,
        _communicateModal$cal = communicateModal.callInfo,
        callInfo = _communicateModal$cal === undefined ? {} : _communicateModal$cal,
        isSpeaking = communicateModal.isSpeaking;
    var error = callInfo.error,
        info = callInfo.info;
    var nickname = person.nickname,
        pro = person.pro,
        avatar = person.avatar;


    var fullName = nickname;
    var title = isSpeaking ? langPack["a" /* langPack */][locale].COMMUNICATION.ON_CALL_WITH : isCalling ? langPack["a" /* langPack */][locale].COMMUNICATION.CONNECTING_WITH : isOutcoming ? langPack["a" /* langPack */][locale].MISC.CALLING_PRO : isIncoming ? langPack["a" /* langPack */][locale].COMMUNICATION.INCOMING_CALL : '';
    var descr = isIncoming ? langPack["a" /* langPack */][locale].COMMUNICATION.YOUR_CLIENT : pro && pro.profession;
    var _info = error ? info : '';

    var btns = isIncoming ? [{
        txt: consts["D" /* chatBtns */].decline,
        handler: function handler(e) {
            return rejectCall(true);
        }
    }, {
        txt: consts["D" /* chatBtns */].pickUp,
        handler: pickUp
    }] : [];

    var avatarEl = Object(preact_min["h"])(
        'div',
        { 'class': call_style_default.a.avatar },
        ' ',
        avatar ? Object(preact_min["h"])('img', { src: api_0["a" /* apiRoot */] + 'image/' + avatar.id, alt: fullName, title: fullName }) : Object(preact_min["h"])('img', { src: '/assets/nouserimage.jpg', alt: fullName, title: fullName })
    );

    return Object(preact_min["h"])(
        'div',
        { 'class': call_style_default.a.callComponent },
        Object(preact_min["h"])(
            'div',
            { className: call_style_default.a.title },
            title
        ),
        Object(preact_min["h"])(
            'div',
            { style: { position: 'relative' } },
            !isSpeaking && avatarEl
        ),
        Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(
                'div',
                { 'class': call_style_default.a.name },
                fullName
            ),
            Object(preact_min["h"])(
                'div',
                { className: call_style_default.a.descr },
                descr
            )
        ),
        Object(preact_min["h"])(
            'div',
            { 'class': call_style_default.a.info },
            _info
        ),
        Object(preact_min["h"])(
            'div',
            { 'class': call_style_default.a.btnArea },
            props.isConnected ? btns.map(function (el) {
                return Object(preact_min["h"])(call_btn["a" /* Btn */], { text: el.txt, key: el.txt, clickHandler: el.handler });
            }) : langPack["a" /* langPack */][locale].MISC.CONNECTING_TO_SERVER
        )
    );
};

/* harmony default export */ var call = (call_Call);
// CONCATENATED MODULE: ./components/communication/communication-component/index.js


function communication_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function communication_component__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function communication_component__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable func-names */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable import/no-cycle */














var communication_component_Communication = function (_Component) {
  communication_component__inherits(Communication, _Component);

  function Communication(props) {
    communication_component__classCallCheck(this, Communication);

    var _this = communication_component__possibleConstructorReturn(this, _Component.call(this, props));

    _this.anyUnreadNotifications = function () {
      return _this.props.badges.totalMissedCall || _this.props.badges.totalMissedMessage;
    };

    _this.undoCallSecInterval = function () {
      clearInterval(_this.callSecondsInterval);
      _this.callSecondsInterval = null;
    };

    _this.onClose = function () {
      var _this$props = _this.props,
          type = _this$props.type,
          comModal = _this$props.comModal,
          closeCModal = _this$props.closeComModal;

      if (type === consts["E" /* consts */].CALL) {
        if (_this.autoRejectTimeout) {
          _this.undoAutoReject();
          _this.rejectCall();
        }
        _this.rejectCall();
      } else if (comModal.isChatOpened) {
        closeCModal(consts["E" /* consts */].CHAT);
      } else {
        closeCModal();
      }
    };

    _this.rejectCall = function () {
      var isBusy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var rejCall = _this.props.connection.rejectCall;

      rejCall(isBusy);
      // this.props.closeComModal();
    };

    _this.requestGranted = function () {
      var _this$props2 = _this.props,
          comModal = _this$props2.comModal,
          picUpFunc = _this$props2.pickUp,
          connection = _this$props2.connection;
      // eslint-disable-next-line no-console

      console.warn('requestGranted');
      // route(routes.CLIENT_FOR_COMP + this.props.comModal.person.id + '#call');

      connection.rescanMediaDevices(true).then(function () {
        if (comModal.callInfo.fcid) {
          Object(preact_router_es["route"])(routes.FEATURED_SERVICE_FOR_COMP + '/' + comModal.callInfo.fcid);
        } else {
          Object(preact_router_es["route"])('' + routes.USER_FOR_COMP + comModal.person.id + '#call');
        }
        picUpFunc();
      }).catch(function (err) {
        return connection.failCall(connection.tryGetMediaCaptureErrorReason(err));
      });
    };

    _this.state = {
      callSec: 0
    };
    return _this;
  }

  Communication.prototype.componentDidMount = function componentDidMount() {
    if (!this.anyUnreadNotifications()) {
      var _props = this.props,
          type = _props.type,
          comModal = _props.comModal,
          closeCModal = _props.closeComModal;

      if (type !== consts["E" /* consts */].CALL && comModal.isChatOpened) {
        closeCModal(consts["E" /* consts */].CHAT);
      }
    }
  };

  Communication.prototype.componentDidUpdate = function componentDidUpdate() {
    if (!this.anyUnreadNotifications()) {
      var _props2 = this.props,
          type = _props2.type,
          comModal = _props2.comModal,
          closeCModal = _props2.closeComModal;

      if (type !== consts["E" /* consts */].CALL && comModal.isChatOpened) {
        closeCModal(consts["E" /* consts */].CHAT);
      }
    }
  };

  Communication.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.autoRejectTimeout) this.undoAutoReject();
    if (this.callSecondsInterval) this.undoCallSecInterval();
  };

  // new func


  // call start (приём?)
  // new func


  Communication.prototype.render = function render(_ref) {
    var badges = _ref.badges,
        users = _ref.users;
    var _props3 = this.props,
        chooseChatPerson = _props3.chooseChatPerson,
        comModal = _props3.comModal,
        isConnected = _props3.isConnected,
        locale = _props3.locale;
    var modalType = comModal.type,
        isOutcoming = comModal.isOutcoming,
        isPickUp = comModal.isPickUp,
        isChatOpened = comModal.isChatOpened;
    var callSec = this.state.callSec;

    return (modalType && !isOutcoming && !isPickUp || isChatOpened && this.anyUnreadNotifications()) && Object(preact_min["h"])(
      'div',
      { className: communication_component_style_default.a.callAreaBackground },
      isChatOpened && Object(preact_min["h"])(
        'div',
        { className: communication_component_style_default.a.callArea },
        Object(preact_min["h"])('div', { className: communication_component_style_default.a.closeBtn, onClick: this.onClose }),
        Object(preact_min["h"])(communication_chat, {
          users: users,
          communicateModal: comModal,
          chooseChatPerson: chooseChatPerson,
          isConnected: isConnected,
          badges: badges,
          locale: locale
        })
      ),
      modalType === consts["E" /* consts */].CALL && !isOutcoming && !isPickUp && Object(preact_min["h"])(
        'div',
        { className: communication_component_style_default.a.callArea },
        Object(preact_min["h"])(call, {
          communicateModal: comModal,
          seconds: callSec,
          closeModal: this.onClose,
          pickUp: this.requestGranted,
          rejectCall: this.rejectCall,
          isConnected: isConnected,
          locale: locale
        })
      )
    );
  };

  return Communication;
}(preact_min["Component"]);

var communication_component_mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.loggedInUser,
    comModal: state.communicateModal,
    locale: state.locale.locale,
    badges: state.badges.data || {}
  };
};

var communication_component_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(es["bindActionCreators"])({
    closeComModal: chat["k" /* closeComModal */],
    pickUp: chat["o" /* pickUp */]
  }, dispatch);
};

/* harmony default export */ var communication_component = (Object(preact_redux_esm["b" /* connect */])(communication_component_mapStateToProps, communication_component_mapDispatchToProps)(communication_component_Communication));
// EXTERNAL MODULE: ../node_modules/material-ui/Snackbar/index.js
var Snackbar = __webpack_require__("hUiE");
var Snackbar_default = /*#__PURE__*/__webpack_require__.n(Snackbar);

// EXTERNAL MODULE: ./components/communication/notification/style.scss
var notification_style = __webpack_require__("jzqA");
var notification_style_default = /*#__PURE__*/__webpack_require__.n(notification_style);

// CONCATENATED MODULE: ./components/communication/notification/index.js


function notification__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function notification__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function notification__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var notification_Call = function (_Component) {
  notification__inherits(Call, _Component);

  function Call() {
    notification__classCallCheck(this, Call);

    return notification__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Call.prototype.render = function render(_ref) {
    var onClick = _ref.onClick,
        isShown = _ref.isShown,
        locale = _ref.locale;

    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(Snackbar_default.a, {
        open: isShown,
        message: langPack["a" /* langPack */][locale].COMMUNICATION.CALL_WILL_BE_FINISHED,
        onRequestClose: onClick,
        action: 'ok',
        onActionClick: onClick,
        style: { top: 0, bottom: undefined, transform: isShown ? 'translate(-50%, 0)' : 'translate(-50%, -48px)' },
        bodyStyle: { background: '#e5002f', maxWidth: 700, minWidth: 539 },
        contentStyle: { fontSize: 20, display: 'flex' },
        className: notification_style_default.a.notification
      })
    );
  };

  return Call;
}(preact_min["Component"]);

/* harmony default export */ var communication_notification = (notification_Call);
// EXTERNAL MODULE: ./components/api-notifications/index.js
var api_notifications = __webpack_require__("JMpC");

// EXTERNAL MODULE: ./reducers/sign-in.js
var sign_in = __webpack_require__("87tL");

// EXTERNAL MODULE: ./reducers/application.js
var application = __webpack_require__("s5UR");

// EXTERNAL MODULE: ./reducers/user.js
var reducers_user = __webpack_require__("XZs+");

// EXTERNAL MODULE: ./api/users.js
var api_users = __webpack_require__("mecS");

// EXTERNAL MODULE: ./utils/connection.js + 2 modules
var utils_connection = __webpack_require__("PTKh");

// CONCATENATED MODULE: ./components/global/device-activity/index.js
function device_activity__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function device_activity__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function device_activity__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
/** @jsx h */












// eslint-disable-next-line import/no-cycle



var IdleJS = __webpack_require__("iLhB");

var __FILE__ = 'components\\global\\device-activity\\index.js';

var ATTEMPTS = 3;
var RETRY_TIMEOUT_MS = 5000;
var IDLE_TIMEOUT_JS = 3 * 60 * 1000;
var MIN_DEVICE_ACTIVITY_REPORT_INTERVAL = 15 * 60 * 1000;

var device_activity_DeviceActivity = function (_Component) {
  device_activity__inherits(DeviceActivity, _Component);

  function DeviceActivity(props) {
    device_activity__classCallCheck(this, DeviceActivity);

    var _this = device_activity__possibleConstructorReturn(this, _Component.call(this, props));

    _this.onCallStarted = function () {
      var __METHOD__ = 'DeviceActivity::onCallStarted';
      logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["c" /* TAG_PRESENCE */], 'A call has started - stopping idle tracking', lib["LogLevel"].Info, undefined, true);

      var idle = _this.idle;

      idle && idle.stop();

      _this.idleTrackingSuspended = true;

      // As we will not get any onActive / onShow notifications till we resume idle tracking,
      // we have to explicitly report the "available" presence.
      // And we can add the 'On call' additional info, while at that :)
      _this.props.sendPresence('On call');
    };

    _this.onCallFinished = function () {
      var __METHOD__ = 'DeviceActivity::onCallFinished';

      if (_this.idleTrackingSuspended) {
        logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["c" /* TAG_PRESENCE */], 'A call has finished - resuming idle tracking', lib["LogLevel"].Info, undefined, true);

        // Withdraw the 'On call' status
        _this.props.sendPresence();

        var idle = _this.idle;

        idle && idle.reset({
          idle: false,
          visible: !document.hidden
        }).start();

        _this.idleTrackingSuspended = false;
      }
    };

    _this.idleTrackingSuspended = false;
    return _this;
  }

  DeviceActivity.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.idle = new IdleJS({
      idle: IDLE_TIMEOUT_JS,
      events: ['click', 'mousemove', 'mouseenter', 'keydown', 'scroll', 'mousewheel', 'touchmove', 'touchstart', 'mousedown'],
      onActive: function onActive() {
        try {
          _this2.updateDeviceActivity();
        } finally {
          _this2.lastWentIdle = null;
        }
      },
      onShow: function onShow() {
        try {
          _this2.updateDeviceActivity();
        } finally {
          _this2.idle.reset({ idle: false, visible: true });
          _this2.lastWentIdle = false;
        }
      },
      onIdle: function onIdle() {
        _this2.lastWentIdle = Date.now();
        _this2.reportIdlePresence();
      }
    });

    this.lastWentIdle = null;

    var callEvents = this.props.callEvents;


    callEvents.on(utils_connection["b" /* CALL_FAILED_EVENT */], this.onCallFinished, this);
    callEvents.on(utils_connection["f" /* INCOMING_CALL_STARTED_EVENT */], this.onCallStarted, this);
    callEvents.on(utils_connection["g" /* OUTGOING_CALL_STARTED_EVENT */], this.onCallStarted, this);
    callEvents.on(utils_connection["c" /* CALL_FINISHED_EVENT */], this.onCallFinished, this);

    this.idle.start();
  };

  DeviceActivity.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  DeviceActivity.prototype.componentWillUnmount = function componentWillUnmount() {
    this.idle && this.idle.stop();

    var callEvents = this.props.callEvents;


    callEvents.removeListener(utils_connection["b" /* CALL_FAILED_EVENT */], this.onCallFinished, this);
    callEvents.removeListener(utils_connection["f" /* INCOMING_CALL_STARTED_EVENT */], this.onCallStarted, this);
    callEvents.removeListener(utils_connection["g" /* OUTGOING_CALL_STARTED_EVENT */], this.onCallStarted, this);
    callEvents.removeListener(utils_connection["c" /* CALL_FINISHED_EVENT */], this.onCallFinished, this);
  };

  DeviceActivity.prototype.reportIdlePresence = function reportIdlePresence() {
    var __METHOD__ = 'DeviceActivity::reportIdlePresence';
    var _props = this.props,
        sendPresence = _props.sendPresence,
        isConnected = _props.isConnected,
        eventBus = _props.eventBus;


    if (this.isAppAnActiveDeviceNow() && isConnected) {
      logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["c" /* TAG_PRESENCE */], 'Idle state detected - setting XMPP presence as away', lib["LogLevel"].Info, undefined, true);

      sendPresence('Away', 'away');
      eventBus.emit(consts["j" /* EVENT_BUS_EVENTS */].PRESENCE_CHANGED_TO_AWAY);
    }
  };

  DeviceActivity.prototype.wasIdleLongEnoughToSendDeviceActivityUpdate = function wasIdleLongEnoughToSendDeviceActivityUpdate() {
    return this.lastWentIdle && Date.now() - this.lastWentIdle >= MIN_DEVICE_ACTIVITY_REPORT_INTERVAL;
  };

  DeviceActivity.prototype.updateDeviceActivity = function updateDeviceActivity() {
    var $args = arguments;return new Promise(function ($return, $error) {
      var _this3, attempts, __METHOD__, deviceId, _props2, numericDeviceId, eventBus, _props3, detected, userAuth, isConnected, sendPresence, name, version, currentMoment, currentMomentAsISOString;

      _this3 = this;
      attempts = $args.length > 0 && $args[0] !== undefined ? $args[0] : ATTEMPTS;

      __METHOD__ = 'DeviceActivity::updateDeviceActivity';

      if (this.isAppAnActiveDeviceNow()) {
        deviceId = localStorage.getItem(consts["n" /* LOCAL_STORAGE */].UUID);
        _props2 = this.props, numericDeviceId = _props2.numericDeviceId, eventBus = _props2.eventBus;


        if (deviceId && numericDeviceId) {
          _props3 = this.props, detected = _props3.detected, userAuth = _props3.userAuth, isConnected = _props3.isConnected, sendPresence = _props3.sendPresence;
          name = detected.name, version = detected.version;

          currentMoment = Date.now();
          currentMomentAsISOString = new Date(currentMoment).toISOString();

          var $Try_3_Post = function () {
            try {
              return $If_6.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this);var $Try_3_Catch = function (err) {
            try {
              logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["c" /* TAG_PRESENCE */], 'Failed to send the device activity update. Remaining attempts: ' + attempts, lib["LogLevel"].Warning, err, true);

              if (attempts > 0) {
                setTimeout(function () {
                  return _this3.updateDeviceActivity(attempts - 1);
                }, RETRY_TIMEOUT_MS);
              }
              return $Try_3_Post();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          };try {
            if (!isConnected) {
              return $return();
            }

            logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["c" /* TAG_PRESENCE */], 'User activity detected - setting XMPP presence as available', lib["LogLevel"].Info, undefined, true);

            sendPresence();

            // Publish an event so that other components could update themselves (e.g. refresh the chat history
            // or re-read the list of recent activities).
            eventBus.emit(consts["j" /* EVENT_BUS_EVENTS */].PRESENCE_CHANGED_TO_ONLINE);

            if (this.lastWentIdle === null || this.wasIdleLongEnoughToSendDeviceActivityUpdate()) {
              logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["c" /* TAG_PRESENCE */], 'User activity detected - sending a device activity update', lib["LogLevel"].Info, undefined, true);

              return Promise.resolve(Object(api_users["G" /* updateDeviceForCurrentUser */])(userAuth, numericDeviceId, {
                device: deviceId,
                agent: name,
                agentVersion: version,
                type: 'WEB',
                locale: navigator.languages[0],
                appVersion: consts["C" /* appVersion */],
                msDate: currentMoment,
                date: currentMomentAsISOString
              })).then(function ($await_8) {
                try {
                  return $If_7.call(this);
                } catch ($boundEx) {
                  return $Try_3_Catch($boundEx);
                }
              }.bind(this), $Try_3_Catch);
            }

            function $If_7() {
              return $Try_3_Post();
            }

            return $If_7.call(this);
          } catch (err) {
            $Try_3_Catch(err)
          }
        } else {
          logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["c" /* TAG_PRESENCE */], 'No device ID, cannot send a device activity update. Device UUID: ' + deviceId + ', back-end device ID: ' + numericDeviceId, lib["LogLevel"].Error, undefined, false);
          return $If_6.call(this);
        }

        function $If_6() {
          return $If_5.call(this);
        }
      }

      function $If_5() {
        return $return();
      }

      return $If_5.call(this);
    }.bind(this));
  };

  DeviceActivity.prototype.isAppAnActiveDeviceNow = function isAppAnActiveDeviceNow() {
    var __METHOD__ = 'DeviceActivity::isAppAnActiveDeviceNow';
    var _props4 = this.props,
        isWebview = _props4.isWebview,
        isUnsupportedMobileOs = _props4.isUnsupportedMobileOs,
        applicationInitialised = _props4.applicationInitialised,
        signInProcessed = _props4.signInProcessed,
        signInError = _props4.signInError,
        userData = _props4.userData;


    try {
      return (!isUnsupportedMobileOs || isWebview) && applicationInitialised && signInProcessed && !signInError && userData && userData.userAuth;
    } catch (e) {
      logger["j" /* logWithTag */](__FILE__, __METHOD__, logger["c" /* TAG_PRESENCE */], 'Unexpected error occurred while checking if the app is an active device', lib["LogLevel"].Error, e, false);

      return false;
    }
  };

  DeviceActivity.prototype.render = function render() {
    return null; // This is intentionally a renderless component
  };

  return DeviceActivity;
}(preact_min["Component"]);

var device_activity_mapStateToProps = function mapStateToProps(state) {
  return {
    applicationInitialised: Object(application["h" /* selectApplicationIsInitialised */])(state),
    isUnsupportedMobileOs: Object(application["m" /* selectIsUnsupportedMobileOs */])(state),
    isWebview: Object(application["i" /* selectApplicationIsWebview */])(state),
    signInProcessed: Object(sign_in["d" /* selectSignInProcessed */])(state),
    signInError: Object(sign_in["c" /* selectSignInError */])(state),
    userData: Object(reducers_user["r" /* selectLoggedInUser */])(state),
    userAuth: Object(reducers_user["s" /* selectLoggedInUserAuth */])(state),
    numericDeviceId: Object(reducers_user["v" /* selectLoggedInUsersDevice */])(state),
    detected: Object(application["g" /* selectApplicationDetected */])(state),
    logInFailure: state.logInFailure,
    currentUrl: state.url.url
  };
};

/* harmony default export */ var device_activity = (Object(preact_redux_esm["b" /* connect */])(device_activity_mapStateToProps, null)(device_activity_DeviceActivity));
// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/home/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(13).then((function (require) {
				cb( __webpack_require__("iOg+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/user/index.js

		

		function user_load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function (require) {
				cb( __webpack_require__("SJD4") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes_user = (async_default()(user_load));
	
// CONCATENATED MODULE: ./routes/preview/index.js

		

		function preview_load(cb) {
			__webpack_require__.e/* require.ensure */(7).then((function (require) {
				cb( __webpack_require__("VXjH") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var preview = (async_default()(preview_load));
	
// CONCATENATED MODULE: ./routes/static-page/index.js

		

		function static_page_load(cb) {
			__webpack_require__.e/* require.ensure */(20).then((function (require) {
				cb( __webpack_require__("Np5X") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var static_page = (async_default()(static_page_load));
	
// CONCATENATED MODULE: ./routes/log-in/index.js

		

		function log_in_load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function (require) {
				cb( __webpack_require__("r7ZQ") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var log_in = (async_default()(log_in_load));
	
// CONCATENATED MODULE: ./routes/sign-up/index.js

		

		function sign_up_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("GI2D") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var sign_up = (async_default()(sign_up_load));
	
// CONCATENATED MODULE: ./routes/login-or-signup/index.js

		

		function login_or_signup_load(cb) {
			__webpack_require__.e/* require.ensure */(21).then((function (require) {
				cb( __webpack_require__("KsOA") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var login_or_signup = (async_default()(login_or_signup_load));
	
// CONCATENATED MODULE: ./routes/activity/index.js

		

		function activity_load(cb) {
			__webpack_require__.e/* require.ensure */(26).then((function (require) {
				cb( __webpack_require__("mtyC") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes_activity = (async_default()(activity_load));
	
// EXTERNAL MODULE: ../node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("FJnM");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./actions/calls.js
var calls = __webpack_require__("P2wb");

// EXTERNAL MODULE: ./components/profile/all-activity/index.js + 1 modules
var all_activity = __webpack_require__("vjJg");

// EXTERNAL MODULE: ./components/search/dropdown/index.js + 25 modules
var dropdown = __webpack_require__("pXYQ");

// EXTERNAL MODULE: ./routes/activity/style.scss
var activity_style = __webpack_require__("Q8Vk");
var activity_style_default = /*#__PURE__*/__webpack_require__.n(activity_style);

// CONCATENATED MODULE: ./routes/activity/pros.js


function pros__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function pros__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function pros__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-unused-state */
/* eslint-disable react/prop-types */
// eslint-disable-next-line no-unused-vars







// eslint-disable-next-line import/no-cycle








var proSortingItems = [{
  name: '',
  value: ''
}, {
  name: 'Last activity date',
  value: 'date'
}, {
  name: 'Name',
  value: 'name'
}, {
  name: 'Profession',
  value: 'service'
}];

var pros_ActivityPros = function (_Component) {
  pros__inherits(ActivityPros, _Component);

  function ActivityPros(props) {
    pros__classCallCheck(this, ActivityPros);

    var _this = pros__possibleConstructorReturn(this, _Component.call(this, props));

    _this.onSearch = function () {
      _this.getData();
    };

    _this.getData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.props.getCalls(false, page);
    };

    _this.changePage = function (page) {
      _this.props.changeSearchParams({
        type: 'page',
        value: page
      });
      window.scrollTo(0, 0);
      _this.getData(page);
    };

    _this.showConsulted = function () {
      return _this.setState({ proCalls: false });
    };

    _this.showConsultedMe = function () {
      return _this.setState({ proCalls: true });
    };

    _this.sortToggleSwitched = function (sortBy) {
      _this.props.changeSearchParams({
        type: 'sortBy',
        value: sortBy
      });
    };

    _this.changeSearchTerm = function (value) {
      _this.props.changeSearchParams({
        type: 'searchTerm',
        value: value
      });
    };

    _this.onPresenceAvailable = function () {
      var _this$props = _this.props,
          page = _this$props.page,
          dispatchGetUnreadMessages = _this$props.getUnreadMessages;


      dispatchGetUnreadMessages();
      _this.getData(page);
    };

    _this.state = {
      searching: false
    };
    return _this;
  }

  ActivityPros.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        dispatchGetUnreadMessages = _props.getUnreadMessages,
        dispatchChangeLocaleLangs = _props.changeLocaleLangs,
        dispatchChangeLocale = _props.changeLocale,
        eventBus = _props.eventBus,
        userAuth = _props.userData.userAuth;


    dispatchGetUnreadMessages();

    if (userAuth) {
      this.getData();
    }
    dispatchChangeLocaleLangs([]);
    dispatchChangeLocale();

    eventBus.on(consts["j" /* EVENT_BUS_EVENTS */].PRESENCE_CHANGED_TO_ONLINE, this.onPresenceAvailable, this);
  };

  ActivityPros.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _props2 = this.props,
        prevUserAuth = _props2.userData.userAuth,
        prevSortBy = _props2.sortBy;
    var nextUserAuth = nextProps.userData.userAuth,
        nextSortBy = nextProps.sortBy;


    if (nextUserAuth !== prevUserAuth || nextSortBy !== prevSortBy) {
      this.getData();
    }
  };

  ActivityPros.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props3 = this.props,
        reset = _props3.reset,
        eventBus = _props3.eventBus;

    reset();

    eventBus.removeListener(consts["j" /* EVENT_BUS_EVENTS */].PRESENCE_CHANGED_TO_ONLINE, this.onPresenceAvailable, this);
  };

  ActivityPros.prototype.render = function render(_ref, _ref2) {
    var isProCalls = _ref.isProCalls,
        loading = _ref.loading,
        page = _ref.page,
        activity = _ref.activity,
        total = _ref.total,
        sortBy = _ref.sortBy,
        searchTerm = _ref.searchTerm,
        timeOffset = _ref.timeOffset,
        badges = _ref.badges.badges,
        locale = _ref.locale;
    var proCalls = _ref2.proCalls;

    return Object(preact_min["h"])(
      'div',
      { id: 'profile', className: 'uk-container uk-container-small' },
      Object(preact_min["h"])(Helmet_default.a, {
        title: langPack["a" /* langPack */][locale].ROUTES.TELMIE_MY_PROS
      }),
      Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])('div', { className: activity_style_default.a.offset }),
        Object(preact_min["h"])(
          'div',
          { className: activity_style_default.a.content },
          Object(preact_min["h"])(
            'div',
            { className: activity_style_default.a.title },
            Object(preact_min["h"])(
              'h1',
              null,
              langPack["a" /* langPack */][locale].MISC.MY_PROS
            ),
            Object(preact_min["h"])(dropdown["a" /* default */], {
              onChange: this.sortToggleSwitched,
              data: proSortingItems,
              selected: sortBy
            }),
            Object(preact_min["h"])(input["a" /* default */], {
              onChange: this.changeSearchTerm,
              onSearch: this.onSearch,
              value: searchTerm,
              placeholder: langPack["a" /* langPack */][locale].ROUTES.FIND_YOUR_PRO,
              className: activity_style_default.a.search,
              locale: locale
            })
          ),
          Object(preact_min["h"])(all_activity["a" /* default */], {
            showConsultedMe: this.showConsultedMe,
            showConsulted: this.showConsulted,
            activity: activity,
            currentPage: page,
            client: isProCalls,
            loading: loading,
            changePage: this.changePage,
            nextPage: this.nextPage,
            previousPage: this.previousPage,
            proCalls: proCalls,
            total: total,
            searchValue: searchTerm,
            timeOffset: timeOffset,
            locale: locale,
            badges: badges
          })
        )
      )
    );
  };

  return ActivityPros;
}(preact_min["Component"]);

var pros_mapStateToProps = function mapStateToProps(state) {
  return {
    userData: state.loggedInUser,
    proCalls: state.loggedInUserProCalls,
    personalCalls: state.loggedInUserPersonalCalls,
    activity: state.calls.activity,
    sortBy: state.calls.sortBy,
    page: state.calls.page,
    searchTerm: state.calls.searchTerm,
    loading: state.calls.loading,
    total: state.calls.total,
    timeOffset: state.communicateModal.offset,
    locale: state.locale.locale,
    badges: state.badges.data || {}
  };
};

var pros_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(es["bindActionCreators"])({
    getCalls: calls["b" /* getCalls */],
    changeSearchParams: calls["a" /* changeSearchParams */],
    reset: calls["c" /* reset */],
    changeLocaleLangs: actions_user["b" /* changeLocaleLangs */],
    changeLocale: actions_user["a" /* changeLocale */],
    getUnreadMessages: actions_user["m" /* getUnreadMessages */]
  }, dispatch);
};

/* harmony default export */ var activity_pros = (Object(preact_redux_esm["b" /* connect */])(pros_mapStateToProps, pros_mapDispatchToProps)(pros_ActivityPros));
// EXTERNAL MODULE: ./routes/edit-profile/index.js
var edit_profile = __webpack_require__("CZEd");

// CONCATENATED MODULE: ./routes/transactions/index.js

		

		function transactions_load(cb) {
			__webpack_require__.e/* require.ensure */(9).then((function (require) {
				cb( __webpack_require__("x+Dg") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var transactions = (async_default()(transactions_load));
	
// CONCATENATED MODULE: ./routes/forgot-password/index.js

		

		function forgot_password_load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function (require) {
				cb( __webpack_require__("iOEf") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var forgot_password = (async_default()(forgot_password_load));
	
// CONCATENATED MODULE: ./routes/settings/index.js

		

		function settings_load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("i8EF") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes_settings = (async_default()(settings_load));
	
// CONCATENATED MODULE: ./routes/select-interest/index.js

		

		function select_interest_load(cb) {
			__webpack_require__.e/* require.ensure */(17).then((function (require) {
				cb( __webpack_require__("1ZL2") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var select_interest = (async_default()(select_interest_load));
	
// CONCATENATED MODULE: ./routes/register-pro/index.js

		

		function register_pro_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("XSG7") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var register_pro = (async_default()(register_pro_load));
	
// CONCATENATED MODULE: ./routes/contact-us/index.js

		

		function contact_us_load(cb) {
			__webpack_require__.e/* require.ensure */(19).then((function (require) {
				cb( __webpack_require__("X6JR") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var contact_us = (async_default()(contact_us_load));
	
// CONCATENATED MODULE: ./routes/errorRoute/index.js

		

		function errorRoute_load(cb) {
			__webpack_require__.e/* require.ensure */(22).then((function (require) {
				cb( __webpack_require__("QCHc") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var errorRoute = (async_default()(errorRoute_load));
	
// CONCATENATED MODULE: ./routes/faq/index.js

		

		function faq_load(cb) {
			__webpack_require__.e/* require.ensure */(18).then((function (require) {
				cb( __webpack_require__("c0lg") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var faq = (async_default()(faq_load));
	
// CONCATENATED MODULE: ./routes/blog/index.js

		

		function blog_load(cb) {
			__webpack_require__.e/* require.ensure */(14).then((function (require) {
				cb( __webpack_require__("HGh5") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var blog = (async_default()(blog_load));
	
// CONCATENATED MODULE: ./routes/language-practice/index.js

		

		function language_practice_load(cb) {
			__webpack_require__.e/* require.ensure */(12).then((function (require) {
				cb( __webpack_require__("JTQm") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var language_practice = (async_default()(language_practice_load));
	
// CONCATENATED MODULE: ./routes/immigration-law/index.js

		

		function immigration_law_load(cb) {
			__webpack_require__.e/* require.ensure */(11).then((function (require) {
				cb( __webpack_require__("VrUj") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var immigration_law = (async_default()(immigration_law_load));
	
// CONCATENATED MODULE: ./routes/language-learners/index.js

		

		function language_learners_load(cb) {
			__webpack_require__.e/* require.ensure */(10).then((function (require) {
				cb( __webpack_require__("hNrB") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var language_learners = (async_default()(language_learners_load));
	
// CONCATENATED MODULE: ./routes/featured-service/index.js

		

		function featured_service_load(cb) {
			__webpack_require__.e/* require.ensure */(8).then((function (require) {
				cb( __webpack_require__("eJ5p") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var featured_service = (async_default()(featured_service_load));
	
// CONCATENATED MODULE: ./routes/accountActivationSuccess/index.js

		

		function accountActivationSuccess_load(cb) {
			__webpack_require__.e/* require.ensure */(24).then((function (require) {
				cb( __webpack_require__("C4JC") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var accountActivationSuccess = (async_default()(accountActivationSuccess_load));
	
// CONCATENATED MODULE: ./routes/accountActivationError/index.js

		

		function accountActivationError_load(cb) {
			__webpack_require__.e/* require.ensure */(25).then((function (require) {
				cb( __webpack_require__("7of5") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var accountActivationError = (async_default()(accountActivationError_load));
	
// CONCATENATED MODULE: ./routes/api/index.js

		

		function api_load(cb) {
			__webpack_require__.e/* require.ensure */(23).then((function (require) {
				cb( __webpack_require__("QMfK") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes_api = (async_default()(api_load));
	
// EXTERNAL MODULE: ./components/unsupported-browsers/style.scss
var unsupported_browsers_style = __webpack_require__("nRW3");
var unsupported_browsers_style_default = /*#__PURE__*/__webpack_require__.n(unsupported_browsers_style);

// EXTERNAL MODULE: ./assets/browsers/chrome.svg
var chrome = __webpack_require__("ihXi");
var chrome_default = /*#__PURE__*/__webpack_require__.n(chrome);

// EXTERNAL MODULE: ./assets/browsers/safari.svg
var safari = __webpack_require__("Xc0S");
var safari_default = /*#__PURE__*/__webpack_require__.n(safari);

// CONCATENATED MODULE: ./components/unsupported-browsers/index.js





var unsupported_browsers__ref = Object(preact_min["h"])('img', { src: chrome_default.a, alt: 'Google Chrome' });

var unsupported_browsers__ref2 = Object(preact_min["h"])(
  'p',
  null,
  'Google Chrome ',
  Object(preact_min["h"])('br', null),
  Object(preact_min["h"])(
    'span',
    null,
    '(Latest Version)'
  )
);

var unsupported_browsers__ref3 = Object(preact_min["h"])('img', { src: safari_default.a, alt: 'Safari' });

var unsupported_browsers__ref4 = Object(preact_min["h"])(
  'p',
  null,
  'Safari ',
  Object(preact_min["h"])('br', null),
  Object(preact_min["h"])(
    'span',
    null,
    '(Latest Version)'
  )
);

var unsupported_browsers_UnsupportedBrowsers = function UnsupportedBrowsers() {
  return Object(preact_min["h"])(
    'div',
    { className: unsupported_browsers_style_default.a.wrapper },
    Object(preact_min["h"])(
      'h1',
      { className: unsupported_browsers_style_default.a.header },
      'You are seeing this page because you are using an unsupported browser. Currently, we support the following browsers:'
    ),
    Object(preact_min["h"])(
      'div',
      { className: unsupported_browsers_style_default.a.browser },
      Object(preact_min["h"])(
        'a',
        { className: unsupported_browsers_style_default.a.browserLink, href: 'https://www.google.com/chrome', target: '_blank', rel: 'noopener noreferrer' },
        unsupported_browsers__ref,
        unsupported_browsers__ref2
      )
    ),
    Object(preact_min["h"])(
      'div',
      { className: unsupported_browsers_style_default.a.browser },
      Object(preact_min["h"])(
        'a',
        { className: unsupported_browsers_style_default.a.browserLink, href: 'https://www.apple.com/safari', target: '_blank', rel: 'noopener noreferrer' },
        unsupported_browsers__ref3,
        unsupported_browsers__ref4
      )
    )
  );
};

/* harmony default export */ var unsupported_browsers = (unsupported_browsers_UnsupportedBrowsers);
// CONCATENATED MODULE: ./routes/upcoming-bookings/index.js

		

		function upcoming_bookings_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("z5hk") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var upcoming_bookings = (async_default()(upcoming_bookings_load));
	
// CONCATENATED MODULE: ./prismic/prismic-configuration.js
/* harmony default export */ var prismic_configuration = ({

  apiEndpoint: 'https://telmie.cdn.prismic.io/api/v2',

  // -- Access token if the Master is not open
  // accessToken: 'xxxxxx',

  // OAuth
  // clientId: 'xxxxxx',
  // clientSecret: 'xxxxxx',

  // -- Links resolution rules
  // This function will be used to generate links to Prismic.io documents
  // As your project grows, you should update this function according to your routes
  linkResolver: function linkResolver(doc, ctx) {
    return '/';
  }
});
// CONCATENATED MODULE: ./prismic/uids.js
var _uids;



var uids = (_uids = {}, _uids[consts["g" /* EN */]] = {
  CONTACT_US: 'WoRRbigAACgAco9L',
  REGISTRATION: 'Wu7sWiUAAKoBSMxT',
  SHORT_REVIEWS: 'W-0TkBAAACkAeSLm',
  MESSAGE: 'XATS9xAAAEEA1kal'
}, _uids[consts["u" /* RU */]] = {
  // HOMEPAGE: 'W_0QkREAAC8AF6jE',
  /* CONTACT_US: 'WoRRbigAACgAco9L',
  REGISTRATION: 'Wu7sWiUAAKoBSMxT', */
  // LANGUAGE_PRACTICE: 'W_1bdREAADMAGO_b',
  // IMMIGRATION_ADVICE: 'W_1Z1hEAAC4AGOiI',
  /* SHORT_REVIEWS: 'W-0TkBAAACkAeSLm', */
  MESSAGE: 'XATouRAAADsA1qY3'
}, _uids[consts["m" /* IT */]] = {
  MESSAGE: 'XBpjiBEAACcAYCHS'
}, _uids[consts["i" /* ES */]] = {
  MESSAGE: 'XC-L8xEAACMAvKAs'
}, _uids[consts["q" /* PL */]] = {
  MESSAGE: 'XEhg5xUAACQAvYtk'
}, _uids[consts["a" /* AE */]] = {
  MESSAGE: 'XEhgmRUAACUAvYoL'
}, _uids[consts["r" /* PT */]] = {
  MESSAGE: 'XE22fxQAACEALIfu'
}, _uids[consts["e" /* DE */]] = {
  MESSAGE: 'XGb1uhAAACgAlRki'
}, _uids[consts["k" /* FR */]] = {
  MESSAGE: 'XHVVsBIAACMAg5YJ'
}, _uids);

var types = {
  FAQ: 'faq',
  STATIC_PAGE: 'static_page',
  SERVICE_PAGE: 'immigration_advice',
  HOMEPAGE: 'homepage'
};

var tags = {
  PRIVACY: 'Privacy',
  TERMS: 'Terms',
  IMMIGRATION_ADVICE: 'ImmigrationAdvice',
  IMMIGRATION_CLIENTS: 'ImmigrationAdviceClients',
  LANGUAGE_PRACTICE: 'LanguagePractice',
  LANGUAGE_LEARNERS: 'LanguageLearners',
  CANCELLATION: 'cancellation'
};
// EXTERNAL MODULE: ./utils/con-helpers.js
var con_helpers = __webpack_require__("AoWs");

// EXTERNAL MODULE: ./actions/index.js
var actions = __webpack_require__("vyGZ");

// CONCATENATED MODULE: ./actions/url.js


// eslint-disable-next-line import/prefer-default-export
var url_changeUrl = function changeUrl(data) {
  return function (dispatch) {
    dispatch({
      type: actions["a" /* actionTypes */].SET_URL,
      payload: data
    });
  };
};
// EXTERNAL MODULE: ./actions/callTimer.js
var callTimer = __webpack_require__("gZjB");

// EXTERNAL MODULE: ../node_modules/animate.css/animate.css
var animate = __webpack_require__("TOx8");
var animate_default = /*#__PURE__*/__webpack_require__.n(animate);

// EXTERNAL MODULE: ../node_modules/react-notifications-component/dist/theme.css
var theme = __webpack_require__("vnfP");
var theme_default = /*#__PURE__*/__webpack_require__.n(theme);

// EXTERNAL MODULE: ./utils/index.js + 1 modules
var utils = __webpack_require__("DHvs");

// EXTERNAL MODULE: ./actions/api-notifications.js
var actions_api_notifications = __webpack_require__("kKXN");

// EXTERNAL MODULE: ./actions/application.js + 1 modules
var actions_application = __webpack_require__("niFk");

// EXTERNAL MODULE: ./actions/tokenValidation.js + 1 modules
var tokenValidation = __webpack_require__("gkzq");

// EXTERNAL MODULE: ./actions/sign-in.js + 1 modules
var actions_sign_in = __webpack_require__("jT1X");

// CONCATENATED MODULE: ./routes/find-pro/index.js

		

		function find_pro_load(cb) {
			__webpack_require__.e/* require.ensure */(16).then((function (require) {
				cb( __webpack_require__("dtYl") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var find_pro = (async_default()(find_pro_load));
	
// EXTERNAL MODULE: ./actions/forgotPassword.js + 1 modules
var forgotPassword = __webpack_require__("J7oX");

// CONCATENATED MODULE: ./components/app.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routes", function() { return routes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "langRoutes", function() { return app_langRoutes; });
var app__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var app__class, app__temp, app__initialiseProps;



function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */
/* eslint-disable */









// DON'T TOUCH IT!!!!! IF YOU REMOVE IT, CALLS WON'T WORK AT ALL!!!! DONT'T TOUCH ADAPTER













































// import FeaturedService from '../routes/featured-service';



























var _require = __webpack_require__("GLIM"),
    detect = _require.detect;

var app___FILE__ = 'app.js';

var routes = {
  HOME: '/',
  FIND_PRO: '/find-pro',
  SEARCH: '/search',
  // SEARCH_FOR_COMP: '/search/',
  USER: '/user/:userId',
  PREVIEW: '/preview',
  USER_FOR_COMP: '/user/',
  CLIENT: '/client/:userId',
  CLIENT_FOR_COMP: '/client/',
  FAQ: '/help',
  FAQ_LINK: '/#faq',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  CONTACT_US: '/contact-us',
  CONTACT_US_LINK: '/#contact-us',
  HOW_WORKS_LINK: '/#how-it-works',
  BECOME_PRO_LINK: '/#become-pro',
  SIGN_UP: '/sign-up',
  LOG_IN: '/log-in',
  MY_PROS: '/my-pros',
  MY_BOOKINGS: '/my-bookings',
  MY_CLIENTS: '/my-clients',
  TRANSACTIONS: '/transactions',
  EDIT_PROFILE: '/edit-profile',
  LOGIN_OR_SIGNUP: '/login-or-signup',
  FORGOT_PASSWORD: '/forgot-password',
  SETTINGS: '/settings',
  REGISTER_PRO: '/register-pro',
  BLOG_LINK: '/#blog',
  BLOG_POST: '/blog/:uid',
  LANGUAGE_PRACTICE: '/language-practice',
  IMMIGRATION_ADVICE: '/immigration-advice',
  IMMIGRATION_CONSULTANT: '/immigration-pro',
  LANGUAGE_LEARNERS: '/language-learners',
  FEATURED_SERVICE: '/featured-service/:serviceId',
  FEATURED_SERVICE_FOR_COMP: '/featured-service',
  SELECT_INTEREST: '/select-interest',
  ACCOUNT_ACTIVATION_SUCCESS: '/account-activation-success',
  ACCOUNT_ACTIVATION_ERROR: '/account-activation-error',
  PROFILE: '/profile/:refId',
  PROFILE_FOR_COMP: '/profile/',
  API: '/token',
  CANCELLATION: '/cancellation'
};

var app_langRoutes = function langRoutes(lang, route) {
  return lang == consts["G" /* langs */][consts["g" /* EN */]].code ? route : '/' + lang + route;
};

var HIDE_NOTIFICATION_TIME = 40000;
var VERSION_CHECK_FREQUENCY = 60000;
var checkVersionSupportTimer = null;

var BRANCH_IO_RETRIES = 4;

var app__ref = Object(preact_min["h"])(dist_default.a, null);

var app__ref2 = Object(preact_min["h"])(
  'p',
  null,
  'You\'ve come to this page by clicking a link.'
);

var app__ref3 = Object(preact_min["h"])(
  'p',
  null,
  'We are having trouble determining its final destination. Please, wait a moment, we will retry a couple of times.'
);

var app__ref4 = Object(preact_min["h"])(
  'p',
  null,
  'We have made several attempts to determine the final destination for the link you have clicked, but all of them failed.'
);

var app__ref5 = Object(preact_min["h"])(
  'p',
  null,
  'Please, try again in 10 minutes or contact Telmie Support.'
);

var app_App = (app__temp = app__class = function (_Component) {
  app__inherits(App, _Component);

  function App(props, context) {
    app__classCallCheck(this, App);

    var _this = app__possibleConstructorReturn(this, _Component.call(this, props));

    app__initialiseProps.call(_this);

    var uuid = v4_default()();
    var params = Object(utils["m" /* queryToParams */])(window.location.search.replace('?', ''));

    if (params.payment_intent) {
      window.top.postMessage({ message: '3DS-authentication-complete', params: params }, window.location.origin);
    }

    var audioInput = new Audio();
    audioInput.id = 'webRTCIncomingAudio';
    audioInput.muted = false;
    audioInput.controls = false;

    _this.state = {
      prismicCtx: null,
      currentUrl: '',

      chats: {},
      received: -1,
      users: {},
      isConnected: false,
      showNotif: false,
      userVideoStream: false,
      sessionId: uuid,
      avtimeNotificationAudio: Object(media_session["a" /* createInvisibleAudioElementFromMedia */])('/assets/AvtimeNotification.mp3', 'avtimeNotification'),
      preBookingNotificationAudio: Object(media_session["a" /* createInvisibleAudioElementFromMedia */])('/assets/preBooking.mp3', 'prebookingNotification'),
      bookingEndedNotificationAudio: Object(media_session["a" /* createInvisibleAudioElementFromMedia */])('/assets/bookingEnded.mp3', 'bookingEndedNotification'),
      callRingtone: Object(media_session["a" /* createInvisibleAudioElementFromMedia */])('/assets/call_ringtone.mp3', 'callRingtone'),
      messageAudio: Object(media_session["a" /* createInvisibleAudioElementFromMedia */])('/assets/definite.mp3', 'incomingMessageNotification'),
      reconnectingAudio: Object(media_session["a" /* createInvisibleAudioElementFromMedia */])('/assets/reconnecting.mp3', 'reconnectingNotification')
    };

    _this.isFullySupportedEnvironment = context.isSupportedBrowser || context.isSupportedOS;

    if (!_this.isFullySupportedEnvironment) {
      // Prevent further initialization as only static routes will be allowed in unsupported browsers
      return app__possibleConstructorReturn(_this);
    }

    push_min_default.a.Permission.request();

    _this.eventBus = new eventemitter3_default.a();

    var browser = detect();
    _this.preferredOutputDeviceId = browser.name === 'chrome' && browser.os.startsWith('Windows') ? 'communications' : 'default';

    _this.connection = new utils_connection["j" /* default */]({
      setMsg: _this.setMsg.bind(_this),
      setMsgHistory: _this.setMsgHistory.bind(_this),
      setUsr: _this.setUsr,
      changeUnreadNum: function changeUnreadNum() {
        var _this$props;

        if (_this.state.currentUrl === routes.MY_CLIENTS) {
          _this.props.getCalls(true, 1, false);
        } else if (_this.state.currentUrl === routes.MY_PROS) {
          _this.props.getCalls(false, 1, false);
        }
        (_this$props = _this.props).changeUnreadNum.apply(_this$props, arguments);
      },
      changeConnectedState: function changeConnectedState(isConnected) {
        return _this.setState({ isConnected: isConnected });
      },
      getCInfo: function getCInfo() {
        return _this.props.communicateModal.callInfo;
      },
      getCallInfo: _this.props.getCallInfo,
      openComModal: _this.props.openComModal,
      closeComModal: _this.closeComModal,
      createNotification: _this.createNotification,
      chooseChatPerson: _this.chooseChatPerson,
      changeCallRingtoneStatus: _this.changeCallRingtoneStatus,
      caleeIsBusy: _this.props.caleeIsBusy,
      processCall: _this.props.processCall,
      speaking: _this.props.speaking,
      setAutoFinishNotif: _this.setAutoFinishNotif,
      setAutoFinishPreBookingNotif: _this.setAutoFinishPreBookingNotif,
      setAutoFinishBookingEndedNotif: _this.setAutoFinishBookingEndedNotif,
      undoAutoFinishNotif: _this.undoAutoFinishNotif,
      changeVideoStreamStatus: _this.changeUserVideoStreamStatus,
      uuid: _this.state.sessionId,
      updateMsgStatus: _this.updateMsgStatus.bind(_this),
      setTimeOffset: _this.setTimeOffset,
      messageAudio: _this.state.messageAudio,
      reconnect: _this.reconnect,
      changeReconnectionStatus: _this.handleReconnectionStatusChange,
      audioInput: audioInput
    });
    _this.sendPresenceThunk = _this.connection.sendPresence.bind(_this.connection);
    return _this;
  }

  App.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        onApplicationCheckOS = _props.applicationCheckOS,
        initialise = _props.initialise,
        fetchUserData = _props.fetchUserData,
        setProcessed = _props.setProcessed,
        checkApplicationVersionSupport = _props.checkApplicationVersionSupport;
    var reconnectingAudio = this.state.reconnectingAudio;


    onApplicationCheckOS();

    if (!this.isFullySupportedEnvironment) {
      return;
    }

    initialise();

    checkVersionSupportTimer = setInterval(checkApplicationVersionSupport, VERSION_CHECK_FREQUENCY);

    this.eventBus.on(consts["j" /* EVENT_BUS_EVENTS */].PRESENCE_CHANGED_TO_ONLINE, this.onPresenceAvailable, this);

    var deviceId = localStorage.getItem('uuid');

    if (!deviceId) {
      localStorage.setItem('uuid', v4_default()());
    }

    firebase.analytics().logEvent('Launch_the_App');

    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {};
    }

    reconnectingAudio.addEventListener('ended', function () {
      reconnectingAudio.currentTime = 0;
      reconnectingAudio.play().catch(function () {
        console.error('Cannot play reconnection audio');
        Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
      });
      Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
    });

    this.state.callRingtone.addEventListener('ended', function () {
      _this2.state.callRingtone.currentTime = 0;
      _this2.state.callRingtone.play();
      Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
    });

    document.body.addEventListener('click', this.setUpAudio);
    document.body.addEventListener('keydown', this.setUpAudio);
    window.addEventListener('storage', this.updatedUserAuth);
    window.addEventListener('pagehide', this.onPageHide);

    this.connection.events.on(utils_connection["b" /* CALL_FAILED_EVENT */], this.onCallFailed, this);
    this.connection.events.on(utils_connection["e" /* INCOMING_CALL_REQUEST_EVENT */], this.onCallStarted, this);
    this.connection.events.on(utils_connection["g" /* OUTGOING_CALL_STARTED_EVENT */], this.onCallStarted, this);
    this.connection.events.on(utils_connection["c" /* CALL_FINISHED_EVENT */], this.onCallFinished, this);
    this.connection.events.on(utils_connection["a" /* CALL_CONNECTED_EVENT */], this.onCallConnected, this);
    this.connection.events.on(utils_connection["i" /* SCREEN_SHARING_PERMISSION_DENIED_EVENT */], this.onScreenSharingPermissionDenied, this);

    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        return getUserMedia ? new Promise(function (resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject);
        }) : Promise.reject(new Error('getUserMedia is not implemented in this browser'));
      };
    }

    this._disableMultimediaKeys();

    navigator.mediaDevices && typeof navigator.mediaDevices.addEventListener === 'function' && navigator.mediaDevices.addEventListener('devicechange', this.onMediaDevicesChanged);

    if (this.props.userData.id) {
      this.reconnect(v4_default()());
    }

    var userAuth = localStorage.getItem(consts["z" /* USER_AUTH */]);

    if (userAuth) {
      fetchUserData('Bearer ' + userAuth);
    } else {
      setProcessed();
    }

    this.initBranchIo();
  };

  App.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!this.isFullySupportedEnvironment) {
      return;
    }

    var _props$userData = this.props.userData,
        prevUser = _props$userData === undefined ? {} : _props$userData;
    var _nextProps$userData = nextProps.userData,
        loading = _nextProps$userData.loading,
        id = _nextProps$userData.id;

    if (!prevUser.id && nextProps.userData.id) {
      this.reconnect(v4_default()());
      this.props.getUnreadMessages();

      if (this.props.redirect.refId) {
        this.props.getUserByRef(this.props.redirect.refId);
      }
    }
    if (!loading && prevUser.loading && !id) {
      var name = nextProps.branchIo.name;

      if (name === 'registration') {
        Object(preact_router_es["route"])(routes.SIGN_UP);
      }
      if (name === 'profile') {
        Object(preact_router_es["route"])('' + routes.PROFILE_FOR_COMP + nextProps.branchIo.value);
      }
    }
    if (nextProps.branchIo.name && !prevUser.id && nextProps.userData.id || nextProps.userData.id && nextProps.branchIo.name && nextProps.branchIo !== this.props.branchIo || nextProps.userFromDeepLink.id && nextProps.userData.id || prevUser.id && nextProps.userFromDeepLink.id) {
      if (nextProps.branchIo.name === 'sector') {
        this.props.updateUserSettings({ interestSector: [nextProps.branchIo.value] });
        Object(preact_router_es["route"])(routes.FIND_PRO);
        nextProps.setBranchIoData({});
      }
      if (nextProps.branchIo.name === 'profile' && (nextProps.userFromDeepLink.id || this.props.userFromDeepLink.id)) {
        Object(preact_router_es["route"])('' + routes.USER_FOR_COMP + nextProps.userFromDeepLink.id);
        nextProps.setBranchIoData({});
      }
    }
    if (prevUser.id && !nextProps.userData.id) {
      this.connection.disconnect();
      this.setState({ chats: {}, users: {} });
      this.props.clearChats();
    }
  };

  App.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this3 = this;

    var _props2 = this.props,
        isWebview = _props2.isWebview,
        callTimeBeep = _props2.callTimeBeep,
        locale = _props2.locale,
        onAddNotification = _props2.addNotification,
        isUnsupportedMobileOs = _props2.application.isUnsupportedMobileOs,
        _props2$userData = _props2.userData,
        id = _props2$userData.id,
        settings = _props2$userData.settings;


    if (isUnsupportedMobileOs && !isWebview && !prevProps.application.isUnsupportedMobileOs) {
      setTimeout(function () {
        onAddNotification({
          reloadRequired: false,
          id: v4_default()(),
          message: langPack["a" /* langPack */][locale].NOTIFICATIONS.DOWNLOAD_TO_USE_ON_MOBILE,
          type: api_notifications["a" /* API_NOTIFICATION_TYPE */].SUCCESS
        });
      }, 1000);
    }

    if (!this.isFullySupportedEnvironment) {
      return;
    }

    if (prevProps.callTimeBeep !== callTimeBeep) {
      this.connection.setCallTimeBeep(callTimeBeep);
    }

    if (prevState.chats !== this.state.chats) {
      this.props.changeChat(this.state.chats);
    }
    if (this.state.isConnected !== prevState.isConnected) {
      this.props.changeConnectionStatus(this.state.isConnected);
    }

    if (id && (!settings || !settings.interestSector.length && this.state.currentUrl !== routes.SELECT_INTEREST)) {
      Object(preact_router_es["route"])(routes.SELECT_INTEREST);
    }

    if (this.props.notifications && this.props.notifications !== prevProps.notifications && this.props.notifications.length) {
      var newNotifications = this.props.notifications || [];
      var uniqueNotifications = this.uniqueNotifications(prevProps.notifications, newNotifications);

      uniqueNotifications.forEach(function (notification) {
        _this3.handleAddNotification(notification);
      });
    }
  };

  App.prototype.componentWillMount = function componentWillMount() {
    var _this4 = this;

    esm["a" /* default */].initialize('UA-127710081-1');
    this.buildContext().then(function (prismicCtx) {
      _this4.setState({ prismicCtx: prismicCtx });
    }).catch(function (e) {
      console.error('Cannot contact the API, check your prismic configuration:\n' + e);
    });
  };

  /**
   *
   * @param {boolean} isReconnect
   */


  App.prototype.buildContext = function buildContext() {
    var accessToken = prismic_configuration.accessToken;

    return prismic_javascript_min_default.a.api(prismic_configuration.apiEndpoint, { accessToken: accessToken }).then(function (api) {
      return {
        api: api,
        endpoint: prismic_configuration.apiEndpoint,
        accessToken: accessToken,
        linkResolver: prismic_configuration.linkResolver
      };
    });
  };

  App.prototype.onLogout = function onLogout() {
    this.connection.gracefullyCloseCallOnLogout();
  };

  App.prototype.render = function render() {
    var _props3 = this.props,
        _props3$userData = _props3.userData,
        user = _props3$userData === undefined ? {} : _props3$userData,
        openComModal = _props3.openComModal;

    var locale = this.props.locale || consts["g" /* EN */];
    var isLoading = user.loading;

    return Object(preact_min["h"])(
      'div',
      { id: 'app' },
      app__ref,
      this.isFullySupportedEnvironment && Object(preact_min["h"])(device_activity, {
        isConnected: this.state.isConnected,
        sendPresence: this.sendPresenceThunk,
        eventBus: this.eventBus,
        callEvents: this.connection.events }),
      this.state.prismicCtx !== null && [Object(preact_min["h"])(header, {
        locale: locale,
        prismicCtx: this.state.prismicCtx,
        uid: uids[locale].MESSAGE,
        openComModal: openComModal,
        onLogout: this.onLogout.bind(this)
      }), Object(preact_min["h"])(
        'div',
        { className: 'mainContainer', style: { minHeight: window.outerHeight - 80 < 755 ? 755 : window.outerHeight - 80 } },
        Object(preact_min["h"])(
          preact_router_es["Router"],
          { onChange: this.handleRoute },
          user.id ? user.pro != null ? this.renderProRoutes() : this.renderUserRoutes() : this.renderDefaultRoutes(),
          Object(preact_min["h"])(errorRoute, {
            isLoading: isLoading,
            userId: user.id,
            path: document.location.pathname,
            locale: this.props.locale,
            'default': true
          })
        ),
        this.isFullySupportedEnvironment && Object(preact_min["h"])(communication_notification, { isShown: this.state.showNotif, onClick: this.hideNotif, locale: locale })
      ), Object(preact_min["h"])(footer, { locale: locale }), this.isFullySupportedEnvironment && Object(preact_min["h"])(communication_component, {
        connection: this.connection,
        isConnected: this.state.isConnected,
        users: this.state.users,
        chooseChatPerson: this.chooseChatPerson,
        user: this.props.userData,
        openComModal: openComModal
      })]
    );
  };

  App.prototype.componentWillUnmount = function componentWillUnmount() {
    clearInterval(checkVersionSupportTimer);

    this.connection.events.removeListener(utils_connection["b" /* CALL_FAILED_EVENT */], this.onCallFailed, this);
    this.connection.events.removeListener(utils_connection["e" /* INCOMING_CALL_REQUEST_EVENT */], this.onCallStarted, this);
    this.connection.events.removeListener(utils_connection["g" /* OUTGOING_CALL_STARTED_EVENT */], this.onCallStarted, this);
    this.connection.events.removeListener(utils_connection["c" /* CALL_FINISHED_EVENT */], this.onCallFinished, this);
    this.connection.events.removeListener(utils_connection["a" /* CALL_CONNECTED_EVENT */], this.onCallConnected, this);
    this.connection.events.removeListener(utils_connection["i" /* SCREEN_SHARING_PERMISSION_DENIED_EVENT */], this.onScreenSharingPermissionDenied, this);

    this.eventBus.removeListener(consts["j" /* EVENT_BUS_EVENTS */].PRESENCE_CHANGED_TO_ONLINE, this.onPresenceAvailable, this);
    navigator.mediaDevices && typeof navigator.mediaDevices.removeEventListener === 'function' && navigator.mediaDevices.removeEventListener('devicechange', this.onMediaDevicesChanged);

    window.removeEventListener('pagehide', this.onPageHide);

    this._enableMultimediaKeys();
  };

  return App;
}(preact_min["Component"]), app__initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleReconnectionStatusChange = function (isReconnect) {
    var changeReconnectionStatus = _this5.props.changeReconnectionStatus;


    _this5.changeReconnectionAudioStatus(isReconnect);
    changeReconnectionStatus(isReconnect);
  };

  this.initBranchIo = function () {
    _this5.remainingBranchIORetries = BRANCH_IO_RETRIES;

    branch.init("key_live_hcHm1UgQh2mQQALMLl3aMojlrrjmoA5w", { retries: BRANCH_IO_RETRIES }, _this5.getBranchIoData);
  };

  this.setUpAudio = function () {
    /*
    * Permissions to play audio in Safari
    * */

    document.body.removeEventListener('click', _this5.setUpAudio);
    document.body.removeEventListener('keydown', _this5.setUpAudio);

    Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
  };

  this.changeCallRingtoneStatus = function () {
    var play = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (play) {
      _this5.safeSetSinkId(_this5.state.callRingtone, _this5.preferredOutputDeviceId);
      _this5.state.callRingtone.muted = false;
      _this5.state.callRingtone.play();
      Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
    } else {
      _this5.state.callRingtone.pause();
      _this5.state.callRingtone.muted = true;
      _this5.state.callRingtone.currentTime = 0;
      Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
    }
  };

  this.changeReconnectionAudioStatus = function (play) {
    var reconnectingAudio = _this5.state.reconnectingAudio;


    if (play) {
      _this5.safeSetSinkId(_this5.state.reconnectingAudio, _this5.preferredOutputDeviceId);
      reconnectingAudio.muted = false;
      reconnectingAudio.play().catch(function () {
        console.error('Cannot play reconnection audio');
        Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
      });
      Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
    } else {
      reconnectingAudio.pause();
      reconnectingAudio.muted = true;
      reconnectingAudio.currentTime = 0;
      Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
    }
  };

  this.initConnection = function () {
    _this5.connection.initializeConnection(app__extends({}, _this5.props, {
      uuid: _this5.state.uuid
    })).catch(function (error) {
      console.error('Cannot initialise connection');

      throw error;
    });
  };

  this.reconnect = function () {
    var uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : v4_default()();

    _this5.setState({
      uuid: uuid
    }, function () {
      return _this5.initConnection();
    });
  };

  this._disableMultimediaKeys = function () {
    Object(media_session["b" /* safeDisableMultimediaKeys */])();
  };

  this._enableMultimediaKeys = function () {
    Object(media_session["c" /* safeEnableMulimediaKeys */])();
  };

  this.onCallFailed = function (amICallee, reason) {
    window.removeEventListener('beforeunload', _this5.onPageUnloadWhileCallIsInProgress, { capture: true });
    clearInterval(_this5.callSecondsInterval);
    _this5.callSecondsInterval = null;
    setTimeout(function () {
      _this5.createNotification('Failed to ' + (amICallee ? 'accept' : 'initiate') + ' the call', reason, 10000);
    }, 500);
  };

  this.onCallStarted = function () {
    _this5.props.resetCallTimer();
    window.addEventListener('beforeunload', _this5.onPageUnloadWhileCallIsInProgress, { capture: true });
  };

  this.onCallFinished = function () {
    window.removeEventListener('beforeunload', _this5.onPageUnloadWhileCallIsInProgress, { capture: true });
    clearInterval(_this5.callSecondsInterval);
    _this5.callSecondsInterval = null;
  };

  this.onCallConnected = function () {
    _this5.props.setCallStartTimestamp();
    _this5.callSecondsInterval = setInterval(function () {
      return _this5.props.tickCallTimer();
    }, 1000);
  };

  this.onPageUnloadWhileCallIsInProgress = function (event) {
    event.preventDefault();
    return event.returnValue = "A call is in progress. Are you sure you want to close the page and finish the call?";
  };

  this.onScreenSharingPermissionDenied = function (reason) {
    setTimeout(function () {
      _this5.createNotification('Could not share the screen content', reason);
    }, 100);
  };

  this.getBranchIoData = function (err, data) {
    var __METHOD__ = 'getBranchIoData';

    var _props4 = _this5.props,
        onGetUserByRef = _props4.getUserByRef,
        onSetBranchIoData = _props4.setBranchIoData,
        setPasswordResettingMode = _props4.setPasswordResettingMode,
        onTokenValidate = _props4.tokenValidate,
        _props4$userData = _props4.userData,
        loading = _props4$userData.loading,
        id = _props4$userData.id,
        onAddNotification = _props4.addNotification;


    if (err) {
      logger["j" /* logWithTag */](app___FILE__, __METHOD__, logger["b" /* TAG_BRANCH_IO */], 'Failed to parse branch link data', lib["LogLevel"].Error, err.message, false);

      if (_this5.remainingBranchIORetries === BRANCH_IO_RETRIES) {
        setTimeout(function () {
          return onAddNotification({
            reloadRequired: false,
            id: v4_default()(),
            message: [app__ref2, app__ref3],
            type: api_notifications["a" /* API_NOTIFICATION_TYPE */].WARNING,
            dismissAfter: 10000
          });
        }, 0);
      }

      _this5.remainingBranchIORetries = _this5.remainingBranchIORetries - 1;

      if (_this5.remainingBranchIORetries === 0) {
        setTimeout(function () {
          return onAddNotification({
            reloadRequired: false,
            id: v4_default()(),
            message: [app__ref4, app__ref5],
            type: api_notifications["a" /* API_NOTIFICATION_TYPE */].DANGER,
            dismissAfter: 10000
          });
        }, 0);
      }

      return;
    };

    _this5.remainingBranchIORetries = BRANCH_IO_RETRIES;

    /**
     * @type {{
     *  data_parsed: {
     *    schooseChatPersonectorTag,
     *    ref_id: string,
     *    ref_type: string,
     *    partner_tag
     * } }}
     */
    var dataParsed = data.data_parsed;


    Object.keys(dataParsed).length > 0 && dataParsed["+clicked_branch_link"] && logger["j" /* logWithTag */](app___FILE__, __METHOD__, logger["b" /* TAG_BRANCH_IO */], 'A branch.io link has been successfully parsed', lib["LogLevel"].Info, dataParsed, true);

    var branchIoData = void 0;

    if (dataParsed.ref_type === consts["c" /* BRANCH_IO_REF_TYPES */].RESET_PASSWORD) {
      var email = dataParsed.email,
          token = dataParsed.token;


      branchIoData = { email: email, token: token };

      setPasswordResettingMode(branchIoData);

      return;
    }

    if (dataParsed.ref_type === 'REGISTRATION') {
      branchIoData = { name: 'registration', value: dataParsed.email };

      var _token = dataParsed.token;


      onTokenValidate({ token: _token });

      onSetBranchIoData(branchIoData);
    }
    if (dataParsed.ref_type === 'PARTNER') {
      branchIoData = { name: 'partner', value: dataParsed.partner_tag };
      onSetBranchIoData(branchIoData);
    }
    if (dataParsed.schooseChatPersonectorTag) {
      branchIoData = { name: 'sector', value: dataParsed.sectorTag };
    } else if (dataParsed.ref_id) {
      branchIoData = { name: 'profile', value: dataParsed.ref_id };
      onGetUserByRef(branchIoData.value);
    }
    if (branchIoData) {
      if (!loading && !id) {
        if (branchIoData.name === 'profile') {
          Object(preact_router_es["route"])('' + routes.PROFILE_FOR_COMP + branchIoData.value);
        } else if (dataParsed.ref_type !== 'REGISTRATION') {
          Object(preact_router_es["route"])(routes.SIGN_UP);
          onSetBranchIoData(branchIoData);
        }
      } else {
        onSetBranchIoData(branchIoData);
      }
    }
  };

  this.createNotification = function () {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

    var __METHOD__ = 'App::createNotification';

    push_min_default.a.create(title, {
      body: body,
      icon: '/assets/icons/favicon-16x16.png',
      timeout: timeout,
      onClick: function onClick() {
        window.focus();
        callback();
        this.close();
      }
    }).catch(function (err) {
      logger["j" /* logWithTag */](app___FILE__, __METHOD__, logger["d" /* TAG_UI */], 'Failed to create a UI notification: ' + err, err);
    });
  };

  this.setMsg = function (userId, isPro, id, msg) {
    var isMy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    var isCurrentFeaturedService = _this5.props.communicateModal.person && _this5.props.communicateModal.person.id === userId;
    if (isCurrentFeaturedService || Object(con_helpers["g" /* isCurrentUserRoute */])(_this5.state.currentUrl, userId)) {
      _this5.setState(function (prev) {
        return Object(con_helpers["p" /* setMessages */])(id, msg, isMy, prev);
      });
    }
  };

  this.setMsgHistory = function (id, msgArr, count) {
    return _this5.setState(function (prev) {
      return Object(con_helpers["o" /* setMessageHistory */])(id, msgArr, count, prev);
    });
  };

  this.setUsr = function (user) {
    !Object(con_helpers["g" /* isCurrentUserRoute */])(_this5.state.currentUrl, user.id, user.isUserPro) && _this5.setState(function (prev) {
      return Object(con_helpers["q" /* setUser */])(user, prev);
    });
  };

  this.clearChat = function (userId) {
    return _this5.setState(function (prev) {
      return Object(con_helpers["b" /* clearUserChat */])(userId, prev);
    });
  };

  this.setDisplayedStatus = function (userJID) {
    return _this5.setState(function (prev) {
      var _extends2;

      return {
        chats: app__extends({}, prev.chats, (_extends2 = {}, _extends2[userJID] = app__extends({}, prev.chats[userJID], {
          isDisplayed: true,
          mesId: '',
          thread: ''
        }), _extends2))
      };
    });
  };

  this.onPresenceAvailable = function () {
    _this5.props.getUnreadMessages();
  };

  this.closeComModal = function () {
    _this5.props.changeVideoStatus(false);
    _this5.setState({ userVideoStream: false });
    _this5.props.closeComModal();
  };

  this.setTimeOffset = function (offset) {
    _this5.props.setTimeOffset(offset);
  };

  this.updateMsgStatus = function (chatId, messId, status) {
    _this5.setState(function (_ref6) {
      var chats = _ref6.chats;

      var currentChat = chats[chatId];
      if (currentChat) {
        var _extends3;

        var lastMessage = currentChat.lastMessage;

        var messageIndex = 0;
        if (status === consts["H" /* statuses */].READ) {
          if (lastMessage === messId) {
            messageIndex = currentChat.chat.length - 1;
          } else {
            messageIndex = currentChat.chat.findIndex(function (item) {
              return item.id === messId;
            });
          }
        }
        var newChat = currentChat.chat.map(function (item, index) {
          var msg = void 0;
          if (index <= messageIndex && item.status !== consts["H" /* statuses */].READ && item.status !== consts["H" /* statuses */].FAILED) {
            msg = app__extends({}, item, {
              status: status
            });
          } else if (item.id === messId) {
            msg = app__extends({}, item, {
              status: status
            });
          } else {
            msg = item;
          }
          return msg;
        });
        return {
          chats: app__extends({}, chats, (_extends3 = {}, _extends3[chatId] = app__extends({}, chats[chatId], {
            chat: newChat
          }), _extends3))
        };
      }
    });
  };

  this.changeUserVideoStreamStatus = function (status) {
    _this5.props.changeVideoStatus(status);
    _this5.setState({ userVideoStream: status });
  };

  this.chooseChatPerson = function (person) {
    var witRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _this5.props.updateBadges(person);
    _this5.props.chooseChatPerson(person);
    witRedirect && Object(preact_router_es["route"])(routes.USER_FOR_COMP + person.toUser.id + '#chat');
  };

  this.hideNotif = function () {
    _this5.setState({ showNotif: false });
    clearTimeout(_this5.hideNotifTimeout);
    _this5.hideNotifTimeout = null;
  };

  this.setAutoFinishNotif = function () {
    _this5.hideNotifTimeout = setTimeout(_this5.hideNotif, HIDE_NOTIFICATION_TIME);
    _this5.safeSetSinkId(_this5.state.avtimeNotificationAudio, _this5.preferredOutputDeviceId);
    _this5.state.avtimeNotificationAudio.play();
    Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
    _this5.setState({ showNotif: true });
  };

  this.setAutoFinishPreBookingNotif = function () {
    _this5.hideNotifTimeout = setTimeout(_this5.hideNotif, HIDE_NOTIFICATION_TIME);
    _this5.safeSetSinkId(_this5.state.preBookingNotificationAudio, _this5.preferredOutputDeviceId);
    _this5.state.preBookingNotificationAudio.play();
    Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
    _this5.setState({ showNotif: true });
  };

  this.setAutoFinishBookingEndedNotif = function () {
    _this5.hideNotifTimeout = setTimeout(_this5.hideNotif, HIDE_NOTIFICATION_TIME);
    _this5.safeSetSinkId(_this5.state.bookingEndedNotificationAudio, _this5.preferredOutputDeviceId);
    _this5.state.bookingEndedNotificationAudio.play();
    Object(media_session["d" /* safeSetMediaPlaybackState */])('none');
    _this5.setState({ showNotif: true });
  };

  this.undoAutoFinishNotif = function () {
    clearTimeout(_this5.hideNotifTimeout);
    _this5.hideNotifTimeout = null;
  };

  this.handleRoute = function (e) {
    // this.updatedUserAuth();
    e.previous && _this5.handleClearNotifications();
    esm["a" /* default */].pageview(e.url);
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
    _this5.setState({ currentUrl: e.url });
    _this5.props.changeUrl(e.url);
  };

  this.renderProRoutes = function () {
    return _this5.isFullySupportedEnvironment ? [].concat(_this5.renderUserRoutes(), [Object(preact_min["h"])(routes_activity, { path: routes.MY_CLIENTS, isProCalls: true, eventBus: _this5.eventBus }), Object(preact_min["h"])(routes_user, {
      path: routes.CLIENT,
      isPro: false,
      users: _this5.state.users,
      clearChat: _this5.clearChat,
      setDisplayedStatus: _this5.setDisplayedStatus,
      received: _this5.state.received,
      chooseChatPerson: _this5.chooseChatPerson,
      uuid: _this5.state.sessionId,
      connection: _this5.connection,
      eventBus: _this5.eventBus
    }), Object(preact_min["h"])(preview, {
      path: routes.PREVIEW,
      clearChat: _this5.clearChat
    })]) : [Object(preact_min["h"])(unsupported_browsers, { path: routes.MY_CLIENTS }), Object(preact_min["h"])(unsupported_browsers, { path: routes.CLIENT }), Object(preact_min["h"])(unsupported_browsers, { path: routes.PREVIEW })];
  };

  this.renderUserRoutes = function () {
    return _this5.isFullySupportedEnvironment ? [].concat(_this5.renderDefaultRoutes(), [Object(preact_min["h"])(find_pro, { path: routes.FIND_PRO }), Object(preact_min["h"])(activity_pros, { path: routes.MY_PROS, isProCalls: false, eventBus: _this5.eventBus }), Object(preact_min["h"])(upcoming_bookings, { path: routes.MY_BOOKINGS }), Object(preact_min["h"])(transactions, { path: routes.TRANSACTIONS }), Object(preact_min["h"])(routes_user, {
      path: routes.USER,
      users: _this5.state.users,
      clearChat: _this5.clearChat,
      setDisplayedStatus: _this5.setDisplayedStatus,
      received: _this5.state.received,
      chooseChatPerson: _this5.chooseChatPerson,
      uuid: _this5.state.sessionId,
      connection: _this5.connection,
      eventBus: _this5.eventBus
    }), Object(preact_min["h"])(edit_profile["a" /* default */], { path: routes.EDIT_PROFILE }), Object(preact_min["h"])(featured_service, {
      path: routes.FEATURED_SERVICE,
      connection: _this5.connection,
      chooseChatPerson: _this5.chooseChatPerson,
      users: _this5.state.users,
      uuid: _this5.state.sessionId,
      clearChat: _this5.clearChat,
      received: _this5.state.received,
      setDisplayedStatus: _this5.setDisplayedStatus
    }), Object(preact_min["h"])(register_pro, { path: routes.REGISTER_PRO }), Object(preact_min["h"])(routes_settings, {
      path: routes.SETTINGS,
      setUserState: api_users["C" /* setUserState */],
      removeUserState: api_users["y" /* removeUserState */]
    }), Object(preact_min["h"])(select_interest, {
      path: routes.SELECT_INTEREST
    })]) : [].concat(_this5.renderDefaultRoutes(), [Object(preact_min["h"])(unsupported_browsers, { path: routes.FIND_PRO }), Object(preact_min["h"])(unsupported_browsers, { path: routes.MY_PROS }), Object(preact_min["h"])(unsupported_browsers, { path: routes.MY_BOOKINGS }), Object(preact_min["h"])(unsupported_browsers, { path: routes.TRANSACTIONS }), Object(preact_min["h"])(unsupported_browsers, { path: routes.EDIT_PROFILE }), Object(preact_min["h"])(unsupported_browsers, { path: routes.FEATURED_SERVICE }), Object(preact_min["h"])(unsupported_browsers, { path: routes.REGISTER_PRO }), Object(preact_min["h"])(unsupported_browsers, { path: routes.SETTINGS }), Object(preact_min["h"])(unsupported_browsers, { path: routes.USER }), Object(preact_min["h"])(unsupported_browsers, { path: routes.SELECT_INTEREST })]);
  };

  this.renderDefaultRoutes = function () {
    return _this5.isFullySupportedEnvironment ? [].concat(_this5.renderLangRoutes(consts["G" /* langs */][consts["g" /* EN */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["u" /* RU */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["m" /* IT */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["i" /* ES */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["q" /* PL */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["a" /* AE */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["r" /* PT */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["e" /* DE */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["k" /* FR */]].code), [Object(preact_min["h"])(routes_api, { path: routes.API }), Object(preact_min["h"])(log_in, { path: routes.LOG_IN }), Object(preact_min["h"])(sign_up, { path: routes.SIGN_UP, prismicCtx: _this5.state.prismicCtx, uid: uids.REGISTRATION }), Object(preact_min["h"])(login_or_signup, { path: routes.LOGIN_OR_SIGNUP }), Object(preact_min["h"])(forgot_password, { path: routes.FORGOT_PASSWORD }), Object(preact_min["h"])(accountActivationSuccess, { path: routes.ACCOUNT_ACTIVATION_SUCCESS, prismicCtx: _this5.state.prismicCtx }), Object(preact_min["h"])(accountActivationError, { path: routes.ACCOUNT_ACTIVATION_ERROR, prismicCtx: _this5.state.prismicCtx })]) : [].concat(_this5.renderLangRoutes(consts["G" /* langs */][consts["g" /* EN */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["u" /* RU */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["m" /* IT */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["i" /* ES */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["q" /* PL */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["a" /* AE */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["r" /* PT */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["e" /* DE */]].code), _this5.renderLangRoutes(consts["G" /* langs */][consts["k" /* FR */]].code), [Object(preact_min["h"])(unsupported_browsers, { path: routes.API }), Object(preact_min["h"])(unsupported_browsers, { path: routes.LOG_IN }), Object(preact_min["h"])(unsupported_browsers, { path: routes.SIGN_UP }), Object(preact_min["h"])(unsupported_browsers, { path: routes.LOGIN_OR_SIGNUP }), Object(preact_min["h"])(unsupported_browsers, { path: routes.FORGOT_PASSWORD }), Object(preact_min["h"])(unsupported_browsers, { path: routes.ACCOUNT_ACTIVATION_SUCCESS }), Object(preact_min["h"])(unsupported_browsers, { path: routes.ACCOUNT_ACTIVATION_ERROR })]);
  };

  this.renderLangRoutes = function (lang) {
    return _this5.isFullySupportedEnvironment ? [Object(preact_min["h"])(preview, {
      path: routes.PROFILE
    }), Object(preact_min["h"])(home, { path: app_langRoutes(lang, routes.HOME), prismicCtx: _this5.state.prismicCtx, type: types.HOMEPAGE }), Object(preact_min["h"])(immigration_law, {
      path: app_langRoutes(lang, routes.IMMIGRATION_CONSULTANT),
      prismicCtx: _this5.state.prismicCtx,
      type: types.SERVICE_PAGE,
      tag: tags.IMMIGRATION_ADVICE,
      reviewsUid: uids.SHORT_REVIEWS
    }), Object(preact_min["h"])(immigration_law, {
      path: app_langRoutes(lang, routes.IMMIGRATION_ADVICE),
      prismicCtx: _this5.state.prismicCtx,
      type: types.SERVICE_PAGE,
      tag: tags.IMMIGRATION_CLIENTS,
      reviewsUid: uids.SHORT_REVIEWS
    }), Object(preact_min["h"])(language_practice, {
      path: app_langRoutes(lang, routes.LANGUAGE_PRACTICE),
      prismicCtx: _this5.state.prismicCtx,
      type: types.SERVICE_PAGE,
      tag: tags.LANGUAGE_PRACTICE,
      reviewsUid: uids.SHORT_REVIEWS
    }), Object(preact_min["h"])(language_learners, {
      path: app_langRoutes(lang, routes.LANGUAGE_LEARNERS),
      prismicCtx: _this5.state.prismicCtx,
      type: types.SERVICE_PAGE,
      tag: tags.LANGUAGE_LEARNERS,
      reviewsUid: uids.SHORT_REVIEWS
    }), Object(preact_min["h"])(blog, { path: app_langRoutes(lang, routes.BLOG_POST), prismicCtx: _this5.state.prismicCtx }), Object(preact_min["h"])(faq, { path: app_langRoutes(lang, routes.FAQ), prismicCtx: _this5.state.prismicCtx, type: types.FAQ }), Object(preact_min["h"])(static_page, {
      path: app_langRoutes(lang, routes.TERMS),
      prismicCtx: _this5.state.prismicCtx,
      type: types.STATIC_PAGE,
      tag: tags.TERMS
    }), Object(preact_min["h"])(static_page, {
      path: app_langRoutes(lang, routes.PRIVACY),
      prismicCtx: _this5.state.prismicCtx,
      type: types.STATIC_PAGE,
      tag: tags.PRIVACY
    }), Object(preact_min["h"])(static_page, {
      path: app_langRoutes(lang, routes.CANCELLATION),
      prismicCtx: _this5.state.prismicCtx,
      type: types.STATIC_PAGE,
      tag: tags.CANCELLATION
    }), Object(preact_min["h"])(contact_us, { path: app_langRoutes(lang, routes.CONTACT_US) })] : [Object(preact_min["h"])(unsupported_browsers, { path: routes.PROFILE }), Object(preact_min["h"])(home, { path: app_langRoutes(lang, routes.HOME), prismicCtx: _this5.state.prismicCtx, type: types.HOMEPAGE }), Object(preact_min["h"])(immigration_law, {
      path: app_langRoutes(lang, routes.IMMIGRATION_CONSULTANT),
      prismicCtx: _this5.state.prismicCtx,
      type: types.SERVICE_PAGE,
      tag: tags.IMMIGRATION_ADVICE,
      reviewsUid: uids.SHORT_REVIEWS
    }), Object(preact_min["h"])(immigration_law, {
      path: app_langRoutes(lang, routes.IMMIGRATION_ADVICE),
      prismicCtx: _this5.state.prismicCtx,
      type: types.SERVICE_PAGE,
      tag: tags.IMMIGRATION_CLIENTS,
      reviewsUid: uids.SHORT_REVIEWS
    }), Object(preact_min["h"])(language_practice, {
      path: app_langRoutes(lang, routes.LANGUAGE_PRACTICE),
      prismicCtx: _this5.state.prismicCtx,
      type: types.SERVICE_PAGE,
      tag: tags.LANGUAGE_PRACTICE,
      reviewsUid: uids.SHORT_REVIEWS
    }), Object(preact_min["h"])(language_learners, {
      path: app_langRoutes(lang, routes.LANGUAGE_LEARNERS),
      prismicCtx: _this5.state.prismicCtx,
      type: types.SERVICE_PAGE,
      tag: tags.LANGUAGE_LEARNERS,
      reviewsUid: uids.SHORT_REVIEWS
    }), Object(preact_min["h"])(blog, { path: app_langRoutes(lang, routes.BLOG_POST), prismicCtx: _this5.state.prismicCtx }), Object(preact_min["h"])(faq, { path: app_langRoutes(lang, routes.FAQ), prismicCtx: _this5.state.prismicCtx, type: types.FAQ }), Object(preact_min["h"])(static_page, {
      path: app_langRoutes(lang, routes.TERMS),
      prismicCtx: _this5.state.prismicCtx,
      type: types.STATIC_PAGE,
      tag: tags.TERMS
    }), Object(preact_min["h"])(static_page, {
      path: app_langRoutes(lang, routes.PRIVACY),
      prismicCtx: _this5.state.prismicCtx,
      type: types.STATIC_PAGE,
      tag: tags.PRIVACY
    }), Object(preact_min["h"])(static_page, {
      path: app_langRoutes(lang, routes.CANCELLATION),
      prismicCtx: _this5.state.prismicCtx,
      type: types.STATIC_PAGE,
      tag: tags.CANCELLATION
    }), Object(preact_min["h"])(contact_us, { path: app_langRoutes(lang, routes.CONTACT_US) })];
  };

  this.updatedUserAuth = function (e) {
    if (e.key === consts["z" /* USER_AUTH */]) {
      var _props5 = _this5.props,
          _props5$userData = _props5.userData,
          user = _props5$userData === undefined ? {} : _props5$userData,
          fetchUserData = _props5.fetchUserData;


      var localStorageUserAuth = localStorage.getItem(consts["z" /* USER_AUTH */]);

      var updatedToken = 'Bearer ' + localStorageUserAuth;

      var userAuth = user.userAuth || '';

      if (userAuth !== updatedToken) {
        if (localStorageUserAuth) {
          fetchUserData(updatedToken);
        } else {
          _this5.props.logOff();
        }
      }
    }
  };

  this.handleClearNotifications = function () {
    var notifications = _this5.props.notifications || [];
    notifications.forEach(function (notification) {
      dist["store"].removeNotification(notification.id);
      _this5.props.removeNotification(notification.id);
    });
  };

  this.uniqueNotifications = function (oldNotifications, newNotifications) {
    return newNotifications.filter(function (notification) {
      return !oldNotifications.includes(notification);
    });
  };

  this.handleAddNotification = function (_ref7) {
    var reloadRequired = _ref7.reloadRequired,
        iconClassName = _ref7.iconClassName,
        id = _ref7.id,
        type = _ref7.type,
        message = _ref7.message,
        dismissAfter = _ref7.dismissAfter;
    var onRemoveNotification = _this5.props.removeNotification;


    var locale = _this5.props.locale || consts["g" /* EN */],
        _ref8 = Object(preact_min["h"])(api_notifications["b" /* default */], {
      reloadRequired: reloadRequired,
      type: type,
      iconClassName: iconClassName,
      message: message,
      locale: locale
    });

    dist["store"].addNotification({
      id: id,
      width: 300,
      content: function content() {
        return _ref8;
      },
      insert: 'top',
      container: 'top-right',
      animationIn: ['animated', 'fadeIn'],
      animationOut: ['animated', 'fadeOut'],
      click: false,
      onRemoval: function onRemoval(id) {
        if (reloadRequired) {
          window.location.reload();
        }

        onRemoveNotification(id);
      },
      dismiss: !reloadRequired && {
        duration: dismissAfter || 3000,
        pauseOnHover: true
      }
    });
  };

  this.safeSetSinkId = function (element, deviceId) {
    return element.setSinkId && typeof element.setSinkId === 'function' && element.setSinkId(deviceId);
  };

  this.onMediaDevicesChanged = function () {
    navigator.mediaDevices && typeof navigator.mediaDevices.enumerateDevices === 'function' && navigator.mediaDevices.enumerateDevices().then(function (devices) {
      var newPreferredOutputDeviceId = null;

      devices.forEach(function (device) {
        if (device.kind === 'audiooutput' && device.deviceId === 'communications') {
          newPreferredOutputDeviceId = device.deviceId;
        } else if (!newPreferredOutputDeviceId && device.kind === 'audiooutput' && device.deviceId === 'default') {
          newPreferredOutputDeviceId = device.deviceId;
        }
      });

      if (!newPreferredOutputDeviceId) {
        var firstAudioOutputDevice = devices.find(function (device) {
          return device.kind === 'audiooutput';
        });
        if (firstAudioOutputDevice) {
          newPreferredOutputDeviceId = firstAudioOutputDevice.deviceId;
        }
      }

      if (newPreferredOutputDeviceId && newPreferredOutputDeviceId !== _this5.preferredOutputDeviceId) {
        _this5.preferredOutputDeviceId = newPreferredOutputDeviceId;
      }
    });
  };

  this.onPageHide = function (_event) {
    _this5.connection.gracefullyCloseCallOnLogout();
  };
}, app__temp);


app_App.contextTypes = {
  isSupportedBrowser: preact_compat_es["PropTypes"].bool,
  isSupportedOS: preact_compat_es["PropTypes"].bool
};

var app_mapStateToProps = function mapStateToProps(state) {
  return {
    application: state.application,
    isWebview: Object(application["i" /* selectApplicationIsWebview */])(state),
    callTimeBeep: Object(application["d" /* selectApplicationCallTimeBeep */])(state),
    userData: state.loggedInUser,
    userFromDeepLink: state.userDetails.user,
    locale: state.locale.locale,
    communicateModal: state.communicateModal,
    branchIo: state.branchIo,
    redirect: state.redirect,
    notifications: state.notifications
  };
};

var app_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(es["bindActionCreators"])({
    addNotification: actions_api_notifications["a" /* addNotification */],
    applicationCheckOS: actions_application["a" /* applicationCheckOS */],
    initialise: actions_application["b" /* applicationInitialise */],
    checkApplicationVersionSupport: actions_application["c" /* checkVersionSupport */],
    openComModal: chat["n" /* openComModal */],
    closeComModal: chat["k" /* closeComModal */],
    changeUnreadNum: chat["f" /* changeUnreadNum */],
    chooseChatPerson: chat["h" /* chooseChatPerson */],
    clearChats: chat["j" /* clearChats */],
    getCallInfo: chat["m" /* getCallInfo */],
    caleeIsBusy: chat["b" /* caleeIsBusy */],
    processCall: chat["p" /* processCall */],
    speaking: chat["t" /* speaking */],
    changeChat: chat["c" /* changeChat */],
    changeConnectionStatus: chat["d" /* changeConnectionStatus */],
    setUserState: api_users["C" /* setUserState */],
    removeUserState: api_users["y" /* removeUserState */],
    setBranchIoData: actions_user["y" /* setBranchIoData */],
    updateUserSettings: actions_user["F" /* updateUserSettings */],
    changeVideoStatus: chat["g" /* changeVideoStatus */],
    getCalls: calls["b" /* getCalls */],
    changeUrl: url_changeUrl,
    fetchUserData: actions_sign_in["a" /* signInFetchUserData */],
    setPasswordResettingMode: forgotPassword["c" /* forgotPasswordSetResettingMode */],
    setProcessed: actions_sign_in["c" /* signInSetProcessed */],
    logOff: actions_user["q" /* logOff */],
    setTimeOffset: chat["s" /* setTimeOffset */],
    getUserByRef: actions_user["n" /* getUserByRef */],
    getUnreadMessages: actions_user["m" /* getUnreadMessages */],
    updateBadges: actions_user["E" /* updateBadges */],
    removeNotification: actions_api_notifications["b" /* removeNotification */],
    tokenValidate: tokenValidation["a" /* tokenValidate */],
    changeReconnectionStatus: chat["e" /* changeReconnectionStatus */],
    resetCallTimer: callTimer["a" /* resetCallTimer */],
    tickCallTimer: callTimer["c" /* tickCallTimer */],
    setCallStartTimestamp: callTimer["b" /* setCallStartTimestamp */]
  }, dispatch);
};

/* harmony default export */ var app = __webpack_exports__["default"] = (Object(preact_redux_esm["b" /* connect */])(app_mapStateToProps, app_mapDispatchToProps)(app_App));

/***/ }),

/***/ "qLzV":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");

module.exports = global.Promise;

/***/ }),

/***/ "qNd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__("4Etx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["b"]; });


/***/ }),

/***/ "qQO4":
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__("hVVj");
var v4 = __webpack_require__("hYHi");

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;

/***/ }),

/***/ "qR+x":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("7U15");
var fails = __webpack_require__("rtOw");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/***/ }),

/***/ "qpDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeLocaleLangs; });
/* unused harmony export resetPassword */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return logOff; });
/* unused harmony export register */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return verify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return editDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return switchEmailNotif; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return switchWorkingPro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getProCalls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getPersonalCalls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTransactions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getWithdraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return resetTransactions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return uploadPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearuploadPhotoStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return sendContactData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearContactData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getUserDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return refreshLoggedInUserDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getUserByRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return resetUserDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return setUserState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return removeUserState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAvailability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return setAvailability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return updateAvailability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteAvailability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return updateUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setBranchIoData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDeepLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return sendGlobalMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getUnreadMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return updateBadges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return setRediretLink; });
/* unused harmony export forgotPasswordReset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__ = __webpack_require__("FFyX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__("hYHi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_users__ = __webpack_require__("mecS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_pros__ = __webpack_require__("iMz2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("/C1n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index__ = __webpack_require__("vyGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_consts__ = __webpack_require__("4PH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_notifications__ = __webpack_require__("kKXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sign_in__ = __webpack_require__("jT1X");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// import * as Sentry from '@sentry/browser';










var verifyFailure = function verifyFailure() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].VERIFY_FAILURE
  };
};

var loggedOff = function loggedOff() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].LOGGED_OFF
  };
};

var photoUploaded = function photoUploaded(photo) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].PHOTO_UPLOADED,
    photo: photo
  };
};

var editSuccess = function editSuccess(response, userAuth) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].EDIT_SUCCESS,
    userData: response,
    userAuth: userAuth
  };
};
var editFailure = function editFailure() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].EDIT_FAILURE
  };
};

var registerFailure = function registerFailure(message) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].REGISTER_FAILURE,
    message: message
  };
};

var resetSuccess = function resetSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].RESET_SUCCESS
  };
};
var resetFailure = function resetFailure(message) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].RESET_FAILURE,
    message: message
  };
};

var proCallsReceived = function proCallsReceived(response) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].PRO_CALLS_RECEIVED,
    calls: response
  };
};

var personalCallsReceived = function personalCallsReceived(response) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].PERSONAL_CALLS_RECEIVED,
    calls: response
  };
};

var transactionsReceived = function transactionsReceived(response) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].TRANSACTIONS_RECEIVED,
    payload: response
  };
};

var withdrawReceived = function withdrawReceived(response) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].WITHDRAW_RECEIVED,
    payload: response
  };
};

var setCategories = function setCategories(response) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_CATEGORIES,
    categories: response
  };
};

var sendContactMessageFailure = function sendContactMessageFailure(message) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SEND_CONTACT_MESS_FAILURE,
    message: message
  };
};

var sendContactMessage = function sendContactMessage() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SEND_CONTACT_MESS
  };
};

var changePendingActivation = function changePendingActivation(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].REGISTRATION_PENDING_ACTIVATION,
    payload: payload
  };
};

var translatePayoutv3ResponseToWithdraw = function translatePayoutv3ResponseToWithdraw(payload) {
  return {
    availableAmount: payload.availableAmount,
    totalAmount: payload.totalAmount,
    verificationStatus: payload.verificationStatus
  };
};

var changeLocale = function changeLocale(lang) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].CHANGE_LOCALE,
      lang: lang
    });
  };
};

var changeLocaleLangs = function changeLocaleLangs() {
  var langs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].CHANGE_LOCALE_LANGS,
      langs: langs.map(function (el) {
        return el.lang || el;
      })
    });
  };
};

var resetPassword = function resetPassword(email, password, code) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (err) {
        try {
          dispatch(resetFailure(err.message));
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["z" /* resetPassword */]({ email: email, password: password, code: code })).then(function ($await_28) {
          try {
            dispatch(resetSuccess());
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (err) {
        $Try_1_Catch(err)
      }
    });
  };
};

var logOff = function logOff() {
  return function (dispatch, getState) {
    var _getState = getState(),
        userAuth = _getState.loggedInUser.userAuth;

    __WEBPACK_IMPORTED_MODULE_2__api_users__["r" /* logOut */](userAuth);
    dispatch(loggedOff());
    localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_6__utils_consts__["z" /* USER_AUTH */]);
    // Sentry.configureScope(((scope) => {
    //  scope.setUser({});
    // }));
    __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"].removeDeviceKey('user_email');
    __WEBPACK_IMPORTED_MODULE_0__bugfender_sdk__["Bugfender"].setDeviceKey('user_logged_in', false);
  };
};
var register = function register(data) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var onError, params, deviceId, message;
      onError = data.onError, params = _objectWithoutProperties(data, ['onError']);
      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_2_Catch = function (_ref) {
        try {
          message = _ref.message;

          if (onError) {
            onError({ message: message });
          }

          dispatch(registerFailure(message));
          return $Try_2_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        deviceId = __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()();
        localStorage.setItem('uuid', deviceId);

        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["v" /* register */](_extends({}, params, { device: deviceId, locale: navigator.languages[0] }))).then(function ($await_29) {
          try {

            dispatch(changePendingActivation(true));
            return $Try_2_Post();
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (_ref) {
        $Try_2_Catch(_ref)
      }
    });
  };
};


var getCategories = function getCategories(authData) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;
      var $Try_3_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_3_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          return $Try_3_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["j" /* getCategories */](authData)).then(function ($await_30) {
          try {
            response = $await_30;
            dispatch(setCategories(response));
            return $Try_3_Post();
          } catch ($boundEx) {
            return $Try_3_Catch($boundEx);
          }
        }, $Try_3_Catch);
      } catch (err) {
        $Try_3_Catch(err)
      }
    });
  };
};

var verify = function verify(token) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;
      var $Try_4_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_4_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch(verifyFailure());
          return $Try_4_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["J" /* verify */](token)).then(function ($await_31) {
          try {
            response = $await_31;
            dispatch(verifyFailure(response));
            return $Try_4_Post();
          } catch ($boundEx) {
            return $Try_4_Catch($boundEx);
          }
        }, $Try_4_Catch);
      } catch (err) {
        $Try_4_Catch(err)
      }
    });
  };
};

var editDetails = function editDetails(data, userAuth) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;
      var $Try_5_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_5_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch(editFailure());
          return $Try_5_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["g" /* editDetails */](data, userAuth)).then(function ($await_32) {
          try {
            response = $await_32;
            dispatch(editSuccess(response, userAuth));
            return $Try_5_Post();
          } catch ($boundEx) {
            return $Try_5_Catch($boundEx);
          }
        }, $Try_5_Catch);
      } catch (err) {
        $Try_5_Catch(err)
      }
    });
  };
};
var switchEmailNotif = function switchEmailNotif(data, userAuth) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;
      var $Try_6_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_6_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch(editFailure());
          return $Try_6_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["D" /* switchData */](__WEBPACK_IMPORTED_MODULE_4__api__["b" /* apiUrls */].EMAIL_NOTIFICATIONS, data, userAuth)).then(function ($await_33) {
          try {
            response = $await_33;
            dispatch(editSuccess(response, userAuth));
            return $Try_6_Post();
          } catch ($boundEx) {
            return $Try_6_Catch($boundEx);
          }
        }, $Try_6_Catch);
      } catch (err) {
        $Try_6_Catch(err)
      }
    });
  };
};
var switchWorkingPro = function switchWorkingPro(data, userAuth) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;
      var $Try_7_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_7_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch(editFailure());
          return $Try_7_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["D" /* switchData */](__WEBPACK_IMPORTED_MODULE_4__api__["b" /* apiUrls */].WORKING_PRO, data, userAuth)).then(function ($await_34) {
          try {
            response = $await_34;
            dispatch(editSuccess(response, userAuth));
            return $Try_7_Post();
          } catch ($boundEx) {
            return $Try_7_Catch($boundEx);
          }
        }, $Try_7_Catch);
      } catch (err) {
        $Try_7_Catch(err)
      }
    });
  };
};

var getProCalls = function getProCalls(authData, num) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;

      dispatch(proCallsReceived([]));
      var $Try_8_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_8_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          return $Try_8_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["i" /* getCalls */](authData, true, num)).then(function ($await_35) {
          try {
            response = $await_35;
            dispatch(proCallsReceived(response.results));
            return $Try_8_Post();
          } catch ($boundEx) {
            return $Try_8_Catch($boundEx);
          }
        }, $Try_8_Catch);
      } catch (err) {
        $Try_8_Catch(err)
      }
    });
  };
};

var getPersonalCalls = function getPersonalCalls(authData, num) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;

      dispatch(personalCallsReceived([]));
      var $Try_9_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_9_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          return $Try_9_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["i" /* getCalls */](authData, false, num)).then(function ($await_36) {
          try {
            response = $await_36;
            dispatch(personalCallsReceived(response.results));
            return $Try_9_Post();
          } catch ($boundEx) {
            return $Try_9_Catch($boundEx);
          }
        }, $Try_9_Catch);
      } catch (err) {
        $Try_9_Catch(err)
      }
    });
  };
};

var getTransactions = function getTransactions(authData, num) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_TRANSACTIONS
      });
      var $Try_10_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_10_Catch = function (error) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(error));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_TRANSACTIONS_FAILURE,
            error: error
          });
          return $Try_10_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["n" /* getTransactions */](authData, num, page).catch(function (error) {
          throw error;
        })).then(function ($await_37) {
          try {
            response = $await_37;
            dispatch(transactionsReceived(response));
            return $Try_10_Post();
          } catch ($boundEx) {
            return $Try_10_Catch($boundEx);
          }
        }, $Try_10_Catch);
      } catch (error) {
        $Try_10_Catch(error)
      }
    });
  };
};

var getWithdraw = function getWithdraw(authData) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_WITHDRAW
      });
      var $Try_11_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_11_Catch = function (error) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(error));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_WITHDRAW_FAILURE,
            error: error
          });
          return $Try_11_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["p" /* getWithdraw */](authData).catch(function (error) {
          throw error;
        })).then(function ($await_38) {
          try {
            response = $await_38;
            if (Object.keys(response).length !== 0) {
              dispatch(withdrawReceived(translatePayoutv3ResponseToWithdraw(response)));
            }
            return $Try_11_Post();
          } catch ($boundEx) {
            return $Try_11_Catch($boundEx);
          }
        }, $Try_11_Catch);
      } catch (error) {
        $Try_11_Catch(error)
      }
    });
  };
};

var resetTransactions = function resetTransactions() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].RESET_TRANSACTIONS
    });
  };
};

var uploadPhoto = function uploadPhoto(authData, photo, filName) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;
      var $Try_12_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_12_Catch = function (err) {
        try {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].PHOTO_UPLOAD_FAILURE,
            errorMsg: err.message || 'Upload photo error!'
          });
          return $Try_12_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["I" /* uploadPhoto */](authData, photo, filName)).then(function ($await_39) {
          try {
            response = $await_39;
            dispatch(photoUploaded(response));
            return $Try_12_Post();
          } catch ($boundEx) {
            return $Try_12_Catch($boundEx);
          }
        }, $Try_12_Catch);
      } catch (err) {
        $Try_12_Catch(err)
      }
    });
  };
};

var clearuploadPhotoStatus = function clearuploadPhotoStatus() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].PHOTO_UPLOAD_CLEAR_STATUS
    });
  };
};

var sendContactData = function sendContactData(data) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;

      dispatch(sendContactMessage());
      var $Try_13_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_13_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch(sendContactMessageFailure(err.message));
          return $Try_13_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["A" /* sendContactData */](data)).then(function ($await_40) {
          try {
            response = $await_40;
            dispatch(sendContactMessageFailure(response.message));
            return $Try_13_Post();
          } catch ($boundEx) {
            return $Try_13_Catch($boundEx);
          }
        }, $Try_13_Catch);
      } catch (err) {
        $Try_13_Catch(err)
      }
    });
  };
};

var clearContactData = function clearContactData() {
  return function (dispatch) {
    return dispatch(sendContactMessage());
  };
};

var getUserDetails = function getUserDetails(id, isPro) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState2, userAuth, response, timezone, availabilities;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_USER_DETAILS
      });
      _getState2 = getState(), userAuth = _getState2.loggedInUser.userAuth;
      var $Try_14_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_14_Catch = function (error) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(error));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_USER_DETAILS_FAILURE,
            error: error
          });
          return $Try_14_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_3__api_pros__["f" /* getUserDetails */](id, userAuth, isPro).catch(function (err) {
          throw err;
        })).then(function ($await_41) {
          try {
            response = $await_41;
            if (response.pro) {
              timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
              return Promise.resolve(__WEBPACK_IMPORTED_MODULE_3__api_pros__["c" /* getProAvailabilityForTimezone */](id, timezone, userAuth)).then(function ($await_42) {
                try {
                  availabilities = $await_42;
                  response.pro.availability = {
                    total: availabilities.length,
                    results: availabilities
                  };
                  return $If_27.call(this);
                } catch ($boundEx) {
                  return $Try_14_Catch($boundEx);
                }
              }.bind(this), $Try_14_Catch);
            }

            function $If_27() {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_USER_DETAILS_SUCCESS,
                payload: response
              });
              return $Try_14_Post();
            }

            return $If_27.call(this);
          } catch ($boundEx) {
            return $Try_14_Catch($boundEx);
          }
        }.bind(this), $Try_14_Catch);
      } catch (error) {
        $Try_14_Catch(error)
      }
    });
  };
};

var refreshLoggedInUserDetails = function refreshLoggedInUserDetails() {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState3, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].REFRESH_LOGGED_IN_USER_DETAILS
      });

      _getState3 = getState(), userAuth = _getState3.loggedInUser.userAuth;
      var $Try_15_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_15_Catch = function (error) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(error));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].REFRESH_LOGGED_IN_USER_DETAILS_FAILURE,
            error: error
          });
          return $Try_15_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["o" /* getUserInfo */](userAuth).catch(function (err) {
          throw err;
        })).then(function ($await_43) {
          try {
            response = $await_43;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].REFRESH_LOGGED_IN_USER_DETAILS_SUCCESS,
              payload: response
            });
            return $Try_15_Post();
          } catch ($boundEx) {
            return $Try_15_Catch($boundEx);
          }
        }, $Try_15_Catch);
      } catch (error) {
        $Try_15_Catch(error)
      }
    });
  };
};

var getUserByRef = function getUserByRef(id) {
  return function (dispatch) {
    return new Promise(function ($return, $error) {
      var response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_USER_DETAILS
      });
      var $Try_16_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_16_Catch = function (error) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(error));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_USER_DETAILS_FAILURE,
            error: error
          });
          return $Try_16_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_3__api_pros__["e" /* getUserByRef */](id).catch(function (err) {
          throw err;
        })).then(function ($await_44) {
          try {
            response = $await_44;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_USER_DETAILS_SUCCESS,
              payload: response
            });
            return $Try_16_Post();
          } catch ($boundEx) {
            return $Try_16_Catch($boundEx);
          }
        }, $Try_16_Catch);
      } catch (error) {
        $Try_16_Catch(error)
      }
    });
  };
};

var resetUserDetails = function resetUserDetails() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].RESET_USER_DETAILS
    });
  };
};

var setUserState = function setUserState(key) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState4, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_STATE
      });
      var $Try_17_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_17_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_STATE_FAILURE,
            error: err
          });
          return $Try_17_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState4 = getState(), userAuth = _getState4.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["C" /* setUserState */](key, userAuth).catch(function (err) {
          throw err;
        })).then(function ($await_45) {
          try {
            response = $await_45;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_STATE_SUCCESS,
              payload: response
            });
            if (key === 'showFullName') dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__sign_in__["a" /* signInFetchUserData */])(userAuth));
            return $Try_17_Post();
          } catch ($boundEx) {
            return $Try_17_Catch($boundEx);
          }
        }, $Try_17_Catch);
      } catch (err) {
        $Try_17_Catch(err)
      }
    });
  };
};

var removeUserState = function removeUserState(key) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState5, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_STATE
      });
      var $Try_18_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_18_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_STATE_FAILURE,
            error: err
          });
          return $Try_18_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState5 = getState(), userAuth = _getState5.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["y" /* removeUserState */](key, userAuth).catch(function (err) {
          throw err;
        })).then(function ($await_46) {
          try {
            response = $await_46;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_STATE_SUCCESS,
              payload: response
            });
            if (key === 'showFullName') dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__sign_in__["a" /* signInFetchUserData */])(userAuth));
            return $Try_18_Post();
          } catch ($boundEx) {
            return $Try_18_Catch($boundEx);
          }
        }, $Try_18_Catch);
      } catch (err) {
        $Try_18_Catch(err)
      }
    });
  };
};

var getAvailability = function getAvailability() {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState6, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_AVAILABILITY
      });
      var $Try_19_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_19_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_AVAILABILITY_FAILURE,
            error: err
          });
          return $Try_19_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState6 = getState(), userAuth = _getState6.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["h" /* getAvailability */](userAuth).catch(function (err) {
          throw err;
        })).then(function ($await_47) {
          try {
            response = $await_47;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_AVAILABILITY_SUCCESS,
              payload: response
            });
            return $Try_19_Post();
          } catch ($boundEx) {
            return $Try_19_Catch($boundEx);
          }
        }, $Try_19_Catch);
      } catch (err) {
        $Try_19_Catch(err)
      }
    });
  };
};

var setAvailability = function setAvailability(data) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState7, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_AVAILABILITY
      });

      var $Try_20_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_20_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_AVAILABILITY_FAILURE,
            error: err
          });
          return $Try_20_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState7 = getState(), userAuth = _getState7.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["B" /* setAvailability */](userAuth, data).catch(function (err) {
          throw err;
        })).then(function ($await_48) {
          try {
            response = $await_48;

            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_AVAILABILITY_SUCCESS,
              payload: response
            });
            return $Try_20_Post();
          } catch ($boundEx) {
            return $Try_20_Catch($boundEx);
          }
        }, $Try_20_Catch);
      } catch (err) {
        $Try_20_Catch(err)
      }
    });
  };
};

var updateAvailability = function updateAvailability(data) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState8, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].UPDATE_AVAILABILITY
      });
      var $Try_21_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_21_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].UPDATE_AVAILABILITY_FAILURE,
            error: err
          });
          return $Try_21_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState8 = getState(), userAuth = _getState8.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["F" /* updateAvailability */](userAuth, data).catch(function (err) {
          throw err;
        })).then(function ($await_49) {
          try {
            response = $await_49;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].UPDATE_AVAILABILITY_SUCCESS,
              payload: response
            });
            return $Try_21_Post();
          } catch ($boundEx) {
            return $Try_21_Catch($boundEx);
          }
        }, $Try_21_Catch);
      } catch (err) {
        $Try_21_Catch(err)
      }
    });
  };
};

var deleteAvailability = function deleteAvailability(id) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState9, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].DELETE_AVAILABILITY
      });
      var $Try_22_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_22_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].DELETE_AVAILABILITY_FAILURE,
            error: err
          });
          return $Try_22_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState9 = getState(), userAuth = _getState9.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["f" /* deleteAvailability */](userAuth, id).catch(function (err) {
          throw err;
        })).then(function ($await_50) {
          try {
            response = $await_50;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].DELETE_AVAILABILITY_SUCCESS,
              payload: response
            });
            return $Try_22_Post();
          } catch ($boundEx) {
            return $Try_22_Catch($boundEx);
          }
        }, $Try_22_Catch);
      } catch (err) {
        $Try_22_Catch(err)
      }
    });
  };
};

var updateUserSettings = function updateUserSettings(data) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState10, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].UPDATE_USER_SETTINGS
      });
      var $Try_23_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_23_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].UPDATE_AVAILABILITY_FAILURE,
            error: err
          });
          return $Try_23_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState10 = getState(), userAuth = _getState10.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["H" /* updateUserSettings */](userAuth, data).catch(function (err) {
          throw err;
        })).then(function ($await_51) {
          try {
            response = $await_51;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].UPDATE_USER_SETTINGS_SUCCESS,
              payload: response
            });
            return $Try_23_Post();
          } catch ($boundEx) {
            return $Try_23_Catch($boundEx);
          }
        }, $Try_23_Catch);
      } catch (err) {
        $Try_23_Catch(err)
      }
    });
  };
};

var setBranchIoData = function setBranchIoData(data) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].BRANCH_IO_DATA,
      payload: data
    });
  };
};

var getDeepLink = function getDeepLink() {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState11, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_DEEP_LINK
      });
      var $Try_24_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_24_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_DEEP_LINK_FAILURE,
            error: err
          });
          return $Try_24_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState11 = getState(), userAuth = _getState11.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["k" /* getDeepLink */](userAuth)).then(function ($await_52) {
          try {
            response = $await_52;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_DEEP_LINK_SUCCESS,
              payload: response
            });
            return $Try_24_Post();
          } catch ($boundEx) {
            return $Try_24_Catch($boundEx);
          }
        }, $Try_24_Catch);
      } catch (err) {
        $Try_24_Catch(err)
      }
    });
  };
};

var sendGlobalMessage = function sendGlobalMessage(message) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GLOBAL_MESSAGE,
      payload: message
    });
  };
};

var getUnreadMessages = function getUnreadMessages() {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState12, userAuth, response;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_BADGE
      });
      var $Try_25_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_25_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_BADGE_FAILURE,
            error: err
          });
          return $Try_25_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState12 = getState(), userAuth = _getState12.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["E" /* unreadMessagesController */](userAuth)).then(function ($await_53) {
          try {
            response = $await_53;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].GET_BADGE_SUCCESS,
              payload: response
            });
            return $Try_25_Post();
          } catch ($boundEx) {
            return $Try_25_Catch($boundEx);
          }
        }, $Try_25_Catch);
      } catch (err) {
        $Try_25_Catch(err)
      }
    });
  };
};

var updateBadges = function updateBadges(person) {
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState13, userAuth;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].UPDATE_BADGE
      });
      // eslint-disable-next-line no-console
      console.log('PERSON', person);

      var $Try_26_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_26_Catch = function (err) {
        try {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__api_notifications__["a" /* addNotification */])(err));
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].UPDATE_BADGE_FAILURE,
            error: err
          });
          return $Try_26_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };try {
        _getState13 = getState(), userAuth = _getState13.loggedInUser.userAuth;
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__api_users__["E" /* unreadMessagesController */](userAuth, person.toUser && person.toUser.id)).then(function ($await_54) {
          try {
            return $Try_26_Post();
          } catch ($boundEx) {
            return $Try_26_Catch($boundEx);
          }
        }, $Try_26_Catch);
      } catch (err) {
        $Try_26_Catch(err)
      }
    });
  };
};

var setRediretLink = function setRediretLink(path) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].SET_REDIRECT_LINK,
      payload: path
    });
  };
};

function forgotPasswordReset() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_5__index__["a" /* actionTypes */].FORGOT_PASSWORD_RESET
  };
}

/***/ }),

/***/ "qrqX":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("fCoI");
__webpack_require__("7CVk");
__webpack_require__("e/vF");
__webpack_require__("cGzZ");
__webpack_require__("s25D");
__webpack_require__("u82x");
__webpack_require__("D1wH");
__webpack_require__("laPu");
var path = __webpack_require__("iXvo");

module.exports = path.Promise;

/***/ }),

/***/ "qvVx":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("iXvo");
var global = __webpack_require__("IJ/8");
var isCallable = __webpack_require__("yeFe");

var aFunction = function aFunction(variable) {
  return isCallable(variable) ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};

/***/ }),

/***/ "r3yy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectCallSec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectCallStartTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("vyGZ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var moduleName = 'callTimer';

var initialState = {
  callSec: 0,
  callStartTime: null
};

var MILLISECONDS_IN_SECOND = 1000;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _extends({}, initialState);
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CALL_TIMER_RESET:
      return _extends({}, state, {
        callSec: 0,
        callStartTime: null
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CALL_TIMER_TICK:
      return _extends({}, state, {
        callSec: Math.round((new Date().getTime() - state.callStartTime.getTime()) / MILLISECONDS_IN_SECOND)
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actionTypes */].CALL_TIMER_TIMESTAMP:
      return _extends({}, state, {
        callStartTime: new Date()
      });
    default:
      return _extends({}, state);
  }
});

var stateSelector = function stateSelector(state) {
  return state[moduleName];
};

var selectCallSec = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (callTimer) {
  return callTimer.callSec;
});

var selectCallStartTime = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(stateSelector, function (callTimer) {
  return callTimer.callStartTime;
});

/***/ }),

/***/ "r5Fo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__("mYpx");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _toArray2 = __webpack_require__("Ayp7");

var _toArray3 = _interopRequireDefault(_toArray2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("eW0v");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__("i8vT");

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _dom = __webpack_require__("yw9g");

var _dom2 = _interopRequireDefault(_dom);

var _CircleRipple = __webpack_require__("Z2Ia");

var _CircleRipple2 = _interopRequireDefault(_CircleRipple);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// Remove the first element of the array
var shift = function shift(_ref) {
  var _ref2 = (0, _toArray3.default)(_ref),
      newArray = _ref2.slice(1);

  return newArray;
};

var TouchRipple = function (_Component) {
  (0, _inherits3.default)(TouchRipple, _Component);

  function TouchRipple(props, context) {
    (0, _classCallCheck3.default)(this, TouchRipple);

    // Touch start produces a mouse down event for compat reasons. To avoid
    // showing ripples twice we skip showing a ripple for the first mouse down
    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
    // to avoid re-rendering when we change it.
    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));

    _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.start(event, false);
      }
    };

    _this.handleMouseUp = function () {
      _this.end();
    };

    _this.handleMouseLeave = function () {
      _this.end();
    };

    _this.handleTouchStart = function (event) {
      event.stopPropagation();
      // If the user is swiping (not just tapping), save the position so we can
      // abort ripples if the user appears to be scrolling.
      if (_this.props.abortOnScroll && event.touches) {
        _this.startListeningForScrollAbort(event);
        _this.startTime = Date.now();
      }
      _this.start(event, true);
    };

    _this.handleTouchEnd = function () {
      _this.end();
    };

    _this.handleTouchMove = function (event) {
      // Stop trying to abort if we're already 300ms into the animation
      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
      if (timeSinceStart > 300) {
        _this.stopListeningForScrollAbort();
        return;
      }

      // If the user is scrolling...
      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
      if (deltaY > 6 || deltaX > 6) {
        var currentRipples = _this.state.ripples;
        var ripple = currentRipples[0];
        // This clone will replace the ripple in ReactTransitionGroup with a
        // version that will disappear immediately when removed from the DOM
        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
        // Remove the old ripple and replace it with the new updated one
        currentRipples = shift(currentRipples);
        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
        _this.setState({ ripples: currentRipples }, function () {
          // Call end after we've set the ripple to abort otherwise the setState
          // in end() merges with this and the ripple abort fails
          _this.end();
        });
      }
    };

    _this.ignoreNextMouseDown = false;

    _this.state = {
      // This prop allows us to only render the ReactTransitionGroup
      // on the first click of the component, making the inital render faster.
      hasRipples: false,
      nextKey: 0,
      ripples: []
    };
    return _this;
  }

  (0, _createClass3.default)(TouchRipple, [{
    key: 'start',
    value: function start(event, isRippleTouchGenerated) {
      var theme = this.context.muiTheme.ripple;

      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
        this.ignoreNextMouseDown = false;
        return;
      }

      var ripples = this.state.ripples;

      // Add a ripple to the ripples array
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
        key: this.state.nextKey,
        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
        color: this.props.color || theme.color,
        opacity: this.props.opacity,
        touchGenerated: isRippleTouchGenerated
      })]);

      this.ignoreNextMouseDown = isRippleTouchGenerated;
      this.setState({
        hasRipples: true,
        nextKey: this.state.nextKey + 1,
        ripples: ripples
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var currentRipples = this.state.ripples;
      this.setState({
        ripples: shift(currentRipples)
      });
      if (this.props.abortOnScroll) {
        this.stopListeningForScrollAbort();
      }
    }

    // Check if the user seems to be scrolling and abort the animation if so

  }, {
    key: 'startListeningForScrollAbort',
    value: function startListeningForScrollAbort(event) {
      this.firstTouchY = event.touches[0].clientY;
      this.firstTouchX = event.touches[0].clientX;
      // Note that when scolling Chrome throttles this event to every 200ms
      // Also note we don't listen for scroll events directly as there's no general
      // way to cover cases like scrolling within containers on the page
      document.body.addEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'stopListeningForScrollAbort',
    value: function stopListeningForScrollAbort() {
      document.body.removeEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'getRippleStyle',
    value: function getRippleStyle(event) {
      var el = _reactDom2.default.findDOMNode(this);
      var elHeight = el.offsetHeight;
      var elWidth = el.offsetWidth;
      var offset = _dom2.default.offset(el);
      var isTouchEvent = event.touches && event.touches.length;
      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
      var pointerX = pageX - offset.left;
      var pointerY = pageY - offset.top;
      var topLeftDiag = this.calcDiag(pointerX, pointerY);
      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
      var rippleSize = rippleRadius * 2;
      var left = pointerX - rippleRadius;
      var top = pointerY - rippleRadius;

      return {
        directionInvariant: true,
        height: rippleSize,
        width: rippleSize,
        top: top,
        left: left
      };
    }
  }, {
    key: 'calcDiag',
    value: function calcDiag(a, b) {
      return Math.sqrt(a * a + b * b);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style;
      var _state = this.state,
          hasRipples = _state.hasRipples,
          ripples = _state.ripples;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var rippleGroup = void 0;

      if (hasRipples) {
        var mergedStyles = (0, _simpleAssign2.default)({
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
        }, style);

        rippleGroup = _react2.default.createElement(_TransitionGroup2.default, { style: prepareStyles(mergedStyles) }, ripples);
      }

      return _react2.default.createElement('div', {
        onMouseUp: this.handleMouseUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      }, rippleGroup, children);
    }
  }]);
  return TouchRipple;
}(_react.Component);

TouchRipple.defaultProps = {
  abortOnScroll: true
};
TouchRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TouchRipple.propTypes =  false ? {
  abortOnScroll: _propTypes2.default.bool,
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = TouchRipple;

/***/ }),

/***/ "rGMG":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");

module.exports = uncurryThis([].slice);

/***/ }),

/***/ "rMkZ":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("Wyka");
var gOPN = __webpack_require__("Ni5N").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),

/***/ "rQKw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedValue;
function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
  if (keepUnprefixed) {
    return [prefixedValue, value];
  }
  return prefixedValue;
}
module.exports = exports["default"];

/***/ }),

/***/ "rngY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c647b93a8ae5c9a09b8f23b2cf174657.png";

/***/ }),

/***/ "rtOw":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

/***/ }),

/***/ "s25D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("SNRl");
var call = __webpack_require__("HiG7");
var aCallable = __webpack_require__("oOss");
var newPromiseCapabilityModule = __webpack_require__("JteQ");
var perform = __webpack_require__("1UNZ");
var iterate = __webpack_require__("abHJ");

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

/***/ }),

/***/ "s5UR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleName; });
/* unused harmony export detectedShape */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectApplicationIsInitialised; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectIsUnsupportedMobileOs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectApplicationIsWebview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectApplicationDetected; });
/* unused harmony export selectApplicationLaunchData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectApplicationActiveNowBadgeTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectApplicationCallTimeBeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectApplicationCallTimeBeepDelay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectApplicationCallTimeFree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectApplicationMinWithdrawalAmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return selectApplicationSystemFeePayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return selectApplicationUserSupportId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_compat__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("vyGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_consts__ = __webpack_require__("4PH9");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var moduleName = 'application';

var detectedShape = __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
  name: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  os: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  version: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired
});

// Reducer (down)

/**
 *
 * @type {{
 * initialised: boolean,
 * initialising: boolean,
 * isUnsupportedMobileOs: boolean,
 * launchData: null | {
 *   activeNowBadgeTime: number,
 *   callTimeFree: number,
 *   callTimeBeep: number,
 *   minWithdrawalAmount: number,
 *   userSupportId: number,
 *   systemFeePayout: null | { amount: number, percent: number }[]
 * },
 * detected: Object | null,
 * error: string
 * }}
 */
var initialState = {
  initialised: false,
  initialising: false,
  isUnsupportedMobileOs: false,
  isWebview: false,
  error: '',
  detected: null,
  launchData: null,
  applicationShouldUpdate: false
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var error = action.error,
      type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].APPLICATION_INITIALISE_REQUEST:
      return _extends({}, state, {
        initialised: false,
        initialising: true,
        error: initialState.error,
        launchData: initialState.launchData
      });

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].APPLICATION_INITIALISE_SUCCESS:
      {
        var launchData = payload.launchData;


        return _extends({}, state, {
          launchData: launchData,
          initialised: true,
          initialising: false,
          error: initialState.error
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].APPLICATION_INITIALISE_FAILURE:
      return _extends({}, state, {
        initialised: false,
        initialising: false,
        error: error || 'Unknown initialisation error'
      });

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].APPLICATION_SET_DETECTED:
      {
        var isWebview = payload.isWebview,
            detected = payload.detected;
        var os = detected.os;


        return _extends({}, state, {
          isWebview: isWebview,
          detected: detected,
          isUnsupportedMobileOs: [__WEBPACK_IMPORTED_MODULE_3__utils_consts__["p" /* OS */].ANDROID, __WEBPACK_IMPORTED_MODULE_3__utils_consts__["p" /* OS */].IOS].includes(os)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].SET_APPLICATION_SHOULD_UPDATE_SUCCESS:
      {
        return _extends({}, state, {
          applicationShouldUpdate: payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].SET_APPLICATION_SHOULD_UPDATE_FAILURE:
      {
        return _extends({}, state, {
          applicationShouldUpdate: false,
          error: error || 'Unknown error'
        });
      }

    default:
      return state;
  }
});

// Reducer (up)

// Selectors (down)

var stateSelector = function stateSelector(state) {
  return state[moduleName];
};

var selectApplicationIsInitialised = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (application) {
  return application.initialised;
});

var selectIsUnsupportedMobileOs = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (application) {
  return application.isUnsupportedMobileOs;
});

var selectApplicationIsWebview = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (application) {
  return application.isWebview;
});

var selectApplicationDetected = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (application) {
  return application.detected;
});

var selectApplicationLaunchData = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (application) {
  return application.launchData;
});

var selectApplicationActiveNowBadgeTime = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(selectApplicationLaunchData, function (launchData) {
  return launchData && launchData.activeNowBadgeTime;
});

var selectApplicationCallTimeBeep = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(selectApplicationLaunchData, function (launchData) {
  return launchData && launchData.callTimeBeep;
});

var selectApplicationCallTimeBeepDelay = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(selectApplicationLaunchData, function (launchData) {
  return launchData && launchData.callTimeBeepDelay;
});

var selectApplicationCallTimeFree = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(selectApplicationLaunchData, function (launchData) {
  return launchData && launchData.callTimeFree;
});

var selectApplicationMinWithdrawalAmount = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(selectApplicationLaunchData, function (launchData) {
  return launchData && launchData.minWithdrawalAmount;
});

var selectApplicationSystemFeePayout = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(selectApplicationLaunchData, function (launchData) {
  return launchData && launchData.systemFeePayout;
});

var selectApplicationUserSupportId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(selectApplicationLaunchData, function (launchData) {
  return launchData && launchData.userSupportId;
});

// Selectors (up)

/***/ }),

/***/ "s7YI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Go to',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages'
};
module.exports = exports['default'];

/***/ }),

/***/ "sFsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__("2kK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__ = __webpack_require__("VYL5");


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ "sUXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__ = __webpack_require__("V2hq");

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(fractionalSeconds, token.length);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),

/***/ "slh1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  once: function once(el, type, callback) {
    var typeArray = type ? type.split(' ') : [];
    var recursiveFunction = function recursiveFunction(event) {
      event.target.removeEventListener(event.type, recursiveFunction);
      return callback(event);
    };

    for (var i = typeArray.length - 1; i >= 0; i--) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  },
  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback);
    } else {
      // IE8+ Support
      el.attachEvent('on' + type, function () {
        callback.call(el);
      });
    }
  },
  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback);
    } else {
      // IE8+ Support
      el.detachEvent('on' + type, callback);
    }
  },
  isKeyboard: function isKeyboard(event) {
    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
  }
};

/***/ }),

/***/ "sqxo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (t) {
  var e = {};function n(i) {
    if (e[i]) return e[i].exports;var o = e[i] = { i: i, l: !1, exports: {} };return t[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }return n.m = t, n.c = e, n.d = function (t, e, i) {
    n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;if (4 & e && "object" == typeof t && t && t.__esModule) return t;var i = Object.create(null);if (n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(i, o, function (e) {
        return t[e];
      }.bind(null, o));
    }return i;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 5);
}([function (t, e) {
  t.exports = __webpack_require__("eW0v");
}, function (t, e, n) {
  t.exports = n(2)();
}, function (t, e, n) {
  "use strict";
  var i = n(3);function o() {}function r() {}r.resetWarningCache = o, t.exports = function () {
    function t(t, e, n, o, r, a) {
      if (a !== i) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name = "Invariant Violation", c;
      }
    }function e() {
      return t;
    }t.isRequired = t;var n = { array: t, bool: t, func: t, number: t, object: t, string: t, symbol: t, any: t, arrayOf: e, element: t, elementType: t, instanceOf: e, node: t, objectOf: e, oneOf: e, oneOfType: e, shape: e, exact: e, checkPropTypes: r, resetWarningCache: o };return n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";
  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {}, function (t, e, n) {
  "use strict";
  n.r(e), n.d(e, "store", function () {
    return M;
  });var i = "notification-item",
      o = "bottom-left",
      r = "bottom-right",
      a = "bottom-center",
      c = "top-left",
      u = "top-right",
      s = "top-center",
      l = "center",
      f = "top",
      p = "bottom",
      d = "success",
      m = "danger",
      h = "info",
      y = "default",
      v = "warning",
      b = "timeout",
      g = "click",
      S = "touch",
      E = "manual",
      w = function w(t) {
    return null == t;
  };function O(t) {
    return t === o || t === r || t === a;
  }function N(t) {
    return t === c || t === u || t === s;
  }function T(t) {
    var e = t.type,
        n = t.content,
        o = t.userDefinedTypes,
        r = [i];if (n) return r;if (w(o)) return function (t) {
      switch (t) {case y:
          return [i, "notification-default"];case d:
          return [i, "notification-success"];case m:
          return [i, "notification-danger"];case v:
          return [i, "notification-warning"];case h:
          return [i, "notification-info"];default:
          return [i];}
    }(e);var a = o.find(function (t) {
      return t.name === e;
    });return r.concat(a.htmlClasses);
  }function k(t, e) {
    var n = t.duration,
        i = t.timingFunction,
        o = t.delay;return "".concat(n, "ms ").concat(e, " ").concat(i, " ").concat(o, "ms");
  }function j(t, e) {
    var n = e.duration,
        i = e.timingFunction,
        o = e.delay,
        r = t || {};return w(r.duration) && (r.duration = n), w(r.timingFunction) && (r.timingFunction = i), w(r.delay) && (r.delay = o), r;
  }function R(t, e) {
    var n = t,
        i = n.id,
        o = n.type,
        r = n.insert,
        a = n.content,
        c = n.container,
        u = n.animationIn,
        s = n.animationOut,
        l = n.slidingEnter,
        f = n.slidingExit,
        p = n.touchRevert,
        b = n.touchSlidingExit,
        g = n.dismiss,
        S = n.width,
        E = n.onRemoval;n.id = i || M.counter, n.type = a ? null : o.toLowerCase(), e && !a && (n.userDefinedTypes = function (t, e) {
      var n = t.content,
          i = t.type;if (!n && i !== d && i !== m && i !== h && i !== y && i !== v && e) return e;
    }(n, e)), w(S) || (n.width = S), n.container = c.toLowerCase(), n.insert = (r || "top").toLowerCase(), n.dismiss = function (t) {
      var e = t,
          n = { duration: 0, click: !0, touch: !0, onScreen: !1, waitForAnimation: !1, showIcon: !1 };return e ? (Object.keys(n).forEach(function (t) {
        w(e[t]) && (e[t] = n[t]);
      }), e) : n;
    }(g), n.animationIn = u || [], n.animationOut = s || [], n.onRemoval = E || function () {};var O = function O(t, e, n) {
      return { duration: t, timingFunction: e, delay: n };
    };n.slidingEnter = j(l, O(600, "linear", 0)), n.slidingExit = j(f, O(600, "linear", 0)), n.touchRevert = j(p, O(600, "linear", 0));var N = b || {},
        T = N.swipe,
        k = N.fade;return n.touchSlidingExit = N, n.touchSlidingExit.swipe = j(T || {}, O(600, "linear", 0)), n.touchSlidingExit.fade = j(k || {}, O(300, "linear", 0)), n;
  }var P = n(0),
      C = n.n(P);var M = new function () {
    var t = this;return this.types = null, this.counter = 0, this.add = function () {}, this.addNotification = function (e) {
      var n = t.types;return t.counter += 1, t.add(R(e, n));
    }, this.removeNotification = function () {}, this.register = function (e) {
      var n = e.addNotification,
          i = e.removeNotification,
          o = e.types;t.add = n, t.removeNotification = i, t.types = o;
    }, this;
  }(),
      _ = n(1),
      x = n.n(_),
      L = function L(t, e) {
    var n,
        i,
        o = e;this.pause = function () {
      clearTimeout(n), o -= Date.now() - i;
    }, this.resume = function () {
      i = Date.now(), clearTimeout(n), n = setTimeout(t, o);
    }, this.clear = function () {
      clearTimeout(n);
    }, this.resume();
  };function A(t) {
    return (A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }function D(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || function (t, e) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;var n = [],
          i = !0,
          o = !1,
          r = void 0;try {
        for (var a, c = t[Symbol.iterator](); !(i = (a = c.next()).done) && (n.push(a.value), !e || n.length !== e); i = !0) {}
      } catch (t) {
        o = !0, r = t;
      } finally {
        try {
          i || null == c.return || c.return();
        } finally {
          if (o) throw r;
        }
      }return n;
    }(t, e) || U(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }function I(t, e) {
    var n = Object.keys(t);if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);e && (i = i.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, i);
    }return n;
  }function F(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};e % 2 ? I(Object(n), !0).forEach(function (e) {
        W(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }return t;
  }function W(t, e, n) {
    return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
  }function z(t) {
    return function (t) {
      if (Array.isArray(t)) return X(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || U(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }function U(t, e) {
    if (t) {
      if ("string" == typeof t) return X(t, e);var n = Object.prototype.toString.call(t).slice(8, -1);return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? X(t, e) : void 0;
    }
  }function X(t, e) {
    (null == e || e > t.length) && (e = t.length);for (var n = 0, i = new Array(e); n < e; n++) {
      i[n] = t[n];
    }return i;
  }function q(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }function H(t, e) {
    return (H = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }function V(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;if (Reflect.construct.sham) return !1;if ("function" == typeof Proxy) return !0;try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();return function () {
      var n,
          i = Y(t);if (e) {
        var o = Y(this).constructor;n = Reflect.construct(i, arguments, o);
      } else n = i.apply(this, arguments);return $(this, n);
    };
  }function $(t, e) {
    return !e || "object" !== A(e) && "function" != typeof e ? B(t) : e;
  }function B(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t;
  }function Y(t) {
    return (Y = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }var G = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && H(t, e);
    }(r, t);var e,
        n,
        i,
        o = V(r);function r(t) {
      var e;!function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, r), (e = o.call(this, t)).rootElementRef = C.a.createRef(), e.onClick = e.onClick.bind(B(e)), e.onTouchStart = e.onTouchStart.bind(B(e)), e.onTouchMove = e.onTouchMove.bind(B(e)), e.onTouchEnd = e.onTouchEnd.bind(B(e)), e.onMouseEnter = e.onMouseEnter.bind(B(e)), e.onMouseLeave = e.onMouseLeave.bind(B(e));var n = t.notification.width;return e.state = { parentStyle: { height: 0, overflow: "hidden", width: n ? "".concat(n, "px") : "100%" }, htmlClassList: T(t.notification), animationPlayState: "running", touchEnabled: !0 }, e;
    }return e = r, (n = [{ key: "componentWillUnmount", value: function value() {
        this.timer && this.timer.clear();
      } }, { key: "componentDidMount", value: function value() {
        var t = this,
            e = this.props,
            n = e.notification,
            i = e.count,
            o = n.dismiss,
            r = o.duration,
            a = o.onScreen,
            c = this.rootElementRef.current.scrollHeight,
            u = function (t, e) {
          return !(e <= 1) && e > 1 && (t.insert === f && N(t.container) || t.insert === p && O(t.container) || t.container === l);
        }(n, i),
            s = function s() {
          r && !a && (t.timer = new L(function () {
            return t.removeNotification(b);
          }, r));
        };this.setState(function (t) {
          return { parentStyle: { width: t.parentStyle.width, height: "".concat(c, "px"), transition: u ? k(n.slidingEnter, "height") : "10ms height" }, onTransitionEnd: s };
        }, function () {
          requestAnimationFrame(function () {
            t.setState(function (t) {
              return { htmlClassList: [].concat(z(n.animationIn), z(t.htmlClassList)) };
            });
          });
        });
      } }, { key: "componentDidUpdate", value: function value(t) {
        var e = t.removed;this.props.removed && !e && this.removeNotification(E);
      } }, { key: "removeNotification", value: function value(t) {
        var e = this,
            n = this.props,
            i = n.notification,
            o = n.toggleRemoval,
            r = i.id,
            a = i.onRemoval,
            c = i.dismiss.waitForAnimation,
            u = [].concat(z(i.animationOut), z(T(i))),
            s = function s() {
          return o(r, function () {
            return a(r, t);
          });
        },
            l = { height: 0, transition: k(i.slidingExit, "height") };return c ? this.setState(function (t) {
          var n = t.parentStyle.width;return { htmlClassList: u, onAnimationEnd: function onAnimationEnd() {
              e.setState({ parentStyle: F({ width: n }, l), onTransitionEnd: s });
            } };
        }) : this.setState(function (t) {
          return { parentStyle: F({ width: t.parentStyle.width }, l), onTransitionEnd: s, htmlClassList: u };
        });
      } }, { key: "onClick", value: function value() {
        var t = this.props.notification.dismiss;(t.click || t.showIcon) && this.removeNotification(g);
      } }, { key: "onTouchStart", value: function value(t) {
        var e = D(t.touches, 1)[0].pageX;this.setState(function (t) {
          var n = t.parentStyle;return { startX: e, currentX: e, parentStyle: F(F({}, n), {}, { position: "relative" }) };
        });
      } }, { key: "onTouchMove", value: function value(t) {
        var e = this,
            n = t.touches,
            i = this.state.startX,
            o = this.props,
            r = o.toggleRemoval,
            a = o.notification,
            c = a.id,
            u = a.onRemoval,
            s = a.slidingExit,
            l = a.touchSlidingExit,
            f = l.swipe,
            p = l.fade,
            d = D(n, 1)[0].pageX,
            m = d - i,
            h = this.rootElementRef.current.offsetWidth,
            y = window.innerWidth + h,
            v = "".concat(d - i >= 0 ? y : -y, "px");if (function (t, e) {
          return Math.abs(t) >= .4 * e;
        }(m, h)) {
          var b = k(f, "left"),
              g = k(p, "opacity"),
              E = function E() {
            r(c, function () {
              return u(c, S);
            });
          };return this.setState(function (t) {
            return { touchEnabled: !1, parentStyle: F(F({}, t.parentStyle), {}, { left: v, opacity: 0, transition: "".concat(b, ", ").concat(g) }), onTransitionEnd: function onTransitionEnd() {
                e.setState(function (t) {
                  return { parentStyle: F(F({}, t.parentStyle), {}, { height: 0, transition: k(s, "height") }), onTransitionEnd: E };
                });
              } };
          });
        }return this.setState(function (t) {
          var e = t.parentStyle;return { currentX: d, parentStyle: F(F({}, e), {}, { left: "".concat(0 + m, "px") }) };
        });
      } }, { key: "onTouchEnd", value: function value() {
        var t = this.props.notification.touchRevert;this.setState(function (e) {
          return { parentStyle: F(F({}, e.parentStyle), {}, { left: 0, transition: k(t, "left") }) };
        });
      } }, { key: "onMouseEnter", value: function value() {
        this.timer ? this.timer.pause() : this.setState({ animationPlayState: "paused" });
      } }, { key: "onMouseLeave", value: function value() {
        this.timer ? this.timer.resume() : this.setState({ animationPlayState: "running" });
      } }, { key: "renderTimer", value: function value() {
        var t = this,
            e = this.props.notification.dismiss,
            n = e.duration,
            i = e.onScreen,
            o = this.state.animationPlayState;if (n && i) {
          var r = { animationName: "timer", animationDuration: "".concat(n, "ms"), animationTimingFunction: "linear", animationFillMode: "forwards", animationDelay: 0, animationPlayState: o };return C.a.createElement("div", { className: "timer" }, C.a.createElement("div", { className: "timer-filler", onAnimationEnd: function onAnimationEnd() {
              return t.removeNotification(b);
            }, style: r }));
        }
      } }, { key: "renderCustomContent", value: function value() {
        var t = this.state.htmlClassList,
            e = this.props.notification,
            n = e.id,
            i = e.content,
            o = e.dismiss,
            r = o.duration,
            a = o.pauseOnHover,
            c = r > 0 && a;return C.a.createElement("div", { className: "".concat([].concat(z(t), ["n-child"]).join(" ")), onMouseEnter: c ? this.onMouseEnter : null, onMouseLeave: c ? this.onMouseLeave : null }, C.a.isValidElement(i) ? i : C.a.createElement(i, { id: n }));
      } }, { key: "renderNotification", value: function value() {
        var t = this.props.notification,
            e = t.title,
            n = t.message,
            i = t.dismiss,
            o = i.showIcon,
            r = i.duration,
            a = i.pauseOnHover,
            c = this.state.htmlClassList,
            u = r > 0 && a;return C.a.createElement("div", { className: "".concat([].concat(z(c), ["n-child"]).join(" ")), onMouseEnter: u ? this.onMouseEnter : null, onMouseLeave: u ? this.onMouseLeave : null }, C.a.createElement("div", { className: "notification-content" }, o && C.a.createElement("div", { className: "notification-close", onClick: this.onClick }), e && C.a.createElement("div", { className: "notification-title" }, e), C.a.createElement("div", { className: "notification-message" }, n), this.renderTimer()));
      } }, { key: "render", value: function value() {
        var t = this.props.notification,
            e = t.content,
            n = t.dismiss.click,
            i = this.state,
            o = i.parentStyle,
            r = i.onAnimationEnd,
            a = i.onTransitionEnd,
            c = i.touchEnabled;return C.a.createElement("div", { ref: this.rootElementRef, onClick: n ? this.onClick : null, className: "notification-parent", style: o, onAnimationEnd: r, onTransitionEnd: a, onTouchStart: c ? this.onTouchStart : null, onTouchMove: c ? this.onTouchMove : null, onTouchEnd: c ? this.onTouchEnd : null }, e ? this.renderCustomContent() : this.renderNotification());
      } }]) && q(e.prototype, n), i && q(e, i), r;
  }(C.a.Component);G.propTypes = { toggleRemoval: x.a.func.isRequired, count: x.a.number.isRequired, removed: x.a.bool };var J = G;n(4);function K(t) {
    return (K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }function Q(t) {
    return function (t) {
      if (Array.isArray(t)) return Z(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || function (t, e) {
      if (!t) return;if ("string" == typeof t) return Z(t, e);var n = Object.prototype.toString.call(t).slice(8, -1);"Object" === n && t.constructor && (n = t.constructor.name);if ("Map" === n || "Set" === n) return Array.from(t);if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Z(t, e);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }function Z(t, e) {
    (null == e || e > t.length) && (e = t.length);for (var n = 0, i = new Array(e); n < e; n++) {
      i[n] = t[n];
    }return i;
  }function tt(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }function et(t, e) {
    return (et = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }function nt(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;if (Reflect.construct.sham) return !1;if ("function" == typeof Proxy) return !0;try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();return function () {
      var n,
          i = rt(t);if (e) {
        var o = rt(this).constructor;n = Reflect.construct(i, arguments, o);
      } else n = i.apply(this, arguments);return it(this, n);
    };
  }function it(t, e) {
    return !e || "object" !== K(e) && "function" != typeof e ? ot(t) : e;
  }function ot(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t;
  }function rt(t) {
    return (rt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }var at = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && et(t, e);
    }(p, t);var e,
        n,
        i,
        f = nt(p);function p(t) {
      var e;return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, p), (e = f.call(this, t)).state = { isMobile: t.isMobile, breakpoint: t.breakpoint, notifications: [] }, e.add = e.add.bind(ot(e)), e.remove = e.remove.bind(ot(e)), e.toggleRemoval = e.toggleRemoval.bind(ot(e)), e.handleResize = e.handleResize.bind(ot(e)), e;
    }return e = p, (n = [{ key: "componentDidMount", value: function value() {
        var t = this.props.types;M.register({ addNotification: this.add, removeNotification: this.remove, types: t }), this.setState({ width: window.innerWidth }), window.addEventListener("resize", this.handleResize);
      } }, { key: "componentWillUnmount", value: function value() {
        window.removeEventListener("resize", this.handleResize);
      } }, { key: "handleResize", value: function value() {
        this.setState({ width: window.innerWidth });
      } }, { key: "add", value: function value(t) {
        return this.setState(function (e) {
          var n = e.notifications;return { notifications: "top" === t.insert ? [t].concat(Q(n)) : [].concat(Q(n), [t]) };
        }), t.id;
      } }, { key: "remove", value: function value(t) {
        this.setState(function (e) {
          return { notifications: e.notifications.map(function (e) {
              return e.id === t && (e.removed = !0), e;
            }) };
        });
      } }, { key: "toggleRemoval", value: function value(t, e) {
        this.setState(function (e) {
          return { notifications: e.notifications.filter(function (e) {
              return e.id !== t;
            }) };
        }, e);
      } }, { key: "renderNotifications", value: function value(t) {
        var e = this;return t.map(function (n) {
          return C.a.createElement(J, { id: n.id, key: n.id, notification: n, toggleRemoval: e.toggleRemoval, count: t.length, removed: n.removed });
        });
      } }, { key: "renderMobileNotifications", value: function value(t) {
        var e = t.className,
            n = t.id,
            i = function (t) {
          var e = [],
              n = [];return t.forEach(function (t) {
            var i = t.container,
                o = l;N(i) || i === o ? e.push(t) : O(i) && n.push(t);
          }), { top: e, bottom: n };
        }(this.state.notifications),
            o = this.renderNotifications(i.top),
            r = this.renderNotifications(i.bottom);return C.a.createElement("div", { id: n, key: "mobile", className: "react-notification-root ".concat(e || "") }, C.a.createElement("div", { className: "notification-container-mobile-top" }, o), C.a.createElement("div", { className: "notification-container-mobile-bottom" }, r));
      } }, { key: "renderScreenNotifications", value: function value(t) {
        var e = t.className,
            n = t.id,
            i = function (t) {
          var e = [],
              n = [],
              i = [],
              f = [],
              p = [],
              d = [],
              m = [];return t.forEach(function (t) {
            var h = t.container;h === c ? e.push(t) : h === u ? n.push(t) : h === s ? i.push(t) : h === o ? f.push(t) : h === r ? p.push(t) : h === a ? d.push(t) : h === l && m.push(t);
          }), { topLeft: e, topRight: n, topCenter: i, bottomLeft: f, bottomRight: p, bottomCenter: d, center: m };
        }(this.state.notifications),
            f = this.renderNotifications(i.topLeft),
            p = this.renderNotifications(i.topRight),
            d = this.renderNotifications(i.topCenter),
            m = this.renderNotifications(i.bottomLeft),
            h = this.renderNotifications(i.bottomRight),
            y = this.renderNotifications(i.bottomCenter),
            v = this.renderNotifications(i.center);return C.a.createElement("div", { id: n, key: "screen", className: "react-notification-root ".concat(e || "") }, C.a.createElement("div", { className: "notification-container-top-left" }, f), C.a.createElement("div", { className: "notification-container-top-right" }, p), C.a.createElement("div", { className: "notification-container-bottom-left" }, m), C.a.createElement("div", { className: "notification-container-bottom-right" }, h), C.a.createElement("div", { className: "notification-container-top-center" }, d), C.a.createElement("div", { className: "notification-container-center" }, C.a.createElement("div", { className: "center-inner" }, v)), C.a.createElement("div", { className: "notification-container-bottom-center" }, y));
      } }, { key: "render", value: function value() {
        var t = this.props.isMobile,
            e = this.state,
            n = e.width,
            i = e.breakpoint;return t && n <= i ? this.renderMobileNotifications(this.props) : this.renderScreenNotifications(this.props);
      } }]) && tt(e.prototype, n), i && tt(e, i), p;
  }(C.a.Component);at.propTypes = { isMobile: x.a.bool, breakpoint: x.a.number, types: x.a.array }, at.defaultProps = { isMobile: !0, breakpoint: 768 };var ct = at;e.default = ct;
}]);
//# sourceMappingURL=react-notifications.prod.js.map

/***/ }),

/***/ "svpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__("Oi8n");

// CONCATENATED MODULE: ../node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol["a" /* default */] ? _Symbol["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);
// CONCATENATED MODULE: ../node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);
// CONCATENATED MODULE: ../node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol["a" /* default */] ? _Symbol["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return _baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = __webpack_exports__["a"] = (baseGetTag);

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "sxPs":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("z7R8");
var createDesc = __webpack_require__("0WCH");
var toIObject = __webpack_require__("Wyka");
var toPrimitive = __webpack_require__("EKwp");
var has = __webpack_require__("yS17");
var IE8_DOM_DEFINE = __webpack_require__("R6c1");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("6MLN") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),

/***/ "t2zx":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "tAi/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("LiLl");

var callBind = __webpack_require__("y9YS");

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

/***/ }),

/***/ "tKq7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRoundingMethod;
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/***/ }),

/***/ "tQoh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4f6a031d3715fa17c40977163a2cd8c3.png";

/***/ }),

/***/ "tU9A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),

/***/ "ta1H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chatComponent":"chatComponent__1Cisa","connectingDiv":"connectingDiv__29E90","ldsDefault":"ldsDefault__kMNod","lds-default":"lds-default__1ApJq","users":"users__2R5kU","avatar":"avatar__1bzqr","msgCount":"msgCount__1M4Rh","authorName":"authorName__UE3Xg","messages":"messages__PyNwv","title":"title__3LDbd","image":"image__2CBZQ","info":"info__2SRBQ","name":"name__zWQdK","priceItem":"priceItem__3OsiM","callBtn":"callBtn__hfoGA","msg":"msg__1No0b","msgText":"msgText__3-eBJ","fileName":"fileName__2AEjW","myMsg":"myMsg__XSoji","messageText":"messageText__3cF-i","msgDate":"msgDate__8gQgP","error":"error__3Uu08","msgDay":"msgDay__3J70P","sendForm":"sendForm__2Hu0w","attachedFile":"attachedFile__3dzVz","deleteIcon":"deleteIcon__VvSFT","mediaOpacity":"mediaOpacity__3GZz7","mediaContent":"mediaContent__3u3bq","labelUploadFile":"labelUploadFile__3aR1m","uploadIcon":"uploadIcon__lPNhZ","inputUploadFile":"inputUploadFile__1vJTQ","contactLink":"contactLink__3TjmS","popover":"popover__2KipV","Loader":"Loader__2z7RT","proToShare":"proToShare__3I2JH","sendButton":"sendButton__3XjHd","mediaFilesPreview":"mediaFilesPreview__2Li-x","mediaFilePreviewItem":"mediaFilePreviewItem__2x1V0","deleteMediaButton":"deleteMediaButton__1s97e","prosListForSupport":"prosListForSupport__3k6cD","proListContent":"proListContent__1tdiv","contactMessage":"contactMessage__2SgTB","icon":"icon__1IBvo"};

/***/ }),

/***/ "tfSr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),

/***/ "tprn":
/***/ (function(module, exports, __webpack_require__) {

var RetryOperation = __webpack_require__("nMzr");

exports.operation = function (options) {
  var timeouts = exports.timeouts(options);
  return new RetryOperation(timeouts, {
    forever: options && (options.forever || options.retries === Infinity),
    unref: options && options.unref,
    maxRetryTime: options && options.maxRetryTime
  });
};

exports.timeouts = function (options) {
  if (options instanceof Array) {
    return [].concat(options);
  }

  var opts = {
    retries: 10,
    factor: 2,
    minTimeout: 1 * 1000,
    maxTimeout: Infinity,
    randomize: false
  };
  for (var key in options) {
    opts[key] = options[key];
  }

  if (opts.minTimeout > opts.maxTimeout) {
    throw new Error('minTimeout is greater than maxTimeout');
  }

  var timeouts = [];
  for (var i = 0; i < opts.retries; i++) {
    timeouts.push(this.createTimeout(i, opts));
  }

  if (options && options.forever && !timeouts.length) {
    timeouts.push(this.createTimeout(i, opts));
  }

  // sort the array numerically ascending
  timeouts.sort(function (a, b) {
    return a - b;
  });

  return timeouts;
};

exports.createTimeout = function (attempt, opts) {
  var random = opts.randomize ? Math.random() + 1 : 1;

  var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
  timeout = Math.min(timeout, opts.maxTimeout);

  return timeout;
};

exports.wrap = function (obj, options, methods) {
  if (options instanceof Array) {
    methods = options;
    options = null;
  }

  if (!methods) {
    methods = [];
    for (var key in obj) {
      if (typeof obj[key] === 'function') {
        methods.push(key);
      }
    }
  }

  for (var i = 0; i < methods.length; i++) {
    var method = methods[i];
    var original = obj[method];

    obj[method] = function retryWrapper(original) {
      var op = exports.operation(options);
      var args = Array.prototype.slice.call(arguments, 1);
      var callback = args.pop();

      args.push(function (err) {
        if (op.retry(err)) {
          return;
        }
        if (err) {
          arguments[0] = op.mainError();
        }
        callback.apply(this, arguments);
      });

      op.attempt(function () {
        original.apply(obj, args);
      });
    }.bind(obj, original);
    obj[method].options = options;
  }
};

/***/ }),

/***/ "trvQ":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var getBuiltIn = __webpack_require__("qvVx");
var isCallable = __webpack_require__("yeFe");
var isPrototypeOf = __webpack_require__("VN+O");
var USE_SYMBOL_AS_UID = __webpack_require__("HGpA");

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};

/***/ }),

/***/ "tuDi":
/***/ (function(module, exports) {



/***/ }),

/***/ "u760":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("RA6A");
var definePropertyModule = __webpack_require__("y7Dx");
var anObject = __webpack_require__("1kal");
var toIndexedObject = __webpack_require__("M0Be");
var objectKeys = __webpack_require__("A3Hj");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) {
    definePropertyModule.f(O, key = keys[index++], props[key]);
  }return O;
};

/***/ }),

/***/ "u82x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("SNRl");
var aCallable = __webpack_require__("oOss");
var getBuiltIn = __webpack_require__("qvVx");
var call = __webpack_require__("HiG7");
var newPromiseCapabilityModule = __webpack_require__("JteQ");
var perform = __webpack_require__("1UNZ");
var iterate = __webpack_require__("abHJ");

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true }, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn('AggregateError');
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

/***/ }),

/***/ "u8U4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("eW0v");

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getMuiTheme = __webpack_require__("AsRs");

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var MuiThemeProvider = function (_Component) {
  (0, _inherits3.default)(MuiThemeProvider, _Component);

  function MuiThemeProvider() {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);
    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.Component);

MuiThemeProvider.childContextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MuiThemeProvider.propTypes =  false ? {
  children: _propTypes2.default.element,
  muiTheme: _propTypes2.default.object
} : {};
exports.default = MuiThemeProvider;

/***/ }),

/***/ "u9EY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);

/***/ }),

/***/ "uGKn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__("/B6s");

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__("mZSj");

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__("pZzd");

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__("gf6g");

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__("G96k");

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__("ka1r");

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__("IsmX");

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
}; /* eslint-disable */

/***/ }),

/***/ "uRfg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__("1kq3");
var $export = __webpack_require__("vSO4");
var redefine = __webpack_require__("gojl");
var hide = __webpack_require__("akPY");
var Iterators = __webpack_require__("dhak");
var $iterCreate = __webpack_require__("b7Q2");
var setToStringTag = __webpack_require__("11Ut");
var getPrototypeOf = __webpack_require__("HHE0");
var ITERATOR = __webpack_require__("Ug9I")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),

/***/ "uTT0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

/***/ }),

/***/ "ufZ4":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("GZef");

module.exports = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];else redefine(target, key, src[key], options);
  }return target;
};

/***/ }),

/***/ "uiRb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node: true */


var normalice = __webpack_require__("9I8e");

/**
  # freeice

  The `freeice` module is a simple way of getting random STUN or TURN server
  for your WebRTC application.  The list of servers (just STUN at this stage)
  were sourced from this [gist](https://gist.github.com/zziuni/3741933).

  ## Example Use

  The following demonstrates how you can use `freeice` with
  [rtc-quickconnect](https://github.com/rtc-io/rtc-quickconnect):

  <<< examples/quickconnect.js

  As the `freeice` module generates ice servers in a list compliant with the
  WebRTC spec you will be able to use it with raw `RTCPeerConnection`
  constructors and other WebRTC libraries.

  ## Hey, don't use my STUN/TURN server!

  If for some reason your free STUN or TURN server ends up in the
  list of servers ([stun](https://github.com/DamonOehlman/freeice/blob/master/stun.json) or
  [turn](https://github.com/DamonOehlman/freeice/blob/master/turn.json))
  that is used in this module, you can feel
  free to open an issue on this repository and those servers will be removed
  within 24 hours (or sooner).  This is the quickest and probably the most
  polite way to have something removed (and provides us some visibility
  if someone opens a pull request requesting that a server is added).

  ## Please add my server!

  If you have a server that you wish to add to the list, that's awesome! I'm
  sure I speak on behalf of a whole pile of WebRTC developers who say thanks.
  To get it into the list, feel free to either open a pull request or if you
  find that process a bit daunting then just create an issue requesting
  the addition of the server (make sure you provide all the details, and if
  you have a Terms of Service then including that in the PR/issue would be
  awesome).

  ## I know of a free server, can I add it?

  Sure, if you do your homework and make sure it is ok to use (I'm currently
  in the process of reviewing the terms of those STUN servers included from
  the original list).  If it's ok to go, then please see the previous entry
  for how to add it.

  ## Current List of Servers

  * current as at the time of last `README.md` file generation

  ### STUN

  <<< stun.json

  ### TURN

  <<< turn.json

**/

var freeice = function freeice(opts) {
  // if a list of servers has been provided, then use it instead of defaults
  var servers = {
    stun: (opts || {}).stun || __webpack_require__("v9tU"),
    turn: (opts || {}).turn || __webpack_require__("i2r7")
  };

  var stunCount = (opts || {}).stunCount || 2;
  var turnCount = (opts || {}).turnCount || 0;
  var selected;

  function getServers(type, count) {
    var out = [];
    var input = [].concat(servers[type]);
    var idx;

    while (input.length && out.length < count) {
      idx = Math.random() * input.length | 0;
      out = out.concat(input.splice(idx, 1));
    }

    return out.map(function (url) {
      //If it's a not a string, don't try to "normalice" it otherwise using type:url will screw it up
      if (typeof url !== 'string' && !(url instanceof String)) {
        return url;
      } else {
        return normalice(type + ':' + url);
      }
    });
  }

  // add stun servers
  selected = [].concat(getServers('stun', stunCount));

  if (turnCount) {
    selected = selected.concat(getServers('turn', turnCount));
  }

  return selected;
};

module.exports = freeice;

/***/ }),

/***/ "uj5A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__("6MLN");
var getKeys = __webpack_require__("knrM");
var gOPS = __webpack_require__("Ocr3");
var pIE = __webpack_require__("z7R8");
var toObject = __webpack_require__("mbLO");
var IObject = __webpack_require__("E5Ce");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("wLcK")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),

/***/ "umce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__("VYL5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate).getTime();
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ "upEt":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("JOB+");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

/***/ }),

/***/ "uvux":
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__("PFZ8");
__webpack_require__("goEr");
// TODO: Remove from `core-js@4`
__webpack_require__("MUmM");
__webpack_require__("kvem");
__webpack_require__("H2mZ");

module.exports = parent;

/***/ }),

/***/ "v5sI":
/***/ (function(module, exports) {

module.exports = function (arr, obj) {
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),

/***/ "v6/v":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "v9LT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__("Q38I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("eW0v");


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom__["default"].unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom__["default"].unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),

/***/ "v9s1":
/***/ (function(module, exports, __webpack_require__) {

var EventEmitter = __webpack_require__("T2os").EventEmitter;
var emitters = {};

module.exports = function TabEmitter(key) {
	key = 'tabemitter' + (key || '');
	if (!emitters[key]) emitters[key] = makeEmitter(key);
	return emitters[key];
};

function makeEmitter(key) {
	var emitter = new EventEmitter();
	var originalEmit = emitter.emit;

	emitter.emit = function emit() {
		var args = [].slice.call(arguments);
		localStorage.setItem(key, JSON.stringify(args));
		localStorage.removeItem(key);
		return originalEmit.apply(emitter, args);
	};

	window.addEventListener('storage', function (ev) {
		if (ev.key === key && ev.newValue) {
			var args = JSON.parse(ev.newValue);
			originalEmit.apply(emitter, args);
		}
	});

	return emitter;
}

/***/ }),

/***/ "v9tU":
/***/ (function(module, exports) {

module.exports = ["stun.l.google.com:19302","stun1.l.google.com:19302","stun2.l.google.com:19302","stun3.l.google.com:19302","stun4.l.google.com:19302","stun.ekiga.net","stun.ideasip.com","stun.schlund.de","stun.stunprotocol.org:3478","stun.voiparound.com","stun.voipbuster.com","stun.voipstunt.com","stun.voxgratia.org"]

/***/ }),

/***/ "vJ8O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vLpE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export featuredServiceItemShape */
/* unused harmony export proItemShape */
/* unused harmony export prosSearchResultShape */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return moduleName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SORT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectFindProProcessing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectFindProSearchPhrase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectFindProSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectFindProActiveFilterTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectFindProEntities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectCategoriesFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_compat__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("15a7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("vyGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__categories__ = __webpack_require__("mbma");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var featuredServiceItemShape = __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
  amount: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired,
  imgUrl: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  subTitle: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired
});

var proItemShape = __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
  avatarUrl: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired,
  lastName: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  nickname: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  pro: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
    costPerMinute: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired,
    service: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
    serviceDescription: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
    review: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
      rating: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired,
      total: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired
    }).isRequired
  }).isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
    activeNow: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].bool.isRequired,
    onCall: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].bool.isRequired,
    dateLastActive: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string
  }).isRequired
});

var prosSearchResultShape = __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
  circle: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].arrayOf(proItemShape).isRequired,
  filtered: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].arrayOf(proItemShape).isRequired,
  relevant: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].arrayOf(proItemShape).isRequired,
  featuredServices: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].arrayOf(featuredServiceItemShape).isRequired
});

// Constants (down)

var moduleName = 'findPro';

var SORT_TYPE = {
  BY_ACTIVITY: 'by_activity',
  BY_EXPERIENCE: 'by_experience',
  BY_LOWEST_RATE: 'by_lowest_rate',
  BY_HIGHEST_RATE: 'by_highest_rate',
  BY_RATING: 'by_rating'
};

// Constants (up)

// Reducer (down)

var initialState = {
  processed: false,
  processing: false,
  searchPhrase: '',
  sort: SORT_TYPE.BY_ACTIVITY,
  activeFilterTags: {
    categories: [],
    sectors: [],
    services: []
  },
  entities: {
    circle: [],
    filtered: [],
    relevant: [],
    featuredServices: []
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].FIND_PRO_FILTER_REQUEST:
      return _extends({}, state, {
        processed: false,
        processing: true,
        entities: initialState.entities
      });

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].FIND_PRO_FILTER_SUCCESS:
      {
        var pros = payload.pros;


        return _extends({}, state, {
          processed: true,
          processing: false,
          entities: _extends({}, pros)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].FIND_PRO_FILTER_FAILURE:
      return _extends({}, state, {
        processed: false,
        processing: false,
        entities: initialState.entities
      });

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].FIND_PRO_SET_ACTIVE_FILTER_TAGS:
      {
        var activeFilterTags = payload.activeFilterTags;


        return _extends({}, state, {
          activeFilterTags: activeFilterTags
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].FIND_PRO_SET_SORT:
      {
        var sort = payload.sort;


        return _extends({}, state, {
          sort: sort
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].FIND_PRO_SET_SEARCH_PHRASE:
      {
        var searchPhrase = payload.searchPhrase;


        return _extends({}, state, {
          searchPhrase: searchPhrase
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].FIND_PRO_RESET:
      return _extends({}, initialState);

    default:
      return state;
  }
});

// Reducer (up)

// Selectors (down)

var stateSelector = function stateSelector(state) {
  return state[moduleName];
};

var selectFindProProcessing = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (findPro) {
  return findPro.processing;
});

var selectFindProSearchPhrase = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (findPro) {
  return findPro.searchPhrase;
});

var selectFindProSort = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (findPro) {
  return findPro.sort;
});

var selectFindProActiveFilterTags = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (findPro) {
  return findPro.activeFilterTags;
});

var selectFindProEntities = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(stateSelector, function (findPro) {
  return findPro.entities;
});

var selectCategoriesFilters = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["a" /* createSelector */])(__WEBPACK_IMPORTED_MODULE_3__categories__["e" /* selectCategories */], selectFindProActiveFilterTags, function (entities, activeFilterTags) {
  return (
    /**
     * @property {[{}]} childs
     */
    entities.map(function (sector) {
      return {
        ticked: activeFilterTags.sectors.includes(sector.tag),
        label: sector.name,
        level: __WEBPACK_IMPORTED_MODULE_3__categories__["a" /* CATEGORY_LEVELS */].SECTORS,
        tag: sector.tag,
        children: sector.childs.map(function (category) {
          return {
            ticked: activeFilterTags.categories.includes(category.tag),
            label: category.name,
            level: __WEBPACK_IMPORTED_MODULE_3__categories__["a" /* CATEGORY_LEVELS */].CATEGORIES,
            tag: category.tag,
            children: category.childs.map(function (service) {
              return {
                ticked: activeFilterTags.services.includes(service.tag),
                level: __WEBPACK_IMPORTED_MODULE_3__categories__["a" /* CATEGORY_LEVELS */].SERVICES,
                label: service.name,
                tag: service.tag,
                children: []
              };
            })
          };
        })
      };
    })
  );
});

// Selectors (up)

/***/ }),

/***/ "vSO4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("i1Q6");
var core = __webpack_require__("zKeE");
var ctx = __webpack_require__("3zRh");
var hide = __webpack_require__("akPY");
var has = __webpack_require__("yS17");
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();
            case 1:
              return new C(a);
            case 2:
              return new C(a, b);
          }return new C(a, b, c);
        }return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
      // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),

/***/ "vUQk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__("Gfzd");
var createDesc = __webpack_require__("0WCH");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
};

/***/ }),

/***/ "vc57":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("FS7x");
var createNonEnumerableProperty = __webpack_require__("yNEm");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};

/***/ }),

/***/ "vcHl":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("YD0x");
module.exports = __webpack_require__("zKeE").Object.assign;

/***/ }),

/***/ "vjJg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/profile/all-activity/style.scss
var style = __webpack_require__("jKgr");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/global/spinner/index.js
var spinner = __webpack_require__("K1uT");

// EXTERNAL MODULE: ../node_modules/date-fns/esm/format/index.js + 2 modules
var format = __webpack_require__("OZJZ");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./utils/consts.js + 1 modules
var consts = __webpack_require__("4PH9");

// EXTERNAL MODULE: ./components/app.js + 53 modules
var app = __webpack_require__("qLaj");

// EXTERNAL MODULE: ./assets/icons/missedCall.png
var icons_missedCall = __webpack_require__("Q373");
var missedCall_default = /*#__PURE__*/__webpack_require__.n(icons_missedCall);

// EXTERNAL MODULE: ./assets/icons/message.png
var message = __webpack_require__("PZh6");
var message_default = /*#__PURE__*/__webpack_require__.n(message);

// EXTERNAL MODULE: ./assets/icons/newMessage.png
var newMessage = __webpack_require__("OP68");
var newMessage_default = /*#__PURE__*/__webpack_require__.n(newMessage);

// EXTERNAL MODULE: ./assets/errorTextIcon.png
var errorTextIcon = __webpack_require__("/44e");
var errorTextIcon_default = /*#__PURE__*/__webpack_require__.n(errorTextIcon);

// EXTERNAL MODULE: ./components/profile/activity/style.scss
var activity_style = __webpack_require__("Fg8D");
var activity_style_default = /*#__PURE__*/__webpack_require__.n(activity_style);

// EXTERNAL MODULE: ./reducers/application.js
var application = __webpack_require__("s5UR");

// EXTERNAL MODULE: ./utils/index.js + 1 modules
var utils = __webpack_require__("DHvs");

// CONCATENATED MODULE: ./components/profile/activity/index.js
var _class, _temp, activity__initialiseProps;



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */






// eslint-disable-next-line import/no-cycle










// eslint-disable-next-line import/no-cycle


var activity_Activity = (_temp = _class = function (_Component) {
  _inherits(Activity, _Component);

  function Activity(props) {
    _classCallCheck(this, Activity);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    activity__initialiseProps.call(_this);

    _this.state = {
      lastVisit: props.timeOffset && _this.getLastVisit(props)
    };
    return _this;
  }

  Activity.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      lastVisit: this.getLastVisit(this.props)
    });
  };

  Activity.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.timeOffset !== this.props.timeOffset) {
      this.setState({
        lastVisit: this.getLastVisit(nextProps)
      });
    }
  };

  Activity.prototype.render = function render(_ref, _ref2) {
    var _ref$activity = _ref.activity,
        activity = _ref$activity === undefined ? {} : _ref$activity,
        pro = _ref.pro,
        _ref$badges = _ref.badges,
        _ref$badges$missedMes = _ref$badges.missedMessage,
        missedMessage = _ref$badges$missedMes === undefined ? 0 : _ref$badges$missedMes,
        _ref$badges$missedCal = _ref$badges.missedCall,
        missedCall = _ref$badges$missedCal === undefined ? 0 : _ref$badges$missedCal;
    var lastVisit = _ref2.lastVisit;

    var activityDate = new Date(activity.activityDate);
    var isMc = pro && missedMessage + missedCall > 0 && (activity.activity === 'callMissed' || activity.activity === 'callDeclined' || activity.activity === 'callWithdrawn' || activity.activity === 'callFailed' || activity.activity === 'callDisconnected');
    var isBold = isMc || activity.activity === 'uim';

    return Object(preact_min["h"])(
      'div',
      { className: activity_style_default.a.activity, onClick: this.gotoHandler(activity.id) },
      Object(preact_min["h"])(
        'div',
        { className: activity_style_default.a.contact },
        Object(preact_min["h"])(
          'div',
          { className: activity_style_default.a.avatar },
          activity.avatarUrl ? Object(preact_min["h"])('img', { src: activity.avatarUrl, alt: activity.nickname }) : Object(preact_min["h"])('img', { src: '/assets/nouserimage.jpg', alt: activity.nickname }),
          lastVisit !== false && Object(preact_min["h"])(
            'div',
            { className: activity.state.onCall ? activity_style_default.a.call : '' },
            Object(preact_min["h"])(
              'span',
              null,
              lastVisit
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: activity_style_default.a.info },
          Object(preact_min["h"])(
            'h3',
            null,
            activity.nickname
          ),
          !this.props.client && activity.pro !== null && Object(preact_min["h"])(
            'div',
            null,
            activity.pro.profession
          )
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: activity_style_default.a.type + ' ' + (isBold ? activity_style_default.a.typeBold : '') },
        Object(preact_min["h"])('img', { className: activity_style_default.a.icon, src: activity.activity === 'chatError' ? errorTextIcon_default.a : isMc ? missedCall_default.a : activity.activity === 'uim' ? newMessage_default.a : message_default.a }),
        Object(preact_min["h"])(
          'span',
          null,
          consts["B" /* activityTypes */][activity.activity]
        ),
        Object(preact_min["h"])(
          'span',
          { className: activity_style_default.a.date },
          Object(format["a" /* default */])(activityDate, consts["d" /* DATE_FORMAT */]) + ' at ' + Object(format["a" /* default */])(activityDate, consts["v" /* TIME_FORMAT */])
        ),
        Object(preact_min["h"])(
          'div',
          { className: activity_style_default.a.count + ' ' + (isBold ? activity_style_default.a.countRed : '') },
          isBold && missedCall + missedMessage
        )
      )
    );
  };

  return Activity;
}(preact_min["Component"]), activity__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getLastVisit = function (props) {
    var lastVisit = void 0;
    if (props.activity.state.onCall) {
      lastVisit = 'On call';
    } else if (props.activity.state.activeNow) {
      lastVisit = '';
    } else {
      lastVisit = Object(utils["g" /* getFormattedLastVisit */])(props.activity.state.msDateLastActive, props.activeNowBadgeTime);
    }

    return lastVisit;
  };

  this.gotoHandler = function (id) {
    return function () {
      if (_this2.props.client) {
        firebase.analytics().logEvent('Tap_on_any_Pro_in_My_Clients');
        Object(preact_router_es["route"])(app["routes"].USER_FOR_COMP + id);
      } else {
        firebase.analytics().logEvent('Tap_on_any_Pro_in_My_Pros');
        Object(preact_router_es["route"])(app["routes"].USER_FOR_COMP + id);
      }
    };
  };
}, _temp);


var activity_mapStateToProps = function mapStateToProps(state) {
  return {
    activeNowBadgeTime: Object(application["c" /* selectApplicationActiveNowBadgeTime */])(state)
  };
};

/* harmony default export */ var profile_activity = (Object(preact_redux_esm["b" /* connect */])(activity_mapStateToProps)(activity_Activity));
// EXTERNAL MODULE: ./components/pagination/index.js + 6 modules
var pagination = __webpack_require__("PvLZ");

// EXTERNAL MODULE: ./utils/langPack.js
var langPack = __webpack_require__("9dRJ");

// CONCATENATED MODULE: ./components/profile/all-activity/index.js


function all_activity__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function all_activity__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function all_activity__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// eslint-disable-next-line import/no-cycle







var all_activity__ref2 = Object(preact_min["h"])(spinner["a" /* default */], null);

var all_activity_AllActivity = function (_Component) {
  all_activity__inherits(AllActivity, _Component);

  function AllActivity() {
    all_activity__classCallCheck(this, AllActivity);

    return all_activity__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AllActivity.prototype.render = function render(_ref) {
    var _this2 = this;

    var _ref$activity = _ref.activity,
        activity = _ref$activity === undefined ? [] : _ref$activity,
        total = _ref.total,
        currentPage = _ref.currentPage,
        changePage = _ref.changePage,
        loading = _ref.loading,
        timeOffset = _ref.timeOffset,
        locale = _ref.locale,
        pro = _ref.pro,
        _ref$badges = _ref.badges,
        badges = _ref$badges === undefined ? {} : _ref$badges;

    return Object(preact_min["h"])(
      'div',
      { className: style_default.a.activityList + ' ' + (!this.props.client && style_default.a.withSorting) },
      Object(preact_min["h"])(
        'div',
        { className: style_default.a.inner },
        activity.length > 0 && !loading && activity.map(function (activity) {
          return Object(preact_min["h"])(profile_activity, { key: activity.id, activity: activity, client: _this2.props.client, timeOffset: timeOffset,
            locale: locale, pro: pro, badges: badges[activity.id] || {} });
        }),
        activity.length === 0 && !loading && Object(preact_min["h"])(
          'div',
          { className: style_default.a.empty },
          langPack["a" /* langPack */][locale].PROFILE.NO_RECENT_ACTIVITY
        ),
        loading && Object(preact_min["h"])(
          'div',
          { className: style_default.a.spinnerContainer },
          all_activity__ref2
        )
      ),
      activity.length < total && Object(preact_min["h"])(
        'div',
        { className: style_default.a.pagination },
        Object(preact_min["h"])(pagination["a" /* default */], {
          total: total,
          onChange: changePage,
          current: currentPage,
          pageSize: consts["E" /* consts */].PAGE_SIZE
        })
      )
    );
  };

  return AllActivity;
}(preact_min["Component"]);

/* harmony default export */ var all_activity = __webpack_exports__["a"] = (all_activity_AllActivity);

/***/ }),

/***/ "vkXE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

/***/ }),

/***/ "vnfP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vq39":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

/***/ }),

/***/ "vyGZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionTypes; });
// ACTION TYPES
// eslint-disable-next-line import/prefer-default-export
var actionTypes = {
  APPLICATION_INITIALISE_REQUEST: 'APPLICATION_INITIALISE_REQUEST',
  APPLICATION_INITIALISE_SUCCESS: 'APPLICATION_INITIALISE_SUCCESS',
  APPLICATION_INITIALISE_FAILURE: 'APPLICATION_INITIALISE_FAILURE',

  COUNTRIES_FETCH_REQUEST: 'COUNTRIES_FETCH_REQUEST',
  COUNTRIES_FETCH_SUCCESS: 'COUNTRIES_FETCH_SUCCESS',
  COUNTRIES_FETCH_FAILURE: 'COUNTRIES_FETCH_FAILURE',

  SET_APPLICATION_SHOULD_UPDATE_SUCCESS: 'SET_APPLICATION_SHOULD_UPDATE_SUCCESS',
  SET_APPLICATION_SHOULD_UPDATE_FAILURE: 'SET_APPLICATION_SHOULD_UPDATE_FAILURE',

  CHANGE_LOCALE: 'CHANGE_LOCALE',
  CHANGE_LOCALE_LANGS: 'CHANGE_LOCALE_LANGS',
  USER_DETAILS_FETCHED: 'USER_DETAILS_FETCHED',
  SHOW_SEARCH_BOX: 'SHOW_SEARCH_BOX',
  LOG_IN: 'LOG_IN',
  LOG_IN_SUCCESS: 'LOG_IN_SUCCESS',
  LOG_IN_FAILURE: 'LOG_IN_FAILURE',
  PRO_CALLS_RECEIVED: 'PRO_CALLS_RECEIVED',
  PERSONAL_CALLS_RECEIVED: 'PERSONAL_CALLS_RECEIVED',
  TRANSACTIONS_RECEIVED: 'TRANSACTIONS_RECEIVED',
  RESET_TRANSACTIONS: 'RESET_TRANSACTIONS',
  GET_TRANSACTIONS: 'GET_TRANSACTIONS',
  GET_TRANSACTIONS_FAILURE: 'GET_TRANSACTIONS_FAILURE',

  GET_WITHDRAW: 'GET_WITHDRAW',
  WITHDRAW_RECEIVED: 'WITHDRAW_RECEIVED',
  GET_WITHDRAW_FAILURE: 'GET_WITHDRAW_FAILURE',

  AUTH_FAILURE: 'AUTH_FAILURE',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_FAILURE: 'REGISTER_FAILURE',
  LOGGED_OFF: 'LOGGED_OFF',
  EDIT_SUCCESS: 'EDIT_SUCCESS',
  EDIT_FAILURE: 'EDIT_FAILURE',
  FETCHING_REGISTRATION: 'FETCHING_REGISTRATION',
  VERIFY_FAILURE: 'VERIFY_FAILURE',
  VERIFY_SUCCESS: 'VERIFY_SUCCESS',
  RESET_SUCCESS: 'RESET_SUCCESS',
  RESET_FAILURE: 'RESET_FAILURE',
  PHOTO_UPLOADED: 'PHOTO_UPLOADED',
  PHOTO_UPLOAD_FAILURE: 'PHOTO_UPLOAD_FAILURE',
  PHOTO_UPLOAD_CLEAR_STATUS: 'PHOTO_UPLOAD_CLEAR_STATUS',
  FORGOT_PASSWORD_RESET: 'FORGOT_PASSWORD_RESET',
  SET_CATEGORIES: 'SET_CATEGORIES',
  SEND_CONTACT_MESS: 'SEND_CONTACT_MESS',
  SEND_CONTACT_MESS_FAILURE: 'SEND_CONTACT_MESS_FAILURE',
  SEND_CONTACT_MESS_SUCCESS: 'SEND_CONTACT_MESS_SUCCESS',
  SET_STATE: 'SET_STATE',
  SET_STATE_SUCCESS: 'SET_STATE_SUCCESS',
  SET_STATE_FAILURE: 'SET_STATE_FAILURE',
  CLOSE_COMMUNICATE_MODAL: 'CLOSE_COMMUNICATE_MODAL',
  CLOSE_COMMUNICATE_MODAL_CHAT: 'CLOSE_COMMUNICATE_MODAL_CHAT',
  OPEN_COMMUNICATE_MODAL: 'OPEN_COMMUNICATE_MODAL',
  OPEN_COMMUNICATE_MODAL_CHAT: 'OPEN_COMMUNICATE_MODAL_CHAT',
  CHOOSE_CHAT_PERSON: 'CHOOSE_CHAT_PERSON',
  CLEAR_CHATS: 'CLEAR_CHATS',
  CLEAR_CALL_BRIEFS: 'CLEAR_CALL_BRIEFS',

  CHANGE_UNREAD_MSG: 'CHANGE_UNREAD_MSG',
  CREATE_CALL: 'CREATE_CALL',
  CREATE_CALL_ERROR: 'CREATE_CALL_ERROR',
  GET_CALL_INFO: 'GET_CALL_INFO',
  CALEE_IS_BUSY: 'CALEE_IS_BUSY',
  PROCESSING_CALL: 'PROCESSING_CALL',
  SPEAKING: 'SPEAKING',
  STOP_COMMUNICATION: 'STOP_COMMUNICATION',
  PICK_UP_CALL: 'PICK_UP_CALL',

  MODIFYING_CARDS: 'MODIFYING_CARDS',
  GETING_CARDS_SUCCESS: 'GETING_CARDS_SUCCESS',
  GETING_CARDS_FAILURE: 'GETING_CARDS_FAILURE',

  MODIFYING_BANKS: 'MODIFYING_BANKS',
  GETING_BANKS_SUCCESS: 'GETING_BANKS_SUCCESS',
  GETING_BANKS_FAILURE: 'GETING_BANKS_FAILURE',
  VERIFICATION_ID_UPLOADED: 'VERIFICATION_ID_UPLOADED',
  VERIFICATION_ID_UPLOAD_FAILURE: 'VERIFICATION_ID_UPLOAD_FAILURE',
  VERIFICATION_ID_STATUS_RESET: 'VERIFICATION_ID_STATUS_RESET',
  CHECK_VERIFICATION_ID_FAIL: 'CHECK_VERIFICATION_ID_FAIL',
  CHECK_VERIFICATION_ID_SUCCESS: 'CHECK_VERIFICATION_ID_SUCCESS',

  GET_PROS: 'GET_PROS',
  GET_PROS_FAILURE: 'GET_PROS_FAILURE',
  GET_PROS_SUCCESS: 'GET_PROS_SUCCESS',
  SET_PRO_SEARCH_PARAMS: 'SET_PRO_SEARCH_PARAMS',
  RESET_PRO_SEARCH_PARAMS: 'RESET_PRO_SEARCH_PARAMS',

  GET_USER_ACTIVITY: 'GET_USER_ACTIVITY',
  GET_USER_ACTIVITY_SUCCESS: 'GET_USER_ACTIVITY_SUCCESS',
  GET_USER_ACTIVITY_FAILURE: 'GET_USER_ACTIVITY_FAILURE',
  SET_ACTIVITY_SEARCH_PARAMS: 'SET_ACTIVITY_SEARCH_PARAMS',
  RESET_ACTIVITY_SEARCH_PARAMS: 'RESET_ACTIVITY_SEARCH_PARAMS',

  GET_USER_DETAILS: 'GET_USER_DETAILS',
  RESET_USER_DETAILS: 'RESET_USER_DETAILS',
  GET_USER_DETAILS_SUCCESS: 'GET_USER_DETAILS_SUCCESS',
  GET_USER_DETAILS_FAILURE: 'GET_USER_DETAILS_FAILURE',

  CHANGE_CHAT: 'CHANGE_CHAT',
  CHANGE_CONNECTION_STATUS: 'CHANGE_CONNECTION_STATUS',
  CHANGE_VIDEO_STATUS: 'CHANGE_VIDEO_STATUS',

  TOP_UP: 'TOP_UP',
  TOP_UP_SUCCESS: 'TOP_UP_SUCCESS',
  TOP_UP_PENDING: 'TOP_UP_PENDING',
  TOP_UP_FAILURE: 'TOP_UP_FAILURE',

  GET_AMOUNTS_SUCCESS: 'GET_AMOUNTS_SUCCESS',
  GET_AMOUNTS_FAILURE: 'GET_AMOUNTS_FAILURE',
  GET_AMOUNTS: 'GET_AMOUNTS',

  SEND_WITHDRAW_START: 'SEND_WITHDRAW_START',
  SEND_WITHDRAW_SUCCESS: 'SEND_WITHDRAW_SUCCESS',
  SEND_WITHDRAW_FAILURE: 'SEND_WITHDRAW_FAILURE',

  GET_STRIPE_KEY_SUCCESS: 'GET_STRIPE_KEY_SUCCESS',
  GET_STRIPE_KEY_FAILURE: 'GET_STRIPE_KEY_FAILURE',

  GET_AVAILABILITY: 'GET_AVAILABILITY',
  GET_AVAILABILITY_SUCCESS: 'GET_AVAILABILITY_SUCCESS',
  GET_AVAILABILITY_FAILURE: 'GET_AVAILABILITY_FAILURE',

  SET_AVAILABILITY: 'SET_AVAILABILITY',
  SET_AVAILABILITY_SUCCESS: 'SET_AVAILABILITY_SUCCESS',
  SET_AVAILABILITY_FAILURE: 'SET_AVAILABILITY_FAILURE',

  UPDATE_AVAILABILITY: 'UPDATE_AVAILABILITY',
  UPDATE_AVAILABILITY_SUCCESS: 'UPDATE_AVAILABILITY_SUCCESS',
  UPDATE_AVAILABILITY_FAILURE: 'UPDATE_AVAILABILITY_FAILURE',

  DELETE_AVAILABILITY: 'DELETE_AVAILABILITY',
  DELETE_AVAILABILITY_SUCCESS: 'DELETE_AVAILABILITY_SUCCESS',
  DELETE_AVAILABILITY_FAILURE: 'DELETE_AVAILABILITY_FAILURE',

  GET_SECTORS_REQUSET: 'GET_SECTORS_REQUSET',
  GET_SECTORS_SUCCESS: 'GET_SECTORS_SUCCESS',
  GET_SECTORS_FAILURE: 'GET_SECTORS_FAILURE',

  SET_URL: 'SET_URL',

  FEATURED_SERVICE: 'FEATURED_SERVICE',
  FEATURED_SERVICE_SUCCESS: 'FEATURED_SERVICE_SUCCESS',
  FEATURED_SERVICE_FAILURE: 'FEATURED_SERVICE_FAILURE',

  FEATURED_SERVICES: 'FEATURED_SERVICES',
  FEATURED_SERVICES_SUCCESS: 'FEATURED_SERVICES_SUCCESS',
  FEATURED_SERVICES_FAILURE: 'FEATURED_SERVICES_FAILURE',
  RESET_FEATURED_SERVICE: 'RESET_FEATURED_SERVICE',

  FEATURED_AGREEMENT: 'FEATURED_AGREEMENT',
  FEATURED_AGREEMENT_SUCCESS: 'FEATURED_AGREEMENT_SUCCESS',
  FEATURED_AGREEMENT_FAILURE: 'FEATURED_AGREEMENT_FAILURE',

  SET_TIME_OFFSET: 'SET_TIME_OFFSET',

  BRANCH_IO_DATA: 'BRANCH_IO_DATA',
  UPDATE_USER_SETTINGS: 'UPDATE_USER_SETTINGS',
  UPDATE_USER_SETTINGS_SUCCESS: 'UPDATE_USER_SETTINGS_SUCCESS',
  UPDATE_USER_SETTINGS_FAILURE: 'UPDATE_USER_SETTINGS_FAILURE',

  GET_DEEP_LINK: 'GET_DEEP_LINK',
  GET_DEEP_LINK_SUCCESS: 'GET_DEEP_LINK_SUCCESS',
  GET_DEEP_LINK_FAILURE: 'GET_DEEP_LINK_FAILURE',

  GET_BADGE: 'GET_BADGE',
  GET_BADGE_SUCCESS: 'GET_BADGE_SUCCESS',
  GET_BADGE_FAILURE: 'GET_BADGE_FAILURE',

  UPDATE_BADGE: 'UPDATE_BADGE',
  UPDATE_BADGE_SUCCESS: 'UPDATE_BADGE_SUCCESS',
  UPDATE_BADGE_FAILURE: 'UPDATE_BADGE_FAILURE',

  GLOBAL_MESSAGE: 'GLOBAL_MESSAGE',
  UPLOAD_FILE_REQUSET: 'UPLOAD_FILE_REQUSET',
  UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE: 'UPLOAD_FILE_FAILURE',

  DELETE_FILE_REQUSET: 'DELETE_FILE_REQUSET',
  DELETE_FILE_SUCCESS: 'DELETE_FILE_SUCCESS',
  DELETE_FILE_FAILURE: 'DELETE_FILE_FAILURE',

  SET_REDIRECT_LINK: 'SET_REDIRECT_LINK',

  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  REGISTRATION_PENDING_ACTIVATION: 'REGISTRATION_PENDING_ACTIVATION',

  TOKEN_VALIDATE_REQUEST: 'TOKEN_VALIDATE_REQUEST',
  TOKEN_VALIDATE_SUCCESS: 'TOKEN_VALIDATE_SUCCESS',
  TOKEN_VALIDATE_FAILURE: 'TOKEN_VALIDATE_FAILURE',
  TOKEN_VALIDATE_RESET: 'TOKEN_VALIDATE_RESET',

  APPLICATION_CHECK_OS: 'APPLICATION_CHECK_OS',
  APPLICATION_SET_DETECTED: 'APPLICATION_SET_DETECTED',

  CHANGE_RECONNECTION_STATUS: 'CHANGE_RECONNECTION_STATUS',

  SIGN_IN_FETCH_USER_DATA_REQUEST: 'SIGN_IN_FETCH_USER_DATA_REQUEST',
  SIGN_IN_FETCH_USER_DATA_SUCCESS: 'SIGN_IN_FETCH_USER_DATA_SUCCESS',
  SIGN_IN_FETCH_USER_DATA_FAILURE: 'SIGN_IN_FETCH_USER_DATA_FAILURE',
  SIGN_IN_LOGIN_REQUEST: 'SIGN_IN_LOGIN_REQUEST',
  SIGN_IN_LOGIN_SUCCESS: 'SIGN_IN_LOGIN_SUCCESS',
  SIGN_IN_LOGIN_FAILURE: 'SIGN_IN_LOGIN_FAILURE',
  SIGN_IN_SOCIAL_LOGIN_REQUEST: 'SIGN_IN_SOCIAL_LOGIN_REQUEST',
  SIGN_IN_PUT_RESPONSE: 'SIGN_IN_PUT_RESPONSE',
  SIGN_IN_SET_PROCESSED: 'SIGN_IN_SET_PROCESSED',

  SIGN_UP_REGISTER_REQUEST: 'SIGN_UP_REGISTER_REQUEST',
  SIGN_UP_REGISTER_SUCCESS: 'SIGN_UP_REGISTER_SUCCESS',
  SIGN_UP_REGISTER_FAILURE: 'SIGN_UP_REGISTER_FAILURE',
  SIGN_UP_RESET: 'SIGN_UP_RESET',
  CATEGORIES_FETCH_REQUEST: 'CATEGORIES_FETCH_REQUEST',
  CATEGORIES_FETCH_SUCCESS: 'CATEGORIES_FETCH_SUCCESS',
  CATEGORIES_FETCH_FAILURE: 'CATEGORIES_FETCH_FAILURE',

  FIND_PRO_FILTER_REQUEST: 'FIND_PRO_FILTER_REQUEST',
  FIND_PRO_FILTER_SUCCESS: 'FIND_PRO_FILTER_SUCCESS',
  FIND_PRO_FILTER_FAILURE: 'FIND_PRO_FILTER_FAILURE',
  FIND_PRO_SET_ACTIVE_FILTER_TAGS: 'FIND_PRO_SET_ACTIVE_FILTER_TAGS',
  FIND_PRO_SET_SEARCH_PHRASE: 'FIND_PRO_SET_SEARCH_PHRASE',
  FIND_PRO_SET_SORT: 'FIND_PRO_SET_SORT',
  FIND_PRO_RESET: 'FIND_PRO_RESET',

  FORGOT_PASSWORD_POST_REQUEST: 'FORGOT_PASSWORD_POST_REQUEST',
  FORGOT_PASSWORD_POST_SUCCESS: 'FORGOT_PASSWORD_POST_SUCCESS',
  FORGOT_PASSWORD_POST_FAILURE: 'FORGOT_PASSWORD_POST_FAILURE',
  FORGOT_PASSWORD_RESET_REQUEST: 'FORGOT_PASSWORD_RESET_REQUEST',
  FORGOT_PASSWORD_RESET_SUCCESS: 'FORGOT_PASSWORD_REST_SUCCESS',
  FORGOT_PASSWORD_RESET_FAILURE: 'FORGOT_PASSWORD_RESET_FAILURE',
  FORGOT_PASSWORD_SET_RESETTING_MODE: 'FORGOT_PASSWORD_SET_RESETTING_MODE',

  MESSAGE_SET_TEXT: 'MESSAGE_SET_TEXT',
  MESSAGE_FETCH_PROS_AS_SUPPORT_REQUEST: 'MESSAGE_FETCH_PROS_AS_SUPPORT_REQUEST',
  MESSAGE_FETCH_PROS_AS_SUPPORT_SUCCESS: 'MESSAGE_FETCH_PROS_AS_SUPPORT_SUCCESS',
  MESSAGE_FETCH_PROS_AS_SUPPORT_FAILURE: 'MESSAGE_FETCH_PROS_AS_SUPPORT_FAILURE',
  MESSAGE_RESET: 'MESSAGE_RESET',

  GET_BOOKINGS_REQUEST: 'GET_BOOKINGS_REQUEST',
  GET_BOOKINGS_SUCCESS: 'GET_BOOKINGS_SUCCESS',
  GET_BOOKINGS_FAILURE: 'GET_BOOKINGS_FAILURE',
  CANCEL_BOOKING_SUCCESS: 'CANCEL_BOOKING_SUCCESS',
  CANCEL_BOOKING_FAILURE: 'CANCEL_BOOKING_FAILURE',
  GET_BOOKING_REFUND_SUCCESS: 'GET_BOOKING_REFUND_SUCCESS',
  GET_BOOKING_REFUND_FAILURE: 'GET_BOOKING_REFUND_FAILURE',
  CANCEL_BOOKING_NOT_CONFIRMED: 'CANCEL_BOOKING_NOT_CONFIRMED',

  REFRESH_LOGGED_IN_USER_DETAILS: 'REFRESH_LOGGED_IN_USER_DETAILS',
  REFRESH_LOGGED_IN_USER_DETAILS_SUCCESS: 'REFRESH_LOGGED_IN_USER_DETAILS_SUCCESS',
  REFRESH_LOGGED_IN_USER_DETAILS_FAILURE: 'REFRESH_LOGGED_IN_USER_DETAILS_FAILURE',

  CALL_TIMER_RESET: 'CALL_TIMER_RESET',
  CALL_TIMER_TICK: 'CALL_TIMER_TICK',
  CALL_TIMER_TIMESTAMP: 'CALL_TIMER_TIMESTAMP'
};

/***/ }),

/***/ "w8cn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleName; });
/* unused harmony export userProfileShape */
/* unused harmony export bookingShape */
/* unused harmony export upcomingBookingsShape */
/* unused harmony export selectUpcomingBookingsState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectUpcomingBookingsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectAreUpcomingBookingsLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectDidUpcomingBookingsLoadingFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectLastCancelledBookingId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectBookingBeingCancelled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_compat__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__("mo7Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("vyGZ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var moduleName = 'bookings';

var userProfileShape = __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
  id: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  lastName: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  nickname: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  avatarUrl: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string,
  pro: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
    costPerMinute: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired,
    service: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired
  })
});

var bookingShape = __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].shape({
  id: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired,
  client: userProfileShape.isRequired,
  pro: userProfileShape,
  startTime: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  endTime: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].oneOf(['ONLINE', 'IN_PERSON']).isRequired,
  status: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].oneOf(['PRE_BOOKED', 'BOOKED', 'CANCELLED_BY_CLIENT', 'CANCELLED_BY_PRO', 'READY_TO_PURGE']).isRequired,
  viewed: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].bool.isRequired,
  paymentAmount: __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].number.isRequired
});

var upcomingBookingsShape = __WEBPACK_IMPORTED_MODULE_0_preact_compat__["PropTypes"].arrayOf(bookingShape);

var selectUpcomingBookingsState = function selectUpcomingBookingsState(state) {
  return state.bookings;
};

var selectUpcomingBookingsData = function selectUpcomingBookingsData(state) {
  return state.bookings.upcomingBookings;
};

var selectAreUpcomingBookingsLoading = function selectAreUpcomingBookingsLoading(state) {
  return state.bookings.loading;
};

var selectDidUpcomingBookingsLoadingFailed = function selectDidUpcomingBookingsLoadingFailed(state) {
  return state.bookings.error;
};

var selectLastCancelledBookingId = function selectLastCancelledBookingId(state) {
  return state.bookings.lastCancelledBookingId;
};

var selectBookingBeingCancelled = function selectBookingBeingCancelled(state) {
  return state.bookings.bookingBeingCancelled;
};

var initialState = {
  upcomingBookings: [],
  error: false,
  loading: false,
  lastCancelledBookingId: null
};

var extractRefundAmountfromDetailsPayload = function extractRefundAmountfromDetailsPayload(payload) {
  return payload.details ? payload.details ? payload.details.refundData ? payload.details.refundData.amount : 0 : 0 : 0;
};

var extractBookingIdFromDetailsPayload = function extractBookingIdFromDetailsPayload(payload) {
  return payload.booking ? payload.booking.id : null;
};

var extractPaymentAmountFromDetailsPayload = function extractPaymentAmountFromDetailsPayload(payload) {
  return payload.booking ? payload.booking.paymentAmount : null;
};

var extractBookingStartTimeFromDetailsPayload = function extractBookingStartTimeFromDetailsPayload(payload) {
  return payload.booking ? Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["d" /* parseISO */])(payload.booking.startTime) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _extends({}, initialState);
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].GET_BOOKINGS_REQUEST:
      return _extends({}, state, {
        error: false,
        loading: true,
        lastCancelledBookingId: null,
        bookingBeingCancelled: null
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].GET_BOOKINGS_FAILURE:
      return {
        upcomingBookings: [],
        error: true,
        loading: false
      };
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].GET_BOOKINGS_SUCCESS:
      return {
        upcomingBookings: action.payload,
        error: false,
        loading: false
      };
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CANCEL_BOOKING_SUCCESS:
      return _extends({}, state, {
        lastCancelledBookingId: action.payload.id,
        bookingBeingCancelled: null
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].GET_BOOKING_REFUND_SUCCESS:
      return _extends({}, state, {
        bookingBeingCancelled: {
          id: extractBookingIdFromDetailsPayload(action.payload),
          refundAmount: extractRefundAmountfromDetailsPayload(action.payload),
          amIClient: action.payload.userId === action.payload.booking.client.id,
          paymentAmount: extractPaymentAmountFromDetailsPayload(action.payload),
          secondsToStart: Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["a" /* differenceInSeconds */])(extractBookingStartTimeFromDetailsPayload(action.payload), new Date())
        }
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionTypes */].CANCEL_BOOKING_NOT_CONFIRMED:
      return _extends({}, state, {
        bookingBeingCancelled: null
      });
    default:
      return state;
  }
});

/***/ }),

/***/ "wLcK":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ "wT1l":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("1kal");
var aConstructor = __webpack_require__("RBnT");
var wellKnownSymbol = __webpack_require__("G69i");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Asjh");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "wkTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPros; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeSearchParams; });
/* unused harmony export resetPros */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_pros__ = __webpack_require__("iMz2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("vyGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_notifications__ = __webpack_require__("kKXN");




var getPros = function getPros() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return function (dispatch, getState) {
    return new Promise(function ($return, $error) {
      var _getState, _getState$pros, searchTerm, sortBy, filter, userAuth, splitedFilter, response;

      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].GET_PROS
      });
      _getState = getState(), _getState$pros = _getState.pros, searchTerm = _getState$pros.searchTerm, sortBy = _getState$pros.sortBy, filter = _getState$pros.filter, userAuth = _getState.loggedInUser.userAuth;

      if (filter) {
        var $Try_1_Post = function () {
          try {
            return $If_2.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this);var $Try_1_Catch = function (error) {
          try {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__api_notifications__["a" /* addNotification */])(error));
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].GET_PROS_FAILURE,
              error: error
            });
            return $Try_1_Post();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };
        try {
          splitedFilter = filter.split('.');
          return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__api_pros__["d" /* getPros */](searchTerm, sortBy, page, splitedFilter.pop(), userAuth).catch(function (err) {
            throw err;
          })).then(function ($await_3) {
            try {
              response = $await_3;
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].GET_PROS_SUCCESS,
                payload: response
              });
              return $Try_1_Post();
            } catch ($boundEx) {
              return $Try_1_Catch($boundEx);
            }
          }, $Try_1_Catch);
        } catch (error) {
          $Try_1_Catch(error)
        }
      }

      function $If_2() {
        return $return();
      }

      return $If_2.call(this);
    });
  };
};

var changeSearchParams = function changeSearchParams(data) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].SET_PRO_SEARCH_PARAMS,
      payload: data
    });
  };
};

var resetPros = function resetPros() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* actionTypes */].RESET_PRO_SEARCH_PARAMS
    });
  };
};

/***/ }),

/***/ "wuZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__("2kK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__ = __webpack_require__("IuuM");


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ "wv0P":
/***/ (function(module, exports, __webpack_require__) {

!function (t, e) {
   true ? module.exports = e(__webpack_require__("CQH0")) : "function" == typeof define && define.amd ? define("PrismicJS", ["cross-fetch/polyfill"], e) : "object" == typeof exports ? exports.PrismicJS = e(require("cross-fetch/polyfill")) : t.PrismicJS = e(t["cross-fetch/polyfill"]);
}("undefined" != typeof self ? self : this, function (t) {
  return function (t) {
    var e = {};function n(r) {
      if (e[r]) return e[r].exports;var o = e[r] = { i: r, l: !1, exports: {} };return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: r });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;if (4 & e && "object" == typeof t && t && t.__esModule) return t;var r = Object.create(null);if (n.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 20);
  }([function (t, e, n) {
    "use strict";
    e.a = function (t) {
      var e = this.constructor;return this.then(function (n) {
        return e.resolve(t()).then(function () {
          return n;
        });
      }, function (n) {
        return e.resolve(t()).then(function () {
          return e.reject(n);
        });
      });
    };
  }, function (t, e) {
    var n;n = function () {
      return this;
    }();try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (n = window);
    }t.exports = n;
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = n(5),
        o = n(4),
        i = n(6),
        u = n(12);e.PREVIEW_COOKIE = "io.prismic.preview", e.EXPERIMENT_COOKIE = "io.prismic.experiment";var a = function () {
      function t(t, e, n) {
        this.data = t, this.masterRef = t.refs.filter(function (t) {
          return t.isMasterRef;
        })[0], this.experiments = new r.Experiments(t.experiments), this.bookmarks = t.bookmarks, this.httpClient = e, this.options = n, this.refs = t.refs, this.tags = t.tags, this.types = t.types;
      }return t.prototype.form = function (t) {
        var e = this.data.forms[t];return e ? new o.SearchForm(e, this.httpClient) : null;
      }, t.prototype.everything = function () {
        var t = this.form("everything");if (!t) throw new Error("Missing everything form");return t;
      }, t.prototype.master = function () {
        return this.masterRef.ref;
      }, t.prototype.ref = function (t) {
        var e = this.data.refs.filter(function (e) {
          return e.label === t;
        })[0];return e ? e.ref : null;
      }, t.prototype.currentExperiment = function () {
        return this.experiments.current();
      }, t.prototype.query = function (t, n, r) {
        void 0 === r && (r = function r() {});var o = "function" == typeof n ? { options: {}, callback: n } : { options: n || {}, callback: r },
            i = o.options,
            a = o.callback,
            s = this.everything();for (var f in i) {
          s = s.set(f, i[f]);
        }if (!i.ref) {
          var c = "";this.options.req ? c = this.options.req.headers.cookie || "" : "undefined" != typeof window && window.document && (c = window.document.cookie || "");var l = u.default.parse(c),
              h = l[e.PREVIEW_COOKIE],
              p = this.experiments.refFromCookie(l[e.EXPERIMENT_COOKIE]);s = s.ref(h || p || this.masterRef.ref);
        }return t && s.query(t), s.submit(a);
      }, t.prototype.queryFirst = function (t, e, n) {
        var r = "function" == typeof e ? { options: {}, callback: e } : { options: e || {}, callback: n || function () {} },
            o = r.options,
            i = r.callback;return o.page = 1, o.pageSize = 1, this.query(t, o).then(function (t) {
          var e = t && t.results && t.results[0];return i(null, e), e;
        }).catch(function (t) {
          throw i(t), t;
        });
      }, t.prototype.getByID = function (t, e, n) {
        var r = e || {};return r.lang || (r.lang = "*"), this.queryFirst(i.default.at("document.id", t), r, n);
      }, t.prototype.getByIDs = function (t, e, n) {
        var r = e || {};return r.lang || (r.lang = "*"), this.query(i.default.in("document.id", t), r, n);
      }, t.prototype.getByUID = function (t, e, n, r) {
        var o = n || {};return o.lang || (o.lang = "*"), this.queryFirst(i.default.at("my." + t + ".uid", e), o, r);
      }, t.prototype.getSingle = function (t, e, n) {
        var r = e || {};return this.queryFirst(i.default.at("document.type", t), r, n);
      }, t.prototype.getBookmark = function (t, e, n) {
        var r = this.data.bookmarks[t];return r ? this.getByID(r, e, n) : Promise.reject("Error retrieving bookmarked id");
      }, t.prototype.previewSession = function (t, e, n, r) {
        var o = this;return new Promise(function (i, u) {
          o.httpClient.request(t, function (a, s) {
            if (a) r && r(a), u(a);else if (s) {
              if (s.mainDocument) return o.getByID(s.mainDocument, { ref: t }).then(function (t) {
                if (t) {
                  var o = e(t);r && r(null, o), i(o);
                } else r && r(null, n), i(n);
              }).catch(u);r && r(null, n), i(n);
            }
          });
        });
      }, t;
    }();e.default = a;
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = n(2),
        o = n(11),
        i = function () {
      function t(t, e) {
        if (this.options = e || {}, this.url = t, this.options.accessToken) {
          var n = "access_token=" + this.options.accessToken;this.url += (t.indexOf("?") > -1 ? "&" : "?") + n;
        }this.apiDataTTL = this.options.apiDataTTL || 5, this.httpClient = new o.default(this.options.requestHandler, this.options.apiCache, this.options.proxyAgent);
      }return t.prototype.get = function (t) {
        var e = this;return this.httpClient.cachedRequest(this.url, { ttl: this.apiDataTTL }).then(function (n) {
          var o = new r.default(n, e.httpClient, e.options);return t && t(null, o), o;
        }).catch(function (e) {
          throw t && t(e), e;
        });
      }, t;
    }();e.default = i;
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = function () {
      function t(t, e) {
        this.id = t, this.api = e, this.fields = {};
      }return t.prototype.set = function (t, e) {
        return this.fields[t] = e, this;
      }, t.prototype.ref = function (t) {
        return this.set("ref", t);
      }, t.prototype.query = function (t) {
        return this.set("q", t);
      }, t.prototype.pageSize = function (t) {
        return this.set("pageSize", t);
      }, t.prototype.fetch = function (t) {
        return this.set("fetch", t);
      }, t.prototype.fetchLinks = function (t) {
        return this.set("fetchLinks", t);
      }, t.prototype.lang = function (t) {
        return this.set("lang", t);
      }, t.prototype.page = function (t) {
        return this.set("page", t);
      }, t.prototype.after = function (t) {
        return this.set("after", t);
      }, t.prototype.orderings = function (t) {
        return this.set("orderings", t);
      }, t.prototype.url = function () {
        var e = this;return this.api.get().then(function (n) {
          return t.toSearchForm(e, n).url();
        });
      }, t.prototype.submit = function (e) {
        var n = this;return this.api.get().then(function (r) {
          return t.toSearchForm(n, r).submit(e);
        });
      }, t.toSearchForm = function (t, e) {
        var n = e.form(t.id);if (n) return Object.keys(t.fields).reduce(function (e, n) {
          var r = t.fields[n];return "q" === n ? e.query(r) : "pageSize" === n ? e.pageSize(r) : "fetch" === n ? e.fetch(r) : "fetchLinks" === n ? e.fetchLinks(r) : "lang" === n ? e.lang(r) : "page" === n ? e.page(r) : "after" === n ? e.after(r) : "orderings" === n ? e.orderings(r) : e.set(n, r);
        }, n);throw new Error("Unable to access to form " + t.id);
      }, t;
    }();e.LazySearchForm = r;var o = function () {
      function t(t, e) {
        for (var n in this.httpClient = e, this.form = t, this.data = {}, t.fields) {
          t.fields[n].default && (this.data[n] = [t.fields[n].default]);
        }
      }return t.prototype.set = function (t, e) {
        var n = this.form.fields[t];if (!n) throw new Error("Unknown field " + t);var r = "" === e || void 0 === e ? null : e,
            o = this.data[t] || [];return o = n.multiple ? r ? o.concat([r]) : o : r ? [r] : o, this.data[t] = o, this;
      }, t.prototype.ref = function (t) {
        return this.set("ref", t);
      }, t.prototype.query = function (t) {
        if ("string" == typeof t) return this.query([t]);if (t instanceof Array) return this.set("q", "[" + t.join("") + "]");throw new Error("Invalid query : " + t);
      }, t.prototype.pageSize = function (t) {
        return this.set("pageSize", t);
      }, t.prototype.fetch = function (t) {
        var e = t instanceof Array ? t.join(",") : t;return this.set("fetch", e);
      }, t.prototype.fetchLinks = function (t) {
        var e = t instanceof Array ? t.join(",") : t;return this.set("fetchLinks", e);
      }, t.prototype.lang = function (t) {
        return this.set("lang", t);
      }, t.prototype.page = function (t) {
        return this.set("page", t);
      }, t.prototype.after = function (t) {
        return this.set("after", t);
      }, t.prototype.orderings = function (t) {
        return t ? this.set("orderings", "[" + t.join(",") + "]") : this;
      }, t.prototype.url = function () {
        var t = this.form.action;if (this.data) {
          var e = t.indexOf("?") > -1 ? "&" : "?";for (var n in this.data) {
            if (this.data.hasOwnProperty(n)) {
              var r = this.data[n];if (r) for (var o = 0; o < r.length; o++) {
                t += e + n + "=" + encodeURIComponent(r[o]), e = "&";
              }
            }
          }
        }return t;
      }, t.prototype.submit = function (t) {
        return this.httpClient.cachedRequest(this.url()).then(function (e) {
          return t && t(null, e), e;
        }).catch(function (e) {
          throw t && t(e), e;
        });
      }, t;
    }();e.SearchForm = o;
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = function () {
      function t(t) {
        this.data = {}, this.data = t;
      }return t.prototype.id = function () {
        return this.data.id;
      }, t.prototype.ref = function () {
        return this.data.ref;
      }, t.prototype.label = function () {
        return this.data.label;
      }, t;
    }();e.Variation = r;var o = function () {
      function t(t) {
        this.data = {}, this.data = t, this.variations = (t.variations || []).map(function (t) {
          return new r(t);
        });
      }return t.prototype.id = function () {
        return this.data.id;
      }, t.prototype.googleId = function () {
        return this.data.googleId;
      }, t.prototype.name = function () {
        return this.data.name;
      }, t;
    }();e.Experiment = o;var i = function () {
      function t(t) {
        t && (this.drafts = (t.drafts || []).map(function (t) {
          return new o(t);
        }), this.running = (t.running || []).map(function (t) {
          return new o(t);
        }));
      }return t.prototype.current = function () {
        return this.running.length > 0 ? this.running[0] : null;
      }, t.prototype.refFromCookie = function (t) {
        if (!t || "" === t.trim()) return null;var e = t.trim().split(" ");if (e.length < 2) return null;var n = e[0],
            r = parseInt(e[1], 10),
            o = this.running.filter(function (t) {
          return t.googleId() === n && t.variations.length > r;
        })[0];return o ? o.variations[r].ref() : null;
      }, t;
    }();e.Experiments = i;
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = "at",
        o = "not",
        i = "missing",
        u = "has",
        a = "any",
        s = "in",
        f = "fulltext",
        c = "similar",
        l = "number.gt",
        h = "number.lt",
        p = "number.inRange",
        d = "date.before",
        y = "date.after",
        m = "date.between",
        v = "date.day-of-month",
        g = "date.day-of-month-after",
        w = "date.day-of-month-before",
        _ = "date.day-of-week",
        b = "date.day-of-week-after",
        k = "date.day-of-week-before",
        T = "date.month",
        I = "date.month-before",
        E = "date.month-after",
        O = "date.year",
        x = "date.hour",
        A = "date.hour-before",
        M = "date.hour-after",
        j = "geopoint.near";function q(t) {
      if ("string" == typeof t) return '"' + t + '"';if ("number" == typeof t) return t.toString();if (t instanceof Date) return t.getTime().toString();if (t instanceof Array) return "[" + t.map(function (t) {
        return q(t);
      }).join(",") + "]";throw new Error("Unable to encode " + t + " of type " + typeof t);
    }var S = { near: function near(t, e, n, r) {
        return "[" + j + "(" + t + ", " + e + ", " + n + ", " + r + ")]";
      } },
        C = { before: function before(t, e) {
        return "[" + d + "(" + t + ", " + q(e) + ")]";
      }, after: function after(t, e) {
        return "[" + y + "(" + t + ", " + q(e) + ")]";
      }, between: function between(t, e, n) {
        return "[" + m + "(" + t + ", " + q(e) + ", " + q(n) + ")]";
      }, dayOfMonth: function dayOfMonth(t, e) {
        return "[" + v + "(" + t + ", " + e + ")]";
      }, dayOfMonthAfter: function dayOfMonthAfter(t, e) {
        return "[" + g + "(" + t + ", " + e + ")]";
      }, dayOfMonthBefore: function dayOfMonthBefore(t, e) {
        return "[" + w + "(" + t + ", " + e + ")]";
      }, dayOfWeek: function dayOfWeek(t, e) {
        return "[" + _ + "(" + t + ", " + q(e) + ")]";
      }, dayOfWeekAfter: function dayOfWeekAfter(t, e) {
        return "[" + b + "(" + t + ", " + q(e) + ")]";
      }, dayOfWeekBefore: function dayOfWeekBefore(t, e) {
        return "[" + k + "(" + t + ", " + q(e) + ")]";
      }, month: function month(t, e) {
        return "[" + T + "(" + t + ", " + q(e) + ")]";
      }, monthBefore: function monthBefore(t, e) {
        return "[" + I + "(" + t + ", " + q(e) + ")]";
      }, monthAfter: function monthAfter(t, e) {
        return "[" + E + "(" + t + ", " + q(e) + ")]";
      }, year: function year(t, e) {
        return "[" + O + "(" + t + ", " + e + ")]";
      }, hour: function hour(t, e) {
        return "[" + x + "(" + t + ", " + e + ")]";
      }, hourBefore: function hourBefore(t, e) {
        return "[" + A + "(" + t + ", " + e + ")]";
      }, hourAfter: function hourAfter(t, e) {
        return "[" + M + "(" + t + ", " + e + ")]";
      } },
        P = { gt: function gt(t, e) {
        return "[" + l + "(" + t + ", " + e + ")]";
      }, lt: function lt(t, e) {
        return "[" + h + "(" + t + ", " + e + ")]";
      }, inRange: function inRange(t, e, n) {
        return "[" + p + "(" + t + ", " + e + ", " + n + ")]";
      } };e.default = { at: function at(t, e) {
        return "[" + r + "(" + t + ", " + q(e) + ")]";
      }, not: function not(t, e) {
        return "[" + o + "(" + t + ", " + q(e) + ")]";
      }, missing: function missing(t) {
        return "[" + i + "(" + t + ")]";
      }, has: function has(t) {
        return "[" + u + "(" + t + ")]";
      }, any: function any(t, e) {
        return "[" + a + "(" + t + ", " + q(e) + ")]";
      }, in: function _in(t, e) {
        return "[" + s + "(" + t + ", " + q(e) + ")]";
      }, fulltext: function fulltext(t, e) {
        return "[" + f + "(" + t + ", " + q(e) + ")]";
      }, similar: function similar(t, e) {
        return "[" + c + '("' + t + '", ' + e + ")]";
      }, date: C, dateBefore: C.before, dateAfter: C.after, dateBetween: C.between, dayOfMonth: C.dayOfMonth, dayOfMonthAfter: C.dayOfMonthAfter, dayOfMonthBefore: C.dayOfMonthBefore, dayOfWeek: C.dayOfWeek, dayOfWeekAfter: C.dayOfWeekAfter, dayOfWeekBefore: C.dayOfWeekBefore, month: C.month, monthBefore: C.monthBefore, monthAfter: C.monthAfter, year: C.year, hour: C.hour, hourBefore: C.hourBefore, hourAfter: C.hourAfter, number: P, gt: P.gt, lt: P.lt, inRange: P.inRange, near: S.near, geopoint: S };
  }, function (t, e, n) {
    "use strict";
    (function (t) {
      var r = n(0),
          o = setTimeout;function i() {}function u(t) {
        if (!(this instanceof u)) throw new TypeError("Promises must be constructed via new");if ("function" != typeof t) throw new TypeError("not a function");this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], l(t, this);
      }function a(t, e) {
        for (; 3 === t._state;) {
          t = t._value;
        }0 !== t._state ? (t._handled = !0, u._immediateFn(function () {
          var n = 1 === t._state ? e.onFulfilled : e.onRejected;if (null !== n) {
            var r;try {
              r = n(t._value);
            } catch (t) {
              return void f(e.promise, t);
            }s(e.promise, r);
          } else (1 === t._state ? s : f)(e.promise, t._value);
        })) : t._deferreds.push(e);
      }function s(t, e) {
        try {
          if (e === t) throw new TypeError("A promise cannot be resolved with itself.");if (e && ("object" == typeof e || "function" == typeof e)) {
            var n = e.then;if (e instanceof u) return t._state = 3, t._value = e, void c(t);if ("function" == typeof n) return void l(function (t, e) {
              return function () {
                t.apply(e, arguments);
              };
            }(n, e), t);
          }t._state = 1, t._value = e, c(t);
        } catch (e) {
          f(t, e);
        }
      }function f(t, e) {
        t._state = 2, t._value = e, c(t);
      }function c(t) {
        2 === t._state && 0 === t._deferreds.length && u._immediateFn(function () {
          t._handled || u._unhandledRejectionFn(t._value);
        });for (var e = 0, n = t._deferreds.length; e < n; e++) {
          a(t, t._deferreds[e]);
        }t._deferreds = null;
      }function l(t, e) {
        var n = !1;try {
          t(function (t) {
            n || (n = !0, s(e, t));
          }, function (t) {
            n || (n = !0, f(e, t));
          });
        } catch (t) {
          if (n) return;n = !0, f(e, t);
        }
      }u.prototype.catch = function (t) {
        return this.then(null, t);
      }, u.prototype.then = function (t, e) {
        var n = new this.constructor(i);return a(this, new function (t, e, n) {
          this.onFulfilled = "function" == typeof t ? t : null, this.onRejected = "function" == typeof e ? e : null, this.promise = n;
        }(t, e, n)), n;
      }, u.prototype.finally = r.a, u.all = function (t) {
        return new u(function (e, n) {
          if (!t || void 0 === t.length) throw new TypeError("Promise.all accepts an array");var r = Array.prototype.slice.call(t);if (0 === r.length) return e([]);var o = r.length;function i(t, u) {
            try {
              if (u && ("object" == typeof u || "function" == typeof u)) {
                var a = u.then;if ("function" == typeof a) return void a.call(u, function (e) {
                  i(t, e);
                }, n);
              }r[t] = u, 0 == --o && e(r);
            } catch (t) {
              n(t);
            }
          }for (var u = 0; u < r.length; u++) {
            i(u, r[u]);
          }
        });
      }, u.resolve = function (t) {
        return t && "object" == typeof t && t.constructor === u ? t : new u(function (e) {
          e(t);
        });
      }, u.reject = function (t) {
        return new u(function (e, n) {
          n(t);
        });
      }, u.race = function (t) {
        return new u(function (e, n) {
          for (var r = 0, o = t.length; r < o; r++) {
            t[r].then(e, n);
          }
        });
      }, u._immediateFn = "function" == typeof t && function (e) {
        t(e);
      } || function (t) {
        o(t, 0);
      }, u._unhandledRejectionFn = function (t) {
        "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", t);
      }, e.a = u;
    }).call(this, n(18).setImmediate);
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = 20,
        o = 0,
        i = [];function u(t) {
      if (i.length > 0 && o < r) {
        o++;var e = i.shift();e && function (t, e, n) {
          var r = { headers: { Accept: "application/json" } };e && e.proxyAgent && (r.agent = e.proxyAgent), fetch(t, r).then(function (e) {
            return ~~(e.status / 100 != 2) ? e.text().then(function () {
              var n = new Error("Unexpected status code [" + e.status + "] on URL " + t);throw n.status = e.status, n;
            }) : e.json().then(function (t) {
              var r = e.headers.get("cache-control"),
                  o = r ? /max-age=(\d+)/.exec(r) : null,
                  i = o ? parseInt(o[1], 10) : void 0;n(null, t, e, i);
            });
          }).catch(n);
        }(e.url, t, function (n, r, i, a) {
          o--, e.callback(n, r, i, a), u(t);
        });
      }
    }var a = function () {
      function t(t) {
        this.options = t || {};
      }return t.prototype.request = function (t, e) {
        i.push({ url: t, callback: e }), u(this.options);
      }, t;
    }();e.DefaultRequestHandler = a;
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      this.size = 0, this.limit = t, this._keymap = {};
    }e.__esModule = !0, e.MakeLRUCache = function (t) {
      return new r(t);
    }, r.prototype.put = function (t, e) {
      var n = { key: t, value: e };if (this._keymap[t] = n, this.tail ? (this.tail.newer = n, n.older = this.tail) : this.head = n, this.tail = n, this.size === this.limit) return this.shift();this.size++;
    }, r.prototype.shift = function () {
      var t = this.head;return t && (this.head.newer ? (this.head = this.head.newer, this.head.older = void 0) : this.head = void 0, t.newer = t.older = void 0, delete this._keymap[t.key]), console.log("purging ", t.key), t;
    }, r.prototype.get = function (t, e) {
      var n = this._keymap[t];if (void 0 !== n) return n === this.tail ? e ? n : n.value : (n.newer && (n === this.head && (this.head = n.newer), n.newer.older = n.older), n.older && (n.older.newer = n.newer), n.newer = void 0, n.older = this.tail, this.tail && (this.tail.newer = n), this.tail = n, e ? n : n.value);
    }, r.prototype.find = function (t) {
      return this._keymap[t];
    }, r.prototype.set = function (t, e) {
      var n,
          r = this.get(t, !0);return r ? (n = r.value, r.value = e) : (n = this.put(t, e)) && (n = n.value), n;
    }, r.prototype.remove = function (t) {
      var e = this._keymap[t];if (e) return delete this._keymap[e.key], e.newer && e.older ? (e.older.newer = e.newer, e.newer.older = e.older) : e.newer ? (e.newer.older = void 0, this.head = e.newer) : e.older ? (e.older.newer = void 0, this.tail = e.older) : this.head = this.tail = void 0, this.size--, e.value;
    }, r.prototype.removeAll = function () {
      this.head = this.tail = void 0, this.size = 0, this._keymap = {};
    }, "function" == typeof Object.keys ? r.prototype.keys = function () {
      return Object.keys(this._keymap);
    } : r.prototype.keys = function () {
      var t = [];for (var e in this._keymap) {
        t.push(e);
      }return t;
    }, r.prototype.forEach = function (t, e, n) {
      var r;if (!0 === e ? (n = !0, e = void 0) : "object" != typeof e && (e = this), n) for (r = this.tail; r;) {
        t.call(e, r.key, r.value, this), r = r.older;
      } else for (r = this.head; r;) {
        t.call(e, r.key, r.value, this), r = r.newer;
      }
    }, r.prototype.toString = function () {
      for (var t = "", e = this.head; e;) {
        t += String(e.key) + ":" + e.value, (e = e.newer) && (t += " < ");
      }return t;
    };
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = n(9),
        o = function () {
      function t(t) {
        void 0 === t && (t = 1e3), this.lru = r.MakeLRUCache(t);
      }return t.prototype.isExpired = function (t) {
        var e = this.lru.get(t, !1);return !!e && 0 !== e.expiredIn && e.expiredIn < Date.now();
      }, t.prototype.get = function (t, e) {
        var n = this.lru.get(t, !1);n && !this.isExpired(t) ? e(null, n.data) : e && e(null);
      }, t.prototype.set = function (t, e, n, r) {
        this.lru.remove(t), this.lru.put(t, { data: e, expiredIn: n ? Date.now() + 1e3 * n : 0 }), r && r(null);
      }, t.prototype.remove = function (t, e) {
        this.lru.remove(t), e && e(null);
      }, t.prototype.clear = function (t) {
        this.lru.removeAll(), t && t(null);
      }, t;
    }();e.DefaultApiCache = o;
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = n(10),
        o = n(8),
        i = function () {
      function t(t, e, n) {
        this.requestHandler = t || new o.DefaultRequestHandler({ proxyAgent: n }), this.cache = e || new r.DefaultApiCache();
      }return t.prototype.request = function (t, e) {
        this.requestHandler.request(t, function (t, n, r, o) {
          t ? e && e(t, null, r, o) : n && e && e(null, n, r, o);
        });
      }, t.prototype.cachedRequest = function (t, e) {
        var n = this,
            r = e || {};return new Promise(function (e, o) {
          !function (e) {
            var o = r.cacheKey || t;n.cache.get(o, function (i, u) {
              i || u ? e(i, u) : n.request(t, function (t, i, u, a) {
                if (t) e(t, null);else {
                  var s = a || r.ttl;s && n.cache.set(o, i, s, e), e(null, i);
                }
              });
            });
          }(function (t, n) {
            t && o(t), n && e(n);
          });
        });
      }, t;
    }();e.default = i;
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = decodeURIComponent;e.default = { parse: function parse(t, e) {
        if ("string" != typeof t) throw new TypeError("argument str must be a string");var n = {},
            o = e || {},
            i = t.split(/; */),
            u = o.decode || r;return i.forEach(function (t) {
          var e = t.indexOf("=");if (!(e < 0)) {
            var r = t.substr(0, e).trim(),
                o = t.substr(++e, t.length).trim();'"' == o[0] && (o = o.slice(1, -1)), void 0 == n[r] && (n[r] = function (t, e) {
              try {
                return e(t);
              } catch (e) {
                return t;
              }
            }(o, u));
          }
        }), n;
      } };
  }, function (t, e, n) {
    "use strict";
    e.__esModule = !0;var r = n(4),
        o = n(3),
        i = function () {
      function t(t, e) {
        this.api = new o.default(t, e);
      }return t.prototype.getApi = function () {
        return this.api.get();
      }, t.prototype.everything = function () {
        return this.form("everything");
      }, t.prototype.form = function (t) {
        return new r.LazySearchForm(t, this.api);
      }, t.prototype.query = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.query(t, e, n);
        });
      }, t.prototype.queryFirst = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.queryFirst(t, e, n);
        });
      }, t.prototype.getByID = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.getByID(t, e, n);
        });
      }, t.prototype.getByIDs = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.getByIDs(t, e, n);
        });
      }, t.prototype.getByUID = function (t, e, n, r) {
        return this.getApi().then(function (o) {
          return o.getByUID(t, e, n, r);
        });
      }, t.prototype.getSingle = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.getSingle(t, e, n);
        });
      }, t.prototype.getBookmark = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.getBookmark(t, e, n);
        });
      }, t.prototype.previewSession = function (t, e, n, r) {
        return this.getApi().then(function (o) {
          return o.previewSession(t, e, n, r);
        });
      }, t.getApi = function (t, e) {
        return new o.default(t, e).get();
      }, t;
    }();e.DefaultClient = i;
  }, function (t, e, n) {
    "use strict";
    var r,
        o = n(6),
        i = n(5),
        u = n(13),
        a = n(3),
        s = n(2);!function (t) {
      function e(t, e) {
        return u.DefaultClient.getApi(t, e);
      }t.experimentCookie = s.EXPERIMENT_COOKIE, t.previewCookie = s.PREVIEW_COOKIE, t.Predicates = o.default, t.Experiments = i.Experiments, t.Api = a.default, t.client = function (t, e) {
        return new u.DefaultClient(t, e);
      }, t.getApi = e, t.api = function (t, n) {
        return e(t, n);
      };
    }(r || (r = {})), t.exports = r;
  }, function (e, n) {
    e.exports = t;
  }, function (t, e) {
    var n,
        r,
        o = t.exports = {};function i() {
      throw new Error("setTimeout has not been defined");
    }function u() {
      throw new Error("clearTimeout has not been defined");
    }function a(t) {
      if (n === setTimeout) return setTimeout(t, 0);if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }!function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i;
      } catch (t) {
        n = i;
      }try {
        r = "function" == typeof clearTimeout ? clearTimeout : u;
      } catch (t) {
        r = u;
      }
    }();var s,
        f = [],
        c = !1,
        l = -1;function h() {
      c && s && (c = !1, s.length ? f = s.concat(f) : l = -1, f.length && p());
    }function p() {
      if (!c) {
        var t = a(h);c = !0;for (var e = f.length; e;) {
          for (s = f, f = []; ++l < e;) {
            s && s[l].run();
          }l = -1, e = f.length;
        }s = null, c = !1, function (t) {
          if (r === clearTimeout) return clearTimeout(t);if ((r === u || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);try {
            r(t);
          } catch (e) {
            try {
              return r.call(null, t);
            } catch (e) {
              return r.call(this, t);
            }
          }
        }(t);
      }
    }function d(t, e) {
      this.fun = t, this.array = e;
    }function y() {}o.nextTick = function (t) {
      var e = new Array(arguments.length - 1);if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }f.push(new d(t, e)), 1 !== f.length || c || a(p);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = y, o.addListener = y, o.once = y, o.off = y, o.removeListener = y, o.removeAllListeners = y, o.emit = y, o.prependListener = y, o.prependOnceListener = y, o.listeners = function (t) {
      return [];
    }, o.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    (function (t, e) {
      !function (t, n) {
        "use strict";
        if (!t.setImmediate) {
          var r,
              o = 1,
              i = {},
              u = !1,
              a = t.document,
              s = Object.getPrototypeOf && Object.getPrototypeOf(t);s = s && s.setTimeout ? s : t, "[object process]" === {}.toString.call(t.process) ? r = function r(t) {
            e.nextTick(function () {
              c(t);
            });
          } : function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  n = t.onmessage;return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = n, e;
            }
          }() ? function () {
            var e = "setImmediate$" + Math.random() + "$",
                n = function n(_n) {
              _n.source === t && "string" == typeof _n.data && 0 === _n.data.indexOf(e) && c(+_n.data.slice(e.length));
            };t.addEventListener ? t.addEventListener("message", n, !1) : t.attachEvent("onmessage", n), r = function r(n) {
              t.postMessage(e + n, "*");
            };
          }() : t.MessageChannel ? function () {
            var t = new MessageChannel();t.port1.onmessage = function (t) {
              c(t.data);
            }, r = function r(e) {
              t.port2.postMessage(e);
            };
          }() : a && "onreadystatechange" in a.createElement("script") ? function () {
            var t = a.documentElement;r = function r(e) {
              var n = a.createElement("script");n.onreadystatechange = function () {
                c(e), n.onreadystatechange = null, t.removeChild(n), n = null;
              }, t.appendChild(n);
            };
          }() : r = function r(t) {
            setTimeout(c, 0, t);
          }, s.setImmediate = function (t) {
            "function" != typeof t && (t = new Function("" + t));for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) {
              e[n] = arguments[n + 1];
            }var u = { callback: t, args: e };return i[o] = u, r(o), o++;
          }, s.clearImmediate = f;
        }function f(t) {
          delete i[t];
        }function c(t) {
          if (u) setTimeout(c, 0, t);else {
            var e = i[t];if (e) {
              u = !0;try {
                !function (t) {
                  var e = t.callback,
                      r = t.args;switch (r.length) {case 0:
                      e();break;case 1:
                      e(r[0]);break;case 2:
                      e(r[0], r[1]);break;case 3:
                      e(r[0], r[1], r[2]);break;default:
                      e.apply(n, r);}
                }(e);
              } finally {
                f(t), u = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(this, n(1), n(16));
  }, function (t, e, n) {
    (function (t) {
      var r = void 0 !== t && t || "undefined" != typeof self && self || window,
          o = Function.prototype.apply;function i(t, e) {
        this._id = t, this._clearFn = e;
      }e.setTimeout = function () {
        return new i(o.call(setTimeout, r, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new i(o.call(setInterval, r, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
        this._clearFn.call(r, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);var e = t._idleTimeout;e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, n(17), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(this, n(1));
  }, function (t, e, n) {
    "use strict";
    n.r(e), function (t) {
      var e = n(7),
          r = n(0),
          o = function () {
        if ("undefined" != typeof self) return self;if ("undefined" != typeof window) return window;if (void 0 !== t) return t;throw new Error("unable to locate global object");
      }();o.Promise ? o.Promise.prototype.finally || (o.Promise.prototype.finally = r.a) : o.Promise = e.a;
    }.call(this, n(1));
  }, function (t, e, n) {
    n(19), n(15), t.exports = n(14);
  }]);
});

/***/ }),

/***/ "x6RK":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("0guB");
var getMethod = __webpack_require__("YeOI");
var Iterators = __webpack_require__("25e4");
var wellKnownSymbol = __webpack_require__("G69i");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
};

/***/ }),

/***/ "xC+t":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");
var hasOwn = __webpack_require__("J3pj");
var toIndexedObject = __webpack_require__("M0Be");
var indexOf = __webpack_require__("cyQs").indexOf;
var hiddenKeys = __webpack_require__("Psxq");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (hasOwn(O, key = names[i++])) {
      ~indexOf(result, key) || push(result, key);
    }
  }return result;
};

/***/ }),

/***/ "xE50":
/***/ (function(module, exports) {

module.exports = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

/***/ }),

/***/ "xNmf":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.2
(function () {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(this);

//# sourceMappingURL=performance-now.js.map

/***/ }),

/***/ "xToX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /** @jsx h */

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        // preact-compat normally does this
        var children = nextProps.children,
            props = _objectWithoutProperties(nextProps, ['children']);

        if (children && children.length) props.children = children;
        return shallowDiffers(props, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return (0, _preact.h)(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_preact.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

    return SideEffect;
  };

  // Pulled from react-compat
  function shallowDiffers(a, b) {
    for (var i in a) {
      if (!(i in b)) return true;
    }for (var _i in b) {
      if (a[_i] !== b[_i]) return true;
    }return false;
  }
};

/***/ }),

/***/ "xqvi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("T4f3");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("zCAL");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__("KQdW");

var _transitions2 = _interopRequireDefault(_transitions);

var _ClickAwayListener = __webpack_require__("71YK");

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _SnackbarBody = __webpack_require__("UCMn");

var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
      zIndex = _context$muiTheme.zIndex;
  var open = state.open;

  var styles = {
    root: {
      position: 'fixed',
      left: '50%',
      display: 'flex',
      bottom: 0,
      zIndex: zIndex.snackbar,
      visibility: open ? 'visible' : 'hidden',
      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
    }
  };

  return styles;
}

var Snackbar = function (_Component) {
  (0, _inherits3.default)(Snackbar, _Component);

  function Snackbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
      if (_this.timerTransitionId) {
        // If transitioning, don't close the snackbar.
        return;
      }

      if (_this.props.open !== null && _this.props.onRequestClose) {
        _this.props.onRequestClose(Snackbar.reasons.CLICKAWAY);
      } else {
        _this.setState({ open: false });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Snackbar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        open: this.props.open,
        message: this.props.message,
        action: this.props.action
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.open) {
        this.setAutoHideTimer();
        this.setTransitionTimer();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
        this.setState({
          open: false
        });

        clearTimeout(this.timerOneAtTheTimeId);
        this.timerOneAtTheTimeId = setTimeout(function () {
          _this2.setState({
            message: nextProps.message,
            action: nextProps.action,
            open: true
          });
        }, 400);
      } else {
        var open = nextProps.open;

        this.setState({
          open: open !== null ? open : this.state.open,
          message: nextProps.message,
          action: nextProps.action
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.open !== this.state.open) {
        if (this.state.open) {
          this.setAutoHideTimer();
          this.setTransitionTimer();
        } else {
          clearTimeout(this.timerAutoHideId);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHideId);
      clearTimeout(this.timerTransitionId);
      clearTimeout(this.timerOneAtTheTimeId);
    }
  }, {
    key: 'setAutoHideTimer',

    // Timer that controls delay before snackbar auto hides
    value: function setAutoHideTimer() {
      var _this3 = this;

      var autoHideDuration = this.props.autoHideDuration;

      if (autoHideDuration > 0) {
        clearTimeout(this.timerAutoHideId);
        this.timerAutoHideId = setTimeout(function () {
          if (_this3.props.open !== null && _this3.props.onRequestClose) {
            _this3.props.onRequestClose(Snackbar.reasons.TIMEOUT);
          } else {
            _this3.setState({ open: false });
          }
        }, autoHideDuration);
      }
    }

    // Timer that controls delay before click-away events are captured (based on when animation completes)

  }, {
    key: 'setTransitionTimer',
    value: function setTransitionTimer() {
      var _this4 = this;

      this.timerTransitionId = setTimeout(function () {
        _this4.timerTransitionId = undefined;
      }, 400);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoHideDuration = _props.autoHideDuration,
          contentStyle = _props.contentStyle,
          bodyStyle = _props.bodyStyle,
          messageProp = _props.message,
          onRequestClose = _props.onRequestClose,
          onActionClick = _props.onActionClick,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionClick', 'style']);
      var _state = this.state,
          action = _state.action,
          message = _state.message,
          open = _state.open;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(_ClickAwayListener2.default, { onClickAway: open ? this.componentClickAway : null }, _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }), _react2.default.createElement(_SnackbarBody2.default, {
        action: action,
        contentStyle: contentStyle,
        message: message,
        open: open,
        onActionClick: onActionClick,
        style: bodyStyle
      })));
    }
  }]);
  return Snackbar;
}(_react.Component);

Snackbar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Snackbar.reasons = {
  CLICKAWAY: 'clickaway',
  TIMEOUT: 'timeout'
};
Snackbar.propTypes =  false ? {
  /**
   * The label for the action on the snackbar.
   */
  action: _propTypes2.default.node,
  /**
   * The number of milliseconds to wait before automatically dismissing.
   * If no value is specified the snackbar will dismiss normally.
   * If a value is provided the snackbar can still be dismissed normally.
   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
   */
  autoHideDuration: _propTypes2.default.number,
  /**
   * Override the inline-styles of the body element.
   */
  bodyStyle: _propTypes2.default.object,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the content element.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _propTypes2.default.node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _propTypes2.default.func,
  /**
   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
   * `autoHideDuration` timer expires.
   *
   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
   * `open` prop.
   *
   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
   * for example ignoring `clickaway`.
   *
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Snackbar;

/***/ }),

/***/ "xwD+":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),

/***/ "y+zt":
/***/ (function(module, exports, __webpack_require__) {

var toIntIfInt = function toIntIfInt(v) {
  return String(Number(v)) === v ? Number(v) : v;
};

var attachProperties = function attachProperties(match, location, names, rawName) {
  if (rawName && !names) {
    location[rawName] = toIntIfInt(match[1]);
  } else {
    for (var i = 0; i < names.length; i += 1) {
      if (match[i + 1] != null) {
        location[names[i]] = toIntIfInt(match[i + 1]);
      }
    }
  }
};

var parseReg = function parseReg(obj, location, content) {
  var needsBlank = obj.name && obj.names;
  if (obj.push && !location[obj.push]) {
    location[obj.push] = [];
  } else if (needsBlank && !location[obj.name]) {
    location[obj.name] = {};
  }
  var keyLocation = obj.push ? {} : // blank object that will be pushed
  needsBlank ? location[obj.name] : location; // otherwise, named location or root

  attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);

  if (obj.push) {
    location[obj.push].push(keyLocation);
  }
};

var grammar = __webpack_require__("F2TU");
var validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);

exports.parse = function (sdp) {
  var session = {},
      media = [],
      location = session; // points at where properties go under (one of the above)

  // parse lines we understand
  sdp.split(/(\r\n|\r|\n)/).filter(validLine).forEach(function (l) {
    var type = l[0];
    var content = l.slice(2);
    if (type === 'm') {
      media.push({ rtp: [], fmtp: [] });
      location = media[media.length - 1]; // point at latest media line
    }

    for (var j = 0; j < (grammar[type] || []).length; j += 1) {
      var obj = grammar[type][j];
      if (obj.reg.test(content)) {
        return parseReg(obj, location, content);
      }
    }
  });

  session.media = media; // link it up
  return session;
};

var fmtpReducer = function fmtpReducer(acc, expr) {
  var s = expr.split('=');
  if (s.length === 2) {
    acc[s[0]] = toIntIfInt(s[1]);
  }
  return acc;
};

exports.parseFmtpConfig = function (str) {
  return str.split(/\;\s?/).reduce(fmtpReducer, {});
};

exports.parsePayloads = function (str) {
  return str.split(' ').map(Number);
};

exports.parseRemoteCandidates = function (str) {
  var candidates = [];
  var parts = str.split(' ').map(toIntIfInt);
  for (var i = 0; i < parts.length; i += 3) {
    candidates.push({
      component: parts[i],
      ip: parts[i + 1],
      port: parts[i + 2]
    });
  }
  return candidates;
};

/***/ }),

/***/ "y5eN":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("WMuu");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);

/***/ }),

/***/ "y7Dx":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("IJ/8");
var DESCRIPTORS = __webpack_require__("RA6A");
var IE8_DOM_DEFINE = __webpack_require__("DSHT");
var anObject = __webpack_require__("1kal");
var toPropertyKey = __webpack_require__("D38D");

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "y8+K":
/***/ (function(module, exports) {

// Does nothing at all.

/***/ }),

/***/ "y9Ox":
/***/ (function(module, exports, __webpack_require__) {

/* Copyright @ 2015 Atlassian Pty Ltd
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.Interop = __webpack_require__("0Ucg");

/***/ }),

/***/ "y9YS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("58Ti");
var GetIntrinsic = __webpack_require__("LiLl");

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(func, 'length', { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) });
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

/***/ }),

/***/ "yB2/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("7CVk");
var DOMIterables = __webpack_require__("Y+87");
var global = __webpack_require__("IJ/8");
var classof = __webpack_require__("0guB");
var createNonEnumerableProperty = __webpack_require__("yNEm");
var Iterators = __webpack_require__("25e4");
var wellKnownSymbol = __webpack_require__("G69i");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }
  Iterators[COLLECTION_NAME] = Iterators.Array;
}

/***/ }),

/***/ "yJBJ":
/***/ (function(module, exports, __webpack_require__) {

/*
 * (C) Copyright 2014-2015 Kurento (http://kurento.org/)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var freeice = __webpack_require__("uiRb");
var inherits = __webpack_require__("4Bm0");
var UAParser = __webpack_require__("noDf");
var uuid = __webpack_require__("g7MH");
var hark = __webpack_require__("WQDn");

var EventEmitter = __webpack_require__("T2os").EventEmitter;
var recursive = __webpack_require__("oSON").recursive.bind(undefined, true);
var sdpTranslator = __webpack_require__("y9Ox");
var logger = window.Logger || console;
// var gUM = navigator.mediaDevices.getUserMedia || function (constraints) {
//   return new Promise(navigator.getUserMedia(constraints, function (stream) {
//     videoStream = stream
//     start()
//   }).eror(callback));
// }

try {
  __webpack_require__("y8+K");
} catch (error) {
  if (typeof getScreenConstraints === 'undefined') {
    logger.warn('screen sharing is not available');

    getScreenConstraints = function getScreenConstraints(sendSource, callback) {
      callback(new Error("This library is not enabled for screen sharing"));
    };
  }
}

var MEDIA_CONSTRAINTS = {
  audio: true,
  video: {
    width: 640,
    framerate: 15
  }

  // Somehow, the UAParser constructor gets an empty window object.
  // We need to pass the user agent string in order to get information
};var ua = window && window.navigator ? window.navigator.userAgent : '';
var parser = new UAParser(ua);
var browser = parser.getBrowser();

var usePlanB = false;
if (browser.name === 'Chrome' || browser.name === 'Chromium') {
  logger.debug(browser.name + ": using SDP PlanB");
  usePlanB = true;
}

function noop(error) {
  if (error) logger.error(error);
}

function trackStop(track) {
  track.stop && track.stop();
}

function streamStop(stream) {
  stream.getTracks().forEach(trackStop);
}

/**
 * Returns a string representation of a SessionDescription object.
 */
var dumpSDP = function dumpSDP(description) {
  if (typeof description === 'undefined' || description === null) {
    return '';
  }

  return 'type: ' + description.type + '\r\n' + description.sdp;
};

function bufferizeCandidates(pc, onerror) {
  var candidatesQueue = [];

  pc.addEventListener('signalingstatechange', function () {
    if (this.signalingState === 'stable') {
      while (candidatesQueue.length) {
        var entry = candidatesQueue.shift();
        pc.addIceCandidate(entry.candidate, entry.callback, entry.callback);
      }
    }
  });

  return function (candidate, callback) {
    callback = callback || onerror;

    switch (pc.signalingState) {
      case 'closed':
        callback(new Error('PeerConnection object is closed'));
        break;
      case 'stable':
        if (pc.remoteDescription) {
          pc.addIceCandidate(candidate, callback, callback);
          break;
        }
      default:
        candidatesQueue.push({
          candidate: candidate,
          callback: callback
        });
    }
  };
}

/* Simulcast utilities */

function removeFIDFromOffer(sdp) {
  var n = sdp.indexOf("a=ssrc-group:FID");

  if (n > 0) {
    return sdp.slice(0, n);
  } else {
    return sdp;
  }
}

function getSimulcastInfo(videoStream) {
  var videoTracks = videoStream.getVideoTracks();
  if (!videoTracks.length) {
    logger.warn('No video tracks available in the video stream');
    return '';
  }
  var lines = ['a=x-google-flag:conference', 'a=ssrc-group:SIM 1 2 3', 'a=ssrc:1 cname:localVideo', 'a=ssrc:1 msid:' + videoStream.id + ' ' + videoTracks[0].id, 'a=ssrc:1 mslabel:' + videoStream.id, 'a=ssrc:1 label:' + videoTracks[0].id, 'a=ssrc:2 cname:localVideo', 'a=ssrc:2 msid:' + videoStream.id + ' ' + videoTracks[0].id, 'a=ssrc:2 mslabel:' + videoStream.id, 'a=ssrc:2 label:' + videoTracks[0].id, 'a=ssrc:3 cname:localVideo', 'a=ssrc:3 msid:' + videoStream.id + ' ' + videoTracks[0].id, 'a=ssrc:3 mslabel:' + videoStream.id, 'a=ssrc:3 label:' + videoTracks[0].id];

  lines.push('');

  return lines.join('\n');
}

/**
 * Wrapper object of an RTCPeerConnection. This object is aimed to simplify the
 * development of WebRTC-based applications.
 *
 * @constructor module:kurentoUtils.WebRtcPeer
 *
 * @param {String} mode Mode in which the PeerConnection will be configured.
 *  Valid values are: 'recv', 'send', and 'sendRecv'
 * @param localVideo Video tag for the local stream
 * @param remoteVideo Video tag for the remote stream
 * @param {MediaStream} videoStream Stream to be used as primary source
 *  (typically video and audio, or only video if combined with audioStream) for
 *  localVideo and to be added as stream to the RTCPeerConnection
 * @param {MediaStream} audioStream Stream to be used as second source
 *  (typically for audio) for localVideo and to be added as stream to the
 *  RTCPeerConnection
 */
function WebRtcPeer(mode, options, callback) {
  if (!(this instanceof WebRtcPeer)) {
    return new WebRtcPeer(mode, options, callback);
  }

  WebRtcPeer.super_.call(this);

  if (options instanceof Function) {
    callback = options;
    options = undefined;
  }

  options = options || {};
  callback = (callback || noop).bind(this);

  var self = this;
  var localVideo = options.localVideo;
  var remoteVideo = options.remoteVideo;
  var videoStream = options.videoStream;
  var audioStream = options.audioStream;
  var mediaConstraints = options.mediaConstraints;
  var receiveConstraints = options.receiveConstraints || options.mediaConstraints;
  var remoteAudio = options.remoteAudio;
  var connectionConstraints = options.connectionConstraints;
  var pc = options.peerConnection;
  var sendSource = options.sendSource || 'webcam';

  var dataChannelConfig = options.dataChannelConfig;
  var useDataChannels = options.dataChannels || false;
  var dataChannel;

  var guid = uuid.v4();
  var configuration = recursive({
    iceServers: freeice()
  }, options.configuration);

  var onicecandidate = options.onicecandidate;
  if (onicecandidate) this.on('icecandidate', onicecandidate);

  var oncandidategatheringdone = options.oncandidategatheringdone;
  if (oncandidategatheringdone) {
    this.on('candidategatheringdone', oncandidategatheringdone);
  }

  var simulcast = options.simulcast;
  var multistream = options.multistream;
  var interop = new sdpTranslator.Interop();
  var candidatesQueueOut = [];
  var candidategatheringdone = false;

  Object.defineProperties(this, {
    'peerConnection': {
      get: function get() {
        return pc;
      }
    },

    'videoStream': {
      get: function get() {
        return videoStream;
      }
    },

    'audioStream': {
      get: function get() {
        return audioStream;
      }
    },

    'id': {
      value: options.id || guid,
      writable: false
    },

    'remoteVideo': {
      get: function get() {
        return remoteVideo;
      }
    },

    'localVideo': {
      get: function get() {
        return localVideo;
      }
    },

    'dataChannel': {
      get: function get() {
        return dataChannel;
      }
    },

    /**
     * @member {(external:ImageData|undefined)} currentFrame
     */
    'currentFrame': {
      get: function get() {
        // [ToDo] Find solution when we have a remote stream but we didn't set
        // a remoteVideo tag
        if (!remoteVideo) return;

        if (remoteVideo.readyState < remoteVideo.HAVE_CURRENT_DATA) throw new Error('No video stream data available');

        var canvas = document.createElement('canvas');
        canvas.width = remoteVideo.videoWidth;
        canvas.height = remoteVideo.videoHeight;

        canvas.getContext('2d').drawImage(remoteVideo, 0, 0);

        return canvas;
      }
    }
  });

  // Init PeerConnection
  if (!pc) {
    pc = new RTCPeerConnection(configuration, { optional: [{ RtpDataChannels: true }, {
        DtlsSrtpKeyAgreement: true }] });
    if (useDataChannels && !dataChannel) {
      var dcId = 'WebRtcPeer-' + self.id;
      var dcOptions = undefined;
      if (dataChannelConfig) {
        dcId = dataChannelConfig.id || dcId;
        dcOptions = dataChannelConfig.options;
      }
      dataChannel = pc.createDataChannel(dcId, dcOptions);
      if (dataChannelConfig) {
        dataChannel.onopen = dataChannelConfig.onopen;
        dataChannel.onclose = dataChannelConfig.onclose;
        dataChannel.onmessage = dataChannelConfig.onmessage;
        dataChannel.onbufferedamountlow = dataChannelConfig.onbufferedamountlow;
        dataChannel.onerror = dataChannelConfig.onerror || noop;
      }
    }
  }

  pc.addEventListener('icecandidate', function (event) {
    var candidate = event.candidate;

    if (EventEmitter.listenerCount(self, 'icecandidate') || EventEmitter.listenerCount(self, 'candidategatheringdone')) {
      if (candidate) {
        var cand;

        if (multistream && usePlanB) {
          cand = interop.candidateToUnifiedPlan(candidate);
        } else {
          cand = candidate;
        }

        self.emit('icecandidate', cand);
        candidategatheringdone = false;
      } else if (!candidategatheringdone) {
        self.emit('candidategatheringdone');
        candidategatheringdone = true;
      }
    } else if (!candidategatheringdone) {
      // Not listening to 'icecandidate' or 'candidategatheringdone' events, queue
      // the candidate until one of them is listened
      candidatesQueueOut.push(candidate);

      if (!candidate) candidategatheringdone = true;
    }
  });

  pc.onaddstream = options.onaddstream;
  pc.onnegotiationneeded = options.onnegotiationneeded;
  this.on('newListener', function (event, listener) {
    if (event === 'icecandidate' || event === 'candidategatheringdone') {
      while (candidatesQueueOut.length) {
        var candidate = candidatesQueueOut.shift();

        if (!candidate === (event === 'candidategatheringdone')) {
          listener(candidate);
        }
      }
    }
  });

  var addIceCandidate = bufferizeCandidates(pc);

  /**
   * Callback function invoked when an ICE candidate is received. Developers are
   * expected to invoke this function in order to complete the SDP negotiation.
   *
   * @function module:kurentoUtils.WebRtcPeer.prototype.addIceCandidate
   *
   * @param iceCandidate - Literal object with the ICE candidate description
   * @param callback - Called when the ICE candidate has been added.
   */
  this.addIceCandidate = function (iceCandidate, callback) {
    var candidate;

    if (multistream && usePlanB) {
      candidate = interop.candidateToPlanB(iceCandidate);
    } else {
      candidate = new RTCIceCandidate(iceCandidate);
    }

    logger.debug('Remote ICE candidate received', iceCandidate);
    callback = (callback || noop).bind(this);
    addIceCandidate(candidate, callback);
  };

  this.generateOffer = function (callback) {
    callback = callback.bind(this);

    var offerAudio = true;
    var offerVideo = true;
    // Constraints must have both blocks
    if (receiveConstraints) {
      offerAudio = typeof receiveConstraints.audio === 'boolean' ? receiveConstraints.audio : true;
      offerVideo = typeof receiveConstraints.video === 'boolean' ? receiveConstraints.video : true;
    }

    var browserDependantConstraints = {
      offerToReceiveAudio: mode !== 'sendonly' && offerAudio,
      offerToReceiveVideo: mode !== 'sendonly' && offerVideo

      //FIXME: clarify possible constraints passed to createOffer()
      /*var constraints = recursive(browserDependantConstraints,
        connectionConstraints)*/

    };var constraints = browserDependantConstraints;

    logger.debug('constraints: ' + JSON.stringify(constraints));

    configureVideoTransceiverIfNeeeded();

    pc.createOffer(constraints).then(function (offer) {
      logger.debug('Created SDP offer');
      offer = mangleSdpToAddSimulcast(offer);
      // if(browser.name === 'Chrome' || browser.name === 'Chromium') {
      //     offer.sdp = offer.sdp.replace(/a=rtpmap:\d+ rtx\/\d+\r\n/i, "");
      //     offer.sdp = offer.sdp.replace(/a=fmtp:\d+ apt=\d+\r\n/i, "");
      // }
      // if(offer.sdp.indexOf('a=rtpmap:120 VP8/90000') >= 0 && offer.sdp.indexOf('a=rtpmap:100 VP8/90000') >= 0){
      //     offer.sdp = offer.sdp.replace(/a=rtpmap:120 VP8\/90000\r\n/i, "");
      //     offer.sdp = offer.sdp.replace(/a=rtcp-fb:120 nack\r\n/i,"");
      //     offer.sdp = offer.sdp.replace(/a=rtcp-fb:120 nack pli\r\n/i,"");
      //     offer.sdp = offer.sdp.replace(/a=rtcp-fb:120 ccm fir\r\n/i,"");
      // }
      return pc.setLocalDescription(offer);
    }).then(function () {
      var localDescription = pc.localDescription;
      logger.debug('Local description set', localDescription.sdp);
      if (multistream && usePlanB) {
        localDescription = interop.toUnifiedPlan(localDescription);
        logger.debug('offer::origPlanB->UnifiedPlan', dumpSDP(localDescription));
      }
      callback(null, localDescription.sdp, self.processAnswer.bind(self));
    }).catch(callback);
  };

  this.getLocalSessionDescriptor = function () {
    return pc.localDescription;
  };

  this.getRemoteSessionDescriptor = function () {
    return pc.remoteDescription;
  };

  this.showLocalVideo = function () {
    localVideo.srcObject = videoStream;
    localVideo.muted = true;
  };

  this.send = function (data) {
    if (dataChannel && dataChannel.readyState === 'open') {
      dataChannel.send(data);
    } else {
      logger.warn('Trying to send data over a non-existing or closed data channel');
    }
  };

  /**
   * Callback function invoked when a SDP answer is received. Developers are
   * expected to invoke this function in order to complete the SDP negotiation.
   *
   * @function module:kurentoUtils.WebRtcPeer.prototype.processAnswer
   *
   * @param sdpAnswer - Description of sdpAnswer
   * @param callback -
   *            Invoked after the SDP answer is processed, or there is an error.
   */
  this.processAnswer = function (sdpAnswer, callback) {
    callback = (callback || noop).bind(this);

    var answer = new RTCSessionDescription({
      type: 'answer',
      sdp: sdpAnswer
    });

    if (multistream && usePlanB) {
      var planBAnswer = interop.toPlanB(answer);
      logger.debug('asnwer::planB', dumpSDP(planBAnswer));
      answer = planBAnswer;
    }

    logger.debug('SDP answer received, setting remote description');

    if (pc.signalingState === 'closed') {
      return callback('PeerConnection is closed');
    }

    pc.setRemoteDescription(answer, function () {
      callback();
    }, callback);
  };

  /**
   * Callback function invoked when a SDP offer is received. Developers are
   * expected to invoke this function in order to complete the SDP negotiation.
   *
   * @function module:kurentoUtils.WebRtcPeer.prototype.processOffer
   *
   * @param sdpOffer - Description of sdpOffer
   * @param callback - Called when the remote description has been set
   *  successfully.
   */
  this.processOffer = function (sdpOffer, callback) {
    callback = callback.bind(this);

    var offer = new RTCSessionDescription({
      type: 'offer',
      sdp: sdpOffer
    });

    if (multistream && usePlanB) {
      var planBOffer = interop.toPlanB(offer);
      logger.debug('offer::planB', dumpSDP(planBOffer));
      offer = planBOffer;
    }

    logger.debug('SDP offer received, setting remote description');

    if (pc.signalingState === 'closed') {
      return callback('PeerConnection is closed');
    }

    pc.setRemoteDescription(offer).then(function () {
      configureVideoTransceiverIfNeeeded();
      return pc.createAnswer();
    }).then(function (answer) {
      answer = mangleSdpToAddSimulcast(answer);
      logger.debug('Created SDP answer');
      return pc.setLocalDescription(answer);
    }).then(function () {
      var localDescription = pc.localDescription;
      if (multistream && usePlanB) {
        localDescription = interop.toUnifiedPlan(localDescription);
        logger.debug('answer::origPlanB->UnifiedPlan', dumpSDP(localDescription));
      }
      logger.debug('Local description set', localDescription.sdp);
      callback(null, localDescription.sdp);
    }).catch(callback);
  };

  function mangleSdpToAddSimulcast(answer) {
    if (simulcast) {
      if (browser.name === 'Chrome' || browser.name === 'Chromium') {
        logger.debug('Adding multicast info');
        answer = new RTCSessionDescription({
          'type': answer.type,
          'sdp': removeFIDFromOffer(answer.sdp) + getSimulcastInfo(videoStream)
        });
      } else {
        logger.warn('Simulcast is only available in Chrome browser.');
      }
    }

    return answer;
  }

  function configureVideoTransceiverIfNeeeded() {
    var videoTranceiver = pc.getTransceivers().find(function (tranceiver) {
      return tranceiver.receiver && tranceiver.receiver.track && tranceiver.receiver.track.kind === 'video';
    });
    if (!videoTranceiver) {
      console.info('WebRtcPeer::start - Adding a recvonly video tranceiver');

      videoTranceiver = pc.addTransceiver('video', {
        direction: 'recvonly'
      });
    }

    // [Hack] https://bugs.webkit.org/show_bug.cgi?id=233036
    var browser = parser.getBrowser();
    if (browser.name === 'Safari' && browser.version.startsWith('15.')) {
      var videoCodecs = RTCRtpSender.getCapabilities('video').codecs;
      var vp8_vp9_codecs = videoCodecs.filter(function (codec) {
        return codec.mimeType === 'video/VP8' || codec.mimeType === 'video/VP9';
      });

      videoTranceiver.setCodecPreferences(vp8_vp9_codecs);
    }
  }

  /**
   * This function creates the RTCPeerConnection object taking into account the
   * properties received in the constructor. It starts the SDP negotiation
   * process: generates the SDP offer and invokes the onsdpoffer callback. This
   * callback is expected to send the SDP offer, in order to obtain an SDP
   * answer from another peer.
   */
  function start() {
    if (pc.signalingState === 'closed') {
      callback('The peer connection object is in "closed" state. This is most likely due to an invocation of the dispose method before accepting in the dialogue');
    }

    if (videoStream && localVideo) {
      self.showLocalVideo();
    }

    if (videoStream) {
      for (var _iterator = videoStream.getTracks(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var track = _ref;

        pc.addTrack(track, videoStream);
      }
    }

    if (audioStream) {
      for (var _iterator2 = audioStream.getTracks(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var _track = _ref2;

        pc.addTrack(_track, audioStream);
      }
    }

    var browser = parser.getBrowser();

    // [Hack] https://code.google.com/p/chromium/issues/detail?id=443558
    if (mode === 'sendonly' && (browser.name === 'Chrome' || browser.name === 'Chromium') && browser.major === 39) {
      mode = 'sendrecv';
    }

    callback();
  }

  if (mode !== 'recvonly' && !videoStream && !audioStream) {
    var getMedia = function getMedia(constraints) {
      if (constraints === undefined) {
        constraints = MEDIA_CONSTRAINTS;
      }

      navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
        videoStream = stream;
        start();
      }).catch(callback);
    };

    if (sendSource === 'webcam') {
      getMedia(mediaConstraints);
    } else {
      getScreenConstraints(sendSource, function (error, constraints_) {
        if (error) return callback(error);

        constraints = [mediaConstraints];
        constraints.unshift(constraints_);
        getMedia(recursive.apply(undefined, constraints));
      }, guid);
    }
  } else {
    setTimeout(start, 0);
  }

  this.on('_dispose', function () {
    if (localVideo) {
      localVideo.pause();
      localVideo.srcObject = null;
      localVideo.load();
      //Unmute local video in case the video tag is later used for remote video
      localVideo.muted = false;
    }
    if (remoteVideo) {
      remoteVideo.pause();
      remoteVideo.srcObject = null;
      remoteVideo.load();
    }
    self.removeAllListeners();

    if (window.cancelChooseDesktopMedia !== undefined) {
      window.cancelChooseDesktopMedia(guid);
    }
  });
}
inherits(WebRtcPeer, EventEmitter);

function createEnableDescriptor(type) {
  var method = 'get' + type + 'Tracks';
  var kind = type.toLowerCase();

  return {
    enumerable: true,
    get: function get() {
      // [ToDo] Should return undefined if not all tracks have the same value?

      if (!this.peerConnection) return;

      if (this.peerConnection.getSenders().some(sender.track.kind === kind && !sender.track.enabled)) {
        return false;
      }

      return true;
    },
    set: function set(value) {
      function trackSetEnable(track) {
        track.enabled = value;
      }

      this.peerConnection.getSenders().filter(sender.track.kind === kind).forEach(trackSetEnable);
    }
  };
}

Object.defineProperties(WebRtcPeer.prototype, {
  'enabled': {
    enumerable: true,
    get: function get() {
      return this.audioEnabled && this.videoEnabled;
    },
    set: function set(value) {
      this.audioEnabled = this.videoEnabled = value;
    }
  },
  'audioEnabled': createEnableDescriptor('Audio'),
  'videoEnabled': createEnableDescriptor('Video')
});

WebRtcPeer.prototype.getLocalStream = function (index) {
  if (this.peerConnection) {
    // return this.peerConnection.getLocalStreams()[index || 0]
    if ((index || 0) === 1) {
      return this.audioStream;
    }

    return this.videoStream;
  }
};

WebRtcPeer.prototype.getRemoteStream = function (index) {
  if (this.peerConnection) {
    return this.peerConnection.getRemoteStreams()[index || 0];
  }
};

/**
 * @description This method frees the resources used by WebRtcPeer.
 *
 * @function module:kurentoUtils.WebRtcPeer.prototype.dispose
 */
WebRtcPeer.prototype.dispose = function () {
  logger.debug('Disposing WebRtcPeer');

  var pc = this.peerConnection;
  var dc = this.dataChannel;
  try {
    if (dc) {
      if (dc.signalingState === 'closed') return;

      dc.close();
    }

    if (pc) {
      if (pc.signalingState === 'closed') return;

      pc.getSenders().forEach(function (sender) {
        return sender.track && sender.track.stop();
      });

      // FIXME This is not yet implemented in firefox
      // if(videoStream) pc.removeStream(videoStream);
      // if(audioStream) pc.removeStream(audioStream);

      pc.close();
    }
  } catch (err) {
    logger.warn('Exception disposing webrtc peer ' + err);
  }

  this.emit('_dispose');
};

//
// Specialized child classes
//

function WebRtcPeerRecvonly(options, callback) {
  if (!(this instanceof WebRtcPeerRecvonly)) {
    return new WebRtcPeerRecvonly(options, callback);
  }

  WebRtcPeerRecvonly.super_.call(this, 'recvonly', options, callback);
}
inherits(WebRtcPeerRecvonly, WebRtcPeer);

function WebRtcPeerSendonly(options, callback) {
  if (!(this instanceof WebRtcPeerSendonly)) {
    return new WebRtcPeerSendonly(options, callback);
  }

  WebRtcPeerSendonly.super_.call(this, 'sendonly', options, callback);
}
inherits(WebRtcPeerSendonly, WebRtcPeer);

function WebRtcPeerSendrecv(options, callback) {
  if (!(this instanceof WebRtcPeerSendrecv)) {
    return new WebRtcPeerSendrecv(options, callback);
  }

  WebRtcPeerSendrecv.super_.call(this, 'sendrecv', options, callback);
}
inherits(WebRtcPeerSendrecv, WebRtcPeer);

function harkUtils(stream, options) {
  return hark(stream, options);
}

exports.bufferizeCandidates = bufferizeCandidates;

exports.WebRtcPeerRecvonly = WebRtcPeerRecvonly;
exports.WebRtcPeerSendonly = WebRtcPeerSendonly;
exports.WebRtcPeerSendrecv = WebRtcPeerSendrecv;
exports.hark = harkUtils;

/***/ }),

/***/ "yNEm":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("RA6A");
var definePropertyModule = __webpack_require__("y7Dx");
var createPropertyDescriptor = __webpack_require__("v6/v");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "yNJ0":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "yOG5":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("vSO4");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("TNJq") });

/***/ }),

/***/ "yP4S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__("fpuT").compose;

exports.__esModule = true;
exports.composeWithDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
  if (arguments.length === 0) return undefined;
  if (typeof arguments[0] === 'object') return compose;
  return compose.apply(null, arguments);
};

exports.devToolsEnhancer = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
  return function (noop) {
    return noop;
  };
};

/***/ }),

/***/ "yPWo":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("PoOm");
var isCallable = __webpack_require__("yeFe");
var store = __webpack_require__("kERb");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;

/***/ }),

/***/ "yS17":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "yY49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ycyv":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("knrM");
var gOPS = __webpack_require__("Ocr3");
var pIE = __webpack_require__("z7R8");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "yd8v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(null, "", urlToPush) : history.replaceState(null, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports.default = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),

/***/ "ydL9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("T4f3");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("zCAL");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("BX4+");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("dACh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jx4H");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("VOrx");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("ZKjc");

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__("xE50");

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _events = __webpack_require__("slh1");

var _events2 = _interopRequireDefault(_events);

var _keycode = __webpack_require__("dy/l");

var _keycode2 = _interopRequireDefault(_keycode);

var _FocusRipple = __webpack_require__("eG0P");

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__("r5Fo");

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var styleInjected = false;
var listening = false;
var tabPressed = false;

function injectStyle() {
  if (!styleInjected) {
    // Remove inner padding and border in Firefox 4+.
    var style = document.createElement('style');
    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';

    document.body.appendChild(style);
    styleInjected = true;
  }
}

function listenForTabPresses() {
  if (!listening) {
    _events2.default.on(window, 'keydown', function (event) {
      tabPressed = (0, _keycode2.default)(event) === 'tab';
    });
    listening = true;
  }
}

var EnhancedButton = function (_Component) {
  (0, _inherits3.default)(EnhancedButton, _Component);

  function EnhancedButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleKeyDown = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
          _this.removeKeyboardFocus(event);
        }
      }
      _this.props.onKeyDown(event);
    }, _this.handleKeyUp = function (event) {
      _this.props.onKeyUp(event);
    }, _this.handleBlur = function (event) {
      _this.cancelFocusTimeout();
      _this.removeKeyboardFocus(event);
      _this.props.onBlur(event);
    }, _this.handleFocus = function (event) {
      if (event) event.persist();
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        // setTimeout is needed because the focus event fires first
        // Wait so that we can capture if this was a keyboard focus
        // or touch focus
        _this.focusTimeout = setTimeout(function () {
          if (tabPressed) {
            _this.setKeyboardFocus(event);
            tabPressed = false;
          }
        }, 150);

        _this.props.onFocus(event);
      }
    }, _this.handleClick = function (event) {
      _this.cancelFocusTimeout();
      if (!_this.props.disabled) {
        tabPressed = false;
        _this.removeKeyboardFocus(event);
        _this.props.onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          disabled = _props.disabled,
          disableKeyboardFocus = _props.disableKeyboardFocus,
          keyboardFocused = _props.keyboardFocused;

      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
        this.setState({ isKeyboardFocused: true });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      injectStyle();
      listenForTabPresses();
      if (this.state.isKeyboardFocused) {
        this.button.focus();
        this.props.onKeyboardFocus(null, true);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        if (nextProps.onKeyboardFocus) {
          nextProps.onKeyboardFocus(null, false);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
      }
    }
  }, {
    key: 'isKeyboardFocused',
    value: function isKeyboardFocused() {
      return this.state.isKeyboardFocused;
    }
  }, {
    key: 'removeKeyboardFocus',
    value: function removeKeyboardFocus(event) {
      if (this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        this.props.onKeyboardFocus(event, false);
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus(event) {
      if (!this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: true });
        this.props.onKeyboardFocus(event, true);
      }
    }
  }, {
    key: 'cancelFocusTimeout',
    value: function cancelFocusTimeout() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
        this.focusTimeout = null;
      }
    }
  }, {
    key: 'createButtonChildren',
    value: function createButtonChildren() {
      var _props2 = this.props,
          centerRipple = _props2.centerRipple,
          children = _props2.children,
          disabled = _props2.disabled,
          disableFocusRipple = _props2.disableFocusRipple,
          disableKeyboardFocus = _props2.disableKeyboardFocus,
          disableTouchRipple = _props2.disableTouchRipple,
          focusRippleColor = _props2.focusRippleColor,
          focusRippleOpacity = _props2.focusRippleOpacity,
          touchRippleColor = _props2.touchRippleColor,
          touchRippleOpacity = _props2.touchRippleOpacity;
      var isKeyboardFocused = this.state.isKeyboardFocused;

      // Focus Ripple

      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
        color: focusRippleColor,
        opacity: focusRippleOpacity,
        show: isKeyboardFocused,
        style: {
          overflow: 'hidden'
        },
        key: 'focusRipple'
      }) : undefined;

      // Touch Ripple
      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(_TouchRipple2.default, {
        centerRipple: centerRipple,
        color: touchRippleColor,
        opacity: touchRippleOpacity,
        key: 'touchRipple'
      }, children) : undefined;

      return [focusRipple, touchRipple, touchRipple ? undefined : children];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          centerRipple = _props3.centerRipple,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableFocusRipple = _props3.disableFocusRipple,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          disableTouchRipple = _props3.disableTouchRipple,
          focusRippleColor = _props3.focusRippleColor,
          focusRippleOpacity = _props3.focusRippleOpacity,
          href = _props3.href,
          keyboardFocused = _props3.keyboardFocused,
          touchRippleColor = _props3.touchRippleColor,
          touchRippleOpacity = _props3.touchRippleOpacity,
          onBlur = _props3.onBlur,
          onClick = _props3.onClick,
          onFocus = _props3.onFocus,
          onKeyUp = _props3.onKeyUp,
          onKeyDown = _props3.onKeyDown,
          onKeyboardFocus = _props3.onKeyboardFocus,
          style = _props3.style,
          tabIndex = _props3.tabIndex,
          type = _props3.type,
          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          enhancedButton = _context$muiTheme.enhancedButton;

      var mergedStyles = (0, _simpleAssign2.default)({
        border: 10,
        boxSizing: 'border-box',
        display: 'inline-block',
        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
        cursor: disabled ? 'default' : 'pointer',
        textDecoration: 'none',
        margin: 0,
        padding: 0,
        outline: 'none',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        position: 'relative', // This is needed so that ripples do not bleed past border radius.
        verticalAlign: href ? 'middle' : null
      }, style);

      // Passing both background:none & backgroundColor can break due to object iteration order
      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
        mergedStyles.background = 'none';
      }

      if (disabled && href) {
        return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
          style: mergedStyles
        }), children);
      }

      var buttonProps = (0, _extends3.default)({}, other, {
        style: prepareStyles(mergedStyles),
        ref: function ref(node) {
          return _this2.button = node;
        },
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
      });

      if (href) buttonProps.href = href;

      var buttonChildren = this.createButtonChildren();

      if (_react2.default.isValidElement(containerElement)) {
        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
      }

      if (!href && containerElement === 'button') {
        buttonProps.type = type;
      }

      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
    }
  }]);
  return EnhancedButton;
}(_react.Component);

EnhancedButton.defaultProps = {
  containerElement: 'button',
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  tabIndex: 0,
  type: 'button'
};
EnhancedButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedButton.propTypes =  false ? {
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  disableFocusRipple: _propTypes2.default.bool,
  disableKeyboardFocus: _propTypes2.default.bool,
  disableTouchRipple: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusRippleColor: _propTypes2.default.string,
  focusRippleOpacity: _propTypes2.default.number,
  href: _propTypes2.default.string,
  keyboardFocused: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onKeyboardFocus: _propTypes2.default.func,
  style: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,
  touchRippleColor: _propTypes2.default.string,
  touchRippleOpacity: _propTypes2.default.number,
  type: _propTypes2.default.string
} : {};
exports.default = EnhancedButton;

/***/ }),

/***/ "yeEC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("cjsw"), __esModule: true };

/***/ }),

/***/ "yeFe":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};

/***/ }),

/***/ "yfLs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__1yxZG","copyright":"copyright__3lK7Q","socialIcons":"socialIcons__qdhtB","logo":"logo__3MaHB","left":"left__2OeWL","right":"right__1aDsX","footerLinks":"footerLinks__3SXWO"};

/***/ }),

/***/ "ygki":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("i/J7");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);

/***/ }),

/***/ "yi9p":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("tprn");

/***/ }),

/***/ "yiHt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__("KYJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__("2kK6");


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),

/***/ "yw9g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },
  offset: function offset(el) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  }
};

/***/ }),

/***/ "ywQn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__("uTT0");

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
	return origKeys(o);
} : __webpack_require__("orz+");

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2);
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) {
				// eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

/***/ }),

/***/ "z7R8":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "zCAL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "zCZt":
/***/ (function(module, exports, __webpack_require__) {

/*
 * (C) Copyright 2014 Kurento (http://kurento.org/)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

/**
 * This module contains a set of reusable components that have been found useful
 * during the development of the WebRTC applications with Kurento.
 * 
 * @module kurentoUtils
 * 
 * @copyright 2014 Kurento (http://kurento.org/)
 * @license ALv2
 */

var WebRtcPeer = __webpack_require__("yJBJ");

exports.WebRtcPeer = WebRtcPeer;

/***/ }),

/***/ "zI/n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),

/***/ "zKbo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.default = connect;

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _shallowequal = __webpack_require__("pz6A");

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _hoistNonReactStatics = __webpack_require__("6k8n");

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _reactLifecyclesCompat = __webpack_require__("nkXc");

var _PropTypes = __webpack_require__("hDW8");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function isStateless(Component) {
  return !Component.prototype.render;
}

var defaultMapStateToProps = function defaultMapStateToProps() {
  return {};
};

function connect(mapStateToProps) {
  var shouldSubscribe = !!mapStateToProps;
  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;

  return function wrapWithConnect(WrappedComponent) {
    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      _createClass(Connect, null, [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, prevState) {
          // using ownProps
          if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
            return {
              subscribed: finnalMapStateToProps(prevState.store.getState(), props),
              props: props
            };
          }
          return { props: props };
        }
      }]);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));

        _this.handleChange = function () {
          if (!_this.unsubscribe) {
            return;
          }
          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
          _this.setState({ subscribed: nextState });
        };

        _this.store = context.miniStore;
        _this.state = {
          subscribed: finnalMapStateToProps(_this.store.getState(), props),
          store: _this.store,
          props: props
        };
        return _this;
      }

      _createClass(Connect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.trySubscribe();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.tryUnsubscribe();
        }
      }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state.subscribed, nextState.subscribed);
        }
      }, {
        key: 'trySubscribe',
        value: function trySubscribe() {
          if (shouldSubscribe) {
            this.unsubscribe = this.store.subscribe(this.handleChange);
            this.handleChange();
          }
        }
      }, {
        key: 'tryUnsubscribe',
        value: function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var props = _extends({}, this.props, this.state.subscribed, {
            store: this.store
          });

          if (!isStateless(WrappedComponent)) {
            props = _extends({}, props, {
              ref: function ref(c) {
                return _this2.wrappedInstance = c;
              }
            });
          }

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return Connect;
    }(_react.Component);

    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
    Connect.contextTypes = {
      miniStore: _PropTypes.storeShape.isRequired
    };

    (0, _reactLifecyclesCompat.polyfill)(Connect);

    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
  };
}

/***/ }),

/***/ "zKeE":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "zjJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Btn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ControlBtn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fontawesome__ = __webpack_require__("piIy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__("c5PF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_btnCallEnd_png__ = __webpack_require__("lH4u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_btnCallEnd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_btnCallEnd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_btnCallStart_png__ = __webpack_require__("tQoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_btnCallStart_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_btnCallStart_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_btnCancel_png__ = __webpack_require__("JZvF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_btnCancel_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_btnCancel_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_next_pro_svg__ = __webpack_require__("LLDo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_next_pro_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_next_pro_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_btnText_png__ = __webpack_require__("QyBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_btnText_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_btnText_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_btnControlVideo_png__ = __webpack_require__("+uQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_btnControlVideo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_btnControlVideo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_btnControlSpeaker_png__ = __webpack_require__("k0hK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_btnControlSpeaker_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_btnControlSpeaker_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_btnControlMute_png__ = __webpack_require__("dvJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_btnControlMute_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_btnControlMute_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_btnControlScreenSharing_png__ = __webpack_require__("iY6Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_btnControlScreenSharing_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_btnControlScreenSharing_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_consts__ = __webpack_require__("4PH9");


















var Btn = function Btn(_ref) {
  var text = _ref.text,
      clickHandler = _ref.clickHandler,
      hideText = _ref.hideText;

  var src = void 0;
  switch (text) {
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].cancel:
      src = __WEBPACK_IMPORTED_MODULE_5__assets_btnCancel_png___default.a;
      break;
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].decline:
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].finish:
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].cancelCall:
      src = __WEBPACK_IMPORTED_MODULE_3__assets_btnCallEnd_png___default.a;
      break;
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].pickUp:
      src = __WEBPACK_IMPORTED_MODULE_4__assets_btnCallStart_png___default.a;
      break;
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].textMe:
      src = __WEBPACK_IMPORTED_MODULE_7__assets_btnText_png___default.a;
      break;
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].next:
      src = __WEBPACK_IMPORTED_MODULE_6__assets_next_pro_svg___default.a;
      break;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.btn },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { className: __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.btnImg, src: src, onClick: clickHandler }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.btnText, onClick: clickHandler },
      hideText ? '' : text
    )
  );
};

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { alt: '', src: __WEBPACK_IMPORTED_MODULE_10__assets_btnControlMute_png___default.a });

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { alt: '', src: __WEBPACK_IMPORTED_MODULE_9__assets_btnControlSpeaker_png___default.a });

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { alt: '', src: __WEBPACK_IMPORTED_MODULE_8__assets_btnControlVideo_png___default.a });

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { alt: '', src: __WEBPACK_IMPORTED_MODULE_11__assets_btnControlScreenSharing_png___default.a });

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_react_fontawesome___default.a, { name: 'compress', size: '3x' });

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_react_fontawesome___default.a, { name: 'expand', size: '3x' });

var ControlBtn = function ControlBtn(_ref2) {
  var type = _ref2.type,
      clickHandler = _ref2.clickHandler,
      isTurnOff = _ref2.isTurnOff,
      isFullScreen = _ref2.isFullScreen;

  var el = void 0;
  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].control.mute:
      el = _ref3;
      break;
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].control.speaker:
      el = _ref4;
      break;
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].control.video:
      el = _ref5;
      break;
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].control.screenSharing:
      el = _ref6;
      break;
    case __WEBPACK_IMPORTED_MODULE_12__utils_consts__["D" /* chatBtns */].control.fullScreen:
      el = isFullScreen ? _ref7 : _ref8;
      break;
  }

  return el && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.controlBtn, onClick: clickHandler },
    el,
    isTurnOff && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.lineThrough })
  );
};

/***/ }),

/***/ "znAs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("8FtN");

var _keys2 = _interopRequireDefault(_keys);

exports.default = rtl;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;

/**
 * This function ensures that `style` supports both ltr and rtl directions by
 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
 * necessary.
 */
function rtl(muiTheme) {
  if (muiTheme.isRtl) {
    return function (style) {
      if (style.directionInvariant === true) {
        return style;
      }

      var flippedAttributes = {
        // Keys and their replacements.
        right: 'left',
        left: 'right',
        marginRight: 'marginLeft',
        marginLeft: 'marginRight',
        paddingRight: 'paddingLeft',
        paddingLeft: 'paddingRight',
        borderRight: 'borderLeft',
        borderLeft: 'borderRight'
      };

      var newStyle = {};

      (0, _keys2.default)(style).forEach(function (attribute) {
        var value = style[attribute];
        var key = attribute;

        if (flippedAttributes.hasOwnProperty(attribute)) {
          key = flippedAttributes[attribute];
        }

        switch (attribute) {
          case 'float':
          case 'textAlign':
            if (value === 'right') {
              value = 'left';
            } else if (value === 'left') {
              value = 'right';
            }
            break;

          case 'direction':
            if (value === 'ltr') {
              value = 'rtl';
            } else if (value === 'rtl') {
              value = 'ltr';
            }
            break;

          case 'transform':
            if (!value) break;
            var matches = void 0;
            if (matches = value.match(reTranslate)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
            }
            if (matches = value.match(reSkew)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
            }
            break;

          case 'transformOrigin':
            if (!value) break;
            if (value.indexOf('right') > -1) {
              value = value.replace('right', 'left');
            } else if (value.indexOf('left') > -1) {
              value = value.replace('left', 'right');
            }
            break;
        }

        newStyle[key] = value;
      });

      return newStyle;
    };
  }
}

/***/ }),

/***/ "zotD":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("BxvP");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.64c70.js